import { getCurrentInstance as ff, ref as W, onMounted as ct, onUnmounted as hf, isRef as er, isReactive as U2, watch as et, defineComponent as Ne, nextTick as Ln, unref as M, reactive as Oa, h as Me, isVNode as cS, render as $2, computed as x, openBlock as v, createElementBlock as A, toDisplayString as Q, createElementVNode as g, createBlock as te, resolveDynamicComponent as zo, normalizeClass as z, normalizeStyle as Fe, withCtx as q, renderSlot as ue, onBeforeUnmount as Li, useCssVars as Wr, resolveComponent as ee, createCommentVNode as V, createVNode as H, Transition as Zt, getCurrentScope as uS, onScopeDispose as dS, readonly as fS, watchEffect as Y_, resolveDirective as ft, withDirectives as Ze, inject as so, Fragment as ge, renderList as ye, mergeProps as Tt, vModelSelect as hS, vModelText as g1, createTextVNode as me, vModelDynamic as _S, onUpdated as ES, provide as Ti, withModifiers as ua, normalizeProps as pS, guardReactiveProps as mS, useSlots as NS, createStaticVNode as vt, toRef as Ga, Teleport as _f, createSlots as K_, Comment as vS, cloneVNode as gS, useAttrs as IS, withKeys as DO, vShow as bi, TransitionGroup as OS, shallowRef as AS, markRaw as DS, customRef as CS } from "vue";
/*!
  * vue-tippy v6.2.0
  * (c) 2023 
  * @license MIT
  */
var Hn = "top", vr = "bottom", gr = "right", Wn = "left", z_ = "auto", zc = [Hn, vr, gr, Wn], Ps = "start", uc = "end", SS = "clippingParents", CO = "viewport", Il = "popper", wS = "reference", k2 = /* @__PURE__ */ zc.reduce(function(t, e) {
  return t.concat([e + "-" + Ps, e + "-" + uc]);
}, []), SO = /* @__PURE__ */ [].concat(zc, [z_]).reduce(function(t, e) {
  return t.concat([e, e + "-" + Ps, e + "-" + uc]);
}, []), TS = "beforeRead", bS = "read", RS = "afterRead", MS = "beforeMain", PS = "main", yS = "afterMain", LS = "beforeWrite", xS = "write", US = "afterWrite", $S = [TS, bS, RS, MS, PS, yS, LS, xS, US];
function fo(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function Yr(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function ys(t) {
  var e = Yr(t).Element;
  return t instanceof e || t instanceof Element;
}
function hr(t) {
  var e = Yr(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function wO(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = Yr(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function kS(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var r = e.styles[n] || {}, o = e.attributes[n] || {}, i = e.elements[n];
    !hr(i) || !fo(i) || (Object.assign(i.style, r), Object.keys(o).forEach(function(a) {
      var s = o[a];
      s === !1 ? i.removeAttribute(a) : i.setAttribute(a, s === !0 ? "" : s);
    }));
  });
}
function BS(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var o = e.elements[r], i = e.attributes[r] || {}, a = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : n[r]), s = a.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !hr(o) || !fo(o) || (Object.assign(o.style, s), Object.keys(i).forEach(function(l) {
        o.removeAttribute(l);
      }));
    });
  };
}
var TO = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: kS,
  effect: BS,
  requires: ["computeStyles"]
};
function lo(t) {
  return t.split("-")[0];
}
var da = Math.max, hd = Math.min, Ls = Math.round;
function xs(t, e) {
  e === void 0 && (e = !1);
  var n = t.getBoundingClientRect(), r = 1, o = 1;
  if (hr(t) && e) {
    var i = t.offsetHeight, a = t.offsetWidth;
    a > 0 && (r = Ls(n.width) / a || 1), i > 0 && (o = Ls(n.height) / i || 1);
  }
  return {
    width: n.width / r,
    height: n.height / o,
    top: n.top / o,
    right: n.right / r,
    bottom: n.bottom / o,
    left: n.left / r,
    x: n.left / r,
    y: n.top / o
  };
}
function Z_(t) {
  var e = xs(t), n = t.offsetWidth, r = t.offsetHeight;
  return Math.abs(e.width - n) <= 1 && (n = e.width), Math.abs(e.height - r) <= 1 && (r = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: r
  };
}
function bO(t, e) {
  var n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && wO(n)) {
    var r = e;
    do {
      if (r && t.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function ho(t) {
  return Yr(t).getComputedStyle(t);
}
function GS(t) {
  return ["table", "td", "th"].indexOf(fo(t)) >= 0;
}
function xi(t) {
  return ((ys(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function Ef(t) {
  return fo(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (wO(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    xi(t)
  );
}
function B2(t) {
  return !hr(t) || // https://github.com/popperjs/popper-core/issues/837
  ho(t).position === "fixed" ? null : t.offsetParent;
}
function FS(t) {
  var e = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, n = navigator.userAgent.indexOf("Trident") !== -1;
  if (n && hr(t)) {
    var r = ho(t);
    if (r.position === "fixed")
      return null;
  }
  for (var o = Ef(t); hr(o) && ["html", "body"].indexOf(fo(o)) < 0; ) {
    var i = ho(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || e && i.willChange === "filter" || e && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Zc(t) {
  for (var e = Yr(t), n = B2(t); n && GS(n) && ho(n).position === "static"; )
    n = B2(n);
  return n && (fo(n) === "html" || fo(n) === "body" && ho(n).position === "static") ? e : n || FS(t) || e;
}
function q_(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function Fl(t, e, n) {
  return da(t, hd(e, n));
}
function VS(t, e, n) {
  var r = Fl(t, e, n);
  return r > n ? n : r;
}
function RO() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function MO(t) {
  return Object.assign({}, RO(), t);
}
function PO(t, e) {
  return e.reduce(function(n, r) {
    return n[r] = t, n;
  }, {});
}
var HS = function(e, n) {
  return e = typeof e == "function" ? e(Object.assign({}, n.rects, {
    placement: n.placement
  })) : e, MO(typeof e != "number" ? e : PO(e, zc));
};
function WS(t) {
  var e, n = t.state, r = t.name, o = t.options, i = n.elements.arrow, a = n.modifiersData.popperOffsets, s = lo(n.placement), l = q_(s), c = [Wn, gr].indexOf(s) >= 0, u = c ? "height" : "width";
  if (!(!i || !a)) {
    var d = HS(o.padding, n), f = Z_(i), h = l === "y" ? Hn : Wn, _ = l === "y" ? vr : gr, E = n.rects.reference[u] + n.rects.reference[l] - a[l] - n.rects.popper[u], m = a[l] - n.rects.reference[l], N = Zc(i), I = N ? l === "y" ? N.clientHeight || 0 : N.clientWidth || 0 : 0, O = E / 2 - m / 2, p = d[h], C = I - f[u] - d[_], D = I / 2 - f[u] / 2 + O, T = Fl(p, D, C), k = l;
    n.modifiersData[r] = (e = {}, e[k] = T, e.centerOffset = T - D, e);
  }
}
function YS(t) {
  var e = t.state, n = t.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = e.elements.popper.querySelector(o), !o) || bO(e.elements.popper, o) && (e.elements.arrow = o));
}
var KS = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: WS,
  effect: YS,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Us(t) {
  return t.split("-")[1];
}
var zS = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function ZS(t) {
  var e = t.x, n = t.y, r = window, o = r.devicePixelRatio || 1;
  return {
    x: Ls(e * o) / o || 0,
    y: Ls(n * o) / o || 0
  };
}
function G2(t) {
  var e, n = t.popper, r = t.popperRect, o = t.placement, i = t.variation, a = t.offsets, s = t.position, l = t.gpuAcceleration, c = t.adaptive, u = t.roundOffsets, d = t.isFixed, f = u === !0 ? ZS(a) : typeof u == "function" ? u(a) : a, h = f.x, _ = h === void 0 ? 0 : h, E = f.y, m = E === void 0 ? 0 : E, N = a.hasOwnProperty("x"), I = a.hasOwnProperty("y"), O = Wn, p = Hn, C = window;
  if (c) {
    var D = Zc(n), T = "clientHeight", k = "clientWidth";
    if (D === Yr(n) && (D = xi(n), ho(D).position !== "static" && s === "absolute" && (T = "scrollHeight", k = "scrollWidth")), D = D, o === Hn || (o === Wn || o === gr) && i === uc) {
      p = vr;
      var G = d && C.visualViewport ? C.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        D[T]
      );
      m -= G - r.height, m *= l ? 1 : -1;
    }
    if (o === Wn || (o === Hn || o === vr) && i === uc) {
      O = gr;
      var b = d && C.visualViewport ? C.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        D[k]
      );
      _ -= b - r.width, _ *= l ? 1 : -1;
    }
  }
  var P = Object.assign({
    position: s
  }, c && zS);
  if (l) {
    var $;
    return Object.assign({}, P, ($ = {}, $[p] = I ? "0" : "", $[O] = N ? "0" : "", $.transform = (C.devicePixelRatio || 1) <= 1 ? "translate(" + _ + "px, " + m + "px)" : "translate3d(" + _ + "px, " + m + "px, 0)", $));
  }
  return Object.assign({}, P, (e = {}, e[p] = I ? m + "px" : "", e[O] = N ? _ + "px" : "", e.transform = "", e));
}
function qS(t) {
  var e = t.state, n = t.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, i = n.adaptive, a = i === void 0 ? !0 : i, s = n.roundOffsets, l = s === void 0 ? !0 : s, c = {
    placement: lo(e.placement),
    variation: Us(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: o,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, G2(Object.assign({}, c, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: a,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, G2(Object.assign({}, c, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
var XS = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: qS,
  data: {}
}, vu = {
  passive: !0
};
function jS(t) {
  var e = t.state, n = t.instance, r = t.options, o = r.scroll, i = o === void 0 ? !0 : o, a = r.resize, s = a === void 0 ? !0 : a, l = Yr(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return i && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, vu);
  }), s && l.addEventListener("resize", n.update, vu), function() {
    i && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, vu);
    }), s && l.removeEventListener("resize", n.update, vu);
  };
}
var JS = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: jS,
  data: {}
}, QS = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ju(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return QS[e];
  });
}
var ew = {
  start: "end",
  end: "start"
};
function F2(t) {
  return t.replace(/start|end/g, function(e) {
    return ew[e];
  });
}
function X_(t) {
  var e = Yr(t), n = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function j_(t) {
  return xs(xi(t)).left + X_(t).scrollLeft;
}
function tw(t) {
  var e = Yr(t), n = xi(t), r = e.visualViewport, o = n.clientWidth, i = n.clientHeight, a = 0, s = 0;
  return r && (o = r.width, i = r.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (a = r.offsetLeft, s = r.offsetTop)), {
    width: o,
    height: i,
    x: a + j_(t),
    y: s
  };
}
function nw(t) {
  var e, n = xi(t), r = X_(t), o = (e = t.ownerDocument) == null ? void 0 : e.body, i = da(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), a = da(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), s = -r.scrollLeft + j_(t), l = -r.scrollTop;
  return ho(o || n).direction === "rtl" && (s += da(n.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: a,
    x: s,
    y: l
  };
}
function J_(t) {
  var e = ho(t), n = e.overflow, r = e.overflowX, o = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function yO(t) {
  return ["html", "body", "#document"].indexOf(fo(t)) >= 0 ? t.ownerDocument.body : hr(t) && J_(t) ? t : yO(Ef(t));
}
function Vl(t, e) {
  var n;
  e === void 0 && (e = []);
  var r = yO(t), o = r === ((n = t.ownerDocument) == null ? void 0 : n.body), i = Yr(r), a = o ? [i].concat(i.visualViewport || [], J_(r) ? r : []) : r, s = e.concat(a);
  return o ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Vl(Ef(a)))
  );
}
function $h(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function rw(t) {
  var e = xs(t);
  return e.top = e.top + t.clientTop, e.left = e.left + t.clientLeft, e.bottom = e.top + t.clientHeight, e.right = e.left + t.clientWidth, e.width = t.clientWidth, e.height = t.clientHeight, e.x = e.left, e.y = e.top, e;
}
function V2(t, e) {
  return e === CO ? $h(tw(t)) : ys(e) ? rw(e) : $h(nw(xi(t)));
}
function ow(t) {
  var e = Vl(Ef(t)), n = ["absolute", "fixed"].indexOf(ho(t).position) >= 0, r = n && hr(t) ? Zc(t) : t;
  return ys(r) ? e.filter(function(o) {
    return ys(o) && bO(o, r) && fo(o) !== "body" && (n ? ho(o).position !== "static" : !0);
  }) : [];
}
function iw(t, e, n) {
  var r = e === "clippingParents" ? ow(t) : [].concat(e), o = [].concat(r, [n]), i = o[0], a = o.reduce(function(s, l) {
    var c = V2(t, l);
    return s.top = da(c.top, s.top), s.right = hd(c.right, s.right), s.bottom = hd(c.bottom, s.bottom), s.left = da(c.left, s.left), s;
  }, V2(t, i));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function LO(t) {
  var e = t.reference, n = t.element, r = t.placement, o = r ? lo(r) : null, i = r ? Us(r) : null, a = e.x + e.width / 2 - n.width / 2, s = e.y + e.height / 2 - n.height / 2, l;
  switch (o) {
    case Hn:
      l = {
        x: a,
        y: e.y - n.height
      };
      break;
    case vr:
      l = {
        x: a,
        y: e.y + e.height
      };
      break;
    case gr:
      l = {
        x: e.x + e.width,
        y: s
      };
      break;
    case Wn:
      l = {
        x: e.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var c = o ? q_(o) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (i) {
      case Ps:
        l[c] = l[c] - (e[u] / 2 - n[u] / 2);
        break;
      case uc:
        l[c] = l[c] + (e[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function dc(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, o = r === void 0 ? t.placement : r, i = n.boundary, a = i === void 0 ? SS : i, s = n.rootBoundary, l = s === void 0 ? CO : s, c = n.elementContext, u = c === void 0 ? Il : c, d = n.altBoundary, f = d === void 0 ? !1 : d, h = n.padding, _ = h === void 0 ? 0 : h, E = MO(typeof _ != "number" ? _ : PO(_, zc)), m = u === Il ? wS : Il, N = t.rects.popper, I = t.elements[f ? m : u], O = iw(ys(I) ? I : I.contextElement || xi(t.elements.popper), a, l), p = xs(t.elements.reference), C = LO({
    reference: p,
    element: N,
    strategy: "absolute",
    placement: o
  }), D = $h(Object.assign({}, N, C)), T = u === Il ? D : p, k = {
    top: O.top - T.top + E.top,
    bottom: T.bottom - O.bottom + E.bottom,
    left: O.left - T.left + E.left,
    right: T.right - O.right + E.right
  }, G = t.modifiersData.offset;
  if (u === Il && G) {
    var b = G[o];
    Object.keys(k).forEach(function(P) {
      var $ = [gr, vr].indexOf(P) >= 0 ? 1 : -1, y = [Hn, vr].indexOf(P) >= 0 ? "y" : "x";
      k[P] += b[y] * $;
    });
  }
  return k;
}
function aw(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, o = n.boundary, i = n.rootBoundary, a = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? SO : l, u = Us(r), d = u ? s ? k2 : k2.filter(function(_) {
    return Us(_) === u;
  }) : zc, f = d.filter(function(_) {
    return c.indexOf(_) >= 0;
  });
  f.length === 0 && (f = d);
  var h = f.reduce(function(_, E) {
    return _[E] = dc(t, {
      placement: E,
      boundary: o,
      rootBoundary: i,
      padding: a
    })[lo(E)], _;
  }, {});
  return Object.keys(h).sort(function(_, E) {
    return h[_] - h[E];
  });
}
function sw(t) {
  if (lo(t) === z_)
    return [];
  var e = ju(t);
  return [F2(t), e, F2(e)];
}
function lw(t) {
  var e = t.state, n = t.options, r = t.name;
  if (!e.modifiersData[r]._skip) {
    for (var o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, s = a === void 0 ? !0 : a, l = n.fallbackPlacements, c = n.padding, u = n.boundary, d = n.rootBoundary, f = n.altBoundary, h = n.flipVariations, _ = h === void 0 ? !0 : h, E = n.allowedAutoPlacements, m = e.options.placement, N = lo(m), I = N === m, O = l || (I || !_ ? [ju(m)] : sw(m)), p = [m].concat(O).reduce(function(re, j) {
      return re.concat(lo(j) === z_ ? aw(e, {
        placement: j,
        boundary: u,
        rootBoundary: d,
        padding: c,
        flipVariations: _,
        allowedAutoPlacements: E
      }) : j);
    }, []), C = e.rects.reference, D = e.rects.popper, T = /* @__PURE__ */ new Map(), k = !0, G = p[0], b = 0; b < p.length; b++) {
      var P = p[b], $ = lo(P), y = Us(P) === Ps, L = [Hn, vr].indexOf($) >= 0, w = L ? "width" : "height", R = dc(e, {
        placement: P,
        boundary: u,
        rootBoundary: d,
        altBoundary: f,
        padding: c
      }), B = L ? y ? gr : Wn : y ? vr : Hn;
      C[w] > D[w] && (B = ju(B));
      var U = ju(B), K = [];
      if (i && K.push(R[$] <= 0), s && K.push(R[B] <= 0, R[U] <= 0), K.every(function(re) {
        return re;
      })) {
        G = P, k = !1;
        break;
      }
      T.set(P, K);
    }
    if (k)
      for (var Z = _ ? 3 : 1, X = function(j) {
        var ne = p.find(function(Ee) {
          var fe = T.get(Ee);
          if (fe)
            return fe.slice(0, j).every(function(Oe) {
              return Oe;
            });
        });
        if (ne)
          return G = ne, "break";
      }, J = Z; J > 0; J--) {
        var ae = X(J);
        if (ae === "break")
          break;
      }
    e.placement !== G && (e.modifiersData[r]._skip = !0, e.placement = G, e.reset = !0);
  }
}
var cw = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: lw,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function H2(t, e, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - n.y,
    right: t.right - e.width + n.x,
    bottom: t.bottom - e.height + n.y,
    left: t.left - e.width - n.x
  };
}
function W2(t) {
  return [Hn, gr, vr, Wn].some(function(e) {
    return t[e] >= 0;
  });
}
function uw(t) {
  var e = t.state, n = t.name, r = e.rects.reference, o = e.rects.popper, i = e.modifiersData.preventOverflow, a = dc(e, {
    elementContext: "reference"
  }), s = dc(e, {
    altBoundary: !0
  }), l = H2(a, r), c = H2(s, o, i), u = W2(l), d = W2(c);
  e.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: d
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": d
  });
}
var dw = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: uw
};
function fw(t, e, n) {
  var r = lo(t), o = [Wn, Hn].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, a = i[0], s = i[1];
  return a = a || 0, s = (s || 0) * o, [Wn, gr].indexOf(r) >= 0 ? {
    x: s,
    y: a
  } : {
    x: a,
    y: s
  };
}
function hw(t) {
  var e = t.state, n = t.options, r = t.name, o = n.offset, i = o === void 0 ? [0, 0] : o, a = SO.reduce(function(u, d) {
    return u[d] = fw(d, e.rects, i), u;
  }, {}), s = a[e.placement], l = s.x, c = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += c), e.modifiersData[r] = a;
}
var _w = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: hw
};
function Ew(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = LO({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
var pw = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Ew,
  data: {}
};
function mw(t) {
  return t === "x" ? "y" : "x";
}
function Nw(t) {
  var e = t.state, n = t.options, r = t.name, o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, s = a === void 0 ? !1 : a, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, d = n.padding, f = n.tether, h = f === void 0 ? !0 : f, _ = n.tetherOffset, E = _ === void 0 ? 0 : _, m = dc(e, {
    boundary: l,
    rootBoundary: c,
    padding: d,
    altBoundary: u
  }), N = lo(e.placement), I = Us(e.placement), O = !I, p = q_(N), C = mw(p), D = e.modifiersData.popperOffsets, T = e.rects.reference, k = e.rects.popper, G = typeof E == "function" ? E(Object.assign({}, e.rects, {
    placement: e.placement
  })) : E, b = typeof G == "number" ? {
    mainAxis: G,
    altAxis: G
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, G), P = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, $ = {
    x: 0,
    y: 0
  };
  if (D) {
    if (i) {
      var y, L = p === "y" ? Hn : Wn, w = p === "y" ? vr : gr, R = p === "y" ? "height" : "width", B = D[p], U = B + m[L], K = B - m[w], Z = h ? -k[R] / 2 : 0, X = I === Ps ? T[R] : k[R], J = I === Ps ? -k[R] : -T[R], ae = e.elements.arrow, re = h && ae ? Z_(ae) : {
        width: 0,
        height: 0
      }, j = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : RO(), ne = j[L], Ee = j[w], fe = Fl(0, T[R], re[R]), Oe = O ? T[R] / 2 - Z - fe - ne - b.mainAxis : X - fe - ne - b.mainAxis, ce = O ? -T[R] / 2 + Z + fe + Ee + b.mainAxis : J + fe + Ee + b.mainAxis, Se = e.elements.arrow && Zc(e.elements.arrow), se = Se ? p === "y" ? Se.clientTop || 0 : Se.clientLeft || 0 : 0, Ie = (y = P == null ? void 0 : P[p]) != null ? y : 0, we = B + Oe - Ie - se, le = B + ce - Ie, De = Fl(h ? hd(U, we) : U, B, h ? da(K, le) : K);
      D[p] = De, $[p] = De - B;
    }
    if (s) {
      var pe, Le = p === "x" ? Hn : Wn, ze = p === "x" ? vr : gr, Xe = D[C], je = C === "y" ? "height" : "width", it = Xe + m[Le], ot = Xe - m[ze], Rt = [Hn, Wn].indexOf(N) !== -1, Ht = (pe = P == null ? void 0 : P[C]) != null ? pe : 0, Mt = Rt ? it : Xe - T[je] - k[je] - Ht + b.altAxis, pn = Rt ? Xe + T[je] + k[je] - Ht - b.altAxis : ot, on = h && Rt ? VS(Mt, Xe, pn) : Fl(h ? Mt : it, Xe, h ? pn : ot);
      D[C] = on, $[C] = on - Xe;
    }
    e.modifiersData[r] = $;
  }
}
var vw = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Nw,
  requiresIfExists: ["offset"]
};
function gw(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function Iw(t) {
  return t === Yr(t) || !hr(t) ? X_(t) : gw(t);
}
function Ow(t) {
  var e = t.getBoundingClientRect(), n = Ls(e.width) / t.offsetWidth || 1, r = Ls(e.height) / t.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function Aw(t, e, n) {
  n === void 0 && (n = !1);
  var r = hr(e), o = hr(e) && Ow(e), i = xi(e), a = xs(t, o), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((fo(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  J_(i)) && (s = Iw(e)), hr(e) ? (l = xs(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : i && (l.x = j_(i))), {
    x: a.left + s.scrollLeft - l.x,
    y: a.top + s.scrollTop - l.y,
    width: a.width,
    height: a.height
  };
}
function Dw(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  t.forEach(function(i) {
    e.set(i.name, i);
  });
  function o(i) {
    n.add(i.name);
    var a = [].concat(i.requires || [], i.requiresIfExists || []);
    a.forEach(function(s) {
      if (!n.has(s)) {
        var l = e.get(s);
        l && o(l);
      }
    }), r.push(i);
  }
  return t.forEach(function(i) {
    n.has(i.name) || o(i);
  }), r;
}
function Cw(t) {
  var e = Dw(t);
  return $S.reduce(function(n, r) {
    return n.concat(e.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function Sw(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function ww(t) {
  var e = t.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var Y2 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function K2() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function Tw(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, r = n === void 0 ? [] : n, o = e.defaultOptions, i = o === void 0 ? Y2 : o;
  return function(s, l, c) {
    c === void 0 && (c = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Y2, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, h = {
      state: u,
      setOptions: function(N) {
        var I = typeof N == "function" ? N(u.options) : N;
        E(), u.options = Object.assign({}, i, u.options, I), u.scrollParents = {
          reference: ys(s) ? Vl(s) : s.contextElement ? Vl(s.contextElement) : [],
          popper: Vl(l)
        };
        var O = Cw(ww([].concat(r, u.options.modifiers)));
        return u.orderedModifiers = O.filter(function(p) {
          return p.enabled;
        }), _(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var N = u.elements, I = N.reference, O = N.popper;
          if (K2(I, O)) {
            u.rects = {
              reference: Aw(I, Zc(O), u.options.strategy === "fixed"),
              popper: Z_(O)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(b) {
              return u.modifiersData[b.name] = Object.assign({}, b.data);
            });
            for (var p = 0; p < u.orderedModifiers.length; p++) {
              if (u.reset === !0) {
                u.reset = !1, p = -1;
                continue;
              }
              var C = u.orderedModifiers[p], D = C.fn, T = C.options, k = T === void 0 ? {} : T, G = C.name;
              typeof D == "function" && (u = D({
                state: u,
                options: k,
                name: G,
                instance: h
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Sw(function() {
        return new Promise(function(m) {
          h.forceUpdate(), m(u);
        });
      }),
      destroy: function() {
        E(), f = !0;
      }
    };
    if (!K2(s, l))
      return h;
    h.setOptions(c).then(function(m) {
      !f && c.onFirstUpdate && c.onFirstUpdate(m);
    });
    function _() {
      u.orderedModifiers.forEach(function(m) {
        var N = m.name, I = m.options, O = I === void 0 ? {} : I, p = m.effect;
        if (typeof p == "function") {
          var C = p({
            state: u,
            name: N,
            instance: h,
            options: O
          }), D = function() {
          };
          d.push(C || D);
        }
      });
    }
    function E() {
      d.forEach(function(m) {
        return m();
      }), d = [];
    }
    return h;
  };
}
var bw = [JS, pw, XS, TO, _w, cw, vw, KS, dw], Rw = /* @__PURE__ */ Tw({
  defaultModifiers: bw
}), Mw = "tippy-box", xO = "tippy-content", UO = "tippy-backdrop", $O = "tippy-arrow", kO = "tippy-svg-arrow", ji = {
  passive: !0,
  capture: !0
}, BO = function() {
  return document.body;
};
function I1(t, e, n) {
  if (Array.isArray(t)) {
    var r = t[e];
    return r ?? (Array.isArray(n) ? n[e] : n);
  }
  return t;
}
function Q_(t, e) {
  var n = {}.toString.call(t);
  return n.indexOf("[object") === 0 && n.indexOf(e + "]") > -1;
}
function GO(t, e) {
  return typeof t == "function" ? t.apply(void 0, e) : t;
}
function z2(t, e) {
  if (e === 0)
    return t;
  var n;
  return function(r) {
    clearTimeout(n), n = setTimeout(function() {
      t(r);
    }, e);
  };
}
function Pw(t, e) {
  var n = Object.assign({}, t);
  return e.forEach(function(r) {
    delete n[r];
  }), n;
}
function yw(t) {
  return t.split(/\s+/).filter(Boolean);
}
function ra(t) {
  return [].concat(t);
}
function Z2(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function Lw(t) {
  return t.filter(function(e, n) {
    return t.indexOf(e) === n;
  });
}
function FO(t) {
  return t.split("-")[0];
}
function $s(t) {
  return [].slice.call(t);
}
function q2(t) {
  return Object.keys(t).reduce(function(e, n) {
    return t[n] !== void 0 && (e[n] = t[n]), e;
  }, {});
}
function fa() {
  return document.createElement("div");
}
function pf(t) {
  return ["Element", "Fragment"].some(function(e) {
    return Q_(t, e);
  });
}
function xw(t) {
  return Q_(t, "NodeList");
}
function eE(t) {
  return Q_(t, "MouseEvent");
}
function Uw(t) {
  return !!(t && t._tippy && t._tippy.reference === t);
}
function $w(t) {
  return pf(t) ? [t] : xw(t) ? $s(t) : Array.isArray(t) ? t : $s(document.querySelectorAll(t));
}
function O1(t, e) {
  t.forEach(function(n) {
    n && (n.style.transitionDuration = e + "ms");
  });
}
function fc(t, e) {
  t.forEach(function(n) {
    n && n.setAttribute("data-state", e);
  });
}
function VO(t) {
  var e, n = ra(t), r = n[0];
  return r != null && (e = r.ownerDocument) != null && e.body ? r.ownerDocument : document;
}
function kw(t, e) {
  var n = e.clientX, r = e.clientY;
  return t.every(function(o) {
    var i = o.popperRect, a = o.popperState, s = o.props, l = s.interactiveBorder, c = FO(a.placement), u = a.modifiersData.offset;
    if (!u)
      return !0;
    var d = c === "bottom" ? u.top.y : 0, f = c === "top" ? u.bottom.y : 0, h = c === "right" ? u.left.x : 0, _ = c === "left" ? u.right.x : 0, E = i.top - r + d > l, m = r - i.bottom - f > l, N = i.left - n + h > l, I = n - i.right - _ > l;
    return E || m || N || I;
  });
}
function A1(t, e, n) {
  var r = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(o) {
    t[r](o, n);
  });
}
function X2(t, e) {
  for (var n = e; n; ) {
    var r;
    if (t.contains(n))
      return !0;
    n = n.getRootNode == null || (r = n.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var Qr = {
  isTouch: !1
}, j2 = 0;
function Bw() {
  Qr.isTouch || (Qr.isTouch = !0, window.performance && document.addEventListener("mousemove", HO));
}
function HO() {
  var t = performance.now();
  t - j2 < 20 && (Qr.isTouch = !1, document.removeEventListener("mousemove", HO)), j2 = t;
}
function Gw() {
  var t = document.activeElement;
  if (Uw(t)) {
    var e = t._tippy;
    t.blur && !e.state.isVisible && t.blur();
  }
}
function Fw() {
  document.addEventListener("touchstart", Bw, ji), window.addEventListener("blur", Gw);
}
var Vw = typeof window < "u" && typeof document < "u", Hw = Vw ? (
  // @ts-ignore
  !!window.msCrypto
) : !1, Ww = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, Yw = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, $r = Object.assign({
  appendTo: BO,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, Ww, Yw), Kw = Object.keys($r), zw = function(e) {
  var n = Object.keys(e);
  n.forEach(function(r) {
    $r[r] = e[r];
  });
};
function WO(t) {
  var e = t.plugins || [], n = e.reduce(function(r, o) {
    var i = o.name, a = o.defaultValue;
    if (i) {
      var s;
      r[i] = t[i] !== void 0 ? t[i] : (s = $r[i]) != null ? s : a;
    }
    return r;
  }, {});
  return Object.assign({}, t, n);
}
function Zw(t, e) {
  var n = e ? Object.keys(WO(Object.assign({}, $r, {
    plugins: e
  }))) : Kw, r = n.reduce(function(o, i) {
    var a = (t.getAttribute("data-tippy-" + i) || "").trim();
    if (!a)
      return o;
    if (i === "content")
      o[i] = a;
    else
      try {
        o[i] = JSON.parse(a);
      } catch {
        o[i] = a;
      }
    return o;
  }, {});
  return r;
}
function J2(t, e) {
  var n = Object.assign({}, e, {
    content: GO(e.content, [t])
  }, e.ignoreAttributes ? {} : Zw(t, e.plugins));
  return n.aria = Object.assign({}, $r.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? e.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? e.interactive ? null : "describedby" : n.aria.content
  }, n;
}
var qw = function() {
  return "innerHTML";
};
function kh(t, e) {
  t[qw()] = e;
}
function Q2(t) {
  var e = fa();
  return t === !0 ? e.className = $O : (e.className = kO, pf(t) ? e.appendChild(t) : kh(e, t)), e;
}
function em(t, e) {
  pf(e.content) ? (kh(t, ""), t.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? kh(t, e.content) : t.textContent = e.content);
}
function _d(t) {
  var e = t.firstElementChild, n = $s(e.children);
  return {
    box: e,
    content: n.find(function(r) {
      return r.classList.contains(xO);
    }),
    arrow: n.find(function(r) {
      return r.classList.contains($O) || r.classList.contains(kO);
    }),
    backdrop: n.find(function(r) {
      return r.classList.contains(UO);
    })
  };
}
function YO(t) {
  var e = fa(), n = fa();
  n.className = Mw, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var r = fa();
  r.className = xO, r.setAttribute("data-state", "hidden"), em(r, t.props), e.appendChild(n), n.appendChild(r), o(t.props, t.props);
  function o(i, a) {
    var s = _d(e), l = s.box, c = s.content, u = s.arrow;
    a.theme ? l.setAttribute("data-theme", a.theme) : l.removeAttribute("data-theme"), typeof a.animation == "string" ? l.setAttribute("data-animation", a.animation) : l.removeAttribute("data-animation"), a.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof a.maxWidth == "number" ? a.maxWidth + "px" : a.maxWidth, a.role ? l.setAttribute("role", a.role) : l.removeAttribute("role"), (i.content !== a.content || i.allowHTML !== a.allowHTML) && em(c, t.props), a.arrow ? u ? i.arrow !== a.arrow && (l.removeChild(u), l.appendChild(Q2(a.arrow))) : l.appendChild(Q2(a.arrow)) : u && l.removeChild(u);
  }
  return {
    popper: e,
    onUpdate: o
  };
}
YO.$$tippy = !0;
var Xw = 1, gu = [], D1 = [];
function jw(t, e) {
  var n = J2(t, Object.assign({}, $r, WO(q2(e)))), r, o, i, a = !1, s = !1, l = !1, c = !1, u, d, f, h = [], _ = z2(we, n.interactiveDebounce), E, m = Xw++, N = null, I = Lw(n.plugins), O = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, p = {
    // properties
    id: m,
    reference: t,
    popper: fa(),
    popperInstance: N,
    props: n,
    state: O,
    plugins: I,
    // methods
    clearDelayTimeouts: Mt,
    setProps: pn,
    setContent: on,
    show: Zr,
    hide: Pr,
    hideWithInteractivity: yr,
    enable: Rt,
    disable: Ht,
    unmount: ht,
    destroy: Gn
  };
  if (!n.render)
    return p;
  var C = n.render(p), D = C.popper, T = C.onUpdate;
  D.setAttribute("data-tippy-root", ""), D.id = "tippy-" + p.id, p.popper = D, t._tippy = p, D._tippy = p;
  var k = I.map(function(F) {
    return F.fn(p);
  }), G = t.hasAttribute("aria-expanded");
  return Se(), Z(), B(), U("onCreate", [p]), n.showOnCreate && it(), D.addEventListener("mouseenter", function() {
    p.props.interactive && p.state.isVisible && p.clearDelayTimeouts();
  }), D.addEventListener("mouseleave", function() {
    p.props.interactive && p.props.trigger.indexOf("mouseenter") >= 0 && L().addEventListener("mousemove", _);
  }), p;
  function b() {
    var F = p.props.touch;
    return Array.isArray(F) ? F : [F, 0];
  }
  function P() {
    return b()[0] === "hold";
  }
  function $() {
    var F;
    return !!((F = p.props.render) != null && F.$$tippy);
  }
  function y() {
    return E || t;
  }
  function L() {
    var F = y().parentNode;
    return F ? VO(F) : document;
  }
  function w() {
    return _d(D);
  }
  function R(F) {
    return p.state.isMounted && !p.state.isVisible || Qr.isTouch || u && u.type === "focus" ? 0 : I1(p.props.delay, F ? 0 : 1, $r.delay);
  }
  function B(F) {
    F === void 0 && (F = !1), D.style.pointerEvents = p.props.interactive && !F ? "" : "none", D.style.zIndex = "" + p.props.zIndex;
  }
  function U(F, oe, he) {
    if (he === void 0 && (he = !0), k.forEach(function(Ce) {
      Ce[F] && Ce[F].apply(Ce, oe);
    }), he) {
      var Re;
      (Re = p.props)[F].apply(Re, oe);
    }
  }
  function K() {
    var F = p.props.aria;
    if (F.content) {
      var oe = "aria-" + F.content, he = D.id, Re = ra(p.props.triggerTarget || t);
      Re.forEach(function(Ce) {
        var at = Ce.getAttribute(oe);
        if (p.state.isVisible)
          Ce.setAttribute(oe, at ? at + " " + he : he);
        else {
          var Ot = at && at.replace(he, "").trim();
          Ot ? Ce.setAttribute(oe, Ot) : Ce.removeAttribute(oe);
        }
      });
    }
  }
  function Z() {
    if (!(G || !p.props.aria.expanded)) {
      var F = ra(p.props.triggerTarget || t);
      F.forEach(function(oe) {
        p.props.interactive ? oe.setAttribute("aria-expanded", p.state.isVisible && oe === y() ? "true" : "false") : oe.removeAttribute("aria-expanded");
      });
    }
  }
  function X() {
    L().removeEventListener("mousemove", _), gu = gu.filter(function(F) {
      return F !== _;
    });
  }
  function J(F) {
    if (!(Qr.isTouch && (l || F.type === "mousedown"))) {
      var oe = F.composedPath && F.composedPath()[0] || F.target;
      if (!(p.props.interactive && X2(D, oe))) {
        if (ra(p.props.triggerTarget || t).some(function(he) {
          return X2(he, oe);
        })) {
          if (Qr.isTouch || p.state.isVisible && p.props.trigger.indexOf("click") >= 0)
            return;
        } else
          U("onClickOutside", [p, F]);
        p.props.hideOnClick === !0 && (p.clearDelayTimeouts(), p.hide(), s = !0, setTimeout(function() {
          s = !1;
        }), p.state.isMounted || ne());
      }
    }
  }
  function ae() {
    l = !0;
  }
  function re() {
    l = !1;
  }
  function j() {
    var F = L();
    F.addEventListener("mousedown", J, !0), F.addEventListener("touchend", J, ji), F.addEventListener("touchstart", re, ji), F.addEventListener("touchmove", ae, ji);
  }
  function ne() {
    var F = L();
    F.removeEventListener("mousedown", J, !0), F.removeEventListener("touchend", J, ji), F.removeEventListener("touchstart", re, ji), F.removeEventListener("touchmove", ae, ji);
  }
  function Ee(F, oe) {
    Oe(F, function() {
      !p.state.isVisible && D.parentNode && D.parentNode.contains(D) && oe();
    });
  }
  function fe(F, oe) {
    Oe(F, oe);
  }
  function Oe(F, oe) {
    var he = w().box;
    function Re(Ce) {
      Ce.target === he && (A1(he, "remove", Re), oe());
    }
    if (F === 0)
      return oe();
    A1(he, "remove", d), A1(he, "add", Re), d = Re;
  }
  function ce(F, oe, he) {
    he === void 0 && (he = !1);
    var Re = ra(p.props.triggerTarget || t);
    Re.forEach(function(Ce) {
      Ce.addEventListener(F, oe, he), h.push({
        node: Ce,
        eventType: F,
        handler: oe,
        options: he
      });
    });
  }
  function Se() {
    P() && (ce("touchstart", Ie, {
      passive: !0
    }), ce("touchend", le, {
      passive: !0
    })), yw(p.props.trigger).forEach(function(F) {
      if (F !== "manual")
        switch (ce(F, Ie), F) {
          case "mouseenter":
            ce("mouseleave", le);
            break;
          case "focus":
            ce(Hw ? "focusout" : "blur", De);
            break;
          case "focusin":
            ce("focusout", De);
            break;
        }
    });
  }
  function se() {
    h.forEach(function(F) {
      var oe = F.node, he = F.eventType, Re = F.handler, Ce = F.options;
      oe.removeEventListener(he, Re, Ce);
    }), h = [];
  }
  function Ie(F) {
    var oe, he = !1;
    if (!(!p.state.isEnabled || pe(F) || s)) {
      var Re = ((oe = u) == null ? void 0 : oe.type) === "focus";
      u = F, E = F.currentTarget, Z(), !p.state.isVisible && eE(F) && gu.forEach(function(Ce) {
        return Ce(F);
      }), F.type === "click" && (p.props.trigger.indexOf("mouseenter") < 0 || a) && p.props.hideOnClick !== !1 && p.state.isVisible ? he = !0 : it(F), F.type === "click" && (a = !he), he && !Re && ot(F);
    }
  }
  function we(F) {
    var oe = F.target, he = y().contains(oe) || D.contains(oe);
    if (!(F.type === "mousemove" && he)) {
      var Re = je().concat(D).map(function(Ce) {
        var at, Ot = Ce._tippy, Xn = (at = Ot.popperInstance) == null ? void 0 : at.state;
        return Xn ? {
          popperRect: Ce.getBoundingClientRect(),
          popperState: Xn,
          props: n
        } : null;
      }).filter(Boolean);
      kw(Re, F) && (X(), ot(F));
    }
  }
  function le(F) {
    var oe = pe(F) || p.props.trigger.indexOf("click") >= 0 && a;
    if (!oe) {
      if (p.props.interactive) {
        p.hideWithInteractivity(F);
        return;
      }
      ot(F);
    }
  }
  function De(F) {
    p.props.trigger.indexOf("focusin") < 0 && F.target !== y() || p.props.interactive && F.relatedTarget && D.contains(F.relatedTarget) || ot(F);
  }
  function pe(F) {
    return Qr.isTouch ? P() !== F.type.indexOf("touch") >= 0 : !1;
  }
  function Le() {
    ze();
    var F = p.props, oe = F.popperOptions, he = F.placement, Re = F.offset, Ce = F.getReferenceClientRect, at = F.moveTransition, Ot = $() ? _d(D).arrow : null, Xn = Ce ? {
      getBoundingClientRect: Ce,
      contextElement: Ce.contextElement || y()
    } : t, gl = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(wo) {
        var jn = wo.state;
        if ($()) {
          var v1 = w(), qi = v1.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(To) {
            To === "placement" ? qi.setAttribute("data-placement", jn.placement) : jn.attributes.popper["data-popper-" + To] ? qi.setAttribute("data-" + To, "") : qi.removeAttribute("data-" + To);
          }), jn.attributes.popper = {};
        }
      }
    }, Cn = [{
      name: "offset",
      options: {
        offset: Re
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !at
      }
    }, gl];
    $() && Ot && Cn.push({
      name: "arrow",
      options: {
        element: Ot,
        padding: 3
      }
    }), Cn.push.apply(Cn, (oe == null ? void 0 : oe.modifiers) || []), p.popperInstance = Rw(Xn, D, Object.assign({}, oe, {
      placement: he,
      onFirstUpdate: f,
      modifiers: Cn
    }));
  }
  function ze() {
    p.popperInstance && (p.popperInstance.destroy(), p.popperInstance = null);
  }
  function Xe() {
    var F = p.props.appendTo, oe, he = y();
    p.props.interactive && F === BO || F === "parent" ? oe = he.parentNode : oe = GO(F, [he]), oe.contains(D) || oe.appendChild(D), p.state.isMounted = !0, Le();
  }
  function je() {
    return $s(D.querySelectorAll("[data-tippy-root]"));
  }
  function it(F) {
    p.clearDelayTimeouts(), F && U("onTrigger", [p, F]), j();
    var oe = R(!0), he = b(), Re = he[0], Ce = he[1];
    Qr.isTouch && Re === "hold" && Ce && (oe = Ce), oe ? r = setTimeout(function() {
      p.show();
    }, oe) : p.show();
  }
  function ot(F) {
    if (p.clearDelayTimeouts(), U("onUntrigger", [p, F]), !p.state.isVisible) {
      ne();
      return;
    }
    if (!(p.props.trigger.indexOf("mouseenter") >= 0 && p.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(F.type) >= 0 && a)) {
      var oe = R(!1);
      oe ? o = setTimeout(function() {
        p.state.isVisible && p.hide();
      }, oe) : i = requestAnimationFrame(function() {
        p.hide();
      });
    }
  }
  function Rt() {
    p.state.isEnabled = !0;
  }
  function Ht() {
    p.hide(), p.state.isEnabled = !1;
  }
  function Mt() {
    clearTimeout(r), clearTimeout(o), cancelAnimationFrame(i);
  }
  function pn(F) {
    if (!p.state.isDestroyed) {
      U("onBeforeUpdate", [p, F]), se();
      var oe = p.props, he = J2(t, Object.assign({}, oe, q2(F), {
        ignoreAttributes: !0
      }));
      p.props = he, Se(), oe.interactiveDebounce !== he.interactiveDebounce && (X(), _ = z2(we, he.interactiveDebounce)), oe.triggerTarget && !he.triggerTarget ? ra(oe.triggerTarget).forEach(function(Re) {
        Re.removeAttribute("aria-expanded");
      }) : he.triggerTarget && t.removeAttribute("aria-expanded"), Z(), B(), T && T(oe, he), p.popperInstance && (Le(), je().forEach(function(Re) {
        requestAnimationFrame(Re._tippy.popperInstance.forceUpdate);
      })), U("onAfterUpdate", [p, F]);
    }
  }
  function on(F) {
    p.setProps({
      content: F
    });
  }
  function Zr() {
    var F = p.state.isVisible, oe = p.state.isDestroyed, he = !p.state.isEnabled, Re = Qr.isTouch && !p.props.touch, Ce = I1(p.props.duration, 0, $r.duration);
    if (!(F || oe || he || Re) && !y().hasAttribute("disabled") && (U("onShow", [p], !1), p.props.onShow(p) !== !1)) {
      if (p.state.isVisible = !0, $() && (D.style.visibility = "visible"), B(), j(), p.state.isMounted || (D.style.transition = "none"), $()) {
        var at = w(), Ot = at.box, Xn = at.content;
        O1([Ot, Xn], 0);
      }
      f = function() {
        var Cn;
        if (!(!p.state.isVisible || c)) {
          if (c = !0, D.offsetHeight, D.style.transition = p.props.moveTransition, $() && p.props.animation) {
            var Zi = w(), wo = Zi.box, jn = Zi.content;
            O1([wo, jn], Ce), fc([wo, jn], "visible");
          }
          K(), Z(), Z2(D1, p), (Cn = p.popperInstance) == null || Cn.forceUpdate(), U("onMount", [p]), p.props.animation && $() && fe(Ce, function() {
            p.state.isShown = !0, U("onShown", [p]);
          });
        }
      }, Xe();
    }
  }
  function Pr() {
    var F = !p.state.isVisible, oe = p.state.isDestroyed, he = !p.state.isEnabled, Re = I1(p.props.duration, 1, $r.duration);
    if (!(F || oe || he) && (U("onHide", [p], !1), p.props.onHide(p) !== !1)) {
      if (p.state.isVisible = !1, p.state.isShown = !1, c = !1, a = !1, $() && (D.style.visibility = "hidden"), X(), ne(), B(!0), $()) {
        var Ce = w(), at = Ce.box, Ot = Ce.content;
        p.props.animation && (O1([at, Ot], Re), fc([at, Ot], "hidden"));
      }
      K(), Z(), p.props.animation ? $() && Ee(Re, p.unmount) : p.unmount();
    }
  }
  function yr(F) {
    L().addEventListener("mousemove", _), Z2(gu, _), _(F);
  }
  function ht() {
    p.state.isVisible && p.hide(), p.state.isMounted && (ze(), je().forEach(function(F) {
      F._tippy.unmount();
    }), D.parentNode && D.parentNode.removeChild(D), D1 = D1.filter(function(F) {
      return F !== p;
    }), p.state.isMounted = !1, U("onHidden", [p]));
  }
  function Gn() {
    p.state.isDestroyed || (p.clearDelayTimeouts(), p.unmount(), se(), delete t._tippy, p.state.isDestroyed = !0, U("onDestroy", [p]));
  }
}
function Pe(t, e) {
  e === void 0 && (e = {});
  var n = $r.plugins.concat(e.plugins || []);
  Fw();
  var r = Object.assign({}, e, {
    plugins: n
  }), o = $w(t), i = o.reduce(function(a, s) {
    var l = s && jw(s, r);
    return l && a.push(l), a;
  }, []);
  return pf(t) ? i[0] : i;
}
Pe.defaultProps = $r;
Pe.setDefaultProps = zw;
Pe.currentInput = Qr;
var Jw = Object.assign({}, TO, {
  effect: function(e) {
    var n = e.state, r = {
      popper: {
        position: n.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(n.elements.popper.style, r.popper), n.styles = r, n.elements.arrow && Object.assign(n.elements.arrow.style, r.arrow);
  }
}), Qw = function(e, n) {
  var r;
  n === void 0 && (n = {});
  var o = e, i = [], a = [], s, l = n.overrides, c = [], u = !1;
  function d() {
    a = o.map(function(p) {
      return ra(p.props.triggerTarget || p.reference);
    }).reduce(function(p, C) {
      return p.concat(C);
    }, []);
  }
  function f() {
    i = o.map(function(p) {
      return p.reference;
    });
  }
  function h(p) {
    o.forEach(function(C) {
      p ? C.enable() : C.disable();
    });
  }
  function _(p) {
    return o.map(function(C) {
      var D = C.setProps;
      return C.setProps = function(T) {
        D(T), C.reference === s && p.setProps(T);
      }, function() {
        C.setProps = D;
      };
    });
  }
  function E(p, C) {
    var D = a.indexOf(C);
    if (C !== s) {
      s = C;
      var T = (l || []).concat("content").reduce(function(k, G) {
        return k[G] = o[D].props[G], k;
      }, {});
      p.setProps(Object.assign({}, T, {
        getReferenceClientRect: typeof T.getReferenceClientRect == "function" ? T.getReferenceClientRect : function() {
          var k;
          return (k = i[D]) == null ? void 0 : k.getBoundingClientRect();
        }
      }));
    }
  }
  h(!1), f(), d();
  var m = {
    fn: function() {
      return {
        onDestroy: function() {
          h(!0);
        },
        onHidden: function() {
          s = null;
        },
        onClickOutside: function(D) {
          D.props.showOnCreate && !u && (u = !0, s = null);
        },
        onShow: function(D) {
          D.props.showOnCreate && !u && (u = !0, E(D, i[0]));
        },
        onTrigger: function(D, T) {
          E(D, T.currentTarget);
        }
      };
    }
  }, N = Pe(fa(), Object.assign({}, Pw(n, ["overrides"]), {
    plugins: [m].concat(n.plugins || []),
    triggerTarget: a,
    popperOptions: Object.assign({}, n.popperOptions, {
      modifiers: [].concat(((r = n.popperOptions) == null ? void 0 : r.modifiers) || [], [Jw])
    })
  })), I = N.show;
  N.show = function(p) {
    if (I(), !s && p == null)
      return E(N, i[0]);
    if (!(s && p == null)) {
      if (typeof p == "number")
        return i[p] && E(N, i[p]);
      if (o.indexOf(p) >= 0) {
        var C = p.reference;
        return E(N, C);
      }
      if (i.indexOf(p) >= 0)
        return E(N, p);
    }
  }, N.showNext = function() {
    var p = i[0];
    if (!s)
      return N.show(0);
    var C = i.indexOf(s);
    N.show(i[C + 1] || p);
  }, N.showPrevious = function() {
    var p = i[i.length - 1];
    if (!s)
      return N.show(p);
    var C = i.indexOf(s), D = i[C - 1] || p;
    N.show(D);
  };
  var O = N.setProps;
  return N.setProps = function(p) {
    l = p.overrides || l, O(p);
  }, N.setInstances = function(p) {
    h(!0), c.forEach(function(C) {
      return C();
    }), o = p, h(!1), f(), d(), c = _(N), N.setProps({
      triggerTarget: a
    });
  }, c = _(N), N;
}, eT = {
  name: "animateFill",
  defaultValue: !1,
  fn: function(e) {
    var n;
    if (!((n = e.props.render) != null && n.$$tippy))
      return {};
    var r = _d(e.popper), o = r.box, i = r.content, a = e.props.animateFill ? tT() : null;
    return {
      onCreate: function() {
        a && (o.insertBefore(a, o.firstElementChild), o.setAttribute("data-animatefill", ""), o.style.overflow = "hidden", e.setProps({
          arrow: !1,
          animation: "shift-away"
        }));
      },
      onMount: function() {
        if (a) {
          var l = o.style.transitionDuration, c = Number(l.replace("ms", ""));
          i.style.transitionDelay = Math.round(c / 10) + "ms", a.style.transitionDuration = l, fc([a], "visible");
        }
      },
      onShow: function() {
        a && (a.style.transitionDuration = "0ms");
      },
      onHide: function() {
        a && fc([a], "hidden");
      }
    };
  }
};
function tT() {
  var t = fa();
  return t.className = UO, fc([t], "hidden"), t;
}
var Bh = {
  clientX: 0,
  clientY: 0
}, Iu = [];
function KO(t) {
  var e = t.clientX, n = t.clientY;
  Bh = {
    clientX: e,
    clientY: n
  };
}
function nT(t) {
  t.addEventListener("mousemove", KO);
}
function rT(t) {
  t.removeEventListener("mousemove", KO);
}
var oT = {
  name: "followCursor",
  defaultValue: !1,
  fn: function(e) {
    var n = e.reference, r = VO(e.props.triggerTarget || n), o = !1, i = !1, a = !0, s = e.props;
    function l() {
      return e.props.followCursor === "initial" && e.state.isVisible;
    }
    function c() {
      r.addEventListener("mousemove", f);
    }
    function u() {
      r.removeEventListener("mousemove", f);
    }
    function d() {
      o = !0, e.setProps({
        getReferenceClientRect: null
      }), o = !1;
    }
    function f(E) {
      var m = E.target ? n.contains(E.target) : !0, N = e.props.followCursor, I = E.clientX, O = E.clientY, p = n.getBoundingClientRect(), C = I - p.left, D = O - p.top;
      (m || !e.props.interactive) && e.setProps({
        // @ts-ignore - unneeded DOMRect properties
        getReferenceClientRect: function() {
          var k = n.getBoundingClientRect(), G = I, b = O;
          N === "initial" && (G = k.left + C, b = k.top + D);
          var P = N === "horizontal" ? k.top : b, $ = N === "vertical" ? k.right : G, y = N === "horizontal" ? k.bottom : b, L = N === "vertical" ? k.left : G;
          return {
            width: $ - L,
            height: y - P,
            top: P,
            right: $,
            bottom: y,
            left: L
          };
        }
      });
    }
    function h() {
      e.props.followCursor && (Iu.push({
        instance: e,
        doc: r
      }), nT(r));
    }
    function _() {
      Iu = Iu.filter(function(E) {
        return E.instance !== e;
      }), Iu.filter(function(E) {
        return E.doc === r;
      }).length === 0 && rT(r);
    }
    return {
      onCreate: h,
      onDestroy: _,
      onBeforeUpdate: function() {
        s = e.props;
      },
      onAfterUpdate: function(m, N) {
        var I = N.followCursor;
        o || I !== void 0 && s.followCursor !== I && (_(), I ? (h(), e.state.isMounted && !i && !l() && c()) : (u(), d()));
      },
      onMount: function() {
        e.props.followCursor && !i && (a && (f(Bh), a = !1), l() || c());
      },
      onTrigger: function(m, N) {
        eE(N) && (Bh = {
          clientX: N.clientX,
          clientY: N.clientY
        }), i = N.type === "focus";
      },
      onHidden: function() {
        e.props.followCursor && (d(), u(), a = !0);
      }
    };
  }
};
function iT(t, e) {
  var n;
  return {
    popperOptions: Object.assign({}, t.popperOptions, {
      modifiers: [].concat((((n = t.popperOptions) == null ? void 0 : n.modifiers) || []).filter(function(r) {
        var o = r.name;
        return o !== e.name;
      }), [e])
    })
  };
}
var aT = {
  name: "inlinePositioning",
  defaultValue: !1,
  fn: function(e) {
    var n = e.reference;
    function r() {
      return !!e.props.inlinePositioning;
    }
    var o, i = -1, a = !1, s = [], l = {
      name: "tippyInlinePositioning",
      enabled: !0,
      phase: "afterWrite",
      fn: function(h) {
        var _ = h.state;
        r() && (s.indexOf(_.placement) !== -1 && (s = []), o !== _.placement && s.indexOf(_.placement) === -1 && (s.push(_.placement), e.setProps({
          // @ts-ignore - unneeded DOMRect properties
          getReferenceClientRect: function() {
            return c(_.placement);
          }
        })), o = _.placement);
      }
    };
    function c(f) {
      return sT(FO(f), n.getBoundingClientRect(), $s(n.getClientRects()), i);
    }
    function u(f) {
      a = !0, e.setProps(f), a = !1;
    }
    function d() {
      a || u(iT(e.props, l));
    }
    return {
      onCreate: d,
      onAfterUpdate: d,
      onTrigger: function(h, _) {
        if (eE(_)) {
          var E = $s(e.reference.getClientRects()), m = E.find(function(I) {
            return I.left - 2 <= _.clientX && I.right + 2 >= _.clientX && I.top - 2 <= _.clientY && I.bottom + 2 >= _.clientY;
          }), N = E.indexOf(m);
          i = N > -1 ? N : i;
        }
      },
      onHidden: function() {
        i = -1;
      }
    };
  }
};
function sT(t, e, n, r) {
  if (n.length < 2 || t === null)
    return e;
  if (n.length === 2 && r >= 0 && n[0].left > n[1].right)
    return n[r] || e;
  switch (t) {
    case "top":
    case "bottom": {
      var o = n[0], i = n[n.length - 1], a = t === "top", s = o.top, l = i.bottom, c = a ? o.left : i.left, u = a ? o.right : i.right, d = u - c, f = l - s;
      return {
        top: s,
        bottom: l,
        left: c,
        right: u,
        width: d,
        height: f
      };
    }
    case "left":
    case "right": {
      var h = Math.min.apply(Math, n.map(function(D) {
        return D.left;
      })), _ = Math.max.apply(Math, n.map(function(D) {
        return D.right;
      })), E = n.filter(function(D) {
        return t === "left" ? D.left === h : D.right === _;
      }), m = E[0].top, N = E[E.length - 1].bottom, I = h, O = _, p = O - I, C = N - m;
      return {
        top: m,
        bottom: N,
        left: I,
        right: O,
        width: p,
        height: C
      };
    }
    default:
      return e;
  }
}
var lT = {
  name: "sticky",
  defaultValue: !1,
  fn: function(e) {
    var n = e.reference, r = e.popper;
    function o() {
      return e.popperInstance ? e.popperInstance.state.elements.reference : n;
    }
    function i(c) {
      return e.props.sticky === !0 || e.props.sticky === c;
    }
    var a = null, s = null;
    function l() {
      var c = i("reference") ? o().getBoundingClientRect() : null, u = i("popper") ? r.getBoundingClientRect() : null;
      (c && tm(a, c) || u && tm(s, u)) && e.popperInstance && e.popperInstance.update(), a = c, s = u, e.state.isMounted && requestAnimationFrame(l);
    }
    return {
      onMount: function() {
        e.props.sticky && l();
      }
    };
  }
};
function tm(t, e) {
  return t && e ? t.top !== e.top || t.right !== e.right || t.bottom !== e.bottom || t.left !== e.left : !0;
}
Pe.setDefaultProps({
  render: YO
});
Pe.setDefaultProps({
  //@ts-ignore
  onShow: (t) => {
    if (!t.props.content)
      return !1;
  }
});
function Ui(t, e = {}, n = { mount: !0 }) {
  const r = ff(), o = W(), i = W({
    isEnabled: !1,
    isVisible: !1,
    isDestroyed: !1,
    isMounted: !1,
    isShown: !1
  });
  let a = null;
  const s = () => a || (a = document.createDocumentFragment(), a), l = (D) => {
    let T, k = er(D) ? D.value : D;
    if (cS(k))
      r && (k.appContext = r.appContext), $2(k, s()), T = () => s();
    else if (typeof k == "object") {
      let G = Me(k);
      r && (G.appContext = r.appContext), $2(G, s()), T = () => s();
    } else
      T = k;
    return T;
  }, c = (D) => {
    let T = {};
    return er(D) ? T = D.value || {} : U2(D) ? T = { ...D } : T = { ...D }, T.content && (T.content = l(T.content)), T.triggerTarget && (T.triggerTarget = er(T.triggerTarget) ? T.triggerTarget.value : T.triggerTarget), (!T.plugins || !Array.isArray(T.plugins)) && (T.plugins = []), T.plugins = T.plugins.filter((k) => k.name !== "vueTippyReactiveState"), T.plugins.push({
      name: "vueTippyReactiveState",
      fn: () => ({
        onCreate() {
          i.value.isEnabled = !0;
        },
        onMount() {
          i.value.isMounted = !0;
        },
        onShow() {
          i.value.isMounted = !0, i.value.isVisible = !0;
        },
        onShown() {
          i.value.isShown = !0;
        },
        onHide() {
          i.value.isMounted = !1, i.value.isVisible = !1;
        },
        onHidden() {
          i.value.isShown = !1;
        },
        onUnmounted() {
          i.value.isMounted = !1;
        },
        onDestroy() {
          i.value.isDestroyed = !0;
        }
      })
    }), T;
  }, u = () => {
    o.value && o.value.setProps(c(e));
  }, d = () => {
    !o.value || !e.content || o.value.setContent(l(e.content));
  }, f = (D) => {
    var T;
    (T = o.value) === null || T === void 0 || T.setContent(l(D));
  }, h = (D) => {
    var T;
    (T = o.value) === null || T === void 0 || T.setProps(c(D));
  }, _ = () => {
    o.value && (o.value.destroy(), o.value = void 0), a = null;
  }, E = () => {
    var D;
    (D = o.value) === null || D === void 0 || D.show();
  }, m = () => {
    var D;
    (D = o.value) === null || D === void 0 || D.hide();
  }, N = () => {
    var D;
    (D = o.value) === null || D === void 0 || D.disable(), i.value.isEnabled = !1;
  }, I = () => {
    var D;
    (D = o.value) === null || D === void 0 || D.enable(), i.value.isEnabled = !0;
  }, O = () => {
    var D;
    (D = o.value) === null || D === void 0 || D.unmount();
  }, p = () => {
    if (!t)
      return;
    let D = er(t) ? t.value : t;
    typeof D == "function" && (D = D()), D && (o.value = Pe(D, c(e)), D.$tippy = C);
  }, C = {
    tippy: o,
    refresh: u,
    refreshContent: d,
    setContent: f,
    setProps: h,
    destroy: _,
    hide: m,
    show: E,
    disable: N,
    enable: I,
    unmount: O,
    mount: p,
    state: i
  };
  return n.mount && (r ? (r.isMounted ? p() : ct(p), hf(() => {
    _();
  })) : p()), er(e) || U2(e) ? et(e, u, { immediate: !1 }) : er(e.content) && et(e.content, d, { immediate: !1 }), C;
}
function cT(t, e) {
  const n = W();
  return ct(() => {
    const o = (Array.isArray(t) ? t.map((i) => i.value) : typeof t == "function" ? t() : t.value).map((i) => i instanceof Element ? i._tippy : i).filter(Boolean);
    n.value = Qw(o, e ? { allowHTML: !0, ...e } : { allowHTML: !0 });
  }), {
    singleton: n
  };
}
function uT(t) {
  return typeof t == "function" ? t() : M(t);
}
function dT(t) {
  var e, n;
  const r = uT(t);
  return (n = (e = r) === null || e === void 0 ? void 0 : e.$el) !== null && n !== void 0 ? n : r;
}
const fT = Ne({
  props: {
    to: {
      type: [String, Function]
    },
    tag: {
      type: [String, Object],
      default: "span"
    },
    contentTag: {
      type: [String, Object],
      default: "span"
    },
    contentClass: {
      type: String,
      default: null
    },
    appendTo: { default: () => Pe.defaultProps.appendTo },
    aria: { default: () => Pe.defaultProps.aria },
    delay: { default: () => Pe.defaultProps.delay },
    duration: { default: () => Pe.defaultProps.duration },
    getReferenceClientRect: { default: () => Pe.defaultProps.getReferenceClientRect },
    hideOnClick: { type: [Boolean, String], default: () => Pe.defaultProps.hideOnClick },
    ignoreAttributes: { type: Boolean, default: () => Pe.defaultProps.ignoreAttributes },
    interactive: { type: Boolean, default: () => Pe.defaultProps.interactive },
    interactiveBorder: { default: () => Pe.defaultProps.interactiveBorder },
    interactiveDebounce: { default: () => Pe.defaultProps.interactiveDebounce },
    moveTransition: { default: () => Pe.defaultProps.moveTransition },
    offset: { default: () => Pe.defaultProps.offset },
    onAfterUpdate: { default: () => Pe.defaultProps.onAfterUpdate },
    onBeforeUpdate: { default: () => Pe.defaultProps.onBeforeUpdate },
    onCreate: { default: () => Pe.defaultProps.onCreate },
    onDestroy: { default: () => Pe.defaultProps.onDestroy },
    onHidden: { default: () => Pe.defaultProps.onHidden },
    onHide: { default: () => Pe.defaultProps.onHide },
    onMount: { default: () => Pe.defaultProps.onMount },
    onShow: { default: () => Pe.defaultProps.onShow },
    onShown: { default: () => Pe.defaultProps.onShown },
    onTrigger: { default: () => Pe.defaultProps.onTrigger },
    onUntrigger: { default: () => Pe.defaultProps.onUntrigger },
    onClickOutside: { default: () => Pe.defaultProps.onClickOutside },
    placement: { default: () => Pe.defaultProps.placement },
    plugins: { default: () => Pe.defaultProps.plugins },
    popperOptions: { default: () => Pe.defaultProps.popperOptions },
    render: { default: () => Pe.defaultProps.render },
    showOnCreate: { type: Boolean, default: () => Pe.defaultProps.showOnCreate },
    touch: { type: [Boolean, String, Array], default: () => Pe.defaultProps.touch },
    trigger: { default: () => Pe.defaultProps.trigger },
    triggerTarget: { default: () => Pe.defaultProps.triggerTarget },
    animateFill: { type: Boolean, default: () => Pe.defaultProps.animateFill },
    followCursor: { type: [Boolean, String], default: () => Pe.defaultProps.followCursor },
    inlinePositioning: { type: Boolean, default: () => Pe.defaultProps.inlinePositioning },
    sticky: { type: [Boolean, String], default: () => Pe.defaultProps.sticky },
    allowHTML: { type: Boolean, default: () => Pe.defaultProps.allowHTML },
    animation: { default: () => Pe.defaultProps.animation },
    arrow: { default: () => Pe.defaultProps.arrow },
    content: { default: () => Pe.defaultProps.content },
    inertia: { default: () => Pe.defaultProps.inertia },
    maxWidth: { default: () => Pe.defaultProps.maxWidth },
    role: { default: () => Pe.defaultProps.role },
    theme: { default: () => Pe.defaultProps.theme },
    zIndex: { default: () => Pe.defaultProps.zIndex }
  },
  emits: ["state"],
  setup(t, { slots: e, emit: n, expose: r }) {
    const o = W(), i = W(), a = W(!1), s = () => {
      let d = { ...t };
      for (const f of ["to", "tag", "contentTag", "contentClass"])
        d.hasOwnProperty(f) && delete d[f];
      return d;
    };
    let l = () => dT(o);
    t.to && (typeof Element < "u" && t.to instanceof Element ? l = () => t.to : (typeof t.to == "string" || t.to instanceof String) && (l = () => document.querySelector(t.to)));
    const c = Ui(l, s());
    ct(() => {
      a.value = !0, Ln(() => {
        e.content && c.setContent(() => i.value);
      });
    }), et(c.state, () => {
      n("state", M(c.state));
    }, { immediate: !0, deep: !0 }), et(() => t, () => {
      c.setProps(s()), e.content && c.setContent(() => i.value);
    }, { deep: !0 });
    let u = Oa({
      elem: o,
      contentElem: i,
      mounted: a,
      ...c
    });
    return r(u), () => {
      const d = e.default ? e.default(u) : [], f = (typeof t.contentTag == "string", t.contentTag);
      if (!t.tag) {
        const _ = Me(d[0], {
          ref: o,
          "data-v-tippy": ""
        });
        return e.content ? [
          _,
          Me(f, {
            ref: i,
            style: { display: a.value ? "inherit" : "none" },
            class: t.contentClass
          }, e.content(u))
        ] : _;
      }
      const h = (typeof t.tag == "string", t.tag);
      return Me(h, { ref: o, "data-v-tippy": "" }, e.content ? [
        d,
        Me(f, {
          ref: i,
          style: { display: a.value ? "inherit" : "none" },
          class: t.contentClass
        }, e.content(u))
      ] : d);
    };
  }
}), hT = [
  "a11y",
  "allowHTML",
  "arrow",
  "flip",
  "flipOnUpdate",
  "hideOnClick",
  "ignoreAttributes",
  "inertia",
  "interactive",
  "lazy",
  "multiple",
  "showOnInit",
  "touch",
  "touchHold"
];
let Gh = {};
Object.keys(Pe.defaultProps).forEach((t) => {
  hT.includes(t) ? Gh[t] = {
    type: Boolean,
    default: function() {
      return Pe.defaultProps[t];
    }
  } : Gh[t] = {
    default: function() {
      return Pe.defaultProps[t];
    }
  };
});
const _T = Ne({
  props: Gh,
  setup(t) {
    const e = W([]), { singleton: n } = cT(e, t);
    return { instances: e, singleton: n };
  },
  mounted() {
    var t;
    const n = this.$el.parentElement.querySelectorAll("[data-v-tippy]");
    this.instances = Array.from(n).map((r) => r._tippy).filter(Boolean), (t = this.singleton) === null || t === void 0 || t.setInstances(this.instances);
  },
  render() {
    let t = this.$slots.default ? this.$slots.default() : [];
    return Me(() => t);
  }
}), ET = {
  mounted(t, e, n) {
    const r = typeof e.value == "string" ? { content: e.value } : e.value || {}, o = Object.keys(e.modifiers || {}), i = o.find((s) => s !== "arrow"), a = o.findIndex((s) => s === "arrow") !== -1;
    i && (r.placement = r.placement || i), a && (r.arrow = r.arrow !== void 0 ? r.arrow : !0), n.props && n.props.onTippyShow && (r.onShow = function(...s) {
      var l;
      return (l = n.props) === null || l === void 0 ? void 0 : l.onTippyShow(...s);
    }), n.props && n.props.onTippyShown && (r.onShown = function(...s) {
      var l;
      return (l = n.props) === null || l === void 0 ? void 0 : l.onTippyShown(...s);
    }), n.props && n.props.onTippyHidden && (r.onHidden = function(...s) {
      var l;
      return (l = n.props) === null || l === void 0 ? void 0 : l.onTippyHidden(...s);
    }), n.props && n.props.onTippyHide && (r.onHide = function(...s) {
      var l;
      return (l = n.props) === null || l === void 0 ? void 0 : l.onTippyHide(...s);
    }), n.props && n.props.onTippyMount && (r.onMount = function(...s) {
      var l;
      return (l = n.props) === null || l === void 0 ? void 0 : l.onTippyMount(...s);
    }), t.getAttribute("title") && !r.content && (r.content = t.getAttribute("title"), t.removeAttribute("title")), t.getAttribute("content") && !r.content && (r.content = t.getAttribute("content")), Ui(t, r);
  },
  unmounted(t) {
    t.$tippy ? t.$tippy.destroy() : t._tippy && t._tippy.destroy();
  },
  updated(t, e) {
    const n = typeof e.value == "string" ? { content: e.value } : e.value || {};
    t.getAttribute("title") && !n.content && (n.content = t.getAttribute("title"), t.removeAttribute("title")), t.getAttribute("content") && !n.content && (n.content = t.getAttribute("content")), t.$tippy ? t.$tippy.setProps(n || {}) : t._tippy && t._tippy.setProps(n || {});
  }
}, pT = {
  install(t, e = {}) {
    Pe.setDefaultProps(e.defaultProps || {}), t.directive(e.directive || "tippy", ET), t.component(e.component || "tippy", fT), t.component(e.componentSingleton || "tippy-singleton", _T);
  }
}, mT = Pe.setDefaultProps;
mT({
  ignoreAttributes: !0,
  plugins: [lT, aT, oT, eT]
});
const NT = pT;
/*!
 * perfect-scrollbar v1.5.6
 * Copyright 2024 Hyunje Jun, MDBootstrap and Contributors
 * Licensed under MIT
 */
function no(t) {
  return getComputedStyle(t);
}
function Vn(t, e) {
  for (var n in e) {
    var r = e[n];
    typeof r == "number" && (r = r + "px"), t.style[n] = r;
  }
  return t;
}
function Ou(t) {
  var e = document.createElement("div");
  return e.className = t, e;
}
var nm = typeof Element < "u" && (Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector);
function fi(t, e) {
  if (!nm)
    throw new Error("No element matching method supported");
  return nm.call(t, e);
}
function vs(t) {
  t.remove ? t.remove() : t.parentNode && t.parentNode.removeChild(t);
}
function rm(t, e) {
  return Array.prototype.filter.call(
    t.children,
    function(n) {
      return fi(n, e);
    }
  );
}
var Kt = {
  main: "ps",
  rtl: "ps__rtl",
  element: {
    thumb: function(t) {
      return "ps__thumb-" + t;
    },
    rail: function(t) {
      return "ps__rail-" + t;
    },
    consuming: "ps__child--consume"
  },
  state: {
    focus: "ps--focus",
    clicking: "ps--clicking",
    active: function(t) {
      return "ps--active-" + t;
    },
    scrolling: function(t) {
      return "ps--scrolling-" + t;
    }
  }
}, zO = { x: null, y: null };
function ZO(t, e) {
  var n = t.element.classList, r = Kt.state.scrolling(e);
  n.contains(r) ? clearTimeout(zO[e]) : n.add(r);
}
function qO(t, e) {
  zO[e] = setTimeout(
    function() {
      return t.isAlive && t.element.classList.remove(Kt.state.scrolling(e));
    },
    t.settings.scrollingThreshold
  );
}
function vT(t, e) {
  ZO(t, e), qO(t, e);
}
var qc = function(e) {
  this.element = e, this.handlers = {};
}, XO = { isEmpty: { configurable: !0 } };
qc.prototype.bind = function(e, n) {
  typeof this.handlers[e] > "u" && (this.handlers[e] = []), this.handlers[e].push(n), this.element.addEventListener(e, n, !1);
};
qc.prototype.unbind = function(e, n) {
  var r = this;
  this.handlers[e] = this.handlers[e].filter(function(o) {
    return n && o !== n ? !0 : (r.element.removeEventListener(e, o, !1), !1);
  });
};
qc.prototype.unbindAll = function() {
  for (var e in this.handlers)
    this.unbind(e);
};
XO.isEmpty.get = function() {
  var t = this;
  return Object.keys(this.handlers).every(
    function(e) {
      return t.handlers[e].length === 0;
    }
  );
};
Object.defineProperties(qc.prototype, XO);
var tl = function() {
  this.eventElements = [];
};
tl.prototype.eventElement = function(e) {
  var n = this.eventElements.filter(function(r) {
    return r.element === e;
  })[0];
  return n || (n = new qc(e), this.eventElements.push(n)), n;
};
tl.prototype.bind = function(e, n, r) {
  this.eventElement(e).bind(n, r);
};
tl.prototype.unbind = function(e, n, r) {
  var o = this.eventElement(e);
  o.unbind(n, r), o.isEmpty && this.eventElements.splice(this.eventElements.indexOf(o), 1);
};
tl.prototype.unbindAll = function() {
  this.eventElements.forEach(function(e) {
    return e.unbindAll();
  }), this.eventElements = [];
};
tl.prototype.once = function(e, n, r) {
  var o = this.eventElement(e), i = function(a) {
    o.unbind(n, i), r(a);
  };
  o.bind(n, i);
};
function Au(t) {
  if (typeof window.CustomEvent == "function")
    return new CustomEvent(t);
  var e = document.createEvent("CustomEvent");
  return e.initCustomEvent(t, !1, !1, void 0), e;
}
function Ed(t, e, n, r, o) {
  r === void 0 && (r = !0), o === void 0 && (o = !1);
  var i;
  if (e === "top")
    i = ["contentHeight", "containerHeight", "scrollTop", "y", "up", "down"];
  else if (e === "left")
    i = ["contentWidth", "containerWidth", "scrollLeft", "x", "left", "right"];
  else
    throw new Error("A proper axis should be provided");
  gT(t, n, i, r, o);
}
function gT(t, e, n, r, o) {
  var i = n[0], a = n[1], s = n[2], l = n[3], c = n[4], u = n[5];
  r === void 0 && (r = !0), o === void 0 && (o = !1);
  var d = t.element;
  t.reach[l] = null, d[s] < 1 && (t.reach[l] = "start"), d[s] > t[i] - t[a] - 1 && (t.reach[l] = "end"), e && (d.dispatchEvent(Au("ps-scroll-" + l)), e < 0 ? d.dispatchEvent(Au("ps-scroll-" + c)) : e > 0 && d.dispatchEvent(Au("ps-scroll-" + u)), r && vT(t, l)), t.reach[l] && (e || o) && d.dispatchEvent(Au("ps-" + l + "-reach-" + t.reach[l]));
}
function Pt(t) {
  return parseInt(t, 10) || 0;
}
function IT(t) {
  return fi(t, "input,[contenteditable]") || fi(t, "select,[contenteditable]") || fi(t, "textarea,[contenteditable]") || fi(t, "button,[contenteditable]");
}
function OT(t) {
  var e = no(t);
  return Pt(e.width) + Pt(e.paddingLeft) + Pt(e.paddingRight) + Pt(e.borderLeftWidth) + Pt(e.borderRightWidth);
}
var fs = {
  isWebKit: typeof document < "u" && "WebkitAppearance" in document.documentElement.style,
  supportsTouch: typeof window < "u" && ("ontouchstart" in window || "maxTouchPoints" in window.navigator && window.navigator.maxTouchPoints > 0 || window.DocumentTouch && document instanceof window.DocumentTouch),
  supportsIePointer: typeof navigator < "u" && navigator.msMaxTouchPoints,
  isChrome: typeof navigator < "u" && /Chrome/i.test(navigator && navigator.userAgent)
};
function Wo(t) {
  var e = t.element, n = Math.floor(e.scrollTop), r = e.getBoundingClientRect();
  t.containerWidth = Math.floor(r.width), t.containerHeight = Math.floor(r.height), t.contentWidth = e.scrollWidth, t.contentHeight = e.scrollHeight, e.contains(t.scrollbarXRail) || (rm(e, Kt.element.rail("x")).forEach(function(o) {
    return vs(o);
  }), e.appendChild(t.scrollbarXRail)), e.contains(t.scrollbarYRail) || (rm(e, Kt.element.rail("y")).forEach(function(o) {
    return vs(o);
  }), e.appendChild(t.scrollbarYRail)), !t.settings.suppressScrollX && t.containerWidth + t.settings.scrollXMarginOffset < t.contentWidth ? (t.scrollbarXActive = !0, t.railXWidth = t.containerWidth - t.railXMarginWidth, t.railXRatio = t.containerWidth / t.railXWidth, t.scrollbarXWidth = om(t, Pt(t.railXWidth * t.containerWidth / t.contentWidth)), t.scrollbarXLeft = Pt(
    (t.negativeScrollAdjustment + e.scrollLeft) * (t.railXWidth - t.scrollbarXWidth) / (t.contentWidth - t.containerWidth)
  )) : t.scrollbarXActive = !1, !t.settings.suppressScrollY && t.containerHeight + t.settings.scrollYMarginOffset < t.contentHeight ? (t.scrollbarYActive = !0, t.railYHeight = t.containerHeight - t.railYMarginHeight, t.railYRatio = t.containerHeight / t.railYHeight, t.scrollbarYHeight = om(
    t,
    Pt(t.railYHeight * t.containerHeight / t.contentHeight)
  ), t.scrollbarYTop = Pt(
    n * (t.railYHeight - t.scrollbarYHeight) / (t.contentHeight - t.containerHeight)
  )) : t.scrollbarYActive = !1, t.scrollbarXLeft >= t.railXWidth - t.scrollbarXWidth && (t.scrollbarXLeft = t.railXWidth - t.scrollbarXWidth), t.scrollbarYTop >= t.railYHeight - t.scrollbarYHeight && (t.scrollbarYTop = t.railYHeight - t.scrollbarYHeight), AT(e, t), t.scrollbarXActive ? e.classList.add(Kt.state.active("x")) : (e.classList.remove(Kt.state.active("x")), t.scrollbarXWidth = 0, t.scrollbarXLeft = 0, e.scrollLeft = t.isRtl === !0 ? t.contentWidth : 0), t.scrollbarYActive ? e.classList.add(Kt.state.active("y")) : (e.classList.remove(Kt.state.active("y")), t.scrollbarYHeight = 0, t.scrollbarYTop = 0, e.scrollTop = 0);
}
function om(t, e) {
  return t.settings.minScrollbarLength && (e = Math.max(e, t.settings.minScrollbarLength)), t.settings.maxScrollbarLength && (e = Math.min(e, t.settings.maxScrollbarLength)), e;
}
function AT(t, e) {
  var n = { width: e.railXWidth }, r = Math.floor(t.scrollTop);
  e.isRtl ? n.left = e.negativeScrollAdjustment + t.scrollLeft + e.containerWidth - e.contentWidth : n.left = t.scrollLeft, e.isScrollbarXUsingBottom ? n.bottom = e.scrollbarXBottom - r : n.top = e.scrollbarXTop + r, Vn(e.scrollbarXRail, n);
  var o = { top: r, height: e.railYHeight };
  e.isScrollbarYUsingRight ? e.isRtl ? o.right = e.contentWidth - (e.negativeScrollAdjustment + t.scrollLeft) - e.scrollbarYRight - e.scrollbarYOuterWidth - 9 : o.right = e.scrollbarYRight - t.scrollLeft : e.isRtl ? o.left = e.negativeScrollAdjustment + t.scrollLeft + e.containerWidth * 2 - e.contentWidth - e.scrollbarYLeft - e.scrollbarYOuterWidth : o.left = e.scrollbarYLeft + t.scrollLeft, Vn(e.scrollbarYRail, o), Vn(e.scrollbarX, {
    left: e.scrollbarXLeft,
    width: e.scrollbarXWidth - e.railBorderXWidth
  }), Vn(e.scrollbarY, {
    top: e.scrollbarYTop,
    height: e.scrollbarYHeight - e.railBorderYWidth
  });
}
function DT(t) {
  t.event.bind(t.scrollbarY, "mousedown", function(e) {
    return e.stopPropagation();
  }), t.event.bind(t.scrollbarYRail, "mousedown", function(e) {
    var n = e.pageY - window.pageYOffset - t.scrollbarYRail.getBoundingClientRect().top, r = n > t.scrollbarYTop ? 1 : -1;
    t.element.scrollTop += r * t.containerHeight, Wo(t), e.stopPropagation();
  }), t.event.bind(t.scrollbarX, "mousedown", function(e) {
    return e.stopPropagation();
  }), t.event.bind(t.scrollbarXRail, "mousedown", function(e) {
    var n = e.pageX - window.pageXOffset - t.scrollbarXRail.getBoundingClientRect().left, r = n > t.scrollbarXLeft ? 1 : -1;
    t.element.scrollLeft += r * t.containerWidth, Wo(t), e.stopPropagation();
  });
}
var Du = null;
function CT(t) {
  im(t, [
    "containerHeight",
    "contentHeight",
    "pageY",
    "railYHeight",
    "scrollbarY",
    "scrollbarYHeight",
    "scrollTop",
    "y",
    "scrollbarYRail"
  ]), im(t, [
    "containerWidth",
    "contentWidth",
    "pageX",
    "railXWidth",
    "scrollbarX",
    "scrollbarXWidth",
    "scrollLeft",
    "x",
    "scrollbarXRail"
  ]);
}
function im(t, e) {
  var n = e[0], r = e[1], o = e[2], i = e[3], a = e[4], s = e[5], l = e[6], c = e[7], u = e[8], d = t.element, f = null, h = null, _ = null;
  function E(I) {
    I.touches && I.touches[0] && (I[o] = I.touches[0]["page" + c.toUpperCase()]), Du === a && (d[l] = f + _ * (I[o] - h), ZO(t, c), Wo(t), I.stopPropagation(), I.preventDefault());
  }
  function m() {
    qO(t, c), t[u].classList.remove(Kt.state.clicking), document.removeEventListener("mousemove", E), document.removeEventListener("mouseup", m), document.removeEventListener("touchmove", E), document.removeEventListener("touchend", m), Du = null;
  }
  function N(I) {
    Du === null && (Du = a, f = d[l], I.touches && (I[o] = I.touches[0]["page" + c.toUpperCase()]), h = I[o], _ = (t[r] - t[n]) / (t[i] - t[s]), I.touches ? (document.addEventListener("touchmove", E, { passive: !1 }), document.addEventListener("touchend", m)) : (document.addEventListener("mousemove", E), document.addEventListener("mouseup", m)), t[u].classList.add(Kt.state.clicking)), I.stopPropagation(), I.cancelable && I.preventDefault();
  }
  t[a].addEventListener("mousedown", N), t[a].addEventListener("touchstart", N);
}
function ST(t) {
  var e = t.element, n = function() {
    return fi(e, ":hover");
  }, r = function() {
    return fi(t.scrollbarX, ":focus") || fi(t.scrollbarY, ":focus");
  };
  function o(i, a) {
    var s = Math.floor(e.scrollTop);
    if (i === 0) {
      if (!t.scrollbarYActive)
        return !1;
      if (s === 0 && a > 0 || s >= t.contentHeight - t.containerHeight && a < 0)
        return !t.settings.wheelPropagation;
    }
    var l = e.scrollLeft;
    if (a === 0) {
      if (!t.scrollbarXActive)
        return !1;
      if (l === 0 && i < 0 || l >= t.contentWidth - t.containerWidth && i > 0)
        return !t.settings.wheelPropagation;
    }
    return !0;
  }
  t.event.bind(t.ownerDocument, "keydown", function(i) {
    if (!(i.isDefaultPrevented && i.isDefaultPrevented() || i.defaultPrevented) && !(!n() && !r())) {
      var a = document.activeElement ? document.activeElement : t.ownerDocument.activeElement;
      if (a) {
        if (a.tagName === "IFRAME")
          a = a.contentDocument.activeElement;
        else
          for (; a.shadowRoot; )
            a = a.shadowRoot.activeElement;
        if (IT(a))
          return;
      }
      var s = 0, l = 0;
      switch (i.which) {
        case 37:
          i.metaKey ? s = -t.contentWidth : i.altKey ? s = -t.containerWidth : s = -30;
          break;
        case 38:
          i.metaKey ? l = t.contentHeight : i.altKey ? l = t.containerHeight : l = 30;
          break;
        case 39:
          i.metaKey ? s = t.contentWidth : i.altKey ? s = t.containerWidth : s = 30;
          break;
        case 40:
          i.metaKey ? l = -t.contentHeight : i.altKey ? l = -t.containerHeight : l = -30;
          break;
        case 32:
          i.shiftKey ? l = t.containerHeight : l = -t.containerHeight;
          break;
        case 33:
          l = t.containerHeight;
          break;
        case 34:
          l = -t.containerHeight;
          break;
        case 36:
          l = t.contentHeight;
          break;
        case 35:
          l = -t.contentHeight;
          break;
        default:
          return;
      }
      t.settings.suppressScrollX && s !== 0 || t.settings.suppressScrollY && l !== 0 || (e.scrollTop -= l, e.scrollLeft += s, Wo(t), o(s, l) && i.preventDefault());
    }
  });
}
function wT(t) {
  var e = t.element;
  function n(a, s) {
    var l = Math.floor(e.scrollTop), c = e.scrollTop === 0, u = l + e.offsetHeight === e.scrollHeight, d = e.scrollLeft === 0, f = e.scrollLeft + e.offsetWidth === e.scrollWidth, h;
    return Math.abs(s) > Math.abs(a) ? h = c || u : h = d || f, h ? !t.settings.wheelPropagation : !0;
  }
  function r(a) {
    var s = a.deltaX, l = -1 * a.deltaY;
    return (typeof s > "u" || typeof l > "u") && (s = -1 * a.wheelDeltaX / 6, l = a.wheelDeltaY / 6), a.deltaMode && a.deltaMode === 1 && (s *= 10, l *= 10), s !== s && l !== l && (s = 0, l = a.wheelDelta), a.shiftKey ? [-l, -s] : [s, l];
  }
  function o(a, s, l) {
    if (!fs.isWebKit && e.querySelector("select:focus"))
      return !0;
    if (!e.contains(a))
      return !1;
    for (var c = a; c && c !== e; ) {
      if (c.classList.contains(Kt.element.consuming))
        return !0;
      var u = no(c);
      if (l && u.overflowY.match(/(scroll|auto)/)) {
        var d = c.scrollHeight - c.clientHeight;
        if (d > 0 && (c.scrollTop > 0 && l < 0 || c.scrollTop < d && l > 0))
          return !0;
      }
      if (s && u.overflowX.match(/(scroll|auto)/)) {
        var f = c.scrollWidth - c.clientWidth;
        if (f > 0 && (c.scrollLeft > 0 && s < 0 || c.scrollLeft < f && s > 0))
          return !0;
      }
      c = c.parentNode;
    }
    return !1;
  }
  function i(a) {
    var s = r(a), l = s[0], c = s[1];
    if (!o(a.target, l, c)) {
      var u = !1;
      t.settings.useBothWheelAxes ? t.scrollbarYActive && !t.scrollbarXActive ? (c ? e.scrollTop -= c * t.settings.wheelSpeed : e.scrollTop += l * t.settings.wheelSpeed, u = !0) : t.scrollbarXActive && !t.scrollbarYActive && (l ? e.scrollLeft += l * t.settings.wheelSpeed : e.scrollLeft -= c * t.settings.wheelSpeed, u = !0) : (e.scrollTop -= c * t.settings.wheelSpeed, e.scrollLeft += l * t.settings.wheelSpeed), Wo(t), u = u || n(l, c), u && !a.ctrlKey && (a.stopPropagation(), a.preventDefault());
    }
  }
  typeof window.onwheel < "u" ? t.event.bind(e, "wheel", i) : typeof window.onmousewheel < "u" && t.event.bind(e, "mousewheel", i);
}
function TT(t) {
  if (!fs.supportsTouch && !fs.supportsIePointer)
    return;
  var e = t.element, n = {
    startOffset: {},
    startTime: 0,
    speed: {},
    easingLoop: null
  };
  function r(d, f) {
    var h = Math.floor(e.scrollTop), _ = e.scrollLeft, E = Math.abs(d), m = Math.abs(f);
    if (m > E) {
      if (f < 0 && h === t.contentHeight - t.containerHeight || f > 0 && h === 0)
        return window.scrollY === 0 && f > 0 && fs.isChrome;
    } else if (E > m && (d < 0 && _ === t.contentWidth - t.containerWidth || d > 0 && _ === 0))
      return !0;
    return !0;
  }
  function o(d, f) {
    e.scrollTop -= f, e.scrollLeft -= d, Wo(t);
  }
  function i(d) {
    return d.targetTouches ? d.targetTouches[0] : d;
  }
  function a(d) {
    return d.target === t.scrollbarX || d.target === t.scrollbarY || d.pointerType && d.pointerType === "pen" && d.buttons === 0 ? !1 : !!(d.targetTouches && d.targetTouches.length === 1 || d.pointerType && d.pointerType !== "mouse" && d.pointerType !== d.MSPOINTER_TYPE_MOUSE);
  }
  function s(d) {
    if (a(d)) {
      var f = i(d);
      n.startOffset.pageX = f.pageX, n.startOffset.pageY = f.pageY, n.startTime = (/* @__PURE__ */ new Date()).getTime(), n.easingLoop !== null && clearInterval(n.easingLoop);
    }
  }
  function l(d, f, h) {
    if (!e.contains(d))
      return !1;
    for (var _ = d; _ && _ !== e; ) {
      if (_.classList.contains(Kt.element.consuming))
        return !0;
      var E = no(_);
      if (h && E.overflowY.match(/(scroll|auto)/)) {
        var m = _.scrollHeight - _.clientHeight;
        if (m > 0 && (_.scrollTop > 0 && h < 0 || _.scrollTop < m && h > 0))
          return !0;
      }
      if (f && E.overflowX.match(/(scroll|auto)/)) {
        var N = _.scrollWidth - _.clientWidth;
        if (N > 0 && (_.scrollLeft > 0 && f < 0 || _.scrollLeft < N && f > 0))
          return !0;
      }
      _ = _.parentNode;
    }
    return !1;
  }
  function c(d) {
    if (a(d)) {
      var f = i(d), h = { pageX: f.pageX, pageY: f.pageY }, _ = h.pageX - n.startOffset.pageX, E = h.pageY - n.startOffset.pageY;
      if (l(d.target, _, E))
        return;
      o(_, E), n.startOffset = h;
      var m = (/* @__PURE__ */ new Date()).getTime(), N = m - n.startTime;
      N > 0 && (n.speed.x = _ / N, n.speed.y = E / N, n.startTime = m), r(_, E) && d.cancelable && d.preventDefault();
    }
  }
  function u() {
    t.settings.swipeEasing && (clearInterval(n.easingLoop), n.easingLoop = setInterval(function() {
      if (t.isInitialized) {
        clearInterval(n.easingLoop);
        return;
      }
      if (!n.speed.x && !n.speed.y) {
        clearInterval(n.easingLoop);
        return;
      }
      if (Math.abs(n.speed.x) < 0.01 && Math.abs(n.speed.y) < 0.01) {
        clearInterval(n.easingLoop);
        return;
      }
      o(n.speed.x * 30, n.speed.y * 30), n.speed.x *= 0.8, n.speed.y *= 0.8;
    }, 10));
  }
  fs.supportsTouch ? (t.event.bind(e, "touchstart", s), t.event.bind(e, "touchmove", c), t.event.bind(e, "touchend", u)) : fs.supportsIePointer && (window.PointerEvent ? (t.event.bind(e, "pointerdown", s), t.event.bind(e, "pointermove", c), t.event.bind(e, "pointerup", u)) : window.MSPointerEvent && (t.event.bind(e, "MSPointerDown", s), t.event.bind(e, "MSPointerMove", c), t.event.bind(e, "MSPointerUp", u)));
}
var bT = function() {
  return {
    handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
    maxScrollbarLength: null,
    minScrollbarLength: null,
    scrollingThreshold: 1e3,
    scrollXMarginOffset: 0,
    scrollYMarginOffset: 0,
    suppressScrollX: !1,
    suppressScrollY: !1,
    swipeEasing: !0,
    useBothWheelAxes: !1,
    wheelPropagation: !0,
    wheelSpeed: 1
  };
}, RT = {
  "click-rail": DT,
  "drag-thumb": CT,
  keyboard: ST,
  wheel: wT,
  touch: TT
}, Xc = function(e, n) {
  var r = this;
  if (n === void 0 && (n = {}), typeof e == "string" && (e = document.querySelector(e)), !e || !e.nodeName)
    throw new Error("no element is specified to initialize PerfectScrollbar");
  this.element = e, e.classList.add(Kt.main), this.settings = bT();
  for (var o in n)
    this.settings[o] = n[o];
  this.containerWidth = null, this.containerHeight = null, this.contentWidth = null, this.contentHeight = null;
  var i = function() {
    return e.classList.add(Kt.state.focus);
  }, a = function() {
    return e.classList.remove(Kt.state.focus);
  };
  this.isRtl = no(e).direction === "rtl", this.isRtl === !0 && e.classList.add(Kt.rtl), this.isNegativeScroll = function() {
    var c = e.scrollLeft, u = null;
    return e.scrollLeft = -1, u = e.scrollLeft < 0, e.scrollLeft = c, u;
  }(), this.negativeScrollAdjustment = this.isNegativeScroll ? e.scrollWidth - e.clientWidth : 0, this.event = new tl(), this.ownerDocument = e.ownerDocument || document, this.scrollbarXRail = Ou(Kt.element.rail("x")), e.appendChild(this.scrollbarXRail), this.scrollbarX = Ou(Kt.element.thumb("x")), this.scrollbarXRail.appendChild(this.scrollbarX), this.scrollbarX.setAttribute("tabindex", 0), this.event.bind(this.scrollbarX, "focus", i), this.event.bind(this.scrollbarX, "blur", a), this.scrollbarXActive = null, this.scrollbarXWidth = null, this.scrollbarXLeft = null;
  var s = no(this.scrollbarXRail);
  this.scrollbarXBottom = parseInt(s.bottom, 10), isNaN(this.scrollbarXBottom) ? (this.isScrollbarXUsingBottom = !1, this.scrollbarXTop = Pt(s.top)) : this.isScrollbarXUsingBottom = !0, this.railBorderXWidth = Pt(s.borderLeftWidth) + Pt(s.borderRightWidth), Vn(this.scrollbarXRail, { display: "block" }), this.railXMarginWidth = Pt(s.marginLeft) + Pt(s.marginRight), Vn(this.scrollbarXRail, { display: "" }), this.railXWidth = null, this.railXRatio = null, this.scrollbarYRail = Ou(Kt.element.rail("y")), e.appendChild(this.scrollbarYRail), this.scrollbarY = Ou(Kt.element.thumb("y")), this.scrollbarYRail.appendChild(this.scrollbarY), this.scrollbarY.setAttribute("tabindex", 0), this.event.bind(this.scrollbarY, "focus", i), this.event.bind(this.scrollbarY, "blur", a), this.scrollbarYActive = null, this.scrollbarYHeight = null, this.scrollbarYTop = null;
  var l = no(this.scrollbarYRail);
  this.scrollbarYRight = parseInt(l.right, 10), isNaN(this.scrollbarYRight) ? (this.isScrollbarYUsingRight = !1, this.scrollbarYLeft = Pt(l.left)) : this.isScrollbarYUsingRight = !0, this.scrollbarYOuterWidth = this.isRtl ? OT(this.scrollbarY) : null, this.railBorderYWidth = Pt(l.borderTopWidth) + Pt(l.borderBottomWidth), Vn(this.scrollbarYRail, { display: "block" }), this.railYMarginHeight = Pt(l.marginTop) + Pt(l.marginBottom), Vn(this.scrollbarYRail, { display: "" }), this.railYHeight = null, this.railYRatio = null, this.reach = {
    x: e.scrollLeft <= 0 ? "start" : e.scrollLeft >= this.contentWidth - this.containerWidth ? "end" : null,
    y: e.scrollTop <= 0 ? "start" : e.scrollTop >= this.contentHeight - this.containerHeight ? "end" : null
  }, this.isAlive = !0, this.settings.handlers.forEach(function(c) {
    return RT[c](r);
  }), this.lastScrollTop = Math.floor(e.scrollTop), this.lastScrollLeft = e.scrollLeft, this.event.bind(this.element, "scroll", function(c) {
    return r.onScroll(c);
  }), Wo(this);
};
Xc.prototype.update = function() {
  this.isAlive && (this.negativeScrollAdjustment = this.isNegativeScroll ? this.element.scrollWidth - this.element.clientWidth : 0, Vn(this.scrollbarXRail, { display: "block" }), Vn(this.scrollbarYRail, { display: "block" }), this.railXMarginWidth = Pt(no(this.scrollbarXRail).marginLeft) + Pt(no(this.scrollbarXRail).marginRight), this.railYMarginHeight = Pt(no(this.scrollbarYRail).marginTop) + Pt(no(this.scrollbarYRail).marginBottom), Vn(this.scrollbarXRail, { display: "none" }), Vn(this.scrollbarYRail, { display: "none" }), Wo(this), Ed(this, "top", 0, !1, !0), Ed(this, "left", 0, !1, !0), Vn(this.scrollbarXRail, { display: "" }), Vn(this.scrollbarYRail, { display: "" }));
};
Xc.prototype.onScroll = function(e) {
  this.isAlive && (Wo(this), Ed(this, "top", this.element.scrollTop - this.lastScrollTop), Ed(this, "left", this.element.scrollLeft - this.lastScrollLeft), this.lastScrollTop = Math.floor(this.element.scrollTop), this.lastScrollLeft = this.element.scrollLeft);
};
Xc.prototype.destroy = function() {
  this.isAlive && (this.event.unbindAll(), vs(this.scrollbarX), vs(this.scrollbarY), vs(this.scrollbarXRail), vs(this.scrollbarYRail), this.removePsClasses(), this.element = null, this.scrollbarX = null, this.scrollbarY = null, this.scrollbarXRail = null, this.scrollbarYRail = null, this.isAlive = !1);
};
Xc.prototype.removePsClasses = function() {
  this.element.className = this.element.className.split(" ").filter(function(e) {
    return !e.match(/^ps([-_].+|)$/);
  }).join(" ");
};
const am = [
  "scroll",
  "ps-scroll-y",
  "ps-scroll-x",
  "ps-scroll-up",
  "ps-scroll-down",
  "ps-scroll-left",
  "ps-scroll-right",
  "ps-y-reach-start",
  "ps-y-reach-end",
  "ps-x-reach-start",
  "ps-x-reach-end"
];
var es = {
  name: "PerfectScrollbar",
  props: {
    options: {
      type: Object,
      required: !1,
      default: () => {
      }
    },
    tag: {
      type: String,
      required: !1,
      default: "div"
    },
    watchOptions: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: am,
  data() {
    return {
      ps: null
    };
  },
  watch: {
    watchOptions(t) {
      !t && this.watcher ? this.watcher() : this.createWatcher();
    }
  },
  mounted() {
    this.create(), this.watchOptions && this.createWatcher();
  },
  updated() {
    this.$nextTick(() => {
      this.update();
    });
  },
  beforeUnmount() {
    this.destroy();
  },
  methods: {
    create() {
      this.ps && this.$isServer || (this.ps = new Xc(this.$el, this.options), am.forEach((t) => {
        this.ps.element.addEventListener(t, (e) => this.$emit(t, e));
      }));
    },
    createWatcher() {
      this.watcher = this.$watch("options", () => {
        this.destroy(), this.create();
      }, {
        deep: !0
      });
    },
    update() {
      this.ps && this.ps.update();
    },
    destroy() {
      this.ps && (this.ps.destroy(), this.ps = null);
    }
  },
  render() {
    return Me(
      this.tag,
      {
        class: "ps"
      },
      this.$slots.default && this.$slots.default()
    );
  }
}, MT = {
  install: (t, e) => {
    e && (e.name && typeof e.name == "string" && (es.name = e.name), e.options && typeof e.options == "object" && (es.props.options.default = () => e.options), e.tag && typeof e.tag == "string" && (es.props.tag.default = e.tag), e.watchOptions && typeof e.watchOptions == "boolean" && (es.props.watchOptions = e.watchOptions)), t.component(
      es.name,
      es
    );
  }
}, PT = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function mf(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function tE(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var o = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, o.get ? o : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var jO = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(PT, function() {
    function n(b, P, $) {
      return (P = function(y) {
        var L = function(w, R) {
          if (typeof w != "object" || w === null)
            return w;
          var B = w[Symbol.toPrimitive];
          if (B !== void 0) {
            var U = B.call(w, R || "default");
            if (typeof U != "object")
              return U;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (R === "string" ? String : Number)(w);
        }(y, "string");
        return typeof L == "symbol" ? L : String(L);
      }(P)) in b ? Object.defineProperty(b, P, { value: $, enumerable: !0, configurable: !0, writable: !0 }) : b[P] = $, b;
    }
    function r(b, P) {
      var $ = Object.keys(b);
      if (Object.getOwnPropertySymbols) {
        var y = Object.getOwnPropertySymbols(b);
        P && (y = y.filter(function(L) {
          return Object.getOwnPropertyDescriptor(b, L).enumerable;
        })), $.push.apply($, y);
      }
      return $;
    }
    function o(b) {
      for (var P = 1; P < arguments.length; P++) {
        var $ = arguments[P] != null ? arguments[P] : {};
        P % 2 ? r(Object($), !0).forEach(function(y) {
          a(b, y, $[y]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(b, Object.getOwnPropertyDescriptors($)) : r(Object($)).forEach(function(y) {
          Object.defineProperty(b, y, Object.getOwnPropertyDescriptor($, y));
        });
      }
      return b;
    }
    function i(b) {
      return i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(P) {
        return typeof P;
      } : function(P) {
        return P && typeof Symbol == "function" && P.constructor === Symbol && P !== Symbol.prototype ? "symbol" : typeof P;
      }, i(b);
    }
    function a(b, P, $) {
      return (P = function(y) {
        var L = function(w, R) {
          if (typeof w != "object" || w === null)
            return w;
          var B = w[Symbol.toPrimitive];
          if (B !== void 0) {
            var U = B.call(w, R);
            if (typeof U != "object")
              return U;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(w);
        }(y, "string");
        return typeof L == "symbol" ? L : String(L);
      }(P)) in b ? Object.defineProperty(b, P, { value: $, enumerable: !0, configurable: !0, writable: !0 }) : b[P] = $, b;
    }
    function s(b, P) {
      (P == null || P > b.length) && (P = b.length);
      for (var $ = 0, y = new Array(P); $ < P; $++)
        y[$] = b[$];
      return y;
    }
    function l(b, P) {
      var $ = typeof Symbol < "u" && b[Symbol.iterator] || b["@@iterator"];
      if (!$) {
        if (Array.isArray(b) || ($ = function(U, K) {
          if (U) {
            if (typeof U == "string")
              return s(U, K);
            var Z = Object.prototype.toString.call(U).slice(8, -1);
            return Z === "Object" && U.constructor && (Z = U.constructor.name), Z === "Map" || Z === "Set" ? Array.from(U) : Z === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Z) ? s(U, K) : void 0;
          }
        }(b)) || P && b && typeof b.length == "number") {
          $ && (b = $);
          var y = 0, L = function() {
          };
          return { s: L, n: function() {
            return y >= b.length ? { done: !0 } : { done: !1, value: b[y++] };
          }, e: function(U) {
            throw U;
          }, f: L };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var w, R = !0, B = !1;
      return { s: function() {
        $ = $.call(b);
      }, n: function() {
        var U = $.next();
        return R = U.done, U;
      }, e: function(U) {
        B = !0, w = U;
      }, f: function() {
        try {
          R || $.return == null || $.return();
        } finally {
          if (B)
            throw w;
        }
      } };
    }
    var c = function(b) {
      var P = window.getComputedStyle(b), $ = parseFloat(P.height), y = P.lineHeight === "normal" ? 1.2 * parseFloat(P.fontSize) : parseFloat(P.lineHeight);
      return $ === 0 && y === 0 ? 0 : Math.ceil($ / y);
    }, u = /* @__PURE__ */ new WeakMap(), d = function(b) {
      return u.get(b);
    }, f = function(b, P) {
      u.set(b, P);
    }, h = function(b) {
      return { hasEllipsis: d(b).hasEllipsis };
    }, _ = function(b) {
      var P = o({}, d(b));
      P != null && P.observer && (P == null || P.observer.disconnect()), P != null && P.observer && (P == null || delete P.prevWidth), P != null && P.observer && (P == null || delete P.prevHeight), P != null && P.observer && (P == null || delete P.observer), f(b, P);
    }, E = { mode: "css", lines: 3, ellipsis: ". . .", midWord: !0, textContent: null }, m = function(b) {
      if (typeof b == "number")
        return parseInt(b.toString());
      if (typeof b == "string") {
        var P = parseInt(b);
        if (!isNaN(P))
          return P;
      }
      return E.lines;
    }, N = function(b) {
      return typeof CSS < "u" && CSS.supports("display", "-webkit-box") && CSS.supports("-webkit-line-clamp", "3") && CSS.supports("-webkit-box-orient", "vertical") ? b === "css" || b === "js" ? b : E.mode : "js";
    }, I = function(b) {
      return typeof b == "string" ? b : typeof b == "number" ? b.toString() : E.ellipsis;
    }, O = function(b) {
      return typeof b == "boolean" ? b : E.midWord;
    }, p = function(b) {
      return typeof b == "string" ? b : typeof b == "number" ? b.toString() : E.textContent;
    }, C = function(b) {
      var P, $ = d(b);
      b.textContent = (P = $ == null ? void 0 : $.fullText) !== null && P !== void 0 ? P : b.textContent, b.style.display = "", b.style.webkitLineClamp = "", b.style.webkitBoxOrient = "", b.style.overflow = "";
    }, D = function(b, P, $) {
      var y = !function(B) {
        return u.has(B);
      }(b), L = d(b), w = function(B) {
        if (i(B) !== "object" || B === null)
          return E;
        var U = B, K = U.mode, Z = U.lines, X = U.ellipsis, J = U.midWord, ae = U.textContent;
        return { mode: N(K), lines: m(Z), ellipsis: I(X), midWord: O(J), textContent: p(ae) };
      }(P);
      f(b, o(o(o({}, L), w), {}, { hasEllipsis: !y && (L == null ? void 0 : L.hasEllipsis), fullText: w.textContent ? w.textContent : y ? b.textContent : L == null ? void 0 : L.fullText }));
      var R = function() {
        var B = h(b), U = d(b);
        C(b);
        var K = c(b);
        if (U.mode === "css" && function(X, J) {
          var ae = J.lines, re = J.fullText;
          X.textContent = re, X.style.display = "-webkit-box", X.style.webkitLineClamp = ae.toString(), X.style.webkitBoxOrient = "vertical", X.style.overflow = "hidden";
        }(b, U), U.mode === "js" && function(X, J) {
          var ae = J.lines, re = J.midWord, j = J.fullText, ne = J.ellipsis, Ee = re ? [". ", ", ", " ", ""] : [". ", ", ", " "];
          if (X.textContent = j, X.style.display = "", X.style.webkitLineClamp = "", X.style.webkitBoxOrient = "", X.style.overflow = "", !(ae <= 0 || c(X) <= ae)) {
            var fe = { unprocessed: j, processed: "" };
            Ee.forEach(function(Oe) {
              var ce, Se = l(fe.unprocessed.split(Oe));
              try {
                for (Se.s(); !(ce = Se.n()).done; ) {
                  var se = ce.value;
                  if (X.textContent = "".concat(fe.processed).concat(se).concat(Oe).concat(ne), c(X) > ae) {
                    fe.unprocessed = se;
                    break;
                  }
                  fe.processed = "".concat(fe.processed).concat(se).concat(Oe);
                }
              } catch (Ie) {
                Se.e(Ie);
              } finally {
                Se.f();
              }
            }), X.textContent = "".concat(fe.processed.trim()).concat(ne);
          }
        }(b, U), f(b, o(o({}, U), {}, { hasEllipsis: c(b) < K })), $) {
          var Z = h(b);
          $(Z, B);
        }
      };
      if (typeof ResizeObserver < "u")
        return _(b), void function(B, U) {
          var K = d(B), Z = K.observer || new ResizeObserver(function() {
            var X = d(B);
            if (B.clientWidth !== X.prevWidth || B.clientHeight !== X.prevHeight) {
              U();
              var J = o({}, X);
              J.prevWidth = B.clientWidth, J.prevHeight = B.clientHeight, f(B, J);
            }
          });
          Z.observe(B), f(B, o(o({}, K), {}, { observer: Z }));
        }(b, R);
      R();
    }, T = function(b, P) {
      var $ = P.value, y = $.lines, L = $.mode, w = $.midWord, R = $.ellipsis, B = $.onSnipped;
      D(b, { lines: y, mode: L, midWord: w, ellipsis: R }, B);
    }, k = function(b, P, $) {
      var y, L, w, R = P.value, B = (y = $ == null || (L = $.children) === null || L === void 0 || (w = L[0]) === null || w === void 0 ? void 0 : w.text) !== null && y !== void 0 ? y : "", U = R.lines, K = R.mode, Z = R.midWord, X = R.ellipsis, J = R.onSnipped;
      D(b, { lines: U, mode: K, midWord: Z, ellipsis: X, textContent: B }, J);
    }, G = function(b) {
      (function(P) {
        C(P), _(P), function($) {
          u.delete($);
        }(P);
      })(b);
    };
    return { install: function(b) {
      var P, $ = parseFloat(b.version[0]) > 2;
      b.directive("snip", (n(P = {}, $ ? "mounted" : "inserted", T), n(P, $ ? "updated" : "update", k), n(P, $ ? "unmounted" : "unbind", G), P));
    } };
  });
})(jO);
var yT = jO.exports;
const LT = /* @__PURE__ */ mf(yT);
var nE = {}, Fh = function(t, e) {
  return Fh = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var o in r)
      Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
  }, Fh(t, e);
};
function rE(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Fh(t, e);
  function n() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
}
var pd = function() {
  return pd = Object.assign || function(e) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
    }
    return e;
  }, pd.apply(this, arguments);
};
function JO(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(t); o < r.length; o++)
      e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
  return n;
}
function QO(t, e, n, r) {
  var o = arguments.length, i = o < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (a = t[s]) && (i = (o < 3 ? a(i) : o > 3 ? a(e, n, i) : a(e, n)) || i);
  return o > 3 && i && Object.defineProperty(e, n, i), i;
}
function eA(t, e) {
  return function(n, r) {
    e(n, r, t);
  };
}
function tA(t, e, n, r, o, i) {
  function a(N) {
    if (N !== void 0 && typeof N != "function")
      throw new TypeError("Function expected");
    return N;
  }
  for (var s = r.kind, l = s === "getter" ? "get" : s === "setter" ? "set" : "value", c = !e && t ? r.static ? t : t.prototype : null, u = e || (c ? Object.getOwnPropertyDescriptor(c, r.name) : {}), d, f = !1, h = n.length - 1; h >= 0; h--) {
    var _ = {};
    for (var E in r)
      _[E] = E === "access" ? {} : r[E];
    for (var E in r.access)
      _.access[E] = r.access[E];
    _.addInitializer = function(N) {
      if (f)
        throw new TypeError("Cannot add initializers after decoration has completed");
      i.push(a(N || null));
    };
    var m = (0, n[h])(s === "accessor" ? { get: u.get, set: u.set } : u[l], _);
    if (s === "accessor") {
      if (m === void 0)
        continue;
      if (m === null || typeof m != "object")
        throw new TypeError("Object expected");
      (d = a(m.get)) && (u.get = d), (d = a(m.set)) && (u.set = d), (d = a(m.init)) && o.unshift(d);
    } else
      (d = a(m)) && (s === "field" ? o.unshift(d) : u[l] = d);
  }
  c && Object.defineProperty(c, r.name, u), f = !0;
}
function nA(t, e, n) {
  for (var r = arguments.length > 2, o = 0; o < e.length; o++)
    n = r ? e[o].call(t, n) : e[o].call(t);
  return r ? n : void 0;
}
function rA(t) {
  return typeof t == "symbol" ? t : "".concat(t);
}
function oA(t, e, n) {
  return typeof e == "symbol" && (e = e.description ? "[".concat(e.description, "]") : ""), Object.defineProperty(t, "name", { configurable: !0, value: n ? "".concat(n, " ", e) : e });
}
function iA(t, e) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(t, e);
}
function aA(t, e, n, r) {
  function o(i) {
    return i instanceof n ? i : new n(function(a) {
      a(i);
    });
  }
  return new (n || (n = Promise))(function(i, a) {
    function s(u) {
      try {
        c(r.next(u));
      } catch (d) {
        a(d);
      }
    }
    function l(u) {
      try {
        c(r.throw(u));
      } catch (d) {
        a(d);
      }
    }
    function c(u) {
      u.done ? i(u.value) : o(u.value).then(s, l);
    }
    c((r = r.apply(t, e || [])).next());
  });
}
function sA(t, e) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, o, i, a = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return a.next = s(0), a.throw = s(1), a.return = s(2), typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, c[0] && (n = 0)), n; )
      try {
        if (r = 1, o && (i = c[0] & 2 ? o.return : c[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, c[1])).done)
          return i;
        switch (o = 0, i && (c = [c[0] & 2, i.value]), c[0]) {
          case 0:
          case 1:
            i = c;
            break;
          case 4:
            return n.label++, { value: c[1], done: !1 };
          case 5:
            n.label++, o = c[1], c = [0];
            continue;
          case 7:
            c = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              n = 0;
              continue;
            }
            if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
              n.label = c[1];
              break;
            }
            if (c[0] === 6 && n.label < i[1]) {
              n.label = i[1], i = c;
              break;
            }
            if (i && n.label < i[2]) {
              n.label = i[2], n.ops.push(c);
              break;
            }
            i[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        c = e.call(t, n);
      } catch (u) {
        c = [6, u], o = 0;
      } finally {
        r = i = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
var Nf = Object.create ? function(t, e, n, r) {
  r === void 0 && (r = n);
  var o = Object.getOwnPropertyDescriptor(e, n);
  (!o || ("get" in o ? !e.__esModule : o.writable || o.configurable)) && (o = { enumerable: !0, get: function() {
    return e[n];
  } }), Object.defineProperty(t, r, o);
} : function(t, e, n, r) {
  r === void 0 && (r = n), t[r] = e[n];
};
function lA(t, e) {
  for (var n in t)
    n !== "default" && !Object.prototype.hasOwnProperty.call(e, n) && Nf(e, t, n);
}
function md(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function oE(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n)
    return t;
  var r = n.call(t), o, i = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(o = r.next()).done; )
      i.push(o.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      o && !o.done && (n = r.return) && n.call(r);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
}
function cA() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t = t.concat(oE(arguments[e]));
  return t;
}
function uA() {
  for (var t = 0, e = 0, n = arguments.length; e < n; e++)
    t += arguments[e].length;
  for (var r = Array(t), o = 0, e = 0; e < n; e++)
    for (var i = arguments[e], a = 0, s = i.length; a < s; a++, o++)
      r[o] = i[a];
  return r;
}
function Fr(t, e, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = e.length, i; r < o; r++)
      (i || !(r in e)) && (i || (i = Array.prototype.slice.call(e, 0, r)), i[r] = e[r]);
  return t.concat(i || Array.prototype.slice.call(e));
}
function ks(t) {
  return this instanceof ks ? (this.v = t, this) : new ks(t);
}
function dA(t, e, n) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(t, e || []), o, i = [];
  return o = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), s("next"), s("throw"), s("return", a), o[Symbol.asyncIterator] = function() {
    return this;
  }, o;
  function a(h) {
    return function(_) {
      return Promise.resolve(_).then(h, d);
    };
  }
  function s(h, _) {
    r[h] && (o[h] = function(E) {
      return new Promise(function(m, N) {
        i.push([h, E, m, N]) > 1 || l(h, E);
      });
    }, _ && (o[h] = _(o[h])));
  }
  function l(h, _) {
    try {
      c(r[h](_));
    } catch (E) {
      f(i[0][3], E);
    }
  }
  function c(h) {
    h.value instanceof ks ? Promise.resolve(h.value.v).then(u, d) : f(i[0][2], h);
  }
  function u(h) {
    l("next", h);
  }
  function d(h) {
    l("throw", h);
  }
  function f(h, _) {
    h(_), i.shift(), i.length && l(i[0][0], i[0][1]);
  }
}
function fA(t) {
  var e, n;
  return e = {}, r("next"), r("throw", function(o) {
    throw o;
  }), r("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function r(o, i) {
    e[o] = t[o] ? function(a) {
      return (n = !n) ? { value: ks(t[o](a)), done: !1 } : i ? i(a) : a;
    } : i;
  }
}
function hA(t) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], n;
  return e ? e.call(t) : (t = typeof md == "function" ? md(t) : t[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(i) {
    n[i] = t[i] && function(a) {
      return new Promise(function(s, l) {
        a = t[i](a), o(s, l, a.done, a.value);
      });
    };
  }
  function o(i, a, s, l) {
    Promise.resolve(l).then(function(c) {
      i({ value: c, done: s });
    }, a);
  }
}
function _A(t, e) {
  return Object.defineProperty ? Object.defineProperty(t, "raw", { value: e }) : t.raw = e, t;
}
var xT = Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}, Vh = function(t) {
  return Vh = Object.getOwnPropertyNames || function(e) {
    var n = [];
    for (var r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (n[n.length] = r);
    return n;
  }, Vh(t);
};
function EA(t) {
  if (t && t.__esModule)
    return t;
  var e = {};
  if (t != null)
    for (var n = Vh(t), r = 0; r < n.length; r++)
      n[r] !== "default" && Nf(e, t, n[r]);
  return xT(e, t), e;
}
function pA(t) {
  return t && t.__esModule ? t : { default: t };
}
function mA(t, e, n, r) {
  if (n === "a" && !r)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !r : !e.has(t))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(t) : r ? r.value : e.get(t);
}
function NA(t, e, n, r, o) {
  if (r === "m")
    throw new TypeError("Private method is not writable");
  if (r === "a" && !o)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !o : !e.has(t))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return r === "a" ? o.call(t, n) : o ? o.value = n : e.set(t, n), n;
}
function vA(t, e) {
  if (e === null || typeof e != "object" && typeof e != "function")
    throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof t == "function" ? e === t : t.has(e);
}
function gA(t, e, n) {
  if (e != null) {
    if (typeof e != "object" && typeof e != "function")
      throw new TypeError("Object expected.");
    var r, o;
    if (n) {
      if (!Symbol.asyncDispose)
        throw new TypeError("Symbol.asyncDispose is not defined.");
      r = e[Symbol.asyncDispose];
    }
    if (r === void 0) {
      if (!Symbol.dispose)
        throw new TypeError("Symbol.dispose is not defined.");
      r = e[Symbol.dispose], n && (o = r);
    }
    if (typeof r != "function")
      throw new TypeError("Object not disposable.");
    o && (r = function() {
      try {
        o.call(this);
      } catch (i) {
        return Promise.reject(i);
      }
    }), t.stack.push({ value: e, dispose: r, async: n });
  } else
    n && t.stack.push({ async: !0 });
  return e;
}
var UT = typeof SuppressedError == "function" ? SuppressedError : function(t, e, n) {
  var r = new Error(n);
  return r.name = "SuppressedError", r.error = t, r.suppressed = e, r;
};
function IA(t) {
  function e(i) {
    t.error = t.hasError ? new UT(i, t.error, "An error was suppressed during disposal.") : i, t.hasError = !0;
  }
  var n, r = 0;
  function o() {
    for (; n = t.stack.pop(); )
      try {
        if (!n.async && r === 1)
          return r = 0, t.stack.push(n), Promise.resolve().then(o);
        if (n.dispose) {
          var i = n.dispose.call(n.value);
          if (n.async)
            return r |= 2, Promise.resolve(i).then(o, function(a) {
              return e(a), o();
            });
        } else
          r |= 1;
      } catch (a) {
        e(a);
      }
    if (r === 1)
      return t.hasError ? Promise.reject(t.error) : Promise.resolve();
    if (t.hasError)
      throw t.error;
  }
  return o();
}
function OA(t, e) {
  return typeof t == "string" && /^\.\.?\//.test(t) ? t.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(n, r, o, i, a) {
    return r ? e ? ".jsx" : ".js" : o && (!i || !a) ? n : o + i + "." + a.toLowerCase() + "js";
  }) : t;
}
const $T = {
  __extends: rE,
  __assign: pd,
  __rest: JO,
  __decorate: QO,
  __param: eA,
  __esDecorate: tA,
  __runInitializers: nA,
  __propKey: rA,
  __setFunctionName: oA,
  __metadata: iA,
  __awaiter: aA,
  __generator: sA,
  __createBinding: Nf,
  __exportStar: lA,
  __values: md,
  __read: oE,
  __spread: cA,
  __spreadArrays: uA,
  __spreadArray: Fr,
  __await: ks,
  __asyncGenerator: dA,
  __asyncDelegator: fA,
  __asyncValues: hA,
  __makeTemplateObject: _A,
  __importStar: EA,
  __importDefault: pA,
  __classPrivateFieldGet: mA,
  __classPrivateFieldSet: NA,
  __classPrivateFieldIn: vA,
  __addDisposableResource: gA,
  __disposeResources: IA,
  __rewriteRelativeImportExtension: OA
}, kT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __addDisposableResource: gA,
  get __assign() {
    return pd;
  },
  __asyncDelegator: fA,
  __asyncGenerator: dA,
  __asyncValues: hA,
  __await: ks,
  __awaiter: aA,
  __classPrivateFieldGet: mA,
  __classPrivateFieldIn: vA,
  __classPrivateFieldSet: NA,
  __createBinding: Nf,
  __decorate: QO,
  __disposeResources: IA,
  __esDecorate: tA,
  __exportStar: lA,
  __extends: rE,
  __generator: sA,
  __importDefault: pA,
  __importStar: EA,
  __makeTemplateObject: _A,
  __metadata: iA,
  __param: eA,
  __propKey: rA,
  __read: oE,
  __rest: JO,
  __rewriteRelativeImportExtension: OA,
  __runInitializers: nA,
  __setFunctionName: oA,
  __spread: cA,
  __spreadArray: Fr,
  __spreadArrays: uA,
  __values: md,
  default: $T
}, Symbol.toStringTag, { value: "Module" })), BT = /* @__PURE__ */ tE(kT);
function AA(t) {
  return Intl.getCanonicalLocales(t);
}
function GT(t, e) {
  var n = e.zoneNames, r = e.uppercaseLinks, o = t.toUpperCase(), i = n.reduce(function(s, l) {
    return s[l.toUpperCase()] = l, s;
  }, {}), a = r[o] || i[o];
  return a === "Etc/UTC" || a === "Etc/GMT" ? "UTC" : a;
}
/*!
 *  decimal.js v10.6.0
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js
 *  Copyright (c) 2025 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Licence
 */
var gs = 9e15, $i = 1e9, Hh = "0123456789abcdef", Nd = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", vd = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", Wh = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed at run-time using the `Decimal.config` method.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used when rounding to `precision`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The modulo mode used when calculating the modulus: a mod n.
  // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
  // The remainder (r) is calculated as: r = a - n * q.
  //
  // UP         0 The remainder is positive if the dividend is negative, else is negative.
  // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
  // FLOOR      3 The remainder has the same sign as the divisor (Python %).
  // HALF_EVEN  6 The IEEE 754 remainder function.
  // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
  //
  // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
  // division (9) are commonly used for the modulus operation. The other rounding modes can also
  // be used, but they may not give useful results.
  modulo: 1,
  // 0 to 9
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -EXP_LIMIT
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to EXP_LIMIT
  // The minimum exponent value, beneath which underflow to zero occurs.
  // JavaScript numbers: -324  (5e-324)
  minE: -gs,
  // -1 to -EXP_LIMIT
  // The maximum exponent value, above which overflow to Infinity occurs.
  // JavaScript numbers: 308  (1.7976931348623157e+308)
  maxE: gs,
  // 1 to EXP_LIMIT
  // Whether to use cryptographically-secure random number generation, if available.
  crypto: !1
  // true/false
}, DA, xo, We = !0, vf = "[DecimalError] ", Ri = vf + "Invalid argument: ", CA = vf + "Precision limit exceeded", SA = vf + "crypto unavailable", wA = "[object Decimal]", gn = Math.floor, Xt = Math.pow, FT = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, VT = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, HT = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, TA = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, kr = 1e7, Be = 7, WT = 9007199254740991, YT = Nd.length - 1, Yh = vd.length - 1, de = { toStringTag: wA };
de.absoluteValue = de.abs = function() {
  var t = new this.constructor(this);
  return t.s < 0 && (t.s = 1), xe(t);
};
de.ceil = function() {
  return xe(new this.constructor(this), this.e + 1, 2);
};
de.clampedTo = de.clamp = function(t, e) {
  var n, r = this, o = r.constructor;
  if (t = new o(t), e = new o(e), !t.s || !e.s)
    return new o(NaN);
  if (t.gt(e))
    throw Error(Ri + e);
  return n = r.cmp(t), n < 0 ? t : r.cmp(e) > 0 ? e : new o(r);
};
de.comparedTo = de.cmp = function(t) {
  var e, n, r, o, i = this, a = i.d, s = (t = new i.constructor(t)).d, l = i.s, c = t.s;
  if (!a || !s)
    return !l || !c ? NaN : l !== c ? l : a === s ? 0 : !a ^ l < 0 ? 1 : -1;
  if (!a[0] || !s[0])
    return a[0] ? l : s[0] ? -c : 0;
  if (l !== c)
    return l;
  if (i.e !== t.e)
    return i.e > t.e ^ l < 0 ? 1 : -1;
  for (r = a.length, o = s.length, e = 0, n = r < o ? r : o; e < n; ++e)
    if (a[e] !== s[e])
      return a[e] > s[e] ^ l < 0 ? 1 : -1;
  return r === o ? 0 : r > o ^ l < 0 ? 1 : -1;
};
de.cosine = de.cos = function() {
  var t, e, n = this, r = n.constructor;
  return n.d ? n.d[0] ? (t = r.precision, e = r.rounding, r.precision = t + Math.max(n.e, n.sd()) + Be, r.rounding = 1, n = KT(r, yA(r, n)), r.precision = t, r.rounding = e, xe(xo == 2 || xo == 3 ? n.neg() : n, t, e, !0)) : new r(1) : new r(NaN);
};
de.cubeRoot = de.cbrt = function() {
  var t, e, n, r, o, i, a, s, l, c, u = this, d = u.constructor;
  if (!u.isFinite() || u.isZero())
    return new d(u);
  for (We = !1, i = u.s * Xt(u.s * u, 1 / 3), !i || Math.abs(i) == 1 / 0 ? (n = fn(u.d), t = u.e, (i = (t - n.length + 1) % 3) && (n += i == 1 || i == -2 ? "0" : "00"), i = Xt(n, 1 / 3), t = gn((t + 1) / 3) - (t % 3 == (t < 0 ? -1 : 2)), i == 1 / 0 ? n = "5e" + t : (n = i.toExponential(), n = n.slice(0, n.indexOf("e") + 1) + t), r = new d(n), r.s = u.s) : r = new d(i.toString()), a = (t = d.precision) + 3; ; )
    if (s = r, l = s.times(s).times(s), c = l.plus(u), r = mt(c.plus(u).times(s), c.plus(l), a + 2, 1), fn(s.d).slice(0, a) === (n = fn(r.d)).slice(0, a))
      if (n = n.slice(a - 3, a + 1), n == "9999" || !o && n == "4999") {
        if (!o && (xe(s, t + 1, 0), s.times(s).times(s).eq(u))) {
          r = s;
          break;
        }
        a += 4, o = 1;
      } else {
        (!+n || !+n.slice(1) && n.charAt(0) == "5") && (xe(r, t + 1, 1), e = !r.times(r).times(r).eq(u));
        break;
      }
  return We = !0, xe(r, t, d.rounding, e);
};
de.decimalPlaces = de.dp = function() {
  var t, e = this.d, n = NaN;
  if (e) {
    if (t = e.length - 1, n = (t - gn(this.e / Be)) * Be, t = e[t], t)
      for (; t % 10 == 0; t /= 10)
        n--;
    n < 0 && (n = 0);
  }
  return n;
};
de.dividedBy = de.div = function(t) {
  return mt(this, new this.constructor(t));
};
de.dividedToIntegerBy = de.divToInt = function(t) {
  var e = this, n = e.constructor;
  return xe(mt(e, new n(t), 0, 1, 1), n.precision, n.rounding);
};
de.equals = de.eq = function(t) {
  return this.cmp(t) === 0;
};
de.floor = function() {
  return xe(new this.constructor(this), this.e + 1, 3);
};
de.greaterThan = de.gt = function(t) {
  return this.cmp(t) > 0;
};
de.greaterThanOrEqualTo = de.gte = function(t) {
  var e = this.cmp(t);
  return e == 1 || e === 0;
};
de.hyperbolicCosine = de.cosh = function() {
  var t, e, n, r, o, i = this, a = i.constructor, s = new a(1);
  if (!i.isFinite())
    return new a(i.s ? 1 / 0 : NaN);
  if (i.isZero())
    return s;
  n = a.precision, r = a.rounding, a.precision = n + Math.max(i.e, i.sd()) + 4, a.rounding = 1, o = i.d.length, o < 32 ? (t = Math.ceil(o / 3), e = (1 / If(4, t)).toString()) : (t = 16, e = "2.3283064365386962890625e-10"), i = Bs(a, 1, i.times(e), new a(1), !0);
  for (var l, c = t, u = new a(8); c--; )
    l = i.times(i), i = s.minus(l.times(u.minus(l.times(u))));
  return xe(i, a.precision = n, a.rounding = r, !0);
};
de.hyperbolicSine = de.sinh = function() {
  var t, e, n, r, o = this, i = o.constructor;
  if (!o.isFinite() || o.isZero())
    return new i(o);
  if (e = i.precision, n = i.rounding, i.precision = e + Math.max(o.e, o.sd()) + 4, i.rounding = 1, r = o.d.length, r < 3)
    o = Bs(i, 2, o, o, !0);
  else {
    t = 1.4 * Math.sqrt(r), t = t > 16 ? 16 : t | 0, o = o.times(1 / If(5, t)), o = Bs(i, 2, o, o, !0);
    for (var a, s = new i(5), l = new i(16), c = new i(20); t--; )
      a = o.times(o), o = o.times(s.plus(a.times(l.times(a).plus(c))));
  }
  return i.precision = e, i.rounding = n, xe(o, e, n, !0);
};
de.hyperbolicTangent = de.tanh = function() {
  var t, e, n = this, r = n.constructor;
  return n.isFinite() ? n.isZero() ? new r(n) : (t = r.precision, e = r.rounding, r.precision = t + 7, r.rounding = 1, mt(n.sinh(), n.cosh(), r.precision = t, r.rounding = e)) : new r(n.s);
};
de.inverseCosine = de.acos = function() {
  var t = this, e = t.constructor, n = t.abs().cmp(1), r = e.precision, o = e.rounding;
  return n !== -1 ? n === 0 ? t.isNeg() ? ro(e, r, o) : new e(0) : new e(NaN) : t.isZero() ? ro(e, r + 4, o).times(0.5) : (e.precision = r + 6, e.rounding = 1, t = new e(1).minus(t).div(t.plus(1)).sqrt().atan(), e.precision = r, e.rounding = o, t.times(2));
};
de.inverseHyperbolicCosine = de.acosh = function() {
  var t, e, n = this, r = n.constructor;
  return n.lte(1) ? new r(n.eq(1) ? 0 : NaN) : n.isFinite() ? (t = r.precision, e = r.rounding, r.precision = t + Math.max(Math.abs(n.e), n.sd()) + 4, r.rounding = 1, We = !1, n = n.times(n).minus(1).sqrt().plus(n), We = !0, r.precision = t, r.rounding = e, n.ln()) : new r(n);
};
de.inverseHyperbolicSine = de.asinh = function() {
  var t, e, n = this, r = n.constructor;
  return !n.isFinite() || n.isZero() ? new r(n) : (t = r.precision, e = r.rounding, r.precision = t + 2 * Math.max(Math.abs(n.e), n.sd()) + 6, r.rounding = 1, We = !1, n = n.times(n).plus(1).sqrt().plus(n), We = !0, r.precision = t, r.rounding = e, n.ln());
};
de.inverseHyperbolicTangent = de.atanh = function() {
  var t, e, n, r, o = this, i = o.constructor;
  return o.isFinite() ? o.e >= 0 ? new i(o.abs().eq(1) ? o.s / 0 : o.isZero() ? o : NaN) : (t = i.precision, e = i.rounding, r = o.sd(), Math.max(r, t) < 2 * -o.e - 1 ? xe(new i(o), t, e, !0) : (i.precision = n = r - o.e, o = mt(o.plus(1), new i(1).minus(o), n + t, 1), i.precision = t + 4, i.rounding = 1, o = o.ln(), i.precision = t, i.rounding = e, o.times(0.5))) : new i(NaN);
};
de.inverseSine = de.asin = function() {
  var t, e, n, r, o = this, i = o.constructor;
  return o.isZero() ? new i(o) : (e = o.abs().cmp(1), n = i.precision, r = i.rounding, e !== -1 ? e === 0 ? (t = ro(i, n + 4, r).times(0.5), t.s = o.s, t) : new i(NaN) : (i.precision = n + 6, i.rounding = 1, o = o.div(new i(1).minus(o.times(o)).sqrt().plus(1)).atan(), i.precision = n, i.rounding = r, o.times(2)));
};
de.inverseTangent = de.atan = function() {
  var t, e, n, r, o, i, a, s, l, c = this, u = c.constructor, d = u.precision, f = u.rounding;
  if (c.isFinite()) {
    if (c.isZero())
      return new u(c);
    if (c.abs().eq(1) && d + 4 <= Yh)
      return a = ro(u, d + 4, f).times(0.25), a.s = c.s, a;
  } else {
    if (!c.s)
      return new u(NaN);
    if (d + 4 <= Yh)
      return a = ro(u, d + 4, f).times(0.5), a.s = c.s, a;
  }
  for (u.precision = s = d + 10, u.rounding = 1, n = Math.min(28, s / Be + 2 | 0), t = n; t; --t)
    c = c.div(c.times(c).plus(1).sqrt().plus(1));
  for (We = !1, e = Math.ceil(s / Be), r = 1, l = c.times(c), a = new u(c), o = c; t !== -1; )
    if (o = o.times(l), i = a.minus(o.div(r += 2)), o = o.times(l), a = i.plus(o.div(r += 2)), a.d[e] !== void 0)
      for (t = e; a.d[t] === i.d[t] && t--; )
        ;
  return n && (a = a.times(2 << n - 1)), We = !0, xe(a, u.precision = d, u.rounding = f, !0);
};
de.isFinite = function() {
  return !!this.d;
};
de.isInteger = de.isInt = function() {
  return !!this.d && gn(this.e / Be) > this.d.length - 2;
};
de.isNaN = function() {
  return !this.s;
};
de.isNegative = de.isNeg = function() {
  return this.s < 0;
};
de.isPositive = de.isPos = function() {
  return this.s > 0;
};
de.isZero = function() {
  return !!this.d && this.d[0] === 0;
};
de.lessThan = de.lt = function(t) {
  return this.cmp(t) < 0;
};
de.lessThanOrEqualTo = de.lte = function(t) {
  return this.cmp(t) < 1;
};
de.logarithm = de.log = function(t) {
  var e, n, r, o, i, a, s, l, c = this, u = c.constructor, d = u.precision, f = u.rounding, h = 5;
  if (t == null)
    t = new u(10), e = !0;
  else {
    if (t = new u(t), n = t.d, t.s < 0 || !n || !n[0] || t.eq(1))
      return new u(NaN);
    e = t.eq(10);
  }
  if (n = c.d, c.s < 0 || !n || !n[0] || c.eq(1))
    return new u(n && !n[0] ? -1 / 0 : c.s != 1 ? NaN : n ? 0 : 1 / 0);
  if (e)
    if (n.length > 1)
      i = !0;
    else {
      for (o = n[0]; o % 10 === 0; )
        o /= 10;
      i = o !== 1;
    }
  if (We = !1, s = d + h, a = hi(c, s), r = e ? gd(u, s + 10) : hi(t, s), l = mt(a, r, s, 1), hc(l.d, o = d, f))
    do
      if (s += 10, a = hi(c, s), r = e ? gd(u, s + 10) : hi(t, s), l = mt(a, r, s, 1), !i) {
        +fn(l.d).slice(o + 1, o + 15) + 1 == 1e14 && (l = xe(l, d + 1, 0));
        break;
      }
    while (hc(l.d, o += 10, f));
  return We = !0, xe(l, d, f);
};
de.minus = de.sub = function(t) {
  var e, n, r, o, i, a, s, l, c, u, d, f, h = this, _ = h.constructor;
  if (t = new _(t), !h.d || !t.d)
    return !h.s || !t.s ? t = new _(NaN) : h.d ? t.s = -t.s : t = new _(t.d || h.s !== t.s ? h : NaN), t;
  if (h.s != t.s)
    return t.s = -t.s, h.plus(t);
  if (c = h.d, f = t.d, s = _.precision, l = _.rounding, !c[0] || !f[0]) {
    if (f[0])
      t.s = -t.s;
    else if (c[0])
      t = new _(h);
    else
      return new _(l === 3 ? -0 : 0);
    return We ? xe(t, s, l) : t;
  }
  if (n = gn(t.e / Be), u = gn(h.e / Be), c = c.slice(), i = u - n, i) {
    for (d = i < 0, d ? (e = c, i = -i, a = f.length) : (e = f, n = u, a = c.length), r = Math.max(Math.ceil(s / Be), a) + 2, i > r && (i = r, e.length = 1), e.reverse(), r = i; r--; )
      e.push(0);
    e.reverse();
  } else {
    for (r = c.length, a = f.length, d = r < a, d && (a = r), r = 0; r < a; r++)
      if (c[r] != f[r]) {
        d = c[r] < f[r];
        break;
      }
    i = 0;
  }
  for (d && (e = c, c = f, f = e, t.s = -t.s), a = c.length, r = f.length - a; r > 0; --r)
    c[a++] = 0;
  for (r = f.length; r > i; ) {
    if (c[--r] < f[r]) {
      for (o = r; o && c[--o] === 0; )
        c[o] = kr - 1;
      --c[o], c[r] += kr;
    }
    c[r] -= f[r];
  }
  for (; c[--a] === 0; )
    c.pop();
  for (; c[0] === 0; c.shift())
    --n;
  return c[0] ? (t.d = c, t.e = gf(c, n), We ? xe(t, s, l) : t) : new _(l === 3 ? -0 : 0);
};
de.modulo = de.mod = function(t) {
  var e, n = this, r = n.constructor;
  return t = new r(t), !n.d || !t.s || t.d && !t.d[0] ? new r(NaN) : !t.d || n.d && !n.d[0] ? xe(new r(n), r.precision, r.rounding) : (We = !1, r.modulo == 9 ? (e = mt(n, t.abs(), 0, 3, 1), e.s *= t.s) : e = mt(n, t, 0, r.modulo, 1), e = e.times(t), We = !0, n.minus(e));
};
de.naturalExponential = de.exp = function() {
  return Kh(this);
};
de.naturalLogarithm = de.ln = function() {
  return hi(this);
};
de.negated = de.neg = function() {
  var t = new this.constructor(this);
  return t.s = -t.s, xe(t);
};
de.plus = de.add = function(t) {
  var e, n, r, o, i, a, s, l, c, u, d = this, f = d.constructor;
  if (t = new f(t), !d.d || !t.d)
    return !d.s || !t.s ? t = new f(NaN) : d.d || (t = new f(t.d || d.s === t.s ? d : NaN)), t;
  if (d.s != t.s)
    return t.s = -t.s, d.minus(t);
  if (c = d.d, u = t.d, s = f.precision, l = f.rounding, !c[0] || !u[0])
    return u[0] || (t = new f(d)), We ? xe(t, s, l) : t;
  if (i = gn(d.e / Be), r = gn(t.e / Be), c = c.slice(), o = i - r, o) {
    for (o < 0 ? (n = c, o = -o, a = u.length) : (n = u, r = i, a = c.length), i = Math.ceil(s / Be), a = i > a ? i + 1 : a + 1, o > a && (o = a, n.length = 1), n.reverse(); o--; )
      n.push(0);
    n.reverse();
  }
  for (a = c.length, o = u.length, a - o < 0 && (o = a, n = u, u = c, c = n), e = 0; o; )
    e = (c[--o] = c[o] + u[o] + e) / kr | 0, c[o] %= kr;
  for (e && (c.unshift(e), ++r), a = c.length; c[--a] == 0; )
    c.pop();
  return t.d = c, t.e = gf(c, r), We ? xe(t, s, l) : t;
};
de.precision = de.sd = function(t) {
  var e, n = this;
  if (t !== void 0 && t !== !!t && t !== 1 && t !== 0)
    throw Error(Ri + t);
  return n.d ? (e = bA(n.d), t && n.e + 1 > e && (e = n.e + 1)) : e = NaN, e;
};
de.round = function() {
  var t = this, e = t.constructor;
  return xe(new e(t), t.e + 1, e.rounding);
};
de.sine = de.sin = function() {
  var t, e, n = this, r = n.constructor;
  return n.isFinite() ? n.isZero() ? new r(n) : (t = r.precision, e = r.rounding, r.precision = t + Math.max(n.e, n.sd()) + Be, r.rounding = 1, n = ZT(r, yA(r, n)), r.precision = t, r.rounding = e, xe(xo > 2 ? n.neg() : n, t, e, !0)) : new r(NaN);
};
de.squareRoot = de.sqrt = function() {
  var t, e, n, r, o, i, a = this, s = a.d, l = a.e, c = a.s, u = a.constructor;
  if (c !== 1 || !s || !s[0])
    return new u(!c || c < 0 && (!s || s[0]) ? NaN : s ? a : 1 / 0);
  for (We = !1, c = Math.sqrt(+a), c == 0 || c == 1 / 0 ? (e = fn(s), (e.length + l) % 2 == 0 && (e += "0"), c = Math.sqrt(e), l = gn((l + 1) / 2) - (l < 0 || l % 2), c == 1 / 0 ? e = "5e" + l : (e = c.toExponential(), e = e.slice(0, e.indexOf("e") + 1) + l), r = new u(e)) : r = new u(c.toString()), n = (l = u.precision) + 3; ; )
    if (i = r, r = i.plus(mt(a, i, n + 2, 1)).times(0.5), fn(i.d).slice(0, n) === (e = fn(r.d)).slice(0, n))
      if (e = e.slice(n - 3, n + 1), e == "9999" || !o && e == "4999") {
        if (!o && (xe(i, l + 1, 0), i.times(i).eq(a))) {
          r = i;
          break;
        }
        n += 4, o = 1;
      } else {
        (!+e || !+e.slice(1) && e.charAt(0) == "5") && (xe(r, l + 1, 1), t = !r.times(r).eq(a));
        break;
      }
  return We = !0, xe(r, l, u.rounding, t);
};
de.tangent = de.tan = function() {
  var t, e, n = this, r = n.constructor;
  return n.isFinite() ? n.isZero() ? new r(n) : (t = r.precision, e = r.rounding, r.precision = t + 10, r.rounding = 1, n = n.sin(), n.s = 1, n = mt(n, new r(1).minus(n.times(n)).sqrt(), t + 10, 0), r.precision = t, r.rounding = e, xe(xo == 2 || xo == 4 ? n.neg() : n, t, e, !0)) : new r(NaN);
};
de.times = de.mul = function(t) {
  var e, n, r, o, i, a, s, l, c, u = this, d = u.constructor, f = u.d, h = (t = new d(t)).d;
  if (t.s *= u.s, !f || !f[0] || !h || !h[0])
    return new d(!t.s || f && !f[0] && !h || h && !h[0] && !f ? NaN : !f || !h ? t.s / 0 : t.s * 0);
  for (n = gn(u.e / Be) + gn(t.e / Be), l = f.length, c = h.length, l < c && (i = f, f = h, h = i, a = l, l = c, c = a), i = [], a = l + c, r = a; r--; )
    i.push(0);
  for (r = c; --r >= 0; ) {
    for (e = 0, o = l + r; o > r; )
      s = i[o] + h[r] * f[o - r - 1] + e, i[o--] = s % kr | 0, e = s / kr | 0;
    i[o] = (i[o] + e) % kr | 0;
  }
  for (; !i[--a]; )
    i.pop();
  return e ? ++n : i.shift(), t.d = i, t.e = gf(i, n), We ? xe(t, d.precision, d.rounding) : t;
};
de.toBinary = function(t, e) {
  return iE(this, 2, t, e);
};
de.toDecimalPlaces = de.toDP = function(t, e) {
  var n = this, r = n.constructor;
  return n = new r(n), t === void 0 ? n : (Zn(t, 0, $i), e === void 0 ? e = r.rounding : Zn(e, 0, 8), xe(n, t + n.e + 1, e));
};
de.toExponential = function(t, e) {
  var n, r = this, o = r.constructor;
  return t === void 0 ? n = _o(r, !0) : (Zn(t, 0, $i), e === void 0 ? e = o.rounding : Zn(e, 0, 8), r = xe(new o(r), t + 1, e), n = _o(r, !0, t + 1)), r.isNeg() && !r.isZero() ? "-" + n : n;
};
de.toFixed = function(t, e) {
  var n, r, o = this, i = o.constructor;
  return t === void 0 ? n = _o(o) : (Zn(t, 0, $i), e === void 0 ? e = i.rounding : Zn(e, 0, 8), r = xe(new i(o), t + o.e + 1, e), n = _o(r, !1, t + r.e + 1)), o.isNeg() && !o.isZero() ? "-" + n : n;
};
de.toFraction = function(t) {
  var e, n, r, o, i, a, s, l, c, u, d, f, h = this, _ = h.d, E = h.constructor;
  if (!_)
    return new E(h);
  if (c = n = new E(1), r = l = new E(0), e = new E(r), i = e.e = bA(_) - h.e - 1, a = i % Be, e.d[0] = Xt(10, a < 0 ? Be + a : a), t == null)
    t = i > 0 ? e : c;
  else {
    if (s = new E(t), !s.isInt() || s.lt(c))
      throw Error(Ri + s);
    t = s.gt(e) ? i > 0 ? e : c : s;
  }
  for (We = !1, s = new E(fn(_)), u = E.precision, E.precision = i = _.length * Be * 2; d = mt(s, e, 0, 1, 1), o = n.plus(d.times(r)), o.cmp(t) != 1; )
    n = r, r = o, o = c, c = l.plus(d.times(o)), l = o, o = e, e = s.minus(d.times(o)), s = o;
  return o = mt(t.minus(n), r, 0, 1, 1), l = l.plus(o.times(c)), n = n.plus(o.times(r)), l.s = c.s = h.s, f = mt(c, r, i, 1).minus(h).abs().cmp(mt(l, n, i, 1).minus(h).abs()) < 1 ? [c, r] : [l, n], E.precision = u, We = !0, f;
};
de.toHexadecimal = de.toHex = function(t, e) {
  return iE(this, 16, t, e);
};
de.toNearest = function(t, e) {
  var n = this, r = n.constructor;
  if (n = new r(n), t == null) {
    if (!n.d)
      return n;
    t = new r(1), e = r.rounding;
  } else {
    if (t = new r(t), e === void 0 ? e = r.rounding : Zn(e, 0, 8), !n.d)
      return t.s ? n : t;
    if (!t.d)
      return t.s && (t.s = n.s), t;
  }
  return t.d[0] ? (We = !1, n = mt(n, t, 0, e, 1).times(t), We = !0, xe(n)) : (t.s = n.s, n = t), n;
};
de.toNumber = function() {
  return +this;
};
de.toOctal = function(t, e) {
  return iE(this, 8, t, e);
};
de.toPower = de.pow = function(t) {
  var e, n, r, o, i, a, s = this, l = s.constructor, c = +(t = new l(t));
  if (!s.d || !t.d || !s.d[0] || !t.d[0])
    return new l(Xt(+s, c));
  if (s = new l(s), s.eq(1))
    return s;
  if (r = l.precision, i = l.rounding, t.eq(1))
    return xe(s, r, i);
  if (e = gn(t.e / Be), e >= t.d.length - 1 && (n = c < 0 ? -c : c) <= WT)
    return o = RA(l, s, n, r), t.s < 0 ? new l(1).div(o) : xe(o, r, i);
  if (a = s.s, a < 0) {
    if (e < t.d.length - 1)
      return new l(NaN);
    if (t.d[e] & 1 || (a = 1), s.e == 0 && s.d[0] == 1 && s.d.length == 1)
      return s.s = a, s;
  }
  return n = Xt(+s, c), e = n == 0 || !isFinite(n) ? gn(c * (Math.log("0." + fn(s.d)) / Math.LN10 + s.e + 1)) : new l(n + "").e, e > l.maxE + 1 || e < l.minE - 1 ? new l(e > 0 ? a / 0 : 0) : (We = !1, l.rounding = s.s = 1, n = Math.min(12, (e + "").length), o = Kh(t.times(hi(s, r + n)), r), o.d && (o = xe(o, r + 5, 1), hc(o.d, r, i) && (e = r + 10, o = xe(Kh(t.times(hi(s, e + n)), e), e + 5, 1), +fn(o.d).slice(r + 1, r + 15) + 1 == 1e14 && (o = xe(o, r + 1, 0)))), o.s = a, We = !0, l.rounding = i, xe(o, r, i));
};
de.toPrecision = function(t, e) {
  var n, r = this, o = r.constructor;
  return t === void 0 ? n = _o(r, r.e <= o.toExpNeg || r.e >= o.toExpPos) : (Zn(t, 1, $i), e === void 0 ? e = o.rounding : Zn(e, 0, 8), r = xe(new o(r), t, e), n = _o(r, t <= r.e || r.e <= o.toExpNeg, t)), r.isNeg() && !r.isZero() ? "-" + n : n;
};
de.toSignificantDigits = de.toSD = function(t, e) {
  var n = this, r = n.constructor;
  return t === void 0 ? (t = r.precision, e = r.rounding) : (Zn(t, 1, $i), e === void 0 ? e = r.rounding : Zn(e, 0, 8)), xe(new r(n), t, e);
};
de.toString = function() {
  var t = this, e = t.constructor, n = _o(t, t.e <= e.toExpNeg || t.e >= e.toExpPos);
  return t.isNeg() && !t.isZero() ? "-" + n : n;
};
de.truncated = de.trunc = function() {
  return xe(new this.constructor(this), this.e + 1, 1);
};
de.valueOf = de.toJSON = function() {
  var t = this, e = t.constructor, n = _o(t, t.e <= e.toExpNeg || t.e >= e.toExpPos);
  return t.isNeg() ? "-" + n : n;
};
function fn(t) {
  var e, n, r, o = t.length - 1, i = "", a = t[0];
  if (o > 0) {
    for (i += a, e = 1; e < o; e++)
      r = t[e] + "", n = Be - r.length, n && (i += si(n)), i += r;
    a = t[e], r = a + "", n = Be - r.length, n && (i += si(n));
  } else if (a === 0)
    return "0";
  for (; a % 10 === 0; )
    a /= 10;
  return i + a;
}
function Zn(t, e, n) {
  if (t !== ~~t || t < e || t > n)
    throw Error(Ri + t);
}
function hc(t, e, n, r) {
  var o, i, a, s;
  for (i = t[0]; i >= 10; i /= 10)
    --e;
  return --e < 0 ? (e += Be, o = 0) : (o = Math.ceil((e + 1) / Be), e %= Be), i = Xt(10, Be - e), s = t[o] % i | 0, r == null ? e < 3 ? (e == 0 ? s = s / 100 | 0 : e == 1 && (s = s / 10 | 0), a = n < 4 && s == 99999 || n > 3 && s == 49999 || s == 5e4 || s == 0) : a = (n < 4 && s + 1 == i || n > 3 && s + 1 == i / 2) && (t[o + 1] / i / 100 | 0) == Xt(10, e - 2) - 1 || (s == i / 2 || s == 0) && (t[o + 1] / i / 100 | 0) == 0 : e < 4 ? (e == 0 ? s = s / 1e3 | 0 : e == 1 ? s = s / 100 | 0 : e == 2 && (s = s / 10 | 0), a = (r || n < 4) && s == 9999 || !r && n > 3 && s == 4999) : a = ((r || n < 4) && s + 1 == i || !r && n > 3 && s + 1 == i / 2) && (t[o + 1] / i / 1e3 | 0) == Xt(10, e - 3) - 1, a;
}
function Ju(t, e, n) {
  for (var r, o = [0], i, a = 0, s = t.length; a < s; ) {
    for (i = o.length; i--; )
      o[i] *= e;
    for (o[0] += Hh.indexOf(t.charAt(a++)), r = 0; r < o.length; r++)
      o[r] > n - 1 && (o[r + 1] === void 0 && (o[r + 1] = 0), o[r + 1] += o[r] / n | 0, o[r] %= n);
  }
  return o.reverse();
}
function KT(t, e) {
  var n, r, o;
  if (e.isZero())
    return e;
  r = e.d.length, r < 32 ? (n = Math.ceil(r / 3), o = (1 / If(4, n)).toString()) : (n = 16, o = "2.3283064365386962890625e-10"), t.precision += n, e = Bs(t, 1, e.times(o), new t(1));
  for (var i = n; i--; ) {
    var a = e.times(e);
    e = a.times(a).minus(a).times(8).plus(1);
  }
  return t.precision -= n, e;
}
var mt = function() {
  function t(r, o, i) {
    var a, s = 0, l = r.length;
    for (r = r.slice(); l--; )
      a = r[l] * o + s, r[l] = a % i | 0, s = a / i | 0;
    return s && r.unshift(s), r;
  }
  function e(r, o, i, a) {
    var s, l;
    if (i != a)
      l = i > a ? 1 : -1;
    else
      for (s = l = 0; s < i; s++)
        if (r[s] != o[s]) {
          l = r[s] > o[s] ? 1 : -1;
          break;
        }
    return l;
  }
  function n(r, o, i, a) {
    for (var s = 0; i--; )
      r[i] -= s, s = r[i] < o[i] ? 1 : 0, r[i] = s * a + r[i] - o[i];
    for (; !r[0] && r.length > 1; )
      r.shift();
  }
  return function(r, o, i, a, s, l) {
    var c, u, d, f, h, _, E, m, N, I, O, p, C, D, T, k, G, b, P, $, y = r.constructor, L = r.s == o.s ? 1 : -1, w = r.d, R = o.d;
    if (!w || !w[0] || !R || !R[0])
      return new y(
        // Return NaN if either NaN, or both Infinity or 0.
        !r.s || !o.s || (w ? R && w[0] == R[0] : !R) ? NaN : (
          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
          w && w[0] == 0 || !R ? L * 0 : L / 0
        )
      );
    for (l ? (h = 1, u = r.e - o.e) : (l = kr, h = Be, u = gn(r.e / h) - gn(o.e / h)), P = R.length, G = w.length, N = new y(L), I = N.d = [], d = 0; R[d] == (w[d] || 0); d++)
      ;
    if (R[d] > (w[d] || 0) && u--, i == null ? (D = i = y.precision, a = y.rounding) : s ? D = i + (r.e - o.e) + 1 : D = i, D < 0)
      I.push(1), _ = !0;
    else {
      if (D = D / h + 2 | 0, d = 0, P == 1) {
        for (f = 0, R = R[0], D++; (d < G || f) && D--; d++)
          T = f * l + (w[d] || 0), I[d] = T / R | 0, f = T % R | 0;
        _ = f || d < G;
      } else {
        for (f = l / (R[0] + 1) | 0, f > 1 && (R = t(R, f, l), w = t(w, f, l), P = R.length, G = w.length), k = P, O = w.slice(0, P), p = O.length; p < P; )
          O[p++] = 0;
        $ = R.slice(), $.unshift(0), b = R[0], R[1] >= l / 2 && ++b;
        do
          f = 0, c = e(R, O, P, p), c < 0 ? (C = O[0], P != p && (C = C * l + (O[1] || 0)), f = C / b | 0, f > 1 ? (f >= l && (f = l - 1), E = t(R, f, l), m = E.length, p = O.length, c = e(E, O, m, p), c == 1 && (f--, n(E, P < m ? $ : R, m, l))) : (f == 0 && (c = f = 1), E = R.slice()), m = E.length, m < p && E.unshift(0), n(O, E, p, l), c == -1 && (p = O.length, c = e(R, O, P, p), c < 1 && (f++, n(O, P < p ? $ : R, p, l))), p = O.length) : c === 0 && (f++, O = [0]), I[d++] = f, c && O[0] ? O[p++] = w[k] || 0 : (O = [w[k]], p = 1);
        while ((k++ < G || O[0] !== void 0) && D--);
        _ = O[0] !== void 0;
      }
      I[0] || I.shift();
    }
    if (h == 1)
      N.e = u, DA = _;
    else {
      for (d = 1, f = I[0]; f >= 10; f /= 10)
        d++;
      N.e = d + u * h - 1, xe(N, s ? i + N.e + 1 : i, a, _);
    }
    return N;
  };
}();
function xe(t, e, n, r) {
  var o, i, a, s, l, c, u, d, f, h = t.constructor;
  e:
    if (e != null) {
      if (d = t.d, !d)
        return t;
      for (o = 1, s = d[0]; s >= 10; s /= 10)
        o++;
      if (i = e - o, i < 0)
        i += Be, a = e, u = d[f = 0], l = u / Xt(10, o - a - 1) % 10 | 0;
      else if (f = Math.ceil((i + 1) / Be), s = d.length, f >= s)
        if (r) {
          for (; s++ <= f; )
            d.push(0);
          u = l = 0, o = 1, i %= Be, a = i - Be + 1;
        } else
          break e;
      else {
        for (u = s = d[f], o = 1; s >= 10; s /= 10)
          o++;
        i %= Be, a = i - Be + o, l = a < 0 ? 0 : u / Xt(10, o - a - 1) % 10 | 0;
      }
      if (r = r || e < 0 || d[f + 1] !== void 0 || (a < 0 ? u : u % Xt(10, o - a - 1)), c = n < 4 ? (l || r) && (n == 0 || n == (t.s < 0 ? 3 : 2)) : l > 5 || l == 5 && (n == 4 || r || n == 6 && // Check whether the digit to the left of the rounding digit is odd.
      (i > 0 ? a > 0 ? u / Xt(10, o - a) : 0 : d[f - 1]) % 10 & 1 || n == (t.s < 0 ? 8 : 7)), e < 1 || !d[0])
        return d.length = 0, c ? (e -= t.e + 1, d[0] = Xt(10, (Be - e % Be) % Be), t.e = -e || 0) : d[0] = t.e = 0, t;
      if (i == 0 ? (d.length = f, s = 1, f--) : (d.length = f + 1, s = Xt(10, Be - i), d[f] = a > 0 ? (u / Xt(10, o - a) % Xt(10, a) | 0) * s : 0), c)
        for (; ; )
          if (f == 0) {
            for (i = 1, a = d[0]; a >= 10; a /= 10)
              i++;
            for (a = d[0] += s, s = 1; a >= 10; a /= 10)
              s++;
            i != s && (t.e++, d[0] == kr && (d[0] = 1));
            break;
          } else {
            if (d[f] += s, d[f] != kr)
              break;
            d[f--] = 0, s = 1;
          }
      for (i = d.length; d[--i] === 0; )
        d.pop();
    }
  return We && (t.e > h.maxE ? (t.d = null, t.e = NaN) : t.e < h.minE && (t.e = 0, t.d = [0])), t;
}
function _o(t, e, n) {
  if (!t.isFinite())
    return PA(t);
  var r, o = t.e, i = fn(t.d), a = i.length;
  return e ? (n && (r = n - a) > 0 ? i = i.charAt(0) + "." + i.slice(1) + si(r) : a > 1 && (i = i.charAt(0) + "." + i.slice(1)), i = i + (t.e < 0 ? "e" : "e+") + t.e) : o < 0 ? (i = "0." + si(-o - 1) + i, n && (r = n - a) > 0 && (i += si(r))) : o >= a ? (i += si(o + 1 - a), n && (r = n - o - 1) > 0 && (i = i + "." + si(r))) : ((r = o + 1) < a && (i = i.slice(0, r) + "." + i.slice(r)), n && (r = n - a) > 0 && (o + 1 === a && (i += "."), i += si(r))), i;
}
function gf(t, e) {
  var n = t[0];
  for (e *= Be; n >= 10; n /= 10)
    e++;
  return e;
}
function gd(t, e, n) {
  if (e > YT)
    throw We = !0, n && (t.precision = n), Error(CA);
  return xe(new t(Nd), e, 1, !0);
}
function ro(t, e, n) {
  if (e > Yh)
    throw Error(CA);
  return xe(new t(vd), e, n, !0);
}
function bA(t) {
  var e = t.length - 1, n = e * Be + 1;
  if (e = t[e], e) {
    for (; e % 10 == 0; e /= 10)
      n--;
    for (e = t[0]; e >= 10; e /= 10)
      n++;
  }
  return n;
}
function si(t) {
  for (var e = ""; t--; )
    e += "0";
  return e;
}
function RA(t, e, n, r) {
  var o, i = new t(1), a = Math.ceil(r / Be + 4);
  for (We = !1; ; ) {
    if (n % 2 && (i = i.times(e), lm(i.d, a) && (o = !0)), n = gn(n / 2), n === 0) {
      n = i.d.length - 1, o && i.d[n] === 0 && ++i.d[n];
      break;
    }
    e = e.times(e), lm(e.d, a);
  }
  return We = !0, i;
}
function sm(t) {
  return t.d[t.d.length - 1] & 1;
}
function MA(t, e, n) {
  for (var r, o, i = new t(e[0]), a = 0; ++a < e.length; ) {
    if (o = new t(e[a]), !o.s) {
      i = o;
      break;
    }
    r = i.cmp(o), (r === n || r === 0 && i.s === n) && (i = o);
  }
  return i;
}
function Kh(t, e) {
  var n, r, o, i, a, s, l, c = 0, u = 0, d = 0, f = t.constructor, h = f.rounding, _ = f.precision;
  if (!t.d || !t.d[0] || t.e > 17)
    return new f(t.d ? t.d[0] ? t.s < 0 ? 0 : 1 / 0 : 1 : t.s ? t.s < 0 ? 0 : t : 0 / 0);
  for (e == null ? (We = !1, l = _) : l = e, s = new f(0.03125); t.e > -2; )
    t = t.times(s), d += 5;
  for (r = Math.log(Xt(2, d)) / Math.LN10 * 2 + 5 | 0, l += r, n = i = a = new f(1), f.precision = l; ; ) {
    if (i = xe(i.times(t), l, 1), n = n.times(++u), s = a.plus(mt(i, n, l, 1)), fn(s.d).slice(0, l) === fn(a.d).slice(0, l)) {
      for (o = d; o--; )
        a = xe(a.times(a), l, 1);
      if (e == null)
        if (c < 3 && hc(a.d, l - r, h, c))
          f.precision = l += 10, n = i = s = new f(1), u = 0, c++;
        else
          return xe(a, f.precision = _, h, We = !0);
      else
        return f.precision = _, a;
    }
    a = s;
  }
}
function hi(t, e) {
  var n, r, o, i, a, s, l, c, u, d, f, h = 1, _ = 10, E = t, m = E.d, N = E.constructor, I = N.rounding, O = N.precision;
  if (E.s < 0 || !m || !m[0] || !E.e && m[0] == 1 && m.length == 1)
    return new N(m && !m[0] ? -1 / 0 : E.s != 1 ? NaN : m ? 0 : E);
  if (e == null ? (We = !1, u = O) : u = e, N.precision = u += _, n = fn(m), r = n.charAt(0), Math.abs(i = E.e) < 15e14) {
    for (; r < 7 && r != 1 || r == 1 && n.charAt(1) > 3; )
      E = E.times(t), n = fn(E.d), r = n.charAt(0), h++;
    i = E.e, r > 1 ? (E = new N("0." + n), i++) : E = new N(r + "." + n.slice(1));
  } else
    return c = gd(N, u + 2, O).times(i + ""), E = hi(new N(r + "." + n.slice(1)), u - _).plus(c), N.precision = O, e == null ? xe(E, O, I, We = !0) : E;
  for (d = E, l = a = E = mt(E.minus(1), E.plus(1), u, 1), f = xe(E.times(E), u, 1), o = 3; ; ) {
    if (a = xe(a.times(f), u, 1), c = l.plus(mt(a, new N(o), u, 1)), fn(c.d).slice(0, u) === fn(l.d).slice(0, u))
      if (l = l.times(2), i !== 0 && (l = l.plus(gd(N, u + 2, O).times(i + ""))), l = mt(l, new N(h), u, 1), e == null)
        if (hc(l.d, u - _, I, s))
          N.precision = u += _, c = a = E = mt(d.minus(1), d.plus(1), u, 1), f = xe(E.times(E), u, 1), o = s = 1;
        else
          return xe(l, N.precision = O, I, We = !0);
      else
        return N.precision = O, l;
    l = c, o += 2;
  }
}
function PA(t) {
  return String(t.s * t.s / 0);
}
function Qu(t, e) {
  var n, r, o;
  for ((n = e.indexOf(".")) > -1 && (e = e.replace(".", "")), (r = e.search(/e/i)) > 0 ? (n < 0 && (n = r), n += +e.slice(r + 1), e = e.substring(0, r)) : n < 0 && (n = e.length), r = 0; e.charCodeAt(r) === 48; r++)
    ;
  for (o = e.length; e.charCodeAt(o - 1) === 48; --o)
    ;
  if (e = e.slice(r, o), e) {
    if (o -= r, t.e = n = n - r - 1, t.d = [], r = (n + 1) % Be, n < 0 && (r += Be), r < o) {
      for (r && t.d.push(+e.slice(0, r)), o -= Be; r < o; )
        t.d.push(+e.slice(r, r += Be));
      e = e.slice(r), r = Be - e.length;
    } else
      r -= o;
    for (; r--; )
      e += "0";
    t.d.push(+e), We && (t.e > t.constructor.maxE ? (t.d = null, t.e = NaN) : t.e < t.constructor.minE && (t.e = 0, t.d = [0]));
  } else
    t.e = 0, t.d = [0];
  return t;
}
function zT(t, e) {
  var n, r, o, i, a, s, l, c, u;
  if (e.indexOf("_") > -1) {
    if (e = e.replace(/(\d)_(?=\d)/g, "$1"), TA.test(e))
      return Qu(t, e);
  } else if (e === "Infinity" || e === "NaN")
    return +e || (t.s = NaN), t.e = NaN, t.d = null, t;
  if (VT.test(e))
    n = 16, e = e.toLowerCase();
  else if (FT.test(e))
    n = 2;
  else if (HT.test(e))
    n = 8;
  else
    throw Error(Ri + e);
  for (i = e.search(/p/i), i > 0 ? (l = +e.slice(i + 1), e = e.substring(2, i)) : e = e.slice(2), i = e.indexOf("."), a = i >= 0, r = t.constructor, a && (e = e.replace(".", ""), s = e.length, i = s - i, o = RA(r, new r(n), i, i * 2)), c = Ju(e, n, kr), u = c.length - 1, i = u; c[i] === 0; --i)
    c.pop();
  return i < 0 ? new r(t.s * 0) : (t.e = gf(c, u), t.d = c, We = !1, a && (t = mt(t, o, s * 4)), l && (t = t.times(Math.abs(l) < 54 ? Xt(2, l) : cr.pow(2, l))), We = !0, t);
}
function ZT(t, e) {
  var n, r = e.d.length;
  if (r < 3)
    return e.isZero() ? e : Bs(t, 2, e, e);
  n = 1.4 * Math.sqrt(r), n = n > 16 ? 16 : n | 0, e = e.times(1 / If(5, n)), e = Bs(t, 2, e, e);
  for (var o, i = new t(5), a = new t(16), s = new t(20); n--; )
    o = e.times(e), e = e.times(i.plus(o.times(a.times(o).minus(s))));
  return e;
}
function Bs(t, e, n, r, o) {
  var i, a, s, l, c = t.precision, u = Math.ceil(c / Be);
  for (We = !1, l = n.times(n), s = new t(r); ; ) {
    if (a = mt(s.times(l), new t(e++ * e++), c, 1), s = o ? r.plus(a) : r.minus(a), r = mt(a.times(l), new t(e++ * e++), c, 1), a = s.plus(r), a.d[u] !== void 0) {
      for (i = u; a.d[i] === s.d[i] && i--; )
        ;
      if (i == -1)
        break;
    }
    i = s, s = r, r = a, a = i;
  }
  return We = !0, a.d.length = u + 1, a;
}
function If(t, e) {
  for (var n = t; --e; )
    n *= t;
  return n;
}
function yA(t, e) {
  var n, r = e.s < 0, o = ro(t, t.precision, 1), i = o.times(0.5);
  if (e = e.abs(), e.lte(i))
    return xo = r ? 4 : 1, e;
  if (n = e.divToInt(o), n.isZero())
    xo = r ? 3 : 2;
  else {
    if (e = e.minus(n.times(o)), e.lte(i))
      return xo = sm(n) ? r ? 2 : 3 : r ? 4 : 1, e;
    xo = sm(n) ? r ? 1 : 4 : r ? 3 : 2;
  }
  return e.minus(o).abs();
}
function iE(t, e, n, r) {
  var o, i, a, s, l, c, u, d, f, h = t.constructor, _ = n !== void 0;
  if (_ ? (Zn(n, 1, $i), r === void 0 ? r = h.rounding : Zn(r, 0, 8)) : (n = h.precision, r = h.rounding), !t.isFinite())
    u = PA(t);
  else {
    for (u = _o(t), a = u.indexOf("."), _ ? (o = 2, e == 16 ? n = n * 4 - 3 : e == 8 && (n = n * 3 - 2)) : o = e, a >= 0 && (u = u.replace(".", ""), f = new h(1), f.e = u.length - a, f.d = Ju(_o(f), 10, o), f.e = f.d.length), d = Ju(u, 10, o), i = l = d.length; d[--l] == 0; )
      d.pop();
    if (!d[0])
      u = _ ? "0p+0" : "0";
    else {
      if (a < 0 ? i-- : (t = new h(t), t.d = d, t.e = i, t = mt(t, f, n, r, 0, o), d = t.d, i = t.e, c = DA), a = d[n], s = o / 2, c = c || d[n + 1] !== void 0, c = r < 4 ? (a !== void 0 || c) && (r === 0 || r === (t.s < 0 ? 3 : 2)) : a > s || a === s && (r === 4 || c || r === 6 && d[n - 1] & 1 || r === (t.s < 0 ? 8 : 7)), d.length = n, c)
        for (; ++d[--n] > o - 1; )
          d[n] = 0, n || (++i, d.unshift(1));
      for (l = d.length; !d[l - 1]; --l)
        ;
      for (a = 0, u = ""; a < l; a++)
        u += Hh.charAt(d[a]);
      if (_) {
        if (l > 1)
          if (e == 16 || e == 8) {
            for (a = e == 16 ? 4 : 3, --l; l % a; l++)
              u += "0";
            for (d = Ju(u, o, e), l = d.length; !d[l - 1]; --l)
              ;
            for (a = 1, u = "1."; a < l; a++)
              u += Hh.charAt(d[a]);
          } else
            u = u.charAt(0) + "." + u.slice(1);
        u = u + (i < 0 ? "p" : "p+") + i;
      } else if (i < 0) {
        for (; ++i; )
          u = "0" + u;
        u = "0." + u;
      } else if (++i > l)
        for (i -= l; i--; )
          u += "0";
      else
        i < l && (u = u.slice(0, i) + "." + u.slice(i));
    }
    u = (e == 16 ? "0x" : e == 2 ? "0b" : e == 8 ? "0o" : "") + u;
  }
  return t.s < 0 ? "-" + u : u;
}
function lm(t, e) {
  if (t.length > e)
    return t.length = e, !0;
}
function qT(t) {
  return new this(t).abs();
}
function XT(t) {
  return new this(t).acos();
}
function jT(t) {
  return new this(t).acosh();
}
function JT(t, e) {
  return new this(t).plus(e);
}
function QT(t) {
  return new this(t).asin();
}
function eb(t) {
  return new this(t).asinh();
}
function tb(t) {
  return new this(t).atan();
}
function nb(t) {
  return new this(t).atanh();
}
function rb(t, e) {
  t = new this(t), e = new this(e);
  var n, r = this.precision, o = this.rounding, i = r + 4;
  return !t.s || !e.s ? n = new this(NaN) : !t.d && !e.d ? (n = ro(this, i, 1).times(e.s > 0 ? 0.25 : 0.75), n.s = t.s) : !e.d || t.isZero() ? (n = e.s < 0 ? ro(this, r, o) : new this(0), n.s = t.s) : !t.d || e.isZero() ? (n = ro(this, i, 1).times(0.5), n.s = t.s) : e.s < 0 ? (this.precision = i, this.rounding = 1, n = this.atan(mt(t, e, i, 1)), e = ro(this, i, 1), this.precision = r, this.rounding = o, n = t.s < 0 ? n.minus(e) : n.plus(e)) : n = this.atan(mt(t, e, i, 1)), n;
}
function ob(t) {
  return new this(t).cbrt();
}
function ib(t) {
  return xe(t = new this(t), t.e + 1, 2);
}
function ab(t, e, n) {
  return new this(t).clamp(e, n);
}
function sb(t) {
  if (!t || typeof t != "object")
    throw Error(vf + "Object expected");
  var e, n, r, o = t.defaults === !0, i = [
    "precision",
    1,
    $i,
    "rounding",
    0,
    8,
    "toExpNeg",
    -gs,
    0,
    "toExpPos",
    0,
    gs,
    "maxE",
    0,
    gs,
    "minE",
    -gs,
    0,
    "modulo",
    0,
    9
  ];
  for (e = 0; e < i.length; e += 3)
    if (n = i[e], o && (this[n] = Wh[n]), (r = t[n]) !== void 0)
      if (gn(r) === r && r >= i[e + 1] && r <= i[e + 2])
        this[n] = r;
      else
        throw Error(Ri + n + ": " + r);
  if (n = "crypto", o && (this[n] = Wh[n]), (r = t[n]) !== void 0)
    if (r === !0 || r === !1 || r === 0 || r === 1)
      if (r)
        if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
          this[n] = !0;
        else
          throw Error(SA);
      else
        this[n] = !1;
    else
      throw Error(Ri + n + ": " + r);
  return this;
}
function lb(t) {
  return new this(t).cos();
}
function cb(t) {
  return new this(t).cosh();
}
function LA(t) {
  var e, n, r;
  function o(i) {
    var a, s, l, c = this;
    if (!(c instanceof o))
      return new o(i);
    if (c.constructor = o, cm(i)) {
      c.s = i.s, We ? !i.d || i.e > o.maxE ? (c.e = NaN, c.d = null) : i.e < o.minE ? (c.e = 0, c.d = [0]) : (c.e = i.e, c.d = i.d.slice()) : (c.e = i.e, c.d = i.d ? i.d.slice() : i.d);
      return;
    }
    if (l = typeof i, l === "number") {
      if (i === 0) {
        c.s = 1 / i < 0 ? -1 : 1, c.e = 0, c.d = [0];
        return;
      }
      if (i < 0 ? (i = -i, c.s = -1) : c.s = 1, i === ~~i && i < 1e7) {
        for (a = 0, s = i; s >= 10; s /= 10)
          a++;
        We ? a > o.maxE ? (c.e = NaN, c.d = null) : a < o.minE ? (c.e = 0, c.d = [0]) : (c.e = a, c.d = [i]) : (c.e = a, c.d = [i]);
        return;
      }
      if (i * 0 !== 0) {
        i || (c.s = NaN), c.e = NaN, c.d = null;
        return;
      }
      return Qu(c, i.toString());
    }
    if (l === "string")
      return (s = i.charCodeAt(0)) === 45 ? (i = i.slice(1), c.s = -1) : (s === 43 && (i = i.slice(1)), c.s = 1), TA.test(i) ? Qu(c, i) : zT(c, i);
    if (l === "bigint")
      return i < 0 ? (i = -i, c.s = -1) : c.s = 1, Qu(c, i.toString());
    throw Error(Ri + i);
  }
  if (o.prototype = de, o.ROUND_UP = 0, o.ROUND_DOWN = 1, o.ROUND_CEIL = 2, o.ROUND_FLOOR = 3, o.ROUND_HALF_UP = 4, o.ROUND_HALF_DOWN = 5, o.ROUND_HALF_EVEN = 6, o.ROUND_HALF_CEIL = 7, o.ROUND_HALF_FLOOR = 8, o.EUCLID = 9, o.config = o.set = sb, o.clone = LA, o.isDecimal = cm, o.abs = qT, o.acos = XT, o.acosh = jT, o.add = JT, o.asin = QT, o.asinh = eb, o.atan = tb, o.atanh = nb, o.atan2 = rb, o.cbrt = ob, o.ceil = ib, o.clamp = ab, o.cos = lb, o.cosh = cb, o.div = ub, o.exp = db, o.floor = fb, o.hypot = hb, o.ln = _b, o.log = Eb, o.log10 = mb, o.log2 = pb, o.max = Nb, o.min = vb, o.mod = gb, o.mul = Ib, o.pow = Ob, o.random = Ab, o.round = Db, o.sign = Cb, o.sin = Sb, o.sinh = wb, o.sqrt = Tb, o.sub = bb, o.sum = Rb, o.tan = Mb, o.tanh = Pb, o.trunc = yb, t === void 0 && (t = {}), t && t.defaults !== !0)
    for (r = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], e = 0; e < r.length; )
      t.hasOwnProperty(n = r[e++]) || (t[n] = this[n]);
  return o.config(t), o;
}
function ub(t, e) {
  return new this(t).div(e);
}
function db(t) {
  return new this(t).exp();
}
function fb(t) {
  return xe(t = new this(t), t.e + 1, 3);
}
function hb() {
  var t, e, n = new this(0);
  for (We = !1, t = 0; t < arguments.length; )
    if (e = new this(arguments[t++]), e.d)
      n.d && (n = n.plus(e.times(e)));
    else {
      if (e.s)
        return We = !0, new this(1 / 0);
      n = e;
    }
  return We = !0, n.sqrt();
}
function cm(t) {
  return t instanceof cr || t && t.toStringTag === wA || !1;
}
function _b(t) {
  return new this(t).ln();
}
function Eb(t, e) {
  return new this(t).log(e);
}
function pb(t) {
  return new this(t).log(2);
}
function mb(t) {
  return new this(t).log(10);
}
function Nb() {
  return MA(this, arguments, -1);
}
function vb() {
  return MA(this, arguments, 1);
}
function gb(t, e) {
  return new this(t).mod(e);
}
function Ib(t, e) {
  return new this(t).mul(e);
}
function Ob(t, e) {
  return new this(t).pow(e);
}
function Ab(t) {
  var e, n, r, o, i = 0, a = new this(1), s = [];
  if (t === void 0 ? t = this.precision : Zn(t, 1, $i), r = Math.ceil(t / Be), this.crypto)
    if (crypto.getRandomValues)
      for (e = crypto.getRandomValues(new Uint32Array(r)); i < r; )
        o = e[i], o >= 429e7 ? e[i] = crypto.getRandomValues(new Uint32Array(1))[0] : s[i++] = o % 1e7;
    else if (crypto.randomBytes) {
      for (e = crypto.randomBytes(r *= 4); i < r; )
        o = e[i] + (e[i + 1] << 8) + (e[i + 2] << 16) + ((e[i + 3] & 127) << 24), o >= 214e7 ? crypto.randomBytes(4).copy(e, i) : (s.push(o % 1e7), i += 4);
      i = r / 4;
    } else
      throw Error(SA);
  else
    for (; i < r; )
      s[i++] = Math.random() * 1e7 | 0;
  for (r = s[--i], t %= Be, r && t && (o = Xt(10, Be - t), s[i] = (r / o | 0) * o); s[i] === 0; i--)
    s.pop();
  if (i < 0)
    n = 0, s = [0];
  else {
    for (n = -1; s[0] === 0; n -= Be)
      s.shift();
    for (r = 1, o = s[0]; o >= 10; o /= 10)
      r++;
    r < Be && (n -= Be - r);
  }
  return a.e = n, a.d = s, a;
}
function Db(t) {
  return xe(t = new this(t), t.e + 1, this.rounding);
}
function Cb(t) {
  return t = new this(t), t.d ? t.d[0] ? t.s : 0 * t.s : t.s || NaN;
}
function Sb(t) {
  return new this(t).sin();
}
function wb(t) {
  return new this(t).sinh();
}
function Tb(t) {
  return new this(t).sqrt();
}
function bb(t, e) {
  return new this(t).sub(e);
}
function Rb() {
  var t = 0, e = arguments, n = new this(e[t]);
  for (We = !1; n.s && ++t < e.length; )
    n = n.plus(e[t]);
  return We = !0, xe(n, this.precision, this.rounding);
}
function Mb(t) {
  return new this(t).tan();
}
function Pb(t) {
  return new this(t).tanh();
}
function yb(t) {
  return xe(t = new this(t), t.e + 1, 1);
}
de[Symbol.for("nodejs.util.inspect.custom")] = de.toString;
de[Symbol.toStringTag] = "Decimal";
var cr = de.constructor = LA(Wh);
Nd = new cr(Nd);
vd = new cr(vd);
const lt = cr;
new lt(10);
var jc = new lt(0), Lb = new lt(-0);
function Jc(t, e) {
  var n = e && e.cache ? e.cache : Fb, r = e && e.serializer ? e.serializer : Bb, o = e && e.strategy ? e.strategy : Ub;
  return o(t, {
    cache: n,
    serializer: r
  });
}
function xb(t) {
  return t == null || typeof t == "number" || typeof t == "boolean";
}
function xA(t, e, n, r) {
  var o = xb(r) ? r : n(r), i = e.get(o);
  return typeof i > "u" && (i = t.call(this, r), e.set(o, i)), i;
}
function UA(t, e, n) {
  var r = Array.prototype.slice.call(arguments, 3), o = n(r), i = e.get(o);
  return typeof i > "u" && (i = t.apply(this, r), e.set(o, i)), i;
}
function aE(t, e, n, r, o) {
  return n.bind(e, t, r, o);
}
function Ub(t, e) {
  var n = t.length === 1 ? xA : UA;
  return aE(t, this, n, e.cache.create(), e.serializer);
}
function $b(t, e) {
  return aE(t, this, UA, e.cache.create(), e.serializer);
}
function kb(t, e) {
  return aE(t, this, xA, e.cache.create(), e.serializer);
}
var Bb = function() {
  return JSON.stringify(arguments);
}, Gb = (
  /** @class */
  function() {
    function t() {
      this.cache = /* @__PURE__ */ Object.create(null);
    }
    return t.prototype.get = function(e) {
      return this.cache[e];
    }, t.prototype.set = function(e, n) {
      this.cache[e] = n;
    }, t;
  }()
), Fb = {
  create: function() {
    return new Gb();
  }
}, Qc = {
  variadic: $b,
  monadic: kb
};
function Hl(t, e) {
  if (typeof t.repeat == "function")
    return t.repeat(e);
  for (var n = new Array(e), r = 0; r < n.length; r++)
    n[r] = t;
  return n.join("");
}
function $A(t, e, n, r) {
  t.get(e) || t.set(e, /* @__PURE__ */ Object.create(null));
  var o = t.get(e);
  o[n] = r;
}
function Vb(t, e, n) {
  for (var r = 0, o = Object.keys(n); r < o.length; r++) {
    var i = o[r];
    $A(t, e, i, n[i]);
  }
}
function Hb(t, e, n) {
  return kA(t, e, n)[n];
}
function kA(t, e) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var o = t.get(e);
  if (!o)
    throw new TypeError("".concat(e, " InternalSlot has not been initialized"));
  return n.reduce(function(i, a) {
    return i[a] = o[a], i;
  }, /* @__PURE__ */ Object.create(null));
}
function Wb(t) {
  return t.type === "literal";
}
function Yb(t, e, n) {
  var r = n.value;
  Object.defineProperty(t, e, {
    configurable: !0,
    enumerable: !1,
    writable: !0,
    value: r
  });
}
function Kb(t, e, n) {
  Object.defineProperty(t, e, {
    configurable: !0,
    enumerable: !0,
    writable: !0,
    value: n
  });
}
function St(t, e, n) {
  if (n === void 0 && (n = Error), !t)
    throw new n(e);
}
var zb = Jc(function() {
  for (var t, e = [], n = 0; n < arguments.length; n++)
    e[n] = arguments[n];
  return new ((t = Intl.NumberFormat).bind.apply(t, Fr([void 0], e, !1)))();
}, {
  strategy: Qc.variadic
}), Zb = Jc(function() {
  for (var t, e = [], n = 0; n < arguments.length; n++)
    e[n] = arguments[n];
  return new ((t = Intl.DateTimeFormat).bind.apply(t, Fr([void 0], e, !1)))();
}, {
  strategy: Qc.variadic
}), qb = Jc(function() {
  for (var t, e = [], n = 0; n < arguments.length; n++)
    e[n] = arguments[n];
  return new ((t = Intl.PluralRules).bind.apply(t, Fr([void 0], e, !1)))();
}, {
  strategy: Qc.variadic
}), Xb = Jc(function() {
  for (var t, e = [], n = 0; n < arguments.length; n++)
    e[n] = arguments[n];
  return new ((t = Intl.Locale).bind.apply(t, Fr([void 0], e, !1)))();
}, {
  strategy: Qc.variadic
}), jb = Jc(function() {
  for (var t, e = [], n = 0; n < arguments.length; n++)
    e[n] = arguments[n];
  return new ((t = Intl.ListFormat).bind.apply(t, Fr([void 0], e, !1)))();
}, {
  strategy: Qc.variadic
});
function sE(t) {
  if (typeof t == "symbol")
    throw TypeError("Cannot convert a Symbol value to a string");
  return String(t);
}
function lE(t) {
  if (typeof t == "number")
    return new cr(t);
  if (St(typeof t != "bigint" && typeof t != "symbol", "BigInt and Symbol are not supported", TypeError), t === void 0)
    return new cr(NaN);
  if (t === null || t === 0)
    return jc;
  if (t === !0)
    return new cr(1);
  if (typeof t == "string")
    try {
      return new cr(t);
    } catch {
      return new cr(NaN);
    }
  St(typeof t == "object", "object expected", TypeError);
  var e = EE(t, "number");
  return St(typeof e != "object", "object expected", TypeError), lE(e);
}
function Jb(t) {
  var e = lE(t);
  if (e.isNaN() || e.isZero())
    return jc;
  if (e.isFinite())
    return e;
  var n = e.abs().floor();
  return e.isNegative() && (n = n.negated()), n;
}
function Qb(t) {
  return t.isFinite() ? t.abs().greaterThan(8.64 * 1e15) ? new cr(NaN) : Jb(t) : new cr(NaN);
}
function cE(t) {
  if (t == null)
    throw new TypeError("undefined/null cannot be converted to object");
  return Object(t);
}
function e9(t, e) {
  return Object.is ? Object.is(t, e) : t === e ? t !== 0 || 1 / t === 1 / e : t !== t && e !== e;
}
function BA(t) {
  return new Array(t);
}
function GA(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function t9(t) {
  if (t === null)
    return "Null";
  if (typeof t > "u")
    return "Undefined";
  if (typeof t == "function" || typeof t == "object")
    return "Object";
  if (typeof t == "number")
    return "Number";
  if (typeof t == "boolean")
    return "Boolean";
  if (typeof t == "string")
    return "String";
  if (typeof t == "symbol")
    return "Symbol";
  if (typeof t == "bigint")
    return "BigInt";
}
var zh = 864e5;
function eu(t, e) {
  return t - Math.floor(t / e) * e;
}
function uE(t) {
  return Math.floor(t / zh);
}
function n9(t) {
  return eu(uE(t) + 4, 7);
}
function FA(t) {
  if (t < 100) {
    var e = /* @__PURE__ */ new Date(0);
    return e.setUTCFullYear(t, 0, 1), e.setUTCHours(0, 0, 0, 0), e.getTime() / zh;
  }
  return Date.UTC(t, 0) / zh;
}
function r9(t) {
  return Date.UTC(t, 0);
}
function dE(t) {
  return new Date(t).getUTCFullYear();
}
function VA(t) {
  return t % 4 !== 0 ? 365 : t % 100 !== 0 ? 366 : t % 400 !== 0 ? 365 : 366;
}
function fE(t) {
  return uE(t) - FA(dE(t));
}
function hE(t) {
  return VA(dE(t)) === 365 ? 0 : 1;
}
function HA(t) {
  var e = fE(t), n = hE(t);
  if (e >= 0 && e < 31)
    return 0;
  if (e < 59 + n)
    return 1;
  if (e < 90 + n)
    return 2;
  if (e < 120 + n)
    return 3;
  if (e < 151 + n)
    return 4;
  if (e < 181 + n)
    return 5;
  if (e < 212 + n)
    return 6;
  if (e < 243 + n)
    return 7;
  if (e < 273 + n)
    return 8;
  if (e < 304 + n)
    return 9;
  if (e < 334 + n)
    return 10;
  if (e < 365 + n)
    return 11;
  throw new Error("Invalid time");
}
function o9(t) {
  var e = fE(t), n = HA(t), r = hE(t);
  if (n === 0)
    return e + 1;
  if (n === 1)
    return e - 30;
  if (n === 2)
    return e - 58 - r;
  if (n === 3)
    return e - 89 - r;
  if (n === 4)
    return e - 119 - r;
  if (n === 5)
    return e - 150 - r;
  if (n === 6)
    return e - 180 - r;
  if (n === 7)
    return e - 211 - r;
  if (n === 8)
    return e - 242 - r;
  if (n === 9)
    return e - 272 - r;
  if (n === 10)
    return e - 303 - r;
  if (n === 11)
    return e - 333 - r;
  throw new Error("Invalid time");
}
var i9 = 24, WA = 60, YA = 60, _E = 1e3, KA = _E * YA, a9 = KA * WA;
function s9(t) {
  return eu(Math.floor(t / a9), i9);
}
function l9(t) {
  return eu(Math.floor(t / KA), WA);
}
function c9(t) {
  return eu(Math.floor(t / _E), YA);
}
function zA(t) {
  return typeof t == "function";
}
function u9(t, e, n) {
  if (!zA(t))
    return !1;
  if (n != null && n.boundTargetFunction) {
    var r = n == null ? void 0 : n.boundTargetFunction;
    return e instanceof r;
  }
  if (typeof e != "object")
    return !1;
  var o = t.prototype;
  if (typeof o != "object")
    throw new TypeError("OrdinaryHasInstance called on an object with an invalid prototype property.");
  return Object.prototype.isPrototypeOf.call(o, e);
}
function d9(t) {
  return eu(t, _E);
}
function f9(t, e) {
  var n;
  e === "string" ? n = ["toString", "valueOf"] : n = ["valueOf", "toString"];
  for (var r = 0, o = n; r < o.length; r++) {
    var i = o[r], a = t[i];
    if (zA(a)) {
      var s = a.call(t);
      if (typeof s != "object")
        return s;
    }
  }
  throw new TypeError("Cannot convert object to primitive value");
}
function EE(t, e) {
  if (typeof t == "object" && t != null) {
    var n = Symbol.toPrimitive in t ? t[Symbol.toPrimitive] : void 0, r = void 0;
    if (n !== void 0) {
      e === void 0 ? r = "default" : e === "string" ? r = "string" : (St(e === "number", 'preferredType must be "string" or "number"'), r = "number");
      var o = n.call(t, r);
      if (typeof o != "object")
        return o;
      throw new TypeError("Cannot convert exotic object to primitive.");
    }
    return e === void 0 && (e = "number"), f9(t, e);
  }
  return t;
}
function ZA(t) {
  return typeof t > "u" ? /* @__PURE__ */ Object.create(null) : cE(t);
}
function yl(t, e, n, r) {
  if (t === void 0)
    return r;
  var o = Number(t);
  if (isNaN(o) || o < e || o > n)
    throw new RangeError("".concat(o, " is outside of range [").concat(e, ", ").concat(n, "]"));
  return Math.floor(o);
}
function Zh(t, e, n, r, o) {
  var i = t[e];
  return yl(i, n, r, o);
}
function Nn(t, e, n, r, o) {
  if (typeof t != "object")
    throw new TypeError("Options must be an object");
  var i = t[e];
  if (i !== void 0) {
    if (n !== "boolean" && n !== "string")
      throw new TypeError("invalid type");
    if (n === "boolean" && (i = !!i), n === "string" && (i = sE(i)), r !== void 0 && !r.filter(function(a) {
      return a == i;
    }).length)
      throw new RangeError("".concat(i, " is not within ").concat(r.join(", ")));
    return i;
  }
  return o;
}
function h9(t) {
  if (typeof t > "u")
    return /* @__PURE__ */ Object.create(null);
  if (typeof t == "object")
    return t;
  throw new TypeError("Options must be an object");
}
function qA(t, e, n, r, o, i) {
  var a = t[e];
  if (a === void 0)
    return i;
  if (a === !0)
    return r;
  var s = !!a;
  if (s === !1)
    return o;
  if (a = sE(a), a === "true" || a === "false")
    return i;
  if ((n || []).indexOf(a) === -1)
    throw new RangeError("Invalid value ".concat(a));
  return a;
}
var XA = [
  "angle-degree",
  "area-acre",
  "area-hectare",
  "concentr-percent",
  "digital-bit",
  "digital-byte",
  "digital-gigabit",
  "digital-gigabyte",
  "digital-kilobit",
  "digital-kilobyte",
  "digital-megabit",
  "digital-megabyte",
  "digital-petabyte",
  "digital-terabit",
  "digital-terabyte",
  "duration-day",
  "duration-hour",
  "duration-millisecond",
  "duration-minute",
  "duration-month",
  "duration-second",
  "duration-week",
  "duration-year",
  "length-centimeter",
  "length-foot",
  "length-inch",
  "length-kilometer",
  "length-meter",
  "length-mile-scandinavian",
  "length-mile",
  "length-millimeter",
  "length-yard",
  "mass-gram",
  "mass-kilogram",
  "mass-ounce",
  "mass-pound",
  "mass-stone",
  "temperature-celsius",
  "temperature-fahrenheit",
  "volume-fluid-ounce",
  "volume-gallon",
  "volume-liter",
  "volume-milliliter"
];
function jA(t) {
  return t.slice(t.indexOf("-") + 1);
}
var JA = XA.map(jA);
function ed(t) {
  return JA.indexOf(t) > -1;
}
function _9(t, e) {
  var n = e.zoneNamesFromData, r = e.uppercaseLinks, o = t.toUpperCase(), i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  return n.map(function(s) {
    return s.toUpperCase();
  }).forEach(function(s) {
    return i.add(s);
  }), Object.keys(r).forEach(function(s) {
    a.add(s.toUpperCase()), i.add(r[s].toUpperCase());
  }), i.has(o) || a.has(o);
}
function E9(t) {
  return t.replace(/([a-z])/g, function(e, n) {
    return n.toUpperCase();
  });
}
var p9 = /[^A-Z]/;
function QA(t) {
  return t = E9(t), !(t.length !== 3 || p9.test(t));
}
function m9(t) {
  return t.replace(/([A-Z])/g, function(e, n) {
    return n.toLowerCase();
  });
}
function e4(t) {
  if (t = m9(t), ed(t))
    return !0;
  var e = t.split("-per-");
  if (e.length !== 2)
    return !1;
  var n = e[0], r = e[1];
  return !(!ed(n) || !ed(r));
}
function pE(t, e, n, r) {
  if (t.eq(e) || (St(e.lessThan(t) && t.lessThan(n), "x should be between r1 and r2 but x=".concat(t, ", r1=").concat(e, ", r2=").concat(n)), r === "zero"))
    return e;
  if (r === "infinity")
    return n;
  var o = t.minus(e), i = n.minus(t);
  if (o.lessThan(i))
    return e;
  if (i.lessThan(o))
    return n;
  if (St(o.eq(i), "d1 should be equal to d2"), r === "half-zero")
    return e;
  if (r === "half-infinity")
    return n;
  St(r === "half-even", "unsignedRoundingMode should be half-even");
  var a = e.div(n.minus(e)).mod(2);
  return a.isZero() ? e : n;
}
var um = /* @__PURE__ */ new Set([
  "unit",
  "exponentMinusSign",
  "minusSign",
  "plusSign",
  "percentSign",
  "exponentSeparator",
  "percent",
  "percentSign",
  "currency",
  "literal"
]);
function t4(t, e, n) {
  for (var r = n.getInternalSlots, o = r(t), i = o.dataLocaleData.numbers.symbols[o.numberingSystem], a = new RegExp("s?[".concat(i.rangeSign, "]s?")), s = e.findIndex(function(f) {
    return f.type === "literal" && a.test(f.value);
  }), l = [], c = s - 1; c >= 0 && um.has(e[c].type); c--)
    l.unshift(e[c]);
  if (Array.from(l.map(function(f) {
    return f.value;
  }).join("")).length > 1) {
    var u = Array.from(e);
    return u.splice(s - l.length, l.length), u;
  }
  for (var d = [], c = s + 1; c < e.length && um.has(e[c].type); c++)
    d.push(e[c]);
  if (Array.from(d.map(function(f) {
    return f.value;
  }).join("")).length > 1) {
    var u = Array.from(e);
    return u.splice(s + 1, d.length), u;
  }
  return e;
}
lt.set({
  toExpPos: 100
});
function qh(t, e) {
  var n = t.notation, r = t.dataLocaleData, o = t.numberingSystem;
  switch (n) {
    case "standard":
      return 0;
    case "scientific":
      return e.toNumber();
    case "engineering":
      var i = e.div(3).floor();
      return i.times(3).toNumber();
    default: {
      St(n === "compact", "Invalid notation");
      var a = t.compactDisplay, s = t.style, l = t.currencyDisplay, c = void 0;
      if (s === "currency" && l !== "name") {
        var u = r.numbers.currency[o] || r.numbers.currency[r.numbers.nu[0]];
        c = u.short;
      } else {
        var d = r.numbers.decimal[o] || r.numbers.decimal[r.numbers.nu[0]];
        c = a === "long" ? d.long : d.short;
      }
      if (!c)
        return 0;
      var f = lt.pow(10, e).toString(), h = Object.keys(c);
      if (f < h[0])
        return 0;
      if (f > h[h.length - 1])
        return h[h.length - 1].length - 1;
      var _ = h.indexOf(f);
      if (_ === -1)
        return 0;
      var E = h[_], m = c[E].other;
      return m === "0" ? 0 : E.length - c[E].other.match(/0+/)[0].length;
    }
  }
}
var N9 = {
  ceil: "zero",
  floor: "infinity",
  expand: "infinity",
  trunc: "zero",
  halfCeil: "half-zero",
  halfFloor: "half-infinity",
  halfExpand: "half-infinity",
  halfTrunc: "half-zero",
  halfEven: "half-even"
}, v9 = {
  ceil: "infinity",
  floor: "zero",
  expand: "infinity",
  trunc: "zero",
  halfCeil: "half-infinity",
  halfFloor: "half-zero",
  halfExpand: "half-infinity",
  halfTrunc: "half-zero",
  halfEven: "half-even"
};
function mE(t, e) {
  return e ? N9[t] : v9[t];
}
lt.set({
  toExpPos: 100
});
function n4(t, e) {
  return t.times(lt.pow(10, -e));
}
function g9(t, e, n) {
  var r = t.times(lt.pow(10, e)).floor(), o = r.div(n).floor().times(n), i = n4(o, e);
  return {
    n1: o,
    r1: i
  };
}
function I9(t, e, n) {
  var r = t.times(lt.pow(10, e)).ceil(), o = r.div(n).ceil().times(n), i = n4(o, e);
  return {
    n2: o,
    r2: i
  };
}
function Id(t, e, n, r, o) {
  var i = n, a = g9(t, i, r), s = a.n1, l = a.r1, c = I9(t, i, r), u = c.n2, d = c.r2, f = pE(t, l, d, o), h, _, E;
  f.eq(l) ? (h = s, _ = l) : (h = u, _ = d), h.isZero() ? E = "0" : E = h.toString();
  var m;
  if (i !== 0) {
    var N = E.length;
    if (N <= i) {
      var I = Hl("0", i - N + 1);
      E = I + E, N = i + 1;
    }
    var O = E.slice(0, N - i), p = E.slice(E.length - i);
    E = O + "." + p, m = O.length;
  } else
    m = E.length;
  for (var C = n - e; C > 0 && E[E.length - 1] === "0"; )
    E = E.slice(0, E.length - 1), C--;
  return E[E.length - 1] === "." && (E = E.slice(0, E.length - 1)), {
    formattedString: E,
    roundedNumber: _,
    integerDigitsCount: m,
    roundingMagnitude: -i
  };
}
function O9(t, e) {
  for (var n = lt.pow(10, e), r = lt.pow(10, e - 1), o = t.div(r).log(10).plus(e).minus(1).ceil(), i = o; ; ) {
    var a = t.div(lt.pow(10, i.minus(e).plus(1))).floor();
    if (a.lessThan(n) && a.greaterThanOrEqualTo(r)) {
      var s = a.times(lt.pow(10, i.minus(e).plus(1)));
      if (s.lessThanOrEqualTo(t))
        return {
          n1: a,
          e1: i,
          r1: s
        };
    }
    i = i.minus(1);
  }
}
function A9(t, e) {
  for (var n = lt.pow(10, e), r = lt.pow(10, e - 1), o = t.div(n).log(10).plus(e).minus(1).floor(), i = o; ; ) {
    var a = t.div(lt.pow(10, i.minus(e).plus(1))).ceil();
    if (a.lessThan(n) && a.greaterThanOrEqualTo(r)) {
      var s = a.times(lt.pow(10, i.minus(e).plus(1)));
      if (s.greaterThanOrEqualTo(t))
        return {
          n2: a,
          e2: i,
          r2: s
        };
    }
    i = i.plus(1);
  }
}
function Xh(t, e, n, r) {
  var o = n, i, a, s;
  if (t.isZero())
    i = Hl("0", o), a = 0, s = jc;
  else {
    var l = O9(t, o), c = l.n1, u = l.e1, d = l.r1, f = A9(t, o), h = f.n2, _ = f.e2, E = f.r2, m = pE(t, d, E, r), N = void 0;
    m.eq(d) ? (N = c, a = u.toNumber(), s = d) : (N = h, a = _.toNumber(), s = E), i = N.toString();
  }
  var I;
  if (a >= o - 1 ? (i = i + Hl("0", a - o + 1), I = a + 1) : a >= 0 ? (i = i.slice(0, a + 1) + "." + i.slice(i.length - (o - (a + 1))), I = a + 1) : (St(a < 0, "e should be less than 0"), i = "0." + Hl("0", -a - 1) + i, I = 1), i.includes(".") && n > e) {
    for (var O = n - e; O > 0 && i[i.length - 1] === "0"; )
      i = i.slice(0, i.length - 1), O--;
    i[i.length - 1] === "." && (i = i.slice(0, i.length - 1));
  }
  return {
    formattedString: i,
    roundedNumber: s,
    integerDigitsCount: I,
    roundingMagnitude: a
  };
}
function NE(t, e) {
  var n = e, r;
  n.isZero() && n.isNegative() ? (r = "negative", n = jc) : (St(n.isFinite(), "NumberFormatDigitInternalSlots value is not finite"), n.lessThan(0) ? r = "negative" : r = "positive", r === "negative" && (n = n.negated()));
  var o, i = t.roundingType, a = mE(t.roundingMode, r === "negative");
  switch (i) {
    case "significantDigits":
      o = Xh(n, t.minimumSignificantDigits, t.maximumSignificantDigits, a);
      break;
    case "fractionDigits":
      o = Id(n, t.minimumFractionDigits, t.maximumFractionDigits, t.roundingIncrement, a);
      break;
    default:
      var s = Xh(n, t.minimumSignificantDigits, t.maximumSignificantDigits, a), l = Id(n, t.minimumFractionDigits, t.maximumFractionDigits, t.roundingIncrement, a);
      t.roundingType === "morePrecision" ? s.roundingMagnitude <= l.roundingMagnitude ? o = s : o = l : (St(t.roundingType === "lessPrecision", "Invalid roundingType"), s.roundingMagnitude <= l.roundingMagnitude ? o = l : o = s);
      break;
  }
  n = o.roundedNumber;
  var c = o.formattedString;
  if (t.trailingZeroDisplay === "stripIfInteger" && n.isInteger()) {
    var u = c.indexOf(".");
    u > -1 && (c = c.slice(0, u));
  }
  var d = o.integerDigitsCount, f = t.minimumIntegerDigits;
  if (d < f) {
    var h = Hl("0", f - d);
    c = h + c;
  }
  return r === "negative" && (n.isZero() ? n = Lb : n = n.negated()), { roundedNumber: n, formattedString: c };
}
function r4(t, e) {
  if (e.isZero())
    return [0, 0];
  e.isNegative() && (e = e.negated());
  var n = e.log(10).floor(), r = qh(t, n);
  e = e.times(lt.pow(10, -r));
  var o = NE(t, e);
  if (o.roundedNumber.isZero())
    return [r, n.toNumber()];
  var i = o.roundedNumber.log(10).floor();
  return i.eq(n.minus(r)) ? [r, n.toNumber()] : [
    qh(t, n.plus(1)),
    n.plus(1).toNumber()
  ];
}
function o4(t, e) {
  var n = e.currencyDigitsData;
  return GA(n, t) ? n[t] : 2;
}
var i4 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20BF\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC1\uFDFC\uFDFD\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEE0-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDD78\uDD7A-\uDDCB\uDDCD-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6\uDF00-\uDF92\uDF94-\uDFCA]/, D9 = {
  adlm: [
    "𞥐",
    "𞥑",
    "𞥒",
    "𞥓",
    "𞥔",
    "𞥕",
    "𞥖",
    "𞥗",
    "𞥘",
    "𞥙"
  ],
  ahom: [
    "𑜰",
    "𑜱",
    "𑜲",
    "𑜳",
    "𑜴",
    "𑜵",
    "𑜶",
    "𑜷",
    "𑜸",
    "𑜹"
  ],
  arab: [
    "٠",
    "١",
    "٢",
    "٣",
    "٤",
    "٥",
    "٦",
    "٧",
    "٨",
    "٩"
  ],
  arabext: [
    "۰",
    "۱",
    "۲",
    "۳",
    "۴",
    "۵",
    "۶",
    "۷",
    "۸",
    "۹"
  ],
  bali: [
    "᭐",
    "᭑",
    "᭒",
    "᭓",
    "᭔",
    "᭕",
    "᭖",
    "᭗",
    "᭘",
    "᭙"
  ],
  beng: [
    "০",
    "১",
    "২",
    "৩",
    "৪",
    "৫",
    "৬",
    "৭",
    "৮",
    "৯"
  ],
  bhks: [
    "𑱐",
    "𑱑",
    "𑱒",
    "𑱓",
    "𑱔",
    "𑱕",
    "𑱖",
    "𑱗",
    "𑱘",
    "𑱙"
  ],
  brah: [
    "𑁦",
    "𑁧",
    "𑁨",
    "𑁩",
    "𑁪",
    "𑁫",
    "𑁬",
    "𑁭",
    "𑁮",
    "𑁯"
  ],
  cakm: [
    "𑄶",
    "𑄷",
    "𑄸",
    "𑄹",
    "𑄺",
    "𑄻",
    "𑄼",
    "𑄽",
    "𑄾",
    "𑄿"
  ],
  cham: [
    "꩐",
    "꩑",
    "꩒",
    "꩓",
    "꩔",
    "꩕",
    "꩖",
    "꩗",
    "꩘",
    "꩙"
  ],
  deva: [
    "०",
    "१",
    "२",
    "३",
    "४",
    "५",
    "६",
    "७",
    "८",
    "९"
  ],
  diak: [
    "𑥐",
    "𑥑",
    "𑥒",
    "𑥓",
    "𑥔",
    "𑥕",
    "𑥖",
    "𑥗",
    "𑥘",
    "𑥙"
  ],
  fullwide: [
    "０",
    "１",
    "２",
    "３",
    "４",
    "５",
    "６",
    "７",
    "８",
    "９"
  ],
  gong: [
    "𑶠",
    "𑶡",
    "𑶢",
    "𑶣",
    "𑶤",
    "𑶥",
    "𑶦",
    "𑶧",
    "𑶨",
    "𑶩"
  ],
  gonm: [
    "𑵐",
    "𑵑",
    "𑵒",
    "𑵓",
    "𑵔",
    "𑵕",
    "𑵖",
    "𑵗",
    "𑵘",
    "𑵙"
  ],
  gujr: [
    "૦",
    "૧",
    "૨",
    "૩",
    "૪",
    "૫",
    "૬",
    "૭",
    "૮",
    "૯"
  ],
  guru: [
    "੦",
    "੧",
    "੨",
    "੩",
    "੪",
    "੫",
    "੬",
    "੭",
    "੮",
    "੯"
  ],
  hanidec: [
    "〇",
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九"
  ],
  hmng: [
    "𖭐",
    "𖭑",
    "𖭒",
    "𖭓",
    "𖭔",
    "𖭕",
    "𖭖",
    "𖭗",
    "𖭘",
    "𖭙"
  ],
  hmnp: [
    "𞅀",
    "𞅁",
    "𞅂",
    "𞅃",
    "𞅄",
    "𞅅",
    "𞅆",
    "𞅇",
    "𞅈",
    "𞅉"
  ],
  java: [
    "꧐",
    "꧑",
    "꧒",
    "꧓",
    "꧔",
    "꧕",
    "꧖",
    "꧗",
    "꧘",
    "꧙"
  ],
  kali: [
    "꤀",
    "꤁",
    "꤂",
    "꤃",
    "꤄",
    "꤅",
    "꤆",
    "꤇",
    "꤈",
    "꤉"
  ],
  khmr: [
    "០",
    "១",
    "២",
    "៣",
    "៤",
    "៥",
    "៦",
    "៧",
    "៨",
    "៩"
  ],
  knda: [
    "೦",
    "೧",
    "೨",
    "೩",
    "೪",
    "೫",
    "೬",
    "೭",
    "೮",
    "೯"
  ],
  lana: [
    "᪀",
    "᪁",
    "᪂",
    "᪃",
    "᪄",
    "᪅",
    "᪆",
    "᪇",
    "᪈",
    "᪉"
  ],
  lanatham: [
    "᪐",
    "᪑",
    "᪒",
    "᪓",
    "᪔",
    "᪕",
    "᪖",
    "᪗",
    "᪘",
    "᪙"
  ],
  laoo: [
    "໐",
    "໑",
    "໒",
    "໓",
    "໔",
    "໕",
    "໖",
    "໗",
    "໘",
    "໙"
  ],
  lepc: [
    "᪐",
    "᪑",
    "᪒",
    "᪓",
    "᪔",
    "᪕",
    "᪖",
    "᪗",
    "᪘",
    "᪙"
  ],
  limb: [
    "᥆",
    "᥇",
    "᥈",
    "᥉",
    "᥊",
    "᥋",
    "᥌",
    "᥍",
    "᥎",
    "᥏"
  ],
  mathbold: [
    "𝟎",
    "𝟏",
    "𝟐",
    "𝟑",
    "𝟒",
    "𝟓",
    "𝟔",
    "𝟕",
    "𝟖",
    "𝟗"
  ],
  mathdbl: [
    "𝟘",
    "𝟙",
    "𝟚",
    "𝟛",
    "𝟜",
    "𝟝",
    "𝟞",
    "𝟟",
    "𝟠",
    "𝟡"
  ],
  mathmono: [
    "𝟶",
    "𝟷",
    "𝟸",
    "𝟹",
    "𝟺",
    "𝟻",
    "𝟼",
    "𝟽",
    "𝟾",
    "𝟿"
  ],
  mathsanb: [
    "𝟬",
    "𝟭",
    "𝟮",
    "𝟯",
    "𝟰",
    "𝟱",
    "𝟲",
    "𝟳",
    "𝟴",
    "𝟵"
  ],
  mathsans: [
    "𝟢",
    "𝟣",
    "𝟤",
    "𝟥",
    "𝟦",
    "𝟧",
    "𝟨",
    "𝟩",
    "𝟪",
    "𝟫"
  ],
  mlym: [
    "൦",
    "൧",
    "൨",
    "൩",
    "൪",
    "൫",
    "൬",
    "൭",
    "൮",
    "൯"
  ],
  modi: [
    "𑙐",
    "𑙑",
    "𑙒",
    "𑙓",
    "𑙔",
    "𑙕",
    "𑙖",
    "𑙗",
    "𑙘",
    "𑙙"
  ],
  mong: [
    "᠐",
    "᠑",
    "᠒",
    "᠓",
    "᠔",
    "᠕",
    "᠖",
    "᠗",
    "᠘",
    "᠙"
  ],
  mroo: [
    "𖩠",
    "𖩡",
    "𖩢",
    "𖩣",
    "𖩤",
    "𖩥",
    "𖩦",
    "𖩧",
    "𖩨",
    "𖩩"
  ],
  mtei: [
    "꯰",
    "꯱",
    "꯲",
    "꯳",
    "꯴",
    "꯵",
    "꯶",
    "꯷",
    "꯸",
    "꯹"
  ],
  mymr: [
    "၀",
    "၁",
    "၂",
    "၃",
    "၄",
    "၅",
    "၆",
    "၇",
    "၈",
    "၉"
  ],
  mymrshan: [
    "႐",
    "႑",
    "႒",
    "႓",
    "႔",
    "႕",
    "႖",
    "႗",
    "႘",
    "႙"
  ],
  mymrtlng: [
    "꧰",
    "꧱",
    "꧲",
    "꧳",
    "꧴",
    "꧵",
    "꧶",
    "꧷",
    "꧸",
    "꧹"
  ],
  newa: [
    "𑑐",
    "𑑑",
    "𑑒",
    "𑑓",
    "𑑔",
    "𑑕",
    "𑑖",
    "𑑗",
    "𑑘",
    "𑑙"
  ],
  nkoo: [
    "߀",
    "߁",
    "߂",
    "߃",
    "߄",
    "߅",
    "߆",
    "߇",
    "߈",
    "߉"
  ],
  olck: [
    "᱐",
    "᱑",
    "᱒",
    "᱓",
    "᱔",
    "᱕",
    "᱖",
    "᱗",
    "᱘",
    "᱙"
  ],
  orya: [
    "୦",
    "୧",
    "୨",
    "୩",
    "୪",
    "୫",
    "୬",
    "୭",
    "୮",
    "୯"
  ],
  osma: [
    "𐒠",
    "𐒡",
    "𐒢",
    "𐒣",
    "𐒤",
    "𐒥",
    "𐒦",
    "𐒧",
    "𐒨",
    "𐒩"
  ],
  rohg: [
    "𐴰",
    "𐴱",
    "𐴲",
    "𐴳",
    "𐴴",
    "𐴵",
    "𐴶",
    "𐴷",
    "𐴸",
    "𐴹"
  ],
  saur: [
    "꣐",
    "꣑",
    "꣒",
    "꣓",
    "꣔",
    "꣕",
    "꣖",
    "꣗",
    "꣘",
    "꣙"
  ],
  segment: [
    "🯰",
    "🯱",
    "🯲",
    "🯳",
    "🯴",
    "🯵",
    "🯶",
    "🯷",
    "🯸",
    "🯹"
  ],
  shrd: [
    "𑇐",
    "𑇑",
    "𑇒",
    "𑇓",
    "𑇔",
    "𑇕",
    "𑇖",
    "𑇗",
    "𑇘",
    "𑇙"
  ],
  sind: [
    "𑋰",
    "𑋱",
    "𑋲",
    "𑋳",
    "𑋴",
    "𑋵",
    "𑋶",
    "𑋷",
    "𑋸",
    "𑋹"
  ],
  sinh: [
    "෦",
    "෧",
    "෨",
    "෩",
    "෪",
    "෫",
    "෬",
    "෭",
    "෮",
    "෯"
  ],
  sora: [
    "𑃰",
    "𑃱",
    "𑃲",
    "𑃳",
    "𑃴",
    "𑃵",
    "𑃶",
    "𑃷",
    "𑃸",
    "𑃹"
  ],
  sund: [
    "᮰",
    "᮱",
    "᮲",
    "᮳",
    "᮴",
    "᮵",
    "᮶",
    "᮷",
    "᮸",
    "᮹"
  ],
  takr: [
    "𑛀",
    "𑛁",
    "𑛂",
    "𑛃",
    "𑛄",
    "𑛅",
    "𑛆",
    "𑛇",
    "𑛈",
    "𑛉"
  ],
  talu: [
    "᧐",
    "᧑",
    "᧒",
    "᧓",
    "᧔",
    "᧕",
    "᧖",
    "᧗",
    "᧘",
    "᧙"
  ],
  tamldec: [
    "௦",
    "௧",
    "௨",
    "௩",
    "௪",
    "௫",
    "௬",
    "௭",
    "௮",
    "௯"
  ],
  telu: [
    "౦",
    "౧",
    "౨",
    "౩",
    "౪",
    "౫",
    "౬",
    "౭",
    "౮",
    "౯"
  ],
  thai: [
    "๐",
    "๑",
    "๒",
    "๓",
    "๔",
    "๕",
    "๖",
    "๗",
    "๘",
    "๙"
  ],
  tibt: [
    "༠",
    "༡",
    "༢",
    "༣",
    "༤",
    "༥",
    "༦",
    "༧",
    "༨",
    "༩"
  ],
  tirh: [
    "𑓐",
    "𑓑",
    "𑓒",
    "𑓓",
    "𑓔",
    "𑓕",
    "𑓖",
    "𑓗",
    "𑓘",
    "𑓙"
  ],
  vaii: [
    "ᘠ",
    "ᘡ",
    "ᘢ",
    "ᘣ",
    "ᘤ",
    "ᘥ",
    "ᘦ",
    "ᘧ",
    "ᘨ",
    "ᘩ"
  ],
  wara: [
    "𑣠",
    "𑣡",
    "𑣢",
    "𑣣",
    "𑣤",
    "𑣥",
    "𑣦",
    "𑣧",
    "𑣨",
    "𑣩"
  ],
  wcho: [
    "𞋰",
    "𞋱",
    "𞋲",
    "𞋳",
    "𞋴",
    "𞋵",
    "𞋶",
    "𞋷",
    "𞋸",
    "𞋹"
  ]
}, C9 = new RegExp("^".concat(i4.source)), S9 = new RegExp("".concat(i4.source, "$")), dm = /[#0](?:[\.,][#0]+)*/g;
function a4(t, e, n, r) {
  var o, i = t.sign, a = t.exponent, s = t.magnitude, l = r.notation, c = r.style, u = r.numberingSystem, d = e.numbers.nu[0], f = null;
  l === "compact" && s && (f = T9(t, n, e, c, r.compactDisplay, r.currencyDisplay, u));
  var h;
  if (c === "currency" && r.currencyDisplay !== "name") {
    var _ = e.currencies[r.currency];
    if (_)
      switch (r.currencyDisplay) {
        case "code":
          h = r.currency;
          break;
        case "symbol":
          h = _.symbol;
          break;
        default:
          h = _.narrow;
          break;
      }
    else
      h = r.currency;
  }
  var E;
  if (f)
    E = f;
  else if (c === "decimal" || c === "unit" || c === "currency" && r.currencyDisplay === "name") {
    var m = e.numbers.decimal[u] || e.numbers.decimal[d];
    E = td(m.standard, i);
  } else if (c === "currency") {
    var N = e.numbers.currency[u] || e.numbers.currency[d];
    E = td(N[r.currencySign], i);
  } else {
    var I = e.numbers.percent[u] || e.numbers.percent[d];
    E = td(I, i);
  }
  var O = dm.exec(E)[0];
  if (E = E.replace(dm, "{0}").replace(/'(.)'/g, "$1"), c === "currency" && r.currencyDisplay !== "name") {
    var N = e.numbers.currency[u] || e.numbers.currency[d], p = N.currencySpacing.afterInsertBetween;
    p && !S9.test(h) && (E = E.replace("¤{0}", "¤".concat(p, "{0}")));
    var C = N.currencySpacing.beforeInsertBetween;
    C && !C9.test(h) && (E = E.replace("{0}¤", "{0}".concat(C, "¤")));
  }
  for (var D = E.split(/({c:[^}]+}|\{0\}|[¤%\-\+])/g), T = [], k = e.numbers.symbols[u] || e.numbers.symbols[d], G = 0, b = D; G < b.length; G++) {
    var P = b[G];
    if (P)
      switch (P) {
        case "{0}": {
          T.push.apply(T, w9(
            k,
            t,
            l,
            a,
            u,
            // If compact number pattern exists, do not insert group separators.
            !f && ((o = r.useGrouping) !== null && o !== void 0 ? o : !0),
            O,
            c,
            r.roundingIncrement,
            mE(r.roundingMode, i === -1)
          ));
          break;
        }
        case "-":
          T.push({ type: "minusSign", value: k.minusSign });
          break;
        case "+":
          T.push({ type: "plusSign", value: k.plusSign });
          break;
        case "%":
          T.push({ type: "percentSign", value: k.percentSign });
          break;
        case "¤":
          T.push({ type: "currency", value: h });
          break;
        default:
          /^\{c:/.test(P) ? T.push({
            type: "compact",
            value: P.substring(3, P.length - 1)
          }) : T.push({ type: "literal", value: P });
          break;
      }
  }
  switch (c) {
    case "currency":
      if (r.currencyDisplay === "name") {
        var $ = (e.numbers.currency[u] || e.numbers.currency[d]).unitPattern, y = void 0, L = e.currencies[r.currency];
        L ? y = Is(n, t.roundedNumber.times(lt.pow(10, a)).toNumber(), L.displayName) : y = r.currency;
        for (var w = $.split(/(\{[01]\})/g), R = [], B = 0, U = w; B < U.length; B++) {
          var P = U[B];
          switch (P) {
            case "{0}":
              R.push.apply(R, T);
              break;
            case "{1}":
              R.push({ type: "currency", value: y });
              break;
            default:
              P && R.push({ type: "literal", value: P });
              break;
          }
        }
        return R;
      } else
        return T;
    case "unit": {
      var K = r.unit, Z = r.unitDisplay, X = e.units.simple[K], $ = void 0;
      if (X)
        $ = Is(n, t.roundedNumber.times(lt.pow(10, a)).toNumber(), e.units.simple[K][Z]);
      else {
        var J = K.split("-per-"), ae = J[0], re = J[1];
        X = e.units.simple[ae];
        var j = Is(n, t.roundedNumber.times(lt.pow(10, a)).toNumber(), e.units.simple[ae][Z]), ne = e.units.simple[re].perUnit[Z];
        if (ne)
          $ = ne.replace("{0}", j);
        else {
          var Ee = e.units.compound.per[Z], fe = Is(n, 1, e.units.simple[re][Z]);
          $ = $ = Ee.replace("{0}", j).replace("{1}", fe.replace("{0}", ""));
        }
      }
      for (var R = [], Oe = 0, ce = $.split(/(\s*\{0\}\s*)/); Oe < ce.length; Oe++) {
        var P = ce[Oe], Se = /^(\s*)\{0\}(\s*)$/.exec(P);
        Se ? (Se[1] && R.push({ type: "literal", value: Se[1] }), R.push.apply(R, T), Se[2] && R.push({ type: "literal", value: Se[2] })) : P && R.push({ type: "unit", value: P });
      }
      return R;
    }
    default:
      return T;
  }
}
function w9(t, e, n, r, o, i, a, s, l, c) {
  var u = [], d = e.formattedString, f = e.roundedNumber;
  if (f.isNaN())
    return [{ type: "nan", value: d }];
  if (!f.isFinite())
    return [{ type: "infinity", value: d }];
  var h = D9[o];
  h && (d = d.replace(/\d/g, function($) {
    return h[+$] || $;
  }));
  var _ = d.indexOf("."), E, m;
  _ > 0 ? (E = d.slice(0, _), m = d.slice(_ + 1)) : E = d;
  var N = !1;
  if (i === "always" ? N = !0 : i === "min2" ? N = f.greaterThanOrEqualTo(1e4) : (i === "auto" || i) && (N = n !== "compact" || f.greaterThanOrEqualTo(1e4)), N) {
    var I = s === "currency" && t.currencyGroup != null ? t.currencyGroup : t.group, O = [], p = a.split(".")[0], C = p.split(","), D = 3, T = 3;
    C.length > 1 && (D = C[C.length - 1].length), C.length > 2 && (T = C[C.length - 2].length);
    var k = E.length - D;
    if (k > 0) {
      for (O.push(E.slice(k, k + D)), k -= T; k > 0; k -= T)
        O.push(E.slice(k, k + T));
      O.push(E.slice(0, k + T));
    } else
      O.push(E);
    for (; O.length > 0; ) {
      var G = O.pop();
      u.push({ type: "integer", value: G }), O.length > 0 && u.push({ type: "group", value: I });
    }
  } else
    u.push({ type: "integer", value: E });
  if (m !== void 0) {
    var b = s === "currency" && t.currencyDecimal != null ? t.currencyDecimal : t.decimal;
    u.push({ type: "decimal", value: b }, { type: "fraction", value: m });
  }
  if ((n === "scientific" || n === "engineering") && f.isFinite()) {
    u.push({ type: "exponentSeparator", value: t.exponential }), r < 0 && (u.push({ type: "exponentMinusSign", value: t.minusSign }), r = -r);
    var P = Id(new lt(r), 0, 0, l, c);
    u.push({
      type: "exponentInteger",
      value: P.formattedString
    });
  }
  return u;
}
function td(t, e) {
  t.indexOf(";") < 0 && (t = "".concat(t, ";-").concat(t));
  var n = t.split(";"), r = n[0], o = n[1];
  switch (e) {
    case 0:
      return r;
    case -1:
      return o;
    default:
      return o.indexOf("-") >= 0 ? o.replace(/-/g, "+") : "+".concat(r);
  }
}
function T9(t, e, n, r, o, i, a) {
  var s, l = t.roundedNumber, c = t.sign, u = t.magnitude, d = String(Math.pow(10, u)), f = n.numbers.nu[0], h;
  if (r === "currency" && i !== "name") {
    var _ = n.numbers.currency, E = _[a] || _[f], m = (s = E.short) === null || s === void 0 ? void 0 : s[d];
    if (!m)
      return null;
    h = Is(e, l.toNumber(), m);
  } else {
    var _ = n.numbers.decimal, N = _[a] || _[f], I = N[o][d];
    if (!I)
      return null;
    h = Is(e, l.toNumber(), I);
  }
  return h === "0" ? null : (h = td(h, c).replace(/([^\s;\-\+\d¤]+)/g, "{c:$1}").replace(/0+/, "0"), h);
}
function Is(t, e, n) {
  return n[t.select(e)] || n.other;
}
function s4(t, e) {
  var n = t.dataLocaleData.numbers.symbols[t.numberingSystem], r = n.approximatelySign;
  return e.push({ type: "approximatelySign", value: r }), e;
}
function _c(t, e) {
  var n, r = e, o = 0, i = t.pl, a = t.dataLocaleData, s = t.numberingSystem, l = a.numbers.symbols[s] || a.numbers.symbols[a.numbers.nu[0]], c = 0, u;
  if (r.isNaN())
    u = l.nan;
  else if (!r.isFinite())
    u = l.infinity;
  else {
    r.isZero() || (St(r.isFinite(), "Input must be a mathematical value"), t.style == "percent" && (r = r.times(100)), n = r4(t, r), c = n[0], // IMPL: We need to record the magnitude of the number
    o = n[1], r = r.times(lt.pow(10, -c)));
    var d = NE(t, r);
    u = d.formattedString, r = d.roundedNumber;
  }
  var f, h = t.signDisplay;
  switch (h) {
    case "never":
      f = 0;
      break;
    case "auto":
      r.isPositive() || r.isNaN() ? f = 0 : f = -1;
      break;
    case "always":
      r.isPositive() || r.isNaN() ? f = 1 : f = -1;
      break;
    case "exceptZero":
      r.isZero() ? f = 0 : r.isNegative() ? f = -1 : f = 1;
      break;
    default:
      St(h === "negative", 'signDisplay must be "negative"'), r.isNegative() && !r.isZero() ? f = -1 : f = 0;
      break;
  }
  return a4({
    roundedNumber: r,
    formattedString: u,
    exponent: c,
    // IMPL: We're returning this for our implementation of formatToParts
    magnitude: o,
    sign: f
  }, t.dataLocaleData, i, t);
}
function jh(t, e) {
  var n = _c(t, e);
  return n.map(function(r) {
    return r.value;
  }).join("");
}
function vE(t, e, n, r) {
  var o = r.getInternalSlots;
  St(!e.isNaN() && !n.isNaN(), "Input must be a number", RangeError);
  var i = o(t), a = _c(i, e), s = _c(i, n);
  if (jh(i, e) === jh(i, n)) {
    var l = s4(i, a);
    return l.forEach(function(d) {
      d.source = "shared";
    }), l;
  }
  var c = [];
  a.forEach(function(d) {
    d.source = "startRange", c.push(d);
  });
  var u = i.dataLocaleData.numbers.symbols[i.numberingSystem].rangeSign;
  return c.push({ type: "literal", value: u, source: "shared" }), s.forEach(function(d) {
    d.source = "endRange", c.push(d);
  }), t4(t, c, { getInternalSlots: o });
}
function b9(t, e, n, r) {
  var o = r.getInternalSlots, i = vE(t, e, n, {
    getInternalSlots: o
  });
  return i.map(function(a) {
    return a.value;
  }).join("");
}
function R9(t, e, n, r) {
  var o = r.getInternalSlots, i = vE(t, e, n, {
    getInternalSlots: o
  });
  return i.map(function(a, s) {
    return {
      type: a.type,
      value: a.value,
      source: a.source,
      result: s.toString()
    };
  });
}
function M9(t, e, n) {
  for (var r = _c(n.getInternalSlots(t), e), o = BA(0), i = 0, a = r; i < a.length; i++) {
    var s = a[i];
    o.push({
      type: s.type,
      value: s.value
    });
  }
  return o;
}
function P9(t) {
  return Intl.getCanonicalLocales(t);
}
var C1 = {
  supplemental: {
    languageMatching: {
      "written-new": [
        {
          paradigmLocales: {
            _locales: "en en_GB es es_419 pt_BR pt_PT"
          }
        },
        {
          $enUS: {
            _value: "AS+CA+GU+MH+MP+PH+PR+UM+US+VI"
          }
        },
        {
          $cnsar: {
            _value: "HK+MO"
          }
        },
        {
          $americas: {
            _value: "019"
          }
        },
        {
          $maghreb: {
            _value: "MA+DZ+TN+LY+MR+EH"
          }
        },
        {
          no: {
            _desired: "nb",
            _distance: "1"
          }
        },
        {
          bs: {
            _desired: "hr",
            _distance: "4"
          }
        },
        {
          bs: {
            _desired: "sh",
            _distance: "4"
          }
        },
        {
          hr: {
            _desired: "sh",
            _distance: "4"
          }
        },
        {
          sr: {
            _desired: "sh",
            _distance: "4"
          }
        },
        {
          aa: {
            _desired: "ssy",
            _distance: "4"
          }
        },
        {
          de: {
            _desired: "gsw",
            _distance: "4",
            _oneway: "true"
          }
        },
        {
          de: {
            _desired: "lb",
            _distance: "4",
            _oneway: "true"
          }
        },
        {
          no: {
            _desired: "da",
            _distance: "8"
          }
        },
        {
          nb: {
            _desired: "da",
            _distance: "8"
          }
        },
        {
          ru: {
            _desired: "ab",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ach",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          nl: {
            _desired: "af",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ak",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "am",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "ay",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "az",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ur: {
            _desired: "bal",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "be",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "bem",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "bh",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "bn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "bo",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "br",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "ca",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          fil: {
            _desired: "ceb",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "chr",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ckb",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "co",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "crs",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          sk: {
            _desired: "cs",
            _distance: "20"
          }
        },
        {
          en: {
            _desired: "cy",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ee",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "eo",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "eu",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          da: {
            _desired: "fo",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          nl: {
            _desired: "fy",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ga",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "gaa",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "gd",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "gl",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "gn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "gu",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ha",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "haw",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "ht",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "hy",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ia",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ig",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "is",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          id: {
            _desired: "jv",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ka",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "kg",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "kk",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "km",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "kn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "kri",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          tr: {
            _desired: "ku",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "ky",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          it: {
            _desired: "la",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "lg",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "ln",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "lo",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "loz",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "lua",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "mai",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "mfe",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "mg",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "mi",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ml",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "mn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "mr",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          id: {
            _desired: "ms",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "mt",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "my",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ne",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          nb: {
            _desired: "nn",
            _distance: "20"
          }
        },
        {
          no: {
            _desired: "nn",
            _distance: "20"
          }
        },
        {
          en: {
            _desired: "nso",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ny",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "nyn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "oc",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "om",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "or",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "pa",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "pcm",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ps",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "qu",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          de: {
            _desired: "rm",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "rn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "rw",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "sa",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "sd",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "si",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "sn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "so",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "sq",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "st",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          id: {
            _desired: "su",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "sw",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ta",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "te",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "tg",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ti",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "tk",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "tlh",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "tn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "to",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "tt",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "tum",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "ug",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "uk",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ur",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "uz",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "wo",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "xh",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "yi",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "yo",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "za",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "zu",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "aao",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "abh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "abv",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acx",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "adf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "aeb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "aec",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "afb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ajp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "apc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "apd",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "arq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ars",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ary",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "arz",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "auz",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "avl",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ayh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ayl",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ayn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ayp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "bbz",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "pga",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "shu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ssh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          az: {
            _desired: "azb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          et: {
            _desired: "vro",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "ffm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fub",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fue",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fuf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fuh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fui",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fuq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fuv",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          gn: {
            _desired: "gnw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          gn: {
            _desired: "gui",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          gn: {
            _desired: "gun",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          gn: {
            _desired: "nhd",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          iu: {
            _desired: "ikt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "enb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "eyo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "niq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "oki",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "pko",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "sgc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "tec",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "tuy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kok: {
            _desired: "gom",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kpe: {
            _desired: "gkp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "ida",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lkb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lko",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lks",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lri",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lrm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lsm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lto",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lts",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lwg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "nle",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "nyd",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "rag",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          lv: {
            _desired: "ltg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "bhr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "bjq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "bmm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "bzc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "msh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "skg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "tdx",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "tkg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "txy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "xmv",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "xmw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mn: {
            _desired: "mvf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "bjn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "btj",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "bve",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "bvu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "coa",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "dup",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "hji",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "id",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "jak",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "jax",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "kvb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "kvr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "kxd",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "lce",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "lcf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "liw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "max",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "meo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "mfa",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "mfb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "min",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "mqg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "msi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "mui",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "orn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "ors",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "pel",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "pse",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "tmw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "urk",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "vkk",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "vkt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "xmm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "zlm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "zmi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ne: {
            _desired: "dty",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          om: {
            _desired: "gax",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          om: {
            _desired: "hae",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          om: {
            _desired: "orc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          or: {
            _desired: "spv",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ps: {
            _desired: "pbt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ps: {
            _desired: "pst",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qub",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qud",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qug",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quk",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qul",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qup",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qur",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qus",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qux",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qva",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qve",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvj",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvl",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvs",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvz",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qwa",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qwc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qwh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qws",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxa",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxl",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sc: {
            _desired: "sdc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sc: {
            _desired: "sdn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sc: {
            _desired: "sro",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sq: {
            _desired: "aae",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sq: {
            _desired: "aat",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sq: {
            _desired: "aln",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          syr: {
            _desired: "aii",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          uz: {
            _desired: "uzs",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          yi: {
            _desired: "yih",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "cdo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "cjy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "cpx",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "czh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "czo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "gan",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "hak",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "hsn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "lzh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "mnp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "nan",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "wuu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "yue",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "*": {
            _desired: "*",
            _distance: "80"
          }
        },
        {
          "en-Latn": {
            _desired: "am-Ethi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "ru-Cyrl": {
            _desired: "az-Latn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "bn-Beng",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "zh-Hans": {
            _desired: "bo-Tibt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "ru-Cyrl": {
            _desired: "hy-Armn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ka-Geor",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "km-Khmr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "kn-Knda",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "lo-Laoo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ml-Mlym",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "my-Mymr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ne-Deva",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "or-Orya",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "pa-Guru",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ps-Arab",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "sd-Arab",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "si-Sinh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ta-Taml",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "te-Telu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ti-Ethi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "ru-Cyrl": {
            _desired: "tk-Latn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ur-Arab",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "ru-Cyrl": {
            _desired: "uz-Latn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "yi-Hebr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "sr-Cyrl": {
            _desired: "sr-Latn",
            _distance: "5"
          }
        },
        {
          "zh-Hans": {
            _desired: "za-Latn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "zh-Hans": {
            _desired: "zh-Hani",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "zh-Hant": {
            _desired: "zh-Hani",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "ar-Arab": {
            _desired: "ar-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "bn-Beng": {
            _desired: "bn-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "gu-Gujr": {
            _desired: "gu-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "hi-Deva": {
            _desired: "hi-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "kn-Knda": {
            _desired: "kn-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "ml-Mlym": {
            _desired: "ml-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "mr-Deva": {
            _desired: "mr-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "ta-Taml": {
            _desired: "ta-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "te-Telu": {
            _desired: "te-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "zh-Hans": {
            _desired: "zh-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Latn",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Hani",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Hira",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Kana",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Hrkt",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Hrkt": {
            _desired: "ja-Hira",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Hrkt": {
            _desired: "ja-Kana",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ko-Kore": {
            _desired: "ko-Hani",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ko-Kore": {
            _desired: "ko-Hang",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ko-Kore": {
            _desired: "ko-Jamo",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ko-Hang": {
            _desired: "ko-Jamo",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "*-*": {
            _desired: "*-*",
            _distance: "50"
          }
        },
        {
          "ar-*-$maghreb": {
            _desired: "ar-*-$maghreb",
            _distance: "4"
          }
        },
        {
          "ar-*-$!maghreb": {
            _desired: "ar-*-$!maghreb",
            _distance: "4"
          }
        },
        {
          "ar-*-*": {
            _desired: "ar-*-*",
            _distance: "5"
          }
        },
        {
          "en-*-$enUS": {
            _desired: "en-*-$enUS",
            _distance: "4"
          }
        },
        {
          "en-*-GB": {
            _desired: "en-*-$!enUS",
            _distance: "3"
          }
        },
        {
          "en-*-$!enUS": {
            _desired: "en-*-$!enUS",
            _distance: "4"
          }
        },
        {
          "en-*-*": {
            _desired: "en-*-*",
            _distance: "5"
          }
        },
        {
          "es-*-$americas": {
            _desired: "es-*-$americas",
            _distance: "4"
          }
        },
        {
          "es-*-$!americas": {
            _desired: "es-*-$!americas",
            _distance: "4"
          }
        },
        {
          "es-*-*": {
            _desired: "es-*-*",
            _distance: "5"
          }
        },
        {
          "pt-*-$americas": {
            _desired: "pt-*-$americas",
            _distance: "4"
          }
        },
        {
          "pt-*-$!americas": {
            _desired: "pt-*-$!americas",
            _distance: "4"
          }
        },
        {
          "pt-*-*": {
            _desired: "pt-*-*",
            _distance: "5"
          }
        },
        {
          "zh-Hant-$cnsar": {
            _desired: "zh-Hant-$cnsar",
            _distance: "4"
          }
        },
        {
          "zh-Hant-$!cnsar": {
            _desired: "zh-Hant-$!cnsar",
            _distance: "4"
          }
        },
        {
          "zh-Hant-*": {
            _desired: "zh-Hant-*",
            _distance: "5"
          }
        },
        {
          "*-*-*": {
            _desired: "*-*-*",
            _distance: "4"
          }
        }
      ]
    }
  }
}, y9 = {
  "001": [
    "001",
    "001-status-grouping",
    "002",
    "005",
    "009",
    "011",
    "013",
    "014",
    "015",
    "017",
    "018",
    "019",
    "021",
    "029",
    "030",
    "034",
    "035",
    "039",
    "053",
    "054",
    "057",
    "061",
    "142",
    "143",
    "145",
    "150",
    "151",
    "154",
    "155",
    "AC",
    "AD",
    "AE",
    "AF",
    "AG",
    "AI",
    "AL",
    "AM",
    "AO",
    "AQ",
    "AR",
    "AS",
    "AT",
    "AU",
    "AW",
    "AX",
    "AZ",
    "BA",
    "BB",
    "BD",
    "BE",
    "BF",
    "BG",
    "BH",
    "BI",
    "BJ",
    "BL",
    "BM",
    "BN",
    "BO",
    "BQ",
    "BR",
    "BS",
    "BT",
    "BV",
    "BW",
    "BY",
    "BZ",
    "CA",
    "CC",
    "CD",
    "CF",
    "CG",
    "CH",
    "CI",
    "CK",
    "CL",
    "CM",
    "CN",
    "CO",
    "CP",
    "CQ",
    "CR",
    "CU",
    "CV",
    "CW",
    "CX",
    "CY",
    "CZ",
    "DE",
    "DG",
    "DJ",
    "DK",
    "DM",
    "DO",
    "DZ",
    "EA",
    "EC",
    "EE",
    "EG",
    "EH",
    "ER",
    "ES",
    "ET",
    "EU",
    "EZ",
    "FI",
    "FJ",
    "FK",
    "FM",
    "FO",
    "FR",
    "GA",
    "GB",
    "GD",
    "GE",
    "GF",
    "GG",
    "GH",
    "GI",
    "GL",
    "GM",
    "GN",
    "GP",
    "GQ",
    "GR",
    "GS",
    "GT",
    "GU",
    "GW",
    "GY",
    "HK",
    "HM",
    "HN",
    "HR",
    "HT",
    "HU",
    "IC",
    "ID",
    "IE",
    "IL",
    "IM",
    "IN",
    "IO",
    "IQ",
    "IR",
    "IS",
    "IT",
    "JE",
    "JM",
    "JO",
    "JP",
    "KE",
    "KG",
    "KH",
    "KI",
    "KM",
    "KN",
    "KP",
    "KR",
    "KW",
    "KY",
    "KZ",
    "LA",
    "LB",
    "LC",
    "LI",
    "LK",
    "LR",
    "LS",
    "LT",
    "LU",
    "LV",
    "LY",
    "MA",
    "MC",
    "MD",
    "ME",
    "MF",
    "MG",
    "MH",
    "MK",
    "ML",
    "MM",
    "MN",
    "MO",
    "MP",
    "MQ",
    "MR",
    "MS",
    "MT",
    "MU",
    "MV",
    "MW",
    "MX",
    "MY",
    "MZ",
    "NA",
    "NC",
    "NE",
    "NF",
    "NG",
    "NI",
    "NL",
    "NO",
    "NP",
    "NR",
    "NU",
    "NZ",
    "OM",
    "PA",
    "PE",
    "PF",
    "PG",
    "PH",
    "PK",
    "PL",
    "PM",
    "PN",
    "PR",
    "PS",
    "PT",
    "PW",
    "PY",
    "QA",
    "QO",
    "RE",
    "RO",
    "RS",
    "RU",
    "RW",
    "SA",
    "SB",
    "SC",
    "SD",
    "SE",
    "SG",
    "SH",
    "SI",
    "SJ",
    "SK",
    "SL",
    "SM",
    "SN",
    "SO",
    "SR",
    "SS",
    "ST",
    "SV",
    "SX",
    "SY",
    "SZ",
    "TA",
    "TC",
    "TD",
    "TF",
    "TG",
    "TH",
    "TJ",
    "TK",
    "TL",
    "TM",
    "TN",
    "TO",
    "TR",
    "TT",
    "TV",
    "TW",
    "TZ",
    "UA",
    "UG",
    "UM",
    "UN",
    "US",
    "UY",
    "UZ",
    "VA",
    "VC",
    "VE",
    "VG",
    "VI",
    "VN",
    "VU",
    "WF",
    "WS",
    "XK",
    "YE",
    "YT",
    "ZA",
    "ZM",
    "ZW"
  ],
  "002": [
    "002",
    "002-status-grouping",
    "011",
    "014",
    "015",
    "017",
    "018",
    "202",
    "AO",
    "BF",
    "BI",
    "BJ",
    "BW",
    "CD",
    "CF",
    "CG",
    "CI",
    "CM",
    "CV",
    "DJ",
    "DZ",
    "EA",
    "EG",
    "EH",
    "ER",
    "ET",
    "GA",
    "GH",
    "GM",
    "GN",
    "GQ",
    "GW",
    "IC",
    "IO",
    "KE",
    "KM",
    "LR",
    "LS",
    "LY",
    "MA",
    "MG",
    "ML",
    "MR",
    "MU",
    "MW",
    "MZ",
    "NA",
    "NE",
    "NG",
    "RE",
    "RW",
    "SC",
    "SD",
    "SH",
    "SL",
    "SN",
    "SO",
    "SS",
    "ST",
    "SZ",
    "TD",
    "TF",
    "TG",
    "TN",
    "TZ",
    "UG",
    "YT",
    "ZA",
    "ZM",
    "ZW"
  ],
  "003": [
    "003",
    "013",
    "021",
    "029",
    "AG",
    "AI",
    "AW",
    "BB",
    "BL",
    "BM",
    "BQ",
    "BS",
    "BZ",
    "CA",
    "CR",
    "CU",
    "CW",
    "DM",
    "DO",
    "GD",
    "GL",
    "GP",
    "GT",
    "HN",
    "HT",
    "JM",
    "KN",
    "KY",
    "LC",
    "MF",
    "MQ",
    "MS",
    "MX",
    "NI",
    "PA",
    "PM",
    "PR",
    "SV",
    "SX",
    "TC",
    "TT",
    "US",
    "VC",
    "VG",
    "VI"
  ],
  "005": [
    "005",
    "AR",
    "BO",
    "BR",
    "BV",
    "CL",
    "CO",
    "EC",
    "FK",
    "GF",
    "GS",
    "GY",
    "PE",
    "PY",
    "SR",
    "UY",
    "VE"
  ],
  "009": [
    "009",
    "053",
    "054",
    "057",
    "061",
    "AC",
    "AQ",
    "AS",
    "AU",
    "CC",
    "CK",
    "CP",
    "CX",
    "DG",
    "FJ",
    "FM",
    "GU",
    "HM",
    "KI",
    "MH",
    "MP",
    "NC",
    "NF",
    "NR",
    "NU",
    "NZ",
    "PF",
    "PG",
    "PN",
    "PW",
    "QO",
    "SB",
    "TA",
    "TK",
    "TO",
    "TV",
    "UM",
    "VU",
    "WF",
    "WS"
  ],
  "011": [
    "011",
    "BF",
    "BJ",
    "CI",
    "CV",
    "GH",
    "GM",
    "GN",
    "GW",
    "LR",
    "ML",
    "MR",
    "NE",
    "NG",
    "SH",
    "SL",
    "SN",
    "TG"
  ],
  "013": [
    "013",
    "BZ",
    "CR",
    "GT",
    "HN",
    "MX",
    "NI",
    "PA",
    "SV"
  ],
  "014": [
    "014",
    "BI",
    "DJ",
    "ER",
    "ET",
    "IO",
    "KE",
    "KM",
    "MG",
    "MU",
    "MW",
    "MZ",
    "RE",
    "RW",
    "SC",
    "SO",
    "SS",
    "TF",
    "TZ",
    "UG",
    "YT",
    "ZM",
    "ZW"
  ],
  "015": [
    "015",
    "DZ",
    "EA",
    "EG",
    "EH",
    "IC",
    "LY",
    "MA",
    "SD",
    "TN"
  ],
  "017": [
    "017",
    "AO",
    "CD",
    "CF",
    "CG",
    "CM",
    "GA",
    "GQ",
    "ST",
    "TD"
  ],
  "018": [
    "018",
    "BW",
    "LS",
    "NA",
    "SZ",
    "ZA"
  ],
  "019": [
    "003",
    "005",
    "013",
    "019",
    "019-status-grouping",
    "021",
    "029",
    "419",
    "AG",
    "AI",
    "AR",
    "AW",
    "BB",
    "BL",
    "BM",
    "BO",
    "BQ",
    "BR",
    "BS",
    "BV",
    "BZ",
    "CA",
    "CL",
    "CO",
    "CR",
    "CU",
    "CW",
    "DM",
    "DO",
    "EC",
    "FK",
    "GD",
    "GF",
    "GL",
    "GP",
    "GS",
    "GT",
    "GY",
    "HN",
    "HT",
    "JM",
    "KN",
    "KY",
    "LC",
    "MF",
    "MQ",
    "MS",
    "MX",
    "NI",
    "PA",
    "PE",
    "PM",
    "PR",
    "PY",
    "SR",
    "SV",
    "SX",
    "TC",
    "TT",
    "US",
    "UY",
    "VC",
    "VE",
    "VG",
    "VI"
  ],
  "021": [
    "021",
    "BM",
    "CA",
    "GL",
    "PM",
    "US"
  ],
  "029": [
    "029",
    "AG",
    "AI",
    "AW",
    "BB",
    "BL",
    "BQ",
    "BS",
    "CU",
    "CW",
    "DM",
    "DO",
    "GD",
    "GP",
    "HT",
    "JM",
    "KN",
    "KY",
    "LC",
    "MF",
    "MQ",
    "MS",
    "PR",
    "SX",
    "TC",
    "TT",
    "VC",
    "VG",
    "VI"
  ],
  "030": [
    "030",
    "CN",
    "HK",
    "JP",
    "KP",
    "KR",
    "MN",
    "MO",
    "TW"
  ],
  "034": [
    "034",
    "AF",
    "BD",
    "BT",
    "IN",
    "IR",
    "LK",
    "MV",
    "NP",
    "PK"
  ],
  "035": [
    "035",
    "BN",
    "ID",
    "KH",
    "LA",
    "MM",
    "MY",
    "PH",
    "SG",
    "TH",
    "TL",
    "VN"
  ],
  "039": [
    "039",
    "AD",
    "AL",
    "BA",
    "ES",
    "GI",
    "GR",
    "HR",
    "IT",
    "ME",
    "MK",
    "MT",
    "PT",
    "RS",
    "SI",
    "SM",
    "VA",
    "XK"
  ],
  "053": [
    "053",
    "AU",
    "CC",
    "CX",
    "HM",
    "NF",
    "NZ"
  ],
  "054": [
    "054",
    "FJ",
    "NC",
    "PG",
    "SB",
    "VU"
  ],
  "057": [
    "057",
    "FM",
    "GU",
    "KI",
    "MH",
    "MP",
    "NR",
    "PW",
    "UM"
  ],
  "061": [
    "061",
    "AS",
    "CK",
    "NU",
    "PF",
    "PN",
    "TK",
    "TO",
    "TV",
    "WF",
    "WS"
  ],
  142: [
    "030",
    "034",
    "035",
    "142",
    "143",
    "145",
    "AE",
    "AF",
    "AM",
    "AZ",
    "BD",
    "BH",
    "BN",
    "BT",
    "CN",
    "CY",
    "GE",
    "HK",
    "ID",
    "IL",
    "IN",
    "IQ",
    "IR",
    "JO",
    "JP",
    "KG",
    "KH",
    "KP",
    "KR",
    "KW",
    "KZ",
    "LA",
    "LB",
    "LK",
    "MM",
    "MN",
    "MO",
    "MV",
    "MY",
    "NP",
    "OM",
    "PH",
    "PK",
    "PS",
    "QA",
    "SA",
    "SG",
    "SY",
    "TH",
    "TJ",
    "TL",
    "TM",
    "TR",
    "TW",
    "UZ",
    "VN",
    "YE"
  ],
  143: [
    "143",
    "KG",
    "KZ",
    "TJ",
    "TM",
    "UZ"
  ],
  145: [
    "145",
    "AE",
    "AM",
    "AZ",
    "BH",
    "CY",
    "GE",
    "IL",
    "IQ",
    "JO",
    "KW",
    "LB",
    "OM",
    "PS",
    "QA",
    "SA",
    "SY",
    "TR",
    "YE"
  ],
  150: [
    "039",
    "150",
    "151",
    "154",
    "155",
    "AD",
    "AL",
    "AT",
    "AX",
    "BA",
    "BE",
    "BG",
    "BY",
    "CH",
    "CQ",
    "CZ",
    "DE",
    "DK",
    "EE",
    "ES",
    "FI",
    "FO",
    "FR",
    "GB",
    "GG",
    "GI",
    "GR",
    "HR",
    "HU",
    "IE",
    "IM",
    "IS",
    "IT",
    "JE",
    "LI",
    "LT",
    "LU",
    "LV",
    "MC",
    "MD",
    "ME",
    "MK",
    "MT",
    "NL",
    "NO",
    "PL",
    "PT",
    "RO",
    "RS",
    "RU",
    "SE",
    "SI",
    "SJ",
    "SK",
    "SM",
    "UA",
    "VA",
    "XK"
  ],
  151: [
    "151",
    "BG",
    "BY",
    "CZ",
    "HU",
    "MD",
    "PL",
    "RO",
    "RU",
    "SK",
    "UA"
  ],
  154: [
    "154",
    "AX",
    "CQ",
    "DK",
    "EE",
    "FI",
    "FO",
    "GB",
    "GG",
    "IE",
    "IM",
    "IS",
    "JE",
    "LT",
    "LV",
    "NO",
    "SE",
    "SJ"
  ],
  155: [
    "155",
    "AT",
    "BE",
    "CH",
    "DE",
    "FR",
    "LI",
    "LU",
    "MC",
    "NL"
  ],
  202: [
    "011",
    "014",
    "017",
    "018",
    "202",
    "AO",
    "BF",
    "BI",
    "BJ",
    "BW",
    "CD",
    "CF",
    "CG",
    "CI",
    "CM",
    "CV",
    "DJ",
    "ER",
    "ET",
    "GA",
    "GH",
    "GM",
    "GN",
    "GQ",
    "GW",
    "IO",
    "KE",
    "KM",
    "LR",
    "LS",
    "MG",
    "ML",
    "MR",
    "MU",
    "MW",
    "MZ",
    "NA",
    "NE",
    "NG",
    "RE",
    "RW",
    "SC",
    "SH",
    "SL",
    "SN",
    "SO",
    "SS",
    "ST",
    "SZ",
    "TD",
    "TF",
    "TG",
    "TZ",
    "UG",
    "YT",
    "ZA",
    "ZM",
    "ZW"
  ],
  419: [
    "005",
    "013",
    "029",
    "419",
    "AG",
    "AI",
    "AR",
    "AW",
    "BB",
    "BL",
    "BO",
    "BQ",
    "BR",
    "BS",
    "BV",
    "BZ",
    "CL",
    "CO",
    "CR",
    "CU",
    "CW",
    "DM",
    "DO",
    "EC",
    "FK",
    "GD",
    "GF",
    "GP",
    "GS",
    "GT",
    "GY",
    "HN",
    "HT",
    "JM",
    "KN",
    "KY",
    "LC",
    "MF",
    "MQ",
    "MS",
    "MX",
    "NI",
    "PA",
    "PE",
    "PR",
    "PY",
    "SR",
    "SV",
    "SX",
    "TC",
    "TT",
    "UY",
    "VC",
    "VE",
    "VG",
    "VI"
  ],
  EU: [
    "AT",
    "BE",
    "BG",
    "CY",
    "CZ",
    "DE",
    "DK",
    "EE",
    "ES",
    "EU",
    "FI",
    "FR",
    "GR",
    "HR",
    "HU",
    "IE",
    "IT",
    "LT",
    "LU",
    "LV",
    "MT",
    "NL",
    "PL",
    "PT",
    "RO",
    "SE",
    "SI",
    "SK"
  ],
  EZ: [
    "AT",
    "BE",
    "CY",
    "DE",
    "EE",
    "ES",
    "EZ",
    "FI",
    "FR",
    "GR",
    "IE",
    "IT",
    "LT",
    "LU",
    "LV",
    "MT",
    "NL",
    "PT",
    "SI",
    "SK"
  ],
  QO: [
    "AC",
    "AQ",
    "CP",
    "DG",
    "QO",
    "TA"
  ],
  UN: [
    "AD",
    "AE",
    "AF",
    "AG",
    "AL",
    "AM",
    "AO",
    "AR",
    "AT",
    "AU",
    "AZ",
    "BA",
    "BB",
    "BD",
    "BE",
    "BF",
    "BG",
    "BH",
    "BI",
    "BJ",
    "BN",
    "BO",
    "BR",
    "BS",
    "BT",
    "BW",
    "BY",
    "BZ",
    "CA",
    "CD",
    "CF",
    "CG",
    "CH",
    "CI",
    "CL",
    "CM",
    "CN",
    "CO",
    "CR",
    "CU",
    "CV",
    "CY",
    "CZ",
    "DE",
    "DJ",
    "DK",
    "DM",
    "DO",
    "DZ",
    "EC",
    "EE",
    "EG",
    "ER",
    "ES",
    "ET",
    "FI",
    "FJ",
    "FM",
    "FR",
    "GA",
    "GB",
    "GD",
    "GE",
    "GH",
    "GM",
    "GN",
    "GQ",
    "GR",
    "GT",
    "GW",
    "GY",
    "HN",
    "HR",
    "HT",
    "HU",
    "ID",
    "IE",
    "IL",
    "IN",
    "IQ",
    "IR",
    "IS",
    "IT",
    "JM",
    "JO",
    "JP",
    "KE",
    "KG",
    "KH",
    "KI",
    "KM",
    "KN",
    "KP",
    "KR",
    "KW",
    "KZ",
    "LA",
    "LB",
    "LC",
    "LI",
    "LK",
    "LR",
    "LS",
    "LT",
    "LU",
    "LV",
    "LY",
    "MA",
    "MC",
    "MD",
    "ME",
    "MG",
    "MH",
    "MK",
    "ML",
    "MM",
    "MN",
    "MR",
    "MT",
    "MU",
    "MV",
    "MW",
    "MX",
    "MY",
    "MZ",
    "NA",
    "NE",
    "NG",
    "NI",
    "NL",
    "NO",
    "NP",
    "NR",
    "NZ",
    "OM",
    "PA",
    "PE",
    "PG",
    "PH",
    "PK",
    "PL",
    "PT",
    "PW",
    "PY",
    "QA",
    "RO",
    "RS",
    "RU",
    "RW",
    "SA",
    "SB",
    "SC",
    "SD",
    "SE",
    "SG",
    "SI",
    "SK",
    "SL",
    "SM",
    "SN",
    "SO",
    "SR",
    "SS",
    "ST",
    "SV",
    "SY",
    "SZ",
    "TD",
    "TG",
    "TH",
    "TJ",
    "TL",
    "TM",
    "TN",
    "TO",
    "TR",
    "TT",
    "TV",
    "TZ",
    "UA",
    "UG",
    "UN",
    "US",
    "UY",
    "UZ",
    "VC",
    "VE",
    "VN",
    "VU",
    "WS",
    "YE",
    "ZA",
    "ZM",
    "ZW"
  ]
}, gE = /-u(?:-[0-9a-z]{2,8})+/gi;
function Uo(t, e, n) {
  if (n === void 0 && (n = Error), !t)
    throw new n(e);
}
var L9 = 838, S1;
function x9() {
  var t, e;
  if (!S1) {
    var n = (e = (t = C1.supplemental.languageMatching["written-new"][0]) === null || t === void 0 ? void 0 : t.paradigmLocales) === null || e === void 0 ? void 0 : e._locales.split(" "), r = C1.supplemental.languageMatching["written-new"].slice(1, 5), o = C1.supplemental.languageMatching["written-new"].slice(5), i = o.map(function(a) {
      var s = Object.keys(a)[0], l = a[s];
      return {
        supported: s,
        desired: l._desired,
        distance: +l._distance,
        oneway: l.oneway === "true"
      };
    }, {});
    S1 = {
      matches: i,
      matchVariables: r.reduce(function(a, s) {
        var l = Object.keys(s)[0], c = s[l];
        return a[l.slice(1)] = c._value.split("+"), a;
      }, {}),
      paradigmLocales: Fr(Fr([], n, !0), n.map(function(a) {
        return new Intl.Locale(a.replace(/_/g, "-")).maximize().toString();
      }), !0)
    };
  }
  return S1;
}
function Cu(t, e, n) {
  var r = e.split("-"), o = r[0], i = r[1], a = r[2], s = !0;
  if (a && a[0] === "$") {
    var l = a[1] !== "!", c = l ? n[a.slice(1)] : n[a.slice(2)], u = c.map(function(d) {
      return y9[d] || [d];
    }).reduce(function(d, f) {
      return Fr(Fr([], d, !0), f, !0);
    }, []);
    s && (s = u.indexOf(t.region || "") > -1 == l);
  } else
    s && (s = t.region ? a === "*" || a === t.region : !0);
  return s && (s = t.script ? i === "*" || i === t.script : !0), s && (s = t.language ? o === "*" || o === t.language : !0), s;
}
function fm(t) {
  return [t.language, t.script, t.region].filter(Boolean).join("-");
}
function w1(t, e, n) {
  for (var r = 0, o = n.matches; r < o.length; r++) {
    var i = o[r], a = Cu(t, i.desired, n.matchVariables) && Cu(e, i.supported, n.matchVariables);
    if (!i.oneway && !a && (a = Cu(t, i.supported, n.matchVariables) && Cu(e, i.desired, n.matchVariables)), a) {
      var s = i.distance * 10;
      return n.paradigmLocales.indexOf(fm(t)) > -1 != n.paradigmLocales.indexOf(fm(e)) > -1 ? s - 1 : s;
    }
  }
  throw new Error("No matching distance found");
}
function U9(t, e) {
  var n = new Intl.Locale(t).maximize(), r = new Intl.Locale(e).maximize(), o = {
    language: n.language,
    script: n.script || "",
    region: n.region || ""
  }, i = {
    language: r.language,
    script: r.script || "",
    region: r.region || ""
  }, a = 0, s = x9();
  return o.language !== i.language && (a += w1({
    language: n.language,
    script: "",
    region: ""
  }, {
    language: r.language,
    script: "",
    region: ""
  }, s)), o.script !== i.script && (a += w1({
    language: n.language,
    script: o.script,
    region: ""
  }, {
    language: r.language,
    script: i.script,
    region: ""
  }, s)), o.region !== i.region && (a += w1(o, i, s)), a;
}
function $9(t, e, n) {
  n === void 0 && (n = L9);
  var r = 1 / 0, o = {
    matchedDesiredLocale: "",
    distances: {}
  };
  return t.forEach(function(i, a) {
    o.distances[i] || (o.distances[i] = {}), e.forEach(function(s) {
      var l = U9(i, s) + 0 + a * 40;
      o.distances[i][s] = l, l < r && (r = l, o.matchedDesiredLocale = i, o.matchedSupportedLocale = s);
    });
  }), r >= n && (o.matchedDesiredLocale = void 0, o.matchedSupportedLocale = void 0), o;
}
function k9(t, e, n) {
  var r, o, i = [], a = e.reduce(function(l, c) {
    var u = c.replace(gE, "");
    return i.push(u), l[u] = c, l;
  }, {}), s = $9(i, t);
  return s.matchedSupportedLocale && s.matchedDesiredLocale && (r = s.matchedSupportedLocale, o = a[s.matchedDesiredLocale].slice(s.matchedDesiredLocale.length) || void 0), r ? {
    locale: r,
    extension: o
  } : { locale: n() };
}
function B9(t, e) {
  var n = e.toLowerCase();
  Uo(t !== void 0, "ukey must be defined");
  var r = n;
  return r;
}
function hm(t) {
  return Intl.getCanonicalLocales(t)[0];
}
function G9(t, e, n) {
  Uo(t.indexOf("-u-") === -1, "Expected locale to not have a Unicode locale extension");
  for (var r = "-u", o = 0, i = e; o < i.length; o++) {
    var a = i[o];
    r += "-".concat(a);
  }
  for (var s = 0, l = n; s < l.length; s++) {
    var c = l[s], u = c.key, d = c.value;
    r += "-".concat(u), d !== "" && (r += "-".concat(d));
  }
  if (r === "-u")
    return hm(t);
  var f = t.indexOf("-x-"), h;
  if (f === -1)
    h = t + r;
  else {
    var _ = t.slice(0, f), E = t.slice(f);
    h = _ + r + E;
  }
  return hm(h);
}
function l4(t, e) {
  for (var n = e; ; ) {
    if (t.indexOf(n) > -1)
      return n;
    var r = n.lastIndexOf("-");
    if (!~r)
      return;
    r >= 2 && n[r - 2] === "-" && (r -= 2), n = n.slice(0, r);
  }
}
function F9(t, e, n) {
  for (var r = { locale: "" }, o = 0, i = e; o < i.length; o++) {
    var a = i[o], s = a.replace(gE, ""), l = l4(t, s);
    if (l)
      return r.locale = l, a !== s && (r.extension = a.slice(s.length, a.length)), r;
  }
  return r.locale = n(), r;
}
function V9(t) {
  Uo(t === t.toLowerCase(), "Expected extension to be lowercase"), Uo(t.slice(0, 3) === "-u-", "Expected extension to be a Unicode locale extension");
  for (var e = [], n = [], r, o = t.length, i = 3; i < o; ) {
    var a = t.indexOf("-", i), s = void 0;
    a === -1 ? s = o - i : s = a - i;
    var l = t.slice(i, i + s);
    Uo(s >= 2, "Expected a subtag to have at least 2 characters"), r === void 0 && s != 2 ? e.indexOf(l) === -1 && e.push(l) : s === 2 ? (r = { key: l, value: "" }, n.find(function(c) {
      return c.key === (r == null ? void 0 : r.key);
    }) === void 0 && n.push(r)) : (r == null ? void 0 : r.value) === "" ? r.value = l : (Uo(r !== void 0, "Expected keyword to be defined"), r.value += "-" + l), i += s + 1;
  }
  return { attributes: e, keywords: n };
}
function IE(t, e, n, r, o, i) {
  var a, s = n.localeMatcher, l;
  s === "lookup" ? l = F9(Array.from(t), e, i) : l = k9(Array.from(t), e, i), l == null && (l = {
    locale: i(),
    extension: ""
  });
  var c = l.locale, u = o[c], d = { locale: "en", dataLocale: c }, f, h;
  l.extension ? (f = V9(l.extension), h = f.keywords) : h = [];
  for (var _ = [], E = function(p) {
    var C = (a = u == null ? void 0 : u[p]) !== null && a !== void 0 ? a : [];
    Uo(Array.isArray(C), "keyLocaleData for ".concat(p, " must be an array"));
    var D = C[0];
    Uo(D === void 0 || typeof D == "string", "value must be a string or undefined");
    var T = void 0, k = h.find(function($) {
      return $.key === p;
    });
    if (k) {
      var G = k.value;
      G !== "" ? C.indexOf(G) > -1 && (D = G, T = {
        key: p,
        value: D
      }) : C.indexOf("true") > -1 && (D = "true", T = {
        key: p,
        value: D
      });
    }
    var b = n[p];
    if (Uo(b == null || typeof b == "string", "optionsValue must be a string or undefined"), typeof b == "string") {
      var P = p.toLowerCase();
      b = B9(P, b), b === "" && (b = "true");
    }
    b !== D && C.indexOf(b) > -1 && (D = b, T = void 0), T && _.push(T), d[p] = D;
  }, m = 0, N = r; m < N.length; m++) {
    var I = N[m];
    E(I);
  }
  var O = [];
  return _.length > 0 && (O = [], c = G9(c, O, _)), d.locale = c, d;
}
function Jh(t, e) {
  for (var n = [], r = 0, o = e; r < o.length; r++) {
    var i = o[r], a = i.replace(gE, ""), s = l4(t, a);
    s && n.push(s);
  }
  return n;
}
function H9(t, e, n, r) {
  return IE(e, P9(t), {
    localeMatcher: (r == null ? void 0 : r.algorithm) || "best fit"
  }, [], {}, function() {
    return n;
  }).locale;
}
const W9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LookupSupportedLocales: Jh,
  ResolveLocale: IE,
  match: H9
}, Symbol.toStringTag, { value: "Module" }));
var _m = /* @__PURE__ */ new Set([
  1,
  2,
  5,
  10,
  20,
  25,
  50,
  100,
  200,
  250,
  500,
  1e3,
  2e3,
  2500,
  5e3
]);
function c4(t, e, n, r, o) {
  var i = Zh(e, "minimumIntegerDigits", 1, 21, 1), a = e.minimumFractionDigits, s = e.maximumFractionDigits, l = e.minimumSignificantDigits, c = e.maximumSignificantDigits;
  t.minimumIntegerDigits = i;
  var u = Zh(e, "roundingIncrement", 1, 5e3, 1);
  St(_m.has(u), "Invalid rounding increment value: ".concat(u, `.
Valid values are `).concat(Array.from(_m).join(", "), "."));
  var d = Nn(e, "roundingMode", "string", [
    "ceil",
    "floor",
    "expand",
    "trunc",
    "halfCeil",
    "halfFloor",
    "halfExpand",
    "halfTrunc",
    "halfEven"
  ], "halfExpand"), f = Nn(e, "roundingPriority", "string", ["auto", "morePrecision", "lessPrecision"], "auto"), h = Nn(e, "trailingZeroDisplay", "string", ["auto", "stripIfInteger"], "auto");
  u !== 1 && (r = n), t.roundingIncrement = u, t.roundingMode = d, t.trailingZeroDisplay = h;
  var _ = l !== void 0 || c !== void 0, E = a !== void 0 || s !== void 0, m = !0, N = !0;
  if (f === "auto" && (m = _, (_ || !E && o === "compact") && (N = !1)), m && (_ ? (t.minimumSignificantDigits = yl(l, 1, 21, 1), t.maximumSignificantDigits = yl(c, t.minimumSignificantDigits, 21, 21)) : (t.minimumSignificantDigits = 1, t.maximumSignificantDigits = 21)), N)
    if (E) {
      if (a = yl(a, 0, 100, void 0), s = yl(s, 0, 100, void 0), a === void 0)
        St(s !== void 0, "maximumFractionDigits must be defined"), a = Math.min(n, s);
      else if (s === void 0)
        s = Math.max(r, a);
      else if (a > s)
        throw new RangeError("Invalid range, ".concat(a, " > ").concat(s));
      t.minimumFractionDigits = a, t.maximumFractionDigits = s;
    } else
      t.minimumFractionDigits = n, t.maximumFractionDigits = r;
  !m && !N ? (t.minimumFractionDigits = 0, t.maximumFractionDigits = 0, t.minimumSignificantDigits = 1, t.maximumSignificantDigits = 2, t.roundingType = "morePrecision", t.roundingPriority = "morePrecision") : f === "morePrecision" ? (t.roundingType = "morePrecision", t.roundingPriority = "morePrecision") : f === "lessPrecision" ? (t.roundingType = "lessPrecision", t.roundingPriority = "lessPrecision") : _ ? (t.roundingType = "significantDigits", t.roundingPriority = "auto") : (t.roundingType = "fractionDigits", t.roundingPriority = "auto"), u !== 1 && (St(t.roundingType === "fractionDigits", "Invalid roundingType", TypeError), St(t.maximumFractionDigits === t.minimumFractionDigits, "With roundingIncrement > 1, maximumFractionDigits and minimumFractionDigits must be equal.", RangeError));
}
function u4(t, e) {
  e === void 0 && (e = /* @__PURE__ */ Object.create(null));
  var n = Nn(e, "style", "string", ["decimal", "percent", "currency", "unit"], "decimal");
  t.style = n;
  var r = Nn(e, "currency", "string", void 0, void 0);
  St(r === void 0 || QA(r), "Malformed currency code", RangeError), St(n !== "currency" || r !== void 0, "currency cannot be undefined", TypeError);
  var o = Nn(e, "currencyDisplay", "string", ["code", "symbol", "narrowSymbol", "name"], "symbol"), i = Nn(e, "currencySign", "string", ["standard", "accounting"], "standard"), a = Nn(e, "unit", "string", void 0, void 0);
  St(a === void 0 || e4(a), "Invalid unit argument for Intl.NumberFormat()", RangeError), St(n !== "unit" || a !== void 0, "unit cannot be undefined", TypeError);
  var s = Nn(e, "unitDisplay", "string", ["short", "narrow", "long"], "short");
  n === "currency" && (t.currency = r.toUpperCase(), t.currencyDisplay = o, t.currencySign = i), n === "unit" && (t.unit = a, t.unitDisplay = s);
}
function Y9(t, e, n, r) {
  var o = r.getInternalSlots, i = r.localeData, a = r.availableLocales, s = r.numberingSystemNames, l = r.getDefaultLocale, c = r.currencyDigitsData, u = AA(e), d = ZA(n), f = /* @__PURE__ */ Object.create(null), h = Nn(d, "localeMatcher", "string", ["lookup", "best fit"], "best fit");
  f.localeMatcher = h;
  var _ = Nn(d, "numberingSystem", "string", void 0, void 0);
  if (_ !== void 0 && s.indexOf(_) < 0)
    throw RangeError("Invalid numberingSystems: ".concat(_));
  f.nu = _;
  var E = IE(
    Array.from(a),
    u,
    f,
    // [[RelevantExtensionKeys]] slot, which is a constant
    ["nu"],
    i,
    l
  ), m = i[E.dataLocale];
  St(!!m, "Missing locale data for ".concat(E.dataLocale));
  var N = o(t);
  N.locale = E.locale, N.dataLocale = E.dataLocale, N.numberingSystem = E.nu, N.dataLocaleData = m, u4(N, d);
  var I = N.style, O = Nn(d, "notation", "string", ["standard", "scientific", "engineering", "compact"], "standard");
  N.notation = O;
  var p, C;
  if (I === "currency" && O === "standard") {
    var D = N.currency, T = o4(D, { currencyDigitsData: c });
    p = T, C = T;
  } else
    p = 0, C = I === "percent" ? 0 : 3;
  c4(N, d, p, C, O);
  var k = Nn(d, "compactDisplay", "string", ["short", "long"], "short"), G = "auto";
  O === "compact" && (N.compactDisplay = k, G = "min2");
  var b = qA(d, "useGrouping", ["min2", "auto", "always"], "always", !1, G);
  N.useGrouping = b;
  var P = Nn(d, "signDisplay", "string", ["auto", "never", "always", "exceptZero", "negative"], "auto");
  return N.signDisplay = P, t;
}
function K9(t) {
  for (var e = [], n = t.indexOf("{"), r = 0, o = 0, i = t.length; n < t.length && n > -1; )
    r = t.indexOf("}", n), St(r > n, "Invalid pattern ".concat(t)), n > o && e.push({
      type: "literal",
      value: t.substring(o, n)
    }), e.push({
      type: t.substring(n + 1, r),
      value: void 0
    }), o = r + 1, n = t.indexOf("{", o);
  return o < i && e.push({
    type: "literal",
    value: t.substring(o, i)
  }), e;
}
function z9(t, e, n) {
  var r = "best fit";
  return n !== void 0 && (n = cE(n), r = Nn(n, "localeMatcher", "string", ["lookup", "best fit"], "best fit")), Jh(Array.from(t), e);
}
(function(t) {
  rE(e, t);
  function e() {
    var n = t !== null && t.apply(this, arguments) || this;
    return n.type = "MISSING_LOCALE_DATA", n;
  }
  return e;
})(Error);
function Z9(t) {
  return t.type === "MISSING_LOCALE_DATA";
}
var Qh;
(function(t) {
  t.startRange = "startRange", t.shared = "shared", t.endRange = "endRange";
})(Qh || (Qh = {}));
function q9(t) {
  var e = EE(t, "number");
  if (typeof e == "bigint")
    return new lt(e);
  if (e === void 0)
    return new lt(NaN);
  if (e === !0)
    return new lt(1);
  if (e === !1)
    return new lt(0);
  if (e === null)
    return new lt(0);
  try {
    return new lt(e);
  } catch {
    return new lt(NaN);
  }
}
const X9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ApplyUnsignedRoundingMode: pE,
  ArrayCreate: BA,
  CanonicalizeLocaleList: AA,
  CanonicalizeTimeZoneName: GT,
  CoerceOptionsToObject: ZA,
  CollapseNumberRange: t4,
  ComputeExponent: r4,
  ComputeExponentForMagnitude: qh,
  CurrencyDigits: o4,
  DateFromTime: o9,
  Day: uE,
  DayFromYear: FA,
  DayWithinYear: fE,
  DaysInYear: VA,
  FormatApproximately: s4,
  FormatNumeric: jh,
  FormatNumericRange: b9,
  FormatNumericRangeToParts: R9,
  FormatNumericToParts: M9,
  FormatNumericToString: NE,
  GetNumberOption: Zh,
  GetOption: Nn,
  GetOptionsObject: h9,
  GetStringOrBooleanOption: qA,
  GetUnsignedRoundingMode: mE,
  HasOwnProperty: GA,
  HourFromTime: s9,
  InLeapYear: hE,
  InitializeNumberFormat: Y9,
  IsSanctionedSimpleUnitIdentifier: ed,
  IsValidTimeZoneName: _9,
  IsWellFormedCurrencyCode: QA,
  IsWellFormedUnitIdentifier: e4,
  MinFromTime: l9,
  MonthFromTime: HA,
  OrdinaryHasInstance: u9,
  PartitionNumberPattern: _c,
  PartitionNumberRangePattern: vE,
  PartitionPattern: K9,
  get RangePatternType() {
    return Qh;
  },
  SANCTIONED_UNITS: XA,
  SIMPLE_UNITS: JA,
  SameValue: e9,
  SecFromTime: c9,
  SetNumberFormatDigitOptions: c4,
  SetNumberFormatUnitOptions: u4,
  SupportedLocales: z9,
  TimeClip: Qb,
  TimeFromYear: r9,
  ToIntlMathematicalValue: q9,
  ToNumber: lE,
  ToObject: cE,
  ToPrimitive: EE,
  ToRawFixed: Id,
  ToRawPrecision: Xh,
  ToString: sE,
  Type: t9,
  WeekDay: n9,
  YearFromTime: dE,
  ZERO: jc,
  _formatToParts: a4,
  createDataProperty: Kb,
  createMemoizedDateTimeFormat: Zb,
  createMemoizedListFormat: jb,
  createMemoizedLocale: Xb,
  createMemoizedNumberFormat: zb,
  createMemoizedPluralRules: qb,
  defineProperty: Yb,
  getInternalSlot: Hb,
  getMultiInternalSlots: kA,
  invariant: St,
  isLiteralPart: Wb,
  isMissingLocaleDataError: Z9,
  msFromTime: d9,
  removeUnitNamespace: jA,
  setInternalSlot: $A,
  setMultiInternalSlots: Vb
}, Symbol.toStringTag, { value: "Module" })), d4 = /* @__PURE__ */ tE(X9);
var Of = {};
Object.defineProperty(Of, "__esModule", { value: !0 });
Of.currencyDigitsData = void 0;
Of.currencyDigitsData = {
  ADP: 0,
  AFN: 0,
  ALL: 0,
  AMD: 2,
  BHD: 3,
  BIF: 0,
  BYN: 2,
  BYR: 0,
  CAD: 2,
  CHF: 2,
  CLF: 4,
  CLP: 0,
  COP: 2,
  CRC: 2,
  CZK: 2,
  DEFAULT: 2,
  DJF: 0,
  DKK: 2,
  ESP: 0,
  GNF: 0,
  GYD: 2,
  HUF: 2,
  IDR: 2,
  IQD: 0,
  IRR: 0,
  ISK: 0,
  ITL: 0,
  JOD: 3,
  JPY: 0,
  KMF: 0,
  KPW: 0,
  KRW: 0,
  KWD: 3,
  LAK: 0,
  LBP: 0,
  LUF: 0,
  LYD: 3,
  MGA: 0,
  MGF: 0,
  MMK: 0,
  MNT: 2,
  MRO: 0,
  MUR: 2,
  NOK: 2,
  OMR: 3,
  PKR: 2,
  PYG: 0,
  RSD: 0,
  RWF: 0,
  SEK: 2,
  SLE: 2,
  SLL: 0,
  SOS: 0,
  STD: 0,
  SYP: 0,
  TMM: 0,
  TND: 3,
  TRL: 0,
  TWD: 2,
  TZS: 2,
  UGX: 0,
  UYI: 0,
  UYW: 4,
  UZS: 2,
  VEF: 2,
  VND: 0,
  VUV: 0,
  XAF: 0,
  XOF: 0,
  XPF: 0,
  YER: 0,
  ZMK: 0,
  ZWD: 0
};
var Af = {};
Object.defineProperty(Af, "__esModule", { value: !0 });
Af.numberingSystemNames = void 0;
Af.numberingSystemNames = ["adlm", "ahom", "arab", "arabext", "armn", "armnlow", "bali", "beng", "bhks", "brah", "cakm", "cham", "cyrl", "deva", "diak", "ethi", "fullwide", "gara", "geor", "gong", "gonm", "grek", "greklow", "gujr", "gukh", "guru", "hanidays", "hanidec", "hans", "hansfin", "hant", "hantfin", "hebr", "hmng", "hmnp", "java", "jpan", "jpanfin", "jpanyear", "kali", "kawi", "khmr", "knda", "krai", "lana", "lanatham", "laoo", "latn", "lepc", "limb", "mathbold", "mathdbl", "mathmono", "mathsanb", "mathsans", "mlym", "modi", "mong", "mroo", "mtei", "mymr", "mymrepka", "mymrpao", "mymrshan", "mymrtlng", "nagm", "newa", "nkoo", "olck", "onao", "orya", "osma", "outlined", "rohg", "roman", "romanlow", "saur", "segment", "shrd", "sind", "sinh", "sora", "sund", "sunu", "takr", "talu", "taml", "tamldec", "telu", "thai", "tibt", "tirh", "tnsa", "vaii", "wara", "wcho"];
var Su = {}, Em;
function j9() {
  if (Em)
    return Su;
  Em = 1, Object.defineProperty(Su, "__esModule", { value: !0 }), Su.default = e;
  var t = /* @__PURE__ */ new WeakMap();
  function e(n) {
    var r = t.get(n);
    return r || (r = /* @__PURE__ */ Object.create(null), t.set(n, r)), r;
  }
  return Su;
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.NumberFormat = void 0;
  var e = BT, n = d4, r = Of, o = Af, i = e.__importDefault(j9()), a = [
    "locale",
    "numberingSystem",
    "style",
    "currency",
    "currencyDisplay",
    "currencySign",
    "unit",
    "unitDisplay",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    "useGrouping",
    "notation",
    "compactDisplay",
    "signDisplay"
  ];
  t.NumberFormat = function(d, f) {
    if (!this || !(0, n.OrdinaryHasInstance)(t.NumberFormat, this))
      return new t.NumberFormat(d, f);
    (0, n.InitializeNumberFormat)(this, d, f, {
      getInternalSlots: i.default,
      localeData: t.NumberFormat.localeData,
      availableLocales: t.NumberFormat.availableLocales,
      getDefaultLocale: t.NumberFormat.getDefaultLocale,
      currencyDigitsData: r.currencyDigitsData,
      numberingSystemNames: o.numberingSystemNames
    });
    var h = (0, i.default)(this), _ = h.dataLocale, E = t.NumberFormat.localeData[_];
    return (0, n.invariant)(E !== void 0, "Cannot load locale-dependent data for ".concat(_, ".")), h.pl = (0, n.createMemoizedPluralRules)(_, {
      minimumFractionDigits: h.minimumFractionDigits,
      maximumFractionDigits: h.maximumFractionDigits,
      minimumIntegerDigits: h.minimumIntegerDigits,
      minimumSignificantDigits: h.minimumSignificantDigits,
      maximumSignificantDigits: h.maximumSignificantDigits
    }), this;
  };
  function s(d) {
    return (0, n.FormatNumericToParts)(this, (0, n.ToIntlMathematicalValue)(d), {
      getInternalSlots: i.default
    });
  }
  function l(d, f) {
    return (0, n.FormatNumericRange)(this, (0, n.ToIntlMathematicalValue)(d), (0, n.ToIntlMathematicalValue)(f), {
      getInternalSlots: i.default
    });
  }
  function c(d, f) {
    return (0, n.FormatNumericRangeToParts)(this, (0, n.ToIntlMathematicalValue)(d), (0, n.ToIntlMathematicalValue)(f), {
      getInternalSlots: i.default
    });
  }
  try {
    Object.defineProperty(s, "name", {
      value: "formatToParts",
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  } catch {
  }
  (0, n.defineProperty)(t.NumberFormat.prototype, "formatToParts", {
    value: s
  }), (0, n.defineProperty)(t.NumberFormat.prototype, "formatRange", {
    value: l
  }), (0, n.defineProperty)(t.NumberFormat.prototype, "formatRangeToParts", {
    value: c
  }), (0, n.defineProperty)(t.NumberFormat.prototype, "resolvedOptions", {
    value: function() {
      if (typeof this != "object" || !(0, n.OrdinaryHasInstance)(t.NumberFormat, this))
        throw TypeError("Method Intl.NumberFormat.prototype.resolvedOptions called on incompatible receiver");
      for (var f = (0, i.default)(this), h = {}, _ = 0, E = a; _ < E.length; _++) {
        var m = E[_], N = f[m];
        N !== void 0 && (h[m] = N);
      }
      return f.roundingType === "morePrecision" ? h.roundingPriority = "morePrecision" : f.roundingType === "lessPrecision" ? h.roundingPriority = "lessPrecision" : h.roundingPriority = "auto", h;
    }
  });
  var u = {
    enumerable: !1,
    configurable: !0,
    get: function() {
      if (typeof this != "object" || !(0, n.OrdinaryHasInstance)(t.NumberFormat, this))
        throw TypeError("Intl.NumberFormat format property accessor called on incompatible receiver");
      var d = (0, i.default)(this), f = d.boundFormat;
      if (f === void 0) {
        f = function(h) {
          return (0, n.FormatNumeric)(d, (0, n.ToIntlMathematicalValue)(h));
        };
        try {
          Object.defineProperty(f, "name", {
            configurable: !0,
            enumerable: !1,
            writable: !1,
            value: ""
          });
        } catch {
        }
        d.boundFormat = f;
      }
      return f;
    }
  };
  try {
    Object.defineProperty(u.get, "name", {
      configurable: !0,
      enumerable: !1,
      writable: !1,
      value: "get format"
    });
  } catch {
  }
  Object.defineProperty(t.NumberFormat.prototype, "format", u), (0, n.defineProperty)(t.NumberFormat, "supportedLocalesOf", {
    value: function(f, h) {
      return (0, n.SupportedLocales)(t.NumberFormat.availableLocales, (0, n.CanonicalizeLocaleList)(f), h);
    }
  }), t.NumberFormat.__addLocaleData = function() {
    for (var f = [], h = 0; h < arguments.length; h++)
      f[h] = arguments[h];
    for (var _ = 0, E = f; _ < E.length; _++) {
      var m = E[_], N = m.data, I = m.locale, O = new Intl.Locale(I).minimize().toString();
      t.NumberFormat.localeData[I] = t.NumberFormat.localeData[O] = N, t.NumberFormat.availableLocales.add(O), t.NumberFormat.availableLocales.add(I), t.NumberFormat.__defaultLocale || (t.NumberFormat.__defaultLocale = O);
    }
  }, t.NumberFormat.__addUnitData = function(f, h) {
    var _ = t.NumberFormat.localeData, E = f, m = _[E];
    if (!m)
      throw new Error('Locale data for "'.concat(f, `" has not been loaded in NumberFormat. 
Please __addLocaleData before adding additional unit data`));
    for (var N in h.simple)
      m.units.simple[N] = h.simple[N];
    for (var N in h.compound)
      m.units.compound[N] = h.compound[N];
  }, t.NumberFormat.__defaultLocale = "", t.NumberFormat.localeData = {}, t.NumberFormat.availableLocales = /* @__PURE__ */ new Set(), t.NumberFormat.getDefaultLocale = function() {
    return t.NumberFormat.__defaultLocale;
  }, t.NumberFormat.polyfilled = !0;
  try {
    typeof Symbol < "u" && Object.defineProperty(t.NumberFormat.prototype, Symbol.toStringTag, {
      configurable: !0,
      enumerable: !1,
      writable: !1,
      value: "Intl.NumberFormat"
    }), Object.defineProperty(t.NumberFormat.prototype.constructor, "length", {
      configurable: !0,
      enumerable: !1,
      writable: !1,
      value: 0
    }), Object.defineProperty(t.NumberFormat.supportedLocalesOf, "length", {
      configurable: !0,
      enumerable: !1,
      writable: !1,
      value: 1
    }), Object.defineProperty(t.NumberFormat, "prototype", {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: t.NumberFormat.prototype
    });
  } catch {
  }
})(nE);
var OE = {};
Object.defineProperty(OE, "__esModule", { value: !0 });
OE.toLocaleString = Q9;
var J9 = nE;
function Q9(t, e, n) {
  var r = new J9.NumberFormat(e, n);
  return r.format(t);
}
var AE = {};
const eR = /* @__PURE__ */ tE(W9);
var Df = {};
Object.defineProperty(Df, "__esModule", { value: !0 });
Df.supportedLocales = void 0;
Df.supportedLocales = ["af", "af-NA", "agq", "ak", "am", "ar", "ar-AE", "ar-BH", "ar-DJ", "ar-DZ", "ar-EG", "ar-EH", "ar-ER", "ar-IL", "ar-IQ", "ar-JO", "ar-KM", "ar-KW", "ar-LB", "ar-LY", "ar-MA", "ar-MR", "ar-OM", "ar-PS", "ar-QA", "ar-SA", "ar-SD", "ar-SO", "ar-SS", "ar-SY", "ar-TD", "ar-TN", "ar-YE", "as", "asa", "ast", "az", "az-Cyrl", "az-Latn", "bas", "be", "be-tarask", "bem", "bez", "bg", "bm", "bn", "bn-IN", "bo", "bo-IN", "br", "brx", "bs", "bs-Cyrl", "bs-Latn", "ca", "ca-AD", "ca-ES-valencia", "ca-FR", "ca-IT", "ccp", "ccp-IN", "ce", "ceb", "cgg", "chr", "ckb", "ckb-IR", "cs", "cy", "da", "da-GL", "dav", "de", "de-AT", "de-BE", "de-CH", "de-IT", "de-LI", "de-LU", "dje", "doi", "dsb", "dua", "dyo", "dz", "ebu", "ee", "ee-TG", "el", "el-CY", "en", "en-001", "en-150", "en-AE", "en-AG", "en-AI", "en-AS", "en-AT", "en-AU", "en-BB", "en-BE", "en-BI", "en-BM", "en-BS", "en-BW", "en-BZ", "en-CA", "en-CC", "en-CH", "en-CK", "en-CM", "en-CX", "en-CY", "en-DE", "en-DG", "en-DK", "en-DM", "en-ER", "en-FI", "en-FJ", "en-FK", "en-FM", "en-GB", "en-GD", "en-GG", "en-GH", "en-GI", "en-GM", "en-GU", "en-GY", "en-HK", "en-IE", "en-IL", "en-IM", "en-IN", "en-IO", "en-JE", "en-JM", "en-KE", "en-KI", "en-KN", "en-KY", "en-LC", "en-LR", "en-LS", "en-MG", "en-MH", "en-MO", "en-MP", "en-MS", "en-MT", "en-MU", "en-MW", "en-MY", "en-NA", "en-NF", "en-NG", "en-NL", "en-NR", "en-NU", "en-NZ", "en-PG", "en-PH", "en-PK", "en-PN", "en-PR", "en-PW", "en-RW", "en-SB", "en-SC", "en-SD", "en-SE", "en-SG", "en-SH", "en-SI", "en-SL", "en-SS", "en-SX", "en-SZ", "en-TC", "en-TK", "en-TO", "en-TT", "en-TV", "en-TZ", "en-UG", "en-UM", "en-VC", "en-VG", "en-VI", "en-VU", "en-WS", "en-ZA", "en-ZM", "en-ZW", "eo", "es", "es-419", "es-AR", "es-BO", "es-BR", "es-BZ", "es-CL", "es-CO", "es-CR", "es-CU", "es-DO", "es-EA", "es-EC", "es-GQ", "es-GT", "es-HN", "es-IC", "es-MX", "es-NI", "es-PA", "es-PE", "es-PH", "es-PR", "es-PY", "es-SV", "es-US", "es-UY", "es-VE", "et", "eu", "ewo", "fa", "fa-AF", "ff", "ff-Adlm", "ff-Adlm-BF", "ff-Adlm-CM", "ff-Adlm-GH", "ff-Adlm-GM", "ff-Adlm-GW", "ff-Adlm-LR", "ff-Adlm-MR", "ff-Adlm-NE", "ff-Adlm-NG", "ff-Adlm-SL", "ff-Adlm-SN", "ff-Latn", "ff-Latn-BF", "ff-Latn-CM", "ff-Latn-GH", "ff-Latn-GM", "ff-Latn-GN", "ff-Latn-GW", "ff-Latn-LR", "ff-Latn-MR", "ff-Latn-NE", "ff-Latn-NG", "ff-Latn-SL", "fi", "fil", "fo", "fo-DK", "fr", "fr-BE", "fr-BF", "fr-BI", "fr-BJ", "fr-BL", "fr-CA", "fr-CD", "fr-CF", "fr-CG", "fr-CH", "fr-CI", "fr-CM", "fr-DJ", "fr-DZ", "fr-GA", "fr-GF", "fr-GN", "fr-GP", "fr-GQ", "fr-HT", "fr-KM", "fr-LU", "fr-MA", "fr-MC", "fr-MF", "fr-MG", "fr-ML", "fr-MQ", "fr-MR", "fr-MU", "fr-NC", "fr-NE", "fr-PF", "fr-PM", "fr-RE", "fr-RW", "fr-SC", "fr-SN", "fr-SY", "fr-TD", "fr-TG", "fr-TN", "fr-VU", "fr-WF", "fr-YT", "fur", "fy", "ga", "ga-GB", "gd", "gl", "gsw", "gsw-FR", "gsw-LI", "gu", "guz", "gv", "ha", "ha-GH", "ha-NE", "haw", "he", "hi", "hr", "hr-BA", "hsb", "hu", "hy", "ia", "id", "ig", "ii", "is", "it", "it-CH", "it-SM", "it-VA", "ja", "jgo", "jmc", "jv", "ka", "kab", "kam", "kde", "kea", "kgp", "khq", "ki", "kk", "kkj", "kl", "kln", "km", "kn", "ko", "ko-KP", "kok", "ks", "ks-Arab", "ksb", "ksf", "ksh", "ku", "kw", "ky", "lag", "lb", "lg", "lkt", "ln", "ln-AO", "ln-CF", "ln-CG", "lo", "lrc", "lrc-IQ", "lt", "lu", "luo", "luy", "lv", "mai", "mas", "mas-TZ", "mer", "mfe", "mg", "mgh", "mgo", "mi", "mk", "ml", "mn", "mni", "mni-Beng", "mr", "ms", "ms-BN", "ms-ID", "ms-SG", "mt", "mua", "my", "mzn", "naq", "nb", "nb-SJ", "nd", "nds", "nds-NL", "ne", "ne-IN", "nl", "nl-AW", "nl-BE", "nl-BQ", "nl-CW", "nl-SR", "nl-SX", "nmg", "nn", "nnh", "no", "nus", "nyn", "om", "om-KE", "or", "os", "os-RU", "pa", "pa-Arab", "pa-Guru", "pcm", "pl", "ps", "ps-PK", "pt", "pt-AO", "pt-CH", "pt-CV", "pt-GQ", "pt-GW", "pt-LU", "pt-MO", "pt-MZ", "pt-PT", "pt-ST", "pt-TL", "qu", "qu-BO", "qu-EC", "rm", "rn", "ro", "ro-MD", "rof", "ru", "ru-BY", "ru-KG", "ru-KZ", "ru-MD", "ru-UA", "rw", "rwk", "sa", "sah", "saq", "sat", "sat-Olck", "sbp", "sc", "sd", "sd-Arab", "sd-Deva", "se", "se-FI", "se-SE", "seh", "ses", "sg", "shi", "shi-Latn", "shi-Tfng", "si", "sk", "sl", "smn", "sn", "so", "so-DJ", "so-ET", "so-KE", "sq", "sq-MK", "sq-XK", "sr", "sr-Cyrl", "sr-Cyrl-BA", "sr-Cyrl-ME", "sr-Cyrl-XK", "sr-Latn", "sr-Latn-BA", "sr-Latn-ME", "sr-Latn-XK", "su", "su-Latn", "sv", "sv-AX", "sv-FI", "sw", "sw-CD", "sw-KE", "sw-UG", "ta", "ta-LK", "ta-MY", "ta-SG", "te", "teo", "teo-KE", "tg", "th", "ti", "ti-ER", "tk", "to", "tr", "tr-CY", "tt", "twq", "tzm", "ug", "uk", "und", "ur", "ur-IN", "uz", "uz-Arab", "uz-Cyrl", "uz-Latn", "vai", "vai-Latn", "vai-Vaii", "vi", "vun", "wae", "wo", "xh", "xog", "yav", "yi", "yo", "yo-BJ", "yrl", "yrl-CO", "yrl-VE", "yue", "yue-Hans", "yue-Hant", "zgh", "zh", "zh-Hans", "zh-Hans-HK", "zh-Hans-MO", "zh-Hans-SG", "zh-Hant", "zh-Hant-HK", "zh-Hant-MO", "zu"];
Object.defineProperty(AE, "__esModule", { value: !0 });
AE.shouldPolyfill = sR;
var tR = eR, nR = Df;
function rR() {
  return !Intl.NumberFormat.polyfilled && !Intl.NumberFormat.supportedLocalesOf(["es"]).length;
}
function oR() {
  try {
    var t = new Intl.NumberFormat("en", {
      style: "unit",
      unit: "bit",
      unitDisplay: "long",
      notation: "scientific"
    }).format(1e4);
    if (t !== "1E4 bits")
      return !1;
  } catch {
    return !1;
  }
  return !0;
}
function iR() {
  try {
    var t = new Intl.NumberFormat("en", {
      notation: "compact",
      minimumSignificantDigits: 3,
      maximumSignificantDigits: 3,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      // @ts-ignore TS types are old
      roundingPriority: "morePrecision"
    }).format(1e8);
    return t === "100.00M";
  } catch {
    return !1;
  }
}
function aR(t) {
  if (!t)
    return !0;
  var e = Array.isArray(t) ? t : [t];
  return Intl.NumberFormat.supportedLocalesOf(e).length === e.length;
}
function sR(t) {
  if (t === void 0 && (t = "en"), typeof Intl > "u" || !("NumberFormat" in Intl) || !oR() || !iR() || rR() || !aR(t))
    return t ? (0, tR.match)([t], nR.supportedLocales, "en") : void 0;
}
var lR = nE, cR = OE, pm = d4, uR = AE;
(0, uR.shouldPolyfill)() && ((0, pm.defineProperty)(Intl, "NumberFormat", { value: lR.NumberFormat }), (0, pm.defineProperty)(Number.prototype, "toLocaleString", {
  value: function(e, n) {
    return (0, cR.toLocaleString)(this, e, n);
  }
}));
Intl.NumberFormat && typeof Intl.NumberFormat.__addLocaleData == "function" && Intl.NumberFormat.__addLocaleData({
  data: {
    currencies: {
      ADP: {
        displayName: {
          one: "Andorran peseta",
          other: "Andorran pesetas"
        },
        narrow: "ADP",
        symbol: "ADP"
      },
      AED: {
        displayName: {
          one: "UAE dirham",
          other: "UAE dirhams"
        },
        narrow: "AED",
        symbol: "AED"
      },
      AFA: {
        displayName: {
          one: "Afghan afghani (1927–2002)",
          other: "Afghan afghanis (1927–2002)"
        },
        narrow: "AFA",
        symbol: "AFA"
      },
      AFN: {
        displayName: {
          one: "Afghan Afghani",
          other: "Afghan Afghanis"
        },
        narrow: "؋",
        symbol: "AFN"
      },
      ALK: {
        displayName: {
          one: "Albanian lek (1946–1965)",
          other: "Albanian lekë (1946–1965)"
        },
        narrow: "ALK",
        symbol: "ALK"
      },
      ALL: {
        displayName: {
          one: "Albanian lek",
          other: "Albanian lekë"
        },
        narrow: "ALL",
        symbol: "ALL"
      },
      AMD: {
        displayName: {
          one: "Armenian dram",
          other: "Armenian drams"
        },
        narrow: "֏",
        symbol: "AMD"
      },
      ANG: {
        displayName: {
          one: "Netherlands Antillean guilder",
          other: "Netherlands Antillean guilders"
        },
        narrow: "ANG",
        symbol: "ANG"
      },
      AOA: {
        displayName: {
          one: "Angolan kwanza",
          other: "Angolan kwanzas"
        },
        narrow: "Kz",
        symbol: "AOA"
      },
      AOK: {
        displayName: {
          one: "Angolan kwanza (1977–1991)",
          other: "Angolan kwanzas (1977–1991)"
        },
        narrow: "AOK",
        symbol: "AOK"
      },
      AON: {
        displayName: {
          one: "Angolan new kwanza (1990–2000)",
          other: "Angolan new kwanzas (1990–2000)"
        },
        narrow: "AON",
        symbol: "AON"
      },
      AOR: {
        displayName: {
          one: "Angolan readjusted kwanza (1995–1999)",
          other: "Angolan readjusted kwanzas (1995–1999)"
        },
        narrow: "AOR",
        symbol: "AOR"
      },
      ARA: {
        displayName: {
          one: "Argentine austral",
          other: "Argentine australs"
        },
        narrow: "ARA",
        symbol: "ARA"
      },
      ARL: {
        displayName: {
          one: "Argentine peso ley (1970–1983)",
          other: "Argentine pesos ley (1970–1983)"
        },
        narrow: "ARL",
        symbol: "ARL"
      },
      ARM: {
        displayName: {
          one: "Argentine peso (1881–1970)",
          other: "Argentine pesos (1881–1970)"
        },
        narrow: "ARM",
        symbol: "ARM"
      },
      ARP: {
        displayName: {
          one: "Argentine peso (1983–1985)",
          other: "Argentine pesos (1983–1985)"
        },
        narrow: "ARP",
        symbol: "ARP"
      },
      ARS: {
        displayName: {
          one: "Argentine peso",
          other: "Argentine pesos"
        },
        narrow: "$",
        symbol: "ARS"
      },
      ATS: {
        displayName: {
          one: "Austrian schilling",
          other: "Austrian schillings"
        },
        narrow: "ATS",
        symbol: "ATS"
      },
      AUD: {
        displayName: {
          one: "Australian dollar",
          other: "Australian dollars"
        },
        narrow: "$",
        symbol: "A$"
      },
      AWG: {
        displayName: {
          other: "Aruban florin"
        },
        narrow: "AWG",
        symbol: "AWG"
      },
      AZM: {
        displayName: {
          one: "Azerbaijani manat (1993–2006)",
          other: "Azerbaijani manats (1993–2006)"
        },
        narrow: "AZM",
        symbol: "AZM"
      },
      AZN: {
        displayName: {
          one: "Azerbaijani manat",
          other: "Azerbaijani manats"
        },
        narrow: "₼",
        symbol: "AZN"
      },
      BAD: {
        displayName: {
          one: "Bosnia-Herzegovina dinar (1992–1994)",
          other: "Bosnia-Herzegovina dinars (1992–1994)"
        },
        narrow: "BAD",
        symbol: "BAD"
      },
      BAM: {
        displayName: {
          one: "Bosnia-Herzegovina convertible mark",
          other: "Bosnia-Herzegovina convertible marks"
        },
        narrow: "KM",
        symbol: "BAM"
      },
      BAN: {
        displayName: {
          one: "Bosnia-Herzegovina new dinar (1994–1997)",
          other: "Bosnia-Herzegovina new dinars (1994–1997)"
        },
        narrow: "BAN",
        symbol: "BAN"
      },
      BBD: {
        displayName: {
          one: "Barbadian dollar",
          other: "Barbadian dollars"
        },
        narrow: "$",
        symbol: "BBD"
      },
      BDT: {
        displayName: {
          one: "Bangladeshi taka",
          other: "Bangladeshi takas"
        },
        narrow: "৳",
        symbol: "BDT"
      },
      BEC: {
        displayName: {
          one: "Belgian franc (convertible)",
          other: "Belgian francs (convertible)"
        },
        narrow: "BEC",
        symbol: "BEC"
      },
      BEF: {
        displayName: {
          one: "Belgian franc",
          other: "Belgian francs"
        },
        narrow: "BEF",
        symbol: "BEF"
      },
      BEL: {
        displayName: {
          one: "Belgian franc (financial)",
          other: "Belgian francs (financial)"
        },
        narrow: "BEL",
        symbol: "BEL"
      },
      BGL: {
        displayName: {
          one: "Bulgarian hard lev",
          other: "Bulgarian hard leva"
        },
        narrow: "BGL",
        symbol: "BGL"
      },
      BGM: {
        displayName: {
          one: "Bulgarian socialist lev",
          other: "Bulgarian socialist leva"
        },
        narrow: "BGM",
        symbol: "BGM"
      },
      BGN: {
        displayName: {
          one: "Bulgarian lev",
          other: "Bulgarian leva"
        },
        narrow: "BGN",
        symbol: "BGN"
      },
      BGO: {
        displayName: {
          one: "Bulgarian lev (1879–1952)",
          other: "Bulgarian leva (1879–1952)"
        },
        narrow: "BGO",
        symbol: "BGO"
      },
      BHD: {
        displayName: {
          one: "Bahraini dinar",
          other: "Bahraini dinars"
        },
        narrow: "BHD",
        symbol: "BHD"
      },
      BIF: {
        displayName: {
          one: "Burundian franc",
          other: "Burundian francs"
        },
        narrow: "BIF",
        symbol: "BIF"
      },
      BMD: {
        displayName: {
          one: "Bermudan dollar",
          other: "Bermudan dollars"
        },
        narrow: "$",
        symbol: "BMD"
      },
      BND: {
        displayName: {
          one: "Brunei dollar",
          other: "Brunei dollars"
        },
        narrow: "$",
        symbol: "BND"
      },
      BOB: {
        displayName: {
          one: "Bolivian boliviano",
          other: "Bolivian bolivianos"
        },
        narrow: "Bs",
        symbol: "BOB"
      },
      BOL: {
        displayName: {
          one: "Bolivian boliviano (1863–1963)",
          other: "Bolivian bolivianos (1863–1963)"
        },
        narrow: "BOL",
        symbol: "BOL"
      },
      BOP: {
        displayName: {
          one: "Bolivian peso",
          other: "Bolivian pesos"
        },
        narrow: "BOP",
        symbol: "BOP"
      },
      BOV: {
        displayName: {
          one: "Bolivian mvdol",
          other: "Bolivian mvdols"
        },
        narrow: "BOV",
        symbol: "BOV"
      },
      BRB: {
        displayName: {
          one: "Brazilian new cruzeiro (1967–1986)",
          other: "Brazilian new cruzeiros (1967–1986)"
        },
        narrow: "BRB",
        symbol: "BRB"
      },
      BRC: {
        displayName: {
          one: "Brazilian cruzado (1986–1989)",
          other: "Brazilian cruzados (1986–1989)"
        },
        narrow: "BRC",
        symbol: "BRC"
      },
      BRE: {
        displayName: {
          one: "Brazilian cruzeiro (1990–1993)",
          other: "Brazilian cruzeiros (1990–1993)"
        },
        narrow: "BRE",
        symbol: "BRE"
      },
      BRL: {
        displayName: {
          one: "Brazilian real",
          other: "Brazilian reals"
        },
        narrow: "R$",
        symbol: "R$"
      },
      BRN: {
        displayName: {
          one: "Brazilian new cruzado (1989–1990)",
          other: "Brazilian new cruzados (1989–1990)"
        },
        narrow: "BRN",
        symbol: "BRN"
      },
      BRR: {
        displayName: {
          one: "Brazilian cruzeiro (1993–1994)",
          other: "Brazilian cruzeiros (1993–1994)"
        },
        narrow: "BRR",
        symbol: "BRR"
      },
      BRZ: {
        displayName: {
          one: "Brazilian cruzeiro (1942–1967)",
          other: "Brazilian cruzeiros (1942–1967)"
        },
        narrow: "BRZ",
        symbol: "BRZ"
      },
      BSD: {
        displayName: {
          one: "Bahamian dollar",
          other: "Bahamian dollars"
        },
        narrow: "$",
        symbol: "BSD"
      },
      BTN: {
        displayName: {
          one: "Bhutanese ngultrum",
          other: "Bhutanese ngultrums"
        },
        narrow: "BTN",
        symbol: "BTN"
      },
      BUK: {
        displayName: {
          one: "Burmese kyat",
          other: "Burmese kyats"
        },
        narrow: "BUK",
        symbol: "BUK"
      },
      BWP: {
        displayName: {
          one: "Botswanan pula",
          other: "Botswanan pulas"
        },
        narrow: "P",
        symbol: "BWP"
      },
      BYB: {
        displayName: {
          one: "Belarusian ruble (1994–1999)",
          other: "Belarusian rubles (1994–1999)"
        },
        narrow: "BYB",
        symbol: "BYB"
      },
      BYN: {
        displayName: {
          one: "Belarusian ruble",
          other: "Belarusian rubles"
        },
        narrow: "BYN",
        symbol: "BYN"
      },
      BYR: {
        displayName: {
          one: "Belarusian ruble (2000–2016)",
          other: "Belarusian rubles (2000–2016)"
        },
        narrow: "BYR",
        symbol: "BYR"
      },
      BZD: {
        displayName: {
          one: "Belize dollar",
          other: "Belize dollars"
        },
        narrow: "$",
        symbol: "BZD"
      },
      CAD: {
        displayName: {
          one: "Canadian dollar",
          other: "Canadian dollars"
        },
        narrow: "$",
        symbol: "CA$"
      },
      CDF: {
        displayName: {
          one: "Congolese franc",
          other: "Congolese francs"
        },
        narrow: "CDF",
        symbol: "CDF"
      },
      CHE: {
        displayName: {
          one: "WIR euro",
          other: "WIR euros"
        },
        narrow: "CHE",
        symbol: "CHE"
      },
      CHF: {
        displayName: {
          one: "Swiss franc",
          other: "Swiss francs"
        },
        narrow: "CHF",
        symbol: "CHF"
      },
      CHW: {
        displayName: {
          one: "WIR franc",
          other: "WIR francs"
        },
        narrow: "CHW",
        symbol: "CHW"
      },
      CLE: {
        displayName: {
          one: "Chilean escudo",
          other: "Chilean escudos"
        },
        narrow: "CLE",
        symbol: "CLE"
      },
      CLF: {
        displayName: {
          one: "Chilean unit of account (UF)",
          other: "Chilean units of account (UF)"
        },
        narrow: "CLF",
        symbol: "CLF"
      },
      CLP: {
        displayName: {
          one: "Chilean peso",
          other: "Chilean pesos"
        },
        narrow: "$",
        symbol: "CLP"
      },
      CNH: {
        displayName: {
          other: "Chinese yuan (offshore)"
        },
        narrow: "CNH",
        symbol: "CNH"
      },
      CNX: {
        displayName: {
          one: "Chinese People’s Bank dollar",
          other: "Chinese People’s Bank dollars"
        },
        narrow: "CNX",
        symbol: "CNX"
      },
      CNY: {
        displayName: {
          other: "Chinese yuan"
        },
        narrow: "¥",
        symbol: "CN¥"
      },
      COP: {
        displayName: {
          one: "Colombian peso",
          other: "Colombian pesos"
        },
        narrow: "$",
        symbol: "COP"
      },
      COU: {
        displayName: {
          one: "Colombian real value unit",
          other: "Colombian real value units"
        },
        narrow: "COU",
        symbol: "COU"
      },
      CRC: {
        displayName: {
          one: "Costa Rican colón",
          other: "Costa Rican colóns"
        },
        narrow: "₡",
        symbol: "CRC"
      },
      CSD: {
        displayName: {
          one: "Serbian dinar (2002–2006)",
          other: "Serbian dinars (2002–2006)"
        },
        narrow: "CSD",
        symbol: "CSD"
      },
      CSK: {
        displayName: {
          one: "Czechoslovak hard koruna",
          other: "Czechoslovak hard korunas"
        },
        narrow: "CSK",
        symbol: "CSK"
      },
      CUC: {
        displayName: {
          one: "Cuban convertible peso",
          other: "Cuban convertible pesos"
        },
        narrow: "$",
        symbol: "CUC"
      },
      CUP: {
        displayName: {
          one: "Cuban peso",
          other: "Cuban pesos"
        },
        narrow: "$",
        symbol: "CUP"
      },
      CVE: {
        displayName: {
          one: "Cape Verdean escudo",
          other: "Cape Verdean escudos"
        },
        narrow: "CVE",
        symbol: "CVE"
      },
      CYP: {
        displayName: {
          one: "Cypriot pound",
          other: "Cypriot pounds"
        },
        narrow: "CYP",
        symbol: "CYP"
      },
      CZK: {
        displayName: {
          one: "Czech koruna",
          other: "Czech korunas"
        },
        narrow: "Kč",
        symbol: "CZK"
      },
      DDM: {
        displayName: {
          one: "East German mark",
          other: "East German marks"
        },
        narrow: "DDM",
        symbol: "DDM"
      },
      DEM: {
        displayName: {
          one: "German mark",
          other: "German marks"
        },
        narrow: "DEM",
        symbol: "DEM"
      },
      DJF: {
        displayName: {
          one: "Djiboutian franc",
          other: "Djiboutian francs"
        },
        narrow: "DJF",
        symbol: "DJF"
      },
      DKK: {
        displayName: {
          one: "Danish krone",
          other: "Danish kroner"
        },
        narrow: "kr",
        symbol: "DKK"
      },
      DOP: {
        displayName: {
          one: "Dominican peso",
          other: "Dominican pesos"
        },
        narrow: "$",
        symbol: "DOP"
      },
      DZD: {
        displayName: {
          one: "Algerian dinar",
          other: "Algerian dinars"
        },
        narrow: "DZD",
        symbol: "DZD"
      },
      ECS: {
        displayName: {
          one: "Ecuadorian sucre",
          other: "Ecuadorian sucres"
        },
        narrow: "ECS",
        symbol: "ECS"
      },
      ECV: {
        displayName: {
          one: "Ecuadorian unit of constant value",
          other: "Ecuadorian units of constant value"
        },
        narrow: "ECV",
        symbol: "ECV"
      },
      EEK: {
        displayName: {
          one: "Estonian kroon",
          other: "Estonian kroons"
        },
        narrow: "EEK",
        symbol: "EEK"
      },
      EGP: {
        displayName: {
          one: "Egyptian pound",
          other: "Egyptian pounds"
        },
        narrow: "E£",
        symbol: "EGP"
      },
      ERN: {
        displayName: {
          one: "Eritrean nakfa",
          other: "Eritrean nakfas"
        },
        narrow: "ERN",
        symbol: "ERN"
      },
      ESA: {
        displayName: {
          one: "Spanish peseta (A account)",
          other: "Spanish pesetas (A account)"
        },
        narrow: "ESA",
        symbol: "ESA"
      },
      ESB: {
        displayName: {
          one: "Spanish peseta (convertible account)",
          other: "Spanish pesetas (convertible account)"
        },
        narrow: "ESB",
        symbol: "ESB"
      },
      ESP: {
        displayName: {
          one: "Spanish peseta",
          other: "Spanish pesetas"
        },
        narrow: "₧",
        symbol: "ESP"
      },
      ETB: {
        displayName: {
          one: "Ethiopian birr",
          other: "Ethiopian birrs"
        },
        narrow: "ETB",
        symbol: "ETB"
      },
      EUR: {
        displayName: {
          one: "euro",
          other: "euros"
        },
        narrow: "€",
        symbol: "€"
      },
      FIM: {
        displayName: {
          one: "Finnish markka",
          other: "Finnish markkas"
        },
        narrow: "FIM",
        symbol: "FIM"
      },
      FJD: {
        displayName: {
          one: "Fijian dollar",
          other: "Fijian dollars"
        },
        narrow: "$",
        symbol: "FJD"
      },
      FKP: {
        displayName: {
          one: "Falkland Islands pound",
          other: "Falkland Islands pounds"
        },
        narrow: "£",
        symbol: "FKP"
      },
      FRF: {
        displayName: {
          one: "French franc",
          other: "French francs"
        },
        narrow: "FRF",
        symbol: "FRF"
      },
      GBP: {
        displayName: {
          one: "British pound",
          other: "British pounds"
        },
        narrow: "£",
        symbol: "£"
      },
      GEK: {
        displayName: {
          one: "Georgian kupon larit",
          other: "Georgian kupon larits"
        },
        narrow: "GEK",
        symbol: "GEK"
      },
      GEL: {
        displayName: {
          one: "Georgian lari",
          other: "Georgian laris"
        },
        narrow: "₾",
        symbol: "GEL"
      },
      GHC: {
        displayName: {
          one: "Ghanaian cedi (1979–2007)",
          other: "Ghanaian cedis (1979–2007)"
        },
        narrow: "GHC",
        symbol: "GHC"
      },
      GHS: {
        displayName: {
          one: "Ghanaian cedi",
          other: "Ghanaian cedis"
        },
        narrow: "GH₵",
        symbol: "GHS"
      },
      GIP: {
        displayName: {
          one: "Gibraltar pound",
          other: "Gibraltar pounds"
        },
        narrow: "£",
        symbol: "GIP"
      },
      GMD: {
        displayName: {
          one: "Gambian dalasi",
          other: "Gambian dalasis"
        },
        narrow: "GMD",
        symbol: "GMD"
      },
      GNF: {
        displayName: {
          one: "Guinean franc",
          other: "Guinean francs"
        },
        narrow: "FG",
        symbol: "GNF"
      },
      GNS: {
        displayName: {
          one: "Guinean syli",
          other: "Guinean sylis"
        },
        narrow: "GNS",
        symbol: "GNS"
      },
      GQE: {
        displayName: {
          other: "Equatorial Guinean ekwele"
        },
        narrow: "GQE",
        symbol: "GQE"
      },
      GRD: {
        displayName: {
          one: "Greek drachma",
          other: "Greek drachmas"
        },
        narrow: "GRD",
        symbol: "GRD"
      },
      GTQ: {
        displayName: {
          one: "Guatemalan quetzal",
          other: "Guatemalan quetzals"
        },
        narrow: "Q",
        symbol: "GTQ"
      },
      GWE: {
        displayName: {
          one: "Portuguese Guinea escudo",
          other: "Portuguese Guinea escudos"
        },
        narrow: "GWE",
        symbol: "GWE"
      },
      GWP: {
        displayName: {
          one: "Guinea-Bissau peso",
          other: "Guinea-Bissau pesos"
        },
        narrow: "GWP",
        symbol: "GWP"
      },
      GYD: {
        displayName: {
          one: "Guyanaese dollar",
          other: "Guyanaese dollars"
        },
        narrow: "$",
        symbol: "GYD"
      },
      HKD: {
        displayName: {
          one: "Hong Kong dollar",
          other: "Hong Kong dollars"
        },
        narrow: "$",
        symbol: "HK$"
      },
      HNL: {
        displayName: {
          one: "Honduran lempira",
          other: "Honduran lempiras"
        },
        narrow: "L",
        symbol: "HNL"
      },
      HRD: {
        displayName: {
          one: "Croatian dinar",
          other: "Croatian dinars"
        },
        narrow: "HRD",
        symbol: "HRD"
      },
      HRK: {
        displayName: {
          one: "Croatian kuna",
          other: "Croatian kunas"
        },
        narrow: "kn",
        symbol: "HRK"
      },
      HTG: {
        displayName: {
          one: "Haitian gourde",
          other: "Haitian gourdes"
        },
        narrow: "HTG",
        symbol: "HTG"
      },
      HUF: {
        displayName: {
          one: "Hungarian forint",
          other: "Hungarian forints"
        },
        narrow: "Ft",
        symbol: "HUF"
      },
      IDR: {
        displayName: {
          one: "Indonesian rupiah",
          other: "Indonesian rupiahs"
        },
        narrow: "Rp",
        symbol: "IDR"
      },
      IEP: {
        displayName: {
          one: "Irish pound",
          other: "Irish pounds"
        },
        narrow: "IEP",
        symbol: "IEP"
      },
      ILP: {
        displayName: {
          one: "Israeli pound",
          other: "Israeli pounds"
        },
        narrow: "ILP",
        symbol: "ILP"
      },
      ILR: {
        displayName: {
          one: "Israeli shekel (1980–1985)",
          other: "Israeli shekels (1980–1985)"
        },
        narrow: "ILR",
        symbol: "ILR"
      },
      ILS: {
        displayName: {
          one: "Israeli new shekel",
          other: "Israeli new shekels"
        },
        narrow: "₪",
        symbol: "₪"
      },
      INR: {
        displayName: {
          one: "Indian rupee",
          other: "Indian rupees"
        },
        narrow: "₹",
        symbol: "₹"
      },
      IQD: {
        displayName: {
          one: "Iraqi dinar",
          other: "Iraqi dinars"
        },
        narrow: "IQD",
        symbol: "IQD"
      },
      IRR: {
        displayName: {
          one: "Iranian rial",
          other: "Iranian rials"
        },
        narrow: "IRR",
        symbol: "IRR"
      },
      ISJ: {
        displayName: {
          one: "Icelandic króna (1918–1981)",
          other: "Icelandic krónur (1918–1981)"
        },
        narrow: "ISJ",
        symbol: "ISJ"
      },
      ISK: {
        displayName: {
          one: "Icelandic króna",
          other: "Icelandic krónur"
        },
        narrow: "kr",
        symbol: "ISK"
      },
      ITL: {
        displayName: {
          one: "Italian lira",
          other: "Italian liras"
        },
        narrow: "ITL",
        symbol: "ITL"
      },
      JMD: {
        displayName: {
          one: "Jamaican dollar",
          other: "Jamaican dollars"
        },
        narrow: "$",
        symbol: "JMD"
      },
      JOD: {
        displayName: {
          one: "Jordanian dinar",
          other: "Jordanian dinars"
        },
        narrow: "JOD",
        symbol: "JOD"
      },
      JPY: {
        displayName: {
          other: "Japanese yen"
        },
        narrow: "¥",
        symbol: "¥"
      },
      KES: {
        displayName: {
          one: "Kenyan shilling",
          other: "Kenyan shillings"
        },
        narrow: "KES",
        symbol: "KES"
      },
      KGS: {
        displayName: {
          one: "Kyrgystani som",
          other: "Kyrgystani soms"
        },
        narrow: "⃀",
        symbol: "KGS"
      },
      KHR: {
        displayName: {
          one: "Cambodian riel",
          other: "Cambodian riels"
        },
        narrow: "៛",
        symbol: "KHR"
      },
      KMF: {
        displayName: {
          one: "Comorian franc",
          other: "Comorian francs"
        },
        narrow: "CF",
        symbol: "KMF"
      },
      KPW: {
        displayName: {
          other: "North Korean won"
        },
        narrow: "₩",
        symbol: "KPW"
      },
      KRH: {
        displayName: {
          other: "South Korean hwan (1953–1962)"
        },
        narrow: "KRH",
        symbol: "KRH"
      },
      KRO: {
        displayName: {
          other: "South Korean won (1945–1953)"
        },
        narrow: "KRO",
        symbol: "KRO"
      },
      KRW: {
        displayName: {
          other: "South Korean won"
        },
        narrow: "₩",
        symbol: "₩"
      },
      KWD: {
        displayName: {
          one: "Kuwaiti dinar",
          other: "Kuwaiti dinars"
        },
        narrow: "KWD",
        symbol: "KWD"
      },
      KYD: {
        displayName: {
          one: "Cayman Islands dollar",
          other: "Cayman Islands dollars"
        },
        narrow: "$",
        symbol: "KYD"
      },
      KZT: {
        displayName: {
          one: "Kazakhstani tenge",
          other: "Kazakhstani tenges"
        },
        narrow: "₸",
        symbol: "KZT"
      },
      LAK: {
        displayName: {
          one: "Laotian kip",
          other: "Laotian kips"
        },
        narrow: "₭",
        symbol: "LAK"
      },
      LBP: {
        displayName: {
          one: "Lebanese pound",
          other: "Lebanese pounds"
        },
        narrow: "L£",
        symbol: "LBP"
      },
      LKR: {
        displayName: {
          one: "Sri Lankan rupee",
          other: "Sri Lankan rupees"
        },
        narrow: "Rs",
        symbol: "LKR"
      },
      LRD: {
        displayName: {
          one: "Liberian dollar",
          other: "Liberian dollars"
        },
        narrow: "$",
        symbol: "LRD"
      },
      LSL: {
        displayName: {
          one: "Lesotho loti",
          other: "Lesotho lotis"
        },
        narrow: "LSL",
        symbol: "LSL"
      },
      LTL: {
        displayName: {
          one: "Lithuanian litas",
          other: "Lithuanian litai"
        },
        narrow: "Lt",
        symbol: "LTL"
      },
      LTT: {
        displayName: {
          one: "Lithuanian talonas",
          other: "Lithuanian talonases"
        },
        narrow: "LTT",
        symbol: "LTT"
      },
      LUC: {
        displayName: {
          one: "Luxembourgian convertible franc",
          other: "Luxembourgian convertible francs"
        },
        narrow: "LUC",
        symbol: "LUC"
      },
      LUF: {
        displayName: {
          one: "Luxembourgian franc",
          other: "Luxembourgian francs"
        },
        narrow: "LUF",
        symbol: "LUF"
      },
      LUL: {
        displayName: {
          one: "Luxembourg financial franc",
          other: "Luxembourg financial francs"
        },
        narrow: "LUL",
        symbol: "LUL"
      },
      LVL: {
        displayName: {
          one: "Latvian lats",
          other: "Latvian lati"
        },
        narrow: "Ls",
        symbol: "LVL"
      },
      LVR: {
        displayName: {
          one: "Latvian ruble",
          other: "Latvian rubles"
        },
        narrow: "LVR",
        symbol: "LVR"
      },
      LYD: {
        displayName: {
          one: "Libyan dinar",
          other: "Libyan dinars"
        },
        narrow: "LYD",
        symbol: "LYD"
      },
      MAD: {
        displayName: {
          one: "Moroccan dirham",
          other: "Moroccan dirhams"
        },
        narrow: "MAD",
        symbol: "MAD"
      },
      MAF: {
        displayName: {
          one: "Moroccan franc",
          other: "Moroccan francs"
        },
        narrow: "MAF",
        symbol: "MAF"
      },
      MCF: {
        displayName: {
          one: "Monegasque franc",
          other: "Monegasque francs"
        },
        narrow: "MCF",
        symbol: "MCF"
      },
      MDC: {
        displayName: {
          other: "Moldovan cupon"
        },
        narrow: "MDC",
        symbol: "MDC"
      },
      MDL: {
        displayName: {
          one: "Moldovan leu",
          other: "Moldovan lei"
        },
        narrow: "MDL",
        symbol: "MDL"
      },
      MGA: {
        displayName: {
          one: "Malagasy ariary",
          other: "Malagasy ariaries"
        },
        narrow: "Ar",
        symbol: "MGA"
      },
      MGF: {
        displayName: {
          one: "Malagasy franc",
          other: "Malagasy francs"
        },
        narrow: "MGF",
        symbol: "MGF"
      },
      MKD: {
        displayName: {
          one: "Macedonian denar",
          other: "Macedonian denari"
        },
        narrow: "MKD",
        symbol: "MKD"
      },
      MKN: {
        displayName: {
          one: "Macedonian denar (1992–1993)",
          other: "Macedonian denari (1992–1993)"
        },
        narrow: "MKN",
        symbol: "MKN"
      },
      MLF: {
        displayName: {
          one: "Malian franc",
          other: "Malian francs"
        },
        narrow: "MLF",
        symbol: "MLF"
      },
      MMK: {
        displayName: {
          one: "Myanmar kyat",
          other: "Myanmar kyats"
        },
        narrow: "K",
        symbol: "MMK"
      },
      MNT: {
        displayName: {
          one: "Mongolian tugrik",
          other: "Mongolian tugriks"
        },
        narrow: "₮",
        symbol: "MNT"
      },
      MOP: {
        displayName: {
          one: "Macanese pataca",
          other: "Macanese patacas"
        },
        narrow: "MOP",
        symbol: "MOP"
      },
      MRO: {
        displayName: {
          one: "Mauritanian ouguiya (1973–2017)",
          other: "Mauritanian ouguiyas (1973–2017)"
        },
        narrow: "MRO",
        symbol: "MRO"
      },
      MRU: {
        displayName: {
          one: "Mauritanian ouguiya",
          other: "Mauritanian ouguiyas"
        },
        narrow: "MRU",
        symbol: "MRU"
      },
      MTL: {
        displayName: {
          other: "Maltese lira"
        },
        narrow: "MTL",
        symbol: "MTL"
      },
      MTP: {
        displayName: {
          one: "Maltese pound",
          other: "Maltese pounds"
        },
        narrow: "MTP",
        symbol: "MTP"
      },
      MUR: {
        displayName: {
          one: "Mauritian rupee",
          other: "Mauritian rupees"
        },
        narrow: "Rs",
        symbol: "MUR"
      },
      MVP: {
        displayName: {
          one: "Maldivian rupee (1947–1981)",
          other: "Maldivian rupees (1947–1981)"
        },
        narrow: "MVP",
        symbol: "MVP"
      },
      MVR: {
        displayName: {
          one: "Maldivian rufiyaa",
          other: "Maldivian rufiyaas"
        },
        narrow: "MVR",
        symbol: "MVR"
      },
      MWK: {
        displayName: {
          one: "Malawian kwacha",
          other: "Malawian kwachas"
        },
        narrow: "MWK",
        symbol: "MWK"
      },
      MXN: {
        displayName: {
          one: "Mexican peso",
          other: "Mexican pesos"
        },
        narrow: "$",
        symbol: "MX$"
      },
      MXP: {
        displayName: {
          one: "Mexican silver peso (1861–1992)",
          other: "Mexican silver pesos (1861–1992)"
        },
        narrow: "MXP",
        symbol: "MXP"
      },
      MXV: {
        displayName: {
          one: "Mexican investment unit",
          other: "Mexican investment units"
        },
        narrow: "MXV",
        symbol: "MXV"
      },
      MYR: {
        displayName: {
          one: "Malaysian ringgit",
          other: "Malaysian ringgits"
        },
        narrow: "RM",
        symbol: "MYR"
      },
      MZE: {
        displayName: {
          one: "Mozambican escudo",
          other: "Mozambican escudos"
        },
        narrow: "MZE",
        symbol: "MZE"
      },
      MZM: {
        displayName: {
          one: "Mozambican metical (1980–2006)",
          other: "Mozambican meticals (1980–2006)"
        },
        narrow: "MZM",
        symbol: "MZM"
      },
      MZN: {
        displayName: {
          one: "Mozambican metical",
          other: "Mozambican meticals"
        },
        narrow: "MZN",
        symbol: "MZN"
      },
      NAD: {
        displayName: {
          one: "Namibian dollar",
          other: "Namibian dollars"
        },
        narrow: "$",
        symbol: "NAD"
      },
      NGN: {
        displayName: {
          one: "Nigerian naira",
          other: "Nigerian nairas"
        },
        narrow: "₦",
        symbol: "NGN"
      },
      NIC: {
        displayName: {
          one: "Nicaraguan córdoba (1988–1991)",
          other: "Nicaraguan córdobas (1988–1991)"
        },
        narrow: "NIC",
        symbol: "NIC"
      },
      NIO: {
        displayName: {
          one: "Nicaraguan córdoba",
          other: "Nicaraguan córdobas"
        },
        narrow: "C$",
        symbol: "NIO"
      },
      NLG: {
        displayName: {
          one: "Dutch guilder",
          other: "Dutch guilders"
        },
        narrow: "NLG",
        symbol: "NLG"
      },
      NOK: {
        displayName: {
          one: "Norwegian krone",
          other: "Norwegian kroner"
        },
        narrow: "kr",
        symbol: "NOK"
      },
      NPR: {
        displayName: {
          one: "Nepalese rupee",
          other: "Nepalese rupees"
        },
        narrow: "Rs",
        symbol: "NPR"
      },
      NZD: {
        displayName: {
          one: "New Zealand dollar",
          other: "New Zealand dollars"
        },
        narrow: "$",
        symbol: "NZ$"
      },
      OMR: {
        displayName: {
          one: "Omani rial",
          other: "Omani rials"
        },
        narrow: "OMR",
        symbol: "OMR"
      },
      PAB: {
        displayName: {
          one: "Panamanian balboa",
          other: "Panamanian balboas"
        },
        narrow: "PAB",
        symbol: "PAB"
      },
      PEI: {
        displayName: {
          one: "Peruvian inti",
          other: "Peruvian intis"
        },
        narrow: "PEI",
        symbol: "PEI"
      },
      PEN: {
        displayName: {
          one: "Peruvian sol",
          other: "Peruvian soles"
        },
        narrow: "PEN",
        symbol: "PEN"
      },
      PES: {
        displayName: {
          one: "Peruvian sol (1863–1965)",
          other: "Peruvian soles (1863–1965)"
        },
        narrow: "PES",
        symbol: "PES"
      },
      PGK: {
        displayName: {
          other: "Papua New Guinean kina"
        },
        narrow: "PGK",
        symbol: "PGK"
      },
      PHP: {
        displayName: {
          one: "Philippine peso",
          other: "Philippine pesos"
        },
        narrow: "₱",
        symbol: "₱"
      },
      PKR: {
        displayName: {
          one: "Pakistani rupee",
          other: "Pakistani rupees"
        },
        narrow: "Rs",
        symbol: "PKR"
      },
      PLN: {
        displayName: {
          one: "Polish zloty",
          other: "Polish zlotys"
        },
        narrow: "zł",
        symbol: "PLN"
      },
      PLZ: {
        displayName: {
          one: "Polish zloty (PLZ)",
          other: "Polish zlotys (PLZ)"
        },
        narrow: "PLZ",
        symbol: "PLZ"
      },
      PTE: {
        displayName: {
          one: "Portuguese escudo",
          other: "Portuguese escudos"
        },
        narrow: "PTE",
        symbol: "PTE"
      },
      PYG: {
        displayName: {
          one: "Paraguayan guarani",
          other: "Paraguayan guaranis"
        },
        narrow: "₲",
        symbol: "PYG"
      },
      QAR: {
        displayName: {
          one: "Qatari riyal",
          other: "Qatari riyals"
        },
        narrow: "QAR",
        symbol: "QAR"
      },
      RHD: {
        displayName: {
          one: "Rhodesian dollar",
          other: "Rhodesian dollars"
        },
        narrow: "RHD",
        symbol: "RHD"
      },
      ROL: {
        displayName: {
          one: "Romanian leu (1952–2006)",
          other: "Romanian Lei (1952–2006)"
        },
        narrow: "ROL",
        symbol: "ROL"
      },
      RON: {
        displayName: {
          one: "Romanian leu",
          other: "Romanian lei"
        },
        narrow: "lei",
        symbol: "RON"
      },
      RSD: {
        displayName: {
          one: "Serbian dinar",
          other: "Serbian dinars"
        },
        narrow: "RSD",
        symbol: "RSD"
      },
      RUB: {
        displayName: {
          one: "Russian ruble",
          other: "Russian rubles"
        },
        narrow: "₽",
        symbol: "RUB"
      },
      RUR: {
        displayName: {
          one: "Russian ruble (1991–1998)",
          other: "Russian rubles (1991–1998)"
        },
        narrow: "RUR",
        symbol: "RUR"
      },
      RWF: {
        displayName: {
          one: "Rwandan franc",
          other: "Rwandan francs"
        },
        narrow: "RF",
        symbol: "RWF"
      },
      SAR: {
        displayName: {
          one: "Saudi riyal",
          other: "Saudi riyals"
        },
        narrow: "SAR",
        symbol: "SAR"
      },
      SBD: {
        displayName: {
          one: "Solomon Islands dollar",
          other: "Solomon Islands dollars"
        },
        narrow: "$",
        symbol: "SBD"
      },
      SCR: {
        displayName: {
          one: "Seychellois rupee",
          other: "Seychellois rupees"
        },
        narrow: "SCR",
        symbol: "SCR"
      },
      SDD: {
        displayName: {
          one: "Sudanese dinar (1992–2007)",
          other: "Sudanese dinars (1992–2007)"
        },
        narrow: "SDD",
        symbol: "SDD"
      },
      SDG: {
        displayName: {
          one: "Sudanese pound",
          other: "Sudanese pounds"
        },
        narrow: "SDG",
        symbol: "SDG"
      },
      SDP: {
        displayName: {
          one: "Sudanese pound (1957–1998)",
          other: "Sudanese pounds (1957–1998)"
        },
        narrow: "SDP",
        symbol: "SDP"
      },
      SEK: {
        displayName: {
          one: "Swedish krona",
          other: "Swedish kronor"
        },
        narrow: "kr",
        symbol: "SEK"
      },
      SGD: {
        displayName: {
          one: "Singapore dollar",
          other: "Singapore dollars"
        },
        narrow: "$",
        symbol: "SGD"
      },
      SHP: {
        displayName: {
          one: "St. Helena pound",
          other: "St. Helena pounds"
        },
        narrow: "£",
        symbol: "SHP"
      },
      SIT: {
        displayName: {
          one: "Slovenian tolar",
          other: "Slovenian tolars"
        },
        narrow: "SIT",
        symbol: "SIT"
      },
      SKK: {
        displayName: {
          one: "Slovak koruna",
          other: "Slovak korunas"
        },
        narrow: "SKK",
        symbol: "SKK"
      },
      SLE: {
        displayName: {
          one: "Sierra Leonean leone",
          other: "Sierra Leonean leones"
        },
        narrow: "SLE",
        symbol: "SLE"
      },
      SLL: {
        displayName: {
          one: "Sierra Leonean leone (1964—2022)",
          other: "Sierra Leonean leones (1964—2022)"
        },
        narrow: "SLL",
        symbol: "SLL"
      },
      SOS: {
        displayName: {
          one: "Somali shilling",
          other: "Somali shillings"
        },
        narrow: "SOS",
        symbol: "SOS"
      },
      SRD: {
        displayName: {
          one: "Surinamese dollar",
          other: "Surinamese dollars"
        },
        narrow: "$",
        symbol: "SRD"
      },
      SRG: {
        displayName: {
          one: "Surinamese guilder",
          other: "Surinamese guilders"
        },
        narrow: "SRG",
        symbol: "SRG"
      },
      SSP: {
        displayName: {
          one: "South Sudanese pound",
          other: "South Sudanese pounds"
        },
        narrow: "£",
        symbol: "SSP"
      },
      STD: {
        displayName: {
          one: "São Tomé & Príncipe dobra (1977–2017)",
          other: "São Tomé & Príncipe dobras (1977–2017)"
        },
        narrow: "STD",
        symbol: "STD"
      },
      STN: {
        displayName: {
          one: "São Tomé & Príncipe dobra",
          other: "São Tomé & Príncipe dobras"
        },
        narrow: "Db",
        symbol: "STN"
      },
      SUR: {
        displayName: {
          one: "Soviet rouble",
          other: "Soviet roubles"
        },
        narrow: "SUR",
        symbol: "SUR"
      },
      SVC: {
        displayName: {
          one: "Salvadoran colón",
          other: "Salvadoran colones"
        },
        narrow: "SVC",
        symbol: "SVC"
      },
      SYP: {
        displayName: {
          one: "Syrian pound",
          other: "Syrian pounds"
        },
        narrow: "£",
        symbol: "SYP"
      },
      SZL: {
        displayName: {
          one: "Swazi lilangeni",
          other: "Swazi emalangeni"
        },
        narrow: "SZL",
        symbol: "SZL"
      },
      THB: {
        displayName: {
          other: "Thai baht"
        },
        narrow: "฿",
        symbol: "THB"
      },
      TJR: {
        displayName: {
          one: "Tajikistani ruble",
          other: "Tajikistani rubles"
        },
        narrow: "TJR",
        symbol: "TJR"
      },
      TJS: {
        displayName: {
          one: "Tajikistani somoni",
          other: "Tajikistani somonis"
        },
        narrow: "TJS",
        symbol: "TJS"
      },
      TMM: {
        displayName: {
          other: "Turkmenistani manat (1993–2009)"
        },
        narrow: "TMM",
        symbol: "TMM"
      },
      TMT: {
        displayName: {
          other: "Turkmenistani manat"
        },
        narrow: "TMT",
        symbol: "TMT"
      },
      TND: {
        displayName: {
          one: "Tunisian dinar",
          other: "Tunisian dinars"
        },
        narrow: "TND",
        symbol: "TND"
      },
      TOP: {
        displayName: {
          other: "Tongan paʻanga"
        },
        narrow: "T$",
        symbol: "TOP"
      },
      TPE: {
        displayName: {
          one: "Timorese escudo",
          other: "Timorese escudos"
        },
        narrow: "TPE",
        symbol: "TPE"
      },
      TRL: {
        displayName: {
          one: "Turkish lira (1922–2005)",
          other: "Turkish Lira (1922–2005)"
        },
        narrow: "TRL",
        symbol: "TRL"
      },
      TRY: {
        displayName: {
          one: "Turkish lira",
          other: "Turkish Lira"
        },
        narrow: "₺",
        symbol: "TRY"
      },
      TTD: {
        displayName: {
          one: "Trinidad & Tobago dollar",
          other: "Trinidad & Tobago dollars"
        },
        narrow: "$",
        symbol: "TTD"
      },
      TWD: {
        displayName: {
          one: "New Taiwan dollar",
          other: "New Taiwan dollars"
        },
        narrow: "$",
        symbol: "NT$"
      },
      TZS: {
        displayName: {
          one: "Tanzanian shilling",
          other: "Tanzanian shillings"
        },
        narrow: "TZS",
        symbol: "TZS"
      },
      UAH: {
        displayName: {
          one: "Ukrainian hryvnia",
          other: "Ukrainian hryvnias"
        },
        narrow: "₴",
        symbol: "UAH"
      },
      UAK: {
        displayName: {
          one: "Ukrainian karbovanets",
          other: "Ukrainian karbovantsiv"
        },
        narrow: "UAK",
        symbol: "UAK"
      },
      UGS: {
        displayName: {
          one: "Ugandan shilling (1966–1987)",
          other: "Ugandan shillings (1966–1987)"
        },
        narrow: "UGS",
        symbol: "UGS"
      },
      UGX: {
        displayName: {
          one: "Ugandan shilling",
          other: "Ugandan shillings"
        },
        narrow: "UGX",
        symbol: "UGX"
      },
      USD: {
        displayName: {
          one: "US dollar",
          other: "US dollars"
        },
        narrow: "$",
        symbol: "$"
      },
      USN: {
        displayName: {
          one: "US dollar (next day)",
          other: "US dollars (next day)"
        },
        narrow: "USN",
        symbol: "USN"
      },
      USS: {
        displayName: {
          one: "US dollar (same day)",
          other: "US dollars (same day)"
        },
        narrow: "USS",
        symbol: "USS"
      },
      UYI: {
        displayName: {
          one: "Uruguayan peso (indexed units)",
          other: "Uruguayan pesos (indexed units)"
        },
        narrow: "UYI",
        symbol: "UYI"
      },
      UYP: {
        displayName: {
          one: "Uruguayan peso (1975–1993)",
          other: "Uruguayan pesos (1975–1993)"
        },
        narrow: "UYP",
        symbol: "UYP"
      },
      UYU: {
        displayName: {
          one: "Uruguayan peso",
          other: "Uruguayan pesos"
        },
        narrow: "$",
        symbol: "UYU"
      },
      UYW: {
        displayName: {
          one: "Uruguayan nominal wage index unit",
          other: "Uruguayan nominal wage index units"
        },
        narrow: "UYW",
        symbol: "UYW"
      },
      UZS: {
        displayName: {
          other: "Uzbekistani som"
        },
        narrow: "UZS",
        symbol: "UZS"
      },
      VEB: {
        displayName: {
          one: "Venezuelan bolívar (1871–2008)",
          other: "Venezuelan bolívars (1871–2008)"
        },
        narrow: "VEB",
        symbol: "VEB"
      },
      VED: {
        displayName: {
          one: "Bolívar Soberano",
          other: "Bolívar Soberanos"
        },
        narrow: "VED",
        symbol: "VED"
      },
      VEF: {
        displayName: {
          one: "Venezuelan bolívar (2008–2018)",
          other: "Venezuelan bolívars (2008–2018)"
        },
        narrow: "Bs",
        symbol: "VEF"
      },
      VES: {
        displayName: {
          one: "Venezuelan bolívar",
          other: "Venezuelan bolívars"
        },
        narrow: "VES",
        symbol: "VES"
      },
      VND: {
        displayName: {
          other: "Vietnamese dong"
        },
        narrow: "₫",
        symbol: "₫"
      },
      VNN: {
        displayName: {
          other: "Vietnamese dong (1978–1985)"
        },
        narrow: "VNN",
        symbol: "VNN"
      },
      VUV: {
        displayName: {
          one: "Vanuatu vatu",
          other: "Vanuatu vatus"
        },
        narrow: "VUV",
        symbol: "VUV"
      },
      WST: {
        displayName: {
          other: "Samoan tala"
        },
        narrow: "WST",
        symbol: "WST"
      },
      XAF: {
        displayName: {
          one: "Central African CFA franc",
          other: "Central African CFA francs"
        },
        narrow: "FCFA",
        symbol: "FCFA"
      },
      XAG: {
        displayName: {
          one: "troy ounce of silver",
          other: "troy ounces of silver"
        },
        narrow: "XAG",
        symbol: "XAG"
      },
      XAU: {
        displayName: {
          one: "troy ounce of gold",
          other: "troy ounces of gold"
        },
        narrow: "XAU",
        symbol: "XAU"
      },
      XBA: {
        displayName: {
          one: "European composite unit",
          other: "European composite units"
        },
        narrow: "XBA",
        symbol: "XBA"
      },
      XBB: {
        displayName: {
          one: "European monetary unit",
          other: "European monetary units"
        },
        narrow: "XBB",
        symbol: "XBB"
      },
      XBC: {
        displayName: {
          one: "European unit of account (XBC)",
          other: "European units of account (XBC)"
        },
        narrow: "XBC",
        symbol: "XBC"
      },
      XBD: {
        displayName: {
          one: "European unit of account (XBD)",
          other: "European units of account (XBD)"
        },
        narrow: "XBD",
        symbol: "XBD"
      },
      XCD: {
        displayName: {
          one: "East Caribbean dollar",
          other: "East Caribbean dollars"
        },
        narrow: "$",
        symbol: "EC$"
      },
      XCG: {
        displayName: {
          one: "Caribbean guilder",
          other: "Caribbean guilders"
        },
        narrow: "Cg.",
        symbol: "Cg."
      },
      XDR: {
        displayName: {
          other: "special drawing rights"
        },
        narrow: "XDR",
        symbol: "XDR"
      },
      XEU: {
        displayName: {
          one: "European currency unit",
          other: "European currency units"
        },
        narrow: "XEU",
        symbol: "XEU"
      },
      XFO: {
        displayName: {
          one: "French gold franc",
          other: "French gold francs"
        },
        narrow: "XFO",
        symbol: "XFO"
      },
      XFU: {
        displayName: {
          one: "French UIC-franc",
          other: "French UIC-francs"
        },
        narrow: "XFU",
        symbol: "XFU"
      },
      XOF: {
        displayName: {
          one: "West African CFA franc",
          other: "West African CFA francs"
        },
        narrow: "F CFA",
        symbol: "F CFA"
      },
      XPD: {
        displayName: {
          one: "troy ounce of palladium",
          other: "troy ounces of palladium"
        },
        narrow: "XPD",
        symbol: "XPD"
      },
      XPF: {
        displayName: {
          one: "CFP franc",
          other: "CFP francs"
        },
        narrow: "CFPF",
        symbol: "CFPF"
      },
      XPT: {
        displayName: {
          one: "troy ounce of platinum",
          other: "troy ounces of platinum"
        },
        narrow: "XPT",
        symbol: "XPT"
      },
      XRE: {
        displayName: {
          one: "RINET Funds unit",
          other: "RINET Funds units"
        },
        narrow: "XRE",
        symbol: "XRE"
      },
      XSU: {
        displayName: {
          one: "Sucre",
          other: "Sucres"
        },
        narrow: "XSU",
        symbol: "XSU"
      },
      XTS: {
        displayName: {
          one: "Testing Currency unit",
          other: "Testing Currency units"
        },
        narrow: "XTS",
        symbol: "XTS"
      },
      XUA: {
        displayName: {
          one: "ADB unit of account",
          other: "ADB units of account"
        },
        narrow: "XUA",
        symbol: "XUA"
      },
      XXX: {
        displayName: {
          one: "(unknown unit of currency)",
          other: "(unknown currency)"
        },
        narrow: "¤",
        symbol: "¤"
      },
      YDD: {
        displayName: {
          one: "Yemeni dinar",
          other: "Yemeni dinars"
        },
        narrow: "YDD",
        symbol: "YDD"
      },
      YER: {
        displayName: {
          one: "Yemeni rial",
          other: "Yemeni rials"
        },
        narrow: "YER",
        symbol: "YER"
      },
      YUD: {
        displayName: {
          one: "Yugoslavian hard dinar (1966–1990)",
          other: "Yugoslavian hard dinars (1966–1990)"
        },
        narrow: "YUD",
        symbol: "YUD"
      },
      YUM: {
        displayName: {
          one: "Yugoslavian new dinar (1994–2002)",
          other: "Yugoslavian new dinars (1994–2002)"
        },
        narrow: "YUM",
        symbol: "YUM"
      },
      YUN: {
        displayName: {
          one: "Yugoslavian convertible dinar (1990–1992)",
          other: "Yugoslavian convertible dinars (1990–1992)"
        },
        narrow: "YUN",
        symbol: "YUN"
      },
      YUR: {
        displayName: {
          one: "Yugoslavian reformed dinar (1992–1993)",
          other: "Yugoslavian reformed dinars (1992–1993)"
        },
        narrow: "YUR",
        symbol: "YUR"
      },
      ZAL: {
        displayName: {
          one: "South African rand (financial)",
          other: "South African rands (financial)"
        },
        narrow: "ZAL",
        symbol: "ZAL"
      },
      ZAR: {
        displayName: {
          other: "South African rand"
        },
        narrow: "R",
        symbol: "ZAR"
      },
      ZMK: {
        displayName: {
          one: "Zambian kwacha (1968–2012)",
          other: "Zambian kwachas (1968–2012)"
        },
        narrow: "ZMK",
        symbol: "ZMK"
      },
      ZMW: {
        displayName: {
          one: "Zambian kwacha",
          other: "Zambian kwachas"
        },
        narrow: "ZK",
        symbol: "ZMW"
      },
      ZRN: {
        displayName: {
          one: "Zairean new zaire (1993–1998)",
          other: "Zairean new zaires (1993–1998)"
        },
        narrow: "ZRN",
        symbol: "ZRN"
      },
      ZRZ: {
        displayName: {
          one: "Zairean zaire (1971–1993)",
          other: "Zairean zaires (1971–1993)"
        },
        narrow: "ZRZ",
        symbol: "ZRZ"
      },
      ZWD: {
        displayName: {
          one: "Zimbabwean dollar (1980–2008)",
          other: "Zimbabwean dollars (1980–2008)"
        },
        narrow: "ZWD",
        symbol: "ZWD"
      },
      ZWG: {
        displayName: {
          other: "Zimbabwean gold"
        },
        narrow: "ZWG",
        symbol: "ZWG"
      },
      ZWL: {
        displayName: {
          one: "Zimbabwean dollar (2009–2024)",
          other: "Zimbabwean dollars (2009–2024)"
        },
        narrow: "ZWL",
        symbol: "ZWL"
      },
      ZWR: {
        displayName: {
          one: "Zimbabwean dollar (2008)",
          other: "Zimbabwean dollars (2008)"
        },
        narrow: "ZWR",
        symbol: "ZWR"
      }
    },
    nu: [
      "latn"
    ],
    numbers: {
      currency: {
        latn: {
          accounting: "¤#,##0.00;(¤#,##0.00)",
          currencySpacing: {
            afterInsertBetween: " ",
            beforeInsertBetween: " "
          },
          short: {
            1e3: {
              other: "¤0K"
            },
            1e4: {
              other: "¤00K"
            },
            1e5: {
              other: "¤000K"
            },
            1e6: {
              other: "¤0M"
            },
            1e7: {
              other: "¤00M"
            },
            1e8: {
              other: "¤000M"
            },
            1e9: {
              other: "¤0B"
            },
            "10000000000": {
              other: "¤00B"
            },
            "100000000000": {
              other: "¤000B"
            },
            "1000000000000": {
              other: "¤0T"
            },
            "10000000000000": {
              other: "¤00T"
            },
            "100000000000000": {
              other: "¤000T"
            }
          },
          standard: "¤#,##0.00",
          unitPattern: "{0} {1}"
        }
      },
      decimal: {
        latn: {
          long: {
            1e3: {
              other: "0 thousand"
            },
            1e4: {
              other: "00 thousand"
            },
            1e5: {
              other: "000 thousand"
            },
            1e6: {
              other: "0 million"
            },
            1e7: {
              other: "00 million"
            },
            1e8: {
              other: "000 million"
            },
            1e9: {
              other: "0 billion"
            },
            "10000000000": {
              other: "00 billion"
            },
            "100000000000": {
              other: "000 billion"
            },
            "1000000000000": {
              other: "0 trillion"
            },
            "10000000000000": {
              other: "00 trillion"
            },
            "100000000000000": {
              other: "000 trillion"
            }
          },
          short: {
            1e3: {
              other: "0K"
            },
            1e4: {
              other: "00K"
            },
            1e5: {
              other: "000K"
            },
            1e6: {
              other: "0M"
            },
            1e7: {
              other: "00M"
            },
            1e8: {
              other: "000M"
            },
            1e9: {
              other: "0B"
            },
            "10000000000": {
              other: "00B"
            },
            "100000000000": {
              other: "000B"
            },
            "1000000000000": {
              other: "0T"
            },
            "10000000000000": {
              other: "00T"
            },
            "100000000000000": {
              other: "000T"
            }
          },
          standard: "#,##0.###"
        }
      },
      nu: [
        "latn"
      ],
      percent: {
        latn: "#,##0%"
      },
      symbols: {
        latn: {
          approximatelySign: "~",
          decimal: ".",
          exponential: "E",
          group: ",",
          infinity: "∞",
          list: ";",
          minusSign: "-",
          nan: "NaN",
          perMille: "‰",
          percentSign: "%",
          plusSign: "+",
          rangeSign: "–",
          superscriptingExponent: "×",
          timeSeparator: ":"
        }
      }
    },
    units: {
      compound: {
        per: {
          long: "{0} per {1}",
          narrow: "{0}/{1}",
          short: "{0}/{1}"
        }
      },
      simple: {
        acre: {
          long: {
            one: "{0} acre",
            other: "{0} acres"
          },
          narrow: {
            other: "{0}ac"
          },
          perUnit: {},
          short: {
            other: "{0} ac"
          }
        },
        bit: {
          long: {
            one: "{0} bit",
            other: "{0} bits"
          },
          narrow: {
            other: "{0}bit"
          },
          perUnit: {},
          short: {
            other: "{0} bit"
          }
        },
        byte: {
          long: {
            one: "{0} byte",
            other: "{0} bytes"
          },
          narrow: {
            other: "{0}B"
          },
          perUnit: {},
          short: {
            other: "{0} byte"
          }
        },
        celsius: {
          long: {
            one: "{0} degree Celsius",
            other: "{0} degrees Celsius"
          },
          narrow: {
            other: "{0}°C"
          },
          perUnit: {},
          short: {
            other: "{0}°C"
          }
        },
        centimeter: {
          long: {
            one: "{0} centimeter",
            other: "{0} centimeters"
          },
          narrow: {
            other: "{0}cm"
          },
          perUnit: {
            long: "{0} per centimeter",
            narrow: "{0}/cm",
            short: "{0}/cm"
          },
          short: {
            other: "{0} cm"
          }
        },
        day: {
          long: {
            one: "{0} day",
            other: "{0} days"
          },
          narrow: {
            other: "{0}d"
          },
          perUnit: {
            long: "{0} per day",
            narrow: "{0}/d",
            short: "{0}/d"
          },
          short: {
            one: "{0} day",
            other: "{0} days"
          }
        },
        degree: {
          long: {
            one: "{0} degree",
            other: "{0} degrees"
          },
          narrow: {
            other: "{0}°"
          },
          perUnit: {},
          short: {
            other: "{0} deg"
          }
        },
        fahrenheit: {
          long: {
            one: "{0} degree Fahrenheit",
            other: "{0} degrees Fahrenheit"
          },
          narrow: {
            other: "{0}°"
          },
          perUnit: {},
          short: {
            other: "{0}°F"
          }
        },
        "fluid-ounce": {
          long: {
            one: "{0} fluid ounce",
            other: "{0} fluid ounces"
          },
          narrow: {
            other: "{0}fl oz"
          },
          perUnit: {},
          short: {
            other: "{0} fl oz"
          }
        },
        foot: {
          long: {
            one: "{0} foot",
            other: "{0} feet"
          },
          narrow: {
            other: "{0}′"
          },
          perUnit: {
            long: "{0} per foot",
            narrow: "{0}/ft",
            short: "{0}/ft"
          },
          short: {
            other: "{0} ft"
          }
        },
        gallon: {
          long: {
            one: "{0} gallon",
            other: "{0} gallons"
          },
          narrow: {
            other: "{0}gal"
          },
          perUnit: {
            long: "{0} per gallon",
            narrow: "{0}/gal",
            short: "{0}/gal US"
          },
          short: {
            other: "{0} gal"
          }
        },
        gigabit: {
          long: {
            one: "{0} gigabit",
            other: "{0} gigabits"
          },
          narrow: {
            other: "{0}Gb"
          },
          perUnit: {},
          short: {
            other: "{0} Gb"
          }
        },
        gigabyte: {
          long: {
            one: "{0} gigabyte",
            other: "{0} gigabytes"
          },
          narrow: {
            other: "{0}GB"
          },
          perUnit: {},
          short: {
            other: "{0} GB"
          }
        },
        gram: {
          long: {
            one: "{0} gram",
            other: "{0} grams"
          },
          narrow: {
            other: "{0}g"
          },
          perUnit: {
            long: "{0} per gram",
            narrow: "{0}/g",
            short: "{0}/g"
          },
          short: {
            other: "{0} g"
          }
        },
        hectare: {
          long: {
            one: "{0} hectare",
            other: "{0} hectares"
          },
          narrow: {
            other: "{0}ha"
          },
          perUnit: {},
          short: {
            other: "{0} ha"
          }
        },
        hour: {
          long: {
            one: "{0} hour",
            other: "{0} hours"
          },
          narrow: {
            other: "{0}h"
          },
          perUnit: {
            long: "{0} per hour",
            narrow: "{0}/h",
            short: "{0}/h"
          },
          short: {
            other: "{0} hr"
          }
        },
        inch: {
          long: {
            one: "{0} inch",
            other: "{0} inches"
          },
          narrow: {
            other: "{0}″"
          },
          perUnit: {
            long: "{0} per inch",
            narrow: "{0}/in",
            short: "{0}/in"
          },
          short: {
            other: "{0} in"
          }
        },
        kilobit: {
          long: {
            one: "{0} kilobit",
            other: "{0} kilobits"
          },
          narrow: {
            other: "{0}kb"
          },
          perUnit: {},
          short: {
            other: "{0} kb"
          }
        },
        kilobyte: {
          long: {
            one: "{0} kilobyte",
            other: "{0} kilobytes"
          },
          narrow: {
            other: "{0}kB"
          },
          perUnit: {},
          short: {
            other: "{0} kB"
          }
        },
        kilogram: {
          long: {
            one: "{0} kilogram",
            other: "{0} kilograms"
          },
          narrow: {
            other: "{0}kg"
          },
          perUnit: {
            long: "{0} per kilogram",
            narrow: "{0}/kg",
            short: "{0}/kg"
          },
          short: {
            other: "{0} kg"
          }
        },
        kilometer: {
          long: {
            one: "{0} kilometer",
            other: "{0} kilometers"
          },
          narrow: {
            other: "{0}km"
          },
          perUnit: {
            long: "{0} per kilometer",
            narrow: "{0}/km",
            short: "{0}/km"
          },
          short: {
            other: "{0} km"
          }
        },
        "kilometer-per-hour": {
          long: {
            one: "{0} kilometer per hour",
            other: "{0} kilometers per hour"
          },
          narrow: {
            other: "{0}km/h"
          },
          perUnit: {},
          short: {
            other: "{0} km/h"
          }
        },
        liter: {
          long: {
            one: "{0} liter",
            other: "{0} liters"
          },
          narrow: {
            other: "{0}L"
          },
          perUnit: {
            long: "{0} per liter",
            narrow: "{0}/L",
            short: "{0}/L"
          },
          short: {
            other: "{0} L"
          }
        },
        "liter-per-kilometer": {
          long: {
            one: "{0} liter per kilometer",
            other: "{0} liters per kilometer"
          },
          narrow: {
            other: "{0}L/km"
          },
          perUnit: {},
          short: {
            other: "{0} L/km"
          }
        },
        megabit: {
          long: {
            one: "{0} megabit",
            other: "{0} megabits"
          },
          narrow: {
            other: "{0}Mb"
          },
          perUnit: {},
          short: {
            other: "{0} Mb"
          }
        },
        megabyte: {
          long: {
            one: "{0} megabyte",
            other: "{0} megabytes"
          },
          narrow: {
            other: "{0}MB"
          },
          perUnit: {},
          short: {
            other: "{0} MB"
          }
        },
        meter: {
          long: {
            one: "{0} meter",
            other: "{0} meters"
          },
          narrow: {
            other: "{0}m"
          },
          perUnit: {
            long: "{0} per meter",
            narrow: "{0}/m",
            short: "{0}/m"
          },
          short: {
            other: "{0} m"
          }
        },
        "meter-per-second": {
          long: {
            one: "{0} meter per second",
            other: "{0} meters per second"
          },
          narrow: {
            other: "{0}m/s"
          },
          perUnit: {},
          short: {
            other: "{0} m/s"
          }
        },
        mile: {
          long: {
            one: "{0} mile",
            other: "{0} miles"
          },
          narrow: {
            other: "{0}mi"
          },
          perUnit: {},
          short: {
            other: "{0} mi"
          }
        },
        "mile-per-gallon": {
          long: {
            one: "{0} mile per gallon",
            other: "{0} miles per gallon"
          },
          narrow: {
            other: "{0}mpg"
          },
          perUnit: {},
          short: {
            other: "{0} mpg"
          }
        },
        "mile-per-hour": {
          long: {
            one: "{0} mile per hour",
            other: "{0} miles per hour"
          },
          narrow: {
            other: "{0}mph"
          },
          perUnit: {},
          short: {
            other: "{0} mph"
          }
        },
        "mile-scandinavian": {
          long: {
            one: "{0} mile-scandinavian",
            other: "{0} miles-scandinavian"
          },
          narrow: {
            other: "{0}smi"
          },
          perUnit: {},
          short: {
            other: "{0} smi"
          }
        },
        milliliter: {
          long: {
            one: "{0} milliliter",
            other: "{0} milliliters"
          },
          narrow: {
            other: "{0}mL"
          },
          perUnit: {},
          short: {
            other: "{0} mL"
          }
        },
        millimeter: {
          long: {
            one: "{0} millimeter",
            other: "{0} millimeters"
          },
          narrow: {
            other: "{0}mm"
          },
          perUnit: {},
          short: {
            other: "{0} mm"
          }
        },
        millisecond: {
          long: {
            one: "{0} millisecond",
            other: "{0} milliseconds"
          },
          narrow: {
            other: "{0}ms"
          },
          perUnit: {},
          short: {
            other: "{0} ms"
          }
        },
        minute: {
          long: {
            one: "{0} minute",
            other: "{0} minutes"
          },
          narrow: {
            other: "{0}m"
          },
          perUnit: {
            long: "{0} per minute",
            narrow: "{0}/min",
            short: "{0}/min"
          },
          short: {
            other: "{0} min"
          }
        },
        month: {
          long: {
            one: "{0} month",
            other: "{0} months"
          },
          narrow: {
            other: "{0}m"
          },
          perUnit: {
            long: "{0} per month",
            narrow: "{0}/m",
            short: "{0}/m"
          },
          short: {
            one: "{0} mth",
            other: "{0} mths"
          }
        },
        ounce: {
          long: {
            one: "{0} ounce",
            other: "{0} ounces"
          },
          narrow: {
            other: "{0}oz"
          },
          perUnit: {
            long: "{0} per ounce",
            narrow: "{0}/oz",
            short: "{0}/oz"
          },
          short: {
            other: "{0} oz"
          }
        },
        percent: {
          long: {
            other: "{0} percent"
          },
          narrow: {
            other: "{0}%"
          },
          perUnit: {},
          short: {
            other: "{0}%"
          }
        },
        petabyte: {
          long: {
            one: "{0} petabyte",
            other: "{0} petabytes"
          },
          narrow: {
            other: "{0}PB"
          },
          perUnit: {},
          short: {
            other: "{0} PB"
          }
        },
        pound: {
          long: {
            one: "{0} pound",
            other: "{0} pounds"
          },
          narrow: {
            other: "{0}#"
          },
          perUnit: {
            long: "{0} per pound",
            narrow: "{0}/lb",
            short: "{0}/lb"
          },
          short: {
            other: "{0} lb"
          }
        },
        second: {
          long: {
            one: "{0} second",
            other: "{0} seconds"
          },
          narrow: {
            other: "{0}s"
          },
          perUnit: {
            long: "{0} per second",
            narrow: "{0}/s",
            short: "{0}/s"
          },
          short: {
            other: "{0} sec"
          }
        },
        stone: {
          long: {
            one: "{0} stone",
            other: "{0} stones"
          },
          narrow: {
            other: "{0}st"
          },
          perUnit: {},
          short: {
            other: "{0} st"
          }
        },
        terabit: {
          long: {
            one: "{0} terabit",
            other: "{0} terabits"
          },
          narrow: {
            other: "{0}Tb"
          },
          perUnit: {},
          short: {
            other: "{0} Tb"
          }
        },
        terabyte: {
          long: {
            one: "{0} terabyte",
            other: "{0} terabytes"
          },
          narrow: {
            other: "{0}TB"
          },
          perUnit: {},
          short: {
            other: "{0} TB"
          }
        },
        week: {
          long: {
            one: "{0} week",
            other: "{0} weeks"
          },
          narrow: {
            other: "{0}w"
          },
          perUnit: {
            long: "{0} per week",
            narrow: "{0}/w",
            short: "{0}/w"
          },
          short: {
            one: "{0} wk",
            other: "{0} wks"
          }
        },
        yard: {
          long: {
            one: "{0} yard",
            other: "{0} yards"
          },
          narrow: {
            other: "{0}yd"
          },
          perUnit: {},
          short: {
            other: "{0} yd"
          }
        },
        year: {
          long: {
            one: "{0} year",
            other: "{0} years"
          },
          narrow: {
            other: "{0}y"
          },
          perUnit: {
            long: "{0} per year",
            narrow: "{0}/y",
            short: "{0}/y"
          },
          short: {
            one: "{0} yr",
            other: "{0} yrs"
          }
        }
      }
    }
  },
  locale: "en"
});
var mm;
((t) => {
  ((e) => {
    e.USER = "user", e.ADMIN = "admin";
  })(t.Role || (t.Role = {}));
})(mm || (mm = {}));
var Nm;
((t) => {
  ((e) => {
    e.SLACK = "slack", e.EMAIL = "email";
  })(t.AlertPlatform || (t.AlertPlatform = {}));
})(Nm || (Nm = {}));
var vm;
((t) => {
  ((e) => {
    e.FAR_OVER = "far_over", e.OVER = "over", e.GOOD = "good", e.UNDER = "under", e.FAR_UNDER = "far_under", e.TOO_EARLY = "too_early", e.INVALID = "invalid";
  })(t.BudgetStatus || (t.BudgetStatus = {}));
})(vm || (vm = {}));
var gm;
((t) => {
  ((e) => {
    e.DEAD_GROUP = "dead_group", e.TEST_ACCOUNT = "test_account", e.NO_STRIPE_CUSTOMER = "no_stripe_customer", e.CREATED_ACCOUNT = "created_account", e.CONNECTED_AW = "connected_aw", e.TRIALER = "trialer", e.UNLOCKED_TRIALER = "unlocked_trialer", e.UNPAID = "unpaid", e.RETRIALER = "retrialer", e.YOUNG_CUSTOMER = "young_customer", e.MATURE_CUSTOMER = "mature_customer", e.CANCELLED_TRIAL = "cancelled_trial", e.CANCELLED_CUSTOMER = "cancelled_customer", e.CANCELLED_AT_PERIOD_END_TRIAL = "cancelled_at_period_end_trial", e.CANCELLED_AT_PERIOD_END_CUSTOMER = "cancelled_at_period_end_customer", e.FREE_USER = "free_user";
  })(t.OpteoLifeCycleStage || (t.OpteoLifeCycleStage = {}));
})(gm || (gm = {}));
var e0;
((t) => {
  ((e) => {
    e.Basic = "plan-v4-s", e.Professional = "plan-v4-m", e.Agency = "plan-v4-l", e.Enterprise = "plan-v4-xl", e.YearlyBasic = "plan-v4-s-yearly", e.YearlyProfessional = "plan-v4-m-yearly", e.YearlyAgency = "plan-v4-l-yearly", e.YearlyEnterprise = "plan-v4-xl-yearly";
  })(t.LegacyPlan || (t.LegacyPlan = {})), ((e) => {
    e.Basic = "plan-v5-s", e.Professional = "plan-v5-m", e.Agency = "plan-v5-l", e.Enterprise = "plan-v5-xl", e.YearlyBasic = "plan-v5-s-yearly", e.YearlyProfessional = "plan-v5-m-yearly", e.YearlyAgency = "plan-v5-l-yearly", e.YearlyEnterprise = "plan-v5-xl-yearly";
  })(t.StandardPlan || (t.StandardPlan = {})), ((e) => {
    e.System = "plan-system", e.AgencyGrowth = "plan-agency-growth", e.TikTokAdvertiserPartner = "plan-tiktok-advertiser-partner", e.EnterpriseTrial = "plan-v5-enterprise-trial";
  })(t.SpecialPlan || (t.SpecialPlan = {})), t.Coupon = {
    ReportUpgrades20Percent3Months: "report-upgrades-20x3"
  }, t.FreeTrialLengthInDays = 14, ((e) => {
    e.COUPON_NOT_APPLICABLE_TO_PRODUCT = "COUPON_NOT_APPLICABLE_TO_PRODUCT", e.NO_SUBSCRIPTION_OR_PRODUCT = "NO_SUBSCRIPTION_OR_PRODUCT", e.INVALID_CODE = "INVALID_CODE", e.UNKNOWN_ERROR = "UNKNOWN_ERROR";
  })(t.CouponApplicationError || (t.CouponApplicationError = {}));
})(e0 || (e0 = {}));
var Im;
((t) => {
  ((e) => {
    e.NO_REFRESH_TOKEN = "No google analytics refresh token found", e.INVALID_TOKEN = "Invalid google analytics token", e.COULD_NOT_READ_RECENTLY_INSERTED_TOKEN = "Could not read recently inserted google analytics token", e.REVOKING_TOKEN = "Failed to get google analytics account data after storing token, revoking token", e.NO_LINKED_PROFILE_FOUND = "No linked google analytics profile was found", e.ACCESS_DENIED = "User cancelled authorization", e.NO_AUTHORIZATION_CODE = "We received no authorization code and google did not provide any error", e.NO_ACCESS_TOKEN = "Something unexpected happened and we received no access token after authorization", e.EMAIL_WITHOUT_ANALYTICS = "The email address you selected has no associated Google Analytics account. If it does, please contact support.", e.ACCESS_TOKEN_SCOPE_INSUFFICIENT = "Authorization failed due to insufficient permissions.", e.UNKNOWN_ERROR = "An unknown error occurred while linking your Google Analytics account. Please contact support.";
  })(t.Error || (t.Error = {})), ((e) => {
    e[e.Account = 0] = "Account", e[e.Property = 1] = "Property", e[e.Profile = 2] = "Profile";
  })(t.MatadataEntityType || (t.MatadataEntityType = {}));
})(Im || (Im = {}));
var S;
((t) => {
  t.SyncType = {
    GoogleAdsSync: "google_ads_sync",
    SyncPauseCampaign: "sync_pause_campaign",
    SyncKeywordBids: "sync_keyword_bids"
  }, t.Type = {
    // Special non-existent type
    NotExists: "not_exists",
    // Special meta improvement (generates all other imps)
    Meta: "refresh_cycling_improvements",
    // -- Improvements
    // Shared types
    AdComparison: "ad_comparison",
    AdComparisonV2: "ad_comparison_v2",
    Branding: "branding",
    Remarketing: "remarketing",
    BroadKeywords: "broad_keywords",
    BroadKeywordsV2: "broad_keywords_v2",
    BudgetCap: "budget_cap",
    ContentExclusions: "content_exclusions",
    LocationInterestV2: "location_interest_v2",
    SQR: "sqr",
    SqrShopping: "sqr_shopping",
    SKAGV1: "skag_v1",
    SKAG: "skag",
    KeywordCutoff: "keyword_cutoff",
    KeywordBids: "keyword_bids",
    KeywordBidsV2: "keyword_bids_v2",
    BrokenLink: "broken_link",
    DemographicBids: "demo_bids",
    DemographicGenderMod: "demographic_gender_mod",
    DemographicParentalMod: "demographic_parental_mod",
    DemographicAgeMod: "demographic_age_mod",
    PlacementExclusion: "placement_exclusion",
    MobileAppsExclusion: "mobile_apps_exclusion",
    PauseDuplicateKeywords: "pause_duplicate_keywords",
    PauseDuplicateKeywordsV2: "pause_duplicate_keywords_v2",
    SiteCategoryExclusions: "site_category_exclusions",
    FrequencyCapping: "frequency_capping",
    SearchPartnersSettings: "search_partners_settings",
    SearchPartners: "search_partners",
    // v2
    SpellChecker: "spell_checker",
    AdSchedule: "ad_schedule",
    AdScheduleV2: "ad_schedule_v2",
    RemovePlussedNegatives: "remove_plussed_negatives",
    CheckNegativesBlockingKeywords: "check_negatives_blocking_keywords",
    GeoBids: "geo_bids",
    LocationBids: "location_bids",
    ResyncSharedSetNegativeLists: "resync_shared_set_negative_lists",
    LocationInterests: "location_interests",
    NegativeGeoKeywords: "negative_geo_keywords",
    BidsBelowFirstPage: "bids_below_first_page",
    CampaignLevelExtensions: "campaign_level_extensions",
    AccountLevelExtensions: "account_level_extensions",
    ResyncExclusionLists: "resync_exclusion_lists",
    AttributionModel: "attribution_model",
    DeviceBids: "device_bids",
    RobotNegatives: "robot_negatives",
    CheckProductGroups: "check_product_groups",
    Ngram: "ngram",
    DeviceBidsV2: "device_bids_v2",
    TargetAdjustments: "target_adjustments",
    // Microsoft Ads types only
    KeywordBidsMs: "keyword_bids_ms",
    SQRMs: "sqr_ms",
    // --- Issues ---
    // Critical Issues
    SpendFlatlineIssue: "spend_flatline_issue",
    ConversionFlatlineIssue: "conversion_flatline_issue",
    PaymentCardExpiringIssue: "payment_card_expiring_issue",
    PaymentCardExpiredIssue: "payment_card_expired_issue",
    // Broken Link Issues
    BrokenLinkIssue: "broken_link_issue",
    // For general broken links that are issues
    BrokenSitelinkIssue: "broken_sitelink_issue",
    // Disapproval Issues
    DisapprovedEntityIssue: "disapproved_entity_issue",
    // Account Management Issues
    EmptyEntityIssue: "empty_entity_issue",
    LowActivityReactivationIssue: "low_activity_reactivation_issue",
    FailedLearningIssue: "failed_learning_issue",
    // Spelling Error Issues
    SpellingErrorIssue: "spelling_error_issue",
    ...t.SyncType,
    // Multi-platform types
    SegmentExclusions: "segment_exclusions",
    SettingFlippers: "setting_flippers"
  }, t.RecAction = {
    // Google
    AddCallExtension: "add_call_extension",
    AddCalloutExtension: "add_callout_extension",
    AddCampaignLevelCalloutExtension: "add_campaign_level_callout_extension",
    AddCampaignLevelSitelinkExtension: "add_campaign_level_sitelink_extension",
    AddCampaignLevelSnippetExtension: "add_campaign_level_snippet_extension",
    AddFrequencyCapping: "add_frequency_capping",
    AddMissingCampaignsToSharedSet: "add_missing_campaigns_to_shared_set",
    AddLocationNameAsNegative: "add_location_name_as_negative",
    AddNegativeListShopping: "add_negative_list_shopping",
    AddNegativeWord: "add_negative_word",
    AddRobotNegative: "add_robot_negative",
    AddSiteExclusions: "add_site_exclusions",
    AddSitelinkExtension: "add_sitelink_extension",
    AddSkagV1: "add_skag",
    AddSkagV2: "add_skag_v2",
    AddStructuredSnippetsExtension: "add_structured_snippets_extension",
    AdjustAdGroupMultiTargets: "adjust_ad_group_multi_targets",
    AdjustAdScheduleBids: "adjust_ad_schedule_bids",
    AdjustAdScheduleBidsV2: "adjust_ad_schedule_bids_v2",
    AdjustSingleAgeBid: "adjust_single_age_bid",
    AdjustSingleGenderBid: "adjust_single_gender_bid",
    AdjustSingleParentalStatusBid: "adjust_single_parental_status_bid",
    AdjustSingleIncomeBid: "adjust_single_income_bid",
    ExcludeAgeDemographic: "exclude_age_demographic",
    ExcludeGenderDemographic: "exclude_gender_demographic",
    ExcludeParentalStatusDemographic: "exclude_parental_status_demographic",
    ExcludeIncomeDemographic: "exclude_income_demographic",
    AdjustMultipleAgeBids: "adjust_multiple_age_bids",
    AdjustMultipleGenderBids: "adjust_multiple_gender_bids",
    AdjustMultipleParentalStatusBids: "adjust_multiple_parental_status_bids",
    AdjustMultipleIncomeBids: "adjust_multiple_income_bids",
    AdjustAgeBid: "adjust_age_bid",
    AdjustAttributionModel: "adjust_attribution_model",
    AdjustDeviceBid: "adjust_device_bid",
    AdjustGenderBid: "adjust_gender_bid",
    AdjustGeoBids: "adjust_geo_bids",
    AdjustLocationBids: "adjust_location_bids",
    ExcludeLocation: "exclude_location",
    AdjustKeywordBid: "adjust_keyword_bid",
    AdjustKeywordBidV2: "adjust_keyword_bid_v2",
    AdjustParentalBid: "adjust_parental_bid",
    AdjustProductGroupBid: "adjust_product_group_bid",
    CheckAdSpelling: "check_ad_spelling",
    CheckQueryRelevance: "check_query_relevance",
    CreateBrandCampaign: "create_brand_campaign",
    CreateRemarketingCampaign: "create_remarketing_campaign",
    DisableInterestLocations: "disable_interest_locations",
    DisableInterestLocationsV2: "disable_interest_locations_v2",
    DisableSearchPartners: "disable_search_partners",
    DuplicateKeyword: "duplicate_keyword",
    ExcludeWebsitePlacement: "exclude_website_placement",
    ExcludeMobileAppPlacement: "exclude_mobile_app_placement",
    ExcludeYoutubePlacement: "exclude_youtube_placement",
    ExcludeGmailPlacement: "exclude_gmail_placement",
    ExcludePlacement: "exclude_placement",
    ExcludeMobileApps: "exclude_mobile_apps",
    FixBelowFirstPageBid: "fix_below_first_page_bid",
    FixBrokenLink: "fix_broken_link",
    FixBrokenSitelink: "fix_broken_sitelink",
    FixNegativesBlockingKeywords: "fix_negatives_blocking_keywords",
    IncreaseKeywordBidV2: "increase_keyword_bid_v2",
    LiftCampaignBudgetCap: "lift_campaign_budget_cap",
    PauseAd: "pause_ad",
    PauseAdV2: "pause_ad_v2",
    PauseDuplicateKeywords: "pause_duplicate_keywords",
    PauseDuplicateKeywordsV2: "pause_duplicate_keywords_v2",
    PauseKeyword: "pause_keyword",
    PauseKeywordV2: "pause_keyword_v2",
    ReduceCampaignBids: "reduce_campaign_bids",
    ReduceWordBids: "reduce_word_bids",
    RemoveBroadKeywords: "remove_broad_keywords",
    RemoveBroadKeywordsV2: "remove_broad_keywords_v2",
    RemovePlussedNegatives: "remove_plussed_negatives",
    ResyncExclusionLists: "resync_exclusion_lists",
    ResyncProductGroups: "resync_product_groups",
    SearchPartnersSettings: "search_partners_settings",
    SubdivideProductGroup: "subdivide_product_group",
    WriteAd: "write_ad",
    WriteAdV2: "write_ad_v2",
    AddNegativeNgram: "add_negative_ngram",
    ReduceNgramBids: "reduce_ngram_bids",
    AdjustSingleDeviceBid: "adjust_single_device_bid",
    AdjustMultipleDeviceBids: "adjust_multiple_device_bids",
    ExcludeSingleDevice: "exclude_single_device",
    // Microsoft
    CheckQueryRelevanceMs: "check_query_relevance_ms",
    PauseKeywordMs: "pause_keyword_ms",
    AdjustKeywordBidMs: "adjust_keyword_bid_ms",
    IncreaseKeywordBidMs: "increase_keyword_bid_ms",
    // Multi-Platform
    // Exclude Segment (Google)
    ExcludeSegmentCountryGA: "exclude_country_ga",
    ExcludeSegmentStateGA: "exclude_us_state_ga",
    ExcludeSegmentDeviceGA: "exclude_device_ga",
    ExcludeSegmentContentNetworkGA: "disable_content_network_ga",
    ExcludeSegmentSearchPartnersGA: "disable_search_partners_ga",
    ExcludeSegmentAgeDemoGA: "exclude_age_demo_ga",
    ExcludeSegmentGenderGA: "exclude_gender_ga",
    ExcludeSegmentIncomeGA: "exclude_income_ga",
    ExcludeSegmentParentalStatusGA: "exclude_parental_status_ga",
    ExcludeSegmentCityGA: "exclude_city_ga",
    ExcludeSegmentLandingPageGA: "exclude_landing_page_ga",
    ExcludeSegment: "exclude_segment",
    // Exclude Segment (Microsoft)
    ExcludeSegmentCountryMS: "exclude_country_ms",
    ExcludeSegmentStateMS: "exclude_us_state_ms",
    ExcludeSegmentDeviceMS: "exclude_device_ms",
    ExcludeSegmentSyndicatedSearchMS: "disable_syndicated_search_ms",
    ExcludeSegmentAgeDemoMS: "exclude_age_demo_ms",
    ExcludeSegmentGenderMS: "exclude_gender_ms",
    ExcludeSegmentCityMS: "exclude_city_ms",
    // Exclude Segment (Meta)
    ExcludeSegmentCountryME: "exclude_country_me",
    ExcludeSegmentDeviceME: "exclude_device_me",
    ExcludeSegmentPublisherPlatformME: "exclude_publisher_platform_me",
    ExcludeSegmentAgeDemoME: "exclude_age_demo_me",
    ExcludeSegmentGenderME: "exclude_gender_me",
    // Exclude Segment (LinkedIn)
    ExcludeSegmentCountryLI: "exclude_country_li",
    ExcludeSegmentStateLI: "exclude_us_state_li",
    ExcludeSegmentOffsiteDeliveryLI: "disable_offsite_delivery_li",
    ExcludeSegmentCompanyLI: "exclude_company_li",
    ExcludeSegmentCompanySizeLI: "exclude_company_size_li",
    ExcludeSegmentMemberIndustryLI: "exclude_member_industry_li",
    ExcludeSegmentMemberJobFunctionLI: "exclude_member_job_function_li",
    ExcludeSegmentMemberJobTitleLI: "exclude_member_job_title_li",
    ExcludeSegmentMemberSeniorityLI: "exclude_member_seniority_li",
    // Setting Flipper (Google)
    GADisableAdGroupOptimizedTargetingEnabled: "ga_disable_ad_group_optimized_targeting_enabled",
    GADisableBroadMatchAsDefault: "ga_disable_broad_match_as_default",
    GAOptOutTextAssetAutomation: "ga_opt_out_text_asset_automation",
    GAAccountRecommendLimitedBrandSafetySuitability: "ga_account_recommend_limited_brand_safety_suitability",
    GAAccountToggleRecommendationSubscriptions: "ga_account_toggle_recommendation_subscriptions",
    // Setting Flipper (Microsoft)
    MSAccountGetAutoApplyOptInStatus: "ms_account_get_auto_apply_opt_in_status",
    MSCampaignPeopleInOrSearchingForOrViewingPages: "ms_campaign_people_in_or_searching_for_or_viewing_pages",
    MSCampaignAutoGeneratedTextOptOut: "ms_campaign_auto_generated_text_opt_out",
    MSCampaignFinalUrlExpansionOptOut: "ms_campaign_final_url_expansion_opt_out",
    MSCampaignAutoGeneratedImageOptOut: "ms_campaign_auto_generated_image_opt_out",
    MSCampaignAutoGeneratedAssetsEnabled: "ms_campaign_auto_generated_assets_enabled",
    // Setting Flipper (Meta)
    DisableImageTouchups: "disable_image_touchups",
    DisableImageTemplates: "disable_image_templates",
    DisableTextOptimizations: "disable_text_optimizations",
    DisableVideoAutoCrop: "disable_video_auto_crop",
    // Setting Flipper (Linkedin)
    DisableAudienceExpansionLi: "disable_audience_expansion_li",
    AdjustCreativeSelectionLi: "adjust_creative_selection_li",
    AdjustAdTargetingFacetLocationLi: "adjust_ad_targeting_facet_location_li",
    // Issues
    RecheckDisapprovedAd: "recheck_disapproved_ad",
    RecheckDisapprovedKeyword: "recheck_disapproved_keyword",
    RecheckEmptyCampaign: "recheck_empty_campaign",
    RecheckEmptyAdGroup: "recheck_empty_ad_group",
    RecheckBrokenLink: "recheck_broken_link",
    RecheckFailedLearning: "recheck_failed_learning",
    RecheckSpellingError: "recheck_spelling_error",
    RecheckReactivatedKeyword: "recheck_reactivated_keyword",
    RecheckReactivatedAdGroup: "recheck_reactivated_ad_group"
  }, ((e) => {
    e[e.SEVEN_DAYS = 7] = "SEVEN_DAYS", e[e.FOURTEEN_DAYS = 14] = "FOURTEEN_DAYS", e[e.THIRTY_DAYS = 30] = "THIRTY_DAYS", e[e.FOURTY_FIVE_DAYS = 45] = "FOURTY_FIVE_DAYS", e[e.SIXTY_DAYS = 60] = "SIXTY_DAYS", e[e.NINETY_DAYS = 90] = "NINETY_DAYS", e[e.ONE_HUNDRED_EIGHTY_DAYS = 180] = "ONE_HUNDRED_EIGHTY_DAYS", e[e.ONE_YEAR = 365] = "ONE_YEAR";
  })(t.LookbackWindow || (t.LookbackWindow = {})), ((e) => {
    e.AccountLevel = "account-level", e.Ad = "ad", e.AdGroup = "adgroup", e.AssetGroup = "asset-group", e.Campaign = "campaign", e.CampaignGroup = "campaign-group", e.ConversionAction = "conversion-action", e.Demographic = "demographic", e.Device = "device", e.Experiment = "experiment", e.Extension = "extension", e.Keyword = "keyword", e.Location = "location", e.NGram = "n-gram", e.NegativeKeyword = "negative-keyword", e.NegativeList = "negative-list", e.Pause = "pause", e.Placement = "placement", e.PlacementExclusionList = "placement-exclusion-list", e.Product = "product", e.ProductGroup = "product-group", e.ReplacementKeyword = "replacement-keyword", e.SearchTerm = "search-term", e.URL = "url", e.Word = "word";
  })(t.LocationEntity || (t.LocationEntity = {})), t.Error = {
    INVALID_REC_ACTION: "improvement_invalid_rec_action",
    INVALID_TYPE: "improvement_invalid_type",
    IMPROVEMENT_NOT_FOUND: "improvement_not_found",
    READ_ONLY_DOMAIN: "read_only_domain",
    MISSING_IMPROVEMENT_ID: "missing_improvement_id",
    MISSING_DOMAIN_ID: "missing_domain_id",
    MISSING_USER_ID: "missing_user_id",
    // `unique_fields` must be either "hash" or an array of body keys
    INVALID_UNIQUE_FIELDS: "invalid_unique_fields",
    INVALID_UNIQUE_FUNCTION: "invalid_unique_function",
    MISSING_UNIQUE_KEY_GENERATOR: "missing_unique_key_generator",
    BAD_JSON_IN_BODY: "bad_json_in_body",
    INVALID_DOMAIN: "domain_invalid",
    MISSING_ACCOUNT_ID: "missing_account_id",
    BAD_PLATFORM_FOR_IMP_TYPE: "bad_platform_for_imp_type"
  }, ((e) => {
    e[e.Active = 0] = "Active", e[e.Expired = 1] = "Expired", e[e.Completed = 2] = "Completed", e[e.Deferred = 3] = "Deferred";
  })(t.Status || (t.Status = {})), ((e) => {
    e.Week = "week", e.Month = "month", e.Forever = "forever";
  })(t.DeferDuration || (t.DeferDuration = {}));
})(S || (S = {}));
const dR = {
  [S.RecAction.PauseAd]: S.Type.AdComparison,
  [S.RecAction.WriteAd]: S.Type.AdComparison,
  [S.RecAction.PauseAdV2]: S.Type.AdComparisonV2,
  [S.RecAction.WriteAdV2]: S.Type.AdComparisonV2,
  [S.RecAction.CreateBrandCampaign]: S.Type.Branding,
  [S.RecAction.CreateRemarketingCampaign]: S.Type.Remarketing,
  [S.RecAction.RemoveBroadKeywords]: S.Type.BroadKeywords,
  [S.RecAction.RemoveBroadKeywordsV2]: S.Type.BroadKeywordsV2,
  [S.RecAction.LiftCampaignBudgetCap]: S.Type.BudgetCap,
  [S.RecAction.ReduceCampaignBids]: S.Type.BudgetCap,
  [S.RecAction.CheckQueryRelevance]: S.Type.SQR,
  [S.RecAction.AddNegativeListShopping]: S.Type.SqrShopping,
  [S.RecAction.AddSkagV1]: S.Type.SKAGV1,
  [S.RecAction.AddSkagV2]: S.Type.SKAG,
  [S.RecAction.DuplicateKeyword]: S.Type.NotExists,
  [S.RecAction.PauseKeyword]: S.Type.KeywordCutoff,
  [S.RecAction.AdjustKeywordBid]: S.Type.KeywordBids,
  [S.RecAction.PauseKeywordV2]: S.Type.KeywordBidsV2,
  [S.RecAction.AdjustKeywordBidV2]: S.Type.KeywordBidsV2,
  [S.RecAction.IncreaseKeywordBidV2]: S.Type.KeywordBidsV2,
  [S.RecAction.FixBrokenLink]: S.Type.BrokenLink,
  [S.RecAction.FixBrokenSitelink]: S.Type.BrokenLink,
  [S.RecAction.AdjustGenderBid]: S.Type.DemographicGenderMod,
  [S.RecAction.AdjustParentalBid]: S.Type.DemographicParentalMod,
  [S.RecAction.AdjustAgeBid]: S.Type.DemographicAgeMod,
  [S.RecAction.ReduceNgramBids]: S.Type.Ngram,
  [S.RecAction.AddNegativeNgram]: S.Type.Ngram,
  [S.RecAction.ExcludePlacement]: S.Type.PlacementExclusion,
  [S.RecAction.ExcludeMobileApps]: S.Type.MobileAppsExclusion,
  [S.RecAction.PauseDuplicateKeywords]: S.Type.PauseDuplicateKeywords,
  [S.RecAction.PauseDuplicateKeywordsV2]: S.Type.PauseDuplicateKeywordsV2,
  [S.RecAction.AddSiteExclusions]: S.Type.SiteCategoryExclusions,
  [S.RecAction.AddFrequencyCapping]: S.Type.FrequencyCapping,
  [S.RecAction.SearchPartnersSettings]: S.Type.SearchPartnersSettings,
  [S.RecAction.DisableSearchPartners]: S.Type.SearchPartners,
  [S.RecAction.CheckAdSpelling]: S.Type.SpellChecker,
  [S.RecAction.AdjustAdScheduleBids]: S.Type.AdSchedule,
  [S.RecAction.AdjustAdScheduleBidsV2]: S.Type.AdScheduleV2,
  [S.RecAction.RemovePlussedNegatives]: S.Type.RemovePlussedNegatives,
  [S.RecAction.FixNegativesBlockingKeywords]: S.Type.CheckNegativesBlockingKeywords,
  [S.RecAction.AdjustGeoBids]: S.Type.GeoBids,
  [S.RecAction.AdjustLocationBids]: S.Type.LocationBids,
  [S.RecAction.ExcludeLocation]: S.Type.LocationBids,
  [S.RecAction.AddMissingCampaignsToSharedSet]: S.Type.ResyncSharedSetNegativeLists,
  [S.RecAction.DisableInterestLocations]: S.Type.LocationInterests,
  [S.RecAction.DisableInterestLocationsV2]: S.Type.LocationInterestV2,
  [S.RecAction.AddLocationNameAsNegative]: S.Type.NegativeGeoKeywords,
  [S.RecAction.FixBelowFirstPageBid]: S.Type.BidsBelowFirstPage,
  [S.RecAction.AddCallExtension]: S.Type.AccountLevelExtensions,
  [S.RecAction.AddCalloutExtension]: S.Type.AccountLevelExtensions,
  [S.RecAction.AddSitelinkExtension]: S.Type.AccountLevelExtensions,
  [S.RecAction.AddStructuredSnippetsExtension]: S.Type.AccountLevelExtensions,
  [S.RecAction.AddCampaignLevelSitelinkExtension]: S.Type.CampaignLevelExtensions,
  [S.RecAction.AddCampaignLevelCalloutExtension]: S.Type.CampaignLevelExtensions,
  [S.RecAction.AddCampaignLevelSnippetExtension]: S.Type.CampaignLevelExtensions,
  [S.RecAction.ResyncExclusionLists]: S.Type.ResyncExclusionLists,
  [S.RecAction.AdjustAttributionModel]: S.Type.AttributionModel,
  [S.RecAction.AdjustDeviceBid]: S.Type.DeviceBids,
  [S.RecAction.AdjustProductGroupBid]: S.Type.CheckProductGroups,
  [S.RecAction.ResyncProductGroups]: S.Type.CheckProductGroups,
  [S.RecAction.SubdivideProductGroup]: S.Type.CheckProductGroups,
  [S.RecAction.AddRobotNegative]: S.Type.RobotNegatives,
  [S.RecAction.ExcludeWebsitePlacement]: S.Type.ContentExclusions,
  [S.RecAction.ExcludeMobileAppPlacement]: S.Type.ContentExclusions,
  [S.RecAction.ExcludeYoutubePlacement]: S.Type.ContentExclusions,
  [S.RecAction.ExcludeGmailPlacement]: S.Type.ContentExclusions,
  [S.RecAction.AdjustSingleAgeBid]: S.Type.DemographicBids,
  [S.RecAction.AdjustSingleGenderBid]: S.Type.DemographicBids,
  [S.RecAction.AdjustSingleParentalStatusBid]: S.Type.DemographicBids,
  [S.RecAction.AdjustSingleIncomeBid]: S.Type.DemographicBids,
  [S.RecAction.ExcludeAgeDemographic]: S.Type.DemographicBids,
  [S.RecAction.ExcludeGenderDemographic]: S.Type.DemographicBids,
  [S.RecAction.ExcludeParentalStatusDemographic]: S.Type.DemographicBids,
  [S.RecAction.ExcludeIncomeDemographic]: S.Type.DemographicBids,
  [S.RecAction.AdjustMultipleAgeBids]: S.Type.DemographicBids,
  [S.RecAction.AdjustMultipleGenderBids]: S.Type.DemographicBids,
  [S.RecAction.AdjustMultipleParentalStatusBids]: S.Type.DemographicBids,
  [S.RecAction.AdjustMultipleIncomeBids]: S.Type.DemographicBids,
  [S.RecAction.AddNegativeWord]: S.Type.NotExists,
  [S.RecAction.ReduceWordBids]: S.Type.NotExists,
  [S.RecAction.AdjustAdGroupMultiTargets]: S.Type.TargetAdjustments,
  [S.RecAction.CheckQueryRelevanceMs]: S.Type.SQRMs,
  [S.RecAction.PauseKeywordMs]: S.Type.KeywordBidsMs,
  [S.RecAction.AdjustKeywordBidMs]: S.Type.KeywordBidsMs,
  [S.RecAction.IncreaseKeywordBidMs]: S.Type.KeywordBidsMs,
  [S.RecAction.AdjustSingleDeviceBid]: S.Type.DeviceBidsV2,
  [S.RecAction.AdjustMultipleDeviceBids]: S.Type.DeviceBidsV2,
  [S.RecAction.ExcludeSingleDevice]: S.Type.DeviceBidsV2,
  [S.RecAction.RecheckDisapprovedAd]: S.Type.DisapprovedEntityIssue,
  [S.RecAction.RecheckDisapprovedKeyword]: S.Type.DisapprovedEntityIssue,
  [S.RecAction.RecheckEmptyCampaign]: S.Type.EmptyEntityIssue,
  [S.RecAction.RecheckEmptyAdGroup]: S.Type.EmptyEntityIssue,
  [S.RecAction.RecheckBrokenLink]: S.Type.BrokenLinkIssue,
  [S.RecAction.RecheckFailedLearning]: S.Type.FailedLearningIssue,
  [S.RecAction.RecheckSpellingError]: S.Type.SpellingErrorIssue,
  [S.RecAction.RecheckReactivatedKeyword]: S.Type.LowActivityReactivationIssue,
  [S.RecAction.RecheckReactivatedAdGroup]: S.Type.LowActivityReactivationIssue,
  [S.RecAction.DisableImageTouchups]: S.Type.SettingFlippers,
  [S.RecAction.DisableImageTemplates]: S.Type.SettingFlippers,
  [S.RecAction.DisableTextOptimizations]: S.Type.SettingFlippers,
  [S.RecAction.DisableVideoAutoCrop]: S.Type.SettingFlippers,
  [S.RecAction.GADisableAdGroupOptimizedTargetingEnabled]: S.Type.SettingFlippers,
  [S.RecAction.GADisableBroadMatchAsDefault]: S.Type.SettingFlippers,
  [S.RecAction.GAOptOutTextAssetAutomation]: S.Type.SettingFlippers,
  [S.RecAction.GAAccountRecommendLimitedBrandSafetySuitability]: S.Type.SettingFlippers,
  [S.RecAction.GAAccountToggleRecommendationSubscriptions]: S.Type.SettingFlippers,
  [S.RecAction.DisableAudienceExpansionLi]: S.Type.SettingFlippers,
  [S.RecAction.AdjustCreativeSelectionLi]: S.Type.SettingFlippers,
  [S.RecAction.AdjustAdTargetingFacetLocationLi]: S.Type.SettingFlippers,
  [S.RecAction.MSAccountGetAutoApplyOptInStatus]: S.Type.SettingFlippers,
  [S.RecAction.MSCampaignPeopleInOrSearchingForOrViewingPages]: S.Type.SettingFlippers,
  [S.RecAction.MSCampaignAutoGeneratedAssetsEnabled]: S.Type.SettingFlippers,
  [S.RecAction.MSCampaignAutoGeneratedImageOptOut]: S.Type.SettingFlippers,
  [S.RecAction.MSCampaignAutoGeneratedTextOptOut]: S.Type.SettingFlippers,
  [S.RecAction.MSCampaignFinalUrlExpansionOptOut]: S.Type.SettingFlippers,
  [S.RecAction.ExcludeSegment]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentCountryMS]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentCountryME]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentCountryLI]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentDeviceGA]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentDeviceMS]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentDeviceME]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentAgeDemoMS]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentAgeDemoME]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentGenderMS]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentGenderME]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentStateMS]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentStateGA]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentStateLI]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentCompanyLI]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentCompanySizeLI]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentMemberIndustryLI]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentMemberJobFunctionLI]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentMemberJobTitleLI]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentMemberSeniorityLI]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentContentNetworkGA]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentSearchPartnersGA]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentOffsiteDeliveryLI]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentSyndicatedSearchMS]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentPublisherPlatformME]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentCountryGA]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentCityGA]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentCityMS]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentAgeDemoGA]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentGenderGA]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentIncomeGA]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentParentalStatusGA]: S.Type.SegmentExclusions,
  [S.RecAction.ExcludeSegmentLandingPageGA]: S.Type.SegmentExclusions
}, fR = {
  [S.RecAction.AdjustSingleAgeBid]: "adjustments",
  [S.RecAction.AdjustSingleGenderBid]: "adjustments",
  [S.RecAction.AdjustSingleIncomeBid]: "adjustments",
  [S.RecAction.AdjustSingleParentalStatusBid]: "adjustments",
  [S.RecAction.AdjustMultipleAgeBids]: "adjustments",
  [S.RecAction.AdjustMultipleGenderBids]: "adjustments",
  [S.RecAction.AdjustMultipleIncomeBids]: "adjustments",
  [S.RecAction.AdjustMultipleParentalStatusBids]: "adjustments",
  [S.RecAction.AdjustSingleDeviceBid]: "adjustments",
  [S.RecAction.AdjustMultipleDeviceBids]: "adjustments",
  [S.RecAction.AdjustLocationBids]: "adjustments",
  [S.RecAction.AddFrequencyCapping]: "adjustments",
  [S.RecAction.LiftCampaignBudgetCap]: "adjustments",
  [S.RecAction.ReduceCampaignBids]: "adjustments",
  [S.RecAction.ReduceNgramBids]: "adjustments",
  [S.RecAction.AdjustAdGroupMultiTargets]: "adjustments",
  [S.RecAction.DisableImageTouchups]: "adjustments",
  [S.RecAction.DisableImageTemplates]: "adjustments",
  [S.RecAction.DisableTextOptimizations]: "adjustments",
  [S.RecAction.DisableVideoAutoCrop]: "adjustments",
  [S.RecAction.GADisableAdGroupOptimizedTargetingEnabled]: "adjustments",
  [S.RecAction.GADisableBroadMatchAsDefault]: "adjustments",
  [S.RecAction.GAOptOutTextAssetAutomation]: "adjustments",
  [S.RecAction.GAAccountRecommendLimitedBrandSafetySuitability]: "adjustments",
  [S.RecAction.GAAccountToggleRecommendationSubscriptions]: "adjustments",
  [S.RecAction.DisableAudienceExpansionLi]: "adjustments",
  [S.RecAction.AdjustCreativeSelectionLi]: "adjustments",
  [S.RecAction.AdjustAdTargetingFacetLocationLi]: "adjustments",
  [S.RecAction.MSAccountGetAutoApplyOptInStatus]: "adjustments",
  [S.RecAction.MSCampaignPeopleInOrSearchingForOrViewingPages]: "adjustments",
  [S.RecAction.MSCampaignAutoGeneratedAssetsEnabled]: "adjustments",
  [S.RecAction.MSCampaignAutoGeneratedImageOptOut]: "adjustments",
  [S.RecAction.MSCampaignAutoGeneratedTextOptOut]: "adjustments",
  [S.RecAction.MSCampaignFinalUrlExpansionOptOut]: "adjustments",
  [S.RecAction.ExcludeAgeDemographic]: "exclusions",
  [S.RecAction.ExcludeGenderDemographic]: "exclusions",
  [S.RecAction.ExcludeIncomeDemographic]: "exclusions",
  [S.RecAction.ExcludeParentalStatusDemographic]: "exclusions",
  [S.RecAction.ExcludeYoutubePlacement]: "exclusions",
  [S.RecAction.ExcludeGmailPlacement]: "exclusions",
  [S.RecAction.ExcludeWebsitePlacement]: "exclusions",
  [S.RecAction.ExcludeMobileAppPlacement]: "exclusions",
  [S.RecAction.ExcludeSingleDevice]: "exclusions",
  [S.RecAction.ExcludeLocation]: "exclusions",
  [S.RecAction.DisableInterestLocationsV2]: "exclusions",
  [S.RecAction.DisableSearchPartners]: "exclusions",
  [S.RecAction.CheckQueryRelevance]: "keywords",
  [S.RecAction.CheckQueryRelevanceMs]: "keywords",
  [S.RecAction.PauseKeywordV2]: "keywords",
  [S.RecAction.PauseKeywordMs]: "keywords",
  [S.RecAction.FixNegativesBlockingKeywords]: "keywords",
  [S.RecAction.AdjustKeywordBidV2]: "keywords",
  [S.RecAction.AdjustKeywordBidMs]: "keywords",
  [S.RecAction.IncreaseKeywordBidV2]: "keywords",
  [S.RecAction.IncreaseKeywordBidMs]: "keywords",
  [S.RecAction.RemoveBroadKeywordsV2]: "keywords",
  [S.RecAction.PauseDuplicateKeywordsV2]: "keywords",
  [S.RecAction.AddRobotNegative]: "negatives",
  [S.RecAction.AddLocationNameAsNegative]: "negatives",
  [S.RecAction.AddNegativeNgram]: "negatives",
  [S.RecAction.AddMissingCampaignsToSharedSet]: "negatives",
  [S.RecAction.ResyncExclusionLists]: "negatives",
  [S.RecAction.DuplicateKeyword]: "deprecated",
  [S.RecAction.ReduceWordBids]: "deprecated",
  [S.RecAction.FixBelowFirstPageBid]: "deprecated",
  [S.RecAction.AddCampaignLevelCalloutExtension]: "deprecated",
  [S.RecAction.AddCampaignLevelSitelinkExtension]: "deprecated",
  [S.RecAction.AddCampaignLevelSnippetExtension]: "deprecated",
  [S.RecAction.AddNegativeWord]: "deprecated",
  [S.RecAction.AddSiteExclusions]: "deprecated",
  [S.RecAction.AddSitelinkExtension]: "deprecated",
  [S.RecAction.AddSkagV1]: "deprecated",
  [S.RecAction.AddSkagV2]: "deprecated",
  [S.RecAction.AddStructuredSnippetsExtension]: "deprecated",
  [S.RecAction.AdjustAdScheduleBids]: "deprecated",
  [S.RecAction.AdjustAdScheduleBidsV2]: "deprecated",
  [S.RecAction.AdjustKeywordBid]: "deprecated",
  [S.RecAction.CheckAdSpelling]: "deprecated",
  [S.RecAction.CreateBrandCampaign]: "deprecated",
  [S.RecAction.CreateRemarketingCampaign]: "deprecated",
  [S.RecAction.FixBrokenLink]: "deprecated",
  [S.RecAction.FixBrokenSitelink]: "deprecated",
  [S.RecAction.PauseAd]: "deprecated",
  [S.RecAction.PauseAdV2]: "deprecated",
  [S.RecAction.RemovePlussedNegatives]: "deprecated",
  [S.RecAction.WriteAd]: "deprecated",
  [S.RecAction.WriteAdV2]: "deprecated",
  [S.RecAction.ResyncProductGroups]: "deprecated",
  [S.RecAction.AddCallExtension]: "deprecated",
  [S.RecAction.AddCalloutExtension]: "deprecated",
  [S.RecAction.PauseDuplicateKeywords]: "deprecated",
  [S.RecAction.PauseKeyword]: "deprecated",
  [S.RecAction.RemoveBroadKeywords]: "deprecated",
  [S.RecAction.AddNegativeListShopping]: "deprecated",
  [S.RecAction.AdjustAgeBid]: "deprecated",
  [S.RecAction.AdjustAttributionModel]: "deprecated",
  [S.RecAction.AdjustDeviceBid]: "deprecated",
  [S.RecAction.AdjustGenderBid]: "deprecated",
  [S.RecAction.AdjustGeoBids]: "deprecated",
  [S.RecAction.AdjustParentalBid]: "deprecated",
  [S.RecAction.AdjustProductGroupBid]: "deprecated",
  [S.RecAction.DisableInterestLocations]: "deprecated",
  [S.RecAction.SearchPartnersSettings]: "deprecated",
  [S.RecAction.SubdivideProductGroup]: "deprecated",
  [S.RecAction.ExcludePlacement]: "deprecated",
  [S.RecAction.ExcludeMobileApps]: "deprecated",
  [S.RecAction.RecheckDisapprovedAd]: "disapprovals",
  [S.RecAction.RecheckDisapprovedKeyword]: "disapprovals",
  [S.RecAction.RecheckBrokenLink]: "broken_links",
  [S.RecAction.RecheckSpellingError]: "spelling_errors",
  [S.RecAction.RecheckEmptyCampaign]: "account_management",
  [S.RecAction.RecheckEmptyAdGroup]: "account_management",
  [S.RecAction.RecheckFailedLearning]: "account_management",
  [S.RecAction.RecheckReactivatedKeyword]: "account_management",
  [S.RecAction.RecheckReactivatedAdGroup]: "account_management",
  [S.RecAction.ExcludeSegment]: "exclusions",
  [S.RecAction.ExcludeSegmentCountryMS]: "exclusions",
  [S.RecAction.ExcludeSegmentCountryME]: "exclusions",
  [S.RecAction.ExcludeSegmentCountryLI]: "exclusions",
  [S.RecAction.ExcludeSegmentDeviceGA]: "exclusions",
  [S.RecAction.ExcludeSegmentDeviceMS]: "exclusions",
  [S.RecAction.ExcludeSegmentDeviceME]: "exclusions",
  [S.RecAction.ExcludeSegmentAgeDemoMS]: "exclusions",
  [S.RecAction.ExcludeSegmentAgeDemoME]: "exclusions",
  [S.RecAction.ExcludeSegmentGenderMS]: "exclusions",
  [S.RecAction.ExcludeSegmentGenderME]: "exclusions",
  [S.RecAction.ExcludeSegmentStateMS]: "exclusions",
  [S.RecAction.ExcludeSegmentStateGA]: "exclusions",
  [S.RecAction.ExcludeSegmentStateLI]: "exclusions",
  [S.RecAction.ExcludeSegmentCompanyLI]: "exclusions",
  [S.RecAction.ExcludeSegmentCompanySizeLI]: "exclusions",
  [S.RecAction.ExcludeSegmentMemberIndustryLI]: "exclusions",
  [S.RecAction.ExcludeSegmentMemberJobFunctionLI]: "exclusions",
  [S.RecAction.ExcludeSegmentMemberJobTitleLI]: "exclusions",
  [S.RecAction.ExcludeSegmentMemberSeniorityLI]: "exclusions",
  [S.RecAction.ExcludeSegmentContentNetworkGA]: "exclusions",
  [S.RecAction.ExcludeSegmentSearchPartnersGA]: "exclusions",
  [S.RecAction.ExcludeSegmentOffsiteDeliveryLI]: "exclusions",
  [S.RecAction.ExcludeSegmentSyndicatedSearchMS]: "exclusions",
  [S.RecAction.ExcludeSegmentPublisherPlatformME]: "exclusions",
  [S.RecAction.ExcludeSegmentCountryGA]: "exclusions",
  [S.RecAction.ExcludeSegmentCityGA]: "exclusions",
  [S.RecAction.ExcludeSegmentCityMS]: "exclusions",
  [S.RecAction.ExcludeSegmentAgeDemoGA]: "exclusions",
  [S.RecAction.ExcludeSegmentGenderGA]: "exclusions",
  [S.RecAction.ExcludeSegmentIncomeGA]: "exclusions",
  [S.RecAction.ExcludeSegmentParentalStatusGA]: "exclusions",
  [S.RecAction.ExcludeSegmentLandingPageGA]: "exclusions"
};
Object.fromEntries(
  Object.values(S.Type).map((t) => {
    const n = Object.fromEntries(
      Object.entries(dR).map(([r, o]) => [o, r])
    )[t];
    return [t, fR[n] ?? "deprecated"];
  })
);
var t0;
((t) => {
  t.Level = {
    Account: "account",
    Campaign: "campaign"
  }, t.AlertType = {
    Budget: "budget",
    Conversion: "conversion",
    Delta: "delta",
    ImpressionsFlatline: "impressionsFlatline",
    ConversionActionsFlatline: "conversionActionsFlatline",
    RecordDays: "record_days",
    ScheduledReport: "scheduled_report",
    OverBudget: "over_budget",
    SmartBiddingExperiment: "smart_bidding_experiment"
  };
})(t0 || (t0 = {}));
var Om;
((t) => {
  ((e) => {
    e.CAMPAIGN = "campaign", e.CPC_BANDS = "cpc_bands", e.DEVICE = "device", e.ADVERTISING_CHANNEL = "advertising_channel", e.AGE_RANGE = "age_range", e.GENDER = "gender", e.COMPANY = "company", e.COMPANY_SIZE = "company_size", e.MEMBER_SENIORITY = "member_seniority", e.MEMBER_INDUSTRY = "member_industry", e.MEMBER_JOB_TITLE = "member_job_title", e.MEMBER_JOB_FUNCTION = "member_job_function", e.HOUR_OF_DAY = "hour_of_day", e.DAY_OF_WEEK = "day_of_week", e.MATCH_TYPE = "match_type", e.COUNTRY = "country", e.STATE = "state", e.CITY = "city", e.WORD = "word", e.WORD_2 = "word2", e.WORD_3 = "word3", e.LANDING_PAGE_URL = "landing_page_url", e.LANDING_PAGE_VIEW = "landing_page_view", e.NETWORK = "network", e.INCOME_RANGE = "income_range", e.PARENTAL_STATUS = "parental_status", e.PRODUCT = "product";
  })(t.Segment || (t.Segment = {}));
})(Om || (Om = {}));
var Am;
((t) => {
  ((e) => {
    e.NO_REFRESH_TOKEN = "No google search console refresh token found", e.INVALID_TOKEN = "Invalid google search console token", e.COULD_NOT_READ_RECENTLY_INSERTED_TOKEN = "Could not read recently inserted google search console token", e.REVOKING_TOKEN = "Failed to get google search console account data after storing token, revoking token", e.NO_LINKED_PROFILE_FOUND = "No linked google search console profile was found", e.ACCESS_DENIED = "User cancelled authorization", e.NO_AUTHORIZATION_CODE = "We received no authorization code and google did not provide any error", e.NO_ACCESS_TOKEN = "Something unexpected happened and we received no access token after authorization", e.EMAIL_WITHOUT_SEARCH_CONSOLE = "The email address you selected has no associated Google search console account. If it does, please contact support.", e.ACCESS_TOKEN_SCOPE_INSUFFICIENT = "Authorization failed due to insufficient permissions.", e.UNKNOWN_ERROR = "An unknown error occurred while linking your Google search console account. Please contact support.";
  })(t.Error || (t.Error = {})), ((e) => {
    e[e.Account = 0] = "Account", e[e.Property = 1] = "Property", e[e.Profile = 2] = "Profile";
  })(t.MatadataEntityType || (t.MatadataEntityType = {}));
})(Am || (Am = {}));
var Dm;
((t) => {
  ((e) => {
    e.LAST_30_DAYS = "LAST_30_DAYS", e.LAST_90_DAYS = "LAST_90_DAYS", e.LAST_180_DAYS = "LAST_180_DAYS", e.LAST_YEAR = "LAST_YEAR", e.MONTH_TO_DATE = "MONTH_TO_DATE";
  })(t.LookbackWindow || (t.LookbackWindow = {}));
})(Dm || (Dm = {}));
var Cm;
((t) => {
  ((e) => {
    e.LAST_30_DAYS = "LAST_30_DAYS", e.LAST_90_DAYS = "LAST_90_DAYS", e.LAST_180_DAYS = "LAST_180_DAYS", e.LAST_YEAR = "LAST_YEAR";
  })(t.LookbackWindow || (t.LookbackWindow = {}));
})(Cm || (Cm = {}));
var Sm;
((t) => {
  ((e) => {
    e.Generic = "generic", e.Insight = "insight";
  })(t.InsightType || (t.InsightType = {})), ((e) => {
    e[e.Monthly = 1] = "Monthly", e[e.Bimonthly = 2] = "Bimonthly";
  })(t.ReportScheduleInterval || (t.ReportScheduleInterval = {}));
})(Sm || (Sm = {}));
var jr;
((t) => {
  ((e) => {
    e[e.Cover = 0] = "Cover", e[e.ReportSummary = 1] = "ReportSummary", e[e.GoogleAnalyticsSummary = 24] = "GoogleAnalyticsSummary", e[e.SpendSummary = 2] = "SpendSummary", e[e.ConversionsSummary = 3] = "ConversionsSummary", e[e.ConversionsValueSummary = 25] = "ConversionsValueSummary", e[e.CostPerConversionSummary = 4] = "CostPerConversionSummary", e[e.ReturnOnAdSpendSummary = 26] = "ReturnOnAdSpendSummary", e[e.ImpressionsSummary = 5] = "ImpressionsSummary", e[e.ClicksSummary = 6] = "ClicksSummary", e[e.CostPerClickSummary = 7] = "CostPerClickSummary", e[e.SpendTargets = 8] = "SpendTargets", e[e.CpaTargets = 9] = "CpaTargets", e[e.RoasTargets = 27] = "RoasTargets", e[e.TopPerformingAds = 10] = "TopPerformingAds", e[e.TopPerformingKeywords = 11] = "TopPerformingKeywords", e[e.TopPerformingSegments = 12] = "TopPerformingSegments", e[e.AdTest = 13] = "AdTest", e[e.AdCreative = 14] = "AdCreative", e[e.FeaturedKeywordBid = 15] = "FeaturedKeywordBid", e[e.FeaturedScheduleAdjustment = 16] = "FeaturedScheduleAdjustment", e[e.FeaturedAgeBid = 17] = "FeaturedAgeBid", e[e.FeaturedGenderBid = 18] = "FeaturedGenderBid", e[e.FeaturedParentalStatusBid = 19] = "FeaturedParentalStatusBid", e[e.FeaturedLocationBid = 20] = "FeaturedLocationBid", e[e.WorkSummary = 21] = "WorkSummary", e[e.NextSteps = 22] = "NextSteps", e[e.Conclusion = 23] = "Conclusion";
  })(t.SlideType || (t.SlideType = {})), ((e) => {
    e[e.Cover = 0] = "Cover", e[e.Summary = 1] = "Summary", e[e.PerformanceSummary = 2] = "PerformanceSummary", e[e.Targets = 3] = "Targets", e[e.TopPerformers = 4] = "TopPerformers", e[e.FeaturedImprovements = 7] = "FeaturedImprovements", e[e.WorkSummary = 8] = "WorkSummary", e[e.Conclusion = 9] = "Conclusion";
  })(t.SlideCategory || (t.SlideCategory = {})), ((e) => {
    e.Cover = "Cover", e.ReportSummary = "Google Ads Summary", e.GoogleAnalyticsSummary = "Google Analytics Summary", e.SpendSummary = "Spend Summary", e.ConversionsSummary = "Conversions Summary", e.ConversionsValueSummary = "Conversion Value Summary", e.CostPerConversionSummary = "Cost Per Conversion Summary", e.ReturnOnAdSpendSummary = "ROAS Summary", e.ImpressionsSummary = "Impressions Summary", e.ClicksSummary = "Clicks Summary", e.CostPerClickSummary = "Cost Per Click Summary", e.SpendTargets = "Spend Targets", e.CpaTargets = "Cost Per Conversion Targets", e.RoasTargets = "ROAS Targets", e.TopPerformingAds = "Top Performing Ads", e.TopPerformingKeywords = "Top Performing Keywords", e.TopPerformingSegments = "Top Performing Segments", e.AdTest = "Featured Ad Test", e.AdCreative = "Featured Ad Creative", e.FeaturedKeywordBid = "Featured Keyword Bid", e.FeaturedScheduleAdjustment = "Featured Schedule Adjustment", e.FeaturedAgeBid = "Featured Age Bid Adjustment", e.FeaturedGenderBid = "Featured Gender Bid Adjustment", e.FeaturedParentalStatusBid = "Featured Parent Bid Adjustment", e.FeaturedLocationBid = "Featured Location Bid Adjustment", e.WorkSummary = "Work Summary", e.NextSteps = "Next Steps", e.Conclusion = "Conclusion";
  })(t.SlideTypeName || (t.SlideTypeName = {})), ((e) => {
    e.Cover = "Cover", e.Summary = "Summary", e.PerformanceSummary = "Performance Summary", e.Targets = "Targets", e.TopPerformers = "Top Performers", e.FeaturedImprovements = "Featured Changes", e.WorkSummary = "Work Summary", e.Conclusion = "Conclusion";
  })(t.SlideCategoryName || (t.SlideCategoryName = {}));
})(jr || (jr = {}));
var wm;
((t) => {
  t.SlideTypeToMetric = {
    [jr.SlideType.SpendSummary]: "cost",
    [jr.SlideType.ConversionsSummary]: "conversions",
    [jr.SlideType.ConversionsValueSummary]: "conversions_value",
    [jr.SlideType.CostPerConversionSummary]: "cpa",
    [jr.SlideType.ReturnOnAdSpendSummary]: "roas",
    [jr.SlideType.ImpressionsSummary]: "impressions",
    [jr.SlideType.ClicksSummary]: "clicks",
    [jr.SlideType.CostPerClickSummary]: "cpc"
  };
})(wm || (wm = {}));
var Tm;
((t) => {
  ((e) => {
    e.GENERIC = "Error occured while generating google analytics report", e.INSUFFICIENT_DATA = "Insufficient data for reporting period", e.NO_USER_GROUP_FOUND = "Could not find groupId for given userId";
  })(t.Error || (t.Error = {}));
})(Tm || (Tm = {}));
var bm;
((t) => {
  t.Error = {}, t.ErrorReadable = {}, t.NoImprovementMessage = {
    NO_CAMPAIGNS: "no_campaigns_in_last_90d",
    NO_IMPROVEMENTS: "no_improvements",
    NO_SUITABLE_CAMPAIGN_ENVIRONMENTS: "no_suitable_campaign_environments"
  };
})(bm || (bm = {}));
var Rm;
((t) => {
  t.Error = {
    NO_CPC_BID_TO_UPDATE: "bid_undefined"
  }, t.ErrorReadable = {
    [t.Error.NO_CPC_BID_TO_UPDATE]: "Tried to update a criterion without a bid"
  };
})(Rm || (Rm = {}));
var Mm;
((t) => {
  t.Error = {
    NO_OUT_OF_SYNC_PRODUCT_GROUP: "no_out_of_sync_product_groups",
    INVALID_CASE_VALUE: "invalid_case_value",
    INVALID_PRODUCT_CHANNEL_EXCLUSIVITY_CASE_VALUE: "invalid_product_channel_exclusivity_case_value",
    INVALID_PRODUCT_CHANNEL_CASE_VALUE: "invalid_product_channel_case_value",
    INVALID_PRODUCT_CUSTOM_ATTRIBUTE_CASE_VALUE: "invalid_product_custom_attribute_case_value",
    INVALID_PRODUCT_CONDITION_CASE_VALUE: "invalid_product_condition_case_value",
    INVALID_PRODUCT_TYPE_CASE_VALUE: "invalid_product_type_case_value",
    INVALID_PRODUCT_CATEGORY_CASE_VALUE: "invalid_product_category_case_value",
    NO_CASE_VALUE: "no_case_value"
  }, t.ErrorReadable = {
    [t.Error.NO_OUT_OF_SYNC_PRODUCT_GROUP]: 'No "Everything else" Product Groups detected',
    [t.Error.INVALID_PRODUCT_CHANNEL_EXCLUSIVITY_CASE_VALUE]: "The generated product channel exclusivity case value is malformed",
    [t.Error.INVALID_PRODUCT_CHANNEL_CASE_VALUE]: "The generated product channel case value is malformed",
    [t.Error.INVALID_PRODUCT_CUSTOM_ATTRIBUTE_CASE_VALUE]: "The generated custom attribute case value is malformed",
    [t.Error.INVALID_PRODUCT_CONDITION_CASE_VALUE]: "The generated product condition case value is malformed",
    [t.Error.INVALID_PRODUCT_TYPE_CASE_VALUE]: "The generated product type case value is malformed",
    [t.Error.INVALID_PRODUCT_CATEGORY_CASE_VALUE]: "The generated product category case value is malformed",
    [t.Error.NO_CASE_VALUE]: "No case value was generated"
  };
})(Mm || (Mm = {}));
var Pm;
((t) => {
  t.Error = {
    KEYWORD_NO_LONGER_EXISTS: "KEYWORD_NO_LONGER_EXISTS"
  }, t.ErrorReadable = {
    [t.Error.KEYWORD_NO_LONGER_EXISTS]: "The keyword we wanted to pause has already been deleted."
  }, ((e) => {
    e.no_search_campaigns_found = "no_search_campaigns_found", e.no_broad_keywords_found = "no_broad_keywords_found", e.no_campaign_groups_found = "no_campaign_groups_found", e.no_eligible_keywords_found = "no_eligible_keywords_found", e.not_enough_search_terms_found = "not_enough_search_terms_found", e.is_google_grant_account = "is_google_grant_account";
  })(t.NoImprovementReason || (t.NoImprovementReason = {}));
})(Pm || (Pm = {}));
S.LookbackWindow.SEVEN_DAYS, S.LookbackWindow.FOURTEEN_DAYS, S.LookbackWindow.THIRTY_DAYS, S.LookbackWindow.SIXTY_DAYS, S.LookbackWindow.NINETY_DAYS;
var ym;
((t) => {
  t.Error = {
    NO_TOP_SPENDING_AD_GROUPS: "no_top_spending_ad_groups",
    NOT_ENOUGH_AD_TYPES_IN_AD_GROUP: "not_enough_ad_types_in_ad_group",
    FAILED_TO_GENERATE_ANY_IMPROVEMENTS_FOR_DOMAIN: "failed_to_generate_any_improvements_for_domain",
    NO_EXTRA_DETAILS_FOR_WRITE_IMPLEMENT: "no_extra_details_for_write_implement"
  }, t.ErrorReadable = {
    [t.Error.NO_TOP_SPENDING_AD_GROUPS]: "There are no top spending ad groups for this domain",
    [t.Error.NOT_ENOUGH_AD_TYPES_IN_AD_GROUP]: "There are not enough ad types in this domain",
    [t.Error.FAILED_TO_GENERATE_ANY_IMPROVEMENTS_FOR_DOMAIN]: "No improvements were generated for this domain",
    [t.Error.NO_EXTRA_DETAILS_FOR_WRITE_IMPLEMENT]: "extra details (new ad copy) expected when writing new ad"
  };
})(ym || (ym = {}));
var Lm;
((t) => {
  ((e) => {
    e.CPI = "cpi", e.VPI = "vpi", e.CTR = "ctr";
  })(t.MeasureMode || (t.MeasureMode = {}));
})(Lm || (Lm = {}));
var Ge;
(function(t) {
  (function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.BOOK = 2] = "BOOK", e[e.HOLD = 3] = "HOLD";
  })(t.ReservationRequestType || (t.ReservationRequestType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.UI_PREVIEW = 2] = "UI_PREVIEW", e[e.YOUTUBE_LIVE_PREVIEW = 3] = "YOUTUBE_LIVE_PREVIEW";
  }(t.PreviewType || (t.PreviewType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PROHIBITED = 2] = "PROHIBITED", e[e.LIMITED = 4] = "LIMITED", e[e.FULLY_LIMITED = 8] = "FULLY_LIMITED", e[e.DESCRIPTIVE = 5] = "DESCRIPTIVE", e[e.BROADENING = 6] = "BROADENING", e[e.AREA_OF_INTEREST_ONLY = 7] = "AREA_OF_INTEREST_ONLY";
  }(t.PolicyTopicEntryType || (t.PolicyTopicEntryType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.DISPLAY_URL = 2] = "DISPLAY_URL", e[e.FINAL_URL = 3] = "FINAL_URL", e[e.FINAL_MOBILE_URL = 4] = "FINAL_MOBILE_URL", e[e.TRACKING_URL = 5] = "TRACKING_URL", e[e.MOBILE_TRACKING_URL = 6] = "MOBILE_TRACKING_URL";
  }(t.PolicyTopicEvidenceDestinationMismatchUrlType || (t.PolicyTopicEvidenceDestinationMismatchUrlType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.DESKTOP = 2] = "DESKTOP", e[e.ANDROID = 3] = "ANDROID", e[e.IOS = 4] = "IOS";
  }(t.PolicyTopicEvidenceDestinationNotWorkingDevice || (t.PolicyTopicEvidenceDestinationNotWorkingDevice = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.HOSTNAME_NOT_FOUND = 2] = "HOSTNAME_NOT_FOUND", e[e.GOOGLE_CRAWLER_DNS_ISSUE = 3] = "GOOGLE_CRAWLER_DNS_ISSUE";
  }(t.PolicyTopicEvidenceDestinationNotWorkingDnsErrorType || (t.PolicyTopicEvidenceDestinationNotWorkingDnsErrorType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ELIGIBLE = 2] = "ELIGIBLE", e[e.PAUSED = 3] = "PAUSED", e[e.REMOVED = 4] = "REMOVED", e[e.PENDING = 5] = "PENDING", e[e.LIMITED = 6] = "LIMITED", e[e.NOT_ELIGIBLE = 7] = "NOT_ELIGIBLE";
  }(t.AssetLinkPrimaryStatus || (t.AssetLinkPrimaryStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ASSET_LINK_PAUSED = 2] = "ASSET_LINK_PAUSED", e[e.ASSET_LINK_REMOVED = 3] = "ASSET_LINK_REMOVED", e[e.ASSET_DISAPPROVED = 4] = "ASSET_DISAPPROVED", e[e.ASSET_UNDER_REVIEW = 5] = "ASSET_UNDER_REVIEW", e[e.ASSET_APPROVED_LABELED = 6] = "ASSET_APPROVED_LABELED";
  }(t.AssetLinkPrimaryStatusReason || (t.AssetLinkPrimaryStatusReason = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PRICE_ASSET_DESCRIPTION_REPEATS_ROW_HEADER = 2] = "PRICE_ASSET_DESCRIPTION_REPEATS_ROW_HEADER", e[e.PRICE_ASSET_REPETITIVE_HEADERS = 3] = "PRICE_ASSET_REPETITIVE_HEADERS", e[e.PRICE_ASSET_HEADER_INCOMPATIBLE_WITH_PRICE_TYPE = 4] = "PRICE_ASSET_HEADER_INCOMPATIBLE_WITH_PRICE_TYPE", e[e.PRICE_ASSET_DESCRIPTION_INCOMPATIBLE_WITH_ITEM_HEADER = 5] = "PRICE_ASSET_DESCRIPTION_INCOMPATIBLE_WITH_ITEM_HEADER", e[e.PRICE_ASSET_DESCRIPTION_HAS_PRICE_QUALIFIER = 6] = "PRICE_ASSET_DESCRIPTION_HAS_PRICE_QUALIFIER", e[e.PRICE_ASSET_UNSUPPORTED_LANGUAGE = 7] = "PRICE_ASSET_UNSUPPORTED_LANGUAGE", e[e.PRICE_ASSET_OTHER_ERROR = 8] = "PRICE_ASSET_OTHER_ERROR";
  }(t.AssetOfflineEvaluationErrorReasons || (t.AssetOfflineEvaluationErrorReasons = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.DISAPPROVED = 2] = "DISAPPROVED", e[e.APPROVED_LIMITED = 3] = "APPROVED_LIMITED", e[e.APPROVED = 4] = "APPROVED", e[e.AREA_OF_INTEREST_ONLY = 5] = "AREA_OF_INTEREST_ONLY";
  }(t.PolicyApprovalStatus || (t.PolicyApprovalStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.REVIEW_IN_PROGRESS = 2] = "REVIEW_IN_PROGRESS", e[e.REVIEWED = 3] = "REVIEWED", e[e.UNDER_APPEAL = 4] = "UNDER_APPEAL", e[e.ELIGIBLE_MAY_SERVE = 5] = "ELIGIBLE_MAY_SERVE";
  }(t.PolicyReviewStatus || (t.PolicyReviewStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PENDING = 2] = "PENDING", e[e.LEARNING = 3] = "LEARNING", e[e.LOW = 4] = "LOW", e[e.GOOD = 5] = "GOOD", e[e.BEST = 6] = "BEST", e[e.NOT_APPLICABLE = 7] = "NOT_APPLICABLE";
  }(t.AssetPerformanceLabel || (t.AssetPerformanceLabel = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.HEADLINE_1 = 2] = "HEADLINE_1", e[e.HEADLINE_2 = 3] = "HEADLINE_2", e[e.HEADLINE_3 = 4] = "HEADLINE_3", e[e.DESCRIPTION_1 = 5] = "DESCRIPTION_1", e[e.DESCRIPTION_2 = 6] = "DESCRIPTION_2", e[e.HEADLINE = 7] = "HEADLINE", e[e.HEADLINE_IN_PORTRAIT = 8] = "HEADLINE_IN_PORTRAIT", e[e.LONG_HEADLINE = 9] = "LONG_HEADLINE", e[e.DESCRIPTION = 10] = "DESCRIPTION", e[e.DESCRIPTION_IN_PORTRAIT = 11] = "DESCRIPTION_IN_PORTRAIT", e[e.BUSINESS_NAME_IN_PORTRAIT = 12] = "BUSINESS_NAME_IN_PORTRAIT", e[e.BUSINESS_NAME = 13] = "BUSINESS_NAME", e[e.MARKETING_IMAGE = 14] = "MARKETING_IMAGE", e[e.MARKETING_IMAGE_IN_PORTRAIT = 15] = "MARKETING_IMAGE_IN_PORTRAIT", e[e.SQUARE_MARKETING_IMAGE = 16] = "SQUARE_MARKETING_IMAGE", e[e.PORTRAIT_MARKETING_IMAGE = 17] = "PORTRAIT_MARKETING_IMAGE", e[e.LOGO = 18] = "LOGO", e[e.LANDSCAPE_LOGO = 19] = "LANDSCAPE_LOGO", e[e.CALL_TO_ACTION = 20] = "CALL_TO_ACTION", e[e.YOU_TUBE_VIDEO = 21] = "YOU_TUBE_VIDEO", e[e.SITELINK = 22] = "SITELINK", e[e.CALL = 23] = "CALL", e[e.MOBILE_APP = 24] = "MOBILE_APP", e[e.CALLOUT = 25] = "CALLOUT", e[e.STRUCTURED_SNIPPET = 26] = "STRUCTURED_SNIPPET", e[e.PRICE = 27] = "PRICE", e[e.PROMOTION = 28] = "PROMOTION", e[e.AD_IMAGE = 29] = "AD_IMAGE", e[e.LEAD_FORM = 30] = "LEAD_FORM", e[e.BUSINESS_LOGO = 31] = "BUSINESS_LOGO", e[e.DESCRIPTION_PREFIX = 32] = "DESCRIPTION_PREFIX", e[e.HEADLINE_AS_SITELINK_POSITION_ONE = 39] = "HEADLINE_AS_SITELINK_POSITION_ONE", e[e.HEADLINE_AS_SITELINK_POSITION_TWO = 40] = "HEADLINE_AS_SITELINK_POSITION_TWO", e[e.DESCRIPTION_LINE_HEADLINE_AS_SITELINK_POSITION_ONE = 41] = "DESCRIPTION_LINE_HEADLINE_AS_SITELINK_POSITION_ONE", e[e.DESCRIPTION_LINE_HEADLINE_AS_SITELINK_POSITION_TWO = 42] = "DESCRIPTION_LINE_HEADLINE_AS_SITELINK_POSITION_TWO", e[e.TEXT_DISCLAIMER = 43] = "TEXT_DISCLAIMER";
  }(t.ServedAssetFieldType || (t.ServedAssetFieldType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ALL_FORMATS = 2] = "ALL_FORMATS", e[e.NON_NATIVE = 3] = "NON_NATIVE", e[e.NATIVE = 4] = "NATIVE";
  }(t.DisplayAdFormatSetting || (t.DisplayAdFormatSetting = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.HTML5_UPLOAD_AD = 2] = "HTML5_UPLOAD_AD", e[e.DYNAMIC_HTML5_EDUCATION_AD = 3] = "DYNAMIC_HTML5_EDUCATION_AD", e[e.DYNAMIC_HTML5_FLIGHT_AD = 4] = "DYNAMIC_HTML5_FLIGHT_AD", e[e.DYNAMIC_HTML5_HOTEL_RENTAL_AD = 5] = "DYNAMIC_HTML5_HOTEL_RENTAL_AD", e[e.DYNAMIC_HTML5_JOB_AD = 6] = "DYNAMIC_HTML5_JOB_AD", e[e.DYNAMIC_HTML5_LOCAL_AD = 7] = "DYNAMIC_HTML5_LOCAL_AD", e[e.DYNAMIC_HTML5_REAL_ESTATE_AD = 8] = "DYNAMIC_HTML5_REAL_ESTATE_AD", e[e.DYNAMIC_HTML5_CUSTOM_AD = 9] = "DYNAMIC_HTML5_CUSTOM_AD", e[e.DYNAMIC_HTML5_TRAVEL_AD = 10] = "DYNAMIC_HTML5_TRAVEL_AD", e[e.DYNAMIC_HTML5_HOTEL_AD = 11] = "DYNAMIC_HTML5_HOTEL_AD";
  }(t.DisplayUploadProductType || (t.DisplayUploadProductType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.APPLE_APP_STORE = 2] = "APPLE_APP_STORE", e[e.GOOGLE_PLAY = 3] = "GOOGLE_PLAY", e[e.WINDOWS_STORE = 4] = "WINDOWS_STORE", e[e.WINDOWS_PHONE_STORE = 5] = "WINDOWS_PHONE_STORE", e[e.CN_APP_STORE = 6] = "CN_APP_STORE";
  }(t.LegacyAppInstallAdAppStore || (t.LegacyAppInstallAdAppStore = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.IMAGE_JPEG = 2] = "IMAGE_JPEG", e[e.IMAGE_GIF = 3] = "IMAGE_GIF", e[e.IMAGE_PNG = 4] = "IMAGE_PNG", e[e.FLASH = 5] = "FLASH", e[e.TEXT_HTML = 6] = "TEXT_HTML", e[e.PDF = 7] = "PDF", e[e.MSWORD = 8] = "MSWORD", e[e.MSEXCEL = 9] = "MSEXCEL", e[e.RTF = 10] = "RTF", e[e.AUDIO_WAV = 11] = "AUDIO_WAV", e[e.AUDIO_MP3 = 12] = "AUDIO_MP3", e[e.HTML5_AD_ZIP = 13] = "HTML5_AD_ZIP";
  }(t.MimeType || (t.MimeType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.DEFAULT_THUMBNAIL = 2] = "DEFAULT_THUMBNAIL", e[e.THUMBNAIL_1 = 3] = "THUMBNAIL_1", e[e.THUMBNAIL_2 = 4] = "THUMBNAIL_2", e[e.THUMBNAIL_3 = 5] = "THUMBNAIL_3";
  }(t.VideoThumbnail || (t.VideoThumbnail = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.DEVELOPMENT_AND_TESTING = 2] = "DEVELOPMENT_AND_TESTING", e[e.PRODUCTION = 3] = "PRODUCTION";
  }(t.ApplicationInstance || (t.ApplicationInstance = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AUTO_DEALERS = 2] = "AUTO_DEALERS", e[e.GENERAL_RETAILERS = 3] = "GENERAL_RETAILERS";
  }(t.ChainRelationshipType || (t.ChainRelationshipType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.BUSINESS_OWNER = 2] = "BUSINESS_OWNER", e[e.AFFILIATE = 3] = "AFFILIATE";
  }(t.LocationOwnershipType || (t.LocationOwnershipType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.EXACT = 2] = "EXACT";
  }(t.LocationStringFilterType || (t.LocationStringFilterType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AGE_RANGE_18_24 = 503001] = "AGE_RANGE_18_24", e[e.AGE_RANGE_25_34 = 503002] = "AGE_RANGE_25_34", e[e.AGE_RANGE_35_44 = 503003] = "AGE_RANGE_35_44", e[e.AGE_RANGE_45_54 = 503004] = "AGE_RANGE_45_54", e[e.AGE_RANGE_55_64 = 503005] = "AGE_RANGE_55_64", e[e.AGE_RANGE_65_UP = 503006] = "AGE_RANGE_65_UP", e[e.AGE_RANGE_UNDETERMINED = 503999] = "AGE_RANGE_UNDETERMINED";
  }(t.AgeRangeType || (t.AgeRangeType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PAID = 30] = "PAID";
  }(t.AppPaymentModelType || (t.AppPaymentModelType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.EXISTING_BRAND = 2] = "EXISTING_BRAND", e[e.EXISTING_BRAND_VARIANT = 3] = "EXISTING_BRAND_VARIANT", e[e.INCORRECT_INFORMATION = 4] = "INCORRECT_INFORMATION", e[e.NOT_A_BRAND = 5] = "NOT_A_BRAND";
  }(t.BrandRequestRejectionReason || (t.BrandRequestRejectionReason = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.DEPRECATED = 3] = "DEPRECATED", e[e.UNVERIFIED = 4] = "UNVERIFIED", e[e.APPROVED = 5] = "APPROVED", e[e.CANCELLED = 6] = "CANCELLED", e[e.REJECTED = 7] = "REJECTED";
  }(t.BrandState || (t.BrandState = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.SEXUALLY_SUGGESTIVE = 2] = "SEXUALLY_SUGGESTIVE", e[e.BELOW_THE_FOLD = 3] = "BELOW_THE_FOLD", e[e.PARKED_DOMAIN = 4] = "PARKED_DOMAIN", e[e.JUVENILE = 6] = "JUVENILE", e[e.PROFANITY = 7] = "PROFANITY", e[e.TRAGEDY = 8] = "TRAGEDY", e[e.VIDEO = 9] = "VIDEO", e[e.VIDEO_RATING_DV_G = 10] = "VIDEO_RATING_DV_G", e[e.VIDEO_RATING_DV_PG = 11] = "VIDEO_RATING_DV_PG", e[e.VIDEO_RATING_DV_T = 12] = "VIDEO_RATING_DV_T", e[e.VIDEO_RATING_DV_MA = 13] = "VIDEO_RATING_DV_MA", e[e.VIDEO_NOT_YET_RATED = 14] = "VIDEO_NOT_YET_RATED", e[e.EMBEDDED_VIDEO = 15] = "EMBEDDED_VIDEO", e[e.LIVE_STREAMING_VIDEO = 16] = "LIVE_STREAMING_VIDEO", e[e.SOCIAL_ISSUES = 17] = "SOCIAL_ISSUES", e[e.BRAND_SUITABILITY_CONTENT_FOR_FAMILIES = 18] = "BRAND_SUITABILITY_CONTENT_FOR_FAMILIES", e[e.BRAND_SUITABILITY_GAMES_FIGHTING = 19] = "BRAND_SUITABILITY_GAMES_FIGHTING", e[e.BRAND_SUITABILITY_GAMES_MATURE = 20] = "BRAND_SUITABILITY_GAMES_MATURE", e[e.BRAND_SUITABILITY_HEALTH_SENSITIVE = 21] = "BRAND_SUITABILITY_HEALTH_SENSITIVE", e[e.BRAND_SUITABILITY_HEALTH_SOURCE_UNDETERMINED = 22] = "BRAND_SUITABILITY_HEALTH_SOURCE_UNDETERMINED", e[e.BRAND_SUITABILITY_NEWS_RECENT = 23] = "BRAND_SUITABILITY_NEWS_RECENT", e[e.BRAND_SUITABILITY_NEWS_SENSITIVE = 24] = "BRAND_SUITABILITY_NEWS_SENSITIVE", e[e.BRAND_SUITABILITY_NEWS_SOURCE_NOT_FEATURED = 25] = "BRAND_SUITABILITY_NEWS_SOURCE_NOT_FEATURED", e[e.BRAND_SUITABILITY_POLITICS = 26] = "BRAND_SUITABILITY_POLITICS", e[e.BRAND_SUITABILITY_RELIGION = 27] = "BRAND_SUITABILITY_RELIGION";
  }(t.ContentLabelType || (t.ContentLabelType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.MONDAY = 2] = "MONDAY", e[e.TUESDAY = 3] = "TUESDAY", e[e.WEDNESDAY = 4] = "WEDNESDAY", e[e.THURSDAY = 5] = "THURSDAY", e[e.FRIDAY = 6] = "FRIDAY", e[e.SATURDAY = 7] = "SATURDAY", e[e.SUNDAY = 8] = "SUNDAY";
  }(t.DayOfWeek || (t.DayOfWeek = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.MOBILE = 2] = "MOBILE", e[e.TABLET = 3] = "TABLET", e[e.DESKTOP = 4] = "DESKTOP", e[e.CONNECTED_TV = 6] = "CONNECTED_TV", e[e.OTHER = 5] = "OTHER";
  }(t.Device || (t.Device = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.MALE = 10] = "MALE", e[e.FEMALE = 11] = "FEMALE", e[e.UNDETERMINED = 20] = "UNDETERMINED";
  }(t.GenderType || (t.GenderType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.DEFAULT_SELECTION = 50] = "DEFAULT_SELECTION", e[e.USER_SELECTED = 51] = "USER_SELECTED";
  }(t.HotelDateSelectionType || (t.HotelDateSelectionType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.INCOME_RANGE_0_50 = 510001] = "INCOME_RANGE_0_50", e[e.INCOME_RANGE_50_60 = 510002] = "INCOME_RANGE_50_60", e[e.INCOME_RANGE_60_70 = 510003] = "INCOME_RANGE_60_70", e[e.INCOME_RANGE_70_80 = 510004] = "INCOME_RANGE_70_80", e[e.INCOME_RANGE_80_90 = 510005] = "INCOME_RANGE_80_90", e[e.INCOME_RANGE_90_UP = 510006] = "INCOME_RANGE_90_UP", e[e.INCOME_RANGE_UNDETERMINED = 51e4] = "INCOME_RANGE_UNDETERMINED";
  }(t.IncomeRangeType || (t.IncomeRangeType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CALLS = 8e3] = "CALLS";
  }(t.InteractionType || (t.InteractionType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.EXACT = 2] = "EXACT", e[e.PHRASE = 3] = "PHRASE", e[e.BROAD = 4] = "BROAD";
  }(t.KeywordMatchType || (t.KeywordMatchType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.SUBDIVISION = 2] = "SUBDIVISION", e[e.UNIT = 3] = "UNIT";
  }(t.ListingGroupType || (t.ListingGroupType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.METERS = 2] = "METERS", e[e.MILES = 3] = "MILES", e[e.MILLI_MILES = 4] = "MILLI_MILES";
  }(t.LocationGroupRadiusUnits || (t.LocationGroupRadiusUnits = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ZERO = 2] = "ZERO", e[e.FIFTEEN = 3] = "FIFTEEN", e[e.THIRTY = 4] = "THIRTY", e[e.FORTY_FIVE = 5] = "FORTY_FIVE";
  }(t.MinuteOfHour || (t.MinuteOfHour = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PARENT = 300] = "PARENT", e[e.NOT_A_PARENT = 301] = "NOT_A_PARENT", e[e.UNDETERMINED = 302] = "UNDETERMINED";
  }(t.ParentalStatusType || (t.ParentalStatusType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.LEVEL1 = 2] = "LEVEL1", e[e.LEVEL2 = 3] = "LEVEL2", e[e.LEVEL3 = 4] = "LEVEL3", e[e.LEVEL4 = 5] = "LEVEL4", e[e.LEVEL5 = 6] = "LEVEL5";
  }(t.ProductCategoryLevel || (t.ProductCategoryLevel = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ONLINE = 2] = "ONLINE", e[e.LOCAL = 3] = "LOCAL";
  }(t.ProductChannel || (t.ProductChannel = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.SINGLE_CHANNEL = 2] = "SINGLE_CHANNEL", e[e.MULTI_CHANNEL = 3] = "MULTI_CHANNEL";
  }(t.ProductChannelExclusivity || (t.ProductChannelExclusivity = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NEW = 3] = "NEW", e[e.REFURBISHED = 4] = "REFURBISHED", e[e.USED = 5] = "USED";
  }(t.ProductCondition || (t.ProductCondition = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.INDEX0 = 7] = "INDEX0", e[e.INDEX1 = 8] = "INDEX1", e[e.INDEX2 = 9] = "INDEX2", e[e.INDEX3 = 10] = "INDEX3", e[e.INDEX4 = 11] = "INDEX4";
  }(t.ProductCustomAttributeIndex || (t.ProductCustomAttributeIndex = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.LEVEL1 = 7] = "LEVEL1", e[e.LEVEL2 = 8] = "LEVEL2", e[e.LEVEL3 = 9] = "LEVEL3", e[e.LEVEL4 = 10] = "LEVEL4", e[e.LEVEL5 = 11] = "LEVEL5";
  }(t.ProductTypeLevel || (t.ProductTypeLevel = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.MILES = 2] = "MILES", e[e.KILOMETERS = 3] = "KILOMETERS";
  }(t.ProximityRadiusUnits || (t.ProximityRadiusUnits = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.URL = 2] = "URL", e[e.CATEGORY = 3] = "CATEGORY", e[e.PAGE_TITLE = 4] = "PAGE_TITLE", e[e.PAGE_CONTENT = 5] = "PAGE_CONTENT", e[e.CUSTOM_LABEL = 6] = "CUSTOM_LABEL";
  }(t.WebpageConditionOperand || (t.WebpageConditionOperand = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.EQUALS = 2] = "EQUALS", e[e.CONTAINS = 3] = "CONTAINS";
  }(t.WebpageConditionOperator || (t.WebpageConditionOperator = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.APPLY_NOW = 2] = "APPLY_NOW", e[e.BOOK_NOW = 3] = "BOOK_NOW", e[e.CONTACT_US = 4] = "CONTACT_US", e[e.GET_INFO = 5] = "GET_INFO", e[e.GET_OFFER = 6] = "GET_OFFER", e[e.GET_QUOTE = 7] = "GET_QUOTE", e[e.GET_STARTED = 8] = "GET_STARTED", e[e.LEARN_MORE = 9] = "LEARN_MORE";
  }(t.BusinessMessageCallToActionType || (t.BusinessMessageCallToActionType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.WHATSAPP = 2] = "WHATSAPP", e[e.FACEBOOK_MESSENGER = 3] = "FACEBOOK_MESSENGER", e[e.ZALO = 4] = "ZALO";
  }(t.BusinessMessageProvider || (t.BusinessMessageProvider = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.DISABLED = 2] = "DISABLED", e[e.USE_ACCOUNT_LEVEL_CALL_CONVERSION_ACTION = 3] = "USE_ACCOUNT_LEVEL_CALL_CONVERSION_ACTION", e[e.USE_RESOURCE_LEVEL_CALL_CONVERSION_ACTION = 4] = "USE_RESOURCE_LEVEL_CALL_CONVERSION_ACTION";
  }(t.CallConversionReportingState || (t.CallConversionReportingState = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.LEARN_MORE = 2] = "LEARN_MORE", e[e.GET_QUOTE = 3] = "GET_QUOTE", e[e.APPLY_NOW = 4] = "APPLY_NOW", e[e.SIGN_UP = 5] = "SIGN_UP", e[e.CONTACT_US = 6] = "CONTACT_US", e[e.SUBSCRIBE = 7] = "SUBSCRIBE", e[e.DOWNLOAD = 8] = "DOWNLOAD", e[e.BOOK_NOW = 9] = "BOOK_NOW", e[e.SHOP_NOW = 10] = "SHOP_NOW", e[e.BUY_NOW = 11] = "BUY_NOW", e[e.DONATE_NOW = 12] = "DONATE_NOW", e[e.ORDER_NOW = 13] = "ORDER_NOW", e[e.PLAY_NOW = 14] = "PLAY_NOW", e[e.SEE_MORE = 15] = "SEE_MORE", e[e.START_NOW = 16] = "START_NOW", e[e.VISIT_SITE = 17] = "VISIT_SITE", e[e.WATCH_NOW = 18] = "WATCH_NOW";
  }(t.CallToActionType || (t.CallToActionType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.LEARN_MORE = 2] = "LEARN_MORE", e[e.GET_QUOTE = 3] = "GET_QUOTE", e[e.APPLY_NOW = 4] = "APPLY_NOW", e[e.SIGN_UP = 5] = "SIGN_UP", e[e.CONTACT_US = 6] = "CONTACT_US", e[e.SUBSCRIBE = 7] = "SUBSCRIBE", e[e.DOWNLOAD = 8] = "DOWNLOAD", e[e.BOOK_NOW = 9] = "BOOK_NOW", e[e.GET_OFFER = 10] = "GET_OFFER", e[e.REGISTER = 11] = "REGISTER", e[e.GET_INFO = 12] = "GET_INFO", e[e.REQUEST_DEMO = 13] = "REQUEST_DEMO", e[e.JOIN_NOW = 14] = "JOIN_NOW", e[e.GET_STARTED = 15] = "GET_STARTED";
  }(t.LeadFormCallToActionType || (t.LeadFormCallToActionType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.LOW_INTENT = 2] = "LOW_INTENT", e[e.HIGH_INTENT = 3] = "HIGH_INTENT";
  }(t.LeadFormDesiredIntent || (t.LeadFormDesiredIntent = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.FULL_NAME = 2] = "FULL_NAME", e[e.EMAIL = 3] = "EMAIL", e[e.PHONE_NUMBER = 4] = "PHONE_NUMBER", e[e.POSTAL_CODE = 5] = "POSTAL_CODE", e[e.STREET_ADDRESS = 8] = "STREET_ADDRESS", e[e.CITY = 9] = "CITY", e[e.REGION = 10] = "REGION", e[e.COUNTRY = 11] = "COUNTRY", e[e.WORK_EMAIL = 12] = "WORK_EMAIL", e[e.COMPANY_NAME = 13] = "COMPANY_NAME", e[e.WORK_PHONE = 14] = "WORK_PHONE", e[e.JOB_TITLE = 15] = "JOB_TITLE", e[e.GOVERNMENT_ISSUED_ID_CPF_BR = 16] = "GOVERNMENT_ISSUED_ID_CPF_BR", e[e.GOVERNMENT_ISSUED_ID_DNI_AR = 17] = "GOVERNMENT_ISSUED_ID_DNI_AR", e[e.GOVERNMENT_ISSUED_ID_DNI_PE = 18] = "GOVERNMENT_ISSUED_ID_DNI_PE", e[e.GOVERNMENT_ISSUED_ID_RUT_CL = 19] = "GOVERNMENT_ISSUED_ID_RUT_CL", e[e.GOVERNMENT_ISSUED_ID_CC_CO = 20] = "GOVERNMENT_ISSUED_ID_CC_CO", e[e.GOVERNMENT_ISSUED_ID_CI_EC = 21] = "GOVERNMENT_ISSUED_ID_CI_EC", e[e.GOVERNMENT_ISSUED_ID_RFC_MX = 22] = "GOVERNMENT_ISSUED_ID_RFC_MX", e[e.FIRST_NAME = 23] = "FIRST_NAME", e[e.LAST_NAME = 24] = "LAST_NAME", e[e.VEHICLE_MODEL = 1001] = "VEHICLE_MODEL", e[e.VEHICLE_TYPE = 1002] = "VEHICLE_TYPE", e[e.PREFERRED_DEALERSHIP = 1003] = "PREFERRED_DEALERSHIP", e[e.VEHICLE_PURCHASE_TIMELINE = 1004] = "VEHICLE_PURCHASE_TIMELINE", e[e.VEHICLE_OWNERSHIP = 1005] = "VEHICLE_OWNERSHIP", e[e.VEHICLE_PAYMENT_TYPE = 1009] = "VEHICLE_PAYMENT_TYPE", e[e.VEHICLE_CONDITION = 1010] = "VEHICLE_CONDITION", e[e.COMPANY_SIZE = 1006] = "COMPANY_SIZE", e[e.ANNUAL_SALES = 1007] = "ANNUAL_SALES", e[e.YEARS_IN_BUSINESS = 1008] = "YEARS_IN_BUSINESS", e[e.JOB_DEPARTMENT = 1011] = "JOB_DEPARTMENT", e[e.JOB_ROLE = 1012] = "JOB_ROLE", e[e.OVER_18_AGE = 1078] = "OVER_18_AGE", e[e.OVER_19_AGE = 1079] = "OVER_19_AGE", e[e.OVER_20_AGE = 1080] = "OVER_20_AGE", e[e.OVER_21_AGE = 1081] = "OVER_21_AGE", e[e.OVER_22_AGE = 1082] = "OVER_22_AGE", e[e.OVER_23_AGE = 1083] = "OVER_23_AGE", e[e.OVER_24_AGE = 1084] = "OVER_24_AGE", e[e.OVER_25_AGE = 1085] = "OVER_25_AGE", e[e.OVER_26_AGE = 1086] = "OVER_26_AGE", e[e.OVER_27_AGE = 1087] = "OVER_27_AGE", e[e.OVER_28_AGE = 1088] = "OVER_28_AGE", e[e.OVER_29_AGE = 1089] = "OVER_29_AGE", e[e.OVER_30_AGE = 1090] = "OVER_30_AGE", e[e.OVER_31_AGE = 1091] = "OVER_31_AGE", e[e.OVER_32_AGE = 1092] = "OVER_32_AGE", e[e.OVER_33_AGE = 1093] = "OVER_33_AGE", e[e.OVER_34_AGE = 1094] = "OVER_34_AGE", e[e.OVER_35_AGE = 1095] = "OVER_35_AGE", e[e.OVER_36_AGE = 1096] = "OVER_36_AGE", e[e.OVER_37_AGE = 1097] = "OVER_37_AGE", e[e.OVER_38_AGE = 1098] = "OVER_38_AGE", e[e.OVER_39_AGE = 1099] = "OVER_39_AGE", e[e.OVER_40_AGE = 1100] = "OVER_40_AGE", e[e.OVER_41_AGE = 1101] = "OVER_41_AGE", e[e.OVER_42_AGE = 1102] = "OVER_42_AGE", e[e.OVER_43_AGE = 1103] = "OVER_43_AGE", e[e.OVER_44_AGE = 1104] = "OVER_44_AGE", e[e.OVER_45_AGE = 1105] = "OVER_45_AGE", e[e.OVER_46_AGE = 1106] = "OVER_46_AGE", e[e.OVER_47_AGE = 1107] = "OVER_47_AGE", e[e.OVER_48_AGE = 1108] = "OVER_48_AGE", e[e.OVER_49_AGE = 1109] = "OVER_49_AGE", e[e.OVER_50_AGE = 1110] = "OVER_50_AGE", e[e.OVER_51_AGE = 1111] = "OVER_51_AGE", e[e.OVER_52_AGE = 1112] = "OVER_52_AGE", e[e.OVER_53_AGE = 1113] = "OVER_53_AGE", e[e.OVER_54_AGE = 1114] = "OVER_54_AGE", e[e.OVER_55_AGE = 1115] = "OVER_55_AGE", e[e.OVER_56_AGE = 1116] = "OVER_56_AGE", e[e.OVER_57_AGE = 1117] = "OVER_57_AGE", e[e.OVER_58_AGE = 1118] = "OVER_58_AGE", e[e.OVER_59_AGE = 1119] = "OVER_59_AGE", e[e.OVER_60_AGE = 1120] = "OVER_60_AGE", e[e.OVER_61_AGE = 1121] = "OVER_61_AGE", e[e.OVER_62_AGE = 1122] = "OVER_62_AGE", e[e.OVER_63_AGE = 1123] = "OVER_63_AGE", e[e.OVER_64_AGE = 1124] = "OVER_64_AGE", e[e.OVER_65_AGE = 1125] = "OVER_65_AGE", e[e.EDUCATION_PROGRAM = 1013] = "EDUCATION_PROGRAM", e[e.EDUCATION_COURSE = 1014] = "EDUCATION_COURSE", e[e.PRODUCT = 1016] = "PRODUCT", e[e.SERVICE = 1017] = "SERVICE", e[e.OFFER = 1018] = "OFFER", e[e.CATEGORY = 1019] = "CATEGORY", e[e.PREFERRED_CONTACT_METHOD = 1020] = "PREFERRED_CONTACT_METHOD", e[e.PREFERRED_LOCATION = 1021] = "PREFERRED_LOCATION", e[e.PREFERRED_CONTACT_TIME = 1022] = "PREFERRED_CONTACT_TIME", e[e.PURCHASE_TIMELINE = 1023] = "PURCHASE_TIMELINE", e[e.YEARS_OF_EXPERIENCE = 1048] = "YEARS_OF_EXPERIENCE", e[e.JOB_INDUSTRY = 1049] = "JOB_INDUSTRY", e[e.LEVEL_OF_EDUCATION = 1050] = "LEVEL_OF_EDUCATION", e[e.PROPERTY_TYPE = 1024] = "PROPERTY_TYPE", e[e.REALTOR_HELP_GOAL = 1025] = "REALTOR_HELP_GOAL", e[e.PROPERTY_COMMUNITY = 1026] = "PROPERTY_COMMUNITY", e[e.PRICE_RANGE = 1027] = "PRICE_RANGE", e[e.NUMBER_OF_BEDROOMS = 1028] = "NUMBER_OF_BEDROOMS", e[e.FURNISHED_PROPERTY = 1029] = "FURNISHED_PROPERTY", e[e.PETS_ALLOWED_PROPERTY = 1030] = "PETS_ALLOWED_PROPERTY", e[e.NEXT_PLANNED_PURCHASE = 1031] = "NEXT_PLANNED_PURCHASE", e[e.EVENT_SIGNUP_INTEREST = 1033] = "EVENT_SIGNUP_INTEREST", e[e.PREFERRED_SHOPPING_PLACES = 1034] = "PREFERRED_SHOPPING_PLACES", e[e.FAVORITE_BRAND = 1035] = "FAVORITE_BRAND", e[e.TRANSPORTATION_COMMERCIAL_LICENSE_TYPE = 1036] = "TRANSPORTATION_COMMERCIAL_LICENSE_TYPE", e[e.EVENT_BOOKING_INTEREST = 1038] = "EVENT_BOOKING_INTEREST", e[e.DESTINATION_COUNTRY = 1039] = "DESTINATION_COUNTRY", e[e.DESTINATION_CITY = 1040] = "DESTINATION_CITY", e[e.DEPARTURE_COUNTRY = 1041] = "DEPARTURE_COUNTRY", e[e.DEPARTURE_CITY = 1042] = "DEPARTURE_CITY", e[e.DEPARTURE_DATE = 1043] = "DEPARTURE_DATE", e[e.RETURN_DATE = 1044] = "RETURN_DATE", e[e.NUMBER_OF_TRAVELERS = 1045] = "NUMBER_OF_TRAVELERS", e[e.TRAVEL_BUDGET = 1046] = "TRAVEL_BUDGET", e[e.TRAVEL_ACCOMMODATION = 1047] = "TRAVEL_ACCOMMODATION";
  }(t.LeadFormFieldUserInputType || (t.LeadFormFieldUserInputType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.VISIT_SITE = 2] = "VISIT_SITE", e[e.DOWNLOAD = 3] = "DOWNLOAD", e[e.LEARN_MORE = 4] = "LEARN_MORE", e[e.SHOP_NOW = 5] = "SHOP_NOW";
  }(t.LeadFormPostSubmitCallToActionType || (t.LeadFormPostSubmitCallToActionType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.APPLE_APP_STORE = 2] = "APPLE_APP_STORE", e[e.GOOGLE_APP_STORE = 3] = "GOOGLE_APP_STORE";
  }(t.MobileAppVendor || (t.MobileAppVendor = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.FROM = 2] = "FROM", e[e.UP_TO = 3] = "UP_TO", e[e.AVERAGE = 4] = "AVERAGE";
  }(t.PriceExtensionPriceQualifier || (t.PriceExtensionPriceQualifier = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PER_HOUR = 2] = "PER_HOUR", e[e.PER_DAY = 3] = "PER_DAY", e[e.PER_WEEK = 4] = "PER_WEEK", e[e.PER_MONTH = 5] = "PER_MONTH", e[e.PER_YEAR = 6] = "PER_YEAR", e[e.PER_NIGHT = 7] = "PER_NIGHT";
  }(t.PriceExtensionPriceUnit || (t.PriceExtensionPriceUnit = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.BRANDS = 2] = "BRANDS", e[e.EVENTS = 3] = "EVENTS", e[e.LOCATIONS = 4] = "LOCATIONS", e[e.NEIGHBORHOODS = 5] = "NEIGHBORHOODS", e[e.PRODUCT_CATEGORIES = 6] = "PRODUCT_CATEGORIES", e[e.PRODUCT_TIERS = 7] = "PRODUCT_TIERS", e[e.SERVICES = 8] = "SERVICES", e[e.SERVICE_CATEGORIES = 9] = "SERVICE_CATEGORIES", e[e.SERVICE_TIERS = 10] = "SERVICE_TIERS";
  }(t.PriceExtensionType || (t.PriceExtensionType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AZTEC = 2] = "AZTEC", e[e.CODABAR = 3] = "CODABAR", e[e.CODE39 = 4] = "CODE39", e[e.CODE128 = 5] = "CODE128", e[e.DATA_MATRIX = 6] = "DATA_MATRIX", e[e.EAN8 = 7] = "EAN8", e[e.EAN13 = 8] = "EAN13", e[e.ITF = 9] = "ITF", e[e.PDF417 = 10] = "PDF417", e[e.UPC_A = 11] = "UPC_A";
  }(t.PromotionBarcodeType || (t.PromotionBarcodeType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.UP_TO = 2] = "UP_TO";
  }(t.PromotionExtensionDiscountModifier || (t.PromotionExtensionDiscountModifier = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NEW_YEARS = 2] = "NEW_YEARS", e[e.CHINESE_NEW_YEAR = 3] = "CHINESE_NEW_YEAR", e[e.VALENTINES_DAY = 4] = "VALENTINES_DAY", e[e.EASTER = 5] = "EASTER", e[e.MOTHERS_DAY = 6] = "MOTHERS_DAY", e[e.FATHERS_DAY = 7] = "FATHERS_DAY", e[e.LABOR_DAY = 8] = "LABOR_DAY", e[e.BACK_TO_SCHOOL = 9] = "BACK_TO_SCHOOL", e[e.HALLOWEEN = 10] = "HALLOWEEN", e[e.BLACK_FRIDAY = 11] = "BLACK_FRIDAY", e[e.CYBER_MONDAY = 12] = "CYBER_MONDAY", e[e.CHRISTMAS = 13] = "CHRISTMAS", e[e.BOXING_DAY = 14] = "BOXING_DAY", e[e.INDEPENDENCE_DAY = 15] = "INDEPENDENCE_DAY", e[e.NATIONAL_DAY = 16] = "NATIONAL_DAY", e[e.END_OF_SEASON = 17] = "END_OF_SEASON", e[e.WINTER_SALE = 18] = "WINTER_SALE", e[e.SUMMER_SALE = 19] = "SUMMER_SALE", e[e.FALL_SALE = 20] = "FALL_SALE", e[e.SPRING_SALE = 21] = "SPRING_SALE", e[e.RAMADAN = 22] = "RAMADAN", e[e.EID_AL_FITR = 23] = "EID_AL_FITR", e[e.EID_AL_ADHA = 24] = "EID_AL_ADHA", e[e.SINGLES_DAY = 25] = "SINGLES_DAY", e[e.WOMENS_DAY = 26] = "WOMENS_DAY", e[e.HOLI = 27] = "HOLI", e[e.PARENTS_DAY = 28] = "PARENTS_DAY", e[e.ST_NICHOLAS_DAY = 29] = "ST_NICHOLAS_DAY", e[e.CARNIVAL = 30] = "CARNIVAL", e[e.EPIPHANY = 31] = "EPIPHANY", e[e.ROSH_HASHANAH = 32] = "ROSH_HASHANAH", e[e.PASSOVER = 33] = "PASSOVER", e[e.HANUKKAH = 34] = "HANUKKAH", e[e.DIWALI = 35] = "DIWALI", e[e.NAVRATRI = 36] = "NAVRATRI", e[e.SONGKRAN = 37] = "SONGKRAN", e[e.YEAR_END_GIFT = 38] = "YEAR_END_GIFT";
  }(t.PromotionExtensionOccasion || (t.PromotionExtensionOccasion = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CATEGORY = 2] = "CATEGORY", e[e.KNOWLEDGE_GRAPH = 3] = "KNOWLEDGE_GRAPH", e[e.GEO_TARGET_COUNTRY = 4] = "GEO_TARGET_COUNTRY", e[e.SUB_COUNTRY_LOCATION = 5] = "SUB_COUNTRY_LOCATION", e[e.YOUTUBE_CHANNEL = 6] = "YOUTUBE_CHANNEL", e[e.AFFINITY_USER_INTEREST = 8] = "AFFINITY_USER_INTEREST", e[e.IN_MARKET_USER_INTEREST = 9] = "IN_MARKET_USER_INTEREST", e[e.PARENTAL_STATUS = 10] = "PARENTAL_STATUS", e[e.INCOME_RANGE = 11] = "INCOME_RANGE", e[e.AGE_RANGE = 12] = "AGE_RANGE", e[e.GENDER = 13] = "GENDER", e[e.YOUTUBE_VIDEO = 14] = "YOUTUBE_VIDEO", e[e.DEVICE = 15] = "DEVICE", e[e.YOUTUBE_LINEUP = 16] = "YOUTUBE_LINEUP", e[e.USER_LIST = 17] = "USER_LIST", e[e.LIFE_EVENT_USER_INTEREST = 18] = "LIFE_EVENT_USER_INTEREST";
  }(t.AudienceInsightsDimension || (t.AudienceInsightsDimension = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CONTENT_TRENDING_INSIGHTS = 2] = "CONTENT_TRENDING_INSIGHTS", e[e.CREATOR_ATTRIBUTE = 3] = "CREATOR_ATTRIBUTE", e[e.BRAND = 4] = "BRAND", e[e.CREATOR_TOPIC_INSIGHTS = 5] = "CREATOR_TOPIC_INSIGHTS";
  }(t.InsightsKnowledgeGraphEntityCapabilities || (t.InsightsKnowledgeGraphEntityCapabilities = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.REMARKETING = 2] = "REMARKETING", e[e.LOGICAL = 3] = "LOGICAL", e[e.EXTERNAL_REMARKETING = 4] = "EXTERNAL_REMARKETING", e[e.RULE_BASED = 5] = "RULE_BASED", e[e.SIMILAR = 6] = "SIMILAR", e[e.CRM_BASED = 7] = "CRM_BASED", e[e.LOOKALIKE = 9] = "LOOKALIKE";
  }(t.UserListType || (t.UserListType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.LIVE_STREAM = 2] = "LIVE_STREAM", e[e.SHORTS = 3] = "SHORTS";
  }(t.YouTubeVideoProperty || (t.YouTubeVideoProperty = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.REACH = 2] = "REACH", e[e.TARGET_FREQUENCY = 3] = "TARGET_FREQUENCY";
  }(t.FixedCpmGoal || (t.FixedCpmGoal = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.MONTHLY = 2] = "MONTHLY";
  }(t.FixedCpmTargetFrequencyTimeUnit || (t.FixedCpmTargetFrequencyTimeUnit = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.WEEKLY = 2] = "WEEKLY", e[e.MONTHLY = 3] = "MONTHLY";
  }(t.TargetFrequencyTimeUnit || (t.TargetFrequencyTimeUnit = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ANYWHERE_ON_PAGE = 2] = "ANYWHERE_ON_PAGE", e[e.TOP_OF_PAGE = 3] = "TOP_OF_PAGE", e[e.ABSOLUTE_TOP_OF_PAGE = 4] = "ABSOLUTE_TOP_OF_PAGE";
  }(t.TargetImpressionShareLocation || (t.TargetImpressionShareLocation = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.TARGET_ALL = 2] = "TARGET_ALL", e[e.TARGET_SPECIFIC = 3] = "TARGET_SPECIFIC";
  }(t.CustomerLifecycleOptimizationMode || (t.CustomerLifecycleOptimizationMode = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.GRANTED = 2] = "GRANTED", e[e.DENIED = 3] = "DENIED";
  }(t.ConsentStatus || (t.ConsentStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.SEARCH_MOBILE_APP = 2] = "SEARCH_MOBILE_APP", e[e.DISPLAY_MOBILE_APP = 3] = "DISPLAY_MOBILE_APP", e[e.SEARCH_EXPRESS = 4] = "SEARCH_EXPRESS", e[e.DISPLAY_EXPRESS = 5] = "DISPLAY_EXPRESS", e[e.SHOPPING_SMART_ADS = 6] = "SHOPPING_SMART_ADS", e[e.DISPLAY_GMAIL_AD = 7] = "DISPLAY_GMAIL_AD", e[e.DISPLAY_SMART_CAMPAIGN = 8] = "DISPLAY_SMART_CAMPAIGN", e[e.VIDEO_ACTION = 10] = "VIDEO_ACTION", e[e.VIDEO_NON_SKIPPABLE = 11] = "VIDEO_NON_SKIPPABLE", e[e.APP_CAMPAIGN = 12] = "APP_CAMPAIGN", e[e.APP_CAMPAIGN_FOR_ENGAGEMENT = 13] = "APP_CAMPAIGN_FOR_ENGAGEMENT", e[e.LOCAL_CAMPAIGN = 14] = "LOCAL_CAMPAIGN", e[e.SHOPPING_COMPARISON_LISTING_ADS = 15] = "SHOPPING_COMPARISON_LISTING_ADS", e[e.SMART_CAMPAIGN = 16] = "SMART_CAMPAIGN", e[e.VIDEO_SEQUENCE = 17] = "VIDEO_SEQUENCE", e[e.APP_CAMPAIGN_FOR_PRE_REGISTRATION = 18] = "APP_CAMPAIGN_FOR_PRE_REGISTRATION", e[e.VIDEO_REACH_TARGET_FREQUENCY = 19] = "VIDEO_REACH_TARGET_FREQUENCY", e[e.TRAVEL_ACTIVITIES = 20] = "TRAVEL_ACTIVITIES", e[e.YOUTUBE_AUDIO = 22] = "YOUTUBE_AUDIO";
  }(t.AdvertisingChannelSubType || (t.AdvertisingChannelSubType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.SEARCH = 2] = "SEARCH", e[e.DISPLAY = 3] = "DISPLAY", e[e.SHOPPING = 4] = "SHOPPING", e[e.HOTEL = 5] = "HOTEL", e[e.VIDEO = 6] = "VIDEO", e[e.MULTI_CHANNEL = 7] = "MULTI_CHANNEL", e[e.LOCAL = 8] = "LOCAL", e[e.SMART = 9] = "SMART", e[e.PERFORMANCE_MAX = 10] = "PERFORMANCE_MAX", e[e.LOCAL_SERVICES = 11] = "LOCAL_SERVICES", e[e.TRAVEL = 13] = "TRAVEL", e[e.DEMAND_GEN = 14] = "DEMAND_GEN";
  }(t.AdvertisingChannelType || (t.AdvertisingChannelType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ALL_CHANNELS = 2] = "ALL_CHANNELS", e[e.CHANNEL_TYPE_AND_ALL_SUBTYPES = 3] = "CHANNEL_TYPE_AND_ALL_SUBTYPES", e[e.CHANNEL_TYPE_AND_SUBSET_SUBTYPES = 4] = "CHANNEL_TYPE_AND_SUBSET_SUBTYPES";
  }(t.CriterionCategoryChannelAvailabilityMode || (t.CriterionCategoryChannelAvailabilityMode = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ALL_LOCALES = 2] = "ALL_LOCALES", e[e.COUNTRY_AND_ALL_LANGUAGES = 3] = "COUNTRY_AND_ALL_LANGUAGES", e[e.LANGUAGE_AND_ALL_COUNTRIES = 4] = "LANGUAGE_AND_ALL_COUNTRIES", e[e.COUNTRY_AND_LANGUAGE = 5] = "COUNTRY_AND_LANGUAGE";
  }(t.CriterionCategoryLocaleAvailabilityMode || (t.CriterionCategoryLocaleAvailabilityMode = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.TEXT = 2] = "TEXT", e[e.NUMBER = 3] = "NUMBER", e[e.PRICE = 4] = "PRICE", e[e.PERCENT = 5] = "PERCENT";
  }(t.CustomizerAttributeType || (t.CustomizerAttributeType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.JANUARY = 2] = "JANUARY", e[e.FEBRUARY = 3] = "FEBRUARY", e[e.MARCH = 4] = "MARCH", e[e.APRIL = 5] = "APRIL", e[e.MAY = 6] = "MAY", e[e.JUNE = 7] = "JUNE", e[e.JULY = 8] = "JULY", e[e.AUGUST = 9] = "AUGUST", e[e.SEPTEMBER = 10] = "SEPTEMBER", e[e.OCTOBER = 11] = "OCTOBER", e[e.NOVEMBER = 12] = "NOVEMBER", e[e.DECEMBER = 13] = "DECEMBER";
  }(t.MonthOfYear || (t.MonthOfYear = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.DEFAULT = 2] = "DEFAULT", e[e.PAGE_VIEW = 3] = "PAGE_VIEW", e[e.PURCHASE = 4] = "PURCHASE", e[e.SIGNUP = 5] = "SIGNUP", e[e.DOWNLOAD = 7] = "DOWNLOAD", e[e.ADD_TO_CART = 8] = "ADD_TO_CART", e[e.BEGIN_CHECKOUT = 9] = "BEGIN_CHECKOUT", e[e.SUBSCRIBE_PAID = 10] = "SUBSCRIBE_PAID", e[e.PHONE_CALL_LEAD = 11] = "PHONE_CALL_LEAD", e[e.IMPORTED_LEAD = 12] = "IMPORTED_LEAD", e[e.SUBMIT_LEAD_FORM = 13] = "SUBMIT_LEAD_FORM", e[e.BOOK_APPOINTMENT = 14] = "BOOK_APPOINTMENT", e[e.REQUEST_QUOTE = 15] = "REQUEST_QUOTE", e[e.GET_DIRECTIONS = 16] = "GET_DIRECTIONS", e[e.OUTBOUND_CLICK = 17] = "OUTBOUND_CLICK", e[e.CONTACT = 18] = "CONTACT", e[e.ENGAGEMENT = 19] = "ENGAGEMENT", e[e.STORE_VISIT = 20] = "STORE_VISIT", e[e.STORE_SALE = 21] = "STORE_SALE", e[e.QUALIFIED_LEAD = 22] = "QUALIFIED_LEAD", e[e.CONVERTED_LEAD = 23] = "CONVERTED_LEAD", e[e.YOUTUBE_FOLLOW_ON_VIEWS = 24] = "YOUTUBE_FOLLOW_ON_VIEWS";
  }(t.ConversionActionCategory || (t.ConversionActionCategory = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.WEBSITE = 2] = "WEBSITE", e[e.GOOGLE_HOSTED = 3] = "GOOGLE_HOSTED", e[e.APP = 4] = "APP", e[e.CALL_FROM_ADS = 5] = "CALL_FROM_ADS", e[e.STORE = 6] = "STORE", e[e.YOUTUBE_HOSTED = 7] = "YOUTUBE_HOSTED", e[e.LOCAL_SERVICES_ADS = 8] = "LOCAL_SERVICES_ADS";
  }(t.ConversionOrigin || (t.ConversionOrigin = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ADD_ASSETS_TO_ASSETLESS_RETAIL = 2] = "ADD_ASSETS_TO_ASSETLESS_RETAIL", e[e.ADD_VIDEO_ASSETS_TO_VIDEOLESS = 3] = "ADD_VIDEO_ASSETS_TO_VIDEOLESS", e[e.COMPARE_ASSETS = 4] = "COMPARE_ASSETS";
  }(t.OptimizeAssetsExperimentSubtype || (t.OptimizeAssetsExperimentSubtype = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.DEMAND_GEN_ASSET = 2] = "DEMAND_GEN_ASSET", e[e.ASSET = 3] = "ASSET", e[e.ASSET_UPLIFT = 4] = "ASSET_UPLIFT";
  }(t.VideoExperimentSubtype || (t.VideoExperimentSubtype = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.IOS = 2] = "IOS", e[e.ANDROID = 3] = "ANDROID";
  }(t.AppUrlOperatingSystemType || (t.AppUrlOperatingSystemType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.IMPRESSION = 2] = "IMPRESSION", e[e.VIDEO_VIEW = 3] = "VIDEO_VIEW";
  }(t.FrequencyCapEventType || (t.FrequencyCapEventType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AD_GROUP_AD = 2] = "AD_GROUP_AD", e[e.AD_GROUP = 3] = "AD_GROUP", e[e.CAMPAIGN = 4] = "CAMPAIGN";
  }(t.FrequencyCapLevel || (t.FrequencyCapLevel = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.DAY = 2] = "DAY", e[e.WEEK = 3] = "WEEK", e[e.MONTH = 4] = "MONTH";
  }(t.FrequencyCapTimeUnit || (t.FrequencyCapTimeUnit = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.DEVICE = 2] = "DEVICE";
  }(t.KeywordPlanAggregateMetricType || (t.KeywordPlanAggregateMetricType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.LOW = 2] = "LOW", e[e.MEDIUM = 3] = "MEDIUM", e[e.HIGH = 4] = "HIGH";
  }(t.KeywordPlanCompetitionLevel || (t.KeywordPlanCompetitionLevel = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.BRAND = 2] = "BRAND", e[e.OTHER_BRANDS = 3] = "OTHER_BRANDS", e[e.NON_BRAND = 4] = "NON_BRAND";
  }(t.KeywordPlanConceptGroupType || (t.KeywordPlanConceptGroupType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.DESTINATION_PHONE_NUMBER_FOR_ADS = 2] = "DESTINATION_PHONE_NUMBER_FOR_ADS", e[e.DESTINATION_PHONE_NUMBER_FOR_SMS_ONLY = 3] = "DESTINATION_PHONE_NUMBER_FOR_SMS_ONLY", e[e.DESTINATION_PHONE_NUMBER_FOR_WHATSAPP_ONLY = 4] = "DESTINATION_PHONE_NUMBER_FOR_WHATSAPP_ONLY";
  }(t.GlsPhoneNumberType || (t.GlsPhoneNumberType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CLICKS = 2] = "CLICKS", e[e.IMPRESSIONS = 3] = "IMPRESSIONS", e[e.COST = 4] = "COST", e[e.CONVERSIONS_PER_INTERACTION_RATE = 5] = "CONVERSIONS_PER_INTERACTION_RATE", e[e.COST_PER_CONVERSION = 6] = "COST_PER_CONVERSION", e[e.CONVERSIONS_VALUE_PER_COST = 7] = "CONVERSIONS_VALUE_PER_COST", e[e.AVERAGE_CPC = 8] = "AVERAGE_CPC", e[e.CTR = 9] = "CTR", e[e.INCREMENTAL_CONVERSIONS = 10] = "INCREMENTAL_CONVERSIONS", e[e.COMPLETED_VIDEO_VIEWS = 11] = "COMPLETED_VIDEO_VIEWS", e[e.CUSTOM_ALGORITHMS = 12] = "CUSTOM_ALGORITHMS", e[e.CONVERSIONS = 13] = "CONVERSIONS", e[e.CONVERSION_VALUE = 14] = "CONVERSION_VALUE";
  }(t.ExperimentMetric || (t.ExperimentMetric = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NO_CHANGE = 2] = "NO_CHANGE", e[e.INCREASE = 3] = "INCREASE", e[e.DECREASE = 4] = "DECREASE", e[e.NO_CHANGE_OR_INCREASE = 5] = "NO_CHANGE_OR_INCREASE", e[e.NO_CHANGE_OR_DECREASE = 6] = "NO_CHANGE_OR_DECREASE";
  }(t.ExperimentMetricDirection || (t.ExperimentMetricDirection = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CLICK = 2] = "CLICK", e[e.ENGAGEMENT = 3] = "ENGAGEMENT", e[e.VIDEO_VIEW = 4] = "VIDEO_VIEW", e[e.NONE = 5] = "NONE";
  }(t.InteractionEventType || (t.InteractionEventType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.BELOW_AVERAGE = 2] = "BELOW_AVERAGE", e[e.AVERAGE = 3] = "AVERAGE", e[e.ABOVE_AVERAGE = 4] = "ABOVE_AVERAGE";
  }(t.QualityScoreBucket || (t.QualityScoreBucket = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.FIRST_PARTY = 2] = "FIRST_PARTY", e[e.THIRD_PARTY = 3] = "THIRD_PARTY";
  }(t.UserIdentifierSource || (t.UserIdentifierSource = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NOT_APPLICABLE = 2] = "NOT_APPLICABLE", e[e.WEBSITE = 3] = "WEBSITE", e[e.APP_DEEP_LINK = 4] = "APP_DEEP_LINK", e[e.APP_STORE = 5] = "APP_STORE", e[e.PHONE_CALL = 6] = "PHONE_CALL", e[e.MAP_DIRECTIONS = 7] = "MAP_DIRECTIONS", e[e.LOCATION_LISTING = 8] = "LOCATION_LISTING", e[e.MESSAGE = 9] = "MESSAGE", e[e.LEAD_FORM = 10] = "LEAD_FORM", e[e.YOUTUBE = 11] = "YOUTUBE", e[e.UNMODELED_FOR_CONVERSIONS = 12] = "UNMODELED_FOR_CONVERSIONS";
  }(t.AdDestinationType || (t.AdDestinationType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.OTHER = 2] = "OTHER", e[e.UNSEGMENTED = 3] = "UNSEGMENTED", e[e.INSTREAM_SKIPPABLE = 4] = "INSTREAM_SKIPPABLE", e[e.INSTREAM_NON_SKIPPABLE = 5] = "INSTREAM_NON_SKIPPABLE", e[e.INFEED = 6] = "INFEED", e[e.BUMPER = 7] = "BUMPER", e[e.OUTSTREAM = 8] = "OUTSTREAM", e[e.MASTHEAD = 9] = "MASTHEAD", e[e.AUDIO = 10] = "AUDIO", e[e.SHORTS = 11] = "SHORTS", e[e.PAUSE = 12] = "PAUSE", e[e.VERTICAL_ADS_PROMOTION = 13] = "VERTICAL_ADS_PROMOTION", e[e.VERTICAL_ADS_BOOKING_LINK = 14] = "VERTICAL_ADS_BOOKING_LINK", e[e.TEXT = 15] = "TEXT";
  }(t.AdFormatType || (t.AdFormatType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.SEARCH = 2] = "SEARCH", e[e.SEARCH_PARTNERS = 3] = "SEARCH_PARTNERS", e[e.CONTENT = 4] = "CONTENT", e[e.MIXED = 7] = "MIXED", e[e.YOUTUBE = 8] = "YOUTUBE", e[e.GOOGLE_TV = 9] = "GOOGLE_TV", e[e.GOOGLE_OWNED_CHANNELS = 10] = "GOOGLE_OWNED_CHANNELS", e[e.GMAIL = 11] = "GMAIL", e[e.DISCOVER = 12] = "DISCOVER", e[e.MAPS = 13] = "MAPS";
  }(t.AdNetworkType || (t.AdNetworkType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.UNSEGMENTED = 2] = "UNSEGMENTED", e[e.INSTREAM_NON_SKIPPABLE_STANDARD = 3] = "INSTREAM_NON_SKIPPABLE_STANDARD", e[e.INSTREAM_NON_SKIPPABLE_MAX30_SEC = 4] = "INSTREAM_NON_SKIPPABLE_MAX30_SEC", e[e.INSTREAM_NON_SKIPPABLE_MAX60_SEC = 5] = "INSTREAM_NON_SKIPPABLE_MAX60_SEC";
  }(t.AdSubFormatType || (t.AdSubFormatType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.UNSEGMENTED = 2] = "UNSEGMENTED", e[e.YOUTUBE_INSTREAM = 3] = "YOUTUBE_INSTREAM", e[e.YOUTUBE_INFEED = 4] = "YOUTUBE_INFEED", e[e.YOUTUBE_SHORTS = 5] = "YOUTUBE_SHORTS";
  }(t.AdSubNetworkType || (t.AdSubNetworkType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.RECALL = 2] = "RECALL", e[e.AWARENESS = 3] = "AWARENESS", e[e.CONSIDERATION = 4] = "CONSIDERATION", e[e.FAVORABILITY = 5] = "FAVORABILITY", e[e.PURCHASE_INTENT = 6] = "PURCHASE_INTENT", e[e.CUSTOM = 7] = "CUSTOM", e[e.ASSOCIATION = 8] = "ASSOCIATION";
  }(t.BrandLiftMeasurementType || (t.BrandLiftMeasurementType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED";
  }(t.BudgetCampaignAssociationStatus || (t.BudgetCampaignAssociationStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.APP_DEEPLINK = 2] = "APP_DEEPLINK", e[e.BREADCRUMBS = 3] = "BREADCRUMBS", e[e.BROADBAND_PLAN = 4] = "BROADBAND_PLAN", e[e.CALL_TRACKING = 5] = "CALL_TRACKING", e[e.CALLS = 6] = "CALLS", e[e.CLICK_ON_ENGAGEMENT_AD = 7] = "CLICK_ON_ENGAGEMENT_AD", e[e.GET_DIRECTIONS = 8] = "GET_DIRECTIONS", e[e.LOCATION_EXPANSION = 9] = "LOCATION_EXPANSION", e[e.LOCATION_FORMAT_CALL = 10] = "LOCATION_FORMAT_CALL", e[e.LOCATION_FORMAT_DIRECTIONS = 11] = "LOCATION_FORMAT_DIRECTIONS", e[e.LOCATION_FORMAT_IMAGE = 12] = "LOCATION_FORMAT_IMAGE", e[e.LOCATION_FORMAT_LANDING_PAGE = 13] = "LOCATION_FORMAT_LANDING_PAGE", e[e.LOCATION_FORMAT_MAP = 14] = "LOCATION_FORMAT_MAP", e[e.LOCATION_FORMAT_STORE_INFO = 15] = "LOCATION_FORMAT_STORE_INFO", e[e.LOCATION_FORMAT_TEXT = 16] = "LOCATION_FORMAT_TEXT", e[e.MOBILE_CALL_TRACKING = 17] = "MOBILE_CALL_TRACKING", e[e.OFFER_PRINTS = 18] = "OFFER_PRINTS", e[e.OTHER = 19] = "OTHER", e[e.PRODUCT_EXTENSION_CLICKS = 20] = "PRODUCT_EXTENSION_CLICKS", e[e.PRODUCT_LISTING_AD_CLICKS = 21] = "PRODUCT_LISTING_AD_CLICKS", e[e.SITELINKS = 22] = "SITELINKS", e[e.STORE_LOCATOR = 23] = "STORE_LOCATOR", e[e.URL_CLICKS = 25] = "URL_CLICKS", e[e.VIDEO_APP_STORE_CLICKS = 26] = "VIDEO_APP_STORE_CLICKS", e[e.VIDEO_CALL_TO_ACTION_CLICKS = 27] = "VIDEO_CALL_TO_ACTION_CLICKS", e[e.VIDEO_CARD_ACTION_HEADLINE_CLICKS = 28] = "VIDEO_CARD_ACTION_HEADLINE_CLICKS", e[e.VIDEO_END_CAP_CLICKS = 29] = "VIDEO_END_CAP_CLICKS", e[e.VIDEO_WEBSITE_CLICKS = 30] = "VIDEO_WEBSITE_CLICKS", e[e.VISUAL_SITELINKS = 31] = "VISUAL_SITELINKS", e[e.WIRELESS_PLAN = 32] = "WIRELESS_PLAN", e[e.PRODUCT_LISTING_AD_LOCAL = 33] = "PRODUCT_LISTING_AD_LOCAL", e[e.PRODUCT_LISTING_AD_MULTICHANNEL_LOCAL = 34] = "PRODUCT_LISTING_AD_MULTICHANNEL_LOCAL", e[e.PRODUCT_LISTING_AD_MULTICHANNEL_ONLINE = 35] = "PRODUCT_LISTING_AD_MULTICHANNEL_ONLINE", e[e.PRODUCT_LISTING_ADS_COUPON = 36] = "PRODUCT_LISTING_ADS_COUPON", e[e.PRODUCT_LISTING_AD_TRANSACTABLE = 37] = "PRODUCT_LISTING_AD_TRANSACTABLE", e[e.PRODUCT_AD_APP_DEEPLINK = 38] = "PRODUCT_AD_APP_DEEPLINK", e[e.SHOWCASE_AD_CATEGORY_LINK = 39] = "SHOWCASE_AD_CATEGORY_LINK", e[e.SHOWCASE_AD_LOCAL_STOREFRONT_LINK = 40] = "SHOWCASE_AD_LOCAL_STOREFRONT_LINK", e[e.SHOWCASE_AD_ONLINE_PRODUCT_LINK = 42] = "SHOWCASE_AD_ONLINE_PRODUCT_LINK", e[e.SHOWCASE_AD_LOCAL_PRODUCT_LINK = 43] = "SHOWCASE_AD_LOCAL_PRODUCT_LINK", e[e.PROMOTION_EXTENSION = 44] = "PROMOTION_EXTENSION", e[e.SWIPEABLE_GALLERY_AD_HEADLINE = 45] = "SWIPEABLE_GALLERY_AD_HEADLINE", e[e.SWIPEABLE_GALLERY_AD_SWIPES = 46] = "SWIPEABLE_GALLERY_AD_SWIPES", e[e.SWIPEABLE_GALLERY_AD_SEE_MORE = 47] = "SWIPEABLE_GALLERY_AD_SEE_MORE", e[e.SWIPEABLE_GALLERY_AD_SITELINK_ONE = 48] = "SWIPEABLE_GALLERY_AD_SITELINK_ONE", e[e.SWIPEABLE_GALLERY_AD_SITELINK_TWO = 49] = "SWIPEABLE_GALLERY_AD_SITELINK_TWO", e[e.SWIPEABLE_GALLERY_AD_SITELINK_THREE = 50] = "SWIPEABLE_GALLERY_AD_SITELINK_THREE", e[e.SWIPEABLE_GALLERY_AD_SITELINK_FOUR = 51] = "SWIPEABLE_GALLERY_AD_SITELINK_FOUR", e[e.SWIPEABLE_GALLERY_AD_SITELINK_FIVE = 52] = "SWIPEABLE_GALLERY_AD_SITELINK_FIVE", e[e.HOTEL_PRICE = 53] = "HOTEL_PRICE", e[e.PRICE_EXTENSION = 54] = "PRICE_EXTENSION", e[e.HOTEL_BOOK_ON_GOOGLE_ROOM_SELECTION = 55] = "HOTEL_BOOK_ON_GOOGLE_ROOM_SELECTION", e[e.SHOPPING_COMPARISON_LISTING = 56] = "SHOPPING_COMPARISON_LISTING", e[e.CROSS_NETWORK = 57] = "CROSS_NETWORK", e[e.AD_IMAGE = 58] = "AD_IMAGE", e[e.TRAVEL_ASSETS = 59] = "TRAVEL_ASSETS", e[e.VEHICLE_ASSETS = 60] = "VEHICLE_ASSETS", e[e.PRODUCT_ASSETS = 61] = "PRODUCT_ASSETS", e[e.VIDEO_CHANNEL_CLICK = 62] = "VIDEO_CHANNEL_CLICK", e[e.VIDEO_RELATED_VIDEOS_CLICK = 63] = "VIDEO_RELATED_VIDEOS_CLICK", e[e.CLICK_TO_MESSAGE_THIRD_PARTY_CLICK = 64] = "CLICK_TO_MESSAGE_THIRD_PARTY_CLICK", e[e.CLICK_TO_MESSAGE_LANDING_PAGE_CLICK = 65] = "CLICK_TO_MESSAGE_LANDING_PAGE_CLICK";
  }(t.ClickType || (t.ClickType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.IMPRESSION = 2] = "IMPRESSION", e[e.INTERACTION = 3] = "INTERACTION", e[e.ENGAGED_VIEW = 4] = "ENGAGED_VIEW";
  }(t.ConversionAttributionEventType || (t.ConversionAttributionEventType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.LESS_THAN_ONE_DAY = 2] = "LESS_THAN_ONE_DAY", e[e.ONE_TO_TWO_DAYS = 3] = "ONE_TO_TWO_DAYS", e[e.TWO_TO_THREE_DAYS = 4] = "TWO_TO_THREE_DAYS", e[e.THREE_TO_FOUR_DAYS = 5] = "THREE_TO_FOUR_DAYS", e[e.FOUR_TO_FIVE_DAYS = 6] = "FOUR_TO_FIVE_DAYS", e[e.FIVE_TO_SIX_DAYS = 7] = "FIVE_TO_SIX_DAYS", e[e.SIX_TO_SEVEN_DAYS = 8] = "SIX_TO_SEVEN_DAYS", e[e.SEVEN_TO_EIGHT_DAYS = 9] = "SEVEN_TO_EIGHT_DAYS", e[e.EIGHT_TO_NINE_DAYS = 10] = "EIGHT_TO_NINE_DAYS", e[e.NINE_TO_TEN_DAYS = 11] = "NINE_TO_TEN_DAYS", e[e.TEN_TO_ELEVEN_DAYS = 12] = "TEN_TO_ELEVEN_DAYS", e[e.ELEVEN_TO_TWELVE_DAYS = 13] = "ELEVEN_TO_TWELVE_DAYS", e[e.TWELVE_TO_THIRTEEN_DAYS = 14] = "TWELVE_TO_THIRTEEN_DAYS", e[e.THIRTEEN_TO_FOURTEEN_DAYS = 15] = "THIRTEEN_TO_FOURTEEN_DAYS", e[e.FOURTEEN_TO_TWENTY_ONE_DAYS = 16] = "FOURTEEN_TO_TWENTY_ONE_DAYS", e[e.TWENTY_ONE_TO_THIRTY_DAYS = 17] = "TWENTY_ONE_TO_THIRTY_DAYS", e[e.THIRTY_TO_FORTY_FIVE_DAYS = 18] = "THIRTY_TO_FORTY_FIVE_DAYS", e[e.FORTY_FIVE_TO_SIXTY_DAYS = 19] = "FORTY_FIVE_TO_SIXTY_DAYS", e[e.SIXTY_TO_NINETY_DAYS = 20] = "SIXTY_TO_NINETY_DAYS";
  }(t.ConversionLagBucket || (t.ConversionLagBucket = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ALL = 2] = "ALL", e[e.SELECTED = 3] = "SELECTED";
  }(t.ConversionLiftIncludedConversionActionTypes || (t.ConversionLiftIncludedConversionActionTypes = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CONVERSION_LESS_THAN_ONE_DAY = 2] = "CONVERSION_LESS_THAN_ONE_DAY", e[e.CONVERSION_ONE_TO_TWO_DAYS = 3] = "CONVERSION_ONE_TO_TWO_DAYS", e[e.CONVERSION_TWO_TO_THREE_DAYS = 4] = "CONVERSION_TWO_TO_THREE_DAYS", e[e.CONVERSION_THREE_TO_FOUR_DAYS = 5] = "CONVERSION_THREE_TO_FOUR_DAYS", e[e.CONVERSION_FOUR_TO_FIVE_DAYS = 6] = "CONVERSION_FOUR_TO_FIVE_DAYS", e[e.CONVERSION_FIVE_TO_SIX_DAYS = 7] = "CONVERSION_FIVE_TO_SIX_DAYS", e[e.CONVERSION_SIX_TO_SEVEN_DAYS = 8] = "CONVERSION_SIX_TO_SEVEN_DAYS", e[e.CONVERSION_SEVEN_TO_EIGHT_DAYS = 9] = "CONVERSION_SEVEN_TO_EIGHT_DAYS", e[e.CONVERSION_EIGHT_TO_NINE_DAYS = 10] = "CONVERSION_EIGHT_TO_NINE_DAYS", e[e.CONVERSION_NINE_TO_TEN_DAYS = 11] = "CONVERSION_NINE_TO_TEN_DAYS", e[e.CONVERSION_TEN_TO_ELEVEN_DAYS = 12] = "CONVERSION_TEN_TO_ELEVEN_DAYS", e[e.CONVERSION_ELEVEN_TO_TWELVE_DAYS = 13] = "CONVERSION_ELEVEN_TO_TWELVE_DAYS", e[e.CONVERSION_TWELVE_TO_THIRTEEN_DAYS = 14] = "CONVERSION_TWELVE_TO_THIRTEEN_DAYS", e[e.CONVERSION_THIRTEEN_TO_FOURTEEN_DAYS = 15] = "CONVERSION_THIRTEEN_TO_FOURTEEN_DAYS", e[e.CONVERSION_FOURTEEN_TO_TWENTY_ONE_DAYS = 16] = "CONVERSION_FOURTEEN_TO_TWENTY_ONE_DAYS", e[e.CONVERSION_TWENTY_ONE_TO_THIRTY_DAYS = 17] = "CONVERSION_TWENTY_ONE_TO_THIRTY_DAYS", e[e.CONVERSION_THIRTY_TO_FORTY_FIVE_DAYS = 18] = "CONVERSION_THIRTY_TO_FORTY_FIVE_DAYS", e[e.CONVERSION_FORTY_FIVE_TO_SIXTY_DAYS = 19] = "CONVERSION_FORTY_FIVE_TO_SIXTY_DAYS", e[e.CONVERSION_SIXTY_TO_NINETY_DAYS = 20] = "CONVERSION_SIXTY_TO_NINETY_DAYS", e[e.ADJUSTMENT_LESS_THAN_ONE_DAY = 21] = "ADJUSTMENT_LESS_THAN_ONE_DAY", e[e.ADJUSTMENT_ONE_TO_TWO_DAYS = 22] = "ADJUSTMENT_ONE_TO_TWO_DAYS", e[e.ADJUSTMENT_TWO_TO_THREE_DAYS = 23] = "ADJUSTMENT_TWO_TO_THREE_DAYS", e[e.ADJUSTMENT_THREE_TO_FOUR_DAYS = 24] = "ADJUSTMENT_THREE_TO_FOUR_DAYS", e[e.ADJUSTMENT_FOUR_TO_FIVE_DAYS = 25] = "ADJUSTMENT_FOUR_TO_FIVE_DAYS", e[e.ADJUSTMENT_FIVE_TO_SIX_DAYS = 26] = "ADJUSTMENT_FIVE_TO_SIX_DAYS", e[e.ADJUSTMENT_SIX_TO_SEVEN_DAYS = 27] = "ADJUSTMENT_SIX_TO_SEVEN_DAYS", e[e.ADJUSTMENT_SEVEN_TO_EIGHT_DAYS = 28] = "ADJUSTMENT_SEVEN_TO_EIGHT_DAYS", e[e.ADJUSTMENT_EIGHT_TO_NINE_DAYS = 29] = "ADJUSTMENT_EIGHT_TO_NINE_DAYS", e[e.ADJUSTMENT_NINE_TO_TEN_DAYS = 30] = "ADJUSTMENT_NINE_TO_TEN_DAYS", e[e.ADJUSTMENT_TEN_TO_ELEVEN_DAYS = 31] = "ADJUSTMENT_TEN_TO_ELEVEN_DAYS", e[e.ADJUSTMENT_ELEVEN_TO_TWELVE_DAYS = 32] = "ADJUSTMENT_ELEVEN_TO_TWELVE_DAYS", e[e.ADJUSTMENT_TWELVE_TO_THIRTEEN_DAYS = 33] = "ADJUSTMENT_TWELVE_TO_THIRTEEN_DAYS", e[e.ADJUSTMENT_THIRTEEN_TO_FOURTEEN_DAYS = 34] = "ADJUSTMENT_THIRTEEN_TO_FOURTEEN_DAYS", e[e.ADJUSTMENT_FOURTEEN_TO_TWENTY_ONE_DAYS = 35] = "ADJUSTMENT_FOURTEEN_TO_TWENTY_ONE_DAYS", e[e.ADJUSTMENT_TWENTY_ONE_TO_THIRTY_DAYS = 36] = "ADJUSTMENT_TWENTY_ONE_TO_THIRTY_DAYS", e[e.ADJUSTMENT_THIRTY_TO_FORTY_FIVE_DAYS = 37] = "ADJUSTMENT_THIRTY_TO_FORTY_FIVE_DAYS", e[e.ADJUSTMENT_FORTY_FIVE_TO_SIXTY_DAYS = 38] = "ADJUSTMENT_FORTY_FIVE_TO_SIXTY_DAYS", e[e.ADJUSTMENT_SIXTY_TO_NINETY_DAYS = 39] = "ADJUSTMENT_SIXTY_TO_NINETY_DAYS", e[e.ADJUSTMENT_NINETY_TO_ONE_HUNDRED_AND_FORTY_FIVE_DAYS = 40] = "ADJUSTMENT_NINETY_TO_ONE_HUNDRED_AND_FORTY_FIVE_DAYS", e[e.CONVERSION_UNKNOWN = 41] = "CONVERSION_UNKNOWN", e[e.ADJUSTMENT_UNKNOWN = 42] = "ADJUSTMENT_UNKNOWN";
  }(t.ConversionOrAdjustmentLagBucket || (t.ConversionOrAdjustmentLagBucket = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NO_RULE_APPLIED = 2] = "NO_RULE_APPLIED", e[e.ORIGINAL = 3] = "ORIGINAL", e[e.NEW_VS_RETURNING_USER = 4] = "NEW_VS_RETURNING_USER", e[e.GEO_LOCATION = 5] = "GEO_LOCATION", e[e.DEVICE = 6] = "DEVICE", e[e.AUDIENCE = 7] = "AUDIENCE", e[e.MULTIPLE = 8] = "MULTIPLE", e[e.ITINERARY = 9] = "ITINERARY", e[e.LOYALTY_MEMBERSHIP = 10] = "LOYALTY_MEMBERSHIP";
  }(t.ConversionValueRulePrimaryDimension || (t.ConversionValueRulePrimaryDimension = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NEW = 2] = "NEW", e[e.RETURNING = 3] = "RETURNING", e[e.NEW_AND_HIGH_LTV = 4] = "NEW_AND_HIGH_LTV";
  }(t.ConvertingUserPriorEngagementTypeAndLtvBucket || (t.ConvertingUserPriorEngagementTypeAndLtvBucket = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.WEBPAGE = 2] = "WEBPAGE", e[e.ANALYTICS = 3] = "ANALYTICS", e[e.UPLOAD = 4] = "UPLOAD", e[e.AD_CALL_METRICS = 5] = "AD_CALL_METRICS", e[e.WEBSITE_CALL_METRICS = 6] = "WEBSITE_CALL_METRICS", e[e.STORE_VISITS = 7] = "STORE_VISITS", e[e.ANDROID_IN_APP = 8] = "ANDROID_IN_APP", e[e.IOS_IN_APP = 9] = "IOS_IN_APP", e[e.IOS_FIRST_OPEN = 10] = "IOS_FIRST_OPEN", e[e.APP_UNSPECIFIED = 11] = "APP_UNSPECIFIED", e[e.ANDROID_FIRST_OPEN = 12] = "ANDROID_FIRST_OPEN", e[e.UPLOAD_CALLS = 13] = "UPLOAD_CALLS", e[e.FIREBASE = 14] = "FIREBASE", e[e.CLICK_TO_CALL = 15] = "CLICK_TO_CALL", e[e.SALESFORCE = 16] = "SALESFORCE", e[e.STORE_SALES_CRM = 17] = "STORE_SALES_CRM", e[e.STORE_SALES_PAYMENT_NETWORK = 18] = "STORE_SALES_PAYMENT_NETWORK", e[e.GOOGLE_PLAY = 19] = "GOOGLE_PLAY", e[e.THIRD_PARTY_APP_ANALYTICS = 20] = "THIRD_PARTY_APP_ANALYTICS", e[e.GOOGLE_ATTRIBUTION = 21] = "GOOGLE_ATTRIBUTION", e[e.STORE_SALES_DIRECT_UPLOAD = 23] = "STORE_SALES_DIRECT_UPLOAD", e[e.STORE_SALES = 24] = "STORE_SALES", e[e.SEARCH_ADS_360 = 25] = "SEARCH_ADS_360", e[e.GOOGLE_HOSTED = 27] = "GOOGLE_HOSTED", e[e.FLOODLIGHT = 29] = "FLOODLIGHT", e[e.ANALYTICS_SEARCH_ADS_360 = 31] = "ANALYTICS_SEARCH_ADS_360", e[e.FIREBASE_SEARCH_ADS_360 = 33] = "FIREBASE_SEARCH_ADS_360", e[e.DISPLAY_AND_VIDEO_360_FLOODLIGHT = 34] = "DISPLAY_AND_VIDEO_360_FLOODLIGHT";
  }(t.ExternalConversionSource || (t.ExternalConversionSource = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.LOWEST_UNIQUE = 2] = "LOWEST_UNIQUE", e[e.LOWEST_TIED = 3] = "LOWEST_TIED", e[e.NOT_LOWEST = 4] = "NOT_LOWEST", e[e.ONLY_PARTNER_SHOWN = 5] = "ONLY_PARTNER_SHOWN";
  }(t.HotelPriceBucket || (t.HotelPriceBucket = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.UNAVAILABLE = 2] = "UNAVAILABLE", e[e.PUBLIC_RATE = 3] = "PUBLIC_RATE", e[e.QUALIFIED_RATE = 4] = "QUALIFIED_RATE", e[e.PRIVATE_RATE = 5] = "PRIVATE_RATE";
  }(t.HotelRateType || (t.HotelRateType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ADVERTISER = 2] = "ADVERTISER", e[e.AUTOMATIC = 3] = "AUTOMATIC";
  }(t.LandingPageSource || (t.LandingPageSource = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NONMEMBER = 2] = "NONMEMBER", e[e.TIER1 = 3] = "TIER1", e[e.TIER2 = 4] = "TIER2", e[e.TIER3 = 5] = "TIER3", e[e.TIER4 = 6] = "TIER4", e[e.TIER5 = 7] = "TIER5", e[e.TIER6 = 8] = "TIER6", e[e.TIER7 = 9] = "TIER7";
  }(t.LoyaltyMembership || (t.LoyaltyMembership = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.BROAD = 2] = "BROAD", e[e.EXACT = 3] = "EXACT", e[e.PHRASE = 4] = "PHRASE", e[e.AI_MAX = 5] = "AI_MAX";
  }(t.MatchType || (t.MatchType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ANDROID = 2] = "ANDROID", e[e.IOS = 3] = "IOS", e[e.OTHER_MOBILE = 4] = "OTHER_MOBILE", e[e.DESKTOP = 5] = "DESKTOP";
  }(t.MobileDevicePlatform || (t.MobileDevicePlatform = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CAMPAIGN_BUDGET = 2] = "CAMPAIGN_BUDGET", e[e.KEYWORD = 3] = "KEYWORD", e[e.TEXT_AD = 4] = "TEXT_AD", e[e.TARGET_CPA_OPT_IN = 5] = "TARGET_CPA_OPT_IN", e[e.MAXIMIZE_CONVERSIONS_OPT_IN = 6] = "MAXIMIZE_CONVERSIONS_OPT_IN", e[e.ENHANCED_CPC_OPT_IN = 7] = "ENHANCED_CPC_OPT_IN", e[e.SEARCH_PARTNERS_OPT_IN = 8] = "SEARCH_PARTNERS_OPT_IN", e[e.MAXIMIZE_CLICKS_OPT_IN = 9] = "MAXIMIZE_CLICKS_OPT_IN", e[e.OPTIMIZE_AD_ROTATION = 10] = "OPTIMIZE_AD_ROTATION", e[e.KEYWORD_MATCH_TYPE = 14] = "KEYWORD_MATCH_TYPE", e[e.MOVE_UNUSED_BUDGET = 15] = "MOVE_UNUSED_BUDGET", e[e.FORECASTING_CAMPAIGN_BUDGET = 16] = "FORECASTING_CAMPAIGN_BUDGET", e[e.TARGET_ROAS_OPT_IN = 17] = "TARGET_ROAS_OPT_IN", e[e.RESPONSIVE_SEARCH_AD = 18] = "RESPONSIVE_SEARCH_AD", e[e.MARGINAL_ROI_CAMPAIGN_BUDGET = 19] = "MARGINAL_ROI_CAMPAIGN_BUDGET", e[e.USE_BROAD_MATCH_KEYWORD = 20] = "USE_BROAD_MATCH_KEYWORD", e[e.RESPONSIVE_SEARCH_AD_ASSET = 21] = "RESPONSIVE_SEARCH_AD_ASSET", e[e.UPGRADE_SMART_SHOPPING_CAMPAIGN_TO_PERFORMANCE_MAX = 22] = "UPGRADE_SMART_SHOPPING_CAMPAIGN_TO_PERFORMANCE_MAX", e[e.RESPONSIVE_SEARCH_AD_IMPROVE_AD_STRENGTH = 23] = "RESPONSIVE_SEARCH_AD_IMPROVE_AD_STRENGTH", e[e.DISPLAY_EXPANSION_OPT_IN = 24] = "DISPLAY_EXPANSION_OPT_IN", e[e.UPGRADE_LOCAL_CAMPAIGN_TO_PERFORMANCE_MAX = 25] = "UPGRADE_LOCAL_CAMPAIGN_TO_PERFORMANCE_MAX", e[e.RAISE_TARGET_CPA_BID_TOO_LOW = 26] = "RAISE_TARGET_CPA_BID_TOO_LOW", e[e.FORECASTING_SET_TARGET_ROAS = 27] = "FORECASTING_SET_TARGET_ROAS", e[e.CALLOUT_ASSET = 28] = "CALLOUT_ASSET", e[e.SITELINK_ASSET = 29] = "SITELINK_ASSET", e[e.CALL_ASSET = 30] = "CALL_ASSET", e[e.SHOPPING_ADD_AGE_GROUP = 31] = "SHOPPING_ADD_AGE_GROUP", e[e.SHOPPING_ADD_COLOR = 32] = "SHOPPING_ADD_COLOR", e[e.SHOPPING_ADD_GENDER = 33] = "SHOPPING_ADD_GENDER", e[e.SHOPPING_ADD_GTIN = 34] = "SHOPPING_ADD_GTIN", e[e.SHOPPING_ADD_MORE_IDENTIFIERS = 35] = "SHOPPING_ADD_MORE_IDENTIFIERS", e[e.SHOPPING_ADD_SIZE = 36] = "SHOPPING_ADD_SIZE", e[e.SHOPPING_ADD_PRODUCTS_TO_CAMPAIGN = 37] = "SHOPPING_ADD_PRODUCTS_TO_CAMPAIGN", e[e.SHOPPING_FIX_DISAPPROVED_PRODUCTS = 38] = "SHOPPING_FIX_DISAPPROVED_PRODUCTS", e[e.SHOPPING_TARGET_ALL_OFFERS = 39] = "SHOPPING_TARGET_ALL_OFFERS", e[e.SHOPPING_FIX_SUSPENDED_MERCHANT_CENTER_ACCOUNT = 40] = "SHOPPING_FIX_SUSPENDED_MERCHANT_CENTER_ACCOUNT", e[e.SHOPPING_FIX_MERCHANT_CENTER_ACCOUNT_SUSPENSION_WARNING = 41] = "SHOPPING_FIX_MERCHANT_CENTER_ACCOUNT_SUSPENSION_WARNING", e[e.SHOPPING_MIGRATE_REGULAR_SHOPPING_CAMPAIGN_OFFERS_TO_PERFORMANCE_MAX = 42] = "SHOPPING_MIGRATE_REGULAR_SHOPPING_CAMPAIGN_OFFERS_TO_PERFORMANCE_MAX", e[e.DYNAMIC_IMAGE_EXTENSION_OPT_IN = 43] = "DYNAMIC_IMAGE_EXTENSION_OPT_IN", e[e.RAISE_TARGET_CPA = 44] = "RAISE_TARGET_CPA", e[e.LOWER_TARGET_ROAS = 45] = "LOWER_TARGET_ROAS", e[e.PERFORMANCE_MAX_OPT_IN = 46] = "PERFORMANCE_MAX_OPT_IN", e[e.IMPROVE_PERFORMANCE_MAX_AD_STRENGTH = 47] = "IMPROVE_PERFORMANCE_MAX_AD_STRENGTH", e[e.MIGRATE_DYNAMIC_SEARCH_ADS_CAMPAIGN_TO_PERFORMANCE_MAX = 48] = "MIGRATE_DYNAMIC_SEARCH_ADS_CAMPAIGN_TO_PERFORMANCE_MAX", e[e.FORECASTING_SET_TARGET_CPA = 49] = "FORECASTING_SET_TARGET_CPA", e[e.SET_TARGET_CPA = 50] = "SET_TARGET_CPA", e[e.SET_TARGET_ROAS = 51] = "SET_TARGET_ROAS", e[e.MAXIMIZE_CONVERSION_VALUE_OPT_IN = 52] = "MAXIMIZE_CONVERSION_VALUE_OPT_IN", e[e.IMPROVE_GOOGLE_TAG_COVERAGE = 53] = "IMPROVE_GOOGLE_TAG_COVERAGE", e[e.PERFORMANCE_MAX_FINAL_URL_OPT_IN = 54] = "PERFORMANCE_MAX_FINAL_URL_OPT_IN", e[e.REFRESH_CUSTOMER_MATCH_LIST = 55] = "REFRESH_CUSTOMER_MATCH_LIST", e[e.CUSTOM_AUDIENCE_OPT_IN = 56] = "CUSTOM_AUDIENCE_OPT_IN", e[e.LEAD_FORM_ASSET = 57] = "LEAD_FORM_ASSET", e[e.IMPROVE_DEMAND_GEN_AD_STRENGTH = 58] = "IMPROVE_DEMAND_GEN_AD_STRENGTH", e[e.CAMPAIGN_SPECIFIC_APP_GOAL = 59] = "CAMPAIGN_SPECIFIC_APP_GOAL";
  }(t.RecommendationType || (t.RecommendationType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ADS_ONLY = 2] = "ADS_ONLY", e[e.ORGANIC_ONLY = 3] = "ORGANIC_ONLY", e[e.ADS_AND_ORGANIC = 4] = "ADS_AND_ORGANIC";
  }(t.SearchEngineResultsPageType || (t.SearchEngineResultsPageType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ADVERTISER_PROVIDED_KEYWORD = 2] = "ADVERTISER_PROVIDED_KEYWORD", e[e.AI_MAX_KEYWORDLESS = 3] = "AI_MAX_KEYWORDLESS", e[e.AI_MAX_BROAD_MATCH = 4] = "AI_MAX_BROAD_MATCH", e[e.DYNAMIC_SEARCH_ADS = 5] = "DYNAMIC_SEARCH_ADS", e[e.PERFORMANCE_MAX = 6] = "PERFORMANCE_MAX", e[e.VERTICAL_ADS_DATA_FEED = 7] = "VERTICAL_ADS_DATA_FEED";
  }(t.SearchTermMatchSource || (t.SearchTermMatchSource = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.BROAD = 2] = "BROAD", e[e.EXACT = 3] = "EXACT", e[e.PHRASE = 4] = "PHRASE", e[e.NEAR_EXACT = 5] = "NEAR_EXACT", e[e.NEAR_PHRASE = 6] = "NEAR_PHRASE", e[e.AI_MAX = 7] = "AI_MAX", e[e.PERFORMANCE_MAX = 8] = "PERFORMANCE_MAX";
  }(t.SearchTermMatchType || (t.SearchTermMatchType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ADDED = 2] = "ADDED", e[e.EXCLUDED = 3] = "EXCLUDED", e[e.ADDED_EXCLUDED = 4] = "ADDED_EXCLUDED", e[e.NONE = 5] = "NONE";
  }(t.SearchTermTargetingStatus || (t.SearchTermTargetingStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.UNAVAILABLE = 2] = "UNAVAILABLE", e[e.INTERACTION = 3] = "INTERACTION", e[e.VIEW = 4] = "VIEW";
  }(t.SkAdNetworkAdEventType || (t.SkAdNetworkAdEventType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.UNAVAILABLE = 2] = "UNAVAILABLE", e[e.WON = 3] = "WON", e[e.CONTRIBUTED = 4] = "CONTRIBUTED";
  }(t.SkAdNetworkAttributionCredit || (t.SkAdNetworkAttributionCredit = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.UNAVAILABLE = 2] = "UNAVAILABLE", e[e.LOW = 3] = "LOW", e[e.MEDIUM = 4] = "MEDIUM", e[e.HIGH = 5] = "HIGH", e[e.NONE = 6] = "NONE";
  }(t.SkAdNetworkCoarseConversionValue || (t.SkAdNetworkCoarseConversionValue = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.UNAVAILABLE = 2] = "UNAVAILABLE", e[e.WEBSITE = 3] = "WEBSITE", e[e.MOBILE_APPLICATION = 4] = "MOBILE_APPLICATION";
  }(t.SkAdNetworkSourceType || (t.SkAdNetworkSourceType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.UNAVAILABLE = 2] = "UNAVAILABLE", e[e.NEW_INSTALLER = 3] = "NEW_INSTALLER", e[e.REINSTALLER = 4] = "REINSTALLER";
  }(t.SkAdNetworkUserType || (t.SkAdNetworkUserType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.SEARCH_SIDE = 2] = "SEARCH_SIDE", e[e.SEARCH_TOP = 3] = "SEARCH_TOP", e[e.SEARCH_OTHER = 4] = "SEARCH_OTHER", e[e.CONTENT = 5] = "CONTENT", e[e.SEARCH_PARTNER_TOP = 6] = "SEARCH_PARTNER_TOP", e[e.SEARCH_PARTNER_OTHER = 7] = "SEARCH_PARTNER_OTHER", e[e.MIXED = 8] = "MIXED";
  }(t.Slot || (t.Slot = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.HOTELS = 2] = "HOTELS", e[e.VACATION_RENTALS = 3] = "VACATION_RENTALS", e[e.RENTAL_CARS = 4] = "RENTAL_CARS", e[e.EVENTS = 5] = "EVENTS", e[e.THINGS_TO_DO = 6] = "THINGS_TO_DO", e[e.FLIGHTS = 7] = "FLIGHTS";
  }(t.VerticalAdsItemVerticalType || (t.VerticalAdsItemVerticalType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NOT_SYNTHETIC = 2] = "NOT_SYNTHETIC", e[e.IS_SYNTHETIC = 3] = "IS_SYNTHETIC";
  }(t.SyntheticContentAttestationStatus || (t.SyntheticContentAttestationStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ADVERTISER_ATTESTED = 2] = "ADVERTISER_ATTESTED", e[e.GOOGLE_GENERATED_ADVERTISER_REVIEWED = 3] = "GOOGLE_GENERATED_ADVERTISER_REVIEWED", e[e.GOOGLE_GENERATED_FULLY_AUTOMATED = 4] = "GOOGLE_GENERATED_FULLY_AUTOMATED";
  }(t.SyntheticContentSource || (t.SyntheticContentSource = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.HTML = 2] = "HTML", e[e.AMP = 3] = "AMP";
  }(t.TrackingCodePageFormat || (t.TrackingCodePageFormat = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.WEBPAGE = 2] = "WEBPAGE", e[e.WEBPAGE_ONCLICK = 3] = "WEBPAGE_ONCLICK", e[e.CLICK_TO_CALL = 4] = "CLICK_TO_CALL", e[e.WEBSITE_CALL = 5] = "WEBSITE_CALL";
  }(t.TrackingCodeType || (t.TrackingCodeType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.KEYWORD = 2] = "KEYWORD", e[e.AUDIENCE = 3] = "AUDIENCE", e[e.TOPIC = 4] = "TOPIC", e[e.GENDER = 5] = "GENDER", e[e.AGE_RANGE = 6] = "AGE_RANGE", e[e.PLACEMENT = 7] = "PLACEMENT", e[e.PARENTAL_STATUS = 8] = "PARENTAL_STATUS", e[e.INCOME_RANGE = 9] = "INCOME_RANGE";
  }(t.TargetingDimension || (t.TargetingDimension = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.KANTAR_MILLWARD_BROWN = 2] = "KANTAR_MILLWARD_BROWN", e[e.DYNATA = 3] = "DYNATA", e[e.INTAGE = 4] = "INTAGE", e[e.MACROMILL = 5] = "MACROMILL";
  }(t.ThirdPartyBrandLiftIntegrationPartner || (t.ThirdPartyBrandLiftIntegrationPartner = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.DOUBLE_VERIFY = 2] = "DOUBLE_VERIFY", e[e.INTEGRAL_AD_SCIENCE = 3] = "INTEGRAL_AD_SCIENCE", e[e.ZEFR = 4] = "ZEFR";
  }(t.ThirdPartyBrandSafetyIntegrationPartner || (t.ThirdPartyBrandSafetyIntegrationPartner = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.TRANSUNION = 2] = "TRANSUNION";
  }(t.ThirdPartyConversionAttributionIntegrationPartner || (t.ThirdPartyConversionAttributionIntegrationPartner = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NIELSEN = 2] = "NIELSEN", e[e.COMSCORE = 3] = "COMSCORE", e[e.KANTAR_MILLWARD_BROWN = 4] = "KANTAR_MILLWARD_BROWN", e[e.VIDEO_RESEARCH = 5] = "VIDEO_RESEARCH", e[e.GEMIUS = 6] = "GEMIUS", e[e.MEDIA_SCOPE = 7] = "MEDIA_SCOPE", e[e.AUDIENCE_PROJECT = 8] = "AUDIENCE_PROJECT", e[e.VIDEO_AMP = 9] = "VIDEO_AMP", e[e.ISPOT_TV = 10] = "ISPOT_TV";
  }(t.ThirdPartyReachIntegrationPartner || (t.ThirdPartyReachIntegrationPartner = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.DOUBLE_VERIFY = 2] = "DOUBLE_VERIFY", e[e.INTEGRAL_AD_SCIENCE = 3] = "INTEGRAL_AD_SCIENCE", e[e.ZEFR = 4] = "ZEFR";
  }(t.ThirdPartyViewabilityIntegrationPartner || (t.ThirdPartyViewabilityIntegrationPartner = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CONTACT_INFO = 2] = "CONTACT_INFO", e[e.CRM_ID = 3] = "CRM_ID", e[e.MOBILE_ADVERTISING_ID = 4] = "MOBILE_ADVERTISING_ID";
  }(t.CustomerMatchUploadKeyType || (t.CustomerMatchUploadKeyType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NARROW = 2] = "NARROW", e[e.BALANCED = 3] = "BALANCED", e[e.BROAD = 4] = "BROAD";
  }(t.LookalikeExpansionLevel || (t.LookalikeExpansionLevel = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.FIRST_PARTY = 2] = "FIRST_PARTY", e[e.THIRD_PARTY_CREDIT_BUREAU = 3] = "THIRD_PARTY_CREDIT_BUREAU", e[e.THIRD_PARTY_VOTER_FILE = 4] = "THIRD_PARTY_VOTER_FILE", e[e.THIRD_PARTY_PARTNER_DATA = 5] = "THIRD_PARTY_PARTNER_DATA";
  }(t.UserListCrmDataSourceType || (t.UserListCrmDataSourceType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.EQUALS = 2] = "EQUALS", e[e.NOT_EQUALS = 3] = "NOT_EQUALS", e[e.BEFORE = 4] = "BEFORE", e[e.AFTER = 5] = "AFTER";
  }(t.UserListDateRuleItemOperator || (t.UserListDateRuleItemOperator = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AND = 2] = "AND", e[e.OR = 3] = "OR";
  }(t.UserListFlexibleRuleOperator || (t.UserListFlexibleRuleOperator = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ALL = 2] = "ALL", e[e.ANY = 3] = "ANY", e[e.NONE = 4] = "NONE";
  }(t.UserListLogicalRuleOperator || (t.UserListLogicalRuleOperator = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.GREATER_THAN = 2] = "GREATER_THAN", e[e.GREATER_THAN_OR_EQUAL = 3] = "GREATER_THAN_OR_EQUAL", e[e.EQUALS = 4] = "EQUALS", e[e.NOT_EQUALS = 5] = "NOT_EQUALS", e[e.LESS_THAN = 6] = "LESS_THAN", e[e.LESS_THAN_OR_EQUAL = 7] = "LESS_THAN_OR_EQUAL";
  }(t.UserListNumberRuleItemOperator || (t.UserListNumberRuleItemOperator = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.REQUESTED = 2] = "REQUESTED", e[e.FINISHED = 3] = "FINISHED", e[e.FAILED = 4] = "FAILED";
  }(t.UserListPrepopulationStatus || (t.UserListPrepopulationStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AND_OF_ORS = 2] = "AND_OF_ORS", e[e.OR_OF_ANDS = 3] = "OR_OF_ANDS";
  }(t.UserListRuleType || (t.UserListRuleType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CONTAINS = 2] = "CONTAINS", e[e.EQUALS = 3] = "EQUALS", e[e.STARTS_WITH = 4] = "STARTS_WITH", e[e.ENDS_WITH = 5] = "ENDS_WITH", e[e.NOT_EQUALS = 6] = "NOT_EQUALS", e[e.NOT_CONTAINS = 7] = "NOT_CONTAINS", e[e.NOT_STARTS_WITH = 8] = "NOT_STARTS_WITH", e[e.NOT_ENDS_WITH = 9] = "NOT_ENDS_WITH";
  }(t.UserListStringRuleItemOperator || (t.UserListStringRuleItemOperator = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PENDING = 2] = "PENDING", e[e.DECLINED = 3] = "DECLINED", e[e.EXPIRED = 4] = "EXPIRED";
  }(t.AccessInvitationStatus || (t.AccessInvitationStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.OWNED = 2] = "OWNED", e[e.SHARED = 3] = "SHARED", e[e.LICENSED = 4] = "LICENSED", e[e.SUBSCRIBED = 5] = "SUBSCRIBED", e[e.AFFILIATED = 6] = "AFFILIATED";
  }(t.AccessReason || (t.AccessReason = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ADMIN = 2] = "ADMIN", e[e.STANDARD = 3] = "STANDARD", e[e.READ_ONLY = 4] = "READ_ONLY", e[e.EMAIL_ONLY = 5] = "EMAIL_ONLY";
  }(t.AccessRole || (t.AccessRole = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PENDING = 2] = "PENDING", e[e.APPROVED_HELD = 3] = "APPROVED_HELD", e[e.APPROVED = 4] = "APPROVED", e[e.CANCELLED = 5] = "CANCELLED", e[e.REJECTED = 6] = "REJECTED";
  }(t.AccountBudgetProposalStatus || (t.AccountBudgetProposalStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CREATE = 2] = "CREATE", e[e.UPDATE = 3] = "UPDATE", e[e.END = 4] = "END", e[e.REMOVE = 5] = "REMOVE";
  }(t.AccountBudgetProposalType || (t.AccountBudgetProposalType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PENDING = 2] = "PENDING", e[e.APPROVED = 3] = "APPROVED", e[e.CANCELLED = 4] = "CANCELLED";
  }(t.AccountBudgetStatus || (t.AccountBudgetStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED", e[e.REQUESTED = 4] = "REQUESTED", e[e.PENDING_APPROVAL = 5] = "PENDING_APPROVAL", e[e.REJECTED = 6] = "REJECTED", e[e.REVOKED = 7] = "REVOKED";
  }(t.AccountLinkStatus || (t.AccountLinkStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ELIGIBLE = 2] = "ELIGIBLE", e[e.PAUSED = 3] = "PAUSED", e[e.REMOVED = 4] = "REMOVED", e[e.PENDING = 5] = "PENDING", e[e.LIMITED = 6] = "LIMITED", e[e.NOT_ELIGIBLE = 7] = "NOT_ELIGIBLE";
  }(t.AdGroupAdPrimaryStatus || (t.AdGroupAdPrimaryStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CAMPAIGN_REMOVED = 2] = "CAMPAIGN_REMOVED", e[e.CAMPAIGN_PAUSED = 3] = "CAMPAIGN_PAUSED", e[e.CAMPAIGN_PENDING = 4] = "CAMPAIGN_PENDING", e[e.CAMPAIGN_ENDED = 5] = "CAMPAIGN_ENDED", e[e.AD_GROUP_PAUSED = 6] = "AD_GROUP_PAUSED", e[e.AD_GROUP_REMOVED = 7] = "AD_GROUP_REMOVED", e[e.AD_GROUP_AD_PAUSED = 8] = "AD_GROUP_AD_PAUSED", e[e.AD_GROUP_AD_REMOVED = 9] = "AD_GROUP_AD_REMOVED", e[e.AD_GROUP_AD_DISAPPROVED = 10] = "AD_GROUP_AD_DISAPPROVED", e[e.AD_GROUP_AD_UNDER_REVIEW = 11] = "AD_GROUP_AD_UNDER_REVIEW", e[e.AD_GROUP_AD_POOR_QUALITY = 12] = "AD_GROUP_AD_POOR_QUALITY", e[e.AD_GROUP_AD_NO_ADS = 13] = "AD_GROUP_AD_NO_ADS", e[e.AD_GROUP_AD_APPROVED_LABELED = 14] = "AD_GROUP_AD_APPROVED_LABELED", e[e.AD_GROUP_AD_AREA_OF_INTEREST_ONLY = 15] = "AD_GROUP_AD_AREA_OF_INTEREST_ONLY", e[e.AD_GROUP_AD_UNDER_APPEAL = 16] = "AD_GROUP_AD_UNDER_APPEAL";
  }(t.AdGroupAdPrimaryStatusReason || (t.AdGroupAdPrimaryStatusReason = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.OPTIMIZE = 2] = "OPTIMIZE", e[e.ROTATE_FOREVER = 3] = "ROTATE_FOREVER";
  }(t.AdGroupAdRotationMode || (t.AdGroupAdRotationMode = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.PAUSED = 3] = "PAUSED", e[e.REMOVED = 4] = "REMOVED";
  }(t.AdGroupAdStatus || (t.AdGroupAdStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.APPROVED = 2] = "APPROVED", e[e.DISAPPROVED = 3] = "DISAPPROVED", e[e.PENDING_REVIEW = 4] = "PENDING_REVIEW", e[e.UNDER_REVIEW = 5] = "UNDER_REVIEW";
  }(t.AdGroupCriterionApprovalStatus || (t.AdGroupCriterionApprovalStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ELIGIBLE = 2] = "ELIGIBLE", e[e.PAUSED = 3] = "PAUSED", e[e.REMOVED = 4] = "REMOVED", e[e.PENDING = 5] = "PENDING", e[e.NOT_ELIGIBLE = 6] = "NOT_ELIGIBLE";
  }(t.AdGroupCriterionPrimaryStatus || (t.AdGroupCriterionPrimaryStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CAMPAIGN_PENDING = 2] = "CAMPAIGN_PENDING", e[e.CAMPAIGN_CRITERION_NEGATIVE = 3] = "CAMPAIGN_CRITERION_NEGATIVE", e[e.CAMPAIGN_PAUSED = 4] = "CAMPAIGN_PAUSED", e[e.CAMPAIGN_REMOVED = 5] = "CAMPAIGN_REMOVED", e[e.CAMPAIGN_ENDED = 6] = "CAMPAIGN_ENDED", e[e.AD_GROUP_PAUSED = 7] = "AD_GROUP_PAUSED", e[e.AD_GROUP_REMOVED = 8] = "AD_GROUP_REMOVED", e[e.AD_GROUP_CRITERION_DISAPPROVED = 9] = "AD_GROUP_CRITERION_DISAPPROVED", e[e.AD_GROUP_CRITERION_RARELY_SERVED = 10] = "AD_GROUP_CRITERION_RARELY_SERVED", e[e.AD_GROUP_CRITERION_LOW_QUALITY = 11] = "AD_GROUP_CRITERION_LOW_QUALITY", e[e.AD_GROUP_CRITERION_UNDER_REVIEW = 12] = "AD_GROUP_CRITERION_UNDER_REVIEW", e[e.AD_GROUP_CRITERION_PENDING_REVIEW = 13] = "AD_GROUP_CRITERION_PENDING_REVIEW", e[e.AD_GROUP_CRITERION_BELOW_FIRST_PAGE_BID = 14] = "AD_GROUP_CRITERION_BELOW_FIRST_PAGE_BID", e[e.AD_GROUP_CRITERION_NEGATIVE = 15] = "AD_GROUP_CRITERION_NEGATIVE", e[e.AD_GROUP_CRITERION_RESTRICTED = 16] = "AD_GROUP_CRITERION_RESTRICTED", e[e.AD_GROUP_CRITERION_PAUSED = 17] = "AD_GROUP_CRITERION_PAUSED", e[e.AD_GROUP_CRITERION_PAUSED_DUE_TO_LOW_ACTIVITY = 18] = "AD_GROUP_CRITERION_PAUSED_DUE_TO_LOW_ACTIVITY", e[e.AD_GROUP_CRITERION_REMOVED = 19] = "AD_GROUP_CRITERION_REMOVED";
  }(t.AdGroupCriterionPrimaryStatusReason || (t.AdGroupCriterionPrimaryStatusReason = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.PAUSED = 3] = "PAUSED", e[e.REMOVED = 4] = "REMOVED";
  }(t.AdGroupCriterionStatus || (t.AdGroupCriterionStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ELIGIBLE = 2] = "ELIGIBLE", e[e.PAUSED = 3] = "PAUSED", e[e.REMOVED = 4] = "REMOVED", e[e.PENDING = 5] = "PENDING", e[e.NOT_ELIGIBLE = 6] = "NOT_ELIGIBLE", e[e.LIMITED = 7] = "LIMITED";
  }(t.AdGroupPrimaryStatus || (t.AdGroupPrimaryStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CAMPAIGN_REMOVED = 2] = "CAMPAIGN_REMOVED", e[e.CAMPAIGN_PAUSED = 3] = "CAMPAIGN_PAUSED", e[e.CAMPAIGN_PENDING = 4] = "CAMPAIGN_PENDING", e[e.CAMPAIGN_ENDED = 5] = "CAMPAIGN_ENDED", e[e.AD_GROUP_PAUSED = 6] = "AD_GROUP_PAUSED", e[e.AD_GROUP_REMOVED = 7] = "AD_GROUP_REMOVED", e[e.AD_GROUP_INCOMPLETE = 8] = "AD_GROUP_INCOMPLETE", e[e.KEYWORDS_PAUSED = 9] = "KEYWORDS_PAUSED", e[e.NO_KEYWORDS = 10] = "NO_KEYWORDS", e[e.AD_GROUP_ADS_PAUSED = 11] = "AD_GROUP_ADS_PAUSED", e[e.NO_AD_GROUP_ADS = 12] = "NO_AD_GROUP_ADS", e[e.HAS_ADS_DISAPPROVED = 13] = "HAS_ADS_DISAPPROVED", e[e.HAS_ADS_LIMITED_BY_POLICY = 14] = "HAS_ADS_LIMITED_BY_POLICY", e[e.MOST_ADS_UNDER_REVIEW = 15] = "MOST_ADS_UNDER_REVIEW", e[e.CAMPAIGN_DRAFT = 16] = "CAMPAIGN_DRAFT", e[e.AD_GROUP_PAUSED_DUE_TO_LOW_ACTIVITY = 19] = "AD_GROUP_PAUSED_DUE_TO_LOW_ACTIVITY";
  }(t.AdGroupPrimaryStatusReason || (t.AdGroupPrimaryStatusReason = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.PAUSED = 3] = "PAUSED", e[e.REMOVED = 4] = "REMOVED";
  }(t.AdGroupStatus || (t.AdGroupStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.SEARCH_STANDARD = 2] = "SEARCH_STANDARD", e[e.DISPLAY_STANDARD = 3] = "DISPLAY_STANDARD", e[e.SHOPPING_PRODUCT_ADS = 4] = "SHOPPING_PRODUCT_ADS", e[e.HOTEL_ADS = 6] = "HOTEL_ADS", e[e.SHOPPING_SMART_ADS = 7] = "SHOPPING_SMART_ADS", e[e.VIDEO_BUMPER = 8] = "VIDEO_BUMPER", e[e.VIDEO_TRUE_VIEW_IN_STREAM = 9] = "VIDEO_TRUE_VIEW_IN_STREAM", e[e.VIDEO_TRUE_VIEW_IN_DISPLAY = 10] = "VIDEO_TRUE_VIEW_IN_DISPLAY", e[e.VIDEO_NON_SKIPPABLE_IN_STREAM = 11] = "VIDEO_NON_SKIPPABLE_IN_STREAM", e[e.SEARCH_DYNAMIC_ADS = 13] = "SEARCH_DYNAMIC_ADS", e[e.SHOPPING_COMPARISON_LISTING_ADS = 14] = "SHOPPING_COMPARISON_LISTING_ADS", e[e.PROMOTED_HOTEL_ADS = 15] = "PROMOTED_HOTEL_ADS", e[e.VIDEO_RESPONSIVE = 16] = "VIDEO_RESPONSIVE", e[e.VIDEO_EFFICIENT_REACH = 17] = "VIDEO_EFFICIENT_REACH", e[e.SMART_CAMPAIGN_ADS = 18] = "SMART_CAMPAIGN_ADS", e[e.TRAVEL_ADS = 19] = "TRAVEL_ADS", e[e.YOUTUBE_AUDIO = 20] = "YOUTUBE_AUDIO";
  }(t.AdGroupType || (t.AdGroupType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.OPTIMIZE = 2] = "OPTIMIZE", e[e.CONVERSION_OPTIMIZE = 3] = "CONVERSION_OPTIMIZE", e[e.ROTATE = 4] = "ROTATE", e[e.ROTATE_INDEFINITELY = 5] = "ROTATE_INDEFINITELY", e[e.UNAVAILABLE = 6] = "UNAVAILABLE";
  }(t.AdServingOptimizationStatus || (t.AdServingOptimizationStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PENDING = 2] = "PENDING", e[e.NO_ADS = 3] = "NO_ADS", e[e.POOR = 4] = "POOR", e[e.AVERAGE = 5] = "AVERAGE", e[e.GOOD = 6] = "GOOD", e[e.EXCELLENT = 7] = "EXCELLENT";
  }(t.AdStrength || (t.AdStrength = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ADD_ASSET = 2] = "ADD_ASSET";
  }(t.AdStrengthActionItemType || (t.AdStrengthActionItemType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.TEXT_AD = 2] = "TEXT_AD", e[e.EXPANDED_TEXT_AD = 3] = "EXPANDED_TEXT_AD", e[e.EXPANDED_DYNAMIC_SEARCH_AD = 7] = "EXPANDED_DYNAMIC_SEARCH_AD", e[e.HOTEL_AD = 8] = "HOTEL_AD", e[e.SHOPPING_SMART_AD = 9] = "SHOPPING_SMART_AD", e[e.SHOPPING_PRODUCT_AD = 10] = "SHOPPING_PRODUCT_AD", e[e.VIDEO_AD = 12] = "VIDEO_AD", e[e.IMAGE_AD = 14] = "IMAGE_AD", e[e.RESPONSIVE_SEARCH_AD = 15] = "RESPONSIVE_SEARCH_AD", e[e.LEGACY_RESPONSIVE_DISPLAY_AD = 16] = "LEGACY_RESPONSIVE_DISPLAY_AD", e[e.APP_AD = 17] = "APP_AD", e[e.LEGACY_APP_INSTALL_AD = 18] = "LEGACY_APP_INSTALL_AD", e[e.RESPONSIVE_DISPLAY_AD = 19] = "RESPONSIVE_DISPLAY_AD", e[e.LOCAL_AD = 20] = "LOCAL_AD", e[e.HTML5_UPLOAD_AD = 21] = "HTML5_UPLOAD_AD", e[e.DYNAMIC_HTML5_AD = 22] = "DYNAMIC_HTML5_AD", e[e.APP_ENGAGEMENT_AD = 23] = "APP_ENGAGEMENT_AD", e[e.SHOPPING_COMPARISON_LISTING_AD = 24] = "SHOPPING_COMPARISON_LISTING_AD", e[e.VIDEO_BUMPER_AD = 25] = "VIDEO_BUMPER_AD", e[e.VIDEO_NON_SKIPPABLE_IN_STREAM_AD = 26] = "VIDEO_NON_SKIPPABLE_IN_STREAM_AD", e[e.VIDEO_TRUEVIEW_IN_STREAM_AD = 29] = "VIDEO_TRUEVIEW_IN_STREAM_AD", e[e.VIDEO_RESPONSIVE_AD = 30] = "VIDEO_RESPONSIVE_AD", e[e.SMART_CAMPAIGN_AD = 31] = "SMART_CAMPAIGN_AD", e[e.CALL_AD = 32] = "CALL_AD", e[e.APP_PRE_REGISTRATION_AD = 33] = "APP_PRE_REGISTRATION_AD", e[e.IN_FEED_VIDEO_AD = 34] = "IN_FEED_VIDEO_AD", e[e.DEMAND_GEN_MULTI_ASSET_AD = 40] = "DEMAND_GEN_MULTI_ASSET_AD", e[e.DEMAND_GEN_CAROUSEL_AD = 41] = "DEMAND_GEN_CAROUSEL_AD", e[e.TRAVEL_AD = 37] = "TRAVEL_AD", e[e.DEMAND_GEN_VIDEO_RESPONSIVE_AD = 42] = "DEMAND_GEN_VIDEO_RESPONSIVE_AD", e[e.DEMAND_GEN_PRODUCT_AD = 39] = "DEMAND_GEN_PRODUCT_AD", e[e.YOUTUBE_AUDIO_AD = 44] = "YOUTUBE_AUDIO_AD";
  }(t.AdType || (t.AdType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CLICK = 2] = "CLICK", e[e.ENGAGED_VIEW = 3] = "ENGAGED_VIEW", e[e.VIEW = 4] = "VIEW";
  }(t.AndroidPrivacyInteractionType || (t.AndroidPrivacyInteractionType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.SEARCH = 2] = "SEARCH", e[e.DISPLAY = 3] = "DISPLAY", e[e.YOUTUBE = 4] = "YOUTUBE";
  }(t.AndroidPrivacyNetworkType || (t.AndroidPrivacyNetworkType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.OPTIMIZE_FOR_INSTALL_CONVERSION_VOLUME = 2] = "OPTIMIZE_FOR_INSTALL_CONVERSION_VOLUME", e[e.OPTIMIZE_FOR_IN_APP_CONVERSION_VOLUME = 3] = "OPTIMIZE_FOR_IN_APP_CONVERSION_VOLUME", e[e.OPTIMIZE_FOR_TOTAL_CONVERSION_VALUE = 4] = "OPTIMIZE_FOR_TOTAL_CONVERSION_VALUE", e[e.OPTIMIZE_FOR_TARGET_IN_APP_CONVERSION = 5] = "OPTIMIZE_FOR_TARGET_IN_APP_CONVERSION", e[e.OPTIMIZE_FOR_RETURN_ON_ADVERTISING_SPEND = 6] = "OPTIMIZE_FOR_RETURN_ON_ADVERTISING_SPEND", e[e.OPTIMIZE_FOR_INSTALL_CONVERSION_VOLUME_WITHOUT_TARGET_CPI = 7] = "OPTIMIZE_FOR_INSTALL_CONVERSION_VOLUME_WITHOUT_TARGET_CPI", e[e.OPTIMIZE_FOR_PRE_REGISTRATION_CONVERSION_VOLUME = 8] = "OPTIMIZE_FOR_PRE_REGISTRATION_CONVERSION_VOLUME";
  }(t.AppBiddingGoal || (t.AppBiddingGoal = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.APPLE_APP_STORE = 2] = "APPLE_APP_STORE", e[e.GOOGLE_APP_STORE = 3] = "GOOGLE_APP_STORE";
  }(t.AppCampaignAppStore || (t.AppCampaignAppStore = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.OPTIMIZE_INSTALLS_TARGET_INSTALL_COST = 2] = "OPTIMIZE_INSTALLS_TARGET_INSTALL_COST", e[e.OPTIMIZE_IN_APP_CONVERSIONS_TARGET_INSTALL_COST = 3] = "OPTIMIZE_IN_APP_CONVERSIONS_TARGET_INSTALL_COST", e[e.OPTIMIZE_IN_APP_CONVERSIONS_TARGET_CONVERSION_COST = 4] = "OPTIMIZE_IN_APP_CONVERSIONS_TARGET_CONVERSION_COST", e[e.OPTIMIZE_RETURN_ON_ADVERTISING_SPEND = 5] = "OPTIMIZE_RETURN_ON_ADVERTISING_SPEND", e[e.OPTIMIZE_PRE_REGISTRATION_CONVERSION_VOLUME = 6] = "OPTIMIZE_PRE_REGISTRATION_CONVERSION_VOLUME", e[e.OPTIMIZE_INSTALLS_WITHOUT_TARGET_INSTALL_COST = 7] = "OPTIMIZE_INSTALLS_WITHOUT_TARGET_INSTALL_COST", e[e.OPTIMIZE_IN_APP_CONVERSIONS_WITHOUT_TARGET_CPA = 8] = "OPTIMIZE_IN_APP_CONVERSIONS_WITHOUT_TARGET_CPA", e[e.OPTIMIZE_TOTAL_VALUE_WITHOUT_TARGET_ROAS = 9] = "OPTIMIZE_TOTAL_VALUE_WITHOUT_TARGET_ROAS";
  }(t.AppCampaignBiddingStrategyGoalType || (t.AppCampaignBiddingStrategyGoalType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.OPTED_IN = 2] = "OPTED_IN", e[e.OPTED_OUT = 3] = "OPTED_OUT";
  }(t.AssetAutomationStatus || (t.AssetAutomationStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.TEXT_ASSET_AUTOMATION = 2] = "TEXT_ASSET_AUTOMATION", e[e.GENERATE_VERTICAL_YOUTUBE_VIDEOS = 3] = "GENERATE_VERTICAL_YOUTUBE_VIDEOS", e[e.GENERATE_SHORTER_YOUTUBE_VIDEOS = 4] = "GENERATE_SHORTER_YOUTUBE_VIDEOS", e[e.GENERATE_LANDING_PAGE_PREVIEW = 5] = "GENERATE_LANDING_PAGE_PREVIEW", e[e.GENERATE_LANDING_PAGE_TEXT = 14] = "GENERATE_LANDING_PAGE_TEXT", e[e.GENERATE_ENHANCED_YOUTUBE_VIDEOS = 6] = "GENERATE_ENHANCED_YOUTUBE_VIDEOS", e[e.GENERATE_IMAGE_ENHANCEMENT = 7] = "GENERATE_IMAGE_ENHANCEMENT", e[e.GENERATE_IMAGE_EXTRACTION = 9] = "GENERATE_IMAGE_EXTRACTION", e[e.GENERATE_DESIGN_VERSIONS_FOR_IMAGES = 10] = "GENERATE_DESIGN_VERSIONS_FOR_IMAGES", e[e.FINAL_URL_EXPANSION_TEXT_ASSET_AUTOMATION = 11] = "FINAL_URL_EXPANSION_TEXT_ASSET_AUTOMATION", e[e.GENERATE_VIDEOS_FROM_OTHER_ASSETS = 12] = "GENERATE_VIDEOS_FROM_OTHER_ASSETS", e[e.GENERATE_ANIMATED_IMAGES_FROM_OTHER_ASSETS = 13] = "GENERATE_ANIMATED_IMAGES_FROM_OTHER_ASSETS";
  }(t.AssetAutomationType || (t.AssetAutomationType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.HORIZONTAL = 2] = "HORIZONTAL", e[e.SQUARE = 3] = "SQUARE", e[e.VERTICAL = 4] = "VERTICAL";
  }(t.AssetCoverageVideoAspectRatioRequirement || (t.AssetCoverageVideoAspectRatioRequirement = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.HEADLINE = 2] = "HEADLINE", e[e.DESCRIPTION = 3] = "DESCRIPTION", e[e.MANDATORY_AD_TEXT = 4] = "MANDATORY_AD_TEXT", e[e.MARKETING_IMAGE = 5] = "MARKETING_IMAGE", e[e.MEDIA_BUNDLE = 6] = "MEDIA_BUNDLE", e[e.YOUTUBE_VIDEO = 7] = "YOUTUBE_VIDEO", e[e.BOOK_ON_GOOGLE = 8] = "BOOK_ON_GOOGLE", e[e.LEAD_FORM = 9] = "LEAD_FORM", e[e.PROMOTION = 10] = "PROMOTION", e[e.CALLOUT = 11] = "CALLOUT", e[e.STRUCTURED_SNIPPET = 12] = "STRUCTURED_SNIPPET", e[e.SITELINK = 13] = "SITELINK", e[e.MOBILE_APP = 14] = "MOBILE_APP", e[e.HOTEL_CALLOUT = 15] = "HOTEL_CALLOUT", e[e.CALL = 16] = "CALL", e[e.PRICE = 24] = "PRICE", e[e.LONG_HEADLINE = 17] = "LONG_HEADLINE", e[e.BUSINESS_NAME = 18] = "BUSINESS_NAME", e[e.SQUARE_MARKETING_IMAGE = 19] = "SQUARE_MARKETING_IMAGE", e[e.PORTRAIT_MARKETING_IMAGE = 20] = "PORTRAIT_MARKETING_IMAGE", e[e.LOGO = 21] = "LOGO", e[e.LANDSCAPE_LOGO = 22] = "LANDSCAPE_LOGO", e[e.VIDEO = 23] = "VIDEO", e[e.CALL_TO_ACTION_SELECTION = 25] = "CALL_TO_ACTION_SELECTION", e[e.AD_IMAGE = 26] = "AD_IMAGE", e[e.BUSINESS_LOGO = 27] = "BUSINESS_LOGO", e[e.HOTEL_PROPERTY = 28] = "HOTEL_PROPERTY", e[e.DEMAND_GEN_CAROUSEL_CARD = 30] = "DEMAND_GEN_CAROUSEL_CARD", e[e.BUSINESS_MESSAGE = 31] = "BUSINESS_MESSAGE", e[e.TALL_PORTRAIT_MARKETING_IMAGE = 32] = "TALL_PORTRAIT_MARKETING_IMAGE", e[e.RELATED_YOUTUBE_VIDEOS = 33] = "RELATED_YOUTUBE_VIDEOS", e[e.LANDING_PAGE_PREVIEW = 38] = "LANDING_PAGE_PREVIEW", e[e.LONG_DESCRIPTION = 39] = "LONG_DESCRIPTION", e[e.CALL_TO_ACTION = 40] = "CALL_TO_ACTION", e[e.CLASSIC_DISPLAY_IMAGE = 47] = "CLASSIC_DISPLAY_IMAGE", e[e.TEXT_DISCLAIMER = 48] = "TEXT_DISCLAIMER";
  }(t.AssetFieldType || (t.AssetFieldType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ELIGIBLE = 2] = "ELIGIBLE", e[e.PAUSED = 3] = "PAUSED", e[e.REMOVED = 4] = "REMOVED", e[e.NOT_ELIGIBLE = 5] = "NOT_ELIGIBLE", e[e.LIMITED = 6] = "LIMITED", e[e.PENDING = 7] = "PENDING";
  }(t.AssetGroupPrimaryStatus || (t.AssetGroupPrimaryStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ASSET_GROUP_PAUSED = 2] = "ASSET_GROUP_PAUSED", e[e.ASSET_GROUP_REMOVED = 3] = "ASSET_GROUP_REMOVED", e[e.CAMPAIGN_REMOVED = 4] = "CAMPAIGN_REMOVED", e[e.CAMPAIGN_PAUSED = 5] = "CAMPAIGN_PAUSED", e[e.CAMPAIGN_PENDING = 6] = "CAMPAIGN_PENDING", e[e.CAMPAIGN_ENDED = 7] = "CAMPAIGN_ENDED", e[e.ASSET_GROUP_LIMITED = 8] = "ASSET_GROUP_LIMITED", e[e.ASSET_GROUP_DISAPPROVED = 9] = "ASSET_GROUP_DISAPPROVED", e[e.ASSET_GROUP_UNDER_REVIEW = 10] = "ASSET_GROUP_UNDER_REVIEW";
  }(t.AssetGroupPrimaryStatusReason || (t.AssetGroupPrimaryStatusReason = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.APPROVED = 2] = "APPROVED", e[e.LIMITED = 3] = "LIMITED", e[e.DISAPPROVED = 4] = "DISAPPROVED", e[e.UNDER_REVIEW = 5] = "UNDER_REVIEW";
  }(t.AssetGroupSignalApprovalStatus || (t.AssetGroupSignalApprovalStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.PAUSED = 3] = "PAUSED", e[e.REMOVED = 4] = "REMOVED";
  }(t.AssetGroupStatus || (t.AssetGroupStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED", e[e.PAUSED = 4] = "PAUSED";
  }(t.AssetLinkStatus || (t.AssetLinkStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.LANDSCAPE = 2] = "LANDSCAPE", e[e.PORTRAIT = 3] = "PORTRAIT", e[e.SQUARE = 4] = "SQUARE";
  }(t.AssetOrientation || (t.AssetOrientation = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED";
  }(t.AssetSetAssetStatus || (t.AssetSetAssetStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED";
  }(t.AssetSetLinkStatus || (t.AssetSetLinkStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED";
  }(t.AssetSetStatus || (t.AssetSetStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PAGE_FEED = 2] = "PAGE_FEED", e[e.DYNAMIC_EDUCATION = 3] = "DYNAMIC_EDUCATION", e[e.MERCHANT_CENTER_FEED = 4] = "MERCHANT_CENTER_FEED", e[e.DYNAMIC_REAL_ESTATE = 5] = "DYNAMIC_REAL_ESTATE", e[e.DYNAMIC_CUSTOM = 6] = "DYNAMIC_CUSTOM", e[e.DYNAMIC_HOTELS_AND_RENTALS = 7] = "DYNAMIC_HOTELS_AND_RENTALS", e[e.DYNAMIC_FLIGHTS = 8] = "DYNAMIC_FLIGHTS", e[e.DYNAMIC_TRAVEL = 9] = "DYNAMIC_TRAVEL", e[e.DYNAMIC_LOCAL = 10] = "DYNAMIC_LOCAL", e[e.DYNAMIC_JOBS = 11] = "DYNAMIC_JOBS", e[e.LOCATION_SYNC = 12] = "LOCATION_SYNC", e[e.BUSINESS_PROFILE_DYNAMIC_LOCATION_GROUP = 13] = "BUSINESS_PROFILE_DYNAMIC_LOCATION_GROUP", e[e.CHAIN_DYNAMIC_LOCATION_GROUP = 14] = "CHAIN_DYNAMIC_LOCATION_GROUP", e[e.STATIC_LOCATION_GROUP = 15] = "STATIC_LOCATION_GROUP", e[e.HOTEL_PROPERTY = 16] = "HOTEL_PROPERTY", e[e.TRAVEL_FEED = 17] = "TRAVEL_FEED";
  }(t.AssetSetType || (t.AssetSetType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ADVERTISER = 2] = "ADVERTISER", e[e.AUTOMATICALLY_CREATED = 3] = "AUTOMATICALLY_CREATED";
  }(t.AssetSource || (t.AssetSource = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.YOUTUBE_VIDEO = 2] = "YOUTUBE_VIDEO", e[e.MEDIA_BUNDLE = 3] = "MEDIA_BUNDLE", e[e.IMAGE = 4] = "IMAGE", e[e.TEXT = 5] = "TEXT", e[e.LEAD_FORM = 6] = "LEAD_FORM", e[e.BOOK_ON_GOOGLE = 7] = "BOOK_ON_GOOGLE", e[e.PROMOTION = 8] = "PROMOTION", e[e.CALLOUT = 9] = "CALLOUT", e[e.STRUCTURED_SNIPPET = 10] = "STRUCTURED_SNIPPET", e[e.SITELINK = 11] = "SITELINK", e[e.PAGE_FEED = 12] = "PAGE_FEED", e[e.DYNAMIC_EDUCATION = 13] = "DYNAMIC_EDUCATION", e[e.MOBILE_APP = 14] = "MOBILE_APP", e[e.HOTEL_CALLOUT = 15] = "HOTEL_CALLOUT", e[e.CALL = 16] = "CALL", e[e.PRICE = 17] = "PRICE", e[e.CALL_TO_ACTION = 18] = "CALL_TO_ACTION", e[e.DYNAMIC_REAL_ESTATE = 19] = "DYNAMIC_REAL_ESTATE", e[e.DYNAMIC_CUSTOM = 20] = "DYNAMIC_CUSTOM", e[e.DYNAMIC_HOTELS_AND_RENTALS = 21] = "DYNAMIC_HOTELS_AND_RENTALS", e[e.DYNAMIC_FLIGHTS = 22] = "DYNAMIC_FLIGHTS", e[e.DYNAMIC_TRAVEL = 24] = "DYNAMIC_TRAVEL", e[e.DYNAMIC_LOCAL = 25] = "DYNAMIC_LOCAL", e[e.DYNAMIC_JOBS = 26] = "DYNAMIC_JOBS", e[e.LOCATION = 27] = "LOCATION", e[e.HOTEL_PROPERTY = 28] = "HOTEL_PROPERTY", e[e.DEMAND_GEN_CAROUSEL_CARD = 29] = "DEMAND_GEN_CAROUSEL_CARD", e[e.BUSINESS_MESSAGE = 30] = "BUSINESS_MESSAGE", e[e.APP_DEEP_LINK = 31] = "APP_DEEP_LINK", e[e.YOUTUBE_VIDEO_LIST = 32] = "YOUTUBE_VIDEO_LIST";
  }(t.AssetType || (t.AssetType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NOT_STARTED = 2] = "NOT_STARTED", e[e.IN_PROGRESS = 3] = "IN_PROGRESS", e[e.COMPLETED = 4] = "COMPLETED", e[e.FAILED = 5] = "FAILED", e[e.COMPLETED_WITH_WARNING = 6] = "COMPLETED_WITH_WARNING";
  }(t.AsyncActionStatus || (t.AsyncActionStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.EXTERNAL = 100] = "EXTERNAL", e[e.GOOGLE_ADS_LAST_CLICK = 101] = "GOOGLE_ADS_LAST_CLICK", e[e.GOOGLE_SEARCH_ATTRIBUTION_FIRST_CLICK = 102] = "GOOGLE_SEARCH_ATTRIBUTION_FIRST_CLICK", e[e.GOOGLE_SEARCH_ATTRIBUTION_LINEAR = 103] = "GOOGLE_SEARCH_ATTRIBUTION_LINEAR", e[e.GOOGLE_SEARCH_ATTRIBUTION_TIME_DECAY = 104] = "GOOGLE_SEARCH_ATTRIBUTION_TIME_DECAY", e[e.GOOGLE_SEARCH_ATTRIBUTION_POSITION_BASED = 105] = "GOOGLE_SEARCH_ATTRIBUTION_POSITION_BASED", e[e.GOOGLE_SEARCH_ATTRIBUTION_DATA_DRIVEN = 106] = "GOOGLE_SEARCH_ATTRIBUTION_DATA_DRIVEN";
  }(t.AttributionModel || (t.AttributionModel = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AWARENESS = 2] = "AWARENESS", e[e.CONSIDERATION = 3] = "CONSIDERATION", e[e.RESEARCH = 4] = "RESEARCH";
  }(t.AudienceInsightsMarketingObjective || (t.AudienceInsightsMarketingObjective = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CUSTOMER = 2] = "CUSTOMER", e[e.ASSET_GROUP = 3] = "ASSET_GROUP";
  }(t.AudienceScope || (t.AudienceScope = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED";
  }(t.AudienceStatus || (t.AudienceStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PENDING = 2] = "PENDING", e[e.RUNNING = 3] = "RUNNING", e[e.DONE = 4] = "DONE";
  }(t.BatchJobStatus || (t.BatchJobStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AWARENESS = 2] = "AWARENESS", e[e.CONSIDERATION = 3] = "CONSIDERATION", e[e.ACTION = 4] = "ACTION";
  }(t.BenchmarksMarketingObjective || (t.BenchmarksMarketingObjective = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.INDUSTRY_VERTICAL = 2] = "INDUSTRY_VERTICAL", e[e.CATEGORY = 3] = "CATEGORY";
  }(t.BenchmarksSourceType || (t.BenchmarksSourceType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.WEEK = 2] = "WEEK", e[e.MONTH = 3] = "MONTH", e[e.QUARTER = 4] = "QUARTER";
  }(t.BenchmarksTimeGranularity || (t.BenchmarksTimeGranularity = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CAMPAIGN = 2] = "CAMPAIGN", e[e.AD_GROUP = 3] = "AD_GROUP";
  }(t.BidModifierSource || (t.BidModifierSource = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CAMPAIGN_BIDDING_STRATEGY = 5] = "CAMPAIGN_BIDDING_STRATEGY", e[e.AD_GROUP = 6] = "AD_GROUP", e[e.AD_GROUP_CRITERION = 7] = "AD_GROUP_CRITERION";
  }(t.BiddingSource || (t.BiddingSource = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 4] = "REMOVED";
  }(t.BiddingStrategyStatus || (t.BiddingStrategyStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.LEARNING_NEW = 3] = "LEARNING_NEW", e[e.LEARNING_SETTING_CHANGE = 4] = "LEARNING_SETTING_CHANGE", e[e.LEARNING_BUDGET_CHANGE = 5] = "LEARNING_BUDGET_CHANGE", e[e.LEARNING_COMPOSITION_CHANGE = 6] = "LEARNING_COMPOSITION_CHANGE", e[e.LEARNING_CONVERSION_TYPE_CHANGE = 7] = "LEARNING_CONVERSION_TYPE_CHANGE", e[e.LEARNING_CONVERSION_SETTING_CHANGE = 8] = "LEARNING_CONVERSION_SETTING_CHANGE", e[e.LIMITED_BY_CPC_BID_CEILING = 9] = "LIMITED_BY_CPC_BID_CEILING", e[e.LIMITED_BY_CPC_BID_FLOOR = 10] = "LIMITED_BY_CPC_BID_FLOOR", e[e.LIMITED_BY_DATA = 11] = "LIMITED_BY_DATA", e[e.LIMITED_BY_BUDGET = 12] = "LIMITED_BY_BUDGET", e[e.LIMITED_BY_LOW_PRIORITY_SPEND = 13] = "LIMITED_BY_LOW_PRIORITY_SPEND", e[e.LIMITED_BY_LOW_QUALITY = 14] = "LIMITED_BY_LOW_QUALITY", e[e.LIMITED_BY_INVENTORY = 15] = "LIMITED_BY_INVENTORY", e[e.MISCONFIGURED_ZERO_ELIGIBILITY = 16] = "MISCONFIGURED_ZERO_ELIGIBILITY", e[e.MISCONFIGURED_CONVERSION_TYPES = 17] = "MISCONFIGURED_CONVERSION_TYPES", e[e.MISCONFIGURED_CONVERSION_SETTINGS = 18] = "MISCONFIGURED_CONVERSION_SETTINGS", e[e.MISCONFIGURED_SHARED_BUDGET = 19] = "MISCONFIGURED_SHARED_BUDGET", e[e.MISCONFIGURED_STRATEGY_TYPE = 20] = "MISCONFIGURED_STRATEGY_TYPE", e[e.PAUSED = 21] = "PAUSED", e[e.UNAVAILABLE = 22] = "UNAVAILABLE", e[e.MULTIPLE_LEARNING = 23] = "MULTIPLE_LEARNING", e[e.MULTIPLE_LIMITED = 24] = "MULTIPLE_LIMITED", e[e.MULTIPLE_MISCONFIGURED = 25] = "MULTIPLE_MISCONFIGURED", e[e.MULTIPLE = 26] = "MULTIPLE";
  }(t.BiddingStrategySystemStatus || (t.BiddingStrategySystemStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.COMMISSION = 16] = "COMMISSION", e[e.ENHANCED_CPC = 2] = "ENHANCED_CPC", e[e.FIXED_CPM = 19] = "FIXED_CPM", e[e.FIXED_SHARE_OF_VOICE = 22] = "FIXED_SHARE_OF_VOICE", e[e.INVALID = 17] = "INVALID", e[e.MANUAL_CPA = 18] = "MANUAL_CPA", e[e.MANUAL_CPC = 3] = "MANUAL_CPC", e[e.MANUAL_CPM = 4] = "MANUAL_CPM", e[e.MANUAL_CPV = 13] = "MANUAL_CPV", e[e.MAXIMIZE_CONVERSIONS = 10] = "MAXIMIZE_CONVERSIONS", e[e.MAXIMIZE_CONVERSION_VALUE = 11] = "MAXIMIZE_CONVERSION_VALUE", e[e.PAGE_ONE_PROMOTED = 5] = "PAGE_ONE_PROMOTED", e[e.PERCENT_CPC = 12] = "PERCENT_CPC", e[e.TARGET_CPA = 6] = "TARGET_CPA", e[e.TARGET_CPC = 21] = "TARGET_CPC", e[e.TARGET_CPM = 14] = "TARGET_CPM", e[e.TARGET_CPV = 20] = "TARGET_CPV", e[e.TARGET_IMPRESSION_SHARE = 15] = "TARGET_IMPRESSION_SHARE", e[e.TARGET_OUTRANK_SHARE = 7] = "TARGET_OUTRANK_SHARE", e[e.TARGET_ROAS = 8] = "TARGET_ROAS", e[e.TARGET_SPEND = 9] = "TARGET_SPEND";
  }(t.BiddingStrategyType || (t.BiddingStrategyType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PENDING = 2] = "PENDING", e[e.APPROVED_HELD = 3] = "APPROVED_HELD", e[e.APPROVED = 4] = "APPROVED", e[e.CANCELLED = 5] = "CANCELLED";
  }(t.BillingSetupStatus || (t.BillingSetupStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.BOOKED = 2] = "BOOKED", e[e.HELD = 3] = "HELD", e[e.CAMPAIGN_ENDED = 4] = "CAMPAIGN_ENDED", e[e.HOLD_EXPIRED = 5] = "HOLD_EXPIRED", e[e.BOOKING_CANCELLED = 6] = "BOOKING_CANCELLED";
  }(t.BookingStatus || (t.BookingStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.EXPANDED_INVENTORY = 2] = "EXPANDED_INVENTORY", e[e.STANDARD_INVENTORY = 3] = "STANDARD_INVENTORY", e[e.LIMITED_INVENTORY = 4] = "LIMITED_INVENTORY";
  }(t.BrandSafetySuitability || (t.BrandSafetySuitability = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.STANDARD = 2] = "STANDARD", e[e.ACCELERATED = 3] = "ACCELERATED";
  }(t.BudgetDeliveryMethod || (t.BudgetDeliveryMethod = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.DAILY = 2] = "DAILY", e[e.CUSTOM_PERIOD = 5] = "CUSTOM_PERIOD";
  }(t.BudgetPeriod || (t.BudgetPeriod = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED";
  }(t.BudgetStatus || (t.BudgetStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.STANDARD = 2] = "STANDARD", e[e.FIXED_CPA = 4] = "FIXED_CPA", e[e.SMART_CAMPAIGN = 5] = "SMART_CAMPAIGN", e[e.LOCAL_SERVICES = 6] = "LOCAL_SERVICES";
  }(t.BudgetType || (t.BudgetType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AD = 2] = "AD", e[e.LANDING_PAGE = 3] = "LANDING_PAGE";
  }(t.CallTrackingDisplayLocation || (t.CallTrackingDisplayLocation = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.MANUALLY_DIALED = 2] = "MANUALLY_DIALED", e[e.HIGH_END_MOBILE_SEARCH = 3] = "HIGH_END_MOBILE_SEARCH";
  }(t.CallType || (t.CallType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.PAUSED = 3] = "PAUSED", e[e.REMOVED = 4] = "REMOVED";
  }(t.CampaignCriterionStatus || (t.CampaignCriterionStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PROPOSED = 2] = "PROPOSED", e[e.REMOVED = 3] = "REMOVED", e[e.PROMOTING = 5] = "PROMOTING", e[e.PROMOTED = 4] = "PROMOTED", e[e.PROMOTE_FAILED = 6] = "PROMOTE_FAILED";
  }(t.CampaignDraftStatus || (t.CampaignDraftStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.BASE = 2] = "BASE", e[e.DRAFT = 3] = "DRAFT", e[e.EXPERIMENT = 4] = "EXPERIMENT";
  }(t.CampaignExperimentType || (t.CampaignExperimentType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED";
  }(t.CampaignGroupStatus || (t.CampaignGroupStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.BROAD = 2] = "BROAD";
  }(t.CampaignKeywordMatchType || (t.CampaignKeywordMatchType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ELIGIBLE = 2] = "ELIGIBLE", e[e.PAUSED = 3] = "PAUSED", e[e.REMOVED = 4] = "REMOVED", e[e.ENDED = 5] = "ENDED", e[e.PENDING = 6] = "PENDING", e[e.MISCONFIGURED = 7] = "MISCONFIGURED", e[e.LIMITED = 8] = "LIMITED", e[e.LEARNING = 9] = "LEARNING", e[e.NOT_ELIGIBLE = 10] = "NOT_ELIGIBLE";
  }(t.CampaignPrimaryStatus || (t.CampaignPrimaryStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CAMPAIGN_REMOVED = 2] = "CAMPAIGN_REMOVED", e[e.CAMPAIGN_PAUSED = 3] = "CAMPAIGN_PAUSED", e[e.CAMPAIGN_PENDING = 4] = "CAMPAIGN_PENDING", e[e.CAMPAIGN_ENDED = 5] = "CAMPAIGN_ENDED", e[e.CAMPAIGN_DRAFT = 6] = "CAMPAIGN_DRAFT", e[e.BIDDING_STRATEGY_MISCONFIGURED = 7] = "BIDDING_STRATEGY_MISCONFIGURED", e[e.BIDDING_STRATEGY_LIMITED = 8] = "BIDDING_STRATEGY_LIMITED", e[e.BIDDING_STRATEGY_LEARNING = 9] = "BIDDING_STRATEGY_LEARNING", e[e.BIDDING_STRATEGY_CONSTRAINED = 10] = "BIDDING_STRATEGY_CONSTRAINED", e[e.BUDGET_CONSTRAINED = 11] = "BUDGET_CONSTRAINED", e[e.BUDGET_MISCONFIGURED = 12] = "BUDGET_MISCONFIGURED", e[e.SEARCH_VOLUME_LIMITED = 13] = "SEARCH_VOLUME_LIMITED", e[e.AD_GROUPS_PAUSED = 14] = "AD_GROUPS_PAUSED", e[e.NO_AD_GROUPS = 15] = "NO_AD_GROUPS", e[e.KEYWORDS_PAUSED = 16] = "KEYWORDS_PAUSED", e[e.NO_KEYWORDS = 17] = "NO_KEYWORDS", e[e.AD_GROUP_ADS_PAUSED = 18] = "AD_GROUP_ADS_PAUSED", e[e.NO_AD_GROUP_ADS = 19] = "NO_AD_GROUP_ADS", e[e.HAS_ADS_LIMITED_BY_POLICY = 20] = "HAS_ADS_LIMITED_BY_POLICY", e[e.HAS_ADS_DISAPPROVED = 21] = "HAS_ADS_DISAPPROVED", e[e.MOST_ADS_UNDER_REVIEW = 22] = "MOST_ADS_UNDER_REVIEW", e[e.MISSING_LEAD_FORM_EXTENSION = 23] = "MISSING_LEAD_FORM_EXTENSION", e[e.MISSING_CALL_EXTENSION = 24] = "MISSING_CALL_EXTENSION", e[e.LEAD_FORM_EXTENSION_UNDER_REVIEW = 25] = "LEAD_FORM_EXTENSION_UNDER_REVIEW", e[e.LEAD_FORM_EXTENSION_DISAPPROVED = 26] = "LEAD_FORM_EXTENSION_DISAPPROVED", e[e.CALL_EXTENSION_UNDER_REVIEW = 27] = "CALL_EXTENSION_UNDER_REVIEW", e[e.CALL_EXTENSION_DISAPPROVED = 28] = "CALL_EXTENSION_DISAPPROVED", e[e.NO_MOBILE_APPLICATION_AD_GROUP_CRITERIA = 29] = "NO_MOBILE_APPLICATION_AD_GROUP_CRITERIA", e[e.CAMPAIGN_GROUP_PAUSED = 30] = "CAMPAIGN_GROUP_PAUSED", e[e.CAMPAIGN_GROUP_ALL_GROUP_BUDGETS_ENDED = 31] = "CAMPAIGN_GROUP_ALL_GROUP_BUDGETS_ENDED", e[e.APP_NOT_RELEASED = 32] = "APP_NOT_RELEASED", e[e.APP_PARTIALLY_RELEASED = 33] = "APP_PARTIALLY_RELEASED", e[e.HAS_ASSET_GROUPS_DISAPPROVED = 34] = "HAS_ASSET_GROUPS_DISAPPROVED", e[e.HAS_ASSET_GROUPS_LIMITED_BY_POLICY = 35] = "HAS_ASSET_GROUPS_LIMITED_BY_POLICY", e[e.MOST_ASSET_GROUPS_UNDER_REVIEW = 36] = "MOST_ASSET_GROUPS_UNDER_REVIEW", e[e.NO_ASSET_GROUPS = 37] = "NO_ASSET_GROUPS", e[e.ASSET_GROUPS_PAUSED = 38] = "ASSET_GROUPS_PAUSED", e[e.MISSING_LOCATION_TARGETING = 39] = "MISSING_LOCATION_TARGETING", e[e.CAMPAIGN_NOT_BOOKED = 40] = "CAMPAIGN_NOT_BOOKED", e[e.BOOKING_HOLD_EXPIRING = 41] = "BOOKING_HOLD_EXPIRING", e[e.BOOKING_HOLD_EXPIRED = 42] = "BOOKING_HOLD_EXPIRED", e[e.BOOKING_CANCELLED = 43] = "BOOKING_CANCELLED";
  }(t.CampaignPrimaryStatusReason || (t.CampaignPrimaryStatusReason = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.SERVING = 2] = "SERVING", e[e.NONE = 3] = "NONE", e[e.ENDED = 4] = "ENDED", e[e.PENDING = 5] = "PENDING", e[e.SUSPENDED = 6] = "SUSPENDED";
  }(t.CampaignServingStatus || (t.CampaignServingStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED";
  }(t.CampaignSharedSetStatus || (t.CampaignSharedSetStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.PAUSED = 3] = "PAUSED", e[e.REMOVED = 4] = "REMOVED";
  }(t.CampaignStatus || (t.CampaignStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.GOOGLE_ADS_WEB_CLIENT = 2] = "GOOGLE_ADS_WEB_CLIENT", e[e.GOOGLE_ADS_AUTOMATED_RULE = 3] = "GOOGLE_ADS_AUTOMATED_RULE", e[e.GOOGLE_ADS_SCRIPTS = 4] = "GOOGLE_ADS_SCRIPTS", e[e.GOOGLE_ADS_BULK_UPLOAD = 5] = "GOOGLE_ADS_BULK_UPLOAD", e[e.GOOGLE_ADS_API = 6] = "GOOGLE_ADS_API", e[e.GOOGLE_ADS_EDITOR = 7] = "GOOGLE_ADS_EDITOR", e[e.GOOGLE_ADS_MOBILE_APP = 8] = "GOOGLE_ADS_MOBILE_APP", e[e.GOOGLE_ADS_RECOMMENDATIONS = 9] = "GOOGLE_ADS_RECOMMENDATIONS", e[e.SEARCH_ADS_360_SYNC = 10] = "SEARCH_ADS_360_SYNC", e[e.SEARCH_ADS_360_POST = 11] = "SEARCH_ADS_360_POST", e[e.INTERNAL_TOOL = 12] = "INTERNAL_TOOL", e[e.OTHER = 13] = "OTHER", e[e.GOOGLE_ADS_RECOMMENDATIONS_SUBSCRIPTION = 14] = "GOOGLE_ADS_RECOMMENDATIONS_SUBSCRIPTION";
  }(t.ChangeClientType || (t.ChangeClientType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AD = 2] = "AD", e[e.AD_GROUP = 3] = "AD_GROUP", e[e.AD_GROUP_CRITERION = 4] = "AD_GROUP_CRITERION", e[e.CAMPAIGN = 5] = "CAMPAIGN", e[e.CAMPAIGN_BUDGET = 6] = "CAMPAIGN_BUDGET", e[e.AD_GROUP_BID_MODIFIER = 7] = "AD_GROUP_BID_MODIFIER", e[e.CAMPAIGN_CRITERION = 8] = "CAMPAIGN_CRITERION", e[e.FEED = 9] = "FEED", e[e.FEED_ITEM = 10] = "FEED_ITEM", e[e.CAMPAIGN_FEED = 11] = "CAMPAIGN_FEED", e[e.AD_GROUP_FEED = 12] = "AD_GROUP_FEED", e[e.AD_GROUP_AD = 13] = "AD_GROUP_AD", e[e.ASSET = 14] = "ASSET", e[e.CUSTOMER_ASSET = 15] = "CUSTOMER_ASSET", e[e.CAMPAIGN_ASSET = 16] = "CAMPAIGN_ASSET", e[e.AD_GROUP_ASSET = 17] = "AD_GROUP_ASSET", e[e.ASSET_SET = 18] = "ASSET_SET", e[e.ASSET_SET_ASSET = 19] = "ASSET_SET_ASSET", e[e.CAMPAIGN_ASSET_SET = 20] = "CAMPAIGN_ASSET_SET";
  }(t.ChangeEventResourceType || (t.ChangeEventResourceType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ADDED = 2] = "ADDED", e[e.CHANGED = 3] = "CHANGED", e[e.REMOVED = 4] = "REMOVED";
  }(t.ChangeStatusOperation || (t.ChangeStatusOperation = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AD_GROUP = 3] = "AD_GROUP", e[e.AD_GROUP_AD = 4] = "AD_GROUP_AD", e[e.AD_GROUP_CRITERION = 5] = "AD_GROUP_CRITERION", e[e.CAMPAIGN = 6] = "CAMPAIGN", e[e.CAMPAIGN_CRITERION = 7] = "CAMPAIGN_CRITERION", e[e.CAMPAIGN_BUDGET = 8] = "CAMPAIGN_BUDGET", e[e.FEED = 9] = "FEED", e[e.FEED_ITEM = 10] = "FEED_ITEM", e[e.AD_GROUP_FEED = 11] = "AD_GROUP_FEED", e[e.CAMPAIGN_FEED = 12] = "CAMPAIGN_FEED", e[e.AD_GROUP_BID_MODIFIER = 13] = "AD_GROUP_BID_MODIFIER", e[e.SHARED_SET = 14] = "SHARED_SET", e[e.CAMPAIGN_SHARED_SET = 15] = "CAMPAIGN_SHARED_SET", e[e.ASSET = 16] = "ASSET", e[e.CUSTOMER_ASSET = 17] = "CUSTOMER_ASSET", e[e.CAMPAIGN_ASSET = 18] = "CAMPAIGN_ASSET", e[e.AD_GROUP_ASSET = 19] = "AD_GROUP_ASSET", e[e.COMBINED_AUDIENCE = 20] = "COMBINED_AUDIENCE", e[e.ASSET_GROUP = 21] = "ASSET_GROUP", e[e.ASSET_SET = 22] = "ASSET_SET", e[e.CAMPAIGN_ASSET_SET = 23] = "CAMPAIGN_ASSET_SET";
  }(t.ChangeStatusResourceType || (t.ChangeStatusResourceType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED";
  }(t.CombinedAudienceStatus || (t.CombinedAudienceStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.BRAND_SENTIMENT_DATA = 2] = "BRAND_SENTIMENT_DATA", e[e.LOCAL_CREATOR_DATA = 3] = "LOCAL_CREATOR_DATA";
  }(t.ContentCreatorInsightsSupplementalData || (t.ContentCreatorInsightsSupplementalData = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ONE_PER_CLICK = 2] = "ONE_PER_CLICK", e[e.MANY_PER_CLICK = 3] = "MANY_PER_CLICK";
  }(t.ConversionActionCountingType || (t.ConversionActionCountingType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED", e[e.HIDDEN = 4] = "HIDDEN";
  }(t.ConversionActionStatus || (t.ConversionActionStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AD_CALL = 2] = "AD_CALL", e[e.CLICK_TO_CALL = 3] = "CLICK_TO_CALL", e[e.GOOGLE_PLAY_DOWNLOAD = 4] = "GOOGLE_PLAY_DOWNLOAD", e[e.GOOGLE_PLAY_IN_APP_PURCHASE = 5] = "GOOGLE_PLAY_IN_APP_PURCHASE", e[e.UPLOAD_CALLS = 6] = "UPLOAD_CALLS", e[e.UPLOAD_CLICKS = 7] = "UPLOAD_CLICKS", e[e.WEBPAGE = 8] = "WEBPAGE", e[e.WEBSITE_CALL = 9] = "WEBSITE_CALL", e[e.STORE_SALES_DIRECT_UPLOAD = 10] = "STORE_SALES_DIRECT_UPLOAD", e[e.STORE_SALES = 11] = "STORE_SALES", e[e.FIREBASE_ANDROID_FIRST_OPEN = 12] = "FIREBASE_ANDROID_FIRST_OPEN", e[e.FIREBASE_ANDROID_IN_APP_PURCHASE = 13] = "FIREBASE_ANDROID_IN_APP_PURCHASE", e[e.FIREBASE_ANDROID_CUSTOM = 14] = "FIREBASE_ANDROID_CUSTOM", e[e.FIREBASE_IOS_FIRST_OPEN = 15] = "FIREBASE_IOS_FIRST_OPEN", e[e.FIREBASE_IOS_IN_APP_PURCHASE = 16] = "FIREBASE_IOS_IN_APP_PURCHASE", e[e.FIREBASE_IOS_CUSTOM = 17] = "FIREBASE_IOS_CUSTOM", e[e.THIRD_PARTY_APP_ANALYTICS_ANDROID_FIRST_OPEN = 18] = "THIRD_PARTY_APP_ANALYTICS_ANDROID_FIRST_OPEN", e[e.THIRD_PARTY_APP_ANALYTICS_ANDROID_IN_APP_PURCHASE = 19] = "THIRD_PARTY_APP_ANALYTICS_ANDROID_IN_APP_PURCHASE", e[e.THIRD_PARTY_APP_ANALYTICS_ANDROID_CUSTOM = 20] = "THIRD_PARTY_APP_ANALYTICS_ANDROID_CUSTOM", e[e.THIRD_PARTY_APP_ANALYTICS_IOS_FIRST_OPEN = 21] = "THIRD_PARTY_APP_ANALYTICS_IOS_FIRST_OPEN", e[e.THIRD_PARTY_APP_ANALYTICS_IOS_IN_APP_PURCHASE = 22] = "THIRD_PARTY_APP_ANALYTICS_IOS_IN_APP_PURCHASE", e[e.THIRD_PARTY_APP_ANALYTICS_IOS_CUSTOM = 23] = "THIRD_PARTY_APP_ANALYTICS_IOS_CUSTOM", e[e.ANDROID_APP_PRE_REGISTRATION = 24] = "ANDROID_APP_PRE_REGISTRATION", e[e.ANDROID_INSTALLS_ALL_OTHER_APPS = 25] = "ANDROID_INSTALLS_ALL_OTHER_APPS", e[e.FLOODLIGHT_ACTION = 26] = "FLOODLIGHT_ACTION", e[e.FLOODLIGHT_TRANSACTION = 27] = "FLOODLIGHT_TRANSACTION", e[e.GOOGLE_HOSTED = 28] = "GOOGLE_HOSTED", e[e.LEAD_FORM_SUBMIT = 29] = "LEAD_FORM_SUBMIT", e[e.SALESFORCE = 30] = "SALESFORCE", e[e.SEARCH_ADS_360 = 31] = "SEARCH_ADS_360", e[e.SMART_CAMPAIGN_AD_CLICKS_TO_CALL = 32] = "SMART_CAMPAIGN_AD_CLICKS_TO_CALL", e[e.SMART_CAMPAIGN_MAP_CLICKS_TO_CALL = 33] = "SMART_CAMPAIGN_MAP_CLICKS_TO_CALL", e[e.SMART_CAMPAIGN_MAP_DIRECTIONS = 34] = "SMART_CAMPAIGN_MAP_DIRECTIONS", e[e.SMART_CAMPAIGN_TRACKED_CALLS = 35] = "SMART_CAMPAIGN_TRACKED_CALLS", e[e.STORE_VISITS = 36] = "STORE_VISITS", e[e.WEBPAGE_CODELESS = 37] = "WEBPAGE_CODELESS", e[e.UNIVERSAL_ANALYTICS_GOAL = 38] = "UNIVERSAL_ANALYTICS_GOAL", e[e.UNIVERSAL_ANALYTICS_TRANSACTION = 39] = "UNIVERSAL_ANALYTICS_TRANSACTION", e[e.GOOGLE_ANALYTICS_4_CUSTOM = 40] = "GOOGLE_ANALYTICS_4_CUSTOM", e[e.GOOGLE_ANALYTICS_4_PURCHASE = 41] = "GOOGLE_ANALYTICS_4_PURCHASE", e[e.GOOGLE_ANALYTICS_4_GENERATE_LEAD = 42] = "GOOGLE_ANALYTICS_4_GENERATE_LEAD", e[e.GOOGLE_ANALYTICS_4_QUALIFY_LEAD = 43] = "GOOGLE_ANALYTICS_4_QUALIFY_LEAD", e[e.GOOGLE_ANALYTICS_4_CLOSE_CONVERT_LEAD = 44] = "GOOGLE_ANALYTICS_4_CLOSE_CONVERT_LEAD", e[e.FIREBASE_ANDROID_GENERATE_LEAD = 45] = "FIREBASE_ANDROID_GENERATE_LEAD", e[e.FIREBASE_ANDROID_QUALIFY_LEAD = 46] = "FIREBASE_ANDROID_QUALIFY_LEAD", e[e.FIREBASE_ANDROID_CLOSE_CONVERT_LEAD = 47] = "FIREBASE_ANDROID_CLOSE_CONVERT_LEAD", e[e.FIREBASE_IOS_GENERATE_LEAD = 48] = "FIREBASE_IOS_GENERATE_LEAD", e[e.FIREBASE_IOS_QUALIFY_LEAD = 49] = "FIREBASE_IOS_QUALIFY_LEAD", e[e.FIREBASE_IOS_CLOSE_CONVERT_LEAD = 50] = "FIREBASE_IOS_CLOSE_CONVERT_LEAD", e[e.LOCAL_SERVICES_ADS = 51] = "LOCAL_SERVICES_ADS";
  }(t.ConversionActionType || (t.ConversionActionType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.RETRACTION = 2] = "RETRACTION", e[e.RESTATEMENT = 3] = "RESTATEMENT", e[e.ENHANCEMENT = 4] = "ENHANCEMENT";
  }(t.ConversionAdjustmentType || (t.ConversionAdjustmentType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ACTIVATION_NEEDED = 2] = "ACTIVATION_NEEDED", e[e.ENABLED = 3] = "ENABLED", e[e.PAUSED = 4] = "PAUSED";
  }(t.ConversionCustomVariableStatus || (t.ConversionCustomVariableStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NEW = 2] = "NEW", e[e.RETURNING = 3] = "RETURNING";
  }(t.ConversionCustomerType || (t.ConversionCustomerType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.APP = 2] = "APP", e[e.WEB = 3] = "WEB";
  }(t.ConversionEnvironment || (t.ConversionEnvironment = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NOT_CONVERSION_TRACKED = 2] = "NOT_CONVERSION_TRACKED", e[e.CONVERSION_TRACKING_MANAGED_BY_SELF = 3] = "CONVERSION_TRACKING_MANAGED_BY_SELF", e[e.CONVERSION_TRACKING_MANAGED_BY_THIS_MANAGER = 4] = "CONVERSION_TRACKING_MANAGED_BY_THIS_MANAGER", e[e.CONVERSION_TRACKING_MANAGED_BY_ANOTHER_MANAGER = 5] = "CONVERSION_TRACKING_MANAGED_BY_ANOTHER_MANAGER";
  }(t.ConversionTrackingStatus || (t.ConversionTrackingStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED", e[e.PAUSED = 4] = "PAUSED";
  }(t.ConversionValueRuleSetStatus || (t.ConversionValueRuleSetStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED", e[e.PAUSED = 4] = "PAUSED";
  }(t.ConversionValueRuleStatus || (t.ConversionValueRuleStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ELIGIBLE = 2] = "ELIGIBLE", e[e.RARELY_SERVED = 3] = "RARELY_SERVED";
  }(t.CriterionSystemServingStatus || (t.CriterionSystemServingStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.KEYWORD = 2] = "KEYWORD", e[e.PLACEMENT = 3] = "PLACEMENT", e[e.MOBILE_APP_CATEGORY = 4] = "MOBILE_APP_CATEGORY", e[e.MOBILE_APPLICATION = 5] = "MOBILE_APPLICATION", e[e.DEVICE = 6] = "DEVICE", e[e.LOCATION = 7] = "LOCATION", e[e.LISTING_GROUP = 8] = "LISTING_GROUP", e[e.AD_SCHEDULE = 9] = "AD_SCHEDULE", e[e.AGE_RANGE = 10] = "AGE_RANGE", e[e.GENDER = 11] = "GENDER", e[e.INCOME_RANGE = 12] = "INCOME_RANGE", e[e.PARENTAL_STATUS = 13] = "PARENTAL_STATUS", e[e.YOUTUBE_VIDEO = 14] = "YOUTUBE_VIDEO", e[e.YOUTUBE_CHANNEL = 15] = "YOUTUBE_CHANNEL", e[e.USER_LIST = 16] = "USER_LIST", e[e.PROXIMITY = 17] = "PROXIMITY", e[e.TOPIC = 18] = "TOPIC", e[e.LISTING_SCOPE = 19] = "LISTING_SCOPE", e[e.LANGUAGE = 20] = "LANGUAGE", e[e.IP_BLOCK = 21] = "IP_BLOCK", e[e.CONTENT_LABEL = 22] = "CONTENT_LABEL", e[e.CARRIER = 23] = "CARRIER", e[e.USER_INTEREST = 24] = "USER_INTEREST", e[e.WEBPAGE = 25] = "WEBPAGE", e[e.OPERATING_SYSTEM_VERSION = 26] = "OPERATING_SYSTEM_VERSION", e[e.APP_PAYMENT_MODEL = 27] = "APP_PAYMENT_MODEL", e[e.MOBILE_DEVICE = 28] = "MOBILE_DEVICE", e[e.CUSTOM_AFFINITY = 29] = "CUSTOM_AFFINITY", e[e.CUSTOM_INTENT = 30] = "CUSTOM_INTENT", e[e.LOCATION_GROUP = 31] = "LOCATION_GROUP", e[e.CUSTOM_AUDIENCE = 32] = "CUSTOM_AUDIENCE", e[e.COMBINED_AUDIENCE = 33] = "COMBINED_AUDIENCE", e[e.KEYWORD_THEME = 34] = "KEYWORD_THEME", e[e.AUDIENCE = 35] = "AUDIENCE", e[e.NEGATIVE_KEYWORD_LIST = 36] = "NEGATIVE_KEYWORD_LIST", e[e.LOCAL_SERVICE_ID = 37] = "LOCAL_SERVICE_ID", e[e.SEARCH_THEME = 38] = "SEARCH_THEME", e[e.BRAND = 39] = "BRAND", e[e.BRAND_LIST = 40] = "BRAND_LIST", e[e.LIFE_EVENT = 41] = "LIFE_EVENT", e[e.WEBPAGE_LIST = 42] = "WEBPAGE_LIST", e[e.VIDEO_LINEUP = 43] = "VIDEO_LINEUP", e[e.PLACEMENT_LIST = 44] = "PLACEMENT_LIST", e[e.VERTICAL_ADS_ITEM_GROUP_RULE_LIST = 45] = "VERTICAL_ADS_ITEM_GROUP_RULE_LIST", e[e.VERTICAL_ADS_ITEM_GROUP_RULE = 46] = "VERTICAL_ADS_ITEM_GROUP_RULE", e[e.VERTICAL_ADS_ITEM_BID = 47] = "VERTICAL_ADS_ITEM_BID", e[e.RETAIL_FILTER_BUNDLE = 180] = "RETAIL_FILTER_BUNDLE", e[e.RETAIL_FILTER = 181] = "RETAIL_FILTER";
  }(t.CriterionType || (t.CriterionType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.KEYWORD = 2] = "KEYWORD", e[e.URL = 3] = "URL", e[e.PLACE_CATEGORY = 4] = "PLACE_CATEGORY", e[e.APP = 5] = "APP";
  }(t.CustomAudienceMemberType || (t.CustomAudienceMemberType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED";
  }(t.CustomAudienceStatus || (t.CustomAudienceStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AUTO = 2] = "AUTO", e[e.INTEREST = 3] = "INTEREST", e[e.PURCHASE_INTENT = 4] = "PURCHASE_INTENT", e[e.SEARCH = 5] = "SEARCH";
  }(t.CustomAudienceType || (t.CustomAudienceType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED";
  }(t.CustomConversionGoalStatus || (t.CustomConversionGoalStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.KEYWORD = 2] = "KEYWORD", e[e.URL = 3] = "URL";
  }(t.CustomInterestMemberType || (t.CustomInterestMemberType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED";
  }(t.CustomInterestStatus || (t.CustomInterestStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CUSTOM_AFFINITY = 2] = "CUSTOM_AFFINITY", e[e.CUSTOM_INTENT = 3] = "CUSTOM_INTENT";
  }(t.CustomInterestType || (t.CustomInterestType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NEW_CUSTOMER_ACQUISITION_VALUE = 2] = "NEW_CUSTOMER_ACQUISITION_VALUE", e[e.NEW_CUSTOMER_ACQUISITION_ONLY = 3] = "NEW_CUSTOMER_ACQUISITION_ONLY", e[e.CUSTOMER_RETENTION_VALUE = 4] = "CUSTOMER_RETENTION_VALUE", e[e.CUSTOMER_RETENTION_ONLY = 5] = "CUSTOMER_RETENTION_ONLY", e[e.LOYALTY_RETENTION_VALUE = 7] = "LOYALTY_RETENTION_VALUE", e[e.LOYALTY_RETENTION_BENEFITS = 8] = "LOYALTY_RETENTION_BENEFITS";
  }(t.CustomerLifecycleOptimizationGoalSubType || (t.CustomerLifecycleOptimizationGoalSubType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NOT_ENOUGH_CONVERSIONS = 2] = "NOT_ENOUGH_CONVERSIONS", e[e.CONVERSION_LAG_TOO_HIGH = 3] = "CONVERSION_LAG_TOO_HIGH", e[e.HAS_CAMPAIGN_WITH_SHARED_BUDGET = 4] = "HAS_CAMPAIGN_WITH_SHARED_BUDGET", e[e.HAS_UPLOAD_CLICKS_CONVERSION = 5] = "HAS_UPLOAD_CLICKS_CONVERSION", e[e.AVERAGE_DAILY_SPEND_TOO_HIGH = 6] = "AVERAGE_DAILY_SPEND_TOO_HIGH", e[e.ANALYSIS_NOT_COMPLETE = 7] = "ANALYSIS_NOT_COMPLETE", e[e.OTHER = 8] = "OTHER";
  }(t.CustomerPayPerConversionEligibilityFailureReason || (t.CustomerPayPerConversionEligibilityFailureReason = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.CANCELED = 3] = "CANCELED", e[e.SUSPENDED = 4] = "SUSPENDED", e[e.CLOSED = 5] = "CLOSED";
  }(t.CustomerStatus || (t.CustomerStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED";
  }(t.CustomizerAttributeStatus || (t.CustomizerAttributeStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED";
  }(t.CustomizerValueStatus || (t.CustomizerValueStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AVAILABLE = 2] = "AVAILABLE", e[e.STALE = 3] = "STALE", e[e.EXPIRED = 4] = "EXPIRED", e[e.NEVER_GENERATED = 5] = "NEVER_GENERATED";
  }(t.DataDrivenModelStatus || (t.DataDrivenModelStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.REQUESTED = 2] = "REQUESTED", e[e.PENDING_APPROVAL = 3] = "PENDING_APPROVAL", e[e.ENABLED = 4] = "ENABLED", e[e.DISABLED = 5] = "DISABLED", e[e.REVOKED = 6] = "REVOKED", e[e.REJECTED = 7] = "REJECTED";
  }(t.DataLinkStatus || (t.DataLinkStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.VIDEO = 2] = "VIDEO";
  }(t.DataLinkType || (t.DataLinkType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CHANNEL_STRATEGY = 2] = "CHANNEL_STRATEGY", e[e.SELECTED_CHANNELS = 3] = "SELECTED_CHANNELS";
  }(t.DemandGenChannelConfig || (t.DemandGenChannelConfig = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ALL_CHANNELS = 2] = "ALL_CHANNELS", e[e.ALL_OWNED_AND_OPERATED_CHANNELS = 3] = "ALL_OWNED_AND_OPERATED_CHANNELS";
  }(t.DemandGenChannelStrategy || (t.DemandGenChannelStrategy = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.WITHIN_700M = 2] = "WITHIN_700M", e[e.WITHIN_1KM = 3] = "WITHIN_1KM", e[e.WITHIN_5KM = 4] = "WITHIN_5KM", e[e.WITHIN_10KM = 5] = "WITHIN_10KM", e[e.WITHIN_15KM = 6] = "WITHIN_15KM", e[e.WITHIN_20KM = 7] = "WITHIN_20KM", e[e.WITHIN_25KM = 8] = "WITHIN_25KM", e[e.WITHIN_30KM = 9] = "WITHIN_30KM", e[e.WITHIN_35KM = 10] = "WITHIN_35KM", e[e.WITHIN_40KM = 11] = "WITHIN_40KM", e[e.WITHIN_45KM = 12] = "WITHIN_45KM", e[e.WITHIN_50KM = 13] = "WITHIN_50KM", e[e.WITHIN_55KM = 14] = "WITHIN_55KM", e[e.WITHIN_60KM = 15] = "WITHIN_60KM", e[e.WITHIN_65KM = 16] = "WITHIN_65KM", e[e.BEYOND_65KM = 17] = "BEYOND_65KM", e[e.WITHIN_0_7MILES = 18] = "WITHIN_0_7MILES", e[e.WITHIN_1MILE = 19] = "WITHIN_1MILE", e[e.WITHIN_5MILES = 20] = "WITHIN_5MILES", e[e.WITHIN_10MILES = 21] = "WITHIN_10MILES", e[e.WITHIN_15MILES = 22] = "WITHIN_15MILES", e[e.WITHIN_20MILES = 23] = "WITHIN_20MILES", e[e.WITHIN_25MILES = 24] = "WITHIN_25MILES", e[e.WITHIN_30MILES = 25] = "WITHIN_30MILES", e[e.WITHIN_35MILES = 26] = "WITHIN_35MILES", e[e.WITHIN_40MILES = 27] = "WITHIN_40MILES", e[e.BEYOND_40MILES = 28] = "BEYOND_40MILES";
  }(t.DistanceBucket || (t.DistanceBucket = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CONTAINS_EU_POLITICAL_ADVERTISING = 2] = "CONTAINS_EU_POLITICAL_ADVERTISING", e[e.DOES_NOT_CONTAIN_EU_POLITICAL_ADVERTISING = 3] = "DOES_NOT_CONTAIN_EU_POLITICAL_ADVERTISING";
  }(t.EuPoliticalAdvertisingStatus || (t.EuPoliticalAdvertisingStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ADD = 2] = "ADD", e[e.REMOVE = 3] = "REMOVE";
  }(t.ExperimentAssetDetailOperation || (t.ExperimentAssetDetailOperation = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED", e[e.HALTED = 4] = "HALTED", e[e.PROMOTED = 5] = "PROMOTED", e[e.SETUP = 6] = "SETUP", e[e.INITIATED = 7] = "INITIATED", e[e.GRADUATED = 8] = "GRADUATED";
  }(t.ExperimentStatus || (t.ExperimentStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.DISPLAY_AND_VIDEO_360 = 2] = "DISPLAY_AND_VIDEO_360", e[e.AD_VARIATION = 3] = "AD_VARIATION", e[e.YOUTUBE_CUSTOM = 5] = "YOUTUBE_CUSTOM", e[e.DISPLAY_CUSTOM = 6] = "DISPLAY_CUSTOM", e[e.SEARCH_CUSTOM = 7] = "SEARCH_CUSTOM", e[e.DISPLAY_AUTOMATED_BIDDING_STRATEGY = 8] = "DISPLAY_AUTOMATED_BIDDING_STRATEGY", e[e.SEARCH_AUTOMATED_BIDDING_STRATEGY = 9] = "SEARCH_AUTOMATED_BIDDING_STRATEGY", e[e.SHOPPING_AUTOMATED_BIDDING_STRATEGY = 10] = "SHOPPING_AUTOMATED_BIDDING_STRATEGY", e[e.SMART_MATCHING = 11] = "SMART_MATCHING", e[e.HOTEL_CUSTOM = 12] = "HOTEL_CUSTOM", e[e.OPTIMIZE_ASSETS = 13] = "OPTIMIZE_ASSETS", e[e.ADOPT_AI_MAX = 14] = "ADOPT_AI_MAX", e[e.ADOPT_BROAD_MATCH_KEYWORDS = 15] = "ADOPT_BROAD_MATCH_KEYWORDS", e[e.PMAX_REPLACEMENT_SHOPPING = 16] = "PMAX_REPLACEMENT_SHOPPING", e[e.COMPARE_CAMPAIGNS = 17] = "COMPARE_CAMPAIGNS", e[e.PMAX_TEXT_CUSTOMIZATION_FINAL_URL_EXPANSION = 18] = "PMAX_TEXT_CUSTOMIZATION_FINAL_URL_EXPANSION";
  }(t.ExperimentType || (t.ExperimentType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVAL_PLANNED = 3] = "REMOVAL_PLANNED";
  }(t.GeoTargetConstantStatus || (t.GeoTargetConstantStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AREA_OF_INTEREST = 2] = "AREA_OF_INTEREST", e[e.LOCATION_OF_PRESENCE = 3] = "LOCATION_OF_PRESENCE";
  }(t.GeoTargetingType || (t.GeoTargetingType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CUSTOMER = 2] = "CUSTOMER", e[e.CAMPAIGN = 3] = "CAMPAIGN";
  }(t.GoalConfigLevel || (t.GoalConfigLevel = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ELIGIBLE = 2] = "ELIGIBLE", e[e.INELIGIBLE = 3] = "INELIGIBLE";
  }(t.GoalOptimizationEligibility || (t.GoalOptimizationEligibility = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CUSTOMER_RETENTION = 3] = "CUSTOMER_RETENTION", e[e.NEW_CUSTOMER_ACQUISITION = 4] = "NEW_CUSTOMER_ACQUISITION", e[e.LOYALTY_RETENTION = 5] = "LOYALTY_RETENTION";
  }(t.GoalType || (t.GoalType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.RESOURCE = 2] = "RESOURCE", e[e.ATTRIBUTE = 3] = "ATTRIBUTE", e[e.SEGMENT = 5] = "SEGMENT", e[e.METRIC = 6] = "METRIC";
  }(t.GoogleAdsFieldCategory || (t.GoogleAdsFieldCategory = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.BOOLEAN = 2] = "BOOLEAN", e[e.DATE = 3] = "DATE", e[e.DOUBLE = 4] = "DOUBLE", e[e.ENUM = 5] = "ENUM", e[e.FLOAT = 6] = "FLOAT", e[e.INT32 = 7] = "INT32", e[e.INT64 = 8] = "INT64", e[e.MESSAGE = 9] = "MESSAGE", e[e.RESOURCE_NAME = 10] = "RESOURCE_NAME", e[e.STRING = 11] = "STRING", e[e.UINT64 = 12] = "UINT64";
  }(t.GoogleAdsFieldDataType || (t.GoogleAdsFieldDataType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.MISSED = 2] = "MISSED", e[e.RECEIVED = 3] = "RECEIVED";
  }(t.GoogleVoiceCallStatus || (t.GoogleVoiceCallStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.SUCCESS = 2] = "SUCCESS", e[e.HOTEL_NOT_FOUND = 3] = "HOTEL_NOT_FOUND", e[e.INVALID_PLACE_ID = 4] = "INVALID_PLACE_ID";
  }(t.HotelAssetSuggestionStatus || (t.HotelAssetSuggestionStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.RESERVATION_ENABLED = 2] = "RESERVATION_ENABLED", e[e.RECONCILIATION_NEEDED = 3] = "RECONCILIATION_NEEDED", e[e.RECONCILED = 4] = "RECONCILED", e[e.CANCELED = 5] = "CANCELED";
  }(t.HotelReconciliationStatus || (t.HotelReconciliationStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ADVERTISER_IDENTITY_VERIFICATION = 2] = "ADVERTISER_IDENTITY_VERIFICATION";
  }(t.IdentityVerificationProgram || (t.IdentityVerificationProgram = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PENDING_USER_ACTION = 2] = "PENDING_USER_ACTION", e[e.PENDING_REVIEW = 3] = "PENDING_REVIEW", e[e.SUCCESS = 4] = "SUCCESS", e[e.FAILURE = 5] = "FAILURE";
  }(t.IdentityVerificationProgramStatus || (t.IdentityVerificationProgramStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NO_INCENTIVE = 2] = "NO_INCENTIVE", e[e.CYO_INCENTIVE = 3] = "CYO_INCENTIVE";
  }(t.IncentiveOfferType || (t.IncentiveOfferType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.REDEEMED = 2] = "REDEEMED", e[e.FULFILLED = 3] = "FULFILLED", e[e.REWARD_GRANTED = 4] = "REWARD_GRANTED", e[e.EXPIRED = 5] = "EXPIRED", e[e.REWARD_EXPIRED = 6] = "REWARD_EXPIRED", e[e.INVALIDATED = 7] = "INVALIDATED", e[e.REWARD_EXHAUSTED = 8] = "REWARD_EXHAUSTED";
  }(t.IncentiveState || (t.IncentiveState = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ACQUISITION = 2] = "ACQUISITION";
  }(t.IncentiveType || (t.IncentiveType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.EMERGING = 2] = "EMERGING", e[e.RISING = 3] = "RISING", e[e.SUSTAINED = 4] = "SUSTAINED", e[e.DECLINING = 5] = "DECLINING";
  }(t.InsightsTrend || (t.InsightsTrend = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CREDIT_MEMO = 2] = "CREDIT_MEMO", e[e.INVOICE = 3] = "INVOICE";
  }(t.InvoiceType || (t.InvoiceType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NEXT_WEEK = 3] = "NEXT_WEEK", e[e.NEXT_MONTH = 4] = "NEXT_MONTH", e[e.NEXT_QUARTER = 5] = "NEXT_QUARTER";
  }(t.KeywordPlanForecastInterval || (t.KeywordPlanForecastInterval = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.KEYWORD_CONCEPT = 2] = "KEYWORD_CONCEPT";
  }(t.KeywordPlanKeywordAnnotation || (t.KeywordPlanKeywordAnnotation = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.GOOGLE_SEARCH = 2] = "GOOGLE_SEARCH", e[e.GOOGLE_SEARCH_AND_PARTNERS = 3] = "GOOGLE_SEARCH_AND_PARTNERS";
  }(t.KeywordPlanNetwork || (t.KeywordPlanNetwork = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED";
  }(t.LabelStatus || (t.LabelStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.STOPPED = 3] = "STOPPED";
  }(t.LiftMeasurementFlightStatus || (t.LiftMeasurementFlightStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CONVERSION = 2] = "CONVERSION", e[e.SEARCH = 3] = "SEARCH", e[e.SURVEY = 4] = "SURVEY";
  }(t.LiftMetricType || (t.LiftMetricType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.THIRD_PARTY_APP_ANALYTICS = 2] = "THIRD_PARTY_APP_ANALYTICS";
  }(t.LinkedAccountType || (t.LinkedAccountType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.DATA_PARTNER = 2] = "DATA_PARTNER", e[e.GOOGLE_ADS = 3] = "GOOGLE_ADS", e[e.HOTEL_CENTER = 7] = "HOTEL_CENTER", e[e.MERCHANT_CENTER = 8] = "MERCHANT_CENTER", e[e.ADVERTISING_PARTNER = 9] = "ADVERTISING_PARTNER";
  }(t.LinkedProductType || (t.LinkedProductType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.INDEX0 = 2] = "INDEX0", e[e.INDEX1 = 3] = "INDEX1", e[e.INDEX2 = 4] = "INDEX2", e[e.INDEX3 = 5] = "INDEX3", e[e.INDEX4 = 6] = "INDEX4";
  }(t.ListingGroupFilterCustomAttributeIndex || (t.ListingGroupFilterCustomAttributeIndex = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.SHOPPING = 2] = "SHOPPING", e[e.WEBPAGE = 3] = "WEBPAGE", e[e.RETAIL = 4] = "RETAIL";
  }(t.ListingGroupFilterListingSource || (t.ListingGroupFilterListingSource = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.LEVEL1 = 2] = "LEVEL1", e[e.LEVEL2 = 3] = "LEVEL2", e[e.LEVEL3 = 4] = "LEVEL3", e[e.LEVEL4 = 5] = "LEVEL4", e[e.LEVEL5 = 6] = "LEVEL5";
  }(t.ListingGroupFilterProductCategoryLevel || (t.ListingGroupFilterProductCategoryLevel = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ONLINE = 2] = "ONLINE", e[e.LOCAL = 3] = "LOCAL";
  }(t.ListingGroupFilterProductChannel || (t.ListingGroupFilterProductChannel = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NEW = 2] = "NEW", e[e.REFURBISHED = 3] = "REFURBISHED", e[e.USED = 4] = "USED";
  }(t.ListingGroupFilterProductCondition || (t.ListingGroupFilterProductCondition = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.LEVEL1 = 2] = "LEVEL1", e[e.LEVEL2 = 3] = "LEVEL2", e[e.LEVEL3 = 4] = "LEVEL3", e[e.LEVEL4 = 5] = "LEVEL4", e[e.LEVEL5 = 6] = "LEVEL5";
  }(t.ListingGroupFilterProductTypeLevel || (t.ListingGroupFilterProductTypeLevel = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.SUBDIVISION = 2] = "SUBDIVISION", e[e.UNIT_INCLUDED = 3] = "UNIT_INCLUDED", e[e.UNIT_EXCLUDED = 4] = "UNIT_EXCLUDED";
  }(t.ListingGroupFilterType || (t.ListingGroupFilterType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.VEHICLES = 2] = "VEHICLES";
  }(t.ListingType || (t.ListingType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.BUSINESS_NAME_MISMATCH = 2] = "BUSINESS_NAME_MISMATCH", e[e.BUSINESS_DETAILS_MISMATCH = 3] = "BUSINESS_DETAILS_MISMATCH", e[e.ID_NOT_FOUND = 4] = "ID_NOT_FOUND", e[e.POOR_DOCUMENT_IMAGE_QUALITY = 5] = "POOR_DOCUMENT_IMAGE_QUALITY", e[e.DOCUMENT_EXPIRED = 6] = "DOCUMENT_EXPIRED", e[e.DOCUMENT_INVALID = 7] = "DOCUMENT_INVALID", e[e.DOCUMENT_TYPE_MISMATCH = 8] = "DOCUMENT_TYPE_MISMATCH", e[e.DOCUMENT_UNVERIFIABLE = 9] = "DOCUMENT_UNVERIFIABLE", e[e.OTHER = 10] = "OTHER";
  }(t.LocalServicesBusinessRegistrationCheckRejectionReason || (t.LocalServicesBusinessRegistrationCheckRejectionReason = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NUMBER = 2] = "NUMBER", e[e.DOCUMENT = 3] = "DOCUMENT";
  }(t.LocalServicesBusinessRegistrationType || (t.LocalServicesBusinessRegistrationType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.EMAIL = 2] = "EMAIL", e[e.MESSAGE = 3] = "MESSAGE", e[e.PHONE_CALL = 4] = "PHONE_CALL", e[e.SMS = 5] = "SMS", e[e.BOOKING = 6] = "BOOKING", e[e.WHATSAPP = 7] = "WHATSAPP", e[e.ADS_API = 8] = "ADS_API";
  }(t.LocalServicesLeadConversationType || (t.LocalServicesLeadConversationType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED";
  }(t.LocalServicesEmployeeStatus || (t.LocalServicesEmployeeStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.BUSINESS_OWNER = 2] = "BUSINESS_OWNER", e[e.EMPLOYEE = 3] = "EMPLOYEE";
  }(t.LocalServicesEmployeeType || (t.LocalServicesEmployeeType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.BUSINESS_NAME_MISMATCH = 2] = "BUSINESS_NAME_MISMATCH", e[e.INSURANCE_AMOUNT_INSUFFICIENT = 3] = "INSURANCE_AMOUNT_INSUFFICIENT", e[e.EXPIRED = 4] = "EXPIRED", e[e.NO_SIGNATURE = 5] = "NO_SIGNATURE", e[e.NO_POLICY_NUMBER = 6] = "NO_POLICY_NUMBER", e[e.NO_COMMERCIAL_GENERAL_LIABILITY = 7] = "NO_COMMERCIAL_GENERAL_LIABILITY", e[e.EDITABLE_FORMAT = 8] = "EDITABLE_FORMAT", e[e.CATEGORY_MISMATCH = 9] = "CATEGORY_MISMATCH", e[e.MISSING_EXPIRATION_DATE = 10] = "MISSING_EXPIRATION_DATE", e[e.POOR_QUALITY = 11] = "POOR_QUALITY", e[e.POTENTIALLY_EDITED = 12] = "POTENTIALLY_EDITED", e[e.WRONG_DOCUMENT_TYPE = 13] = "WRONG_DOCUMENT_TYPE", e[e.NON_FINAL = 14] = "NON_FINAL", e[e.OTHER = 15] = "OTHER";
  }(t.LocalServicesInsuranceRejectionReason || (t.LocalServicesInsuranceRejectionReason = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.SUCCESS_NOT_REACHED_THRESHOLD = 2] = "SUCCESS_NOT_REACHED_THRESHOLD", e[e.SUCCESS_REACHED_THRESHOLD = 3] = "SUCCESS_REACHED_THRESHOLD", e[e.FAIL_OVER_THRESHOLD = 4] = "FAIL_OVER_THRESHOLD", e[e.FAIL_NOT_ELIGIBLE = 5] = "FAIL_NOT_ELIGIBLE";
  }(t.LocalServicesLeadCreditIssuanceDecision || (t.LocalServicesLeadCreditIssuanceDecision = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PENDING = 2] = "PENDING", e[e.CREDITED = 3] = "CREDITED";
  }(t.LocalServicesCreditState || (t.LocalServicesCreditState = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NEW = 2] = "NEW", e[e.ACTIVE = 3] = "ACTIVE", e[e.BOOKED = 4] = "BOOKED", e[e.DECLINED = 5] = "DECLINED", e[e.EXPIRED = 6] = "EXPIRED", e[e.DISABLED = 7] = "DISABLED", e[e.CONSUMER_DECLINED = 8] = "CONSUMER_DECLINED", e[e.WIPED_OUT = 9] = "WIPED_OUT";
  }(t.LocalServicesLeadStatus || (t.LocalServicesLeadStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.VERY_SATISFIED = 2] = "VERY_SATISFIED", e[e.SATISFIED = 3] = "SATISFIED", e[e.NEUTRAL = 4] = "NEUTRAL", e[e.DISSATISFIED = 5] = "DISSATISFIED", e[e.VERY_DISSATISFIED = 6] = "VERY_DISSATISFIED";
  }(t.LocalServicesLeadSurveyAnswer || (t.LocalServicesLeadSurveyAnswer = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.OTHER_DISSATISFIED_REASON = 2] = "OTHER_DISSATISFIED_REASON", e[e.GEO_MISMATCH = 3] = "GEO_MISMATCH", e[e.JOB_TYPE_MISMATCH = 4] = "JOB_TYPE_MISMATCH", e[e.NOT_READY_TO_BOOK = 5] = "NOT_READY_TO_BOOK", e[e.SPAM = 6] = "SPAM", e[e.DUPLICATE = 7] = "DUPLICATE", e[e.SOLICITATION = 8] = "SOLICITATION";
  }(t.LocalServicesLeadSurveyDissatisfiedReason || (t.LocalServicesLeadSurveyDissatisfiedReason = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.OTHER_SATISFIED_REASON = 2] = "OTHER_SATISFIED_REASON", e[e.BOOKED_CUSTOMER = 3] = "BOOKED_CUSTOMER", e[e.LIKELY_BOOKED_CUSTOMER = 4] = "LIKELY_BOOKED_CUSTOMER", e[e.SERVICE_RELATED = 5] = "SERVICE_RELATED", e[e.HIGH_VALUE_SERVICE = 6] = "HIGH_VALUE_SERVICE";
  }(t.LocalServicesLeadSurveySatisfiedReason || (t.LocalServicesLeadSurveySatisfiedReason = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.MESSAGE = 2] = "MESSAGE", e[e.PHONE_CALL = 3] = "PHONE_CALL", e[e.BOOKING = 4] = "BOOKING";
  }(t.LocalServicesLeadType || (t.LocalServicesLeadType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.BUSINESS_NAME_MISMATCH = 2] = "BUSINESS_NAME_MISMATCH", e[e.UNAUTHORIZED = 3] = "UNAUTHORIZED", e[e.EXPIRED = 4] = "EXPIRED", e[e.POOR_QUALITY = 5] = "POOR_QUALITY", e[e.UNVERIFIABLE = 6] = "UNVERIFIABLE", e[e.WRONG_DOCUMENT_OR_ID = 7] = "WRONG_DOCUMENT_OR_ID", e[e.OTHER = 8] = "OTHER";
  }(t.LocalServicesLicenseRejectionReason || (t.LocalServicesLicenseRejectionReason = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ADVERTISER = 2] = "ADVERTISER", e[e.CONSUMER = 3] = "CONSUMER";
  }(t.LocalServicesParticipantType || (t.LocalServicesParticipantType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PASSED = 2] = "PASSED", e[e.FAILED = 3] = "FAILED", e[e.PENDING = 4] = "PENDING", e[e.NO_SUBMISSION = 5] = "NO_SUBMISSION", e[e.CANCELLED = 6] = "CANCELLED";
  }(t.LocalServicesVerificationArtifactStatus || (t.LocalServicesVerificationArtifactStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.BACKGROUND_CHECK = 2] = "BACKGROUND_CHECK", e[e.INSURANCE = 3] = "INSURANCE", e[e.LICENSE = 4] = "LICENSE", e[e.BUSINESS_REGISTRATION_CHECK = 5] = "BUSINESS_REGISTRATION_CHECK";
  }(t.LocalServicesVerificationArtifactType || (t.LocalServicesVerificationArtifactType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NEEDS_REVIEW = 2] = "NEEDS_REVIEW", e[e.FAILED = 3] = "FAILED", e[e.PASSED = 4] = "PASSED", e[e.NOT_APPLICABLE = 5] = "NOT_APPLICABLE", e[e.NO_SUBMISSION = 6] = "NO_SUBMISSION", e[e.PARTIAL_SUBMISSION = 7] = "PARTIAL_SUBMISSION", e[e.PENDING_ESCALATION = 8] = "PENDING_ESCALATION";
  }(t.LocalServicesVerificationStatus || (t.LocalServicesVerificationStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.GOOGLE_MY_BUSINESS = 2] = "GOOGLE_MY_BUSINESS", e[e.AFFILIATE = 3] = "AFFILIATE";
  }(t.LocationSourceType || (t.LocationSourceType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ACTIVE = 2] = "ACTIVE", e[e.INACTIVE = 3] = "INACTIVE", e[e.PENDING = 4] = "PENDING", e[e.REFUSED = 5] = "REFUSED", e[e.CANCELED = 6] = "CANCELED";
  }(t.ManagerLinkStatus || (t.ManagerLinkStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.IMAGE = 2] = "IMAGE", e[e.ICON = 3] = "ICON", e[e.MEDIA_BUNDLE = 4] = "MEDIA_BUNDLE", e[e.AUDIO = 5] = "AUDIO", e[e.VIDEO = 6] = "VIDEO", e[e.DYNAMIC_IMAGE = 7] = "DYNAMIC_IMAGE";
  }(t.MediaType || (t.MediaType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.RESTRICTION_BASED_EXCLUSION = 2] = "RESTRICTION_BASED_EXCLUSION";
  }(t.MessagingRestrictionType || (t.MessagingRestrictionType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.MOBILE = 2] = "MOBILE", e[e.TABLET = 3] = "TABLET";
  }(t.MobileDeviceType || (t.MobileDeviceType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CREATE = 2] = "CREATE", e[e.UPDATE = 3] = "UPDATE", e[e.REMOVE = 4] = "REMOVE";
  }(t.MultiPartyAuthOperationType || (t.MultiPartyAuthOperationType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.APPROVED = 2] = "APPROVED", e[e.PENDING = 3] = "PENDING", e[e.REVOKED = 4] = "REVOKED", e[e.REJECTED = 5] = "REJECTED", e[e.EXPIRED = 6] = "EXPIRED";
  }(t.MultiPartyAuthReviewStatus || (t.MultiPartyAuthReviewStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CUSTOMER_USER_ACCESS = 2] = "CUSTOMER_USER_ACCESS", e[e.CUSTOMER_USER_ACCESS_INVITATION = 3] = "CUSTOMER_USER_ACCESS_INVITATION";
  }(t.MultiPartyAuthReviewTargetResource || (t.MultiPartyAuthReviewTargetResource = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PRESENCE_OR_INTEREST = 4] = "PRESENCE_OR_INTEREST", e[e.PRESENCE = 5] = "PRESENCE";
  }(t.NegativeGeoTargetType || (t.NegativeGeoTargetType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.MAX_DURATION_FIFTEEN_SECONDS = 2] = "MAX_DURATION_FIFTEEN_SECONDS", e[e.MAX_DURATION_THIRTY_SECONDS = 3] = "MAX_DURATION_THIRTY_SECONDS", e[e.MAX_DURATION_SIXTY_SECONDS = 4] = "MAX_DURATION_SIXTY_SECONDS";
  }(t.NonSkippableMaxDuration || (t.NonSkippableMaxDuration = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.MIN_DURATION_FIVE_SECONDS = 2] = "MIN_DURATION_FIVE_SECONDS", e[e.MIN_DURATION_SEVEN_SECONDS = 3] = "MIN_DURATION_SEVEN_SECONDS", e[e.MIN_DURATION_SIXTEEN_SECONDS = 4] = "MIN_DURATION_SIXTEEN_SECONDS", e[e.MIN_DURATION_THIRTY_ONE_SECONDS = 5] = "MIN_DURATION_THIRTY_ONE_SECONDS";
  }(t.NonSkippableMinDuration || (t.NonSkippableMinDuration = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.EXCELLENT = 2] = "EXCELLENT", e[e.GOOD = 3] = "GOOD", e[e.NEEDS_ATTENTION = 4] = "NEEDS_ATTENTION", e[e.NO_RECENT_UPLOAD = 6] = "NO_RECENT_UPLOAD";
  }(t.OfflineConversionDiagnosticStatus || (t.OfflineConversionDiagnosticStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.GOOGLE_ADS_API = 2] = "GOOGLE_ADS_API", e[e.GOOGLE_ADS_WEB_CLIENT = 3] = "GOOGLE_ADS_WEB_CLIENT", e[e.ADS_DATA_CONNECTOR = 4] = "ADS_DATA_CONNECTOR";
  }(t.OfflineEventUploadClient || (t.OfflineEventUploadClient = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.INSUFFICIENT_MATCHED_TRANSACTIONS = 2] = "INSUFFICIENT_MATCHED_TRANSACTIONS", e[e.INSUFFICIENT_TRANSACTIONS = 3] = "INSUFFICIENT_TRANSACTIONS", e[e.HIGH_AVERAGE_TRANSACTION_VALUE = 4] = "HIGH_AVERAGE_TRANSACTION_VALUE", e[e.LOW_AVERAGE_TRANSACTION_VALUE = 5] = "LOW_AVERAGE_TRANSACTION_VALUE", e[e.NEWLY_OBSERVED_CURRENCY_CODE = 6] = "NEWLY_OBSERVED_CURRENCY_CODE";
  }(t.OfflineUserDataJobFailureReason || (t.OfflineUserDataJobFailureReason = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.MATCH_RANGE_LESS_THAN_20 = 2] = "MATCH_RANGE_LESS_THAN_20", e[e.MATCH_RANGE_20_TO_30 = 3] = "MATCH_RANGE_20_TO_30", e[e.MATCH_RANGE_31_TO_40 = 4] = "MATCH_RANGE_31_TO_40", e[e.MATCH_RANGE_41_TO_50 = 5] = "MATCH_RANGE_41_TO_50", e[e.MATCH_RANGE_51_TO_60 = 6] = "MATCH_RANGE_51_TO_60", e[e.MATCH_RANGE_61_TO_70 = 7] = "MATCH_RANGE_61_TO_70", e[e.MATCH_RANGE_71_TO_80 = 8] = "MATCH_RANGE_71_TO_80", e[e.MATCH_RANGE_81_TO_90 = 9] = "MATCH_RANGE_81_TO_90", e[e.MATCH_RANGE_91_TO_100 = 10] = "MATCH_RANGE_91_TO_100";
  }(t.OfflineUserDataJobMatchRateRange || (t.OfflineUserDataJobMatchRateRange = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PENDING = 2] = "PENDING", e[e.RUNNING = 3] = "RUNNING", e[e.SUCCESS = 4] = "SUCCESS", e[e.FAILED = 5] = "FAILED";
  }(t.OfflineUserDataJobStatus || (t.OfflineUserDataJobStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.STORE_SALES_UPLOAD_FIRST_PARTY = 2] = "STORE_SALES_UPLOAD_FIRST_PARTY", e[e.STORE_SALES_UPLOAD_THIRD_PARTY = 3] = "STORE_SALES_UPLOAD_THIRD_PARTY", e[e.CUSTOMER_MATCH_USER_LIST = 4] = "CUSTOMER_MATCH_USER_LIST", e[e.CUSTOMER_MATCH_WITH_ATTRIBUTES = 5] = "CUSTOMER_MATCH_WITH_ATTRIBUTES";
  }(t.OfflineUserDataJobType || (t.OfflineUserDataJobType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.EQUALS_TO = 2] = "EQUALS_TO", e[e.GREATER_THAN_EQUALS_TO = 4] = "GREATER_THAN_EQUALS_TO";
  }(t.OperatingSystemVersionOperatorType || (t.OperatingSystemVersionOperatorType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CALL_CLICKS = 2] = "CALL_CLICKS", e[e.DRIVING_DIRECTIONS = 3] = "DRIVING_DIRECTIONS", e[e.APP_PRE_REGISTRATION = 4] = "APP_PRE_REGISTRATION";
  }(t.OptimizationGoalType || (t.OptimizationGoalType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CREATOR_PARTNERSHIPS = 2] = "CREATOR_PARTNERSHIPS", e[e.CREATOR_TAKEOVER = 3] = "CREATOR_TAKEOVER", e[e.PARTNERSHIP_ADS = 4] = "PARTNERSHIP_ADS", e[e.YOUTUBE_SELECT_LINEUPS = 5] = "YOUTUBE_SELECT_LINEUPS";
  }(t.PartnershipOpportunity || (t.PartnershipOpportunity = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CLICKS = 4] = "CLICKS", e[e.CONVERSION_VALUE = 5] = "CONVERSION_VALUE", e[e.CONVERSIONS = 6] = "CONVERSIONS", e[e.GUEST_STAY = 7] = "GUEST_STAY";
  }(t.PaymentMode || (t.PaymentMode = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.UPGRADE_IN_PROGRESS = 3] = "UPGRADE_IN_PROGRESS", e[e.UPGRADE_COMPLETE = 4] = "UPGRADE_COMPLETE", e[e.UPGRADE_FAILED = 5] = "UPGRADE_FAILED", e[e.UPGRADE_ELIGIBLE = 6] = "UPGRADE_ELIGIBLE";
  }(t.PerformanceMaxUpgradeStatus || (t.PerformanceMaxUpgradeStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.WEBSITE = 2] = "WEBSITE", e[e.MOBILE_APP_CATEGORY = 3] = "MOBILE_APP_CATEGORY", e[e.MOBILE_APPLICATION = 4] = "MOBILE_APPLICATION", e[e.YOUTUBE_VIDEO = 5] = "YOUTUBE_VIDEO", e[e.YOUTUBE_CHANNEL = 6] = "YOUTUBE_CHANNEL", e[e.GOOGLE_PRODUCTS = 7] = "GOOGLE_PRODUCTS";
  }(t.PlacementType || (t.PlacementType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PRESENCE_OR_INTEREST = 5] = "PRESENCE_OR_INTEREST", e[e.SEARCH_INTEREST = 6] = "SEARCH_INTEREST", e[e.PRESENCE = 7] = "PRESENCE";
  }(t.PositiveGeoTargetType || (t.PositiveGeoTargetType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.IN_STOCK = 2] = "IN_STOCK", e[e.OUT_OF_STOCK = 3] = "OUT_OF_STOCK", e[e.PREORDER = 4] = "PREORDER";
  }(t.ProductAvailability || (t.ProductAvailability = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.OBSOLETE = 3] = "OBSOLETE";
  }(t.ProductCategoryState || (t.ProductCategoryState = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.WARNING = 2] = "WARNING", e[e.ERROR = 3] = "ERROR";
  }(t.ProductIssueSeverity || (t.ProductIssueSeverity = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ACCEPTED = 2] = "ACCEPTED", e[e.REQUESTED = 3] = "REQUESTED", e[e.PENDING_APPROVAL = 4] = "PENDING_APPROVAL", e[e.REVOKED = 5] = "REVOKED", e[e.REJECTED = 6] = "REJECTED", e[e.EXPIRED = 7] = "EXPIRED";
  }(t.ProductLinkInvitationStatus || (t.ProductLinkInvitationStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NOT_ELIGIBLE = 2] = "NOT_ELIGIBLE", e[e.ELIGIBLE_LIMITED = 3] = "ELIGIBLE_LIMITED", e[e.ELIGIBLE = 4] = "ELIGIBLE";
  }(t.ProductStatus || (t.ProductStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AGE_RANGE_18_24 = 503001] = "AGE_RANGE_18_24", e[e.AGE_RANGE_18_34 = 2] = "AGE_RANGE_18_34", e[e.AGE_RANGE_18_44 = 3] = "AGE_RANGE_18_44", e[e.AGE_RANGE_18_49 = 4] = "AGE_RANGE_18_49", e[e.AGE_RANGE_18_54 = 5] = "AGE_RANGE_18_54", e[e.AGE_RANGE_18_64 = 6] = "AGE_RANGE_18_64", e[e.AGE_RANGE_18_65_UP = 7] = "AGE_RANGE_18_65_UP", e[e.AGE_RANGE_21_34 = 8] = "AGE_RANGE_21_34", e[e.AGE_RANGE_21_44 = 22] = "AGE_RANGE_21_44", e[e.AGE_RANGE_21_49 = 23] = "AGE_RANGE_21_49", e[e.AGE_RANGE_21_54 = 24] = "AGE_RANGE_21_54", e[e.AGE_RANGE_21_64 = 25] = "AGE_RANGE_21_64", e[e.AGE_RANGE_21_65_UP = 26] = "AGE_RANGE_21_65_UP", e[e.AGE_RANGE_25_34 = 503002] = "AGE_RANGE_25_34", e[e.AGE_RANGE_25_44 = 9] = "AGE_RANGE_25_44", e[e.AGE_RANGE_25_49 = 10] = "AGE_RANGE_25_49", e[e.AGE_RANGE_25_54 = 11] = "AGE_RANGE_25_54", e[e.AGE_RANGE_25_64 = 12] = "AGE_RANGE_25_64", e[e.AGE_RANGE_25_65_UP = 13] = "AGE_RANGE_25_65_UP", e[e.AGE_RANGE_35_44 = 503003] = "AGE_RANGE_35_44", e[e.AGE_RANGE_35_49 = 14] = "AGE_RANGE_35_49", e[e.AGE_RANGE_35_54 = 15] = "AGE_RANGE_35_54", e[e.AGE_RANGE_35_64 = 16] = "AGE_RANGE_35_64", e[e.AGE_RANGE_35_65_UP = 17] = "AGE_RANGE_35_65_UP", e[e.AGE_RANGE_45_54 = 503004] = "AGE_RANGE_45_54", e[e.AGE_RANGE_45_64 = 18] = "AGE_RANGE_45_64", e[e.AGE_RANGE_45_65_UP = 19] = "AGE_RANGE_45_65_UP", e[e.AGE_RANGE_50_65_UP = 20] = "AGE_RANGE_50_65_UP", e[e.AGE_RANGE_55_64 = 503005] = "AGE_RANGE_55_64", e[e.AGE_RANGE_55_65_UP = 21] = "AGE_RANGE_55_65_UP", e[e.AGE_RANGE_65_UP = 503006] = "AGE_RANGE_65_UP";
  }(t.ReachPlanAgeRange || (t.ReachPlanAgeRange = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AUCTION = 2] = "AUCTION", e[e.RESERVATION = 3] = "RESERVATION";
  }(t.ReachPlanBuyingMethod || (t.ReachPlanBuyingMethod = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CUSTOMER_HISTORY = 2] = "CUSTOMER_HISTORY", e[e.INVENTORY_AGGRESSIVE = 3] = "INVENTORY_AGGRESSIVE", e[e.INVENTORY_CONSERVATIVE = 4] = "INVENTORY_CONSERVATIVE", e[e.INVENTORY_MEDIAN = 5] = "INVENTORY_MEDIAN";
  }(t.ReachPlanConversionRateModel || (t.ReachPlanConversionRateModel = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CPM = 2] = "CPM", e[e.CPV = 3] = "CPV", e[e.CPC = 4] = "CPC", e[e.CPA = 5] = "CPA";
  }(t.ReachPlanCostModel || (t.ReachPlanCostModel = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AWARENESS = 2] = "AWARENESS", e[e.CONSIDERATION = 3] = "CONSIDERATION", e[e.ACTION = 4] = "ACTION";
  }(t.ReachPlanMarketingObjective || (t.ReachPlanMarketingObjective = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.YOUTUBE = 2] = "YOUTUBE", e[e.GOOGLE_VIDEO_PARTNERS = 3] = "GOOGLE_VIDEO_PARTNERS", e[e.YOUTUBE_AND_GOOGLE_VIDEO_PARTNERS = 4] = "YOUTUBE_AND_GOOGLE_VIDEO_PARTNERS";
  }(t.ReachPlanNetwork || (t.ReachPlanNetwork = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PLANNABLE = 2] = "PLANNABLE", e[e.UNPLANNABLE = 3] = "UNPLANNABLE";
  }(t.ReachPlanPlannableUserListStatus || (t.ReachPlanPlannableUserListStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.DISCOVER_FEED = 7] = "DISCOVER_FEED", e[e.GMAIL = 8] = "GMAIL", e[e.IN_FEED = 2] = "IN_FEED", e[e.IN_STREAM_BUMPER = 3] = "IN_STREAM_BUMPER", e[e.IN_STREAM_NON_SKIPPABLE = 4] = "IN_STREAM_NON_SKIPPABLE", e[e.IN_STREAM_SKIPPABLE = 5] = "IN_STREAM_SKIPPABLE", e[e.SHORTS = 6] = "SHORTS", e[e.GOOGLE_DISPLAY_NETWORK = 9] = "GOOGLE_DISPLAY_NETWORK", e[e.IN_STREAM_NON_SKIPPABLE_THIRTY_SECONDS = 10] = "IN_STREAM_NON_SKIPPABLE_THIRTY_SECONDS";
  }(t.ReachPlanSurface || (t.ReachPlanSurface = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.PAUSED = 3] = "PAUSED";
  }(t.RecommendationSubscriptionStatus || (t.RecommendationSubscriptionStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AUSTRIA_DST_FEE = 2] = "AUSTRIA_DST_FEE", e[e.TURKIYE_REGULATORY_OPERATING_COST = 3] = "TURKIYE_REGULATORY_OPERATING_COST", e[e.UK_DST_FEE = 4] = "UK_DST_FEE", e[e.SPAIN_REGULATORY_OPERATING_COST = 5] = "SPAIN_REGULATORY_OPERATING_COST", e[e.FRANCE_REGULATORY_OPERATING_COST = 6] = "FRANCE_REGULATORY_OPERATING_COST", e[e.ITALY_REGULATORY_OPERATING_COST = 7] = "ITALY_REGULATORY_OPERATING_COST", e[e.INDIA_REGULATORY_OPERATING_COST = 8] = "INDIA_REGULATORY_OPERATING_COST", e[e.POLAND_REGULATORY_OPERATING_COST = 9] = "POLAND_REGULATORY_OPERATING_COST", e[e.OPERATING_CHARGES = 10] = "OPERATING_CHARGES", e[e.CANADA_DST_FEE = 11] = "CANADA_DST_FEE";
  }(t.RegulatoryFeeType || (t.RegulatoryFeeType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CREATE = 2] = "CREATE", e[e.UPDATE = 3] = "UPDATE", e[e.REMOVE = 4] = "REMOVE";
  }(t.ResourceChangeOperation || (t.ResourceChangeOperation = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CAMPAIGNS_PER_CUSTOMER = 2] = "CAMPAIGNS_PER_CUSTOMER", e[e.BASE_CAMPAIGNS_PER_CUSTOMER = 3] = "BASE_CAMPAIGNS_PER_CUSTOMER", e[e.EXPERIMENT_CAMPAIGNS_PER_CUSTOMER = 105] = "EXPERIMENT_CAMPAIGNS_PER_CUSTOMER", e[e.HOTEL_CAMPAIGNS_PER_CUSTOMER = 4] = "HOTEL_CAMPAIGNS_PER_CUSTOMER", e[e.SMART_SHOPPING_CAMPAIGNS_PER_CUSTOMER = 5] = "SMART_SHOPPING_CAMPAIGNS_PER_CUSTOMER", e[e.AD_GROUPS_PER_CAMPAIGN = 6] = "AD_GROUPS_PER_CAMPAIGN", e[e.AD_GROUPS_PER_SHOPPING_CAMPAIGN = 8] = "AD_GROUPS_PER_SHOPPING_CAMPAIGN", e[e.AD_GROUPS_PER_HOTEL_CAMPAIGN = 9] = "AD_GROUPS_PER_HOTEL_CAMPAIGN", e[e.REPORTING_AD_GROUPS_PER_LOCAL_CAMPAIGN = 10] = "REPORTING_AD_GROUPS_PER_LOCAL_CAMPAIGN", e[e.REPORTING_AD_GROUPS_PER_APP_CAMPAIGN = 11] = "REPORTING_AD_GROUPS_PER_APP_CAMPAIGN", e[e.MANAGED_AD_GROUPS_PER_SMART_CAMPAIGN = 52] = "MANAGED_AD_GROUPS_PER_SMART_CAMPAIGN", e[e.AD_GROUP_CRITERIA_PER_CUSTOMER = 12] = "AD_GROUP_CRITERIA_PER_CUSTOMER", e[e.BASE_AD_GROUP_CRITERIA_PER_CUSTOMER = 13] = "BASE_AD_GROUP_CRITERIA_PER_CUSTOMER", e[e.EXPERIMENT_AD_GROUP_CRITERIA_PER_CUSTOMER = 107] = "EXPERIMENT_AD_GROUP_CRITERIA_PER_CUSTOMER", e[e.AD_GROUP_CRITERIA_PER_CAMPAIGN = 14] = "AD_GROUP_CRITERIA_PER_CAMPAIGN", e[e.CAMPAIGN_CRITERIA_PER_CUSTOMER = 15] = "CAMPAIGN_CRITERIA_PER_CUSTOMER", e[e.BASE_CAMPAIGN_CRITERIA_PER_CUSTOMER = 16] = "BASE_CAMPAIGN_CRITERIA_PER_CUSTOMER", e[e.EXPERIMENT_CAMPAIGN_CRITERIA_PER_CUSTOMER = 108] = "EXPERIMENT_CAMPAIGN_CRITERIA_PER_CUSTOMER", e[e.WEBPAGE_CRITERIA_PER_CUSTOMER = 17] = "WEBPAGE_CRITERIA_PER_CUSTOMER", e[e.BASE_WEBPAGE_CRITERIA_PER_CUSTOMER = 18] = "BASE_WEBPAGE_CRITERIA_PER_CUSTOMER", e[e.EXPERIMENT_WEBPAGE_CRITERIA_PER_CUSTOMER = 19] = "EXPERIMENT_WEBPAGE_CRITERIA_PER_CUSTOMER", e[e.COMBINED_AUDIENCE_CRITERIA_PER_AD_GROUP = 20] = "COMBINED_AUDIENCE_CRITERIA_PER_AD_GROUP", e[e.CUSTOMER_NEGATIVE_PLACEMENT_CRITERIA_PER_CUSTOMER = 21] = "CUSTOMER_NEGATIVE_PLACEMENT_CRITERIA_PER_CUSTOMER", e[e.CUSTOMER_NEGATIVE_YOUTUBE_CHANNEL_CRITERIA_PER_CUSTOMER = 22] = "CUSTOMER_NEGATIVE_YOUTUBE_CHANNEL_CRITERIA_PER_CUSTOMER", e[e.CRITERIA_PER_AD_GROUP = 23] = "CRITERIA_PER_AD_GROUP", e[e.LISTING_GROUPS_PER_AD_GROUP = 24] = "LISTING_GROUPS_PER_AD_GROUP", e[e.EXPLICITLY_SHARED_BUDGETS_PER_CUSTOMER = 25] = "EXPLICITLY_SHARED_BUDGETS_PER_CUSTOMER", e[e.IMPLICITLY_SHARED_BUDGETS_PER_CUSTOMER = 26] = "IMPLICITLY_SHARED_BUDGETS_PER_CUSTOMER", e[e.COMBINED_AUDIENCE_CRITERIA_PER_CAMPAIGN = 27] = "COMBINED_AUDIENCE_CRITERIA_PER_CAMPAIGN", e[e.NEGATIVE_KEYWORDS_PER_CAMPAIGN = 28] = "NEGATIVE_KEYWORDS_PER_CAMPAIGN", e[e.NEGATIVE_PLACEMENTS_PER_CAMPAIGN = 29] = "NEGATIVE_PLACEMENTS_PER_CAMPAIGN", e[e.GEO_TARGETS_PER_CAMPAIGN = 30] = "GEO_TARGETS_PER_CAMPAIGN", e[e.NEGATIVE_IP_BLOCKS_PER_CAMPAIGN = 32] = "NEGATIVE_IP_BLOCKS_PER_CAMPAIGN", e[e.PROXIMITIES_PER_CAMPAIGN = 33] = "PROXIMITIES_PER_CAMPAIGN", e[e.LISTING_SCOPES_PER_SHOPPING_CAMPAIGN = 34] = "LISTING_SCOPES_PER_SHOPPING_CAMPAIGN", e[e.LISTING_SCOPES_PER_NON_SHOPPING_CAMPAIGN = 35] = "LISTING_SCOPES_PER_NON_SHOPPING_CAMPAIGN", e[e.NEGATIVE_KEYWORDS_PER_SHARED_SET = 36] = "NEGATIVE_KEYWORDS_PER_SHARED_SET", e[e.NEGATIVE_PLACEMENTS_PER_SHARED_SET = 37] = "NEGATIVE_PLACEMENTS_PER_SHARED_SET", e[e.SHARED_SETS_PER_CUSTOMER_FOR_TYPE_DEFAULT = 40] = "SHARED_SETS_PER_CUSTOMER_FOR_TYPE_DEFAULT", e[e.SHARED_SETS_PER_CUSTOMER_FOR_NEGATIVE_PLACEMENT_LIST_LOWER = 41] = "SHARED_SETS_PER_CUSTOMER_FOR_NEGATIVE_PLACEMENT_LIST_LOWER", e[e.HOTEL_ADVANCE_BOOKING_WINDOW_BID_MODIFIERS_PER_AD_GROUP = 44] = "HOTEL_ADVANCE_BOOKING_WINDOW_BID_MODIFIERS_PER_AD_GROUP", e[e.BIDDING_STRATEGIES_PER_CUSTOMER = 45] = "BIDDING_STRATEGIES_PER_CUSTOMER", e[e.BASIC_USER_LISTS_PER_CUSTOMER = 47] = "BASIC_USER_LISTS_PER_CUSTOMER", e[e.LOGICAL_USER_LISTS_PER_CUSTOMER = 48] = "LOGICAL_USER_LISTS_PER_CUSTOMER", e[e.RULE_BASED_USER_LISTS_PER_CUSTOMER = 153] = "RULE_BASED_USER_LISTS_PER_CUSTOMER", e[e.BASE_AD_GROUP_ADS_PER_CUSTOMER = 53] = "BASE_AD_GROUP_ADS_PER_CUSTOMER", e[e.EXPERIMENT_AD_GROUP_ADS_PER_CUSTOMER = 54] = "EXPERIMENT_AD_GROUP_ADS_PER_CUSTOMER", e[e.AD_GROUP_ADS_PER_CAMPAIGN = 55] = "AD_GROUP_ADS_PER_CAMPAIGN", e[e.TEXT_AND_OTHER_ADS_PER_AD_GROUP = 56] = "TEXT_AND_OTHER_ADS_PER_AD_GROUP", e[e.IMAGE_ADS_PER_AD_GROUP = 57] = "IMAGE_ADS_PER_AD_GROUP", e[e.SHOPPING_SMART_ADS_PER_AD_GROUP = 58] = "SHOPPING_SMART_ADS_PER_AD_GROUP", e[e.RESPONSIVE_SEARCH_ADS_PER_AD_GROUP = 59] = "RESPONSIVE_SEARCH_ADS_PER_AD_GROUP", e[e.APP_ADS_PER_AD_GROUP = 60] = "APP_ADS_PER_AD_GROUP", e[e.APP_ENGAGEMENT_ADS_PER_AD_GROUP = 61] = "APP_ENGAGEMENT_ADS_PER_AD_GROUP", e[e.LOCAL_ADS_PER_AD_GROUP = 62] = "LOCAL_ADS_PER_AD_GROUP", e[e.VIDEO_ADS_PER_AD_GROUP = 63] = "VIDEO_ADS_PER_AD_GROUP", e[e.LEAD_FORM_CAMPAIGN_ASSETS_PER_CAMPAIGN = 143] = "LEAD_FORM_CAMPAIGN_ASSETS_PER_CAMPAIGN", e[e.PROMOTION_CUSTOMER_ASSETS_PER_CUSTOMER = 79] = "PROMOTION_CUSTOMER_ASSETS_PER_CUSTOMER", e[e.PROMOTION_CAMPAIGN_ASSETS_PER_CAMPAIGN = 80] = "PROMOTION_CAMPAIGN_ASSETS_PER_CAMPAIGN", e[e.PROMOTION_AD_GROUP_ASSETS_PER_AD_GROUP = 81] = "PROMOTION_AD_GROUP_ASSETS_PER_AD_GROUP", e[e.CALLOUT_CUSTOMER_ASSETS_PER_CUSTOMER = 134] = "CALLOUT_CUSTOMER_ASSETS_PER_CUSTOMER", e[e.CALLOUT_CAMPAIGN_ASSETS_PER_CAMPAIGN = 135] = "CALLOUT_CAMPAIGN_ASSETS_PER_CAMPAIGN", e[e.CALLOUT_AD_GROUP_ASSETS_PER_AD_GROUP = 136] = "CALLOUT_AD_GROUP_ASSETS_PER_AD_GROUP", e[e.SITELINK_CUSTOMER_ASSETS_PER_CUSTOMER = 137] = "SITELINK_CUSTOMER_ASSETS_PER_CUSTOMER", e[e.SITELINK_CAMPAIGN_ASSETS_PER_CAMPAIGN = 138] = "SITELINK_CAMPAIGN_ASSETS_PER_CAMPAIGN", e[e.SITELINK_AD_GROUP_ASSETS_PER_AD_GROUP = 139] = "SITELINK_AD_GROUP_ASSETS_PER_AD_GROUP", e[e.STRUCTURED_SNIPPET_CUSTOMER_ASSETS_PER_CUSTOMER = 140] = "STRUCTURED_SNIPPET_CUSTOMER_ASSETS_PER_CUSTOMER", e[e.STRUCTURED_SNIPPET_CAMPAIGN_ASSETS_PER_CAMPAIGN = 141] = "STRUCTURED_SNIPPET_CAMPAIGN_ASSETS_PER_CAMPAIGN", e[e.STRUCTURED_SNIPPET_AD_GROUP_ASSETS_PER_AD_GROUP = 142] = "STRUCTURED_SNIPPET_AD_GROUP_ASSETS_PER_AD_GROUP", e[e.MOBILE_APP_CUSTOMER_ASSETS_PER_CUSTOMER = 144] = "MOBILE_APP_CUSTOMER_ASSETS_PER_CUSTOMER", e[e.MOBILE_APP_CAMPAIGN_ASSETS_PER_CAMPAIGN = 145] = "MOBILE_APP_CAMPAIGN_ASSETS_PER_CAMPAIGN", e[e.MOBILE_APP_AD_GROUP_ASSETS_PER_AD_GROUP = 146] = "MOBILE_APP_AD_GROUP_ASSETS_PER_AD_GROUP", e[e.HOTEL_CALLOUT_CUSTOMER_ASSETS_PER_CUSTOMER = 147] = "HOTEL_CALLOUT_CUSTOMER_ASSETS_PER_CUSTOMER", e[e.HOTEL_CALLOUT_CAMPAIGN_ASSETS_PER_CAMPAIGN = 148] = "HOTEL_CALLOUT_CAMPAIGN_ASSETS_PER_CAMPAIGN", e[e.HOTEL_CALLOUT_AD_GROUP_ASSETS_PER_AD_GROUP = 149] = "HOTEL_CALLOUT_AD_GROUP_ASSETS_PER_AD_GROUP", e[e.CALL_CUSTOMER_ASSETS_PER_CUSTOMER = 150] = "CALL_CUSTOMER_ASSETS_PER_CUSTOMER", e[e.CALL_CAMPAIGN_ASSETS_PER_CAMPAIGN = 151] = "CALL_CAMPAIGN_ASSETS_PER_CAMPAIGN", e[e.CALL_AD_GROUP_ASSETS_PER_AD_GROUP = 152] = "CALL_AD_GROUP_ASSETS_PER_AD_GROUP", e[e.PRICE_CUSTOMER_ASSETS_PER_CUSTOMER = 154] = "PRICE_CUSTOMER_ASSETS_PER_CUSTOMER", e[e.PRICE_CAMPAIGN_ASSETS_PER_CAMPAIGN = 155] = "PRICE_CAMPAIGN_ASSETS_PER_CAMPAIGN", e[e.PRICE_AD_GROUP_ASSETS_PER_AD_GROUP = 156] = "PRICE_AD_GROUP_ASSETS_PER_AD_GROUP", e[e.AD_IMAGE_CAMPAIGN_ASSETS_PER_CAMPAIGN = 175] = "AD_IMAGE_CAMPAIGN_ASSETS_PER_CAMPAIGN", e[e.AD_IMAGE_AD_GROUP_ASSETS_PER_AD_GROUP = 176] = "AD_IMAGE_AD_GROUP_ASSETS_PER_AD_GROUP", e[e.PAGE_FEED_ASSET_SETS_PER_CUSTOMER = 157] = "PAGE_FEED_ASSET_SETS_PER_CUSTOMER", e[e.DYNAMIC_EDUCATION_FEED_ASSET_SETS_PER_CUSTOMER = 158] = "DYNAMIC_EDUCATION_FEED_ASSET_SETS_PER_CUSTOMER", e[e.ASSETS_PER_PAGE_FEED_ASSET_SET = 159] = "ASSETS_PER_PAGE_FEED_ASSET_SET", e[e.ASSETS_PER_DYNAMIC_EDUCATION_FEED_ASSET_SET = 160] = "ASSETS_PER_DYNAMIC_EDUCATION_FEED_ASSET_SET", e[e.DYNAMIC_REAL_ESTATE_ASSET_SETS_PER_CUSTOMER = 161] = "DYNAMIC_REAL_ESTATE_ASSET_SETS_PER_CUSTOMER", e[e.ASSETS_PER_DYNAMIC_REAL_ESTATE_ASSET_SET = 162] = "ASSETS_PER_DYNAMIC_REAL_ESTATE_ASSET_SET", e[e.DYNAMIC_CUSTOM_ASSET_SETS_PER_CUSTOMER = 163] = "DYNAMIC_CUSTOM_ASSET_SETS_PER_CUSTOMER", e[e.ASSETS_PER_DYNAMIC_CUSTOM_ASSET_SET = 164] = "ASSETS_PER_DYNAMIC_CUSTOM_ASSET_SET", e[e.DYNAMIC_HOTELS_AND_RENTALS_ASSET_SETS_PER_CUSTOMER = 165] = "DYNAMIC_HOTELS_AND_RENTALS_ASSET_SETS_PER_CUSTOMER", e[e.ASSETS_PER_DYNAMIC_HOTELS_AND_RENTALS_ASSET_SET = 166] = "ASSETS_PER_DYNAMIC_HOTELS_AND_RENTALS_ASSET_SET", e[e.DYNAMIC_LOCAL_ASSET_SETS_PER_CUSTOMER = 167] = "DYNAMIC_LOCAL_ASSET_SETS_PER_CUSTOMER", e[e.ASSETS_PER_DYNAMIC_LOCAL_ASSET_SET = 168] = "ASSETS_PER_DYNAMIC_LOCAL_ASSET_SET", e[e.DYNAMIC_FLIGHTS_ASSET_SETS_PER_CUSTOMER = 169] = "DYNAMIC_FLIGHTS_ASSET_SETS_PER_CUSTOMER", e[e.ASSETS_PER_DYNAMIC_FLIGHTS_ASSET_SET = 170] = "ASSETS_PER_DYNAMIC_FLIGHTS_ASSET_SET", e[e.DYNAMIC_TRAVEL_ASSET_SETS_PER_CUSTOMER = 171] = "DYNAMIC_TRAVEL_ASSET_SETS_PER_CUSTOMER", e[e.ASSETS_PER_DYNAMIC_TRAVEL_ASSET_SET = 172] = "ASSETS_PER_DYNAMIC_TRAVEL_ASSET_SET", e[e.DYNAMIC_JOBS_ASSET_SETS_PER_CUSTOMER = 173] = "DYNAMIC_JOBS_ASSET_SETS_PER_CUSTOMER", e[e.ASSETS_PER_DYNAMIC_JOBS_ASSET_SET = 174] = "ASSETS_PER_DYNAMIC_JOBS_ASSET_SET", e[e.BUSINESS_NAME_CAMPAIGN_ASSETS_PER_CAMPAIGN = 179] = "BUSINESS_NAME_CAMPAIGN_ASSETS_PER_CAMPAIGN", e[e.BUSINESS_LOGO_CAMPAIGN_ASSETS_PER_CAMPAIGN = 180] = "BUSINESS_LOGO_CAMPAIGN_ASSETS_PER_CAMPAIGN", e[e.VERSIONS_PER_AD = 82] = "VERSIONS_PER_AD", e[e.USER_FEEDS_PER_CUSTOMER = 90] = "USER_FEEDS_PER_CUSTOMER", e[e.SYSTEM_FEEDS_PER_CUSTOMER = 91] = "SYSTEM_FEEDS_PER_CUSTOMER", e[e.FEED_ATTRIBUTES_PER_FEED = 92] = "FEED_ATTRIBUTES_PER_FEED", e[e.FEED_ITEMS_PER_CUSTOMER = 94] = "FEED_ITEMS_PER_CUSTOMER", e[e.CAMPAIGN_FEEDS_PER_CUSTOMER = 95] = "CAMPAIGN_FEEDS_PER_CUSTOMER", e[e.BASE_CAMPAIGN_FEEDS_PER_CUSTOMER = 96] = "BASE_CAMPAIGN_FEEDS_PER_CUSTOMER", e[e.EXPERIMENT_CAMPAIGN_FEEDS_PER_CUSTOMER = 109] = "EXPERIMENT_CAMPAIGN_FEEDS_PER_CUSTOMER", e[e.AD_GROUP_FEEDS_PER_CUSTOMER = 97] = "AD_GROUP_FEEDS_PER_CUSTOMER", e[e.BASE_AD_GROUP_FEEDS_PER_CUSTOMER = 98] = "BASE_AD_GROUP_FEEDS_PER_CUSTOMER", e[e.EXPERIMENT_AD_GROUP_FEEDS_PER_CUSTOMER = 110] = "EXPERIMENT_AD_GROUP_FEEDS_PER_CUSTOMER", e[e.AD_GROUP_FEEDS_PER_CAMPAIGN = 99] = "AD_GROUP_FEEDS_PER_CAMPAIGN", e[e.FEED_ITEM_SETS_PER_CUSTOMER = 100] = "FEED_ITEM_SETS_PER_CUSTOMER", e[e.FEED_ITEMS_PER_FEED_ITEM_SET = 101] = "FEED_ITEMS_PER_FEED_ITEM_SET", e[e.CAMPAIGN_EXPERIMENTS_PER_CUSTOMER = 112] = "CAMPAIGN_EXPERIMENTS_PER_CUSTOMER", e[e.EXPERIMENT_ARMS_PER_VIDEO_EXPERIMENT = 113] = "EXPERIMENT_ARMS_PER_VIDEO_EXPERIMENT", e[e.OWNED_LABELS_PER_CUSTOMER = 115] = "OWNED_LABELS_PER_CUSTOMER", e[e.LABELS_PER_CAMPAIGN = 117] = "LABELS_PER_CAMPAIGN", e[e.LABELS_PER_AD_GROUP = 118] = "LABELS_PER_AD_GROUP", e[e.LABELS_PER_AD_GROUP_AD = 119] = "LABELS_PER_AD_GROUP_AD", e[e.LABELS_PER_AD_GROUP_CRITERION = 120] = "LABELS_PER_AD_GROUP_CRITERION", e[e.TARGET_CUSTOMERS_PER_LABEL = 121] = "TARGET_CUSTOMERS_PER_LABEL", e[e.KEYWORD_PLANS_PER_USER_PER_CUSTOMER = 122] = "KEYWORD_PLANS_PER_USER_PER_CUSTOMER", e[e.KEYWORD_PLAN_AD_GROUP_KEYWORDS_PER_KEYWORD_PLAN = 123] = "KEYWORD_PLAN_AD_GROUP_KEYWORDS_PER_KEYWORD_PLAN", e[e.KEYWORD_PLAN_AD_GROUPS_PER_KEYWORD_PLAN = 124] = "KEYWORD_PLAN_AD_GROUPS_PER_KEYWORD_PLAN", e[e.KEYWORD_PLAN_NEGATIVE_KEYWORDS_PER_KEYWORD_PLAN = 125] = "KEYWORD_PLAN_NEGATIVE_KEYWORDS_PER_KEYWORD_PLAN", e[e.KEYWORD_PLAN_CAMPAIGNS_PER_KEYWORD_PLAN = 126] = "KEYWORD_PLAN_CAMPAIGNS_PER_KEYWORD_PLAN", e[e.CONVERSION_ACTIONS_PER_CUSTOMER = 128] = "CONVERSION_ACTIONS_PER_CUSTOMER", e[e.BATCH_JOB_OPERATIONS_PER_JOB = 130] = "BATCH_JOB_OPERATIONS_PER_JOB", e[e.BATCH_JOBS_PER_CUSTOMER = 131] = "BATCH_JOBS_PER_CUSTOMER", e[e.HOTEL_CHECK_IN_DATE_RANGE_BID_MODIFIERS_PER_AD_GROUP = 132] = "HOTEL_CHECK_IN_DATE_RANGE_BID_MODIFIERS_PER_AD_GROUP", e[e.SHARED_SETS_PER_ACCOUNT_FOR_ACCOUNT_LEVEL_NEGATIVE_KEYWORDS = 177] = "SHARED_SETS_PER_ACCOUNT_FOR_ACCOUNT_LEVEL_NEGATIVE_KEYWORDS", e[e.ACCOUNT_LEVEL_NEGATIVE_KEYWORDS_PER_SHARED_SET = 178] = "ACCOUNT_LEVEL_NEGATIVE_KEYWORDS_PER_SHARED_SET", e[e.ENABLED_ASSET_PER_HOTEL_PROPERTY_ASSET_SET = 181] = "ENABLED_ASSET_PER_HOTEL_PROPERTY_ASSET_SET", e[e.ENABLED_HOTEL_PROPERTY_ASSET_LINKS_PER_ASSET_GROUP = 182] = "ENABLED_HOTEL_PROPERTY_ASSET_LINKS_PER_ASSET_GROUP", e[e.BRANDS_PER_SHARED_SET = 183] = "BRANDS_PER_SHARED_SET", e[e.ENABLED_BRAND_LIST_CRITERIA_PER_CAMPAIGN = 184] = "ENABLED_BRAND_LIST_CRITERIA_PER_CAMPAIGN", e[e.SHARED_SETS_PER_ACCOUNT_FOR_BRAND = 185] = "SHARED_SETS_PER_ACCOUNT_FOR_BRAND", e[e.LOOKALIKE_USER_LISTS_PER_CUSTOMER = 186] = "LOOKALIKE_USER_LISTS_PER_CUSTOMER", e[e.LOGO_CAMPAIGN_ASSETS_PER_CAMPAIGN = 187] = "LOGO_CAMPAIGN_ASSETS_PER_CAMPAIGN", e[e.BUSINESS_MESSAGE_ASSET_LINKS_PER_CUSTOMER = 188] = "BUSINESS_MESSAGE_ASSET_LINKS_PER_CUSTOMER", e[e.WHATSAPP_BUSINESS_MESSAGE_ASSET_LINKS_PER_CAMPAIGN = 189] = "WHATSAPP_BUSINESS_MESSAGE_ASSET_LINKS_PER_CAMPAIGN", e[e.WHATSAPP_BUSINESS_MESSAGE_ASSET_LINKS_PER_AD_GROUP = 190] = "WHATSAPP_BUSINESS_MESSAGE_ASSET_LINKS_PER_AD_GROUP", e[e.BRAND_LIST_CRITERIA_PER_AD_GROUP = 193] = "BRAND_LIST_CRITERIA_PER_AD_GROUP";
  }(t.ResourceLimitType || (t.ResourceLimitType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.RESOURCE_NAME_ONLY = 1] = "RESOURCE_NAME_ONLY", e[e.MUTABLE_RESOURCE = 2] = "MUTABLE_RESOURCE";
  }(t.ResponseContentType || (t.ResponseContentType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CUSTOMER = 2] = "CUSTOMER", e[e.CAMPAIGN = 4] = "CAMPAIGN", e[e.CHANNEL = 5] = "CHANNEL";
  }(t.SeasonalityEventScope || (t.SeasonalityEventScope = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 4] = "REMOVED";
  }(t.SeasonalityEventStatus || (t.SeasonalityEventStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.SENTIMENT_NEUTRAL = 2] = "SENTIMENT_NEUTRAL", e[e.SENTIMENT_POSITIVE = 3] = "SENTIMENT_POSITIVE", e[e.SENTIMENT_NEGATIVE = 4] = "SENTIMENT_NEGATIVE";
  }(t.Sentiment || (t.Sentiment = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.REMOVED = 3] = "REMOVED";
  }(t.SharedSetStatus || (t.SharedSetStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NEGATIVE_KEYWORDS = 2] = "NEGATIVE_KEYWORDS", e[e.NEGATIVE_PLACEMENTS = 3] = "NEGATIVE_PLACEMENTS", e[e.ACCOUNT_LEVEL_NEGATIVE_KEYWORDS = 4] = "ACCOUNT_LEVEL_NEGATIVE_KEYWORDS", e[e.BRANDS = 5] = "BRANDS", e[e.WEBPAGES = 6] = "WEBPAGES", e[e.VERTICAL_ADS_ITEM_GROUP_RULE_LIST = 7] = "VERTICAL_ADS_ITEM_GROUP_RULE_LIST", e[e.RETAIL_FILTER = 32] = "RETAIL_FILTER";
  }(t.SharedSetType || (t.SharedSetType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.MERCHANT_CENTER_ACCOUNT_HAS_NO_SUBMITTED_PRODUCTS = 2] = "MERCHANT_CENTER_ACCOUNT_HAS_NO_SUBMITTED_PRODUCTS", e[e.MERCHANT_CENTER_ACCOUNT_HAS_NO_SUBMITTED_PRODUCTS_IN_FEED = 3] = "MERCHANT_CENTER_ACCOUNT_HAS_NO_SUBMITTED_PRODUCTS_IN_FEED", e[e.ADS_ACCOUNT_EXCLUDES_OFFERS_FROM_CAMPAIGN = 4] = "ADS_ACCOUNT_EXCLUDES_OFFERS_FROM_CAMPAIGN", e[e.ALL_PRODUCTS_ARE_EXCLUDED_FROM_CAMPAIGN = 5] = "ALL_PRODUCTS_ARE_EXCLUDED_FROM_CAMPAIGN";
  }(t.ShoppingAddProductsToCampaignRecommendation || (t.ShoppingAddProductsToCampaignRecommendation = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.UNIFORM = 2] = "UNIFORM", e[e.DEFAULT = 3] = "DEFAULT", e[e.SCALING = 4] = "SCALING";
  }(t.SimulationModificationMethod || (t.SimulationModificationMethod = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CPC_BID = 2] = "CPC_BID", e[e.CPV_BID = 3] = "CPV_BID", e[e.TARGET_CPA = 4] = "TARGET_CPA", e[e.BID_MODIFIER = 5] = "BID_MODIFIER", e[e.TARGET_ROAS = 6] = "TARGET_ROAS", e[e.PERCENT_CPC_BID = 7] = "PERCENT_CPC_BID", e[e.TARGET_IMPRESSION_SHARE = 8] = "TARGET_IMPRESSION_SHARE", e[e.BUDGET = 9] = "BUDGET";
  }(t.SimulationType || (t.SimulationType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ACCOUNT_ISSUE = 2] = "ACCOUNT_ISSUE", e[e.BILLING_ISSUE = 3] = "BILLING_ISSUE", e[e.BUSINESS_PROFILE_LOCATION_REMOVED = 4] = "BUSINESS_PROFILE_LOCATION_REMOVED", e[e.ALL_ADS_DISAPPROVED = 5] = "ALL_ADS_DISAPPROVED";
  }(t.SmartCampaignNotEligibleReason || (t.SmartCampaignNotEligibleReason = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PAUSED = 2] = "PAUSED", e[e.NOT_ELIGIBLE = 3] = "NOT_ELIGIBLE", e[e.PENDING = 4] = "PENDING", e[e.ELIGIBLE = 5] = "ELIGIBLE", e[e.REMOVED = 6] = "REMOVED", e[e.ENDED = 7] = "ENDED";
  }(t.SmartCampaignStatus || (t.SmartCampaignStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.INFINITE = 2] = "INFINITE";
  }(t.SpendingLimitType || (t.SpendingLimitType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NO_SUMMARY_ROW = 2] = "NO_SUMMARY_ROW", e[e.SUMMARY_ROW_WITH_RESULTS = 3] = "SUMMARY_ROW_WITH_RESULTS", e[e.SUMMARY_ROW_ONLY = 4] = "SUMMARY_ROW_ONLY";
  }(t.SummaryRowSetting || (t.SummaryRowSetting = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.APPLY_FOR = 2] = "APPLY_FOR", e[e.APPLY_TO_WORK_FOR = 3] = "APPLY_TO_WORK_FOR", e[e.ATTEND = 4] = "ATTEND", e[e.BOOK = 5] = "BOOK", e[e.BOOK_WITH = 6] = "BOOK_WITH", e[e.BUY = 7] = "BUY", e[e.BUY_CONTENT_FROM = 8] = "BUY_CONTENT_FROM", e[e.BUY_TICKETS_FOR = 9] = "BUY_TICKETS_FOR", e[e.CARE_ABOUT = 10] = "CARE_ABOUT", e[e.CHOOSE = 11] = "CHOOSE", e[e.DONATE_TO = 12] = "DONATE_TO", e[e.DOWNLOAD = 13] = "DOWNLOAD", e[e.DOWNLOAD_FROM = 14] = "DOWNLOAD_FROM", e[e.EAT = 15] = "EAT", e[e.EAT_AT = 16] = "EAT_AT", e[e.HAVE_UNFAVORABLE_OPINION_OF = 17] = "HAVE_UNFAVORABLE_OPINION_OF", e[e.JOIN = 18] = "JOIN", e[e.LEARN = 19] = "LEARN", e[e.LISTEN_TO = 20] = "LISTEN_TO", e[e.NONE = 21] = "NONE", e[e.ORDER_FROM = 22] = "ORDER_FROM", e[e.PARTICIPATE_IN = 23] = "PARTICIPATE_IN", e[e.PLAY = 24] = "PLAY", e[e.PLAY_AT = 25] = "PLAY_AT", e[e.PLAY_ON = 26] = "PLAY_ON", e[e.RENT = 27] = "RENT", e[e.SEE = 28] = "SEE", e[e.SEE_IN_THEATERS = 29] = "SEE_IN_THEATERS", e[e.SHOP = 30] = "SHOP", e[e.SIGN_UP_FOR = 31] = "SIGN_UP_FOR", e[e.SUBSCRIBE_TO = 32] = "SUBSCRIBE_TO", e[e.TAKE_ACTION_ON = 33] = "TAKE_ACTION_ON", e[e.USE = 34] = "USE", e[e.VISIT = 35] = "VISIT", e[e.VOTE_FOR = 36] = "VOTE_FOR", e[e.WATCH = 37] = "WATCH", e[e.WATCH_IN_THEATERS = 38] = "WATCH_IN_THEATERS";
  }(t.SurveyIntendedAction || (t.SurveyIntendedAction = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.STANDARD = 2] = "STANDARD", e[e.BOOST = 3] = "BOOST";
  }(t.SurveyLiftFlightTargetResponseMode || (t.SurveyLiftFlightTargetResponseMode = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.GENERIC_BRAND = 2] = "GENERIC_BRAND", e[e.GENERIC_PRODUCT = 3] = "GENERIC_PRODUCT", e[e.GENERIC_SERVICE = 4] = "GENERIC_SERVICE", e[e.APP = 5] = "APP", e[e.APPS_DATING_SERVICES = 6] = "APPS_DATING_SERVICES", e[e.APPS_PODCASTS = 7] = "APPS_PODCASTS", e[e.APPS_DIGITAL_COMICS = 8] = "APPS_DIGITAL_COMICS", e[e.AUTOMOTIVE_BATTERY = 9] = "AUTOMOTIVE_BATTERY", e[e.AUTOMOTIVE_BRAND = 10] = "AUTOMOTIVE_BRAND", e[e.AUTOMOTIVE_CAR_RENTAL = 11] = "AUTOMOTIVE_CAR_RENTAL", e[e.AUTOMOTIVE_CAR_SERVICE = 12] = "AUTOMOTIVE_CAR_SERVICE", e[e.AUTOMOTIVE_ELECTRIC_CAR_BRAND = 13] = "AUTOMOTIVE_ELECTRIC_CAR_BRAND", e[e.AUTOMOTIVE_GAS_STATIONS = 14] = "AUTOMOTIVE_GAS_STATIONS", e[e.AUTOMOTIVE_MOTORCYCLE = 15] = "AUTOMOTIVE_MOTORCYCLE", e[e.AUTOMOTIVE_OIL = 16] = "AUTOMOTIVE_OIL", e[e.AUTOMOTIVE_PRODUCT = 17] = "AUTOMOTIVE_PRODUCT", e[e.AUTOMOTIVE_TIRES_BRAND = 18] = "AUTOMOTIVE_TIRES_BRAND", e[e.BIM_COMPANY = 19] = "BIM_COMPANY", e[e.BIM_ENTERPRISE_SERVICES_COMPANY = 20] = "BIM_ENTERPRISE_SERVICES_COMPANY", e[e.BIM_JOB = 21] = "BIM_JOB", e[e.BIM_MARKETING_COMPANY = 22] = "BIM_MARKETING_COMPANY", e[e.BIM_RECRUITING = 23] = "BIM_RECRUITING", e[e.BIM_SHIPPING = 24] = "BIM_SHIPPING", e[e.CPG_BABY_CARE_BRAND = 25] = "CPG_BABY_CARE_BRAND", e[e.CPG_BABY_CARE_PRODUCT = 26] = "CPG_BABY_CARE_PRODUCT", e[e.CPG_BEAUTY_BRAND = 27] = "CPG_BEAUTY_BRAND", e[e.CPG_BEAUTY_PRODUCT = 28] = "CPG_BEAUTY_PRODUCT", e[e.CPG_BEAUTY_AND_PERSONAL_CARE_BRAND = 29] = "CPG_BEAUTY_AND_PERSONAL_CARE_BRAND", e[e.CPG_BEAUTY_AND_PERSONAL_CARE_PRODUCT = 30] = "CPG_BEAUTY_AND_PERSONAL_CARE_PRODUCT", e[e.CPG_BODY_WASH_BRAND = 31] = "CPG_BODY_WASH_BRAND", e[e.CPG_BODY_WASH_PRODUCT = 32] = "CPG_BODY_WASH_PRODUCT", e[e.CPG_DRAIN_CLEANERS = 33] = "CPG_DRAIN_CLEANERS", e[e.CPG_FRAGRANCE_BRAND = 34] = "CPG_FRAGRANCE_BRAND", e[e.CPG_FRAGRANCE_PRODUCT = 35] = "CPG_FRAGRANCE_PRODUCT", e[e.CPG_HAIR_CARE_BRAND = 36] = "CPG_HAIR_CARE_BRAND", e[e.CPG_HAIR_CARE_PRODUCT = 37] = "CPG_HAIR_CARE_PRODUCT", e[e.CPG_HOUSEHOLD_CLEANING_BRAND = 38] = "CPG_HOUSEHOLD_CLEANING_BRAND", e[e.CPG_HOUSEHOLD_CLEANING_PRODUCT = 39] = "CPG_HOUSEHOLD_CLEANING_PRODUCT", e[e.CPG_LAUNDRY_BRAND = 40] = "CPG_LAUNDRY_BRAND", e[e.CPG_MAKE_UP_BRAND = 41] = "CPG_MAKE_UP_BRAND", e[e.CPG_MAKE_UP_PRODUCT = 42] = "CPG_MAKE_UP_PRODUCT", e[e.CPG_MOUTHWASH_BRAND = 43] = "CPG_MOUTHWASH_BRAND", e[e.CPG_OFFICE_SUPPLIES_BRAND = 44] = "CPG_OFFICE_SUPPLIES_BRAND", e[e.CPG_OFFICE_SUPPLIES_PRODUCT = 45] = "CPG_OFFICE_SUPPLIES_PRODUCT", e[e.CPG_ORAL_CARE_BRAND = 46] = "CPG_ORAL_CARE_BRAND", e[e.CPG_PERSONAL_CARE_BRAND = 47] = "CPG_PERSONAL_CARE_BRAND", e[e.CPG_PERSONAL_CARE_PRODUCT = 48] = "CPG_PERSONAL_CARE_PRODUCT", e[e.CPG_SKIN_CARE_BRAND = 49] = "CPG_SKIN_CARE_BRAND", e[e.CPG_SKIN_CARE_PRODUCT = 50] = "CPG_SKIN_CARE_PRODUCT", e[e.EDUCATION_BUSINESS_PROGRAMS = 51] = "EDUCATION_BUSINESS_PROGRAMS", e[e.EDUCATION_MASTERS_PROGRAMS = 52] = "EDUCATION_MASTERS_PROGRAMS", e[e.EDUCATION_NURSING_PROGRAMS = 53] = "EDUCATION_NURSING_PROGRAMS", e[e.EDUCATION_IT_PROGRAMS = 54] = "EDUCATION_IT_PROGRAMS", e[e.EDUCATION_OFFLINE = 55] = "EDUCATION_OFFLINE", e[e.EDUCATION_ONLINE = 56] = "EDUCATION_ONLINE", e[e.EDUCATION_PROGRAM = 57] = "EDUCATION_PROGRAM", e[e.EDUCATION_TEST_PREPARATION = 58] = "EDUCATION_TEST_PREPARATION", e[e.FBR_BEER_BRAND = 59] = "FBR_BEER_BRAND", e[e.FBR_BEVERAGE_BRAND = 60] = "FBR_BEVERAGE_BRAND", e[e.FBR_BEVERAGE_PRODUCT = 61] = "FBR_BEVERAGE_PRODUCT", e[e.FBR_BREAKFAST_FOOD_BRAND = 62] = "FBR_BREAKFAST_FOOD_BRAND", e[e.FBR_BREAKFAST_FOOD_PRODUCT = 63] = "FBR_BREAKFAST_FOOD_PRODUCT", e[e.FBR_CANDY = 64] = "FBR_CANDY", e[e.FBR_CHEESE = 65] = "FBR_CHEESE", e[e.FBR_CHIPS_BRAND = 66] = "FBR_CHIPS_BRAND", e[e.FBR_CHIPS_PRODUCT = 67] = "FBR_CHIPS_PRODUCT", e[e.FBR_CHOCOLATE_BRAND = 68] = "FBR_CHOCOLATE_BRAND", e[e.FBR_CHOCOLATE_PRODUCT = 69] = "FBR_CHOCOLATE_PRODUCT", e[e.FBR_COFFEE_BRAND = 70] = "FBR_COFFEE_BRAND", e[e.FBR_COFFEE_PRODUCT = 71] = "FBR_COFFEE_PRODUCT", e[e.FBR_COLD_DRINK_BRAND = 72] = "FBR_COLD_DRINK_BRAND", e[e.FBR_COLD_DRINK_PRODUCT = 73] = "FBR_COLD_DRINK_PRODUCT", e[e.FBR_COOKIES = 74] = "FBR_COOKIES", e[e.FBR_DOGFOOD_BRAND = 75] = "FBR_DOGFOOD_BRAND", e[e.FBR_DOGFOOD_PRODUCT = 76] = "FBR_DOGFOOD_PRODUCT", e[e.FBR_DOG_TREATS_BRAND = 77] = "FBR_DOG_TREATS_BRAND", e[e.FBR_FOOD_BRAND = 78] = "FBR_FOOD_BRAND", e[e.FBR_FOOD_DELIVERY_BRAND = 79] = "FBR_FOOD_DELIVERY_BRAND", e[e.FBR_FOOD_PRODUCT = 80] = "FBR_FOOD_PRODUCT", e[e.FBR_ICE_CREAM_BRAND = 81] = "FBR_ICE_CREAM_BRAND", e[e.FBR_ICE_CREAM_PRODUCT = 82] = "FBR_ICE_CREAM_PRODUCT", e[e.FBR_PET_FOOD_BRAND = 83] = "FBR_PET_FOOD_BRAND", e[e.FBR_PET_FOOD_PRODUCT = 84] = "FBR_PET_FOOD_PRODUCT", e[e.FBR_PET_SUPPLY_BRAND = 85] = "FBR_PET_SUPPLY_BRAND", e[e.FBR_PET_SUPPLY_PRODUCT = 86] = "FBR_PET_SUPPLY_PRODUCT", e[e.FBR_RESTAURANT = 87] = "FBR_RESTAURANT", e[e.FBR_RESTAURANT_DELIVERY_SERVICE_BRAND = 88] = "FBR_RESTAURANT_DELIVERY_SERVICE_BRAND", e[e.FBR_RESTAURANT_DELIVERY_SERVICE_PRODUCT = 89] = "FBR_RESTAURANT_DELIVERY_SERVICE_PRODUCT", e[e.FBR_SNACKS_BRAND = 90] = "FBR_SNACKS_BRAND", e[e.FBR_SNACKS_PRODUCT = 91] = "FBR_SNACKS_PRODUCT", e[e.FBR_SODA_BRAND = 92] = "FBR_SODA_BRAND", e[e.FBR_SODA_PRODUCT = 93] = "FBR_SODA_PRODUCT", e[e.FBR_SPIRIT_BRAND = 94] = "FBR_SPIRIT_BRAND", e[e.FBR_SPIRIT_PRODUCT = 95] = "FBR_SPIRIT_PRODUCT", e[e.FBR_WHEY_PROTEIN_BRAND = 96] = "FBR_WHEY_PROTEIN_BRAND", e[e.FBR_WINE = 97] = "FBR_WINE", e[e.FINANCE_ACCOUNTING_BRAND = 98] = "FINANCE_ACCOUNTING_BRAND", e[e.FINANCE_BANK = 99] = "FINANCE_BANK", e[e.FINANCE_CREDIT_CARD_BRAND = 100] = "FINANCE_CREDIT_CARD_BRAND", e[e.FINANCE_CREDIT_CARD_PRODUCT = 101] = "FINANCE_CREDIT_CARD_PRODUCT", e[e.FINANCE_FINANCIAL_SERVICES = 102] = "FINANCE_FINANCIAL_SERVICES", e[e.FINANCE_INSURANCE = 103] = "FINANCE_INSURANCE", e[e.FINANCE_INVESTMENT_SERVICES = 104] = "FINANCE_INVESTMENT_SERVICES", e[e.FINANCE_LOAN_PROVIDER = 105] = "FINANCE_LOAN_PROVIDER", e[e.FINANCE_MORTGAGE_COMPANY = 106] = "FINANCE_MORTGAGE_COMPANY", e[e.FINANCE_PAYMENTS_PROCESSING = 107] = "FINANCE_PAYMENTS_PROCESSING", e[e.FINANCE_PAYMENTS_SYSTEMS = 108] = "FINANCE_PAYMENTS_SYSTEMS", e[e.FINANCE_TAXES_BRAND = 109] = "FINANCE_TAXES_BRAND", e[e.FINANCE_TAXES_PRODUCT = 110] = "FINANCE_TAXES_PRODUCT", e[e.GAMBLING_CASINO = 111] = "GAMBLING_CASINO", e[e.GAMBLING_DAILY_FANTASY_SPORT = 112] = "GAMBLING_DAILY_FANTASY_SPORT", e[e.GAMBLING_GAMBLING_SITE = 113] = "GAMBLING_GAMBLING_SITE", e[e.GAMBLING_LOTTERY = 114] = "GAMBLING_LOTTERY", e[e.GAMBLING_SPORTS_BETTING_SITE = 115] = "GAMBLING_SPORTS_BETTING_SITE", e[e.GOVERNMENT_ANTI_SMOKING = 116] = "GOVERNMENT_ANTI_SMOKING", e[e.GOVERNMENT_MILITARY = 117] = "GOVERNMENT_MILITARY", e[e.GOVERNMENT_ORGANIZATION = 118] = "GOVERNMENT_ORGANIZATION", e[e.GOVERNMENT_PROGRAM = 119] = "GOVERNMENT_PROGRAM", e[e.GOVERNMENT_PUBLIC_HEALTH_BEHAVIORS = 120] = "GOVERNMENT_PUBLIC_HEALTH_BEHAVIORS", e[e.GOVERNMENT_PUBLIC_HEALTH_ISSUE = 121] = "GOVERNMENT_PUBLIC_HEALTH_ISSUE", e[e.GOVERNMENT_PUBLIC_HEALTH_TOPIC = 122] = "GOVERNMENT_PUBLIC_HEALTH_TOPIC", e[e.GOVERNMENT_SERVICE = 123] = "GOVERNMENT_SERVICE", e[e.HEALTHCARE_GYMS = 124] = "HEALTHCARE_GYMS", e[e.HEALTHCARE_HEALTH_INSURANCE_BRAND = 125] = "HEALTHCARE_HEALTH_INSURANCE_BRAND", e[e.HEALTHCARE_MULTIVITAMINS = 126] = "HEALTHCARE_MULTIVITAMINS", e[e.HEALTHCARE_SPORTS_SUPPLEMENTS = 127] = "HEALTHCARE_SPORTS_SUPPLEMENTS", e[e.HEALTHCARE_WEIGHT_LOSS_BRAND = 128] = "HEALTHCARE_WEIGHT_LOSS_BRAND", e[e.HEALTHCARE_WEIGHT_LOSS_PRODUCT = 129] = "HEALTHCARE_WEIGHT_LOSS_PRODUCT", e[e.HOME_SERVICES_CABLE_TV = 130] = "HOME_SERVICES_CABLE_TV", e[e.HOME_SERVICES_ENERGY_BRAND = 131] = "HOME_SERVICES_ENERGY_BRAND", e[e.HOME_SERVICES_HOUSEHOLD_SERVICES_COMPANY = 132] = "HOME_SERVICES_HOUSEHOLD_SERVICES_COMPANY", e[e.HOME_SERVICES_INTERNET_SERVICE = 133] = "HOME_SERVICES_INTERNET_SERVICE", e[e.HOME_SERVICES_MOBILE_PHONE = 134] = "HOME_SERVICES_MOBILE_PHONE", e[e.HOME_SERVICES_PAY_TV_CHANNEL = 135] = "HOME_SERVICES_PAY_TV_CHANNEL", e[e.HOME_SERVICES_PAY_TV_NETWORK = 136] = "HOME_SERVICES_PAY_TV_NETWORK", e[e.LOCAL_CHARITY = 137] = "LOCAL_CHARITY", e[e.LOCAL_CLASSIFIEDS_SITE = 138] = "LOCAL_CLASSIFIEDS_SITE", e[e.LOCAL_FLOWER_BRAND = 139] = "LOCAL_FLOWER_BRAND", e[e.LOCAL_JOB_CLASSIFIEDS_SITE = 140] = "LOCAL_JOB_CLASSIFIEDS_SITE", e[e.LOCAL_LAW_FIRMS = 141] = "LOCAL_LAW_FIRMS", e[e.LOCAL_REAL_ESTATE_SITE = 142] = "LOCAL_REAL_ESTATE_SITE", e[e.MEDIA_AND_ENTERTAINMENT_DOWNLOAD_SITE = 143] = "MEDIA_AND_ENTERTAINMENT_DOWNLOAD_SITE", e[e.MEDIA_AND_ENTERTAINMENT_DVD = 144] = "MEDIA_AND_ENTERTAINMENT_DVD", e[e.MEDIA_AND_ENTERTAINMENT_EVENT = 145] = "MEDIA_AND_ENTERTAINMENT_EVENT", e[e.MEDIA_AND_ENTERTAINMENT_GAME = 146] = "MEDIA_AND_ENTERTAINMENT_GAME", e[e.MEDIA_AND_ENTERTAINMENT_GAMING_PRODUCTS = 147] = "MEDIA_AND_ENTERTAINMENT_GAMING_PRODUCTS", e[e.MEDIA_AND_ENTERTAINMENT_LIVE_EVENT = 148] = "MEDIA_AND_ENTERTAINMENT_LIVE_EVENT", e[e.MEDIA_AND_ENTERTAINMENT_MOBILE_GAME = 149] = "MEDIA_AND_ENTERTAINMENT_MOBILE_GAME", e[e.MEDIA_AND_ENTERTAINMENT_MOVIE = 150] = "MEDIA_AND_ENTERTAINMENT_MOVIE", e[e.MEDIA_AND_ENTERTAINMENT_MOVIE_DIGITAL_DOWNLOAD = 151] = "MEDIA_AND_ENTERTAINMENT_MOVIE_DIGITAL_DOWNLOAD", e[e.MEDIA_AND_ENTERTAINMENT_MUSIC_ARTIST = 152] = "MEDIA_AND_ENTERTAINMENT_MUSIC_ARTIST", e[e.MEDIA_AND_ENTERTAINMENT_MUSIC_RELEASES = 153] = "MEDIA_AND_ENTERTAINMENT_MUSIC_RELEASES", e[e.MEDIA_AND_ENTERTAINMENT_PLAYLISTS = 154] = "MEDIA_AND_ENTERTAINMENT_PLAYLISTS", e[e.MEDIA_AND_ENTERTAINMENT_SHOW = 155] = "MEDIA_AND_ENTERTAINMENT_SHOW", e[e.MEDIA_AND_ENTERTAINMENT_SHOW_DIGITAL_DOWNLOAD = 156] = "MEDIA_AND_ENTERTAINMENT_SHOW_DIGITAL_DOWNLOAD", e[e.MEDIA_AND_ENTERTAINMENT_SPORTS = 157] = "MEDIA_AND_ENTERTAINMENT_SPORTS", e[e.MEDIA_AND_ENTERTAINMENT_STREAMING_SITE = 158] = "MEDIA_AND_ENTERTAINMENT_STREAMING_SITE", e[e.MEDIA_AND_ENTERTAINMENT_TITLE_DIGITAL_DOWNLOAD = 159] = "MEDIA_AND_ENTERTAINMENT_TITLE_DIGITAL_DOWNLOAD", e[e.MEDIA_AND_ENTERTAINMENT_TV_CHANNEL = 160] = "MEDIA_AND_ENTERTAINMENT_TV_CHANNEL", e[e.MEDIA_AND_ENTERTAINMENT_TV_SHOW = 161] = "MEDIA_AND_ENTERTAINMENT_TV_SHOW", e[e.MEDIA_AND_ENTERTAINMENT_TV_SHOW_DIGITAL_DOWNLOAD = 162] = "MEDIA_AND_ENTERTAINMENT_TV_SHOW_DIGITAL_DOWNLOAD", e[e.MEDIA_AND_ENTERTAINMENT_VIDEO_GAME = 163] = "MEDIA_AND_ENTERTAINMENT_VIDEO_GAME", e[e.MEDIA_AND_ENTERTAINMENT_VIDEO_GAME_DLC = 164] = "MEDIA_AND_ENTERTAINMENT_VIDEO_GAME_DLC", e[e.MEDIA_AND_ENTERTAINMENT_WEB_SERIES = 165] = "MEDIA_AND_ENTERTAINMENT_WEB_SERIES", e[e.OFFER = 166] = "OFFER", e[e.PHARMA_NON_MEDICAL_CONDITION_OTC_DRUG = 167] = "PHARMA_NON_MEDICAL_CONDITION_OTC_DRUG", e[e.POLITICS_CANDIDATE = 168] = "POLITICS_CANDIDATE", e[e.POLITICS_GET_OUT_THE_VOTE_NOVEMBER_ELECTIONS = 169] = "POLITICS_GET_OUT_THE_VOTE_NOVEMBER_ELECTIONS", e[e.POLITICS_GET_OUT_THE_VOTE_PRIMARY_ELECTIONS = 170] = "POLITICS_GET_OUT_THE_VOTE_PRIMARY_ELECTIONS", e[e.POLITICS_ISSUE = 171] = "POLITICS_ISSUE", e[e.POLITICS_UNFAVORABLE_CANDIDATE = 172] = "POLITICS_UNFAVORABLE_CANDIDATE", e[e.RETAIL_APPAREL = 173] = "RETAIL_APPAREL", e[e.RETAIL_BRICK_AND_MORTAR = 174] = "RETAIL_BRICK_AND_MORTAR", e[e.RETAIL_FURNITURE_BRAND = 175] = "RETAIL_FURNITURE_BRAND", e[e.RETAIL_FURNITURE_PRODUCT = 176] = "RETAIL_FURNITURE_PRODUCT", e[e.RETAIL_GIFTS_BRAND = 177] = "RETAIL_GIFTS_BRAND", e[e.RETAIL_GIFTS_PRODUCT = 178] = "RETAIL_GIFTS_PRODUCT", e[e.RETAIL_HOME_GOODS = 179] = "RETAIL_HOME_GOODS", e[e.RETAIL_JEWELRY_BRAND = 180] = "RETAIL_JEWELRY_BRAND", e[e.RETAIL_ONLINE_RETAILERS = 181] = "RETAIL_ONLINE_RETAILERS", e[e.RETAIL_SHOE_BRAND = 182] = "RETAIL_SHOE_BRAND", e[e.RETAIL_STORE = 183] = "RETAIL_STORE", e[e.RETAIL_TOY_SHOP = 184] = "RETAIL_TOY_SHOP", e[e.TECHNOLOGY_ARTIFICIAL_INTELLIGENCE_BRAND = 185] = "TECHNOLOGY_ARTIFICIAL_INTELLIGENCE_BRAND", e[e.TECHNOLOGY_ARTIFICIAL_INTELLIGENCE_PRODUCT = 186] = "TECHNOLOGY_ARTIFICIAL_INTELLIGENCE_PRODUCT", e[e.TECHNOLOGY_BRAND = 187] = "TECHNOLOGY_BRAND", e[e.TECHNOLOGY_FEATURE = 188] = "TECHNOLOGY_FEATURE", e[e.TECHNOLOGY_PRODUCT = 189] = "TECHNOLOGY_PRODUCT", e[e.TECHNOLOGY_CAMERA_BRAND = 190] = "TECHNOLOGY_CAMERA_BRAND", e[e.TECHNOLOGY_CAMERA_PRODUCT = 191] = "TECHNOLOGY_CAMERA_PRODUCT", e[e.TECHNOLOGY_CONTROL_PLANS = 192] = "TECHNOLOGY_CONTROL_PLANS", e[e.TECHNOLOGY_GAMING_BRAND = 193] = "TECHNOLOGY_GAMING_BRAND", e[e.TECHNOLOGY_HOME_APPLIANCE_BRAND = 194] = "TECHNOLOGY_HOME_APPLIANCE_BRAND", e[e.TECHNOLOGY_HOME_APPLIANCE_PRODUCT = 195] = "TECHNOLOGY_HOME_APPLIANCE_PRODUCT", e[e.TECHNOLOGY_LAPTOP_BRAND = 196] = "TECHNOLOGY_LAPTOP_BRAND", e[e.TECHNOLOGY_LAPTOP_PRODUCT = 197] = "TECHNOLOGY_LAPTOP_PRODUCT", e[e.TECHNOLOGY_MOBILE_PHONE_PLANS = 198] = "TECHNOLOGY_MOBILE_PHONE_PLANS", e[e.TECHNOLOGY_ONLINE_SAFETY_BRAND = 199] = "TECHNOLOGY_ONLINE_SAFETY_BRAND", e[e.TECHNOLOGY_ONLINE_SAFETY_PRODUCT = 200] = "TECHNOLOGY_ONLINE_SAFETY_PRODUCT", e[e.TECHNOLOGY_OPERATING_SYSTEM = 201] = "TECHNOLOGY_OPERATING_SYSTEM", e[e.TECHNOLOGY_POSTPAID_TELCO_PLAN = 202] = "TECHNOLOGY_POSTPAID_TELCO_PLAN", e[e.TECHNOLOGY_PREPAID_TELCO_PLAN = 203] = "TECHNOLOGY_PREPAID_TELCO_PLAN", e[e.TECHNOLOGY_PRINTER_BRAND = 204] = "TECHNOLOGY_PRINTER_BRAND", e[e.TECHNOLOGY_SEARCH_ENGINE = 205] = "TECHNOLOGY_SEARCH_ENGINE", e[e.TECHNOLOGY_SMALL_HOME_APPLIANCE_BRAND = 206] = "TECHNOLOGY_SMALL_HOME_APPLIANCE_BRAND", e[e.TECHNOLOGY_SMALL_HOME_APPLIANCE_PRODUCT = 207] = "TECHNOLOGY_SMALL_HOME_APPLIANCE_PRODUCT", e[e.TECHNOLOGY_SMART_HOME_DEVICE = 208] = "TECHNOLOGY_SMART_HOME_DEVICE", e[e.TECHNOLOGY_SMARTPHONE_BRAND = 209] = "TECHNOLOGY_SMARTPHONE_BRAND", e[e.TECHNOLOGY_SMARTPHONE_PRODUCT = 210] = "TECHNOLOGY_SMARTPHONE_PRODUCT", e[e.TECHNOLOGY_SOCIAL_MEDIA = 211] = "TECHNOLOGY_SOCIAL_MEDIA", e[e.TECHNOLOGY_TABLET_BRAND = 212] = "TECHNOLOGY_TABLET_BRAND", e[e.TECHNOLOGY_TABLET_PRODUCT = 213] = "TECHNOLOGY_TABLET_PRODUCT", e[e.TECHNOLOGY_TELECOM_FIBER_OPTIC_INTERNET = 214] = "TECHNOLOGY_TELECOM_FIBER_OPTIC_INTERNET", e[e.TECHNOLOGY_TELECOM_SERVICE_PACK = 215] = "TECHNOLOGY_TELECOM_SERVICE_PACK", e[e.TECHNOLOGY_TELCO_NETWORK = 216] = "TECHNOLOGY_TELCO_NETWORK", e[e.TECHNOLOGY_TV_BRAND = 217] = "TECHNOLOGY_TV_BRAND", e[e.TECHNOLOGY_TV_PRODUCT = 218] = "TECHNOLOGY_TV_PRODUCT", e[e.TECHNOLOGY_VIDEO_ON_DEMAND = 219] = "TECHNOLOGY_VIDEO_ON_DEMAND", e[e.TECHNOLOGY_WEARABLES_BRAND = 220] = "TECHNOLOGY_WEARABLES_BRAND", e[e.TECHNOLOGY_WEBSITE = 221] = "TECHNOLOGY_WEBSITE", e[e.TRAVEL_ACCOMMODATIONS = 222] = "TRAVEL_ACCOMMODATIONS", e[e.TRAVEL_AIRLINE = 223] = "TRAVEL_AIRLINE", e[e.TRAVEL_BOOKING_SERVICE = 224] = "TRAVEL_BOOKING_SERVICE", e[e.TRAVEL_CRUISES = 225] = "TRAVEL_CRUISES", e[e.TRAVEL_DESTINATION = 226] = "TRAVEL_DESTINATION", e[e.TRAVEL_HOTEL = 227] = "TRAVEL_HOTEL", e[e.TRAVEL_OPTION = 228] = "TRAVEL_OPTION", e[e.TRAVEL_VACATION_RENTAL_SERVICE = 229] = "TRAVEL_VACATION_RENTAL_SERVICE";
  }(t.SurveySubjectType || (t.SurveySubjectType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AD_VARIATIONS = 2] = "AD_VARIATIONS";
  }(t.SystemManagedResourceSource || (t.SystemManagedResourceSource = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.SAME_COST = 2] = "SAME_COST", e[e.SAME_CONVERSIONS = 3] = "SAME_CONVERSIONS", e[e.SAME_CPA = 4] = "SAME_CPA", e[e.CLOSEST_CPA = 5] = "CLOSEST_CPA";
  }(t.TargetCpaOptInRecommendationGoal || (t.TargetCpaOptInRecommendationGoal = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NOW = 2] = "NOW", e[e.FOREVER = 3] = "FOREVER";
  }(t.TimeType || (t.TimeType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CLICKS = 2] = "CLICKS", e[e.IMPRESSIONS = 3] = "IMPRESSIONS", e[e.ACQUISITIONS = 4] = "ACQUISITIONS", e[e.PHONE_CALLS = 5] = "PHONE_CALLS", e[e.VIDEO_PLAYS = 6] = "VIDEO_PLAYS", e[e.DAYS = 7] = "DAYS", e[e.AUDIO_PLAYS = 8] = "AUDIO_PLAYS", e[e.ENGAGEMENTS = 9] = "ENGAGEMENTS", e[e.SECONDS = 10] = "SECONDS", e[e.LEADS = 11] = "LEADS", e[e.GUEST_STAYS = 12] = "GUEST_STAYS", e[e.HOURS = 13] = "HOURS";
  }(t.UnitOfMeasure || (t.UnitOfMeasure = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.AFFINITY = 2] = "AFFINITY", e[e.IN_MARKET = 3] = "IN_MARKET", e[e.MOBILE_APP_INSTALL_USER = 4] = "MOBILE_APP_INSTALL_USER", e[e.VERTICAL_GEO = 5] = "VERTICAL_GEO", e[e.NEW_SMART_PHONE_USER = 6] = "NEW_SMART_PHONE_USER";
  }(t.UserInterestTaxonomyType || (t.UserInterestTaxonomyType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ENABLED = 2] = "ENABLED", e[e.DISABLED = 3] = "DISABLED";
  }(t.UserListAccessStatus || (t.UserListAccessStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.UNUSED = 2] = "UNUSED";
  }(t.UserListClosingReason || (t.UserListClosingReason = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ALL_CUSTOMERS = 2] = "ALL_CUSTOMERS", e[e.PURCHASERS = 3] = "PURCHASERS", e[e.HIGH_VALUE_CUSTOMERS = 4] = "HIGH_VALUE_CUSTOMERS", e[e.DISENGAGED_CUSTOMERS = 5] = "DISENGAGED_CUSTOMERS", e[e.QUALIFIED_LEADS = 6] = "QUALIFIED_LEADS", e[e.CONVERTED_LEADS = 7] = "CONVERTED_LEADS", e[e.PAID_SUBSCRIBERS = 8] = "PAID_SUBSCRIBERS", e[e.CART_ABANDONERS = 10] = "CART_ABANDONERS", e[e.LOYALTY_TIER_1_MEMBERS = 11] = "LOYALTY_TIER_1_MEMBERS", e[e.LOYALTY_TIER_2_MEMBERS = 12] = "LOYALTY_TIER_2_MEMBERS", e[e.LOYALTY_TIER_3_MEMBERS = 13] = "LOYALTY_TIER_3_MEMBERS", e[e.LOYALTY_TIER_4_MEMBERS = 14] = "LOYALTY_TIER_4_MEMBERS", e[e.LOYALTY_TIER_5_MEMBERS = 15] = "LOYALTY_TIER_5_MEMBERS", e[e.LOYALTY_TIER_6_MEMBERS = 16] = "LOYALTY_TIER_6_MEMBERS", e[e.LOYALTY_TIER_7_MEMBERS = 17] = "LOYALTY_TIER_7_MEMBERS";
  }(t.UserListCustomerTypeCategory || (t.UserListCustomerTypeCategory = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.OPEN = 2] = "OPEN", e[e.CLOSED = 3] = "CLOSED";
  }(t.UserListMembershipStatus || (t.UserListMembershipStatus = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.LESS_THAN_FIVE_HUNDRED = 2] = "LESS_THAN_FIVE_HUNDRED", e[e.LESS_THAN_ONE_THOUSAND = 3] = "LESS_THAN_ONE_THOUSAND", e[e.ONE_THOUSAND_TO_TEN_THOUSAND = 4] = "ONE_THOUSAND_TO_TEN_THOUSAND", e[e.TEN_THOUSAND_TO_FIFTY_THOUSAND = 5] = "TEN_THOUSAND_TO_FIFTY_THOUSAND", e[e.FIFTY_THOUSAND_TO_ONE_HUNDRED_THOUSAND = 6] = "FIFTY_THOUSAND_TO_ONE_HUNDRED_THOUSAND", e[e.ONE_HUNDRED_THOUSAND_TO_THREE_HUNDRED_THOUSAND = 7] = "ONE_HUNDRED_THOUSAND_TO_THREE_HUNDRED_THOUSAND", e[e.THREE_HUNDRED_THOUSAND_TO_FIVE_HUNDRED_THOUSAND = 8] = "THREE_HUNDRED_THOUSAND_TO_FIVE_HUNDRED_THOUSAND", e[e.FIVE_HUNDRED_THOUSAND_TO_ONE_MILLION = 9] = "FIVE_HUNDRED_THOUSAND_TO_ONE_MILLION", e[e.ONE_MILLION_TO_TWO_MILLION = 10] = "ONE_MILLION_TO_TWO_MILLION", e[e.TWO_MILLION_TO_THREE_MILLION = 11] = "TWO_MILLION_TO_THREE_MILLION", e[e.THREE_MILLION_TO_FIVE_MILLION = 12] = "THREE_MILLION_TO_FIVE_MILLION", e[e.FIVE_MILLION_TO_TEN_MILLION = 13] = "FIVE_MILLION_TO_TEN_MILLION", e[e.TEN_MILLION_TO_TWENTY_MILLION = 14] = "TEN_MILLION_TO_TWENTY_MILLION", e[e.TWENTY_MILLION_TO_THIRTY_MILLION = 15] = "TWENTY_MILLION_TO_THIRTY_MILLION", e[e.THIRTY_MILLION_TO_FIFTY_MILLION = 16] = "THIRTY_MILLION_TO_FIFTY_MILLION", e[e.OVER_FIFTY_MILLION = 17] = "OVER_FIFTY_MILLION";
  }(t.UserListSizeRange || (t.UserListSizeRange = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.MOBILE = 2] = "MOBILE", e[e.DESKTOP = 3] = "DESKTOP", e[e.TABLET = 4] = "TABLET";
  }(t.ValueRuleDeviceType || (t.ValueRuleDeviceType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ANY = 2] = "ANY", e[e.LOCATION_OF_PRESENCE = 3] = "LOCATION_OF_PRESENCE";
  }(t.ValueRuleGeoLocationMatchType || (t.ValueRuleGeoLocationMatchType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ADD = 2] = "ADD", e[e.MULTIPLY = 3] = "MULTIPLY", e[e.SET = 4] = "SET";
  }(t.ValueRuleOperation || (t.ValueRuleOperation = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.CUSTOMER = 2] = "CUSTOMER", e[e.CAMPAIGN = 3] = "CAMPAIGN";
  }(t.ValueRuleSetAttachmentType || (t.ValueRuleSetAttachmentType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.GEO_LOCATION = 2] = "GEO_LOCATION", e[e.DEVICE = 3] = "DEVICE", e[e.AUDIENCE = 4] = "AUDIENCE", e[e.NO_CONDITION = 5] = "NO_CONDITION", e[e.ITINERARY = 6] = "ITINERARY";
  }(t.ValueRuleSetDimension || (t.ValueRuleSetDimension = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.MANUFACTURER_WEBSITE_URL = 2] = "MANUFACTURER_WEBSITE_URL", e[e.WEBSITE_DESCRIPTION = 3] = "WEBSITE_DESCRIPTION";
  }(t.VanityPharmaDisplayUrlMode || (t.VanityPharmaDisplayUrlMode = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PRESCRIPTION_TREATMENT_WEBSITE_EN = 2] = "PRESCRIPTION_TREATMENT_WEBSITE_EN", e[e.PRESCRIPTION_TREATMENT_WEBSITE_ES = 3] = "PRESCRIPTION_TREATMENT_WEBSITE_ES", e[e.PRESCRIPTION_DEVICE_WEBSITE_EN = 4] = "PRESCRIPTION_DEVICE_WEBSITE_EN", e[e.PRESCRIPTION_DEVICE_WEBSITE_ES = 5] = "PRESCRIPTION_DEVICE_WEBSITE_ES", e[e.MEDICAL_DEVICE_WEBSITE_EN = 6] = "MEDICAL_DEVICE_WEBSITE_EN", e[e.MEDICAL_DEVICE_WEBSITE_ES = 7] = "MEDICAL_DEVICE_WEBSITE_ES", e[e.PREVENTATIVE_TREATMENT_WEBSITE_EN = 8] = "PREVENTATIVE_TREATMENT_WEBSITE_EN", e[e.PREVENTATIVE_TREATMENT_WEBSITE_ES = 9] = "PREVENTATIVE_TREATMENT_WEBSITE_ES", e[e.PRESCRIPTION_CONTRACEPTION_WEBSITE_EN = 10] = "PRESCRIPTION_CONTRACEPTION_WEBSITE_EN", e[e.PRESCRIPTION_CONTRACEPTION_WEBSITE_ES = 11] = "PRESCRIPTION_CONTRACEPTION_WEBSITE_ES", e[e.PRESCRIPTION_VACCINE_WEBSITE_EN = 12] = "PRESCRIPTION_VACCINE_WEBSITE_EN", e[e.PRESCRIPTION_VACCINE_WEBSITE_ES = 13] = "PRESCRIPTION_VACCINE_WEBSITE_ES";
  }(t.VanityPharmaText || (t.VanityPharmaText = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.NON_SKIPPABLE_IN_STREAM = 2] = "NON_SKIPPABLE_IN_STREAM";
  }(t.VideoAdFormatRestriction || (t.VideoAdFormatRestriction = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PAID_VIEW = 2] = "PAID_VIEW", e[e.SKIP = 3] = "SKIP", e[e.IMPRESSION = 4] = "IMPRESSION", e[e.ENGAGED_IMPRESSION = 5] = "ENGAGED_IMPRESSION";
  }(t.VideoAdSequenceInteractionType || (t.VideoAdSequenceInteractionType = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.WEEK = 2] = "WEEK", e[e.MONTH = 3] = "MONTH";
  }(t.VideoAdSequenceMinimumDuration || (t.VideoAdSequenceMinimumDuration = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.ADVERTISER = 2] = "ADVERTISER", e[e.ENHANCED_BY_GOOGLE_ADS = 3] = "ENHANCED_BY_GOOGLE_ADS";
  }(t.VideoEnhancementSource || (t.VideoEnhancementSource = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PUBLIC = 2] = "PUBLIC", e[e.UNLISTED = 3] = "UNLISTED";
  }(t.YouTubeVideoPrivacy || (t.YouTubeVideoPrivacy = {})), function(e) {
    e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.UNKNOWN = 1] = "UNKNOWN", e[e.PENDING = 2] = "PENDING", e[e.UPLOADED = 3] = "UPLOADED", e[e.PROCESSED = 4] = "PROCESSED", e[e.FAILED = 5] = "FAILED", e[e.REJECTED = 6] = "REJECTED", e[e.UNAVAILABLE = 7] = "UNAVAILABLE";
  }(t.YouTubeVideoUploadState || (t.YouTubeVideoUploadState = {}));
})(Ge || (Ge = {}));
S.LookbackWindow.THIRTY_DAYS, S.LookbackWindow.NINETY_DAYS, S.LookbackWindow.ONE_YEAR;
Ge.GeoTargetConstantStatus.UNSPECIFIED, Ge.GeoTargetConstantStatus.UNKNOWN, Ge.GeoTargetConstantStatus.ENABLED, Ge.GeoTargetConstantStatus.REMOVAL_PLANNED;
var xm;
((t) => {
  t.Error = {
    // KEYWORD_NO_LONGER_EXISTS: 'KEYWORD_NO_LONGER_EXISTS',
  }, t.ErrorReadable = {
    // [Error.KEYWORD_NO_LONGER_EXISTS]:
    //     'The keyword we wanted to pause has already been deleted.',
  }, ((e) => {
    e.no_search_campaigns_found = "no_search_campaigns_found";
  })(t.NoImprovementReason || (t.NoImprovementReason = {}));
})(xm || (xm = {}));
var n0 = /* @__PURE__ */ ((t) => (t.Cpa = "cpa", t.Roas = "roas", t.Profit = "profit", t))(n0 || {}), r0;
((t) => {
  t.BidFactoryError = {
    NO_AD_GROUP_CRITERION_SIMULATION: "no_ad_group_criterion_simulation",
    NO_CLICKS_IN_SIMULATION: "no_clicks_in_simulation",
    NO_VALID_REGRESSIONS: "no_valid_regressions",
    ROAS_WITH_NO_TARGET: "roas_with_no_target",
    CPA_WITH_NO_TARGET: "cpa_with_no_target",
    PROFIT_WITH_NO_MARGIN: "profit_with_no_margin",
    NO_VALID_BIDDING_STRATEGY: "no_valid_bidding_strategy",
    NO_BEST_CPC_BID: "no_best_cpc_bid",
    BID_NOT_INCREASING_METRICS: "bid_not_increasing_metrics",
    BID_NOT_DECREASING_METRICS: "bid_not_decreasing_metrics",
    CURRENT_BID_NOT_IN_SIMULATION: "current_bid_not_in_simulation",
    NO_POINT_CLOSE_TO_CPA: "no_point_close_to_cpa",
    NO_POINT_CLOSE_TO_ROAS: "no_point_close_to_roas",
    NO_VALID_SIMULATION_POINTS: "no_valid_simulation_points",
    NO_CPC_BID_IN_SIMULATION: "no_cpc_bid_in_simulation",
    NO_POINT_WITH_MAX_PROFIT: "no_point_with_max_profit",
    NO_CRITERION_CONVERSION_RATE: "no_criterion_conversion_rate"
  }, t.ErrorReadable = {
    [t.BidFactoryError.NO_AD_GROUP_CRITERION_SIMULATION]: "No ad group criterion simulation available for this domain",
    [t.BidFactoryError.NO_CLICKS_IN_SIMULATION]: "The simulation doesn't have any clicks",
    [t.BidFactoryError.NO_VALID_REGRESSIONS]: "No valid regressions could be generated",
    [t.BidFactoryError.ROAS_WITH_NO_TARGET]: "Using ROAS mode with no target or no value per conversion",
    [t.BidFactoryError.NO_BEST_CPC_BID]: "No best CPC bid could be found",
    [t.BidFactoryError.BID_NOT_INCREASING_METRICS]: "Increasing a bid should increase cost and clicks",
    [t.BidFactoryError.BID_NOT_DECREASING_METRICS]: "Decreasing a bid should decrease cost and clicks",
    [t.BidFactoryError.CURRENT_BID_NOT_IN_SIMULATION]: "The current bid is not in the simulation points",
    [t.BidFactoryError.NO_POINT_CLOSE_TO_CPA]: "No CPC bid close to the Target CPA",
    [t.BidFactoryError.NO_POINT_CLOSE_TO_ROAS]: "No CPC bid close to the Target ROAS",
    [t.BidFactoryError.NO_POINT_WITH_MAX_PROFIT]: "Couldn't not find maximum profit cpc bid",
    [t.BidFactoryError.NO_VALID_SIMULATION_POINTS]: "No valid simulation points could be generated",
    [t.BidFactoryError.NO_CPC_BID_IN_SIMULATION]: "No CPC Bid micros in simulation points"
  }, ((e) => {
    e.LOW_CONVERSIONS = "Low Conversions", e.LOW_CONVERSION_VALUE = "Low Conv. Value", e.CURRENT = "Current Bid", e.SUGGESTED = "Suggested Bid", e.ABOVE_CAP = "> 30% Change", e.ABOVE_TARGET_CPA = "Above Target CPA", e.ABOVE_AVERAGE_CPA = "Above Avg. CPA", e.BELOW_TARGET_ROAS = "Below Target ROAS", e.BELOW_AVERAGE_ROAS = "Below Avg. ROAS";
  })(t.BidAnalysis || (t.BidAnalysis = {}));
})(r0 || (r0 = {}));
var Um;
((t) => {
  t.Error = {
    NO_ENABLED_DISPLAY_CAMPAIGNS: "no_enabled_display_campaigns",
    NO_RECOMMENDED_EXCLUSIONS_FOUND: "no_recommend_exclusions_found"
  }, t.ErrorReadable = {
    [t.Error.NO_ENABLED_DISPLAY_CAMPAIGNS]: "No enabled display campaigns found in the account",
    [t.Error.NO_RECOMMENDED_EXCLUSIONS_FOUND]: "No placements to exclude found in the account"
  };
})(Um || (Um = {}));
var hR = ((t) => (t[t.Cpa = n0.Cpa] = "Cpa", t[t.Roas = n0.Roas] = "Roas", t))(hR || {}), f4 = /* @__PURE__ */ ((t) => (t.TARGET_CHANGE_IS_TOO_SMALL = "TARGET_CHANGE_IS_TOO_SMALL", t.TARGET_IN_WRONG_DIRECTION = "TARGET_IN_WRONG_DIRECTION", t.BUDGET_CAPPED_CONSTRAINT = "ONLY_TARGET_TIGHTENING_ALLOWED_IF_BUDGET_CAPPED", t))(f4 || {});
Ge.AdvertisingChannelType.SEARCH, Ge.AdvertisingChannelType.DISPLAY, Ge.AdvertisingChannelType.SHOPPING;
Ge.BiddingStrategyType.TARGET_CPA, Ge.BiddingStrategyType.TARGET_ROAS, Ge.BiddingStrategyType.MAXIMIZE_CONVERSIONS, Ge.BiddingStrategyType.MAXIMIZE_CONVERSION_VALUE;
({
  ...f4
});
S.RecAction.FixNegativesBlockingKeywords;
var Ec = /* @__PURE__ */ ((t) => (t[t.UNSPECIFIED = 0] = "UNSPECIFIED", t[t.CPA = 1] = "CPA", t[t.ROAS = 2] = "ROAS", t))(Ec || {}), h4 = /* @__PURE__ */ ((t) => (t[t.BRAND = 0] = "BRAND", t[t.SEARCH = 1] = "SEARCH", t[t.DISPLAY = 2] = "DISPLAY", t[t.SHOPPING = 3] = "SHOPPING", t[t.VIDEO = 4] = "VIDEO", t[t.OTHER = 5] = "OTHER", t[t.HOTEL = 6] = "HOTEL", t[t.MULTI_CHANNEL = 7] = "MULTI_CHANNEL", t[t.LOCAL = 8] = "LOCAL", t[t.SMART = 9] = "SMART", t[t.PERFORMANCE_MAX = 10] = "PERFORMANCE_MAX", t[t.LOCAL_SERVICES = 11] = "LOCAL_SERVICES", t[t.DEMAND_GEN = 12] = "DEMAND_GEN", t[t.TRAVEL = 13] = "TRAVEL", t[t.APP_PROMOTION = 15] = "APP_PROMOTION", t[t.AWARENESS = 16] = "AWARENESS", t[t.EXCLUDED = 14] = "EXCLUDED", t[t.TRAFFIC = 17] = "TRAFFIC", t[t.ENGAGEMENT = 18] = "ENGAGEMENT", t[t.LEADS = 19] = "LEADS", t[t.SALES = 20] = "SALES", t[t.CONVERSIONS = 21] = "CONVERSIONS", t[t.MOBILE_APP_ENGAGEMENT = 22] = "MOBILE_APP_ENGAGEMENT", t))(h4 || {}), _4 = /* @__PURE__ */ ((t) => (t[t.AUTO = 0] = "AUTO", t[t.ACCOUNT_TARGET = 1] = "ACCOUNT_TARGET", t[t.CUSTOM = 2] = "CUSTOM", t))(_4 || {});
const _R = {
  CONVERSIONS: "CONVERSIONS",
  CONVERSION_VALUE: "CONVERSION_VALUE"
}, ER = {
  IMPROVE_CTR: "IMPROVE_CTR",
  IMPROVE_SIS: "IMPROVE_SIS",
  IMPROVE_AVG_QS: "IMPROVE_AVG_QS",
  REDUCE_CPC: "REDUCE_CPC"
}, pR = {
  DAY: "DAY",
  WEEK: "WEEK",
  MONTH: "MONTH",
  QUARTER: "QUARTER",
  YEAR: "YEAR"
}, mR = {
  MONDAY: "MONDAY",
  TUESDAY: "TUESDAY",
  WEDNESDAY: "WEDNESDAY",
  THURSDAY: "THURSDAY",
  FRIDAY: "FRIDAY",
  SATURDAY: "SATURDAY",
  SUNDAY: "SUNDAY"
};
var E4 = /* @__PURE__ */ ((t) => (t.TARGET_ROAS = "target_roas", t.TARGET_CPA = "target_cpa", t))(E4 || {});
const NR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CampaignGroupType: h4,
  OptimisationTarget: E4,
  PerformanceGoalCycle: pR,
  PerformanceGoalCycleStartDay: mR,
  PerformanceMode: Ec,
  PrimaryPerformanceGoal: _R,
  SecondaryPerformanceGoal: ER,
  TargetMode: _4
}, Symbol.toStringTag, { value: "Module" }));
var $m;
((t) => {
  ((n) => {
    n.BIDS = "all_logged_bids", n.TARGETS = "all_logged_targets";
  })(t.LogsKeys || (t.LogsKeys = {}));
  let e;
  ((n) => {
    n.BIDS = "formatted_bid_changes", n.TARGETS = "formatted_target_changes";
  })(e || (e = {}));
})($m || ($m = {}));
var Lr = /* @__PURE__ */ ((t) => (t.WEBSITE_VISIT = "WEBSITE_VISIT", t.ENGAGEMENT = "ENGAGEMENT", t.VIDEO_VIEW = "VIDEO_VIEW", t.LEAD_GENERATION = "LEAD_GENERATION", t.WEBSITE_CONVERSION = "WEBSITE_CONVERSION", t.JOB_APPLICANT = "JOB_APPLICANT", t.TALENT_LEAD = "TALENT_LEAD", t.BRAND_AWARENESS = "BRAND_AWARENESS", t.WEBSITE_TRAFFIC = "WEBSITE_TRAFFIC", t.CREATIVE_ENGAGEMENT = "CREATIVE_ENGAGEMENT", t))(Lr || {}), Vt = /* @__PURE__ */ ((t) => (t.CAROUSEL = "CAROUSEL", t.FOLLOW_COMPANY = "FOLLOW_COMPANY", t.JOBS = "JOBS", t.SINGLE_VIDEO = "SINGLE_VIDEO", t.SPONSORED_INMAIL = "SPONSORED_INMAIL", t.SPONSORED_MESSAGE = "SPONSORED_MESSAGE", t.SPONSORED_UPDATE = "SPONSORED_UPDATE", t.SPONSORED_UPDATE_EVENT = "SPONSORED_UPDATE_EVENT", t.SPONSORED_UPDATE_JOB_POSTING = "SPONSORED_UPDATE_JOB_POSTING", t.SPONSORED_UPDATE_NATIVE_DOCUMENT = "SPONSORED_UPDATE_NATIVE_DOCUMENT", t.SPOTLIGHT = "SPOTLIGHT", t.STANDARD_UPDATE = "STANDARD_UPDATE", t.TEXT = "TEXT", t.TEXT_AD = "TEXT_AD", t.LEAD_GENERATION_FORM_SPONSORED_CONTENT = "LEAD_GENERATION_FORM_SPONSORED_CONTENT", t.LEAD_GENERATION_FORM_CAROUSEL_SPONSORED_CONTENT = "LEAD_GENERATION_FORM_CAROUSEL_SPONSORED_CONTENT", t.VIDEO_LEAD_GENERATION_FORM_SPONSORED_CONTENT = "VIDEO_LEAD_GENERATION_FORM_SPONSORED_CONTENT", t.LEAD_GENERATION_FORM_SPONSORED_INMAIL = "LEAD_GENERATION_FORM_SPONSORED_INMAIL", t.UNSUPPORTED = "UNSUPPORTED", t.$UNKNOWN = "$UNKNOWN", t))(Vt || {}), Wt = /* @__PURE__ */ ((t) => (t.NONE = "NONE", t.ENHANCED_CONVERSION = "ENHANCED_CONVERSION", t.MAX_IMPRESSION = "MAX_IMPRESSION", t.MAX_CLICK = "MAX_CLICK", t.MAX_CONVERSION = "MAX_CONVERSION", t.MAX_VIDEO_VIEW = "MAX_VIDEO_VIEW", t.MAX_LEAD = "MAX_LEAD", t.MAX_QUALIFIED_LEAD = "MAX_QUALIFIED_LEAD", t.MAX_REACH = "MAX_REACH", t.TARGET_COST_PER_CLICK = "TARGET_COST_PER_CLICK", t.TARGET_COST_PER_IMPRESSION = "TARGET_COST_PER_IMPRESSION", t.TARGET_COST_PER_VIDEO_VIEW = "TARGET_COST_PER_VIDEO_VIEW", t.CAP_COST_AND_MAXIMIZE_CLICKS = "CAP_COST_AND_MAXIMIZE_CLICKS", t.CAP_COST_AND_MAXIMIZE_IMPRESSIONS = "CAP_COST_AND_MAXIMIZE_IMPRESSIONS", t.CAP_COST_AND_MAXIMIZE_VIDEO_VIEWS = "CAP_COST_AND_MAXIMIZE_VIDEO_VIEWS", t.CAP_COST_AND_MAXIMIZE_LEADS = "CAP_COST_AND_MAXIMIZE_LEADS", t))(Wt || {}), tu = /* @__PURE__ */ ((t) => (t.TEXT_AD = "TEXT_AD", t.SPONSORED_UPDATES = "SPONSORED_UPDATES", t.SPONSORED_INMAILS = "SPONSORED_INMAILS", t.DYNAMIC = "DYNAMIC", t.CONTENT = "CONTENT", t))(tu || {}), p4 = /* @__PURE__ */ ((t) => (t.CPM = "CPM", t.CPC = "CPC", t.CPV = "CPV", t))(p4 || {}), Ft = /* @__PURE__ */ ((t) => (t.MAXIMUM_DELIVERY = "MAXIMUM_DELIVERY", t.MANUAL = "MANUAL", t.COST_CAP = "COST_CAP", t))(Ft || {});
const ve = Lr, Ve = Wt, { CPC: Jt, CPM: Je, CPV: km } = p4, Qo = { [Ve.NONE]: [Je] }, bo = { [Ve.NONE]: [Jt, Je] }, ei = { [Ve.NONE]: [Je], [Ve.MAX_IMPRESSION]: [Je] }, o0 = {
  [ve.BRAND_AWARENESS]: {
    [Ve.NONE]: [Je],
    [Ve.MAX_IMPRESSION]: [Je],
    [Ve.MAX_REACH]: [Je],
    [Ve.TARGET_COST_PER_IMPRESSION]: [Je],
    [Ve.CAP_COST_AND_MAXIMIZE_IMPRESSIONS]: [Je]
  },
  [ve.ENGAGEMENT]: {
    [Ve.NONE]: [Jt, Je],
    [Ve.ENHANCED_CONVERSION]: [Jt],
    [Ve.MAX_CLICK]: [Je],
    [Ve.TARGET_COST_PER_CLICK]: [Jt],
    [Ve.CAP_COST_AND_MAXIMIZE_CLICKS]: [Je]
  },
  [ve.JOB_APPLICANT]: { [Ve.NONE]: [Jt, Je], [Ve.MAX_CLICK]: [Je] },
  [ve.LEAD_GENERATION]: {
    [Ve.NONE]: [Jt, Je],
    [Ve.ENHANCED_CONVERSION]: [Jt],
    [Ve.MAX_LEAD]: [Je],
    [Ve.MAX_QUALIFIED_LEAD]: [Je],
    [Ve.CAP_COST_AND_MAXIMIZE_LEADS]: [Je]
  },
  [ve.TALENT_LEAD]: {
    [Ve.NONE]: [Jt, Je],
    [Ve.ENHANCED_CONVERSION]: [Jt],
    [Ve.MAX_CLICK]: [Je],
    [Ve.MAX_LEAD]: [Je]
  },
  [ve.VIDEO_VIEW]: {
    [Ve.NONE]: [Je, km],
    [Ve.MAX_VIDEO_VIEW]: [Je],
    [Ve.TARGET_COST_PER_VIDEO_VIEW]: [km],
    [Ve.CAP_COST_AND_MAXIMIZE_VIDEO_VIEWS]: [Je]
  },
  [ve.WEBSITE_CONVERSION]: {
    [Ve.NONE]: [Jt, Je],
    [Ve.ENHANCED_CONVERSION]: [Jt],
    [Ve.MAX_CONVERSION]: [Je],
    [Ve.MAX_QUALIFIED_LEAD]: [Je]
  },
  [ve.WEBSITE_VISIT]: {
    [Ve.NONE]: [Jt, Je],
    [Ve.ENHANCED_CONVERSION]: [Jt],
    [Ve.MAX_CLICK]: [Je],
    [Ve.TARGET_COST_PER_CLICK]: [Jt],
    [Ve.CAP_COST_AND_MAXIMIZE_CLICKS]: [Je]
  },
  [ve.WEBSITE_TRAFFIC]: {
    [Ve.NONE]: [Jt, Je],
    [Ve.ENHANCED_CONVERSION]: [Jt],
    [Ve.MAX_CLICK]: [Je],
    [Ve.MAX_CONVERSION]: [Je],
    [Ve.MAX_IMPRESSION]: [Je]
  },
  [ve.CREATIVE_ENGAGEMENT]: {
    [Ve.NONE]: [Jt, Je],
    [Ve.ENHANCED_CONVERSION]: [Jt],
    [Ve.MAX_CLICK]: [Je],
    [Ve.MAX_CONVERSION]: [Je],
    [Ve.MAX_IMPRESSION]: [Je]
  }
};
function ts(...t) {
  return Object.fromEntries(t.map((e) => [e, o0[e]]));
}
const Ji = { type: tu.SPONSORED_UPDATES, audienceExpansion: !0 }, Bm = {
  type: tu.SPONSORED_INMAILS,
  audienceExpansion: !0,
  lan: !1
}, T1 = { type: tu.DYNAMIC, audienceExpansion: !1, lan: !1 }, DE = {
  [Vt.STANDARD_UPDATE]: {
    ...Ji,
    lan: !0,
    noLanFor: [ve.LEAD_GENERATION],
    objectives: ts(
      ve.BRAND_AWARENESS,
      ve.ENGAGEMENT,
      ve.JOB_APPLICANT,
      ve.LEAD_GENERATION,
      ve.TALENT_LEAD,
      ve.WEBSITE_CONVERSION,
      ve.WEBSITE_VISIT,
      ve.WEBSITE_TRAFFIC,
      ve.CREATIVE_ENGAGEMENT
    )
  },
  [Vt.CAROUSEL]: {
    ...Ji,
    lan: !0,
    noLanFor: [ve.LEAD_GENERATION, ve.TALENT_LEAD],
    objectives: ts(
      ve.BRAND_AWARENESS,
      ve.ENGAGEMENT,
      ve.LEAD_GENERATION,
      ve.TALENT_LEAD,
      ve.WEBSITE_CONVERSION,
      ve.WEBSITE_VISIT,
      ve.WEBSITE_TRAFFIC,
      ve.CREATIVE_ENGAGEMENT
    )
  },
  [Vt.SINGLE_VIDEO]: {
    ...Ji,
    lan: !0,
    noLanFor: [ve.LEAD_GENERATION],
    objectives: ts(
      ve.BRAND_AWARENESS,
      ve.ENGAGEMENT,
      ve.LEAD_GENERATION,
      ve.TALENT_LEAD,
      ve.VIDEO_VIEW,
      ve.WEBSITE_CONVERSION,
      ve.WEBSITE_VISIT,
      ve.WEBSITE_TRAFFIC,
      ve.CREATIVE_ENGAGEMENT
    )
  },
  [Vt.SPONSORED_UPDATE_EVENT]: {
    ...Ji,
    lan: !1,
    objectives: ts(ve.BRAND_AWARENESS, ve.ENGAGEMENT, ve.LEAD_GENERATION, ve.WEBSITE_VISIT)
  },
  [Vt.SPONSORED_UPDATE_NATIVE_DOCUMENT]: {
    ...Ji,
    lan: !0,
    noLanFor: [ve.LEAD_GENERATION],
    objectives: ts(
      ve.BRAND_AWARENESS,
      ve.ENGAGEMENT,
      ve.LEAD_GENERATION,
      ve.WEBSITE_CONVERSION,
      ve.WEBSITE_VISIT
    )
  },
  [Vt.SPONSORED_UPDATE_JOB_POSTING]: {
    ...Ji,
    lan: !1,
    objectives: ts(ve.JOB_APPLICANT)
  },
  [Vt.SPONSORED_INMAIL]: {
    ...Bm,
    objectives: {
      [ve.LEAD_GENERATION]: ei,
      [ve.WEBSITE_CONVERSION]: ei,
      [ve.WEBSITE_VISIT]: ei,
      [ve.WEBSITE_TRAFFIC]: Qo
    }
  },
  [Vt.SPONSORED_MESSAGE]: {
    ...Bm,
    objectives: {
      [ve.BRAND_AWARENESS]: ei,
      [ve.ENGAGEMENT]: ei,
      [ve.LEAD_GENERATION]: ei,
      [ve.WEBSITE_CONVERSION]: ei,
      [ve.WEBSITE_VISIT]: ei,
      [ve.WEBSITE_TRAFFIC]: Qo
    }
  },
  [Vt.TEXT_AD]: {
    type: tu.TEXT_AD,
    audienceExpansion: !0,
    lan: !1,
    objectives: {
      [ve.BRAND_AWARENESS]: Qo,
      [ve.WEBSITE_CONVERSION]: bo,
      [ve.WEBSITE_VISIT]: bo,
      [ve.WEBSITE_TRAFFIC]: bo
    }
  },
  [Vt.SPOTLIGHT]: {
    ...T1,
    objectives: {
      [ve.BRAND_AWARENESS]: Qo,
      [ve.JOB_APPLICANT]: bo,
      [ve.TALENT_LEAD]: Qo,
      [ve.WEBSITE_CONVERSION]: bo,
      [ve.WEBSITE_VISIT]: bo,
      [ve.WEBSITE_TRAFFIC]: bo
    }
  },
  [Vt.FOLLOW_COMPANY]: {
    ...T1,
    objectives: {
      [ve.BRAND_AWARENESS]: Qo,
      [ve.ENGAGEMENT]: bo,
      [ve.WEBSITE_TRAFFIC]: bo
    }
  },
  [Vt.JOBS]: {
    ...T1,
    objectives: { [ve.JOB_APPLICANT]: Qo, [ve.WEBSITE_TRAFFIC]: Qo }
  }
}, vR = {
  ...Ji,
  lan: !0,
  noLanFor: [ve.LEAD_GENERATION],
  objectives: {
    ...o0,
    [ve.ENGAGEMENT]: { ...o0[ve.ENGAGEMENT], [Ve.MAX_REACH]: [Je] }
  }
};
function Gm(t) {
  return Object.fromEntries(
    Object.entries(t.objectives).map(([e, n]) => [
      e,
      {
        targets: n,
        lan: t.lan && !(t.noLanFor ?? []).includes(e),
        audienceExpansion: t.audienceExpansion
      }
    ])
  );
}
const gR = "UNSET";
({
  [gR]: Gm(vR),
  ...Object.fromEntries(
    Object.entries(DE).map(([t, e]) => [t, Gm(e)])
  )
});
Object.fromEntries(
  Object.entries(DE).map(([t, e]) => [t, e.type])
);
Object.fromEntries(
  Object.keys(DE).map((t) => [t, t])
);
Lr.BRAND_AWARENESS + "", Vt.FOLLOW_COMPANY, Lr.WEBSITE_CONVERSION + "", Vt.SINGLE_VIDEO, Vt.CAROUSEL, Vt.TEXT_AD, Vt.SPOTLIGHT, Vt.SPONSORED_INMAIL, Vt.SPONSORED_MESSAGE;
Vt.SPONSORED_UPDATE_EVENT;
Wt.NONE, Wt.ENHANCED_CONVERSION;
Lr.BRAND_AWARENESS + "", Ft.MAXIMUM_DELIVERY + "", Wt.MAX_REACH, Ft.MANUAL + "", Ft.COST_CAP + "", Lr.WEBSITE_VISIT + "", Ft.MAXIMUM_DELIVERY + "", Wt.MAX_CLICK, Ft.MANUAL + "", Wt.ENHANCED_CONVERSION, Ft.COST_CAP + "", Wt.CAP_COST_AND_MAXIMIZE_CLICKS, Lr.ENGAGEMENT + "", Ft.MAXIMUM_DELIVERY + "", Wt.MAX_CLICK, Ft.MANUAL + "", Wt.ENHANCED_CONVERSION, Ft.COST_CAP + "", Wt.CAP_COST_AND_MAXIMIZE_CLICKS, Lr.LEAD_GENERATION + "", Ft.MAXIMUM_DELIVERY + "", Wt.MAX_LEAD, Ft.MANUAL + "", Wt.ENHANCED_CONVERSION, Ft.COST_CAP + "", Wt.CAP_COST_AND_MAXIMIZE_LEADS, Lr.WEBSITE_CONVERSION + "", Ft.MAXIMUM_DELIVERY + "", Wt.MAX_CONVERSION, Ft.MANUAL + "", Wt.ENHANCED_CONVERSION, Ft.COST_CAP + "", Lr.VIDEO_VIEW + "", Ft.MANUAL + "", Wt.NONE, Ft.COST_CAP + "", Wt.CAP_COST_AND_MAXIMIZE_VIDEO_VIEWS, Lr.JOB_APPLICANT + "", Ft.MAXIMUM_DELIVERY + "", Wt.MAX_CLICK, Ft.MANUAL + "", Wt.NONE, Ft.COST_CAP + "";
var ui = /* @__PURE__ */ ((t) => (t.LAST_7_DAYS = "last7Days", t.LAST_14_DAYS = "last14Days", t.LAST_30_DAYS = "last30Days", t.LAST_45_DAYS = "last45Days", t.LAST_60_DAYS = "last60Days", t.LAST_90_DAYS = "last90Days", t.LAST_180_DAYS = "last180Days", t.LAST_365_DAYS = "last365Days", t.LAST_730_DAYS = "last730Days", t.MONTH_TO_DATE = "monthToDate", t))(ui || {});
((t) => {
  t.LOOKBACK_WINDOW_TO_DAYS = {
    last7Days: 7,
    last14Days: 14,
    last30Days: 30,
    last45Days: 45,
    last60Days: 60,
    last90Days: 90,
    last180Days: 180,
    last365Days: 365,
    last730Days: 730,
    monthToDate: "monthToDate"
  }, t.STANDARD_LOOKBACKS = [
    "last30Days",
    "last90Days",
    "last180Days",
    "last365Days"
    /* LAST_365_DAYS */
  ], t.STANDARD_WITH_MTD_LOOKBACKS = [
    "monthToDate",
    "last30Days",
    "last90Days",
    "last180Days",
    "last365Days"
    /* LAST_365_DAYS */
  ], t.EXTENDED_LOOKBACKS = [
    "monthToDate",
    "last30Days",
    "last90Days",
    "last180Days",
    "last365Days",
    "last730Days"
    /* LAST_730_DAYS */
  ], t.PLACEMENT_LOOKBACKS = [
    "last30Days",
    "last90Days"
    /* LAST_90_DAYS */
  ], t.IMPROVEMENT_LOOKBACKS = [
    "last7Days",
    "last14Days",
    "last30Days",
    "last45Days",
    "last60Days",
    "last90Days"
    /* LAST_90_DAYS */
  ], t.LEGACY_IMPROVEMENT_LOOKBACKS = [
    "last7Days",
    "last14Days",
    "last30Days",
    "last45Days",
    "last60Days",
    "last90Days",
    "last180Days",
    "last365Days"
    /* LAST_365_DAYS */
  ], t.ACCOUNT_MANAGER_LOOKBACKS = [
    "last30Days",
    "last90Days",
    "last180Days",
    "last365Days",
    "monthToDate"
    /* MONTH_TO_DATE */
  ], t.COMPUTE_RANGE_LOOKBACKS = [
    "last30Days",
    "last90Days",
    "last180Days",
    "last365Days",
    "monthToDate"
    /* MONTH_TO_DATE */
  ];
  const e = new Set(Object.values(t));
  function n(i) {
    return typeof i == "string" && e.has(i);
  }
  t.isLookbackWindow = n;
  function r(i) {
    const a = t.LOOKBACK_WINDOW_TO_DAYS[i];
    return typeof a == "number" ? a : void 0;
  }
  t.toDays = r;
  function o(i) {
    return i === "monthToDate";
  }
  t.isMonthToDate = o;
})(ui || (ui = {}));
ui.LAST_30_DAYS, ui.LAST_90_DAYS, ui.LAST_180_DAYS, ui.LAST_365_DAYS, ui.MONTH_TO_DATE;
var st = /* @__PURE__ */ ((t) => (t[t.GoogleAds = 0] = "GoogleAds", t[t.MicrosoftAds = 1] = "MicrosoftAds", t[t.MetaAds = 2] = "MetaAds", t[t.LinkedInAds = 3] = "LinkedInAds", t[t.GoogleAnalytics = 4] = "GoogleAnalytics", t[t.TikTokAds = 5] = "TikTokAds", t[t.GoogleSearchConsole = 6] = "GoogleSearchConsole", t[t.ChatGptAds = 7] = "ChatGptAds", t))(st || {}), m4 = /* @__PURE__ */ ((t) => (t.GoogleAds = "ga", t.MicrosoftAds = "ms", t.MetaAds = "me", t.LinkedInAds = "li", t.GoogleAnalytics = "ga4", t.TikTokAds = "tt", t.GoogleSearchConsole = "gsc", t.ChatGptAds = "cg", t))(m4 || {});
const IR = {
  0: "ga",
  1: "ms",
  2: "me",
  3: "li",
  4: "ga4",
  5: "tt",
  6: "gsc",
  7: "cg"
  /* ChatGptAds */
}, OR = {
  0: "google",
  1: "microsoft",
  2: "meta",
  3: "linkedin",
  4: "googleanalytics",
  5: "tiktok",
  6: "googlesearchconsole",
  7: "chatgpt"
}, AR = {
  0: "Google Ads",
  1: "Microsoft Ads",
  2: "Meta Ads",
  3: "LinkedIn Ads",
  4: "Google Analytics",
  5: "TikTok Ads",
  6: "Google Search Console",
  7: "ChatGPT Ads"
}, DR = {
  0: {
    adGroup: !0,
    keyword: !0
  },
  1: {
    adGroup: !0,
    keyword: !0
  },
  2: {
    adGroup: !0,
    keyword: !1
  },
  3: {
    adGroup: !1,
    keyword: !1
  },
  5: {
    adGroup: !0,
    keyword: !0
  },
  4: {
    adGroup: !1,
    keyword: !1
  },
  6: {
    adGroup: !1,
    keyword: !1
  },
  7: {
    adGroup: !0,
    keyword: !1
  }
}, CR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Platform: st,
  PlatformAvailableEntities: DR,
  PlatformIdPrefix: m4,
  PlatformToFormattedName: AR,
  PlatformToName: OR,
  PlatformToPrefix: IR
}, Symbol.toStringTag, { value: "Module" }));
st.GoogleAds + "", st.MicrosoftAds + "", st.MetaAds + "", st.LinkedInAds + "", st.GoogleAnalytics + "", st.GoogleSearchConsole + "", st.TikTokAds + "", st.ChatGptAds + "";
st.GoogleAds + "", st.MicrosoftAds + "", st.MetaAds + "", st.LinkedInAds + "", st.GoogleAnalytics + "", st.GoogleSearchConsole + "", st.TikTokAds + "", st.ChatGptAds + "";
var N4 = /* @__PURE__ */ ((t) => (t.ALL = "L", t.AFN = "؋", t.ARS = "$", t.AWG = "ƒ", t.AUD = "$", t.AZN = "₼", t.BSD = "$", t.BBD = "$", t.BYN = "Br", t.BZD = "BZ$", t.BMD = "$", t.BOB = "$b", t.BAM = "KM", t.BWP = "P", t.BGN = "лв", t.BRL = "R$", t.BND = "$", t.KHR = "៛", t.CAD = "$", t.KYD = "$", t.CLP = "$", t.CNY = "¥", t.COP = "$", t.CRC = "₡", t.HRK = "kn", t.CUP = "₱", t.CZK = "Kč", t.DKK = "kr", t.DOP = "RD$", t.XCD = "$", t.EGP = "£", t.SVC = "$", t.EUR = "€", t.FKP = "£", t.FJD = "$", t.GHS = "¢", t.GIP = "£", t.GTQ = "Q", t.GGP = "£", t.GYD = "$", t.HNL = "L", t.HKD = "$", t.HUF = "Ft", t.ISK = "kr", t.INR = "₹", t.IDR = "Rp", t.IRR = "﷼", t.IMP = "£", t.ILS = "₪", t.JMD = "J$", t.JPY = "¥", t.JEP = "£", t.KZT = "лв", t.KPW = "₩", t.KRW = "₩", t.KGS = "лв", t.LAK = "₭", t.LBP = "£", t.LRD = "$", t.MKD = "ден", t.MYR = "RM", t.MUR = "₨", t.MXN = "$", t.MNT = "د.إ", t.MZN = "MT", t.NAD = "$", t.NPR = "₨", t.ANG = "ƒ", t.NZD = "$", t.NIO = "C$", t.NGN = "₦", t.NOK = "kr", t.OMR = "﷼", t.PKR = "₨", t.PAB = "B/.", t.PYG = "Gs", t.PEN = "S/.", t.PHP = "₱", t.PLN = "zł", t.QAR = "﷼", t.RON = "lei", t.RUB = "₽", t.SHP = "£", t.SAR = "﷼", t.RSD = "Дин.", t.SCR = "₨", t.SGD = "$", t.SBD = "$", t.SOS = "S", t.ZAR = "R", t.LKR = "₨", t.SEK = "kr", t.CHF = "fr", t.SRD = "$", t.SYP = "£", t.TWD = "NT$", t.THB = "฿", t.TTD = "TT$", t.TRY = "₺", t.TVD = "$", t.UAH = "₴", t.AED = "د.إ", t.GBP = "£", t.USD = "$", t.UYU = "$U", t.UZS = "лв", t.VEF = "Bs", t.VND = "₫", t.YER = "﷼", t.ZWD = "Z$", t))(N4 || {});
const SR = {
  integrations: "integrations",
  conversionTracking: "conversionTracking",
  disapprovals: "disapprovals",
  landingPages: "landingPages",
  projectedSpend: "projectedSpend",
  budgetCap: "budgetCap",
  spendAllocation: "spendAllocation",
  // Search campaigns here
  qs: "qs",
  rsa: "rsa",
  adExtension: "adExtension",
  matchtype: "matchtype",
  sqr: "sqr",
  searchTermAlignment: "searchTermAlignment",
  performanceMax: "performanceMax",
  productPerformance: "productPerformance"
};
[...Object.keys(SR)];
Ge.AssetFieldType.HEADLINE, Ge.AssetFieldType.LONG_HEADLINE, Ge.AssetFieldType.DESCRIPTION, Ge.AssetFieldType.BUSINESS_NAME, Ge.AssetFieldType.MARKETING_IMAGE, Ge.AssetFieldType.SQUARE_MARKETING_IMAGE, Ge.AssetFieldType.PORTRAIT_MARKETING_IMAGE, Ge.AssetFieldType.LOGO, Ge.AssetFieldType.LANDSCAPE_LOGO, Ge.AssetFieldType.YOUTUBE_VIDEO, Ge.AssetFieldType.CALL_TO_ACTION_SELECTION, Ge.AssetFieldType.MEDIA_BUNDLE;
const wR = {
  [Ge.AssetFieldType.HEADLINE]: {
    formattedAssetType: "Headline",
    recommendedAssetCount: 5
  },
  [Ge.AssetFieldType.LONG_HEADLINE]: {
    formattedAssetType: "Long Headline",
    recommendedAssetCount: 2
  },
  [Ge.AssetFieldType.DESCRIPTION]: {
    formattedAssetType: "Description",
    recommendedAssetCount: 3
  },
  [Ge.AssetFieldType.BUSINESS_NAME]: {
    formattedAssetType: "Business Name",
    recommendedAssetCount: 1
  },
  [Ge.AssetFieldType.MARKETING_IMAGE]: {
    formattedAssetType: "Marketing Image",
    recommendedAssetCount: 1
  },
  [Ge.AssetFieldType.SQUARE_MARKETING_IMAGE]: {
    formattedAssetType: "Sq. Marketing Image",
    recommendedAssetCount: 1
  },
  [Ge.AssetFieldType.PORTRAIT_MARKETING_IMAGE]: {
    formattedAssetType: "Portrait Image",
    recommendedAssetCount: 1
  },
  [Ge.AssetFieldType.LOGO]: {
    formattedAssetType: "Logo",
    recommendedAssetCount: 1
  },
  [Ge.AssetFieldType.LANDSCAPE_LOGO]: {
    formattedAssetType: "Landscape Logo",
    recommendedAssetCount: 1
  },
  [Ge.AssetFieldType.YOUTUBE_VIDEO]: {
    formattedAssetType: "YouTube Video",
    recommendedAssetCount: 1
  },
  [Ge.AssetFieldType.CALL_TO_ACTION_SELECTION]: {
    formattedAssetType: "Call To Action",
    recommendedAssetCount: 1
  },
  [Ge.AssetFieldType.MEDIA_BUNDLE]: {
    formattedAssetType: "Media Bundle",
    recommendedAssetCount: 0
  },
  unknownAssetType: {
    formattedAssetType: "Unknown Asset Type",
    recommendedAssetCount: 0
  }
};
Object.values(wR).map(
  ({ formattedAssetType: t }) => t
);
Ge.BiddingStrategyType.TARGET_CPA, Ge.BiddingStrategyType.MAXIMIZE_CONVERSIONS, Ge.BiddingStrategyType.TARGET_SPEND, Ge.BiddingStrategyType.ENHANCED_CPC, Ge.BiddingStrategyType.MANUAL_CPC;
Ge.BiddingStrategyType.TARGET_ROAS, Ge.BiddingStrategyType.MAXIMIZE_CONVERSION_VALUE;
Ge.BiddingStrategyType.TARGET_CPA, Ge.BiddingStrategyType.TARGET_ROAS, Ge.BiddingStrategyType.MAXIMIZE_CONVERSIONS, Ge.BiddingStrategyType.MAXIMIZE_CONVERSION_VALUE, Ge.BiddingStrategyType.ENHANCED_CPC, Ge.BiddingStrategyType.TARGET_SPEND;
function ie(t, e, n) {
  function r(s, l) {
    if (s._zod || Object.defineProperty(s, "_zod", {
      value: {
        def: l,
        constr: a,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), s._zod.traits.has(t))
      return;
    s._zod.traits.add(t), e(s, l);
    const c = a.prototype, u = Object.keys(c);
    for (let d = 0; d < u.length; d++) {
      const f = u[d];
      f in s || (s[f] = c[f].bind(s));
    }
  }
  const o = (n == null ? void 0 : n.Parent) ?? Object;
  class i extends o {
  }
  Object.defineProperty(i, "name", { value: t });
  function a(s) {
    var l;
    const c = n != null && n.Parent ? new i() : this;
    r(c, s), (l = c._zod).deferred ?? (l.deferred = []);
    for (const u of c._zod.deferred)
      u();
    return c;
  }
  return Object.defineProperty(a, "init", { value: r }), Object.defineProperty(a, Symbol.hasInstance, {
    value: (s) => {
      var l, c;
      return n != null && n.Parent && s instanceof n.Parent ? !0 : (c = (l = s == null ? void 0 : s._zod) == null ? void 0 : l.traits) == null ? void 0 : c.has(t);
    }
  }), Object.defineProperty(a, "name", { value: t }), a;
}
class ws extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class v4 extends Error {
  constructor(e) {
    super(`Encountered unidirectional transform during encode: ${e}`), this.name = "ZodEncodeError";
  }
}
const i0 = {};
function Aa(t) {
  return t && Object.assign(i0, t), i0;
}
function g4(t) {
  const e = Object.values(t).filter((r) => typeof r == "number");
  return Object.entries(t).filter(([r, o]) => e.indexOf(+r) === -1).map(([r, o]) => o);
}
function a0(t, e) {
  return typeof e == "bigint" ? e.toString() : e;
}
function CE(t) {
  return {
    get value() {
      {
        const e = t();
        return Object.defineProperty(this, "value", { value: e }), e;
      }
    }
  };
}
function SE(t) {
  return t == null;
}
function wE(t) {
  const e = t.startsWith("^") ? 1 : 0, n = t.endsWith("$") ? t.length - 1 : t.length;
  return t.slice(e, n);
}
function TR(t, e) {
  const n = (t.toString().split(".")[1] || "").length, r = e.toString();
  let o = (r.split(".")[1] || "").length;
  if (o === 0 && /\d?e-\d?/.test(r)) {
    const l = r.match(/\d?e-(\d?)/);
    l != null && l[1] && (o = Number.parseInt(l[1]));
  }
  const i = n > o ? n : o, a = Number.parseInt(t.toFixed(i).replace(".", "")), s = Number.parseInt(e.toFixed(i).replace(".", ""));
  return a % s / 10 ** i;
}
const Fm = Symbol("evaluating");
function dt(t, e, n) {
  let r;
  Object.defineProperty(t, e, {
    get() {
      if (r !== Fm)
        return r === void 0 && (r = Fm, r = n()), r;
    },
    set(o) {
      Object.defineProperty(t, e, {
        value: o
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Fa(t, e, n) {
  Object.defineProperty(t, e, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function ki(...t) {
  const e = {};
  for (const n of t) {
    const r = Object.getOwnPropertyDescriptors(n);
    Object.assign(e, r);
  }
  return Object.defineProperties({}, e);
}
function Vm(t) {
  return JSON.stringify(t);
}
function bR(t) {
  return t.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const I4 = "captureStackTrace" in Error ? Error.captureStackTrace : (...t) => {
};
function Od(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
const RR = CE(() => {
  var t;
  if (typeof navigator < "u" && ((t = navigator == null ? void 0 : navigator.userAgent) != null && t.includes("Cloudflare")))
    return !1;
  try {
    const e = Function;
    return new e(""), !0;
  } catch {
    return !1;
  }
});
function pc(t) {
  if (Od(t) === !1)
    return !1;
  const e = t.constructor;
  if (e === void 0 || typeof e != "function")
    return !0;
  const n = e.prototype;
  return !(Od(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function O4(t) {
  return pc(t) ? { ...t } : Array.isArray(t) ? [...t] : t;
}
const MR = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Cf(t) {
  return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Bi(t, e, n) {
  const r = new t._zod.constr(e ?? t._zod.def);
  return (!e || n != null && n.parent) && (r._zod.parent = t), r;
}
function $e(t) {
  const e = t;
  if (!e)
    return {};
  if (typeof e == "string")
    return { error: () => e };
  if ((e == null ? void 0 : e.message) !== void 0) {
    if ((e == null ? void 0 : e.error) !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    e.error = e.message;
  }
  return delete e.message, typeof e.error == "string" ? { ...e, error: () => e.error } : e;
}
function PR(t) {
  return Object.keys(t).filter((e) => t[e]._zod.optin === "optional" && t[e]._zod.optout === "optional");
}
const yR = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function LR(t, e) {
  const n = t._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const i = ki(t._zod.def, {
    get shape() {
      const a = {};
      for (const s in e) {
        if (!(s in n.shape))
          throw new Error(`Unrecognized key: "${s}"`);
        e[s] && (a[s] = n.shape[s]);
      }
      return Fa(this, "shape", a), a;
    },
    checks: []
  });
  return Bi(t, i);
}
function xR(t, e) {
  const n = t._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const i = ki(t._zod.def, {
    get shape() {
      const a = { ...t._zod.def.shape };
      for (const s in e) {
        if (!(s in n.shape))
          throw new Error(`Unrecognized key: "${s}"`);
        e[s] && delete a[s];
      }
      return Fa(this, "shape", a), a;
    },
    checks: []
  });
  return Bi(t, i);
}
function UR(t, e) {
  if (!pc(e))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = t._zod.def.checks;
  if (n && n.length > 0) {
    const i = t._zod.def.shape;
    for (const a in e)
      if (Object.getOwnPropertyDescriptor(i, a) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const o = ki(t._zod.def, {
    get shape() {
      const i = { ...t._zod.def.shape, ...e };
      return Fa(this, "shape", i), i;
    }
  });
  return Bi(t, o);
}
function $R(t, e) {
  if (!pc(e))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = ki(t._zod.def, {
    get shape() {
      const r = { ...t._zod.def.shape, ...e };
      return Fa(this, "shape", r), r;
    }
  });
  return Bi(t, n);
}
function kR(t, e) {
  const n = ki(t._zod.def, {
    get shape() {
      const r = { ...t._zod.def.shape, ...e._zod.def.shape };
      return Fa(this, "shape", r), r;
    },
    get catchall() {
      return e._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Bi(t, n);
}
function BR(t, e, n) {
  const o = e._zod.def.checks;
  if (o && o.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const a = ki(e._zod.def, {
    get shape() {
      const s = e._zod.def.shape, l = { ...s };
      if (n)
        for (const c in n) {
          if (!(c in s))
            throw new Error(`Unrecognized key: "${c}"`);
          n[c] && (l[c] = t ? new t({
            type: "optional",
            innerType: s[c]
          }) : s[c]);
        }
      else
        for (const c in s)
          l[c] = t ? new t({
            type: "optional",
            innerType: s[c]
          }) : s[c];
      return Fa(this, "shape", l), l;
    },
    checks: []
  });
  return Bi(e, a);
}
function GR(t, e, n) {
  const r = ki(e._zod.def, {
    get shape() {
      const o = e._zod.def.shape, i = { ...o };
      if (n)
        for (const a in n) {
          if (!(a in i))
            throw new Error(`Unrecognized key: "${a}"`);
          n[a] && (i[a] = new t({
            type: "nonoptional",
            innerType: o[a]
          }));
        }
      else
        for (const a in o)
          i[a] = new t({
            type: "nonoptional",
            innerType: o[a]
          });
      return Fa(this, "shape", i), i;
    }
  });
  return Bi(e, r);
}
function Os(t, e = 0) {
  var n;
  if (t.aborted === !0)
    return !0;
  for (let r = e; r < t.issues.length; r++)
    if (((n = t.issues[r]) == null ? void 0 : n.continue) !== !0)
      return !0;
  return !1;
}
function A4(t, e) {
  return e.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(t), n;
  });
}
function wu(t) {
  return typeof t == "string" ? t : t == null ? void 0 : t.message;
}
function Da(t, e, n) {
  var o, i, a, s, l, c;
  const r = { ...t, path: t.path ?? [] };
  if (!t.message) {
    const u = wu((a = (i = (o = t.inst) == null ? void 0 : o._zod.def) == null ? void 0 : i.error) == null ? void 0 : a.call(i, t)) ?? wu((s = e == null ? void 0 : e.error) == null ? void 0 : s.call(e, t)) ?? wu((l = n.customError) == null ? void 0 : l.call(n, t)) ?? wu((c = n.localeError) == null ? void 0 : c.call(n, t)) ?? "Invalid input";
    r.message = u;
  }
  return delete r.inst, delete r.continue, e != null && e.reportInput || delete r.input, r;
}
function TE(t) {
  return Array.isArray(t) ? "array" : typeof t == "string" ? "string" : "unknown";
}
function mc(...t) {
  const [e, n, r] = t;
  return typeof e == "string" ? {
    message: e,
    code: "custom",
    input: n,
    inst: r
  } : { ...e };
}
const D4 = (t, e) => {
  t.name = "$ZodError", Object.defineProperty(t, "_zod", {
    value: t._zod,
    enumerable: !1
  }), Object.defineProperty(t, "issues", {
    value: e,
    enumerable: !1
  }), t.message = JSON.stringify(e, a0, 2), Object.defineProperty(t, "toString", {
    value: () => t.message,
    enumerable: !1
  });
}, C4 = ie("$ZodError", D4), S4 = ie("$ZodError", D4, { Parent: Error });
function FR(t, e = (n) => n.message) {
  const n = {}, r = [];
  for (const o of t.issues)
    o.path.length > 0 ? (n[o.path[0]] = n[o.path[0]] || [], n[o.path[0]].push(e(o))) : r.push(e(o));
  return { formErrors: r, fieldErrors: n };
}
function VR(t, e = (n) => n.message) {
  const n = { _errors: [] }, r = (o) => {
    for (const i of o.issues)
      if (i.code === "invalid_union" && i.errors.length)
        i.errors.map((a) => r({ issues: a }));
      else if (i.code === "invalid_key")
        r({ issues: i.issues });
      else if (i.code === "invalid_element")
        r({ issues: i.issues });
      else if (i.path.length === 0)
        n._errors.push(e(i));
      else {
        let a = n, s = 0;
        for (; s < i.path.length; ) {
          const l = i.path[s];
          s === i.path.length - 1 ? (a[l] = a[l] || { _errors: [] }, a[l]._errors.push(e(i))) : a[l] = a[l] || { _errors: [] }, a = a[l], s++;
        }
      }
  };
  return r(t), n;
}
const bE = (t) => (e, n, r, o) => {
  const i = r ? Object.assign(r, { async: !1 }) : { async: !1 }, a = e._zod.run({ value: n, issues: [] }, i);
  if (a instanceof Promise)
    throw new ws();
  if (a.issues.length) {
    const s = new ((o == null ? void 0 : o.Err) ?? t)(a.issues.map((l) => Da(l, i, Aa())));
    throw I4(s, o == null ? void 0 : o.callee), s;
  }
  return a.value;
}, RE = (t) => async (e, n, r, o) => {
  const i = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let a = e._zod.run({ value: n, issues: [] }, i);
  if (a instanceof Promise && (a = await a), a.issues.length) {
    const s = new ((o == null ? void 0 : o.Err) ?? t)(a.issues.map((l) => Da(l, i, Aa())));
    throw I4(s, o == null ? void 0 : o.callee), s;
  }
  return a.value;
}, Sf = (t) => (e, n, r) => {
  const o = r ? { ...r, async: !1 } : { async: !1 }, i = e._zod.run({ value: n, issues: [] }, o);
  if (i instanceof Promise)
    throw new ws();
  return i.issues.length ? {
    success: !1,
    error: new (t ?? C4)(i.issues.map((a) => Da(a, o, Aa())))
  } : { success: !0, data: i.value };
}, HR = /* @__PURE__ */ Sf(S4), wf = (t) => async (e, n, r) => {
  const o = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let i = e._zod.run({ value: n, issues: [] }, o);
  return i instanceof Promise && (i = await i), i.issues.length ? {
    success: !1,
    error: new t(i.issues.map((a) => Da(a, o, Aa())))
  } : { success: !0, data: i.value };
}, WR = /* @__PURE__ */ wf(S4), YR = (t) => (e, n, r) => {
  const o = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return bE(t)(e, n, o);
}, KR = (t) => (e, n, r) => bE(t)(e, n, r), zR = (t) => async (e, n, r) => {
  const o = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return RE(t)(e, n, o);
}, ZR = (t) => async (e, n, r) => RE(t)(e, n, r), qR = (t) => (e, n, r) => {
  const o = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Sf(t)(e, n, o);
}, XR = (t) => (e, n, r) => Sf(t)(e, n, r), jR = (t) => async (e, n, r) => {
  const o = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return wf(t)(e, n, o);
}, JR = (t) => async (e, n, r) => wf(t)(e, n, r), QR = /^[cC][^\s-]{8,}$/, eM = /^[0-9a-z]+$/, tM = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, nM = /^[0-9a-vA-V]{20}$/, rM = /^[A-Za-z0-9]{27}$/, oM = /^[a-zA-Z0-9_-]{21}$/, iM = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, aM = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Hm = (t) => t ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${t}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, sM = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, lM = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function cM() {
  return new RegExp(lM, "u");
}
const uM = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, dM = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, fM = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, hM = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, _M = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, w4 = /^[A-Za-z0-9_-]*$/, EM = /^\+[1-9]\d{6,14}$/, T4 = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", pM = /* @__PURE__ */ new RegExp(`^${T4}$`);
function b4(t) {
  const e = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof t.precision == "number" ? t.precision === -1 ? `${e}` : t.precision === 0 ? `${e}:[0-5]\\d` : `${e}:[0-5]\\d\\.\\d{${t.precision}}` : `${e}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function mM(t) {
  return new RegExp(`^${b4(t)}$`);
}
function NM(t) {
  const e = b4({ precision: t.precision }), n = ["Z"];
  t.local && n.push(""), t.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const r = `${e}(?:${n.join("|")})`;
  return new RegExp(`^${T4}T(?:${r})$`);
}
const vM = (t) => {
  const e = t ? `[\\s\\S]{${(t == null ? void 0 : t.minimum) ?? 0},${(t == null ? void 0 : t.maximum) ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${e}$`);
}, gM = /^-?\d+$/, IM = /^-?\d+(?:\.\d+)?$/, OM = /^(?:true|false)$/i, AM = /^[^A-Z]*$/, DM = /^[^a-z]*$/, qn = /* @__PURE__ */ ie("$ZodCheck", (t, e) => {
  var n;
  t._zod ?? (t._zod = {}), t._zod.def = e, (n = t._zod).onattach ?? (n.onattach = []);
}), R4 = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, M4 = /* @__PURE__ */ ie("$ZodCheckLessThan", (t, e) => {
  qn.init(t, e);
  const n = R4[typeof e.value];
  t._zod.onattach.push((r) => {
    const o = r._zod.bag, i = (e.inclusive ? o.maximum : o.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    e.value < i && (e.inclusive ? o.maximum = e.value : o.exclusiveMaximum = e.value);
  }), t._zod.check = (r) => {
    (e.inclusive ? r.value <= e.value : r.value < e.value) || r.issues.push({
      origin: n,
      code: "too_big",
      maximum: typeof e.value == "object" ? e.value.getTime() : e.value,
      input: r.value,
      inclusive: e.inclusive,
      inst: t,
      continue: !e.abort
    });
  };
}), P4 = /* @__PURE__ */ ie("$ZodCheckGreaterThan", (t, e) => {
  qn.init(t, e);
  const n = R4[typeof e.value];
  t._zod.onattach.push((r) => {
    const o = r._zod.bag, i = (e.inclusive ? o.minimum : o.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    e.value > i && (e.inclusive ? o.minimum = e.value : o.exclusiveMinimum = e.value);
  }), t._zod.check = (r) => {
    (e.inclusive ? r.value >= e.value : r.value > e.value) || r.issues.push({
      origin: n,
      code: "too_small",
      minimum: typeof e.value == "object" ? e.value.getTime() : e.value,
      input: r.value,
      inclusive: e.inclusive,
      inst: t,
      continue: !e.abort
    });
  };
}), CM = /* @__PURE__ */ ie("$ZodCheckMultipleOf", (t, e) => {
  qn.init(t, e), t._zod.onattach.push((n) => {
    var r;
    (r = n._zod.bag).multipleOf ?? (r.multipleOf = e.value);
  }), t._zod.check = (n) => {
    if (typeof n.value != typeof e.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? n.value % e.value === BigInt(0) : TR(n.value, e.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: e.value,
      input: n.value,
      inst: t,
      continue: !e.abort
    });
  };
}), SM = /* @__PURE__ */ ie("$ZodCheckNumberFormat", (t, e) => {
  var a;
  qn.init(t, e), e.format = e.format || "float64";
  const n = (a = e.format) == null ? void 0 : a.includes("int"), r = n ? "int" : "number", [o, i] = yR[e.format];
  t._zod.onattach.push((s) => {
    const l = s._zod.bag;
    l.format = e.format, l.minimum = o, l.maximum = i, n && (l.pattern = gM);
  }), t._zod.check = (s) => {
    const l = s.value;
    if (n) {
      if (!Number.isInteger(l)) {
        s.issues.push({
          expected: r,
          format: e.format,
          code: "invalid_type",
          continue: !1,
          input: l,
          inst: t
        });
        return;
      }
      if (!Number.isSafeInteger(l)) {
        l > 0 ? s.issues.push({
          input: l,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: t,
          origin: r,
          inclusive: !0,
          continue: !e.abort
        }) : s.issues.push({
          input: l,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: t,
          origin: r,
          inclusive: !0,
          continue: !e.abort
        });
        return;
      }
    }
    l < o && s.issues.push({
      origin: "number",
      input: l,
      code: "too_small",
      minimum: o,
      inclusive: !0,
      inst: t,
      continue: !e.abort
    }), l > i && s.issues.push({
      origin: "number",
      input: l,
      code: "too_big",
      maximum: i,
      inclusive: !0,
      inst: t,
      continue: !e.abort
    });
  };
}), wM = /* @__PURE__ */ ie("$ZodCheckMaxLength", (t, e) => {
  var n;
  qn.init(t, e), (n = t._zod.def).when ?? (n.when = (r) => {
    const o = r.value;
    return !SE(o) && o.length !== void 0;
  }), t._zod.onattach.push((r) => {
    const o = r._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    e.maximum < o && (r._zod.bag.maximum = e.maximum);
  }), t._zod.check = (r) => {
    const o = r.value;
    if (o.length <= e.maximum)
      return;
    const a = TE(o);
    r.issues.push({
      origin: a,
      code: "too_big",
      maximum: e.maximum,
      inclusive: !0,
      input: o,
      inst: t,
      continue: !e.abort
    });
  };
}), TM = /* @__PURE__ */ ie("$ZodCheckMinLength", (t, e) => {
  var n;
  qn.init(t, e), (n = t._zod.def).when ?? (n.when = (r) => {
    const o = r.value;
    return !SE(o) && o.length !== void 0;
  }), t._zod.onattach.push((r) => {
    const o = r._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    e.minimum > o && (r._zod.bag.minimum = e.minimum);
  }), t._zod.check = (r) => {
    const o = r.value;
    if (o.length >= e.minimum)
      return;
    const a = TE(o);
    r.issues.push({
      origin: a,
      code: "too_small",
      minimum: e.minimum,
      inclusive: !0,
      input: o,
      inst: t,
      continue: !e.abort
    });
  };
}), bM = /* @__PURE__ */ ie("$ZodCheckLengthEquals", (t, e) => {
  var n;
  qn.init(t, e), (n = t._zod.def).when ?? (n.when = (r) => {
    const o = r.value;
    return !SE(o) && o.length !== void 0;
  }), t._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.minimum = e.length, o.maximum = e.length, o.length = e.length;
  }), t._zod.check = (r) => {
    const o = r.value, i = o.length;
    if (i === e.length)
      return;
    const a = TE(o), s = i > e.length;
    r.issues.push({
      origin: a,
      ...s ? { code: "too_big", maximum: e.length } : { code: "too_small", minimum: e.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: t,
      continue: !e.abort
    });
  };
}), Tf = /* @__PURE__ */ ie("$ZodCheckStringFormat", (t, e) => {
  var n, r;
  qn.init(t, e), t._zod.onattach.push((o) => {
    const i = o._zod.bag;
    i.format = e.format, e.pattern && (i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(e.pattern));
  }), e.pattern ? (n = t._zod).check ?? (n.check = (o) => {
    e.pattern.lastIndex = 0, !e.pattern.test(o.value) && o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: e.format,
      input: o.value,
      ...e.pattern ? { pattern: e.pattern.toString() } : {},
      inst: t,
      continue: !e.abort
    });
  }) : (r = t._zod).check ?? (r.check = () => {
  });
}), RM = /* @__PURE__ */ ie("$ZodCheckRegex", (t, e) => {
  Tf.init(t, e), t._zod.check = (n) => {
    e.pattern.lastIndex = 0, !e.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: e.pattern.toString(),
      inst: t,
      continue: !e.abort
    });
  };
}), MM = /* @__PURE__ */ ie("$ZodCheckLowerCase", (t, e) => {
  e.pattern ?? (e.pattern = AM), Tf.init(t, e);
}), PM = /* @__PURE__ */ ie("$ZodCheckUpperCase", (t, e) => {
  e.pattern ?? (e.pattern = DM), Tf.init(t, e);
}), yM = /* @__PURE__ */ ie("$ZodCheckIncludes", (t, e) => {
  qn.init(t, e);
  const n = Cf(e.includes), r = new RegExp(typeof e.position == "number" ? `^.{${e.position}}${n}` : n);
  e.pattern = r, t._zod.onattach.push((o) => {
    const i = o._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(r);
  }), t._zod.check = (o) => {
    o.value.includes(e.includes, e.position) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: e.includes,
      input: o.value,
      inst: t,
      continue: !e.abort
    });
  };
}), LM = /* @__PURE__ */ ie("$ZodCheckStartsWith", (t, e) => {
  qn.init(t, e);
  const n = new RegExp(`^${Cf(e.prefix)}.*`);
  e.pattern ?? (e.pattern = n), t._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n);
  }), t._zod.check = (r) => {
    r.value.startsWith(e.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: e.prefix,
      input: r.value,
      inst: t,
      continue: !e.abort
    });
  };
}), xM = /* @__PURE__ */ ie("$ZodCheckEndsWith", (t, e) => {
  qn.init(t, e);
  const n = new RegExp(`.*${Cf(e.suffix)}$`);
  e.pattern ?? (e.pattern = n), t._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n);
  }), t._zod.check = (r) => {
    r.value.endsWith(e.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: e.suffix,
      input: r.value,
      inst: t,
      continue: !e.abort
    });
  };
}), UM = /* @__PURE__ */ ie("$ZodCheckOverwrite", (t, e) => {
  qn.init(t, e), t._zod.check = (n) => {
    n.value = e.tx(n.value);
  };
});
class $M {
  constructor(e = []) {
    this.content = [], this.indent = 0, this && (this.args = e);
  }
  indented(e) {
    this.indent += 1, e(this), this.indent -= 1;
  }
  write(e) {
    if (typeof e == "function") {
      e(this, { execution: "sync" }), e(this, { execution: "async" });
      return;
    }
    const r = e.split(`
`).filter((a) => a), o = Math.min(...r.map((a) => a.length - a.trimStart().length)), i = r.map((a) => a.slice(o)).map((a) => " ".repeat(this.indent * 2) + a);
    for (const a of i)
      this.content.push(a);
  }
  compile() {
    const e = Function, n = this == null ? void 0 : this.args, o = [...((this == null ? void 0 : this.content) ?? [""]).map((i) => `  ${i}`)];
    return new e(...n, o.join(`
`));
  }
}
const kM = {
  major: 4,
  minor: 3,
  patch: 6
}, kt = /* @__PURE__ */ ie("$ZodType", (t, e) => {
  var o;
  var n;
  t ?? (t = {}), t._zod.def = e, t._zod.bag = t._zod.bag || {}, t._zod.version = kM;
  const r = [...t._zod.def.checks ?? []];
  t._zod.traits.has("$ZodCheck") && r.unshift(t);
  for (const i of r)
    for (const a of i._zod.onattach)
      a(t);
  if (r.length === 0)
    (n = t._zod).deferred ?? (n.deferred = []), (o = t._zod.deferred) == null || o.push(() => {
      t._zod.run = t._zod.parse;
    });
  else {
    const i = (s, l, c) => {
      let u = Os(s), d;
      for (const f of l) {
        if (f._zod.def.when) {
          if (!f._zod.def.when(s))
            continue;
        } else if (u)
          continue;
        const h = s.issues.length, _ = f._zod.check(s);
        if (_ instanceof Promise && (c == null ? void 0 : c.async) === !1)
          throw new ws();
        if (d || _ instanceof Promise)
          d = (d ?? Promise.resolve()).then(async () => {
            await _, s.issues.length !== h && (u || (u = Os(s, h)));
          });
        else {
          if (s.issues.length === h)
            continue;
          u || (u = Os(s, h));
        }
      }
      return d ? d.then(() => s) : s;
    }, a = (s, l, c) => {
      if (Os(s))
        return s.aborted = !0, s;
      const u = i(l, r, c);
      if (u instanceof Promise) {
        if (c.async === !1)
          throw new ws();
        return u.then((d) => t._zod.parse(d, c));
      }
      return t._zod.parse(u, c);
    };
    t._zod.run = (s, l) => {
      if (l.skipChecks)
        return t._zod.parse(s, l);
      if (l.direction === "backward") {
        const u = t._zod.parse({ value: s.value, issues: [] }, { ...l, skipChecks: !0 });
        return u instanceof Promise ? u.then((d) => a(d, s, l)) : a(u, s, l);
      }
      const c = t._zod.parse(s, l);
      if (c instanceof Promise) {
        if (l.async === !1)
          throw new ws();
        return c.then((u) => i(u, r, l));
      }
      return i(c, r, l);
    };
  }
  dt(t, "~standard", () => ({
    validate: (i) => {
      var a;
      try {
        const s = HR(t, i);
        return s.success ? { value: s.data } : { issues: (a = s.error) == null ? void 0 : a.issues };
      } catch {
        return WR(t, i).then((l) => {
          var c;
          return l.success ? { value: l.data } : { issues: (c = l.error) == null ? void 0 : c.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), ME = /* @__PURE__ */ ie("$ZodString", (t, e) => {
  var n;
  kt.init(t, e), t._zod.pattern = [...((n = t == null ? void 0 : t._zod.bag) == null ? void 0 : n.patterns) ?? []].pop() ?? vM(t._zod.bag), t._zod.parse = (r, o) => {
    if (e.coerce)
      try {
        r.value = String(r.value);
      } catch {
      }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: t
    }), r;
  };
}), bt = /* @__PURE__ */ ie("$ZodStringFormat", (t, e) => {
  Tf.init(t, e), ME.init(t, e);
}), BM = /* @__PURE__ */ ie("$ZodGUID", (t, e) => {
  e.pattern ?? (e.pattern = aM), bt.init(t, e);
}), GM = /* @__PURE__ */ ie("$ZodUUID", (t, e) => {
  if (e.version) {
    const r = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[e.version];
    if (r === void 0)
      throw new Error(`Invalid UUID version: "${e.version}"`);
    e.pattern ?? (e.pattern = Hm(r));
  } else
    e.pattern ?? (e.pattern = Hm());
  bt.init(t, e);
}), FM = /* @__PURE__ */ ie("$ZodEmail", (t, e) => {
  e.pattern ?? (e.pattern = sM), bt.init(t, e);
}), VM = /* @__PURE__ */ ie("$ZodURL", (t, e) => {
  bt.init(t, e), t._zod.check = (n) => {
    try {
      const r = n.value.trim(), o = new URL(r);
      e.hostname && (e.hostname.lastIndex = 0, e.hostname.test(o.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: e.hostname.source,
        input: n.value,
        inst: t,
        continue: !e.abort
      })), e.protocol && (e.protocol.lastIndex = 0, e.protocol.test(o.protocol.endsWith(":") ? o.protocol.slice(0, -1) : o.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: e.protocol.source,
        input: n.value,
        inst: t,
        continue: !e.abort
      })), e.normalize ? n.value = o.href : n.value = r;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: t,
        continue: !e.abort
      });
    }
  };
}), HM = /* @__PURE__ */ ie("$ZodEmoji", (t, e) => {
  e.pattern ?? (e.pattern = cM()), bt.init(t, e);
}), WM = /* @__PURE__ */ ie("$ZodNanoID", (t, e) => {
  e.pattern ?? (e.pattern = oM), bt.init(t, e);
}), YM = /* @__PURE__ */ ie("$ZodCUID", (t, e) => {
  e.pattern ?? (e.pattern = QR), bt.init(t, e);
}), KM = /* @__PURE__ */ ie("$ZodCUID2", (t, e) => {
  e.pattern ?? (e.pattern = eM), bt.init(t, e);
}), zM = /* @__PURE__ */ ie("$ZodULID", (t, e) => {
  e.pattern ?? (e.pattern = tM), bt.init(t, e);
}), ZM = /* @__PURE__ */ ie("$ZodXID", (t, e) => {
  e.pattern ?? (e.pattern = nM), bt.init(t, e);
}), qM = /* @__PURE__ */ ie("$ZodKSUID", (t, e) => {
  e.pattern ?? (e.pattern = rM), bt.init(t, e);
}), XM = /* @__PURE__ */ ie("$ZodISODateTime", (t, e) => {
  e.pattern ?? (e.pattern = NM(e)), bt.init(t, e);
}), jM = /* @__PURE__ */ ie("$ZodISODate", (t, e) => {
  e.pattern ?? (e.pattern = pM), bt.init(t, e);
}), JM = /* @__PURE__ */ ie("$ZodISOTime", (t, e) => {
  e.pattern ?? (e.pattern = mM(e)), bt.init(t, e);
}), QM = /* @__PURE__ */ ie("$ZodISODuration", (t, e) => {
  e.pattern ?? (e.pattern = iM), bt.init(t, e);
}), eP = /* @__PURE__ */ ie("$ZodIPv4", (t, e) => {
  e.pattern ?? (e.pattern = uM), bt.init(t, e), t._zod.bag.format = "ipv4";
}), tP = /* @__PURE__ */ ie("$ZodIPv6", (t, e) => {
  e.pattern ?? (e.pattern = dM), bt.init(t, e), t._zod.bag.format = "ipv6", t._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: t,
        continue: !e.abort
      });
    }
  };
}), nP = /* @__PURE__ */ ie("$ZodCIDRv4", (t, e) => {
  e.pattern ?? (e.pattern = fM), bt.init(t, e);
}), rP = /* @__PURE__ */ ie("$ZodCIDRv6", (t, e) => {
  e.pattern ?? (e.pattern = hM), bt.init(t, e), t._zod.check = (n) => {
    const r = n.value.split("/");
    try {
      if (r.length !== 2)
        throw new Error();
      const [o, i] = r;
      if (!i)
        throw new Error();
      const a = Number(i);
      if (`${a}` !== i)
        throw new Error();
      if (a < 0 || a > 128)
        throw new Error();
      new URL(`http://[${o}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: t,
        continue: !e.abort
      });
    }
  };
});
function y4(t) {
  if (t === "")
    return !0;
  if (t.length % 4 !== 0)
    return !1;
  try {
    return atob(t), !0;
  } catch {
    return !1;
  }
}
const oP = /* @__PURE__ */ ie("$ZodBase64", (t, e) => {
  e.pattern ?? (e.pattern = _M), bt.init(t, e), t._zod.bag.contentEncoding = "base64", t._zod.check = (n) => {
    y4(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: t,
      continue: !e.abort
    });
  };
});
function iP(t) {
  if (!w4.test(t))
    return !1;
  const e = t.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = e.padEnd(Math.ceil(e.length / 4) * 4, "=");
  return y4(n);
}
const aP = /* @__PURE__ */ ie("$ZodBase64URL", (t, e) => {
  e.pattern ?? (e.pattern = w4), bt.init(t, e), t._zod.bag.contentEncoding = "base64url", t._zod.check = (n) => {
    iP(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: t,
      continue: !e.abort
    });
  };
}), sP = /* @__PURE__ */ ie("$ZodE164", (t, e) => {
  e.pattern ?? (e.pattern = EM), bt.init(t, e);
});
function lP(t, e = null) {
  try {
    const n = t.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n;
    if (!r)
      return !1;
    const o = JSON.parse(atob(r));
    return !("typ" in o && (o == null ? void 0 : o.typ) !== "JWT" || !o.alg || e && (!("alg" in o) || o.alg !== e));
  } catch {
    return !1;
  }
}
const cP = /* @__PURE__ */ ie("$ZodJWT", (t, e) => {
  bt.init(t, e), t._zod.check = (n) => {
    lP(n.value, e.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: t,
      continue: !e.abort
    });
  };
}), L4 = /* @__PURE__ */ ie("$ZodNumber", (t, e) => {
  kt.init(t, e), t._zod.pattern = t._zod.bag.pattern ?? IM, t._zod.parse = (n, r) => {
    if (e.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const o = n.value;
    if (typeof o == "number" && !Number.isNaN(o) && Number.isFinite(o))
      return n;
    const i = typeof o == "number" ? Number.isNaN(o) ? "NaN" : Number.isFinite(o) ? void 0 : "Infinity" : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: o,
      inst: t,
      ...i ? { received: i } : {}
    }), n;
  };
}), uP = /* @__PURE__ */ ie("$ZodNumberFormat", (t, e) => {
  SM.init(t, e), L4.init(t, e);
}), dP = /* @__PURE__ */ ie("$ZodBoolean", (t, e) => {
  kt.init(t, e), t._zod.pattern = OM, t._zod.parse = (n, r) => {
    if (e.coerce)
      try {
        n.value = !!n.value;
      } catch {
      }
    const o = n.value;
    return typeof o == "boolean" || n.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: o,
      inst: t
    }), n;
  };
}), fP = /* @__PURE__ */ ie("$ZodAny", (t, e) => {
  kt.init(t, e), t._zod.parse = (n) => n;
}), hP = /* @__PURE__ */ ie("$ZodUnknown", (t, e) => {
  kt.init(t, e), t._zod.parse = (n) => n;
}), _P = /* @__PURE__ */ ie("$ZodNever", (t, e) => {
  kt.init(t, e), t._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: t
  }), n);
});
function Wm(t, e, n) {
  t.issues.length && e.issues.push(...A4(n, t.issues)), e.value[n] = t.value;
}
const EP = /* @__PURE__ */ ie("$ZodArray", (t, e) => {
  kt.init(t, e), t._zod.parse = (n, r) => {
    const o = n.value;
    if (!Array.isArray(o))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: o,
        inst: t
      }), n;
    n.value = Array(o.length);
    const i = [];
    for (let a = 0; a < o.length; a++) {
      const s = o[a], l = e.element._zod.run({
        value: s,
        issues: []
      }, r);
      l instanceof Promise ? i.push(l.then((c) => Wm(c, n, a))) : Wm(l, n, a);
    }
    return i.length ? Promise.all(i).then(() => n) : n;
  };
});
function Ad(t, e, n, r, o) {
  if (t.issues.length) {
    if (o && !(n in r))
      return;
    e.issues.push(...A4(n, t.issues));
  }
  t.value === void 0 ? n in r && (e.value[n] = void 0) : e.value[n] = t.value;
}
function x4(t) {
  var r, o, i, a;
  const e = Object.keys(t.shape);
  for (const s of e)
    if (!((a = (i = (o = (r = t.shape) == null ? void 0 : r[s]) == null ? void 0 : o._zod) == null ? void 0 : i.traits) != null && a.has("$ZodType")))
      throw new Error(`Invalid element at key "${s}": expected a Zod schema`);
  const n = PR(t.shape);
  return {
    ...t,
    keys: e,
    keySet: new Set(e),
    numKeys: e.length,
    optionalKeys: new Set(n)
  };
}
function U4(t, e, n, r, o, i) {
  const a = [], s = o.keySet, l = o.catchall._zod, c = l.def.type, u = l.optout === "optional";
  for (const d in e) {
    if (s.has(d))
      continue;
    if (c === "never") {
      a.push(d);
      continue;
    }
    const f = l.run({ value: e[d], issues: [] }, r);
    f instanceof Promise ? t.push(f.then((h) => Ad(h, n, d, e, u))) : Ad(f, n, d, e, u);
  }
  return a.length && n.issues.push({
    code: "unrecognized_keys",
    keys: a,
    input: e,
    inst: i
  }), t.length ? Promise.all(t).then(() => n) : n;
}
const pP = /* @__PURE__ */ ie("$ZodObject", (t, e) => {
  kt.init(t, e);
  const n = Object.getOwnPropertyDescriptor(e, "shape");
  if (!(n != null && n.get)) {
    const s = e.shape;
    Object.defineProperty(e, "shape", {
      get: () => {
        const l = { ...s };
        return Object.defineProperty(e, "shape", {
          value: l
        }), l;
      }
    });
  }
  const r = CE(() => x4(e));
  dt(t._zod, "propValues", () => {
    const s = e.shape, l = {};
    for (const c in s) {
      const u = s[c]._zod;
      if (u.values) {
        l[c] ?? (l[c] = /* @__PURE__ */ new Set());
        for (const d of u.values)
          l[c].add(d);
      }
    }
    return l;
  });
  const o = Od, i = e.catchall;
  let a;
  t._zod.parse = (s, l) => {
    a ?? (a = r.value);
    const c = s.value;
    if (!o(c))
      return s.issues.push({
        expected: "object",
        code: "invalid_type",
        input: c,
        inst: t
      }), s;
    s.value = {};
    const u = [], d = a.shape;
    for (const f of a.keys) {
      const h = d[f], _ = h._zod.optout === "optional", E = h._zod.run({ value: c[f], issues: [] }, l);
      E instanceof Promise ? u.push(E.then((m) => Ad(m, s, f, c, _))) : Ad(E, s, f, c, _);
    }
    return i ? U4(u, c, s, l, r.value, t) : u.length ? Promise.all(u).then(() => s) : s;
  };
}), mP = /* @__PURE__ */ ie("$ZodObjectJIT", (t, e) => {
  pP.init(t, e);
  const n = t._zod.parse, r = CE(() => x4(e)), o = (f) => {
    var O;
    const h = new $M(["shape", "payload", "ctx"]), _ = r.value, E = (p) => {
      const C = Vm(p);
      return `shape[${C}]._zod.run({ value: input[${C}], issues: [] }, ctx)`;
    };
    h.write("const input = payload.value;");
    const m = /* @__PURE__ */ Object.create(null);
    let N = 0;
    for (const p of _.keys)
      m[p] = `key_${N++}`;
    h.write("const newResult = {};");
    for (const p of _.keys) {
      const C = m[p], D = Vm(p), T = f[p], k = ((O = T == null ? void 0 : T._zod) == null ? void 0 : O.optout) === "optional";
      h.write(`const ${C} = ${E(p)};`), k ? h.write(`
        if (${C}.issues.length) {
          if (${D} in input) {
            payload.issues = payload.issues.concat(${C}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${D}, ...iss.path] : [${D}]
            })));
          }
        }
        
        if (${C}.value === undefined) {
          if (${D} in input) {
            newResult[${D}] = undefined;
          }
        } else {
          newResult[${D}] = ${C}.value;
        }
        
      `) : h.write(`
        if (${C}.issues.length) {
          payload.issues = payload.issues.concat(${C}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${D}, ...iss.path] : [${D}]
          })));
        }
        
        if (${C}.value === undefined) {
          if (${D} in input) {
            newResult[${D}] = undefined;
          }
        } else {
          newResult[${D}] = ${C}.value;
        }
        
      `);
    }
    h.write("payload.value = newResult;"), h.write("return payload;");
    const I = h.compile();
    return (p, C) => I(f, p, C);
  };
  let i;
  const a = Od, s = !i0.jitless, c = s && RR.value, u = e.catchall;
  let d;
  t._zod.parse = (f, h) => {
    d ?? (d = r.value);
    const _ = f.value;
    return a(_) ? s && c && (h == null ? void 0 : h.async) === !1 && h.jitless !== !0 ? (i || (i = o(e.shape)), f = i(f, h), u ? U4([], _, f, h, d, t) : f) : n(f, h) : (f.issues.push({
      expected: "object",
      code: "invalid_type",
      input: _,
      inst: t
    }), f);
  };
});
function Ym(t, e, n, r) {
  for (const i of t)
    if (i.issues.length === 0)
      return e.value = i.value, e;
  const o = t.filter((i) => !Os(i));
  return o.length === 1 ? (e.value = o[0].value, o[0]) : (e.issues.push({
    code: "invalid_union",
    input: e.value,
    inst: n,
    errors: t.map((i) => i.issues.map((a) => Da(a, r, Aa())))
  }), e);
}
const NP = /* @__PURE__ */ ie("$ZodUnion", (t, e) => {
  kt.init(t, e), dt(t._zod, "optin", () => e.options.some((o) => o._zod.optin === "optional") ? "optional" : void 0), dt(t._zod, "optout", () => e.options.some((o) => o._zod.optout === "optional") ? "optional" : void 0), dt(t._zod, "values", () => {
    if (e.options.every((o) => o._zod.values))
      return new Set(e.options.flatMap((o) => Array.from(o._zod.values)));
  }), dt(t._zod, "pattern", () => {
    if (e.options.every((o) => o._zod.pattern)) {
      const o = e.options.map((i) => i._zod.pattern);
      return new RegExp(`^(${o.map((i) => wE(i.source)).join("|")})$`);
    }
  });
  const n = e.options.length === 1, r = e.options[0]._zod.run;
  t._zod.parse = (o, i) => {
    if (n)
      return r(o, i);
    let a = !1;
    const s = [];
    for (const l of e.options) {
      const c = l._zod.run({
        value: o.value,
        issues: []
      }, i);
      if (c instanceof Promise)
        s.push(c), a = !0;
      else {
        if (c.issues.length === 0)
          return c;
        s.push(c);
      }
    }
    return a ? Promise.all(s).then((l) => Ym(l, o, t, i)) : Ym(s, o, t, i);
  };
}), vP = /* @__PURE__ */ ie("$ZodIntersection", (t, e) => {
  kt.init(t, e), t._zod.parse = (n, r) => {
    const o = n.value, i = e.left._zod.run({ value: o, issues: [] }, r), a = e.right._zod.run({ value: o, issues: [] }, r);
    return i instanceof Promise || a instanceof Promise ? Promise.all([i, a]).then(([l, c]) => Km(n, l, c)) : Km(n, i, a);
  };
});
function s0(t, e) {
  if (t === e)
    return { valid: !0, data: t };
  if (t instanceof Date && e instanceof Date && +t == +e)
    return { valid: !0, data: t };
  if (pc(t) && pc(e)) {
    const n = Object.keys(e), r = Object.keys(t).filter((i) => n.indexOf(i) !== -1), o = { ...t, ...e };
    for (const i of r) {
      const a = s0(t[i], e[i]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [i, ...a.mergeErrorPath]
        };
      o[i] = a.data;
    }
    return { valid: !0, data: o };
  }
  if (Array.isArray(t) && Array.isArray(e)) {
    if (t.length !== e.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < t.length; r++) {
      const o = t[r], i = e[r], a = s0(o, i);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...a.mergeErrorPath]
        };
      n.push(a.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Km(t, e, n) {
  const r = /* @__PURE__ */ new Map();
  let o;
  for (const s of e.issues)
    if (s.code === "unrecognized_keys") {
      o ?? (o = s);
      for (const l of s.keys)
        r.has(l) || r.set(l, {}), r.get(l).l = !0;
    } else
      t.issues.push(s);
  for (const s of n.issues)
    if (s.code === "unrecognized_keys")
      for (const l of s.keys)
        r.has(l) || r.set(l, {}), r.get(l).r = !0;
    else
      t.issues.push(s);
  const i = [...r].filter(([, s]) => s.l && s.r).map(([s]) => s);
  if (i.length && o && t.issues.push({ ...o, keys: i }), Os(t))
    return t;
  const a = s0(e.value, n.value);
  if (!a.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(a.mergeErrorPath)}`);
  return t.value = a.data, t;
}
const gP = /* @__PURE__ */ ie("$ZodEnum", (t, e) => {
  kt.init(t, e);
  const n = g4(e.entries), r = new Set(n);
  t._zod.values = r, t._zod.pattern = new RegExp(`^(${n.filter((o) => MR.has(typeof o)).map((o) => typeof o == "string" ? Cf(o) : o.toString()).join("|")})$`), t._zod.parse = (o, i) => {
    const a = o.value;
    return r.has(a) || o.issues.push({
      code: "invalid_value",
      values: n,
      input: a,
      inst: t
    }), o;
  };
}), IP = /* @__PURE__ */ ie("$ZodTransform", (t, e) => {
  kt.init(t, e), t._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new v4(t.constructor.name);
    const o = e.transform(n.value, n);
    if (r.async)
      return (o instanceof Promise ? o : Promise.resolve(o)).then((a) => (n.value = a, n));
    if (o instanceof Promise)
      throw new ws();
    return n.value = o, n;
  };
});
function zm(t, e) {
  return t.issues.length && e === void 0 ? { issues: [], value: void 0 } : t;
}
const $4 = /* @__PURE__ */ ie("$ZodOptional", (t, e) => {
  kt.init(t, e), t._zod.optin = "optional", t._zod.optout = "optional", dt(t._zod, "values", () => e.innerType._zod.values ? /* @__PURE__ */ new Set([...e.innerType._zod.values, void 0]) : void 0), dt(t._zod, "pattern", () => {
    const n = e.innerType._zod.pattern;
    return n ? new RegExp(`^(${wE(n.source)})?$`) : void 0;
  }), t._zod.parse = (n, r) => {
    if (e.innerType._zod.optin === "optional") {
      const o = e.innerType._zod.run(n, r);
      return o instanceof Promise ? o.then((i) => zm(i, n.value)) : zm(o, n.value);
    }
    return n.value === void 0 ? n : e.innerType._zod.run(n, r);
  };
}), OP = /* @__PURE__ */ ie("$ZodExactOptional", (t, e) => {
  $4.init(t, e), dt(t._zod, "values", () => e.innerType._zod.values), dt(t._zod, "pattern", () => e.innerType._zod.pattern), t._zod.parse = (n, r) => e.innerType._zod.run(n, r);
}), AP = /* @__PURE__ */ ie("$ZodNullable", (t, e) => {
  kt.init(t, e), dt(t._zod, "optin", () => e.innerType._zod.optin), dt(t._zod, "optout", () => e.innerType._zod.optout), dt(t._zod, "pattern", () => {
    const n = e.innerType._zod.pattern;
    return n ? new RegExp(`^(${wE(n.source)}|null)$`) : void 0;
  }), dt(t._zod, "values", () => e.innerType._zod.values ? /* @__PURE__ */ new Set([...e.innerType._zod.values, null]) : void 0), t._zod.parse = (n, r) => n.value === null ? n : e.innerType._zod.run(n, r);
}), DP = /* @__PURE__ */ ie("$ZodDefault", (t, e) => {
  kt.init(t, e), t._zod.optin = "optional", dt(t._zod, "values", () => e.innerType._zod.values), t._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return e.innerType._zod.run(n, r);
    if (n.value === void 0)
      return n.value = e.defaultValue, n;
    const o = e.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((i) => Zm(i, e)) : Zm(o, e);
  };
});
function Zm(t, e) {
  return t.value === void 0 && (t.value = e.defaultValue), t;
}
const CP = /* @__PURE__ */ ie("$ZodPrefault", (t, e) => {
  kt.init(t, e), t._zod.optin = "optional", dt(t._zod, "values", () => e.innerType._zod.values), t._zod.parse = (n, r) => (r.direction === "backward" || n.value === void 0 && (n.value = e.defaultValue), e.innerType._zod.run(n, r));
}), SP = /* @__PURE__ */ ie("$ZodNonOptional", (t, e) => {
  kt.init(t, e), dt(t._zod, "values", () => {
    const n = e.innerType._zod.values;
    return n ? new Set([...n].filter((r) => r !== void 0)) : void 0;
  }), t._zod.parse = (n, r) => {
    const o = e.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((i) => qm(i, t)) : qm(o, t);
  };
});
function qm(t, e) {
  return !t.issues.length && t.value === void 0 && t.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: t.value,
    inst: e
  }), t;
}
const wP = /* @__PURE__ */ ie("$ZodCatch", (t, e) => {
  kt.init(t, e), dt(t._zod, "optin", () => e.innerType._zod.optin), dt(t._zod, "optout", () => e.innerType._zod.optout), dt(t._zod, "values", () => e.innerType._zod.values), t._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return e.innerType._zod.run(n, r);
    const o = e.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((i) => (n.value = i.value, i.issues.length && (n.value = e.catchValue({
      ...n,
      error: {
        issues: i.issues.map((a) => Da(a, r, Aa()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = o.value, o.issues.length && (n.value = e.catchValue({
      ...n,
      error: {
        issues: o.issues.map((i) => Da(i, r, Aa()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), TP = /* @__PURE__ */ ie("$ZodPipe", (t, e) => {
  kt.init(t, e), dt(t._zod, "values", () => e.in._zod.values), dt(t._zod, "optin", () => e.in._zod.optin), dt(t._zod, "optout", () => e.out._zod.optout), dt(t._zod, "propValues", () => e.in._zod.propValues), t._zod.parse = (n, r) => {
    if (r.direction === "backward") {
      const i = e.out._zod.run(n, r);
      return i instanceof Promise ? i.then((a) => Tu(a, e.in, r)) : Tu(i, e.in, r);
    }
    const o = e.in._zod.run(n, r);
    return o instanceof Promise ? o.then((i) => Tu(i, e.out, r)) : Tu(o, e.out, r);
  };
});
function Tu(t, e, n) {
  return t.issues.length ? (t.aborted = !0, t) : e._zod.run({ value: t.value, issues: t.issues }, n);
}
const bP = /* @__PURE__ */ ie("$ZodReadonly", (t, e) => {
  kt.init(t, e), dt(t._zod, "propValues", () => e.innerType._zod.propValues), dt(t._zod, "values", () => e.innerType._zod.values), dt(t._zod, "optin", () => {
    var n, r;
    return (r = (n = e.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optin;
  }), dt(t._zod, "optout", () => {
    var n, r;
    return (r = (n = e.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optout;
  }), t._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return e.innerType._zod.run(n, r);
    const o = e.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then(Xm) : Xm(o);
  };
});
function Xm(t) {
  return t.value = Object.freeze(t.value), t;
}
const RP = /* @__PURE__ */ ie("$ZodCustom", (t, e) => {
  qn.init(t, e), kt.init(t, e), t._zod.parse = (n, r) => n, t._zod.check = (n) => {
    const r = n.value, o = e.fn(r);
    if (o instanceof Promise)
      return o.then((i) => jm(i, n, r, t));
    jm(o, n, r, t);
  };
});
function jm(t, e, n, r) {
  if (!t) {
    const o = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (o.params = r._zod.def.params), e.issues.push(mc(o));
  }
}
var Jm;
class MP {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(e, ...n) {
    const r = n[0];
    return this._map.set(e, r), r && typeof r == "object" && "id" in r && this._idmap.set(r.id, e), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(e) {
    const n = this._map.get(e);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(e), this;
  }
  get(e) {
    const n = e._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      delete r.id;
      const o = { ...r, ...this._map.get(e) };
      return Object.keys(o).length ? o : void 0;
    }
    return this._map.get(e);
  }
  has(e) {
    return this._map.has(e);
  }
}
function PP() {
  return new MP();
}
(Jm = globalThis).__zod_globalRegistry ?? (Jm.__zod_globalRegistry = PP());
const Ll = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function yP(t, e) {
  return new t({
    type: "string",
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function LP(t, e) {
  return new t({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function Qm(t, e) {
  return new t({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function xP(t, e) {
  return new t({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function UP(t, e) {
  return new t({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function $P(t, e) {
  return new t({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function kP(t, e) {
  return new t({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function BP(t, e) {
  return new t({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function GP(t, e) {
  return new t({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function FP(t, e) {
  return new t({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function VP(t, e) {
  return new t({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function HP(t, e) {
  return new t({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function WP(t, e) {
  return new t({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function YP(t, e) {
  return new t({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function KP(t, e) {
  return new t({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function zP(t, e) {
  return new t({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function ZP(t, e) {
  return new t({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function qP(t, e) {
  return new t({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function XP(t, e) {
  return new t({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function jP(t, e) {
  return new t({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function JP(t, e) {
  return new t({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function QP(t, e) {
  return new t({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function ey(t, e) {
  return new t({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function ty(t, e) {
  return new t({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function ny(t, e) {
  return new t({
    type: "string",
    format: "date",
    check: "string_format",
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function ry(t, e) {
  return new t({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function oy(t, e) {
  return new t({
    type: "string",
    format: "duration",
    check: "string_format",
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function iy(t, e) {
  return new t({
    type: "number",
    checks: [],
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function ay(t, e) {
  return new t({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function sy(t, e) {
  return new t({
    type: "boolean",
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function ly(t) {
  return new t({
    type: "any"
  });
}
// @__NO_SIDE_EFFECTS__
function cy(t) {
  return new t({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function uy(t, e) {
  return new t({
    type: "never",
    ...$e(e)
  });
}
// @__NO_SIDE_EFFECTS__
function eN(t, e) {
  return new M4({
    check: "less_than",
    ...$e(e),
    value: t,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function b1(t, e) {
  return new M4({
    check: "less_than",
    ...$e(e),
    value: t,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function tN(t, e) {
  return new P4({
    check: "greater_than",
    ...$e(e),
    value: t,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function R1(t, e) {
  return new P4({
    check: "greater_than",
    ...$e(e),
    value: t,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function nN(t, e) {
  return new CM({
    check: "multiple_of",
    ...$e(e),
    value: t
  });
}
// @__NO_SIDE_EFFECTS__
function k4(t, e) {
  return new wM({
    check: "max_length",
    ...$e(e),
    maximum: t
  });
}
// @__NO_SIDE_EFFECTS__
function Dd(t, e) {
  return new TM({
    check: "min_length",
    ...$e(e),
    minimum: t
  });
}
// @__NO_SIDE_EFFECTS__
function B4(t, e) {
  return new bM({
    check: "length_equals",
    ...$e(e),
    length: t
  });
}
// @__NO_SIDE_EFFECTS__
function dy(t, e) {
  return new RM({
    check: "string_format",
    format: "regex",
    ...$e(e),
    pattern: t
  });
}
// @__NO_SIDE_EFFECTS__
function fy(t) {
  return new MM({
    check: "string_format",
    format: "lowercase",
    ...$e(t)
  });
}
// @__NO_SIDE_EFFECTS__
function hy(t) {
  return new PM({
    check: "string_format",
    format: "uppercase",
    ...$e(t)
  });
}
// @__NO_SIDE_EFFECTS__
function _y(t, e) {
  return new yM({
    check: "string_format",
    format: "includes",
    ...$e(e),
    includes: t
  });
}
// @__NO_SIDE_EFFECTS__
function Ey(t, e) {
  return new LM({
    check: "string_format",
    format: "starts_with",
    ...$e(e),
    prefix: t
  });
}
// @__NO_SIDE_EFFECTS__
function py(t, e) {
  return new xM({
    check: "string_format",
    format: "ends_with",
    ...$e(e),
    suffix: t
  });
}
// @__NO_SIDE_EFFECTS__
function nl(t) {
  return new UM({
    check: "overwrite",
    tx: t
  });
}
// @__NO_SIDE_EFFECTS__
function my(t) {
  return /* @__PURE__ */ nl((e) => e.normalize(t));
}
// @__NO_SIDE_EFFECTS__
function Ny() {
  return /* @__PURE__ */ nl((t) => t.trim());
}
// @__NO_SIDE_EFFECTS__
function vy() {
  return /* @__PURE__ */ nl((t) => t.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function gy() {
  return /* @__PURE__ */ nl((t) => t.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function Iy() {
  return /* @__PURE__ */ nl((t) => bR(t));
}
// @__NO_SIDE_EFFECTS__
function Oy(t, e, n) {
  return new t({
    type: "array",
    element: e,
    // get element() {
    //   return element;
    // },
    ...$e(n)
  });
}
// @__NO_SIDE_EFFECTS__
function Ay(t, e, n) {
  return new t({
    type: "custom",
    check: "custom",
    fn: e,
    ...$e(n)
  });
}
// @__NO_SIDE_EFFECTS__
function Dy(t) {
  const e = /* @__PURE__ */ Cy((n) => (n.addIssue = (r) => {
    if (typeof r == "string")
      n.issues.push(mc(r, n.value, e._zod.def));
    else {
      const o = r;
      o.fatal && (o.continue = !1), o.code ?? (o.code = "custom"), o.input ?? (o.input = n.value), o.inst ?? (o.inst = e), o.continue ?? (o.continue = !e._zod.def.abort), n.issues.push(mc(o));
    }
  }, t(n.value, n)));
  return e;
}
// @__NO_SIDE_EFFECTS__
function Cy(t, e) {
  const n = new qn({
    check: "custom",
    ...$e(e)
  });
  return n._zod.check = t, n;
}
function G4(t) {
  let e = (t == null ? void 0 : t.target) ?? "draft-2020-12";
  return e === "draft-4" && (e = "draft-04"), e === "draft-7" && (e = "draft-07"), {
    processors: t.processors ?? {},
    metadataRegistry: (t == null ? void 0 : t.metadata) ?? Ll,
    target: e,
    unrepresentable: (t == null ? void 0 : t.unrepresentable) ?? "throw",
    override: (t == null ? void 0 : t.override) ?? (() => {
    }),
    io: (t == null ? void 0 : t.io) ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: (t == null ? void 0 : t.cycles) ?? "ref",
    reused: (t == null ? void 0 : t.reused) ?? "inline",
    external: (t == null ? void 0 : t.external) ?? void 0
  };
}
function _n(t, e, n = { path: [], schemaPath: [] }) {
  var u, d;
  var r;
  const o = t._zod.def, i = e.seen.get(t);
  if (i)
    return i.count++, n.schemaPath.includes(t) && (i.cycle = n.path), i.schema;
  const a = { schema: {}, count: 1, cycle: void 0, path: n.path };
  e.seen.set(t, a);
  const s = (d = (u = t._zod).toJSONSchema) == null ? void 0 : d.call(u);
  if (s)
    a.schema = s;
  else {
    const f = {
      ...n,
      schemaPath: [...n.schemaPath, t],
      path: n.path
    };
    if (t._zod.processJSONSchema)
      t._zod.processJSONSchema(e, a.schema, f);
    else {
      const _ = a.schema, E = e.processors[o.type];
      if (!E)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${o.type}`);
      E(t, e, _, f);
    }
    const h = t._zod.parent;
    h && (a.ref || (a.ref = h), _n(h, e, f), e.seen.get(h).isParent = !0);
  }
  const l = e.metadataRegistry.get(t);
  return l && Object.assign(a.schema, l), e.io === "input" && wn(t) && (delete a.schema.examples, delete a.schema.default), e.io === "input" && a.schema._prefault && ((r = a.schema).default ?? (r.default = a.schema._prefault)), delete a.schema._prefault, e.seen.get(t).schema;
}
function F4(t, e) {
  var a, s, l, c;
  const n = t.seen.get(e);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const r = /* @__PURE__ */ new Map();
  for (const u of t.seen.entries()) {
    const d = (a = t.metadataRegistry.get(u[0])) == null ? void 0 : a.id;
    if (d) {
      const f = r.get(d);
      if (f && f !== u[0])
        throw new Error(`Duplicate schema id "${d}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      r.set(d, u[0]);
    }
  }
  const o = (u) => {
    var E;
    const d = t.target === "draft-2020-12" ? "$defs" : "definitions";
    if (t.external) {
      const m = (E = t.external.registry.get(u[0])) == null ? void 0 : E.id, N = t.external.uri ?? ((O) => O);
      if (m)
        return { ref: N(m) };
      const I = u[1].defId ?? u[1].schema.id ?? `schema${t.counter++}`;
      return u[1].defId = I, { defId: I, ref: `${N("__shared")}#/${d}/${I}` };
    }
    if (u[1] === n)
      return { ref: "#" };
    const h = `#/${d}/`, _ = u[1].schema.id ?? `__schema${t.counter++}`;
    return { defId: _, ref: h + _ };
  }, i = (u) => {
    if (u[1].schema.$ref)
      return;
    const d = u[1], { ref: f, defId: h } = o(u);
    d.def = { ...d.schema }, h && (d.defId = h);
    const _ = d.schema;
    for (const E in _)
      delete _[E];
    _.$ref = f;
  };
  if (t.cycles === "throw")
    for (const u of t.seen.entries()) {
      const d = u[1];
      if (d.cycle)
        throw new Error(`Cycle detected: #/${(s = d.cycle) == null ? void 0 : s.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const u of t.seen.entries()) {
    const d = u[1];
    if (e === u[0]) {
      i(u);
      continue;
    }
    if (t.external) {
      const h = (l = t.external.registry.get(u[0])) == null ? void 0 : l.id;
      if (e !== u[0] && h) {
        i(u);
        continue;
      }
    }
    if ((c = t.metadataRegistry.get(u[0])) == null ? void 0 : c.id) {
      i(u);
      continue;
    }
    if (d.cycle) {
      i(u);
      continue;
    }
    if (d.count > 1 && t.reused === "ref") {
      i(u);
      continue;
    }
  }
}
function V4(t, e) {
  var a, s, l;
  const n = t.seen.get(e);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const r = (c) => {
    const u = t.seen.get(c);
    if (u.ref === null)
      return;
    const d = u.def ?? u.schema, f = { ...d }, h = u.ref;
    if (u.ref = null, h) {
      r(h);
      const E = t.seen.get(h), m = E.schema;
      if (m.$ref && (t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0") ? (d.allOf = d.allOf ?? [], d.allOf.push(m)) : Object.assign(d, m), Object.assign(d, f), c._zod.parent === h)
        for (const I in d)
          I === "$ref" || I === "allOf" || I in f || delete d[I];
      if (m.$ref && E.def)
        for (const I in d)
          I === "$ref" || I === "allOf" || I in E.def && JSON.stringify(d[I]) === JSON.stringify(E.def[I]) && delete d[I];
    }
    const _ = c._zod.parent;
    if (_ && _ !== h) {
      r(_);
      const E = t.seen.get(_);
      if (E != null && E.schema.$ref && (d.$ref = E.schema.$ref, E.def))
        for (const m in d)
          m === "$ref" || m === "allOf" || m in E.def && JSON.stringify(d[m]) === JSON.stringify(E.def[m]) && delete d[m];
    }
    t.override({
      zodSchema: c,
      jsonSchema: d,
      path: u.path ?? []
    });
  };
  for (const c of [...t.seen.entries()].reverse())
    r(c[0]);
  const o = {};
  if (t.target === "draft-2020-12" ? o.$schema = "https://json-schema.org/draft/2020-12/schema" : t.target === "draft-07" ? o.$schema = "http://json-schema.org/draft-07/schema#" : t.target === "draft-04" ? o.$schema = "http://json-schema.org/draft-04/schema#" : t.target, (a = t.external) != null && a.uri) {
    const c = (s = t.external.registry.get(e)) == null ? void 0 : s.id;
    if (!c)
      throw new Error("Schema is missing an `id` property");
    o.$id = t.external.uri(c);
  }
  Object.assign(o, n.def ?? n.schema);
  const i = ((l = t.external) == null ? void 0 : l.defs) ?? {};
  for (const c of t.seen.entries()) {
    const u = c[1];
    u.def && u.defId && (i[u.defId] = u.def);
  }
  t.external || Object.keys(i).length > 0 && (t.target === "draft-2020-12" ? o.$defs = i : o.definitions = i);
  try {
    const c = JSON.parse(JSON.stringify(o));
    return Object.defineProperty(c, "~standard", {
      value: {
        ...e["~standard"],
        jsonSchema: {
          input: Cd(e, "input", t.processors),
          output: Cd(e, "output", t.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), c;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function wn(t, e) {
  const n = e ?? { seen: /* @__PURE__ */ new Set() };
  if (n.seen.has(t))
    return !1;
  n.seen.add(t);
  const r = t._zod.def;
  if (r.type === "transform")
    return !0;
  if (r.type === "array")
    return wn(r.element, n);
  if (r.type === "set")
    return wn(r.valueType, n);
  if (r.type === "lazy")
    return wn(r.getter(), n);
  if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault")
    return wn(r.innerType, n);
  if (r.type === "intersection")
    return wn(r.left, n) || wn(r.right, n);
  if (r.type === "record" || r.type === "map")
    return wn(r.keyType, n) || wn(r.valueType, n);
  if (r.type === "pipe")
    return wn(r.in, n) || wn(r.out, n);
  if (r.type === "object") {
    for (const o in r.shape)
      if (wn(r.shape[o], n))
        return !0;
    return !1;
  }
  if (r.type === "union") {
    for (const o of r.options)
      if (wn(o, n))
        return !0;
    return !1;
  }
  if (r.type === "tuple") {
    for (const o of r.items)
      if (wn(o, n))
        return !0;
    return !!(r.rest && wn(r.rest, n));
  }
  return !1;
}
const Sy = (t, e = {}) => (n) => {
  const r = G4({ ...n, processors: e });
  return _n(t, r), F4(r, t), V4(r, t);
}, Cd = (t, e, n = {}) => (r) => {
  const { libraryOptions: o, target: i } = r ?? {}, a = G4({ ...o ?? {}, target: i, io: e, processors: n });
  return _n(t, a), F4(a, t), V4(a, t);
}, wy = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, Ty = (t, e, n, r) => {
  const o = n;
  o.type = "string";
  const { minimum: i, maximum: a, format: s, patterns: l, contentEncoding: c } = t._zod.bag;
  if (typeof i == "number" && (o.minLength = i), typeof a == "number" && (o.maxLength = a), s && (o.format = wy[s] ?? s, o.format === "" && delete o.format, s === "time" && delete o.format), c && (o.contentEncoding = c), l && l.size > 0) {
    const u = [...l];
    u.length === 1 ? o.pattern = u[0].source : u.length > 1 && (o.allOf = [
      ...u.map((d) => ({
        ...e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: d.source
      }))
    ]);
  }
}, by = (t, e, n, r) => {
  const o = n, { minimum: i, maximum: a, format: s, multipleOf: l, exclusiveMaximum: c, exclusiveMinimum: u } = t._zod.bag;
  typeof s == "string" && s.includes("int") ? o.type = "integer" : o.type = "number", typeof u == "number" && (e.target === "draft-04" || e.target === "openapi-3.0" ? (o.minimum = u, o.exclusiveMinimum = !0) : o.exclusiveMinimum = u), typeof i == "number" && (o.minimum = i, typeof u == "number" && e.target !== "draft-04" && (u >= i ? delete o.minimum : delete o.exclusiveMinimum)), typeof c == "number" && (e.target === "draft-04" || e.target === "openapi-3.0" ? (o.maximum = c, o.exclusiveMaximum = !0) : o.exclusiveMaximum = c), typeof a == "number" && (o.maximum = a, typeof c == "number" && e.target !== "draft-04" && (c <= a ? delete o.maximum : delete o.exclusiveMaximum)), typeof l == "number" && (o.multipleOf = l);
}, Ry = (t, e, n, r) => {
  n.type = "boolean";
}, My = (t, e, n, r) => {
  n.not = {};
}, Py = (t, e, n, r) => {
}, yy = (t, e, n, r) => {
}, Ly = (t, e, n, r) => {
  const o = t._zod.def, i = g4(o.entries);
  i.every((a) => typeof a == "number") && (n.type = "number"), i.every((a) => typeof a == "string") && (n.type = "string"), n.enum = i;
}, xy = (t, e, n, r) => {
  if (e.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, Uy = (t, e, n, r) => {
  if (e.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, $y = (t, e, n, r) => {
  const o = n, i = t._zod.def, { minimum: a, maximum: s } = t._zod.bag;
  typeof a == "number" && (o.minItems = a), typeof s == "number" && (o.maxItems = s), o.type = "array", o.items = _n(i.element, e, { ...r, path: [...r.path, "items"] });
}, ky = (t, e, n, r) => {
  var c;
  const o = n, i = t._zod.def;
  o.type = "object", o.properties = {};
  const a = i.shape;
  for (const u in a)
    o.properties[u] = _n(a[u], e, {
      ...r,
      path: [...r.path, "properties", u]
    });
  const s = new Set(Object.keys(a)), l = new Set([...s].filter((u) => {
    const d = i.shape[u]._zod;
    return e.io === "input" ? d.optin === void 0 : d.optout === void 0;
  }));
  l.size > 0 && (o.required = Array.from(l)), ((c = i.catchall) == null ? void 0 : c._zod.def.type) === "never" ? o.additionalProperties = !1 : i.catchall ? i.catchall && (o.additionalProperties = _n(i.catchall, e, {
    ...r,
    path: [...r.path, "additionalProperties"]
  })) : e.io === "output" && (o.additionalProperties = !1);
}, By = (t, e, n, r) => {
  const o = t._zod.def, i = o.inclusive === !1, a = o.options.map((s, l) => _n(s, e, {
    ...r,
    path: [...r.path, i ? "oneOf" : "anyOf", l]
  }));
  i ? n.oneOf = a : n.anyOf = a;
}, Gy = (t, e, n, r) => {
  const o = t._zod.def, i = _n(o.left, e, {
    ...r,
    path: [...r.path, "allOf", 0]
  }), a = _n(o.right, e, {
    ...r,
    path: [...r.path, "allOf", 1]
  }), s = (c) => "allOf" in c && Object.keys(c).length === 1, l = [
    ...s(i) ? i.allOf : [i],
    ...s(a) ? a.allOf : [a]
  ];
  n.allOf = l;
}, Fy = (t, e, n, r) => {
  const o = t._zod.def, i = _n(o.innerType, e, r), a = e.seen.get(t);
  e.target === "openapi-3.0" ? (a.ref = o.innerType, n.nullable = !0) : n.anyOf = [i, { type: "null" }];
}, Vy = (t, e, n, r) => {
  const o = t._zod.def;
  _n(o.innerType, e, r);
  const i = e.seen.get(t);
  i.ref = o.innerType;
}, Hy = (t, e, n, r) => {
  const o = t._zod.def;
  _n(o.innerType, e, r);
  const i = e.seen.get(t);
  i.ref = o.innerType, n.default = JSON.parse(JSON.stringify(o.defaultValue));
}, Wy = (t, e, n, r) => {
  const o = t._zod.def;
  _n(o.innerType, e, r);
  const i = e.seen.get(t);
  i.ref = o.innerType, e.io === "input" && (n._prefault = JSON.parse(JSON.stringify(o.defaultValue)));
}, Yy = (t, e, n, r) => {
  const o = t._zod.def;
  _n(o.innerType, e, r);
  const i = e.seen.get(t);
  i.ref = o.innerType;
  let a;
  try {
    a = o.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  n.default = a;
}, Ky = (t, e, n, r) => {
  const o = t._zod.def, i = e.io === "input" ? o.in._zod.def.type === "transform" ? o.out : o.in : o.out;
  _n(i, e, r);
  const a = e.seen.get(t);
  a.ref = i;
}, zy = (t, e, n, r) => {
  const o = t._zod.def;
  _n(o.innerType, e, r);
  const i = e.seen.get(t);
  i.ref = o.innerType, n.readOnly = !0;
}, H4 = (t, e, n, r) => {
  const o = t._zod.def;
  _n(o.innerType, e, r);
  const i = e.seen.get(t);
  i.ref = o.innerType;
}, Zy = /* @__PURE__ */ ie("ZodISODateTime", (t, e) => {
  XM.init(t, e), xt.init(t, e);
});
function qy(t) {
  return /* @__PURE__ */ ty(Zy, t);
}
const Xy = /* @__PURE__ */ ie("ZodISODate", (t, e) => {
  jM.init(t, e), xt.init(t, e);
});
function jy(t) {
  return /* @__PURE__ */ ny(Xy, t);
}
const Jy = /* @__PURE__ */ ie("ZodISOTime", (t, e) => {
  JM.init(t, e), xt.init(t, e);
});
function Qy(t) {
  return /* @__PURE__ */ ry(Jy, t);
}
const eL = /* @__PURE__ */ ie("ZodISODuration", (t, e) => {
  QM.init(t, e), xt.init(t, e);
});
function tL(t) {
  return /* @__PURE__ */ oy(eL, t);
}
const nL = (t, e) => {
  C4.init(t, e), t.name = "ZodError", Object.defineProperties(t, {
    format: {
      value: (n) => VR(t, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => FR(t, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        t.issues.push(n), t.message = JSON.stringify(t.issues, a0, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        t.issues.push(...n), t.message = JSON.stringify(t.issues, a0, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return t.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, Tr = ie("ZodError", nL, {
  Parent: Error
}), rL = /* @__PURE__ */ bE(Tr), oL = /* @__PURE__ */ RE(Tr), iL = /* @__PURE__ */ Sf(Tr), aL = /* @__PURE__ */ wf(Tr), sL = /* @__PURE__ */ YR(Tr), lL = /* @__PURE__ */ KR(Tr), cL = /* @__PURE__ */ zR(Tr), uL = /* @__PURE__ */ ZR(Tr), dL = /* @__PURE__ */ qR(Tr), fL = /* @__PURE__ */ XR(Tr), hL = /* @__PURE__ */ jR(Tr), _L = /* @__PURE__ */ JR(Tr), Bt = /* @__PURE__ */ ie("ZodType", (t, e) => (kt.init(t, e), Object.assign(t["~standard"], {
  jsonSchema: {
    input: Cd(t, "input"),
    output: Cd(t, "output")
  }
}), t.toJSONSchema = Sy(t, {}), t.def = e, t.type = e.type, Object.defineProperty(t, "_def", { value: e }), t.check = (...n) => t.clone(ki(e, {
  checks: [
    ...e.checks ?? [],
    ...n.map((r) => typeof r == "function" ? { _zod: { check: r, def: { check: "custom" }, onattach: [] } } : r)
  ]
}), {
  parent: !0
}), t.with = t.check, t.clone = (n, r) => Bi(t, n, r), t.brand = () => t, t.register = (n, r) => (n.add(t, r), t), t.parse = (n, r) => rL(t, n, r, { callee: t.parse }), t.safeParse = (n, r) => iL(t, n, r), t.parseAsync = async (n, r) => oL(t, n, r, { callee: t.parseAsync }), t.safeParseAsync = async (n, r) => aL(t, n, r), t.spa = t.safeParseAsync, t.encode = (n, r) => sL(t, n, r), t.decode = (n, r) => lL(t, n, r), t.encodeAsync = async (n, r) => cL(t, n, r), t.decodeAsync = async (n, r) => uL(t, n, r), t.safeEncode = (n, r) => dL(t, n, r), t.safeDecode = (n, r) => fL(t, n, r), t.safeEncodeAsync = async (n, r) => hL(t, n, r), t.safeDecodeAsync = async (n, r) => _L(t, n, r), t.refine = (n, r) => t.check(lx(n, r)), t.superRefine = (n) => t.check(cx(n)), t.overwrite = (n) => t.check(/* @__PURE__ */ nl(n)), t.optional = () => sN(t), t.exactOptional = () => qL(t), t.nullable = () => lN(t), t.nullish = () => sN(lN(t)), t.nonoptional = (n) => tx(t, n), t.array = () => K4(t), t.or = (n) => HL([t, n]), t.and = (n) => YL(t, n), t.transform = (n) => cN(t, zL(n)), t.default = (n) => JL(t, n), t.prefault = (n) => ex(t, n), t.catch = (n) => rx(t, n), t.pipe = (n) => cN(t, n), t.readonly = () => ax(t), t.describe = (n) => {
  const r = t.clone();
  return Ll.add(r, { description: n }), r;
}, Object.defineProperty(t, "description", {
  get() {
    var n;
    return (n = Ll.get(t)) == null ? void 0 : n.description;
  },
  configurable: !0
}), t.meta = (...n) => {
  if (n.length === 0)
    return Ll.get(t);
  const r = t.clone();
  return Ll.add(r, n[0]), r;
}, t.isOptional = () => t.safeParse(void 0).success, t.isNullable = () => t.safeParse(null).success, t.apply = (n) => n(t), t)), W4 = /* @__PURE__ */ ie("_ZodString", (t, e) => {
  ME.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (r, o, i) => Ty(t, r, o);
  const n = t._zod.bag;
  t.format = n.format ?? null, t.minLength = n.minimum ?? null, t.maxLength = n.maximum ?? null, t.regex = (...r) => t.check(/* @__PURE__ */ dy(...r)), t.includes = (...r) => t.check(/* @__PURE__ */ _y(...r)), t.startsWith = (...r) => t.check(/* @__PURE__ */ Ey(...r)), t.endsWith = (...r) => t.check(/* @__PURE__ */ py(...r)), t.min = (...r) => t.check(/* @__PURE__ */ Dd(...r)), t.max = (...r) => t.check(/* @__PURE__ */ k4(...r)), t.length = (...r) => t.check(/* @__PURE__ */ B4(...r)), t.nonempty = (...r) => t.check(/* @__PURE__ */ Dd(1, ...r)), t.lowercase = (r) => t.check(/* @__PURE__ */ fy(r)), t.uppercase = (r) => t.check(/* @__PURE__ */ hy(r)), t.trim = () => t.check(/* @__PURE__ */ Ny()), t.normalize = (...r) => t.check(/* @__PURE__ */ my(...r)), t.toLowerCase = () => t.check(/* @__PURE__ */ vy()), t.toUpperCase = () => t.check(/* @__PURE__ */ gy()), t.slugify = () => t.check(/* @__PURE__ */ Iy());
}), EL = /* @__PURE__ */ ie("ZodString", (t, e) => {
  ME.init(t, e), W4.init(t, e), t.email = (n) => t.check(/* @__PURE__ */ LP(pL, n)), t.url = (n) => t.check(/* @__PURE__ */ BP(mL, n)), t.jwt = (n) => t.check(/* @__PURE__ */ ey(PL, n)), t.emoji = (n) => t.check(/* @__PURE__ */ GP(NL, n)), t.guid = (n) => t.check(/* @__PURE__ */ Qm(rN, n)), t.uuid = (n) => t.check(/* @__PURE__ */ xP(bu, n)), t.uuidv4 = (n) => t.check(/* @__PURE__ */ UP(bu, n)), t.uuidv6 = (n) => t.check(/* @__PURE__ */ $P(bu, n)), t.uuidv7 = (n) => t.check(/* @__PURE__ */ kP(bu, n)), t.nanoid = (n) => t.check(/* @__PURE__ */ FP(vL, n)), t.guid = (n) => t.check(/* @__PURE__ */ Qm(rN, n)), t.cuid = (n) => t.check(/* @__PURE__ */ VP(gL, n)), t.cuid2 = (n) => t.check(/* @__PURE__ */ HP(IL, n)), t.ulid = (n) => t.check(/* @__PURE__ */ WP(OL, n)), t.base64 = (n) => t.check(/* @__PURE__ */ jP(bL, n)), t.base64url = (n) => t.check(/* @__PURE__ */ JP(RL, n)), t.xid = (n) => t.check(/* @__PURE__ */ YP(AL, n)), t.ksuid = (n) => t.check(/* @__PURE__ */ KP(DL, n)), t.ipv4 = (n) => t.check(/* @__PURE__ */ zP(CL, n)), t.ipv6 = (n) => t.check(/* @__PURE__ */ ZP(SL, n)), t.cidrv4 = (n) => t.check(/* @__PURE__ */ qP(wL, n)), t.cidrv6 = (n) => t.check(/* @__PURE__ */ XP(TL, n)), t.e164 = (n) => t.check(/* @__PURE__ */ QP(ML, n)), t.datetime = (n) => t.check(qy(n)), t.date = (n) => t.check(jy(n)), t.time = (n) => t.check(Qy(n)), t.duration = (n) => t.check(tL(n));
});
function Ct(t) {
  return /* @__PURE__ */ yP(EL, t);
}
const xt = /* @__PURE__ */ ie("ZodStringFormat", (t, e) => {
  bt.init(t, e), W4.init(t, e);
}), pL = /* @__PURE__ */ ie("ZodEmail", (t, e) => {
  FM.init(t, e), xt.init(t, e);
}), rN = /* @__PURE__ */ ie("ZodGUID", (t, e) => {
  BM.init(t, e), xt.init(t, e);
}), bu = /* @__PURE__ */ ie("ZodUUID", (t, e) => {
  GM.init(t, e), xt.init(t, e);
}), mL = /* @__PURE__ */ ie("ZodURL", (t, e) => {
  VM.init(t, e), xt.init(t, e);
}), NL = /* @__PURE__ */ ie("ZodEmoji", (t, e) => {
  HM.init(t, e), xt.init(t, e);
}), vL = /* @__PURE__ */ ie("ZodNanoID", (t, e) => {
  WM.init(t, e), xt.init(t, e);
}), gL = /* @__PURE__ */ ie("ZodCUID", (t, e) => {
  YM.init(t, e), xt.init(t, e);
}), IL = /* @__PURE__ */ ie("ZodCUID2", (t, e) => {
  KM.init(t, e), xt.init(t, e);
}), OL = /* @__PURE__ */ ie("ZodULID", (t, e) => {
  zM.init(t, e), xt.init(t, e);
}), AL = /* @__PURE__ */ ie("ZodXID", (t, e) => {
  ZM.init(t, e), xt.init(t, e);
}), DL = /* @__PURE__ */ ie("ZodKSUID", (t, e) => {
  qM.init(t, e), xt.init(t, e);
}), CL = /* @__PURE__ */ ie("ZodIPv4", (t, e) => {
  eP.init(t, e), xt.init(t, e);
}), SL = /* @__PURE__ */ ie("ZodIPv6", (t, e) => {
  tP.init(t, e), xt.init(t, e);
}), wL = /* @__PURE__ */ ie("ZodCIDRv4", (t, e) => {
  nP.init(t, e), xt.init(t, e);
}), TL = /* @__PURE__ */ ie("ZodCIDRv6", (t, e) => {
  rP.init(t, e), xt.init(t, e);
}), bL = /* @__PURE__ */ ie("ZodBase64", (t, e) => {
  oP.init(t, e), xt.init(t, e);
}), RL = /* @__PURE__ */ ie("ZodBase64URL", (t, e) => {
  aP.init(t, e), xt.init(t, e);
}), ML = /* @__PURE__ */ ie("ZodE164", (t, e) => {
  sP.init(t, e), xt.init(t, e);
}), PL = /* @__PURE__ */ ie("ZodJWT", (t, e) => {
  cP.init(t, e), xt.init(t, e);
}), Y4 = /* @__PURE__ */ ie("ZodNumber", (t, e) => {
  L4.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (r, o, i) => by(t, r, o), t.gt = (r, o) => t.check(/* @__PURE__ */ tN(r, o)), t.gte = (r, o) => t.check(/* @__PURE__ */ R1(r, o)), t.min = (r, o) => t.check(/* @__PURE__ */ R1(r, o)), t.lt = (r, o) => t.check(/* @__PURE__ */ eN(r, o)), t.lte = (r, o) => t.check(/* @__PURE__ */ b1(r, o)), t.max = (r, o) => t.check(/* @__PURE__ */ b1(r, o)), t.int = (r) => t.check(oN(r)), t.safe = (r) => t.check(oN(r)), t.positive = (r) => t.check(/* @__PURE__ */ tN(0, r)), t.nonnegative = (r) => t.check(/* @__PURE__ */ R1(0, r)), t.negative = (r) => t.check(/* @__PURE__ */ eN(0, r)), t.nonpositive = (r) => t.check(/* @__PURE__ */ b1(0, r)), t.multipleOf = (r, o) => t.check(/* @__PURE__ */ nN(r, o)), t.step = (r, o) => t.check(/* @__PURE__ */ nN(r, o)), t.finite = () => t;
  const n = t._zod.bag;
  t.minValue = Math.max(n.minimum ?? Number.NEGATIVE_INFINITY, n.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, t.maxValue = Math.min(n.maximum ?? Number.POSITIVE_INFINITY, n.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, t.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? 0.5), t.isFinite = !0, t.format = n.format ?? null;
});
function As(t) {
  return /* @__PURE__ */ iy(Y4, t);
}
const yL = /* @__PURE__ */ ie("ZodNumberFormat", (t, e) => {
  uP.init(t, e), Y4.init(t, e);
});
function oN(t) {
  return /* @__PURE__ */ ay(yL, t);
}
const LL = /* @__PURE__ */ ie("ZodBoolean", (t, e) => {
  dP.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => Ry(t, n, r);
});
function iN(t) {
  return /* @__PURE__ */ sy(LL, t);
}
const xL = /* @__PURE__ */ ie("ZodAny", (t, e) => {
  fP.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => Py();
});
function UL() {
  return /* @__PURE__ */ ly(xL);
}
const $L = /* @__PURE__ */ ie("ZodUnknown", (t, e) => {
  hP.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => yy();
});
function aN() {
  return /* @__PURE__ */ cy($L);
}
const kL = /* @__PURE__ */ ie("ZodNever", (t, e) => {
  _P.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => My(t, n, r);
});
function BL(t) {
  return /* @__PURE__ */ uy(kL, t);
}
const GL = /* @__PURE__ */ ie("ZodArray", (t, e) => {
  EP.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => $y(t, n, r, o), t.element = e.element, t.min = (n, r) => t.check(/* @__PURE__ */ Dd(n, r)), t.nonempty = (n) => t.check(/* @__PURE__ */ Dd(1, n)), t.max = (n, r) => t.check(/* @__PURE__ */ k4(n, r)), t.length = (n, r) => t.check(/* @__PURE__ */ B4(n, r)), t.unwrap = () => t.element;
});
function K4(t, e) {
  return /* @__PURE__ */ Oy(GL, t, e);
}
const FL = /* @__PURE__ */ ie("ZodObject", (t, e) => {
  mP.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => ky(t, n, r, o), dt(t, "shape", () => e.shape), t.keyof = () => ha(Object.keys(t._zod.def.shape)), t.catchall = (n) => t.clone({ ...t._zod.def, catchall: n }), t.passthrough = () => t.clone({ ...t._zod.def, catchall: aN() }), t.loose = () => t.clone({ ...t._zod.def, catchall: aN() }), t.strict = () => t.clone({ ...t._zod.def, catchall: BL() }), t.strip = () => t.clone({ ...t._zod.def, catchall: void 0 }), t.extend = (n) => UR(t, n), t.safeExtend = (n) => $R(t, n), t.merge = (n) => kR(t, n), t.pick = (n) => LR(t, n), t.omit = (n) => xR(t, n), t.partial = (...n) => BR(z4, t, n[0]), t.required = (...n) => GR(Z4, t, n[0]);
});
function Ca(t, e) {
  const n = {
    type: "object",
    shape: t ?? {},
    ...$e(e)
  };
  return new FL(n);
}
const VL = /* @__PURE__ */ ie("ZodUnion", (t, e) => {
  NP.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => By(t, n, r, o), t.options = e.options;
});
function HL(t, e) {
  return new VL({
    type: "union",
    options: t,
    ...$e(e)
  });
}
const WL = /* @__PURE__ */ ie("ZodIntersection", (t, e) => {
  vP.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => Gy(t, n, r, o);
});
function YL(t, e) {
  return new WL({
    type: "intersection",
    left: t,
    right: e
  });
}
const l0 = /* @__PURE__ */ ie("ZodEnum", (t, e) => {
  gP.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (r, o, i) => Ly(t, r, o), t.enum = e.entries, t.options = Object.values(e.entries);
  const n = new Set(Object.keys(e.entries));
  t.extract = (r, o) => {
    const i = {};
    for (const a of r)
      if (n.has(a))
        i[a] = e.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new l0({
      ...e,
      checks: [],
      ...$e(o),
      entries: i
    });
  }, t.exclude = (r, o) => {
    const i = { ...e.entries };
    for (const a of r)
      if (n.has(a))
        delete i[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new l0({
      ...e,
      checks: [],
      ...$e(o),
      entries: i
    });
  };
});
function ha(t, e) {
  const n = Array.isArray(t) ? Object.fromEntries(t.map((r) => [r, r])) : t;
  return new l0({
    type: "enum",
    entries: n,
    ...$e(e)
  });
}
const KL = /* @__PURE__ */ ie("ZodTransform", (t, e) => {
  IP.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => Uy(t, n), t._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new v4(t.constructor.name);
    n.addIssue = (i) => {
      if (typeof i == "string")
        n.issues.push(mc(i, n.value, e));
      else {
        const a = i;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = n.value), a.inst ?? (a.inst = t), n.issues.push(mc(a));
      }
    };
    const o = e.transform(n.value, n);
    return o instanceof Promise ? o.then((i) => (n.value = i, n)) : (n.value = o, n);
  };
});
function zL(t) {
  return new KL({
    type: "transform",
    transform: t
  });
}
const z4 = /* @__PURE__ */ ie("ZodOptional", (t, e) => {
  $4.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => H4(t, n, r, o), t.unwrap = () => t._zod.def.innerType;
});
function sN(t) {
  return new z4({
    type: "optional",
    innerType: t
  });
}
const ZL = /* @__PURE__ */ ie("ZodExactOptional", (t, e) => {
  OP.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => H4(t, n, r, o), t.unwrap = () => t._zod.def.innerType;
});
function qL(t) {
  return new ZL({
    type: "optional",
    innerType: t
  });
}
const XL = /* @__PURE__ */ ie("ZodNullable", (t, e) => {
  AP.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => Fy(t, n, r, o), t.unwrap = () => t._zod.def.innerType;
});
function lN(t) {
  return new XL({
    type: "nullable",
    innerType: t
  });
}
const jL = /* @__PURE__ */ ie("ZodDefault", (t, e) => {
  DP.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => Hy(t, n, r, o), t.unwrap = () => t._zod.def.innerType, t.removeDefault = t.unwrap;
});
function JL(t, e) {
  return new jL({
    type: "default",
    innerType: t,
    get defaultValue() {
      return typeof e == "function" ? e() : O4(e);
    }
  });
}
const QL = /* @__PURE__ */ ie("ZodPrefault", (t, e) => {
  CP.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => Wy(t, n, r, o), t.unwrap = () => t._zod.def.innerType;
});
function ex(t, e) {
  return new QL({
    type: "prefault",
    innerType: t,
    get defaultValue() {
      return typeof e == "function" ? e() : O4(e);
    }
  });
}
const Z4 = /* @__PURE__ */ ie("ZodNonOptional", (t, e) => {
  SP.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => Vy(t, n, r, o), t.unwrap = () => t._zod.def.innerType;
});
function tx(t, e) {
  return new Z4({
    type: "nonoptional",
    innerType: t,
    ...$e(e)
  });
}
const nx = /* @__PURE__ */ ie("ZodCatch", (t, e) => {
  wP.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => Yy(t, n, r, o), t.unwrap = () => t._zod.def.innerType, t.removeCatch = t.unwrap;
});
function rx(t, e) {
  return new nx({
    type: "catch",
    innerType: t,
    catchValue: typeof e == "function" ? e : () => e
  });
}
const ox = /* @__PURE__ */ ie("ZodPipe", (t, e) => {
  TP.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => Ky(t, n, r, o), t.in = e.in, t.out = e.out;
});
function cN(t, e) {
  return new ox({
    type: "pipe",
    in: t,
    out: e
    // ...util.normalizeParams(params),
  });
}
const ix = /* @__PURE__ */ ie("ZodReadonly", (t, e) => {
  bP.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => zy(t, n, r, o), t.unwrap = () => t._zod.def.innerType;
});
function ax(t) {
  return new ix({
    type: "readonly",
    innerType: t
  });
}
const sx = /* @__PURE__ */ ie("ZodCustom", (t, e) => {
  RP.init(t, e), Bt.init(t, e), t._zod.processJSONSchema = (n, r, o) => xy(t, n);
});
function lx(t, e = {}) {
  return /* @__PURE__ */ Ay(sx, t, e);
}
function cx(t) {
  return /* @__PURE__ */ Dy(t);
}
Ca({
  provider: ha([
    "openai",
    "anthropic",
    "google",
    "xiaomi",
    "moonshotai",
    "deepseek",
    "zai",
    "alibaba",
    "xai"
  ]).optional(),
  model: Ct().optional(),
  effort: ha(["quick", "deep"]).optional(),
  finishReason: Ct().optional(),
  promptTokens: As().optional(),
  completionTokens: As().optional(),
  totalTokens: As().optional(),
  createdAt: Ct().optional(),
  /** Set when the turn ended without a `finish` chunk. 'abort' means the
   * SDK saw an abort chunk (stop button); 'cancel' means the UI stream
   * was torn down from downstream without one (what a client disconnect
   * looks like server-side). Absent on turns that finished normally. */
  interruption: ha(["abort", "cancel"]).optional(),
  /** Whether the HTTP request's abort signal had fired by the time the
   * interrupted turn was persisted — distinguishes a client disconnect
   * from a cancellation with an unknown cause. */
  /** Legacy name for stopRequested, on turns interrupted before this field existed. */
  clientDisconnected: iN().optional(),
  stopRequested: iN().optional(),
  /** On a user message sent by a scheduled agent rather than typed by the user. */
  scheduledAgentRunId: As().optional()
}).passthrough();
Ca({
  attachmentId: Ct(),
  entityType: ha(["campaign", "adgroup", "keyword"]),
  name: Ct(),
  entities: K4(UL()),
  dateRange: Ca({
    from: Ct(),
    to: Ct()
  }).optional()
});
Ca({
  attachmentId: Ct(),
  entityType: ha(["campaign", "adgroup", "keyword"]),
  id: Ct(),
  name: Ct(),
  parentId: Ct().optional(),
  parentName: Ct().optional(),
  resourceName: Ct()
});
Ca({
  attachmentId: Ct(),
  kind: ha(["text", "file", "image"]),
  name: Ct(),
  mediaType: Ct().optional(),
  size: As().optional(),
  text: Ct().optional(),
  url: Ct().optional(),
  blobId: Ct().optional(),
  sandboxPath: Ct().optional(),
  previewUrl: Ct().optional()
});
Ca({
  summary: Ct(),
  tokensCompacted: As(),
  model: Ct(),
  createdAt: Ct()
});
Ca({
  text: Ct()
});
({
  ...t0.AlertType
});
const uN = {
  couponApplied: "couponApplied",
  err: "err"
};
uN.couponApplied + "", e0.Coupon.ReportUpgrades20Percent3Months, uN.err + "";
st.GoogleAds + "", st.MicrosoftAds + "";
const gt = {
  AccountLevel: "account-level",
  Ad: "ad",
  AdGroup: "adgroup",
  AdSet: "adset",
  Asset: "asset",
  AssetGroup: "asset-group",
  Campaign: "campaign",
  CampaignGroup: "campaign-group",
  ConversionAction: "conversion-action",
  Demographic: "demographic",
  Device: "device",
  Experiment: "experiment",
  Extension: "extension",
  Keyword: "keyword",
  Location: "location",
  Network: "network",
  NGram: "n-gram",
  NegativeKeyword: "negative-keyword",
  NegativeList: "negative-list",
  Pause: "pause",
  Placement: "placement",
  PlacementExclusionList: "placement-exclusion-list",
  Product: "product",
  ProductGroup: "product-group",
  ReplacementKeyword: "replacement-keyword",
  SearchTerm: "search-term",
  URL: "url",
  Word: "word"
}, ux = {
  Profanity: "profanity",
  Explicit: "explicit",
  Violence: "violence",
  Hate: "hate",
  Substances: "substances",
  Gambling: "gambling",
  Controversial: "controversial",
  Misinfo: "misinfo",
  LowQuality: "lowQuality",
  MadeForKids: "madeForKids"
}, dx = [
  "placementName",
  "risksScore",
  "impressions",
  "clicks",
  "costMinis",
  "conversionsNativeMinis",
  "conversionsValueNativeMinis",
  // auto excluder categories
  "flaggedWords",
  "poorPerformance",
  ...Object.values(ux)
];
new Set(dx);
const fx = ["ilike", "not ilike", "=", ">=", "<="];
new Set(fx);
const hx = [
  "placementName",
  "risksScore",
  "impressions",
  "clicks",
  "costMinis",
  "conversionsNativeMinis",
  "conversionsValueNativeMinis"
];
new Set(hx);
const _x = ["asc", "desc"];
new Set(_x);
const Ex = ({ rawNumber: t, finalValue: e }) => t < 0 ? `-${e}` : e, px = ({
  rawNumber: t,
  finalValue: e,
  parts: n
}) => {
  var o;
  const r = ((o = n.find((i) => i.type === "currency")) == null ? void 0 : o.value) ?? "#";
  return t < 0 ? `-${r}${e}` : `${r}${e}`;
}, mx = ({
  rawNumber: t,
  finalValue: e,
  includeSign: n
}) => `${t < 0 ? "-" : n ? "+" : ""}${e}%`, PE = ({
  dataType: t,
  rawNumber: e,
  parts: n,
  compact: r,
  includeSign: o
}) => {
  const i = t === "percentage" ? 100 : 1, a = Math.abs(e) * i;
  if (r || a < 1e3 || a === 1 / 0)
    return n.map((c) => c.value).join("");
  let s = "";
  return a >= 1e3 && a < 1e6 ? s = Math.round(a).toLocaleString("en") : a >= 1e6 && a < 1e9 ? s = (a / 1e6).toFixed(3) + "m" : s = (a / 1e9).toFixed(3) + "bn", {
    number: Ex({ rawNumber: e, finalValue: s }),
    money: px({ rawNumber: e, finalValue: s, parts: n }),
    percentage: mx({ rawNumber: e, finalValue: s, includeSign: o })
  }[t];
};
function q4(t) {
  const e = (r) => r.toLowerCase(), n = x(
    () => t.value.map((r) => r.type === "compact" ? { ...r, value: e(r.value) } : r)
  );
  return {
    displayValue: x(() => n.value.map((r) => r.value).join("")),
    parts: n
  };
}
const Nx = {
  compact: !1,
  expanded: !1,
  decimalPlaces: 2
};
function Gs(t) {
  const { compact: e, decimalPlaces: n, expanded: r } = { ...Nx, ...t }, o = new Intl.NumberFormat("en", {
    style: "decimal",
    notation: e ? "compact" : "standard",
    maximumFractionDigits: n
  }), i = x(() => Number.isNaN(t.value) ? 0 : t.value), a = x(() => o.formatToParts(i.value));
  return e ? q4(a) : r ? { displayValue: x(() => a.value.map((l) => l.value).join("")), parts: a } : {
    displayValue: x(() => PE({
      dataType: "number",
      rawNumber: t.value,
      parts: a.value,
      compact: e
    })),
    parts: a
  };
}
const X4 = "GBP", vx = {
  currency: X4,
  // Safari doesn't support narrowSymbol, so we need to use a polyfill.
  // To keep the bundle size reasonable, we only bundle the 'en' locale.
  compact: !1
};
function sn(t) {
  const e = () => ({ ...vx, ...t, locale: "en" }), n = x(() => {
    const { locale: i, currency: a, compact: s } = e();
    return new Intl.NumberFormat(i, {
      style: "currency",
      currency: a ?? "GBP",
      // TODO : make this better with OpteoComponentsProvider
      currencyDisplay: "narrowSymbol",
      notation: s ? "compact" : "standard"
    });
  }), r = x(() => {
    const { value: i, compact: a } = e();
    return PE({
      dataType: "money",
      rawNumber: i,
      parts: o.value,
      compact: a
    });
  }), o = x(() => {
    const { currency: i } = e();
    return n.value.formatToParts(t.value).map((a) => a.type === "currency" ? { ...a, value: gx(i ?? X4) } : a).filter((a) => a.value !== " ");
  });
  return e().compact ? q4(o) : {
    displayValue: r,
    parts: o
  };
}
const gx = (t) => N4[t] ?? t + " ", Ix = Ne({
  name: "Money",
  props: {
    currency: {
      type: String,
      required: !0,
      default: "GBP"
    },
    value: {
      type: Number,
      required: !0
    },
    compact: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(t) {
    const { displayValue: e } = sn(t);
    return {
      displayValue: e
    };
  }
}), Y = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [r, o] of e)
    n[r] = o;
  return n;
}, Ox = {
  class: "di",
  dir: "ltr"
};
function Ax(t, e, n, r, o, i) {
  return v(), A("div", Ox, Q(t.displayValue), 1);
}
const Dx = /* @__PURE__ */ Y(Ix, [["render", Ax]]), Cx = Ne({
  name: "Number",
  props: {
    value: {
      type: Number,
      required: !0
    },
    decimalPlaces: {
      type: Number,
      required: !1,
      default: 2
    },
    compact: {
      type: Boolean,
      required: !1,
      default: !1
    },
    expanded: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(t) {
    const { displayValue: e } = Gs(t);
    return {
      displayValue: e
    };
  }
}), Sx = { class: "di" };
function wx(t, e, n, r, o, i) {
  return v(), A("div", Sx, Q(t.displayValue), 1);
}
const YRe = /* @__PURE__ */ Y(Cx, [["render", wx]]), Tx = {}, bx = {
  width: "8",
  height: "10",
  viewBox: "0 0 8 10",
  xmlns: "http://www.w3.org/2000/svg",
  class: "default-arrows o-30"
};
function Rx(t, e) {
  return v(), A("svg", bx, [...e[0] || (e[0] = [
    g("g", {
      transform: "translate(1 1)",
      "fill-rule": "nonzero",
      stroke: "#000000",
      "stroke-width": "2",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      g("polyline", { points: "6 6 3 8 0 6" }),
      g("polyline", {
        transform: "matrix(1 0 0 -1 0 2)",
        points: "6 0 3 2 0 0"
      })
    ], -1)
  ])]);
}
const Mx = /* @__PURE__ */ Y(Tx, [["render", Rx]]), Px = {}, yx = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "none"
};
function Lx(t, e) {
  return v(), A("svg", yx, [...e[0] || (e[0] = [
    g("path", {
      d: "M9 4L5 8L1 4",
      stroke: "#006DFF",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const xx = /* @__PURE__ */ Y(Px, [["render", Lx]]), Ux = {}, $x = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "none"
};
function kx(t, e) {
  return v(), A("svg", $x, [...e[0] || (e[0] = [
    g("path", {
      d: "M9 6L5 2L1 6",
      stroke: "#006DFF",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Bx = /* @__PURE__ */ Y(Ux, [["render", kx]]), Gx = {}, Fx = {
  width: "12",
  height: "16",
  viewBox: "0 0 12 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Vx(t, e) {
  return v(), A("svg", Fx, [...e[0] || (e[0] = [
    g("g", { "clip-path": "url(#clip0_1149_20728)" }, [
      g("path", {
        d: "M6 15V1m0 0 5 5M6 1 1 6",
        stroke: "#040406",
        "stroke-opacity": ".85",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1),
    g("defs", null, [
      g("clipPath", { id: "clip0_1149_20728" }, [
        g("path", {
          fill: "#fff",
          d: "M0 0h12v16H0z"
        })
      ])
    ], -1)
  ])]);
}
const Hx = /* @__PURE__ */ Y(Gx, [["render", Vx]]), Wx = Ne({
  props: {
    as: {
      type: String,
      required: !1,
      default: "p"
    },
    color: {
      type: String,
      required: !1,
      default: "black"
    },
    size: {
      type: String,
      required: !1,
      default: ""
    },
    weight: {
      type: String,
      required: !1
    },
    align: {
      type: String,
      required: !1,
      default: "left"
    },
    clickable: {
      type: Boolean,
      required: !1,
      default: !1
    },
    truncate: {
      type: Boolean,
      required: !1,
      default: !1
    },
    capitalise: {
      type: Boolean,
      required: !1,
      default: !1
    },
    wrap: {
      type: Boolean,
      required: !1,
      default: !0
    }
  }
});
function Yx(t, e, n, r, o, i) {
  return v(), te(zo(t.clickable ? "span" : t.as), {
    class: z([t.color, t.size, { clickable: t.clickable }, { truncate: t.truncate }, { capitalise: t.capitalise }, { "no-wrap": !t.wrap }, "align-" + t.align]),
    style: Fe({ fontWeight: t.weight })
  }, {
    default: q(() => [
      ue(t.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 8, ["class", "style"]);
}
const Ye = /* @__PURE__ */ Y(Wx, [["render", Yx], ["__scopeId", "data-v-4bfff129"]]), Kx = Ne({
  name: "Label",
  props: {
    id: {
      // VS Code does not seem to like this prop being called for so we've gone for id.
      // Usually the labelling of an input is handled within the the <oInput> component
      // with the label prop. In edge cases where a conventional input is not possible
      // or a custom input must be made, the <Label> component can be used, the id should
      // match the id of the corresponding <input /> element
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/label#attributes
      // a example could be a custom input like, a <ImageUploader id="image-uploader" ... />
      // when both id and fieldsset are omitted,this component will be rendred as a span
      // and can be used purely for presentational purposes when text should be styled
      // like a label. A common use case may be in a situation where the input is unconventional
      // like a carousel similar to those found in the Report Settings form
      type: String,
      required: !1
    },
    left: {
      type: Boolean,
      required: !1,
      default: !1
    },
    fieldset: {
      // often <oInput type="checkbox"> components can be grouped together as multiple
      // choice options. fieldset can be very us
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/fieldset
      type: Boolean,
      required: !1
    },
    dark: {
      type: Boolean,
      required: !1,
      default: !1
    },
    noMargin: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(t) {
    return {
      as: x(() => t.fieldset ? "legend" : t.id ? "label" : "span")
    };
  }
});
function zx(t, e, n, r, o, i) {
  return v(), te(zo(t.as), {
    for: t.id,
    class: z([{ left: t.left }, { dark: t.dark }, { "no-margin": t.noMargin }])
  }, {
    default: q(() => [
      ue(t.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 8, ["for", "class"]);
}
const Zx = /* @__PURE__ */ Y(Kx, [["render", zx], ["__scopeId", "data-v-85f3712f"]]);
function Ir({
  keys: t,
  onPressCallBack: e,
  onReleaseCallBack: n,
  eventTarget: r,
  preventDefault: o = !0
}) {
  const i = W(!1);
  function a(c) {
    l(c) === t.join("") && (M(o) && c.preventDefault(), i.value = !0, e && e(c));
  }
  function s(c) {
    const u = l(c);
    t.includes(u) && i.value && (M(o) && c.preventDefault(), i.value = !1, n && n(c));
  }
  ct(() => {
    var c, u;
    r ? ((c = r.value) == null || c.addEventListener("keydown", a), (u = r.value) == null || u.addEventListener("keyup", s)) : (window.addEventListener("keydown", a), window.addEventListener("keyup", s));
  }), Li(() => {
    var c, u;
    r ? ((c = r.value) == null || c.removeEventListener("keydown", a), (u = r.value) == null || u.removeEventListener("keyup", s)) : (window.removeEventListener("keydown", a), window.removeEventListener("keyup", s));
  });
  const l = (c) => {
    let u = "";
    return (c.key === "Shift" || c.shiftKey) && (u += "shift"), (c.key === "Control" || c.ctrlKey) && (u += "ctrl"), (c.key === "Meta" || c.metaKey) && (u += "meta"), (c.key === "Alt" || c.altKey) && (u += "alt"), c.key === "ArrowUp" && (u += "arrowup"), c.key === "ArrowLeft" && (u += "arrowleft"), c.key === "ArrowRight" && (u += "arrowright"), c.key === "ArrowDown" && (u += "arrowdown"), c.key === "AltGraph" && (u += "altgraph"), c.key === "Escape" && (u += "esc"), c.key === "Enter" && (u += "enter"), c.key === "Tab" && (u += "tab"), c.key === " " && (u += "space"), c.key === "PageUp" && (u += "pageup"), c.key === "PageDown" && (u += "pagedown"), c.key === "Home" && (u += "home"), c.key === "End" && (u += "end"), c.key === "Delete" && (u += "del"), c.key === "Backspace" && (u += "backspace"), c.key === "Insert" && (u += "insert"), c.key === "NumLock" && (u += "numlock"), c.key === "CapsLock" && (u += "capslock"), c.key === "Pause" && (u += "pause"), c.key === "ContextMenu" && (u += "contextmenu"), c.key === "ScrollLock" && (u += "scrolllock"), c.key === "BrowserHome" && (u += "browserhome"), c.key === "MediaSelect" && (u += "mediaselect"), (c.key && c.key !== " " && c.key.length === 1 || /F\d{1,2}|\//g.test(c.key)) && (u += c.key.toLowerCase()), u;
  };
  return { pressed: i };
}
var qx = typeof global == "object" && global && global.Object === Object && global;
const j4 = qx;
var Xx = typeof self == "object" && self && self.Object === Object && self, jx = j4 || Xx || Function("return this")();
const Zo = jx;
var Jx = Zo.Symbol;
const Eo = Jx;
var J4 = Object.prototype, Qx = J4.hasOwnProperty, eU = J4.toString, Ol = Eo ? Eo.toStringTag : void 0;
function tU(t) {
  var e = Qx.call(t, Ol), n = t[Ol];
  try {
    t[Ol] = void 0;
    var r = !0;
  } catch {
  }
  var o = eU.call(t);
  return r && (e ? t[Ol] = n : delete t[Ol]), o;
}
var nU = Object.prototype, rU = nU.toString;
function oU(t) {
  return rU.call(t);
}
var iU = "[object Null]", aU = "[object Undefined]", dN = Eo ? Eo.toStringTag : void 0;
function Va(t) {
  return t == null ? t === void 0 ? aU : iU : dN && dN in Object(t) ? tU(t) : oU(t);
}
function Sa(t) {
  return t != null && typeof t == "object";
}
var sU = "[object Number]";
function lU(t) {
  return typeof t == "number" || Sa(t) && Va(t) == sU;
}
function Q4(t) {
  return lU(t) && t != +t;
}
function Br(t = 10, e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789") {
  let n = "";
  for (let r = 0; r < t; r++)
    n += e.charAt(Math.floor(Math.random() * e.length));
  return n;
}
async function Or(t) {
  return new Promise((e) => {
    setTimeout(() => e(null), t);
  });
}
function e5(t, e) {
  if (typeof t == "number")
    return t;
  const n = e ? -1 : 1;
  return +t.replace("%", "").split(",").join("") / 100 * n;
}
function cU(t, e = "ASC", n, r) {
  let o;
  if (t && e && n.length > 0) {
    const i = e === "ASC" ? 1 : -1, a = (c) => r ? r(c) : c, s = a(n[0][t]), l = !Q4(+(typeof s == "string" ? s.replace("%", "") : s));
    o = n.sort((c, u) => {
      const d = a(c[t]), f = a(u[t]);
      return l ? (+d - +f) * i : (d == null ? void 0 : d.toLowerCase()) < (f == null ? void 0 : f.toLowerCase()) ? -1 * i : (d == null ? void 0 : d.toLowerCase()) > (f == null ? void 0 : f.toLowerCase()) ? 1 * i : 0;
    });
  }
  return o ?? n;
}
const uU = (t) => !t.currentTarget.contains(t.relatedTarget), dU = {
  props: {
    hex: {
      type: String,
      default: "#00ffff"
    }
  }
}, fU = {
  width: "14",
  height: "10",
  viewBox: "0 0 14 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hU = ["stroke"];
function _U(t, e, n, r, o, i) {
  return v(), A("svg", fU, [
    g("path", {
      d: "m1 5 4 4 8-8",
      stroke: n.hex,
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, hU)
  ]);
}
const EU = /* @__PURE__ */ Y(dU, [["render", _U]]), pU = {
  props: {
    hex: {
      type: String,
      default: "#00ffff"
    }
  }
}, mU = {
  width: "11",
  height: "11",
  viewBox: "0 0 11 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, NU = ["stroke"];
function vU(t, e, n, r, o, i) {
  return v(), A("svg", mU, [
    g("path", {
      d: "m1 10 4.5-4.5M1 1l4.5 4.5m0 0L10 1M5.5 5.5 10 10",
      stroke: n.hex,
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, NU)
  ]);
}
const gU = /* @__PURE__ */ Y(pU, [["render", vU]]), yE = {
  components: { Cross: gU, Check: EU },
  name: "oButton",
  props: {
    loading: {
      type: Boolean,
      default: !1
    },
    success: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    circle: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "",
      required: !1
    },
    fullWidth: {
      type: Boolean,
      default: !1,
      required: !1
    },
    color: {
      type: String,
      default: "",
      required: !1
    },
    classes: {
      type: String,
      default: "",
      required: !1
    },
    type: {
      type: String,
      required: !1
    },
    iconBefore: {
      type: Boolean,
      default: !1,
      required: !1
    },
    borderRadius: {
      type: String,
      default: "99rem",
      required: !1
    }
  },
  emits: ["clicked"],
  setup(t, { emit: e }) {
    const n = W(), r = W(), o = W(!1), i = W(!1), a = x(() => t.disabled ? "disabled" : ""), s = x(() => o.value || t.success), l = x(() => i.value || t.error);
    Ir({
      keys: ["enter"],
      onPressCallBack: (f) => {
        c(f);
      },
      eventTarget: n
    });
    function c(f) {
      s.value || l.value || t.loading || t.disabled || (e("clicked", f), t.type === "submit" && r.value.click());
    }
    async function u() {
      o.value = !0, await Or(2400), o.value = !1;
    }
    async function d() {
      i.value = !0, await Or(2400), i.value = !1;
    }
    return {
      clicked: c,
      oButton: n,
      tempError: i,
      localError: l,
      flashError: d,
      tempSuccess: o,
      localSuccess: s,
      flashSuccess: u,
      disabledClass: a,
      submit: r
    };
  }
}, fN = () => {
  Wr((t) => ({
    bd2ed32a: t.borderRadius
  }));
}, hN = yE.setup;
yE.setup = hN ? (t, e) => (fN(), hN(t, e)) : fN;
const IU = {
  key: 0,
  class: "spinner"
}, OU = {
  key: 3,
  ref: "submit",
  class: "dn",
  type: "submit",
  tabindex: -1
};
function AU(t, e, n, r, o, i) {
  const a = ee("Check"), s = ee("Cross");
  return v(), A("div", {
    class: z([
      "o-button",
      n.color,
      n.size,
      n.classes,
      r.disabledClass,
      {
        "o-button--success": r.localSuccess,
        "o-button--error": r.localError,
        "o-button--phantom": n.type === "phantom",
        "o-button--fullwidth": n.fullWidth,
        "o-button--circle": n.circle
      }
    ]),
    ref: "oButton",
    onClick: e[0] || (e[0] = (...l) => r.clicked && r.clicked(...l)),
    tabindex: 0,
    role: "button"
  }, [
    n.loading && !r.localSuccess && !r.localError ? (v(), A("div", IU)) : V("", !0),
    H(Zt, { name: "o-button-icon-fade" }, {
      default: q(() => [
        r.localSuccess && !n.loading && !r.localError ? (v(), te(a, {
          key: 0,
          hex: "#fff",
          class: "success"
        })) : V("", !0)
      ]),
      _: 1
    }),
    H(Zt, { name: "o-button-icon-fade" }, {
      default: q(() => [
        r.localError && !n.loading && !r.localSuccess ? (v(), te(s, {
          key: 0,
          hex: "#fff",
          class: "error"
        })) : V("", !0)
      ]),
      _: 1
    }),
    t.$slots.icon && n.iconBefore ? (v(), A("div", {
      key: 1,
      ref: "oButtonIcon",
      class: z(["o-button-icon-slot", "before", { "o-0": n.loading || r.localSuccess || r.localError }])
    }, [
      ue(t.$slots, "icon", {}, void 0, !0)
    ], 2)) : V("", !0),
    g("span", {
      ref: "oButtonSpan",
      class: z({ "o-0": n.loading || r.localSuccess || r.localError })
    }, [
      ue(t.$slots, "default", {}, void 0, !0)
    ], 2),
    t.$slots.icon && !n.iconBefore ? (v(), A("div", {
      key: 2,
      ref: "oButtonIcon",
      class: z(["o-button-icon-slot", { "o-0": n.loading || r.localSuccess || r.localError }])
    }, [
      ue(t.$slots, "icon", {}, void 0, !0)
    ], 2)) : V("", !0),
    n.type === "submit" ? (v(), A("button", OU, null, 512)) : V("", !0)
  ], 2);
}
const ln = /* @__PURE__ */ Y(yE, [["render", AU], ["__scopeId", "data-v-e99539ef"]]), DU = Ne({
  props: {
    dark: {
      type: Boolean,
      required: !1,
      default: !1
    }
  }
});
function CU(t, e, n, r, o, i) {
  return v(), A("div", {
    class: z(["spinner", { dark: t.dark }])
  }, null, 2);
}
const t5 = /* @__PURE__ */ Y(DU, [["render", CU], ["__scopeId", "data-v-033e3742"]]), SU = {}, wU = {
  width: "12",
  height: "11",
  viewBox: "0 0 12 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function TU(t, e) {
  return v(), A("svg", wU, [...e[0] || (e[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.70711.707107c-.39053-.390524-1.02369-.390525-1.41422 0l-.7071.707103 2.12132 2.12132.70709-.7071c.3905-.39053.3905-1.02369 0-1.41422L9.70711.707107zM9 4.24264L6.87868 2.12132 1.63604 7.36396l-.35355 2.47487 2.47487-.35355L9 4.24264z",
      fill: "#CACAD3"
    }, null, -1)
  ])]);
}
const n5 = /* @__PURE__ */ Y(SU, [["render", TU]]);
const bU = {}, RU = {
  "aria-hidden": "true",
  height: "12",
  width: "12",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
};
function MU(t, e) {
  return v(), A("svg", RU, [...e[0] || (e[0] = [
    g("path", {
      d: "M10.115 1.308l5.635 11.269A2.365 2.365 0 0113.634 16H2.365A2.365 2.365 0 01.25 12.577L5.884 1.308a2.365 2.365 0 014.231 0zM8 10.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM8 9c.552 0 1-.32 1-.714V4.714C9 4.32 8.552 4 8 4s-1 .32-1 .714v3.572C7 8.68 7.448 9 8 9z",
      "fill-rule": "evenodd"
    }, null, -1)
  ])]);
}
const PU = /* @__PURE__ */ Y(bU, [["render", MU], ["__scopeId", "data-v-7b4d7503"]]), yU = {
  components: { InputErrorIcon: PU },
  props: {
    content: {
      type: String,
      default: null
    }
  }
};
const LU = { class: "error-message" }, xU = { class: "opteo-red f7" };
function UU(t, e, n, r, o, i) {
  const a = ee("InputErrorIcon");
  return v(), A("div", LU, [
    H(a, { class: "error-icon" }),
    g("span", xU, Q(n.content), 1)
  ]);
}
const r5 = /* @__PURE__ */ Y(yU, [["render", UU], ["__scopeId", "data-v-e3ff35ba"]]);
function Ha(t) {
  return uS() ? (dS(t), !0) : !1;
}
function Et(t) {
  return typeof t == "function" ? t() : M(t);
}
const bf = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const $U = (t) => t != null, kU = Object.prototype.toString, BU = (t) => kU.call(t) === "[object Object]", rr = () => {
}, GU = /* @__PURE__ */ FU();
function FU() {
  var t, e;
  return bf && ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function o5(t, e) {
  function n(...r) {
    return new Promise((o, i) => {
      Promise.resolve(t(() => e.apply(this, r), { fn: e, thisArg: this, args: r })).then(o).catch(i);
    });
  }
  return n;
}
function VU(t, e = {}) {
  let n, r, o = rr;
  const i = (s) => {
    clearTimeout(s), o(), o = rr;
  };
  return (s) => {
    const l = Et(t), c = Et(e.maxWait);
    return n && i(n), l <= 0 || c !== void 0 && c <= 0 ? (r && (i(r), r = null), Promise.resolve(s())) : new Promise((u, d) => {
      o = e.rejectOnCancel ? d : u, c && !r && (r = setTimeout(() => {
        n && i(n), r = null, u(s());
      }, c)), n = setTimeout(() => {
        r && i(r), r = null, u(s());
      }, l);
    });
  };
}
function HU(...t) {
  let e = 0, n, r = !0, o = rr, i, a, s, l, c;
  !er(t[0]) && typeof t[0] == "object" ? { delay: a, trailing: s = !0, leading: l = !0, rejectOnCancel: c = !1 } = t[0] : [a, s = !0, l = !0, c = !1] = t;
  const u = () => {
    n && (clearTimeout(n), n = void 0, o(), o = rr);
  };
  return (f) => {
    const h = Et(a), _ = Date.now() - e, E = () => i = f();
    return u(), h <= 0 ? (e = Date.now(), E()) : (_ > h && (l || !r) ? (e = Date.now(), E()) : s && (i = new Promise((m, N) => {
      o = c ? N : m, n = setTimeout(() => {
        e = Date.now(), r = !0, m(E()), u();
      }, Math.max(0, h - _));
    })), !l && !n && (n = setTimeout(() => r = !0, h)), r = !1, i);
  };
}
function WU(t, e = !1, n = "Timeout") {
  return new Promise((r, o) => {
    setTimeout(e ? () => o(n) : r, t);
  });
}
function YU(t) {
  return t;
}
function KU(t) {
  let e;
  function n() {
    return e || (e = t()), e;
  }
  return n.reset = async () => {
    const r = e;
    e = void 0, r && await r;
  }, n;
}
function zU(t) {
  return t || ff();
}
function ZU(t, e = 200, n = {}) {
  return o5(
    VU(e, n),
    t
  );
}
function qU(t, e = 200, n = !1, r = !0, o = !1) {
  return o5(
    HU(e, n, r, o),
    t
  );
}
function i5(t, e = !0, n) {
  zU() ? ct(t, n) : e ? t() : Ln(t);
}
function XU(t, e, n = {}) {
  const {
    immediate: r = !0
  } = n, o = W(!1);
  let i = null;
  function a() {
    i && (clearTimeout(i), i = null);
  }
  function s() {
    o.value = !1, a();
  }
  function l(...c) {
    a(), o.value = !0, i = setTimeout(() => {
      o.value = !1, i = null, t(...c);
    }, Et(e));
  }
  return r && (o.value = !0, bf && l()), Ha(s), {
    isPending: fS(o),
    start: l,
    stop: s
  };
}
function vn(t) {
  var e;
  const n = Et(t);
  return (e = n == null ? void 0 : n.$el) != null ? e : n;
}
const Gi = bf ? window : void 0, a5 = bf ? window.navigator : void 0;
function co(...t) {
  let e, n, r, o;
  if (typeof t[0] == "string" || Array.isArray(t[0]) ? ([n, r, o] = t, e = Gi) : [e, n, r, o] = t, !e)
    return rr;
  Array.isArray(n) || (n = [n]), Array.isArray(r) || (r = [r]);
  const i = [], a = () => {
    i.forEach((u) => u()), i.length = 0;
  }, s = (u, d, f, h) => (u.addEventListener(d, f, h), () => u.removeEventListener(d, f, h)), l = et(
    () => [vn(e), Et(o)],
    ([u, d]) => {
      if (a(), !u)
        return;
      const f = BU(d) ? { ...d } : d;
      i.push(
        ...n.flatMap((h) => r.map((_) => s(u, h, _, f)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), a();
  };
  return Ha(c), c;
}
let _N = !1;
function Rf(t, e, n = {}) {
  const { window: r = Gi, ignore: o = [], capture: i = !0, detectIframe: a = !1 } = n;
  if (!r)
    return rr;
  GU && !_N && (_N = !0, Array.from(r.document.body.children).forEach((f) => f.addEventListener("click", rr)), r.document.documentElement.addEventListener("click", rr));
  let s = !0;
  const l = (f) => o.some((h) => {
    if (typeof h == "string")
      return Array.from(r.document.querySelectorAll(h)).some((_) => _ === f.target || f.composedPath().includes(_));
    {
      const _ = vn(h);
      return _ && (f.target === _ || f.composedPath().includes(_));
    }
  }), u = [
    co(r, "click", (f) => {
      const h = vn(t);
      if (!(!h || h === f.target || f.composedPath().includes(h))) {
        if (f.detail === 0 && (s = !l(f)), !s) {
          s = !0;
          return;
        }
        e(f);
      }
    }, { passive: !0, capture: i }),
    co(r, "pointerdown", (f) => {
      const h = vn(t);
      s = !l(f) && !!(h && !f.composedPath().includes(h));
    }, { passive: !0 }),
    a && co(r, "blur", (f) => {
      setTimeout(() => {
        var h;
        const _ = vn(t);
        ((h = r.document.activeElement) == null ? void 0 : h.tagName) === "IFRAME" && !(_ != null && _.contains(r.document.activeElement)) && e(f);
      }, 0);
    })
  ].filter(Boolean);
  return () => u.forEach((f) => f());
}
function jU() {
  const t = W(!1), e = ff();
  return e && ct(() => {
    t.value = !0;
  }, e), t;
}
function rl(t) {
  const e = jU();
  return x(() => (e.value, !!t()));
}
function xl(t, e = {}) {
  const { window: n = Gi } = e, r = rl(() => n && "matchMedia" in n && typeof n.matchMedia == "function");
  let o;
  const i = W(!1), a = (c) => {
    i.value = c.matches;
  }, s = () => {
    o && ("removeEventListener" in o ? o.removeEventListener("change", a) : o.removeListener(a));
  }, l = Y_(() => {
    r.value && (s(), o = n.matchMedia(Et(t)), "addEventListener" in o ? o.addEventListener("change", a) : o.addListener(a), i.value = o.matches);
  });
  return Ha(() => {
    l(), s(), o = void 0;
  }), i;
}
function EN(t, e = {}) {
  const {
    controls: n = !1,
    navigator: r = a5
  } = e, o = rl(() => r && "permissions" in r);
  let i;
  const a = typeof t == "string" ? { name: t } : t, s = W(), l = () => {
    i && (s.value = i.state);
  }, c = KU(async () => {
    if (o.value) {
      if (!i)
        try {
          i = await r.permissions.query(a), co(i, "change", l), l();
        } catch {
          s.value = "prompt";
        }
      return i;
    }
  });
  return c(), n ? {
    state: s,
    isSupported: o,
    query: c
  } : s;
}
function JU(t = {}) {
  const {
    navigator: e = a5,
    read: n = !1,
    source: r,
    copiedDuring: o = 1500,
    legacy: i = !1
  } = t, a = rl(() => e && "clipboard" in e), s = EN("clipboard-read"), l = EN("clipboard-write"), c = x(() => a.value || i), u = W(""), d = W(!1), f = XU(() => d.value = !1, o);
  function h() {
    a.value && N(s.value) ? e.clipboard.readText().then((I) => {
      u.value = I;
    }) : u.value = m();
  }
  c.value && n && co(["copy", "cut"], h);
  async function _(I = Et(r)) {
    c.value && I != null && (a.value && N(l.value) ? await e.clipboard.writeText(I) : E(I), u.value = I, d.value = !0, f.start());
  }
  function E(I) {
    const O = document.createElement("textarea");
    O.value = I ?? "", O.style.position = "absolute", O.style.opacity = "0", document.body.appendChild(O), O.select(), document.execCommand("copy"), O.remove();
  }
  function m() {
    var I, O, p;
    return (p = (O = (I = document == null ? void 0 : document.getSelection) == null ? void 0 : I.call(document)) == null ? void 0 : O.toString()) != null ? p : "";
  }
  function N(I) {
    return I === "granted" || I === "prompt";
  }
  return {
    isSupported: c,
    text: u,
    copied: d,
    copy: _
  };
}
function QU(t, e, n = {}) {
  const { window: r = Gi, ...o } = n;
  let i;
  const a = rl(() => r && "ResizeObserver" in r), s = () => {
    i && (i.disconnect(), i = void 0);
  }, l = x(() => Array.isArray(t) ? t.map((d) => vn(d)) : [vn(t)]), c = et(
    l,
    (d) => {
      if (s(), a.value && r) {
        i = new ResizeObserver(e);
        for (const f of d)
          f && i.observe(f, o);
      }
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    s(), c();
  };
  return Ha(u), {
    isSupported: a,
    stop: u
  };
}
function go(t, e = { width: 0, height: 0 }, n = {}) {
  const { window: r = Gi, box: o = "content-box" } = n, i = x(() => {
    var d, f;
    return (f = (d = vn(t)) == null ? void 0 : d.namespaceURI) == null ? void 0 : f.includes("svg");
  }), a = W(e.width), s = W(e.height), { stop: l } = QU(
    t,
    ([d]) => {
      const f = o === "border-box" ? d.borderBoxSize : o === "content-box" ? d.contentBoxSize : d.devicePixelContentBoxSize;
      if (r && i.value) {
        const h = vn(t);
        if (h) {
          const _ = h.getBoundingClientRect();
          a.value = _.width, s.value = _.height;
        }
      } else if (f) {
        const h = Array.isArray(f) ? f : [f];
        a.value = h.reduce((_, { inlineSize: E }) => _ + E, 0), s.value = h.reduce((_, { blockSize: E }) => _ + E, 0);
      } else
        a.value = d.contentRect.width, s.value = d.contentRect.height;
    },
    n
  );
  i5(() => {
    const d = vn(t);
    d && (a.value = "offsetWidth" in d ? d.offsetWidth : e.width, s.value = "offsetHeight" in d ? d.offsetHeight : e.height);
  });
  const c = et(
    () => vn(t),
    (d) => {
      a.value = d ? e.width : 0, s.value = d ? e.height : 0;
    }
  );
  function u() {
    l(), c();
  }
  return {
    width: a,
    height: s,
    stop: u
  };
}
function s5(t, e, n = {}) {
  const {
    root: r,
    rootMargin: o = "0px",
    threshold: i = 0.1,
    window: a = Gi,
    immediate: s = !0
  } = n, l = rl(() => a && "IntersectionObserver" in a), c = x(() => {
    const _ = Et(t);
    return (Array.isArray(_) ? _ : [_]).map(vn).filter($U);
  });
  let u = rr;
  const d = W(s), f = l.value ? et(
    () => [c.value, vn(r), d.value],
    ([_, E]) => {
      if (u(), !d.value || !_.length)
        return;
      const m = new IntersectionObserver(
        e,
        {
          root: vn(E),
          rootMargin: o,
          threshold: i
        }
      );
      _.forEach((N) => N && m.observe(N)), u = () => {
        m.disconnect(), u = rr;
      };
    },
    { immediate: s, flush: "post" }
  ) : rr, h = () => {
    u(), f(), d.value = !1;
  };
  return Ha(h), {
    isSupported: l,
    isActive: d,
    pause() {
      u(), d.value = !1;
    },
    resume() {
      d.value = !0;
    },
    stop: h
  };
}
const pN = 1;
function e$(t, e = {}) {
  const {
    throttle: n = 0,
    idle: r = 200,
    onStop: o = rr,
    onScroll: i = rr,
    offset: a = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions: s = {
      capture: !1,
      passive: !0
    },
    behavior: l = "auto",
    window: c = Gi,
    onError: u = (T) => {
      console.error(T);
    }
  } = e, d = W(0), f = W(0), h = x({
    get() {
      return d.value;
    },
    set(T) {
      E(T, void 0);
    }
  }), _ = x({
    get() {
      return f.value;
    },
    set(T) {
      E(void 0, T);
    }
  });
  function E(T, k) {
    var G, b, P, $;
    if (!c)
      return;
    const y = Et(t);
    if (!y)
      return;
    (P = y instanceof Document ? c.document.body : y) == null || P.scrollTo({
      top: (G = Et(k)) != null ? G : _.value,
      left: (b = Et(T)) != null ? b : h.value,
      behavior: Et(l)
    });
    const L = (($ = y == null ? void 0 : y.document) == null ? void 0 : $.documentElement) || (y == null ? void 0 : y.documentElement) || y;
    h != null && (d.value = L.scrollLeft), _ != null && (f.value = L.scrollTop);
  }
  const m = W(!1), N = Oa({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), I = Oa({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), O = (T) => {
    m.value && (m.value = !1, I.left = !1, I.right = !1, I.top = !1, I.bottom = !1, o(T));
  }, p = ZU(O, n + r), C = (T) => {
    var k;
    if (!c)
      return;
    const G = ((k = T == null ? void 0 : T.document) == null ? void 0 : k.documentElement) || (T == null ? void 0 : T.documentElement) || vn(T), { display: b, flexDirection: P } = getComputedStyle(G), $ = G.scrollLeft;
    I.left = $ < d.value, I.right = $ > d.value;
    const y = Math.abs($) <= (a.left || 0), L = Math.abs($) + G.clientWidth >= G.scrollWidth - (a.right || 0) - pN;
    b === "flex" && P === "row-reverse" ? (N.left = L, N.right = y) : (N.left = y, N.right = L), d.value = $;
    let w = G.scrollTop;
    T === c.document && !w && (w = c.document.body.scrollTop), I.top = w < f.value, I.bottom = w > f.value;
    const R = Math.abs(w) <= (a.top || 0), B = Math.abs(w) + G.clientHeight >= G.scrollHeight - (a.bottom || 0) - pN;
    b === "flex" && P === "column-reverse" ? (N.top = B, N.bottom = R) : (N.top = R, N.bottom = B), f.value = w;
  }, D = (T) => {
    var k;
    if (!c)
      return;
    const G = (k = T.target.documentElement) != null ? k : T.target;
    C(G), m.value = !0, p(T), i(T);
  };
  return co(
    t,
    "scroll",
    n ? qU(D, n, !0, !1) : D,
    s
  ), i5(() => {
    try {
      const T = Et(t);
      if (!T)
        return;
      C(T);
    } catch (T) {
      u(T);
    }
  }), co(
    t,
    "scrollend",
    O,
    s
  ), {
    x: h,
    y: _,
    isScrolling: m,
    arrivedState: N,
    directions: I,
    measure() {
      const T = Et(t);
      c && T && C(T);
    }
  };
}
function t$(t = {}) {
  const { window: e = Gi } = t, n = e == null ? void 0 : e.navigator, r = rl(() => n && "connection" in n), o = W(!0), i = W(!1), a = W(void 0), s = W(void 0), l = W(void 0), c = W(void 0), u = W(void 0), d = W(void 0), f = W("unknown"), h = r.value && n.connection;
  function _() {
    n && (o.value = n.onLine, a.value = o.value ? void 0 : Date.now(), s.value = o.value ? Date.now() : void 0, h && (l.value = h.downlink, c.value = h.downlinkMax, d.value = h.effectiveType, u.value = h.rtt, i.value = h.saveData, f.value = h.type));
  }
  return e && (co(e, "offline", () => {
    o.value = !1, a.value = Date.now();
  }), co(e, "online", () => {
    o.value = !0, s.value = Date.now();
  })), h && co(h, "change", _, !1), _(), {
    isSupported: r,
    isOnline: o,
    saveData: i,
    offlineAt: a,
    onlineAt: s,
    downlink: l,
    downlinkMax: c,
    effectiveType: d,
    rtt: u,
    type: f
  };
}
function n$(t = {}) {
  const { isOnline: e } = t$(t);
  return e;
}
function r$([t, e, n, r]) {
  const o = (u, d) => 1 - 3 * d + 3 * u, i = (u, d) => 3 * d - 6 * u, a = (u) => 3 * u, s = (u, d, f) => ((o(d, f) * u + i(d, f)) * u + a(d)) * u, l = (u, d, f) => 3 * o(d, f) * u * u + 2 * i(d, f) * u + a(d), c = (u) => {
    let d = u;
    for (let f = 0; f < 4; ++f) {
      const h = l(d, t, n);
      if (h === 0)
        return d;
      const _ = s(d, t, n) - u;
      d -= _ / h;
    }
    return d;
  };
  return (u) => t === e && n === r ? u : s(c(u), e, r);
}
function mN(t, e, n) {
  return t + n * (e - t);
}
function M1(t) {
  return (typeof t == "number" ? [t] : t) || [];
}
function o$(t, e, n, r = {}) {
  var o, i;
  const a = Et(e), s = Et(n), l = M1(a), c = M1(s), u = (o = Et(r.duration)) != null ? o : 1e3, d = Date.now(), f = Date.now() + u, h = typeof r.transition == "function" ? r.transition : (i = Et(r.transition)) != null ? i : YU, _ = typeof h == "function" ? h : r$(h);
  return new Promise((E) => {
    t.value = a;
    const m = () => {
      var N;
      if ((N = r.abort) != null && N.call(r)) {
        E();
        return;
      }
      const I = Date.now(), O = _((I - d) / u), p = M1(t.value).map((C, D) => mN(l[D], c[D], O));
      Array.isArray(t.value) ? t.value = p.map((C, D) => {
        var T, k;
        return mN((T = l[D]) != null ? T : 0, (k = c[D]) != null ? k : 0, O);
      }) : typeof t.value == "number" && (t.value = p[0]), I < f ? requestAnimationFrame(m) : (t.value = s, E());
    };
    m();
  });
}
function i$(t, e = {}) {
  let n = 0;
  const r = () => {
    const i = Et(t);
    return typeof i == "number" ? i : i.map(Et);
  }, o = W(r());
  return et(r, async (i) => {
    var a, s;
    if (Et(e.disabled))
      return;
    const l = ++n;
    if (e.delay && await WU(Et(e.delay)), l !== n)
      return;
    const c = Array.isArray(i) ? i.map(Et) : Et(i);
    (a = e.onStarted) == null || a.call(e), await o$(o, o.value, c, {
      ...e,
      abort: () => {
        var u;
        return l !== n || ((u = e.abort) == null ? void 0 : u.call(e));
      }
    }), (s = e.onFinished) == null || s.call(e);
  }, { deep: !0 }), et(() => Et(e.disabled), (i) => {
    i && (n++, o.value = r());
  }), Ha(() => {
    n++;
  }), x(() => Et(e.disabled) ? r() : o.value);
}
function Io() {
  const t = xl("(min-width: 374px)"), e = xl("(min-width: 768px)"), n = xl("(min-width: 1024px)"), r = xl("(max-width: 1280px)");
  return { aboveSmallMobile: t, aboveMobile: e, aboveiPadLandscape: n, below1280: r };
}
const a$ = {
  props: {
    content: {
      type: String,
      required: !1,
      default: ""
    },
    visibleOnlyWhenOverflow: {
      type: Boolean,
      required: !1,
      default: !1
    },
    placement: {
      type: String,
      required: !1,
      default: "top"
    },
    offset: {
      type: Array,
      default: [0, 8]
    },
    followCursor: {
      type: Boolean,
      default: !1
    },
    hideOnClick: {
      type: Boolean,
      default: !0
    },
    animation: {
      type: String,
      default: "shift-away"
    },
    duration: {
      type: Number,
      default: 250
    },
    delay: {
      type: [Number, Array],
      default: [0, 0]
    },
    maxWidth: {
      // number is in px, use string for units such as rem
      // 350px is the default set in vue-tippy
      type: [String, Number],
      required: !1,
      default: 350
    },
    flex: {
      type: Boolean,
      required: !1,
      default: !1
    },
    zIndex: {
      type: Number,
      required: !1,
      default: 9999999999999
    },
    theme: {
      type: String,
      required: !1,
      default: "stripped-down"
    }
  },
  emits: ["hide", "show"],
  setup(t) {
    const { aboveiPadLandscape: e } = Io();
    return {
      aboveiPadLandscape: e
    };
  }
};
const s$ = ["title"];
function l$(t, e, n, r, o, i) {
  const a = ft("tippy");
  return Ze((v(), A("div", {
    class: z(["tooltip", { flex: n.flex }]),
    title: n.content
  }, [
    ue(t.$slots, "default")
  ], 10, s$)), [
    [a, {
      animateFill: "false",
      animation: n.animation,
      duration: n.duration,
      delay: n.delay,
      placement: n.placement,
      theme: n.theme,
      offset: n.offset,
      maxWidth: n.maxWidth,
      zIndex: n.zIndex,
      trigger: r.aboveiPadLandscape ? "mouseenter" : "click",
      followCursor: n.followCursor,
      touch: !0,
      hideOnClick: n.hideOnClick,
      onShow: (s) => {
        const l = s.reference.offsetWidth > s.reference.parentElement.clientWidth;
        if (!n.content || n.visibleOnlyWhenOverflow && !l)
          return !1;
        t.$emit("show");
      },
      onHide: () => t.$emit("hide")
    }]
  ]);
}
const LE = /* @__PURE__ */ Y(a$, [["render", l$]]), c$ = {
  props: {
    hex: {
      type: String,
      required: !1
    },
    dark: {
      type: Boolean,
      required: !1,
      default: !1
    }
  }
};
const u$ = {
  class: "select-arrow",
  width: "12",
  height: "7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, d$ = ["fill"];
function f$(t, e, n, r, o, i) {
  return v(), A("svg", u$, [
    g("path", {
      d: "M1.70711.292893c-.39053-.3905241-1.023693-.3905241-1.414217 0-.3905241.390524-.3905241 1.023687 0 1.414217L1.70711.292893ZM6 6l-.70711.70711c.39053.39052 1.02369.39052 1.41422 0L6 6Zm5.7071-4.29289c.3905-.39053.3905-1.023693 0-1.414217-.3905-.3905241-1.0237-.3905241-1.4142 0l1.4142 1.414217Zm-11.414207 0 4.999997 5 1.41422-1.41422-5-4.999997L.292893 1.70711Zm6.414217 5 4.99999-5L10.2929.292893 5.29289 5.29289l1.41422 1.41422Z",
      fill: n.hex ? n.hex : "",
      class: z([{ default: !n.hex }, { dark: n.dark }])
    }, null, 10, d$)
  ]);
}
const nu = /* @__PURE__ */ Y(c$, [["render", f$], ["__scopeId", "data-v-5273b0f3"]]), h$ = Ne({
  components: { SelectArrow: nu, ErrorMessage: r5, Tooltip: LE },
  name: "oInput",
  inheritAttrs: !1,
  model: {
    event: "updated"
  },
  props: {
    /**
     * Every input should have a label with the exception of `radio` which supports labels for the `items` prop.
     */
    label: {
      type: String,
      required: !1
    },
    /**
     * The input value. Works for all inputs except type `radio`. See `items` prop.
     * This the v-model value from the parent component
     */
    modelValue: {
      type: [String, Number, Boolean, Array],
      default: void 0
    },
    /**
     * An array of items used for inputs of type `radio` and `select`
     */
    items: {
      type: Array,
      default: () => []
    },
    /**
     * A built-in validator which also shows the number of characters left on the label
     */
    maxCharacters: {
      type: Number,
      default: 0,
      required: !1
    },
    /**
     * Override this default function to define your own character counter
     */
    customCounter: {
      type: Function,
      default: (t) => t.length,
      required: !1
    },
    /**
     * A function that returns an error string if the input is not valid.
     * Useful if the built-in validators don't do what you need.
     */
    validator: {
      type: [Function],
      required: !1
    },
    prefix: {
      type: String,
      default: "",
      required: !1
    },
    suffix: {
      type: String,
      default: "",
      required: !1
    },
    nestedButton: {
      type: Boolean,
      default: !1,
      required: !1
    },
    layout: {
      type: String,
      default: "horizontal",
      required: !1
    },
    color: {
      type: String,
      required: !1
    },
    // Only applies to `radio` and `checkbox`
    // Creates a "button" style input with larger click area
    buttonMode: {
      type: Boolean,
      default: !1,
      required: !1
    },
    selectPlaceholder: {
      type: String,
      required: !1,
      default: "Select"
    },
    showCheckboxTooltip: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  emits: ["update:modelValue", "updated"],
  setup(t, { attrs: e, emit: n }) {
    const r = W(t.modelValue), o = W(!0), i = W(!1), a = W(""), s = W(e.id || Br(6)), l = W(), c = W(), u = W(), d = W(), f = x(() => ({ color: t.color })), h = so("validateOnSubmit", !1), _ = so("submitted", void 0), E = x(
      () => !h && !o.value && i.value || h && _ && _.value && !o.value
    ), m = x(() => ({
      "aria-invalid": !o.value,
      "aria-describedby": E.value && "description",
      ...e,
      class: "o-input__input"
    })), N = x(() => {
      const G = {};
      for (const b in e)
        b !== "type" && (G[b] = e[b]);
      return {
        "aria-invalid": !o.value,
        "aria-describedby": E.value && "description",
        ...G,
        class: "o-input__input"
      };
    }), I = x(() => !t.maxCharacters || !t.customCounter ? 0 : t.maxCharacters - t.customCounter(typeof r.value == "string" && r.value ? r.value : ""));
    async function O() {
      var b;
      if (await Ln(), Array.isArray(d.value) && (d.value = d.value[0]), !d.value)
        return;
      const G = (b = d.value) == null ? void 0 : b.validity;
      if (d.value.setCustomValidity(""), o.value = G == null ? void 0 : G.valid, a.value = "", e.type === "email" ? a.value = "Please enter a valid email address." : e.type === "checkbox" ? a.value = "Please check this box." : e.type === "password" && G.tooShort ? a.value = `Your password is not secure. Please choose a password with at least ${e.minlength} characters.` : e.type === "password" && G.valueMissing || e.type === "number" && G.valueMissing ? a.value = "Please fill in this field." : e.type === "radio" && G.valueMissing ? a.value = "Please select one of these options." : e.type === "select" && G.valueMissing ? a.value = "Please select one of these items." : e.type === "number" && G.stepMismatch ? a.value = "Please use fewer decimal places." : G.valueMissing ? a.value = "Please fill in this field." : a.value = d.value.validationMessage, t.maxCharacters && I.value < 0) {
        o.value = !1;
        const P = `Please stay below ${t.maxCharacters} characters.`;
        a.value = P, d.value.setCustomValidity(P);
      }
      if (o.value && t.validator) {
        const P = t.validator(r.value ?? "");
        P && (o.value = !1, a.value = P, d.value.setCustomValidity(P));
      }
    }
    const p = x(
      () => {
        var G;
        return (G = t.items) == null ? void 0 : G.map((b) => b ? Object.assign(b, e, {
          label: b.label || b.value,
          name: e.name,
          value: b.value,
          checked: r.value !== void 0 ? b.value === r.value : b.checked,
          disabled: b.disabled
        }) : {});
      }
    ), C = x(() => typeof t.modelValue < "u"), D = x(() => {
      var b;
      const G = (b = t.items) == null ? void 0 : b.find((P) => P.value === r.value);
      return G ? G.label : (console.error("The value set for this dropdown must be one of its item's values, or undefined."), "");
    });
    function T(G, b) {
      var $, y, L;
      const P = document.getElementById(b);
      if (!P)
        throw new Error("real select element not found...");
      P.value = G, r.value = G, (y = ($ = l.value) == null ? void 0 : $._tippy) == null || y.hide(), (L = l.value) == null || L.focus();
    }
    function k(G) {
      Array.isArray(d.value) && (d.value = d.value[0]), d.value.setCustomValidity(G), i.value = !0, o.value = !1, a.value = G, d.value.focus();
    }
    return Ui(l, {
      content: () => c.value,
      interactive: !0,
      touch: !0,
      animateFill: !1,
      animation: "shift-away",
      duration: [200, 120],
      hideOnClick: !0,
      offset: [0, -2],
      theme: "o-select",
      placement: "bottom",
      trigger: "click",
      maxWidth: 800,
      zIndex: 99999999999999,
      appendTo: "parent",
      popperOptions: {
        strategy: "fixed"
      },
      onShow: () => {
        var G;
        c.value && (c.value.style.width = (((G = l.value) == null ? void 0 : G.clientWidth) ?? 0) + 2 + "px");
      },
      onMount: () => {
        document.body.classList.add("no-scroll");
      },
      onHidden: () => {
        document.body.classList.remove("no-scroll");
      }
    }), ct(async () => {
      await O(), e.hasOwnProperty("autofocus") && e.autofocus !== !1 && (await Or(1), d.value.focus());
    }), et(
      () => t.modelValue,
      (G, b) => {
        G !== b && (r.value = G);
      }
    ), et(r, async (G) => {
      n("update:modelValue", G), n("updated", G), await O();
    }), {
      id: s,
      bind: m,
      bindSelect: N,
      valid: o,
      dirty: i,
      error: E,
      setError: k,
      selectFieldset: u,
      inputRef: d,
      localValue: r,
      errorMessage: a,
      computedItems: p,
      selectContainer: l,
      selectDropDownMenu: c,
      modelValueIsDefined: C,
      selectedItemLabel: D,
      charactersRemaining: I,
      selectValue: T,
      inputColorStyle: f,
      validate: O
    };
  }
});
const _$ = {
  key: 0,
  class: "o-input__fieldset"
}, E$ = {
  key: 0,
  class: "o-label-container flex items-center justify-between"
}, p$ = ["for"], m$ = ["name", "id", "value", "onClick", "disabled"], N$ = {
  key: 0,
  class: "circle"
}, v$ = ["innerHTML"], g$ = {
  key: 0,
  class: "o-label-container flex items-center justify-between"
}, I$ = {
  key: 0,
  class: "select-value"
}, O$ = {
  key: 1,
  class: "select-value placeholder"
}, A$ = ["id"], D$ = ["id", "value"], C$ = { ref: "selectDropDownMenu" }, S$ = ["for", "onClick"], w$ = {
  class: /* @__PURE__ */ z(["select-item o-input__text f6"])
}, T$ = ["for"], b$ = ["id", "checked"], R$ = {
  key: 0,
  class: "check",
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  xmlns: "http://www.w3.org/2000/svg"
}, M$ = ["innerHTML"], P$ = ["innerHTML"], y$ = {
  key: 3,
  class: /* @__PURE__ */ z(["o-input__label"])
}, L$ = {
  key: 0,
  class: "o-label-container flex items-center justify-between"
}, x$ = {
  class: /* @__PURE__ */ z(["o-input__text o-input-label"])
}, U$ = {
  key: 0,
  class: "nested-button"
}, $$ = {
  key: 0,
  class: "prefix"
}, k$ = ["step"], B$ = {
  key: 1,
  class: "suffix"
}, G$ = {
  key: 2,
  class: "nested-button"
}, F$ = {
  key: 0,
  class: "prefix"
}, V$ = {
  key: 1,
  class: "suffix"
}, H$ = {
  key: 0,
  class: "prefix"
}, W$ = {
  key: 1,
  class: "suffix"
}, Y$ = {
  key: 2,
  class: "nested-button"
};
function K$(t, e, n, r, o, i) {
  const a = ee("SelectArrow"), s = ee("perfect-scrollbar"), l = ee("Tooltip"), c = ee("ErrorMessage");
  return v(), A("div", {
    class: z([
      "o-input",
      `o-input--${t.$attrs.type || "text"}`,
      {
        "o-input--required": t.$attrs.hasOwnProperty("required"),
        "o-input--invalid": !t.valid,
        "o-input--dirty": t.dirty,
        "o-input--error": t.error
      },
      t.$attrs.class
    ])
  }, [
    t.$attrs.type === "radio" ? (v(), A("fieldset", _$, [
      t.label ? (v(), A("div", E$, [
        g("span", {
          class: z(["o-input__text o-input-label", t.$attrs.text])
        }, Q(t.label), 3)
      ])) : V("", !0),
      (v(!0), A(ge, null, ye(t.computedItems, (u, d) => (v(), A("label", Tt({
        key: u.value,
        for: `${t.id}__input-${d}`,
        class: [[t.layout, { "button-mode": t.buttonMode, disabled: u.disabled }], "o-input__label o-input__radio"]
      }, { ref_for: !0 }, { ...u }), [
        g("input", Tt({
          ref_for: !0,
          ref: "inputRef",
          name: t.$attrs.name,
          id: `${t.id}__input-${d}`
        }, { ref_for: !0 }, { ...t.bind }, {
          value: t.localValue ?? "",
          onBlurOnce: e[0] || (e[0] = (f) => t.dirty = !0),
          onClick: (f) => t.localValue = u.value,
          class: [u.checked ? "checked" : "", "radio"],
          disabled: !!u.disabled,
          type: "radio"
        }), null, 16, m$),
        u.checked ? (v(), A("div", N$)) : V("", !0),
        g("span", {
          class: z(["o-input__text f6", t.$attrs.text]),
          innerHTML: u.label
        }, null, 10, v$)
      ], 16, p$))), 128))
    ])) : t.$attrs.type === "select" ? (v(), A("fieldset", {
      key: 1,
      ref: "selectFieldset",
      class: z(["o-input__fieldset", t.$attrs.fieldset])
    }, [
      t.label ? (v(), A("div", g$, [
        g("span", {
          class: z(["o-input__text o-input-label", t.$attrs.text])
        }, Q(t.label), 3),
        ue(t.$slots, "label-end")
      ])) : V("", !0),
      g("div", Tt({
        ref: "selectContainer",
        class: "select-container truncate"
      }, t.bind, { tabindex: "0" }), [
        t.modelValueIsDefined ? (v(), A("span", I$, Q(t.selectedItemLabel), 1)) : (v(), A("span", O$, Q(t.selectPlaceholder), 1)),
        H(a, { class: "select-arrow" })
      ], 16),
      Ze(g("select", Tt({
        "onUpdate:modelValue": e[1] || (e[1] = (u) => t.localValue = u)
      }, t.bindSelect, {
        ref: "inputRef",
        id: `${t.id}_select`,
        onBlurOnce: e[2] || (e[2] = (u) => t.dirty = !0),
        class: "hidden-select",
        tabindex: "-1",
        "aria-hidden": "true"
      }), [
        (v(!0), A(ge, null, ye(t.computedItems, (u, d) => (v(), A("option", {
          id: `${t.id}__input-${d}`,
          key: u.value,
          value: u.value
        }, Q(u.label), 9, D$))), 128))
      ], 16, A$), [
        [hS, t.localValue]
      ]),
      g("div", C$, [
        H(s, { class: "w-100 items-container" }, {
          default: q(() => [
            (v(!0), A(ge, null, ye(t.computedItems, (u, d) => (v(), A("label", {
              class: "o-input__label o-input__select",
              key: u.value,
              for: `${t.id}__input-${d}`,
              onClick: (f) => t.selectValue(u.value, `${t.id}_select`),
              onClickOnce: e[3] || (e[3] = (f) => t.dirty = !0)
            }, [
              g("input", Tt({ ref_for: !0 }, { ...t.bind, ...u }, {
                type: "radio",
                class: "select"
              }), null, 16),
              g("span", w$, Q(u.label), 1)
            ], 40, S$))), 128))
          ]),
          _: 1
        })
      ], 512)
    ], 2)) : t.$attrs.type === "checkbox" ? (v(), A("label", {
      key: 2,
      for: `${t.id}__input`,
      class: z([t.layout, { "button-mode": t.buttonMode }, "o-input__label", "o-input__checkbox"])
    }, [
      g("input", Tt({
        ref: "inputRef",
        id: `${t.id}__input`,
        checked: t.localValue === void 0 ? t.$attrs.checked : t.localValue,
        class: t.localValue ? "checked" : ""
      }, t.bind, {
        onChange: e[4] || (e[4] = (u) => {
          var d;
          return t.localValue = (d = u.target) == null ? void 0 : d.checked;
        }),
        onBlurOnce: e[5] || (e[5] = (u) => t.dirty = !0),
        class: "checkbox"
      }), null, 16, b$),
      t.localValue ? (v(), A("svg", R$, [...e[14] || (e[14] = [
        g("polyline", {
          points: "4.5 9 7.5 12 13.5 6",
          transform: "translate(-3 -5)",
          "fill-rule": "nonzero",
          stroke: "#FFFFFF",
          "stroke-width": "2",
          fill: "none",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, -1)
      ])])) : V("", !0),
      t.label && t.showCheckboxTooltip ? (v(), te(l, {
        key: 1,
        content: t.label,
        maxWidth: 600,
        placement: "top-start"
      }, {
        default: q(() => [
          g("span", {
            class: z(["o-input__text f6 ml-12"]),
            innerHTML: t.label
          }, null, 8, M$)
        ]),
        _: 1
      }, 8, ["content"])) : t.label ? (v(), A("span", {
        key: 2,
        class: z(["o-input__text f6 ml-12"]),
        innerHTML: t.label
      }, null, 8, P$)) : V("", !0)
    ], 10, T$)) : (v(), A("label", y$, [
      t.label ? (v(), A("div", L$, [
        g("span", x$, Q(t.label), 1),
        ue(t.$slots, "label-end", {}, () => [
          t.maxCharacters ? (v(), A("span", {
            key: 0,
            class: z([{ red: t.charactersRemaining < 0 }, "o-input-characters-remaining"])
          }, Q(t.charactersRemaining), 3)) : V("", !0)
        ])
      ])) : V("", !0),
      t.$attrs.type === "textarea" ? (v(), A("div", Tt({ key: 1 }, t.bind, {
        class: [t.nestedButton ? "nested-button" : "", "o-input__wrapper"]
      }), [
        Ze(g("textarea", Tt({
          ref: "inputRef",
          "onUpdate:modelValue": e[6] || (e[6] = (u) => t.localValue = u)
        }, t.bind, {
          onBlurOnce: e[7] || (e[7] = (u) => t.dirty = !0)
        }), null, 16), [
          [g1, t.localValue]
        ]),
        t.nestedButton ? (v(), A("div", U$, [
          ue(t.$slots, "nestedButton")
        ])) : V("", !0)
      ], 16)) : t.$attrs.type === "number" ? (v(), A("div", Tt({ key: 2 }, t.bind, { class: "o-input__wrapper" }), [
        t.prefix || t.$slots.prefix ? (v(), A("div", $$, [
          ue(t.$slots, "prefix", {}, () => [
            me(Q(t.prefix), 1)
          ])
        ])) : V("", !0),
        Ze(g("input", Tt({
          ref: "inputRef",
          "onUpdate:modelValue": e[8] || (e[8] = (u) => t.localValue = u)
        }, t.bind, {
          type: "number",
          inputmode: "decimal",
          pattern: "\\d*",
          step: t.$attrs.step ?? "0.01",
          onBlurOnce: e[9] || (e[9] = (u) => t.dirty = !0),
          style: t.inputColorStyle
        }), null, 16, k$), [
          [g1, t.localValue]
        ]),
        t.suffix ? (v(), A("div", B$, Q(t.suffix), 1)) : V("", !0),
        t.nestedButton ? (v(), A("div", G$, [
          ue(t.$slots, "nestedButton")
        ])) : V("", !0),
        t.$slots["wrapper-child"] ? ue(t.$slots, "wrapper-child", { key: 3 }) : V("", !0)
      ], 16)) : t.$attrs.type === "email" ? (v(), A("div", Tt({ key: 3 }, t.bind, { class: "o-input__wrapper" }), [
        t.prefix || t.$slots.prefix ? (v(), A("div", F$, [
          ue(t.$slots, "prefix", {}, () => [
            me(Q(t.prefix), 1)
          ])
        ])) : V("", !0),
        Ze(g("input", Tt({
          ref: "inputRef",
          "onUpdate:modelValue": e[10] || (e[10] = (u) => t.localValue = u)
        }, t.bind, {
          onBlurOnce: e[11] || (e[11] = (u) => t.dirty = !0),
          pattern: "^[a-zA-Z0-9.!#$%&'*+\\/=?^_`\\{\\|\\}~\\-]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)+$",
          style: t.inputColorStyle
        }), null, 16), [
          [_S, t.localValue]
        ]),
        t.suffix ? (v(), A("div", V$, Q(t.suffix), 1)) : V("", !0),
        t.$slots["wrapper-child"] ? ue(t.$slots, "wrapper-child", { key: 2 }) : V("", !0)
      ], 16)) : (v(), A("div", Tt({ key: 4 }, t.bind, {
        class: [t.nestedButton ? "nested-button" : "", "o-input__wrapper"]
      }), [
        t.prefix || t.$slots.prefix ? (v(), A("div", H$, [
          ue(t.$slots, "prefix", {}, () => [
            me(Q(t.prefix), 1)
          ])
        ])) : V("", !0),
        Ze(g("input", Tt({
          ref: "inputRef",
          type: "text",
          "onUpdate:modelValue": e[12] || (e[12] = (u) => t.localValue = u)
        }, t.bind, {
          onBlurOnce: e[13] || (e[13] = (u) => t.dirty = !0),
          style: t.inputColorStyle
        }), null, 16), [
          [g1, t.localValue]
        ]),
        t.suffix ? (v(), A("div", W$, Q(t.suffix), 1)) : V("", !0),
        t.nestedButton ? (v(), A("div", Y$, [
          ue(t.$slots, "nestedButton")
        ])) : V("", !0),
        t.$slots["wrapper-child"] ? ue(t.$slots, "wrapper-child", { key: 3 }) : V("", !0)
      ], 16))
    ])),
    t.error ? (v(), te(c, {
      key: 4,
      content: t.errorMessage,
      style: { "margin-top": "0.875rem" }
    }, null, 8, ["content"])) : V("", !0)
  ], 2);
}
const Nc = /* @__PURE__ */ Y(h$, [["render", K$]]), z$ = {
  name: "oForm",
  props: {
    validateOnSubmit: {
      type: Boolean,
      required: !1,
      default: !1
    },
    autofill: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  setup(t, { emit: e }) {
    const n = W(), r = W(!1), o = Oa({}), i = x(() => !Object.values(o).find((u) => !u.valid));
    ct(() => a()), ES(() => a()), Ti("validateOnSubmit", t.validateOnSubmit), Ti("submitted", r);
    function a() {
      const u = Array.from(n.value.querySelectorAll("input, textarea, select"));
      for (const d in o)
        u.find((f) => f.name === d) || delete o[d];
      u.forEach((d) => {
        !d.name && d.type !== "submit" && console.warn("oForm: input element has no name attribute", d);
        const f = d.name || Br(6);
        o[f] = o[f] ?? {
          el: d,
          value: d.value,
          valid: d.validity.valid
        };
      });
    }
    function s(u) {
      if (!u)
        return;
      const d = u;
      if (!d.name)
        throw new Error('oInputs must have a "name" attribute to work correctly within oForm.');
      const { value: f, validity: h, name: _ } = d;
      o[_].value = f, o[_].valid = h.valid;
    }
    function l() {
      const u = Array.from(n.value.querySelectorAll("input, textarea, select"));
      for (const d in o) {
        const f = u.find((h) => h.name === d);
        s(f);
      }
    }
    function c() {
      if (r.value = !0, l(), !i.value) {
        const d = Object.keys(o).reverse();
        let f;
        for (const h of d) {
          const _ = o[h];
          _.valid || (_.el.focus(), _.el.blur(), f = _);
        }
        f && f.el.focus();
        return;
      }
      const u = {};
      for (const d of Object.keys(o)) {
        const f = o[d];
        f.el.type === "checkbox" ? u[d] = f.el.checked : u[d] = f.value;
      }
      return e("submitted", u), u;
    }
    return { form: n, onInput: s, submit: c, valid: i };
  }
};
const Z$ = ["autocomplete"];
function q$(t, e, n, r, o, i) {
  return v(), A("form", {
    onInput: e[0] || (e[0] = (a) => r.onInput(a.target)),
    onSubmit: e[1] || (e[1] = ua((...a) => r.submit && r.submit(...a), ["prevent"])),
    ref: "form",
    novalidate: "",
    autocomplete: n.autofill ? null : "off"
  }, [
    ue(t.$slots, "default"),
    e[2] || (e[2] = g("input", {
      type: "submit",
      hidden: ""
    }, null, -1))
  ], 40, Z$);
}
const xE = /* @__PURE__ */ Y(z$, [["render", q$]]), X$ = Ne({
  components: { oButton: ln, TableEdit: n5, oInput: Nc, oForm: xE },
  name: "oTableCell",
  props: {
    value: {
      type: [String, Number, Object, Boolean],
      default: null
    },
    columnName: {
      type: [String, Number],
      default: null
    },
    editable: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["updated"],
  setup(t, { emit: e }) {
    const n = W(), r = W(), o = W(), i = W(t.value);
    function a() {
      var l, c;
      i.value = t.value, (c = (l = r.value) == null ? void 0 : l._tippy) == null || c.hide();
    }
    function s() {
      var l, c;
      e("updated", i.value), (c = (l = r.value) == null ? void 0 : l._tippy) == null || c.hide();
    }
    return t.editable && Ui(r, {
      content: () => n.value,
      interactive: !0,
      animateFill: !1,
      trigger: "click",
      animation: "shift-away",
      offset: [0, -28],
      arrow: !1,
      duration: [200, 120],
      placement: "bottom-start",
      theme: "o-edit",
      appendTo: () => document.body,
      popperOptions: {
        strategy: "fixed"
      },
      onShow: () => {
        Ln(() => {
          o.value.inputRef.focus();
        });
      }
    }), { tooltipContent: n, tooltipButton: r, toggleEdit: a, saveEdit: s, tooltipInput: o, localValue: i };
  }
});
const j$ = {
  class: "cell-contents relative",
  ref: "tooltipButton"
}, J$ = {
  key: 1,
  ref: "tooltipContent"
}, Q$ = { class: "w-100 flex justify-start" };
function ek(t, e, n, r, o, i) {
  const a = ee("TableEdit"), s = ee("oButton"), l = ee("oInput"), c = ee("oForm");
  return v(), A("div", j$, [
    ue(t.$slots, "default"),
    t.editable ? (v(), te(s, {
      key: 0,
      color: "white",
      classes: "edit-icon"
    }, {
      default: q(() => [
        H(a, { style: { transform: "translateY(2px) !important" } })
      ]),
      _: 1
    })) : V("", !0),
    t.editable ? (v(), A("div", J$, [
      H(c, { onSubmitted: t.saveEdit }, {
        default: q(() => [
          H(l, {
            ref: "tooltipInput",
            name: "fieldValue",
            type: "text",
            modelValue: t.localValue,
            "onUpdate:modelValue": e[0] || (e[0] = (u) => t.localValue = u),
            autocomplete: "off",
            class: "mb3"
          }, null, 8, ["modelValue"]),
          g("div", Q$, [
            H(s, {
              size: "small",
              color: "white",
              onClicked: t.toggleEdit
            }, {
              default: q(() => [...e[1] || (e[1] = [
                me(" Cancel ", -1)
              ])]),
              _: 1
            }, 8, ["onClicked"]),
            H(s, {
              type: "submit",
              size: "small",
              color: "blue",
              class: "ml2"
            }, {
              default: q(() => [...e[2] || (e[2] = [
                me(" Save ", -1)
              ])]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["onSubmitted"])
    ], 512)) : V("", !0)
  ], 512);
}
const tk = /* @__PURE__ */ Y(X$, [["render", ek]]), UE = Ne({
  components: {
    TableSortArrowUp: Bx,
    TableSortArrowDown: xx,
    TableSortableArrows: Mx,
    oButton: ln,
    TableEdit: n5,
    oInput: Nc,
    oForm: xE,
    oTableCell: tk,
    Text: Ye,
    Label: Zx,
    Spinner: t5,
    UpArrow: Hx
  },
  name: "oTable",
  props: {
    classes: {
      type: String,
      default: null
    },
    headers: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    page: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 40
    },
    paginationMethod: {
      type: String,
      default: "default"
    },
    intersectionOptions: {
      type: Object,
      default: () => ({
        threshold: 1,
        rootMargin: "0px 0px -64px 0px"
      })
    },
    orderBy: {
      type: String,
      default: null
    },
    order: {
      type: String,
      default: null
    },
    caption: {
      type: String,
      default: ""
    },
    noShadow: {
      type: Boolean,
      default: !1
    },
    fixedLayout: {
      type: Boolean,
      default: !1
    },
    isLoading: {
      type: Boolean
    },
    responsiveMode: {
      type: String,
      required: !1,
      default: "stacked"
    },
    persistHeight: {
      type: Boolean,
      default: !1
    },
    maxHeight: {
      type: Number,
      required: !1
    },
    sidebarAdjust: {
      // Adjusts the position of the fixed `scrollToTop` button to account for sidebar
      type: Boolean,
      default: !1
    },
    responsiveBreakpoint: {
      // the window width at which oTable collapses, unit must be provided in px or rem
      type: String,
      required: !1,
      default: "480px"
    },
    responsiveColSize: {
      // when responsiveMode is set to columns, this set the width of the two columns
      // the two values must adhere to grid-template-columns
      // https://developer.mozilla.org/en-US/docs/Web/CSS/grid-template-columns
      type: String,
      required: !1,
      default: "50% 1fr"
    },
    borderRadius: {
      type: Number,
      required: !1,
      default: 16
    }
  },
  emits: ["updated", "mouseenterRow", "mouseleaveRow", "sort"],
  setup: (t, { emit: e }) => {
    const n = W(), r = W(t.orderBy), o = W((t.order && t.order.toUpperCase()) ?? null), i = W(t.page), a = x(() => {
      const w = {};
      return t.headers.forEach((R) => {
        w[R.key] = R;
      }), w;
    }), s = x(() => {
      var K;
      const { items: w, perPage: R } = t;
      let B = w.map((Z) => ({
        ...Z
      })), U = cU(
        r.value,
        o.value,
        B,
        (K = a.value[r.value]) == null ? void 0 : K.sortTransform
      );
      if (t.paginationMethod === "default" && R > -1) {
        const Z = (Math.max(i.value, 1) - 1) * R;
        U = U.slice(Z, Z + R);
      }
      if (t.paginationMethod === "intersection" && R > -1) {
        const Z = i.value * R;
        U = U.slice(0, Z);
      }
      return U;
    }), l = x(
      () => t.headers.filter((w) => w.sortable).map(({ key: w, text: R }) => ({ label: R, value: w }))
    ), c = x(() => {
      const w = Math.max(Math.ceil(t.items.length / t.perPage), 1);
      return w < i.value && (i.value = w), w;
    }), { y: u } = e$(window.document), d = x(() => u.value > 800), f = x(() => c.value > 7), h = x(() => i.value >= 5 && f.value), _ = x(() => c.value - i.value > 3 && f.value), E = x(() => {
      if (!f.value)
        return Math.max(0, c.value - 2);
      const w = h.value && _.value ? 3 : 4;
      return Math.max(0, Math.min(c.value - 2, w));
    }), m = x(() => !f.value || i.value <= 4 ? 1 : Math.min(c.value - (E.value + 1), Math.max(1, i.value - 2))), N = xl(`(max-width: ${t.responsiveBreakpoint})`), I = W("auto"), O = 64, p = W(), { height: C } = go(p), D = W(), T = W(null), k = x(() => c.value > 1 && i.value !== c.value);
    if (t.paginationMethod === "intersection") {
      const { stop: w } = s5(
        T,
        ([{ isIntersecting: R }]) => {
          i.value === c.value && w(), R && k.value && L.showNextPage(i.value + 1);
        },
        t.intersectionOptions
      );
    }
    const G = (w, R) => {
      w && R === 0 && (p.value = w);
    };
    et([p, C, s], async ([w, R, B]) => {
      if (!t.persistHeight || t.paginationMethod === "intersection" || c.value <= 1 || !w)
        return;
      const U = c.value > 1;
      if (!U) {
        I.value = "auto";
        return;
      }
      await Ln(), (U && I.value === "auto" || Math.abs(R - D.value) > 1 && R !== 0) && (D.value = R, b(R));
    });
    function b(w) {
      const R = c.value > 1, B = R ? t.perPage + 1 : t.items.length + 1, U = R ? M(w) * t.perPage : M(w) * t.items.length, K = Math.ceil(O + U + B);
      I.value = K + "px";
    }
    const P = x(() => typeof t.maxHeight == "number"), $ = x(() => t.paginationMethod === "intersection" && P.value), y = x(() => t.paginationMethod === "default" && t.persistHeight && c.value > 1 && i.value === c.value && t.items.length % t.perPage !== 0);
    ct(() => {
      const w = !!t.headers.find((U) => U.editable), R = t.items.every((U) => !!U.id);
      if (w && !R)
        throw new Error("Rows must have IDs to allow editable cells.");
      if (t.headers.find((U) => U.editable && U.sortable))
        throw new Error("A header cannot be both sortable and editable");
    });
    const L = {
      cycleSort() {
        switch (o.value) {
          case "ASC":
            o.value = "DESC";
            break;
          case "DESC":
            o.value = null;
            break;
          default:
            o.value = "ASC";
        }
        e("sort", { key: r.value, order: o.value });
      },
      onSort(w) {
        if (i.value = 1, w !== r.value) {
          r.value = w, o.value = "ASC";
          return;
        }
        L.cycleSort();
      },
      goToPage(w) {
        i.value = Math.min(Math.max(1, w), c.value);
      },
      async showNextPage(w) {
        const R = P.value ? null : window.scrollY;
        i.value = Math.min(w, c.value), R && (await Ln(), window.scrollTo(0, R));
      },
      emitCellChange(w, R, B) {
        e("updated", { rowId: w, cellKey: R, newValue: B });
      },
      ariaSort(w) {
        let R = "descending";
        return r.value !== w.key ? R = null : o.value === "ASC" && (R = "ascending"), R;
      },
      ariaLabel(w) {
        let R = "default";
        return o.value ? o.value === "ASC" && (R = "descending") : R = "ascending", ["sort by", w.text || w.key, "in", R, "order"].join(" ");
      },
      saveEdit({ key: w, row: R }, { fieldValue: B }) {
        e("updated", {
          rowId: R.id,
          cellKey: w,
          newValue: B
        });
      },
      getPaddingStyleOverride(w) {
        if (typeof w > "u")
          return {};
        if (typeof w != "string")
          throw new Error('vPadding must be a string such as "1rem"');
        return {
          "padding-top": w,
          "padding-bottom": w
        };
      },
      scrollToTop() {
        window.scrollTo(0, 0);
      }
    };
    return {
      tableWrapper: n,
      currentPage: i,
      cItems: s,
      cHeaders: a,
      lastPage: c,
      sortBy: r,
      sortOrder: o,
      ...L,
      startingPoint: m,
      shownPages: E,
      showFirstEllipsis: h,
      showSecondEllipsis: _,
      isResponsive: N,
      responsiveSortItems: l,
      responsiveColSize: t.responsiveColSize,
      HEADER_HEIGHT: O,
      setInitalRowRef: G,
      tableHeight: I,
      hasMaxHeight: P,
      hideHeaderBorder: $,
      showLastItemBorder: y,
      showMoreButton: T,
      hasPagesLeft: k,
      showScrollTopButton: d
    };
  }
}), NN = () => {
  Wr((t) => ({
    d0a7d502: t.responsiveColSize
  }));
}, vN = UE.setup;
UE.setup = vN ? (t, e) => (NN(), vN(t, e)) : NN;
const nk = {
  key: 0,
  class: "responsive-sort-header"
}, rk = { class: "responsive-sort-input" }, ok = {
  key: 0,
  class: "responsive-sort-empty-icon"
}, ik = {
  key: 0,
  id: "caption"
}, ak = { key: 1 }, sk = ["aria-sort"], lk = { style: { display: "flex", "align-items": "center" } }, ck = { class: "table-sort-button-container" }, uk = ["onMouseenter", "onMouseleave"], dk = ["data-label"], fk = { key: 1 }, hk = {
  key: 2,
  class: "o-table-pagination-container"
}, _k = {
  key: 0,
  class: "o-table-pagination"
}, Ek = { class: "flex items-center" }, pk = { key: 0 }, mk = { key: 1 }, Nk = {
  key: 1,
  ref: "showMoreButton",
  class: "o-table-pagination intersection"
};
function vk(t, e, n, r, o, i) {
  const a = ee("Label"), s = ee("oInput"), l = ee("TableSortArrowUp"), c = ee("TableSortArrowDown"), u = ee("TableSortableArrows"), d = ee("oButton"), f = ee("oTableCell"), h = ee("Spinner"), _ = ee("UpArrow");
  return v(), A("section", {
    ref: "tableWrapper",
    class: z([
      { "no-shadow": t.noShadow },
      { "fixed-layout": t.fixedLayout },
      t.responsiveMode && t.isResponsive ? `responsive ${t.responsiveMode}` : null,
      "o-table-wrapper"
    ]),
    style: Fe({ borderRadius: t.borderRadius + "px" })
  }, [
    t.isResponsive && t.responsiveSortItems.length > 0 ? (v(), A("header", nk, [
      H(a, {
        left: !0,
        class: "responsive-sort-label"
      }, {
        default: q(() => [...e[10] || (e[10] = [
          me("Sort By:", -1)
        ])]),
        _: 1
      }),
      g("div", rk, [
        H(s, {
          modelValue: t.sortBy,
          "onUpdate:modelValue": e[0] || (e[0] = (E) => t.sortBy = E),
          type: "select",
          items: t.responsiveSortItems
        }, null, 8, ["modelValue", "items"]),
        !t.sortBy || t.sortBy === "id" ? (v(), A("div", ok, [...e[11] || (e[11] = [
          g("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "12",
            height: "8",
            viewBox: "0 0 12 8",
            fill: "none"
          }, [
            g("path", {
              stroke: "#000",
              "stroke-width": "2",
              "stroke-linecap": "round",
              d: "M1 4h10"
            })
          ], -1)
        ])])) : V("", !0)
      ]),
      H(d, {
        color: "white",
        classes: "responsive-table-sort-button ml2",
        circle: !0,
        size: "x-small",
        onClicked: e[1] || (e[1] = (E) => t.cycleSort()),
        "aria-label": "Sort order"
      }, {
        icon: q(() => [
          t.sortOrder === "ASC" ? (v(), te(l, {
            key: 0,
            class: "sort-single-arrow-up"
          })) : t.sortOrder === "DESC" ? (v(), te(c, {
            key: 1,
            class: "sort-single-arrow-down"
          })) : (v(), te(u, { key: 2 }))
        ]),
        _: 1
      })
    ])) : V("", !0),
    (v(), te(zo(t.isResponsive ? "div" : "perfect-scrollbar"), {
      style: Fe([
        { height: t.isResponsive ? "auto" : t.tableHeight },
        { borderRadius: t.borderRadius + "px" },
        { maxHeight: t.hasMaxHeight ? t.maxHeight + "px" : "none" }
      ]),
      class: z(["o-table-container", t.classes]),
      tabindex: "0",
      role: "group",
      "aria-labelledby": "caption",
      onPsYReachEnd: e[2] || (e[2] = (E) => t.hasMaxHeight ? t.showNextPage(t.currentPage + 1) : null)
    }, {
      default: q(() => [
        g("table", {
          class: z({ "fixed-layout": t.fixedLayout })
        }, [
          t.caption ? (v(), A("caption", ik, Q(t.caption), 1)) : V("", !0),
          t.headers.length ? (v(), A("thead", ak, [
            g("tr", {
              style: Fe({ height: t.HEADER_HEIGHT + "px" }),
              class: z({ "no-header-border": t.hideHeaderBorder })
            }, [
              (v(!0), A(ge, null, ye(t.cHeaders, (E, m) => (v(), A("th", {
                key: m,
                "aria-sort": t.ariaSort(E),
                class: z([
                  { "no-padding": !t.isResponsive && t.cHeaders[m].noPadding },
                  t.cHeaders[m].color && t.cHeaders[m].color
                ]),
                style: Fe({
                  width: t.cHeaders[m].width + "px",
                  ...t.getPaddingStyleOverride(t.cHeaders[m].vHeaderPadding)
                })
              }, [
                g("div", lk, [
                  ue(t.$slots, `header.${m}`, {}, () => [
                    me(Q(E.text || E.key), 1)
                  ]),
                  g("div", ck, [
                    E.sortable ? (v(), te(d, {
                      key: 0,
                      circle: !0,
                      size: "x-small",
                      color: "white",
                      classes: "table-sort-button ml2",
                      "aria-label": t.ariaLabel(E),
                      onClicked: (N) => t.onSort(E.key)
                    }, {
                      icon: q(() => [
                        E.key === t.sortBy && t.sortOrder === "ASC" ? (v(), te(l, { key: 0 })) : E.key === t.sortBy && t.sortOrder === "DESC" ? (v(), te(c, { key: 1 })) : (v(), te(u, { key: 2 }))
                      ]),
                      _: 2
                    }, 1032, ["aria-label", "onClicked"])) : V("", !0)
                  ])
                ])
              ], 14, sk))), 128))
            ], 6)
          ])) : V("", !0),
          g("tbody", null, [
            (v(!0), A(ge, null, ye(t.cItems, (E, m) => (v(), A("tr", {
              key: E.id,
              ref_for: !0,
              ref: (N) => t.setInitalRowRef(N, m),
              class: z([t.showLastItemBorder && !t.isResponsive ? "extra-border" : ""]),
              onMouseenter: (N) => t.$emit("mouseenterRow", E),
              onMouseleave: (N) => t.$emit("mouseleaveRow", E)
            }, [
              (v(!0), A(ge, null, ye(t.cHeaders, (N, I) => (v(), A("td", {
                key: I,
                class: z({
                  "remove-padding": t.cHeaders[I].removePadding,
                  "no-padding": !t.isResponsive && t.cHeaders[I].noPadding
                }),
                "data-label": t.cHeaders[I].text,
                style: Fe({
                  ...t.getPaddingStyleOverride(t.cHeaders[I].vPadding)
                })
              }, [
                t.isResponsive ? (v(), A("div", {
                  key: 0,
                  class: z(["responsive-header", t.cHeaders[I].color ?? null])
                }, [
                  t.$slots[`header.${I}`] ? ue(t.$slots, `header.${I}`, { key: 0 }, () => [
                    me(Q(t.cHeaders[I].text || t.cHeaders[I].key), 1)
                  ]) : (v(), A("span", fk, Q(t.cHeaders[I].text || t.cHeaders[I].key), 1))
                ], 2)) : V("", !0),
                H(f, {
                  onUpdated: (O) => t.saveEdit({ key: I, row: E }, { fieldValue: O }),
                  value: E[I],
                  "column-name": I,
                  editable: t.cHeaders[I].editable
                }, {
                  default: q(() => [
                    ue(t.$slots, `column.${I}`, Tt({ ref_for: !0 }, { value: E[I], column: I, row: E, responsiveMode: t.isResponsive }), () => [
                      g("span", null, Q(E[I]), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["onUpdated", "value", "column-name", "editable"])
              ], 14, dk))), 128))
            ], 42, uk))), 128))
          ])
        ], 2),
        t.$slots["empty-state"] ? ue(t.$slots, "empty-state", { key: 0 }) : V("", !0)
      ]),
      _: 3
    }, 40, ["style", "class"])),
    t.$slots.footer ? ue(t.$slots, "footer", { key: 1 }) : V("", !0),
    t.hasMaxHeight ? V("", !0) : (v(), A("div", hk, [
      ue(t.$slots, "pagination", pS(mS({ currentPage: t.currentPage, lastPage: t.lastPage, goToPage: t.goToPage })), () => [
        t.lastPage > 1 && t.paginationMethod === "default" ? (v(), A("div", _k, [
          H(d, {
            disabled: t.currentPage === 1,
            "aria-label": "Go to previous page",
            color: "white",
            size: "small",
            "border-radius": "0.5rem",
            onClicked: e[3] || (e[3] = (E) => t.goToPage(t.currentPage - 1))
          }, {
            default: q(() => [...e[12] || (e[12] = [
              me(" Previous Page ", -1)
            ])]),
            _: 1
          }, 8, ["disabled"]),
          g("ul", Ek, [
            g("li", null, [
              H(d, {
                "aria-label": "Go to page 1",
                class: z([t.currentPage === 1 ? "active" : "", "mh1"]),
                color: "white",
                circle: !0,
                size: "small",
                onClicked: e[4] || (e[4] = (E) => t.goToPage(1))
              }, {
                default: q(() => [...e[13] || (e[13] = [
                  me(" 1 ", -1)
                ])]),
                _: 1
              }, 8, ["class"])
            ]),
            t.showFirstEllipsis ? (v(), A("li", pk, [
              H(d, {
                color: "white",
                circle: !0,
                size: "small",
                class: "mh1",
                onClicked: e[5] || (e[5] = (E) => t.goToPage(t.startingPoint))
              }, {
                default: q(() => [...e[14] || (e[14] = [
                  me("...", -1)
                ])]),
                _: 1
              })
            ])) : V("", !0),
            (v(!0), A(ge, null, ye(t.shownPages, (E) => (v(), A("li", {
              key: E + t.startingPoint
            }, [
              H(d, {
                "aria-label": `Go to page ${E + t.startingPoint}`,
                class: z([E + t.startingPoint === t.currentPage ? "active" : "", "mh1"]),
                color: "white",
                circle: !0,
                size: "small",
                onClicked: (m) => t.goToPage(E + t.startingPoint)
              }, {
                default: q(() => [
                  me(Q(E + t.startingPoint), 1)
                ]),
                _: 2
              }, 1032, ["aria-label", "class", "onClicked"])
            ]))), 128)),
            t.showSecondEllipsis ? (v(), A("li", mk, [
              H(d, {
                color: "white",
                circle: !0,
                size: "small",
                class: "mh1",
                onClicked: e[6] || (e[6] = (E) => t.goToPage(t.startingPoint + 5))
              }, {
                default: q(() => [...e[15] || (e[15] = [
                  me("...", -1)
                ])]),
                _: 1
              })
            ])) : V("", !0),
            g("li", null, [
              H(d, {
                "aria-label": `Go to page ${t.lastPage}`,
                class: z([t.currentPage === t.lastPage ? "active" : "", "mh1"]),
                color: "white",
                circle: !0,
                size: "small",
                onClicked: e[7] || (e[7] = (E) => t.goToPage(t.lastPage))
              }, {
                default: q(() => [
                  me(Q(t.lastPage), 1)
                ]),
                _: 1
              }, 8, ["aria-label", "class"])
            ])
          ]),
          H(d, {
            disabled: t.currentPage === t.lastPage,
            "aria-label": "Go to next page",
            color: "white",
            size: "small",
            "border-radius": "0.5rem",
            onClicked: e[8] || (e[8] = (E) => t.goToPage(t.currentPage + 1))
          }, {
            default: q(() => [...e[16] || (e[16] = [
              me(" Next Page ", -1)
            ])]),
            _: 1
          }, 8, ["disabled"])
        ])) : V("", !0),
        t.paginationMethod === "intersection" && t.hasPagesLeft ? (v(), A("div", Nk, [
          H(h, { "aria-label": "Loading" })
        ], 512)) : V("", !0),
        H(Zt, { name: "scroll-top-fade" }, {
          default: q(() => [
            t.paginationMethod === "intersection" && t.showScrollTopButton ? (v(), A("button", {
              key: 0,
              class: z([t.sidebarAdjust ? "sidebar-adjust" : "", "scroll-top-button"]),
              onClick: e[9] || (e[9] = (...E) => t.scrollToTop && t.scrollToTop(...E))
            }, [
              H(_)
            ], 2)) : V("", !0)
          ]),
          _: 1
        })
      ])
    ]))
  ], 6);
}
const $E = /* @__PURE__ */ Y(UE, [["render", vk]]), gk = {
  includeSign: !1,
  decimalPlaces: 2,
  stripped: !1
};
function Yo(t) {
  const e = x(() => {
    const { includeSign: i, decimalPlaces: a, stripped: s } = { ...gk, ...t }, c = {
      style: "percent",
      signDisplay: s ? "never" : i ? "exceptZero" : "auto",
      minimumFractionDigits: a
    };
    return new Intl.NumberFormat(void 0, c);
  }), n = x(() => Number.isNaN(t.value) ? 0 : t.value), r = x(() => PE({
    dataType: "percentage",
    rawNumber: n.value,
    parts: o.value,
    includeSign: t.includeSign
  })), o = x(() => e.value.formatToParts(n.value));
  return {
    displayValue: r,
    parts: o
  };
}
const Ik = Ne({
  name: "Percent",
  props: {
    value: {
      type: Number,
      required: !0
    },
    includeSign: {
      type: Boolean,
      required: !1,
      default: !1
    },
    decimalPlaces: {
      type: Number,
      required: !1,
      default: 2
    },
    stripped: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(t) {
    const { displayValue: e } = Yo(t);
    return {
      displayValue: e
    };
  }
}), Ok = { class: "di" };
function Ak(t, e, n, r, o, i) {
  return v(), A("div", Ok, Q(t.displayValue), 1);
}
const l5 = /* @__PURE__ */ Y(Ik, [["render", Ak]]);
function vc(t) {
  const e = x(() => {
    const o = t.decimalPlaces ?? 2, { parts: i, displayValue: a } = Yo({
      ...t,
      // if the roas is bigger than 1000%, we drop the decimal places
      decimalPlaces: t.value > 10 ? 0 : o
    });
    return { displayValue: a.value, parts: i.value };
  }), n = x(() => e.value.displayValue), r = x(() => e.value.parts);
  return { displayValue: n, parts: r };
}
const Dk = Ne({
  props: {
    value: {
      type: Number,
      required: !0
    },
    includeSign: {
      type: Boolean,
      required: !1,
      default: !1
    },
    decimalPlaces: {
      type: Number,
      required: !1,
      default: 2
    },
    stripped: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(t) {
    const { displayValue: e } = vc(t);
    return {
      displayValue: e
    };
  }
}), Ck = { class: "di" };
function Sk(t, e, n, r, o, i) {
  return v(), A("div", Ck, Q(t.displayValue), 1);
}
const KRe = /* @__PURE__ */ Y(Dk, [["render", Sk]]), wk = {
  props: {
    hex: {
      type: String,
      default: "#00ffff"
    }
  }
}, Tk = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, bk = ["fill"];
function Rk(t, e, n, r, o, i) {
  return v(), A("svg", Tk, [
    g("g", {
      fill: n.hex,
      "fill-rule": "nonzero"
    }, [...e[0] || (e[0] = [
      g("polygon", { points: "8 8 12 4 9 4 9 0 7 0 7 4 4 4" }, null, -1),
      g("path", { d: "M15 0h-3v2h2v8H2V2h2V0H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zM2 14v-2h12v2H2z" }, null, -1)
    ])], 8, bk)
  ]);
}
const zRe = /* @__PURE__ */ Y(wk, [["render", Rk]]), Mk = {
  props: {
    hex: {
      type: String,
      default: "#FF2828"
    }
  }
}, Pk = {
  width: "16",
  height: "19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yk = ["fill"];
function Lk(t, e, n, r, o, i) {
  return v(), A("svg", Pk, [
    g("path", {
      fill: n.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7 2c-.55228 0-1 .44772-1 1h4c0-.55229-.44772-1-1-1H7Zm5 1c0-1.65685-1.3431-3-3-3H7C5.34315 0 4 1.34315 4 3H1c-.552285 0-1 .44772-1 1s.447715 1 1 1v11c0 1.6569 1.34315 3 3 3h8c1.6569 0 3-1.3431 3-3V5c.5523 0 1-.44772 1-1s-.4477-1-1-1h-3Zm-1 2H3v11c0 .5523.44772 1 1 1h8c.5523 0 1-.4477 1-1V5h-2ZM6 7c.55228 0 1 .44772 1 1v6c0 .5523-.44772 1-1 1s-1-.4477-1-1V8c0-.55228.44772-1 1-1Zm5 1c0-.55228-.4477-1-1-1-.55229 0-1 .44772-1 1v6c0 .5523.44771 1 1 1 .5523 0 1-.4477 1-1V8Z"
    }, null, 8, yk)
  ]);
}
const ZRe = /* @__PURE__ */ Y(Mk, [["render", Lk]]), xk = {
  props: {
    hex: {
      type: String,
      default: "#00ffff"
    }
  }
}, Uk = {
  width: "14",
  height: "17",
  viewBox: "0 0 14 17",
  xmlns: "http://www.w3.org/2000/svg"
}, $k = {
  transform: "rotate(90 6.5 7.5)",
  fill: "none",
  "fill-rule": "evenodd"
}, kk = ["stroke"], Bk = ["fill"], Gk = ["stroke"];
function Fk(t, e, n, r, o, i) {
  return v(), A("svg", Uk, [
    g("g", $k, [
      g("line", {
        stroke: n.hex,
        y1: "7",
        x2: "11",
        y2: "7",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, kk),
      g("rect", {
        fill: n.hex,
        "fill-rule": "nonzero",
        x: "14",
        width: "2",
        height: "14",
        rx: "1"
      }, null, 8, Bk),
      g("polyline", {
        stroke: n.hex,
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        points: "6 2 11 7 6 12"
      }, null, 8, Gk)
    ])
  ]);
}
const qRe = /* @__PURE__ */ Y(xk, [["render", Fk]]), Vk = {
  props: {
    hex: {
      type: String,
      default: "#00ffff"
    }
  }
}, Hk = {
  width: "16",
  height: "18",
  viewBox: "0 0 16 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Wk = ["fill"];
function Yk(t, e, n, r, o, i) {
  return v(), A("svg", Hk, [
    g("path", {
      fill: n.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9 0H3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h1v1a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3h-1V3a3 3 0 0 0-3-3Zm3 6v5a3 3 0 0 1-3 3H6v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1ZM2 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3Z"
    }, null, 8, Wk)
  ]);
}
const XRe = /* @__PURE__ */ Y(Vk, [["render", Yk]]), Kk = {
  props: {
    hex: {
      type: String,
      default: "#00ffff"
    }
  }
}, zk = {
  height: "12",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Zk = ["fill"];
function qk(t, e, n, r, o, i) {
  return v(), A("svg", zk, [
    g("path", {
      fill: n.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.0065918 0.997319C0.0065918 0.714477 0.077302 0.502345 0.289434 0.290213C0.501566 0.0780806 0.713698 0.00737 0.996541 0.00737H6.06761C6.61434 0.00737 7.05756 0.450585 7.05756 0.997319C7.05756 1.54405 6.61434 1.98727 6.06761 1.98727L3.4007 1.98727L6.77472 5.36128C7.16524 5.7518 7.16524 6.38497 6.77472 6.77549C6.38419 7.16602 5.75103 7.16602 5.3605 6.77549L1.98649 3.40148L1.98649 6.06839C1.98649 6.61512 1.54328 7.05834 0.996541 7.05834C0.449807 7.05834 0.0065918 6.61512 0.0065918 6.06839V0.997319ZM16.0036 15.0127C16.0036 15.2955 15.9329 15.5077 15.7207 15.7198C15.5086 15.9319 15.2965 16.0027 15.0136 16.0027H9.94256C9.39583 16.0027 8.95261 15.5594 8.95261 15.0127C8.95261 14.466 9.39583 14.0228 9.94256 14.0228H12.6095L9.23546 10.6487C8.84493 10.2582 8.84493 9.62505 9.23546 9.23453C9.62598 8.844 10.2591 8.844 10.6497 9.23453L14.0237 12.6085L14.0237 9.94163C14.0237 9.3949 14.4669 8.95168 15.0136 8.95168C15.5604 8.95168 16.0036 9.3949 16.0036 9.94163V15.0127Z"
    }, null, 8, Zk)
  ]);
}
const jRe = /* @__PURE__ */ Y(Kk, [["render", qk]]), Xk = {
  props: {
    hex: {
      type: String,
      default: "#006dff"
    }
  }
}, jk = {
  width: "20",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Jk = ["fill"];
function Qk(t, e, n, r, o, i) {
  return v(), A("svg", jk, [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17 0H3C1.34315 0 0 1.34315 0 3v12c0 1.6569 1.34315 3 3 3h14c1.6569 0 3-1.3431 3-3V3c0-1.65685-1.3431-3-3-3ZM2 3c0-.55228.44772-1 1-1h14c.5523 0 1 .44772 1 1v12c0 .5523-.4477 1-1 1H3c-.55228 0-1-.4477-1-1V3Zm7.70711 3.70711c.39049-.39053.39049-1.02369 0-1.41422-.39053-.39052-1.02369-.39052-1.41422 0l-3 3c-.39052.39053-.39052 1.02369 0 1.41422l3 2.99999c.39053.3905 1.02369.3905 1.41422 0 .39049-.3905.39049-1.0237 0-1.4142L8.41421 10H14c.5523 0 1-.44771 1-1 0-.55228-.4477-1-1-1H8.41421l1.2929-1.29289Z",
      fill: n.hex
    }, null, 8, Jk)
  ]);
}
const JRe = /* @__PURE__ */ Y(Xk, [["render", Qk]]);
var c5 = {
  update: null,
  begin: null,
  loopBegin: null,
  changeBegin: null,
  change: null,
  changeComplete: null,
  loopComplete: null,
  complete: null,
  loop: 1,
  direction: "normal",
  autoplay: !0,
  timelineOffset: 0
}, kE = {
  duration: 1e3,
  delay: 0,
  endDelay: 0,
  easing: "easeOutElastic(1, .5)",
  round: 0
}, eB = ["translateX", "translateY", "translateZ", "rotate", "rotateX", "rotateY", "rotateZ", "scale", "scaleX", "scaleY", "scaleZ", "skew", "skewX", "skewY", "perspective", "matrix", "matrix3d"], Sd = {
  CSS: {},
  springs: {}
};
function oo(t, e, n) {
  return Math.min(Math.max(t, e), n);
}
function Wl(t, e) {
  return t.indexOf(e) > -1;
}
function P1(t, e) {
  return t.apply(null, e);
}
var Ue = {
  arr: function(t) {
    return Array.isArray(t);
  },
  obj: function(t) {
    return Wl(Object.prototype.toString.call(t), "Object");
  },
  pth: function(t) {
    return Ue.obj(t) && t.hasOwnProperty("totalLength");
  },
  svg: function(t) {
    return t instanceof SVGElement;
  },
  inp: function(t) {
    return t instanceof HTMLInputElement;
  },
  dom: function(t) {
    return t.nodeType || Ue.svg(t);
  },
  str: function(t) {
    return typeof t == "string";
  },
  fnc: function(t) {
    return typeof t == "function";
  },
  und: function(t) {
    return typeof t > "u";
  },
  nil: function(t) {
    return Ue.und(t) || t === null;
  },
  hex: function(t) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t);
  },
  rgb: function(t) {
    return /^rgb/.test(t);
  },
  hsl: function(t) {
    return /^hsl/.test(t);
  },
  col: function(t) {
    return Ue.hex(t) || Ue.rgb(t) || Ue.hsl(t);
  },
  key: function(t) {
    return !c5.hasOwnProperty(t) && !kE.hasOwnProperty(t) && t !== "targets" && t !== "keyframes";
  }
};
function u5(t) {
  var e = /\(([^)]+)\)/.exec(t);
  return e ? e[1].split(",").map(function(n) {
    return parseFloat(n);
  }) : [];
}
function d5(t, e) {
  var n = u5(t), r = oo(Ue.und(n[0]) ? 1 : n[0], 0.1, 100), o = oo(Ue.und(n[1]) ? 100 : n[1], 0.1, 100), i = oo(Ue.und(n[2]) ? 10 : n[2], 0.1, 100), a = oo(Ue.und(n[3]) ? 0 : n[3], 0.1, 100), s = Math.sqrt(o / r), l = i / (2 * Math.sqrt(o * r)), c = l < 1 ? s * Math.sqrt(1 - l * l) : 0, u = 1, d = l < 1 ? (l * s + -a) / c : -a + s;
  function f(_) {
    var E = e ? e * _ / 1e3 : _;
    return l < 1 ? E = Math.exp(-E * l * s) * (u * Math.cos(c * E) + d * Math.sin(c * E)) : E = (u + d * E) * Math.exp(-E * s), _ === 0 || _ === 1 ? _ : 1 - E;
  }
  function h() {
    var _ = Sd.springs[t];
    if (_)
      return _;
    for (var E = 1 / 6, m = 0, N = 0; ; )
      if (m += E, f(m) === 1) {
        if (N++, N >= 16)
          break;
      } else
        N = 0;
    var I = m * E * 1e3;
    return Sd.springs[t] = I, I;
  }
  return e ? f : h;
}
function tB(t) {
  return t === void 0 && (t = 10), function(e) {
    return Math.ceil(oo(e, 1e-6, 1) * t) * (1 / t);
  };
}
var nB = function() {
  var t = 11, e = 1 / (t - 1);
  function n(u, d) {
    return 1 - 3 * d + 3 * u;
  }
  function r(u, d) {
    return 3 * d - 6 * u;
  }
  function o(u) {
    return 3 * u;
  }
  function i(u, d, f) {
    return ((n(d, f) * u + r(d, f)) * u + o(d)) * u;
  }
  function a(u, d, f) {
    return 3 * n(d, f) * u * u + 2 * r(d, f) * u + o(d);
  }
  function s(u, d, f, h, _) {
    var E, m, N = 0;
    do
      m = d + (f - d) / 2, E = i(m, h, _) - u, E > 0 ? f = m : d = m;
    while (Math.abs(E) > 1e-7 && ++N < 10);
    return m;
  }
  function l(u, d, f, h) {
    for (var _ = 0; _ < 4; ++_) {
      var E = a(d, f, h);
      if (E === 0)
        return d;
      var m = i(d, f, h) - u;
      d -= m / E;
    }
    return d;
  }
  function c(u, d, f, h) {
    if (!(0 <= u && u <= 1 && 0 <= f && f <= 1))
      return;
    var _ = new Float32Array(t);
    if (u !== d || f !== h)
      for (var E = 0; E < t; ++E)
        _[E] = i(E * e, u, f);
    function m(N) {
      for (var I = 0, O = 1, p = t - 1; O !== p && _[O] <= N; ++O)
        I += e;
      --O;
      var C = (N - _[O]) / (_[O + 1] - _[O]), D = I + C * e, T = a(D, u, f);
      return T >= 1e-3 ? l(N, D, u, f) : T === 0 ? D : s(N, I, I + e, u, f);
    }
    return function(N) {
      return u === d && f === h || N === 0 || N === 1 ? N : i(m(N), d, h);
    };
  }
  return c;
}(), f5 = function() {
  var t = { linear: function() {
    return function(r) {
      return r;
    };
  } }, e = {
    Sine: function() {
      return function(r) {
        return 1 - Math.cos(r * Math.PI / 2);
      };
    },
    Expo: function() {
      return function(r) {
        return r ? Math.pow(2, 10 * r - 10) : 0;
      };
    },
    Circ: function() {
      return function(r) {
        return 1 - Math.sqrt(1 - r * r);
      };
    },
    Back: function() {
      return function(r) {
        return r * r * (3 * r - 2);
      };
    },
    Bounce: function() {
      return function(r) {
        for (var o, i = 4; r < ((o = Math.pow(2, --i)) - 1) / 11; )
          ;
        return 1 / Math.pow(4, 3 - i) - 7.5625 * Math.pow((o * 3 - 2) / 22 - r, 2);
      };
    },
    Elastic: function(r, o) {
      r === void 0 && (r = 1), o === void 0 && (o = 0.5);
      var i = oo(r, 1, 10), a = oo(o, 0.1, 2);
      return function(s) {
        return s === 0 || s === 1 ? s : -i * Math.pow(2, 10 * (s - 1)) * Math.sin((s - 1 - a / (Math.PI * 2) * Math.asin(1 / i)) * (Math.PI * 2) / a);
      };
    }
  }, n = ["Quad", "Cubic", "Quart", "Quint"];
  return n.forEach(function(r, o) {
    e[r] = function() {
      return function(i) {
        return Math.pow(i, o + 2);
      };
    };
  }), Object.keys(e).forEach(function(r) {
    var o = e[r];
    t["easeIn" + r] = o, t["easeOut" + r] = function(i, a) {
      return function(s) {
        return 1 - o(i, a)(1 - s);
      };
    }, t["easeInOut" + r] = function(i, a) {
      return function(s) {
        return s < 0.5 ? o(i, a)(s * 2) / 2 : 1 - o(i, a)(s * -2 + 2) / 2;
      };
    }, t["easeOutIn" + r] = function(i, a) {
      return function(s) {
        return s < 0.5 ? (1 - o(i, a)(1 - s * 2)) / 2 : (o(i, a)(s * 2 - 1) + 1) / 2;
      };
    };
  }), t;
}();
function BE(t, e) {
  if (Ue.fnc(t))
    return t;
  var n = t.split("(")[0], r = f5[n], o = u5(t);
  switch (n) {
    case "spring":
      return d5(t, e);
    case "cubicBezier":
      return P1(nB, o);
    case "steps":
      return P1(tB, o);
    default:
      return P1(r, o);
  }
}
function h5(t) {
  try {
    var e = document.querySelectorAll(t);
    return e;
  } catch {
    return;
  }
}
function Mf(t, e) {
  for (var n = t.length, r = arguments.length >= 2 ? arguments[1] : void 0, o = [], i = 0; i < n; i++)
    if (i in t) {
      var a = t[i];
      e.call(r, a, i, t) && o.push(a);
    }
  return o;
}
function Pf(t) {
  return t.reduce(function(e, n) {
    return e.concat(Ue.arr(n) ? Pf(n) : n);
  }, []);
}
function gN(t) {
  return Ue.arr(t) ? t : (Ue.str(t) && (t = h5(t) || t), t instanceof NodeList || t instanceof HTMLCollection ? [].slice.call(t) : [t]);
}
function GE(t, e) {
  return t.some(function(n) {
    return n === e;
  });
}
function FE(t) {
  var e = {};
  for (var n in t)
    e[n] = t[n];
  return e;
}
function c0(t, e) {
  var n = FE(t);
  for (var r in t)
    n[r] = e.hasOwnProperty(r) ? e[r] : t[r];
  return n;
}
function yf(t, e) {
  var n = FE(t);
  for (var r in e)
    n[r] = Ue.und(t[r]) ? e[r] : t[r];
  return n;
}
function rB(t) {
  var e = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(t);
  return e ? "rgba(" + e[1] + ",1)" : t;
}
function oB(t) {
  var e = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, n = t.replace(e, function(s, l, c, u) {
    return l + l + c + c + u + u;
  }), r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(n), o = parseInt(r[1], 16), i = parseInt(r[2], 16), a = parseInt(r[3], 16);
  return "rgba(" + o + "," + i + "," + a + ",1)";
}
function iB(t) {
  var e = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(t) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(t), n = parseInt(e[1], 10) / 360, r = parseInt(e[2], 10) / 100, o = parseInt(e[3], 10) / 100, i = e[4] || 1;
  function a(f, h, _) {
    return _ < 0 && (_ += 1), _ > 1 && (_ -= 1), _ < 1 / 6 ? f + (h - f) * 6 * _ : _ < 1 / 2 ? h : _ < 2 / 3 ? f + (h - f) * (2 / 3 - _) * 6 : f;
  }
  var s, l, c;
  if (r == 0)
    s = l = c = o;
  else {
    var u = o < 0.5 ? o * (1 + r) : o + r - o * r, d = 2 * o - u;
    s = a(d, u, n + 1 / 3), l = a(d, u, n), c = a(d, u, n - 1 / 3);
  }
  return "rgba(" + s * 255 + "," + l * 255 + "," + c * 255 + "," + i + ")";
}
function aB(t) {
  if (Ue.rgb(t))
    return rB(t);
  if (Ue.hex(t))
    return oB(t);
  if (Ue.hsl(t))
    return iB(t);
}
function Bo(t) {
  var e = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(t);
  if (e)
    return e[1];
}
function sB(t) {
  if (Wl(t, "translate") || t === "perspective")
    return "px";
  if (Wl(t, "rotate") || Wl(t, "skew"))
    return "deg";
}
function u0(t, e) {
  return Ue.fnc(t) ? t(e.target, e.id, e.total) : t;
}
function io(t, e) {
  return t.getAttribute(e);
}
function VE(t, e, n) {
  var r = Bo(e);
  if (GE([n, "deg", "rad", "turn"], r))
    return e;
  var o = Sd.CSS[e + n];
  if (!Ue.und(o))
    return o;
  var i = 100, a = document.createElement(t.tagName), s = t.parentNode && t.parentNode !== document ? t.parentNode : document.body;
  s.appendChild(a), a.style.position = "absolute", a.style.width = i + n;
  var l = i / a.offsetWidth;
  s.removeChild(a);
  var c = l * parseFloat(e);
  return Sd.CSS[e + n] = c, c;
}
function _5(t, e, n) {
  if (e in t.style) {
    var r = e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), o = t.style[e] || getComputedStyle(t).getPropertyValue(r) || "0";
    return n ? VE(t, o, n) : o;
  }
}
function HE(t, e) {
  if (Ue.dom(t) && !Ue.inp(t) && (!Ue.nil(io(t, e)) || Ue.svg(t) && t[e]))
    return "attribute";
  if (Ue.dom(t) && GE(eB, e))
    return "transform";
  if (Ue.dom(t) && e !== "transform" && _5(t, e))
    return "css";
  if (t[e] != null)
    return "object";
}
function E5(t) {
  if (Ue.dom(t)) {
    for (var e = t.style.transform || "", n = /(\w+)\(([^)]*)\)/g, r = /* @__PURE__ */ new Map(), o; o = n.exec(e); )
      r.set(o[1], o[2]);
    return r;
  }
}
function lB(t, e, n, r) {
  var o = Wl(e, "scale") ? 1 : 0 + sB(e), i = E5(t).get(e) || o;
  return n && (n.transforms.list.set(e, i), n.transforms.last = e), r ? VE(t, i, r) : i;
}
function WE(t, e, n, r) {
  switch (HE(t, e)) {
    case "transform":
      return lB(t, e, r, n);
    case "css":
      return _5(t, e, n);
    case "attribute":
      return io(t, e);
    default:
      return t[e] || 0;
  }
}
function YE(t, e) {
  var n = /^(\*=|\+=|-=)/.exec(t);
  if (!n)
    return t;
  var r = Bo(t) || 0, o = parseFloat(e), i = parseFloat(t.replace(n[0], ""));
  switch (n[0][0]) {
    case "+":
      return o + i + r;
    case "-":
      return o - i + r;
    case "*":
      return o * i + r;
  }
}
function p5(t, e) {
  if (Ue.col(t))
    return aB(t);
  if (/\s/g.test(t))
    return t;
  var n = Bo(t), r = n ? t.substr(0, t.length - n.length) : t;
  return e ? r + e : r;
}
function KE(t, e) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function cB(t) {
  return Math.PI * 2 * io(t, "r");
}
function uB(t) {
  return io(t, "width") * 2 + io(t, "height") * 2;
}
function dB(t) {
  return KE(
    { x: io(t, "x1"), y: io(t, "y1") },
    { x: io(t, "x2"), y: io(t, "y2") }
  );
}
function m5(t) {
  for (var e = t.points, n = 0, r, o = 0; o < e.numberOfItems; o++) {
    var i = e.getItem(o);
    o > 0 && (n += KE(r, i)), r = i;
  }
  return n;
}
function fB(t) {
  var e = t.points;
  return m5(t) + KE(e.getItem(e.numberOfItems - 1), e.getItem(0));
}
function N5(t) {
  if (t.getTotalLength)
    return t.getTotalLength();
  switch (t.tagName.toLowerCase()) {
    case "circle":
      return cB(t);
    case "rect":
      return uB(t);
    case "line":
      return dB(t);
    case "polyline":
      return m5(t);
    case "polygon":
      return fB(t);
  }
}
function hB(t) {
  var e = N5(t);
  return t.setAttribute("stroke-dasharray", e), e;
}
function _B(t) {
  for (var e = t.parentNode; Ue.svg(e) && Ue.svg(e.parentNode); )
    e = e.parentNode;
  return e;
}
function v5(t, e) {
  var n = e || {}, r = n.el || _B(t), o = r.getBoundingClientRect(), i = io(r, "viewBox"), a = o.width, s = o.height, l = n.viewBox || (i ? i.split(" ") : [0, 0, a, s]);
  return {
    el: r,
    viewBox: l,
    x: l[0] / 1,
    y: l[1] / 1,
    w: a,
    h: s,
    vW: l[2],
    vH: l[3]
  };
}
function EB(t, e) {
  var n = Ue.str(t) ? h5(t)[0] : t, r = e || 100;
  return function(o) {
    return {
      property: o,
      el: n,
      svg: v5(n),
      totalLength: N5(n) * (r / 100)
    };
  };
}
function pB(t, e, n) {
  function r(u) {
    u === void 0 && (u = 0);
    var d = e + u >= 1 ? e + u : 0;
    return t.el.getPointAtLength(d);
  }
  var o = v5(t.el, t.svg), i = r(), a = r(-1), s = r(1), l = n ? 1 : o.w / o.vW, c = n ? 1 : o.h / o.vH;
  switch (t.property) {
    case "x":
      return (i.x - o.x) * l;
    case "y":
      return (i.y - o.y) * c;
    case "angle":
      return Math.atan2(s.y - a.y, s.x - a.x) * 180 / Math.PI;
  }
}
function IN(t, e) {
  var n = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g, r = p5(Ue.pth(t) ? t.totalLength : t, e) + "";
  return {
    original: r,
    numbers: r.match(n) ? r.match(n).map(Number) : [0],
    strings: Ue.str(t) || e ? r.split(n) : []
  };
}
function zE(t) {
  var e = t ? Pf(Ue.arr(t) ? t.map(gN) : gN(t)) : [];
  return Mf(e, function(n, r, o) {
    return o.indexOf(n) === r;
  });
}
function g5(t) {
  var e = zE(t);
  return e.map(function(n, r) {
    return { target: n, id: r, total: e.length, transforms: { list: E5(n) } };
  });
}
function mB(t, e) {
  var n = FE(e);
  if (/^spring/.test(n.easing) && (n.duration = d5(n.easing)), Ue.arr(t)) {
    var r = t.length, o = r === 2 && !Ue.obj(t[0]);
    o ? t = { value: t } : Ue.fnc(e.duration) || (n.duration = e.duration / r);
  }
  var i = Ue.arr(t) ? t : [t];
  return i.map(function(a, s) {
    var l = Ue.obj(a) && !Ue.pth(a) ? a : { value: a };
    return Ue.und(l.delay) && (l.delay = s ? 0 : e.delay), Ue.und(l.endDelay) && (l.endDelay = s === i.length - 1 ? e.endDelay : 0), l;
  }).map(function(a) {
    return yf(a, n);
  });
}
function NB(t) {
  for (var e = Mf(Pf(t.map(function(i) {
    return Object.keys(i);
  })), function(i) {
    return Ue.key(i);
  }).reduce(function(i, a) {
    return i.indexOf(a) < 0 && i.push(a), i;
  }, []), n = {}, r = function(i) {
    var a = e[i];
    n[a] = t.map(function(s) {
      var l = {};
      for (var c in s)
        Ue.key(c) ? c == a && (l.value = s[c]) : l[c] = s[c];
      return l;
    });
  }, o = 0; o < e.length; o++)
    r(o);
  return n;
}
function vB(t, e) {
  var n = [], r = e.keyframes;
  r && (e = yf(NB(r), e));
  for (var o in e)
    Ue.key(o) && n.push({
      name: o,
      tweens: mB(e[o], t)
    });
  return n;
}
function gB(t, e) {
  var n = {};
  for (var r in t) {
    var o = u0(t[r], e);
    Ue.arr(o) && (o = o.map(function(i) {
      return u0(i, e);
    }), o.length === 1 && (o = o[0])), n[r] = o;
  }
  return n.duration = parseFloat(n.duration), n.delay = parseFloat(n.delay), n;
}
function IB(t, e) {
  var n;
  return t.tweens.map(function(r) {
    var o = gB(r, e), i = o.value, a = Ue.arr(i) ? i[1] : i, s = Bo(a), l = WE(e.target, t.name, s, e), c = n ? n.to.original : l, u = Ue.arr(i) ? i[0] : c, d = Bo(u) || Bo(l), f = s || d;
    return Ue.und(a) && (a = c), o.from = IN(u, f), o.to = IN(YE(a, u), f), o.start = n ? n.end : 0, o.end = o.start + o.delay + o.duration + o.endDelay, o.easing = BE(o.easing, o.duration), o.isPath = Ue.pth(i), o.isPathTargetInsideSVG = o.isPath && Ue.svg(e.target), o.isColor = Ue.col(o.from.original), o.isColor && (o.round = 1), n = o, o;
  });
}
var I5 = {
  css: function(t, e, n) {
    return t.style[e] = n;
  },
  attribute: function(t, e, n) {
    return t.setAttribute(e, n);
  },
  object: function(t, e, n) {
    return t[e] = n;
  },
  transform: function(t, e, n, r, o) {
    if (r.list.set(e, n), e === r.last || o) {
      var i = "";
      r.list.forEach(function(a, s) {
        i += s + "(" + a + ") ";
      }), t.style.transform = i;
    }
  }
};
function O5(t, e) {
  var n = g5(t);
  n.forEach(function(r) {
    for (var o in e) {
      var i = u0(e[o], r), a = r.target, s = Bo(i), l = WE(a, o, s, r), c = s || Bo(l), u = YE(p5(i, c), l), d = HE(a, o);
      I5[d](a, o, u, r.transforms, !0);
    }
  });
}
function OB(t, e) {
  var n = HE(t.target, e.name);
  if (n) {
    var r = IB(e, t), o = r[r.length - 1];
    return {
      type: n,
      property: e.name,
      animatable: t,
      tweens: r,
      duration: o.end,
      delay: r[0].delay,
      endDelay: o.endDelay
    };
  }
}
function AB(t, e) {
  return Mf(Pf(t.map(function(n) {
    return e.map(function(r) {
      return OB(n, r);
    });
  })), function(n) {
    return !Ue.und(n);
  });
}
function A5(t, e) {
  var n = t.length, r = function(i) {
    return i.timelineOffset ? i.timelineOffset : 0;
  }, o = {};
  return o.duration = n ? Math.max.apply(Math, t.map(function(i) {
    return r(i) + i.duration;
  })) : e.duration, o.delay = n ? Math.min.apply(Math, t.map(function(i) {
    return r(i) + i.delay;
  })) : e.delay, o.endDelay = n ? o.duration - Math.max.apply(Math, t.map(function(i) {
    return r(i) + i.duration - i.endDelay;
  })) : e.endDelay, o;
}
var ON = 0;
function DB(t) {
  var e = c0(c5, t), n = c0(kE, t), r = vB(n, t), o = g5(t.targets), i = AB(o, r), a = A5(i, n), s = ON;
  return ON++, yf(e, {
    id: s,
    children: [],
    animatables: o,
    animations: i,
    duration: a.duration,
    delay: a.delay,
    endDelay: a.endDelay
  });
}
var xr = [], D5 = function() {
  var t;
  function e() {
    !t && (!AN() || !_t.suspendWhenDocumentHidden) && xr.length > 0 && (t = requestAnimationFrame(n));
  }
  function n(o) {
    for (var i = xr.length, a = 0; a < i; ) {
      var s = xr[a];
      s.paused ? (xr.splice(a, 1), i--) : (s.tick(o), a++);
    }
    t = a > 0 ? requestAnimationFrame(n) : void 0;
  }
  function r() {
    _t.suspendWhenDocumentHidden && (AN() ? t = cancelAnimationFrame(t) : (xr.forEach(
      function(o) {
        return o._onDocumentVisibility();
      }
    ), D5()));
  }
  return typeof document < "u" && document.addEventListener("visibilitychange", r), e;
}();
function AN() {
  return !!document && document.hidden;
}
function _t(t) {
  t === void 0 && (t = {});
  var e = 0, n = 0, r = 0, o, i = 0, a = null;
  function s(I) {
    var O = window.Promise && new Promise(function(p) {
      return a = p;
    });
    return I.finished = O, O;
  }
  var l = DB(t);
  s(l);
  function c() {
    var I = l.direction;
    I !== "alternate" && (l.direction = I !== "normal" ? "normal" : "reverse"), l.reversed = !l.reversed, o.forEach(function(O) {
      return O.reversed = l.reversed;
    });
  }
  function u(I) {
    return l.reversed ? l.duration - I : I;
  }
  function d() {
    e = 0, n = u(l.currentTime) * (1 / _t.speed);
  }
  function f(I, O) {
    O && O.seek(I - O.timelineOffset);
  }
  function h(I) {
    if (l.reversePlayback)
      for (var p = i; p--; )
        f(I, o[p]);
    else
      for (var O = 0; O < i; O++)
        f(I, o[O]);
  }
  function _(I) {
    for (var O = 0, p = l.animations, C = p.length; O < C; ) {
      var D = p[O], T = D.animatable, k = D.tweens, G = k.length - 1, b = k[G];
      G && (b = Mf(k, function(ne) {
        return I < ne.end;
      })[0] || b);
      for (var P = oo(I - b.start - b.delay, 0, b.duration) / b.duration, $ = isNaN(P) ? 1 : b.easing(P), y = b.to.strings, L = b.round, w = [], R = b.to.numbers.length, B = void 0, U = 0; U < R; U++) {
        var K = void 0, Z = b.to.numbers[U], X = b.from.numbers[U] || 0;
        b.isPath ? K = pB(b.value, $ * Z, b.isPathTargetInsideSVG) : K = X + $ * (Z - X), L && (b.isColor && U > 2 || (K = Math.round(K * L) / L)), w.push(K);
      }
      var J = y.length;
      if (!J)
        B = w[0];
      else {
        B = y[0];
        for (var ae = 0; ae < J; ae++) {
          y[ae];
          var re = y[ae + 1], j = w[ae];
          isNaN(j) || (re ? B += j + re : B += j + " ");
        }
      }
      I5[D.type](T.target, D.property, B, T.transforms), D.currentValue = B, O++;
    }
  }
  function E(I) {
    l[I] && !l.passThrough && l[I](l);
  }
  function m() {
    l.remaining && l.remaining !== !0 && l.remaining--;
  }
  function N(I) {
    var O = l.duration, p = l.delay, C = O - l.endDelay, D = u(I);
    l.progress = oo(D / O * 100, 0, 100), l.reversePlayback = D < l.currentTime, o && h(D), !l.began && l.currentTime > 0 && (l.began = !0, E("begin")), !l.loopBegan && l.currentTime > 0 && (l.loopBegan = !0, E("loopBegin")), D <= p && l.currentTime !== 0 && _(0), (D >= C && l.currentTime !== O || !O) && _(O), D > p && D < C ? (l.changeBegan || (l.changeBegan = !0, l.changeCompleted = !1, E("changeBegin")), E("change"), _(D)) : l.changeBegan && (l.changeCompleted = !0, l.changeBegan = !1, E("changeComplete")), l.currentTime = oo(D, 0, O), l.began && E("update"), I >= O && (n = 0, m(), l.remaining ? (e = r, E("loopComplete"), l.loopBegan = !1, l.direction === "alternate" && c()) : (l.paused = !0, l.completed || (l.completed = !0, E("loopComplete"), E("complete"), !l.passThrough && "Promise" in window && (a(), s(l)))));
  }
  return l.reset = function() {
    var I = l.direction;
    l.passThrough = !1, l.currentTime = 0, l.progress = 0, l.paused = !0, l.began = !1, l.loopBegan = !1, l.changeBegan = !1, l.completed = !1, l.changeCompleted = !1, l.reversePlayback = !1, l.reversed = I === "reverse", l.remaining = l.loop, o = l.children, i = o.length;
    for (var O = i; O--; )
      l.children[O].reset();
    (l.reversed && l.loop !== !0 || I === "alternate" && l.loop === 1) && l.remaining++, _(l.reversed ? l.duration : 0);
  }, l._onDocumentVisibility = d, l.set = function(I, O) {
    return O5(I, O), l;
  }, l.tick = function(I) {
    r = I, e || (e = r), N((r + (n - e)) * _t.speed);
  }, l.seek = function(I) {
    N(u(I));
  }, l.pause = function() {
    l.paused = !0, d();
  }, l.play = function() {
    l.paused && (l.completed && l.reset(), l.paused = !1, xr.push(l), d(), D5());
  }, l.reverse = function() {
    c(), l.completed = !l.reversed, d();
  }, l.restart = function() {
    l.reset(), l.play();
  }, l.remove = function(I) {
    var O = zE(I);
    C5(O, l);
  }, l.reset(), l.autoplay && l.play(), l;
}
function DN(t, e) {
  for (var n = e.length; n--; )
    GE(t, e[n].animatable.target) && e.splice(n, 1);
}
function C5(t, e) {
  var n = e.animations, r = e.children;
  DN(t, n);
  for (var o = r.length; o--; ) {
    var i = r[o], a = i.animations;
    DN(t, a), !a.length && !i.children.length && r.splice(o, 1);
  }
  !n.length && !r.length && e.pause();
}
function CB(t) {
  for (var e = zE(t), n = xr.length; n--; ) {
    var r = xr[n];
    C5(e, r);
  }
}
function SB(t, e) {
  e === void 0 && (e = {});
  var n = e.direction || "normal", r = e.easing ? BE(e.easing) : null, o = e.grid, i = e.axis, a = e.from || 0, s = a === "first", l = a === "center", c = a === "last", u = Ue.arr(t), d = parseFloat(u ? t[0] : t), f = u ? parseFloat(t[1]) : 0, h = Bo(u ? t[1] : t) || 0, _ = e.start || 0 + (u ? d : 0), E = [], m = 0;
  return function(N, I, O) {
    if (s && (a = 0), l && (a = (O - 1) / 2), c && (a = O - 1), !E.length) {
      for (var p = 0; p < O; p++) {
        if (!o)
          E.push(Math.abs(a - p));
        else {
          var C = l ? (o[0] - 1) / 2 : a % o[0], D = l ? (o[1] - 1) / 2 : Math.floor(a / o[0]), T = p % o[0], k = Math.floor(p / o[0]), G = C - T, b = D - k, P = Math.sqrt(G * G + b * b);
          i === "x" && (P = -G), i === "y" && (P = -b), E.push(P);
        }
        m = Math.max.apply(Math, E);
      }
      r && (E = E.map(function(y) {
        return r(y / m) * m;
      })), n === "reverse" && (E = E.map(function(y) {
        return i ? y < 0 ? y * -1 : -y : Math.abs(m - y);
      }));
    }
    var $ = u ? (f - d) / m : d;
    return _ + $ * (Math.round(E[I] * 100) / 100) + h;
  };
}
function wB(t) {
  t === void 0 && (t = {});
  var e = _t(t);
  return e.duration = 0, e.add = function(n, r) {
    var o = xr.indexOf(e), i = e.children;
    o > -1 && xr.splice(o, 1);
    function a(f) {
      f.passThrough = !0;
    }
    for (var s = 0; s < i.length; s++)
      a(i[s]);
    var l = yf(n, c0(kE, t));
    l.targets = l.targets || t.targets;
    var c = e.duration;
    l.autoplay = !1, l.direction = e.direction, l.timelineOffset = Ue.und(r) ? c : YE(r, c), a(e), e.seek(l.timelineOffset);
    var u = _t(l);
    a(u), i.push(u);
    var d = A5(i, t);
    return e.delay = d.delay, e.endDelay = d.endDelay, e.duration = d.duration, e.seek(0), e.reset(), e.autoplay && e.play(), e;
  }, e;
}
_t.version = "3.2.1";
_t.speed = 1;
_t.suspendWhenDocumentHidden = !0;
_t.running = xr;
_t.remove = CB;
_t.get = WE;
_t.set = O5;
_t.convertPx = VE;
_t.path = EB;
_t.setDashoffset = hB;
_t.stagger = SB;
_t.timeline = wB;
_t.easing = BE;
_t.penner = f5;
_t.random = function(t, e) {
  return Math.floor(Math.random() * (e - t + 1)) + t;
};
const TB = Ne({
  props: {
    hex: {
      type: String,
      default: "#00ffff"
    },
    animationTrigger: {
      type: Boolean,
      required: !1
    }
  },
  setup(t) {
    const e = W(), n = W(), r = W(), o = () => {
      console.log("Play arrow animation"), _t({
        targets: e.value,
        keyframes: [
          { translateX: 36, opacity: 0 },
          { translateX: [-36, 0], opacity: 1 }
        ],
        easing: "cubicBezier(0.19, 1, 0.22, 1)",
        duration: 1e3,
        direction: "normal",
        loop: 1
      }), _t({
        targets: r.value,
        keyframes: [{ translateX: 0 }, { translateX: [15, 0] }],
        easing: "cubicBezier(0.19, 1, 0.22, 1)",
        duration: 1e3,
        direction: "normal",
        loop: 1
      });
    };
    return Y_(() => {
      t.animationTrigger && (console.log("animation child"), o());
    }), {
      icon: e,
      chevron: n,
      line: r,
      arrowAnimation: o
      // path,
      // circle,
    };
  }
});
const bB = {
  id: "icon",
  ref: "icon",
  width: "17",
  height: "12",
  viewBox: "0 0 17 12",
  xmlns: "http://www.w3.org/2000/svg"
}, RB = ["stroke"], MB = {
  id: "line",
  ref: "line",
  y1: "5",
  x2: "15",
  y2: "5",
  pathLength: "10"
}, PB = {
  id: "chevron",
  ref: "chevron",
  points: "10 0 15 5 10 10",
  pathLength: "10"
};
function yB(t, e, n, r, o, i) {
  return v(), A("svg", bB, [
    g("g", {
      stroke: t.hex,
      transform: "translate(1 1)",
      "stroke-width": "2",
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      g("line", MB, null, 512),
      g("polyline", PB, null, 512)
    ], 8, RB)
  ], 512);
}
const d0 = /* @__PURE__ */ Y(TB, [["render", yB], ["__scopeId", "data-v-1408f6b9"]]), LB = Ne({
  props: {
    hex: {
      type: String,
      default: "#c2c2c3"
    }
  }
}), xB = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14"
}, UB = ["fill"];
function $B(t, e, n, r, o, i) {
  return v(), A("svg", xB, [
    g("path", {
      d: "M10.0317379 8.6175243l3.503796 3.503796-1.4142136 1.4142136-3.503796-3.503796C7.7314831 10.642436 6.6574983 11 5.5 11 2.4624339 11 0 8.5375661 0 5.5S2.4624339 0 5.5 0 11 2.4624339 11 5.5c0 1.1574983-.357564 2.2314831-.9682621 3.1175243zM5.5 9C7.4329966 9 9 7.4329966 9 5.5S7.4329966 2 5.5 2 2 3.5670034 2 5.5 3.5670034 9 5.5 9z",
      fill: t.hex,
      "fill-rule": "evenodd"
    }, null, 8, UB)
  ]);
}
const QRe = /* @__PURE__ */ Y(LB, [["render", $B]]), kB = {
  props: {
    hex: {
      type: String,
      default: "#00ffff"
    }
  }
}, BB = {
  width: "12",
  height: "12",
  xmlns: "http://www.w3.org/2000/svg"
}, GB = ["fill"];
function FB(t, e, n, r, o, i) {
  return v(), A("svg", BB, [
    g("path", {
      d: "M7 5V0H5v5H0v2h5v5h2V7h5V5H7z",
      fill: n.hex,
      "fill-rule": "evenodd"
    }, null, 8, GB)
  ]);
}
const eMe = /* @__PURE__ */ Y(kB, [["render", FB]]), VB = {
  props: {
    hex: {
      type: String,
      default: "#00ffff"
    }
  }
}, HB = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, WB = ["fill"];
function YB(t, e, n, r, o, i) {
  return v(), A("svg", HB, [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8 0C7.44772 0 7 0.447715 7 1V7H1C0.447715 7 0 7.44772 0 8C0 8.55229 0.447715 9 1 9H7V15C7 15.5523 7.44772 16 8 16C8.55229 16 9 15.5523 9 15V9H15C15.5523 9 16 8.55229 16 8C16 7.44772 15.5523 7 15 7H9V1C9 0.447715 8.55229 0 8 0Z",
      fill: n.hex
    }, null, 8, WB)
  ]);
}
const tMe = /* @__PURE__ */ Y(VB, [["render", YB]]), KB = {
  props: {
    hex: {
      type: String,
      default: "#00ffff"
    }
  }
}, zB = {
  width: "23",
  height: "18",
  viewBox: "0 0 23 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ZB = ["fill"], qB = ["fill"];
function XB(t, e, n, r, o, i) {
  return v(), A("svg", zB, [
    e[0] || (e[0] = g("path", {
      d: "M9.57486 1.1747C10.9346 0.88568 12.3462 0.955952 13.6704 1.37859C14.9946 1.80122 16.1857 2.56163 17.1264 3.58487C18.0671 4.60812 18.7249 5.85888 19.0349 7.21388C19.345 8.56889 19.2966 9.98138 18.8945 11.3121",
      stroke: "#010105",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)),
    e[1] || (e[1] = g("path", {
      d: "M12.8976 16.8249C11.5378 17.114 10.1262 17.0437 8.80204 16.621C7.47784 16.1984 6.2867 15.438 5.346 14.4148C4.4053 13.3915 3.74751 12.1408 3.43747 10.7857C3.12742 9.43074 3.17582 8.01825 3.57788 6.68749",
      stroke: "#010105",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)),
    g("path", {
      d: "M17.5691 14.7552L15.7761 10.9101L21.4142 12.9622L17.5691 14.7552Z",
      fill: n.hex,
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, ZB),
    g("path", {
      d: "M4.84514 2.96747L6.63816 6.8126L1 4.76048L4.84514 2.96747Z",
      fill: n.hex,
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, qB)
  ]);
}
const nMe = /* @__PURE__ */ Y(KB, [["render", XB]]), jB = {
  name: "CircleAccountLevelIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    },
    inactive: {
      type: Boolean,
      default: !1,
      required: !1
    }
  }
};
const JB = {
  key: 0,
  title: "<span class='f7 lh-copy'>Account Level</span>",
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-account-level-icon"
}, QB = ["stroke"], eG = {
  key: 1,
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  class: "circle-account-level-icon"
}, tG = ["stroke"];
function nG(t, e, n, r, o, i) {
  const a = ft("tippy");
  return n.tooltip ? Ze((v(), A("svg", JB, [
    g("circle", {
      cx: "12",
      cy: "12",
      r: "11",
      stroke: n.inactive ? "#E0E0E5" : "#006DFF",
      "stroke-width": "2",
      fill: "transparent"
    }, null, 8, QB)
  ])), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", eG, [
    g("circle", {
      cx: "12",
      cy: "12",
      r: "11",
      stroke: n.inactive ? "#E0E0E5" : "#006DFF",
      "stroke-width": "2",
      fill: "transparent"
    }, null, 8, tG)
  ]));
}
const S5 = /* @__PURE__ */ Y(jB, [["render", nG]]), rG = Ne({
  name: "CircleAdgroupIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    },
    inactive: {
      type: Boolean,
      default: !1,
      required: !1
    },
    dark: {
      type: Boolean,
      default: !1,
      required: !1
    }
  }
});
function oG(t, e, n, r, o, i) {
  const a = ft("tippy");
  return t.tooltip ? Ze((v(), A("svg", {
    key: 0,
    title: "<span class='f7 lh-copy'>Ad Group</span>",
    style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    tabindex: "-1",
    class: z(["circle-adgroup-icon", { dark: t.dark }, { inactive: t.inactive }])
  }, [...e[0] || (e[0] = [
    g("g", { "fill-rule": "evenodd" }, [
      g("path", {
        d: "M12 22c5.5228475 0 10-4.4771525 10-10S17.5228475 2 12 2 2 6.4771525 2 12s4.4771525 10 10 10zm0 2C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12z",
        "fill-rule": "nonzero"
      }),
      g("path", { d: "M14.868 17l-.826-2.268H10.01L9.184 17H7.14l3.808-9.926h2.24L16.968 17h-2.1zm-2.842-7.784l-1.372 3.752h2.744l-1.372-3.752z" })
    ], -1)
  ])], 2)), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", {
    key: 1,
    style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    class: z(["circle-adgroup-icon", { dark: t.dark }, { inactive: t.inactive }])
  }, [...e[1] || (e[1] = [
    g("g", { "fill-rule": "evenodd" }, [
      g("path", {
        d: "M12 22c5.5228475 0 10-4.4771525 10-10S17.5228475 2 12 2 2 6.4771525 2 12s4.4771525 10 10 10zm0 2C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12z",
        "fill-rule": "nonzero"
      }),
      g("path", { d: "M14.868 17l-.826-2.268H10.01L9.184 17H7.14l3.808-9.926h2.24L16.968 17h-2.1zm-2.842-7.784l-1.372 3.752h2.744l-1.372-3.752z" })
    ], -1)
  ])], 2));
}
const w5 = /* @__PURE__ */ Y(rG, [["render", oG]]), iG = Ne({
  name: "CircleAdIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    },
    inactive: {
      type: Boolean,
      default: !1,
      required: !1
    },
    dark: {
      type: Boolean,
      default: !1,
      required: !1
    }
  }
});
function aG(t, e, n, r, o, i) {
  const a = ft("tippy");
  return t.tooltip ? Ze((v(), A("svg", {
    key: 0,
    title: "<span class='f7 lh-copy'>Ad</span>",
    style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    tabindex: "-1",
    class: z(["circle-ad-icon", { dark: t.dark }, { inactive: t.inactive }])
  }, [...e[0] || (e[0] = [
    g("g", { "fill-rule": "evenodd" }, [
      g("path", {
        d: "M12 22c5.5228475 0 10-4.4771525 10-10S17.5228475 2 12 2 2 6.4771525 2 12s4.4771525 10 10 10zm0 2C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12z",
        "fill-rule": "nonzero"
      }),
      g("path", { d: "M14.868 17l-.826-2.268H10.01L9.184 17H7.14l3.808-9.926h2.24L16.968 17h-2.1zm-2.842-7.784l-1.372 3.752h2.744l-1.372-3.752z" })
    ], -1)
  ])], 2)), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", {
    key: 1,
    style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    class: z(["circle-ad-icon", { dark: t.dark }, { inactive: t.inactive }])
  }, [...e[1] || (e[1] = [
    g("g", { "fill-rule": "evenodd" }, [
      g("path", {
        d: "M12 22c5.5228475 0 10-4.4771525 10-10S17.5228475 2 12 2 2 6.4771525 2 12s4.4771525 10 10 10zm0 2C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12z",
        "fill-rule": "nonzero"
      }),
      g("path", { d: "M14.868 17l-.826-2.268H10.01L9.184 17H7.14l3.808-9.926h2.24L16.968 17h-2.1zm-2.842-7.784l-1.372 3.752h2.744l-1.372-3.752z" })
    ], -1)
  ])], 2));
}
const sG = /* @__PURE__ */ Y(iG, [["render", aG]]), lG = Ne({
  name: "CircleAssetGroupIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    },
    inactive: {
      type: Boolean,
      default: !1,
      required: !1
    },
    dark: {
      type: Boolean,
      default: !1,
      required: !1
    }
  }
});
function cG(t, e, n, r, o, i) {
  const a = ft("tippy");
  return t.tooltip ? Ze((v(), A("svg", {
    key: 0,
    title: "<span class='f7 lh-copy'>Asset Group</span>",
    style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    tabindex: "-1",
    class: z(["circle-asset-group-icon", { dark: t.dark }, { inactive: t.inactive }])
  }, [...e[0] || (e[0] = [
    g("g", { "fill-rule": "evenodd" }, [
      g("path", {
        d: "M12 22c5.5228475 0 10-4.4771525 10-10S17.5228475 2 12 2 2 6.4771525 2 12s4.4771525 10 10 10zm0 2C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12z",
        "fill-rule": "nonzero"
      }),
      g("path", { d: "M14.868 17l-.826-2.268H10.01L9.184 17H7.14l3.808-9.926h2.24L16.968 17h-2.1zm-2.842-7.784l-1.372 3.752h2.744l-1.372-3.752z" })
    ], -1)
  ])], 2)), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", {
    key: 1,
    style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    class: z(["circle-asset-group-icon", { dark: t.dark }, { inactive: t.inactive }])
  }, [...e[1] || (e[1] = [
    g("g", { "fill-rule": "evenodd" }, [
      g("path", {
        d: "M12 22c5.5228475 0 10-4.4771525 10-10S17.5228475 2 12 2 2 6.4771525 2 12s4.4771525 10 10 10zm0 2C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12z",
        "fill-rule": "nonzero"
      }),
      g("path", { d: "M14.868 17l-.826-2.268H10.01L9.184 17H7.14l3.808-9.926h2.24L16.968 17h-2.1zm-2.842-7.784l-1.372 3.752h2.744l-1.372-3.752z" })
    ], -1)
  ])], 2));
}
const uG = /* @__PURE__ */ Y(lG, [["render", cG]]), dG = {
  name: "CircleCampaignGroupIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    },
    inactive: {
      type: Boolean,
      default: !1,
      required: !1
    }
  }
};
const fG = ["content"], hG = ["fill"], _G = {
  key: 1,
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-campaign-group-icon"
}, EG = ["fill"];
function pG(t, e, n, r, o, i) {
  const a = ft("tippy");
  return n.tooltip ? Ze((v(), A("svg", {
    key: 0,
    content: n.tooltip ? "<span class='f7 lh-copy'>Campaign Group</span>" : "",
    style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    tabindex: "-1",
    class: "circle-campaign-group-icon"
  }, [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M22 12c0 5.5228-4.4772 10-10 10-5.52285 0-10-4.4772-10-10C2 6.47715 6.47715 2 12 2c5.5228 0 10 4.47715 10 10zm2 0c0 6.6274-5.3726 12-12 12-6.62742 0-12-5.3726-12-12C0 5.37258 5.37258 0 12 0c6.6274 0 12 5.37258 12 12zm-12 6c3.3137 0 6-2.6863 6-6 0-3.31371-2.6863-6-6-6-3.31371 0-6 2.68629-6 6 0 3.3137 2.68629 6 6 6zm4-6c0 2.2091-1.7909 4-4 4-2.20914 0-4-1.7909-4-4 0-2.20914 1.79086-4 4-4 2.2091 0 4 1.79086 4 4z",
      fill: n.inactive ? "#E0E0E5" : "#006DFF"
    }, null, 8, hG)
  ], 8, fG)), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", _G, [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M22 12c0 5.5228-4.4772 10-10 10-5.52285 0-10-4.4772-10-10C2 6.47715 6.47715 2 12 2c5.5228 0 10 4.47715 10 10zm2 0c0 6.6274-5.3726 12-12 12-6.62742 0-12-5.3726-12-12C0 5.37258 5.37258 0 12 0c6.6274 0 12 5.37258 12 12zm-12 6c3.3137 0 6-2.6863 6-6 0-3.31371-2.6863-6-6-6-3.31371 0-6 2.68629-6 6 0 3.3137 2.68629 6 6 6zm4-6c0 2.2091-1.7909 4-4 4-2.20914 0-4-1.7909-4-4 0-2.20914 1.79086-4 4-4 2.2091 0 4 1.79086 4 4z",
      fill: n.inactive ? "#E0E0E5" : "#006DFF"
    }, null, 8, EG)
  ]));
}
const T5 = /* @__PURE__ */ Y(dG, [["render", pG]]), mG = Ne({
  name: "CircleCampaignIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    },
    inactive: {
      type: Boolean,
      default: !1,
      required: !1
    },
    dark: {
      type: Boolean,
      default: !1,
      required: !1
    }
  }
});
function NG(t, e, n, r, o, i) {
  const a = ft("tippy");
  return t.tooltip ? Ze((v(), A("svg", {
    key: 0,
    content: "<span class='f7 lh-copy'>Campaign</span>",
    style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    tabindex: "-1",
    class: z(["circle-campaign-icon", { dark: t.dark }, { inactive: t.inactive }])
  }, [...e[0] || (e[0] = [
    g("g", { "fill-rule": "evenodd" }, [
      g("path", {
        d: "M12 22c5.5228475 0 10-4.4771525 10-10S17.5228475 2 12 2 2 6.4771525 2 12s4.4771525 10 10 10zm0 2C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12z",
        "fill-rule": "nonzero"
      }),
      g("path", { d: "M12.128 17.21c2.786 0 4.214-1.848 4.592-3.374l-1.806-.546c-.266.924-1.092 2.03-2.786 2.03-1.596 0-3.08-1.162-3.08-3.276 0-2.254 1.568-3.318 3.052-3.318 1.722 0 2.492 1.05 2.73 2.002l1.82-.574c-.392-1.61-1.806-3.29-4.55-3.29-2.66 0-5.054 2.016-5.054 5.18 0 3.164 2.31 5.166 5.082 5.166z" })
    ], -1)
  ])], 2)), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", {
    key: 1,
    style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    class: z(["circle-campaign-icon", { dark: t.dark }, { inactive: t.inactive }])
  }, [...e[1] || (e[1] = [
    g("g", { "fill-rule": "evenodd" }, [
      g("path", {
        d: "M12 22c5.5228475 0 10-4.4771525 10-10S17.5228475 2 12 2 2 6.4771525 2 12s4.4771525 10 10 10zm0 2C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12z",
        "fill-rule": "nonzero"
      }),
      g("path", { d: "M12.128 17.21c2.786 0 4.214-1.848 4.592-3.374l-1.806-.546c-.266.924-1.092 2.03-2.786 2.03-1.596 0-3.08-1.162-3.08-3.276 0-2.254 1.568-3.318 3.052-3.318 1.722 0 2.492 1.05 2.73 2.002l1.82-.574c-.392-1.61-1.806-3.29-4.55-3.29-2.66 0-5.054 2.016-5.054 5.18 0 3.164 2.31 5.166 5.082 5.166z" })
    ], -1)
  ])], 2));
}
const b5 = /* @__PURE__ */ Y(mG, [["render", NG]]), vG = {
  name: "CircleConversionActionIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    }
  }
};
const gG = {
  key: 0,
  content: "<span class='f7 lh-copy'>Conversion Action</span>",
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-conversion-action-icon"
}, IG = {
  key: 1,
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-conversion-action-icon"
};
function OG(t, e, n, r, o, i) {
  const a = ft("tippy");
  return n.tooltip ? Ze((v(), A("svg", gG, [...e[0] || (e[0] = [
    g("g", {
      fill: "#FF365C",
      "fill-rule": "evenodd"
    }, [
      g("path", {
        d: "M12 22c5.5228475 0 10-4.4771525 10-10S17.5228475 2 12 2 2 6.4771525 2 12s4.4771525 10 10 10zm0 2C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12z",
        "fill-rule": "nonzero"
      }),
      g("path", { d: "M12.128 17.21c2.786 0 4.214-1.848 4.592-3.374l-1.806-.546c-.266.924-1.092 2.03-2.786 2.03-1.596 0-3.08-1.162-3.08-3.276 0-2.254 1.568-3.318 3.052-3.318 1.722 0 2.492 1.05 2.73 2.002l1.82-.574c-.392-1.61-1.806-3.29-4.55-3.29-2.66 0-5.054 2.016-5.054 5.18 0 3.164 2.31 5.166 5.082 5.166z" })
    ], -1)
  ])])), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", IG, [...e[1] || (e[1] = [
    g("g", {
      fill: "#FF365C",
      "fill-rule": "evenodd"
    }, [
      g("path", {
        d: "M12 22c5.5228475 0 10-4.4771525 10-10S17.5228475 2 12 2 2 6.4771525 2 12s4.4771525 10 10 10zm0 2C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12z",
        "fill-rule": "nonzero"
      }),
      g("path", { d: "M12.128 17.21c2.786 0 4.214-1.848 4.592-3.374l-1.806-.546c-.266.924-1.092 2.03-2.786 2.03-1.596 0-3.08-1.162-3.08-3.276 0-2.254 1.568-3.318 3.052-3.318 1.722 0 2.492 1.05 2.73 2.002l1.82-.574c-.392-1.61-1.806-3.29-4.55-3.29-2.66 0-5.054 2.016-5.054 5.18 0 3.164 2.31 5.166 5.082 5.166z" })
    ], -1)
  ])]));
}
const R5 = /* @__PURE__ */ Y(vG, [["render", OG]]), AG = {
  name: "CircleDemographicIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    }
  }
};
const DG = {
  content: "<span class='f7 lh-copy'>Demographic</span>",
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-demographic-icon"
};
function CG(t, e, n, r, o, i) {
  const a = ft("tippy");
  return Ze((v(), A("svg", DG, [...e[0] || (e[0] = [
    g("path", {
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24Z",
      fill: "#006E61"
    }, null, -1),
    g("path", {
      d: "M10.212 15.2082H11.752C13.376 15.2082 14.734 14.2002 14.734 12.0442C14.734 9.88822 13.39 8.86622 11.766 8.86622H10.212V15.2082ZM11.822 17.0002H8.28V7.07422H11.836C14.664 7.07422 16.736 8.90822 16.736 12.0442C16.736 15.1802 14.65 17.0002 11.822 17.0002Z",
      fill: "#006E61"
    }, null, -1)
  ])])), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]);
}
const SG = /* @__PURE__ */ Y(AG, [["render", CG]]), wG = {
  name: "CircleDeviceIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    }
  }
};
const TG = {
  content: "<span class='f7 lh-copy'>Device</span>",
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-device-icon"
};
function bG(t, e, n, r, o, i) {
  const a = ft("tippy");
  return Ze((v(), A("svg", TG, [...e[0] || (e[0] = [
    g("path", {
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24Z",
      fill: "#006E61"
    }, null, -1),
    g("path", {
      d: "M10.212 15.2082H11.752C13.376 15.2082 14.734 14.2002 14.734 12.0442C14.734 9.88822 13.39 8.86622 11.766 8.86622H10.212V15.2082ZM11.822 17.0002H8.28V7.07422H11.836C14.664 7.07422 16.736 8.90822 16.736 12.0442C16.736 15.1802 14.65 17.0002 11.822 17.0002Z",
      fill: "#006E61"
    }, null, -1)
  ])])), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]);
}
const RG = /* @__PURE__ */ Y(wG, [["render", bG]]), MG = {
  name: "CircleExperimentIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    }
  }
};
const PG = {
  key: 0,
  content: "<span class='f7 lh-copy'>Experiment</span>",
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-experiment-icon"
}, yG = {
  key: 1,
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
function LG(t, e, n, r, o, i) {
  const a = ft("tippy");
  return n.tooltip ? Ze((v(), A("svg", PG, [...e[0] || (e[0] = [
    g("path", {
      fill: "#6E3AFF",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.3243 15.18V17H9V7H15.3243V8.82H11V11.162H15V12.884H11V15.18H15.3243Z"
    }, null, -1)
  ])])), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", yG, [...e[1] || (e[1] = [
    g("path", {
      fill: "#6E3AFF",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.3243 15.18V17H9V7H15.3243V8.82H11V11.162H15V12.884H11V15.18H15.3243Z"
    }, null, -1)
  ])]));
}
const M5 = /* @__PURE__ */ Y(MG, [["render", LG]]), xG = Ne({
  name: "CircleExtensionIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    },
    inactive: {
      type: Boolean,
      default: !1,
      required: !1
    },
    dark: {
      type: Boolean,
      default: !1,
      required: !1
    }
  }
});
function UG(t, e, n, r, o, i) {
  const a = ft("tippy");
  return t.tooltip ? Ze((v(), A("svg", {
    key: 0,
    title: "<span class='f7 lh-copy'>Extension</span>",
    style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    tabindex: "-1",
    class: z(["circle-extension-icon", { dark: t.dark }, { inactive: t.inactive }])
  }, [...e[0] || (e[0] = [
    g("g", { "fill-rule": "evenodd" }, [
      g("path", {
        "clip-rule": "evenodd",
        d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.3243 15.18V17H9V7H15.3243V8.82H11V11.162H15V12.884H11V15.18H15.3243Z"
      })
    ], -1)
  ])], 2)), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", {
    key: 1,
    style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    class: z(["circle-extension-icon", { dark: t.dark }, { inactive: t.inactive }])
  }, [...e[1] || (e[1] = [
    g("g", { "fill-rule": "evenodd" }, [
      g("path", {
        "clip-rule": "evenodd",
        d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.3243 15.18V17H9V7H15.3243V8.82H11V11.162H15V12.884H11V15.18H15.3243Z"
      })
    ], -1)
  ])], 2));
}
const $G = /* @__PURE__ */ Y(xG, [["render", UG]]), kG = Ne({
  name: "CircleKeywordIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    },
    inactive: {
      type: Boolean,
      default: !1,
      required: !1
    },
    dark: {
      type: Boolean,
      default: !1,
      required: !1
    }
  }
});
function BG(t, e, n, r, o, i) {
  const a = ft("tippy");
  return t.tooltip ? Ze((v(), A("svg", {
    key: 0,
    title: "<span class='f7 lh-copy'>Keyword</span>",
    style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    tabindex: "-1",
    class: z(["circle-keyword-icon", { dark: t.dark }, { inactive: t.inactive }])
  }, [...e[0] || (e[0] = [
    g("g", { "fill-rule": "evenodd" }, [
      g("path", {
        d: "M12 22c5.5228475 0 10-4.4771525 10-10S17.5228475 2 12 2 2 6.4771525 2 12s4.4771525 10 10 10zm0 2C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12z",
        "fill-rule": "nonzero"
      }),
      g("polygon", { points: "14.182 17 16.604 17 12.642 11.4 16.576 7.074 14.042 7.074 10.066 11.568 10.066 7.074 8.134 7.074 8.134 17 10.066 17 10.066 14.242 11.298 12.884" })
    ], -1)
  ])], 2)), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", {
    key: 1,
    style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    class: z(["circle-keyword-icon", { dark: t.dark }, { inactive: t.inactive }])
  }, [...e[1] || (e[1] = [
    g("g", { "fill-rule": "evenodd" }, [
      g("path", {
        d: "M12 22c5.5228475 0 10-4.4771525 10-10S17.5228475 2 12 2 2 6.4771525 2 12s4.4771525 10 10 10zm0 2C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12z",
        "fill-rule": "nonzero"
      }),
      g("polygon", { points: "14.182 17 16.604 17 12.642 11.4 16.576 7.074 14.042 7.074 10.066 11.568 10.066 7.074 8.134 7.074 8.134 17 10.066 17 10.066 14.242 11.298 12.884" })
    ], -1)
  ])], 2));
}
const ZE = /* @__PURE__ */ Y(kG, [["render", BG]]), GG = {
  name: "CircleLocationIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    }
  }
};
const FG = {
  key: 0,
  title: "<span class='f7 lh-copy'>Location</span>",
  style: { width: "1.125rem", height: "1.5rem", flex: "0 0 1.125rem", outline: "none" },
  width: "18",
  height: "24",
  viewBox: "0 0 18 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-location-icon"
}, VG = {
  key: 1,
  style: { width: "1.125rem", height: "1.5rem", flex: "0 0 1.125rem", outline: "none" },
  width: "18",
  height: "24",
  viewBox: "0 0 18 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-location-icon"
};
function HG(t, e, n, r, o, i) {
  const a = ft("tippy");
  return n.tooltip ? Ze((v(), A("svg", FG, [...e[0] || (e[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2 9c0-4.45203 3.55148-7 7-7 3.4485 0 7 2.54797 7 7 0 2.1984-1.1552 5.5195-2.7465 8.3471-.7864 1.3975-1.6454 2.6124-2.46 3.4627-.4073.4252-.782.7364-1.10898.9358C9.35152 21.9486 9.12698 22 9 22c-.12698 0-.35152-.0514-.68452-.2544-.32702-.1994-.70164-.5106-1.10899-.9358-.81457-.8503-1.67355-2.0652-2.46002-3.4627C3.15523 14.5195 2 11.1984 2 9Zm7-9C4.64852 0 0 3.25203 0 9c0 2.7016 1.34477 6.3805 3.00353 9.3279.83853 1.49 1.79205 2.8564 2.75873 3.8654.48328.5045.99147.9425 1.5121 1.2599C7.78902 23.767 8.37698 24 9 24c.62302 0 1.211-.233 1.7256-.5468.5207-.3174 1.0289-.7554 1.5121-1.2599.9667-1.009 1.9202-2.3754 2.7588-3.8654C16.6552 15.3805 18 11.7016 18 9c0-5.74797-4.6485-9-9-9ZM7 9c0-1.10457.89543-2 2-2 1.1046 0 2 .89543 2 2 0 1.1046-.8954 2-2 2-1.10457 0-2-.8954-2-2Zm2-4C6.79086 5 5 6.79086 5 9c0 2.2091 1.79086 4 4 4 2.2091 0 4-1.7909 4-4 0-2.20914-1.7909-4-4-4Z",
      fill: "#006dff"
    }, null, -1)
  ])])), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", VG, [...e[1] || (e[1] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2 9c0-4.45203 3.55148-7 7-7 3.4485 0 7 2.54797 7 7 0 2.1984-1.1552 5.5195-2.7465 8.3471-.7864 1.3975-1.6454 2.6124-2.46 3.4627-.4073.4252-.782.7364-1.10898.9358C9.35152 21.9486 9.12698 22 9 22c-.12698 0-.35152-.0514-.68452-.2544-.32702-.1994-.70164-.5106-1.10899-.9358-.81457-.8503-1.67355-2.0652-2.46002-3.4627C3.15523 14.5195 2 11.1984 2 9Zm7-9C4.64852 0 0 3.25203 0 9c0 2.7016 1.34477 6.3805 3.00353 9.3279.83853 1.49 1.79205 2.8564 2.75873 3.8654.48328.5045.99147.9425 1.5121 1.2599C7.78902 23.767 8.37698 24 9 24c.62302 0 1.211-.233 1.7256-.5468.5207-.3174 1.0289-.7554 1.5121-1.2599.9667-1.009 1.9202-2.3754 2.7588-3.8654C16.6552 15.3805 18 11.7016 18 9c0-5.74797-4.6485-9-9-9ZM7 9c0-1.10457.89543-2 2-2 1.1046 0 2 .89543 2 2 0 1.1046-.8954 2-2 2-1.10457 0-2-.8954-2-2Zm2-4C6.79086 5 5 6.79086 5 9c0 2.2091 1.79086 4 4 4 2.2091 0 4-1.7909 4-4 0-2.20914-1.7909-4-4-4Z",
      fill: "#006dff"
    }, null, -1)
  ])]));
}
const P5 = /* @__PURE__ */ Y(GG, [["render", HG]]), WG = {
  name: "CircleNegativeKeywordIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    }
  }
};
const YG = {
  key: 0,
  title: "<span class='f7 lh-copy'>Negative Keyword</span>",
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  class: "circle-negative-keyword-icon",
  tabindex: "-1"
}, KG = {
  key: 1,
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  class: "circle-negative-keyword-icon",
  tabindex: "-1"
};
function zG(t, e, n, r, o, i) {
  const a = ft("tippy");
  return n.tooltip ? Ze((v(), A("svg", YG, [...e[0] || (e[0] = [
    g("g", { "fill-rule": "evenodd" }, [
      g("path", {
        d: "M12 22c5.5228475 0 10-4.4771525 10-10S17.5228475 2 12 2 2 6.4771525 2 12s4.4771525 10 10 10zm0 2C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12z",
        "fill-rule": "nonzero"
      }),
      g("polygon", { points: "14.182 17 16.604 17 12.642 11.4 16.576 7.074 14.042 7.074 10.066 11.568 10.066 7.074 8.134 7.074 8.134 17 10.066 17 10.066 14.242 11.298 12.884" })
    ], -1)
  ])])), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", KG, [...e[1] || (e[1] = [
    g("g", { "fill-rule": "evenodd" }, [
      g("path", {
        d: "M12 22c5.5228475 0 10-4.4771525 10-10S17.5228475 2 12 2 2 6.4771525 2 12s4.4771525 10 10 10zm0 2C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12z",
        "fill-rule": "nonzero"
      }),
      g("polygon", { points: "14.182 17 16.604 17 12.642 11.4 16.576 7.074 14.042 7.074 10.066 11.568 10.066 7.074 8.134 7.074 8.134 17 10.066 17 10.066 14.242 11.298 12.884" })
    ], -1)
  ])]));
}
const y5 = /* @__PURE__ */ Y(WG, [["render", zG]]), ZG = {
  name: "CircleNegativeListIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    }
  }
};
const qG = {
  key: 0,
  title: "<span class='f7 lh-copy'>Negative List</span>",
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-negative-list-icon"
}, XG = {
  key: 1,
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-negative-list-icon"
};
function jG(t, e, n, r, o, i) {
  const a = ft("tippy");
  return n.tooltip ? Ze((v(), A("svg", qG, [...e[0] || (e[0] = [
    g("path", {
      d: "M12 22c5.5228 0 10-4.4772 10-10 0-5.52285-4.4772-10-10-10C6.47715 2 2 6.47715 2 12c0 5.5228 4.47715 10 10 10Zm0 2C5.37258 24 0 18.6274 0 12 0 5.37258 5.37258 0 12 0c6.6274 0 12 5.37258 12 12 0 6.6274-5.3726 12-12 12Z",
      fill: "#FF2828"
    }, null, -1),
    g("path", {
      d: "M16.2316 17V7.074h-1.932v6.566l-4.13-6.566h-2.408V17h1.932V9.958L14.2016 17h2.03Z",
      fill: "#FF2828"
    }, null, -1)
  ])])), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", XG, [...e[1] || (e[1] = [
    g("path", {
      d: "M12 22c5.5228 0 10-4.4772 10-10 0-5.52285-4.4772-10-10-10C6.47715 2 2 6.47715 2 12c0 5.5228 4.47715 10 10 10Zm0 2C5.37258 24 0 18.6274 0 12 0 5.37258 5.37258 0 12 0c6.6274 0 12 5.37258 12 12 0 6.6274-5.3726 12-12 12Z",
      fill: "#FF2828"
    }, null, -1),
    g("path", {
      d: "M16.2316 17V7.074h-1.932v6.566l-4.13-6.566h-2.408V17h1.932V9.958L14.2016 17h2.03Z",
      fill: "#FF2828"
    }, null, -1)
  ])]));
}
const L5 = /* @__PURE__ */ Y(ZG, [["render", jG]]), JG = ["fill"], QG = ["fill"], x5 = /* @__PURE__ */ Ne({
  __name: "CircleNGramIcon",
  props: {
    tooltip: { type: Boolean, default: !0 }
  },
  setup(t) {
    const e = NS(), n = x(() => e.gradient ? "url(#fillGradient)" : "#006dff");
    return (r, o) => {
      const i = ft("tippy");
      return Ze((v(), A("svg", {
        title: "<span class='f7'>N-Gram</span>",
        style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        tabindex: "-1",
        class: z(["circle-n-gram-icon", { gradient: !!M(e).gradient }])
      }, [
        ue(r.$slots, "gradient"),
        g("path", {
          fill: n.value,
          d: "M12 22c5.5228 0 10-4.4772 10-10 0-5.52285-4.4772-10-10-10C6.47715 2 2 6.47715 2 12c0 5.5228 4.47715 10 10 10Zm0 2C5.37258 24 0 18.6274 0 12 0 5.37258 5.37258 0 12 0c6.6274 0 12 5.37258 12 12 0 6.6274-5.3726 12-12 12Z"
        }, null, 8, JG),
        g("path", {
          fill: n.value,
          d: "M16.2316 17V7.074h-1.932v6.566l-4.13-6.566h-2.408V17h1.932V9.958L14.2016 17h2.03Z"
        }, null, 8, QG)
      ], 2)), [
        [i, {
          animateFill: "false",
          animation: "shift-away",
          duration: "250",
          placement: "top",
          theme: "circle-icon",
          offset: [0, 8],
          zIndex: 1e7
        }]
      ]);
    };
  }
});
const eF = {
  name: "CirclePauseIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    }
  }
};
const tF = {
  content: "<span class='f7 lh-copy'>Pause</span>",
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-pause-icon"
};
function nF(t, e, n, r, o, i) {
  const a = ft("tippy");
  return Ze((v(), A("svg", tF, [...e[0] || (e[0] = [
    g("path", {
      d: "M12 22c5.5228 0 10-4.4772 10-10 0-5.52285-4.4772-10-10-10C6.47715 2 2 6.47715 2 12c0 5.5228 4.47715 10 10 10Zm0 2C5.37258 24 0 18.6274 0 12 0 5.37258 5.37258 0 12 0c6.6274 0 12 5.37258 12 12 0 6.6274-5.3726 12-12 12Z",
      fill: "#FF2828"
    }, null, -1),
    g("rect", {
      x: "9",
      y: "8",
      width: "2",
      height: "8",
      rx: "1",
      fill: "#FF2828"
    }, null, -1),
    g("rect", {
      x: "13",
      y: "8",
      width: "2",
      height: "8",
      rx: "1",
      fill: "#FF2828"
    }, null, -1)
  ])])), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]);
}
const U5 = /* @__PURE__ */ Y(eF, [["render", nF]]), rF = {
  name: "CirclePlacementExclusionListIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    }
  }
};
const oF = {
  key: 0,
  title: "<span class='f7 lh-copy'>Placement Exclusion List</span>",
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-placement-exclusion-list-icon"
}, iF = {
  key: 1,
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-placement-exclusion-list-icon"
};
function aF(t, e, n, r, o, i) {
  const a = ft("tippy");
  return n.tooltip ? Ze((v(), A("svg", oF, [...e[0] || (e[0] = [
    g("path", {
      d: "M12 24C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12zm0-2c5.522847 0 10-4.477153 10-10S17.522847 2 12 2 2 6.477153 2 12s4.477153 10 10 10zm-.92-10.404h1.526c.966 0 1.554-.56 1.554-1.414 0-.882-.588-1.428-1.554-1.428H11.08v2.842zm1.764 1.666h-1.778V17H9.134V7.074h3.71c1.96 0 3.262 1.302 3.262 3.094 0 1.806-1.302 3.094-3.262 3.094z",
      fill: "#FF2828",
      "fill-rule": "nonzero"
    }, null, -1)
  ])])), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", iF, [...e[1] || (e[1] = [
    g("path", {
      d: "M12 24C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12zm0-2c5.522847 0 10-4.477153 10-10S17.522847 2 12 2 2 6.477153 2 12s4.477153 10 10 10zm-.92-10.404h1.526c.966 0 1.554-.56 1.554-1.414 0-.882-.588-1.428-1.554-1.428H11.08v2.842zm1.764 1.666h-1.778V17H9.134V7.074h3.71c1.96 0 3.262 1.302 3.262 3.094 0 1.806-1.302 3.094-3.262 3.094z",
      fill: "#FF2828",
      "fill-rule": "nonzero"
    }, null, -1)
  ])]));
}
const $5 = /* @__PURE__ */ Y(rF, [["render", aF]]), sF = {
  name: "CirclePlacementIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    }
  }
};
const lF = {
  key: 0,
  title: "<span class='f7 lh-copy'>Placement</span>",
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-placement-icon"
}, cF = {
  key: 1,
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-placement-icon"
};
function uF(t, e, n, r, o, i) {
  const a = ft("tippy");
  return n.tooltip ? Ze((v(), A("svg", lF, [...e[0] || (e[0] = [
    g("path", {
      d: "M12 24C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12zm0-2c5.522847 0 10-4.477153 10-10S17.522847 2 12 2 2 6.477153 2 12s4.477153 10 10 10zm-.92-10.404h1.526c.966 0 1.554-.56 1.554-1.414 0-.882-.588-1.428-1.554-1.428H11.08v2.842zm1.764 1.666h-1.778V17H9.134V7.074h3.71c1.96 0 3.262 1.302 3.262 3.094 0 1.806-1.302 3.094-3.262 3.094z",
      fill: "#006DFF",
      "fill-rule": "nonzero"
    }, null, -1)
  ])])), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", cF, [...e[1] || (e[1] = [
    g("path", {
      d: "M12 24C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12zm0-2c5.522847 0 10-4.477153 10-10S17.522847 2 12 2 2 6.477153 2 12s4.477153 10 10 10zm-.92-10.404h1.526c.966 0 1.554-.56 1.554-1.414 0-.882-.588-1.428-1.554-1.428H11.08v2.842zm1.764 1.666h-1.778V17H9.134V7.074h3.71c1.96 0 3.262 1.302 3.262 3.094 0 1.806-1.302 3.094-3.262 3.094z",
      fill: "#006DFF",
      "fill-rule": "nonzero"
    }, null, -1)
  ])]));
}
const k5 = /* @__PURE__ */ Y(sF, [["render", uF]]), dF = {
  name: "CircleProductGroupIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    }
  }
};
const fF = {
  key: 0,
  title: "<span class='f7 lh-copy'>Product Group</span>",
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-product-group-icon"
}, hF = {
  key: 1,
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-product-group-icon"
};
function _F(t, e, n, r, o, i) {
  const a = ft("tippy");
  return n.tooltip ? Ze((v(), A("svg", fF, [...e[0] || (e[0] = [
    g("path", {
      d: "M12 24C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12zm0-2c5.522847 0 10-4.477153 10-10S17.522847 2 12 2 2 6.477153 2 12s4.477153 10 10 10zm-.92-10.404h1.526c.966 0 1.554-.56 1.554-1.414 0-.882-.588-1.428-1.554-1.428H11.08v2.842zm1.764 1.666h-1.778V17H9.134V7.074h3.71c1.96 0 3.262 1.302 3.262 3.094 0 1.806-1.302 3.094-3.262 3.094z",
      fill: "#000",
      "fill-rule": "nonzero"
    }, null, -1)
  ])])), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", hF, [...e[1] || (e[1] = [
    g("path", {
      d: "M12 24C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12zm0-2c5.522847 0 10-4.477153 10-10S17.522847 2 12 2 2 6.477153 2 12s4.477153 10 10 10zm-.92-10.404h1.526c.966 0 1.554-.56 1.554-1.414 0-.882-.588-1.428-1.554-1.428H11.08v2.842zm1.764 1.666h-1.778V17H9.134V7.074h3.71c1.96 0 3.262 1.302 3.262 3.094 0 1.806-1.302 3.094-3.262 3.094z",
      fill: "#000",
      "fill-rule": "nonzero"
    }, null, -1)
  ])]));
}
const B5 = /* @__PURE__ */ Y(dF, [["render", _F]]), EF = {
  name: "CircleProductIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    }
  }
};
const pF = {
  key: 0,
  title: "<span class='f7 lh-copy'>Product</span>",
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-product-icon"
}, mF = {
  key: 1,
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-product-icon"
};
function NF(t, e, n, r, o, i) {
  const a = ft("tippy");
  return n.tooltip ? Ze((v(), A("svg", pF, [...e[0] || (e[0] = [
    g("path", {
      d: "M12 24C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12zm0-2c5.522847 0 10-4.477153 10-10S17.522847 2 12 2 2 6.477153 2 12s4.477153 10 10 10zm-.92-10.404h1.526c.966 0 1.554-.56 1.554-1.414 0-.882-.588-1.428-1.554-1.428H11.08v2.842zm1.764 1.666h-1.778V17H9.134V7.074h3.71c1.96 0 3.262 1.302 3.262 3.094 0 1.806-1.302 3.094-3.262 3.094z",
      fill: "#006DFF",
      "fill-rule": "nonzero"
    }, null, -1)
  ])])), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", mF, [...e[1] || (e[1] = [
    g("path", {
      d: "M12 24C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12zm0-2c5.522847 0 10-4.477153 10-10S17.522847 2 12 2 2 6.477153 2 12s4.477153 10 10 10zm-.92-10.404h1.526c.966 0 1.554-.56 1.554-1.414 0-.882-.588-1.428-1.554-1.428H11.08v2.842zm1.764 1.666h-1.778V17H9.134V7.074h3.71c1.96 0 3.262 1.302 3.262 3.094 0 1.806-1.302 3.094-3.262 3.094z",
      fill: "#006DFF",
      "fill-rule": "nonzero"
    }, null, -1)
  ])]));
}
const vF = /* @__PURE__ */ Y(EF, [["render", NF]]), gF = {
  name: "CircleReplacementKeywordIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    }
  }
};
const IF = {
  key: 0,
  title: "<span class='f7 lh-copy'>Replace with</span>",
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-replacement-keyword-icon"
}, OF = {
  key: 1,
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-replacement-keyword-icon"
};
function AF(t, e, n, r, o, i) {
  const a = ft("tippy");
  return n.tooltip ? Ze((v(), A("svg", IF, [...e[0] || (e[0] = [
    g("g", {
      fill: "#00A861",
      "fill-rule": "evenodd"
    }, [
      g("path", {
        d: "M12 22c5.5228475 0 10-4.4771525 10-10S17.5228475 2 12 2 2 6.4771525 2 12s4.4771525 10 10 10zm0 2C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12z",
        "fill-rule": "nonzero"
      }),
      g("polygon", { points: "14.182 17 16.604 17 12.642 11.4 16.576 7.074 14.042 7.074 10.066 11.568 10.066 7.074 8.134 7.074 8.134 17 10.066 17 10.066 14.242 11.298 12.884" })
    ], -1)
  ])])), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", OF, [...e[1] || (e[1] = [
    g("g", {
      fill: "#00A861",
      "fill-rule": "evenodd"
    }, [
      g("path", {
        d: "M12 22c5.5228475 0 10-4.4771525 10-10S17.5228475 2 12 2 2 6.4771525 2 12s4.4771525 10 10 10zm0 2C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12z",
        "fill-rule": "nonzero"
      }),
      g("polygon", { points: "14.182 17 16.604 17 12.642 11.4 16.576 7.074 14.042 7.074 10.066 11.568 10.066 7.074 8.134 7.074 8.134 17 10.066 17 10.066 14.242 11.298 12.884" })
    ], -1)
  ])]));
}
const G5 = /* @__PURE__ */ Y(gF, [["render", AF]]), DF = {
  name: "CircleSearchTermIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    }
  }
};
const CF = {
  key: 0,
  title: "<span class='f7 lh-copy'>Search Term</span>",
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-search-term-icon"
}, SF = {
  key: 1,
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-search-term-icon"
};
function wF(t, e, n, r, o, i) {
  const a = ft("tippy");
  return n.tooltip ? Ze((v(), A("svg", CF, [...e[0] || (e[0] = [
    g("path", {
      d: "M12 24C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12zm0-2c5.522847 0 10-4.477153 10-10S17.522847 2 12 2 2 6.477153 2 12s4.477153 10 10 10zm3.592-12.56l-1.736.532c-.098-.546-.546-1.4-1.806-1.4-.938 0-1.554.602-1.554 1.26 0 .546.35.98 1.078 1.12l1.386.266c1.806.35 2.772 1.526 2.772 2.926 0 1.526-1.274 3.066-3.584 3.066-2.632 0-3.794-1.694-3.948-3.108l1.792-.476c.084.98.77 1.862 2.17 1.862 1.036 0 1.61-.518 1.61-1.218 0-.574-.434-1.022-1.204-1.176l-1.386-.28C9.6 12.492 8.578 11.47 8.578 9.972c0-1.764 1.582-3.108 3.458-3.108 2.408 0 3.332 1.456 3.556 2.576z",
      fill: "#006DFF",
      "fill-rule": "nonzero"
    }, null, -1)
  ])])), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", SF, [...e[1] || (e[1] = [
    g("path", {
      d: "M12 24C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12zm0-2c5.522847 0 10-4.477153 10-10S17.522847 2 12 2 2 6.477153 2 12s4.477153 10 10 10zm3.592-12.56l-1.736.532c-.098-.546-.546-1.4-1.806-1.4-.938 0-1.554.602-1.554 1.26 0 .546.35.98 1.078 1.12l1.386.266c1.806.35 2.772 1.526 2.772 2.926 0 1.526-1.274 3.066-3.584 3.066-2.632 0-3.794-1.694-3.948-3.108l1.792-.476c.084.98.77 1.862 2.17 1.862 1.036 0 1.61-.518 1.61-1.218 0-.574-.434-1.022-1.204-1.176l-1.386-.28C9.6 12.492 8.578 11.47 8.578 9.972c0-1.764 1.582-3.108 3.458-3.108 2.408 0 3.332 1.456 3.556 2.576z",
      fill: "#006DFF",
      "fill-rule": "nonzero"
    }, null, -1)
  ])]));
}
const F5 = /* @__PURE__ */ Y(DF, [["render", wF]]), TF = {
  name: "CircleUrlIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    }
  }
};
const bF = {
  key: 0,
  title: "<span class='f7 lh-copy'>URL</span>",
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-url-icon"
}, RF = {
  key: 1,
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-url-icon"
};
function MF(t, e, n, r, o, i) {
  const a = ft("tippy");
  return n.tooltip ? Ze((v(), A("svg", bF, [...e[0] || (e[0] = [
    g("path", {
      d: "M12 24c6.627417 0 12-5.372583 12-12S18.627417 0 12 0 0 5.372583 0 12s5.372583 12 12 12zm0-2C6.477153 22 2 17.522847 2 12S6.477153 2 12 2s10 4.477153 10 10-4.477153 10-10 10zm-.156-4.776c2.128 0 3.822-1.302 3.822-3.738V7.074h-1.932v6.272c0 1.302-.714 1.988-1.89 1.988-1.148 0-1.876-.686-1.876-1.988V7.074H8.036v6.412c0 2.436 1.694 3.738 3.808 3.738z",
      fill: "#006DFF",
      "fill-rule": "nonzero"
    }, null, -1)
  ])])), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", RF, [...e[1] || (e[1] = [
    g("path", {
      d: "M12 24c6.627417 0 12-5.372583 12-12S18.627417 0 12 0 0 5.372583 0 12s5.372583 12 12 12zm0-2C6.477153 22 2 17.522847 2 12S6.477153 2 12 2s10 4.477153 10 10-4.477153 10-10 10zm-.156-4.776c2.128 0 3.822-1.302 3.822-3.738V7.074h-1.932v6.272c0 1.302-.714 1.988-1.89 1.988-1.148 0-1.876-.686-1.876-1.988V7.074H8.036v6.412c0 2.436 1.694 3.738 3.808 3.738z",
      fill: "#006DFF",
      "fill-rule": "nonzero"
    }, null, -1)
  ])]));
}
const V5 = /* @__PURE__ */ Y(TF, [["render", MF]]), PF = {
  name: "CircleWordIcon",
  props: {
    tooltip: {
      type: Boolean,
      default: !0
    }
  }
};
const yF = {
  key: 0,
  title: "<span class='f7'>Word</span>",
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-word-icon"
}, LF = {
  key: 1,
  style: { width: "1.5rem", height: "1.5rem", flex: "0 0 1.5rem", outline: "none" },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  tabindex: "-1",
  class: "circle-word-icon"
};
function xF(t, e, n, r, o, i) {
  const a = ft("tippy");
  return n.tooltip ? Ze((v(), A("svg", yF, [...e[0] || (e[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M22 12c0 5.5228-4.4772 10-10 10-5.52285 0-10-4.4772-10-10C2 6.47715 6.47715 2 12 2c5.5228 0 10 4.47715 10 10zm2 0c0 6.6274-5.3726 12-12 12-6.62742 0-12-5.3726-12-12C0 5.37258 5.37258 0 12 0c6.6274 0 12 5.37258 12 12zM12.972 7.783l2.054 6.37 1.664-6.37h1.833L15.975 17h-1.846l-2.106-6.565L9.91701 17h-1.872l-2.561-9.217h1.898l1.69 6.344L11.113 7.783h1.859z"
    }, null, -1)
  ])])), [
    [a, {
      animateFill: "false",
      animation: "shift-away",
      duration: "250",
      placement: "top",
      theme: "circle-icon",
      offset: [0, 8],
      zIndex: 1e7
    }]
  ]) : (v(), A("svg", LF, [...e[1] || (e[1] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M22 12c0 5.5228-4.4772 10-10 10-5.52285 0-10-4.4772-10-10C2 6.47715 6.47715 2 12 2c5.5228 0 10 4.47715 10 10zm2 0c0 6.6274-5.3726 12-12 12-6.62742 0-12-5.3726-12-12C0 5.37258 5.37258 0 12 0c6.6274 0 12 5.37258 12 12zM12.972 7.783l2.054 6.37 1.664-6.37h1.833L15.975 17h-1.846l-2.106-6.565L9.91701 17h-1.872l-2.561-9.217h1.898l1.69 6.344L11.113 7.783h1.859z"
    }, null, -1)
  ])]));
}
const H5 = /* @__PURE__ */ Y(PF, [["render", xF]]), UF = {}, $F = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function kF(t, e) {
  return v(), A("svg", $F, [...e[0] || (e[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16 10.364c0 .4007-.2531.5875-.7061.5875h-.8658v-.4007h.8658c.08 0 .1465-.0132.1734-.0399.0265-.0268.0531-.0669.0531-.1203 0-.0535-.0265-.1068-.0531-.1335-.0269-.0268-.08-.04-.16-.04-.4129-.0135-.9325.0132-.9325-.57436 0-.26721.1731-.56104.6394-.56104h.8926v.40072h-.826c-.0798 0-.1332 0-.1732.02663-.04.04012-.0666.08016-.0666.147 0 .06676.0401.10688.0933.13369.0534.01323.1067.02663.1733.02663h.2397c.2531 0 .4131.05336.5197.14692.0797.09351.133.21381.133.40071Zm-1.8784-.40071c-.1066-.09356-.2666-.14692-.5196-.14692h-.2398c-.0665 0-.1199-.01348-.1732-.02663-.0534-.02681-.0931-.06693-.0931-.13369 0-.06684.0132-.10688.0665-.147.04-.02663.0932-.02663.1732-.02663h.826V9.0817h-.8926c-.4797 0-.6396.29383-.6396.56104 0 .58746.5197.56086.9327.57436.0798 0 .1332.0132.1598.04.0265.0267.0533.08.0533.1335 0 .0534-.0267.0935-.0533.1203-.04.0267-.0932.0399-.1732.0399h-.866v.4007h.866c.4528 0 .7061-.1869.7061-.5875 0-.1869-.0533-.3072-.1332-.40071Zm-1.7053.60111H11.364v-.374h1.0258v-.37386H11.364v-.34736h1.0523v-.38723h-1.492v1.86965h1.492v-.3872Zm-1.9716-1.38897c-.1467-.08016-.3198-.09356-.5463-.09356H8.87271v1.86963h.45285v-.6811h.47968c.15975 0 .25306.0134.31976.0802.08.0934.08.2537.08.374v.2269h.4394v-.3606c0-.1736-.0132-.2538-.0665-.3472-.04-.0535-.1197-.1203-.2263-.1603.1197-.0399.3197-.20027.3197-.49419-.0001-.21351-.0801-.33379-.2266-.41378Zm-2.53126-.09356H6.48795l-.57284.61439-.54627-.61439H3.57037v1.86963h1.7719l.57292-.6144.54619.6144h.86602v-.6275h.55947c.38635 0 .77278-.1069.77278-.62774-.00008-.50751-.3998-.61439-.74621-.61439Zm2.17146.77471c-.0665.02655-.13319.02655-.21315.02655l-.54619.01349V9.4691h.54619c.07996 0 .15995 0 .21315.04004.0534.02689.0932.08016.0932.16032 0 .08024-.0398.147-.0932.18712Zm-2.17146.09339h-.58621V9.4691h.58621c.15992 0 .26645.06692.26645.22716 0 .16032-.10662.25371-.26645.25371Zm-1.7186.06663.69274-.73437v1.50917l-.69274-.7748Zm-1.07908.5478H4.00994v-.374h.98584v-.37386h-.98584v-.34736h1.11911l.49296.54752-.50625.5477ZM14.761 7.73288h-.6394l-.8393-1.40233v1.40233h-.9058l-.1734-.41403h-.9324l-.1732.41403h-.5196c-.2132 0-.493-.05344-.65268-.21376-.14663-.16023-.2266-.37391-.2266-.70778 0-.28052.03994-.53423.23972-.73451.13316-.147.37306-.21368.67936-.21368h.4263v.40072h-.4263c-.1597 0-.2531.02672-.3463.10688-.08.08016-.1199.227-.1199.42735 0 .20028.0399.3472.1199.44076.0666.06667.1866.09339.3064.09339h.1998l.6395-1.46901h.6661l.7461 1.76285V5.86315h.6928l.786 1.29546V5.86315h.4528l.0001 1.86973ZM9.4722 5.86315h-.45286v1.86973h.45286V5.86315Zm-.94599.08017c-.14655-.08016-.3063-.08017-.53281-.08017H6.96754v1.86973h.43957v-.68115h.47959c.15992 0 .26653.01332.33313.08016.07996.09348.0665.2538.0665.3606v.24039h.45286v-.37399c0-.16024-.01329-.2404-.07979-.33388-.04003-.05344-.11999-.12028-.21315-.16023.11973-.05344.31976-.20036.31976-.4942.00009-.21359-.09324-.33387-.2398-.42726ZM6.64778 7.34565H5.60864v-.37399h1.02577v-.38723H5.60864v-.33396h1.03914v-.38723H5.1557v1.86973h1.49208v-.38732Zm-1.82512-1.4825H4.0899l-.54618 1.26874-.58621-1.26874h-.71939V7.626L1.4788 5.86315H.812717L.0133681 7.73288H.49296l.173121-.41403h.932529l.17321.41403h.90596V6.26387l.65271 1.46901h.38626l.65289-1.46901v1.46901h.45293l.00009-1.86973Zm7.22074 1.05507-.3065-.73451-.3063.73451h.6128Zm-3.86351-.29375c-.06651.04012-.13318.04012-.22643.04012h-.54635v-.41404h.54627c.07996 0 .17303 0 .22642.02672.05323.04013.07997.09357.07997.17364 0 .08008-.02666.14675-.07988.17356Zm-7.353974.29375.306474-.73451.30639.73451H.825916ZM16 0H0v6.73126l.546182-1.24202H1.70514l.15992.30716v-.30716h1.3589l.30639.66775.2931-.66775h4.32979c.19977 0 .37289.04004.50624.14684v-.14684h1.18561v.14684c.19981-.10688.45281-.14684.74601-.14684h1.7185l.16.30716v-.30716h1.2656l.1866.30716v-.30716h1.2388v2.61764h-1.2522l-.2397-.40063v.40063H12.11l-.1732-.42735h-.3865l-.1731.42735h-.8126c-.3198 0-.5597-.08016-.71934-.16023v.16023H7.91344v-.60099c0-.08016-.01328-.09356-.06659-.09356h-.06659v.69447h-3.7303v-.33388l-.13318.33388H3.1308l-.13318-.32056v.32056H1.49208l-.15983-.42736H.945899l-.17312.42736H0V16h16v-4.7947c-.1731.0802-.5195.1202-.7593.1202h-1.1591v-.1603c-.1332.107-.373.1603-.5995.1603H9.83181v-.6009c0-.0802-.0132-.0802-.07996-.0802h-.06659v.6811H8.48628v-.7078c-.19978.0934-.42629.0934-.62615.0934h-.13326v.6144H6.26152l-.34633-.4007-.38634.4007h-2.3582V8.70796H5.5687l.34641.40046.37306-.40046h1.61199c.1864 0 .49287.02663.62605.16006v-.16006h1.43878c.14651 0 .42641.02663.61291.16006v-.16006h2.1715v.16023c.1199-.10688.3465-.16015.5462-.16015h1.2123v.16015c.1334-.09348.3197-.16015.5597-.16015H16V0Z",
      fill: "#006FCF"
    }, null, -1)
  ])]);
}
const rMe = /* @__PURE__ */ Y(UF, [["render", kF]]), BF = {}, GF = {
  width: "26",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function FF(t, e) {
  return v(), A("svg", GF, [...e[0] || (e[0] = [
    g("circle", {
      cx: "8",
      cy: "8",
      r: "8",
      fill: "#EB001B"
    }, null, -1),
    g("circle", {
      cx: "18",
      cy: "8",
      r: "8",
      fill: "#0099DF"
    }, null, -1),
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13 14.2453c1.8289-1.4661 3-3.7189 3-6.24532 0-2.52639-1.1711-4.77925-3-6.24537-1.8289 1.46612-3 3.71898-3 6.24537 0 2.52642 1.1711 4.77922 3 6.24532Z",
      fill: "#6C6BBD"
    }, null, -1)
  ])]);
}
const oMe = /* @__PURE__ */ Y(BF, [["render", FF]]), VF = {}, HF = {
  width: "26",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function WF(t, e) {
  return v(), A("svg", HF, [...e[0] || (e[0] = [
    g("circle", {
      cx: "8",
      cy: "8",
      r: "8",
      fill: "#EB001B"
    }, null, -1),
    g("circle", {
      cx: "18",
      cy: "8",
      r: "8",
      fill: "#F79410"
    }, null, -1),
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13 14.2453c1.8289-1.4661 3-3.7189 3-6.24532 0-2.52639-1.1711-4.77925-3-6.24537-1.8289 1.46612-3 3.71898-3 6.24537 0 2.52642 1.1711 4.77922 3 6.24532Z",
      fill: "#FF5F00"
    }, null, -1)
  ])]);
}
const iMe = /* @__PURE__ */ Y(VF, [["render", WF]]), YF = {}, KF = {
  width: "38",
  height: "12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function zF(t, e) {
  return v(), A("svg", KF, [...e[0] || (e[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19.6526 3.83634c-.0216 1.67157 1.5235 2.60438 2.6873 3.159 1.1959.56911 1.5975.93402 1.593 1.44284-.0091.77888-.954 1.12252-1.8383 1.1359-1.5428.02341-2.4397-.40728-3.1528-.73308l-.5557 2.543c.7155.3225 2.0402.6037 3.4141.616 3.2247 0 5.3345-1.5566 5.346-3.97021.0125-3.06303-4.3327-3.23267-4.3031-4.60184.0103-.41508.4154-.85813 1.3031-.97082.4393-.05685 1.6523-.10042 3.0273.51886L27.7132.5156C26.9738.252226 26.0233 0 24.84 0c-3.0352 0-5.1702 1.57783-5.1874 3.83634ZM32.8994.212001c-.5888 0-1.0851.335929-1.3065.851439L26.9864 11.8192h3.2224l.6412-1.733h3.9379l.372 1.733H38L35.5215.212001h-2.6221Zm.4507 3.135589.93 4.35853h-2.5469l1.6169-4.35853ZM15.7457.212001l-2.54 11.607199h3.0706L18.8151.212001h-3.0694Zm-4.5426 0L8.00689 8.11229 6.71403 1.39481C6.56231.645011 5.96325.212001 5.29796.212001H.0730547L0 .549044c1.07265.227607 2.2913.594756 3.02955.987536.45182.23987.58083.44964.72913 1.01987L6.2074 11.8192h3.24529L14.4277.212001h-3.2246Z",
      fill: "#1A1F71"
    }, null, -1)
  ])]);
}
const aMe = /* @__PURE__ */ Y(YF, [["render", zF]]), ZF = {
  Name: "InfoIcon",
  props: {
    width: {
      type: Number,
      default: 16,
      required: !1
    }
  }
}, qF = ["width", "height"];
function XF(t, e, n, r, o, i) {
  return v(), A("svg", {
    width: n.width,
    height: n.width,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...e[0] || (e[0] = [
    g("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      g("path", {
        d: "M8 0C3.58168075 0 0 3.58168075 0 8c0 4.4183193 3.58168075 8 8 8 4.4183193 0 8-3.5816807 8-8 .0001779-4.41831925-3.5816807-8-8-8z",
        fill: "#D0D0D3"
      }),
      g("path", {
        d: "M9.34927833 11.9091134c-.38812366.1529072-.69773193.2695258-.92898966.3498557-.23125774.0803299-.4997938.1205773-.80544334.1205773-.47043293 0-.83595873-.1146392-1.09641234-.3439175-.2607835-.2292784-.39109278-.5202474-.39109278-.8730722 0-.1372371.00973196-.2772784.02936082-.4204536.01962887-.1430103.05096907-.3046598.09402062-.4849484L6.736 8.54037113c.04338147-.16461853.07983507-.32032986.10919587-.46746393.02936086-.14696907.0442062-.28123707.0442062-.40263913 0-.2195464-.04519587-.37228867-.13558767-.45855674-.09039172-.08610306-.2632577-.1293196-.51876285-.1293196-.12569072 0-.25435052.01962887-.38614434.05872167-.13179381.03925773-.2447835.07637113-.33896906.11167013l.12948453-.52915466c.31785567-.12931959.62202062-.24.9123299-.33220619.29030929-.09204124.56511342-.13806185.82408249-.13806185.46696906 0 .82705153.11282474 1.08008246.33797938.25303094.22548452.3795464.51843299.3795464.87901032 0 .07455667-.0089072.20585567-.02655673.39389687-.01764947.18804127-.04997933.36074227-.09698967.51744333L8.2284536 10.092701c-.03942267.1372371-.0748866.2939382-.1062268.470433-.0313402.1764949-.04717527.3096083-.04717527.3998351 0 .227299.05080414.3821856.15257734.4644948.1017732.0823093.27793813.1235464.52849486.1235464.11727834 0 .25039174-.0206186.39917527-.0616907.14861853-.0412371.25632987-.0773609.32296907-.108866l-.12898974.5286598zM9.264 4.96247423c-.22548453.20964948-.49682473.3145567-.81435053.3145567-.31752574 0-.5900206-.10474227-.8173196-.3145567-.22729894-.20964949-.3409484-.46350516-.3409484-.76140206 0-.29789691.11364946-.55274227.3409484-.76437114.227299-.21162886.49979386-.31752577.8173196-.31752577.3175258 0 .588866.10589691.81435053.31752577.2253196.21162887.33814433.46647423.33814433.76437114 0 .2978969-.11282473.55175257-.33814433.76140206z",
        fill: "#FFFFFF"
      })
    ], -1)
  ])], 8, qF);
}
const sMe = /* @__PURE__ */ Y(ZF, [["render", XF]]), jF = Ne({
  props: {
    color: {
      type: String,
      default: "green",
      required: !1
    },
    animated: {
      type: Boolean,
      default: !1,
      required: !1
    },
    delay: {
      type: Number,
      default: 0,
      required: !1
    },
    checkable: {
      type: Boolean,
      default: !1,
      required: !1
    },
    checked: {
      type: Boolean,
      default: !0,
      required: !1
    },
    translucent: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  setup(t) {
    const e = W(), n = W(), r = (o) => {
      _t.timeline().add({
        targets: n.value,
        scale: [0.8, 1],
        opacity: 1,
        easing: "cubicBezier(0.19, 1, 0.22, 1)",
        duration: 400,
        delay: t.delay,
        loop: !1
      }).add(
        {
          targets: e.value,
          strokeDashoffset: [_t.setDashoffset, 0],
          easing: "cubicBezier(0.19, 1, 0.22, 1)",
          duration: 600,
          direction: "alternate",
          loop: !1
        },
        "-=200"
      );
    };
    return ct(() => {
      !t.animated || t.checkable && !t.checked || r();
    }), et(
      () => t.checked,
      () => {
        t.checkable && t.checked && r();
      }
    ), {
      path: e,
      circle: n
    };
  }
});
const JF = ["data-state"], QF = {
  ref: "circle",
  cx: "12",
  cy: "12",
  r: "12"
}, eV = {
  key: 0,
  ref: "path",
  d: "m8.5 12.5 2 2 5-5",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function tV(t, e, n, r, o, i) {
  return v(), A("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: z([t.color, { animated: t.animated }, { checkable: t.checkable }, { translucent: t.translucent }]),
    "data-state": [t.checked ? "checked" : "unchecked"],
    width: "24",
    height: "24",
    fill: "none"
  }, [
    g("circle", QF, null, 512),
    t.checked ? (v(), A("path", eV, null, 512)) : V("", !0)
  ], 10, JF);
}
const W5 = /* @__PURE__ */ Y(jF, [["render", tV], ["__scopeId", "data-v-b8c042f3"]]), nV = Ne({
  props: {
    animated: {
      type: Boolean,
      default: !1,
      required: !1
    },
    delay: {
      type: Number,
      default: 0,
      required: !1
    },
    color: {
      type: String,
      default: "red",
      required: !1
    },
    translucent: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  setup(t) {
    const e = W(), n = W();
    return ct(() => {
      t.animated && _t.timeline().add({
        targets: n.value,
        scale: [0.8, 1],
        opacity: 1,
        easing: "cubicBezier(0.19, 1, 0.22, 1)",
        duration: 400,
        delay: t.delay,
        loop: !1
      }).add(
        {
          targets: e.value,
          opacity: [0, 1],
          easing: "cubicBezier(0.19, 1, 0.22, 1)",
          duration: 400
        },
        "-=200"
      );
    }), {
      path: e,
      circle: n
    };
  }
});
const rV = {
  ref: "circle",
  cx: "12",
  cy: "12",
  r: "12"
}, oV = {
  ref: "path",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 6.5c-.5523 0-1 .44772-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1v-4c0-.55228-.4477-1-1-1ZM12 17c.8284 0 1.5-.6716 1.5-1.5S12.8284 14 12 14s-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5Z"
};
function iV(t, e, n, r, o, i) {
  return v(), A("svg", {
    class: z([t.color, { animated: t.animated }, { translucent: t.translucent }]),
    width: "24",
    height: "24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    g("circle", rV, null, 512),
    g("path", oV, null, 512)
  ], 2);
}
const lMe = /* @__PURE__ */ Y(nV, [["render", iV], ["__scopeId", "data-v-70768f87"]]), aV = {
  props: {
    animated: {
      type: Boolean,
      default: !1,
      required: !1
    },
    delay: {
      type: Number,
      default: 0,
      required: !1
    }
  },
  setup(t) {
    const e = W(), n = W();
    return ct(() => {
      t.animated && _t.timeline().add({
        targets: n.value,
        scale: [0.8, 1],
        opacity: 1,
        easing: "cubicBezier(0.19, 1, 0.22, 1)",
        duration: 400,
        delay: t.delay,
        loop: !1
      }).add(
        {
          targets: e.value,
          opacity: [0, 1],
          easing: "cubicBezier(0.19, 1, 0.22, 1)",
          duration: 400
        },
        "-=200"
      );
    }), {
      path: e,
      circle: n
    };
  }
};
const sV = {
  ref: "circle",
  cx: "12",
  cy: "12",
  r: "12",
  fill: "#FF9500"
}, lV = {
  ref: "path",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 6.5c-.5523 0-1 .44772-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1v-4c0-.55228-.4477-1-1-1ZM12 17c.8284 0 1.5-.6716 1.5-1.5S12.8284 14 12 14s-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5Z",
  fill: "#fff"
};
function cV(t, e, n, r, o, i) {
  return v(), A("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: z([{ animated: n.animated }]),
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    g("circle", sV, null, 512),
    g("path", lV, null, 512)
  ], 2);
}
const cMe = /* @__PURE__ */ Y(aV, [["render", cV], ["__scopeId", "data-v-48d6e478"]]), uV = {
  props: {
    animated: {
      type: Boolean,
      default: !1,
      required: !1
    },
    delay: {
      type: Number,
      default: 0,
      required: !1
    }
  },
  setup(t) {
    const e = W(), n = W();
    return ct(() => {
      t.animated && _t.timeline().add({
        targets: n.value,
        scale: [0.8, 1],
        opacity: 1,
        easing: "cubicBezier(0.19, 1, 0.22, 1)",
        duration: 400,
        delay: t.delay,
        loop: !1
      }).add(
        {
          targets: [e.value],
          opacity: [0, 1],
          easing: "cubicBezier(0.19, 1, 0.22, 1)",
          duration: 400
        },
        "-=200"
      );
    }), {
      line: e,
      circle: n
    };
  }
};
const dV = {
  ref: "circle",
  cx: "12",
  cy: "12",
  r: "12",
  fill: "#F90"
}, fV = {
  ref: "line",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11 9c0-.55228-.4477-1-1-1-.55228 0-1 .44772-1 1v6c0 .5523.44772 1 1 1 .5523 0 1-.4477 1-1V9Zm4 0c0-.55228-.4477-1-1-1s-1 .44772-1 1v6c0 .5523.4477 1 1 1s1-.4477 1-1V9Z",
  fill: "#fff"
};
function hV(t, e, n, r, o, i) {
  return v(), A("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: z([{ animated: n.animated }]),
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    g("circle", dV, null, 512),
    g("path", fV, null, 512)
  ], 2);
}
const uMe = /* @__PURE__ */ Y(uV, [["render", hV], ["__scopeId", "data-v-8b502008"]]), _V = {}, EV = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
function pV(t, e) {
  return v(), A("svg", EV, [...e[0] || (e[0] = [
    g("path", {
      d: "M12 0c6.627417 0 12 5.372583 12 12s-5.372583 12-12 12S0 18.627417 0 12 5.372583 0 12 0zm0 2C6.477153 2 2 6.477153 2 12s4.477153 10 10 10 10-4.477153 10-10S17.522847 2 12 2zm-1 11V5h2v6h5v2h-7z",
      fill: "#d0d0d3",
      "fill-rule": "nonzero"
    }, null, -1)
  ])]);
}
const dMe = /* @__PURE__ */ Y(_V, [["render", pV]]), mV = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, NV = ["stroke"], fMe = /* @__PURE__ */ Ne({
  __name: "InProgressIcon",
  props: {
    archived: { type: Boolean }
  },
  setup(t) {
    return (e, n) => (v(), A("svg", mV, [
      g("circle", {
        cx: "36",
        cy: "157",
        r: "11",
        transform: "translate(-24 -145)",
        "fill-rule": "nonzero",
        stroke: t.archived ? "#e0e0e5" : "#f90",
        "stroke-width": "2",
        fill: "none"
      }, null, 8, NV)
    ]));
  }
}), vV = {}, gV = {
  style: { "flex-shrink": "0" },
  width: "24",
  height: "24",
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg"
};
function IV(t, e) {
  return v(), A("svg", gV, [...e[0] || (e[0] = [
    vt('<g fill-rule="nonzero" fill="none"><path d="M0 18h48v25c0 2.7614237-2.2385763 5-5 5H5c-2.76142375 0-5-2.2385763-5-5V18z" fill="#E6EBEF"></path><path d="M18.8854771 44V22h-4.032203C14.4127814 24.3050847 12.2189856 25.9661017 9 26v2.998136h5.2433611V44h4.642116zm11.3046676 0C31.1727824 32.9152542 37.3396811 27.3220339 39 25.8983051V22H23v4h10.6124347s-7.3528408 6.1694915-8.2677104 18h4.8454204z" fill="#201D27"></path><path d="M5 0h38c2.7614237 0 5 2.23857625 5 5v13H0V5c0-2.76142375 2.23857625-5 5-5z" fill="#EB1729"></path><path d="M7.63299852 13.9850993c2.01230084 0 3.36841658-1.5794702 3.36841658-3.4867549V4H8.9891143v6.4983444c0 .923841-.52494804 1.5347682-1.37069767 1.5347682-.81658585 0-1.41444335-.4917219-1.42902524-1.5794702V10H4.25v.5430464c0 2.071192 1.3415339 3.4420529 3.38299852 3.4420529zM17.016274 14c2.2164473 0 3.980856-1.3857616 3.980856-3.9784768V4h-2.012301v5.87251656c0 1.38576154-.7436762 2.11589404-1.968555 2.11589404-1.195715 0-2.0039732-.7301325-2.0039732-2.11589404V4H13v6.0215232C13 12.6142384 14.8144086 14 17.016274 14zM30 14v-2h-4.9876992V4H23v10h7zM35 12v2h-2v-2h2zm4 0v2h-2v-2h2zm4 0v2h-2v-2h2zm-8-4v2h-2V8h2zm4 0v2h-2V8h2zm4 0v2h-2V8h2zm-8-4v2h-2V4h2zm4 0v2h-2V4h2zm4 0v2h-2V4h2z" fill="#FFFFFF"></path></g>', 1)
  ])]);
}
const hMe = /* @__PURE__ */ Y(vV, [["render", IV]]), OV = {
  props: {
    width: {
      type: Number,
      default: 249,
      required: !1
    }
  }
};
const AV = ["width"];
function DV(t, e, n, r, o, i) {
  return v(), A("svg", {
    width: n.width,
    viewBox: "0 0 249 227",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...e[0] || (e[0] = [
    vt('<g fill-rule="nonzero" fill="none" data-v-9e16eac4><path d="M84.9 28.6c2.4-6.3 5.7-12.1 10.6-16.8 19.6-19.1 52-14.3 65.3 9.7 10 18.2 20.6 36 30.9 54 17.2 29.9 34.6 59.8 51.6 89.8 14.3 25.1-1.2 56.8-29.6 61.1-17.4 2.6-33.7-5.4-42.7-21-15.1-26.3-30.3-52.6-45.4-78.8-.3-.6-.7-1.1-1.1-1.6-1.6-1.3-2.3-3.2-3.3-4.9-6.7-11.8-13.6-23.5-20.3-35.2-4.3-7.6-8.8-15.1-13.1-22.7-3.9-6.8-5.7-14.2-5.5-22 .3-4 .8-8 2.6-11.6" fill="#3C8BD9" data-v-9e16eac4></path><path d="M84.9 28.6c-.9 3.6-1.7 7.2-1.9 11-.3 8.4 1.8 16.2 6 23.5C100 82 111 101 121.9 120c1 1.7 1.8 3.4 2.8 5-6 10.4-12 20.7-18.1 31.1-8.4 14.5-16.8 29.1-25.3 43.6-.4 0-.5-.2-.6-.5-.1-.8.2-1.5.4-2.3 4.1-15 .7-28.3-9.6-39.7-6.3-6.9-14.3-10.8-23.5-12.1-12-1.7-22.6 1.4-32.1 8.9-1.7 1.3-2.8 3.2-4.8 4.2-.4 0-.6-.2-.7-.5 4.8-8.3 9.5-16.6 14.3-24.9C44.5 98.4 64.3 64 84.2 29.7c.2-.4.5-.7.7-1.1" fill="#FABC04" data-v-9e16eac4></path><path d="M10.8 158c1.9-1.7 3.7-3.5 5.7-5.1 24.3-19.2 60.8-5.3 66.1 25.1 1.3 7.3.6 14.3-1.6 21.3-.1.6-.2 1.1-.4 1.7-.9 1.6-1.7 3.3-2.7 4.9-8.9 14.7-22 22-39.2 20.9C19 225.4 3.5 210.6.8 191c-1.3-9.5.6-18.4 5.5-26.6 1-1.8 2.2-3.4 3.3-5.2.5-.4.3-1.2 1.2-1.2" fill="#34A852" data-v-9e16eac4></path><path d="M10.8 158c-.4.4-.4 1.1-1.1 1.2-.1-.7.3-1.1.7-1.6l.4.4" fill="#FABC04" data-v-9e16eac4></path><path d="M80.6 201c-.4-.7 0-1.2.4-1.7l.4.4-.8 1.3" fill="#E1C025" data-v-9e16eac4></path></g>', 1)
  ])], 8, AV);
}
const CV = /* @__PURE__ */ Y(OV, [["render", DV], ["__scopeId", "data-v-9e16eac4"]]), SV = ["width"], wV = /* @__PURE__ */ Ne({
  __name: "LinkedInLogo",
  props: {
    width: { default: 35 }
  },
  setup(t) {
    return (e, n) => (v(), A("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 72 72",
      width: t.width
    }, [...n[0] || (n[0] = [
      g("g", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        "fill-rule": "evenodd"
      }, [
        g("path", {
          d: "M8,72 L64,72 C68.418278,72 72,68.418278 72,64 L72,8 C72,3.581722 68.418278,-8.11624501e-16 64,0 L8,0 C3.581722,8.11624501e-16 -5.41083001e-16,3.581722 0,8 L0,64 C5.41083001e-16,68.418278 3.581722,72 8,72 Z",
          fill: "#007EBB"
        }),
        g("path", {
          d: "M62,62 L51.315625,62 L51.315625,43.8021149 C51.315625,38.8127542 49.4197917,36.0245323 45.4707031,36.0245323 C41.1746094,36.0245323 38.9300781,38.9261103 38.9300781,43.8021149 L38.9300781,62 L28.6333333,62 L28.6333333,27.3333333 L38.9300781,27.3333333 L38.9300781,32.0029283 C38.9300781,32.0029283 42.0260417,26.2742151 49.3825521,26.2742151 C56.7356771,26.2742151 62,30.7644705 62,40.051212 L62,62 Z M16.349349,22.7940133 C12.8420573,22.7940133 10,19.9296567 10,16.3970067 C10,12.8643566 12.8420573,10 16.349349,10 C19.8566406,10 22.6970052,12.8643566 22.6970052,16.3970067 C22.6970052,19.9296567 19.8566406,22.7940133 16.349349,22.7940133 Z M11.0325521,62 L21.769401,62 L21.769401,27.3333333 L11.0325521,27.3333333 L11.0325521,62 Z",
          fill: "#FFF"
        })
      ], -1)
    ])], 8, SV));
  }
}), TV = {
  props: {
    width: {
      type: Number,
      default: 35,
      required: !1
    }
  }
};
const bV = ["width"];
function RV(t, e, n, r, o, i) {
  return v(), A("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: n.width,
    viewBox: "0 0 35 35",
    fill: "none"
  }, [...e[0] || (e[0] = [
    g("path", {
      d: "M16 0H0V16H16V0Z",
      fill: "#F25022"
    }, null, -1),
    g("path", {
      d: "M35 0H19V16H35V0Z",
      fill: "#7FBA00"
    }, null, -1),
    g("path", {
      d: "M16 19H0V35H16V19Z",
      fill: "#00A4EF"
    }, null, -1),
    g("path", {
      d: "M35 19H19V35H35V19Z",
      fill: "#FFB900"
    }, null, -1)
  ])], 8, bV);
}
const _Me = /* @__PURE__ */ Y(TV, [["render", RV], ["__scopeId", "data-v-d3ca23b9"]]), MV = {
  props: {
    width: {
      type: Number,
      default: 35,
      required: !1
    }
  }
};
const PV = ["width"];
function yV(t, e, n, r, o, i) {
  return v(), A("svg", {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    viewBox: "0 0 287.56 191",
    width: n.width
  }, [...e[0] || (e[0] = [
    vt('<defs data-v-46bb1a26><linearGradient id="linear-gradient" x1="62.34" y1="101.45" x2="260.34" y2="91.45" gradientTransform="matrix(1, 0, 0, -1, 0, 192)" gradientUnits="userSpaceOnUse" data-v-46bb1a26><stop offset="0" stop-color="#0064e1" data-v-46bb1a26></stop><stop offset="0.4" stop-color="#0064e1" data-v-46bb1a26></stop><stop offset="0.83" stop-color="#0073ee" data-v-46bb1a26></stop><stop offset="1" stop-color="#0082fb" data-v-46bb1a26></stop></linearGradient><linearGradient id="linear-gradient-2" x1="41.42" y1="53" x2="41.42" y2="126" gradientTransform="matrix(1, 0, 0, -1, 0, 192)" gradientUnits="userSpaceOnUse" data-v-46bb1a26><stop offset="0" stop-color="#0082fb" data-v-46bb1a26></stop><stop offset="1" stop-color="#0064e0" data-v-46bb1a26></stop></linearGradient></defs><path fill="#0081fb" d="M31.06,126c0,11,2.41,19.41,5.56,24.51A19,19,0,0,0,53.19,160c8.1,0,15.51-2,29.79-21.76,11.44-15.83,24.92-38,34-52l15.36-23.6c10.67-16.39,23-34.61,37.18-47C181.07,5.6,193.54,0,206.09,0c21.07,0,41.14,12.21,56.5,35.11,16.81,25.08,25,56.67,25,89.27,0,19.38-3.82,33.62-10.32,44.87C271,180.13,258.72,191,238.13,191V160c17.63,0,22-16.2,22-34.74,0-26.42-6.16-55.74-19.73-76.69-9.63-14.86-22.11-23.94-35.84-23.94-14.85,0-26.8,11.2-40.23,31.17-7.14,10.61-14.47,23.54-22.7,38.13l-9.06,16c-18.2,32.27-22.81,39.62-31.91,51.75C84.74,183,71.12,191,53.19,191c-21.27,0-34.72-9.21-43-23.09C3.34,156.6,0,141.76,0,124.85Z" data-v-46bb1a26></path><path fill="url(#linear-gradient)" d="M24.49,37.3C38.73,15.35,59.28,0,82.85,0c13.65,0,27.22,4,41.39,15.61,15.5,12.65,32,33.48,52.63,67.81l7.39,12.32c17.84,29.72,28,45,33.93,52.22,7.64,9.26,13,12,19.94,12,17.63,0,22-16.2,22-34.74l27.4-.86c0,19.38-3.82,33.62-10.32,44.87C271,180.13,258.72,191,238.13,191c-12.8,0-24.14-2.78-36.68-14.61-9.64-9.08-20.91-25.21-29.58-39.71L146.08,93.6c-12.94-21.62-24.81-37.74-31.68-45C107,40.71,97.51,31.23,82.35,31.23c-12.27,0-22.69,8.61-31.41,21.78Z" data-v-46bb1a26></path><path fill="url(#linear-gradient-2)" d="M82.35,31.23c-12.27,0-22.69,8.61-31.41,21.78C38.61,71.62,31.06,99.34,31.06,126c0,11,2.41,19.41,5.56,24.51L10.14,167.91C3.34,156.6,0,141.76,0,124.85,0,94.1,8.44,62.05,24.49,37.3,38.73,15.35,59.28,0,82.85,0Z" data-v-46bb1a26></path>', 4)
  ])], 8, PV);
}
const EMe = /* @__PURE__ */ Y(MV, [["render", yV], ["__scopeId", "data-v-46bb1a26"]]), LV = {}, xV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 272 92",
  width: "272",
  height: "92"
};
function UV(t, e) {
  return v(), A("svg", xV, [...e[0] || (e[0] = [
    vt('<path fill="#EA4335" d="M115.75 47.18c0 12.77-9.99 22.18-22.25 22.18s-22.25-9.41-22.25-22.18C71.25 34.32 81.24 25 93.5 25s22.25 9.32 22.25 22.18zm-9.74 0c0-7.98-5.79-13.44-12.51-13.44S80.99 39.2 80.99 47.18c0 7.9 5.79 13.44 12.51 13.44s12.51-5.55 12.51-13.44z"></path><path fill="#FBBC05" d="M163.75 47.18c0 12.77-9.99 22.18-22.25 22.18s-22.25-9.41-22.25-22.18c0-12.85 9.99-22.18 22.25-22.18s22.25 9.32 22.25 22.18zm-9.74 0c0-7.98-5.79-13.44-12.51-13.44s-12.51 5.46-12.51 13.44c0 7.9 5.79 13.44 12.51 13.44s12.51-5.55 12.51-13.44z"></path><path fill="#4285F4" d="M209.75 26.34v39.82c0 16.38-9.66 23.07-21.08 23.07-10.75 0-17.22-7.19-19.66-13.07l8.48-3.53c1.51 3.61 5.21 7.87 11.17 7.87 7.31 0 11.84-4.51 11.84-13v-3.19h-.34c-2.18 2.69-6.38 5.04-11.68 5.04-11.09 0-21.25-9.66-21.25-22.09 0-12.52 10.16-22.26 21.25-22.26 5.29 0 9.49 2.35 11.68 4.96h.34v-3.61h9.25zm-8.56 20.92c0-7.81-5.21-13.52-11.84-13.52-6.72 0-12.35 5.71-12.35 13.52 0 7.73 5.63 13.36 12.35 13.36 6.63 0 11.84-5.63 11.84-13.36z"></path><path fill="#34A853" d="M225 3v65h-9.5V3h9.5z"></path><path fill="#EA4335" d="M262.02 54.48l7.56 5.04c-2.44 3.61-8.32 9.83-18.48 9.83-12.6 0-22.01-9.74-22.01-22.18 0-13.19 9.49-22.18 20.92-22.18 11.51 0 17.14 9.16 18.98 14.11l1.01 2.52-29.65 12.28c2.27 4.45 5.8 6.72 10.75 6.72 4.96 0 8.4-2.44 10.92-6.14zm-23.27-7.98l19.82-8.23c-1.09-2.77-4.37-4.7-8.23-4.7-4.95 0-11.84 4.37-11.59 12.93z"></path><path fill="#4285F4" d="M35.29 41.41V32H67c.31 1.64.47 3.58.47 5.68 0 7.06-1.93 15.79-8.15 22.01-6.05 6.3-13.78 9.66-24.02 9.66C16.32 69.35.36 53.89.36 34.91.36 15.93 16.32.47 35.3.47c10.5 0 17.98 4.12 23.6 9.49l-6.64 6.64c-4.03-3.78-9.49-6.72-16.97-6.72-13.86 0-24.7 11.17-24.7 25.03 0 13.86 10.84 25.03 24.7 25.03 8.99 0 14.11-3.61 17.39-6.89 2.66-2.66 4.41-6.46 5.1-11.65l-22.49.01z"></path>', 6)
  ])]);
}
const $V = /* @__PURE__ */ Y(LV, [["render", UV]]), kV = {}, BV = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function GV(t, e) {
  return v(), A("svg", BV, [...e[0] || (e[0] = [
    g("path", {
      d: "M12 14.6553C10.5769 14.6553 9.42456 13.4522 9.42456 11.9662V5.68902C9.42456 4.2031 10.5769 3 12 3C13.4232 3 14.5755 4.2031 14.5755 5.68902V11.9662C14.5755 13.4522 13.4232 14.6553 12 14.6553Z",
      fill: "#4285F4"
    }, null, -1),
    g("path", {
      d: "M12.8612 17.7115H11.1428V21H12.8612V17.7115Z",
      fill: "#34A853"
    }, null, -1),
    g("path", {
      d: "M16.3019 12C16.2978 14.4737 14.3693 16.4873 12 16.4873C10.8113 16.4873 9.7318 15.9808 8.95148 15.1618L7.75067 16.4156C8.83827 17.5511 10.3383 18.2561 12 18.2561C15.3113 18.2561 17.996 15.4531 18 11.9958H16.3019V12Z",
      fill: "#EA4335"
    }, null, -1),
    g("path", {
      d: "M8.95148 15.1618C8.17925 14.3513 7.69811 13.2326 7.69811 12H6C6 13.7223 6.67116 15.2842 7.75067 16.4156L8.95148 15.1618Z",
      fill: "#FBBC05"
    }, null, -1)
  ])]);
}
const pMe = /* @__PURE__ */ Y(kV, [["render", GV]]), FV = {}, VV = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function HV(t, e) {
  return v(), A("svg", VV, [...e[0] || (e[0] = [
    vt('<path d="M12 24c6.6274 0 12-5.3726 12-12 0-6.62742-5.3726-12-12-12C5.37258 0 0 5.37258 0 12c0 6.6274 5.37258 12 12 12Z" fill="url(#paint0_linear_129_3806)"></path><g filter="url(#filter0_d_129_3806)"><path d="M13 10c.5523 0 1 .4477 1 1v6h1c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.55228 0-1-.4477-1-1s.44772-1 1-1h1v-5H9c-.55228 0-1-.4477-1-1s.44772-1 1-1h4Zm-1-6c1.1046 0 2 .89543 2 2s-.8954 2-2 2-2-.89543-2-2 .8954-2 2-2Z" fill="url(#paint1_linear_129_3806)"></path></g><defs><linearGradient id="paint0_linear_129_3806" x1="3.5" y1="3.5" x2="24" y2="24" gradientUnits="userSpaceOnUse"><stop stop-color="#2482FF"></stop><stop offset="1" stop-color="#0035EC"></stop></linearGradient><linearGradient id="paint1_linear_129_3806" x1="8" y1="4" x2="16" y2="19" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"></stop><stop offset="1" stop-color="#E2EEFF"></stop></linearGradient><filter id="filter0_d_129_3806" x="7.75" y="4" width="8.5" height="15.75" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy=".5"></feOffset><feGaussianBlur stdDeviation=".125"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix values="0 0 0 0 0.00784314 0 0 0 0 0.00784314 0 0 0 0 0.0470588 0 0 0 0.16 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_129_3806"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_129_3806" result="shape"></feBlend></filter></defs>', 3)
  ])]);
}
const WV = /* @__PURE__ */ Y(FV, [["render", HV]]), YV = {}, KV = {
  width: "64",
  height: "64",
  viewBox: "0 0 256 256",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function zV(t, e) {
  return v(), A("svg", KV, [...e[0] || (e[0] = [
    vt('<rect width="256" height="256" rx="64" fill="url(#paint0_radial)"></rect><path d="M92 92h74M92 164h74" stroke="#C5D4E8" stroke-width="8" stroke-miterlimit="10" stroke-linecap="square"></path><rect x="88" y="68" width="80" height="120" rx="12" stroke="#C5D4E8" stroke-width="8" stroke-miterlimit="10" stroke-linecap="square"></rect><defs><radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(90 56 72) scale(297.173)"><stop stop-color="#EEF5FF"></stop><stop offset="1" stop-color="#DEECFF"></stop></radialGradient><clipPath id="iconClip"><rect width="256" height="256" rx="64" fill="url(#paint0_radial)"></rect></clipPath></defs>', 4)
  ])]);
}
const mMe = /* @__PURE__ */ Y(YV, [["render", zV]]), ZV = {
  props: {
    width: {
      type: Number,
      default: 36
    },
    height: {
      type: Number,
      default: 36
    }
  }
}, qV = ["width", "height"];
function XV(t, e, n, r, o, i) {
  return v(), A("svg", {
    width: n.width,
    height: n.height,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...e[0] || (e[0] = [
    vt('<g fill="none" fill-rule="evenodd"><path d="M0 31.75c0-1.7483588 1.49690095-3.25 3.25-3.25 1.94424629 0 3.43927611 1.5016412 3.5 3.25C6.68927611 45.876939 18.0432698 57.2811425 32 57.25c13.9567302.0311425 25.3107239-11.373061 25.25-25.5.0607239-1.7483588 1.5557537-3.25 3.5-3.25 1.7530991 0 3.25 1.5016412 3.25 3.25C64 49.5812378 49.6447199 64 32 64S0 49.5812378 0 31.75z" fill="#0035ec"></path><path d="M57.25 32.25C57.3107239 18.123061 45.9567302 6.71885754 32 6.75 18.0432698 6.71885754 6.68927611 18.123061 6.75 32.25c-.06072389 1.7483588-1.55575371 3.25-3.5 3.25C1.49690095 35.5 0 33.9983588 0 32.25 0 14.4187622 14.3552801 0 32 0s32 14.4187622 32 32.25c0 1.7483588-1.4969009 3.25-3.25 3.25-1.9442463 0-3.4392761-1.5016412-3.5-3.25z" fill="#73D8FF"></path><path d="M57.5 33.75c-5.2166921-9.5652163-15.4388057-13.8167514-26-13.75-9.9391674-.0667514-19.7009771 4.0408368-25 13.75-1.19575213 1.4308307-3.23718099 1.9692295-5 1C.06501706 33.8666143-.47387525 31.8233162.5 30c6.71282481-11.3693231 18.6900807-16.75 31-16.75 12.8963943 0 25.3900887 5.5564043 32 16.75.9738753 1.8233162.4349829 3.8666143-1 4.75-.692519.3523142-1.2707055.5-1.75.5-1.2440382 0-2.3648594-.594482-3.25-1.5z" fill="#3FBBFF"></path><path d="M.5 34c-.97325678-1.8237154-.43435456-3.8689269 1-4.75 1.75602138-.9734514 3.8049725-.4350411 5 1 5.211921 9.5668508 15.4398359 13.8166078 26 13.75 9.938703.0666078 19.7025632-4.0410687 25-13.75 1.1955864-1.4350411 3.2464087-1.9659735 5-1 1.4349135.8810731 1.9738157 2.9262846 1 4.75-6.7092832 11.3710769-18.6867591 16.75-31 16.75-12.8991494 0-25.39307323-5.5565238-32-16.75z" fill="#006dff"></path></g>', 1)
  ])], 8, qV);
}
const NMe = /* @__PURE__ */ Y(ZV, [["render", XV]]), jV = {
  props: {
    hex: {
      type: String,
      default: "#00ffff"
    }
  }
}, JV = {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, QV = ["stroke"];
function eH(t, e, n, r, o, i) {
  return v(), A("svg", JV, [
    g("path", {
      d: "M1 9L9 1M9 1H3M9 1V7",
      stroke: n.hex,
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, QV)
  ]);
}
const vMe = /* @__PURE__ */ Y(jV, [["render", eH]]), tH = {}, nH = {
  width: "27",
  height: "24",
  viewBox: "0 0 27 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function rH(t, e) {
  return v(), A("svg", nH, [...e[0] || (e[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.5002 0c-.79568 0-1.55875.31607-2.12135.87868C7.81624 1.44129 7.50016 2.20435 7.50016 3v1h-4C1.84331 4 .500165 5.34315.500165 7v4.7685a.9983325.9983325 0 0 0 0 .0363V21c0 1.6569 1.343145 3 2.999995 3H23.5002c1.6568 0 3-1.3431 3-3v-9.1951c.0002-.0121.0002-.0243 0-.0365V7c0-1.65685-1.3432-3-3-3h-4V3c0-.79565-.3161-1.55871-.8787-2.12132C18.0589.31607 17.2958 0 16.5002 0h-6ZM2.50016 21v-7.5437c3.41549 1.6795 7.17936 2.5534 11.00064 2.5438 3.8205.0043 7.5829-.8701 10.9994-2.546V21c0 .5523-.4478 1-1 1H3.50016c-.55228 0-1-.4477-1-1Zm11.00124-6.9999c3.8458.0046 7.6278-.959 10.9988-2.7976V7c0-.55229-.4478-1-1-1H3.50016c-.55228 0-1 .44772-1 1v4.2034c3.36858 1.8432 7.15137 2.8067 10.99744 2.7967h.0038ZM17.5002 4V3c0-.26522-.1054-.51957-.2929-.70711C17.0197 2.10536 16.7654 2 16.5002 2h-6c-.2653 0-.51961.10536-.70714.29289-.18754.18754-.2929.44189-.2929.70711v1h8.00004Zm-5.5 6c-.5523 0-1 .4477-1 1s.4477 1 1 1h3c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3Z",
      fill: "#000"
    }, null, -1)
  ])]);
}
const gMe = /* @__PURE__ */ Y(tH, [["render", rH]]), oH = {}, iH = {
  width: "27",
  height: "26",
  viewBox: "0 0 27 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function aH(t, e) {
  return v(), A("svg", iH, [...e[0] || (e[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.5 2c-6.07513 0-11 4.92487-11 11 0 2.5782.88697 4.9492 2.37241 6.8245.3383-.3481.76757-.9443 1.08598-1.7443.43626-1.0961.59754-2.4164.10528-3.7291-.72829-1.9421-.25743-3.71.94564-4.77336 1.17302-1.03682 2.92694-1.28628 4.46479-.45821.8009.43124 1.6942.45266 2.5914.22395.9052-.23073 1.7456-.70182 2.3345-1.14348 1.7496-1.31217 2.6577-2.46709 3.124-3.24922.2272-.38127.3521-.67828.4184-.86777C18.1317 2.7725 15.9061 2 13.5 2Zm8.019 3.47029c-.0788.15718-.1705.32575-.2771.50453C20.6301 7.00123 19.5383 8.34631 17.6 9.8c-.7445.5583-1.8207 1.1706-3.0405 1.4815-1.2278.313-2.6678.3344-4.0336-.401-.80461-.4333-1.65069-.2827-2.19205.1958-.51132.4519-.86923 1.3147-.39752 2.5726.70774 1.8873.45236 3.7336-.11972 5.1709-.39082.9819-.96382 1.8552-1.56517 2.4544C8.18711 22.9713 10.7234 24 13.5 24c2.1588 0 4.1724-.6219 5.8713-1.6963l-.415-.2075c-.1784-.0892-.369-.1512-.5657-.184l-1.8991-.3165c-2.5082-.418-3.9879-3.0474-3.0435-5.4084.5169-1.2922 1.6707-2.2209 3.0435-2.4497l2.5452-.4242c1.4736-.2456 2.9612.3505 3.8576 1.5456l1.0958 1.4611c.3312-1.0476.5099-2.163.5099-3.3201 0-2.9131-1.1324-5.56175-2.981-7.52971ZM23.0703 18.427c-.5288.9305-1.1894 1.7762-1.9563 2.512l-1.2633-.6317c-.3567-.1783-.738-.3023-1.1313-.3679l-1.8991-.3165c-1.2488-.2081-1.9855-1.5173-1.5153-2.6928.2573-.6434.8318-1.1058 1.5153-1.2197l2.5452-.4242c.7368-.1228 1.4806.1752 1.9288.7728l1.776 2.368ZM.5 13c0-7.1797 5.8203-13 13-13s13 5.8203 13 13-5.8203 13-13 13-13-5.8203-13-13Z",
      fill: "#000"
    }, null, -1)
  ])]);
}
const IMe = /* @__PURE__ */ Y(oH, [["render", aH]]), sH = {}, lH = {
  width: "23",
  height: "28",
  viewBox: "0 0 23 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function cH(t, e) {
  return v(), A("svg", lH, [...e[0] || (e[0] = [
    g("path", {
      d: "M11.501 15c2.2091 0 4-1.7909 4-4 0-2.20914-1.7909-4-4-4-2.20916 0-4.00002 1.79086-4.00002 4 0 2.2091 1.79086 4 4.00002 4Z",
      stroke: "#000",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    g("path", {
      d: "M21.501 11c0 9-10 16-10 16S1.50098 20 1.50098 11c0-2.65216 1.05356-5.1957 2.92893-7.07107C6.30527 2.05357 8.84881 1 11.501 1c2.6521 0 5.1957 1.05357 7.071 2.92893C20.4474 5.8043 21.501 8.34784 21.501 11v0Z",
      stroke: "#000",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const OMe = /* @__PURE__ */ Y(sH, [["render", cH]]), uH = {
  props: {
    hex: {
      type: String,
      required: !1,
      default: "#000"
    }
  }
}, dH = {
  width: "18",
  height: "19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fH = ["stroke"], hH = ["fill"];
function _H(t, e, n, r, o, i) {
  return v(), A("svg", dH, [
    g("rect", {
      x: "1",
      y: "1",
      width: "11",
      height: "13",
      rx: "3",
      stroke: n.hex,
      "stroke-width": "2"
    }, null, 8, fH),
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5 13v2c0 2.2091 1.79086 4 4 4h5c2.2091 0 4-1.7909 4-4V8c0-2.20914-1.7909-4-4-4h-3v2h3c1.1046 0 2 .89543 2 2v7c0 1.1046-.8954 2-2 2H9c-1.10457 0-2-.8954-2-2v-2H5Z",
      fill: n.hex
    }, null, 8, hH)
  ]);
}
const AMe = /* @__PURE__ */ Y(uH, [["render", _H]]), EH = {}, pH = {
  width: "8",
  height: "14",
  viewBox: "0 0 8 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function mH(t, e) {
  return v(), A("svg", pH, [...e[0] || (e[0] = [
    g("path", {
      d: "M7 1L1 7L7 13",
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const DMe = /* @__PURE__ */ Y(EH, [["render", mH]]), NH = {}, vH = {
  width: "8",
  height: "14",
  viewBox: "0 0 8 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function gH(t, e) {
  return v(), A("svg", vH, [...e[0] || (e[0] = [
    g("path", {
      d: "M1 1L7 7L1 13",
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const CMe = /* @__PURE__ */ Y(NH, [["render", gH]]), IH = {
  props: {
    hex: {
      type: String,
      required: !1,
      default: "#000"
    }
  }
}, OH = {
  width: "16",
  height: "19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, AH = ["fill"];
function DH(t, e, n, r, o, i) {
  return v(), A("svg", OH, [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7 2c-.55228 0-1 .44772-1 1h4c0-.55229-.44772-1-1-1H7Zm5 1c0-1.65685-1.3431-3-3-3H7C5.34315 0 4 1.34315 4 3H1c-.552285 0-1 .44772-1 1s.447715 1 1 1v11c0 1.6569 1.34315 3 3 3h8c1.6569 0 3-1.3431 3-3V5c.5523 0 1-.44772 1-1s-.4477-1-1-1h-3Zm-1 2H3v11c0 .5523.44772 1 1 1h8c.5523 0 1-.4477 1-1V5h-2ZM6 7c.55228 0 1 .44772 1 1v6c0 .5523-.44772 1-1 1s-1-.4477-1-1V8c0-.55228.44772-1 1-1Zm5 1c0-.55228-.4477-1-1-1-.55229 0-1 .44772-1 1v6c0 .5523.44771 1 1 1 .5523 0 1-.4477 1-1V8Z",
      fill: n.hex
    }, null, 8, AH)
  ]);
}
const SMe = /* @__PURE__ */ Y(IH, [["render", DH]]), CH = {
  props: {
    hex: {
      type: String,
      required: !1,
      default: "#000"
    }
  }
}, SH = {
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wH = ["fill"], TH = ["fill"], bH = ["stroke"];
function RH(t, e, n, r, o, i) {
  return v(), A("svg", SH, [
    g("path", {
      fill: n.hex,
      d: "M8 13h2v4H8z"
    }, null, 8, wH),
    g("rect", {
      x: "3",
      y: "16",
      width: "12",
      height: "2",
      rx: "1",
      fill: n.hex
    }, null, 8, TH),
    g("path", {
      d: "M15 1H3c-1.10457 0-2 .89543-2 2v8c0 1.1046.89543 2 2 2h12c1.1046 0 2-.8954 2-2V3c0-1.10457-.8954-2-2-2Z",
      stroke: n.hex,
      "stroke-width": "2"
    }, null, 8, bH)
  ]);
}
const wMe = /* @__PURE__ */ Y(CH, [["render", RH]]), MH = {
  props: {
    hex: {
      type: String,
      required: !1,
      default: "#000"
    }
  }
}, PH = {
  width: "14",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yH = ["stroke"], LH = ["fill"];
function xH(t, e, n, r, o, i) {
  return v(), A("svg", PH, [
    g("rect", {
      x: "1",
      y: "1",
      width: "12",
      height: "16",
      rx: "3",
      stroke: n.hex,
      "stroke-width": "2"
    }, null, 8, yH),
    g("circle", {
      cx: "7",
      cy: "12.5",
      r: "1.5",
      fill: n.hex
    }, null, 8, LH)
  ]);
}
const TMe = /* @__PURE__ */ Y(MH, [["render", xH]]), UH = {
  props: {
    hex: {
      type: String,
      required: !1,
      default: "#000"
    }
  }
}, $H = {
  width: "10",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kH = ["fill"];
function BH(t, e, n, r, o, i) {
  return v(), A("svg", $H, [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.99515 9.90096C8.27981 9.43957 10 7.42067 10 5c0-2.76142-2.23858-5-5-5S0 2.23858 0 5c0 2.42067 1.72019 4.43957 4.00485 4.90096C4.00164 9.93354 4 9.96658 4 10v5c0 .5523.44772 1 1 1s1-.4477 1-1v-5c0-.03342-.00164-.06646-.00485-.09904ZM8 5c0 1.65685-1.34315 3-3 3S2 6.65685 2 5s1.34315-3 3-3 3 1.34315 3 3Z",
      fill: n.hex
    }, null, 8, kH)
  ]);
}
const bMe = /* @__PURE__ */ Y(UH, [["render", BH]]), GH = {}, FH = {
  width: "14",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function VH(t, e) {
  return v(), A("svg", FH, [...e[0] || (e[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10 5c0 2.42067-1.72019 4.43957-4.00485 4.90096C5.99836 9.93354 6 9.96658 6 10v5c0 .5523-.44772 1-1 1s-1-.4477-1-1v-5c0-.03342.00164-.06646.00485-.09904C1.72019 9.43957 0 7.42067 0 5c0-2.76142 2.23858-5 5-5s5 2.23858 5 5ZM5 8c1.65685 0 3-1.34315 3-3S6.65685 2 5 2 2 3.34315 2 5s1.34315 3 3 3Zm9 1.51001V16h-1.37v-4.34h-1.56v-.93c.95-.01 1.61-.54 1.74-1.21999H14Z",
      fill: "#006DFF"
    }, null, -1)
  ])]);
}
const RMe = /* @__PURE__ */ Y(GH, [["render", VH]]), HH = {}, WH = {
  width: "15",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function YH(t, e) {
  return v(), A("svg", WH, [...e[0] || (e[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10 5c0 2.42067-1.72019 4.43957-4.00485 4.90096C5.99836 9.93354 6 9.96658 6 10v5c0 .5523-.44772 1-1 1s-1-.4477-1-1v-5c0-.03342.00164-.06646.00485-.09904C1.72019 9.43957 0 7.42067 0 5c0-2.76142 2.23858-5 5-5s5 2.23858 5 5ZM5 8c1.65685 0 3-1.34315 3-3S6.65685 2 5 2 2 3.34315 2 5s1.34315 3 3 3Zm6.56 3.66c0 .12.02.25.05.36l-1.31-.04c-.02-.09-.05-.29-.05-.45 0-1.14.86-2.17001 2.37-2.17001 1.45 0 2.34.96001 2.34 2.09001 0 .84-.46 1.52-1.26 2.01l-1.25.76c-.25.16-.46.34-.56.59H15V16h-4.8c.01-1.14.37-2.07 1.53-2.77l1.07-.64c.55-.33.77-.67.77-1.12 0-.47-.33-.89-.98-.89-.69 0-1.03.47-1.03 1.08Z",
      fill: "#006DFF"
    }, null, -1)
  ])]);
}
const MMe = /* @__PURE__ */ Y(HH, [["render", YH]]), KH = {}, zH = {
  width: "15",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function ZH(t, e) {
  return v(), A("svg", zH, [...e[0] || (e[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10 5c0 2.42067-1.72019 4.43957-4.00485 4.90096C5.99836 9.93354 6 9.96658 6 10v5c0 .5523-.44772 1-1 1s-1-.4477-1-1v-5c0-.03342.00164-.06646.00485-.09904C1.72019 9.43957 0 7.42067 0 5c0-2.76142 2.23858-5 5-5s5 2.23858 5 5ZM5 8c1.65685 0 3-1.34315 3-3S6.65685 2 5 2 2 3.34315 2 5s1.34315 3 3 3Zm7.55 4.87c-.28 0-.45.05-.59.1l-.61-.96 1.7-1.46h-2.84V9.35999h4.59V10.47l-1.68 1.4c.98.04 1.88.79 1.88 1.98 0 1.12-.92 2.15-2.49 2.15-1.51 0-2.43-.98-2.51-2.07l1.33-.26c.03.66.5 1.14 1.18 1.14.69 0 1.1-.44 1.1-.98 0-.61-.44-.96-1.06-.96Z",
      fill: "#006DFF"
    }, null, -1)
  ])]);
}
const PMe = /* @__PURE__ */ Y(KH, [["render", ZH]]), qH = {}, XH = {
  width: "24",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function jH(t, e) {
  return v(), A("svg", XH, [...e[0] || (e[0] = [
    g("path", {
      d: "M10.3404 1.17477c1.3597-.289014 2.7713-.218742 4.0955.20389 1.3242.42264 2.5153 1.18305 3.456 2.20629.9407 1.02324 1.5985 2.274 1.9085 3.62901.3101 1.35501.2617 2.7675-.1404 4.09824M13.6631 16.825c-1.3598.289-2.7714.2188-4.09556-.2039-1.32419-.4226-2.51534-1.183-3.45604-2.2063-.9407-1.0232-1.59848-2.274-1.90853-3.629-.31005-1.35498-.26165-2.76747.14042-4.09823",
      stroke: "#010105",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1),
    g("path", {
      d: "m18.3347 14.7553-1.793-3.8452 5.6382 2.0521-3.8452 1.7931ZM5.61058 2.96753 7.4036 6.81266 1.76544 4.76054l3.84514-1.79301Z",
      fill: "#000",
      stroke: "#000",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const yMe = /* @__PURE__ */ Y(qH, [["render", jH]]), JH = {}, QH = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "16",
  height: "16"
};
function eW(t, e) {
  return v(), A("svg", QH, [...e[0] || (e[0] = [
    vt('<title>Google all results</title><path fill="none" d="M0 0h24v24H0z"></path><path fill="#34A853" d="M10 2v2a6 6 0 0 1 6 6h2a8 8 0 0 0-8-8z"></path><path fill="#EA4335" d="M10 4V2a8 8 0 0 0-8 8h2c0-3.3 2.7-6 6-6z"></path><path fill="#FBBC04" d="M4 10H2a8 8 0 0 0 8 8v-2c-3.3 0-6-2.69-6-6z"></path><path fill="#4285F4" d="M22 20.59l-5.69-5.69A7.96 7.96 0 0 0 18 10h-2a6 6 0 0 1-6 6v2c1.85 0 3.52-.64 4.88-1.68l5.69 5.69L22 20.59z"></path>', 6)
  ])]);
}
const LMe = /* @__PURE__ */ Y(JH, [["render", eW]]), tW = {}, nW = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function rW(t, e) {
  return v(), A("svg", nW, [...e[0] || (e[0] = [
    g("path", {
      d: "M9.33334 8.66665L12 12H4L6.66667 9.33331L7.86 10.52L9.33334 8.66665ZM5.32667 6.67331C5.68118 6.6742 6.02151 6.53422 6.27281 6.28417C6.52411 6.03412 6.66579 5.69449 6.66667 5.33998C6.66755 4.98547 6.52757 4.64514 6.27753 4.39384C6.02748 4.14254 5.68784 4.00086 5.33334 3.99998C4.97883 3.9991 4.63849 4.13907 4.38719 4.38912C4.13589 4.63917 3.99422 4.97881 3.99334 5.33331C3.99245 5.68782 4.13243 6.02816 4.38248 6.27946C4.63253 6.53075 4.97216 6.67243 5.32667 6.67331V6.67331ZM14.6667 3.33331V12.6666C14.6649 13.1959 14.4534 13.7029 14.0785 14.0766C13.7036 14.4502 13.1959 14.66 12.6667 14.66H3.33334C2.24 14.66 1.33334 13.7533 1.33334 12.66V3.33331C1.33334 2.23998 2.24 1.33331 3.33334 1.33331H12.6667C13.7667 1.33331 14.6667 2.23998 14.6667 3.33331ZM13.3267 3.33331C13.3267 3.1565 13.2564 2.98693 13.1314 2.86191C13.0064 2.73688 12.8368 2.66665 12.66 2.66665H3.33334C3.15652 2.66665 2.98696 2.73688 2.86193 2.86191C2.73691 2.98693 2.66667 3.1565 2.66667 3.33331V12.6666C2.66667 12.8435 2.73691 13.013 2.86193 13.1381C2.98696 13.2631 3.15652 13.3333 3.33334 13.3333H8V13.3266H12.6667C12.8435 13.3266 13.0131 13.2564 13.1381 13.1314C13.2631 13.0064 13.3333 12.8368 13.3333 12.66V3.33331",
      fill: "#5F6368"
    }, null, -1)
  ])]);
}
const xMe = /* @__PURE__ */ Y(tW, [["render", rW]]), oW = {}, iW = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function aW(t, e) {
  return v(), A("svg", iW, [...e[0] || (e[0] = [
    g("path", {
      d: "M7.503 0C10.593 0 13.005 2.487 13.005 5.427C13.005 7.764 11.875 9.121 10.745 10.477C10.291 11.005 9.839 11.607 9.387 12.211C8.935 12.814 8.633 13.719 8.407 14.171C8.181 14.623 8.03 15 7.503 15C6.975 15 6.825 14.623 6.598 14.17C6.372 13.719 6.071 12.814 5.618 12.211C5.166 11.608 4.714 11.005 4.262 10.477C3.132 9.121 2 7.764 2 5.427C2 2.487 4.412 0 7.503 0ZM7.503 1.364C5.22 1.364 3.363 3.186 3.363 5.427C3.363 7.27 4.223 8.3 5.309 9.604C5.777 10.151 6.251 10.782 6.709 11.394C7.049 11.846 7.305 12.384 7.503 12.838C7.701 12.383 7.956 11.846 8.296 11.393C8.755 10.783 9.227 10.151 9.709 9.59C10.783 8.3 11.642 7.27 11.642 5.427C11.642 3.187 9.784 1.364 7.503 1.364V1.364ZM7.503 4.098C7.68187 4.09113 7.86028 4.12043 8.02755 4.18416C8.19482 4.24788 8.34751 4.34472 8.47647 4.46886C8.60542 4.593 8.70799 4.74189 8.77803 4.90662C8.84806 5.07135 8.88413 5.24852 8.88406 5.42752C8.884 5.60652 8.8478 5.78366 8.77763 5.94834C8.70747 6.11301 8.60479 6.26183 8.47574 6.38588C8.3467 6.50992 8.19394 6.60664 8.02662 6.67024C7.8593 6.73384 7.68086 6.76301 7.502 6.756C7.15845 6.74267 6.83341 6.59682 6.59506 6.34904C6.3567 6.10126 6.22357 5.77081 6.22357 5.427C6.22357 5.08319 6.3567 4.75274 6.59506 4.50496C6.83341 4.25718 7.15845 4.11133 7.502 4.098",
      fill: "#5F6368"
    }, null, -1)
  ])]);
}
const UMe = /* @__PURE__ */ Y(oW, [["render", aW]]), sW = {}, lW = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function cW(t, e) {
  return v(), A("svg", lW, [...e[0] || (e[0] = [
    g("path", {
      d: "M8 5.33335C8.73333 5.33335 9.33333 4.73335 9.33333 4.00002C9.33333 3.26669 8.73333 2.66669 8 2.66669C7.26666 2.66669 6.66666 3.26669 6.66666 4.00002C6.66666 4.73335 7.26666 5.33335 8 5.33335ZM8 6.66669C7.26666 6.66669 6.66666 7.26669 6.66666 8.00002C6.66666 8.73335 7.26666 9.33335 8 9.33335C8.73333 9.33335 9.33333 8.73335 9.33333 8.00002C9.33333 7.26669 8.73333 6.66669 8 6.66669ZM8 10.6667C7.26666 10.6667 6.66666 11.2667 6.66666 12C6.66666 12.7334 7.26666 13.3334 8 13.3334C8.73333 13.3334 9.33333 12.7334 9.33333 12C9.33333 11.2667 8.73333 10.6667 8 10.6667Z",
      fill: "#5F6368"
    }, null, -1)
  ])]);
}
const $Me = /* @__PURE__ */ Y(sW, [["render", cW]]), uW = {}, dW = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function fW(t, e) {
  return v(), A("svg", dW, [...e[0] || (e[0] = [
    g("path", {
      d: "M8 7.33333H12V8.66667H8V7.33333ZM4 11.3333H12V10H4V11.3333ZM4 8.66667H6.66667V4.66667H4V8.66667ZM14.6667 3.85333V12.1467C14.6667 13.1733 13.7733 14 12.6667 14H3.33333C2.24 14 1.33333 13.1667 1.33333 12.1467V3.85333C1.33333 2.84 2.24 2 3.33333 2H12.6667C13.76 2 14.6667 2.83333 14.6667 3.85333V3.85333ZM13.3267 8V3.85333C13.3267 3.57333 13.02 3.33333 12.66 3.33333H3.33333C2.97333 3.33333 2.66667 3.57333 2.66667 3.85333V12.1467C2.66667 12.4267 2.97333 12.6667 3.33333 12.6667H12.6667C13.0267 12.6667 13.3333 12.4267 13.3333 12.1467V8H13.3267ZM8 6H12V4.66667H8V6Z",
      fill: "#5F6368"
    }, null, -1)
  ])]);
}
const kMe = /* @__PURE__ */ Y(uW, [["render", fW]]), hW = {}, _W = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function EW(t, e) {
  return v(), A("svg", _W, [...e[0] || (e[0] = [
    g("path", {
      d: "M6.66666 11L10.6667 8.00004L6.66666 5.00004V11ZM3.33333 13.3334H12.6667C12.8435 13.3334 13.013 13.2631 13.1381 13.1381C13.2631 13.0131 13.3333 12.8435 13.3333 12.6667V3.33337C13.3333 3.15656 13.2631 2.98699 13.1381 2.86197C13.013 2.73695 12.8435 2.66671 12.6667 2.66671H3.33333C3.15652 2.66671 2.98695 2.73695 2.86192 2.86197C2.7369 2.98699 2.66666 3.15656 2.66666 3.33337V12.6667C2.66666 12.8435 2.7369 13.0131 2.86192 13.1381C2.98695 13.2631 3.15652 13.3334 3.33333 13.3334ZM13 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91911 14.0809C1.54404 13.7058 1.33333 13.1971 1.33333 12.6667V2.93337C1.33333 2.50903 1.5019 2.10206 1.80196 1.802C2.10202 1.50195 2.50898 1.33337 2.93333 1.33337H13.0667C13.491 1.33337 13.898 1.50195 14.198 1.802C14.4981 2.10206 14.6667 2.50903 14.6667 2.93337V13C14.6667 13.4421 14.4911 13.866 14.1785 14.1786C13.8659 14.4911 13.442 14.6667 13 14.6667Z",
      fill: "#5F6368"
    }, null, -1)
  ])]);
}
const BMe = /* @__PURE__ */ Y(hW, [["render", EW]]), pW = Ne({
  props: {
    hex: {
      type: String,
      required: !1,
      default: "#9aa0a6"
    }
  }
}), mW = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, NW = ["fill"];
function vW(t, e, n, r, o, i) {
  return v(), A("svg", mW, [
    e[1] || (e[1] = g("title", null, "search", -1)),
    g("g", {
      fill: t.hex,
      class: "nc-icon-wrapper"
    }, [...e[0] || (e[0] = [
      g("path", { d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" }, null, -1)
    ])], 8, NW)
  ]);
}
const GMe = /* @__PURE__ */ Y(pW, [["render", vW]]), gW = {}, IW = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function OW(t, e) {
  return v(), A("svg", IW, [...e[0] || (e[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8 6c0 1.10457-.89545 2-2 2-1.10455 0-2-.89543-2-2s.89545-2 2-2c1.10455 0 2 .89543 2 2Zm0 6c0 1.1046-.89545 2-2 2-1.10455 0-2-.8954-2-2s.89545-2 2-2c1.10455 0 2 .8954 2 2Zm-2 8c1.10455 0 2-.8954 2-2s-.89545-2-2-2c-1.10455 0-2 .8954-2 2s.89545 2 2 2Zm8-14c0 1.10457-.8954 2-2 2s-2-.89543-2-2 .8954-2 2-2 2 .89543 2 2Zm-2 8c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm2 4c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2Zm4-10c1.1046 0 2-.89543 2-2s-.8954-2-2-2-2 .89543-2 2 .8954 2 2 2Zm2 4c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2Zm-2 8c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Z",
      fill: "#757575"
    }, null, -1)
  ])]);
}
const FMe = /* @__PURE__ */ Y(gW, [["render", OW]]), AW = {}, DW = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function CW(t, e) {
  return v(), A("svg", DW, [...e[0] || (e[0] = [
    g("path", {
      d: "M3.5 18H21.5V16H3.5V18ZM3.5 13H21.5V11H3.5V13ZM3.5 6V8H21.5V6H3.5Z",
      fill: "#757575"
    }, null, -1)
  ])]);
}
const VMe = /* @__PURE__ */ Y(AW, [["render", CW]]), SW = {}, wW = {
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg",
  style: { "flex-shrink": "0" }
};
function TW(t, e) {
  return v(), A("svg", wW, [...e[0] || (e[0] = [
    vt('<g transform="matrix(1, 0, 0, 1, 27.009001, -39.238998)"><path fill="#4285F4" d="M -3.264 51.509 C -3.264 50.719 -3.334 49.969 -3.454 49.239 L -14.754 49.239 L -14.754 53.749 L -8.284 53.749 C -8.574 55.229 -9.424 56.479 -10.684 57.329 L -10.684 60.329 L -6.824 60.329 C -4.564 58.239 -3.264 55.159 -3.264 51.509 Z"></path><path fill="#34A853" d="M -14.754 63.239 C -11.514 63.239 -8.804 62.159 -6.824 60.329 L -10.684 57.329 C -11.764 58.049 -13.134 58.489 -14.754 58.489 C -17.884 58.489 -20.534 56.379 -21.484 53.529 L -25.464 53.529 L -25.464 56.619 C -23.494 60.539 -19.444 63.239 -14.754 63.239 Z"></path><path fill="#FBBC05" d="M -21.484 53.529 C -21.734 52.809 -21.864 52.039 -21.864 51.239 C -21.864 50.439 -21.724 49.669 -21.484 48.949 L -21.484 45.859 L -25.464 45.859 C -26.284 47.479 -26.754 49.299 -26.754 51.239 C -26.754 53.179 -26.284 54.999 -25.464 56.619 L -21.484 53.529 Z"></path><path fill="#EA4335" d="M -14.754 43.989 C -12.984 43.989 -11.404 44.599 -10.154 45.789 L -6.734 42.369 C -8.804 40.429 -11.514 39.239 -14.754 39.239 C -19.444 39.239 -23.494 41.939 -25.464 45.859 L -21.484 48.949 C -20.534 46.099 -17.884 43.989 -14.754 43.989 Z"></path></g>', 1)
  ])]);
}
const HMe = /* @__PURE__ */ Y(SW, [["render", TW]]), bW = {}, RW = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function MW(t, e) {
  return v(), A("svg", RW, [...e[0] || (e[0] = [
    g("path", {
      d: "M19.5 6.41L18.09 5L12.5 10.59L6.91 5L5.5 6.41L11.09 12L5.5 17.59L6.91 19L12.5 13.41L18.09 19L19.5 17.59L13.91 12L19.5 6.41Z",
      fill: "#70757A",
      "fill-opacity": "0.87"
    }, null, -1)
  ])]);
}
const WMe = /* @__PURE__ */ Y(bW, [["render", MW]]), PW = {}, yW = {
  focusable: "false",
  viewBox: "0 0 134 32",
  "aria-hidden": "true",
  "data-fill-none": "true",
  style: { width: "4.1875rem" }
};
function LW(t, e) {
  return v(), A("svg", yW, [...e[0] || (e[0] = [
    vt('<g clip-path="url(#clip0_8208_5771)"><path d="M0.000448964 19.7199C-0.0227305 18.9103 0.164984 18.1087 0.545262 17.3931C0.899133 16.7586 1.38047 16.2036 1.95918 15.7631C2.55875 15.3094 3.2251 14.9509 3.93459 14.7004C4.65859 14.4386 5.40213 14.2341 6.15832 14.0887C6.86103 13.9522 7.57149 13.859 8.28569 13.8096C8.96763 13.7634 9.5458 13.7412 10.0239 13.7412H11.1469V13.1461C11.1575 12.6553 11.068 12.1673 10.8837 11.712C10.7326 11.3435 10.4926 11.0179 10.1851 10.7639C9.87834 10.521 9.52435 10.3441 9.14553 10.2446C8.7222 10.1339 8.28598 10.0798 7.84836 10.0838C7.20274 10.0807 6.55999 10.1697 5.93966 10.3481C5.39291 10.5083 4.85895 10.709 4.34228 10.9487C3.81395 11.1884 3.30686 11.4722 2.82644 11.797L1.192 8.73102C1.7867 8.30062 2.42672 7.93623 3.1007 7.64433C3.82102 7.3334 4.56451 7.07883 5.32442 6.88291C6.27842 6.6396 7.26029 6.52216 8.24492 6.53362C10.6416 6.53362 12.4614 7.13117 13.7042 8.32628C14.947 9.52139 15.5678 11.258 15.5665 13.5361V20.6181C15.5665 21.1281 15.8217 21.3832 16.3319 21.3832H17.9256V24.695H13.7431C13.3879 24.7026 13.034 24.6508 12.6961 24.5416C12.4365 24.4579 12.1982 24.3192 11.9975 24.135C11.8239 23.9685 11.6902 23.7651 11.6065 23.5399C11.5198 23.3063 11.4765 23.059 11.4786 22.8099V22.6048C11.4731 22.383 11.4905 22.1613 11.5305 21.9431C11.5395 21.8623 11.5563 21.7824 11.5805 21.7047H11.5138C11.1981 22.3469 10.7708 22.9281 10.2518 23.4216C10.0109 23.6477 9.75522 23.8576 9.4865 24.05C9.18277 24.2645 8.85731 24.4466 8.51547 24.5933C8.12844 24.759 7.72631 24.8871 7.31466 24.9759C6.84736 25.0741 6.37089 25.1225 5.89333 25.12C5.14494 25.122 4.40065 25.0099 3.68628 24.7874C2.99798 24.5794 2.358 24.237 1.80352 23.7802C1.25012 23.3164 0.802746 22.7398 0.491522 22.0891C0.148898 21.347 -0.0190722 20.5366 0.000448964 19.7199ZM4.46273 19.3798C4.46052 19.6994 4.51835 20.0166 4.63322 20.315C4.74436 20.6057 4.9169 20.8691 5.13911 21.0875C5.37315 21.3162 5.65112 21.4953 5.95633 21.6142C6.30676 21.7486 6.67984 21.8145 7.05523 21.8082C7.64079 21.8146 8.21714 21.6626 8.72302 21.3684C9.22253 21.0756 9.66253 20.6919 10.0202 20.2373C10.3873 19.7727 10.6747 19.2506 10.8708 18.6923C11.0707 18.1513 11.1748 17.5797 11.1784 17.0032V16.4247H10.4371C10.1425 16.4247 9.79041 16.4358 9.38273 16.4598C8.97505 16.4838 8.54698 16.5263 8.10408 16.5947C7.66083 16.6627 7.223 16.7621 6.79394 16.8923C6.38204 17.0126 5.98907 17.1899 5.62648 17.419C5.29117 17.6286 5.00388 17.9063 4.78332 18.234C4.56429 18.5755 4.45264 18.9745 4.46273 19.3798Z" fill="currentColor"></path><path d="M19.2034 21.3848H21.7978V11.0224C21.8048 10.9189 21.7904 10.8151 21.7553 10.7175C21.7202 10.6198 21.6653 10.5305 21.5939 10.455C21.4416 10.3194 21.2419 10.249 21.038 10.2591H19.0366V6.96397H23.7027C24.4971 6.96397 25.0821 7.13646 25.4576 7.48144C25.8332 7.82642 26.0185 8.31062 26.0136 8.93405V9.73243C26.0139 9.82878 26.0083 9.92506 25.9969 10.0207C25.9858 10.1131 25.9747 10.1908 25.9635 10.2591C25.9524 10.3275 25.9394 10.4181 25.9283 10.4976H26.0136C26.0867 10.3311 26.1702 10.1693 26.2637 10.0133C26.4271 9.735 26.613 9.47046 26.8197 9.22236C27.0883 8.89751 27.382 8.59411 27.698 8.31493C28.0757 7.98096 28.4897 7.69022 28.9322 7.44817C30.0471 6.8337 31.3036 6.52027 32.5773 6.5389C33.4391 6.52472 34.297 6.65722 35.1142 6.9307C35.8285 7.17539 36.4697 7.5955 36.9784 8.1523C37.5142 8.76171 37.9096 9.48088 38.1366 10.2591C38.4217 11.2412 38.5567 12.2605 38.5369 13.2826V21.3848H41.109V24.6966H34.1394V14.1993C34.1436 13.7036 34.1008 13.2085 34.0116 12.7208C33.9405 12.3154 33.7872 11.9287 33.5613 11.5842C33.3423 11.2654 33.0424 11.0103 32.6922 10.845C32.2585 10.654 31.7872 10.563 31.3135 10.5789C30.5615 10.5654 29.8188 10.7469 29.1583 11.1056C28.5335 11.4536 27.9892 11.9291 27.5609 12.5009C27.116 13.0946 26.7786 13.7613 26.5639 14.471C26.3384 15.2033 26.2241 15.9652 26.2248 16.7312V21.3848H28.7617V24.6966H19.2034V21.3848Z" fill="currentColor"></path><path d="M41.8395 27.5514C42.0682 27.7228 42.3172 27.8656 42.5808 27.9764C42.8528 28.093 43.1343 28.1863 43.4221 28.2555C43.786 28.3437 44.1595 28.3865 44.534 28.383C45.2051 28.3959 45.8645 28.2065 46.426 27.8397C46.9788 27.4668 47.4109 26.9415 47.6694 26.3279L48.1623 25.2191L42.0471 10.2494H39.916V6.9653H48.6868V10.2605H46.5909L49.8283 19.2275C49.9725 19.6368 50.0803 20.0579 50.1507 20.4861C50.1848 20.6824 50.2077 20.8804 50.2193 21.0793H50.3212C50.3435 20.8945 50.3787 20.6894 50.4231 20.4861C50.5062 20.0557 50.6303 19.6343 50.7938 19.2275L54.0126 10.2605H51.9575V6.9653H60.3706V10.2605H58.3433L51.787 26.9914C51.4864 27.8048 51.066 28.569 50.5399 29.259C50.0751 29.8602 49.5178 30.3841 48.8888 30.8114C48.2888 31.2154 47.6274 31.5199 46.93 31.7133C46.2169 31.9074 45.4807 32.0044 44.7415 32.0016C44.1489 32.0079 43.5575 31.9459 42.9792 31.8168C42.5117 31.7108 42.0533 31.5687 41.6079 31.3917C41.1902 31.2289 40.7904 31.0239 40.4145 30.78L41.8395 27.5514Z" fill="currentColor"></path><path d="M59.4495 14.8161L60.5614 18.9226C60.6167 19.1436 60.6594 19.3676 60.6893 19.5934C60.7171 19.8152 60.743 20.0203 60.7652 20.2144C60.7875 20.4084 60.8116 20.6376 60.8338 20.8427H60.9357C60.9472 20.6322 60.97 20.4225 61.0043 20.2144C61.0265 20.0296 61.0543 19.8152 61.0895 19.5934C61.1247 19.3717 61.1692 19.1499 61.2248 18.9226L64.5604 6.99857H68.4779L71.7801 18.9226C71.8363 19.1434 71.879 19.3674 71.908 19.5934C71.9376 19.8152 71.9617 20.0203 71.9858 20.2144C72.0099 20.4084 72.0303 20.6376 72.0544 20.8427H72.173C72.1734 20.6323 72.1901 20.4222 72.223 20.2144C72.2471 20.0296 72.2749 19.8152 72.3082 19.5934C72.3416 19.3717 72.3879 19.1499 72.4454 18.9226L74.8155 10.2605H72.6548V6.9653H81.205V10.2605H79.0776L74.9563 24.6979H69.9529L66.8638 14.3023C66.8082 14.0768 66.76 13.8477 66.7193 13.6148C66.6804 13.3838 66.6489 13.1713 66.6266 12.9772C66.5924 12.7691 66.5695 12.5594 66.5581 12.3488H66.4561C66.445 12.554 66.4209 12.7628 66.3876 12.9772C66.3542 13.1916 66.3301 13.3838 66.2856 13.6148C66.2412 13.8458 66.1893 14.0768 66.1318 14.3023L63.1002 24.6979H58.0764L57.0127 20.9518" fill="currentColor"></path><path d="M80.5607 15.8286C80.5456 14.5415 80.8026 13.2657 81.3149 12.0843C81.7954 10.9773 82.4943 9.97801 83.37 9.14585C84.2525 8.31448 85.2893 7.66285 86.4221 7.22752C87.6159 6.76272 88.8875 6.52877 90.1691 6.53817C91.4591 6.52832 92.7393 6.76223 93.942 7.22752C95.0798 7.66267 96.1221 8.31419 97.0107 9.14585C97.8904 9.97615 98.5921 10.9758 99.0732 12.0843C99.5874 13.2654 99.8463 14.5412 99.833 15.8286C99.8477 17.1164 99.59 18.3929 99.0769 19.5747C98.5958 20.6833 97.8941 21.6829 97.0144 22.5132C96.1291 23.3447 95.0917 23.9985 93.9587 24.4389C91.5388 25.3557 88.866 25.3557 86.4462 24.4389C85.3117 24.0006 84.2724 23.3487 83.3848 22.5188C82.5051 21.6885 81.8035 20.6888 81.3223 19.5803C80.8065 18.3971 80.547 17.1187 80.5607 15.8286ZM84.9878 15.8286C84.978 16.6012 85.117 17.3685 85.3973 18.0888C85.6524 18.738 86.0348 19.3299 86.5221 19.8298C86.9972 20.3108 87.5643 20.6917 88.1899 20.9497C88.8293 21.2176 89.5164 21.3534 90.2098 21.3489C90.8886 21.3514 91.561 21.2182 92.1874 20.9573C92.8137 20.6964 93.3814 20.313 93.8567 19.8298C94.3441 19.3299 94.7265 18.738 94.9816 18.0888C95.5301 16.638 95.5301 15.0377 94.9816 13.5869C94.7257 12.9359 94.3434 12.3418 93.8567 11.8385C93.387 11.3542 92.8259 10.9673 92.2056 10.7001C91.5759 10.4275 90.8963 10.2884 90.2098 10.2917C89.5155 10.2876 88.8278 10.4267 88.1899 10.7001C87.5634 10.9649 86.9964 11.3519 86.5221 11.8385C86.0355 12.3418 85.6532 12.9359 85.3973 13.5869C85.1207 14.3016 84.9842 15.0626 84.9952 15.8286H84.9878Z" fill="currentColor"></path><path d="M100.368 21.3907H102.962V11.0284C102.97 10.9247 102.955 10.8206 102.92 10.7228C102.884 10.6251 102.829 10.5358 102.756 10.461C102.604 10.3248 102.404 10.2544 102.2 10.2651H100.203V6.96994H104.835C105.63 6.96994 106.226 7.13997 106.624 7.48002C107.021 7.82007 107.218 8.36218 107.213 9.10635V10.1598C107.213 10.3298 107.213 10.4813 107.213 10.6181C107.213 10.7549 107.198 10.8676 107.187 10.9582C107.176 11.0487 107.165 11.1725 107.154 11.2631H107.22C107.42 10.6338 107.701 10.033 108.056 9.47598C108.402 8.93487 108.828 8.44838 109.318 8.0326C109.802 7.62809 110.348 7.30419 110.936 7.07343C111.545 6.83364 112.195 6.71256 112.85 6.71675C112.954 6.71675 113.052 6.71675 113.148 6.71675C113.237 6.72089 113.326 6.72953 113.413 6.74262L113.651 6.77589V11.1393C113.56 11.1282 113.465 11.1152 113.345 11.1042C113.224 11.0931 113.143 11.0857 113.013 11.0783C112.883 11.0709 112.737 11.0783 112.578 11.0783C111.769 11.0571 110.969 11.2442 110.254 11.6216C109.612 11.9738 109.058 12.4674 108.636 13.065C108.198 13.6927 107.877 14.3947 107.691 15.1367C107.485 15.9247 107.381 16.736 107.383 17.5504V21.4055H109.922V24.7173H100.368V21.3907Z" fill="currentColor"></path><path d="M113.988 15.8291C113.972 14.5291 114.17 13.2353 114.576 11.9998C114.928 10.9214 115.496 9.92514 116.244 9.07052C116.953 8.26986 117.828 7.63236 118.808 7.20208C119.85 6.75115 120.976 6.52505 122.112 6.53861C122.93 6.51782 123.744 6.65073 124.512 6.93041C125.08 7.14001 125.614 7.43141 126.096 7.79532C126.54 8.14645 126.925 8.56492 127.238 9.0354H127.307C127.294 8.93376 127.282 8.82102 127.271 8.69535C127.26 8.56968 127.253 8.45325 127.247 8.3054C127.242 8.15755 127.238 7.98937 127.238 7.79532V3.29518H124.479V0H131.632V20.6193C131.632 21.1294 131.887 21.3845 132.399 21.3845H134V24.6963H129.827C129.474 24.7047 129.122 24.6528 128.787 24.5429C128.527 24.4552 128.287 24.317 128.081 24.1363C127.899 23.9737 127.758 23.7696 127.672 23.5412C127.585 23.3076 127.542 23.0603 127.544 22.8112V22.6061C127.538 22.4125 127.556 22.2189 127.596 22.0295C127.618 21.95 127.64 21.8761 127.664 21.8077H127.579C127.278 22.4381 126.855 23.0033 126.336 23.471C126.088 23.69 125.826 23.892 125.552 24.0753C125.233 24.2854 124.894 24.4613 124.538 24.6002C123.654 24.9526 122.71 25.129 121.758 25.1195C120.651 25.1348 119.554 24.9024 118.549 24.4394C117.598 23.9943 116.76 23.3411 116.097 22.5284C115.394 21.6573 114.865 20.6598 114.539 19.59C114.162 18.3721 113.976 17.1035 113.988 15.8291ZM118.451 15.8291C118.441 16.603 118.55 17.3738 118.773 18.1152C118.964 18.7509 119.27 19.3465 119.675 19.8727C120.046 20.3469 120.521 20.73 121.063 20.9927C121.619 21.2573 122.228 21.3913 122.844 21.3845C123.422 21.3848 123.994 21.275 124.531 21.061C125.078 20.8447 125.57 20.508 125.969 20.076C126.412 19.586 126.751 19.0114 126.966 18.3868C127.231 17.5963 127.356 16.7659 127.336 15.9325C127.342 15.2248 127.253 14.5195 127.073 13.8349C126.908 13.1956 126.634 12.5892 126.263 12.0423C125.912 11.527 125.446 11.1 124.901 10.7948C124.315 10.4738 123.654 10.3125 122.985 10.3272C122.378 10.3256 121.778 10.4515 121.223 10.6969C120.669 10.943 120.178 11.3085 119.783 11.7669C119.354 12.2754 119.025 12.8605 118.814 13.4912C118.562 14.2446 118.439 15.035 118.451 15.8291Z" fill="currentColor"></path></g><defs><clipPath id="clip0_8208_5771"><rect width="134" height="32" fill="white"></rect></clipPath></defs>', 2)
  ])]);
}
const YMe = /* @__PURE__ */ Y(PW, [["render", LW]]), xW = {}, UW = {
  width: "116",
  height: "32",
  viewBox: "0 0 116 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function $W(t, e) {
  return v(), A("svg", UW, [...e[0] || (e[0] = [
    vt('<path d="M12.4537 5.88784H29.6473L29.8921 4.79559C30.2499 3.10071 28.9693 1.5 27.2368 1.5H10.5328C8.36717 1.5 6.5028 3.00655 6.032 5.11573L2.37861 21.9891C2.0208 23.684 3.30137 25.2847 5.03391 25.2847H6.05084L9.77956 8.03468C10.062 6.79177 11.1731 5.88784 12.4537 5.88784Z" fill="#00CDFA"></path><path d="M30.6642 5.88867H29.6473L25.9186 23.1387C25.6549 24.3816 24.5438 25.2856 23.2633 25.2856H6.06971L5.8249 26.3778C5.46709 28.0727 6.74766 29.6734 8.4802 29.6734H25.1841C27.3498 29.6734 29.2142 28.1668 29.685 26.0577L33.3384 9.20309C33.6962 7.48939 32.3968 5.88867 30.6642 5.88867Z" fill="url(#paint0_linear_13995_81390)"></path><path d="M25.9182 23.1387L29.6469 5.88867H12.4534C11.1728 5.88867 10.0617 6.77377 9.79806 8.03551L6.06934 25.2856H23.2629C24.5435 25.2856 25.6357 24.3816 25.9182 23.1387Z" fill="#3A00FF"></path><path d="M11.6632 18.7029L10.4189 12.2344H12.3701L12.971 16.271L14.9434 12.2344H16.2583L17.0289 16.271L18.8386 12.2344H20.7898L17.6298 18.7029H15.9967L15.2191 14.9137L13.3174 18.7029H11.6632Z" fill="white"></path><path d="M20.1045 17.6563L21.1225 16.4757C21.582 17.0412 22.1617 17.3311 22.8757 17.3311C23.3352 17.3311 23.7382 17.1402 23.8018 16.8221C23.823 16.6312 23.6958 16.4686 23.3988 16.3272C23.3282 16.2919 23.1726 16.2353 22.9252 16.1505C22.4374 15.9596 22.2253 15.8889 21.8012 15.6203C21.2073 15.2527 20.9245 14.7437 21.0235 13.8671C21.2144 12.6723 22.3102 12.0078 23.6958 12.0078C24.6431 12.0078 25.4207 12.3189 26.0499 12.9339L25.046 14.1074C24.6289 13.7186 24.1482 13.5277 23.6039 13.5277C23.1656 13.5277 22.904 13.655 22.8474 13.9307C22.7979 14.1569 22.9181 14.3478 23.2009 14.475C23.2928 14.5245 23.4837 14.6023 23.7665 14.7083C24.0492 14.8144 24.2896 14.9063 24.4875 15.0194C25.1238 15.288 25.8731 15.9172 25.6469 16.8786C25.5409 17.5078 25.2228 18.0027 24.6855 18.3562C24.1553 18.7096 23.512 18.8864 22.7909 18.8864C21.6315 18.8793 20.7337 18.4763 20.1045 17.6563Z" fill="white"></path><path d="M43.8033 21.3156H41.9762L38.3975 10.5039H40.7708L42.9557 17.7745L45.4044 10.5039H46.7794L49.2845 17.7745L51.4318 10.5039H53.8051L50.2451 21.3156H48.4181L46.1201 14.2334L43.8033 21.3156Z" fill="black"></path><path d="M55.8385 21.3153H53.7666V13.3478H55.7632V14.4215C56.2341 13.555 56.9687 13.1406 57.9481 13.1406C58.2683 13.1406 58.5885 13.1971 58.9088 13.3101L58.7392 15.2879C58.3814 15.1749 58.08 15.1184 57.7974 15.1184C57.1947 15.1184 56.7238 15.3256 56.3659 15.7211C56.0269 16.1167 55.8385 16.7194 55.8385 17.5293V21.3153Z" fill="black"></path><path d="M61.6978 11.1826C61.6978 11.5405 61.5848 11.8419 61.3399 12.0867C61.0951 12.3316 60.7937 12.4446 60.4358 12.4446C60.0779 12.4446 59.7766 12.3316 59.5317 12.0867C59.2868 11.8419 59.1738 11.5405 59.1738 11.1826C59.1738 10.8247 59.2868 10.5234 59.5317 10.2973C59.7766 10.0525 60.0779 9.93945 60.4358 9.93945C60.7937 9.93945 61.0951 10.0525 61.3399 10.2973C61.5848 10.5234 61.6978 10.8247 61.6978 11.1826ZM61.453 13.3487V21.3162H59.381V13.3487H61.453Z" fill="black"></path><path d="M67.8571 19.2248L68.4786 20.8447C67.8194 21.2779 67.0283 21.504 66.1242 21.504C65.2012 21.504 64.5231 21.2403 64.0522 20.7129C63.5814 20.1855 63.3553 19.3944 63.3553 18.3584V15.0622H62.0557V13.3293H63.3742V10.5039H65.4273V13.3293H68.0643V15.0622H65.4273V18.2266C65.4273 19.1683 65.804 19.6392 66.5574 19.6392C66.9341 19.6392 67.3862 19.5074 67.8571 19.2248Z" fill="black"></path><path d="M76.4833 17.1526C76.4833 17.3975 76.4645 17.6989 76.408 18.0567H70.4182C70.7196 19.1869 71.4918 19.752 72.735 19.752C73.6579 19.752 74.5244 19.4883 75.3155 18.942L76.1254 20.3924C75.1083 21.127 73.9593 21.4848 72.6408 21.4848C71.247 21.4848 70.1733 21.0893 69.4199 20.2794C68.6853 19.4883 68.3086 18.49 68.3086 17.3222C68.3086 16.0978 68.6853 15.0995 69.4576 14.3273C70.2298 13.5362 71.2281 13.1406 72.4525 13.1406C73.6203 13.1406 74.5621 13.4985 75.3155 14.2143C76.1066 14.9489 76.4833 15.9283 76.4833 17.1526ZM72.4901 14.8547C71.9816 14.8547 71.5295 15.0054 71.1716 15.3067C70.8137 15.6081 70.5689 16.0037 70.437 16.5311H74.4867C74.3925 16.0225 74.1665 15.6081 73.8086 15.3067C73.4507 15.0054 73.0175 14.8547 72.4901 14.8547Z" fill="black"></path><path d="M79.9496 21.5229C78.5557 21.5229 77.4633 21.0144 76.6533 19.9784L77.7458 18.6788C78.0283 19.0178 78.3674 19.2815 78.7629 19.4887C79.1585 19.6959 79.554 19.7901 79.9496 19.7901C80.2698 19.7901 80.5146 19.7147 80.7407 19.564C80.9479 19.4133 81.0609 19.225 81.0609 18.999C81.0609 18.7164 80.8725 18.4904 80.4958 18.3209C80.3828 18.2644 80.0626 18.1514 79.554 17.963C79.102 17.7935 78.7629 17.6616 78.5369 17.5298C77.6139 17.0966 77.1619 16.3996 77.1619 15.4578C77.1619 14.7609 77.4256 14.1959 77.9718 13.725C78.4992 13.2729 79.2338 13.0469 80.1379 13.0469C81.2681 13.0469 82.2099 13.4236 82.9256 14.1959L81.9085 15.5332C81.3434 15.0058 80.7407 14.7421 80.0814 14.7421C79.8177 14.7421 79.5917 14.7986 79.4222 14.9304C79.2526 15.0623 79.1585 15.213 79.1585 15.4013C79.1585 15.7404 79.3845 15.9852 79.8554 16.1359C80.8914 16.5315 81.5318 16.7763 81.7766 16.9082C82.6807 17.3791 83.114 18.0572 83.114 18.9236C83.114 19.6771 82.8126 20.2798 82.2287 20.7695C81.6636 21.2781 80.9102 21.5229 79.9496 21.5229Z" fill="black"></path><path d="M83.4893 17.3234C83.4893 16.1368 83.8848 15.1573 84.6947 14.3474C85.5047 13.5374 86.5218 13.123 87.765 13.123C89.0081 13.123 90.0253 13.5374 90.8352 14.3474C91.6263 15.1385 92.0407 16.1368 92.0407 17.3234C92.0407 18.5101 91.6451 19.5084 90.8352 20.2995C90.0253 21.1094 89.0081 21.5049 87.765 21.5049C86.5218 21.5049 85.5047 21.1094 84.6947 20.2995C83.8848 19.5084 83.4893 18.5101 83.4893 17.3234ZM86.1828 18.9433C86.5971 19.3765 87.1246 19.6025 87.765 19.6025C88.3865 19.6025 88.8951 19.3765 89.3283 18.9433C89.7616 18.4912 89.9687 17.945 89.9687 17.3234C89.9687 16.7018 89.7616 16.1556 89.3283 15.7224C88.8951 15.2892 88.3865 15.0631 87.765 15.0631C87.1246 15.0631 86.5971 15.2892 86.1828 15.7224C85.7684 16.1556 85.5612 16.683 85.5612 17.3234C85.5612 17.9638 85.7684 18.5101 86.1828 18.9433Z" fill="black"></path><path d="M94.9606 21.3153H92.8887V13.3478H94.9041V14.4591C95.1113 14.0636 95.4503 13.7434 95.9024 13.4985C96.3544 13.2536 96.8442 13.1406 97.4092 13.1406C98.2757 13.1406 99.0103 13.4232 99.613 14.0071C100.216 14.591 100.517 15.4009 100.517 16.4557V21.3342H98.4452V17.0208C98.4452 16.3992 98.2945 15.9095 97.9932 15.5704C97.6918 15.2314 97.2774 15.043 96.7688 15.043C96.2226 15.043 95.7894 15.2314 95.4503 15.6081C95.1113 15.9848 94.9418 16.4745 94.9418 17.0585V21.3153H94.9606Z" fill="black"></path><path d="M104.058 11.1826C104.058 11.5405 103.945 11.8419 103.7 12.0867C103.455 12.3316 103.154 12.4446 102.796 12.4446C102.438 12.4446 102.137 12.3316 101.892 12.0867C101.647 11.8419 101.534 11.5405 101.534 11.1826C101.534 10.8247 101.647 10.5234 101.892 10.2973C102.137 10.0525 102.438 9.93945 102.796 9.93945C103.154 9.93945 103.455 10.0525 103.7 10.2973C103.945 10.5234 104.058 10.8247 104.058 11.1826ZM103.813 13.3487V21.3162H101.741V13.3487H103.813Z" fill="black"></path><path d="M108.881 21.5044C107.656 21.5044 106.639 21.1088 105.829 20.3366C105.038 19.5643 104.643 18.566 104.643 17.3417C104.643 16.1174 105.038 15.1191 105.848 14.3468C106.658 13.5557 107.694 13.1602 108.937 13.1602C109.747 13.1602 110.5 13.3485 111.16 13.7441C111.819 14.1396 112.328 14.6858 112.648 15.3828L110.99 16.2869C110.5 15.477 109.822 15.0814 108.956 15.0814C108.297 15.0814 107.75 15.3074 107.336 15.7406C106.903 16.1739 106.696 16.7013 106.696 17.3417C106.696 18.0009 106.903 18.5472 107.317 18.9804C107.75 19.4136 108.278 19.6208 108.918 19.6208C109.333 19.6208 109.728 19.5078 110.124 19.2818C110.5 19.0557 110.783 18.7732 110.953 18.4153L112.629 19.3948C112.29 20.0352 111.781 20.5438 111.122 20.9393C110.444 21.2972 109.691 21.5044 108.881 21.5044Z" fill="black"></path><defs><linearGradient id="paint0_linear_13995_81390" x1="5.76428" y1="17.7837" x2="33.391" y2="17.7837" gradientUnits="userSpaceOnUse"><stop stop-color="#FFB3FF"></stop><stop offset="0.5335" stop-color="#FF76DF"></stop><stop offset="1" stop-color="#C239C6"></stop></linearGradient></defs>', 16)
  ])]);
}
const KMe = /* @__PURE__ */ Y(xW, [["render", $W]]), kW = Ne({
  name: "Avatar",
  components: { LinkedInLogo: wV },
  props: {
    width: {
      type: Number,
      default: 36,
      required: !1
    },
    height: {
      type: Number,
      default: 36,
      required: !1
    },
    color: {
      type: String,
      default: "#006dff",
      required: !1
    },
    fontSize: {
      type: Number,
      default: 11,
      required: !1
    },
    platform: {
      type: Number,
      default: st.GoogleAds,
      required: !1
    },
    showAccountType: {
      type: Boolean,
      default: !1,
      required: !1
    },
    accountTypeSize: {
      type: String,
      default: "medium",
      required: !1
    }
  },
  setup() {
    return { Platform: CR };
  }
});
const BW = {
  key: 0,
  width: "11",
  height: "11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, GW = {
  key: 1,
  width: "9",
  height: "9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, FW = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 287.56 191",
  width: "15",
  height: "15"
};
function VW(t, e, n, r, o, i) {
  const a = ee("LinkedInLogo");
  return v(), A("div", {
    style: Fe({
      width: t.width + "px",
      height: t.height + "px",
      "background-color": t.color,
      flex: "0 0 " + t.width + "px",
      fontSize: t.fontSize + "px"
    }),
    class: "avatar"
  }, [
    g("span", null, [
      ue(t.$slots, "default", {}, void 0, !0)
    ]),
    t.showAccountType ? (v(), A("div", {
      key: 0,
      class: z(["account-type-icon", t.accountTypeSize])
    }, [
      t.platform === t.Platform.Platform.GoogleAds ? (v(), A("svg", BW, [...e[0] || (e[0] = [
        vt('<g clip-path="url(#a)" data-v-aa168dfc><path d="M3.71985 1.7732c.10566-.27734.25093-.53266.46663-.73957.86283-.840814 2.28914-.629509 2.87463.42702.44022.80119.90685 1.58478 1.36028 2.37718.75717 1.31625 1.52315 2.6325 2.27151 3.95316.6295 1.10495-.0528 2.50041-1.30303 2.68971-.76598.1145-1.48354-.2377-1.87974-.92444-.66473-1.15777-1.33386-2.31555-1.99859-3.46892-.0132-.02641-.03081-.04842-.04842-.07043-.07044-.05723-.10125-.14087-.14527-.21571-.29495-.51946-.5987-1.03451-.89365-1.54957-.18929-.33457-.38739-.66473-.57668-.9993-.17169-.29934-.25093-.62511-.24212-.96848.0132-.17608.03521-.35217.11445-.51065Z" fill="#3C8BD9" data-v-aa168dfc></path><path d="M3.71981 1.77319c-.03962.15848-.07483.31696-.08364.48424-.0132.36979.07924.71316.26413 1.03452.48424.83201.96848 1.66843 1.44832 2.50484.04402.07484.07924.14968.12326.22011-.26413.45783-.52826.91125-.79679 1.36908-.36979.63832-.73957 1.28104-1.11376 1.91935-.0176 0-.02201-.0088-.02641-.02201-.0044-.03522.00881-.06603.01761-.10125.18049-.66033.03082-1.24582-.42261-1.74767-.27734-.30375-.62951-.47543-1.03451-.53266-.52827-.07484-.9949.06163-1.413104.39179-.074837.05723-.123261.14087-.211305.1849-.017609 0-.026413-.00881-.030815-.02202.211304-.36538.418207-.73076.629514-1.09614.87163-1.51435 1.74326-3.0287 2.6193-4.53865.0088-.01761.02201-.03082.03081-.04843Z" fill="#FABC04" data-v-aa168dfc></path><path d="M.45773 7.46964c.083641-.07484.162881-.15408.250924-.22452C1.77839 6.3999 3.38518 7.01181 3.6185 8.35007c.05723.32136.02641.62952-.07044.93767-.0044.02641-.0088.04842-.0176.07484-.03962.07043-.07484.14527-.11886.2157-.3918.64712-.96848.96852-1.72566.92002C.818709 10.4367.13637 9.78518.0175113 8.92236c-.0572284-.41821.0264131-.81001.2421197-1.17098.044022-.07924.096849-.14968.145273-.22892.022011-.01761.013206-.05282.052826-.05282Z" fill="#34A852" data-v-aa168dfc></path><path d="M.4578 7.46963c-.017609.01761-.017609.04843-.048424.05283-.004403-.03081.013206-.04842.030815-.07043l.017609.0176Z" fill="#FABC04" data-v-aa168dfc></path><path d="M3.53049 9.36256c-.01761-.03082 0-.05283.01761-.07484.0044.0044.0132.01321.0176.01761l-.03521.05723Z" fill="#E1C025" data-v-aa168dfc></path></g><defs data-v-aa168dfc><clipPath id="a" data-v-aa168dfc><path fill="#fff" d="M0 0h11v11H0z" data-v-aa168dfc></path></clipPath></defs>', 2)
      ])])) : V("", !0),
      t.platform === t.Platform.Platform.MicrosoftAds ? (v(), A("svg", GW, [...e[1] || (e[1] = [
        g("path", {
          d: "M4 0H0v4h4V0Z",
          fill: "#F25022"
        }, null, -1),
        g("path", {
          d: "M9 0H5v4h4V0Z",
          fill: "#7FBA00"
        }, null, -1),
        g("path", {
          d: "M4 5H0v4h4V5Z",
          fill: "#00A4EF"
        }, null, -1),
        g("path", {
          d: "M9 5H5v4h4V5Z",
          fill: "#FFB900"
        }, null, -1)
      ])])) : V("", !0),
      t.platform === t.Platform.Platform.MetaAds ? (v(), A("svg", FW, [...e[2] || (e[2] = [
        vt('<defs data-v-aa168dfc><linearGradient id="linear-gradient" x1="62.34" y1="101.45" x2="260.34" y2="91.45" gradientTransform="matrix(1, 0, 0, -1, 0, 192)" gradientUnits="userSpaceOnUse" data-v-aa168dfc><stop offset="0" stop-color="#0064e1" data-v-aa168dfc></stop><stop offset="0.4" stop-color="#0064e1" data-v-aa168dfc></stop><stop offset="0.83" stop-color="#0073ee" data-v-aa168dfc></stop><stop offset="1" stop-color="#0082fb" data-v-aa168dfc></stop></linearGradient><linearGradient id="linear-gradient-2" x1="41.42" y1="53" x2="41.42" y2="126" gradientTransform="matrix(1, 0, 0, -1, 0, 192)" gradientUnits="userSpaceOnUse" data-v-aa168dfc><stop offset="0" stop-color="#0082fb" data-v-aa168dfc></stop><stop offset="1" stop-color="#0064e0" data-v-aa168dfc></stop></linearGradient></defs><path fill="#0081fb" d="M31.06,126c0,11,2.41,19.41,5.56,24.51A19,19,0,0,0,53.19,160c8.1,0,15.51-2,29.79-21.76,11.44-15.83,24.92-38,34-52l15.36-23.6c10.67-16.39,23-34.61,37.18-47C181.07,5.6,193.54,0,206.09,0c21.07,0,41.14,12.21,56.5,35.11,16.81,25.08,25,56.67,25,89.27,0,19.38-3.82,33.62-10.32,44.87C271,180.13,258.72,191,238.13,191V160c17.63,0,22-16.2,22-34.74,0-26.42-6.16-55.74-19.73-76.69-9.63-14.86-22.11-23.94-35.84-23.94-14.85,0-26.8,11.2-40.23,31.17-7.14,10.61-14.47,23.54-22.7,38.13l-9.06,16c-18.2,32.27-22.81,39.62-31.91,51.75C84.74,183,71.12,191,53.19,191c-21.27,0-34.72-9.21-43-23.09C3.34,156.6,0,141.76,0,124.85Z" data-v-aa168dfc></path><path fill="url(#linear-gradient)" d="M24.49,37.3C38.73,15.35,59.28,0,82.85,0c13.65,0,27.22,4,41.39,15.61,15.5,12.65,32,33.48,52.63,67.81l7.39,12.32c17.84,29.72,28,45,33.93,52.22,7.64,9.26,13,12,19.94,12,17.63,0,22-16.2,22-34.74l27.4-.86c0,19.38-3.82,33.62-10.32,44.87C271,180.13,258.72,191,238.13,191c-12.8,0-24.14-2.78-36.68-14.61-9.64-9.08-20.91-25.21-29.58-39.71L146.08,93.6c-12.94-21.62-24.81-37.74-31.68-45C107,40.71,97.51,31.23,82.35,31.23c-12.27,0-22.69,8.61-31.41,21.78Z" data-v-aa168dfc></path><path fill="url(#linear-gradient-2)" d="M82.35,31.23c-12.27,0-22.69,8.61-31.41,21.78C38.61,71.62,31.06,99.34,31.06,126c0,11,2.41,19.41,5.56,24.51L10.14,167.91C3.34,156.6,0,141.76,0,124.85,0,94.1,8.44,62.05,24.49,37.3,38.73,15.35,59.28,0,82.85,0Z" data-v-aa168dfc></path>', 4)
      ])])) : V("", !0),
      t.platform === 3 ? (v(), te(a, {
        key: 3,
        width: 11
      })) : V("", !0)
    ], 2)) : V("", !0)
  ], 4);
}
const zMe = /* @__PURE__ */ Y(kW, [["render", VW], ["__scopeId", "data-v-aa168dfc"]]), HW = {
  name: "BackButton",
  props: {
    fixed: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["clicked"],
  setup(t, { emit: e }) {
    function n() {
      e("clicked");
    }
    return Ir({ keys: ["esc"], onPressCallBack: n }), { clicked: n };
  }
};
function WW(t, e, n, r, o, i) {
  return v(), A("button", {
    class: z([{ fixed: n.fixed }, "back-button flex items-center justify-center shadow-m pointer z-999"]),
    onClick: e[0] || (e[0] = (...a) => r.clicked && r.clicked(...a))
  }, [...e[1] || (e[1] = [
    g("svg", {
      width: "16",
      height: "12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      g("path", {
        d: "m1 6 5-5M1 6l5 5M1 6h14",
        stroke: "rgba(0, 0, 0, 0.16)",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])], 2);
}
const ZMe = /* @__PURE__ */ Y(HW, [["render", WW], ["__scopeId", "data-v-ef747abc"]]), YW = {
  name: "MoreButton",
  props: {
    fixed: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["clicked"],
  setup(t, { emit: e }) {
    function n() {
      e("clicked");
    }
    return { clicked: n };
  }
};
function KW(t, e, n, r, o, i) {
  return v(), A("button", {
    class: z([{ fixed: n.fixed }, "more-button flex items-center justify-center shadow-m pointer z-999"]),
    onClick: e[0] || (e[0] = (...a) => r.clicked && r.clicked(...a))
  }, [...e[1] || (e[1] = [
    g("svg", {
      width: "4",
      height: "16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      g("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4 2c0 1.10457-.89539 2-2 2-1.104614 0-2-.89543-2-2C0 .895432.895386 0 2 0c1.10461 0 2 .895432 2 2Zm0 6c0 1.10457-.89539 2-2 2-1.104614 0-2-.89543-2-2s.895386-2 2-2c1.10461 0 2 .89543 2 2Zm-2 8c1.10461 0 2-.8954 2-2s-.89539-2-2-2c-1.104614 0-2 .8954-2 2s.895386 2 2 2Z",
        fill: "rgba(0, 0, 0, 0.16)"
      })
    ], -1)
  ])], 2);
}
const qMe = /* @__PURE__ */ Y(YW, [["render", KW], ["__scopeId", "data-v-857af8ac"]]), zW = {
  name: "DeleteButton",
  props: {
    fixed: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["clicked"],
  setup(t, { emit: e }) {
    function n() {
      e("clicked");
    }
    return { clicked: n };
  }
};
function ZW(t, e, n, r, o, i) {
  return v(), A("button", {
    class: z([{ fixed: n.fixed }, "delete-button flex items-center justify-center shadow-m pointer z-999"]),
    onClick: e[0] || (e[0] = (...a) => r.clicked && r.clicked(...a))
  }, [...e[1] || (e[1] = [
    g("svg", {
      width: "16",
      height: "19",
      viewBox: "0 0 16 19",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      g("g", null, [
        g("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M7 2C6.44772 2 6 2.44772 6 3H10C10 2.44771 9.55228 2 9 2H7ZM12 3C12 1.34315 10.6569 0 9 0H7C5.34315 0 4 1.34315 4 3H3H1C0.447715 3 0 3.44772 0 4C0 4.55228 0.447715 5 1 5V16C1 17.6569 2.34315 19 4 19H12C13.6569 19 15 17.6569 15 16V5C15.5523 5 16 4.55228 16 4C16 3.44772 15.5523 3 15 3H13H12ZM11 5H5H3V7V16C3 16.5523 3.44772 17 4 17H12C12.5523 17 13 16.5523 13 16V7V5H11ZM6 7C6.55228 7 7 7.44772 7 8V14C7 14.5523 6.55228 15 6 15C5.44772 15 5 14.5523 5 14V8C5 7.44772 5.44772 7 6 7ZM11 8C11 7.44772 10.5523 7 10 7C9.44771 7 9 7.44772 9 8V14C9 14.5523 9.44771 15 10 15C10.5523 15 11 14.5523 11 14V8Z",
          fill: "rgba(0, 0, 0, 0.16)"
        })
      ])
    ], -1)
  ])], 2);
}
const XMe = /* @__PURE__ */ Y(zW, [["render", ZW], ["__scopeId", "data-v-600b4f84"]]), qW = {
  name: "CloseButton",
  props: {
    fixed: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["clicked"],
  setup(t, { emit: e }) {
    const n = W();
    function r() {
      e("clicked");
    }
    return Ir({ keys: ["esc"], onPressCallBack: r }), Ir({ keys: ["enter"], onPressCallBack: r, eventTarget: n }), { closeButtonRef: n, clicked: r };
  }
};
const XW = ["content"];
function jW(t, e, n, r, o, i) {
  const a = ft("tippy");
  return Ze((v(), A("button", {
    ref: "closeButtonRef",
    class: z([{ fixed: n.fixed }, "close-button"]),
    content: n.tooltip ? "<span class='f6 fw5 lh-copy'>Close</span><br><span class='f7 fw4 o-50 lh-copy mb1'>(Esc)</span>" : "",
    onClick: e[0] || (e[0] = (...s) => r.clicked && r.clicked(...s))
  }, [...e[1] || (e[1] = [
    g("svg", {
      width: "14",
      height: "14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      g("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.2929.292893c.3905-.3905241 1.0237-.3905241 1.4142 0 .3905.390525.3905 1.023687 0 1.414217L8.41421 7l5.29289 5.2929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L7 8.41421 1.70711 13.7071c-.39053.3905-1.023692.3905-1.414216 0-.3905252-.3905-.3905252-1.0237 0-1.4142L5.58579 7 .292894 1.70711c-.3905244-.39053-.3905244-1.023692 0-1.414217.390524-.3905241 1.023686-.3905241 1.414216 0L7 5.58579 12.2929.292893Z",
        fill: "rgba(0, 0, 0, 0.16)"
      })
    ], -1)
  ])], 10, XW)), [
    [a, {
      animateFill: !1,
      animation: "shift-away",
      duration: "250",
      theme: "close",
      placement: "bottom",
      trigger: "mouseenter",
      zIndex: 9999999999
    }]
  ]);
}
const qE = /* @__PURE__ */ Y(qW, [["render", jW], ["__scopeId", "data-v-f8557cc7"]]), JW = {
  name: "ColorTag",
  props: {
    title: {
      type: String,
      required: !0,
      default: "Default Title"
    },
    content: {
      type: [String, Number],
      required: !1
    },
    color: {
      type: String,
      required: !1,
      default: "blue"
    },
    size: {
      type: String,
      required: !1,
      default: "medium"
    }
  }
};
const QW = {
  key: 0,
  class: "o-color-tag-content"
}, eY = {
  key: 1,
  class: "o-color-tag-content"
};
function tY(t, e, n, r, o, i) {
  return v(), A("div", {
    class: z([n.color, n.size, "o-color-tag"])
  }, [
    me(Q(n.title) + " ", 1),
    n.content ? (v(), A("b", QW, Q(n.content), 1)) : V("", !0),
    t.$slots.default ? (v(), A("div", eY, [
      g("b", null, [
        ue(t.$slots, "default")
      ])
    ])) : V("", !0)
  ], 2);
}
const XE = /* @__PURE__ */ Y(JW, [["render", tY]]);
function nY({ presetDate: t, dates: e }, n) {
  const r = W(!1);
  function o() {
    r.value = !r.value;
  }
  const i = W(), a = W(t ?? /* @__PURE__ */ new Date()), s = [{ dot: !0, dates: e ?? [] }];
  ct(async () => {
    var c;
    await ((c = i.value) == null ? void 0 : c.move(a.value));
  }), et(a, () => {
    l();
  });
  function l() {
    r.value = !1, n("change", a.value);
  }
  return {
    popoutOpen: r,
    togglePopoutOpen: o,
    selectedDate: a,
    datePickerElement: i,
    datePickerAttributes: s
  };
}
/*!
* tabbable 6.4.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var Y5 = ["input:not([inert]):not([inert] *)", "select:not([inert]):not([inert] *)", "textarea:not([inert]):not([inert] *)", "a[href]:not([inert]):not([inert] *)", "button:not([inert]):not([inert] *)", "[tabindex]:not(slot):not([inert]):not([inert] *)", "audio[controls]:not([inert]):not([inert] *)", "video[controls]:not([inert]):not([inert] *)", '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', "details>summary:first-of-type:not([inert]):not([inert] *)", "details:not([inert]):not([inert] *)"], wd = /* @__PURE__ */ Y5.join(","), K5 = typeof Element > "u", wa = K5 ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Td = !K5 && Element.prototype.getRootNode ? function(t) {
  var e;
  return t == null || (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t);
} : function(t) {
  return t == null ? void 0 : t.ownerDocument;
}, bd = function(e, n) {
  var r;
  n === void 0 && (n = !0);
  var o = e == null || (r = e.getAttribute) === null || r === void 0 ? void 0 : r.call(e, "inert"), i = o === "" || o === "true", a = i || n && e && // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  (typeof e.closest == "function" ? e.closest("[inert]") : bd(e.parentNode));
  return a;
}, rY = function(e) {
  var n, r = e == null || (n = e.getAttribute) === null || n === void 0 ? void 0 : n.call(e, "contenteditable");
  return r === "" || r === "true";
}, z5 = function(e, n, r) {
  if (bd(e))
    return [];
  var o = Array.prototype.slice.apply(e.querySelectorAll(wd));
  return n && wa.call(e, wd) && o.unshift(e), o = o.filter(r), o;
}, Rd = function(e, n, r) {
  for (var o = [], i = Array.from(e); i.length; ) {
    var a = i.shift();
    if (!bd(a, !1))
      if (a.tagName === "SLOT") {
        var s = a.assignedElements(), l = s.length ? s : a.children, c = Rd(l, !0, r);
        r.flatten ? o.push.apply(o, c) : o.push({
          scopeParent: a,
          candidates: c
        });
      } else {
        var u = wa.call(a, wd);
        u && r.filter(a) && (n || !e.includes(a)) && o.push(a);
        var d = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), f = !bd(d, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (d && f) {
          var h = Rd(d === !0 ? a.children : d.children, !0, r);
          r.flatten ? o.push.apply(o, h) : o.push({
            scopeParent: a,
            candidates: h
          });
        } else
          i.unshift.apply(i, a.children);
      }
  }
  return o;
}, Z5 = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, oa = function(e) {
  if (!e)
    throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || rY(e)) && !Z5(e) ? 0 : e.tabIndex;
}, oY = function(e, n) {
  var r = oa(e);
  return r < 0 && n && !Z5(e) ? 0 : r;
}, iY = function(e, n) {
  return e.tabIndex === n.tabIndex ? e.documentOrder - n.documentOrder : e.tabIndex - n.tabIndex;
}, q5 = function(e) {
  return e.tagName === "INPUT";
}, aY = function(e) {
  return q5(e) && e.type === "hidden";
}, sY = function(e) {
  var n = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, lY = function(e, n) {
  for (var r = 0; r < e.length; r++)
    if (e[r].checked && e[r].form === n)
      return e[r];
}, cY = function(e) {
  if (!e.name)
    return !0;
  var n = e.form || Td(e), r = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = r(window.CSS.escape(e.name));
  else
    try {
      o = r(e.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var i = lY(o, e.form);
  return !i || i === e;
}, uY = function(e) {
  return q5(e) && e.type === "radio";
}, dY = function(e) {
  return uY(e) && !cY(e);
}, fY = function(e) {
  var n, r = e && Td(e), o = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== e) {
    var a, s, l;
    for (i = !!((a = o) !== null && a !== void 0 && (s = a.ownerDocument) !== null && s !== void 0 && s.contains(o) || e != null && (l = e.ownerDocument) !== null && l !== void 0 && l.contains(e)); !i && o; ) {
      var c, u, d;
      r = Td(o), o = (c = r) === null || c === void 0 ? void 0 : c.host, i = !!((u = o) !== null && u !== void 0 && (d = u.ownerDocument) !== null && d !== void 0 && d.contains(o));
    }
  }
  return i;
}, CN = function(e) {
  var n = e.getBoundingClientRect(), r = n.width, o = n.height;
  return r === 0 && o === 0;
}, hY = function(e, n) {
  var r = n.displayCheck, o = n.getShadowRoot;
  if (r === "full-native" && "checkVisibility" in e) {
    var i = e.checkVisibility({
      // Checking opacity might be desirable for some use cases, but natively,
      // opacity zero elements _are_ focusable and tabbable.
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      // This is an alias for `visibilityProperty`. Contemporary browsers
      // support both. However, this alias has wider browser support (Chrome
      // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
      // we include it anyway.
      checkVisibilityCSS: !0
    });
    return !i;
  }
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var a = wa.call(e, "details>summary:first-of-type"), s = a ? e.parentElement : e;
  if (wa.call(s, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  r === "full-native" || r === "legacy-full") {
    if (typeof o == "function") {
      for (var l = e; e; ) {
        var c = e.parentElement, u = Td(e);
        if (c && !c.shadowRoot && o(c) === !0)
          return CN(e);
        e.assignedSlot ? e = e.assignedSlot : !c && u !== e.ownerDocument ? e = u.host : e = c;
      }
      e = l;
    }
    if (fY(e))
      return !e.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return CN(e);
  return !1;
}, _Y = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var n = e.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var o = n.children.item(r);
          if (o.tagName === "LEGEND")
            return wa.call(n, "fieldset[disabled] *") ? !0 : !o.contains(e);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Md = function(e, n) {
  return !(n.disabled || aY(n) || hY(n, e) || // For a details element with a summary, the summary element gets the focus
  sY(n) || _Y(n));
}, f0 = function(e, n) {
  return !(dY(n) || oa(n) < 0 || !Md(e, n));
}, EY = function(e) {
  var n = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, X5 = function(e) {
  var n = [], r = [];
  return e.forEach(function(o, i) {
    var a = !!o.scopeParent, s = a ? o.scopeParent : o, l = oY(s, a), c = a ? X5(o.candidates) : s;
    l === 0 ? a ? n.push.apply(n, c) : n.push(s) : r.push({
      documentOrder: i,
      tabIndex: l,
      item: o,
      isScope: a,
      content: c
    });
  }), r.sort(iY).reduce(function(o, i) {
    return i.isScope ? o.push.apply(o, i.content) : o.push(i.content), o;
  }, []).concat(n);
}, pY = function(e, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Rd([e], n.includeContainer, {
    filter: f0.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: EY
  }) : r = z5(e, n.includeContainer, f0.bind(null, n)), X5(r);
}, mY = function(e, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Rd([e], n.includeContainer, {
    filter: Md.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = z5(e, n.includeContainer, Md.bind(null, n)), r;
}, ns = function(e, n) {
  if (n = n || {}, !e)
    throw new Error("No node provided");
  return wa.call(e, wd) === !1 ? !1 : f0(n, e);
}, NY = /* @__PURE__ */ Y5.concat("iframe:not([inert]):not([inert] *)").join(","), y1 = function(e, n) {
  if (n = n || {}, !e)
    throw new Error("No node provided");
  return wa.call(e, NY) === !1 ? !1 : Md(n, e);
};
/*!
* focus-trap 7.8.0
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function h0(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function vY(t) {
  if (Array.isArray(t))
    return h0(t);
}
function SN(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!n) {
    if (Array.isArray(t) || (n = j5(t)) || e) {
      n && (t = n);
      var r = 0, o = function() {
      };
      return {
        s: o,
        n: function() {
          return r >= t.length ? {
            done: !0
          } : {
            done: !1,
            value: t[r++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: o
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, a = !0, s = !1;
  return {
    s: function() {
      n = n.call(t);
    },
    n: function() {
      var l = n.next();
      return a = l.done, l;
    },
    e: function(l) {
      s = !0, i = l;
    },
    f: function() {
      try {
        a || n.return == null || n.return();
      } finally {
        if (s)
          throw i;
      }
    }
  };
}
function gY(t, e, n) {
  return (e = CY(e)) in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function IY(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function OY() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wN(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function TN(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? wN(Object(n), !0).forEach(function(r) {
      gY(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : wN(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function AY(t) {
  return vY(t) || IY(t) || j5(t) || OY();
}
function DY(t, e) {
  if (typeof t != "object" || !t)
    return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function CY(t) {
  var e = DY(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function j5(t, e) {
  if (t) {
    if (typeof t == "string")
      return h0(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? h0(t, e) : void 0;
  }
}
var Lo = {
  // Returns the trap from the top of the stack.
  getActiveTrap: function(e) {
    return (e == null ? void 0 : e.length) > 0 ? e[e.length - 1] : null;
  },
  // Pauses the currently active trap, then adds a new trap to the stack.
  activateTrap: function(e, n) {
    var r = Lo.getActiveTrap(e);
    n !== r && Lo.pauseTrap(e);
    var o = e.indexOf(n);
    o === -1 || e.splice(o, 1), e.push(n);
  },
  // Removes the trap from the top of the stack, then unpauses the next trap down.
  deactivateTrap: function(e, n) {
    var r = e.indexOf(n);
    r !== -1 && e.splice(r, 1), Lo.unpauseTrap(e);
  },
  // Pauses the trap at the top of the stack.
  pauseTrap: function(e) {
    var n = Lo.getActiveTrap(e);
    n == null || n._setPausedState(!0);
  },
  // Unpauses the trap at the top of the stack.
  unpauseTrap: function(e) {
    var n = Lo.getActiveTrap(e);
    n && !n._isManuallyPaused() && n._setPausedState(!1);
  }
}, SY = function(e) {
  return e.tagName && e.tagName.toLowerCase() === "input" && typeof e.select == "function";
}, wY = function(e) {
  return (e == null ? void 0 : e.key) === "Escape" || (e == null ? void 0 : e.key) === "Esc" || (e == null ? void 0 : e.keyCode) === 27;
}, Yl = function(e) {
  return (e == null ? void 0 : e.key) === "Tab" || (e == null ? void 0 : e.keyCode) === 9;
}, TY = function(e) {
  return Yl(e) && !e.shiftKey;
}, bY = function(e) {
  return Yl(e) && e.shiftKey;
}, bN = function(e) {
  return setTimeout(e, 0);
}, Al = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  return typeof e == "function" ? e.apply(void 0, r) : e;
}, Ru = function(e) {
  return e.target.shadowRoot && typeof e.composedPath == "function" ? e.composedPath()[0] : e.target;
}, RY = [], J5 = function(e, n) {
  var r = (n == null ? void 0 : n.document) || document, o = (n == null ? void 0 : n.trapStack) || RY, i = TN({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isolateSubtrees: !1,
    isKeyForward: TY,
    isKeyBackward: bY
  }, n), a = {
    // containers given to createFocusTrap()
    /** @type {Array<HTMLElement>} */
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    /** @type {Array<{
     *    container: HTMLElement,
     *    tabbableNodes: Array<HTMLElement>, // empty if none
     *    focusableNodes: Array<HTMLElement>, // empty if none
     *    posTabIndexesFound: boolean,
     *    firstTabbableNode: HTMLElement|undefined,
     *    lastTabbableNode: HTMLElement|undefined,
     *    firstDomTabbableNode: HTMLElement|undefined,
     *    lastDomTabbableNode: HTMLElement|undefined,
     *    nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
     *  }>}
     */
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    // references to nodes that are siblings to the ancestors of this trap's containers.
    /** @type {Set<HTMLElement>} */
    adjacentElements: /* @__PURE__ */ new Set(),
    // references to nodes that were inert or aria-hidden before the trap was activated.
    /** @type {Set<HTMLElement>} */
    alreadySilent: /* @__PURE__ */ new Set(),
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, s, l = function(L, w, R) {
    return L && L[w] !== void 0 ? L[w] : i[R || w];
  }, c = function(L, w) {
    var R = typeof (w == null ? void 0 : w.composedPath) == "function" ? w.composedPath() : void 0;
    return a.containerGroups.findIndex(function(B) {
      var U = B.container, K = B.tabbableNodes;
      return U.contains(L) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (R == null ? void 0 : R.includes(U)) || K.find(function(Z) {
        return Z === L;
      });
    });
  }, u = function(L) {
    var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, R = w.hasFallback, B = R === void 0 ? !1 : R, U = w.params, K = U === void 0 ? [] : U, Z = i[L];
    if (typeof Z == "function" && (Z = Z.apply(void 0, AY(K))), Z === !0 && (Z = void 0), !Z) {
      if (Z === void 0 || Z === !1)
        return Z;
      throw new Error("`".concat(L, "` was specified but was not a node, or did not return a node"));
    }
    var X = Z;
    if (typeof Z == "string") {
      try {
        X = r.querySelector(Z);
      } catch (J) {
        throw new Error("`".concat(L, '` appears to be an invalid selector; error="').concat(J.message, '"'));
      }
      if (!X && !B)
        throw new Error("`".concat(L, "` as selector refers to no known node"));
    }
    return X;
  }, d = function() {
    var L = u("initialFocus", {
      hasFallback: !0
    });
    if (L === !1)
      return !1;
    if (L === void 0 || L && !y1(L, i.tabbableOptions))
      if (c(r.activeElement) >= 0)
        L = r.activeElement;
      else {
        var w = a.tabbableGroups[0], R = w && w.firstTabbableNode;
        L = R || u("fallbackFocus");
      }
    else
      L === null && (L = u("fallbackFocus"));
    if (!L)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return L;
  }, f = function() {
    if (a.containerGroups = a.containers.map(function(L) {
      var w = pY(L, i.tabbableOptions), R = mY(L, i.tabbableOptions), B = w.length > 0 ? w[0] : void 0, U = w.length > 0 ? w[w.length - 1] : void 0, K = R.find(function(J) {
        return ns(J);
      }), Z = R.slice().reverse().find(function(J) {
        return ns(J);
      }), X = !!w.find(function(J) {
        return oa(J) > 0;
      });
      return {
        container: L,
        tabbableNodes: w,
        focusableNodes: R,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: X,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: B,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: U,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: K,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: Z,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(ae) {
          var re = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, j = w.indexOf(ae);
          return j < 0 ? re ? R.slice(R.indexOf(ae) + 1).find(function(ne) {
            return ns(ne);
          }) : R.slice(0, R.indexOf(ae)).reverse().find(function(ne) {
            return ns(ne);
          }) : w[j + (re ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(L) {
      return L.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !u("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(L) {
      return L.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, h = function(L) {
    var w = L.activeElement;
    if (w)
      return w.shadowRoot && w.shadowRoot.activeElement !== null ? h(w.shadowRoot) : w;
  }, _ = function(L) {
    if (L !== !1 && L !== h(document)) {
      if (!L || !L.focus) {
        _(d());
        return;
      }
      L.focus({
        preventScroll: !!i.preventScroll
      }), a.mostRecentlyFocusedNode = L, SY(L) && L.select();
    }
  }, E = function(L) {
    var w = u("setReturnFocus", {
      params: [L]
    });
    return w || (w === !1 ? !1 : L);
  }, m = function(L) {
    var w = L.target, R = L.event, B = L.isBackward, U = B === void 0 ? !1 : B;
    w = w || Ru(R), f();
    var K = null;
    if (a.tabbableGroups.length > 0) {
      var Z = c(w, R), X = Z >= 0 ? a.containerGroups[Z] : void 0;
      if (Z < 0)
        U ? K = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : K = a.tabbableGroups[0].firstTabbableNode;
      else if (U) {
        var J = a.tabbableGroups.findIndex(function(fe) {
          var Oe = fe.firstTabbableNode;
          return w === Oe;
        });
        if (J < 0 && (X.container === w || y1(w, i.tabbableOptions) && !ns(w, i.tabbableOptions) && !X.nextTabbableNode(w, !1)) && (J = Z), J >= 0) {
          var ae = J === 0 ? a.tabbableGroups.length - 1 : J - 1, re = a.tabbableGroups[ae];
          K = oa(w) >= 0 ? re.lastTabbableNode : re.lastDomTabbableNode;
        } else
          Yl(R) || (K = X.nextTabbableNode(w, !1));
      } else {
        var j = a.tabbableGroups.findIndex(function(fe) {
          var Oe = fe.lastTabbableNode;
          return w === Oe;
        });
        if (j < 0 && (X.container === w || y1(w, i.tabbableOptions) && !ns(w, i.tabbableOptions) && !X.nextTabbableNode(w)) && (j = Z), j >= 0) {
          var ne = j === a.tabbableGroups.length - 1 ? 0 : j + 1, Ee = a.tabbableGroups[ne];
          K = oa(w) >= 0 ? Ee.firstTabbableNode : Ee.firstDomTabbableNode;
        } else
          Yl(R) || (K = X.nextTabbableNode(w));
      }
    } else
      K = u("fallbackFocus");
    return K;
  }, N = function(L) {
    var w = Ru(L);
    if (!(c(w, L) >= 0)) {
      if (Al(i.clickOutsideDeactivates, L)) {
        s.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: i.returnFocusOnDeactivate
        });
        return;
      }
      Al(i.allowOutsideClick, L) || L.preventDefault();
    }
  }, I = function(L) {
    var w = Ru(L), R = c(w, L) >= 0;
    if (R || w instanceof Document)
      R && (a.mostRecentlyFocusedNode = w);
    else {
      L.stopImmediatePropagation();
      var B, U = !0;
      if (a.mostRecentlyFocusedNode)
        if (oa(a.mostRecentlyFocusedNode) > 0) {
          var K = c(a.mostRecentlyFocusedNode), Z = a.containerGroups[K].tabbableNodes;
          if (Z.length > 0) {
            var X = Z.findIndex(function(J) {
              return J === a.mostRecentlyFocusedNode;
            });
            X >= 0 && (i.isKeyForward(a.recentNavEvent) ? X + 1 < Z.length && (B = Z[X + 1], U = !1) : X - 1 >= 0 && (B = Z[X - 1], U = !1));
          }
        } else
          a.containerGroups.some(function(J) {
            return J.tabbableNodes.some(function(ae) {
              return oa(ae) > 0;
            });
          }) || (U = !1);
      else
        U = !1;
      U && (B = m({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: i.isKeyBackward(a.recentNavEvent)
      })), _(B || a.mostRecentlyFocusedNode || d());
    }
    a.recentNavEvent = void 0;
  }, O = function(L) {
    var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = L;
    var R = m({
      event: L,
      isBackward: w
    });
    R && (Yl(L) && L.preventDefault(), _(R));
  }, p = function(L) {
    (i.isKeyForward(L) || i.isKeyBackward(L)) && O(L, i.isKeyBackward(L));
  }, C = function(L) {
    wY(L) && Al(i.escapeDeactivates, L) !== !1 && (L.preventDefault(), s.deactivate());
  }, D = function(L) {
    var w = Ru(L);
    c(w, L) >= 0 || Al(i.clickOutsideDeactivates, L) || Al(i.allowOutsideClick, L) || (L.preventDefault(), L.stopImmediatePropagation());
  }, T = function() {
    if (a.active)
      return Lo.activateTrap(o, s), a.delayInitialFocusTimer = i.delayInitialFocus ? bN(function() {
        _(d());
      }) : _(d()), r.addEventListener("focusin", I, !0), r.addEventListener("mousedown", N, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", N, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", D, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", p, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", C), s;
  }, k = function(L) {
    a.active && !a.paused && s._setSubtreeIsolation(!1), a.adjacentElements.clear(), a.alreadySilent.clear();
    var w = /* @__PURE__ */ new Set(), R = /* @__PURE__ */ new Set(), B = SN(L), U;
    try {
      for (B.s(); !(U = B.n()).done; ) {
        var K = U.value;
        w.add(K);
        for (var Z = typeof ShadowRoot < "u" && K.getRootNode() instanceof ShadowRoot, X = K; X; ) {
          w.add(X);
          var J = X.parentElement, ae = [];
          J ? ae = J.children : !J && Z && (ae = X.getRootNode().children, J = X.getRootNode().host, Z = typeof ShadowRoot < "u" && J.getRootNode() instanceof ShadowRoot);
          var re = SN(ae), j;
          try {
            for (re.s(); !(j = re.n()).done; ) {
              var ne = j.value;
              R.add(ne);
            }
          } catch (Ee) {
            re.e(Ee);
          } finally {
            re.f();
          }
          X = J;
        }
      }
    } catch (Ee) {
      B.e(Ee);
    } finally {
      B.f();
    }
    w.forEach(function(Ee) {
      R.delete(Ee);
    }), a.adjacentElements = R;
  }, G = function() {
    if (a.active)
      return r.removeEventListener("focusin", I, !0), r.removeEventListener("mousedown", N, !0), r.removeEventListener("touchstart", N, !0), r.removeEventListener("click", D, !0), r.removeEventListener("keydown", p, !0), r.removeEventListener("keydown", C), s;
  }, b = function(L) {
    var w = L.some(function(R) {
      var B = Array.from(R.removedNodes);
      return B.some(function(U) {
        return U === a.mostRecentlyFocusedNode;
      });
    });
    w && _(d());
  }, P = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(b) : void 0, $ = function() {
    P && (P.disconnect(), a.active && !a.paused && a.containers.map(function(L) {
      P.observe(L, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return s = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(L) {
      if (a.active)
        return this;
      var w = l(L, "onActivate"), R = l(L, "onPostActivate"), B = l(L, "checkCanFocusTrap"), U = Lo.getActiveTrap(o), K = !1;
      if (U && !U.paused) {
        var Z;
        (Z = U._setSubtreeIsolation) === null || Z === void 0 || Z.call(U, !1), K = !0;
      }
      try {
        B || f(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = h(r), w == null || w();
        var X = function() {
          B && f(), T(), $(), i.isolateSubtrees && s._setSubtreeIsolation(!0), R == null || R();
        };
        if (B)
          return B(a.containers.concat()).then(X, X), this;
        X();
      } catch (ae) {
        if (U === Lo.getActiveTrap(o) && K) {
          var J;
          (J = U._setSubtreeIsolation) === null || J === void 0 || J.call(U, !0);
        }
        throw ae;
      }
      return this;
    },
    deactivate: function(L) {
      if (!a.active)
        return this;
      var w = TN({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, L);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, a.paused || s._setSubtreeIsolation(!1), a.alreadySilent.clear(), G(), a.active = !1, a.paused = !1, $(), Lo.deactivateTrap(o, s);
      var R = l(w, "onDeactivate"), B = l(w, "onPostDeactivate"), U = l(w, "checkCanReturnFocus"), K = l(w, "returnFocus", "returnFocusOnDeactivate");
      R == null || R();
      var Z = function() {
        bN(function() {
          K && _(E(a.nodeFocusedBeforeActivation)), B == null || B();
        });
      };
      return K && U ? (U(E(a.nodeFocusedBeforeActivation)).then(Z, Z), this) : (Z(), this);
    },
    pause: function(L) {
      return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, L)) : this;
    },
    unpause: function(L) {
      return a.active ? (a.manuallyPaused = !1, o[o.length - 1] !== this ? this : this._setPausedState(!1, L)) : this;
    },
    updateContainerElements: function(L) {
      var w = [].concat(L).filter(Boolean);
      return a.containers = w.map(function(R) {
        return typeof R == "string" ? r.querySelector(R) : R;
      }), i.isolateSubtrees && k(a.containers), a.active && (f(), i.isolateSubtrees && !a.paused && s._setSubtreeIsolation(!0)), $(), this;
    }
  }, Object.defineProperties(s, {
    _isManuallyPaused: {
      value: function() {
        return a.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(L, w) {
        if (a.paused === L)
          return this;
        if (a.paused = L, L) {
          var R = l(w, "onPause"), B = l(w, "onPostPause");
          R == null || R(), G(), $(), s._setSubtreeIsolation(!1), B == null || B();
        } else {
          var U = l(w, "onUnpause"), K = l(w, "onPostUnpause");
          U == null || U(), s._setSubtreeIsolation(!0), f(), T(), $(), K == null || K();
        }
        return this;
      }
    },
    _setSubtreeIsolation: {
      value: function(L) {
        i.isolateSubtrees && a.adjacentElements.forEach(function(w) {
          var R;
          if (L)
            switch (i.isolateSubtrees) {
              case "aria-hidden":
                (w.ariaHidden === "true" || ((R = w.getAttribute("aria-hidden")) === null || R === void 0 ? void 0 : R.toLowerCase()) === "true") && a.alreadySilent.add(w), w.setAttribute("aria-hidden", "true");
                break;
              default:
                (w.inert || w.hasAttribute("inert")) && a.alreadySilent.add(w), w.setAttribute("inert", !0);
                break;
            }
          else if (!a.alreadySilent.has(w))
            switch (i.isolateSubtrees) {
              case "aria-hidden":
                w.removeAttribute("aria-hidden");
                break;
              default:
                w.removeAttribute("inert");
                break;
            }
        });
      }
    }
  }), s.updateContainerElements(e), s;
};
function jE(t, e = {}) {
  let n;
  const { immediate: r, ...o } = e, i = W(!1), a = W(!1), s = (d) => n && n.activate(d), l = (d) => n && n.deactivate(d), c = () => {
    n && (n.pause(), a.value = !0);
  }, u = () => {
    n && (n.unpause(), a.value = !1);
  };
  return et(
    () => vn(t),
    (d) => {
      d && (n = J5(d, {
        ...o,
        onActivate() {
          i.value = !0, e.onActivate && e.onActivate();
        },
        onDeactivate() {
          i.value = !1, e.onDeactivate && e.onDeactivate();
        }
      }), r && s());
    },
    { flush: "post" }
  ), Ha(() => l()), {
    hasFocus: i,
    isPaused: a,
    activate: s,
    deactivate: l,
    pause: c,
    unpause: u
  };
}
const MY = Ne({
  name: "ViewBackground",
  props: {
    active: {
      type: Boolean,
      default: !1
    },
    zIndex: {
      type: Number,
      default: 4e3,
      required: !1
    },
    transparent: {
      type: Boolean,
      default: !1,
      required: !1
    }
  }
});
function PY(t, e, n, r, o, i) {
  return v(), te(Zt, { name: "fade" }, {
    default: q(() => [
      t.active ? (v(), A("div", {
        key: 0,
        class: z(["view-background", { active: t.active }, { opaque: !t.transparent }]),
        style: Fe({ zIndex: t.zIndex })
      }, null, 6)) : V("", !0)
    ]),
    _: 1
  });
}
const ru = /* @__PURE__ */ Y(MY, [["render", PY], ["__scopeId", "data-v-79a994bc"]]), yY = Ne({
  components: {
    ViewBackground: ru
  },
  props: {
    modelValue: {
      default: !1,
      type: Boolean
    },
    wrapperClasses: {
      default: "",
      type: String
    },
    containerClasses: {
      default: "",
      type: String
    },
    interactive: {
      type: Boolean,
      default: !0
    },
    delay: {
      type: [Number, Array],
      default: [0, 0]
    },
    offset: {
      default: [0, 12],
      type: Array
    },
    borderRadius: {
      type: Number,
      default: 16
    },
    placement: {
      type: String,
      default: "bottom-start"
    },
    trigger: {
      default: "click",
      type: String
    },
    // if Popout contains interactive elements like buttons
    // this should be set to true to so focus remains within
    // the popout when navigating with the keyboard
    trapFocus: {
      type: Boolean,
      default: !1
    },
    initialFocus: {
      type: [Boolean, String, Function],
      required: !1,
      default: !1
    },
    disabled: {
      default: !1,
      type: Boolean
    },
    maxWidth: {
      default: "20rem",
      // a number for px
      type: [String, Number],
      required: !1
    },
    // ref="tippyClicker" handles the click event to toggle Popout visibility,
    // the element nested in slot is not required to have any toggle logic,
    // this means that the enter event on oButton will be ineffectual
    // setting externalToggleButton will mean toggle logic can be handle directly
    // on oButton allowing enter and click events to both work
    externalToggleButton: {
      type: Boolean,
      default: !1,
      required: !1
    },
    /*
        remoteControl=true means that the popout will never modify its own opened state.
        It will only be opened or closed via its parent modifying its :modelValue.
    */
    remoteControl: {
      type: Boolean,
      default: !1,
      required: !1
    },
    dark: {
      default: !1,
      required: !1,
      type: Boolean
    },
    zIndex: {
      default: 10001,
      required: !1,
      type: Number
    },
    viewBackgroundZIndex: {
      default: 4e3,
      required: !1,
      type: Number
    },
    popperOptions: {
      type: [Object],
      required: !1
    },
    onClickOutside: {
      type: Function,
      required: !1
    },
    appendTo: {
      type: HTMLElement,
      default: document.body,
      required: !1
    }
  },
  setup(t, { emit: e }) {
    const n = W(), r = W(), o = Ga(t, "modelValue"), i = W(), a = W(), { hasFocus: s, activate: l, deactivate: c } = jE(i, {
      initialFocus: t.initialFocus,
      fallbackFocus: () => i.value,
      setReturnFocus: (E) => a.value ? a.value : E,
      onPostDeactivate: () => {
        a.value && (a.value = void 0);
      }
    }), u = x(() => t.externalToggleButton || t.remoteControl), d = Oa({
      content: () => r.value,
      placement: t.placement,
      offset: t.offset,
      interactive: t.interactive,
      delay: t.delay,
      touch: !0,
      trigger: u.value || t.disabled ? "manual" : t.trigger,
      animation: "shift-away",
      popperOptions: t.popperOptions,
      onShow: () => e("update:modelValue", !0),
      onShown: () => {
        t.trapFocus && l(), e("shown");
      },
      onHide: () => {
        s && c(), e("update:modelValue", !1);
      },
      appendTo: () => t.appendTo,
      maxWidth: t.maxWidth,
      zIndex: t.zIndex,
      hideOnClick: !u.value,
      onClickOutside: (E, m) => {
        const N = m.target;
        N.closest("[data-tippy-root]") || (N.closest(".popout-wrapper") && !n.value.contains(N) && (a.value = N), t.onClickOutside && t.onClickOutside(), !t.remoteControl && t.externalToggleButton && t.modelValue && f());
      }
    }), { hide: f, show: h, setProps: _ } = Ui(n, d);
    return Ir({
      keys: ["esc"],
      onPressCallBack: () => {
        !t.remoteControl && t.modelValue && f();
      }
    }), Ti("hidePopout", f), et(t, (E) => {
      _({
        trigger: u.value || t.disabled ? "manual" : t.trigger,
        maxWidth: E.maxWidth
      }), !E.disabled && E.modelValue ? h() : f();
    }), ct(async () => {
      t.remoteControl && (await Or(200), t.modelValue ? h() : f());
    }), {
      tippyClicker: n,
      tippyContent: r,
      focusTrapRef: i,
      returnFocusOnDeactivate: a,
      popoutOpen: o
    };
  }
});
const LY = {
  ref: "focusTrapRef",
  class: "trap",
  tabindex: "-1"
};
function xY(t, e, n, r, o, i) {
  const a = ee("ViewBackground");
  return v(), A(ge, null, [
    t.disabled ? V("", !0) : (v(), te(_f, {
      key: 0,
      to: t.appendTo
    }, [
      H(a, {
        active: t.popoutOpen && t.trigger === "click" && !t.remoteControl,
        transparent: !0,
        zIndex: t.viewBackgroundZIndex
      }, null, 8, ["active", "zIndex"])
    ], 8, ["to"])),
    g("div", {
      ref: "tippyClicker",
      class: z(["popout-wrapper", t.wrapperClasses])
    }, [
      ue(t.$slots, "default", {}, void 0, !0),
      g("div", {
        ref: "tippyContent",
        class: z(["popout", { dark: t.dark }, t.containerClasses]),
        style: Fe({ borderRadius: t.borderRadius + "px" })
      }, [
        g("div", LY, [
          ue(t.$slots, "content", {}, void 0, !0)
        ], 512)
      ], 6)
    ], 2)
  ], 64);
}
const JE = /* @__PURE__ */ Y(yY, [["render", xY], ["__scopeId", "data-v-7b5eabd1"]]);
function gc(t) {
  var e = t.getBoundingClientRect();
  return {
    width: e.width,
    height: e.height,
    top: e.top,
    right: e.right,
    bottom: e.bottom,
    left: e.left,
    x: e.left,
    y: e.top
  };
}
function br(t) {
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e ? e.defaultView : window;
  }
  return t;
}
function QE(t) {
  var e = br(t), n = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function Ic(t) {
  var e = br(t).Element;
  return t instanceof e || t instanceof Element;
}
function Kr(t) {
  var e = br(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function UY(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function $Y(t) {
  return t === br(t) || !Kr(t) ? QE(t) : UY(t);
}
function qo(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function Fi(t) {
  return (Ic(t) ? t.ownerDocument : t.document).documentElement;
}
function Q5(t) {
  return gc(Fi(t)).left + QE(t).scrollLeft;
}
function Wa(t) {
  return br(t).getComputedStyle(t);
}
function ep(t) {
  var e = Wa(t), n = e.overflow, r = e.overflowX, o = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function eD(t, e, n) {
  n === void 0 && (n = !1);
  var r = Fi(e), o = gc(t), i = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = {
    x: 0,
    y: 0
  };
  return n || ((qo(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  ep(r)) && (i = $Y(e)), Kr(e) ? (a = gc(e), a.x += e.clientLeft, a.y += e.clientTop) : r && (a.x = Q5(r))), {
    x: o.left + i.scrollLeft - a.x,
    y: o.top + i.scrollTop - a.y,
    width: o.width,
    height: o.height
  };
}
function tp(t) {
  return {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: t.offsetWidth,
    height: t.offsetHeight
  };
}
function tD(t) {
  return qo(t) === "html" ? t : (
    // $FlowFixMe: this is a quicker (but less type safe) way to save quite some bytes from the bundle
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    // $FlowFixMe: need a better way to handle this...
    t.host || // ShadowRoot detected
    // $FlowFixMe: HTMLElement is a Node
    Fi(t)
  );
}
function nD(t) {
  return ["html", "body", "#document"].indexOf(qo(t)) >= 0 ? t.ownerDocument.body : Kr(t) && ep(t) ? t : nD(tD(t));
}
function Kl(t, e) {
  e === void 0 && (e = []);
  var n = nD(t), r = qo(n) === "body", o = br(n), i = r ? [o].concat(o.visualViewport || [], ep(n) ? n : []) : n, a = e.concat(i);
  return r ? a : (
    // $FlowFixMe: isBody tells us target will be an HTMLElement here
    a.concat(Kl(tD(i)))
  );
}
function kY(t) {
  return ["table", "td", "th"].indexOf(qo(t)) >= 0;
}
function RN(t) {
  return !Kr(t) || // https://github.com/popperjs/popper-core/issues/837
  Wa(t).position === "fixed" ? null : t.offsetParent;
}
function ou(t) {
  for (var e = br(t), n = RN(t); n && kY(n); )
    n = RN(n);
  return n && qo(n) === "body" && Wa(n).position === "static" ? e : n || e;
}
var Ar = "top", Vr = "bottom", Hr = "right", Dr = "left", Lf = "auto", iu = [Ar, Vr, Hr, Dr], Fs = "start", np = "end", BY = "clippingParents", rD = "viewport", Dl = "popper", GY = "reference", MN = /* @__PURE__ */ iu.reduce(function(t, e) {
  return t.concat([e + "-" + Fs, e + "-" + np]);
}, []), oD = /* @__PURE__ */ [].concat(iu, [Lf]).reduce(function(t, e) {
  return t.concat([e, e + "-" + Fs, e + "-" + np]);
}, []), FY = "beforeRead", VY = "read", HY = "afterRead", WY = "beforeMain", YY = "main", KY = "afterMain", zY = "beforeWrite", ZY = "write", qY = "afterWrite", _0 = [FY, VY, HY, WY, YY, KY, zY, ZY, qY];
function XY(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  t.forEach(function(i) {
    e.set(i.name, i);
  });
  function o(i) {
    n.add(i.name);
    var a = [].concat(i.requires || [], i.requiresIfExists || []);
    a.forEach(function(s) {
      if (!n.has(s)) {
        var l = e.get(s);
        l && o(l);
      }
    }), r.push(i);
  }
  return t.forEach(function(i) {
    n.has(i.name) || o(i);
  }), r;
}
function jY(t) {
  var e = XY(t);
  return _0.reduce(function(n, r) {
    return n.concat(e.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function JY(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function ti(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    n[r - 1] = arguments[r];
  return [].concat(n).reduce(function(o, i) {
    return o.replace(/%s/, i);
  }, t);
}
var Xi = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s', QY = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available', eK = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function tK(t) {
  t.forEach(function(e) {
    Object.keys(e).forEach(function(n) {
      switch (n) {
        case "name":
          typeof e.name != "string" && console.error(ti(Xi, String(e.name), '"name"', '"string"', '"' + String(e.name) + '"'));
          break;
        case "enabled":
          typeof e.enabled != "boolean" && console.error(ti(Xi, e.name, '"enabled"', '"boolean"', '"' + String(e.enabled) + '"'));
        case "phase":
          _0.indexOf(e.phase) < 0 && console.error(ti(Xi, e.name, '"phase"', "either " + _0.join(", "), '"' + String(e.phase) + '"'));
          break;
        case "fn":
          typeof e.fn != "function" && console.error(ti(Xi, e.name, '"fn"', '"function"', '"' + String(e.fn) + '"'));
          break;
        case "effect":
          typeof e.effect != "function" && console.error(ti(Xi, e.name, '"effect"', '"function"', '"' + String(e.fn) + '"'));
          break;
        case "requires":
          Array.isArray(e.requires) || console.error(ti(Xi, e.name, '"requires"', '"array"', '"' + String(e.requires) + '"'));
          break;
        case "requiresIfExists":
          Array.isArray(e.requiresIfExists) || console.error(ti(Xi, e.name, '"requiresIfExists"', '"array"', '"' + String(e.requiresIfExists) + '"'));
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + e.name + '" modifier, valid properties are ' + eK.map(function(r) {
            return '"' + r + '"';
          }).join(", ") + '; but "' + n + '" was provided.');
      }
      e.requires && e.requires.forEach(function(r) {
        t.find(function(o) {
          return o.name === r;
        }) == null && console.error(ti(QY, String(e.name), r, r));
      });
    });
  });
}
function nK(t, e) {
  var n = /* @__PURE__ */ new Set();
  return t.filter(function(r) {
    var o = e(r);
    if (!n.has(o))
      return n.add(o), !0;
  });
}
function Gr(t) {
  return t.split("-")[0];
}
function rK(t) {
  var e = t.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, {}, r, {
      options: Object.assign({}, o.options, {}, r.options),
      data: Object.assign({}, o.data, {}, r.data)
    }) : r, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var PN = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.", oK = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.", yN = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function LN() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function iK(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, r = n === void 0 ? [] : n, o = e.defaultOptions, i = o === void 0 ? yN : o;
  return function(s, l, c) {
    c === void 0 && (c = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, yN, {}, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, h = {
      state: u,
      setOptions: function(N) {
        E(), u.options = Object.assign({}, i, {}, u.options, {}, N), u.scrollParents = {
          reference: Ic(s) ? Kl(s) : s.contextElement ? Kl(s.contextElement) : [],
          popper: Kl(l)
        };
        var I = jY(rK([].concat(r, u.options.modifiers)));
        if (u.orderedModifiers = I.filter(function(b) {
          return b.enabled;
        }), process.env.NODE_ENV !== "production") {
          var O = nK([].concat(I, u.options.modifiers), function(b) {
            var P = b.name;
            return P;
          });
          if (tK(O), Gr(u.options.placement) === Lf) {
            var p = u.orderedModifiers.find(function(b) {
              var P = b.name;
              return P === "flip";
            });
            p || console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
          }
          var C = Wa(l), D = C.marginTop, T = C.marginRight, k = C.marginBottom, G = C.marginLeft;
          [D, T, k, G].some(function(b) {
            return parseFloat(b);
          }) && console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
        }
        return _(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var N = u.elements, I = N.reference, O = N.popper;
          if (!LN(I, O)) {
            process.env.NODE_ENV !== "production" && console.error(PN);
            return;
          }
          u.rects = {
            reference: eD(I, ou(O), u.options.strategy === "fixed"),
            popper: tp(O)
          }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(P) {
            return u.modifiersData[P.name] = Object.assign({}, P.data);
          });
          for (var p = 0, C = 0; C < u.orderedModifiers.length; C++) {
            if (process.env.NODE_ENV !== "production" && (p += 1, p > 100)) {
              console.error(oK);
              break;
            }
            if (u.reset === !0) {
              u.reset = !1, C = -1;
              continue;
            }
            var D = u.orderedModifiers[C], T = D.fn, k = D.options, G = k === void 0 ? {} : k, b = D.name;
            typeof T == "function" && (u = T({
              state: u,
              options: G,
              name: b,
              instance: h
            }) || u);
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: JY(function() {
        return new Promise(function(m) {
          h.forceUpdate(), m(u);
        });
      }),
      destroy: function() {
        E(), f = !0;
      }
    };
    if (!LN(s, l))
      return process.env.NODE_ENV !== "production" && console.error(PN), h;
    h.setOptions(c).then(function(m) {
      !f && c.onFirstUpdate && c.onFirstUpdate(m);
    });
    function _() {
      u.orderedModifiers.forEach(function(m) {
        var N = m.name, I = m.options, O = I === void 0 ? {} : I, p = m.effect;
        if (typeof p == "function") {
          var C = p({
            state: u,
            name: N,
            instance: h,
            options: O
          }), D = function() {
          };
          d.push(C || D);
        }
      });
    }
    function E() {
      d.forEach(function(m) {
        return m();
      }), d = [];
    }
    return h;
  };
}
var Mu = {
  passive: !0
};
function aK(t) {
  var e = t.state, n = t.instance, r = t.options, o = r.scroll, i = o === void 0 ? !0 : o, a = r.resize, s = a === void 0 ? !0 : a, l = br(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return i && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, Mu);
  }), s && l.addEventListener("resize", n.update, Mu), function() {
    i && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, Mu);
    }), s && l.removeEventListener("resize", n.update, Mu);
  };
}
const sK = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: aK,
  data: {}
};
function Oc(t) {
  return t.split("-")[1];
}
function rp(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function iD(t) {
  var e = t.reference, n = t.element, r = t.placement, o = r ? Gr(r) : null, i = r ? Oc(r) : null, a = e.x + e.width / 2 - n.width / 2, s = e.y + e.height / 2 - n.height / 2, l;
  switch (o) {
    case Ar:
      l = {
        x: a,
        y: e.y - n.height
      };
      break;
    case Vr:
      l = {
        x: a,
        y: e.y + e.height
      };
      break;
    case Hr:
      l = {
        x: e.x + e.width,
        y: s
      };
      break;
    case Dr:
      l = {
        x: e.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var c = o ? rp(o) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (i) {
      case Fs:
        l[c] = Math.floor(l[c]) - Math.floor(e[u] / 2 - n[u] / 2);
        break;
      case np:
        l[c] = Math.floor(l[c]) + Math.ceil(e[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function lK(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = iD({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const cK = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: lK,
  data: {}
};
var uK = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function dK(t) {
  var e = t.x, n = t.y, r = window, o = r.devicePixelRatio || 1;
  return {
    x: Math.round(e * o) / o || 0,
    y: Math.round(n * o) / o || 0
  };
}
function xN(t) {
  var e, n = t.popper, r = t.popperRect, o = t.placement, i = t.offsets, a = t.position, s = t.gpuAcceleration, l = t.adaptive, c = dK(i), u = c.x, d = c.y, f = i.hasOwnProperty("x"), h = i.hasOwnProperty("y"), _ = Dr, E = Ar, m = window;
  if (l) {
    var N = ou(n);
    N === br(n) && (N = Fi(n)), o === Ar && (E = Vr, d -= N.clientHeight - r.height, d *= s ? 1 : -1), o === Dr && (_ = Hr, u -= N.clientWidth - r.width, u *= s ? 1 : -1);
  }
  var I = Object.assign({
    position: a
  }, l && uK);
  if (s) {
    var O;
    return Object.assign({}, I, (O = {}, O[E] = h ? "0" : "", O[_] = f ? "0" : "", O.transform = (m.devicePixelRatio || 1) < 2 ? "translate(" + u + "px, " + d + "px)" : "translate3d(" + u + "px, " + d + "px, 0)", O));
  }
  return Object.assign({}, I, (e = {}, e[E] = h ? d + "px" : "", e[_] = f ? u + "px" : "", e.transform = "", e));
}
function fK(t) {
  var e = t.state, n = t.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, i = n.adaptive, a = i === void 0 ? !0 : i;
  if (process.env.NODE_ENV !== "production") {
    var s = Wa(e.elements.popper).transitionProperty || "";
    a && ["transform", "top", "right", "bottom", "left"].some(function(c) {
      return s.indexOf(c) >= 0;
    }) && console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', `

`, 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", `

`, "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
  }
  var l = {
    placement: Gr(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: o
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, {}, xN(Object.assign({}, l, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: a
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, {}, xN(Object.assign({}, l, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const hK = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: fK,
  data: {}
};
function _K(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var r = e.styles[n] || {}, o = e.attributes[n] || {}, i = e.elements[n];
    !Kr(i) || !qo(i) || (Object.assign(i.style, r), Object.keys(o).forEach(function(a) {
      var s = o[a];
      s === !1 ? i.removeAttribute(a) : i.setAttribute(a, s === !0 ? "" : s);
    }));
  });
}
function EK(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var o = e.elements[r], i = e.attributes[r] || {}, a = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : n[r]), s = a.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Kr(o) || !qo(o) || (Object.assign(o.style, s), Object.keys(i).forEach(function(l) {
        o.removeAttribute(l);
      }));
    });
  };
}
const pK = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: _K,
  effect: EK,
  requires: ["computeStyles"]
};
function mK(t, e, n) {
  var r = Gr(t), o = [Dr, Ar].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, a = i[0], s = i[1];
  return a = a || 0, s = (s || 0) * o, [Dr, Hr].indexOf(r) >= 0 ? {
    x: s,
    y: a
  } : {
    x: a,
    y: s
  };
}
function NK(t) {
  var e = t.state, n = t.options, r = t.name, o = n.offset, i = o === void 0 ? [0, 0] : o, a = oD.reduce(function(u, d) {
    return u[d] = mK(d, e.rects, i), u;
  }, {}), s = a[e.placement], l = s.x, c = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += c), e.modifiersData[r] = a;
}
const vK = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: NK
};
var gK = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function nd(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return gK[e];
  });
}
var IK = {
  start: "end",
  end: "start"
};
function UN(t) {
  return t.replace(/start|end/g, function(e) {
    return IK[e];
  });
}
function OK(t) {
  var e = br(t), n = e.visualViewport, r = e.innerWidth, o = e.innerHeight;
  return n && /iPhone|iPod|iPad/.test(navigator.platform) && (r = n.width, o = n.height), {
    width: r,
    height: o,
    x: 0,
    y: 0
  };
}
function AK(t) {
  var e = br(t), n = QE(t), r = eD(Fi(t), e);
  return r.height = Math.max(r.height, e.innerHeight), r.width = Math.max(r.width, e.innerWidth), r.x = -n.scrollLeft, r.y = -n.scrollTop, r;
}
function Pu(t) {
  return parseFloat(t) || 0;
}
function DK(t) {
  var e = Kr(t) ? Wa(t) : {};
  return {
    top: Pu(e.borderTopWidth),
    right: Pu(e.borderRightWidth),
    bottom: Pu(e.borderBottomWidth),
    left: Pu(e.borderLeftWidth)
  };
}
function CK(t) {
  var e = br(t), n = DK(t), r = qo(t) === "html", o = Q5(t), i = t.clientWidth + n.right, a = t.clientHeight + n.bottom;
  return r && e.innerHeight - t.clientHeight > 50 && (a = e.innerHeight - n.bottom), {
    top: r ? 0 : t.clientTop,
    right: (
      // RTL scrollbar (scrolling containers only)
      t.clientLeft > n.left ? n.right : (
        // LTR scrollbar
        r ? e.innerWidth - i - o : t.offsetWidth - i
      )
    ),
    bottom: r ? e.innerHeight - a : t.offsetHeight - a,
    left: r ? o : t.clientLeft
  };
}
function aD(t, e) {
  var n = !!(e.getRootNode && e.getRootNode().host);
  if (t.contains(e))
    return !0;
  if (n) {
    var r = e;
    do {
      if (r && t.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function E0(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function $N(t, e) {
  return e === rD ? E0(OK(t)) : Kr(e) ? gc(e) : E0(AK(Fi(t)));
}
function SK(t) {
  var e = Kl(t), n = ["absolute", "fixed"].indexOf(Wa(t).position) >= 0, r = n && Kr(t) ? ou(t) : t;
  return Ic(r) ? e.filter(function(o) {
    return Ic(o) && aD(o, r);
  }) : [];
}
function wK(t, e, n) {
  var r = e === "clippingParents" ? SK(t) : [].concat(e), o = [].concat(r, [n]), i = o[0], a = o.reduce(function(s, l) {
    var c = $N(t, l), u = CK(Kr(l) ? l : Fi(t));
    return s.top = Math.max(c.top + u.top, s.top), s.right = Math.min(c.right - u.right, s.right), s.bottom = Math.min(c.bottom - u.bottom, s.bottom), s.left = Math.max(c.left + u.left, s.left), s;
  }, $N(t, i));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function sD() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function lD(t) {
  return Object.assign({}, sD(), {}, t);
}
function cD(t, e) {
  return e.reduce(function(n, r) {
    return n[r] = t, n;
  }, {});
}
function Ac(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, o = r === void 0 ? t.placement : r, i = n.boundary, a = i === void 0 ? BY : i, s = n.rootBoundary, l = s === void 0 ? rD : s, c = n.elementContext, u = c === void 0 ? Dl : c, d = n.altBoundary, f = d === void 0 ? !1 : d, h = n.padding, _ = h === void 0 ? 0 : h, E = lD(typeof _ != "number" ? _ : cD(_, iu)), m = u === Dl ? GY : Dl, N = t.elements.reference, I = t.rects.popper, O = t.elements[f ? m : u], p = wK(Ic(O) ? O : O.contextElement || Fi(t.elements.popper), a, l), C = gc(N), D = iD({
    reference: C,
    element: I,
    strategy: "absolute",
    placement: o
  }), T = E0(Object.assign({}, I, {}, D)), k = u === Dl ? T : C, G = {
    top: p.top - k.top + E.top,
    bottom: k.bottom - p.bottom + E.bottom,
    left: p.left - k.left + E.left,
    right: k.right - p.right + E.right
  }, b = t.modifiersData.offset;
  if (u === Dl && b) {
    var P = b[o];
    Object.keys(G).forEach(function($) {
      var y = [Hr, Vr].indexOf($) >= 0 ? 1 : -1, L = [Ar, Vr].indexOf($) >= 0 ? "y" : "x";
      G[$] += P[L] * y;
    });
  }
  return G;
}
function TK(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, o = n.boundary, i = n.rootBoundary, a = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? oD : l, u = Oc(r), d = (u ? s ? MN : MN.filter(function(h) {
    return Oc(h) === u;
  }) : iu).filter(function(h) {
    return c.indexOf(h) >= 0;
  }), f = d.reduce(function(h, _) {
    return h[_] = Ac(t, {
      placement: _,
      boundary: o,
      rootBoundary: i,
      padding: a
    })[Gr(_)], h;
  }, {});
  return Object.keys(f).sort(function(h, _) {
    return f[h] - f[_];
  });
}
function bK(t) {
  if (Gr(t) === Lf)
    return [];
  var e = nd(t);
  return [UN(t), e, UN(e)];
}
function RK(t) {
  var e = t.state, n = t.options, r = t.name;
  if (!e.modifiersData[r]._skip) {
    for (var o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, s = a === void 0 ? !0 : a, l = n.fallbackPlacements, c = n.padding, u = n.boundary, d = n.rootBoundary, f = n.altBoundary, h = n.flipVariations, _ = h === void 0 ? !0 : h, E = n.allowedAutoPlacements, m = e.options.placement, N = Gr(m), I = N === m, O = l || (I || !_ ? [nd(m)] : bK(m)), p = [m].concat(O).reduce(function(re, j) {
      return re.concat(Gr(j) === Lf ? TK(e, {
        placement: j,
        boundary: u,
        rootBoundary: d,
        padding: c,
        flipVariations: _,
        allowedAutoPlacements: E
      }) : j);
    }, []), C = e.rects.reference, D = e.rects.popper, T = /* @__PURE__ */ new Map(), k = !0, G = p[0], b = 0; b < p.length; b++) {
      var P = p[b], $ = Gr(P), y = Oc(P) === Fs, L = [Ar, Vr].indexOf($) >= 0, w = L ? "width" : "height", R = Ac(e, {
        placement: P,
        boundary: u,
        rootBoundary: d,
        altBoundary: f,
        padding: c
      }), B = L ? y ? Hr : Dr : y ? Vr : Ar;
      C[w] > D[w] && (B = nd(B));
      var U = nd(B), K = [];
      if (i && K.push(R[$] <= 0), s && K.push(R[B] <= 0, R[U] <= 0), K.every(function(re) {
        return re;
      })) {
        G = P, k = !1;
        break;
      }
      T.set(P, K);
    }
    if (k)
      for (var Z = _ ? 3 : 1, X = function(j) {
        var ne = p.find(function(Ee) {
          var fe = T.get(Ee);
          if (fe)
            return fe.slice(0, j).every(function(Oe) {
              return Oe;
            });
        });
        if (ne)
          return G = ne, "break";
      }, J = Z; J > 0; J--) {
        var ae = X(J);
        if (ae === "break")
          break;
      }
    e.placement !== G && (e.modifiersData[r]._skip = !0, e.placement = G, e.reset = !0);
  }
}
const MK = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: RK,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function PK(t) {
  return t === "x" ? "y" : "x";
}
function rd(t, e, n) {
  return Math.max(t, Math.min(e, n));
}
function yK(t) {
  var e = t.state, n = t.options, r = t.name, o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, s = a === void 0 ? !1 : a, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, d = n.padding, f = n.tether, h = f === void 0 ? !0 : f, _ = n.tetherOffset, E = _ === void 0 ? 0 : _, m = Ac(e, {
    boundary: l,
    rootBoundary: c,
    padding: d,
    altBoundary: u
  }), N = Gr(e.placement), I = Oc(e.placement), O = !I, p = rp(N), C = PK(p), D = e.modifiersData.popperOffsets, T = e.rects.reference, k = e.rects.popper, G = typeof E == "function" ? E(Object.assign({}, e.rects, {
    placement: e.placement
  })) : E, b = {
    x: 0,
    y: 0
  };
  if (D) {
    if (i) {
      var P = p === "y" ? Ar : Dr, $ = p === "y" ? Vr : Hr, y = p === "y" ? "height" : "width", L = D[p], w = D[p] + m[P], R = D[p] - m[$], B = h ? -k[y] / 2 : 0, U = I === Fs ? T[y] : k[y], K = I === Fs ? -k[y] : -T[y], Z = e.elements.arrow, X = h && Z ? tp(Z) : {
        width: 0,
        height: 0
      }, J = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : sD(), ae = J[P], re = J[$], j = rd(0, T[y], X[y]), ne = O ? T[y] / 2 - B - j - ae - G : U - j - ae - G, Ee = O ? -T[y] / 2 + B + j + re + G : K + j + re + G, fe = e.elements.arrow && ou(e.elements.arrow), Oe = fe ? p === "y" ? fe.clientTop || 0 : fe.clientLeft || 0 : 0, ce = e.modifiersData.offset ? e.modifiersData.offset[e.placement][p] : 0, Se = D[p] + ne - ce - Oe, se = D[p] + Ee - ce, Ie = rd(h ? Math.min(w, Se) : w, L, h ? Math.max(R, se) : R);
      D[p] = Ie, b[p] = Ie - L;
    }
    if (s) {
      var we = p === "x" ? Ar : Dr, le = p === "x" ? Vr : Hr, De = D[C], pe = De + m[we], Le = De - m[le], ze = rd(pe, De, Le);
      D[C] = ze, b[C] = ze - De;
    }
    e.modifiersData[r] = b;
  }
}
const LK = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: yK,
  requiresIfExists: ["offset"]
};
function xK(t) {
  var e, n = t.state, r = t.name, o = n.elements.arrow, i = n.modifiersData.popperOffsets, a = Gr(n.placement), s = rp(a), l = [Dr, Hr].indexOf(a) >= 0, c = l ? "height" : "width";
  if (!(!o || !i)) {
    var u = n.modifiersData[r + "#persistent"].padding, d = tp(o), f = s === "y" ? Ar : Dr, h = s === "y" ? Vr : Hr, _ = n.rects.reference[c] + n.rects.reference[s] - i[s] - n.rects.popper[c], E = i[s] - n.rects.reference[s], m = ou(o), N = m ? s === "y" ? m.clientHeight || 0 : m.clientWidth || 0 : 0, I = _ / 2 - E / 2, O = u[f], p = N - d[c] - u[h], C = N / 2 - d[c] / 2 + I, D = rd(O, C, p), T = s;
    n.modifiersData[r] = (e = {}, e[T] = D, e.centerOffset = D - C, e);
  }
}
function UK(t) {
  var e = t.state, n = t.options, r = t.name, o = n.element, i = o === void 0 ? "[data-popper-arrow]" : o, a = n.padding, s = a === void 0 ? 0 : a;
  if (i != null && !(typeof i == "string" && (i = e.elements.popper.querySelector(i), !i))) {
    if (process.env.NODE_ENV !== "production" && (Kr(i) || console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "))), !aD(e.elements.popper, i)) {
      process.env.NODE_ENV !== "production" && console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
      return;
    }
    e.elements.arrow = i, e.modifiersData[r + "#persistent"] = {
      padding: lD(typeof s != "number" ? s : cD(s, iu))
    };
  }
}
const $K = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: xK,
  effect: UK,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function kN(t, e, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - n.y,
    right: t.right - e.width + n.x,
    bottom: t.bottom - e.height + n.y,
    left: t.left - e.width - n.x
  };
}
function BN(t) {
  return [Ar, Hr, Vr, Dr].some(function(e) {
    return t[e] >= 0;
  });
}
function kK(t) {
  var e = t.state, n = t.name, r = e.rects.reference, o = e.rects.popper, i = e.modifiersData.preventOverflow, a = Ac(e, {
    elementContext: "reference"
  }), s = Ac(e, {
    altBoundary: !0
  }), l = kN(a, r), c = kN(s, o, i), u = BN(l), d = BN(c);
  e.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: d
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": d
  });
}
const BK = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: kK
};
var GK = [sK, cK, hK, pK, vK, MK, LK, $K, BK], FK = /* @__PURE__ */ iK({
  defaultModifiers: GK
}), VK = Object.defineProperty, HK = Object.defineProperties, WK = Object.getOwnPropertyDescriptors, Pd = Object.getOwnPropertySymbols, uD = Object.prototype.hasOwnProperty, dD = Object.prototype.propertyIsEnumerable, GN = (t, e, n) => e in t ? VK(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, be = (t, e) => {
  for (var n in e || (e = {}))
    uD.call(e, n) && GN(t, n, e[n]);
  if (Pd)
    for (var n of Pd(e))
      dD.call(e, n) && GN(t, n, e[n]);
  return t;
}, tt = (t, e) => HK(t, WK(e)), YK = (t, e) => {
  var n = {};
  for (var r in t)
    uD.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && Pd)
    for (var r of Pd(t))
      e.indexOf(r) < 0 && dD.call(t, r) && (n[r] = t[r]);
  return n;
};
function po(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function On(t, e) {
  if (e.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function Xo(t) {
  On(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function eo(t, e) {
  On(2, arguments);
  var n = Xo(t), r = po(e);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function p0(t, e) {
  On(2, arguments);
  var n = Xo(t), r = po(e);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var o = n.getDate(), i = new Date(n.getTime());
  i.setMonth(n.getMonth() + r + 1, 0);
  var a = i.getDate();
  return o >= a ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), o), n);
}
function FN(t, e) {
  On(2, arguments);
  var n = po(e);
  return p0(t, n * 12);
}
var yu = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, KK = typeof yu == "object" && yu && yu.Object === Object && yu, fD = KK, zK = fD, ZK = typeof self == "object" && self && self.Object === Object && self, qK = zK || ZK || Function("return this")(), Oo = qK, XK = Oo, jK = XK.Symbol, ol = jK, VN = ol, hD = Object.prototype, JK = hD.hasOwnProperty, QK = hD.toString, Cl = VN ? VN.toStringTag : void 0;
function ez(t) {
  var e = JK.call(t, Cl), n = t[Cl];
  try {
    t[Cl] = void 0;
    var r = !0;
  } catch {
  }
  var o = QK.call(t);
  return r && (e ? t[Cl] = n : delete t[Cl]), o;
}
var tz = ez, nz = Object.prototype, rz = nz.toString;
function oz(t) {
  return rz.call(t);
}
var iz = oz, HN = ol, az = tz, sz = iz, lz = "[object Null]", cz = "[object Undefined]", WN = HN ? HN.toStringTag : void 0;
function uz(t) {
  return t == null ? t === void 0 ? cz : lz : WN && WN in Object(t) ? az(t) : sz(t);
}
var Ao = uz;
function dz(t) {
  return t != null && typeof t == "object";
}
var ir = dz, fz = Ao, hz = ir, _z = "[object Boolean]";
function Ez(t) {
  return t === !0 || t === !1 || hz(t) && fz(t) == _z;
}
var pz = Ez, mz = Ao, Nz = ir, vz = "[object Number]";
function gz(t) {
  return typeof t == "number" || Nz(t) && mz(t) == vz;
}
var zl = gz, Iz = Array.isArray, ar = Iz, Oz = Ao, Az = ar, Dz = ir, Cz = "[object String]";
function Sz(t) {
  return typeof t == "string" || !Az(t) && Dz(t) && Oz(t) == Cz;
}
var _i = Sz;
function wz(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Rr = wz, Tz = Ao, bz = Rr, Rz = "[object AsyncFunction]", Mz = "[object Function]", Pz = "[object GeneratorFunction]", yz = "[object Proxy]";
function Lz(t) {
  if (!bz(t))
    return !1;
  var e = Tz(t);
  return e == Mz || e == Pz || e == Rz || e == yz;
}
var Go = Lz, xz = 9007199254740991;
function Uz(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= xz;
}
var op = Uz, $z = Go, kz = op;
function Bz(t) {
  return t != null && kz(t.length) && !$z(t);
}
var au = Bz, Gz = au, Fz = ir;
function Vz(t) {
  return Fz(t) && Gz(t);
}
var Fn = Vz;
function Hz(t) {
  return t === void 0;
}
var Wz = Hz, Yz = Ao, Kz = ir, zz = "[object Date]";
function Zz(t) {
  return Kz(t) && Yz(t) == zz;
}
var qz = Zz;
function Xz(t) {
  return function(e) {
    return t(e);
  };
}
var xf = Xz, Vs = { exports: {} };
(function(t, e) {
  var n = fD, r = e && !e.nodeType && e, o = r && !0 && t && !t.nodeType && t, i = o && o.exports === r, a = i && n.process, s = function() {
    try {
      var l = o && o.require && o.require("util").types;
      return l || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  t.exports = s;
})(Vs, Vs.exports);
var jz = qz, Jz = xf, YN = Vs.exports, KN = YN && YN.isDate, Qz = KN ? Jz(KN) : jz, eZ = Qz;
function tZ(t, e, n) {
  return t === t && (n !== void 0 && (t = t <= n ? t : n), e !== void 0 && (t = t >= e ? t : e)), t;
}
var nZ = tZ, rZ = Ao, oZ = ir, iZ = "[object Symbol]";
function aZ(t) {
  return typeof t == "symbol" || oZ(t) && rZ(t) == iZ;
}
var Uf = aZ, zN = Rr, sZ = Uf, ZN = 0 / 0, lZ = /^\s+|\s+$/g, cZ = /^[-+]0x[0-9a-f]+$/i, uZ = /^0b[01]+$/i, dZ = /^0o[0-7]+$/i, fZ = parseInt;
function hZ(t) {
  if (typeof t == "number")
    return t;
  if (sZ(t))
    return ZN;
  if (zN(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = zN(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = t.replace(lZ, "");
  var n = uZ.test(t);
  return n || dZ.test(t) ? fZ(t.slice(2), n ? 2 : 8) : cZ.test(t) ? ZN : +t;
}
var _Z = hZ, EZ = nZ, L1 = _Z;
function pZ(t, e, n) {
  return n === void 0 && (n = e, e = void 0), n !== void 0 && (n = L1(n), n = n === n ? n : 0), e !== void 0 && (e = L1(e), e = e === e ? e : 0), EZ(L1(t), e, n);
}
var mZ = pZ, NZ = ar, vZ = Uf, gZ = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, IZ = /^\w*$/;
function OZ(t, e) {
  if (NZ(t))
    return !1;
  var n = typeof t;
  return n == "number" || n == "symbol" || n == "boolean" || t == null || vZ(t) ? !0 : IZ.test(t) || !gZ.test(t) || e != null && t in Object(e);
}
var ip = OZ, AZ = Oo, DZ = AZ["__core-js_shared__"], CZ = DZ, x1 = CZ, qN = function() {
  var t = /[^.]+$/.exec(x1 && x1.keys && x1.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function SZ(t) {
  return !!qN && qN in t;
}
var wZ = SZ, TZ = Function.prototype, bZ = TZ.toString;
function RZ(t) {
  if (t != null) {
    try {
      return bZ.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var _D = RZ, MZ = Go, PZ = wZ, yZ = Rr, LZ = _D, xZ = /[\\^$.*+?()[\]{}|]/g, UZ = /^\[object .+?Constructor\]$/, $Z = Function.prototype, kZ = Object.prototype, BZ = $Z.toString, GZ = kZ.hasOwnProperty, FZ = RegExp("^" + BZ.call(GZ).replace(xZ, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function VZ(t) {
  if (!yZ(t) || PZ(t))
    return !1;
  var e = MZ(t) ? FZ : UZ;
  return e.test(LZ(t));
}
var HZ = VZ;
function WZ(t, e) {
  return t == null ? void 0 : t[e];
}
var YZ = WZ, KZ = HZ, zZ = YZ;
function ZZ(t, e) {
  var n = zZ(t, e);
  return KZ(n) ? n : void 0;
}
var Ya = ZZ, qZ = Ya, XZ = qZ(Object, "create"), $f = XZ, XN = $f;
function jZ() {
  this.__data__ = XN ? XN(null) : {}, this.size = 0;
}
var JZ = jZ;
function QZ(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var eq = QZ, tq = $f, nq = "__lodash_hash_undefined__", rq = Object.prototype, oq = rq.hasOwnProperty;
function iq(t) {
  var e = this.__data__;
  if (tq) {
    var n = e[t];
    return n === nq ? void 0 : n;
  }
  return oq.call(e, t) ? e[t] : void 0;
}
var aq = iq, sq = $f, lq = Object.prototype, cq = lq.hasOwnProperty;
function uq(t) {
  var e = this.__data__;
  return sq ? e[t] !== void 0 : cq.call(e, t);
}
var dq = uq, fq = $f, hq = "__lodash_hash_undefined__";
function _q(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = fq && e === void 0 ? hq : e, this;
}
var Eq = _q, pq = JZ, mq = eq, Nq = aq, vq = dq, gq = Eq;
function il(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
il.prototype.clear = pq;
il.prototype.delete = mq;
il.prototype.get = Nq;
il.prototype.has = vq;
il.prototype.set = gq;
var Iq = il;
function Oq() {
  this.__data__ = [], this.size = 0;
}
var Aq = Oq;
function Dq(t, e) {
  return t === e || t !== t && e !== e;
}
var al = Dq, Cq = al;
function Sq(t, e) {
  for (var n = t.length; n--; )
    if (Cq(t[n][0], e))
      return n;
  return -1;
}
var kf = Sq, wq = kf, Tq = Array.prototype, bq = Tq.splice;
function Rq(t) {
  var e = this.__data__, n = wq(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : bq.call(e, n, 1), --this.size, !0;
}
var Mq = Rq, Pq = kf;
function yq(t) {
  var e = this.__data__, n = Pq(e, t);
  return n < 0 ? void 0 : e[n][1];
}
var Lq = yq, xq = kf;
function Uq(t) {
  return xq(this.__data__, t) > -1;
}
var $q = Uq, kq = kf;
function Bq(t, e) {
  var n = this.__data__, r = kq(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
var Gq = Bq, Fq = Aq, Vq = Mq, Hq = Lq, Wq = $q, Yq = Gq;
function sl(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
sl.prototype.clear = Fq;
sl.prototype.delete = Vq;
sl.prototype.get = Hq;
sl.prototype.has = Wq;
sl.prototype.set = Yq;
var Bf = sl, Kq = Ya, zq = Oo, Zq = Kq(zq, "Map"), ap = Zq, jN = Iq, qq = Bf, Xq = ap;
function jq() {
  this.size = 0, this.__data__ = {
    hash: new jN(),
    map: new (Xq || qq)(),
    string: new jN()
  };
}
var Jq = jq;
function Qq(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var eX = Qq, tX = eX;
function nX(t, e) {
  var n = t.__data__;
  return tX(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
var Gf = nX, rX = Gf;
function oX(t) {
  var e = rX(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var iX = oX, aX = Gf;
function sX(t) {
  return aX(this, t).get(t);
}
var lX = sX, cX = Gf;
function uX(t) {
  return cX(this, t).has(t);
}
var dX = uX, fX = Gf;
function hX(t, e) {
  var n = fX(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
var _X = hX, EX = Jq, pX = iX, mX = lX, NX = dX, vX = _X;
function ll(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
ll.prototype.clear = EX;
ll.prototype.delete = pX;
ll.prototype.get = mX;
ll.prototype.has = NX;
ll.prototype.set = vX;
var sp = ll, ED = sp, gX = "Expected a function";
function lp(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(gX);
  var n = function() {
    var r = arguments, o = e ? e.apply(this, r) : r[0], i = n.cache;
    if (i.has(o))
      return i.get(o);
    var a = t.apply(this, r);
    return n.cache = i.set(o, a) || i, a;
  };
  return n.cache = new (lp.Cache || ED)(), n;
}
lp.Cache = ED;
var IX = lp, OX = IX, AX = 500;
function DX(t) {
  var e = OX(t, function(r) {
    return n.size === AX && n.clear(), r;
  }), n = e.cache;
  return e;
}
var CX = DX, SX = CX, wX = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, TX = /\\(\\)?/g, bX = SX(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(wX, function(n, r, o, i) {
    e.push(o ? i.replace(TX, "$1") : r || n);
  }), e;
}), RX = bX;
function MX(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, o = Array(r); ++n < r; )
    o[n] = e(t[n], n, t);
  return o;
}
var cp = MX, JN = ol, PX = cp, yX = ar, LX = Uf, xX = 1 / 0, QN = JN ? JN.prototype : void 0, ev = QN ? QN.toString : void 0;
function pD(t) {
  if (typeof t == "string")
    return t;
  if (yX(t))
    return PX(t, pD) + "";
  if (LX(t))
    return ev ? ev.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -xX ? "-0" : e;
}
var UX = pD, $X = UX;
function kX(t) {
  return t == null ? "" : $X(t);
}
var BX = kX, GX = ar, FX = ip, VX = RX, HX = BX;
function WX(t, e) {
  return GX(t) ? t : FX(t, e) ? [t] : VX(HX(t));
}
var cl = WX, YX = Uf, KX = 1 / 0;
function zX(t) {
  if (typeof t == "string" || YX(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -KX ? "-0" : e;
}
var ul = zX, ZX = cl, qX = ul;
function XX(t, e) {
  e = ZX(e, t);
  for (var n = 0, r = e.length; t != null && n < r; )
    t = t[qX(e[n++])];
  return n && n == r ? t : void 0;
}
var Ff = XX, jX = Ff;
function JX(t, e, n) {
  var r = t == null ? void 0 : jX(t, e);
  return r === void 0 ? n : r;
}
var Dc = JX, QX = Ya, ej = function() {
  try {
    var t = QX(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), mD = ej, tv = mD;
function tj(t, e, n) {
  e == "__proto__" && tv ? tv(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
var Vf = tj, nj = Vf, rj = al, oj = Object.prototype, ij = oj.hasOwnProperty;
function aj(t, e, n) {
  var r = t[e];
  (!(ij.call(t, e) && rj(r, n)) || n === void 0 && !(e in t)) && nj(t, e, n);
}
var up = aj, sj = 9007199254740991, lj = /^(?:0|[1-9]\d*)$/;
function cj(t, e) {
  var n = typeof t;
  return e = e ?? sj, !!e && (n == "number" || n != "symbol" && lj.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var Hf = cj, uj = up, dj = cl, fj = Hf, nv = Rr, hj = ul;
function _j(t, e, n, r) {
  if (!nv(t))
    return t;
  e = dj(e, t);
  for (var o = -1, i = e.length, a = i - 1, s = t; s != null && ++o < i; ) {
    var l = hj(e[o]), c = n;
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return t;
    if (o != a) {
      var u = s[l];
      c = r ? r(u, l, s) : void 0, c === void 0 && (c = nv(u) ? u : fj(e[o + 1]) ? [] : {});
    }
    uj(s, l, c), s = s[l];
  }
  return t;
}
var ND = _j, Ej = ND;
function pj(t, e, n) {
  return t == null ? t : Ej(t, e, n);
}
var mj = pj;
function Nj(t) {
  return function(e, n, r) {
    for (var o = -1, i = Object(e), a = r(e), s = a.length; s--; ) {
      var l = a[t ? s : ++o];
      if (n(i[l], l, i) === !1)
        break;
    }
    return e;
  };
}
var vj = Nj, gj = vj, Ij = gj(), vD = Ij;
function Oj(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var Aj = Oj, Dj = Ao, Cj = ir, Sj = "[object Arguments]";
function wj(t) {
  return Cj(t) && Dj(t) == Sj;
}
var Tj = wj, rv = Tj, bj = ir, gD = Object.prototype, Rj = gD.hasOwnProperty, Mj = gD.propertyIsEnumerable, Pj = rv(function() {
  return arguments;
}()) ? rv : function(t) {
  return bj(t) && Rj.call(t, "callee") && !Mj.call(t, "callee");
}, Wf = Pj, Hs = { exports: {} };
function yj() {
  return !1;
}
var Lj = yj;
(function(t, e) {
  var n = Oo, r = Lj, o = e && !e.nodeType && e, i = o && !0 && t && !t.nodeType && t, a = i && i.exports === o, s = a ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || r;
  t.exports = c;
})(Hs, Hs.exports);
var xj = Ao, Uj = op, $j = ir, kj = "[object Arguments]", Bj = "[object Array]", Gj = "[object Boolean]", Fj = "[object Date]", Vj = "[object Error]", Hj = "[object Function]", Wj = "[object Map]", Yj = "[object Number]", Kj = "[object Object]", zj = "[object RegExp]", Zj = "[object Set]", qj = "[object String]", Xj = "[object WeakMap]", jj = "[object ArrayBuffer]", Jj = "[object DataView]", Qj = "[object Float32Array]", eJ = "[object Float64Array]", tJ = "[object Int8Array]", nJ = "[object Int16Array]", rJ = "[object Int32Array]", oJ = "[object Uint8Array]", iJ = "[object Uint8ClampedArray]", aJ = "[object Uint16Array]", sJ = "[object Uint32Array]", At = {};
At[Qj] = At[eJ] = At[tJ] = At[nJ] = At[rJ] = At[oJ] = At[iJ] = At[aJ] = At[sJ] = !0;
At[kj] = At[Bj] = At[jj] = At[Gj] = At[Jj] = At[Fj] = At[Vj] = At[Hj] = At[Wj] = At[Yj] = At[Kj] = At[zj] = At[Zj] = At[qj] = At[Xj] = !1;
function lJ(t) {
  return $j(t) && Uj(t.length) && !!At[xj(t)];
}
var cJ = lJ, uJ = cJ, dJ = xf, ov = Vs.exports, iv = ov && ov.isTypedArray, fJ = iv ? dJ(iv) : uJ, dp = fJ, hJ = Aj, _J = Wf, EJ = ar, pJ = Hs.exports, mJ = Hf, NJ = dp, vJ = Object.prototype, gJ = vJ.hasOwnProperty;
function IJ(t, e) {
  var n = EJ(t), r = !n && _J(t), o = !n && !r && pJ(t), i = !n && !r && !o && NJ(t), a = n || r || o || i, s = a ? hJ(t.length, String) : [], l = s.length;
  for (var c in t)
    (e || gJ.call(t, c)) && !(a && (c == "length" || o && (c == "offset" || c == "parent") || i && (c == "buffer" || c == "byteLength" || c == "byteOffset") || mJ(c, l))) && s.push(c);
  return s;
}
var ID = IJ, OJ = Object.prototype;
function AJ(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || OJ;
  return t === n;
}
var fp = AJ;
function DJ(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var OD = DJ, CJ = OD, SJ = CJ(Object.keys, Object), wJ = SJ, TJ = fp, bJ = wJ, RJ = Object.prototype, MJ = RJ.hasOwnProperty;
function PJ(t) {
  if (!TJ(t))
    return bJ(t);
  var e = [];
  for (var n in Object(t))
    MJ.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
var yJ = PJ, LJ = ID, xJ = yJ, UJ = au;
function $J(t) {
  return UJ(t) ? LJ(t) : xJ(t);
}
var dl = $J, kJ = vD, BJ = dl;
function GJ(t, e) {
  return t && kJ(t, e, BJ);
}
var AD = GJ, FJ = Bf;
function VJ() {
  this.__data__ = new FJ(), this.size = 0;
}
var HJ = VJ;
function WJ(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
var YJ = WJ;
function KJ(t) {
  return this.__data__.get(t);
}
var zJ = KJ;
function ZJ(t) {
  return this.__data__.has(t);
}
var qJ = ZJ, XJ = Bf, jJ = ap, JJ = sp, QJ = 200;
function eQ(t, e) {
  var n = this.__data__;
  if (n instanceof XJ) {
    var r = n.__data__;
    if (!jJ || r.length < QJ - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new JJ(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
var tQ = eQ, nQ = Bf, rQ = HJ, oQ = YJ, iQ = zJ, aQ = qJ, sQ = tQ;
function fl(t) {
  var e = this.__data__ = new nQ(t);
  this.size = e.size;
}
fl.prototype.clear = rQ;
fl.prototype.delete = oQ;
fl.prototype.get = iQ;
fl.prototype.has = aQ;
fl.prototype.set = sQ;
var Yf = fl, lQ = "__lodash_hash_undefined__";
function cQ(t) {
  return this.__data__.set(t, lQ), this;
}
var uQ = cQ;
function dQ(t) {
  return this.__data__.has(t);
}
var fQ = dQ, hQ = sp, _Q = uQ, EQ = fQ;
function yd(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new hQ(); ++e < n; )
    this.add(t[e]);
}
yd.prototype.add = yd.prototype.push = _Q;
yd.prototype.has = EQ;
var pQ = yd;
function mQ(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r; )
    if (e(t[n], n, t))
      return !0;
  return !1;
}
var DD = mQ;
function NQ(t, e) {
  return t.has(e);
}
var vQ = NQ, gQ = pQ, IQ = DD, OQ = vQ, AQ = 1, DQ = 2;
function CQ(t, e, n, r, o, i) {
  var a = n & AQ, s = t.length, l = e.length;
  if (s != l && !(a && l > s))
    return !1;
  var c = i.get(t), u = i.get(e);
  if (c && u)
    return c == e && u == t;
  var d = -1, f = !0, h = n & DQ ? new gQ() : void 0;
  for (i.set(t, e), i.set(e, t); ++d < s; ) {
    var _ = t[d], E = e[d];
    if (r)
      var m = a ? r(E, _, d, e, t, i) : r(_, E, d, t, e, i);
    if (m !== void 0) {
      if (m)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!IQ(e, function(N, I) {
        if (!OQ(h, I) && (_ === N || o(_, N, n, r, i)))
          return h.push(I);
      })) {
        f = !1;
        break;
      }
    } else if (!(_ === E || o(_, E, n, r, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(t), i.delete(e), f;
}
var CD = CQ, SQ = Oo, wQ = SQ.Uint8Array, SD = wQ;
function TQ(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r, o) {
    n[++e] = [o, r];
  }), n;
}
var wD = TQ;
function bQ(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r) {
    n[++e] = r;
  }), n;
}
var RQ = bQ, av = ol, sv = SD, MQ = al, PQ = CD, yQ = wD, LQ = RQ, xQ = 1, UQ = 2, $Q = "[object Boolean]", kQ = "[object Date]", BQ = "[object Error]", GQ = "[object Map]", FQ = "[object Number]", VQ = "[object RegExp]", HQ = "[object Set]", WQ = "[object String]", YQ = "[object Symbol]", KQ = "[object ArrayBuffer]", zQ = "[object DataView]", lv = av ? av.prototype : void 0, U1 = lv ? lv.valueOf : void 0;
function ZQ(t, e, n, r, o, i, a) {
  switch (n) {
    case zQ:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case KQ:
      return !(t.byteLength != e.byteLength || !i(new sv(t), new sv(e)));
    case $Q:
    case kQ:
    case FQ:
      return MQ(+t, +e);
    case BQ:
      return t.name == e.name && t.message == e.message;
    case VQ:
    case WQ:
      return t == e + "";
    case GQ:
      var s = yQ;
    case HQ:
      var l = r & xQ;
      if (s || (s = LQ), t.size != e.size && !l)
        return !1;
      var c = a.get(t);
      if (c)
        return c == e;
      r |= UQ, a.set(t, e);
      var u = PQ(s(t), s(e), r, o, i, a);
      return a.delete(t), u;
    case YQ:
      if (U1)
        return U1.call(t) == U1.call(e);
  }
  return !1;
}
var qQ = ZQ;
function XQ(t, e) {
  for (var n = -1, r = e.length, o = t.length; ++n < r; )
    t[o + n] = e[n];
  return t;
}
var hp = XQ, jQ = hp, JQ = ar;
function QQ(t, e, n) {
  var r = e(t);
  return JQ(t) ? r : jQ(r, n(t));
}
var TD = QQ;
function eee(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, o = 0, i = []; ++n < r; ) {
    var a = t[n];
    e(a, n, t) && (i[o++] = a);
  }
  return i;
}
var tee = eee;
function nee() {
  return [];
}
var bD = nee, ree = tee, oee = bD, iee = Object.prototype, aee = iee.propertyIsEnumerable, cv = Object.getOwnPropertySymbols, see = cv ? function(t) {
  return t == null ? [] : (t = Object(t), ree(cv(t), function(e) {
    return aee.call(t, e);
  }));
} : oee, _p = see, lee = TD, cee = _p, uee = dl;
function dee(t) {
  return lee(t, uee, cee);
}
var RD = dee, uv = RD, fee = 1, hee = Object.prototype, _ee = hee.hasOwnProperty;
function Eee(t, e, n, r, o, i) {
  var a = n & fee, s = uv(t), l = s.length, c = uv(e), u = c.length;
  if (l != u && !a)
    return !1;
  for (var d = l; d--; ) {
    var f = s[d];
    if (!(a ? f in e : _ee.call(e, f)))
      return !1;
  }
  var h = i.get(t), _ = i.get(e);
  if (h && _)
    return h == e && _ == t;
  var E = !0;
  i.set(t, e), i.set(e, t);
  for (var m = a; ++d < l; ) {
    f = s[d];
    var N = t[f], I = e[f];
    if (r)
      var O = a ? r(I, N, f, e, t, i) : r(N, I, f, t, e, i);
    if (!(O === void 0 ? N === I || o(N, I, n, r, i) : O)) {
      E = !1;
      break;
    }
    m || (m = f == "constructor");
  }
  if (E && !m) {
    var p = t.constructor, C = e.constructor;
    p != C && "constructor" in t && "constructor" in e && !(typeof p == "function" && p instanceof p && typeof C == "function" && C instanceof C) && (E = !1);
  }
  return i.delete(t), i.delete(e), E;
}
var pee = Eee, mee = Ya, Nee = Oo, vee = mee(Nee, "DataView"), gee = vee, Iee = Ya, Oee = Oo, Aee = Iee(Oee, "Promise"), Dee = Aee, Cee = Ya, See = Oo, wee = Cee(See, "Set"), Tee = wee, bee = Ya, Ree = Oo, Mee = bee(Ree, "WeakMap"), Pee = Mee, m0 = gee, N0 = ap, v0 = Dee, g0 = Tee, I0 = Pee, MD = Ao, hl = _D, dv = "[object Map]", yee = "[object Object]", fv = "[object Promise]", hv = "[object Set]", _v = "[object WeakMap]", Ev = "[object DataView]", Lee = hl(m0), xee = hl(N0), Uee = hl(v0), $ee = hl(g0), kee = hl(I0), Qi = MD;
(m0 && Qi(new m0(new ArrayBuffer(1))) != Ev || N0 && Qi(new N0()) != dv || v0 && Qi(v0.resolve()) != fv || g0 && Qi(new g0()) != hv || I0 && Qi(new I0()) != _v) && (Qi = function(t) {
  var e = MD(t), n = e == yee ? t.constructor : void 0, r = n ? hl(n) : "";
  if (r)
    switch (r) {
      case Lee:
        return Ev;
      case xee:
        return dv;
      case Uee:
        return fv;
      case $ee:
        return hv;
      case kee:
        return _v;
    }
  return e;
});
var su = Qi, $1 = Yf, Bee = CD, Gee = qQ, Fee = pee, pv = su, mv = ar, Nv = Hs.exports, Vee = dp, Hee = 1, vv = "[object Arguments]", gv = "[object Array]", Lu = "[object Object]", Wee = Object.prototype, Iv = Wee.hasOwnProperty;
function Yee(t, e, n, r, o, i) {
  var a = mv(t), s = mv(e), l = a ? gv : pv(t), c = s ? gv : pv(e);
  l = l == vv ? Lu : l, c = c == vv ? Lu : c;
  var u = l == Lu, d = c == Lu, f = l == c;
  if (f && Nv(t)) {
    if (!Nv(e))
      return !1;
    a = !0, u = !1;
  }
  if (f && !u)
    return i || (i = new $1()), a || Vee(t) ? Bee(t, e, n, r, o, i) : Gee(t, e, l, n, r, o, i);
  if (!(n & Hee)) {
    var h = u && Iv.call(t, "__wrapped__"), _ = d && Iv.call(e, "__wrapped__");
    if (h || _) {
      var E = h ? t.value() : t, m = _ ? e.value() : e;
      return i || (i = new $1()), o(E, m, n, r, i);
    }
  }
  return f ? (i || (i = new $1()), Fee(t, e, n, r, o, i)) : !1;
}
var Kee = Yee, zee = Kee, Ov = ir;
function PD(t, e, n, r, o) {
  return t === e ? !0 : t == null || e == null || !Ov(t) && !Ov(e) ? t !== t && e !== e : zee(t, e, n, r, PD, o);
}
var yD = PD, Zee = Yf, qee = yD, Xee = 1, jee = 2;
function Jee(t, e, n, r) {
  var o = n.length, i = o, a = !r;
  if (t == null)
    return !i;
  for (t = Object(t); o--; ) {
    var s = n[o];
    if (a && s[2] ? s[1] !== t[s[0]] : !(s[0] in t))
      return !1;
  }
  for (; ++o < i; ) {
    s = n[o];
    var l = s[0], c = t[l], u = s[1];
    if (a && s[2]) {
      if (c === void 0 && !(l in t))
        return !1;
    } else {
      var d = new Zee();
      if (r)
        var f = r(c, u, l, t, e, d);
      if (!(f === void 0 ? qee(u, c, Xee | jee, r, d) : f))
        return !1;
    }
  }
  return !0;
}
var Qee = Jee, ete = Rr;
function tte(t) {
  return t === t && !ete(t);
}
var LD = tte, nte = LD, rte = dl;
function ote(t) {
  for (var e = rte(t), n = e.length; n--; ) {
    var r = e[n], o = t[r];
    e[n] = [r, o, nte(o)];
  }
  return e;
}
var ite = ote;
function ate(t, e) {
  return function(n) {
    return n == null ? !1 : n[t] === e && (e !== void 0 || t in Object(n));
  };
}
var xD = ate, ste = Qee, lte = ite, cte = xD;
function ute(t) {
  var e = lte(t);
  return e.length == 1 && e[0][2] ? cte(e[0][0], e[0][1]) : function(n) {
    return n === t || ste(n, t, e);
  };
}
var dte = ute;
function fte(t, e) {
  return t != null && e in Object(t);
}
var hte = fte, _te = cl, Ete = Wf, pte = ar, mte = Hf, Nte = op, vte = ul;
function gte(t, e, n) {
  e = _te(e, t);
  for (var r = -1, o = e.length, i = !1; ++r < o; ) {
    var a = vte(e[r]);
    if (!(i = t != null && n(t, a)))
      break;
    t = t[a];
  }
  return i || ++r != o ? i : (o = t == null ? 0 : t.length, !!o && Nte(o) && mte(a, o) && (pte(t) || Ete(t)));
}
var UD = gte, Ite = hte, Ote = UD;
function Ate(t, e) {
  return t != null && Ote(t, e, Ite);
}
var $D = Ate, Dte = yD, Cte = Dc, Ste = $D, wte = ip, Tte = LD, bte = xD, Rte = ul, Mte = 1, Pte = 2;
function yte(t, e) {
  return wte(t) && Tte(e) ? bte(Rte(t), e) : function(n) {
    var r = Cte(n, t);
    return r === void 0 && r === e ? Ste(n, t) : Dte(e, r, Mte | Pte);
  };
}
var Lte = yte;
function xte(t) {
  return t;
}
var Ep = xte;
function Ute(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
var $te = Ute, kte = Ff;
function Bte(t) {
  return function(e) {
    return kte(e, t);
  };
}
var Gte = Bte, Fte = $te, Vte = Gte, Hte = ip, Wte = ul;
function Yte(t) {
  return Hte(t) ? Fte(Wte(t)) : Vte(t);
}
var Kte = Yte, zte = dte, Zte = Lte, qte = Ep, Xte = ar, jte = Kte;
function Jte(t) {
  return typeof t == "function" ? t : t == null ? qte : typeof t == "object" ? Xte(t) ? Zte(t[0], t[1]) : zte(t) : jte(t);
}
var kD = Jte, Qte = Vf, ene = AD, tne = kD;
function nne(t, e) {
  var n = {};
  return e = tne(e), ene(t, function(r, o, i) {
    Qte(n, o, e(r, o, i));
  }), n;
}
var rne = nne, one = cp;
function ine(t, e) {
  return one(e, function(n) {
    return [n, t[n]];
  });
}
var ane = ine;
function sne(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r) {
    n[++e] = [r, r];
  }), n;
}
var lne = sne, cne = ane, une = su, dne = wD, fne = lne, hne = "[object Map]", _ne = "[object Set]";
function Ene(t) {
  return function(e) {
    var n = une(e);
    return n == hne ? dne(e) : n == _ne ? fne(e) : cne(e, t(e));
  };
}
var pne = Ene, mne = pne, Nne = dl, vne = mne(Nne), od = vne;
function gne(t, e, n) {
  switch (n.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, n[0]);
    case 2:
      return t.call(e, n[0], n[1]);
    case 3:
      return t.call(e, n[0], n[1], n[2]);
  }
  return t.apply(e, n);
}
var BD = gne, Ine = BD, Av = Math.max;
function One(t, e, n) {
  return e = Av(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var r = arguments, o = -1, i = Av(r.length - e, 0), a = Array(i); ++o < i; )
      a[o] = r[e + o];
    o = -1;
    for (var s = Array(e + 1); ++o < e; )
      s[o] = r[o];
    return s[e] = n(a), Ine(t, this, s);
  };
}
var GD = One;
function Ane(t) {
  return function() {
    return t;
  };
}
var Dne = Ane, Cne = Dne, Dv = mD, Sne = Ep, wne = Dv ? function(t, e) {
  return Dv(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Cne(e),
    writable: !0
  });
} : Sne, Tne = wne, bne = 800, Rne = 16, Mne = Date.now;
function Pne(t) {
  var e = 0, n = 0;
  return function() {
    var r = Mne(), o = Rne - (r - n);
    if (n = r, o > 0) {
      if (++e >= bne)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
var yne = Pne, Lne = Tne, xne = yne, Une = xne(Lne), FD = Une, $ne = Ep, kne = GD, Bne = FD;
function Gne(t, e) {
  return Bne(kne(t, e, $ne), t + "");
}
var pp = Gne, Fne = al, Vne = au, Hne = Hf, Wne = Rr;
function Yne(t, e, n) {
  if (!Wne(n))
    return !1;
  var r = typeof e;
  return (r == "number" ? Vne(n) && Hne(e, n.length) : r == "string" && e in n) ? Fne(n[e], t) : !1;
}
var mp = Yne;
function Kne(t) {
  var e = [];
  if (t != null)
    for (var n in Object(t))
      e.push(n);
  return e;
}
var zne = Kne, Zne = Rr, qne = fp, Xne = zne, jne = Object.prototype, Jne = jne.hasOwnProperty;
function Qne(t) {
  if (!Zne(t))
    return Xne(t);
  var e = qne(t), n = [];
  for (var r in t)
    r == "constructor" && (e || !Jne.call(t, r)) || n.push(r);
  return n;
}
var ere = Qne, tre = ID, nre = ere, rre = au;
function ore(t) {
  return rre(t) ? tre(t, !0) : nre(t);
}
var _l = ore, ire = pp, are = al, sre = mp, lre = _l, VD = Object.prototype, cre = VD.hasOwnProperty, ure = ire(function(t, e) {
  t = Object(t);
  var n = -1, r = e.length, o = r > 2 ? e[2] : void 0;
  for (o && sre(e[0], e[1], o) && (r = 1); ++n < r; )
    for (var i = e[n], a = lre(i), s = -1, l = a.length; ++s < l; ) {
      var c = a[s], u = t[c];
      (u === void 0 || are(u, VD[c]) && !cre.call(t, c)) && (t[c] = i[c]);
    }
  return t;
}), Zl = ure, dre = Vf, fre = al;
function hre(t, e, n) {
  (n !== void 0 && !fre(t[e], n) || n === void 0 && !(e in t)) && dre(t, e, n);
}
var HD = hre, Ld = { exports: {} };
(function(t, e) {
  var n = Oo, r = e && !e.nodeType && e, o = r && !0 && t && !t.nodeType && t, i = o && o.exports === r, a = i ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
  function l(c, u) {
    if (u)
      return c.slice();
    var d = c.length, f = s ? s(d) : new c.constructor(d);
    return c.copy(f), f;
  }
  t.exports = l;
})(Ld, Ld.exports);
var Cv = SD;
function _re(t) {
  var e = new t.constructor(t.byteLength);
  return new Cv(e).set(new Cv(t)), e;
}
var Np = _re, Ere = Np;
function pre(t, e) {
  var n = e ? Ere(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.length);
}
var WD = pre;
function mre(t, e) {
  var n = -1, r = t.length;
  for (e || (e = Array(r)); ++n < r; )
    e[n] = t[n];
  return e;
}
var YD = mre, Nre = Rr, Sv = Object.create, vre = function() {
  function t() {
  }
  return function(e) {
    if (!Nre(e))
      return {};
    if (Sv)
      return Sv(e);
    t.prototype = e;
    var n = new t();
    return t.prototype = void 0, n;
  };
}(), gre = vre, Ire = OD, Ore = Ire(Object.getPrototypeOf, Object), vp = Ore, Are = gre, Dre = vp, Cre = fp;
function Sre(t) {
  return typeof t.constructor == "function" && !Cre(t) ? Are(Dre(t)) : {};
}
var KD = Sre, wre = Ao, Tre = vp, bre = ir, Rre = "[object Object]", Mre = Function.prototype, Pre = Object.prototype, zD = Mre.toString, yre = Pre.hasOwnProperty, Lre = zD.call(Object);
function xre(t) {
  if (!bre(t) || wre(t) != Rre)
    return !1;
  var e = Tre(t);
  if (e === null)
    return !0;
  var n = yre.call(e, "constructor") && e.constructor;
  return typeof n == "function" && n instanceof n && zD.call(n) == Lre;
}
var ZD = xre;
function Ure(t, e) {
  if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
    return t[e];
}
var qD = Ure, $re = up, kre = Vf;
function Bre(t, e, n, r) {
  var o = !n;
  n || (n = {});
  for (var i = -1, a = e.length; ++i < a; ) {
    var s = e[i], l = r ? r(n[s], t[s], s, n, t) : void 0;
    l === void 0 && (l = t[s]), o ? kre(n, s, l) : $re(n, s, l);
  }
  return n;
}
var El = Bre, Gre = El, Fre = _l;
function Vre(t) {
  return Gre(t, Fre(t));
}
var Hre = Vre, wv = HD, Wre = Ld.exports, Yre = WD, Kre = YD, zre = KD, Tv = Wf, bv = ar, Zre = Fn, qre = Hs.exports, Xre = Go, jre = Rr, Jre = ZD, Qre = dp, Rv = qD, eoe = Hre;
function toe(t, e, n, r, o, i, a) {
  var s = Rv(t, n), l = Rv(e, n), c = a.get(l);
  if (c) {
    wv(t, n, c);
    return;
  }
  var u = i ? i(s, l, n + "", t, e, a) : void 0, d = u === void 0;
  if (d) {
    var f = bv(l), h = !f && qre(l), _ = !f && !h && Qre(l);
    u = l, f || h || _ ? bv(s) ? u = s : Zre(s) ? u = Kre(s) : h ? (d = !1, u = Wre(l, !0)) : _ ? (d = !1, u = Yre(l, !0)) : u = [] : Jre(l) || Tv(l) ? (u = s, Tv(s) ? u = eoe(s) : (!jre(s) || Xre(s)) && (u = zre(l))) : d = !1;
  }
  d && (a.set(l, u), o(u, l, r, i, a), a.delete(l)), wv(t, n, u);
}
var noe = toe, roe = Yf, ooe = HD, ioe = vD, aoe = noe, soe = Rr, loe = _l, coe = qD;
function XD(t, e, n, r, o) {
  t !== e && ioe(e, function(i, a) {
    if (o || (o = new roe()), soe(i))
      aoe(t, e, a, n, XD, r, o);
    else {
      var s = r ? r(coe(t, a), i, a + "", t, e, o) : void 0;
      s === void 0 && (s = i), ooe(t, a, s);
    }
  }, loe);
}
var jD = XD, uoe = jD, Mv = Rr;
function JD(t, e, n, r, o, i) {
  return Mv(t) && Mv(e) && (i.set(e, t), uoe(t, e, void 0, JD, i), i.delete(e)), t;
}
var doe = JD, foe = pp, hoe = mp;
function _oe(t) {
  return foe(function(e, n) {
    var r = -1, o = n.length, i = o > 1 ? n[o - 1] : void 0, a = o > 2 ? n[2] : void 0;
    for (i = t.length > 3 && typeof i == "function" ? (o--, i) : void 0, a && hoe(n[0], n[1], a) && (i = o < 3 ? void 0 : i, o = 1), e = Object(e); ++r < o; ) {
      var s = n[r];
      s && t(e, s, r, i);
    }
    return e;
  });
}
var Eoe = _oe, poe = jD, moe = Eoe, Noe = moe(function(t, e, n, r) {
  poe(t, e, n, r);
}), voe = Noe, goe = BD, Ioe = pp, Ooe = doe, Aoe = voe, Doe = Ioe(function(t) {
  return t.push(void 0, Ooe), goe(Aoe, void 0, t);
}), gp = Doe, Coe = Ff, Soe = ND, woe = cl;
function Toe(t, e, n) {
  for (var r = -1, o = e.length, i = {}; ++r < o; ) {
    var a = e[r], s = Coe(t, a);
    n(s, a) && Soe(i, woe(a, t), s);
  }
  return i;
}
var boe = Toe, Roe = boe, Moe = $D;
function Poe(t, e) {
  return Roe(t, e, function(n, r) {
    return Moe(t, r);
  });
}
var yoe = Poe, Pv = ol, Loe = Wf, xoe = ar, yv = Pv ? Pv.isConcatSpreadable : void 0;
function Uoe(t) {
  return xoe(t) || Loe(t) || !!(yv && t && t[yv]);
}
var $oe = Uoe, koe = hp, Boe = $oe;
function QD(t, e, n, r, o) {
  var i = -1, a = t.length;
  for (n || (n = Boe), o || (o = []); ++i < a; ) {
    var s = t[i];
    e > 0 && n(s) ? e > 1 ? QD(s, e - 1, n, r, o) : koe(o, s) : r || (o[o.length] = s);
  }
  return o;
}
var Goe = QD, Foe = Goe;
function Voe(t) {
  var e = t == null ? 0 : t.length;
  return e ? Foe(t, 1) : [];
}
var Hoe = Voe, Woe = Hoe, Yoe = GD, Koe = FD;
function zoe(t) {
  return Koe(Yoe(t, void 0, Woe), t + "");
}
var e6 = zoe, Zoe = yoe, qoe = e6, Xoe = qoe(function(t, e) {
  return t == null ? {} : Zoe(t, e);
}), joe = Xoe;
function Joe(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r && e(t[n], n, t) !== !1; )
    ;
  return t;
}
var Qoe = Joe, eie = El, tie = dl;
function nie(t, e) {
  return t && eie(e, tie(e), t);
}
var rie = nie, oie = El, iie = _l;
function aie(t, e) {
  return t && oie(e, iie(e), t);
}
var sie = aie, lie = El, cie = _p;
function uie(t, e) {
  return lie(t, cie(t), e);
}
var die = uie, fie = hp, hie = vp, _ie = _p, Eie = bD, pie = Object.getOwnPropertySymbols, mie = pie ? function(t) {
  for (var e = []; t; )
    fie(e, _ie(t)), t = hie(t);
  return e;
} : Eie, t6 = mie, Nie = El, vie = t6;
function gie(t, e) {
  return Nie(t, vie(t), e);
}
var Iie = gie, Oie = TD, Aie = t6, Die = _l;
function Cie(t) {
  return Oie(t, Die, Aie);
}
var n6 = Cie, Sie = Object.prototype, wie = Sie.hasOwnProperty;
function Tie(t) {
  var e = t.length, n = new t.constructor(e);
  return e && typeof t[0] == "string" && wie.call(t, "index") && (n.index = t.index, n.input = t.input), n;
}
var bie = Tie, Rie = Np;
function Mie(t, e) {
  var n = e ? Rie(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.byteLength);
}
var Pie = Mie, yie = /\w*$/;
function Lie(t) {
  var e = new t.constructor(t.source, yie.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var xie = Lie, Lv = ol, xv = Lv ? Lv.prototype : void 0, Uv = xv ? xv.valueOf : void 0;
function Uie(t) {
  return Uv ? Object(Uv.call(t)) : {};
}
var $ie = Uie, kie = Np, Bie = Pie, Gie = xie, Fie = $ie, Vie = WD, Hie = "[object Boolean]", Wie = "[object Date]", Yie = "[object Map]", Kie = "[object Number]", zie = "[object RegExp]", Zie = "[object Set]", qie = "[object String]", Xie = "[object Symbol]", jie = "[object ArrayBuffer]", Jie = "[object DataView]", Qie = "[object Float32Array]", eae = "[object Float64Array]", tae = "[object Int8Array]", nae = "[object Int16Array]", rae = "[object Int32Array]", oae = "[object Uint8Array]", iae = "[object Uint8ClampedArray]", aae = "[object Uint16Array]", sae = "[object Uint32Array]";
function lae(t, e, n) {
  var r = t.constructor;
  switch (e) {
    case jie:
      return kie(t);
    case Hie:
    case Wie:
      return new r(+t);
    case Jie:
      return Bie(t, n);
    case Qie:
    case eae:
    case tae:
    case nae:
    case rae:
    case oae:
    case iae:
    case aae:
    case sae:
      return Vie(t, n);
    case Yie:
      return new r();
    case Kie:
    case qie:
      return new r(t);
    case zie:
      return Gie(t);
    case Zie:
      return new r();
    case Xie:
      return Fie(t);
  }
}
var cae = lae, uae = su, dae = ir, fae = "[object Map]";
function hae(t) {
  return dae(t) && uae(t) == fae;
}
var _ae = hae, Eae = _ae, pae = xf, $v = Vs.exports, kv = $v && $v.isMap, mae = kv ? pae(kv) : Eae, Nae = mae, vae = su, gae = ir, Iae = "[object Set]";
function Oae(t) {
  return gae(t) && vae(t) == Iae;
}
var Aae = Oae, Dae = Aae, Cae = xf, Bv = Vs.exports, Gv = Bv && Bv.isSet, Sae = Gv ? Cae(Gv) : Dae, wae = Sae, Tae = Yf, bae = Qoe, Rae = up, Mae = rie, Pae = sie, yae = Ld.exports, Lae = YD, xae = die, Uae = Iie, $ae = RD, kae = n6, Bae = su, Gae = bie, Fae = cae, Vae = KD, Hae = ar, Wae = Hs.exports, Yae = Nae, Kae = Rr, zae = wae, Zae = dl, qae = _l, Xae = 1, jae = 2, Jae = 4, r6 = "[object Arguments]", Qae = "[object Array]", ese = "[object Boolean]", tse = "[object Date]", nse = "[object Error]", o6 = "[object Function]", rse = "[object GeneratorFunction]", ose = "[object Map]", ise = "[object Number]", i6 = "[object Object]", ase = "[object RegExp]", sse = "[object Set]", lse = "[object String]", cse = "[object Symbol]", use = "[object WeakMap]", dse = "[object ArrayBuffer]", fse = "[object DataView]", hse = "[object Float32Array]", _se = "[object Float64Array]", Ese = "[object Int8Array]", pse = "[object Int16Array]", mse = "[object Int32Array]", Nse = "[object Uint8Array]", vse = "[object Uint8ClampedArray]", gse = "[object Uint16Array]", Ise = "[object Uint32Array]", It = {};
It[r6] = It[Qae] = It[dse] = It[fse] = It[ese] = It[tse] = It[hse] = It[_se] = It[Ese] = It[pse] = It[mse] = It[ose] = It[ise] = It[i6] = It[ase] = It[sse] = It[lse] = It[cse] = It[Nse] = It[vse] = It[gse] = It[Ise] = !0;
It[nse] = It[o6] = It[use] = !1;
function id(t, e, n, r, o, i) {
  var a, s = e & Xae, l = e & jae, c = e & Jae;
  if (n && (a = o ? n(t, r, o, i) : n(t)), a !== void 0)
    return a;
  if (!Kae(t))
    return t;
  var u = Hae(t);
  if (u) {
    if (a = Gae(t), !s)
      return Lae(t, a);
  } else {
    var d = Bae(t), f = d == o6 || d == rse;
    if (Wae(t))
      return yae(t, s);
    if (d == i6 || d == r6 || f && !o) {
      if (a = l || f ? {} : Vae(t), !s)
        return l ? Uae(t, Pae(a, t)) : xae(t, Mae(a, t));
    } else {
      if (!It[d])
        return o ? t : {};
      a = Fae(t, d, s);
    }
  }
  i || (i = new Tae());
  var h = i.get(t);
  if (h)
    return h;
  i.set(t, a), zae(t) ? t.forEach(function(m) {
    a.add(id(m, e, n, m, t, i));
  }) : Yae(t) && t.forEach(function(m, N) {
    a.set(N, id(m, e, n, N, t, i));
  });
  var _ = c ? l ? kae : $ae : l ? qae : Zae, E = u ? void 0 : _(t);
  return bae(E || t, function(m, N) {
    E && (N = m, m = t[N]), Rae(a, N, id(m, e, n, N, t, i));
  }), a;
}
var Ose = id;
function Ase(t) {
  var e = t == null ? 0 : t.length;
  return e ? t[e - 1] : void 0;
}
var Cc = Ase;
function Dse(t, e, n) {
  var r = -1, o = t.length;
  e < 0 && (e = -e > o ? 0 : o + e), n = n > o ? o : n, n < 0 && (n += o), o = e > n ? 0 : n - e >>> 0, e >>>= 0;
  for (var i = Array(o); ++r < o; )
    i[r] = t[r + e];
  return i;
}
var Cse = Dse, Sse = Ff, wse = Cse;
function Tse(t, e) {
  return e.length < 2 ? t : Sse(t, wse(e, 0, -1));
}
var bse = Tse, Rse = cl, Mse = Cc, Pse = bse, yse = ul;
function Lse(t, e) {
  return e = Rse(e, t), t = Pse(t, e), t == null || delete t[yse(Mse(e))];
}
var xse = Lse, Use = ZD;
function $se(t) {
  return Use(t) ? void 0 : t;
}
var kse = $se, Bse = cp, Gse = Ose, Fse = xse, Vse = cl, Hse = El, Wse = kse, Yse = e6, Kse = n6, zse = 1, Zse = 2, qse = 4, Xse = Yse(function(t, e) {
  var n = {};
  if (t == null)
    return n;
  var r = !1;
  e = Bse(e, function(i) {
    return i = Vse(i, t), r || (r = i.length > 1), i;
  }), Hse(t, Kse(t), n), r && (n = Gse(n, zse | Zse | qse, Wse));
  for (var o = e.length; o--; )
    Fse(n, e[o]);
  return n;
}), O0 = Xse, jse = Object.prototype, Jse = jse.hasOwnProperty;
function Qse(t, e) {
  return t != null && Jse.call(t, e);
}
var ele = Qse, tle = ele, nle = UD;
function rle(t, e) {
  return t != null && nle(t, e, tle);
}
var a6 = rle, ole = au;
function ile(t, e) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!ole(n))
      return t(n, r);
    for (var o = n.length, i = e ? o : -1, a = Object(n); (e ? i-- : ++i < o) && r(a[i], i, a) !== !1; )
      ;
    return n;
  };
}
var ale = ile, sle = AD, lle = ale, cle = lle(sle), ule = cle;
function dle(t) {
  return t && t.length ? t[0] : void 0;
}
var s6 = dle, fle = ule;
function hle(t, e) {
  var n;
  return fle(t, function(r, o, i) {
    return n = e(r, o, i), !n;
  }), !!n;
}
var _le = hle, Ele = DD, ple = kD, mle = _le, Nle = ar, vle = mp;
function gle(t, e, n) {
  var r = Nle(t) ? Ele : mle;
  return n && vle(t, e, n) && (e = void 0), r(t, ple(e));
}
var l6 = gle;
const Ile = (t) => Object.prototype.toString.call(t).slice(8, -1), gi = (t) => eZ(t) && !isNaN(t.getTime()), _r = (t) => Ile(t) === "Object", Ip = a6, A0 = (t, e) => l6(e, (n) => a6(t, n)), Ole = l6, nt = (t, e, n = "0") => {
  for (t = t != null ? String(t) : "", e = e || 2; t.length < e; )
    t = `${n}${t}`;
  return t;
}, Ale = (...t) => {
  const e = {};
  return t.forEach((n) => Object.entries(n).forEach(([r, o]) => {
    e[r] ? Fn(e[r]) ? e[r].push(o) : e[r] = [e[r], o] : e[r] = o;
  })), e;
}, Qn = (t) => !!(t && t.month && t.year), Ul = (t, e) => !Qn(t) || !Qn(e) ? !1 : t.year === e.year ? t.month < e.month : t.year < e.year, ql = (t, e) => !Qn(t) || !Qn(e) ? !1 : t.year === e.year ? t.month > e.month : t.year > e.year, c6 = (t, e, n) => (t || !1) && !Ul(t, e) && !ql(t, n), k1 = (t, e) => !t && e || t && !e ? !1 : !t && !e ? !0 : t.month === e.month && t.year === e.year, Mo = ({ month: t, year: e }, n) => {
  const r = n > 0 ? 1 : -1;
  for (let o = 0; o < Math.abs(n); o++)
    t += r, t > 12 ? (t = 1, e++) : t < 1 && (t = 12, e--);
  return {
    month: t,
    year: e
  };
}, Dle = (t, e) => {
  if (!Qn(t) || !Qn(e))
    return [];
  const n = [];
  for (; !ql(t, e); )
    n.push(t), t = Mo(t, 1);
  return n;
};
function B1(t, e) {
  const n = gi(t), r = gi(e);
  return !n && !r ? !0 : n !== r ? !1 : t.getTime() === e.getTime();
}
const ur = (t) => Fn(t) && t.length > 0, Fv = (t, e, n) => {
  const r = [];
  return n.forEach((o) => {
    const i = o.name || o.toString(), a = o.mixin, s = o.validate;
    if (Object.prototype.hasOwnProperty.call(t, i)) {
      const l = s ? s(t[i]) : t[i];
      e[i] = a && _r(l) ? be(be({}, a), l) : l, r.push(i);
    }
  }), {
    target: e,
    assigned: r.length ? r : null
  };
}, bn = (t, e, n, r) => {
  t && e && n && t.addEventListener(e, n, r);
}, Rn = (t, e, n, r) => {
  t && e && t.removeEventListener(e, n, r);
}, Xl = (t, e) => !!t && !!e && (t === e || t.contains(e)), u6 = (t, e) => {
  (t.key === " " || t.key === "Enter") && (e(t), t.preventDefault());
}, xd = () => {
  function t() {
    return ((1 + Math.random()) * 65536 | 0).toString(16).substring(1);
  }
  return `${t() + t()}-${t()}-${t()}-${t()}-${t()}${t()}${t()}`;
};
function Cle(t) {
  let e = 0, n = 0, r;
  if (t.length === 0)
    return e;
  for (n = 0; n < t.length; n++)
    r = t.charCodeAt(n), e = (e << 5) - e + r, e |= 0;
  return e;
}
var pl = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [r, o] of e)
    n[r] = o;
  return n;
};
const Sle = {
  name: "CustomTransition",
  emits: [
    "before-enter",
    "before-transition",
    "after-enter",
    "after-transition"
  ],
  props: {
    name: String,
    appear: Boolean
  },
  computed: {
    name_() {
      return `vc-${this.name || "none"}`;
    }
  },
  methods: {
    beforeEnter(t) {
      this.$emit("before-enter", t), this.$emit("before-transition", t);
    },
    afterEnter(t) {
      this.$emit("after-enter", t), this.$emit("after-transition", t);
    }
  }
};
function wle(t, e, n, r, o, i) {
  return v(), te(Zt, {
    name: i.name_,
    appear: n.appear,
    onBeforeEnter: i.beforeEnter,
    onAfterEnter: i.afterEnter
  }, {
    default: q(() => [
      ue(t.$slots, "default")
    ]),
    _: 3
  }, 8, ["name", "appear", "onBeforeEnter", "onAfterEnter"]);
}
var d6 = /* @__PURE__ */ pl(Sle, [["render", wle]]);
const D0 = {
  name: "Popover",
  emits: ["before-show", "after-show", "before-hide", "after-hide"],
  render() {
    return Me("div", {
      class: [
        "vc-popover-content-wrapper",
        {
          "is-interactive": this.isInteractive
        }
      ],
      ref: "popover"
    }, [
      Me(d6, {
        name: this.transition,
        appear: !0,
        "on-before-enter": this.beforeEnter,
        "on-after-enter": this.afterEnter,
        "on-before-leave": this.beforeLeave,
        "on-after-leave": this.afterLeave
      }, {
        default: () => this.isVisible ? Me("div", {
          tabindex: -1,
          class: [
            "vc-popover-content",
            `direction-${this.direction}`,
            this.contentClass
          ],
          style: this.contentStyle
        }, [
          this.content,
          Me("span", {
            class: [
              "vc-popover-caret",
              `direction-${this.direction}`,
              `align-${this.alignment}`
            ]
          })
        ]) : null
      })
    ]);
  },
  props: {
    id: { type: String, required: !0 },
    contentClass: String
  },
  data() {
    return {
      ref: null,
      opts: null,
      data: null,
      transition: "slide-fade",
      transitionTranslate: "15px",
      transitionDuration: "0.15s",
      placement: "bottom",
      positionFixed: !1,
      modifiers: [],
      isInteractive: !1,
      isHovered: !1,
      isFocused: !1,
      showDelay: 0,
      hideDelay: 110,
      autoHide: !1,
      popperEl: null
    };
  },
  computed: {
    content() {
      return Go(this.$slots.default) && this.$slots.default({
        direction: this.direction,
        alignment: this.alignment,
        data: this.data,
        updateLayout: this.setupPopper,
        hide: (t) => this.hide(t)
      }) || this.$slots.default;
    },
    contentStyle() {
      return {
        "--slide-translate": this.transitionTranslate,
        "--slide-duration": this.transitionDuration
      };
    },
    popperOptions() {
      return {
        placement: this.placement,
        strategy: this.positionFixed ? "fixed" : "absolute",
        modifiers: [
          {
            name: "onUpdate",
            enabled: !0,
            phase: "afterWrite",
            fn: this.onPopperUpdate
          },
          ...this.modifiers || []
        ],
        onFirstUpdate: this.onPopperUpdate
      };
    },
    isVisible() {
      return !!(this.ref && this.content);
    },
    direction() {
      return this.placement && this.placement.split("-")[0] || "bottom";
    },
    alignment() {
      const t = this.direction === "left" || this.direction === "right";
      let e = this.placement.split("-");
      return e = e.length > 1 ? e[1] : "", ["start", "top", "left"].includes(e) ? t ? "top" : "left" : ["end", "bottom", "right"].includes(e) ? t ? "bottom" : "right" : t ? "middle" : "center";
    }
  },
  watch: {
    opts(t, e) {
      e && e.callback && e.callback(tt(be({}, e), {
        completed: !t,
        reason: t ? "Overridden by action" : null
      }));
    }
  },
  mounted() {
    this.popoverEl = this.$refs.popover, this.addEvents();
  },
  beforeUnmount() {
    this.destroyPopper(), this.removeEvents(), this.popoverEl = null;
  },
  methods: {
    addEvents() {
      bn(this.popoverEl, "click", this.onClick), bn(this.popoverEl, "mouseover", this.onMouseOver), bn(this.popoverEl, "mouseleave", this.onMouseLeave), bn(this.popoverEl, "focusin", this.onFocusIn), bn(this.popoverEl, "focusout", this.onFocusOut), bn(document, "keydown", this.onDocumentKeydown), bn(document, "click", this.onDocumentClick), bn(document, "show-popover", this.onDocumentShowPopover), bn(document, "hide-popover", this.onDocumentHidePopover), bn(document, "toggle-popover", this.onDocumentTogglePopover), bn(document, "update-popover", this.onDocumentUpdatePopover);
    },
    removeEvents() {
      Rn(this.popoverEl, "click", this.onClick), Rn(this.popoverEl, "mouseover", this.onMouseOver), Rn(this.popoverEl, "mouseleave", this.onMouseLeave), Rn(this.popoverEl, "focusin", this.onFocusIn), Rn(this.popoverEl, "focusout", this.onFocusOut), Rn(document, "keydown", this.onDocumentKeydown), Rn(document, "click", this.onDocumentClick), Rn(document, "show-popover", this.onDocumentShowPopover), Rn(document, "hide-popover", this.onDocumentHidePopover), Rn(document, "toggle-popover", this.onDocumentTogglePopover), Rn(document, "update-popover", this.onDocumentUpdatePopover);
    },
    onClick(t) {
      t.stopPropagation();
    },
    onMouseOver() {
      this.isHovered = !0, this.isInteractive && this.show();
    },
    onMouseLeave() {
      this.isHovered = !1, this.autoHide && !this.isFocused && (!this.ref || this.ref !== document.activeElement) && this.hide();
    },
    onFocusIn() {
      this.isFocused = !0, this.isInteractive && this.show();
    },
    onFocusOut(t) {
      (!t.relatedTarget || !Xl(this.popoverEl, t.relatedTarget)) && (this.isFocused = !1, !this.isHovered && this.autoHide && this.hide());
    },
    onDocumentClick(t) {
      !this.$refs.popover || !this.ref || Xl(this.popoverEl, t.target) || Xl(this.ref, t.target) || this.hide();
    },
    onDocumentKeydown(t) {
      (t.key === "Esc" || t.key === "Escape") && this.hide();
    },
    onDocumentShowPopover({ detail: t }) {
      !t.id || t.id !== this.id || this.show(t);
    },
    onDocumentHidePopover({ detail: t }) {
      !t.id || t.id !== this.id || this.hide(t);
    },
    onDocumentTogglePopover({ detail: t }) {
      !t.id || t.id !== this.id || this.toggle(t);
    },
    onDocumentUpdatePopover({ detail: t }) {
      !t.id || t.id !== this.id || this.update(t);
    },
    show(t = {}) {
      t.action = "show";
      const e = t.ref || this.ref, n = t.showDelay >= 0 ? t.showDelay : this.showDelay;
      if (!e) {
        t.callback && t.callback({
          completed: !1,
          reason: "Invalid reference element provided"
        });
        return;
      }
      clearTimeout(this.timeout), this.opts = t;
      const r = () => {
        Object.assign(this, O0(t, ["id"])), this.setupPopper(), this.opts = null;
      };
      n > 0 ? this.timeout = setTimeout(() => r(), n) : r();
    },
    hide(t = {}) {
      t.action = "hide";
      const e = t.ref || this.ref, n = t.hideDelay >= 0 ? t.hideDelay : this.hideDelay;
      if (!this.ref || e !== this.ref) {
        t.callback && t.callback(tt(be({}, t), {
          completed: !1,
          reason: this.ref ? "Invalid reference element provided" : "Popover already hidden"
        }));
        return;
      }
      const r = () => {
        this.ref = null, this.opts = null;
      };
      clearTimeout(this.timeout), this.opts = t, n > 0 ? this.timeout = setTimeout(r, n) : r();
    },
    toggle(t = {}) {
      this.isVisible && t.ref === this.ref ? this.hide(t) : this.show(t);
    },
    update(t = {}) {
      Object.assign(this, O0(t, ["id"])), this.setupPopper();
    },
    setupPopper() {
      this.$nextTick(() => {
        !this.ref || !this.$refs.popover || (this.popper && this.popper.reference !== this.ref && this.destroyPopper(), this.popper ? this.popper.update() : this.popper = FK(this.ref, this.popoverEl, this.popperOptions));
      });
    },
    onPopperUpdate(t) {
      t.placement ? this.placement = t.placement : t.state && (this.placement = t.state.placement);
    },
    beforeEnter(t) {
      this.$emit("before-show", t);
    },
    afterEnter(t) {
      this.$emit("after-show", t);
    },
    beforeLeave(t) {
      this.$emit("before-hide", t);
    },
    afterLeave(t) {
      this.destroyPopper(), this.$emit("after-hide", t);
    },
    destroyPopper() {
      this.popper && (this.popper.destroy(), this.popper = null);
    }
  }
}, Tle = {
  inject: ["sharedState"],
  computed: {
    masks() {
      return this.sharedState.masks;
    },
    theme() {
      return this.sharedState.theme;
    },
    locale() {
      return this.sharedState.locale;
    },
    dayPopoverId() {
      return this.sharedState.dayPopoverId;
    }
  },
  methods: {
    format(t, e) {
      return this.locale.format(t, e);
    },
    pageForDate(t) {
      return this.locale.getDateParts(this.locale.normalizeDate(t));
    }
  }
}, ble = ["base", "start", "end", "startEnd"], Rle = [
  "class",
  "contentClass",
  "style",
  "contentStyle",
  "color",
  "fillMode"
], Mle = {
  color: "blue",
  isDark: !1,
  highlight: {
    base: { fillMode: "light" },
    start: { fillMode: "solid" },
    end: { fillMode: "solid" }
  },
  dot: {
    base: { fillMode: "solid" },
    start: { fillMode: "solid" },
    end: { fillMode: "solid" }
  },
  bar: {
    base: { fillMode: "solid" },
    start: { fillMode: "solid" },
    end: { fillMode: "solid" }
  },
  content: {
    base: {},
    start: {},
    end: {}
  }
};
class Vv {
  constructor(e) {
    Object.assign(this, Mle, e);
  }
  normalizeAttr({ config: e, type: n }) {
    let r = this.color, o = {};
    const i = this[n];
    if (e === !0 || _i(e))
      r = _i(e) ? e : r, o = be({}, i);
    else if (_r(e))
      A0(e, ble) ? o = be({}, e) : o = {
        base: be({}, e),
        start: be({}, e),
        end: be({}, e)
      };
    else
      return null;
    return Zl(o, { start: o.startEnd, end: o.startEnd }, i), od(o).forEach(([a, s]) => {
      let l = r;
      s === !0 || _i(s) ? (l = _i(s) ? s : l, o[a] = { color: l }) : _r(s) && (A0(s, Rle) ? o[a] = be({}, s) : o[a] = {}), Ip(o, `${a}.color`) || mj(o, `${a}.color`, l);
    }), o;
  }
  normalizeHighlight(e) {
    const n = this.normalizeAttr({
      config: e,
      type: "highlight"
    });
    return od(n).forEach(([r, o]) => {
      const i = Zl(o, {
        isDark: this.isDark,
        color: this.color
      });
      o.style = be(be({}, this.getHighlightBgStyle(i)), o.style), o.contentStyle = be(be({}, this.getHighlightContentStyle(i)), o.contentStyle);
    }), n;
  }
  getHighlightBgStyle({ fillMode: e, color: n, isDark: r }) {
    switch (e) {
      case "outline":
      case "none":
        return {
          backgroundColor: r ? "var(--gray-900)" : "var(--white)",
          border: "2px solid",
          borderColor: r ? `var(--${n}-200)` : `var(--${n}-700)`,
          borderRadius: "var(--rounded-full)"
        };
      case "light":
        return {
          backgroundColor: r ? `var(--${n}-800)` : `var(--${n}-200)`,
          opacity: r ? 0.75 : 1,
          borderRadius: "var(--rounded-full)"
        };
      case "solid":
        return {
          backgroundColor: r ? `var(--${n}-500)` : `var(--${n}-600)`,
          borderRadius: "var(--rounded-full)"
        };
      default:
        return {
          borderRadius: "var(--rounded-full)"
        };
    }
  }
  getHighlightContentStyle({ fillMode: e, color: n, isDark: r }) {
    switch (e) {
      case "outline":
      case "none":
        return {
          fontWeight: "var(--font-bold)",
          color: r ? `var(--${n}-100)` : `var(--${n}-900)`
        };
      case "light":
        return {
          fontWeight: "var(--font-bold)",
          color: r ? `var(--${n}-100)` : `var(--${n}-900)`
        };
      case "solid":
        return {
          fontWeight: "var(--font-bold)",
          color: "var(--white)"
        };
      default:
        return "";
    }
  }
  bgAccentHigh({ color: e, isDark: n }) {
    return {
      backgroundColor: n ? `var(--${e}-500)` : `var(--${e}-600)`
    };
  }
  contentAccent({ color: e, isDark: n }) {
    return e ? {
      fontWeight: "var(--font-bold)",
      color: n ? `var(--${e}-100)` : `var(--${e}-900)`
    } : null;
  }
  normalizeDot(e) {
    return this.normalizeNonHighlight("dot", e, this.bgAccentHigh);
  }
  normalizeBar(e) {
    return this.normalizeNonHighlight("bar", e, this.bgAccentHigh);
  }
  normalizeContent(e) {
    return this.normalizeNonHighlight("content", e, this.contentAccent);
  }
  normalizeNonHighlight(e, n, r) {
    const o = this.normalizeAttr({ type: e, config: n });
    return od(o).forEach(([i, a]) => {
      Zl(a, { isDark: this.isDark, color: this.color }), a.style = be(be({}, r(a)), a.style);
    }), o;
  }
}
var ad = 6e4;
function Hv(t) {
  return t.getTime() % ad;
}
function Ud(t) {
  var e = new Date(t.getTime()), n = Math.ceil(e.getTimezoneOffset());
  e.setSeconds(0, 0);
  var r = n > 0, o = r ? (ad + Hv(e)) % ad : Hv(e);
  return n * ad + o;
}
function Ple(t, e) {
  var n = Ule(e);
  return n.formatToParts ? Lle(n, t) : xle(n, t);
}
var yle = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function Lle(t, e) {
  for (var n = t.formatToParts(e), r = [], o = 0; o < n.length; o++) {
    var i = yle[n[o].type];
    i >= 0 && (r[i] = parseInt(n[o].value, 10));
  }
  return r;
}
function xle(t, e) {
  var n = t.format(e).replace(/\u200E/g, ""), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [r[3], r[1], r[2], r[4], r[5], r[6]];
}
var G1 = {};
function Ule(t) {
  if (!G1[t]) {
    var e = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), n = e === "06/25/2014, 00:00:00" || e === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    G1[t] = n ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: t,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: t,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return G1[t];
}
var Wv = 36e5, $le = 6e4, xu = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-])(\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/,
  timezoneIANA: /(UTC|(?:[a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?))$/
};
function Yv(t, e) {
  var n, r;
  if (n = xu.timezoneZ.exec(t), n)
    return 0;
  var o;
  if (n = xu.timezoneHH.exec(t), n)
    return o = parseInt(n[2], 10), Kv() ? (r = o * Wv, n[1] === "+" ? -r : r) : NaN;
  if (n = xu.timezoneHHMM.exec(t), n) {
    o = parseInt(n[2], 10);
    var i = parseInt(n[3], 10);
    return Kv(o, i) ? (r = o * Wv + i * $le, n[1] === "+" ? -r : r) : NaN;
  }
  if (n = xu.timezoneIANA.exec(t), n) {
    var a = Ple(e, t), s = Date.UTC(a[0], a[1] - 1, a[2], a[3], a[4], a[5]), l = e.getTime() - e.getTime() % 1e3;
    return -(s - l);
  }
  return 0;
}
function Kv(t, e) {
  return !(e != null && (e < 0 || e > 59));
}
var F1 = 36e5, zv = 6e4, kle = 2, dn = {
  dateTimeDelimeter: /[T ]/,
  plainTime: /:/,
  timeZoneDelimeter: /[Z ]/i,
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    /^([+-]\d{3})$/,
    /^([+-]\d{4})$/
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    /^([+-]\d{5})/,
    /^([+-]\d{6})/
  ],
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  timezone: /([Z+-].*| UTC|(?:[a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?))$/
};
function Zv(t, e) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = e || {}, r = n.additionalDigits == null ? kle : po(n.additionalDigits);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]")
    return new Date(t.getTime());
  if (typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]")
    return new Date(t);
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var o = Ble(t), i = Gle(o.date, r), a = i.year, s = i.restDateString, l = Fle(s, a);
  if (isNaN(l))
    return /* @__PURE__ */ new Date(NaN);
  if (l) {
    var c = l.getTime(), u = 0, d;
    if (o.time && (u = Vle(o.time), isNaN(u)))
      return /* @__PURE__ */ new Date(NaN);
    if (o.timezone || n.timeZone) {
      if (d = Yv(o.timezone || n.timeZone, new Date(c + u)), isNaN(d))
        return /* @__PURE__ */ new Date(NaN);
      if (d = Yv(o.timezone || n.timeZone, new Date(c + u + d)), isNaN(d))
        return /* @__PURE__ */ new Date(NaN);
    } else
      d = Ud(new Date(c + u)), d = Ud(new Date(c + u + d));
    return new Date(c + u + d);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function Ble(t) {
  var e = {}, n = t.split(dn.dateTimeDelimeter), r;
  if (dn.plainTime.test(n[0]) ? (e.date = null, r = n[0]) : (e.date = n[0], r = n[1], e.timezone = n[2], dn.timeZoneDelimeter.test(e.date) && (e.date = t.split(dn.timeZoneDelimeter)[0], r = t.substr(e.date.length, t.length))), r) {
    var o = dn.timezone.exec(r);
    o ? (e.time = r.replace(o[1], ""), e.timezone = o[1]) : e.time = r;
  }
  return e;
}
function Gle(t, e) {
  var n = dn.YYY[e], r = dn.YYYYY[e], o;
  if (o = dn.YYYY.exec(t) || r.exec(t), o) {
    var i = o[1];
    return {
      year: parseInt(i, 10),
      restDateString: t.slice(i.length)
    };
  }
  if (o = dn.YY.exec(t) || n.exec(t), o) {
    var a = o[1];
    return {
      year: parseInt(a, 10) * 100,
      restDateString: t.slice(a.length)
    };
  }
  return {
    year: null
  };
}
function Fle(t, e) {
  if (e === null)
    return null;
  var n, r, o, i;
  if (t.length === 0)
    return r = /* @__PURE__ */ new Date(0), r.setUTCFullYear(e), r;
  if (n = dn.MM.exec(t), n)
    return r = /* @__PURE__ */ new Date(0), o = parseInt(n[1], 10) - 1, Xv(e, o) ? (r.setUTCFullYear(e, o), r) : /* @__PURE__ */ new Date(NaN);
  if (n = dn.DDD.exec(t), n) {
    r = /* @__PURE__ */ new Date(0);
    var a = parseInt(n[1], 10);
    return Yle(e, a) ? (r.setUTCFullYear(e, 0, a), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = dn.MMDD.exec(t), n) {
    r = /* @__PURE__ */ new Date(0), o = parseInt(n[1], 10) - 1;
    var s = parseInt(n[2], 10);
    return Xv(e, o, s) ? (r.setUTCFullYear(e, o, s), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = dn.Www.exec(t), n)
    return i = parseInt(n[1], 10) - 1, jv(e, i) ? qv(e, i) : /* @__PURE__ */ new Date(NaN);
  if (n = dn.WwwD.exec(t), n) {
    i = parseInt(n[1], 10) - 1;
    var l = parseInt(n[2], 10) - 1;
    return jv(e, i, l) ? qv(e, i, l) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function Vle(t) {
  var e, n, r;
  if (e = dn.HH.exec(t), e)
    return n = parseFloat(e[1].replace(",", ".")), V1(n) ? n % 24 * F1 : NaN;
  if (e = dn.HHMM.exec(t), e)
    return n = parseInt(e[1], 10), r = parseFloat(e[2].replace(",", ".")), V1(n, r) ? n % 24 * F1 + r * zv : NaN;
  if (e = dn.HHMMSS.exec(t), e) {
    n = parseInt(e[1], 10), r = parseInt(e[2], 10);
    var o = parseFloat(e[3].replace(",", "."));
    return V1(n, r, o) ? n % 24 * F1 + r * zv + o * 1e3 : NaN;
  }
  return null;
}
function qv(t, e, n) {
  e = e || 0, n = n || 0;
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  var o = r.getUTCDay() || 7, i = e * 7 + n + 1 - o;
  return r.setUTCDate(r.getUTCDate() + i), r;
}
var Hle = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Wle = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function f6(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function Xv(t, e, n) {
  if (e < 0 || e > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    var r = f6(t);
    if (r && n > Wle[e] || !r && n > Hle[e])
      return !1;
  }
  return !0;
}
function Yle(t, e) {
  if (e < 1)
    return !1;
  var n = f6(t);
  return !(n && e > 366 || !n && e > 365);
}
function jv(t, e, n) {
  return !(e < 0 || e > 52 || n != null && (n < 0 || n > 6));
}
function V1(t, e, n) {
  return !(t != null && (t < 0 || t >= 25) || e != null && (e < 0 || e >= 60) || n != null && (n < 0 || n >= 60));
}
function Ta(t, e) {
  On(1, arguments);
  var n = e || {}, r = n.locale, o = r && r.options && r.options.weekStartsOn, i = o == null ? 0 : po(o), a = n.weekStartsOn == null ? i : po(n.weekStartsOn);
  if (!(a >= 0 && a <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var s = Xo(t), l = s.getDay(), c = (l < a ? 7 : 0) + l - a;
  return s.setDate(s.getDate() - c), s.setHours(0, 0, 0, 0), s;
}
function $d(t) {
  return On(1, arguments), Ta(t, {
    weekStartsOn: 1
  });
}
function Kle(t) {
  On(1, arguments);
  var e = Xo(t), n = e.getFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  var o = $d(r), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  var a = $d(i);
  return e.getTime() >= o.getTime() ? n + 1 : e.getTime() >= a.getTime() ? n : n - 1;
}
function zle(t) {
  On(1, arguments);
  var e = Kle(t), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(e, 0, 4), n.setHours(0, 0, 0, 0);
  var r = $d(n);
  return r;
}
var Zle = 6048e5;
function qle(t) {
  On(1, arguments);
  var e = Xo(t), n = $d(e).getTime() - zle(e).getTime();
  return Math.round(n / Zle) + 1;
}
function Xle(t, e) {
  On(1, arguments);
  var n = Xo(t), r = n.getFullYear(), o = e || {}, i = o.locale, a = i && i.options && i.options.firstWeekContainsDate, s = a == null ? 1 : po(a), l = o.firstWeekContainsDate == null ? s : po(o.firstWeekContainsDate);
  if (!(l >= 1 && l <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var c = /* @__PURE__ */ new Date(0);
  c.setFullYear(r + 1, 0, l), c.setHours(0, 0, 0, 0);
  var u = Ta(c, e), d = /* @__PURE__ */ new Date(0);
  d.setFullYear(r, 0, l), d.setHours(0, 0, 0, 0);
  var f = Ta(d, e);
  return n.getTime() >= u.getTime() ? r + 1 : n.getTime() >= f.getTime() ? r : r - 1;
}
function jle(t, e) {
  On(1, arguments);
  var n = e || {}, r = n.locale, o = r && r.options && r.options.firstWeekContainsDate, i = o == null ? 1 : po(o), a = n.firstWeekContainsDate == null ? i : po(n.firstWeekContainsDate), s = Xle(t, e), l = /* @__PURE__ */ new Date(0);
  l.setFullYear(s, 0, a), l.setHours(0, 0, 0, 0);
  var c = Ta(l, e);
  return c;
}
var Jle = 6048e5;
function Qle(t, e) {
  On(1, arguments);
  var n = Xo(t), r = Ta(n, e).getTime() - jle(n, e).getTime();
  return Math.round(r / Jle) + 1;
}
var ece = 6048e5;
function tce(t, e, n) {
  On(2, arguments);
  var r = Ta(t, n), o = Ta(e, n), i = r.getTime() - Ud(r), a = o.getTime() - Ud(o);
  return Math.round((i - a) / ece);
}
function nce(t) {
  On(1, arguments);
  var e = Xo(t), n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(0, 0, 0, 0), e;
}
function rce(t) {
  On(1, arguments);
  var e = Xo(t);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function oce(t, e) {
  return On(1, arguments), tce(nce(t), rce(t), e) + 1;
}
const ice = 24 * 60 * 60 * 1e3;
class Yt {
  constructor(e, { order: n = 0, locale: r, isFullDay: o } = {}) {
    if (this.isDateInfo = !0, this.order = n, this.locale = r instanceof kd ? r : new kd(r), this.firstDayOfWeek = this.locale.firstDayOfWeek, !_r(e)) {
      const l = this.locale.normalizeDate(e);
      o ? e = {
        start: l,
        end: l
      } : e = {
        startOn: l,
        endOn: l
      };
    }
    let i = null, a = null;
    if (e.start ? i = this.locale.normalizeDate(e.start, tt(be({}, this.opts), {
      time: "00:00:00"
    })) : e.startOn && (i = this.locale.normalizeDate(e.startOn, this.opts)), e.end ? a = this.locale.normalizeDate(e.end, tt(be({}, this.opts), {
      time: "23:59:59"
    })) : e.endOn && (a = this.locale.normalizeDate(e.endOn, this.opts)), i && a && i > a) {
      const l = i;
      i = a, a = l;
    } else
      i && e.span >= 1 && (a = eo(i, e.span - 1));
    this.start = i, this.startTime = i ? i.getTime() : NaN, this.end = a, this.endTime = a ? a.getTime() : NaN, this.isDate = this.startTime && this.startTime === this.endTime, this.isRange = !this.isDate;
    const s = Fv(e, {}, Yt.patternProps);
    if (s.assigned && (this.on = { and: s.target }), e.on) {
      const l = (Fn(e.on) ? e.on : [e.on]).map((c) => {
        if (Go(c))
          return c;
        const u = Fv(c, {}, Yt.patternProps);
        return u.assigned ? u.target : null;
      }).filter((c) => c);
      l.length && (this.on = tt(be({}, this.on), { or: l }));
    }
    this.isComplex = !!this.on;
  }
  get opts() {
    return {
      order: this.order,
      locale: this.locale
    };
  }
  toDateInfo(e) {
    return e.isDateInfo ? e : new Yt(e, this.opts);
  }
  startOfWeek(e) {
    const n = e.getDay() + 1, r = n >= this.firstDayOfWeek ? this.firstDayOfWeek - n : -(7 - (this.firstDayOfWeek - n));
    return eo(e, r);
  }
  diffInDays(e, n) {
    return Math.round((n - e) / ice);
  }
  diffInWeeks(e, n) {
    return this.diffInDays(this.startOfWeek(e), this.startOfWeek(n));
  }
  diffInYears(e, n) {
    return n.getUTCFullYear() - e.getUTCFullYear();
  }
  diffInMonths(e, n) {
    return this.diffInYears(e, n) * 12 + (n.getMonth() - e.getMonth());
  }
  static get patterns() {
    return {
      dailyInterval: {
        test: (e, n, r) => r.diffInDays(r.start || /* @__PURE__ */ new Date(), e.date) % n === 0
      },
      weeklyInterval: {
        test: (e, n, r) => r.diffInWeeks(r.start || /* @__PURE__ */ new Date(), e.date) % n === 0
      },
      monthlyInterval: {
        test: (e, n, r) => r.diffInMonths(r.start || /* @__PURE__ */ new Date(), e.date) % n === 0
      },
      yearlyInterval: {
        test: () => (e, n, r) => r.diffInYears(r.start || /* @__PURE__ */ new Date(), e.date) % n === 0
      },
      days: {
        validate: (e) => Fn(e) ? e : [parseInt(e, 10)],
        test: (e, n) => n.includes(e.day) || n.includes(-e.dayFromEnd)
      },
      weekdays: {
        validate: (e) => Fn(e) ? e : [parseInt(e, 10)],
        test: (e, n) => n.includes(e.weekday)
      },
      ordinalWeekdays: {
        validate: (e) => Object.keys(e).reduce((n, r) => {
          const o = e[r];
          return o && (n[r] = Fn(o) ? o : [parseInt(o, 10)]), n;
        }, {}),
        test: (e, n) => Object.keys(n).map((r) => parseInt(r, 10)).find((r) => n[r].includes(e.weekday) && (r === e.weekdayOrdinal || r === -e.weekdayOrdinalFromEnd))
      },
      weekends: {
        validate: (e) => e,
        test: (e) => e.weekday === 1 || e.weekday === 7
      },
      workweek: {
        validate: (e) => e,
        test: (e) => e.weekday >= 2 && e.weekday <= 6
      },
      weeks: {
        validate: (e) => Fn(e) ? e : [parseInt(e, 10)],
        test: (e, n) => n.includes(e.week) || n.includes(-e.weekFromEnd)
      },
      months: {
        validate: (e) => Fn(e) ? e : [parseInt(e, 10)],
        test: (e, n) => n.includes(e.month)
      },
      years: {
        validate: (e) => Fn(e) ? e : [parseInt(e, 10)],
        test: (e, n) => n.includes(e.year)
      }
    };
  }
  static get patternProps() {
    return Object.keys(Yt.patterns).map((e) => ({
      name: e,
      validate: Yt.patterns[e].validate
    }));
  }
  static testConfig(e, n, r) {
    return Go(e) ? e(n) : _r(e) ? Object.keys(e).every((o) => Yt.patterns[o].test(n, e[o], r)) : null;
  }
  iterateDatesInRange({ start: e, end: n }, r) {
    if (!e || !n || !Go(r))
      return null;
    e = this.locale.normalizeDate(e, tt(be({}, this.opts), {
      time: "00:00:00"
    }));
    const o = {
      i: 0,
      date: e,
      day: this.locale.getDateParts(e),
      finished: !1
    };
    let i = null;
    for (; !o.finished && o.date <= n; o.i++)
      i = r(o), o.date = eo(o.date, 1), o.day = this.locale.getDateParts(o.date);
    return i;
  }
  shallowIntersectingRange(e) {
    return this.rangeShallowIntersectingRange(this, this.toDateInfo(e));
  }
  rangeShallowIntersectingRange(e, n) {
    if (!this.dateShallowIntersectsDate(e, n))
      return null;
    const r = e.toRange(), o = n.toRange();
    let i = null, a = null;
    return r.start ? o.start ? i = r.start > o.start ? r.start : o.start : i = r.start : o.start && (i = o.start), r.end ? o.end ? a = r.end < o.end ? r.end : o.end : a = r.end : o.end && (a = o.end), { start: i, end: a };
  }
  intersectsDate(e) {
    const n = this.toDateInfo(e);
    if (!this.shallowIntersectsDate(n))
      return null;
    if (!this.on)
      return this;
    const r = this.rangeShallowIntersectingRange(this, n);
    let o = !1;
    return this.iterateDatesInRange(r, (i) => {
      this.matchesDay(i.day) && (o = o || n.matchesDay(i.day), i.finished = o);
    }), o;
  }
  shallowIntersectsDate(e) {
    return this.dateShallowIntersectsDate(this, this.toDateInfo(e));
  }
  dateShallowIntersectsDate(e, n) {
    return e.isDate ? n.isDate ? e.startTime === n.startTime : this.dateShallowIncludesDate(n, e) : n.isDate ? this.dateShallowIncludesDate(e, n) : !(e.start && n.end && e.start > n.end || e.end && n.start && e.end < n.start);
  }
  includesDate(e) {
    const n = this.toDateInfo(e);
    if (!this.shallowIncludesDate(n))
      return !1;
    if (!this.on)
      return !0;
    const r = this.rangeShallowIntersectingRange(this, n);
    let o = !0;
    return this.iterateDatesInRange(r, (i) => {
      this.matchesDay(i.day) && (o = o && n.matchesDay(i.day), i.finished = !o);
    }), o;
  }
  shallowIncludesDate(e) {
    return this.dateShallowIncludesDate(this, e.isDate ? e : new Yt(e, this.opts));
  }
  dateShallowIncludesDate(e, n) {
    return e.isDate ? n.isDate ? e.startTime === n.startTime : !n.startTime || !n.endTime ? !1 : e.startTime === n.startTime && e.startTime === n.endTime : n.isDate ? !(e.start && n.start < e.start || e.end && n.start > e.end) : !(e.start && (!n.start || n.start < e.start) || e.end && (!n.end || n.end > e.end));
  }
  intersectsDay(e) {
    return this.shallowIntersectsDate(e.range) && this.matchesDay(e) ? this : null;
  }
  matchesDay(e) {
    return this.on ? !(this.on.and && !Yt.testConfig(this.on.and, e, this) || this.on.or && !this.on.or.some((n) => Yt.testConfig(n, e, this))) : !0;
  }
  toRange() {
    return new Yt({
      start: this.start,
      end: this.end
    }, this.opts);
  }
  compare(e) {
    if (this.order !== e.order)
      return this.order - e.order;
    if (this.isDate !== e.isDate)
      return this.isDate ? 1 : -1;
    if (this.isDate)
      return 0;
    const n = this.start - e.start;
    return n !== 0 ? n : this.end - e.end;
  }
}
const Cr = {
  ar: { dow: 7, L: "D/‏M/‏YYYY" },
  bg: { dow: 2, L: "D.MM.YYYY" },
  ca: { dow: 2, L: "DD/MM/YYYY" },
  "zh-CN": { dow: 2, L: "YYYY/MM/DD" },
  "zh-TW": { dow: 1, L: "YYYY/MM/DD" },
  hr: { dow: 2, L: "DD.MM.YYYY" },
  cs: { dow: 2, L: "DD.MM.YYYY" },
  da: { dow: 2, L: "DD.MM.YYYY" },
  nl: { dow: 2, L: "DD-MM-YYYY" },
  "en-US": { dow: 1, L: "MM/DD/YYYY" },
  "en-AU": { dow: 2, L: "DD/MM/YYYY" },
  "en-CA": { dow: 1, L: "YYYY-MM-DD" },
  "en-GB": { dow: 2, L: "DD/MM/YYYY" },
  "en-IE": { dow: 2, L: "DD-MM-YYYY" },
  "en-NZ": { dow: 2, L: "DD/MM/YYYY" },
  "en-ZA": { dow: 1, L: "YYYY/MM/DD" },
  eo: { dow: 2, L: "YYYY-MM-DD" },
  et: { dow: 2, L: "DD.MM.YYYY" },
  fi: { dow: 2, L: "DD.MM.YYYY" },
  fr: { dow: 2, L: "DD/MM/YYYY" },
  "fr-CA": { dow: 1, L: "YYYY-MM-DD" },
  "fr-CH": { dow: 2, L: "DD.MM.YYYY" },
  de: { dow: 2, L: "DD.MM.YYYY" },
  he: { dow: 1, L: "DD.MM.YYYY" },
  id: { dow: 2, L: "DD/MM/YYYY" },
  it: { dow: 2, L: "DD/MM/YYYY" },
  ja: { dow: 1, L: "YYYY年M月D日" },
  ko: { dow: 1, L: "YYYY.MM.DD" },
  lv: { dow: 2, L: "DD.MM.YYYY" },
  lt: { dow: 2, L: "DD.MM.YYYY" },
  mk: { dow: 2, L: "D.MM.YYYY" },
  nb: { dow: 2, L: "D. MMMM YYYY" },
  nn: { dow: 2, L: "D. MMMM YYYY" },
  pl: { dow: 2, L: "DD.MM.YYYY" },
  pt: { dow: 2, L: "DD/MM/YYYY" },
  ro: { dow: 2, L: "DD.MM.YYYY" },
  ru: { dow: 2, L: "DD.MM.YYYY" },
  sk: { dow: 2, L: "DD.MM.YYYY" },
  "es-ES": { dow: 2, L: "DD/MM/YYYY" },
  "es-MX": { dow: 2, L: "DD/MM/YYYY" },
  sv: { dow: 2, L: "YYYY-MM-DD" },
  th: { dow: 1, L: "DD/MM/YYYY" },
  tr: { dow: 2, L: "DD.MM.YYYY" },
  uk: { dow: 2, L: "DD.MM.YYYY" },
  vi: { dow: 2, L: "DD/MM/YYYY" }
};
Cr.en = Cr["en-US"];
Cr.es = Cr["es-ES"];
Cr.no = Cr.nb;
Cr.zh = Cr["zh-CN"];
od(Cr).forEach(([t, { dow: e, L: n }]) => {
  Cr[t] = {
    id: t,
    firstDayOfWeek: e,
    masks: { L: n }
  };
});
const ni = {
  DATE_TIME: 1,
  DATE: 2,
  TIME: 3
}, ace = {
  1: ["year", "month", "day", "hours", "minutes", "seconds", "milliseconds"],
  2: ["year", "month", "day"],
  3: ["hours", "minutes", "seconds", "milliseconds"]
}, Jv = /d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|Z{1,4}|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g, ri = /\d\d?/, sce = /\d{3}/, lce = /\d{4}/, Sl = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i, cce = /\[([^]*?)\]/gm, Qv = () => {
}, e3 = (t) => (e, n, r) => {
  const o = r[t].indexOf(n.charAt(0).toUpperCase() + n.substring(1).toLowerCase());
  ~o && (e.month = o);
}, uce = ["L", "iso"], Sn = 7, dce = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], fce = [
  { value: 0, label: "00" },
  { value: 1, label: "01" },
  { value: 2, label: "02" },
  { value: 3, label: "03" },
  { value: 4, label: "04" },
  { value: 5, label: "05" },
  { value: 6, label: "06" },
  { value: 7, label: "07" },
  { value: 8, label: "08" },
  { value: 9, label: "09" },
  { value: 10, label: "10" },
  { value: 11, label: "11" },
  { value: 12, label: "12" },
  { value: 13, label: "13" },
  { value: 14, label: "14" },
  { value: 15, label: "15" },
  { value: 16, label: "16" },
  { value: 17, label: "17" },
  { value: 18, label: "18" },
  { value: 19, label: "19" },
  { value: 20, label: "20" },
  { value: 21, label: "21" },
  { value: 22, label: "22" },
  { value: 23, label: "23" }
], t3 = {
  D(t) {
    return t.day;
  },
  DD(t) {
    return nt(t.day);
  },
  Do(t, e) {
    return e.DoFn(t.day);
  },
  d(t) {
    return t.weekday - 1;
  },
  dd(t) {
    return nt(t.weekday - 1);
  },
  W(t, e) {
    return e.dayNamesNarrow[t.weekday - 1];
  },
  WW(t, e) {
    return e.dayNamesShorter[t.weekday - 1];
  },
  WWW(t, e) {
    return e.dayNamesShort[t.weekday - 1];
  },
  WWWW(t, e) {
    return e.dayNames[t.weekday - 1];
  },
  M(t) {
    return t.month;
  },
  MM(t) {
    return nt(t.month);
  },
  MMM(t, e) {
    return e.monthNamesShort[t.month - 1];
  },
  MMMM(t, e) {
    return e.monthNames[t.month - 1];
  },
  YY(t) {
    return String(t.year).substring(2);
  },
  YYYY(t) {
    return nt(t.year, 4);
  },
  h(t) {
    return t.hours % 12 || 12;
  },
  hh(t) {
    return nt(t.hours % 12 || 12);
  },
  H(t) {
    return t.hours;
  },
  HH(t) {
    return nt(t.hours);
  },
  m(t) {
    return t.minutes;
  },
  mm(t) {
    return nt(t.minutes);
  },
  s(t) {
    return t.seconds;
  },
  ss(t) {
    return nt(t.seconds);
  },
  S(t) {
    return Math.round(t.milliseconds / 100);
  },
  SS(t) {
    return nt(Math.round(t.milliseconds / 10), 2);
  },
  SSS(t) {
    return nt(t.milliseconds, 3);
  },
  a(t, e) {
    return t.hours < 12 ? e.amPm[0] : e.amPm[1];
  },
  A(t, e) {
    return t.hours < 12 ? e.amPm[0].toUpperCase() : e.amPm[1].toUpperCase();
  },
  Z() {
    return "Z";
  },
  ZZ(t) {
    const e = t.timezoneOffset;
    return `${e > 0 ? "-" : "+"}${nt(Math.floor(Math.abs(e) / 60), 2)}`;
  },
  ZZZ(t) {
    const e = t.timezoneOffset;
    return `${e > 0 ? "-" : "+"}${nt(Math.floor(Math.abs(e) / 60) * 100 + Math.abs(e) % 60, 4)}`;
  },
  ZZZZ(t) {
    const e = t.timezoneOffset;
    return `${e > 0 ? "-" : "+"}${nt(Math.floor(Math.abs(e) / 60), 2)}:${nt(Math.abs(e) % 60, 2)}`;
  }
}, Nt = {
  D: [
    ri,
    (t, e) => {
      t.day = e;
    }
  ],
  Do: [
    new RegExp(ri.source + Sl.source),
    (t, e) => {
      t.day = parseInt(e, 10);
    }
  ],
  d: [ri, Qv],
  W: [Sl, Qv],
  M: [
    ri,
    (t, e) => {
      t.month = e - 1;
    }
  ],
  MMM: [Sl, e3("monthNamesShort")],
  MMMM: [Sl, e3("monthNames")],
  YY: [
    ri,
    (t, e) => {
      const r = +(/* @__PURE__ */ new Date()).getFullYear().toString().substring(0, 2);
      t.year = `${e > 68 ? r - 1 : r}${e}`;
    }
  ],
  YYYY: [
    lce,
    (t, e) => {
      t.year = e;
    }
  ],
  S: [
    /\d/,
    (t, e) => {
      t.millisecond = e * 100;
    }
  ],
  SS: [
    /\d{2}/,
    (t, e) => {
      t.millisecond = e * 10;
    }
  ],
  SSS: [
    sce,
    (t, e) => {
      t.millisecond = e;
    }
  ],
  h: [
    ri,
    (t, e) => {
      t.hour = e;
    }
  ],
  m: [
    ri,
    (t, e) => {
      t.minute = e;
    }
  ],
  s: [
    ri,
    (t, e) => {
      t.second = e;
    }
  ],
  a: [
    Sl,
    (t, e, n) => {
      const r = e.toLowerCase();
      r === n.amPm[0] ? t.isPm = !1 : r === n.amPm[1] && (t.isPm = !0);
    }
  ],
  Z: [
    /[^\s]*?[+-]\d\d:?\d\d|[^\s]*?Z?/,
    (t, e) => {
      e === "Z" && (e = "+00:00");
      const n = `${e}`.match(/([+-]|\d\d)/gi);
      if (n) {
        const r = +(n[1] * 60) + parseInt(n[2], 10);
        t.timezoneOffset = n[0] === "+" ? r : -r;
      }
    }
  ]
};
Nt.DD = Nt.D;
Nt.dd = Nt.d;
Nt.WWWW = Nt.WWW = Nt.WW = Nt.W;
Nt.MM = Nt.M;
Nt.mm = Nt.m;
Nt.hh = Nt.H = Nt.HH = Nt.h;
Nt.ss = Nt.s;
Nt.A = Nt.a;
Nt.ZZZZ = Nt.ZZZ = Nt.ZZ = Nt.Z;
function hce(t, e) {
  const n = new Intl.DateTimeFormat().resolvedOptions().locale;
  let r;
  _i(t) ? r = t : Ip(t, "id") && (r = t.id), r = (r || n).toLowerCase();
  const o = Object.keys(e), i = (s) => o.find((l) => l.toLowerCase() === s);
  r = i(r) || i(r.substring(0, 2)) || n;
  const a = tt(be(be({}, e["en-IE"]), e[r]), { id: r });
  return t = _r(t) ? gp(t, a) : a, t;
}
class kd {
  constructor(e, { locales: n = Cr, timezone: r } = {}) {
    const { id: o, firstDayOfWeek: i, masks: a } = hce(e, n);
    this.id = o, this.daysInWeek = Sn, this.firstDayOfWeek = mZ(i, 1, Sn), this.masks = a, this.timezone = r || void 0, this.dayNames = this.getDayNames("long"), this.dayNamesShort = this.getDayNames("short"), this.dayNamesShorter = this.dayNamesShort.map((s) => s.substring(0, 2)), this.dayNamesNarrow = this.getDayNames("narrow"), this.monthNames = this.getMonthNames("long"), this.monthNamesShort = this.getMonthNames("short"), this.amPm = ["am", "pm"], this.monthData = {}, this.getMonthComps = this.getMonthComps.bind(this), this.parse = this.parse.bind(this), this.format = this.format.bind(this), this.toPage = this.toPage.bind(this);
  }
  format(e, n) {
    if (e = this.normalizeDate(e), !e)
      return "";
    n = this.normalizeMasks(n)[0];
    const r = [];
    n = n.replace(cce, (a, s) => (r.push(s), "??"));
    const o = /Z$/.test(n) ? "utc" : this.timezone, i = this.getDateParts(e, o);
    return n = n.replace(Jv, (a) => a in t3 ? t3[a](i, this) : a.slice(1, a.length - 1)), n.replace(/\?\?/g, () => r.shift());
  }
  parse(e, n) {
    return this.normalizeMasks(n).map((o) => {
      if (typeof o != "string")
        throw new Error("Invalid mask in fecha.parse");
      let i = e;
      if (i.length > 1e3)
        return !1;
      let a = !0;
      const s = {};
      if (o.replace(Jv, (u) => {
        if (Nt[u]) {
          const d = Nt[u], f = i.search(d[0]);
          ~f ? i.replace(d[0], (h) => (d[1](s, h, this), i = i.substring(f + h.length), h)) : a = !1;
        }
        return Nt[u] ? "" : u.slice(1, u.length - 1);
      }), !a)
        return !1;
      const l = /* @__PURE__ */ new Date();
      s.isPm === !0 && s.hour != null && +s.hour != 12 ? s.hour = +s.hour + 12 : s.isPm === !1 && +s.hour == 12 && (s.hour = 0);
      let c;
      return s.timezoneOffset != null ? (s.minute = +(s.minute || 0) - +s.timezoneOffset, c = new Date(Date.UTC(s.year || l.getFullYear(), s.month || 0, s.day || 1, s.hour || 0, s.minute || 0, s.second || 0, s.millisecond || 0))) : c = this.getDateFromParts({
        year: s.year || l.getFullYear(),
        month: (s.month || 0) + 1,
        day: s.day || 1,
        hours: s.hour || 0,
        minutes: s.minute || 0,
        seconds: s.second || 0,
        milliseconds: s.millisecond || 0
      }), c;
    }).find((o) => o) || new Date(e);
  }
  normalizeMasks(e) {
    return (ur(e) && e || [
      _i(e) && e || "YYYY-MM-DD"
    ]).map((n) => uce.reduce((r, o) => r.replace(o, this.masks[o] || ""), n));
  }
  normalizeDate(e, n = {}) {
    let r = null, { type: o, fillDate: i } = n;
    const { mask: a, patch: s, time: l } = n, c = o === "auto" || !o;
    if (zl(e) ? (o = "number", r = /* @__PURE__ */ new Date(+e)) : _i(e) ? (o = "string", r = e ? this.parse(e, a || "iso") : null) : _r(e) ? (o = "object", r = this.getDateFromParts(e)) : (o = "date", r = gi(e) ? new Date(e.getTime()) : null), r && s) {
      i = i == null ? /* @__PURE__ */ new Date() : this.normalizeDate(i);
      const u = be(be({}, this.getDateParts(i)), joe(this.getDateParts(r), ace[s]));
      r = this.getDateFromParts(u);
    }
    return c && (n.type = o), r && !isNaN(r.getTime()) ? (l && (r = this.adjustTimeForDate(r, {
      timeAdjust: l
    })), r) : null;
  }
  denormalizeDate(e, { type: n, mask: r } = {}) {
    switch (n) {
      case "number":
        return e ? e.getTime() : NaN;
      case "string":
        return e ? this.format(e, r || "iso") : "";
      default:
        return e ? new Date(e) : null;
    }
  }
  hourIsValid(e, n, r) {
    if (!n)
      return !0;
    if (Fn(n))
      return n.includes(e);
    if (_r(n)) {
      const o = n.min || 0, i = n.max || 24;
      return o <= e && i >= e;
    }
    return n(e, r);
  }
  getHourOptions(e, n) {
    return fce.filter((r) => this.hourIsValid(r.value, e, n));
  }
  getMinuteOptions(e) {
    const n = [];
    e = e > 0 ? e : 1;
    for (let r = 0; r <= 59; r += e)
      n.push({
        value: r,
        label: nt(r, 2)
      });
    return n;
  }
  nearestOptionValue(e, n) {
    if (e == null)
      return e;
    const r = n.reduce((o, i) => {
      if (i.disabled)
        return o;
      if (isNaN(o))
        return i.value;
      const a = Math.abs(o - e);
      return Math.abs(i.value - e) < a ? i.value : o;
    }, NaN);
    return isNaN(r) ? e : r;
  }
  adjustTimeForDate(e, { timeAdjust: n, validHours: r, minuteIncrement: o }) {
    if (!n && !r && !o)
      return e;
    const i = this.getDateParts(e);
    if (n)
      if (n === "now") {
        const a = this.getDateParts(/* @__PURE__ */ new Date());
        i.hours = a.hours, i.minutes = a.minutes, i.seconds = a.seconds, i.milliseconds = a.milliseconds;
      } else {
        const a = /* @__PURE__ */ new Date(`2000-01-01T${n}Z`);
        i.hours = a.getUTCHours(), i.minutes = a.getUTCMinutes(), i.seconds = a.getUTCSeconds(), i.milliseconds = a.getUTCMilliseconds();
      }
    if (r) {
      const a = this.getHourOptions(r, i);
      i.hours = this.nearestOptionValue(i.hours, a);
    }
    if (o) {
      const a = this.getMinuteOptions(o);
      i.minutes = this.nearestOptionValue(i.minutes, a);
    }
    return e = this.getDateFromParts(i), e;
  }
  normalizeDates(e, n) {
    return n = n || {}, n.locale = this, (Fn(e) ? e : [e]).map((r) => r && (r instanceof Yt ? r : new Yt(r, n))).filter((r) => r);
  }
  getDateParts(e, n = this.timezone) {
    if (!e)
      return null;
    let r = e;
    if (n) {
      const O = new Date(e.toLocaleString("en-US", { timeZone: n }));
      O.setMilliseconds(e.getMilliseconds());
      const p = O.getTime() - e.getTime();
      r = new Date(e.getTime() + p);
    }
    const o = r.getMilliseconds(), i = r.getSeconds(), a = r.getMinutes(), s = r.getHours(), l = r.getMonth() + 1, c = r.getFullYear(), u = this.getMonthComps(l, c), d = r.getDate(), f = u.days - d + 1, h = r.getDay() + 1, _ = Math.floor((d - 1) / 7 + 1), E = Math.floor((u.days - d) / 7 + 1), m = Math.ceil((d + Math.abs(u.firstWeekday - u.firstDayOfWeek)) / 7), N = u.weeks - m + 1, I = {
      milliseconds: o,
      seconds: i,
      minutes: a,
      hours: s,
      day: d,
      dayFromEnd: f,
      weekday: h,
      weekdayOrdinal: _,
      weekdayOrdinalFromEnd: E,
      week: m,
      weekFromEnd: N,
      month: l,
      year: c,
      date: e,
      isValid: !0
    };
    return I.timezoneOffset = this.getTimezoneOffset(I), I;
  }
  getDateFromParts(e) {
    if (!e)
      return null;
    const n = /* @__PURE__ */ new Date(), {
      year: r = n.getFullYear(),
      month: o = n.getMonth() + 1,
      day: i = n.getDate(),
      hours: a = 0,
      minutes: s = 0,
      seconds: l = 0,
      milliseconds: c = 0
    } = e;
    if (this.timezone) {
      const u = `${nt(r, 4)}-${nt(o, 2)}-${nt(i, 2)}T${nt(a, 2)}:${nt(s, 2)}:${nt(l, 2)}.${nt(c, 3)}`;
      return Zv(u, { timeZone: this.timezone });
    }
    return new Date(r, o - 1, i, a, s, l, c);
  }
  getTimezoneOffset(e) {
    const {
      year: n,
      month: r,
      day: o,
      hours: i = 0,
      minutes: a = 0,
      seconds: s = 0,
      milliseconds: l = 0
    } = e;
    let c;
    const u = new Date(Date.UTC(n, r - 1, o, i, a, s, l));
    if (this.timezone) {
      const d = `${nt(n, 4)}-${nt(r, 2)}-${nt(o, 2)}T${nt(i, 2)}:${nt(a, 2)}:${nt(s, 2)}.${nt(l, 3)}`;
      c = Zv(d, { timeZone: this.timezone });
    } else
      c = new Date(n, r - 1, o, i, a, s, l);
    return (c - u) / 6e4;
  }
  toPage(e, n) {
    return zl(e) ? Mo(n, e) : _i(e) ? this.getDateParts(this.normalizeDate(e)) : gi(e) ? this.getDateParts(e) : _r(e) ? e : null;
  }
  getMonthDates(e = 2e3) {
    const n = [];
    for (let r = 0; r < 12; r++)
      n.push(new Date(e, r, 15));
    return n;
  }
  getMonthNames(e) {
    const n = new Intl.DateTimeFormat(this.id, {
      month: e,
      timezome: "UTC"
    });
    return this.getMonthDates().map((r) => n.format(r));
  }
  getWeekdayDates(e = this.firstDayOfWeek) {
    const n = [], i = 5 + e - 1;
    for (let a = 0; a < Sn; a++)
      n.push(this.getDateFromParts({
        year: 2020,
        month: 1,
        day: i + a,
        hours: 12
      }));
    return n;
  }
  getDayNames(e) {
    const n = new Intl.DateTimeFormat(this.id, {
      weekday: e,
      timeZone: this.timezone
    });
    return this.getWeekdayDates(1).map((r) => n.format(r));
  }
  getMonthComps(e, n) {
    const r = `${e}-${n}`;
    let o = this.monthData[r];
    if (!o) {
      const i = n % 4 === 0 && n % 100 !== 0 || n % 400 === 0, a = new Date(n, e - 1, 1), s = a.getDay() + 1, l = e === 2 && i ? 29 : dce[e - 1], c = this.firstDayOfWeek - 1, u = oce(a, {
        weekStartsOn: c
      }), d = [], f = [];
      for (let h = 0; h < u; h++) {
        const _ = eo(a, h * 7);
        d.push(Qle(_, { weekStartsOn: c })), f.push(qle(_));
      }
      o = {
        firstDayOfWeek: this.firstDayOfWeek,
        inLeapYear: i,
        firstWeekday: s,
        days: l,
        weeks: u,
        month: e,
        year: n,
        weeknumbers: d,
        isoWeeknumbers: f
      }, this.monthData[r] = o;
    }
    return o;
  }
  getThisMonthComps() {
    const { month: e, year: n } = this.getDateParts(/* @__PURE__ */ new Date());
    return this.getMonthComps(e, n);
  }
  getPrevMonthComps(e, n) {
    return e === 1 ? this.getMonthComps(12, n - 1) : this.getMonthComps(e - 1, n);
  }
  getNextMonthComps(e, n) {
    return e === 12 ? this.getMonthComps(1, n + 1) : this.getMonthComps(e + 1, n);
  }
  getDayId(e) {
    return this.format(e, "YYYY-MM-DD");
  }
  getCalendarDays({ weeks: e, monthComps: n, prevMonthComps: r, nextMonthComps: o }) {
    const i = [], { firstDayOfWeek: a, firstWeekday: s, isoWeeknumbers: l, weeknumbers: c } = n, u = s + (s < a ? Sn : 0) - a;
    let d = !0, f = !1, h = !1;
    const _ = new Intl.DateTimeFormat(this.id, {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric"
    });
    let E = r.days - u + 1, m = r.days - E + 1, N = Math.floor((E - 1) / Sn + 1), I = 1, O = r.weeks, p = 1, C = r.month, D = r.year;
    const T = /* @__PURE__ */ new Date(), k = T.getDate(), G = T.getMonth() + 1, b = T.getFullYear(), P = ($, y, L) => (w, R, B, U) => this.normalizeDate({
      year: $,
      month: y,
      day: L,
      hours: w,
      minutes: R,
      seconds: B,
      milliseconds: U
    });
    for (let $ = 1; $ <= e; $++) {
      for (let y = 1, L = a; y <= Sn; y++, L += L === Sn ? 1 - Sn : 1) {
        d && L === s && (E = 1, m = n.days, N = Math.floor((E - 1) / Sn + 1), I = Math.floor((n.days - E) / Sn + 1), O = 1, p = n.weeks, C = n.month, D = n.year, d = !1, f = !0);
        const w = P(D, C, E), R = {
          start: w(0, 0, 0),
          end: w(23, 59, 59, 999)
        }, B = R.start, U = `${nt(D, 4)}-${nt(C, 2)}-${nt(E, 2)}`, K = y, Z = Sn - y, X = c[$ - 1], J = l[$ - 1], ae = E === k && C === G && D === b, re = f && E === 1, j = f && E === n.days, ne = $ === 1, Ee = $ === e, fe = y === 1, Oe = y === Sn;
        i.push({
          id: U,
          label: E.toString(),
          ariaLabel: _.format(new Date(D, C - 1, E)),
          day: E,
          dayFromEnd: m,
          weekday: L,
          weekdayPosition: K,
          weekdayPositionFromEnd: Z,
          weekdayOrdinal: N,
          weekdayOrdinalFromEnd: I,
          week: O,
          weekFromEnd: p,
          weeknumber: X,
          isoWeeknumber: J,
          month: C,
          year: D,
          dateFromTime: w,
          date: B,
          range: R,
          isToday: ae,
          isFirstDay: re,
          isLastDay: j,
          inMonth: f,
          inPrevMonth: d,
          inNextMonth: h,
          onTop: ne,
          onBottom: Ee,
          onLeft: fe,
          onRight: Oe,
          classes: [
            `id-${U}`,
            `day-${E}`,
            `day-from-end-${m}`,
            `weekday-${L}`,
            `weekday-position-${K}`,
            `weekday-ordinal-${N}`,
            `weekday-ordinal-from-end-${I}`,
            `week-${O}`,
            `week-from-end-${p}`,
            {
              "is-today": ae,
              "is-first-day": re,
              "is-last-day": j,
              "in-month": f,
              "in-prev-month": d,
              "in-next-month": h,
              "on-top": ne,
              "on-bottom": Ee,
              "on-left": fe,
              "on-right": Oe
            }
          ]
        }), f && j ? (f = !1, h = !0, E = 1, m = o.days, N = 1, I = Math.floor((o.days - E) / Sn + 1), O = 1, p = o.weeks, C = o.month, D = o.year) : (E++, m--, N = Math.floor((E - 1) / Sn + 1), I = Math.floor((n.days - E) / Sn + 1));
      }
      O++, p--;
    }
    return i;
  }
}
let h6 = class {
  constructor({
    key: e,
    hashcode: n,
    highlight: r,
    content: o,
    dot: i,
    bar: a,
    popover: s,
    dates: l,
    excludeDates: c,
    excludeMode: u,
    customData: d,
    order: f,
    pinPage: h
  }, _, E) {
    this.key = Wz(e) ? xd() : e, this.hashcode = n, this.customData = d, this.order = f || 0, this.dateOpts = { order: f, locale: E }, this.pinPage = h, r && (this.highlight = _.normalizeHighlight(r)), o && (this.content = _.normalizeContent(o)), i && (this.dot = _.normalizeDot(i)), a && (this.bar = _.normalizeBar(a)), s && (this.popover = s), this.dates = E.normalizeDates(l, this.dateOpts), this.hasDates = !!ur(this.dates), this.excludeDates = E.normalizeDates(c, this.dateOpts), this.hasExcludeDates = !!ur(this.excludeDates), this.excludeMode = u || "intersects", this.hasExcludeDates && !this.hasDates && (this.dates.push(new Yt({}, this.dateOpts)), this.hasDates = !0), this.isComplex = Ole(this.dates, (m) => m.isComplex);
  }
  intersectsDate(e) {
    return e = e instanceof Yt ? e : new Yt(e, this.dateOpts), !this.excludesDate(e) && (this.dates.find((n) => n.intersectsDate(e)) || !1);
  }
  includesDate(e) {
    return e = e instanceof Yt ? e : new Yt(e, this.dateOpts), !this.excludesDate(e) && (this.dates.find((n) => n.includesDate(e)) || !1);
  }
  excludesDate(e) {
    return e = e instanceof Yt ? e : new Yt(e, this.dateOpts), this.hasExcludeDates && this.excludeDates.find((n) => this.excludeMode === "intersects" && n.intersectsDate(e) || this.excludeMode === "includes" && n.includesDate(e));
  }
  intersectsDay(e) {
    return !this.excludesDay(e) && (this.dates.find((n) => n.intersectsDay(e)) || !1);
  }
  excludesDay(e) {
    return this.hasExcludeDates && this.excludeDates.find((n) => n.intersectsDay(e));
  }
};
const _ce = 300, Ece = 60, pce = 80;
var mce = {
  maxSwipeTime: _ce,
  minHorizontalSwipeDistance: Ece,
  maxVerticalSwipeDistance: pce
};
const Nce = "MMMM YYYY", vce = "W", gce = "MMM", Ice = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], Oce = [
  "L h:mm A",
  "YYYY-MM-DD h:mm A",
  "YYYY/MM/DD h:mm A"
], Ace = [
  "L HH:mm",
  "YYYY-MM-DD HH:mm",
  "YYYY/MM/DD HH:mm"
], Dce = [
  "h:mm A"
], Cce = [
  "HH:mm"
], Sce = "WWW, MMM D, YYYY", wce = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], Tce = "iso", bce = "YYYY-MM-DDTHH:mm:ss.SSSZ";
var Rce = {
  title: Nce,
  weekdays: vce,
  navMonths: gce,
  input: Ice,
  inputDateTime: Oce,
  inputDateTime24hr: Ace,
  inputTime: Dce,
  inputTime24hr: Cce,
  dayPopover: Sce,
  data: wce,
  model: Tce,
  iso: bce
};
const Mce = "640px", Pce = "768px", yce = "1024px", Lce = "1280px";
var xce = {
  sm: Mce,
  md: Pce,
  lg: yce,
  xl: Lce
};
const Uce = {
  componentPrefix: "v",
  color: "blue",
  isDark: !1,
  navVisibility: "click",
  titlePosition: "center",
  transition: "slide-h",
  touch: mce,
  masks: Rce,
  screens: xce,
  locales: Cr,
  datePicker: {
    updateOnInput: !0,
    inputDebounce: 1e3,
    popover: {
      visibility: "hover-focus",
      placement: "bottom-start",
      keepVisibleOnInput: !1,
      isInteractive: !0
    }
  }
}, C0 = Oa(Uce), $ce = x(() => rne(C0.locales, (t) => (t.masks = gp(t.masks, C0.masks), t))), Ii = (t) => window && Ip(window.__vcalendar__, t) ? Dc(window.__vcalendar__, t) : Dc(C0, t), kce = {
  props: {
    color: {
      type: String,
      default: () => Ii("color")
    },
    isDark: {
      type: Boolean,
      default: () => Ii("isDark")
    },
    firstDayOfWeek: Number,
    masks: Object,
    locale: [String, Object],
    timezone: String,
    minDate: null,
    maxDate: null,
    minDateExact: null,
    maxDateExact: null,
    disabledDates: null,
    availableDates: null,
    theme: null
  },
  computed: {
    $theme() {
      return this.theme instanceof Vv ? this.theme : new Vv({
        color: this.color,
        isDark: this.isDark
      });
    },
    $locale() {
      if (this.locale instanceof kd)
        return this.locale;
      const t = _r(this.locale) ? this.locale : {
        id: this.locale,
        firstDayOfWeek: this.firstDayOfWeek,
        masks: this.masks
      };
      return new kd(t, {
        locales: $ce.value,
        timezone: this.timezone
      });
    },
    disabledDates_() {
      const t = this.normalizeDates(this.disabledDates), { minDate: e, minDateExact: n, maxDate: r, maxDateExact: o } = this;
      if (n || e) {
        const i = n ? this.normalizeDate(n) : this.normalizeDate(e, { time: "00:00:00" });
        t.push({
          start: null,
          end: new Date(i.getTime() - 1e3)
        });
      }
      if (o || r) {
        const i = o ? this.normalizeDate(o) : this.normalizeDate(r, { time: "23:59:59" });
        t.push({
          start: new Date(i.getTime() + 1e3),
          end: null
        });
      }
      return t;
    },
    availableDates_() {
      return this.normalizeDates(this.availableDates);
    },
    disabledAttribute() {
      return new h6({
        key: "disabled",
        dates: this.disabledDates_,
        excludeDates: this.availableDates_,
        excludeMode: "includes",
        order: 100
      }, this.$theme, this.$locale);
    }
  },
  methods: {
    formatDate(t, e) {
      return this.$locale ? this.$locale.format(t, e) : "";
    },
    parseDate(t, e) {
      if (!this.$locale)
        return null;
      const n = this.$locale.parse(t, e);
      return gi(n) ? n : null;
    },
    normalizeDate(t, e) {
      return this.$locale ? this.$locale.normalizeDate(t, e) : t;
    },
    normalizeDates(t) {
      return this.$locale.normalizeDates(t, {
        isFullDay: !0
      });
    },
    pageForDate(t) {
      return this.$locale.getDateParts(this.normalizeDate(t));
    },
    pageForThisMonth() {
      return this.pageForDate(/* @__PURE__ */ new Date());
    }
  }
}, Bce = {
  methods: {
    safeSlot(t, e, n = null) {
      return Go(this.$slots[t]) ? this.$slots[t](e) : n;
    }
  }
}, Kf = Tle, _6 = kce, Op = Bce, Gce = {
  name: "PopoverRow",
  mixins: [Kf],
  props: {
    attribute: Object
  },
  computed: {
    indicator() {
      const { highlight: t, dot: e, bar: n, popover: r } = this.attribute;
      if (r && r.hideIndicator)
        return null;
      if (t) {
        const { color: o, isDark: i } = t.start;
        return {
          style: tt(be({}, this.theme.bgAccentHigh({
            color: o,
            isDark: !i
          })), {
            width: "10px",
            height: "5px",
            borderRadius: "3px"
          })
        };
      }
      if (e) {
        const { color: o, isDark: i } = e.start;
        return {
          style: tt(be({}, this.theme.bgAccentHigh({
            color: o,
            isDark: !i
          })), {
            width: "5px",
            height: "5px",
            borderRadius: "50%"
          })
        };
      }
      if (n) {
        const { color: o, isDark: i } = n.start;
        return {
          style: tt(be({}, this.theme.bgAccentHigh({
            color: o,
            isDark: !i
          })), {
            width: "10px",
            height: "3px"
          })
        };
      }
      return null;
    }
  }
}, Fce = { class: "vc-day-popover-row" }, Vce = {
  key: 0,
  class: "vc-day-popover-row-indicator"
}, Hce = { class: "vc-day-popover-row-content" };
function Wce(t, e, n, r, o, i) {
  return v(), A("div", Fce, [
    i.indicator ? (v(), A("div", Vce, [
      g("span", {
        style: Fe(i.indicator.style),
        class: z(i.indicator.class)
      }, null, 6)
    ])) : V("", !0),
    g("div", Hce, [
      ue(t.$slots, "default", {}, () => [
        me(Q(n.attribute.popover ? n.attribute.popover.label : "No content provided"), 1)
      ])
    ])
  ]);
}
var Yce = /* @__PURE__ */ pl(Gce, [["render", Wce]]);
const Uu = "26px", Kce = "0 0 32 32", zce = {
  "left-arrow": {
    viewBox: "0 -1 16 34",
    path: "M11.196 10c0 0.143-0.071 0.304-0.179 0.411l-7.018 7.018 7.018 7.018c0.107 0.107 0.179 0.268 0.179 0.411s-0.071 0.304-0.179 0.411l-0.893 0.893c-0.107 0.107-0.268 0.179-0.411 0.179s-0.304-0.071-0.411-0.179l-8.321-8.321c-0.107-0.107-0.179-0.268-0.179-0.411s0.071-0.304 0.179-0.411l8.321-8.321c0.107-0.107 0.268-0.179 0.411-0.179s0.304 0.071 0.411 0.179l0.893 0.893c0.107 0.107 0.179 0.25 0.179 0.411z"
  },
  "right-arrow": {
    viewBox: "-5 -1 16 34",
    path: "M10.625 17.429c0 0.143-0.071 0.304-0.179 0.411l-8.321 8.321c-0.107 0.107-0.268 0.179-0.411 0.179s-0.304-0.071-0.411-0.179l-0.893-0.893c-0.107-0.107-0.179-0.25-0.179-0.411 0-0.143 0.071-0.304 0.179-0.411l7.018-7.018-7.018-7.018c-0.107-0.107-0.179-0.268-0.179-0.411s0.071-0.304 0.179-0.411l0.893-0.893c0.107-0.107 0.268-0.179 0.411-0.179s0.304 0.071 0.411 0.179l8.321 8.321c0.107 0.107 0.179 0.268 0.179 0.411z"
  }
}, Zce = {
  props: ["name"],
  data() {
    return {
      width: Uu,
      height: Uu,
      viewBox: Kce,
      path: "",
      isBaseline: !1
    };
  },
  mounted() {
    this.updateIcon();
  },
  watch: {
    name() {
      this.updateIcon();
    }
  },
  methods: {
    updateIcon() {
      const t = zce[this.name];
      t && (this.width = t.width || Uu, this.height = t.height || Uu, this.viewBox = t.viewBox, this.path = t.path);
    }
  }
}, qce = ["width", "height", "viewBox"], Xce = ["d"];
function jce(t, e, n, r, o, i) {
  return v(), A("svg", {
    class: "vc-svg-icon",
    width: o.width,
    height: o.height,
    viewBox: o.viewBox
  }, [
    g("path", { d: o.path }, null, 8, Xce)
  ], 8, qce);
}
var E6 = /* @__PURE__ */ pl(Zce, [["render", jce]]);
const H1 = 12, Jce = {
  name: "CalendarNav",
  emits: ["input"],
  components: {
    SvgIcon: E6
  },
  mixins: [Kf],
  props: {
    value: { type: Object, default: () => ({ month: 0, year: 0 }) },
    validator: { type: Function, default: () => () => !0 }
  },
  data() {
    return {
      monthMode: !0,
      yearIndex: 0,
      yearGroupIndex: 0,
      onSpaceOrEnter: u6
    };
  },
  computed: {
    month() {
      return this.value && this.value.month || 0;
    },
    year() {
      return this.value && this.value.year || 0;
    },
    title() {
      return this.monthMode ? this.yearIndex : `${this.firstYear} - ${this.lastYear}`;
    },
    monthItems() {
      return this.getMonthItems(this.yearIndex);
    },
    yearItems() {
      return this.getYearItems(this.yearGroupIndex);
    },
    prevItemsEnabled() {
      return this.monthMode ? this.prevMonthItemsEnabled : this.prevYearItemsEnabled;
    },
    nextItemsEnabled() {
      return this.monthMode ? this.nextMonthItemsEnabled : this.nextYearItemsEnabled;
    },
    prevMonthItemsEnabled() {
      return this.getMonthItems(this.yearIndex - 1).some((t) => !t.isDisabled);
    },
    nextMonthItemsEnabled() {
      return this.getMonthItems(this.yearIndex + 1).some((t) => !t.isDisabled);
    },
    prevYearItemsEnabled() {
      return this.getYearItems(this.yearGroupIndex - 1).some((t) => !t.isDisabled);
    },
    nextYearItemsEnabled() {
      return this.getYearItems(this.yearGroupIndex + 1).some((t) => !t.isDisabled);
    },
    activeItems() {
      return this.monthMode ? this.monthItems : this.yearItems;
    },
    firstYear() {
      return s6(this.yearItems.map((t) => t.year));
    },
    lastYear() {
      return Cc(this.yearItems.map((t) => t.year));
    }
  },
  watch: {
    year() {
      this.yearIndex = this.year;
    },
    yearIndex(t) {
      this.yearGroupIndex = this.getYearGroupIndex(t);
    },
    value() {
      this.focusFirstItem();
    }
  },
  created() {
    this.yearIndex = this.year;
  },
  mounted() {
    this.focusFirstItem();
  },
  methods: {
    focusFirstItem() {
      this.$nextTick(() => {
        const t = this.$refs.navContainer.querySelector(".vc-nav-item:not(.is-disabled)");
        t && t.focus();
      });
    },
    getItemClasses({ isActive: t, isCurrent: e, isDisabled: n }) {
      const r = ["vc-nav-item"];
      return t ? r.push("is-active") : e && r.push("is-current"), n && r.push("is-disabled"), r;
    },
    getYearGroupIndex(t) {
      return Math.floor(t / H1);
    },
    getMonthItems(t) {
      const { month: e, year: n } = this.pageForDate(/* @__PURE__ */ new Date());
      return this.locale.getMonthDates().map((r, o) => {
        const i = o + 1;
        return {
          month: i,
          year: t,
          id: `${t}.${nt(i, 2)}`,
          label: this.locale.format(r, this.masks.navMonths),
          ariaLabel: this.locale.format(r, "MMMM YYYY"),
          isActive: i === this.month && t === this.year,
          isCurrent: i === e && t === n,
          isDisabled: !this.validator({ month: i, year: t }),
          click: () => this.monthClick(i, t)
        };
      });
    },
    getYearItems(t) {
      const { _: e, year: n } = this.pageForDate(/* @__PURE__ */ new Date()), r = t * H1, o = r + H1, i = [];
      for (let a = r; a < o; a += 1) {
        let s = !1;
        for (let l = 1; l < 12 && (s = this.validator({ month: l, year: a }), !s); l++)
          ;
        i.push({
          year: a,
          id: a,
          label: a,
          ariaLabel: a,
          isActive: a === this.year,
          isCurrent: a === n,
          isDisabled: !s,
          click: () => this.yearClick(a)
        });
      }
      return i;
    },
    monthClick(t, e) {
      this.validator({ month: t, year: e }) && this.$emit("input", { month: t, year: e });
    },
    yearClick(t) {
      this.yearIndex = t, this.monthMode = !0, this.focusFirstItem();
    },
    toggleMode() {
      this.monthMode = !this.monthMode;
    },
    movePrev() {
      this.prevItemsEnabled && (this.monthMode && this.movePrevYear(), this.movePrevYearGroup());
    },
    moveNext() {
      this.nextItemsEnabled && (this.monthMode && this.moveNextYear(), this.moveNextYearGroup());
    },
    movePrevYear() {
      this.yearIndex--;
    },
    moveNextYear() {
      this.yearIndex++;
    },
    movePrevYearGroup() {
      this.yearGroupIndex--;
    },
    moveNextYearGroup() {
      this.yearGroupIndex++;
    }
  }
}, Qce = {
  class: "vc-nav-container",
  ref: "navContainer"
}, eue = { class: "vc-nav-header" }, tue = ["tabindex"], nue = ["tabindex"], rue = { class: "vc-nav-items" }, oue = ["data-id", "aria-label", "tabindex", "onClick", "onKeydown"];
function iue(t, e, n, r, o, i) {
  const a = ee("svg-icon");
  return v(), A("div", Qce, [
    g("div", eue, [
      g("span", {
        role: "button",
        class: z(["vc-nav-arrow is-left", { "is-disabled": !i.prevItemsEnabled }]),
        tabindex: i.prevItemsEnabled ? 0 : void 0,
        onClick: e[0] || (e[0] = (...s) => i.movePrev && i.movePrev(...s)),
        onKeydown: e[1] || (e[1] = (s) => o.onSpaceOrEnter(s, i.movePrev))
      }, [
        ue(t.$slots, "nav-left-button", {}, () => [
          H(a, {
            name: "left-arrow",
            width: "20px",
            height: "24px"
          })
        ])
      ], 42, tue),
      g("span", {
        role: "button",
        class: "vc-nav-title vc-grid-focus",
        style: { whiteSpace: "nowrap" },
        tabindex: "0",
        onClick: e[2] || (e[2] = (...s) => i.toggleMode && i.toggleMode(...s)),
        onKeydown: e[3] || (e[3] = (s) => o.onSpaceOrEnter(s, i.toggleMode))
      }, Q(i.title), 33),
      g("span", {
        role: "button",
        class: z(["vc-nav-arrow is-right", { "is-disabled": !i.nextItemsEnabled }]),
        tabindex: i.nextItemsEnabled ? 0 : void 0,
        onClick: e[4] || (e[4] = (...s) => i.moveNext && i.moveNext(...s)),
        onKeydown: e[5] || (e[5] = (s) => o.onSpaceOrEnter(s, i.moveNext))
      }, [
        ue(t.$slots, "nav-right-button", {}, () => [
          H(a, {
            name: "right-arrow",
            width: "20px",
            height: "24px"
          })
        ])
      ], 42, nue)
    ]),
    g("div", rue, [
      (v(!0), A(ge, null, ye(i.activeItems, (s) => (v(), A("span", {
        key: s.label,
        role: "button",
        "data-id": s.id,
        "aria-label": s.ariaLabel,
        class: z(i.getItemClasses(s)),
        tabindex: s.isDisabled ? void 0 : 0,
        onClick: s.click,
        onKeydown: (l) => o.onSpaceOrEnter(l, s.click)
      }, Q(s.label), 43, oue))), 128))
    ])
  ], 512);
}
var aue = /* @__PURE__ */ pl(Jce, [["render", iue]]);
function S0(t) {
  document && document.dispatchEvent(new CustomEvent("show-popover", {
    detail: t
  }));
}
function w0(t) {
  document && document.dispatchEvent(new CustomEvent("hide-popover", {
    detail: t
  }));
}
function p6(t) {
  document && document.dispatchEvent(new CustomEvent("toggle-popover", {
    detail: t
  }));
}
function sue(t) {
  document && document.dispatchEvent(new CustomEvent("update-popover", {
    detail: t
  }));
}
function Bd(t) {
  const { visibility: e } = t, n = e === "click", r = e === "hover", o = e === "hover-focus", i = e === "focus";
  t.autoHide = !n;
  let a = !1, s = !1;
  const { isRenderFn: l } = t, c = {
    click: l ? "onClick" : "click",
    mousemove: l ? "onMousemove" : "mousemove",
    mouseleave: l ? "onMouseleave" : "mouseleave",
    focusin: l ? "onFocusin" : "focusin",
    focusout: l ? "onFocusout" : "focusout"
  };
  return {
    [c.click](u) {
      n && (t.ref = u.target, p6(t), u.stopPropagation());
    },
    [c.mousemove](u) {
      t.ref = u.currentTarget, a || (a = !0, (r || o) && S0(t));
    },
    [c.mouseleave](u) {
      t.ref = u.target, a && (a = !1, (r || o && !s) && w0(t));
    },
    [c.focusin](u) {
      t.ref = u.currentTarget, s || (s = !0, (i || o) && S0(t));
    },
    [c.focusout](u) {
      t.ref = u.currentTarget, s && !Xl(t.ref, u.relatedTarget) && (s = !1, (i || o && !a) && w0(t));
    }
  };
}
const lue = {
  name: "CalendarDay",
  emits: [
    "dayclick",
    "daymouseenter",
    "daymouseleave",
    "dayfocusin",
    "dayfocusout",
    "daykeydown"
  ],
  mixins: [Kf, Op],
  inheritAttrs: !1,
  render() {
    const t = () => this.hasBackgrounds && Me("div", {
      class: "vc-highlights vc-day-layer"
    }, this.backgrounds.map(({ key: o, wrapperClass: i, class: a, style: s }) => Me("div", {
      key: o,
      class: i
    }, [
      Me("div", {
        class: a,
        style: s
      })
    ]))), e = () => this.safeSlot("day-content", {
      day: this.day,
      attributes: this.day.attributes,
      attributesMap: this.day.attributesMap,
      dayProps: this.dayContentProps,
      dayEvents: this.dayContentEvents
    }) || Me("span", tt(be(tt(be({}, this.dayContentProps), {
      class: this.dayContentClass,
      style: this.dayContentStyle
    }), this.dayContentEvents), {
      ref: "content"
    }), [this.day.label]), n = () => this.hasDots && Me("div", {
      class: "vc-day-layer vc-day-box-center-bottom"
    }, [
      Me("div", {
        class: "vc-dots"
      }, this.dots.map(({ key: o, class: i, style: a }) => Me("span", {
        key: o,
        class: i,
        style: a
      })))
    ]), r = () => this.hasBars && Me("div", {
      class: "vc-day-layer vc-day-box-center-bottom"
    }, [
      Me("div", {
        class: "vc-bars"
      }, this.bars.map(({ key: o, class: i, style: a }) => Me("span", {
        key: o,
        class: i,
        style: a
      })))
    ]);
    return Me("div", {
      class: [
        "vc-day",
        ...this.day.classes,
        { "vc-day-box-center-center": !this.$slots["day-content"] },
        { "is-not-in-month": !this.inMonth }
      ]
    }, [t(), e(), n(), r()]);
  },
  inject: ["sharedState"],
  props: {
    day: { type: Object, required: !0 }
  },
  data() {
    return {
      glyphs: {},
      dayContentEvents: {}
    };
  },
  computed: {
    label() {
      return this.day.label;
    },
    startTime() {
      return this.day.range.start.getTime();
    },
    endTime() {
      return this.day.range.end.getTime();
    },
    inMonth() {
      return this.day.inMonth;
    },
    isDisabled() {
      return this.day.isDisabled;
    },
    backgrounds() {
      return this.glyphs.backgrounds;
    },
    hasBackgrounds() {
      return !!ur(this.backgrounds);
    },
    content() {
      return this.glyphs.content;
    },
    dots() {
      return this.glyphs.dots;
    },
    hasDots() {
      return !!ur(this.dots);
    },
    bars() {
      return this.glyphs.bars;
    },
    hasBars() {
      return !!ur(this.bars);
    },
    popovers() {
      return this.glyphs.popovers;
    },
    hasPopovers() {
      return !!ur(this.popovers);
    },
    dayContentClass() {
      return [
        "vc-day-content vc-focusable",
        { "is-disabled": this.isDisabled },
        Dc(Cc(this.content), "class") || ""
      ];
    },
    dayContentStyle() {
      return Dc(Cc(this.content), "style");
    },
    dayContentProps() {
      let t;
      return this.day.isFocusable ? t = "0" : this.day.inMonth && (t = "-1"), {
        tabindex: t,
        "aria-label": this.day.ariaLabel,
        "aria-disabled": this.day.isDisabled ? "true" : "false",
        role: "button"
      };
    },
    dayEvent() {
      return tt(be({}, this.day), {
        el: this.$refs.content,
        popovers: this.popovers
      });
    }
  },
  watch: {
    theme() {
      this.refresh();
    },
    popovers() {
      this.refreshPopovers();
    },
    "day.shouldRefresh"() {
      this.refresh();
    }
  },
  mounted() {
    this.refreshPopovers(), this.refresh();
  },
  methods: {
    getDayEvent(t) {
      return tt(be({}, this.dayEvent), {
        event: t
      });
    },
    click(t) {
      this.$emit("dayclick", this.getDayEvent(t));
    },
    mouseenter(t) {
      this.$emit("daymouseenter", this.getDayEvent(t));
    },
    mouseleave(t) {
      this.$emit("daymouseleave", this.getDayEvent(t));
    },
    focusin(t) {
      this.$emit("dayfocusin", this.getDayEvent(t));
    },
    focusout(t) {
      this.$emit("dayfocusout", this.getDayEvent(t));
    },
    keydown(t) {
      this.$emit("daykeydown", this.getDayEvent(t));
    },
    refresh() {
      if (!this.day.shouldRefresh)
        return;
      this.day.shouldRefresh = !1;
      const t = {
        backgrounds: [],
        dots: [],
        bars: [],
        popovers: [],
        content: []
      };
      this.day.attributes = Object.values(this.day.attributesMap || {}).sort((e, n) => e.order - n.order), this.day.attributes.forEach((e) => {
        const { targetDate: n } = e, { isDate: r, isComplex: o, startTime: i, endTime: a } = n, s = this.startTime <= i, l = this.endTime >= a, d = {
          isDate: r,
          isComplex: o,
          onStart: s,
          onEnd: l,
          onStartAndEnd: s && l,
          onStartOrEnd: s || l
        };
        this.processHighlight(e, d, t), this.processNonHighlight(e, "content", d, t.content), this.processNonHighlight(e, "dot", d, t.dots), this.processNonHighlight(e, "bar", d, t.bars), this.processPopover(e, t);
      }), this.glyphs = t;
    },
    processHighlight({ key: t, highlight: e }, { isDate: n, isComplex: r, onStart: o, onEnd: i, onStartAndEnd: a }, { backgrounds: s, content: l }) {
      if (!e)
        return;
      const { base: c, start: u, end: d } = e;
      n || r ? (s.push({
        key: t,
        wrapperClass: "vc-day-layer vc-day-box-center-center",
        class: ["vc-highlight", u.class],
        style: u.style
      }), l.push({
        key: `${t}-content`,
        class: u.contentClass,
        style: u.contentStyle
      })) : a ? (s.push({
        key: t,
        wrapperClass: "vc-day-layer vc-day-box-center-center",
        class: ["vc-highlight", u.class],
        style: u.style
      }), l.push({
        key: `${t}-content`,
        class: u.contentClass,
        style: u.contentStyle
      })) : o ? (s.push({
        key: `${t}-base`,
        wrapperClass: "vc-day-layer vc-day-box-right-center",
        class: ["vc-highlight vc-highlight-base-start", c.class],
        style: c.style
      }), s.push({
        key: t,
        wrapperClass: "vc-day-layer vc-day-box-center-center",
        class: ["vc-highlight", u.class],
        style: u.style
      }), l.push({
        key: `${t}-content`,
        class: u.contentClass,
        style: u.contentStyle
      })) : i ? (s.push({
        key: `${t}-base`,
        wrapperClass: "vc-day-layer vc-day-box-left-center",
        class: ["vc-highlight vc-highlight-base-end", c.class],
        style: c.style
      }), s.push({
        key: t,
        wrapperClass: "vc-day-layer vc-day-box-center-center",
        class: ["vc-highlight", d.class],
        style: d.style
      }), l.push({
        key: `${t}-content`,
        class: d.contentClass,
        style: d.contentStyle
      })) : (s.push({
        key: `${t}-middle`,
        wrapperClass: "vc-day-layer vc-day-box-center-center",
        class: ["vc-highlight vc-highlight-base-middle", c.class],
        style: c.style
      }), l.push({
        key: `${t}-content`,
        class: c.contentClass,
        style: c.contentStyle
      }));
    },
    processNonHighlight(t, e, { isDate: n, onStart: r, onEnd: o }, i) {
      if (!t[e])
        return;
      const { key: a } = t, s = `vc-${e}`, { base: l, start: c, end: u } = t[e];
      n || r ? i.push({
        key: a,
        class: [s, c.class],
        style: c.style
      }) : o ? i.push({
        key: a,
        class: [s, u.class],
        style: u.style
      }) : i.push({
        key: a,
        class: [s, l.class],
        style: l.style
      });
    },
    processPopover(t, { popovers: e }) {
      const { key: n, customData: r, popover: o } = t;
      if (!o)
        return;
      const i = Zl({
        key: n,
        customData: r,
        attribute: t
      }, be({}, o), {
        visibility: o.label ? "hover" : "click",
        placement: "bottom",
        isInteractive: !o.label
      });
      e.splice(0, 0, i);
    },
    refreshPopovers() {
      let t = {};
      ur(this.popovers) && (t = Bd(Zl({ id: this.dayPopoverId, data: this.day, isRenderFn: !0 }, ...this.popovers))), this.dayContentEvents = Ale({
        onClick: this.click,
        onMouseenter: this.mouseenter,
        onMouseleave: this.mouseleave,
        onFocusin: this.focusin,
        onFocusout: this.focusout,
        onKeydown: this.keydown
      }, t), sue({
        id: this.dayPopoverId,
        data: this.day
      });
    }
  }
}, cue = {
  name: "CalendarPane",
  emits: ["update:page", "weeknumberclick"],
  mixins: [Kf, Op],
  inheritAttrs: !1,
  render() {
    const t = this.safeSlot("header", this.page) || Me("div", { class: `vc-header align-${this.titlePosition}` }, [
      Me("div", be({
        class: "vc-title"
      }, this.navPopoverEvents), [this.safeSlot("header-title", this.page, this.page.title)])
    ]), e = this.weekdayLabels.map((l, c) => Me("div", {
      key: c + 1,
      class: "vc-weekday"
    }, [l])), n = this.showWeeknumbers_.startsWith("left"), r = this.showWeeknumbers_.startsWith("right");
    n ? e.unshift(Me("div", {
      class: "vc-weekday"
    })) : r && e.push(Me("div", {
      class: "vc-weekday"
    }));
    const o = (l) => Me("div", {
      class: ["vc-weeknumber"]
    }, [
      Me("span", {
        class: ["vc-weeknumber-content", `is-${this.showWeeknumbers_}`],
        onClick: (c) => {
          this.$emit("weeknumberclick", {
            weeknumber: l,
            days: this.page.days.filter((u) => u[this.weeknumberKey] === l),
            event: c
          });
        }
      }, [l])
    ]), i = [], { daysInWeek: a } = this.locale;
    this.page.days.forEach((l, c) => {
      const u = c % a;
      (n && u === 0 || r && u === a) && i.push(o(l[this.weeknumberKey])), i.push(Me(lue, tt(be({}, this.$attrs), {
        day: l
      }), this.$slots)), r && u === a - 1 && i.push(o(l[this.weeknumberKey]));
    });
    const s = Me("div", {
      class: {
        "vc-weeks": !0,
        "vc-show-weeknumbers": this.showWeeknumbers_,
        "is-left": n,
        "is-right": r
      }
    }, [e, i]);
    return Me("div", {
      class: [
        "vc-pane",
        `row-from-end-${this.rowFromEnd}`,
        `column-from-end-${this.columnFromEnd}`
      ],
      ref: "pane"
    }, [t, s]);
  },
  props: {
    page: Object,
    position: Number,
    row: Number,
    rowFromEnd: Number,
    column: Number,
    columnFromEnd: Number,
    titlePosition: String,
    navVisibility: {
      type: String,
      default: () => Ii("navVisibility")
    },
    showWeeknumbers: [Boolean, String],
    showIsoWeeknumbers: [Boolean, String]
  },
  computed: {
    weeknumberKey() {
      return this.showWeeknumbers ? "weeknumber" : "isoWeeknumber";
    },
    showWeeknumbers_() {
      const t = this.showWeeknumbers || this.showIsoWeeknumbers;
      return t == null ? "" : pz(t) ? t ? "left" : "" : t.startsWith("right") ? this.columnFromEnd > 1 ? "right" : t : this.column > 1 ? "left" : t;
    },
    navPlacement() {
      switch (this.titlePosition) {
        case "left":
          return "bottom-start";
        case "right":
          return "bottom-end";
        default:
          return "bottom";
      }
    },
    navPopoverEvents() {
      const { sharedState: t, navVisibility: e, navPlacement: n, page: r, position: o } = this;
      return Bd({
        id: t.navPopoverId,
        visibility: e,
        placement: n,
        modifiers: [
          { name: "flip", options: { fallbackPlacements: ["bottom"] } }
        ],
        data: { page: r, position: o },
        isInteractive: !0,
        isRenderFn: !0
      });
    },
    weekdayLabels() {
      return this.locale.getWeekdayDates().map((t) => this.format(t, this.masks.weekdays));
    }
  }
};
class uue {
  constructor(e, n, r) {
    this.theme = e, this.locale = n, this.map = {}, this.refresh(r, !0);
  }
  destroy() {
    this.theme = null, this.locale = null, this.map = {}, this.list = [], this.pinAttr = null;
  }
  refresh(e, n) {
    const r = {}, o = [];
    let i = null;
    const a = [], s = n ? /* @__PURE__ */ new Set() : new Set(Object.keys(this.map));
    return ur(e) && e.forEach((l, c) => {
      if (!l || !l.dates)
        return;
      const u = l.key ? l.key.toString() : c.toString(), d = l.order || 0, f = Cle(JSON.stringify(l));
      let h = this.map[u];
      !n && h && h.hashcode === f ? s.delete(u) : (h = new h6(be({
        key: u,
        order: d,
        hashcode: f
      }, l), this.theme, this.locale), a.push(h)), h && h.pinPage && (i = h), r[u] = h, o.push(h);
    }), this.map = r, this.list = o, this.pinAttr = i, { adds: a, deletes: Array.from(s) };
  }
}
const due = (t, e, { maxSwipeTime: n, minHorizontalSwipeDistance: r, maxVerticalSwipeDistance: o }) => {
  if (!t || !t.addEventListener || !Go(e))
    return null;
  let i = 0, a = 0, s = null, l = !1;
  function c(d) {
    const f = d.changedTouches[0];
    i = f.screenX, a = f.screenY, s = (/* @__PURE__ */ new Date()).getTime(), l = !0;
  }
  function u(d) {
    if (!l)
      return;
    l = !1;
    const f = d.changedTouches[0], h = f.screenX - i, _ = f.screenY - a;
    if ((/* @__PURE__ */ new Date()).getTime() - s < n && Math.abs(h) >= r && Math.abs(_) <= o) {
      const m = { toLeft: !1, toRight: !1 };
      h < 0 ? m.toLeft = !0 : m.toRight = !0, e(m);
    }
  }
  return bn(t, "touchstart", c, { passive: !0 }), bn(t, "touchend", u, { passive: !0 }), () => {
    Rn(t, "touchstart", c), Rn(t, "touchend", u);
  };
}, fue = {
  name: "Calendar",
  emits: [
    "dayfocusin",
    "dayfocusout",
    "transition-start",
    "transition-end",
    "update:from-page",
    "update:to-page"
  ],
  render() {
    const t = this.pages.map((o, i) => {
      const a = i + 1, s = Math.ceil((i + 1) / this.columns), l = this.rows - s + 1, c = a % this.columns || this.columns, u = this.columns - c + 1;
      return Me(cue, tt(be({}, this.$attrs), {
        key: o.key,
        attributes: this.store,
        page: o,
        position: a,
        row: s,
        rowFromEnd: l,
        column: c,
        columnFromEnd: u,
        titlePosition: this.titlePosition,
        canMove: this.canMove,
        "onUpdate:page": (d) => this.move(d, { position: i + 1 }),
        onDayfocusin: (d) => {
          this.lastFocusedDay = d, this.$emit("dayfocusin", d);
        },
        onDayfocusout: (d) => {
          this.lastFocusedDay = null, this.$emit("dayfocusout", d);
        }
      }), this.$slots);
    }), e = (o) => {
      const i = () => this.move(o ? -this.step_ : this.step_), a = (l) => u6(l, i), s = o ? !this.canMovePrev : !this.canMoveNext;
      return Me("div", {
        class: [
          "vc-arrow",
          `is-${o ? "left" : "right"}`,
          { "is-disabled": s }
        ],
        role: "button",
        onClick: i,
        onKeydown: a
      }, [
        (o ? this.safeSlot("header-left-button", { click: i }) : this.safeSlot("header-right-button", { click: i })) || Me(E6, {
          name: o ? "left-arrow" : "right-arrow"
        })
      ]);
    }, n = () => Me(D0, {
      id: this.sharedState.navPopoverId,
      contentClass: "vc-nav-popover-container",
      ref: "navPopover"
    }, {
      default: ({ data: o }) => {
        const { position: i, page: a } = o;
        return Me(aue, {
          value: a,
          position: i,
          validator: (s) => this.canMove(s, { position: i }),
          onInput: (s) => this.move(s)
        }, be({}, this.$slots));
      }
    }), r = () => Me(D0, {
      id: this.sharedState.dayPopoverId,
      contentClass: "vc-day-popover-container"
    }, {
      default: ({ data: o, updateLayout: i, hide: a }) => {
        const s = Object.values(o.attributes).filter((d) => d.popover), l = this.$locale.masks, c = this.formatDate, u = c(o.date, l.dayPopover);
        return this.safeSlot("day-popover", {
          day: o,
          attributes: s,
          masks: l,
          format: c,
          dayTitle: u,
          updateLayout: i,
          hide: a
        }, Me("div", [
          l.dayPopover && Me("div", {
            class: ["vc-day-popover-header"]
          }, [u]),
          s.map((d) => Me(Yce, {
            key: d.key,
            attribute: d
          }))
        ]));
      }
    });
    return Me("div", {
      "data-helptext": "Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year",
      class: [
        "vc-container",
        `vc-${this.$theme.color}`,
        {
          "vc-is-expanded": this.isExpanded,
          "vc-is-dark": this.$theme.isDark
        }
      ],
      onKeydown: this.handleKeydown,
      onMouseup: (o) => o.preventDefault(),
      ref: "container"
    }, [
      n(),
      Me("div", {
        class: [
          "vc-pane-container",
          { "in-transition": this.inTransition }
        ]
      }, [
        Me(d6, {
          name: this.transitionName,
          "on-before-enter": () => {
            this.inTransition = !0;
          },
          "on-after-enter": () => {
            this.inTransition = !1;
          }
        }, {
          default: () => Me("div", tt(be({}, this.$attrs), {
            class: "vc-pane-layout",
            style: {
              gridTemplateColumns: `repeat(${this.columns}, 1fr)`
            },
            key: this.firstPage ? this.firstPage.key : ""
          }), t)
        }),
        Me("div", {
          class: [`vc-arrows-container title-${this.titlePosition}`]
        }, [e(!0), e(!1)]),
        this.$slots.footer && this.$slots.footer()
      ]),
      r()
    ]);
  },
  mixins: [_6, Op],
  provide() {
    return {
      sharedState: this.sharedState
    };
  },
  props: {
    rows: {
      type: Number,
      default: 1
    },
    columns: {
      type: Number,
      default: 1
    },
    step: Number,
    titlePosition: {
      type: String,
      default: () => Ii("titlePosition")
    },
    isExpanded: Boolean,
    fromDate: Date,
    toDate: Date,
    fromPage: Object,
    toPage: Object,
    minPage: Object,
    maxPage: Object,
    transition: String,
    attributes: [Object, Array],
    trimWeeks: Boolean,
    disablePageSwipe: Boolean
  },
  data() {
    return {
      pages: [],
      store: null,
      lastFocusedDay: null,
      focusableDay: (/* @__PURE__ */ new Date()).getDate(),
      transitionName: "",
      inTransition: !1,
      sharedState: {
        navPopoverId: xd(),
        dayPopoverId: xd(),
        theme: {},
        masks: {},
        locale: {}
      }
    };
  },
  computed: {
    firstPage() {
      return s6(this.pages);
    },
    lastPage() {
      return Cc(this.pages);
    },
    minPage_() {
      return this.minPage || this.pageForDate(this.minDate);
    },
    maxPage_() {
      return this.maxPage || this.pageForDate(this.maxDate);
    },
    count() {
      return this.rows * this.columns;
    },
    step_() {
      return this.step || this.count;
    },
    canMovePrev() {
      return this.canMove(-this.step_);
    },
    canMoveNext() {
      return this.canMove(this.step_);
    }
  },
  watch: {
    $locale() {
      this.refreshLocale(), this.refreshPages({ page: this.firstPage, ignoreCache: !0 }), this.initStore();
    },
    $theme() {
      this.refreshTheme(), this.initStore();
    },
    fromDate() {
      this.refreshPages();
    },
    fromPage(t) {
      const e = this.pages && this.pages[0];
      k1(t, e) || this.refreshPages();
    },
    toPage(t) {
      const e = this.pages && this.pages[this.pages.length - 1];
      k1(t, e) || this.refreshPages();
    },
    count() {
      this.refreshPages();
    },
    attributes: {
      handler(t) {
        const { adds: e, deletes: n } = this.store.refresh(t);
        this.refreshAttrs(this.pages, e, n);
      },
      deep: !0
    },
    pages(t) {
      this.refreshAttrs(t, this.store.list, null, !0);
    },
    disabledAttribute() {
      this.refreshDisabledDays();
    },
    lastFocusedDay(t) {
      t && (this.focusableDay = t.day, this.refreshFocusableDays());
    },
    inTransition(t) {
      t ? this.$emit("transition-start") : (this.$emit("transition-end"), this.transitionPromise && (this.transitionPromise.resolve(!0), this.transitionPromise = null));
    }
  },
  created() {
    this.refreshLocale(), this.refreshTheme(), this.initStore(), this.refreshPages();
  },
  mounted() {
    this.disablePageSwipe || (this.removeHandlers = due(this.$refs.container, ({ toLeft: t, toRight: e }) => {
      t ? this.moveNext() : e && this.movePrev();
    }, Ii("touch")));
  },
  beforeUnmount() {
    this.pages = [], this.store.destroy(), this.store = null, this.sharedState = null, this.removeHandlers && this.removeHandlers();
  },
  methods: {
    refreshLocale() {
      this.sharedState.locale = this.$locale, this.sharedState.masks = this.$locale.masks;
    },
    refreshTheme() {
      this.sharedState.theme = this.$theme;
    },
    canMove(t, e = {}) {
      const n = this.firstPage && this.$locale.toPage(t, this.firstPage);
      if (!n)
        return !1;
      let { position: r } = e;
      if (zl(t) && (r = 1), !r)
        if (Ul(n, this.firstPage))
          r = -1;
        else if (ql(n, this.lastPage))
          r = 1;
        else
          return !0;
      return Object.assign(e, this.getTargetPageRange(n, {
        position: r,
        force: !0
      })), Dle(e.fromPage, e.toPage).some((o) => c6(o, this.minPage_, this.maxPage_));
    },
    movePrev(t) {
      return this.move(-this.step_, t);
    },
    moveNext(t) {
      return this.move(this.step_, t);
    },
    move(t, e = {}) {
      const n = this.canMove(t, e);
      return !e.force && !n ? Promise.reject(new Error(`Move target is disabled: ${JSON.stringify(e)}`)) : (this.$refs.navPopover.hide({ hideDelay: 0 }), e.fromPage && !k1(e.fromPage, this.firstPage) ? this.refreshPages(tt(be({}, e), {
        page: e.fromPage,
        position: 1,
        force: !0
      })) : Promise.resolve(!0));
    },
    focusDate(t, e = {}) {
      return this.move(t, e).then(() => {
        const n = this.$el.querySelector(`.id-${this.$locale.getDayId(t)}.in-month .vc-focusable`);
        return n ? (n.focus(), Promise.resolve(!0)) : Promise.resolve(!1);
      });
    },
    showPageRange(t, e) {
      let n, r;
      if (gi(t))
        n = this.pageForDate(t);
      else if (_r(t)) {
        const { month: a, year: s } = t, { from: l, to: c } = t;
        zl(a) && zl(s) ? n = t : (l || c) && (n = gi(l) ? this.pageForDate(l) : l, r = gi(c) ? this.pageForDate(c) : c);
      } else
        return Promise.reject(new Error("Invalid page range provided."));
      const o = this.lastPage;
      let i = n;
      return ql(r, o) && (i = Mo(r, -(this.pages.length - 1))), Ul(i, n) && (i = n), this.refreshPages(tt(be({}, e), { page: i }));
    },
    getTargetPageRange(t, { position: e, force: n } = {}) {
      let r = null, o = null;
      if (Qn(t)) {
        let i = 0;
        e = +e, isNaN(e) || (i = e > 0 ? 1 - e : -(this.count + e)), r = Mo(t, i);
      } else
        r = this.getDefaultInitialPage();
      return o = Mo(r, this.count - 1), n || (Ul(r, this.minPage_) ? r = this.minPage_ : ql(o, this.maxPage_) && (r = Mo(this.maxPage_, 1 - this.count)), o = Mo(r, this.count - 1)), { fromPage: r, toPage: o };
    },
    getDefaultInitialPage() {
      let t = this.fromPage || this.pageForDate(this.fromDate);
      if (!Qn(t)) {
        const e = this.toPage || this.pageForDate(this.toPage);
        Qn(e) && (t = Mo(e, 1 - this.count));
      }
      return Qn(t) || (t = this.getPageForAttributes()), Qn(t) || (t = this.pageForThisMonth()), t;
    },
    refreshPages({ page: t, position: e = 1, force: n, transition: r, ignoreCache: o } = {}) {
      return new Promise((i, a) => {
        const { fromPage: s, toPage: l } = this.getTargetPageRange(t, {
          position: e,
          force: n
        }), c = [];
        for (let u = 0; u < this.count; u++)
          c.push(this.buildPage(Mo(s, u), o));
        this.refreshDisabledDays(c), this.refreshFocusableDays(c), this.transitionName = this.getPageTransition(this.pages[0], c[0], r), this.pages = c, this.$emit("update:from-page", s), this.$emit("update:to-page", l), this.transitionName && this.transitionName !== "none" ? this.transitionPromise = {
          resolve: i,
          reject: a
        } : i(!0);
      });
    },
    refreshDisabledDays(t) {
      this.getPageDays(t).forEach((e) => {
        e.isDisabled = !!this.disabledAttribute && this.disabledAttribute.intersectsDay(e);
      });
    },
    refreshFocusableDays(t) {
      this.getPageDays(t).forEach((e) => {
        e.isFocusable = e.inMonth && e.day === this.focusableDay;
      });
    },
    getPageDays(t = this.pages) {
      return t.reduce((e, n) => e.concat(n.days), []);
    },
    getPageTransition(t, e, n = this.transition) {
      if (n === "none")
        return n;
      if (n === "fade" || !n && this.count > 1 || !Qn(t) || !Qn(e))
        return "fade";
      const r = Ul(e, t);
      return n === "slide-v" ? r ? "slide-down" : "slide-up" : r ? "slide-right" : "slide-left";
    },
    getPageForAttributes() {
      let t = null;
      const e = this.store.pinAttr;
      if (e && e.hasDates) {
        let [n] = e.dates;
        n = n.start || n.date, t = this.pageForDate(n);
      }
      return t;
    },
    buildPage({ month: t, year: e }, n) {
      const r = `${e.toString()}-${t.toString()}`;
      let o = this.pages.find((i) => i.key === r);
      if (!o || n) {
        const i = new Date(e, t - 1, 15), a = this.$locale.getMonthComps(t, e), s = this.$locale.getPrevMonthComps(t, e), l = this.$locale.getNextMonthComps(t, e);
        o = {
          key: r,
          month: t,
          year: e,
          weeks: this.trimWeeks ? a.weeks : 6,
          title: this.$locale.format(i, this.$locale.masks.title),
          shortMonthLabel: this.$locale.format(i, "MMM"),
          monthLabel: this.$locale.format(i, "MMMM"),
          shortYearLabel: e.toString().substring(2),
          yearLabel: e.toString(),
          monthComps: a,
          prevMonthComps: s,
          nextMonthComps: l,
          canMove: (c) => this.canMove(c),
          move: (c) => this.move(c),
          moveThisMonth: () => this.moveThisMonth(),
          movePrevMonth: () => this.move(s),
          moveNextMonth: () => this.move(l),
          refresh: !0
        }, o.days = this.$locale.getCalendarDays(o);
      }
      return o;
    },
    initStore() {
      this.store = new uue(this.$theme, this.$locale, this.attributes), this.refreshAttrs(this.pages, this.store.list, [], !0);
    },
    refreshAttrs(t = [], e = [], n = [], r) {
      ur(t) && t.forEach((o) => {
        o.days.forEach((i) => {
          let a = !1, s = {};
          r ? a = !0 : A0(i.attributesMap, n) ? (s = O0(i.attributesMap, n), a = !0) : s = i.attributesMap || {}, e.forEach((l) => {
            const c = l.intersectsDay(i);
            if (c) {
              const u = tt(be({}, l), {
                targetDate: c
              });
              s[l.key] = u, a = !0;
            }
          }), a && (i.attributesMap = s, i.shouldRefresh = !0);
        });
      });
    },
    handleKeydown(t) {
      const e = this.lastFocusedDay;
      e != null && (e.event = t, this.handleDayKeydown(e));
    },
    handleDayKeydown(t) {
      const { dateFromTime: e, event: n } = t, r = e(12);
      let o = null;
      switch (n.key) {
        case "ArrowLeft": {
          o = eo(r, -1);
          break;
        }
        case "ArrowRight": {
          o = eo(r, 1);
          break;
        }
        case "ArrowUp": {
          o = eo(r, -7);
          break;
        }
        case "ArrowDown": {
          o = eo(r, 7);
          break;
        }
        case "Home": {
          o = eo(r, -t.weekdayPosition + 1);
          break;
        }
        case "End": {
          o = eo(r, t.weekdayPositionFromEnd);
          break;
        }
        case "PageUp": {
          n.altKey ? o = FN(r, -1) : o = p0(r, -1);
          break;
        }
        case "PageDown": {
          n.altKey ? o = FN(r, 1) : o = p0(r, 1);
          break;
        }
      }
      o && (n.preventDefault(), this.focusDate(o).catch());
    }
  }
}, hue = {
  inheritAttrs: !1,
  emits: ["update:modelValue"],
  props: {
    options: Array,
    modelValue: null
  }
}, _ue = { class: "vc-select" }, Eue = ["value"], pue = ["value", "disabled"], mue = /* @__PURE__ */ g("div", { class: "vc-select-arrow" }, [
  /* @__PURE__ */ g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, [
    /* @__PURE__ */ g("path", { d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" })
  ])
], -1);
function Nue(t, e, n, r, o, i) {
  return v(), A("div", _ue, [
    g("select", Tt(t.$attrs, {
      value: n.modelValue,
      onChange: e[0] || (e[0] = (a) => t.$emit("update:modelValue", a.target.value))
    }), [
      (v(!0), A(ge, null, ye(n.options, (a) => (v(), A("option", {
        key: a.value,
        value: a.value,
        disabled: a.disabled
      }, Q(a.label), 9, pue))), 128))
    ], 16, Eue),
    mue
  ]);
}
var vue = /* @__PURE__ */ pl(hue, [["render", Nue]]);
const gue = [
  { value: 0, label: "12" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" }
], Iue = [
  { value: 12, label: "12" },
  { value: 13, label: "1" },
  { value: 14, label: "2" },
  { value: 15, label: "3" },
  { value: 16, label: "4" },
  { value: 17, label: "5" },
  { value: 18, label: "6" },
  { value: 19, label: "7" },
  { value: 20, label: "8" },
  { value: 21, label: "9" },
  { value: 22, label: "10" },
  { value: 23, label: "11" }
], Oue = {
  name: "TimePicker",
  components: { TimeSelect: vue },
  emits: ["update:modelValue"],
  props: {
    modelValue: { type: Object, required: !0 },
    locale: { type: Object, required: !0 },
    theme: { type: Object, required: !0 },
    is24hr: { type: Boolean, default: !0 },
    showBorder: Boolean,
    hourOptions: Array,
    minuteOptions: Array
  },
  computed: {
    date() {
      let t = this.locale.normalizeDate(this.modelValue);
      return this.modelValue.hours === 24 && (t = new Date(t.getTime() - 1)), t;
    },
    hours: {
      get() {
        return this.modelValue.hours;
      },
      set(t) {
        this.updateValue(t, this.minutes);
      }
    },
    minutes: {
      get() {
        return this.modelValue.minutes;
      },
      set(t) {
        this.updateValue(this.hours, t);
      }
    },
    isAM: {
      get() {
        return this.modelValue.hours < 12;
      },
      set(t) {
        let e = this.hours;
        t && e >= 12 ? e -= 12 : !t && e < 12 && (e += 12), this.updateValue(e, this.minutes);
      }
    },
    amHourOptions() {
      return gue.filter((t) => this.hourOptions.some((e) => e.value === t.value));
    },
    pmHourOptions() {
      return Iue.filter((t) => this.hourOptions.some((e) => e.value === t.value));
    },
    hourOptions_() {
      return this.is24hr ? this.hourOptions : this.isAM ? this.amHourOptions : this.pmHourOptions;
    },
    amDisabled() {
      return !ur(this.amHourOptions);
    },
    pmDisabled() {
      return !ur(this.pmHourOptions);
    }
  },
  methods: {
    updateValue(t, e = this.minutes) {
      (t !== this.hours || e !== this.minutes) && this.$emit("update:modelValue", tt(be({}, this.modelValue), {
        hours: t,
        minutes: e,
        seconds: 0,
        milliseconds: 0
      }));
    }
  }
}, Aue = /* @__PURE__ */ g("div", null, [
  /* @__PURE__ */ g("svg", {
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    viewBox: "0 0 24 24",
    class: "vc-time-icon",
    stroke: "currentColor"
  }, [
    /* @__PURE__ */ g("path", { d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" })
  ])
], -1), Due = { class: "vc-time-content" }, Cue = {
  key: 0,
  class: "vc-time-date"
}, Sue = { class: "vc-time-weekday" }, wue = { class: "vc-time-month" }, Tue = { class: "vc-time-day" }, bue = { class: "vc-time-year" }, Rue = { class: "vc-time-select" }, Mue = /* @__PURE__ */ g("span", { style: { margin: "0 4px" } }, ":", -1), Pue = {
  key: 0,
  class: "vc-am-pm"
};
function yue(t, e, n, r, o, i) {
  const a = ee("time-select");
  return v(), A("div", {
    class: z(["vc-time-picker", [{ "vc-invalid": !n.modelValue.isValid, "vc-bordered": n.showBorder }]])
  }, [
    Aue,
    g("div", Due, [
      i.date ? (v(), A("div", Cue, [
        g("span", Sue, Q(n.locale.format(i.date, "WWW")), 1),
        g("span", wue, Q(n.locale.format(i.date, "MMM")), 1),
        g("span", Tue, Q(n.locale.format(i.date, "D")), 1),
        g("span", bue, Q(n.locale.format(i.date, "YYYY")), 1)
      ])) : V("", !0),
      g("div", Rue, [
        H(a, {
          modelValue: i.hours,
          "onUpdate:modelValue": e[0] || (e[0] = (s) => i.hours = s),
          modelModifiers: { number: !0 },
          options: i.hourOptions_
        }, null, 8, ["modelValue", "options"]),
        Mue,
        H(a, {
          modelValue: i.minutes,
          "onUpdate:modelValue": e[1] || (e[1] = (s) => i.minutes = s),
          modelModifiers: { number: !0 },
          options: n.minuteOptions
        }, null, 8, ["modelValue", "options"]),
        n.is24hr ? V("", !0) : (v(), A("div", Pue, [
          g("button", {
            class: z({ active: i.isAM, "vc-disabled": i.amDisabled }),
            onClick: e[2] || (e[2] = ua((s) => i.isAM = !0, ["prevent"])),
            type: "button"
          }, " AM ", 2),
          g("button", {
            class: z({ active: !i.isAM, "vc-disabled": i.pmDisabled }),
            onClick: e[3] || (e[3] = ua((s) => i.isAM = !1, ["prevent"])),
            type: "button"
          }, " PM ", 2)
        ]))
      ])
    ])
  ], 2);
}
var Lue = /* @__PURE__ */ pl(Oue, [["render", yue]]);
const n3 = {
  type: "auto",
  mask: "iso",
  timeAdjust: ""
}, xue = [n3, n3], $u = {
  DATE: "date",
  DATE_TIME: "datetime",
  TIME: "time"
}, Jn = {
  NONE: 0,
  START: 1,
  END: 2,
  BOTH: 3
}, m6 = {
  name: "DatePicker",
  emits: [
    "update:modelValue",
    "drag",
    "dayclick",
    "daykeydown",
    "popover-will-show",
    "popover-did-show",
    "popover-will-hide",
    "popover-did-hide"
  ],
  render() {
    const t = (o, i) => {
      if (!this.$slots.footer)
        return o;
      const a = [o, this.$slots.footer()];
      return i ? Me(i, a) : a;
    }, e = () => {
      if (!this.dateParts)
        return null;
      const o = this.isRange ? this.dateParts : [this.dateParts[0]];
      return Me("div", {}, tt(be({}, this.$slots), {
        default: () => o.map((i, a) => {
          const s = this.$locale.getHourOptions(this.modelConfig_[a].validHours, i), l = this.$locale.getMinuteOptions(this.modelConfig_[a].minuteIncrement, i);
          return Me(Lue, {
            modelValue: i,
            locale: this.$locale,
            theme: this.$theme,
            is24hr: this.is24hr,
            showBorder: !this.isTime,
            isDisabled: this.isDateTime && !i.isValid || this.isDragging,
            hourOptions: s,
            minuteOptions: l,
            "onUpdate:modelValue": (c) => this.onTimeInput(c, a === 0)
          });
        })
      }));
    }, n = () => Me(fue, tt(be({}, this.$attrs), {
      attributes: this.attributes_,
      theme: this.$theme,
      locale: this.$locale,
      minDate: this.minDateExact || this.minDate,
      maxDate: this.maxDateExact || this.maxDate,
      disabledDates: this.disabledDates,
      availableDates: this.availableDates,
      onDayclick: this.onDayClick,
      onDaykeydown: this.onDayKeydown,
      onDaymouseenter: this.onDayMouseEnter,
      ref: "calendar"
    }), tt(be({}, this.$slots), {
      footer: () => this.isDateTime ? t(e()) : t()
    })), r = () => this.isTime ? Me("div", {
      class: [
        "vc-container",
        `vc-${this.$theme.color}`,
        { "vc-is-dark": this.$theme.isDark }
      ]
    }, t(e(), "div")) : n();
    return this.$slots.default ? Me("div", [
      this.$slots.default(this.slotArgs),
      Me(D0, {
        id: this.datePickerPopoverId,
        placement: "bottom-start",
        contentClass: `vc-container${this.isDark ? " vc-is-dark" : ""}`,
        "on-before-show": (o) => this.$emit("popover-will-show", o),
        "on-after-show": (o) => this.$emit("popover-did-show", o),
        "on-before-hide": (o) => this.$emit("popover-will-hide", o),
        "on-after-hide": (o) => this.$emit("popover-did-hide", o),
        ref: "popover"
      }, {
        default: r
      })
    ]) : r();
  },
  mixins: [_6],
  props: {
    mode: { type: String, default: $u.DATE },
    modelValue: { type: null, required: !0 },
    modelConfig: { type: Object, default: () => ({}) },
    is24hr: Boolean,
    minuteIncrement: Number,
    isRequired: Boolean,
    isRange: Boolean,
    updateOnInput: {
      type: Boolean,
      default: () => Ii("datePicker.updateOnInput")
    },
    inputDebounce: {
      type: Number,
      default: () => Ii("datePicker.inputDebounce")
    },
    popover: { type: Object, default: () => ({}) },
    dragAttribute: Object,
    selectAttribute: Object,
    attributes: Array,
    validHours: [Object, Array, Function]
  },
  data() {
    return {
      value_: null,
      dateParts: null,
      activeDate: "",
      dragValue: null,
      inputValues: ["", ""],
      updateTimeout: null,
      watchValue: !0,
      datePickerPopoverId: xd()
    };
  },
  computed: {
    isDate() {
      return this.mode.toLowerCase() === $u.DATE;
    },
    isDateTime() {
      return this.mode.toLowerCase() === $u.DATE_TIME;
    },
    isTime() {
      return this.mode.toLowerCase() === $u.TIME;
    },
    isDragging() {
      return !!this.dragValue;
    },
    modelConfig_() {
      return this.normalizeConfig(this.modelConfig, xue);
    },
    inputMask() {
      const t = this.$locale.masks;
      return this.isTime ? this.is24hr ? t.inputTime24hr : t.inputTime : this.isDateTime ? this.is24hr ? t.inputDateTime24hr : t.inputDateTime : this.$locale.masks.input;
    },
    inputMaskHasTime() {
      return /[Hh]/g.test(this.inputMask);
    },
    inputMaskHasDate() {
      return /[dD]{1,2}|Do|W{1,4}|M{1,4}|YY(?:YY)?/g.test(this.inputMask);
    },
    inputMaskPatch() {
      if (this.inputMaskHasTime && this.inputMaskHasDate)
        return ni.DATE_TIME;
      if (this.inputMaskHasDate)
        return ni.DATE;
      if (this.inputMaskHasTime)
        return ni.TIME;
    },
    slotArgs() {
      const {
        isRange: t,
        isDragging: e,
        updateValue: n,
        showPopover: r,
        hidePopover: o,
        togglePopover: i
      } = this, a = t ? {
        start: this.inputValues[0],
        end: this.inputValues[1]
      } : this.inputValues[0], s = [!0, !1].map((c) => be({
        input: this.onInputInput(c),
        change: this.onInputChange(c),
        keyup: this.onInputKeyup
      }, Bd(tt(be({}, this.popover_), {
        id: this.datePickerPopoverId,
        callback: (u) => {
          u.action === "show" && u.completed && this.onInputShow(c);
        }
      })))), l = t ? {
        start: s[0],
        end: s[1]
      } : s[0];
      return {
        inputValue: a,
        inputEvents: l,
        isDragging: e,
        updateValue: n,
        showPopover: r,
        hidePopover: o,
        togglePopover: i,
        getPopoverTriggerEvents: Bd
      };
    },
    popover_() {
      return gp(this.popover, Ii("datePicker.popover"));
    },
    selectAttribute_() {
      if (!this.hasValue(this.value_))
        return null;
      const t = tt(be({
        key: "select-drag"
      }, this.selectAttribute), {
        dates: this.value_,
        pinPage: !0
      }), { dot: e, bar: n, highlight: r, content: o } = t;
      return !e && !n && !r && !o && (t.highlight = !0), t;
    },
    dragAttribute_() {
      if (!this.isRange || !this.hasValue(this.dragValue))
        return null;
      const t = tt(be({
        key: "select-drag"
      }, this.dragAttribute), {
        dates: this.dragValue
      }), { dot: e, bar: n, highlight: r, content: o } = t;
      return !e && !n && !r && !o && (t.highlight = {
        startEnd: {
          fillMode: "outline"
        }
      }), t;
    },
    attributes_() {
      const t = Fn(this.attributes) ? [...this.attributes] : [];
      return this.dragAttribute_ ? t.push(this.dragAttribute_) : this.selectAttribute_ && t.push(this.selectAttribute_), t;
    }
  },
  watch: {
    inputMask() {
      this.formatInput();
    },
    modelValue(t) {
      this.watchValue && this.forceUpdateValue(t, {
        config: this.modelConfig_,
        formatInput: !0,
        hidePopover: !1
      });
    },
    value_() {
      this.refreshDateParts();
    },
    dragValue() {
      this.refreshDateParts();
    },
    timezone() {
      this.refreshDateParts(), this.forceUpdateValue(this.value_, { formatInput: !0 });
    }
  },
  created() {
    this.value_ = this.normalizeValue(this.modelValue, this.modelConfig_, ni.DATE_TIME, Jn.BOTH), this.forceUpdateValue(this.modelValue, {
      config: this.modelConfig_,
      formatInput: !0,
      hidePopover: !1
    }), this.refreshDateParts();
  },
  mounted() {
    bn(document, "keydown", this.onDocumentKeyDown), bn(document, "click", this.onDocumentClick);
  },
  beforeUnmount() {
    Rn(document, "keydown", this.onDocumentKeyDown), Rn(document, "click", this.onDocumentClick);
  },
  methods: {
    getDateParts(t) {
      return this.$locale.getDateParts(t);
    },
    getDateFromParts(t) {
      return this.$locale.getDateFromParts(t);
    },
    refreshDateParts() {
      const t = this.dragValue || this.value_, e = [];
      this.isRange ? (t && t.start ? e.push(this.getDateParts(t.start)) : e.push({}), t && t.end ? e.push(this.getDateParts(t.end)) : e.push({})) : t ? e.push(this.getDateParts(t)) : e.push({}), this.$nextTick(() => this.dateParts = e);
    },
    onDocumentKeyDown(t) {
      this.dragValue && t.key === "Escape" && (this.dragValue = null);
    },
    onDocumentClick(t) {
      document.body.contains(t.target) && !Xl(this.$el, t.target) && (this.dragValue = null, this.formatInput());
    },
    onDayClick(t) {
      this.handleDayClick(t), this.$emit("dayclick", t);
    },
    onDayKeydown(t) {
      switch (t.event.key) {
        case " ":
        case "Enter": {
          this.handleDayClick(t), t.event.preventDefault();
          break;
        }
        case "Escape":
          this.hidePopover();
      }
      this.$emit("daykeydown", t);
    },
    handleDayClick(t) {
      const { keepVisibleOnInput: e, visibility: n } = this.popover_, r = {
        patch: ni.DATE,
        adjustTime: !0,
        formatInput: !0,
        hidePopover: this.isDate && !e && n !== "visible"
      };
      this.isRange ? (this.isDragging ? this.dragTrackingValue.end = t.date : this.dragTrackingValue = be({}, t.range), r.isDragging = !this.isDragging, r.rangePriority = r.isDragging ? Jn.NONE : Jn.BOTH, r.hidePopover = r.hidePopover && !r.isDragging, this.updateValue(this.dragTrackingValue, r)) : (r.clearIfEqual = !this.isRequired, this.updateValue(t.date, r));
    },
    onDayMouseEnter(t) {
      this.isDragging && (this.dragTrackingValue.end = t.date, this.updateValue(this.dragTrackingValue, {
        patch: ni.DATE,
        adjustTime: !0,
        formatInput: !0,
        hidePriority: !1,
        rangePriority: Jn.NONE
      }));
    },
    onTimeInput(t, e) {
      let n = null;
      if (this.isRange) {
        const r = e ? t : this.dateParts[0], o = e ? this.dateParts[1] : t;
        n = { start: r, end: o };
      } else
        n = t;
      this.updateValue(n, {
        patch: ni.TIME,
        rangePriority: e ? Jn.START : Jn.END
      }).then(() => this.adjustPageRange(e));
    },
    onInputInput(t) {
      return (e) => {
        this.updateOnInput && this.onInputUpdate(e.target.value, t, {
          formatInput: !1,
          hidePopover: !1,
          debounce: this.inputDebounce
        });
      };
    },
    onInputChange(t) {
      return (e) => {
        this.onInputUpdate(e.target.value, t, {
          formatInput: !0,
          hidePopover: !1
        });
      };
    },
    onInputUpdate(t, e, n) {
      this.inputValues.splice(e ? 0 : 1, 1, t);
      const r = this.isRange ? {
        start: this.inputValues[0],
        end: this.inputValues[1] || this.inputValues[0]
      } : t, o = {
        type: "string",
        mask: this.inputMask
      };
      this.updateValue(r, tt(be({}, n), {
        config: o,
        patch: this.inputMaskPatch,
        rangePriority: e ? Jn.START : Jn.END
      })).then(() => this.adjustPageRange(e));
    },
    onInputShow(t) {
      this.adjustPageRange(t);
    },
    onInputKeyup(t) {
      t.key === "Escape" && this.updateValue(this.value_, {
        formatInput: !0,
        hidePopover: !0
      });
    },
    updateValue(t, e = {}) {
      return clearTimeout(this.updateTimeout), new Promise((n) => {
        const r = e, { debounce: o } = r, i = YK(r, ["debounce"]);
        o > 0 ? this.updateTimeout = setTimeout(() => {
          this.forceUpdateValue(t, i), n(this.value_);
        }, o) : (this.forceUpdateValue(t, i), n(this.value_));
      });
    },
    normalizeConfig(t, e = this.modelConfig_) {
      return t = Fn(t) ? t : [t.start || t, t.end || t], e.map((n, r) => be(be({
        validHours: this.validHours,
        minuteIncrement: this.minuteIncrement
      }, n), t[r]));
    },
    forceUpdateValue(t, {
      config: e = this.modelConfig_,
      patch: n = ni.DATE_TIME,
      clearIfEqual: r = !1,
      formatInput: o = !0,
      hidePopover: i = !1,
      isDragging: a = this.isDragging,
      rangePriority: s = Jn.BOTH
    } = {}) {
      e = this.normalizeConfig(e);
      let l = this.normalizeValue(t, e, n, s);
      !l && this.isRequired && (l = this.value_), l = this.adjustTimeForValue(l, e);
      const c = this.valueIsDisabled(l);
      if (c) {
        if (a)
          return;
        l = this.value_, i = !1;
      }
      const u = a ? "dragValue" : "value_";
      let d = !this.valuesAreEqual(this[u], l);
      if (!c && !d && r && (l = null, d = !0), d) {
        this[u] = l, a || (this.dragValue = null);
        const f = this.denormalizeValue(l), h = this.isDragging ? "drag" : "update:modelValue";
        this.watchValue = !1, this.$emit(h, f), this.$nextTick(() => this.watchValue = !0);
      }
      i && this.hidePopover(), o && this.formatInput();
    },
    hasValue(t) {
      return this.isRange ? _r(t) && !!t.start && !!t.end : !!t;
    },
    normalizeValue(t, e, n, r) {
      if (!this.hasValue(t))
        return null;
      if (this.isRange) {
        const o = {}, i = t.start > t.end ? t.end : t.start;
        o.start = this.normalizeDate(i, tt(be({}, e[0]), {
          fillDate: this.value_ && this.value_.start || e[0].fillDate,
          patch: n
        }));
        const a = t.start > t.end ? t.start : t.end;
        return o.end = this.normalizeDate(a, tt(be({}, e[1]), {
          fillDate: this.value_ && this.value_.end || e[1].fillDate,
          patch: n
        })), this.sortRange(o, r);
      }
      return this.normalizeDate(t, tt(be({}, e[0]), {
        fillDate: this.value_ || e[0].fillDate,
        patch: n
      }));
    },
    adjustTimeForValue(t, e) {
      return this.hasValue(t) ? this.isRange ? {
        start: this.$locale.adjustTimeForDate(t.start, e[0]),
        end: this.$locale.adjustTimeForDate(t.end, e[1])
      } : this.$locale.adjustTimeForDate(t, e[0]) : null;
    },
    sortRange(t, e = Jn.NONE) {
      const { start: n, end: r } = t;
      if (n > r)
        switch (e) {
          case Jn.START:
            return { start: n, end: n };
          case Jn.END:
            return { start: r, end: r };
          case Jn.BOTH:
            return { start: r, end: n };
        }
      return { start: n, end: r };
    },
    denormalizeValue(t, e = this.modelConfig_) {
      return this.isRange ? this.hasValue(t) ? {
        start: this.$locale.denormalizeDate(t.start, e[0]),
        end: this.$locale.denormalizeDate(t.end, e[1])
      } : null : this.$locale.denormalizeDate(t, e[0]);
    },
    valuesAreEqual(t, e) {
      if (this.isRange) {
        const n = this.hasValue(t), r = this.hasValue(e);
        return !n && !r ? !0 : n !== r ? !1 : B1(t.start, e.start) && B1(t.end, e.end);
      }
      return B1(t, e);
    },
    valueIsDisabled(t) {
      return this.hasValue(t) && this.disabledAttribute && this.disabledAttribute.intersectsDate(t);
    },
    formatInput() {
      this.$nextTick(() => {
        const t = this.normalizeConfig({
          type: "string",
          mask: this.inputMask
        }), e = this.denormalizeValue(this.dragValue || this.value_, t);
        this.isRange ? this.inputValues = [e && e.start, e && e.end] : this.inputValues = [e, ""];
      });
    },
    showPopover(t = {}) {
      S0(tt(be(be({
        ref: this.$el
      }, this.popover_), t), {
        isInteractive: !0,
        id: this.datePickerPopoverId
      }));
    },
    hidePopover(t = {}) {
      w0(tt(be(be({
        hideDelay: 10
      }, this.showPopover_), t), {
        id: this.datePickerPopoverId
      }));
    },
    togglePopover(t) {
      p6(tt(be(be({
        ref: this.$el
      }, this.popover_), t), {
        isInteractive: !0,
        id: this.datePickerPopoverId
      }));
    },
    adjustPageRange(t) {
      this.$nextTick(() => {
        const e = this.$refs.calendar, n = this.getPageForValue(t), r = t ? 1 : -1;
        n && e && !c6(n, e.firstPage, e.lastPage) && e.move(n, {
          position: r,
          transition: "fade"
        });
      });
    },
    getPageForValue(t) {
      return this.hasValue(this.value_) ? this.pageForDate(this.isRange ? this.value_[t ? "start" : "end"] : this.value_) : null;
    },
    move(t, e) {
      return this.$refs.calendar ? this.$refs.calendar.move(t, e) : Promise.reject(new Error("Navigation disabled while calendar is not yet displayed"));
    },
    focusDate(t, e) {
      return this.$refs.calendar ? this.$refs.calendar.focusDate(t, e) : Promise.reject(new Error("Navigation disabled while calendar is not yet displayed"));
    }
  }
};
const Uue = { class: "relative" }, $ue = /* @__PURE__ */ Ne({
  __name: "DatePicker",
  props: {
    presetDate: {},
    dates: {}
  },
  emits: ["change"],
  setup(t, { emit: e }) {
    const n = t, r = e, { popoutOpen: o, togglePopoutOpen: i, selectedDate: a, datePickerAttributes: s } = nY(
      { presetDate: n.presetDate, dates: n.dates },
      r
    );
    return (l, c) => (v(), A("div", Uue, [
      H(JE, {
        modelValue: M(o),
        "onUpdate:modelValue": c[1] || (c[1] = (u) => er(o) ? o.value = u : null),
        trapFocus: !0,
        externalToggleButton: !0,
        placement: "bottom-end"
      }, {
        content: q(() => [
          g("div", null, [
            H(M(m6), {
              "trim-weeks": "",
              masks: { weekdays: "WWW" },
              ref: "datePickerElement",
              modelValue: M(a),
              "onUpdate:modelValue": c[0] || (c[0] = (u) => er(a) ? a.value = u : null),
              color: "blue",
              "max-date": /* @__PURE__ */ new Date(),
              "is-required": "",
              class: "date-picker shadow",
              attributes: M(s),
              locale: "en-US"
            }, null, 8, ["modelValue", "max-date", "attributes"])
          ])
        ]),
        default: q(() => [
          H(ln, {
            color: "white",
            onClicked: M(i)
          }, {
            icon: q(() => [
              H(nu)
            ]),
            default: q(() => [
              c[2] || (c[2] = me(" Jump to ", -1))
            ]),
            _: 1
          }, 8, ["onClicked"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]));
  }
});
const JMe = /* @__PURE__ */ Y($ue, [["__scopeId", "data-v-1096ceda"]]);
function ba(t) {
  "@babel/helpers - typeof";
  return ba = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ba(t);
}
function rt(t, e) {
  if (e.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function wt(t) {
  rt(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || ba(t) === "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function r3(t) {
  rt(1, arguments);
  var e = wt(t), n = e.getDate();
  return n;
}
function o3(t) {
  rt(1, arguments);
  var e = wt(t), n = e.getMonth();
  return n;
}
function i3(t) {
  return rt(1, arguments), wt(t).getFullYear();
}
function a3(t, e) {
  rt(2, arguments);
  var n = wt(t), r = wt(e);
  return n.getTime() < r.getTime();
}
function s3(t, e) {
  rt(2, arguments);
  var n = wt(t), r = wt(e);
  return n.getTime() > r.getTime();
}
function kue(t) {
  return rt(1, arguments), t instanceof Date || ba(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function N6(t) {
  if (rt(1, arguments), !kue(t) && typeof t != "number")
    return !1;
  var e = wt(t);
  return !isNaN(Number(e));
}
function zt(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function Ap(t, e) {
  rt(2, arguments);
  var n = wt(t).getTime(), r = zt(e);
  return new Date(n + r);
}
function Bue(t, e) {
  rt(2, arguments);
  var n = zt(e);
  return Ap(t, -n);
}
var Gue = 864e5;
function Fue(t) {
  rt(1, arguments);
  var e = wt(t), n = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var r = e.getTime(), o = n - r;
  return Math.floor(o / Gue) + 1;
}
function Gd(t) {
  rt(1, arguments);
  var e = 1, n = wt(t), r = n.getUTCDay(), o = (r < e ? 7 : 0) + r - e;
  return n.setUTCDate(n.getUTCDate() - o), n.setUTCHours(0, 0, 0, 0), n;
}
function v6(t) {
  rt(1, arguments);
  var e = wt(t), n = e.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var o = Gd(r), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var a = Gd(i);
  return e.getTime() >= o.getTime() ? n + 1 : e.getTime() >= a.getTime() ? n : n - 1;
}
function Vue(t) {
  rt(1, arguments);
  var e = v6(t), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = Gd(n);
  return r;
}
var Hue = 6048e5;
function Wue(t) {
  rt(1, arguments);
  var e = wt(t), n = Gd(e).getTime() - Vue(e).getTime();
  return Math.round(n / Hue) + 1;
}
var Yue = {};
function zf() {
  return Yue;
}
function Fd(t, e) {
  var n, r, o, i, a, s, l, c;
  rt(1, arguments);
  var u = zf(), d = zt((n = (r = (o = (i = e == null ? void 0 : e.weekStartsOn) !== null && i !== void 0 ? i : e == null || (a = e.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = wt(t), h = f.getUTCDay(), _ = (h < d ? 7 : 0) + h - d;
  return f.setUTCDate(f.getUTCDate() - _), f.setUTCHours(0, 0, 0, 0), f;
}
function g6(t, e) {
  var n, r, o, i, a, s, l, c;
  rt(1, arguments);
  var u = wt(t), d = u.getUTCFullYear(), f = zf(), h = zt((n = (r = (o = (i = e == null ? void 0 : e.firstWeekContainsDate) !== null && i !== void 0 ? i : e == null || (a = e.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && o !== void 0 ? o : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var _ = /* @__PURE__ */ new Date(0);
  _.setUTCFullYear(d + 1, 0, h), _.setUTCHours(0, 0, 0, 0);
  var E = Fd(_, e), m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(d, 0, h), m.setUTCHours(0, 0, 0, 0);
  var N = Fd(m, e);
  return u.getTime() >= E.getTime() ? d + 1 : u.getTime() >= N.getTime() ? d : d - 1;
}
function Kue(t, e) {
  var n, r, o, i, a, s, l, c;
  rt(1, arguments);
  var u = zf(), d = zt((n = (r = (o = (i = e == null ? void 0 : e.firstWeekContainsDate) !== null && i !== void 0 ? i : e == null || (a = e.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && o !== void 0 ? o : u.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), f = g6(t, e), h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(f, 0, d), h.setUTCHours(0, 0, 0, 0);
  var _ = Fd(h, e);
  return _;
}
var zue = 6048e5;
function Zue(t, e) {
  rt(1, arguments);
  var n = wt(t), r = Fd(n, e).getTime() - Kue(n, e).getTime();
  return Math.round(r / zue) + 1;
}
function ut(t, e) {
  for (var n = t < 0 ? "-" : "", r = Math.abs(t).toString(); r.length < e; )
    r = "0" + r;
  return n + r;
}
var que = {
  // Year
  y: function(e, n) {
    var r = e.getUTCFullYear(), o = r > 0 ? r : 1 - r;
    return ut(n === "yy" ? o % 100 : o, n.length);
  },
  // Month
  M: function(e, n) {
    var r = e.getUTCMonth();
    return n === "M" ? String(r + 1) : ut(r + 1, 2);
  },
  // Day of the month
  d: function(e, n) {
    return ut(e.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(e, n) {
    var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, n) {
    return ut(e.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(e, n) {
    return ut(e.getUTCHours(), n.length);
  },
  // Minute
  m: function(e, n) {
    return ut(e.getUTCMinutes(), n.length);
  },
  // Second
  s: function(e, n) {
    return ut(e.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(e, n) {
    var r = n.length, o = e.getUTCMilliseconds(), i = Math.floor(o * Math.pow(10, r - 3));
    return ut(i, n.length);
  }
};
const oi = que;
var rs = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Xue = {
  // Era
  G: function(e, n, r) {
    var o = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(o, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(o, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(o, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, n, r) {
    if (n === "yo") {
      var o = e.getUTCFullYear(), i = o > 0 ? o : 1 - o;
      return r.ordinalNumber(i, {
        unit: "year"
      });
    }
    return oi.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, r, o) {
    var i = g6(e, o), a = i > 0 ? i : 1 - i;
    if (n === "YY") {
      var s = a % 100;
      return ut(s, 2);
    }
    return n === "Yo" ? r.ordinalNumber(a, {
      unit: "year"
    }) : ut(a, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    var r = v6(e);
    return ut(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    var r = e.getUTCFullYear();
    return ut(r, n.length);
  },
  // Quarter
  Q: function(e, n, r) {
    var o = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(o);
      case "QQ":
        return ut(o, 2);
      case "Qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, r) {
    var o = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(o);
      case "qq":
        return ut(o, 2);
      case "qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, r) {
    var o = e.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return oi.M(e, n);
      case "Mo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(o, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, n, r) {
    var o = e.getUTCMonth();
    switch (n) {
      case "L":
        return String(o + 1);
      case "LL":
        return ut(o + 1, 2);
      case "Lo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(o, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, n, r, o) {
    var i = Zue(e, o);
    return n === "wo" ? r.ordinalNumber(i, {
      unit: "week"
    }) : ut(i, n.length);
  },
  // ISO week of year
  I: function(e, n, r) {
    var o = Wue(e);
    return n === "Io" ? r.ordinalNumber(o, {
      unit: "week"
    }) : ut(o, n.length);
  },
  // Day of the month
  d: function(e, n, r) {
    return n === "do" ? r.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : oi.d(e, n);
  },
  // Day of year
  D: function(e, n, r) {
    var o = Fue(e);
    return n === "Do" ? r.ordinalNumber(o, {
      unit: "dayOfYear"
    }) : ut(o, n.length);
  },
  // Day of week
  E: function(e, n, r) {
    var o = e.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, r, o) {
    var i = e.getUTCDay(), a = (i - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(a);
      case "ee":
        return ut(a, 2);
      case "eo":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "eee":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, r, o) {
    var i = e.getUTCDay(), a = (i - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(a);
      case "cc":
        return ut(a, n.length);
      case "co":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "ccc":
        return r.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, r) {
    var o = e.getUTCDay(), i = o === 0 ? 7 : o;
    switch (n) {
      case "i":
        return String(i);
      case "ii":
        return ut(i, n.length);
      case "io":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, r) {
    var o = e.getUTCHours(), i = o / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, r) {
    var o = e.getUTCHours(), i;
    switch (o === 12 ? i = rs.noon : o === 0 ? i = rs.midnight : i = o / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, r) {
    var o = e.getUTCHours(), i;
    switch (o >= 17 ? i = rs.evening : o >= 12 ? i = rs.afternoon : o >= 4 ? i = rs.morning : i = rs.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, r) {
    if (n === "ho") {
      var o = e.getUTCHours() % 12;
      return o === 0 && (o = 12), r.ordinalNumber(o, {
        unit: "hour"
      });
    }
    return oi.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, r) {
    return n === "Ho" ? r.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : oi.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, r) {
    var o = e.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : ut(o, n.length);
  },
  // Hour [1-24]
  k: function(e, n, r) {
    var o = e.getUTCHours();
    return o === 0 && (o = 24), n === "ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : ut(o, n.length);
  },
  // Minute
  m: function(e, n, r) {
    return n === "mo" ? r.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : oi.m(e, n);
  },
  // Second
  s: function(e, n, r) {
    return n === "so" ? r.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : oi.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return oi.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, r, o) {
    var i = o._originalDate || e, a = i.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (n) {
      case "X":
        return c3(a);
      case "XXXX":
      case "XX":
        return ea(a);
      case "XXXXX":
      case "XXX":
      default:
        return ea(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, r, o) {
    var i = o._originalDate || e, a = i.getTimezoneOffset();
    switch (n) {
      case "x":
        return c3(a);
      case "xxxx":
      case "xx":
        return ea(a);
      case "xxxxx":
      case "xxx":
      default:
        return ea(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, r, o) {
    var i = o._originalDate || e, a = i.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + l3(a, ":");
      case "OOOO":
      default:
        return "GMT" + ea(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, r, o) {
    var i = o._originalDate || e, a = i.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + l3(a, ":");
      case "zzzz":
      default:
        return "GMT" + ea(a, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, r, o) {
    var i = o._originalDate || e, a = Math.floor(i.getTime() / 1e3);
    return ut(a, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, r, o) {
    var i = o._originalDate || e, a = i.getTime();
    return ut(a, n.length);
  }
};
function l3(t, e) {
  var n = t > 0 ? "-" : "+", r = Math.abs(t), o = Math.floor(r / 60), i = r % 60;
  if (i === 0)
    return n + String(o);
  var a = e || "";
  return n + String(o) + a + ut(i, 2);
}
function c3(t, e) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + ut(Math.abs(t) / 60, 2);
  }
  return ea(t, e);
}
function ea(t, e) {
  var n = e || "", r = t > 0 ? "-" : "+", o = Math.abs(t), i = ut(Math.floor(o / 60), 2), a = ut(o % 60, 2);
  return r + i + n + a;
}
const jue = Xue;
var u3 = function(e, n) {
  switch (e) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, I6 = function(e, n) {
  switch (e) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, Jue = function(e, n) {
  var r = e.match(/(P+)(p+)?/) || [], o = r[1], i = r[2];
  if (!i)
    return u3(e, n);
  var a;
  switch (o) {
    case "P":
      a = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      a = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      a = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      a = n.dateTime({
        width: "full"
      });
      break;
  }
  return a.replace("{{date}}", u3(o, n)).replace("{{time}}", I6(i, n));
}, Que = {
  p: I6,
  P: Jue
};
const ede = Que;
function T0(t) {
  var e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
}
var tde = ["D", "DD"], nde = ["YY", "YYYY"];
function rde(t) {
  return tde.indexOf(t) !== -1;
}
function ode(t) {
  return nde.indexOf(t) !== -1;
}
function d3(t, e, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var ide = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, ade = function(e, n, r) {
  var o, i = ide[e];
  return typeof i == "string" ? o = i : n === 1 ? o = i.one : o = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + o : o + " ago" : o;
};
const sde = ade;
function W1(t) {
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.width ? String(e.width) : t.defaultWidth, r = t.formats[n] || t.formats[t.defaultWidth];
    return r;
  };
}
var lde = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, cde = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ude = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, dde = {
  date: W1({
    formats: lde,
    defaultWidth: "full"
  }),
  time: W1({
    formats: cde,
    defaultWidth: "full"
  }),
  dateTime: W1({
    formats: ude,
    defaultWidth: "full"
  })
};
const fde = dde;
var hde = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, _de = function(e, n, r, o) {
  return hde[e];
};
const Ede = _de;
function wl(t) {
  return function(e, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", o;
    if (r === "formatting" && t.formattingValues) {
      var i = t.defaultFormattingWidth || t.defaultWidth, a = n != null && n.width ? String(n.width) : i;
      o = t.formattingValues[a] || t.formattingValues[i];
    } else {
      var s = t.defaultWidth, l = n != null && n.width ? String(n.width) : t.defaultWidth;
      o = t.values[l] || t.values[s];
    }
    var c = t.argumentCallback ? t.argumentCallback(e) : e;
    return o[c];
  };
}
var pde = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, mde = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Nde = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, vde = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, gde = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Ide = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ode = function(e, n) {
  var r = Number(e), o = r % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, Ade = {
  ordinalNumber: Ode,
  era: wl({
    values: pde,
    defaultWidth: "wide"
  }),
  quarter: wl({
    values: mde,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: wl({
    values: Nde,
    defaultWidth: "wide"
  }),
  day: wl({
    values: vde,
    defaultWidth: "wide"
  }),
  dayPeriod: wl({
    values: gde,
    defaultWidth: "wide",
    formattingValues: Ide,
    defaultFormattingWidth: "wide"
  })
};
const Dde = Ade;
function Tl(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, o = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], i = e.match(o);
    if (!i)
      return null;
    var a = i[0], s = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(s) ? Sde(s, function(d) {
      return d.test(a);
    }) : Cde(s, function(d) {
      return d.test(a);
    }), c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = n.valueCallback ? n.valueCallback(c) : c;
    var u = e.slice(a.length);
    return {
      value: c,
      rest: u
    };
  };
}
function Cde(t, e) {
  for (var n in t)
    if (t.hasOwnProperty(n) && e(t[n]))
      return n;
}
function Sde(t, e) {
  for (var n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function wde(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.match(t.matchPattern);
    if (!r)
      return null;
    var o = r[0], i = e.match(t.parsePattern);
    if (!i)
      return null;
    var a = t.valueCallback ? t.valueCallback(i[0]) : i[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    var s = e.slice(o.length);
    return {
      value: a,
      rest: s
    };
  };
}
var Tde = /^(\d+)(th|st|nd|rd)?/i, bde = /\d+/i, Rde = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Mde = {
  any: [/^b/i, /^(a|c)/i]
}, Pde = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, yde = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Lde = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, xde = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Ude = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, $de = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, kde = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Bde = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Gde = {
  ordinalNumber: wde({
    matchPattern: Tde,
    parsePattern: bde,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Tl({
    matchPatterns: Rde,
    defaultMatchWidth: "wide",
    parsePatterns: Mde,
    defaultParseWidth: "any"
  }),
  quarter: Tl({
    matchPatterns: Pde,
    defaultMatchWidth: "wide",
    parsePatterns: yde,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Tl({
    matchPatterns: Lde,
    defaultMatchWidth: "wide",
    parsePatterns: xde,
    defaultParseWidth: "any"
  }),
  day: Tl({
    matchPatterns: Ude,
    defaultMatchWidth: "wide",
    parsePatterns: $de,
    defaultParseWidth: "any"
  }),
  dayPeriod: Tl({
    matchPatterns: kde,
    defaultMatchWidth: "any",
    parsePatterns: Bde,
    defaultParseWidth: "any"
  })
};
const Fde = Gde;
var Vde = {
  code: "en-US",
  formatDistance: sde,
  formatLong: fde,
  formatRelative: Ede,
  localize: Dde,
  match: Fde,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Hde = Vde;
var Wde = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Yde = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Kde = /^'([^]*?)'?$/, zde = /''/g, Zde = /[a-zA-Z]/;
function lu(t, e, n) {
  var r, o, i, a, s, l, c, u, d, f, h, _, E, m, N, I, O, p;
  rt(2, arguments);
  var C = String(e), D = zf(), T = (r = (o = n == null ? void 0 : n.locale) !== null && o !== void 0 ? o : D.locale) !== null && r !== void 0 ? r : Hde, k = zt((i = (a = (s = (l = n == null ? void 0 : n.firstWeekContainsDate) !== null && l !== void 0 ? l : n == null || (c = n.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && s !== void 0 ? s : D.firstWeekContainsDate) !== null && a !== void 0 ? a : (d = D.locale) === null || d === void 0 || (f = d.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(k >= 1 && k <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var G = zt((h = (_ = (E = (m = n == null ? void 0 : n.weekStartsOn) !== null && m !== void 0 ? m : n == null || (N = n.locale) === null || N === void 0 || (I = N.options) === null || I === void 0 ? void 0 : I.weekStartsOn) !== null && E !== void 0 ? E : D.weekStartsOn) !== null && _ !== void 0 ? _ : (O = D.locale) === null || O === void 0 || (p = O.options) === null || p === void 0 ? void 0 : p.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(G >= 0 && G <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!T.localize)
    throw new RangeError("locale must contain localize property");
  if (!T.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var b = wt(t);
  if (!N6(b))
    throw new RangeError("Invalid time value");
  var P = T0(b), $ = Bue(b, P), y = {
    firstWeekContainsDate: k,
    weekStartsOn: G,
    locale: T,
    _originalDate: b
  }, L = C.match(Yde).map(function(w) {
    var R = w[0];
    if (R === "p" || R === "P") {
      var B = ede[R];
      return B(w, T.formatLong);
    }
    return w;
  }).join("").match(Wde).map(function(w) {
    if (w === "''")
      return "'";
    var R = w[0];
    if (R === "'")
      return qde(w);
    var B = jue[R];
    if (B)
      return !(n != null && n.useAdditionalWeekYearTokens) && ode(w) && d3(w, e, String(t)), !(n != null && n.useAdditionalDayOfYearTokens) && rde(w) && d3(w, e, String(t)), B($, w, T.localize, y);
    if (R.match(Zde))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + R + "`");
    return w;
  }).join("");
  return L;
}
function qde(t) {
  var e = t.match(Kde);
  return e ? e[1].replace(zde, "'") : t;
}
function O6(t, e) {
  rt(2, arguments);
  var n = wt(t), r = zt(e);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function ii(t, e) {
  rt(2, arguments);
  var n = zt(e);
  return O6(t, -n);
}
function Ei(t) {
  rt(1, arguments);
  var e = wt(t);
  return e.setHours(0, 0, 0, 0), e;
}
function jl(t, e) {
  rt(2, arguments);
  var n = Ei(t), r = Ei(e);
  return n.getTime() === r.getTime();
}
function Zf(t, e = !0) {
  const n = W(), r = e ? "no-scroll-fixed" : "no-scroll";
  function o() {
    n.value = window.pageYOffset, document.body.classList.add(r), e && (document.body.style.top = `-${n.value}px`);
  }
  function i() {
    document.body.classList.remove(r), e && (document.body.style.removeProperty("top"), window.scrollTo(0, n.value));
  }
  et(t, (a) => {
    a ? o() : i();
  });
}
function qr(t) {
  return lu(t, "yyyy-MM-dd");
}
function f3(t) {
  return lu(t, "dd/MM/yyyy");
}
function h3(t) {
  return lu(t, "do MMMM yyyy");
}
function Xde(t, e) {
  var ae, re;
  const n = W(!1), { aboveMobile: r } = Io();
  r.value && Zf(n);
  function o() {
    n.value = !n.value, e("update:popoverOpen", n.value);
  }
  const i = W(), a = W(), s = ii(/* @__PURE__ */ new Date(), 365), l = /* @__PURE__ */ new Date(), c = W({
    start: ((ae = t.presetDates) == null ? void 0 : ae.start) ?? /* @__PURE__ */ new Date(),
    end: ((re = t.presetDates) == null ? void 0 : re.end) ?? /* @__PURE__ */ new Date()
  }), u = W({
    start: c.value.start,
    end: c.value.end
  }), d = [
    { days: 7, label: "7 days", selected: W(!1) },
    { days: 30, label: "30 days", selected: W(!1) },
    { days: 90, label: "90 days", selected: W(!1) }
  ], f = x(() => d.find((j) => j.selected.value)), h = W(qr(c.value.start)), _ = W(qr(c.value.end)), E = x(() => {
    const { start: j, end: ne } = c.value;
    return t.longDateFormat ? {
      start: `${h3(j)}`,
      end: `${h3(ne)}`
    } : {
      start: `${f3(j)}`,
      end: `${f3(ne)}`
    };
  });
  function m() {
    e("apply", {
      start: c.value.start,
      end: c.value.end
    }), I(!0);
  }
  ct(async () => {
    var j;
    t || await G(30), N(), await ((j = i.value) == null ? void 0 : j.move(/* @__PURE__ */ new Date())), await C(), P.value = h.value, b();
  });
  function N(j) {
    var ne, Ee;
    if (j) {
      m();
      return;
    }
    (ne = a.value) == null || ne.submit(), (Ee = a.value) != null && Ee.valid && c.value && m();
  }
  et(n, () => {
    n.value && (u.value.start = c.value.start, u.value.end = c.value.end);
  });
  async function I(j) {
    var ne;
    n.value = !1, e("update:popoverOpen", !1), j || (c.value.start = u.value.start, c.value.end = u.value.end), (ne = a.value) == null || ne.submit(), O(), await C();
  }
  function O() {
    var j;
    (j = i.value) == null || j.forceUpdateValue({ start: c.value.start, end: c.value.end });
  }
  async function p() {
    var j;
    await ((j = i.value) == null ? void 0 : j.move(c.value.start));
  }
  async function C() {
    var j;
    await ((j = i.value) == null ? void 0 : j.move(c.value.end));
  }
  function D() {
    X.value = void 0, J.value = void 0, T();
  }
  function T() {
    d.forEach((j) => j.selected.value = !1);
  }
  async function k(j) {
    await G(j);
  }
  async function G(j) {
    var Ee;
    c.value.start = ii(/* @__PURE__ */ new Date(), j), c.value.end = ii(/* @__PURE__ */ new Date(), 1), T();
    const ne = d.find((fe) => fe.days === j);
    ne && (ne.selected.value = !0), (Ee = a.value) == null || Ee.submit(), O(), await C();
  }
  function b() {
    d.forEach((j) => {
      jl(c.value.start, ii(/* @__PURE__ */ new Date(), j.days)) && jl(c.value.end, ii(/* @__PURE__ */ new Date(), 1)) && !j.selected.value && G(j.days);
    });
  }
  et(c, () => {
    jl(c.value.start, c.value.end) && (c.value.start = ii(c.value.start, 1), O()), h.value = qr(c.value.start), _.value = qr(c.value.end), b();
  });
  const P = W(h.value);
  function $() {
    h.value.length || (h.value = qr(ii(/* @__PURE__ */ new Date(), 30)));
    const j = new Date(h.value);
    y(j);
  }
  function y(j) {
    a3(j, s) && (h.value = qr(s)), s3(j, l) && (h.value = qr(l)), c.value.start = new Date(h.value), O(), p();
  }
  function L() {
    K({ input: _, previous: w, clause: "start" });
  }
  const w = W(_.value);
  function R() {
    _.value.length || (_.value = qr(ii(/* @__PURE__ */ new Date(), 1)));
    const j = new Date(_.value);
    B(j);
  }
  function B(j) {
    a3(j, s) && (_.value = qr(s)), s3(j, l) && (_.value = qr(l)), c.value.end = new Date(_.value), O(), C();
  }
  function U() {
    K({ input: h, previous: P, clause: "end" });
  }
  function K({
    input: j,
    previous: ne,
    clause: Ee
  }) {
    if (!j.value || !j.value.length)
      return;
    const fe = new Date(j.value), Oe = new Date(ne.value);
    if (j.value !== ne.value) {
      T();
      const ce = i3(fe), Se = i3(Oe);
      ce !== Se && (Ee === "start" ? P.value = j.value : w.value = j.value);
      const se = o3(fe), Ie = o3(Oe);
      se !== Ie && (Ee === "start" ? P.value = j.value : w.value = j.value);
      const we = r3(fe), le = r3(Oe);
      we !== le && (Ee === "start" ? P.value = j.value : w.value = j.value);
    }
  }
  const Z = x(() => [
    {
      key: "isEdgeOfRange",
      dates: [X.value, J.value]
    }
  ]), X = W(Ei(c.value.start)), J = W(Ei(c.value.end));
  return et(c, () => {
    X.value = Ei(c.value.start), J.value = Ei(c.value.end);
  }), {
    popoutOpen: n,
    dateRange: c,
    dateRangeElement: i,
    minimumDate: s,
    maximumDate: l,
    inputFormElement: a,
    buttonText: E,
    togglePopoutOpen: o,
    closePopout: I,
    presetDateRanges: d,
    selectedDatePreset: f,
    inputStartDate: h,
    inputEndDate: _,
    selectPreset: k,
    selectRange: G,
    clearPresetSelection: T,
    applyDateRange: N,
    goToStartDate: p,
    goToEndDate: C,
    blurStartDateInput: $,
    changeInputStartDate: L,
    blurEndDateInput: R,
    changeInputEndDate: U,
    vCalAttributes: Z,
    onDrag: D
  };
}
const jde = Ne({
  props: {
    width: {
      type: String,
      required: !1,
      default: "100%"
    },
    height: {
      type: String,
      required: !1,
      default: "1.5rem"
    },
    debug: {
      type: Boolean,
      required: !1,
      default: !1
    }
  }
});
function Jde(t, e, n, r, o, i) {
  return v(), A("div", {
    class: z(["spacer", { debug: t.debug }]),
    style: Fe([{ width: t.width }, { minWidth: t.width }, { height: t.height }])
  }, null, 6);
}
const He = /* @__PURE__ */ Y(jde, [["render", Jde], ["__scopeId", "data-v-5ba48f0f"]]), Qde = { class: "relative" }, efe = { style: { display: "flex", "align-items": "center" } }, tfe = {
  style: { margin: "0 0.625rem" },
  width: "14",
  height: "10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nfe = {
  style: { margin: "0 0.625rem" },
  width: "14",
  height: "10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rfe = { class: "button-container-mobile-only" }, ofe = { class: "date-picker-container" }, ife = ["onClick", "onMouseenter", "onMouseleave", "onKeydown", "onFocus", "onBlur"], afe = { class: "button-container" }, sfe = /* @__PURE__ */ Ne({
  __name: "DateRange",
  props: {
    presetDates: {},
    longDateFormat: { type: Boolean, default: !1 },
    popoverOpen: { type: Boolean, default: !1 },
    disablePopout: { type: Boolean, default: !1 },
    wrapperClasses: { default: "" }
  },
  emits: ["apply", "update:popoverOpen"],
  setup(t, { emit: e }) {
    const n = t, r = e, { aboveMobile: o, aboveiPadLandscape: i } = Io();
    function a(L) {
      i.value && L.preventDefault();
    }
    const {
      popoutOpen: s,
      dateRange: l,
      dateRangeElement: c,
      minimumDate: u,
      maximumDate: d,
      inputFormElement: f,
      buttonText: h,
      togglePopoutOpen: _,
      closePopout: E,
      presetDateRanges: m,
      selectedDatePreset: N,
      inputStartDate: I,
      inputEndDate: O,
      selectRange: p,
      applyDateRange: C,
      goToStartDate: D,
      goToEndDate: T,
      blurStartDateInput: k,
      changeInputStartDate: G,
      blurEndDateInput: b,
      changeInputEndDate: P,
      vCalAttributes: $,
      onDrag: y
    } = Xde(n, r);
    return (L, w) => {
      const R = ee("perfect-scrollbar");
      return v(), A("div", Qde, [
        H(JE, {
          modelValue: M(s),
          "onUpdate:modelValue": w[8] || (w[8] = (B) => er(s) ? s.value = B : null),
          "trap-focus": !0,
          "external-toggle-button": !0,
          offset: t.longDateFormat ? [-1, 12] : M(o) ? [62, 12] : [0, 8],
          placement: M(o) ? t.longDateFormat ? "bottom-start" : "bottom-end" : "bottom",
          "max-width": "36.625rem",
          disabled: t.disablePopout,
          "wrapper-classes": t.wrapperClasses,
          popperOptions: {
            strategy: "fixed"
          },
          zIndex: 2998,
          viewBackgroundZIndex: 2997,
          borderRadius: 24
        }, K_({
          default: q(() => [
            t.longDateFormat ? (v(), A("div", {
              key: 1,
              class: "long-date-container",
              onClick: w[0] || (w[0] = //@ts-ignore
              (...B) => M(_) && M(_)(...B)),
              tabindex: "0"
            }, [
              H(Ye, {
                as: "p",
                size: "f-9"
              }, {
                default: q(() => [
                  me(Q(M(h).start) + " ", 1),
                  (v(), A("svg", nfe, [...w[10] || (w[10] = [
                    g("path", {
                      d: "M1 5h12",
                      stroke: "#d6d6d8",
                      "stroke-width": "2",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1),
                    g("path", {
                      d: "m9 1 4 4-4 4",
                      stroke: "#d6d6d8",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)
                  ])])),
                  me(" " + Q(M(h).end), 1)
                ]),
                _: 1
              })
            ])) : (v(), te(ln, {
              key: 0,
              onClicked: M(_),
              color: "white"
            }, {
              icon: q(() => [
                H(nu)
              ]),
              default: q(() => [
                g("div", efe, [
                  me(Q(M(h).start) + " ", 1),
                  (v(), A("svg", tfe, [...w[9] || (w[9] = [
                    g("path", {
                      d: "M1 5h12",
                      stroke: "#d6d6d8",
                      "stroke-width": "2",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1),
                    g("path", {
                      d: "m9 1 4 4-4 4",
                      stroke: "#d6d6d8",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)
                  ])])),
                  me(" " + Q(M(h).end), 1)
                ])
              ]),
              _: 1
            }, 8, ["onClicked"])),
            L.$slots.popout && M(s) ? ue(L.$slots, "popout", {
              key: 2,
              api: {
                presetDateRanges: M(m),
                selectedDatePreset: M(N),
                selectRange: M(p),
                applyDateRange: M(C),
                closePopout: M(E)
              }
            }, void 0, !0) : V("", !0)
          ]),
          _: 2
        }, [
          L.$slots.popout ? void 0 : {
            name: "content",
            fn: q(() => [
              g("div", {
                class: z(["shadow", "date-range-popout", { "modal-short-date": !t.longDateFormat }])
              }, [
                H(R, { class: "date-range-form" }, {
                  default: q(() => [
                    H(xE, {
                      ref_key: "inputFormElement",
                      ref: f
                    }, {
                      default: q(() => [
                        M(o) ? (v(), te(Nc, {
                          key: 0,
                          name: "start date",
                          modelValue: M(I),
                          "onUpdate:modelValue": w[1] || (w[1] = (B) => er(I) ? I.value = B : null),
                          label: "Start Date",
                          type: "date",
                          onBlur: M(k),
                          onFocus: M(D),
                          onInput: M(G),
                          class: "w-100",
                          style: { "min-height": "45px" },
                          onClick: a
                        }, null, 8, ["modelValue", "onBlur", "onFocus", "onInput"])) : V("", !0),
                        M(o) ? (v(), te(He, {
                          key: 1,
                          height: "1.75rem"
                        })) : V("", !0),
                        M(o) ? (v(), te(Nc, {
                          key: 2,
                          name: "end date",
                          modelValue: M(O),
                          "onUpdate:modelValue": w[2] || (w[2] = (B) => er(O) ? O.value = B : null),
                          label: "End Date",
                          type: "date",
                          onBlur: M(b),
                          onFocus: M(T),
                          onInput: M(P),
                          class: "w-100",
                          style: { "min-height": "45px" },
                          onClick: a
                        }, null, 8, ["modelValue", "onBlur", "onFocus", "onInput"])) : V("", !0),
                        M(o) ? (v(), te(He, {
                          key: 3,
                          height: "1.75rem"
                        })) : V("", !0)
                      ]),
                      _: 1
                    }, 512),
                    H(Ye, { class: "input-label" }, {
                      default: q(() => [...w[11] || (w[11] = [
                        me("View Last", -1)
                      ])]),
                      _: 1
                    }),
                    g("div", null, [
                      (v(!0), A(ge, null, ye(M(m), ({ days: B, label: U, selected: K }) => (v(), A("div", {
                        key: B,
                        class: "range-selector-button"
                      }, [
                        H(ln, {
                          onClicked: (Z) => M(p)(B),
                          color: "white",
                          class: z({ "preset-active": K.value }),
                          fullWidth: ""
                        }, {
                          default: q(() => [
                            me(Q(U), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClicked", "class"])
                      ]))), 128))
                    ])
                  ]),
                  _: 1
                }),
                g("div", rfe, [
                  H(ln, {
                    onClicked: w[3] || (w[3] = (B) => M(E)(!1)),
                    color: "white"
                  }, {
                    default: q(() => [...w[12] || (w[12] = [
                      me("Close", -1)
                    ])]),
                    _: 1
                  }),
                  H(ln, {
                    onClicked: w[4] || (w[4] = (B) => M(C)()),
                    color: "blue"
                  }, {
                    default: q(() => [...w[13] || (w[13] = [
                      me("Apply", -1)
                    ])]),
                    _: 1
                  })
                ]),
                g("div", ofe, [
                  H(M(m6), {
                    masks: { weekdays: "WWW" },
                    ref_key: "dateRangeElement",
                    ref: c,
                    modelValue: M(l),
                    "onUpdate:modelValue": w[5] || (w[5] = (B) => er(l) ? l.value = B : null),
                    color: "blue",
                    "max-date": M(d),
                    "min-date": M(u),
                    "is-required": "",
                    "is-range": "",
                    class: "date-picker",
                    onDrag: M(y),
                    attributes: M($),
                    locale: "en-US"
                  }, {
                    "header-left-button": q(() => [
                      H(d0, {
                        class: "arrow rotate180",
                        hex: "#006DFF"
                      })
                    ]),
                    "header-right-button": q(() => [
                      H(d0, {
                        class: "arrow",
                        hex: "#006DFF"
                      })
                    ]),
                    "day-content": q(({ day: B, dayEvents: U }) => {
                      var K;
                      return [
                        g("span", {
                          class: z([
                            ...B.classes,
                            "vc-day-content",
                            {
                              "opt-day-range-edge": (K = B == null ? void 0 : B.attributesMap) == null ? void 0 : K.isEdgeOfRange,
                              "is-disabled": B == null ? void 0 : B.isDisabled
                            }
                          ]),
                          onClick: U.onClick,
                          onMouseenter: U.onMouseenter,
                          onMouseleave: U.onMouseleave,
                          onKeydown: U.onKeydown,
                          onFocus: U.onFocusin,
                          onBlur: U.onFocusout
                        }, Q(B.label), 43, ife)
                      ];
                    }),
                    _: 1
                  }, 8, ["modelValue", "max-date", "min-date", "onDrag", "attributes"]),
                  g("div", afe, [
                    H(ln, {
                      onClicked: w[6] || (w[6] = (B) => M(E)(!1)),
                      color: "white"
                    }, {
                      default: q(() => [...w[14] || (w[14] = [
                        me("Close", -1)
                      ])]),
                      _: 1
                    }),
                    H(ln, {
                      onClicked: w[7] || (w[7] = (B) => M(C)()),
                      color: "blue"
                    }, {
                      default: q(() => [...w[15] || (w[15] = [
                        me("Apply Changes", -1)
                      ])]),
                      _: 1
                    })
                  ])
                ])
              ], 2)
            ]),
            key: "0"
          }
        ]), 1032, ["modelValue", "offset", "placement", "disabled", "wrapper-classes"])
      ]);
    };
  }
});
const QMe = /* @__PURE__ */ Y(sfe, [["__scopeId", "data-v-414f0322"]]), lfe = {
  components: {
    Percent: l5
  },
  props: {
    delta: {
      type: Number,
      required: !0
    },
    reverse: {
      type: Boolean,
      required: !1,
      default: !1
    },
    threshold: {
      type: Number,
      required: !1,
      default: 0.1
    },
    classes: {
      type: String,
      required: !1
    },
    decimalPlaces: {
      type: Number,
      required: !1,
      default: 2
    },
    smallText: {
      type: Boolean,
      required: !1,
      default: !1
    }
  }
};
const cfe = {
  key: 0,
  class: "o-delta"
}, ufe = {
  key: 1,
  class: "o-delta"
}, dfe = {
  key: 2,
  class: "o-delta"
}, ffe = {
  key: 3,
  class: "o-delta"
}, hfe = {
  key: 4,
  class: "o-delta"
}, _fe = {
  key: 0,
  class: "o-delta"
}, Efe = {
  key: 1,
  class: "o-delta"
}, pfe = {
  key: 2,
  class: "o-delta"
}, mfe = {
  key: 3,
  class: "o-delta"
}, Nfe = {
  key: 4,
  class: "o-delta"
};
function vfe(t, e, n, r, o, i) {
  const a = ee("Percent");
  return n.reverse ? (v(), A("div", {
    key: 0,
    class: z(["o-delta-container", n.smallText ? "small-text" : "", n.classes])
  }, [
    n.delta < -n.threshold && n.delta != 0 ? (v(), A("div", cfe, [
      e[0] || (e[0] = g("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        g("circle", {
          opacity: ".1",
          cx: "11",
          cy: "11",
          r: "11",
          fill: "#00A861"
        }),
        g("path", {
          d: "M11 15V7m0 0-3 3m3-3 3 3",
          stroke: "#00A861",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          class: "rotate"
        })
      ], -1)),
      H(a, {
        value: n.delta,
        "decimal-places": n.decimalPlaces,
        stripped: !0,
        style: { color: "#00A861" },
        class: "o-delta-percent"
      }, null, 8, ["value", "decimal-places"])
    ])) : V("", !0),
    n.delta > n.threshold && n.delta != 0 ? (v(), A("div", ufe, [
      e[1] || (e[1] = g("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        g("circle", {
          opacity: ".1",
          cx: "11",
          cy: "11",
          r: "11",
          fill: "#FF2828"
        }),
        g("path", {
          d: "M11 7v8m0 0 3-3m-3 3-3-3",
          stroke: "#FF2828",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          class: "rotate"
        })
      ], -1)),
      H(a, {
        value: n.delta,
        "decimal-places": n.decimalPlaces,
        stripped: !0,
        style: { color: "#FF2828" },
        class: "o-delta-percent"
      }, null, 8, ["value", "decimal-places"])
    ])) : V("", !0),
    n.delta < n.threshold && n.delta > 0 ? (v(), A("div", dfe, [
      e[2] || (e[2] = g("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        g("circle", {
          opacity: ".1",
          cx: "11",
          cy: "11",
          r: "11",
          fill: "#8282A0"
        }),
        g("path", {
          d: "M11 15V7m0 0-3 3m3-3 3 3",
          stroke: "#E0E0E5",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)),
      H(a, {
        value: n.delta,
        "decimal-places": n.decimalPlaces,
        stripped: !0,
        style: { color: "#E0E0E5" },
        class: "o-delta-percent"
      }, null, 8, ["value", "decimal-places"])
    ])) : V("", !0),
    n.delta > -n.threshold && n.delta < 0 ? (v(), A("div", ffe, [
      e[3] || (e[3] = g("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        g("circle", {
          opacity: ".1",
          cx: "11",
          cy: "11",
          r: "11",
          fill: "#8282A0"
        }),
        g("path", {
          d: "M11 7v8m0 0 3-3m-3 3-3-3",
          stroke: "#E0E0E5",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)),
      H(a, {
        value: n.delta,
        "decimal-places": n.decimalPlaces,
        stripped: !0,
        style: { color: "#E0E0E5" },
        class: "o-delta-percent"
      }, null, 8, ["value", "decimal-places"])
    ])) : V("", !0),
    n.delta === 0 ? (v(), A("div", hfe, [
      e[4] || (e[4] = g("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        g("circle", {
          opacity: ".1",
          cx: "11",
          cy: "11",
          r: "11",
          fill: "#8282A0"
        }),
        g("path", {
          d: "M8 10a1 1 0 1 0 0 2v-2Zm6 2a1 1 0 1 0 0-2v2Zm-6 0h6v-2H8v2Z",
          fill: "#E0E0E5"
        })
      ], -1)),
      H(a, {
        value: n.delta,
        "decimal-places": n.decimalPlaces,
        stripped: !0,
        style: { color: "#E0E0E5" },
        class: "o-delta-percent"
      }, null, 8, ["value", "decimal-places"])
    ])) : V("", !0)
  ], 2)) : (v(), A("div", {
    key: 1,
    class: z(["o-delta-container", n.smallText ? "small-text" : "", n.classes])
  }, [
    n.delta > n.threshold && n.delta != 0 ? (v(), A("div", _fe, [
      e[5] || (e[5] = g("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        g("circle", {
          opacity: ".1",
          cx: "11",
          cy: "11",
          r: "11",
          fill: "#00A861"
        }),
        g("path", {
          d: "M11 15V7m0 0-3 3m3-3 3 3",
          stroke: "#00A861",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)),
      H(a, {
        value: n.delta,
        "decimal-places": n.decimalPlaces,
        stripped: !0,
        style: { color: "#00A861" },
        class: "o-delta-percent"
      }, null, 8, ["value", "decimal-places"])
    ])) : V("", !0),
    n.delta < -n.threshold && n.delta != 0 ? (v(), A("div", Efe, [
      e[6] || (e[6] = g("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        g("circle", {
          opacity: ".1",
          cx: "11",
          cy: "11",
          r: "11",
          fill: "#FF2828"
        }),
        g("path", {
          d: "M11 7v8m0 0 3-3m-3 3-3-3",
          stroke: "#FF2828",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)),
      H(a, {
        value: n.delta,
        "decimal-places": n.decimalPlaces,
        stripped: !0,
        style: { color: "#FF2828" },
        class: "o-delta-percent"
      }, null, 8, ["value", "decimal-places"])
    ])) : V("", !0),
    n.delta < n.threshold && n.delta > 0 ? (v(), A("div", pfe, [
      e[7] || (e[7] = g("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        g("circle", {
          opacity: ".1",
          cx: "11",
          cy: "11",
          r: "11",
          fill: "#8282A0"
        }),
        g("path", {
          d: "M11 15V7m0 0-3 3m3-3 3 3",
          stroke: "#E0E0E5",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)),
      H(a, {
        value: n.delta,
        "decimal-places": n.decimalPlaces,
        stripped: !0,
        style: { color: "#E0E0E5" },
        class: "o-delta-percent"
      }, null, 8, ["value", "decimal-places"])
    ])) : V("", !0),
    n.delta > -n.threshold && n.delta < 0 ? (v(), A("div", mfe, [
      e[8] || (e[8] = g("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        g("circle", {
          opacity: ".1",
          cx: "11",
          cy: "11",
          r: "11",
          fill: "#8282A0"
        }),
        g("path", {
          d: "M11 7v8m0 0 3-3m-3 3-3-3",
          stroke: "#E0E0E5",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)),
      H(a, {
        value: n.delta,
        "decimal-places": n.decimalPlaces,
        stripped: !0,
        style: { color: "#E0E0E5" },
        class: "o-delta-percent"
      }, null, 8, ["value", "decimal-places"])
    ])) : V("", !0),
    n.delta === 0 ? (v(), A("div", Nfe, [
      e[9] || (e[9] = g("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        g("circle", {
          opacity: ".1",
          cx: "11",
          cy: "11",
          r: "11",
          fill: "#8282A0"
        }),
        g("path", {
          d: "M8 10a1 1 0 1 0 0 2v-2Zm6 2a1 1 0 1 0 0-2v2Zm-6 0h6v-2H8v2Z",
          fill: "#E0E0E5"
        })
      ], -1)),
      H(a, {
        value: n.delta,
        "decimal-places": n.decimalPlaces,
        stripped: !0,
        style: { color: "#E0E0E5" },
        class: "o-delta-percent"
      }, null, 8, ["value", "decimal-places"])
    ])) : V("", !0)
  ], 2));
}
const Dp = /* @__PURE__ */ Y(lfe, [["render", vfe], ["__scopeId", "data-v-d997c359"]]);
const gfe = {}, Ife = { class: "ent" };
function Ofe(t, e) {
  return v(), A("span", Ife, [
    ue(t.$slots, "default", {}, void 0, !0)
  ]);
}
const ePe = /* @__PURE__ */ Y(gfe, [["render", Ofe], ["__scopeId", "data-v-27831ab0"]]);
function Jl(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, o = Array(r); ++n < r; )
    o[n] = e(t[n], n, t);
  return o;
}
var Afe = Array.isArray;
const xn = Afe;
var Dfe = "[object Symbol]";
function Ra(t) {
  return typeof t == "symbol" || Sa(t) && Va(t) == Dfe;
}
var Cfe = 1 / 0, _3 = Eo ? Eo.prototype : void 0, E3 = _3 ? _3.toString : void 0;
function A6(t) {
  if (typeof t == "string")
    return t;
  if (xn(t))
    return Jl(t, A6) + "";
  if (Ra(t))
    return E3 ? E3.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -Cfe ? "-0" : e;
}
function cu(t) {
  return t == null ? "" : A6(t);
}
function Sfe(t, e, n) {
  var r = -1, o = t.length;
  e < 0 && (e = -e > o ? 0 : o + e), n = n > o ? o : n, n < 0 && (n += o), o = e > n ? 0 : n - e >>> 0, e >>>= 0;
  for (var i = Array(o); ++r < o; )
    i[r] = t[r + e];
  return i;
}
function wfe(t, e, n) {
  var r = t.length;
  return n = n === void 0 ? r : n, !e && n >= r ? t : Sfe(t, e, n);
}
var Tfe = "\\ud800-\\udfff", bfe = "\\u0300-\\u036f", Rfe = "\\ufe20-\\ufe2f", Mfe = "\\u20d0-\\u20ff", Pfe = bfe + Rfe + Mfe, yfe = "\\ufe0e\\ufe0f", Lfe = "\\u200d", xfe = RegExp("[" + Lfe + Tfe + Pfe + yfe + "]");
function D6(t) {
  return xfe.test(t);
}
function Ufe(t) {
  return t.split("");
}
var C6 = "\\ud800-\\udfff", $fe = "\\u0300-\\u036f", kfe = "\\ufe20-\\ufe2f", Bfe = "\\u20d0-\\u20ff", Gfe = $fe + kfe + Bfe, Ffe = "\\ufe0e\\ufe0f", Vfe = "[" + C6 + "]", b0 = "[" + Gfe + "]", R0 = "\\ud83c[\\udffb-\\udfff]", Hfe = "(?:" + b0 + "|" + R0 + ")", S6 = "[^" + C6 + "]", w6 = "(?:\\ud83c[\\udde6-\\uddff]){2}", T6 = "[\\ud800-\\udbff][\\udc00-\\udfff]", Wfe = "\\u200d", b6 = Hfe + "?", R6 = "[" + Ffe + "]?", Yfe = "(?:" + Wfe + "(?:" + [S6, w6, T6].join("|") + ")" + R6 + b6 + ")*", Kfe = R6 + b6 + Yfe, zfe = "(?:" + [S6 + b0 + "?", b0, w6, T6, Vfe].join("|") + ")", Zfe = RegExp(R0 + "(?=" + R0 + ")|" + zfe + Kfe, "g");
function qfe(t) {
  return t.match(Zfe) || [];
}
function Xfe(t) {
  return D6(t) ? qfe(t) : Ufe(t);
}
function jfe(t) {
  return function(e) {
    e = cu(e);
    var n = D6(e) ? Xfe(e) : void 0, r = n ? n[0] : e.charAt(0), o = n ? wfe(n, 1).join("") : e.slice(1);
    return r[t]() + o;
  };
}
var Jfe = jfe("toUpperCase");
const Qfe = Jfe;
function M6(t) {
  return Qfe(cu(t).toLowerCase());
}
const e1e = { key: 1 }, t1e = {
  key: 2,
  class: "link-icon",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, n1e = /* @__PURE__ */ Ne({
  __name: "EntityPill",
  props: {
    type: { default: gt.Campaign },
    size: { default: "medium" },
    color: {},
    content: { default: "Default String" },
    cursor: { default: "inherit" },
    tooltip: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    linkUrl: {}
  },
  setup(t) {
    const e = t, r = {
      [gt.AccountLevel]: S5,
      [gt.Ad]: sG,
      [gt.AdGroup]: w5,
      [gt.AssetGroup]: uG,
      [gt.Campaign]: b5,
      [gt.CampaignGroup]: T5,
      [gt.ConversionAction]: R5,
      [gt.Demographic]: SG,
      [gt.Device]: RG,
      [gt.Experiment]: M5,
      [gt.Extension]: $G,
      [gt.Keyword]: ZE,
      [gt.Location]: P5,
      [gt.NegativeKeyword]: y5,
      [gt.NegativeList]: L5,
      [gt.NGram]: x5,
      [gt.Pause]: U5,
      [gt.Placement]: k5,
      [gt.PlacementExclusionList]: $5,
      [gt.ProductGroup]: B5,
      [gt.Product]: vF,
      [gt.ReplacementKeyword]: G5,
      [gt.SearchTerm]: F5,
      [gt.URL]: V5,
      [gt.Word]: H5
    }[e.type], o = so("obfuscateEntityPills", !1), i = x(() => o ? e.type === "account-level" ? "Account Level" : `${M6(e.type.split("-").join(" "))} ${s(e.content)}` : e.content), a = () => {
      e.linkUrl && window.open(e.linkUrl, "_blank", "noreferrer");
    };
    function s(l) {
      const u = Math.pow(10, 3) - 1, d = Math.pow(10, 2) / 2 - 1;
      let f = 0;
      for (let h = 0; h < l.length; h++)
        f = (f + d * l.charCodeAt(h)) % u;
      return f;
    }
    return (l, c) => (v(), A("div", {
      class: z(["entity-pill", t.type, t.size, t.color, t.disabled ? "disabled" : ""]),
      style: Fe({ cursor: t.linkUrl ? "pointer" : t.cursor }),
      onClick: a
    }, [
      (v(), te(zo(M(r)), { tooltip: t.tooltip }, null, 8, ["tooltip"])),
      l.$slots.default ? ue(l.$slots, "default", { key: 0 }, void 0, !0) : (v(), A("span", e1e, Q(i.value), 1)),
      t.linkUrl ? (v(), A("svg", t1e, [...c[0] || (c[0] = [
        g("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "m7.29352 4.46313.70711-.70711c1.17157-1.17157 3.07107-1.17158 4.24267 0 1.1715 1.17158 1.1715 3.07107 0 4.24264l-.7071.70711c-.3906.39052-.3906 1.02368 0 1.41423.3905.3905 1.0237.3905 1.4142 0l.7071-.70712c1.9526-1.95263 1.9526-5.11845 0-7.07107-1.9526-1.952627-5.11846-1.952624-7.07109 0l-.7071.70711c-.39053.39052-.39053 1.02368 0 1.41421.39053.39053 1.02369.39052 1.41421 0Zm1.41421 1.41421c.39053-.39052 1.02369-.39053 1.41417 0 .3906.39053.3906 1.02369 0 1.41422L7.29352 10.12c-.39052.3905-1.02368.3905-1.41421 0-.39053-.39055-.39053-1.02371 0-1.41423l2.82842-2.82843ZM3.75799 7.99866l.7071-.7071c.39053-.39053.39053-1.02369 0-1.41422-.39053-.39053-1.02369-.39052-1.41421 0l-.70711.70711c-1.952619 1.95262-1.952621 5.11845 0 7.07105 1.95263 1.9526 5.11845 1.9526 7.07107 0l.70706-.7071c.3906-.3905.3906-1.0237 0-1.4142-.39048-.3905-1.02364-.3905-1.41417 0l-.7071.7071c-1.17157 1.1716-3.07107 1.1716-4.24264 0-1.17158-1.1716-1.17157-3.07107 0-4.24264Z"
        }, null, -1)
      ])])) : V("", !0)
    ], 6));
  }
});
const Cp = /* @__PURE__ */ Y(n1e, [["__scopeId", "data-v-b1335c0d"]]), r1e = {
  name: "EntityTransform",
  props: {
    title: {
      type: String,
      required: !1
    },
    entityBefore: {
      type: String,
      required: !0
    },
    entityBeforeType: {
      type: String,
      required: !0
    },
    entityAfter: {
      type: String,
      required: !0
    },
    entityAfterType: {
      type: String,
      required: !0
    }
  },
  components: {
    CircleCampaignGroupIcon: T5,
    CircleCampaignIcon: b5,
    CircleAdgroupIcon: w5,
    CircleKeywordIcon: ZE,
    CircleNegativeKeywordIcon: y5,
    CirclePauseIcon: U5,
    CircleReplacementKeywordIcon: G5,
    CirclePlacementIcon: k5,
    CircleUrlIcon: V5,
    CircleWordIcon: H5,
    CircleNGramIcon: x5,
    CircleProductGroupIcon: B5,
    CircleLocationIcon: P5,
    CircleSearchTermIcon: F5,
    CircleConversionActionIcon: R5,
    CircleNegativeListIcon: L5,
    CircleAccountLevelIcon: S5,
    CirclePlacementExclusionListIcon: $5,
    CircleExperimentIcon: M5,
    EntityPill: Cp,
    Text: Ye,
    Spacer: He
  }
};
const o1e = { class: "w-100" }, i1e = { class: "entity-transform-container" };
function a1e(t, e, n, r, o, i) {
  const a = ee("Text"), s = ee("Spacer"), l = ee("EntityPill");
  return v(), A("div", o1e, [
    n.title ? (v(), te(a, {
      key: 0,
      as: "h3",
      size: "f-4",
      weight: "600"
    }, {
      default: q(() => [
        me(Q(n.title), 1)
      ]),
      _: 1
    })) : V("", !0),
    n.title ? (v(), te(s, {
      key: 1,
      height: "2rem"
    })) : V("", !0),
    g("div", i1e, [
      H(l, {
        content: n.entityBefore,
        type: n.entityBeforeType,
        style: { "z-index": "2", position: "relative" }
      }, null, 8, ["content", "type"]),
      e[0] || (e[0] = g("div", { class: "ant-line" }, null, -1)),
      H(l, {
        content: n.entityAfter,
        type: n.entityAfterType,
        style: { "z-index": "2", position: "relative" }
      }, null, 8, ["content", "type"])
    ])
  ]);
}
const tPe = /* @__PURE__ */ Y(r1e, [["render", a1e], ["__scopeId", "data-v-4f882a99"]]);
/*!
  * focus-trap-vue v4.0.3
  * (c) 2025 Eduardo San Martin Morote
  * @license MIT
  */
const s1e = {
  escapeDeactivates: {
    type: Boolean,
    default: !0
  },
  returnFocusOnDeactivate: {
    type: Boolean,
    default: !0
  },
  allowOutsideClick: {
    type: [Boolean, Function],
    default: !0
  },
  clickOutsideDeactivates: [Boolean, Function],
  initialFocus: [String, Function, Boolean],
  fallbackFocus: [String, Function],
  checkCanFocusTrap: Function,
  checkCanReturnFocus: Function,
  delayInitialFocus: {
    type: Boolean,
    default: !0
  },
  document: Object,
  preventScroll: Boolean,
  setReturnFocus: [Object, String, Boolean, Function],
  tabbableOptions: Object
}, P6 = Ne({
  name: "FocusTrap",
  props: Object.assign({
    active: {
      // TODO: could be options for activate but what about the options for deactivating?
      type: Boolean,
      default: !0
    }
  }, s1e),
  emits: [
    "update:active",
    "activate",
    "postActivate",
    "deactivate",
    "postDeactivate"
  ],
  render() {
    return this.renderImpl();
  },
  setup(t, { slots: e, emit: n }) {
    let r;
    const o = W(null), i = x(() => {
      const s = o.value;
      return s && (s instanceof HTMLElement ? s : s.$el);
    });
    function a() {
      return r || (r = J5(i.value, {
        escapeDeactivates: t.escapeDeactivates,
        allowOutsideClick: t.allowOutsideClick,
        returnFocusOnDeactivate: t.returnFocusOnDeactivate,
        clickOutsideDeactivates: t.clickOutsideDeactivates,
        onActivate: () => {
          n("update:active", !0), n("activate");
        },
        onDeactivate: () => {
          n("update:active", !1), n("deactivate");
        },
        onPostActivate: () => n("postActivate"),
        onPostDeactivate: () => n("postDeactivate"),
        initialFocus: t.initialFocus,
        fallbackFocus: t.fallbackFocus,
        tabbableOptions: t.tabbableOptions,
        delayInitialFocus: t.delayInitialFocus,
        preventScroll: t.preventScroll
      }));
    }
    return ct(() => {
      et(() => t.active, (s) => {
        s && i.value ? a().activate() : r && (r.deactivate(), (!i.value || i.value.nodeType === Node.COMMENT_NODE) && (r = null));
      }, { immediate: !0, flush: "post" });
    }), hf(() => {
      r && r.deactivate(), r = null;
    }), {
      activate() {
        a().activate();
      },
      deactivate() {
        r && r.deactivate();
      },
      renderImpl() {
        if (!e.default)
          return null;
        const s = e.default().filter((c) => c.type !== vS);
        return !s || !s.length || s.length > 1 ? (console.error("[focus-trap-vue]: FocusTrap requires exactly one child."), s) : gS(s[0], { ref: o });
      }
    };
  }
}), l1e = Ne({
  props: {
    modelValue: {
      type: Boolean,
      required: !0
    },
    width: {
      type: String,
      required: !1,
      default: "27rem"
    },
    title: {
      type: String,
      required: !1,
      default: "SidebarTitle"
    },
    header: {
      type: Boolean,
      required: !1,
      default: !0
    },
    initialFocus: {
      // this should be a function that returns the ref
      // of an element passed into the slot currently works
      // on native components i.e <input ref="input" ... />
      // :initialFocus="() => $refs.nameOfRef"
      // not able to get it working with components just yet
      // https://github.com/posva/focus-trap-vue/tree/next#props
      type: Function,
      required: !1
    },
    side: {
      type: String,
      required: !1,
      default: "right"
    }
  },
  emits: ["update:modelValue", "close"],
  setup(t, { emit: e }) {
    const n = W(null), r = Ga(t, "modelValue");
    Zf(r);
    const { aboveMobile: o } = Io(), { pressed: i } = Ir({
      keys: ["esc"],
      onPressCallBack: () => a()
    });
    function a() {
      e("close"), e("update:modelValue", !1);
    }
    return Rf(n, (s) => {
      s.target.closest(".sidebar-button") || a();
    }), { target: n, closeSidebar: a, aboveMobile: o, pressed: i };
  },
  components: { Text: Ye, CloseButton: qE, FocusTrap: P6, ViewBackground: ru }
});
const c1e = {
  class: "trap",
  tabindex: "-1"
}, u1e = { key: 0 };
function d1e(t, e, n, r, o, i) {
  const a = ee("ViewBackground"), s = ee("Text"), l = ee("CloseButton"), c = ee("perfect-scrollbar"), u = ee("FocusTrap");
  return v(), te(_f, { to: "body" }, [
    H(a, {
      active: t.modelValue && !t.aboveMobile
    }, null, 8, ["active"]),
    H(Zt, {
      name: "expandable-sidebar-fade-" + t.side
    }, {
      default: q(() => [
        t.modelValue ? (v(), A("aside", {
          key: 0,
          style: Fe({ width: t.width }),
          class: z(t.side),
          ref: "target"
        }, [
          H(u, {
            active: t.modelValue,
            "initial-focus": t.initialFocus
          }, {
            default: q(() => [
              g("div", c1e, [
                t.header ? (v(), A("header", u1e, [
                  H(s, {
                    as: "h4",
                    weight: "600",
                    class: "header-text"
                  }, {
                    default: q(() => [
                      me(Q(t.title), 1)
                    ]),
                    _: 1
                  }),
                  t.aboveMobile ? (v(), te(l, {
                    key: 0,
                    onClick: e[0] || (e[0] = (d) => t.closeSidebar())
                  })) : V("", !0)
                ])) : V("", !0),
                H(c, {
                  class: z(["scroll-container", t.header ? "" : "no-header"])
                }, {
                  default: q(() => [
                    g("div", {
                      class: z([t.header ? "" : "no-header", "sidebar-content"])
                    }, [
                      ue(t.$slots, "default", {}, void 0, !0)
                    ], 2)
                  ]),
                  _: 3
                }, 8, ["class"])
              ])
            ]),
            _: 3
          }, 8, ["active", "initial-focus"])
        ], 6)) : V("", !0)
      ]),
      _: 3
    }, 8, ["name"])
  ]);
}
const nPe = /* @__PURE__ */ Y(l1e, [["render", d1e], ["__scopeId", "data-v-23acd058"]]), f1e = Ne({
  emits: ["clicked"],
  setup(t, { emit: e }) {
    function n() {
      e("clicked");
    }
    return { clicked: n, ...Io() };
  }
});
const h1e = {
  key: 0,
  width: "16",
  height: "12",
  viewbox: "0 0 12 16",
  xmlns: "http://www.w3.org/2000/svg"
}, _1e = {
  key: 1,
  width: "18",
  height: "16",
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function E1e(t, e, n, r, o, i) {
  return v(), A("button", {
    class: "sidebar-button",
    onClick: e[0] || (e[0] = (...a) => t.clicked && t.clicked(...a))
  }, [
    t.aboveMobile ? (v(), A("svg", h1e, [...e[1] || (e[1] = [
      g("path", {
        d: "M1 0h14a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2zm0 5h14a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2zm0 5h14a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2z",
        fill: "#006dff",
        "fill-rule": "evenodd"
      }, null, -1)
    ])])) : (v(), A("svg", _1e, [...e[2] || (e[2] = [
      g("path", {
        d: "M0 4C0 3.44772 0.447715 3 1 3H17C17.5523 3 18 3.44772 18 4V4C18 4.55228 17.5523 5 17 5H1C0.447716 5 0 4.55228 0 4V4Z",
        fill: "black"
      }, null, -1),
      g("path", {
        d: "M0 12C0 11.4477 0.447715 11 1 11H17C17.5523 11 18 11.4477 18 12V12C18 12.5523 17.5523 13 17 13H1C0.447716 13 0 12.5523 0 12V12Z",
        fill: "black"
      }, null, -1),
      g("circle", {
        cx: "12",
        cy: "4",
        r: "3",
        fill: "white",
        stroke: "#010105",
        "stroke-width": "2"
      }, null, -1),
      g("circle", {
        cx: "6",
        cy: "12",
        r: "3",
        fill: "white",
        stroke: "#010105",
        "stroke-width": "2"
      }, null, -1)
    ])]))
  ]);
}
const rPe = /* @__PURE__ */ Y(f1e, [["render", E1e], ["__scopeId", "data-v-dc5d834a"]]), p1e = Ne({
  props: {
    arrow: {
      type: Boolean,
      required: !1,
      default: !0
    },
    url: {
      type: String,
      required: !1
    },
    clickable: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  components: { HelpIcon: WV, RightArrow: d0, Text: Ye, ColorTag: XE },
  emits: ["clicked"],
  setup(t, { emit: e }) {
    function n() {
      e("clicked");
    }
    return { clicked: n };
  }
});
const m1e = { class: "icon-text-container left" };
function N1e(t, e, n, r, o, i) {
  const a = ee("HelpIcon"), s = ee("Text"), l = ee("RightArrow"), c = ee("ColorTag");
  return v(), te(zo(t.url ? "a" : "div"), {
    class: z([t.clickable ? "clickable" : "", "help-link-container"]),
    tabindex: 0,
    onClick: t.clicked,
    href: t.url ? t.url : null,
    target: t.url ? "_blank" : null,
    rel: t.url ? "noopener noreferrer" : null
  }, {
    default: q(() => [
      g("div", m1e, [
        H(a, { class: "help-icon" }),
        H(s, {
          as: "p",
          size: "f-8",
          class: "help-link-text"
        }, {
          default: q(() => [
            ue(t.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        })
      ]),
      t.arrow ? (v(), te(l, {
        key: 0,
        class: "right-arrow",
        hex: "#0035ec"
      })) : V("", !0),
      H(c, {
        color: "blue",
        title: "Learn More",
        class: "color-tag"
      })
    ]),
    _: 3
  }, 8, ["class", "onClick", "href", "target", "rel"]);
}
const oPe = /* @__PURE__ */ Y(p1e, [["render", N1e], ["__scopeId", "data-v-03382392"]]), v1e = Ne({
  props: {
    // internal
    to: {
      type: String,
      required: !1
    },
    // external
    href: {
      type: String,
      required: !1
    }
    // for styling, underlines, colors, hover, etc
    // variant: {
    //     type: String as PropType<LinkVariant>,
    //     required: false,
    // },
  }
});
const g1e = ["href"];
function I1e(t, e, n, r, o, i) {
  const a = ee("router-link");
  return v(), A(ge, null, [
    t.to ? (v(), te(a, {
      key: 0,
      to: t.to
    }, {
      default: q(() => [
        ue(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["to"])) : V("", !0),
    t.href ? (v(), A("a", {
      key: 1,
      href: t.href,
      rel: "noreferrer",
      target: "_blank"
    }, [
      ue(t.$slots, "default")
    ], 8, g1e)) : V("", !0)
  ], 64);
}
const iPe = /* @__PURE__ */ Y(v1e, [["render", I1e]]), O1e = Ne({
  props: {
    // perfect scrollbar will show if list items
    // height exceeds maxHeight prop value
    maxHeight: {
      // should be in rems and map to 4px grid
      type: String,
      required: !1
    },
    eventContainer: {
      type: Function,
      required: !1
    },
    initialIndexZero: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["changed"],
  setup(t, { slots: e, emit: n }) {
    const r = W(), o = W(), i = x(() => {
      if (!e.default)
        throw new Error("slot must be defined");
      return e.default();
    }), a = x(() => i.value.length > 1), s = x(() => a.value ? i.value : i.value[0].children), l = x(() => {
      if (!s.value)
        throw new Error("elements or components must be nested in slot");
      return s.value.length;
    }), c = x(() => {
      if (typeof r.value == "number")
        return s.value[r.value].props.value;
    }), u = (h) => {
      if (!c.value) {
        r.value = 0;
        return;
      }
      const _ = d(c.value);
      r.value = ((_ + h) % l.value + l.value) % l.value;
    }, d = (h) => s.value.findIndex((_) => _.props.value === h), f = (h) => {
      const _ = d(h);
      r.value = _;
    };
    return ct(async () => {
      await Or(100), t.initialIndexZero && (r.value = 0);
    }), Ti("listValue", c), Ti("setListValue", f), Ir({
      keys: ["arrowup"],
      onPressCallBack: () => {
        u(-1), n("changed", r.value);
      }
    }), Ir({
      keys: ["arrowdown"],
      onPressCallBack: () => {
        u(1), n("changed", r.value);
      }
    }), {
      list: o,
      length,
      index: r,
      listValue: c
    };
  }
});
const A1e = {
  ref: "list",
  tabIndex: "0"
};
function D1e(t, e, n, r, o, i) {
  const a = ee("perfect-scrollbar");
  return v(), A("ul", A1e, [
    H(a, {
      style: Fe({ maxHeight: t.maxHeight })
    }, {
      default: q(() => [
        ue(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["style"])
  ], 512);
}
const aPe = /* @__PURE__ */ Y(O1e, [["render", D1e]]), C1e = Ne({
  props: {
    value: {
      type: String,
      required: !1
    }
  },
  emits: ["clicked"],
  setup(t, { slots: e, emit: n }) {
    const r = W(), o = so("listValue"), i = so("setListValue"), a = so("hidePopout");
    function s() {
      n("clicked"), a && a();
    }
    function l() {
      i && i(t.value);
    }
    return Ir({
      keys: ["enter"],
      onPressCallBack: () => {
        o.value === t.value && s();
      }
    }), {
      item: r,
      listValue: o,
      clicked: s,
      hovered: l
    };
  }
});
const S1e = ["data-state"];
function w1e(t, e, n, r, o, i) {
  return v(), A("li", {
    ref: "item",
    class: "list-item",
    "data-state": t.value === t.listValue ? "selected" : null,
    onClick: e[0] || (e[0] = ua((...a) => t.clicked && t.clicked(...a), ["prevent"])),
    onMouseenter: e[1] || (e[1] = (...a) => t.hovered && t.hovered(...a))
  }, [
    ue(t.$slots, "default")
  ], 40, S1e);
}
const sPe = /* @__PURE__ */ Y(C1e, [["render", w1e]]), T1e = Ne({
  name: "ModalView",
  props: {
    id: {
      type: String,
      required: !1
    },
    modelValue: {
      type: Boolean,
      default: !1
    },
    width: {
      type: String,
      required: !1,
      default: "520px"
    },
    title: {
      type: String,
      required: !1,
      default: "Modal Title"
    },
    noInnerContentShadow: {
      type: Boolean,
      required: !1,
      default: !1
    },
    noPadding: {
      type: Boolean,
      required: !1,
      default: !1
    },
    containerClass: {
      type: String,
      required: !1
    },
    closeButton: {
      type: Boolean,
      required: !1,
      default: !0
    },
    contentMaxHeight: {
      type: String,
      required: !1
    }
  },
  emits: ["closed", "opened", "update:modelValue"],
  setup(t, { emit: e }) {
    const { aboveiPadLandscape: n } = Io();
    et(t, async ({ modelValue: u }) => r(u));
    const r = async (u) => {
      u ? (document.body.classList.add("no-scroll"), await Ln(), e("opened"), a()) : (document.body.classList.remove("no-scroll"), await Ln(), e("closed"), s());
    }, o = W(), { hasFocus: i, activate: a, deactivate: s } = jE(o, {
      initialFocus: !1,
      fallbackFocus: () => o.value
    });
    ct(() => {
      t.modelValue === !0 && r(!0);
    }), hf(() => {
      t.modelValue === !0 && document.body.classList.remove("no-scroll");
    });
    function l() {
      e("update:modelValue", !1);
    }
    const c = W(null);
    return Rf(c, (u) => {
      const d = u.target;
      d.classList.contains("select-item") || d.closest("[data-tippy-root]") || l();
    }), { closeModal: l, target: c, aboveiPadLandscape: n, focusTrapRef: o, hasFocus: i };
  },
  components: { Text: Ye, CloseButton: qE, Spacer: He, ViewBackground: ru }
});
const b1e = ["id"], R1e = { class: "modal-wrapper" }, M1e = {
  ref: "focusTrapRef",
  class: "trap",
  tabindex: "-1"
}, P1e = {
  key: 0,
  class: "title"
}, y1e = {
  key: 3,
  class: "close-btn-cnt"
}, L1e = {
  key: 4,
  class: "close-btn-cnt"
}, x1e = {
  key: 0,
  class: "mobile-nested-header"
}, U1e = {
  key: 1,
  class: "modal-buttons"
};
function $1e(t, e, n, r, o, i) {
  const a = ee("ViewBackground"), s = ee("Text"), l = ee("CloseButton"), c = ee("perfect-scrollbar");
  return v(), te(_f, { to: "body" }, [
    H(a, {
      active: t.modelValue,
      zIndex: 2147483004
    }, null, 8, ["active"]),
    H(Zt, { name: "fade-up" }, {
      default: q(() => [
        t.modelValue ? (v(), A("div", {
          key: 0,
          id: t.id,
          class: z(["modal", { open: t.modelValue }, t.containerClass])
        }, [
          g("div", R1e, [
            g("aside", {
              class: z(["modal-container", { "no-buttons": !t.$slots.buttons }]),
              style: Fe({ maxWidth: t.width }),
              ref: "target"
            }, [
              g("div", M1e, [
                g("header", {
                  class: z({ "has-header": t.$slots.header })
                }, [
                  t.$slots.title ? (v(), A("div", P1e, [
                    ue(t.$slots, "title")
                  ])) : (v(), te(s, {
                    key: 1,
                    as: "h3",
                    weight: "600",
                    style: { "line-height": "2.625rem" },
                    class: "title"
                  }, {
                    default: q(() => [
                      me(Q(t.title), 1)
                    ]),
                    _: 1
                  })),
                  t.aboveiPadLandscape ? ue(t.$slots, "header", { key: 2 }) : V("", !0),
                  t.closeButton ? (v(), A("div", y1e, [
                    H(l, {
                      onClicked: e[0] || (e[0] = (u) => t.closeModal()),
                      tooltip: !1
                    })
                  ])) : V("", !0),
                  t.closeButton ? V("", !0) : (v(), A("div", L1e, [
                    ue(t.$slots, "modal-top-right")
                  ]))
                ], 2),
                t.$slots.header && !t.aboveiPadLandscape ? (v(), A("div", x1e, [
                  ue(t.$slots, "header")
                ])) : V("", !0),
                H(c, {
                  class: z([
                    "modal-content",
                    { "container-shadow": !t.noInnerContentShadow },
                    { "no-padding": t.noPadding }
                  ]),
                  style: Fe(t.contentMaxHeight ? "max-height: " + t.contentMaxHeight : "")
                }, {
                  default: q(() => [
                    ue(t.$slots, "content")
                  ]),
                  _: 3
                }, 8, ["class", "style"]),
                t.$slots.buttons ? (v(), A("div", U1e, [
                  ue(t.$slots, "buttons")
                ])) : V("", !0)
              ], 512)
            ], 6)
          ])
        ], 10, b1e)) : V("", !0)
      ]),
      _: 3
    })
  ]);
}
const k1e = /* @__PURE__ */ Y(T1e, [["render", $1e]]);
function B1e(t, e, n) {
  return Math.max(e, Math.min(t, n));
}
const en = {
  toVector(t, e) {
    return t === void 0 && (t = e), Array.isArray(t) ? t : [t, t];
  },
  add(t, e) {
    return [t[0] + e[0], t[1] + e[1]];
  },
  sub(t, e) {
    return [t[0] - e[0], t[1] - e[1]];
  },
  addTo(t, e) {
    t[0] += e[0], t[1] += e[1];
  },
  subTo(t, e) {
    t[0] -= e[0], t[1] -= e[1];
  }
};
function p3(t, e, n) {
  return e === 0 || Math.abs(e) === 1 / 0 ? Math.pow(t, n * 5) : t * e * n / (e + n * t);
}
function m3(t, e, n, r = 0.15) {
  return r === 0 ? B1e(t, e, n) : t < e ? -p3(e - t, n - e, r) + e : t > n ? +p3(t - n, n - e, r) + n : t;
}
function G1e(t, [e, n], [r, o]) {
  const [[i, a], [s, l]] = t;
  return [m3(e, i, a, r), m3(n, s, l, o)];
}
function F1e(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function V1e(t) {
  var e = F1e(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function Mn(t, e, n) {
  return e = V1e(e), e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function N3(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Lt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? N3(Object(n), !0).forEach(function(r) {
      Mn(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : N3(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
const y6 = {
  pointer: {
    start: "down",
    change: "move",
    end: "up"
  },
  mouse: {
    start: "down",
    change: "move",
    end: "up"
  },
  touch: {
    start: "start",
    change: "move",
    end: "end"
  },
  gesture: {
    start: "start",
    change: "change",
    end: "end"
  }
};
function v3(t) {
  return t ? t[0].toUpperCase() + t.slice(1) : "";
}
const H1e = ["enter", "leave"];
function W1e(t = !1, e) {
  return t && !H1e.includes(e);
}
function Y1e(t, e = "", n = !1) {
  const r = y6[t], o = r && r[e] || e;
  return "on" + v3(t) + v3(o) + (W1e(n, o) ? "Capture" : "");
}
const K1e = ["gotpointercapture", "lostpointercapture"];
function z1e(t) {
  let e = t.substring(2).toLowerCase();
  const n = !!~e.indexOf("passive");
  n && (e = e.replace("passive", ""));
  const r = K1e.includes(e) ? "capturecapture" : "capture", o = !!~e.indexOf(r);
  return o && (e = e.replace("capture", "")), {
    device: e,
    capture: o,
    passive: n
  };
}
function Z1e(t, e = "") {
  const n = y6[t], r = n && n[e] || e;
  return t + r;
}
function qf(t) {
  return "touches" in t;
}
function L6(t) {
  return qf(t) ? "touch" : "pointerType" in t ? t.pointerType : "mouse";
}
function q1e(t) {
  return Array.from(t.touches).filter((e) => {
    var n, r;
    return e.target === t.currentTarget || ((n = t.currentTarget) === null || n === void 0 || (r = n.contains) === null || r === void 0 ? void 0 : r.call(n, e.target));
  });
}
function X1e(t) {
  return t.type === "touchend" || t.type === "touchcancel" ? t.changedTouches : t.targetTouches;
}
function x6(t) {
  return qf(t) ? X1e(t)[0] : t;
}
function j1e(t) {
  return q1e(t).map((e) => e.identifier);
}
function Y1(t) {
  const e = x6(t);
  return qf(t) ? e.identifier : e.pointerId;
}
function g3(t) {
  const e = x6(t);
  return [e.clientX, e.clientY];
}
function J1e(t) {
  var e, n;
  const {
    scrollX: r,
    scrollY: o,
    scrollLeft: i,
    scrollTop: a
  } = t.currentTarget;
  return [(e = r ?? i) !== null && e !== void 0 ? e : 0, (n = o ?? a) !== null && n !== void 0 ? n : 0];
}
function Q1e(t) {
  const e = {};
  if ("buttons" in t && (e.buttons = t.buttons), "shiftKey" in t) {
    const {
      shiftKey: n,
      altKey: r,
      metaKey: o,
      ctrlKey: i
    } = t;
    Object.assign(e, {
      shiftKey: n,
      altKey: r,
      metaKey: o,
      ctrlKey: i
    });
  }
  return e;
}
function Vd(t, ...e) {
  return typeof t == "function" ? t(...e) : t;
}
function ehe() {
}
function the(...t) {
  return t.length === 0 ? ehe : t.length === 1 ? t[0] : function() {
    let e;
    for (const n of t)
      e = n.apply(this, arguments) || e;
    return e;
  };
}
function I3(t, e) {
  return Object.assign({}, e, t || {});
}
const nhe = 32;
let rhe = class {
  constructor(e, n, r) {
    this.ctrl = e, this.args = n, this.key = r, this.state || (this.state = {}, this.computeValues([0, 0]), this.computeInitial(), this.init && this.init(), this.reset());
  }
  get state() {
    return this.ctrl.state[this.key];
  }
  set state(e) {
    this.ctrl.state[this.key] = e;
  }
  get shared() {
    return this.ctrl.state.shared;
  }
  get eventStore() {
    return this.ctrl.gestureEventStores[this.key];
  }
  get timeoutStore() {
    return this.ctrl.gestureTimeoutStores[this.key];
  }
  get config() {
    return this.ctrl.config[this.key];
  }
  get sharedConfig() {
    return this.ctrl.config.shared;
  }
  get handler() {
    return this.ctrl.handlers[this.key];
  }
  reset() {
    const {
      state: e,
      shared: n,
      ingKey: r,
      args: o
    } = this;
    n[r] = e._active = e.active = e._blocked = e._force = !1, e._step = [!1, !1], e.intentional = !1, e._movement = [0, 0], e._distance = [0, 0], e._direction = [0, 0], e._delta = [0, 0], e._bounds = [[-1 / 0, 1 / 0], [-1 / 0, 1 / 0]], e.args = o, e.axis = void 0, e.memo = void 0, e.elapsedTime = e.timeDelta = 0, e.direction = [0, 0], e.distance = [0, 0], e.overflow = [0, 0], e._movementBound = [!1, !1], e.velocity = [0, 0], e.movement = [0, 0], e.delta = [0, 0], e.timeStamp = 0;
  }
  start(e) {
    const n = this.state, r = this.config;
    n._active || (this.reset(), this.computeInitial(), n._active = !0, n.target = e.target, n.currentTarget = e.currentTarget, n.lastOffset = r.from ? Vd(r.from, n) : n.offset, n.offset = n.lastOffset, n.startTime = n.timeStamp = e.timeStamp);
  }
  computeValues(e) {
    const n = this.state;
    n._values = e, n.values = this.config.transform(e);
  }
  computeInitial() {
    const e = this.state;
    e._initial = e._values, e.initial = e.values;
  }
  compute(e) {
    const {
      state: n,
      config: r,
      shared: o
    } = this;
    n.args = this.args;
    let i = 0;
    if (e && (n.event = e, r.preventDefault && e.cancelable && n.event.preventDefault(), n.type = e.type, o.touches = this.ctrl.pointerIds.size || this.ctrl.touchIds.size, o.locked = !!document.pointerLockElement, Object.assign(o, Q1e(e)), o.down = o.pressed = o.buttons % 2 === 1 || o.touches > 0, i = e.timeStamp - n.timeStamp, n.timeStamp = e.timeStamp, n.elapsedTime = n.timeStamp - n.startTime), n._active) {
      const D = n._delta.map(Math.abs);
      en.addTo(n._distance, D);
    }
    this.axisIntent && this.axisIntent(e);
    const [a, s] = n._movement, [l, c] = r.threshold, {
      _step: u,
      values: d
    } = n;
    if (r.hasCustomTransform ? (u[0] === !1 && (u[0] = Math.abs(a) >= l && d[0]), u[1] === !1 && (u[1] = Math.abs(s) >= c && d[1])) : (u[0] === !1 && (u[0] = Math.abs(a) >= l && Math.sign(a) * l), u[1] === !1 && (u[1] = Math.abs(s) >= c && Math.sign(s) * c)), n.intentional = u[0] !== !1 || u[1] !== !1, !n.intentional)
      return;
    const f = [0, 0];
    if (r.hasCustomTransform) {
      const [D, T] = d;
      f[0] = u[0] !== !1 ? D - u[0] : 0, f[1] = u[1] !== !1 ? T - u[1] : 0;
    } else
      f[0] = u[0] !== !1 ? a - u[0] : 0, f[1] = u[1] !== !1 ? s - u[1] : 0;
    this.restrictToAxis && !n._blocked && this.restrictToAxis(f);
    const h = n.offset, _ = n._active && !n._blocked || n.active;
    _ && (n.first = n._active && !n.active, n.last = !n._active && n.active, n.active = o[this.ingKey] = n._active, e && (n.first && ("bounds" in r && (n._bounds = Vd(r.bounds, n)), this.setup && this.setup()), n.movement = f, this.computeOffset()));
    const [E, m] = n.offset, [[N, I], [O, p]] = n._bounds;
    n.overflow = [E < N ? -1 : E > I ? 1 : 0, m < O ? -1 : m > p ? 1 : 0], n._movementBound[0] = n.overflow[0] ? n._movementBound[0] === !1 ? n._movement[0] : n._movementBound[0] : !1, n._movementBound[1] = n.overflow[1] ? n._movementBound[1] === !1 ? n._movement[1] : n._movementBound[1] : !1;
    const C = n._active ? r.rubberband || [0, 0] : [0, 0];
    if (n.offset = G1e(n._bounds, n.offset, C), n.delta = en.sub(n.offset, h), this.computeMovement(), _ && (!n.last || i > nhe)) {
      n.delta = en.sub(n.offset, h);
      const D = n.delta.map(Math.abs);
      en.addTo(n.distance, D), n.direction = n.delta.map(Math.sign), n._direction = n._delta.map(Math.sign), !n.first && i > 0 && (n.velocity = [D[0] / i, D[1] / i], n.timeDelta = i);
    }
  }
  emit() {
    const e = this.state, n = this.shared, r = this.config;
    if (e._active || this.clean(), (e._blocked || !e.intentional) && !e._force && !r.triggerAllEvents)
      return;
    const o = this.handler(Lt(Lt(Lt({}, n), e), {}, {
      [this.aliasKey]: e.values
    }));
    o !== void 0 && (e.memo = o);
  }
  clean() {
    this.eventStore.clean(), this.timeoutStore.clean();
  }
};
function ohe([t, e], n) {
  const r = Math.abs(t), o = Math.abs(e);
  if (r > o && r > n)
    return "x";
  if (o > r && o > n)
    return "y";
}
class U6 extends rhe {
  constructor(...e) {
    super(...e), Mn(this, "aliasKey", "xy");
  }
  reset() {
    super.reset(), this.state.axis = void 0;
  }
  init() {
    this.state.offset = [0, 0], this.state.lastOffset = [0, 0];
  }
  computeOffset() {
    this.state.offset = en.add(this.state.lastOffset, this.state.movement);
  }
  computeMovement() {
    this.state.movement = en.sub(this.state.offset, this.state.lastOffset);
  }
  axisIntent(e) {
    const n = this.state, r = this.config;
    if (!n.axis && e) {
      const o = typeof r.axisThreshold == "object" ? r.axisThreshold[L6(e)] : r.axisThreshold;
      n.axis = ohe(n._movement, o);
    }
    n._blocked = (r.lockDirection || !!r.axis) && !n.axis || !!r.axis && r.axis !== n.axis;
  }
  restrictToAxis(e) {
    if (this.config.axis || this.config.lockDirection)
      switch (this.state.axis) {
        case "x":
          e[1] = 0;
          break;
        case "y":
          e[0] = 0;
          break;
      }
  }
}
const O3 = (t) => t, A3 = 0.15, Sp = {
  enabled(t = !0) {
    return t;
  },
  eventOptions(t, e, n) {
    return Lt(Lt({}, n.shared.eventOptions), t);
  },
  preventDefault(t = !1) {
    return t;
  },
  triggerAllEvents(t = !1) {
    return t;
  },
  rubberband(t = 0) {
    switch (t) {
      case !0:
        return [A3, A3];
      case !1:
        return [0, 0];
      default:
        return en.toVector(t);
    }
  },
  from(t) {
    if (typeof t == "function")
      return t;
    if (t != null)
      return en.toVector(t);
  },
  transform(t, e, n) {
    const r = t || n.shared.transform;
    if (this.hasCustomTransform = !!r, process.env.NODE_ENV === "development") {
      const o = r || O3;
      return (i) => {
        const a = o(i);
        return (!isFinite(a[0]) || !isFinite(a[1])) && console.warn(`[@use-gesture]: config.transform() must produce a valid result, but it was: [${a[0]},${[1]}]`), a;
      };
    }
    return r || O3;
  },
  threshold(t) {
    return en.toVector(t, 0);
  }
};
process.env.NODE_ENV === "development" && Object.assign(Sp, {
  domTarget(t) {
    if (t !== void 0)
      throw Error("[@use-gesture]: `domTarget` option has been renamed to `target`.");
    return NaN;
  },
  lockDirection(t) {
    if (t !== void 0)
      throw Error("[@use-gesture]: `lockDirection` option has been merged with `axis`. Use it as in `{ axis: 'lock' }`");
    return NaN;
  },
  initial(t) {
    if (t !== void 0)
      throw Error("[@use-gesture]: `initial` option has been renamed to `from`.");
    return NaN;
  }
});
const ihe = 0, ml = Lt(Lt({}, Sp), {}, {
  axis(t, e, {
    axis: n
  }) {
    if (this.lockDirection = n === "lock", !this.lockDirection)
      return n;
  },
  axisThreshold(t = ihe) {
    return t;
  },
  bounds(t = {}) {
    if (typeof t == "function")
      return (i) => ml.bounds(t(i));
    if ("current" in t)
      return () => t.current;
    if (typeof HTMLElement == "function" && t instanceof HTMLElement)
      return t;
    const {
      left: e = -1 / 0,
      right: n = 1 / 0,
      top: r = -1 / 0,
      bottom: o = 1 / 0
    } = t;
    return [[e, n], [r, o]];
  }
}), D3 = {
  ArrowRight: (t, e = 1) => [t * e, 0],
  ArrowLeft: (t, e = 1) => [-1 * t * e, 0],
  ArrowUp: (t, e = 1) => [0, -1 * t * e],
  ArrowDown: (t, e = 1) => [0, t * e]
};
class ahe extends U6 {
  constructor(...e) {
    super(...e), Mn(this, "ingKey", "dragging");
  }
  reset() {
    super.reset();
    const e = this.state;
    e._pointerId = void 0, e._pointerActive = !1, e._keyboardActive = !1, e._preventScroll = !1, e._delayed = !1, e.swipe = [0, 0], e.tap = !1, e.canceled = !1, e.cancel = this.cancel.bind(this);
  }
  setup() {
    const e = this.state;
    if (e._bounds instanceof HTMLElement) {
      const n = e._bounds.getBoundingClientRect(), r = e.currentTarget.getBoundingClientRect(), o = {
        left: n.left - r.left + e.offset[0],
        right: n.right - r.right + e.offset[0],
        top: n.top - r.top + e.offset[1],
        bottom: n.bottom - r.bottom + e.offset[1]
      };
      e._bounds = ml.bounds(o);
    }
  }
  cancel() {
    const e = this.state;
    e.canceled || (e.canceled = !0, e._active = !1, setTimeout(() => {
      this.compute(), this.emit();
    }, 0));
  }
  setActive() {
    this.state._active = this.state._pointerActive || this.state._keyboardActive;
  }
  clean() {
    this.pointerClean(), this.state._pointerActive = !1, this.state._keyboardActive = !1, super.clean();
  }
  pointerDown(e) {
    const n = this.config, r = this.state;
    if (e.buttons != null && (Array.isArray(n.pointerButtons) ? !n.pointerButtons.includes(e.buttons) : n.pointerButtons !== -1 && n.pointerButtons !== e.buttons))
      return;
    const o = this.ctrl.setEventIds(e);
    n.pointerCapture && e.target.setPointerCapture(e.pointerId), !(o && o.size > 1 && r._pointerActive) && (this.start(e), this.setupPointer(e), r._pointerId = Y1(e), r._pointerActive = !0, this.computeValues(g3(e)), this.computeInitial(), n.preventScrollAxis && L6(e) !== "mouse" ? (r._active = !1, this.setupScrollPrevention(e)) : n.delay > 0 ? (this.setupDelayTrigger(e), n.triggerAllEvents && (this.compute(e), this.emit())) : this.startPointerDrag(e));
  }
  startPointerDrag(e) {
    const n = this.state;
    n._active = !0, n._preventScroll = !0, n._delayed = !1, this.compute(e), this.emit();
  }
  pointerMove(e) {
    const n = this.state, r = this.config;
    if (!n._pointerActive)
      return;
    const o = Y1(e);
    if (n._pointerId !== void 0 && o !== n._pointerId)
      return;
    const i = g3(e);
    if (document.pointerLockElement === e.target ? n._delta = [e.movementX, e.movementY] : (n._delta = en.sub(i, n._values), this.computeValues(i)), en.addTo(n._movement, n._delta), this.compute(e), n._delayed && n.intentional) {
      this.timeoutStore.remove("dragDelay"), n.active = !1, this.startPointerDrag(e);
      return;
    }
    if (r.preventScrollAxis && !n._preventScroll)
      if (n.axis)
        if (n.axis === r.preventScrollAxis || r.preventScrollAxis === "xy") {
          n._active = !1, this.clean();
          return;
        } else {
          this.timeoutStore.remove("startPointerDrag"), this.startPointerDrag(e);
          return;
        }
      else
        return;
    this.emit();
  }
  pointerUp(e) {
    this.ctrl.setEventIds(e);
    try {
      this.config.pointerCapture && e.target.hasPointerCapture(e.pointerId) && e.target.releasePointerCapture(e.pointerId);
    } catch {
      process.env.NODE_ENV === "development" && console.warn("[@use-gesture]: If you see this message, it's likely that you're using an outdated version of `@react-three/fiber`. \n\nPlease upgrade to the latest version.");
    }
    const n = this.state, r = this.config;
    if (!n._active || !n._pointerActive)
      return;
    const o = Y1(e);
    if (n._pointerId !== void 0 && o !== n._pointerId)
      return;
    this.state._pointerActive = !1, this.setActive(), this.compute(e);
    const [i, a] = n._distance;
    if (n.tap = i <= r.tapsThreshold && a <= r.tapsThreshold, n.tap && r.filterTaps)
      n._force = !0;
    else {
      const [s, l] = n._delta, [c, u] = n._movement, [d, f] = r.swipe.velocity, [h, _] = r.swipe.distance, E = r.swipe.duration;
      if (n.elapsedTime < E) {
        const m = Math.abs(s / n.timeDelta), N = Math.abs(l / n.timeDelta);
        m > d && Math.abs(c) > h && (n.swipe[0] = Math.sign(s)), N > f && Math.abs(u) > _ && (n.swipe[1] = Math.sign(l));
      }
    }
    this.emit();
  }
  pointerClick(e) {
    !this.state.tap && e.detail > 0 && (e.preventDefault(), e.stopPropagation());
  }
  setupPointer(e) {
    const n = this.config, r = n.device;
    if (process.env.NODE_ENV === "development")
      try {
        if (r === "pointer" && n.preventScrollDelay === void 0) {
          const o = "uv" in e ? e.sourceEvent.currentTarget : e.currentTarget;
          window.getComputedStyle(o).touchAction === "auto" && console.warn("[@use-gesture]: The drag target has its `touch-action` style property set to `auto`. It is recommended to add `touch-action: 'none'` so that the drag gesture behaves correctly on touch-enabled devices. For more information read this: https://use-gesture.netlify.app/docs/extras/#touch-action.\n\nThis message will only show in development mode. It won't appear in production. If this is intended, you can ignore it.", o);
        }
      } catch {
      }
    n.pointerLock && e.currentTarget.requestPointerLock(), n.pointerCapture || (this.eventStore.add(this.sharedConfig.window, r, "change", this.pointerMove.bind(this)), this.eventStore.add(this.sharedConfig.window, r, "end", this.pointerUp.bind(this)), this.eventStore.add(this.sharedConfig.window, r, "cancel", this.pointerUp.bind(this)));
  }
  pointerClean() {
    this.config.pointerLock && document.pointerLockElement === this.state.currentTarget && document.exitPointerLock();
  }
  preventScroll(e) {
    this.state._preventScroll && e.cancelable && e.preventDefault();
  }
  setupScrollPrevention(e) {
    this.state._preventScroll = !1, she(e);
    const n = this.eventStore.add(this.sharedConfig.window, "touch", "change", this.preventScroll.bind(this), {
      passive: !1
    });
    this.eventStore.add(this.sharedConfig.window, "touch", "end", n), this.eventStore.add(this.sharedConfig.window, "touch", "cancel", n), this.timeoutStore.add("startPointerDrag", this.startPointerDrag.bind(this), this.config.preventScrollDelay, e);
  }
  setupDelayTrigger(e) {
    this.state._delayed = !0, this.timeoutStore.add("dragDelay", () => {
      this.state._step = [0, 0], this.startPointerDrag(e);
    }, this.config.delay);
  }
  keyDown(e) {
    const n = D3[e.key];
    if (n) {
      const r = this.state, o = e.shiftKey ? 10 : e.altKey ? 0.1 : 1;
      this.start(e), r._delta = n(this.config.keyboardDisplacement, o), r._keyboardActive = !0, en.addTo(r._movement, r._delta), this.compute(e), this.emit();
    }
  }
  keyUp(e) {
    e.key in D3 && (this.state._keyboardActive = !1, this.setActive(), this.compute(e), this.emit());
  }
  bind(e) {
    const n = this.config.device;
    e(n, "start", this.pointerDown.bind(this)), this.config.pointerCapture && (e(n, "change", this.pointerMove.bind(this)), e(n, "end", this.pointerUp.bind(this)), e(n, "cancel", this.pointerUp.bind(this)), e("lostPointerCapture", "", this.pointerUp.bind(this))), this.config.keys && (e("key", "down", this.keyDown.bind(this)), e("key", "up", this.keyUp.bind(this))), this.config.filterTaps && e("click", "", this.pointerClick.bind(this), {
      capture: !0,
      passive: !1
    });
  }
}
function she(t) {
  "persist" in t && typeof t.persist == "function" && t.persist();
}
const uu = typeof window < "u" && window.document && window.document.createElement;
function $6() {
  return uu && "ontouchstart" in window;
}
function lhe() {
  return $6() || uu && window.navigator.maxTouchPoints > 1;
}
function che() {
  return uu && "onpointerdown" in window;
}
function uhe() {
  return uu && "exitPointerLock" in window.document;
}
function dhe() {
  try {
    return "constructor" in GestureEvent;
  } catch {
    return !1;
  }
}
const lr = {
  isBrowser: uu,
  gesture: dhe(),
  touch: $6(),
  touchscreen: lhe(),
  pointer: che(),
  pointerLock: uhe()
}, fhe = 250, hhe = 180, _he = 0.5, Ehe = 50, phe = 250, mhe = 10, C3 = {
  mouse: 0,
  touch: 0,
  pen: 8
}, k6 = Lt(Lt({}, ml), {}, {
  device(t, e, {
    pointer: {
      touch: n = !1,
      lock: r = !1,
      mouse: o = !1
    } = {}
  }) {
    return this.pointerLock = r && lr.pointerLock, lr.touch && n ? "touch" : this.pointerLock ? "mouse" : lr.pointer && !o ? "pointer" : lr.touch ? "touch" : "mouse";
  },
  preventScrollAxis(t, e, {
    preventScroll: n
  }) {
    if (this.preventScrollDelay = typeof n == "number" ? n : n || n === void 0 && t ? fhe : void 0, !(!lr.touchscreen || n === !1))
      return t || (n !== void 0 ? "y" : void 0);
  },
  pointerCapture(t, e, {
    pointer: {
      capture: n = !0,
      buttons: r = 1,
      keys: o = !0
    } = {}
  }) {
    return this.pointerButtons = r, this.keys = o, !this.pointerLock && this.device === "pointer" && n;
  },
  threshold(t, e, {
    filterTaps: n = !1,
    tapsThreshold: r = 3,
    axis: o = void 0
  }) {
    const i = en.toVector(t, n ? r : o ? 1 : 0);
    return this.filterTaps = n, this.tapsThreshold = r, i;
  },
  swipe({
    velocity: t = _he,
    distance: e = Ehe,
    duration: n = phe
  } = {}) {
    return {
      velocity: this.transform(en.toVector(t)),
      distance: this.transform(en.toVector(e)),
      duration: n
    };
  },
  delay(t = 0) {
    switch (t) {
      case !0:
        return hhe;
      case !1:
        return 0;
      default:
        return t;
    }
  },
  axisThreshold(t) {
    return t ? Lt(Lt({}, C3), t) : C3;
  },
  keyboardDisplacement(t = mhe) {
    return t;
  }
});
process.env.NODE_ENV === "development" && Object.assign(k6, {
  useTouch(t) {
    if (t !== void 0)
      throw Error("[@use-gesture]: `useTouch` option has been renamed to `pointer.touch`. Use it as in `{ pointer: { touch: true } }`.");
    return NaN;
  },
  experimental_preventWindowScrollY(t) {
    if (t !== void 0)
      throw Error("[@use-gesture]: `experimental_preventWindowScrollY` option has been renamed to `preventScroll`.");
    return NaN;
  },
  swipeVelocity(t) {
    if (t !== void 0)
      throw Error("[@use-gesture]: `swipeVelocity` option has been renamed to `swipe.velocity`. Use it as in `{ swipe: { velocity: 0.5 } }`.");
    return NaN;
  },
  swipeDistance(t) {
    if (t !== void 0)
      throw Error("[@use-gesture]: `swipeDistance` option has been renamed to `swipe.distance`. Use it as in `{ swipe: { distance: 50 } }`.");
    return NaN;
  },
  swipeDuration(t) {
    if (t !== void 0)
      throw Error("[@use-gesture]: `swipeDuration` option has been renamed to `swipe.duration`. Use it as in `{ swipe: { duration: 250 } }`.");
    return NaN;
  }
});
Lt(Lt({}, Sp), {}, {
  device(t, e, {
    shared: n,
    pointer: {
      touch: r = !1
    } = {}
  }) {
    if (n.target && !lr.touch && lr.gesture)
      return "gesture";
    if (lr.touch && r)
      return "touch";
    if (lr.touchscreen) {
      if (lr.pointer)
        return "pointer";
      if (lr.touch)
        return "touch";
    }
  },
  bounds(t, e, {
    scaleBounds: n = {},
    angleBounds: r = {}
  }) {
    const o = (a) => {
      const s = I3(Vd(n, a), {
        min: -1 / 0,
        max: 1 / 0
      });
      return [s.min, s.max];
    }, i = (a) => {
      const s = I3(Vd(r, a), {
        min: -1 / 0,
        max: 1 / 0
      });
      return [s.min, s.max];
    };
    return typeof n != "function" && typeof r != "function" ? [o(), i()] : (a) => [o(a), i(a)];
  },
  threshold(t, e, n) {
    return this.lockDirection = n.axis === "lock", en.toVector(t, this.lockDirection ? [0.1, 3] : 0);
  },
  modifierKey(t) {
    return t === void 0 ? "ctrlKey" : t;
  },
  pinchOnWheel(t = !0) {
    return t;
  }
});
Lt(Lt({}, ml), {}, {
  mouseOnly: (t = !0) => t
});
class Nhe extends U6 {
  constructor(...e) {
    super(...e), Mn(this, "ingKey", "scrolling");
  }
  scroll(e) {
    this.state._active || this.start(e), this.scrollChange(e), this.timeoutStore.add("scrollEnd", this.scrollEnd.bind(this));
  }
  scrollChange(e) {
    e.cancelable && e.preventDefault();
    const n = this.state, r = J1e(e);
    n._delta = en.sub(r, n._values), en.addTo(n._movement, n._delta), this.computeValues(r), this.compute(e), this.emit();
  }
  scrollEnd() {
    this.state._active && (this.state._active = !1, this.compute(), this.emit());
  }
  bind(e) {
    e("scroll", "", this.scroll.bind(this));
  }
}
const vhe = ml;
Lt(Lt({}, ml), {}, {
  mouseOnly: (t = !0) => t
});
const B6 = /* @__PURE__ */ new Map(), M0 = /* @__PURE__ */ new Map();
function G6(t) {
  B6.set(t.key, t.engine), M0.set(t.key, t.resolver);
}
const ghe = {
  key: "drag",
  engine: ahe,
  resolver: k6
}, Ihe = {
  key: "scroll",
  engine: Nhe,
  resolver: vhe
};
function Ohe(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(e.indexOf(o) >= 0) && (n[o] = t[o]);
  return n;
}
function Ahe(t, e) {
  if (t == null)
    return {};
  var n = Ohe(t, e), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (o = 0; o < i.length; o++)
      r = i[o], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
const Dhe = {
  target(t) {
    if (t)
      return () => "current" in t ? t.current : t;
  },
  enabled(t = !0) {
    return t;
  },
  window(t = lr.isBrowser ? window : void 0) {
    return t;
  },
  eventOptions({
    passive: t = !0,
    capture: e = !1
  } = {}) {
    return {
      passive: t,
      capture: e
    };
  },
  transform(t) {
    return t;
  }
}, Che = ["target", "eventOptions", "window", "enabled", "transform"];
function sd(t = {}, e) {
  const n = {};
  for (const [r, o] of Object.entries(e))
    switch (typeof o) {
      case "function":
        if (process.env.NODE_ENV === "development") {
          const i = o.call(n, t[r], r, t);
          Number.isNaN(i) || (n[r] = i);
        } else
          n[r] = o.call(n, t[r], r, t);
        break;
      case "object":
        n[r] = sd(t[r], o);
        break;
      case "boolean":
        o && (n[r] = t[r]);
        break;
    }
  return n;
}
function She(t, e, n = {}) {
  const r = t, {
    target: o,
    eventOptions: i,
    window: a,
    enabled: s,
    transform: l
  } = r, c = Ahe(r, Che);
  if (n.shared = sd({
    target: o,
    eventOptions: i,
    window: a,
    enabled: s,
    transform: l
  }, Dhe), e) {
    const u = M0.get(e);
    n[e] = sd(Lt({
      shared: n.shared
    }, c), u);
  } else
    for (const u in c) {
      const d = M0.get(u);
      if (d)
        n[u] = sd(Lt({
          shared: n.shared
        }, c[u]), d);
      else if (process.env.NODE_ENV === "development" && !["drag", "pinch", "scroll", "wheel", "move", "hover"].includes(u)) {
        if (u === "domTarget")
          throw Error("[@use-gesture]: `domTarget` option has been renamed to `target`.");
        console.warn(`[@use-gesture]: Unknown config key \`${u}\` was used. Please read the documentation for further information.`);
      }
    }
  return n;
}
let F6 = class {
  constructor(e, n) {
    Mn(this, "_listeners", /* @__PURE__ */ new Set()), this._ctrl = e, this._gestureKey = n;
  }
  add(e, n, r, o, i) {
    const a = this._listeners, s = Z1e(n, r), l = this._gestureKey ? this._ctrl.config[this._gestureKey].eventOptions : {}, c = Lt(Lt({}, l), i);
    e.addEventListener(s, o, c);
    const u = () => {
      e.removeEventListener(s, o, c), a.delete(u);
    };
    return a.add(u), u;
  }
  clean() {
    this._listeners.forEach((e) => e()), this._listeners.clear();
  }
};
class whe {
  constructor() {
    Mn(this, "_timeouts", /* @__PURE__ */ new Map());
  }
  add(e, n, r = 140, ...o) {
    this.remove(e), this._timeouts.set(e, window.setTimeout(n, r, ...o));
  }
  remove(e) {
    const n = this._timeouts.get(e);
    n && window.clearTimeout(n);
  }
  clean() {
    this._timeouts.forEach((e) => void window.clearTimeout(e)), this._timeouts.clear();
  }
}
class The {
  constructor(e) {
    Mn(this, "gestures", /* @__PURE__ */ new Set()), Mn(this, "_targetEventStore", new F6(this)), Mn(this, "gestureEventStores", {}), Mn(this, "gestureTimeoutStores", {}), Mn(this, "handlers", {}), Mn(this, "config", {}), Mn(this, "pointerIds", /* @__PURE__ */ new Set()), Mn(this, "touchIds", /* @__PURE__ */ new Set()), Mn(this, "state", {
      shared: {
        shiftKey: !1,
        metaKey: !1,
        ctrlKey: !1,
        altKey: !1
      }
    }), bhe(this, e);
  }
  setEventIds(e) {
    if (qf(e))
      return this.touchIds = new Set(j1e(e)), this.touchIds;
    if ("pointerId" in e)
      return e.type === "pointerup" || e.type === "pointercancel" ? this.pointerIds.delete(e.pointerId) : e.type === "pointerdown" && this.pointerIds.add(e.pointerId), this.pointerIds;
  }
  applyHandlers(e, n) {
    this.handlers = e, this.nativeHandlers = n;
  }
  applyConfig(e, n) {
    this.config = She(e, n, this.config);
  }
  clean() {
    this._targetEventStore.clean();
    for (const e of this.gestures)
      this.gestureEventStores[e].clean(), this.gestureTimeoutStores[e].clean();
  }
  effect() {
    return this.config.shared.target && this.bind(), () => this._targetEventStore.clean();
  }
  bind(...e) {
    const n = this.config.shared, r = {};
    let o;
    if (!(n.target && (o = n.target(), !o))) {
      if (n.enabled) {
        for (const a of this.gestures) {
          const s = this.config[a], l = S3(r, s.eventOptions, !!o);
          if (s.enabled) {
            const c = B6.get(a);
            new c(this, e, a).bind(l);
          }
        }
        const i = S3(r, n.eventOptions, !!o);
        for (const a in this.nativeHandlers)
          i(a, "", (s) => this.nativeHandlers[a](Lt(Lt({}, this.state.shared), {}, {
            event: s,
            args: e
          })), void 0, !0);
      }
      for (const i in r)
        r[i] = the(...r[i]);
      if (!o)
        return r;
      for (const i in r) {
        const {
          device: a,
          capture: s,
          passive: l
        } = z1e(i);
        this._targetEventStore.add(o, a, "", r[i], {
          capture: s,
          passive: l
        });
      }
    }
  }
}
function is(t, e) {
  t.gestures.add(e), t.gestureEventStores[e] = new F6(t, e), t.gestureTimeoutStores[e] = new whe();
}
function bhe(t, e) {
  e.drag && is(t, "drag"), e.wheel && is(t, "wheel"), e.scroll && is(t, "scroll"), e.move && is(t, "move"), e.pinch && is(t, "pinch"), e.hover && is(t, "hover");
}
const S3 = (t, e, n) => (r, o, i, a = {}, s = !1) => {
  var l, c;
  const u = (l = a.capture) !== null && l !== void 0 ? l : e.capture, d = (c = a.passive) !== null && c !== void 0 ? c : e.passive;
  let f = s ? r : Y1e(r, o, u);
  n && d && (f += "Passive"), t[f] = t[f] || [], t[f].push(i);
};
function Rhe(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Mhe(t) {
  var e = Rhe(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function Phe(t, e, n) {
  return e = Mhe(e), e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function w3(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ku(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? w3(Object(n), !0).forEach(function(r) {
      Phe(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : w3(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
class V6 {
  constructor(e, n, r, o, i) {
    this._target = e, this._gestureKey = o, this._ctrl = new The(n), this._ctrl.applyHandlers(n, i), this._ctrl.applyConfig(ku(ku({}, r), {}, {
      target: e
    }), o), this._ctrl.effect();
  }
  destroy() {
    this._ctrl.clean();
  }
  setConfig(e) {
    this._ctrl.clean(), this._ctrl.applyConfig(ku(ku({}, e), {}, {
      target: this._target
    }), this._gestureKey), this._ctrl.effect();
  }
}
const H6 = function(e, n, r) {
  return G6(ghe), new V6(e, {
    drag: n
  }, r || {}, "drag");
}, yhe = function(e, n, r) {
  return G6(Ihe), new V6(e, {
    scroll: n
  }, r || {}, "scroll");
};
/**
 *  @license
 *  Copyright 2017 Adam Miskiewicz
 *
 *  Use of this source code is governed by a MIT-style license that can be found
 *  in the LICENSE file or at https://opensource.org/licenses/MIT.
 */
function K1(t, e) {
  if (!t)
    throw new Error(e);
}
function Xr(t, e) {
  return typeof t < "u" && t !== null ? t : e;
}
/**
 *  @license
 *  Copyright 2017 Adam Miskiewicz
 *
 *  Use of this source code is governed by a MIT-style license that can be found
 *  in the LICENSE file or at https://opensource.org/licenses/MIT.
 */
class Sc {
  constructor(e = {}) {
    this._listeners = [], this._currentAnimationStep = 0, this._currentTime = 0, this._springTime = 0, this._currentValue = 0, this._currentVelocity = 0, this._isAnimating = !1, this._oscillationVelocityPairs = [], this._config = {
      fromValue: Xr(e.fromValue, 0),
      toValue: Xr(e.toValue, 1),
      stiffness: Xr(e.stiffness, 100),
      damping: Xr(e.damping, 10),
      mass: Xr(e.mass, 1),
      initialVelocity: Xr(e.initialVelocity, 0),
      overshootClamping: Xr(e.overshootClamping, !1),
      allowsOverdamping: Xr(e.allowsOverdamping, !1),
      restVelocityThreshold: Xr(e.restVelocityThreshold, 1e-3),
      restDisplacementThreshold: Xr(e.restDisplacementThreshold, 1e-3)
    }, this._currentValue = this._config.fromValue, this._currentVelocity = this._config.initialVelocity;
  }
  /**
   * If `fromValue` differs from `toValue`, or `initialVelocity` is non-zero,
   * start the simulation and call the `onStart` listeners.
   */
  start() {
    const { fromValue: e, toValue: n, initialVelocity: r } = this._config;
    return (e !== n || r !== 0) && (this._reset(), this._isAnimating = !0, this._currentAnimationStep || (this._notifyListeners("onStart"), this._currentAnimationStep = requestAnimationFrame((o) => {
      this._step(Date.now());
    }))), this;
  }
  /**
   * If a simulation is in progress, stop it and call the `onStop` listeners.
   */
  stop() {
    return this._isAnimating ? (this._isAnimating = !1, this._notifyListeners("onStop"), this._currentAnimationStep && (cancelAnimationFrame(this._currentAnimationStep), this._currentAnimationStep = 0), this) : this;
  }
  /**
   * The spring's current position.
   */
  get currentValue() {
    return this._currentValue;
  }
  /**
   * The spring's current velocity in units / ms.
   */
  get currentVelocity() {
    return this._currentVelocity;
  }
  /**
   * If the spring has reached its `toValue`, or if its velocity is below the
   * `restVelocityThreshold`, it is considered at rest. If `stop()` is called
   * during a simulation, both `isAnimating` and `isAtRest` will be false.
   */
  get isAtRest() {
    return this._isSpringAtRest();
  }
  /**
   * Whether or not the spring is currently emitting values.
   *
   * Note: this is distinct from whether or not it is at rest.
   * See also `isAtRest`.
   */
  get isAnimating() {
    return this._isAnimating;
  }
  /**
   * Updates the spring config with the given values.  Values not explicitly
   * supplied will be reused from the existing config.
   */
  updateConfig(e) {
    this._advanceSpringToTime(Date.now());
    const n = {
      fromValue: this._currentValue,
      initialVelocity: this._currentVelocity
    };
    return this._config = Object.assign({}, this._config, n, e), this._reset(), this;
  }
  /**
   * The provided callback will be invoked when the simulation begins.
   */
  onStart(e) {
    return this._listeners.push({ onStart: e }), this;
  }
  /**
   * The provided callback will be invoked on each frame while the simulation is
   * running.
   */
  onUpdate(e) {
    return this._listeners.push({ onUpdate: e }), this;
  }
  /**
   * The provided callback will be invoked when the simulation ends.
   */
  onStop(e) {
    return this._listeners.push({ onStop: e }), this;
  }
  /**
   * Remove a single listener from this spring.
   */
  removeListener(e) {
    return this._listeners = this._listeners.reduce((n, r) => (Object.values(r).indexOf(e) !== -1 || n.push(r), n), []), this;
  }
  /**
   * Removes all listeners from this spring.
   */
  removeAllListeners() {
    return this._listeners = [], this;
  }
  _reset() {
    this._currentTime = Date.now(), this._springTime = 0, this._currentValue = this._config.fromValue, this._currentVelocity = this._config.initialVelocity;
  }
  _notifyListeners(e) {
    this._listeners.forEach((n) => {
      const r = n[e];
      typeof r == "function" && r(this);
    });
  }
  /**
   * `_step` is the main loop.  While the animation is running, it updates the
   * current state once per frame, and schedules the next frame if the spring is
   * not yet at rest.
   */
  _step(e) {
    this._advanceSpringToTime(e, !0), this._isAnimating && (this._currentAnimationStep = requestAnimationFrame((n) => this._step(Date.now())));
  }
  _advanceSpringToTime(e, n = !1) {
    if (!this._isAnimating)
      return;
    let r = e - this._currentTime;
    r > Sc.MAX_DELTA_TIME_MS && (r = Sc.MAX_DELTA_TIME_MS), this._springTime += r;
    const o = this._config.damping, i = this._config.mass, a = this._config.stiffness, s = this._config.fromValue, l = this._config.toValue, c = -this._config.initialVelocity;
    K1(i > 0, "Mass value must be greater than 0"), K1(a > 0, "Stiffness value must be greater than 0"), K1(o > 0, "Damping value must be greater than 0");
    let u = o / (2 * Math.sqrt(a * i));
    const d = Math.sqrt(a / i) / 1e3, f = d * Math.sqrt(1 - u * u), h = d * Math.sqrt(u * u - 1), _ = l - s;
    u > 1 && !this._config.allowsOverdamping && (u = 1);
    let E = 0, m = 0;
    const N = this._springTime;
    if (u < 1) {
      const I = Math.exp(-u * d * N);
      E = l - I * ((c + u * d * _) / f * Math.sin(f * N) + _ * Math.cos(f * N)), m = u * d * I * (Math.sin(f * N) * (c + u * d * _) / f + _ * Math.cos(f * N)) - I * (Math.cos(f * N) * (c + u * d * _) - f * _ * Math.sin(f * N));
    } else if (u === 1) {
      const I = Math.exp(-d * N);
      E = l - I * (_ + (c + d * _) * N), m = I * (c * (N * d - 1) + N * _ * (d * d));
    } else {
      const I = Math.exp(-u * d * N);
      E = l - I * ((c + u * d * _) * Math.sinh(h * N) + h * _ * Math.cosh(h * N)) / h, m = I * u * d * (Math.sinh(h * N) * (c + u * d * _) + _ * h * Math.cosh(h * N)) / h - I * (h * Math.cosh(h * N) * (c + u * d * _) + h * h * _ * Math.sinh(h * N)) / h;
    }
    if (this._currentTime = e, this._currentValue = E, this._currentVelocity = m, !!n && (this._notifyListeners("onUpdate"), !!this._isAnimating && (this._isSpringOvershooting() || this._isSpringAtRest()))) {
      a !== 0 && (this._currentValue = l, this._currentVelocity = 0, this._notifyListeners("onUpdate")), this.stop();
      return;
    }
  }
  _isSpringOvershooting() {
    const { stiffness: e, fromValue: n, toValue: r, overshootClamping: o } = this._config;
    let i = !1;
    return o && e !== 0 && (n < r ? i = this._currentValue > r : i = this._currentValue < r), i;
  }
  _isSpringAtRest() {
    const { stiffness: e, toValue: n, restDisplacementThreshold: r, restVelocityThreshold: o } = this._config, i = Math.abs(this._currentVelocity) <= o;
    return e !== 0 && Math.abs(n - this._currentValue) <= r && i;
  }
}
Sc.MAX_DELTA_TIME_MS = 1 / 60 * 1e3 * 4;
const T3 = {
  mass: 0.75,
  damping: 100,
  stiffness: 120,
  initialVelocity: 2
}, Lhe = Ne({
  name: "Drawer",
  props: {
    modelValue: {
      type: Boolean,
      default: !1,
      required: !0
    },
    title: {
      type: String,
      required: !1,
      default: "Drawer Title"
    },
    height: {
      type: String,
      default: "80vh",
      required: !1
    },
    preventScroll: {
      type: Boolean,
      default: !1,
      required: !1
    },
    fullWidth: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  emits: ["closed", "opened", "update:modelValue"],
  setup(t, { emit: e }) {
    const n = W(), r = W(), o = W(), i = W("up"), a = W(!1), s = W(), l = W(), c = W(), u = W(), d = W(), f = W(), h = W(), _ = W(!1), E = Ga(t, "modelValue");
    Zf(E), et(t, async ({ modelValue: y }) => {
      N(y);
    });
    const m = ({ clientHeight: y, scrollHeight: L }) => L > y, N = async (y) => {
      y ? (a.value = !0, await Ln(), e("update:modelValue", !0), e("opened"), I(), C(), p(), b(), T()) : (P(), k(), O());
    };
    et(u, (y) => {
      y > s.value * 0.98 && i.value === "down" && G(), !_.value && y <= s.value * 0.5 && (_.value = !0), _.value && y > s.value * 0.5 && (_.value = !1);
    });
    function I() {
      n.value = document.querySelector(".drawer"), r.value = document.querySelector(".drawer-content"), o.value = document.querySelector(".drawer-header");
    }
    function O() {
      n.value = null, r.value = null, o.value = null;
    }
    function p() {
      i.value = "up", l.value = m(r.value), s.value = n.value.offsetHeight, u.value = s.value;
    }
    function C() {
      c.value = new Sc({
        ...T3,
        fromValue: s.value,
        restDisplacementThreshold: 0.1
      }), c.value.onUpdate((y) => {
        u.value = y.currentValue;
      });
    }
    function D(y, { immediate: L, ...w } = { immediate: !1 }) {
      L ? u.value = y : c.value.updateConfig({
        ...w,
        toValue: y
      }).start();
    }
    function T(y) {
      i.value !== "up" && (i.value = "up"), D(0, { fromValue: y ?? s.value, initialVelocity: 4 });
    }
    function k(y) {
      i.value !== "down" && (i.value = "down"), D(s.value, { fromValue: y ?? u.value, ...T3 });
    }
    function G() {
      a.value = !1, c.value.removeAllListeners(), e("update:modelValue", !1), e("closed");
    }
    function b() {
      if (d.value = new H6(
        // if the .drawer-content element has y overflow (scrollable area), only the .drawer-header element will
        // capture drag gestures. if there's NO overflow the entire .drawer element will capture gestures
        l.value && !t.preventScroll ? o.value : n.value,
        // https://use-gesture.netlify.app/docs/state/
        ({ last: B, down: U, velocity: [K, Z], movement: [X, J], cancel: ae }) => {
          U && c.value.stop(), J < -40 && ae(), B ? J > s.value * 0.5 || Z > 0.6 && J > 0 ? k(u.value) : T(u.value) : D(J, { immediate: !0 });
        },
        {
          // https://use-gesture.netlify.app/docs/options/
          axis: "y",
          from: () => [0, u.value]
        }
      ), !l.value || t.preventScroll)
        return;
      r.value.addEventListener("touchstart", L), r.value.addEventListener("touchend", w);
      const y = 100;
      function L() {
        c.value.stop(), h.value = !0;
      }
      function w() {
        h.value = !1, u.value > y && (f.value.destroy(), k(u.value)), 2 <= u.value && u.value < y && T(u.value);
      }
      const R = 1.6;
      f.value = new yhe(
        r.value,
        ({ xy: [B, U], direction: [K, Z] }) => {
          h.value && Z && U < 10 && D(-U * R, { immediate: !0 });
        },
        {
          axis: "y",
          from: () => [0, u.value]
        }
      );
    }
    function P() {
      d.value && d.value.destroy(), d.value = null, f.value && f.value.destroy(), f.value = null;
    }
    function $() {
      i.value = "up";
    }
    return Rf(n, (y) => {
      const L = y.target;
      L.classList.contains("select-item") || L.closest("[data-tippy-root], footer") || e("update:modelValue", !1);
    }), {
      drawerOpen: a,
      drawerY: u,
      showFooter: _,
      onAfterLeave: $
    };
  },
  components: { ViewBackground: ru, Text: Ye, FocusTrap: P6, Spacer: He }
});
const xhe = {
  key: 0,
  class: "drawer-wrapper"
}, Uhe = { class: "drawer-inner" }, $he = { key: 0 }, khe = {
  key: 0,
  class: "drawer-buttons"
};
function Bhe(t, e, n, r, o, i) {
  const a = ee("ViewBackground"), s = ee("Text"), l = ee("Spacer");
  return v(), te(_f, { to: "body" }, [
    H(a, { active: t.showFooter }, null, 8, ["active"]),
    H(Zt, { onAfterLeave: t.onAfterLeave }, {
      default: q(() => [
        t.drawerOpen ? (v(), A("div", xhe, [
          g("aside", {
            class: "drawer",
            style: Fe({ height: t.height, transform: `translateY(${t.drawerY}px)` })
          }, [
            g("div", Uhe, [
              e[0] || (e[0] = g("div", { class: "drawer-header" }, [
                g("div", { class: "drag-handle" })
              ], -1)),
              g("div", {
                class: z(["drawer-content", { "no-scroll": t.preventScroll }])
              }, [
                g("div", {
                  class: z({ "default-content-width": !t.fullWidth })
                }, [
                  t.title ? (v(), A("div", $he, [
                    H(s, {
                      as: "h3",
                      style: { "line-height": "2.625rem" }
                    }, {
                      default: q(() => [
                        me(Q(t.title), 1)
                      ]),
                      _: 1
                    }),
                    H(l, { height: "2rem" })
                  ])) : V("", !0),
                  ue(t.$slots, "content", {}, void 0, !0)
                ], 2)
              ], 2)
            ])
          ], 4),
          H(Zt, {
            name: "fade-down",
            appear: ""
          }, {
            default: q(() => [
              t.showFooter ? (v(), A("footer", {
                key: 0,
                class: z([{ "has-buttons": t.$slots.buttons }])
              }, [
                t.$slots.buttons ? (v(), A("div", khe, [
                  ue(t.$slots, "buttons", {}, void 0, !0)
                ])) : V("", !0)
              ], 2)) : V("", !0)
            ]),
            _: 3
          })
        ])) : V("", !0)
      ]),
      _: 3
    }, 8, ["onAfterLeave"])
  ]);
}
const Ghe = /* @__PURE__ */ Y(Lhe, [["render", Bhe], ["__scopeId", "data-v-86caf6be"]]), Fhe = Ne({
  name: "Modal",
  props: {
    id: {
      type: String,
      required: !1
    },
    modelValue: {
      type: Boolean,
      default: !1
    },
    drawer: {
      type: Boolean,
      default: !0,
      required: !1
    },
    width: {
      type: String,
      required: !1,
      default: "520px"
    },
    title: {
      type: String,
      required: !1,
      default: "Modal Title"
    },
    noInnerContentShadow: {
      type: Boolean,
      required: !1,
      default: !1
    },
    noPadding: {
      type: Boolean,
      required: !1,
      default: !1
    },
    containerClass: {
      type: String,
      required: !1
    },
    closeButton: {
      type: Boolean,
      required: !1,
      default: !0
    },
    drawerOptions: {
      type: Object
    }
  },
  emits: ["closed", "opened", "update:modelValue"],
  setup(t, { emit: e }) {
    const { aboveMobile: n } = Io(), r = x(() => t.drawer && !n.value), o = x(() => {
      const { drawer: l, drawerOptions: c, ...u } = t;
      return r.value ? {
        title: t.title,
        ...c
      } : {
        ...u
      };
    });
    function i(l) {
      e("update:modelValue", l);
    }
    function a() {
      e("closed");
    }
    function s() {
      e("opened");
    }
    return { updateModelValue: i, closedModal: a, openedModal: s, showDrawer: r, componentProps: o };
  },
  components: { ModalView: k1e, Drawer: Ghe }
});
function Vhe(t, e, n, r, o, i) {
  return v(), te(zo(t.showDrawer ? "drawer" : "modal-view"), Tt({
    "model-value": t.modelValue,
    "onUpdate:modelValue": e[0] || (e[0] = (a) => t.updateModelValue(a)),
    onClosed: t.closedModal,
    onOpened: t.openedModal
  }, { ...t.componentProps }), K_({ _: 2 }, [
    t.$slots.title ? {
      name: "title",
      fn: q(() => [
        ue(t.$slots, "title")
      ]),
      key: "0"
    } : void 0,
    t.$slots.header ? {
      name: "header",
      fn: q(() => [
        ue(t.$slots, "header")
      ]),
      key: "1"
    } : void 0,
    t.$slots["modal-top-right"] ? {
      name: "modal-top-right",
      fn: q(() => [
        ue(t.$slots, "modal-top-right")
      ]),
      key: "2"
    } : void 0,
    t.$slots.content ? {
      name: "content",
      fn: q(() => [
        ue(t.$slots, "content")
      ]),
      key: "3"
    } : void 0,
    t.$slots.buttons ? {
      name: "buttons",
      fn: q(() => [
        ue(t.$slots, "buttons")
      ]),
      key: "4"
    } : void 0
  ]), 1040, ["model-value", "onClosed", "onOpened"]);
}
const Hhe = /* @__PURE__ */ Y(Fhe, [["render", Vhe]]), Whe = Ne({
  name: "VisibilityWrapper",
  props: {
    threshold: {
      type: Number,
      required: !1,
      default: 0.7
    }
  },
  emits: ["visibility-change"],
  setup(t, { emit: e }) {
    const n = W();
    return s5(
      n,
      ([{ isIntersecting: r }]) => e("visibility-change", r),
      {
        threshold: t.threshold
      }
    ), {
      visibilityWrapper: n
    };
  }
}), Yhe = { ref: "visibilityWrapper" };
function Khe(t, e, n, r, o, i) {
  return v(), A("div", Yhe, [
    ue(t.$slots, "default")
  ], 512);
}
const zhe = /* @__PURE__ */ Y(Whe, [["render", Khe]]), Zhe = Ne({
  name: "Skeleton",
  components: {
    VisibilityWrapper: zhe
  },
  props: {
    width: {
      type: [Number, String],
      default: 128,
      required: !1
    },
    height: {
      type: [Number, String],
      default: 16,
      required: !1
    },
    color: {
      type: String,
      default: "#006dff",
      required: !1
    }
  },
  setup() {
    const t = W(!0);
    return { onVisibilityChange: (n) => t.value = n, isVisible: t };
  }
});
function qhe(t, e, n, r, o, i) {
  const a = ee("VisibilityWrapper");
  return v(), te(a, { onVisibilityChange: t.onVisibilityChange }, {
    default: q(() => [
      g("div", {
        style: Fe({
          width: typeof t.width == "number" ? t.width + "px" : t.width,
          height: typeof t.height == "number" ? t.height + "px" : t.height
        }),
        class: z(["skeleton", { visible: t.isVisible }])
      }, [
        ue(t.$slots, "default", {}, void 0, !0)
      ], 6)
    ]),
    _: 3
  }, 8, ["onVisibilityChange"]);
}
const sa = /* @__PURE__ */ Y(Zhe, [["render", qhe], ["__scopeId", "data-v-a59a6a4e"]]), Xhe = { key: 0 }, jhe = { class: "section-title" }, Jhe = {
  key: 0,
  class: "header-content-container"
}, Qhe = { key: 1 }, e0e = { class: "section-title" }, t0e = { class: "section-header-content" }, n0e = /* @__PURE__ */ Ne({
  __name: "Section",
  props: {
    title: {},
    group: { type: Boolean, default: !1 },
    items: {},
    contentMaxWidth: { default: "100%" },
    contentBorderRadius: { default: "0.75rem" },
    outerShadow: { type: Boolean, default: !0 },
    innerShadow: { type: Boolean, default: !0 },
    skeleton: { type: Boolean, default: !1 }
  },
  setup(t) {
    return (e, n) => (v(), A("div", {
      class: z(["section-wrapper", { "container-shadow": t.outerShadow }, { group: t.group }])
    }, [
      t.group ? (v(), A("div", Xhe, [
        (v(!0), A(ge, null, ye(t.items, (r) => (v(), A("div", {
          key: r.id,
          class: "group-section"
        }, [
          g("div", jhe, [
            g("div", null, [
              t.skeleton ? (v(), te(sa, {
                key: 0,
                height: 30,
                width: 144
              })) : (v(), te(Ye, {
                key: 1,
                as: "h4",
                weight: "600",
                size: "f-4",
                style: { "letter-spacing": "-0.0375rem" }
              }, {
                default: q(() => [
                  me(Q(r.title), 1)
                ]),
                _: 2
              }, 1024))
            ]),
            e.$slots[`${r.id}-header-content`] ? (v(), A("div", Jhe, [
              ue(e.$slots, `${r.id}-header-content`, {}, void 0, !0)
            ])) : V("", !0)
          ]),
          g("div", {
            class: z(["section-content", { "container-shadow": r.innerShadow }]),
            style: Fe({
              "max-width": r.contentMaxWidth ? `${r.contentMaxWidth}px` : "100%",
              "border-radius": t.contentBorderRadius
            })
          }, [
            e.$slots[`${r.id}-content`] ? ue(e.$slots, `${r.id}-content`, { key: 0 }, void 0, !0) : V("", !0)
          ], 6)
        ]))), 128))
      ])) : (v(), A("div", Qhe, [
        g("div", e0e, [
          g("div", null, [
            t.skeleton ? (v(), te(sa, {
              key: 0,
              height: 30,
              width: 144
            })) : (v(), te(Ye, {
              key: 1,
              as: "h4",
              weight: "600",
              size: "f-4",
              style: { "letter-spacing": "-0.0375rem" }
            }, {
              default: q(() => [
                me(Q(t.title), 1)
              ]),
              _: 1
            }))
          ]),
          g("div", t0e, [
            e.$slots["header-content"] ? ue(e.$slots, "header-content", { key: 0 }, void 0, !0) : V("", !0)
          ])
        ]),
        g("div", {
          class: z(["section-content", { "container-shadow": t.innerShadow }]),
          style: Fe({
            "max-width": t.contentMaxWidth ? `${t.contentMaxWidth}px` : "100%",
            "border-radius": t.contentBorderRadius
          })
        }, [
          e.$slots.content ? ue(e.$slots, "content", { key: 0 }, void 0, !0) : V("", !0)
        ], 6)
      ]))
    ], 2));
  }
});
const uPe = /* @__PURE__ */ Y(n0e, [["__scopeId", "data-v-79d6c638"]]);
function r0e(t, e, n, r, o) {
  return r + (o - r) * ((t - e) / (n - e));
}
function wp(t) {
  return typeof t == "number";
}
function b3(t) {
  return typeof t == "string";
}
function P0(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function o0e(t) {
  return Array.isArray(t);
}
function R3(t) {
  return P0(t) || o0e(t);
}
function $t(t) {
  return Math.abs(t);
}
function Tp(t) {
  return t ? t / $t(t) : 0;
}
function $l(t, e) {
  return $t(t - e);
}
function i0e(t, e) {
  if (t === 0 || e === 0 || $t(t) <= $t(e))
    return 0;
  var n = $l($t(t), $t(e));
  return $t(n / t);
}
function a0e(t) {
  var e = Math.pow(10, t);
  return function(n) {
    return Math.round(n * e) / e;
  };
}
function wc(t) {
  return _a(t).map(Number);
}
function Fo(t) {
  return t[Xf(t)];
}
function Xf(t) {
  return Math.max(0, t.length - 1);
}
function _a(t) {
  return Object.keys(t);
}
function W6(t, e) {
  return [t, e].reduce(function(n, r) {
    return _a(r).forEach(function(o) {
      var i = n[o], a = r[o], s = P0(i) && P0(a);
      n[o] = s ? W6(i, a) : a;
    }), n;
  }, {});
}
function Y6(t, e) {
  var n = _a(t), r = _a(e);
  return n.length !== r.length ? !1 : n.every(function(o) {
    var i = t[o], a = e[o];
    return typeof i == "function" ? "".concat(i) === "".concat(a) : !R3(i) || !R3(a) ? i === a : Y6(i, a);
  });
}
function s0e(t, e) {
  var n = {
    start: r,
    center: o,
    end: i
  };
  function r() {
    return 0;
  }
  function o(c) {
    return i(c) / 2;
  }
  function i(c) {
    return e - c;
  }
  function a() {
    return e * Number(t);
  }
  function s(c) {
    return wp(t) ? a() : n[t](c);
  }
  var l = {
    measure: s
  };
  return l;
}
function l0e(t) {
  var e = 0;
  function n(a, s) {
    return function() {
      a === !!e && s();
    };
  }
  function r() {
    e = window.requestAnimationFrame(t);
  }
  function o() {
    window.cancelAnimationFrame(e), e = 0;
  }
  var i = {
    proceed: n(!0, r),
    start: n(!1, r),
    stop: n(!0, o)
  };
  return i;
}
function c0e(t, e) {
  var n = t === "y" ? "y" : "x", r = t === "y" ? "x" : "y", o = s(), i = l();
  function a(u) {
    var d = u.width, f = u.height;
    return n === "x" ? d : f;
  }
  function s() {
    return n === "y" ? "top" : e === "rtl" ? "right" : "left";
  }
  function l() {
    return n === "y" ? "bottom" : e === "rtl" ? "left" : "right";
  }
  var c = {
    scroll: n,
    cross: r,
    startEdge: o,
    endEdge: i,
    measureSize: a
  };
  return c;
}
function Ws(t, e) {
  var n = $t(t - e);
  function r(c) {
    return c < t;
  }
  function o(c) {
    return c > e;
  }
  function i(c) {
    return r(c) || o(c);
  }
  function a(c) {
    return i(c) ? r(c) ? t : e : c;
  }
  function s(c) {
    return n ? c - n * Math.ceil((c - e) / n) : c;
  }
  var l = {
    length: n,
    max: e,
    min: t,
    constrain: a,
    reachedAny: i,
    reachedMax: o,
    reachedMin: r,
    removeOffset: s
  };
  return l;
}
function K6(t, e, n) {
  var r = Ws(0, t), o = r.min, i = r.constrain, a = t + 1, s = l(e);
  function l(_) {
    return n ? $t((a + _) % a) : i(_);
  }
  function c() {
    return s;
  }
  function u(_) {
    return s = l(_), h;
  }
  function d(_) {
    return u(c() + _);
  }
  function f() {
    return K6(t, c(), n);
  }
  var h = {
    add: d,
    clone: f,
    get: c,
    set: u,
    min: o,
    max: t
  };
  return h;
}
function u0e(t) {
  var e = t === "rtl" ? -1 : 1;
  function n(o) {
    return o * e;
  }
  var r = {
    apply: n
  };
  return r;
}
function Hd() {
  var t = [];
  function e(o, i, a, s) {
    return s === void 0 && (s = {
      passive: !0
    }), o.addEventListener(i, a, s), t.push(function() {
      return o.removeEventListener(i, a, s);
    }), r;
  }
  function n() {
    return t = t.filter(function(o) {
      return o();
    }), r;
  }
  var r = {
    add: e,
    removeAll: n
  };
  return r;
}
function Oi(t) {
  var e = t;
  function n() {
    return e;
  }
  function r(d) {
    return e = c(d), u;
  }
  function o(d) {
    return e += c(d), u;
  }
  function i(d) {
    return e -= c(d), u;
  }
  function a(d) {
    return e *= d, u;
  }
  function s(d) {
    return e /= d, u;
  }
  function l() {
    return e !== 0 && s(e), u;
  }
  function c(d) {
    return wp(d) ? d : d.get();
  }
  var u = {
    add: o,
    divide: s,
    get: n,
    multiply: a,
    normalize: l,
    set: r,
    subtract: i
  };
  return u;
}
function d0e(t, e, n, r, o, i, a, s, l, c, u, d, f, h, _, E) {
  var m = t.cross, N = ["INPUT", "SELECT", "TEXTAREA"], I = {
    passive: !1
  }, O = Oi(0), p = Hd(), C = Hd(), D = f.measure(20), T = {
    mouse: 300,
    touch: 400
  }, k = {
    mouse: 500,
    touch: 600
  }, G = _ ? 5 : 16, b = 1, P = 0, $ = 0, y = !1, L = !1, w = !1, R = !1;
  function B() {
    var ce = n;
    p.add(ce, "dragstart", function(Se) {
      return Se.preventDefault();
    }, I).add(ce, "touchmove", function() {
    }, I).add(ce, "touchend", function() {
    }).add(ce, "touchstart", ae).add(ce, "mousedown", ae).add(ce, "touchcancel", j).add(ce, "contextmenu", j).add(ce, "click", ne, !0);
  }
  function U() {
    var ce = R ? document : n;
    C.add(ce, "touchmove", re, I).add(ce, "touchend", j).add(ce, "mousemove", re, I).add(ce, "mouseup", j);
  }
  function K() {
    p.removeAll(), C.removeAll();
  }
  function Z(ce) {
    var Se = ce.nodeName || "";
    return N.indexOf(Se) > -1;
  }
  function X() {
    var ce = _ ? k : T, Se = R ? "mouse" : "touch";
    return ce[Se];
  }
  function J(ce, Se) {
    var se = u.clone().add(Tp(ce) * -1), Ie = se.get() === u.min || se.get() === u.max, we = c.byDistance(ce, !_).distance;
    return _ || $t(ce) < D ? we : !h && Ie ? we * 0.4 : E && Se ? we * 0.5 : c.byIndex(se.get(), 0).distance;
  }
  function ae(ce) {
    if (R = !o.isTouchEvent(ce), !(R && ce.button !== 0) && !Z(ce.target)) {
      var Se = $l(r.get(), i.get()) >= 2, se = R || !Se;
      y = !0, o.pointerDown(ce), O.set(r), r.set(i), l.useBaseMass().useSpeed(80), U(), P = o.readPoint(ce), $ = o.readPoint(ce, m), d.emit("pointerDown"), se && (w = !1);
    }
  }
  function re(ce) {
    if (!L && !R) {
      if (!ce.cancelable)
        return j(ce);
      var Se = o.readPoint(ce), se = o.readPoint(ce, m), Ie = $l(Se, P), we = $l(se, $);
      if (L = Ie > we, !L && !w)
        return j(ce);
    }
    var le = o.pointerMove(ce);
    !w && le && (w = !0), a.start(), r.add(e.apply(le)), ce.preventDefault();
  }
  function j(ce) {
    var Se = c.byDistance(0, !1), se = Se.index !== u.get(), Ie = o.pointerUp(ce) * X(), we = J(e.apply(Ie), se), le = i0e(Ie, we), De = $l(r.get(), O.get()) >= 0.5, pe = se && le > 0.75, Le = $t(Ie) < D, ze = pe ? 10 : G, Xe = pe ? b + 2.5 * le : b;
    De && !R && (w = !0), L = !1, y = !1, C.removeAll(), l.useSpeed(Le ? 9 : ze).useMass(Xe), s.distance(we, !_), R = !1, d.emit("pointerUp");
  }
  function ne(ce) {
    w && (ce.stopPropagation(), ce.preventDefault());
  }
  function Ee() {
    return !w;
  }
  function fe() {
    return y;
  }
  var Oe = {
    addActivationEvents: B,
    clickAllowed: Ee,
    pointerDown: fe,
    removeAllEvents: K
  };
  return Oe;
}
function f0e(t) {
  var e = 170, n, r;
  function o(d) {
    return typeof TouchEvent < "u" && d instanceof TouchEvent;
  }
  function i(d) {
    return d.timeStamp;
  }
  function a(d, f) {
    var h = f || t.scroll, _ = "client".concat(h === "x" ? "X" : "Y");
    return (o(d) ? d.touches[0] : d)[_];
  }
  function s(d) {
    return n = d, r = d, a(d);
  }
  function l(d) {
    var f = a(d) - a(r), h = i(d) - i(n) > e;
    return r = d, h && (n = d), f;
  }
  function c(d) {
    if (!n || !r)
      return 0;
    var f = a(r) - a(n), h = i(d) - i(n), _ = i(d) - i(r) > e, E = f / h, m = h && !_ && $t(E) > 0.1;
    return m ? E : 0;
  }
  var u = {
    isTouchEvent: o,
    pointerDown: s,
    pointerMove: l,
    pointerUp: c,
    readPoint: a
  };
  return u;
}
function h0e(t) {
  function e(r) {
    return t * (r / 100);
  }
  var n = {
    measure: e
  };
  return n;
}
function _0e(t, e, n) {
  var r = a0e(2), o = Oi(0), i = Oi(0), a = Oi(0), s = 0, l = e, c = n;
  function u() {
    o.add(i), t.add(o), i.multiply(0);
  }
  function d(p) {
    p.divide(c), i.add(p);
  }
  function f(p) {
    a.set(p).subtract(t);
    var C = r0e(a.get(), 0, 100, 0, l);
    return s = Tp(a.get()), a.normalize().multiply(C).subtract(o), d(a), O;
  }
  function h(p) {
    var C = p.get() - t.get(), D = !r(C);
    return D && t.set(p), D;
  }
  function _() {
    return s;
  }
  function E() {
    return N(e);
  }
  function m() {
    return I(n);
  }
  function N(p) {
    return l = p, O;
  }
  function I(p) {
    return c = p, O;
  }
  var O = {
    direction: _,
    seek: f,
    settle: h,
    update: u,
    useBaseMass: m,
    useBaseSpeed: E,
    useMass: I,
    useSpeed: N
  };
  return O;
}
function E0e(t, e, n, r, o) {
  var i = o.measure(10), a = o.measure(50), s = 0.85, l = !1;
  function c() {
    return !(l || !t.reachedAny(n.get()) || !t.reachedAny(e.get()));
  }
  function u(h) {
    if (c()) {
      var _ = t.reachedMin(e.get()) ? "min" : "max", E = $t(t[_] - e.get()), m = n.get() - e.get(), N = Math.min(E / a, s);
      n.subtract(m * N), !h && $t(m) < i && (n.set(t.constrain(n.get())), r.useSpeed(10).useMass(3));
    }
  }
  function d(h) {
    l = !h;
  }
  var f = {
    constrain: u,
    toggleActive: d
  };
  return f;
}
function p0e(t, e, n, r) {
  var o = Ws(-e + t, n[0]), i = n.map(o.constrain), a = l();
  function s() {
    var u = i[0], d = Fo(i), f = i.lastIndexOf(u), h = i.indexOf(d) + 1;
    return Ws(f, h);
  }
  function l() {
    if (e <= t)
      return [o.max];
    if (r === "keepSnaps")
      return i;
    var u = s(), d = u.min, f = u.max;
    return i.slice(d, f);
  }
  var c = {
    snapsContained: a
  };
  return c;
}
function m0e(t, e, n) {
  var r = o();
  function o() {
    var a = e[0], s = Fo(e), l = n ? a - t : s, c = a;
    return Ws(l, c);
  }
  var i = {
    limit: r
  };
  return i;
}
function N0e(t, e, n, r) {
  var o = 0.1, i = e.min + o, a = e.max + o, s = Ws(i, a), l = s.reachedMin, c = s.reachedMax;
  function u(h) {
    return h === 1 ? c(n.get()) : h === -1 ? l(n.get()) : !1;
  }
  function d(h) {
    if (u(h)) {
      var _ = t * (h * -1);
      r.forEach(function(E) {
        return E.add(_);
      });
    }
  }
  var f = {
    loop: d
  };
  return f;
}
function v0e(t) {
  var e = t.max, n = t.length;
  function r(i) {
    var a = i - e;
    return a / -n;
  }
  var o = {
    get: r
  };
  return o;
}
function g0e(t, e, n, r, o, i, a) {
  var s = t.startEdge, l = t.endEdge, c = i.groupSlides, u = h().map(e.measure), d = _(), f = E();
  function h() {
    return c(r).map(function(N) {
      return Fo(N)[l] - N[0][s];
    }).map($t);
  }
  function _() {
    return r.map(function(N) {
      return n[s] - N[s];
    }).map(function(N) {
      return -$t(N);
    });
  }
  function E() {
    var N = 0, I = Fo(d) - Fo(o);
    return c(d).map(function(O) {
      return O[0];
    }).map(function(O, p, C) {
      var D = !p, T = p === Xf(C);
      return a && D ? N : a && T ? I : O + u[p];
    });
  }
  var m = {
    snaps: d,
    snapsAligned: f
  };
  return m;
}
function I0e(t, e, n, r, o) {
  var i = r.reachedAny, a = r.removeOffset, s = r.constrain;
  function l(_) {
    return _.concat().sort(function(E, m) {
      return $t(E) - $t(m);
    })[0];
  }
  function c(_) {
    var E = t ? a(_) : s(_), m = e.map(function(I) {
      return I - E;
    }).map(function(I) {
      return u(I, 0);
    }).map(function(I, O) {
      return {
        diff: I,
        index: O
      };
    }).sort(function(I, O) {
      return $t(I.diff) - $t(O.diff);
    }), N = m[0].index;
    return {
      index: N,
      distance: E
    };
  }
  function u(_, E) {
    var m = [_, _ + n, _ - n];
    if (!t)
      return m[0];
    if (!E)
      return l(m);
    var N = m.filter(function(I) {
      return Tp(I) === E;
    });
    return l(N);
  }
  function d(_, E) {
    var m = e[_] - o.get(), N = u(m, E);
    return {
      index: _,
      distance: N
    };
  }
  function f(_, E) {
    var m = o.get() + _, N = c(m), I = N.index, O = N.distance, p = !t && i(m);
    if (!E || p)
      return {
        index: I,
        distance: _
      };
    var C = e[I] - O, D = _ + u(C, 0);
    return {
      index: I,
      distance: D
    };
  }
  var h = {
    byDistance: f,
    byIndex: d,
    shortcut: u
  };
  return h;
}
function O0e(t, e, n, r, o, i) {
  function a(u) {
    var d = u.distance, f = u.index !== e.get();
    d && (t.start(), o.add(d)), f && (n.set(e.get()), e.set(u.index), i.emit("select"));
  }
  function s(u, d) {
    var f = r.byDistance(u, d);
    a(f);
  }
  function l(u, d) {
    var f = e.clone().set(u), h = r.byIndex(f.get(), d);
    a(h);
  }
  var c = {
    distance: s,
    index: l
  };
  return c;
}
function z6(t, e, n) {
  var r = t.scroll === "x" ? a : s, o = n.style, i = !1;
  function a(f) {
    return "translate3d(".concat(f, "px,0px,0px)");
  }
  function s(f) {
    return "translate3d(0px,".concat(f, "px,0px)");
  }
  function l(f) {
    i || (o.transform = r(e.apply(f.get())));
  }
  function c(f) {
    i = !f;
  }
  function u() {
    i || (o.transform = "", n.getAttribute("style") || n.removeAttribute("style"));
  }
  var d = {
    clear: u,
    to: l,
    toggleActive: c
  };
  return d;
}
function A0e(t, e, n, r, o, i, a, s, l) {
  var c = wc(o), u = wc(o).reverse(), d = E().concat(m());
  function f(C, D) {
    return C.reduce(function(T, k) {
      return T - o[k];
    }, D);
  }
  function h(C, D) {
    return C.reduce(function(T, k) {
      var G = f(T, D);
      return G > 0 ? T.concat([k]) : T;
    }, []);
  }
  function _(C, D) {
    var T = D === "start", k = T ? -r : r, G = a.findSlideBounds([k]);
    return C.map(function(b) {
      var P = T ? 0 : -r, $ = T ? r : 0, y = G.filter(function(K) {
        return K.index === b;
      })[0], L = y[T ? "end" : "start"], w = Oi(-1), R = Oi(-1), B = z6(t, e, l[b]), U = function() {
        return w.set(s.get() > L ? P : $);
      };
      return {
        index: b,
        location: R,
        translate: B,
        target: U
      };
    });
  }
  function E() {
    var C = i[0] - 1, D = h(u, C);
    return _(D, "end");
  }
  function m() {
    var C = n - i[0] - 1, D = h(c, C);
    return _(D, "start");
  }
  function N() {
    return d.every(function(C) {
      var D = C.index, T = c.filter(function(k) {
        return k !== D;
      });
      return f(T, n) <= 0.1;
    });
  }
  function I() {
    d.forEach(function(C) {
      var D = C.target, T = C.translate, k = C.location, G = D();
      G.get() !== k.get() && (G.get() === 0 ? T.clear() : T.to(G), k.set(G));
    });
  }
  function O() {
    d.forEach(function(C) {
      return C.translate.clear();
    });
  }
  var p = {
    canLoop: N,
    clear: O,
    loop: I,
    loopPoints: d
  };
  return p;
}
function D0e(t, e, n, r, o, i, a) {
  var s = o.removeOffset, l = o.constrain, c = 0.5, u = i ? [0, e, -e] : [0], d = h(u, a);
  function f(m) {
    var N = m || 0;
    return n.map(function(I) {
      var O = Ws(c, I - c);
      return O.constrain(I * N);
    });
  }
  function h(m, N) {
    var I = m || u, O = f(N);
    return I.reduce(function(p, C) {
      var D = r.map(function(T, k) {
        return {
          start: T - n[k] + O[k] + C,
          end: T + t - O[k] + C,
          index: k
        };
      });
      return p.concat(D);
    }, []);
  }
  function _(m, N) {
    var I = i ? s(m) : l(m), O = N || d;
    return O.reduce(function(p, C) {
      var D = C.index, T = C.start, k = C.end, G = p.indexOf(D) !== -1, b = T < I && k > I;
      return !G && b ? p.concat([D]) : p;
    }, []);
  }
  var E = {
    check: _,
    findSlideBounds: h
  };
  return E;
}
function C0e(t, e, n, r, o) {
  var i = t.measureSize, a = t.startEdge, s = t.endEdge, l = n[0] && o, c = h(), u = _(), d = n.map(i), f = E();
  function h() {
    if (!l)
      return 0;
    var N = n[0];
    return $t(e[a] - N[a]);
  }
  function _() {
    if (!l)
      return 0;
    var N = window.getComputedStyle(Fo(r));
    return parseFloat(N.getPropertyValue("margin-".concat(s)));
  }
  function E() {
    return n.map(function(N, I, O) {
      var p = !I, C = I === Xf(O);
      return p ? d[I] + c : C ? d[I] + u : O[I + 1][a] - N[a];
    }).map($t);
  }
  var m = {
    slideSizes: d,
    slideSizesWithGaps: f
  };
  return m;
}
function S0e(t, e, n) {
  var r = wp(n);
  function o(l, c) {
    return wc(l).filter(function(u) {
      return u % c === 0;
    }).map(function(u) {
      return l.slice(u, u + c);
    });
  }
  function i(l) {
    return wc(l).reduce(function(c, u) {
      var d = e.slice(Fo(c), u + 1), f = d.reduce(function(h, _) {
        return h + _;
      }, 0);
      return !u || f > t ? c.concat(u) : c;
    }, []).map(function(c, u, d) {
      return l.slice(c, d[u + 1]);
    });
  }
  function a(l) {
    return r ? o(l, n) : i(l);
  }
  var s = {
    groupSlides: a
  };
  return s;
}
function w0e(t, e, n, r, o) {
  var i = r.align, a = r.axis, s = r.direction, l = r.startIndex, c = r.inViewThreshold, u = r.loop, d = r.speed, f = r.dragFree, h = r.slidesToScroll, _ = r.skipSnaps, E = r.containScroll, m = e.getBoundingClientRect(), N = n.map(function(we) {
    return we.getBoundingClientRect();
  }), I = u0e(s), O = c0e(a, s), p = O.measureSize(m), C = h0e(p), D = s0e(i, p), T = !u && E !== "", k = u || E !== "", G = C0e(O, m, N, n, k), b = G.slideSizes, P = G.slideSizesWithGaps, $ = S0e(p, P, h), y = g0e(O, D, m, N, P, $, T), L = y.snaps, w = y.snapsAligned, R = -Fo(L) + Fo(P), B = p0e(p, R, w, E).snapsContained, U = T ? B : w, K = m0e(R, U, u).limit, Z = K6(Xf(U), l, u), X = Z.clone(), J = wc(n), ae = function() {
    u || Ie.scrollBounds.constrain(Ie.dragHandler.pointerDown()), Ie.scrollBody.seek(Ee).update();
    var we = Ie.scrollBody.settle(Ee);
    we && !Ie.dragHandler.pointerDown() && (Ie.animation.stop(), o.emit("settle")), we || o.emit("scroll"), u && (Ie.scrollLooper.loop(Ie.scrollBody.direction()), Ie.slideLooper.loop()), Ie.translate.to(ne), Ie.animation.proceed();
  }, re = l0e(ae), j = U[Z.get()], ne = Oi(j), Ee = Oi(j), fe = _0e(ne, d, 1), Oe = I0e(u, U, R, K, Ee), ce = O0e(re, Z, X, Oe, Ee, o), Se = D0e(p, R, b, L, K, u, c), se = d0e(O, I, t, Ee, f0e(O), ne, re, ce, fe, Oe, Z, o, C, u, f, _), Ie = {
    containerRect: m,
    slideRects: N,
    animation: re,
    axis: O,
    direction: I,
    dragHandler: se,
    eventStore: Hd(),
    percentOfView: C,
    index: Z,
    indexPrevious: X,
    limit: K,
    location: ne,
    options: r,
    scrollBody: fe,
    scrollBounds: E0e(K, ne, Ee, fe, C),
    scrollLooper: N0e(R, K, ne, [ne, Ee]),
    scrollProgress: v0e(K),
    scrollSnaps: U,
    scrollTarget: Oe,
    scrollTo: ce,
    slideLooper: A0e(O, I, p, R, P, U, Se, ne, n),
    slidesToScroll: $,
    slidesInView: Se,
    slideIndexes: J,
    target: Ee,
    translate: z6(O, I, e)
  };
  return Ie;
}
function T0e() {
  var t = {};
  function e(a) {
    return t[a] || [];
  }
  function n(a) {
    return e(a).forEach(function(s) {
      return s(a);
    }), i;
  }
  function r(a, s) {
    return t[a] = e(a).concat([s]), i;
  }
  function o(a, s) {
    return t[a] = e(a).filter(function(l) {
      return l !== s;
    }), i;
  }
  var i = {
    emit: n,
    off: o,
    on: r
  };
  return i;
}
var b0e = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "",
  direction: "ltr",
  slidesToScroll: 1,
  breakpoints: {},
  dragFree: !1,
  draggable: !0,
  inViewThreshold: 0,
  loop: !1,
  skipSnaps: !1,
  speed: 10,
  startIndex: 0,
  active: !0
};
function bp() {
  function t(o, i) {
    return W6(o, i || {});
  }
  function e(o, i) {
    var a = JSON.stringify(_a(o.breakpoints || {})), s = JSON.stringify(_a(i.breakpoints || {}));
    return a !== s ? !1 : Y6(o, i);
  }
  function n(o) {
    var i = o.breakpoints || {}, a = _a(i).filter(function(s) {
      return window.matchMedia(s).matches;
    }).map(function(s) {
      return i[s];
    }).reduce(function(s, l) {
      return t(s, l);
    }, {});
    return t(o, a);
  }
  var r = {
    merge: t,
    areEqual: e,
    atMedia: n
  };
  return r;
}
function R0e() {
  var t = bp(), e = t.atMedia, n = t.areEqual, r = [], o = [];
  function i() {
    return o.some(function(u) {
      return u();
    });
  }
  function a(u) {
    var d = e(u.options);
    return function() {
      return !n(d, e(u.options));
    };
  }
  function s(u, d) {
    return o = u.map(a), r = u.filter(function(f) {
      return e(f.options).active;
    }), r.forEach(function(f) {
      return f.init(d);
    }), u.reduce(function(f, h) {
      var _;
      return Object.assign(f, (_ = {}, _[h.name] = h, _));
    }, {});
  }
  function l() {
    r = r.filter(function(u) {
      return u.destroy();
    });
  }
  var c = {
    init: s,
    destroy: l,
    haveChanged: i
  };
  return c;
}
function du(t, e, n) {
  var r = Hd(), o = bp(), i = R0e(), a = T0e(), s = a.on, l = a.off, c = C, u = !1, d, f = o.merge(b0e, du.globalOptions), h = o.merge(f), _ = [], E, m = 0, N, I;
  function O() {
    var Ee = h.container, fe = h.slides, Oe = b3(Ee) ? t.querySelector(Ee) : Ee;
    N = Oe || t.children[0];
    var ce = b3(fe) ? N.querySelectorAll(fe) : fe;
    I = [].slice.call(ce || N.children);
  }
  function p(Ee, fe) {
    if (!u) {
      if (f = o.merge(f, Ee), h = o.atMedia(f), O(), d = w0e(t, N, I, h, a), m = d.axis.measureSize(t.getBoundingClientRect()), !h.active)
        return D();
      if (d.translate.to(d.location), _ = fe || _, E = i.init(_, ne), h.loop) {
        if (!d.slideLooper.canLoop()) {
          D(), p({
            loop: !1
          }, fe), f = o.merge(f, {
            loop: !0
          });
          return;
        }
        d.slideLooper.loop();
      }
      h.draggable && N.offsetParent && I.length && d.dragHandler.addActivationEvents();
    }
  }
  function C(Ee, fe) {
    var Oe = U();
    D(), p(o.merge({
      startIndex: Oe
    }, Ee), fe), a.emit("reInit");
  }
  function D() {
    d.dragHandler.removeAllEvents(), d.animation.stop(), d.eventStore.removeAll(), d.translate.clear(), d.slideLooper.clear(), i.destroy();
  }
  function T() {
    u || (u = !0, r.removeAll(), D(), a.emit("destroy"));
  }
  function k() {
    var Ee = o.atMedia(f), fe = !o.areEqual(Ee, h), Oe = d.axis.measureSize(t.getBoundingClientRect()), ce = m !== Oe, Se = i.haveChanged();
    (ce || fe || Se) && C(), a.emit("resize");
  }
  function G(Ee) {
    var fe = d[Ee ? "target" : "location"].get(), Oe = h.loop ? "removeOffset" : "constrain";
    return d.slidesInView.check(d.limit[Oe](fe));
  }
  function b(Ee) {
    var fe = G(Ee);
    return d.slideIndexes.filter(function(Oe) {
      return fe.indexOf(Oe) === -1;
    });
  }
  function P(Ee, fe, Oe) {
    !h.active || u || (d.scrollBody.useBaseMass().useSpeed(fe ? 100 : h.speed), d.scrollTo.index(Ee, Oe || 0));
  }
  function $(Ee) {
    var fe = d.index.clone().add(1);
    P(fe.get(), Ee === !0, -1);
  }
  function y(Ee) {
    var fe = d.index.clone().add(-1);
    P(fe.get(), Ee === !0, 1);
  }
  function L() {
    var Ee = d.index.clone().add(1);
    return Ee.get() !== U();
  }
  function w() {
    var Ee = d.index.clone().add(-1);
    return Ee.get() !== U();
  }
  function R() {
    return d.scrollSnaps.map(d.scrollProgress.get);
  }
  function B() {
    return d.scrollProgress.get(d.location.get());
  }
  function U() {
    return d.index.get();
  }
  function K() {
    return d.indexPrevious.get();
  }
  function Z() {
    return d.dragHandler.clickAllowed();
  }
  function X() {
    return E;
  }
  function J() {
    return d;
  }
  function ae() {
    return t;
  }
  function re() {
    return N;
  }
  function j() {
    return I;
  }
  var ne = {
    canScrollNext: L,
    canScrollPrev: w,
    clickAllowed: Z,
    containerNode: re,
    internalEngine: J,
    destroy: T,
    off: l,
    on: s,
    plugins: X,
    previousScrollSnap: K,
    reInit: c,
    rootNode: ae,
    scrollNext: $,
    scrollPrev: y,
    scrollProgress: B,
    scrollSnapList: R,
    scrollTo: P,
    selectedScrollSnap: U,
    slideNodes: j,
    slidesInView: G,
    slidesNotInView: b
  };
  return p(e, n), r.add(window, "resize", k), setTimeout(function() {
    return a.emit("init");
  }, 0), ne;
}
du.globalOptions = void 0;
du.optionsHandler = bp;
function M0e() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function P0e(t = {}, e = []) {
  const n = W(), r = W(), o = W([]), i = W(0), a = W(!1), s = W(!1), l = () => {
    if (!n.value)
      throw new Error("embla is not defined yet, cannot onSelect");
    i.value = n.value.selectedScrollSnap(), a.value = n.value.canScrollPrev(), s.value = n.value.canScrollNext();
  }, c = async () => {
    var u;
    await Or(1), (u = n.value) == null || u.reInit(), l();
  };
  return ct(() => {
    if (M0e()) {
      if (!r.value)
        throw new Error("viewport element ref is not defined yet");
      n.value = du(r.value, t, e), n.value.on("select", l), o.value = n.value.scrollSnapList(), l();
    } else
      n.value = void 0;
  }), Li(() => {
    n.value && n.value.destroy();
  }), { viewport: r, carousel: n, scrollSnaps: o, selectedIndex: i, prevEnabled: a, nextEnabled: s, reInit: c };
}
function Ea() {
  return Ea = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Ea.apply(this, arguments);
}
var y0e = 0.996, L0e = function(e, n) {
  return n === void 0 && (n = y0e), e * n / (1 - n);
};
function x0e(t) {
  return t[t.length - 1];
}
function U0e(t) {
  return t.reduce(function(e, n) {
    return e + n;
  }) / t.length;
}
var $0e = function(e, n, r) {
  return Math.min(Math.max(n, e), r);
};
function z1(t, e) {
  if (t.length !== e.length)
    throw new Error("vectors must be same length");
  return t.map(function(n, r) {
    return n + e[r];
  });
}
function M3(t) {
  return Math.max.apply(Math, t.map(Math.abs));
}
function Ys(t) {
  return Object.freeze(t), Object.values(t).forEach(function(e) {
    e !== null && typeof e == "object" && !Object.isFrozen(e) && Ys(e);
  }), t;
}
function k0e() {
  var t = {};
  function e(o, i) {
    return t[o] = (t[o] || []).concat(i), function() {
      return n(o, i);
    };
  }
  function n(o, i) {
    t[o] = (t[o] || []).filter(function(a) {
      return a !== i;
    });
  }
  function r(o, i) {
    o in t && t[o].forEach(function(a) {
      return a(i);
    });
  }
  return Ys({
    on: e,
    off: n,
    dispatch: r
  });
}
function B0e(t) {
  var e = [], n = function(a) {
    return a.addEventListener("wheel", t, {
      passive: !1
    }), e.push(a), function() {
      return r(a);
    };
  }, r = function(a) {
    a.removeEventListener("wheel", t), e = e.filter(function(s) {
      return s !== a;
    });
  }, o = function() {
    e.forEach(r);
  };
  return Ys({
    observe: n,
    unobserve: r,
    disconnect: o
  });
}
var G0e = 16 * 1.125, F0e = typeof window < "u" && window.innerHeight || 800, Z1 = [1, G0e, F0e];
function V0e(t) {
  var e = t.deltaX * Z1[t.deltaMode], n = t.deltaY * Z1[t.deltaMode], r = (t.deltaZ || 0) * Z1[t.deltaMode];
  return {
    timeStamp: t.timeStamp,
    axisDelta: [e, n, r]
  };
}
var H0e = [-1, -1, -1];
function W0e(t, e) {
  if (!e)
    return t;
  var n = e === !0 ? H0e : e.map(function(r) {
    return r ? -1 : 1;
  });
  return Ea({}, t, {
    axisDelta: t.axisDelta.map(function(r, o) {
      return r * n[o];
    })
  });
}
var P3 = 700, Y0e = function(e) {
  return Ea({}, e, {
    axisDelta: e.axisDelta.map(function(n) {
      return $0e(n, -P3, P3);
    })
  });
}, q1 = process.env.NODE_ENV !== "production", K0e = 0.6, z0e = 0.96, Z0e = 2, y3 = 5, L3 = /* @__PURE__ */ Ys({
  preventWheelAction: !0,
  reverseSign: [!0, !0, !1]
}), q0e = 400;
function x3() {
  return {
    isStarted: !1,
    isStartPublished: !1,
    isMomentum: !1,
    startTime: 0,
    lastAbsDelta: 1 / 0,
    axisMovement: [0, 0, 0],
    axisVelocity: [0, 0, 0],
    accelerationFactors: [],
    scrollPoints: [],
    scrollPointsToMerge: [],
    willEndTimeout: q0e
  };
}
function X0e(t) {
  t === void 0 && (t = {});
  var e = k0e(), n = e.on, r = e.off, o = e.dispatch, i = L3, a = x3(), s, l = !1, c, u = function(L) {
    Array.isArray(L) ? L.forEach(function(w) {
      return _(w);
    }) : _(L);
  }, d = function(L) {
    return L === void 0 && (L = {}), Object.values(L).some(function(w) {
      return w == null;
    }) ? (q1 && console.error("updateOptions ignored! undefined & null options not allowed"), i) : i = Ys(Ea({}, L3, i, L));
  }, f = function(L) {
    var w = Ea({
      event: s,
      isStart: !1,
      isEnding: !1,
      isMomentumCancel: !1,
      isMomentum: a.isMomentum,
      axisDelta: [0, 0, 0],
      axisVelocity: a.axisVelocity,
      axisMovement: a.axisMovement,
      get axisMovementProjection() {
        return z1(w.axisMovement, w.axisVelocity.map(function(R) {
          return L0e(R);
        }));
      }
    }, L);
    o("wheel", Ea({}, w, {
      previous: c
    })), c = w;
  }, h = function(L, w) {
    var R = i, B = R.preventWheelAction, U = w[0], K = w[1], Z = w[2];
    if (typeof B == "boolean")
      return B;
    switch (B) {
      case "x":
        return Math.abs(U) >= L;
      case "y":
        return Math.abs(K) >= L;
      case "z":
        return Math.abs(Z) >= L;
      default:
        return q1 && console.warn("unsupported preventWheelAction value: " + B, "warn"), !1;
    }
  }, _ = function(L) {
    var w = Y0e(W0e(V0e(L), i.reverseSign)), R = w.axisDelta, B = w.timeStamp, U = M3(R);
    if (L.preventDefault && h(U, R) && L.preventDefault(), a.isStarted ? a.isMomentum && U > Math.max(2, a.lastAbsDelta * 2) && (k(!0), D()) : D(), U === 0 && Object.is && Object.is(L.deltaX, -0)) {
      l = !0;
      return;
    }
    s = L, a.axisMovement = z1(a.axisMovement, R), a.lastAbsDelta = U, a.scrollPointsToMerge.push({
      axisDelta: R,
      timeStamp: B
    }), E(), f({
      axisDelta: R,
      isStart: !a.isStartPublished
    }), a.isStartPublished = !0, T();
  }, E = function() {
    a.scrollPointsToMerge.length === Z0e ? (a.scrollPoints.unshift({
      axisDeltaSum: a.scrollPointsToMerge.map(function(L) {
        return L.axisDelta;
      }).reduce(z1),
      timeStamp: U0e(a.scrollPointsToMerge.map(function(L) {
        return L.timeStamp;
      }))
    }), N(), a.scrollPointsToMerge.length = 0, a.scrollPoints.length = 1, a.isMomentum || p()) : a.isStartPublished || m();
  }, m = function() {
    a.axisVelocity = x0e(a.scrollPointsToMerge).axisDelta.map(function(L) {
      return L / a.willEndTimeout;
    });
  }, N = function() {
    var L = a.scrollPoints, w = L[0], R = L[1];
    if (!(!R || !w)) {
      var B = w.timeStamp - R.timeStamp;
      if (B <= 0) {
        q1 && console.warn("invalid deltaTime");
        return;
      }
      var U = w.axisDeltaSum.map(function(Z) {
        return Z / B;
      }), K = U.map(function(Z, X) {
        return Z / (a.axisVelocity[X] || 1);
      });
      a.axisVelocity = U, a.accelerationFactors.push(K), I(B);
    }
  }, I = function(L) {
    var w = Math.ceil(L / 10) * 10 * 1.2;
    a.isMomentum || (w = Math.max(100, w * 2)), a.willEndTimeout = Math.min(1e3, Math.round(w));
  }, O = function(L) {
    return L === 0 ? !0 : L <= z0e && L >= K0e;
  }, p = function() {
    if (a.accelerationFactors.length >= y3) {
      if (l && (l = !1, M3(a.axisVelocity) >= 0.2)) {
        C();
        return;
      }
      var L = a.accelerationFactors.slice(y3 * -1), w = L.every(function(R) {
        var B = !!R.reduce(function(K, Z) {
          return K && K < 1 && K === Z ? 1 : 0;
        }), U = R.filter(O).length === R.length;
        return B || U;
      });
      w && C(), a.accelerationFactors = L;
    }
  }, C = function() {
    a.isMomentum = !0;
  }, D = function() {
    a = x3(), a.isStarted = !0, a.startTime = Date.now(), c = void 0, l = !1;
  }, T = function() {
    var y;
    return function() {
      clearTimeout(y), y = setTimeout(k, a.willEndTimeout);
    };
  }(), k = function(L) {
    L === void 0 && (L = !1), a.isStarted && (a.isMomentum && L ? f({
      isEnding: !0,
      isMomentumCancel: !0
    }) : f({
      isEnding: !0
    }), a.isMomentum = !1, a.isStarted = !1);
  }, G = B0e(u), b = G.observe, P = G.unobserve, $ = G.disconnect;
  return d(t), Ys({
    on: n,
    off: r,
    observe: b,
    unobserve: P,
    disconnect: $,
    feedWheel: u,
    updateOptions: d
  });
}
var j0e = {
  active: !0,
  breakpoints: {},
  wheelDraggingClass: "is-wheel-dragging",
  forceWheelAxis: void 0,
  target: void 0
};
Rp.globalOptions = void 0;
var J0e = process.env.NODE_ENV !== "production";
function Rp(t) {
  var e = du.optionsHandler(), n = e.merge(j0e, Rp.globalOptions), r, o = function() {
  };
  function i(s) {
    var l, c;
    r = e.atMedia(a.options);
    var u = s.internalEngine(), d = (l = r.target) != null ? l : s.containerNode().parentNode, f = (c = r.forceWheelAxis) != null ? c : u.options.axis, h = X0e({
      preventWheelAction: f,
      reverseSign: [!0, !0, !1]
    }), _ = h.observe(d), E = h.on("wheel", G), m = !1, N;
    function I(b) {
      try {
        N = new MouseEvent("mousedown", b.event), k(N);
      } catch {
        return J0e && console.warn("Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"), o();
      }
      m = !0, p(), r.wheelDraggingClass && d.classList.add(r.wheelDraggingClass);
    }
    function O(b) {
      m = !1, k(T("mouseup", b)), C(), r.wheelDraggingClass && d.classList.remove(r.wheelDraggingClass);
    }
    function p() {
      document.documentElement.addEventListener("mousemove", D, !0), document.documentElement.addEventListener("mouseup", D, !0), document.documentElement.addEventListener("mousedown", D, !0);
    }
    function C() {
      document.documentElement.removeEventListener("mousemove", D, !0), document.documentElement.removeEventListener("mouseup", D, !0), document.documentElement.removeEventListener("mousedown", D, !0);
    }
    function D(b) {
      m && b.isTrusted && b.stopImmediatePropagation();
    }
    function T(b, P) {
      var $, y;
      if (f === u.options.axis) {
        var L = P.axisMovement;
        $ = L[0], y = L[1];
      } else {
        var w = P.axisMovement;
        y = w[0], $ = w[1];
      }
      return new MouseEvent(b, {
        clientX: N.clientX + $,
        clientY: N.clientY + y,
        screenX: N.screenX + $,
        screenY: N.screenY + y,
        movementX: $,
        movementY: y,
        button: 0,
        bubbles: !0,
        cancelable: !0,
        composed: !0
      });
    }
    function k(b) {
      s.containerNode().dispatchEvent(b);
    }
    function G(b) {
      var P = b.axisDelta, $ = P[0], y = P[1], L = f === "x" ? $ : y, w = f === "x" ? y : $, R = b.isMomentum && b.previous && !b.previous.isMomentum, B = b.isEnding && !b.isMomentum || R, U = Math.abs(L) > Math.abs(w);
      U && !m && !b.isMomentum && I(b), m && (B ? O(b) : k(T("mousemove", b)));
    }
    o = function() {
      _(), E(), C();
    };
  }
  var a = {
    name: "wheelGestures",
    options: e.merge(n, t),
    init: i,
    destroy: function() {
      return o();
    }
  };
  return a;
}
const Mp = {
  name: "Carousel",
  components: { oButton: ln },
  props: {
    options: {
      // https://www.embla-carousel.com/api/options/
      type: Object,
      required: !1,
      default: {}
    },
    arrows: {
      type: Boolean,
      default: !1,
      required: !1
    },
    arrowHorizontalPadding: {
      type: String,
      default: "0.5rem",
      required: !1
    },
    padding: {
      type: String,
      default: "0rem 0rem 0rem 0rem",
      required: !1
    },
    wheelGestures: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  setup(t, { slots: e }) {
    const { viewport: n, carousel: r, scrollSnaps: o, selectedIndex: i, prevEnabled: a, nextEnabled: s, reInit: l } = P0e(
      { ...t.options, dragFree: t.wheelGestures },
      // conditionally add WheelGesturesPlugin() if wheelGestures prop is true
      [...t.wheelGestures ? [Rp()] : []]
    ), c = {
      carousel: r,
      scrollSnaps: o,
      selectedIndex: i,
      prevEnabled: a,
      nextEnabled: s
    };
    Ti("carousel", c);
    const u = x(() => {
      var d;
      if (!e.slides)
        throw new Error("slides slot must be defined in Carousel");
      return ((d = e.slides()[0].children) == null ? void 0 : d.length) ?? 0;
    });
    return et(u, () => l()), {
      viewport: n,
      ...c
    };
  }
}, U3 = () => {
  Wr((t) => ({
    v5204fc5b: t.padding,
    v7b54b8ba: t.arrowHorizontalPadding
  }));
}, $3 = Mp.setup;
Mp.setup = $3 ? (t, e) => (U3(), $3(t, e)) : U3;
const Q0e = { class: "carousel" }, e_e = {
  className: "viewport",
  ref: "viewport"
}, t_e = { class: "container" }, n_e = {
  key: 0,
  class: "carousel-button prev-button"
}, r_e = {
  key: 1,
  class: "carousel-button next-button"
};
function o_e(t, e, n, r, o, i) {
  const a = ee("oButton");
  return v(), A("div", Q0e, [
    g("div", e_e, [
      g("div", t_e, [
        ue(t.$slots, "slides", {}, void 0, !0)
      ])
    ], 512),
    ue(t.$slots, "navigation", {
      carousel: t.carousel,
      viewport: r.viewport,
      scrollSnaps: t.scrollSnaps,
      selectedIndex: t.selectedIndex,
      prevEnabled: t.prevEnabled,
      nextEnabled: t.nextEnabled
    }, void 0, !0),
    n.arrows ? (v(), A("div", n_e, [
      H(a, {
        color: "white",
        circle: !0,
        onClicked: e[0] || (e[0] = (s) => t.carousel.scrollPrev()),
        disabled: !t.prevEnabled
      }, {
        icon: q(() => [
          (v(), A("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "12",
            viewBox: "0 0 16 12",
            fill: "none",
            class: z(["left-arrow", { disabled: !t.prevEnabled }])
          }, [...e[2] || (e[2] = [
            g("path", {
              d: "M1 6H15",
              stroke: "#010105",
              "stroke-width": "2",
              "stroke-miterlimit": "10",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1),
            g("path", {
              d: "M10 1L15 6L10 11",
              stroke: "#010105",
              "stroke-width": "2",
              "stroke-miterlimit": "10",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ])], 2))
        ]),
        _: 1
      }, 8, ["disabled"])
    ])) : V("", !0),
    n.arrows ? (v(), A("div", r_e, [
      H(a, {
        color: "white",
        circle: !0,
        disabled: !t.nextEnabled,
        onClicked: e[1] || (e[1] = (s) => t.carousel.scrollNext())
      }, {
        icon: q(() => [
          (v(), A("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "12",
            viewBox: "0 0 16 12",
            fill: "none",
            class: z(["right-arrow", { disabled: !t.nextEnabled }])
          }, [...e[3] || (e[3] = [
            g("path", {
              d: "M1 6H15",
              stroke: "#010105",
              "stroke-width": "2",
              "stroke-miterlimit": "10",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1),
            g("path", {
              d: "M10 1L15 6L10 11",
              stroke: "#010105",
              "stroke-width": "2",
              "stroke-miterlimit": "10",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ])], 2))
        ]),
        _: 1
      }, 8, ["disabled"])
    ])) : V("", !0)
  ]);
}
const dPe = /* @__PURE__ */ Y(Mp, [["render", o_e], ["__scopeId", "data-v-471efb4a"]]), i_e = ["disabled"], a_e = {
  key: 0,
  class: "prefix"
}, s_e = {
  key: 3,
  class: "suffix"
}, l_e = /* @__PURE__ */ Ne({
  __name: "SquareButton",
  props: {
    fullWidth: { type: Boolean, default: !1 },
    size: { default: "medium" },
    variant: {},
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(t, { expose: e, emit: n }) {
    const r = W(), o = t, i = n;
    return e({
      elementRef: r
    }), Ir({
      keys: ["enter"],
      onPressCallBack: (a) => {
        i("click", a);
      },
      eventTarget: r
    }), (a, s) => (v(), A("div", Tt({
      ref_key: "elementRef",
      ref: r
    }, a.$attrs, {
      onClick: s[0] || (s[0] = (l) => o.disabled ? null : i("click", l)),
      class: ["square-button", t.size, t.variant, { disabled: t.disabled }, { "full-width": t.fullWidth }],
      tabindex: "0",
      role: "button",
      disabled: t.disabled || t.loading
    }), [
      a.$slots.prefix ? (v(), A("div", a_e, [
        ue(a.$slots, "prefix", {}, void 0, !0)
      ])) : V("", !0),
      a.$slots.text ? ue(a.$slots, "text", { key: 1 }, void 0, !0) : (v(), te(M(Ye), {
        key: 2,
        class: "square-button-text",
        as: "span",
        size: "f-9",
        weight: "500",
        wrap: !1
      }, {
        default: q(() => [
          ue(a.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      })),
      a.$slots.suffix ? (v(), A("div", s_e, [
        ue(a.$slots, "suffix", {}, void 0, !0)
      ])) : V("", !0)
    ], 16, i_e));
  }
});
const c_e = /* @__PURE__ */ Y(l_e, [["__scopeId", "data-v-23f6e738"]]), X1 = "o-image", u_e = Ne({
  name: "oImage",
  inheritAttrs: !1,
  props: {
    src: {
      type: String,
      required: !0
    },
    srcset: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    background: {
      type: String,
      default: ""
    },
    transitionDuration: {
      type: [Number, String],
      default: 500
    },
    classes: {
      type: Object,
      default: () => ({})
    },
    loadImmediately: {
      type: Boolean,
      default: !1
    }
  },
  setup(t, { attrs: e }) {
    const n = W(), r = W(), o = W(), i = W(), a = () => {
      !n.value || !r.value || (n.value.classList.remove(`${X1}--loading`), n.value.classList.add(`${X1}--loaded`), t.placeholder && r.value.addEventListener("transitionend", function d() {
        var f;
        (f = o.value) == null || f.remove(), r.value.removeEventListener("transitionend", d);
      }), r.value.removeEventListener("load", a));
    }, s = () => {
      !n.value || !r.value || (n.value.classList.add(`${X1}--loading`), r.value.addEventListener("load", a), t.srcset && (r.value.srcset = t.srcset), r.value.src = t.src);
    }, l = ([d]) => {
      var f;
      d.isIntersecting && (s(), (f = i.value) == null || f.disconnect());
    }, c = () => {
      t.loadImmediately ? s() : (i.value = new IntersectionObserver(l), i.value.observe(n.value));
    }, u = x(() => {
      const { width: d, height: f } = e;
      if (!d || !f)
        return "";
      const h = 100, _ = document.createElement("canvas");
      return _.width = h, _.height = f / d * h, _.toDataURL();
    });
    return ct(() => {
      c();
    }), et(() => t.src, c), et(() => t.srcset, c), Li(() => {
      var d;
      return (d = i.value) == null ? void 0 : d.disconnect();
    }), {
      rootEl: n,
      imgEl: r,
      placeholderEl: o,
      dataUrl: u
    };
  }
});
const d_e = ["src"], f_e = ["src", "alt"];
function h_e(t, e, n, r, o, i) {
  return v(), A("picture", {
    class: z(["o-image", t.classes.root]),
    ref: "rootEl"
  }, [
    t.dataUrl ? (v(), A("div", {
      key: 0,
      ref: "placeholderEl",
      class: z(["o-image__placeholder", t.classes.placeholder]),
      style: Fe({ background: t.background })
    }, [
      g("img", Tt({
        src: t.placeholder || t.dataUrl
      }, t.$attrs, { alt: "" }), null, 16, d_e)
    ], 6)) : V("", !0),
    g("img", Tt({
      ref: "imgEl",
      src: t.dataUrl,
      class: ["o-image__img", t.classes.img],
      alt: t.$attrs.alt || "",
      style: {
        transitionDuration: `${t.transitionDuration}ms`
      }
    }, t.$attrs), null, 16, f_e)
  ], 2);
}
const fPe = /* @__PURE__ */ Y(u_e, [["render", h_e], ["__scopeId", "data-v-b870aff0"]]), __e = Ne({
  name: "Checkbox",
  components: { ErrorMessage: r5 },
  inheritAttrs: !1,
  model: {
    event: "updated"
  },
  props: {
    // id and name can be set similarly to props using and will be bound using the $attrs object
    label: {
      type: String,
      required: !1
    },
    modelValue: {
      type: Boolean,
      default: !1
    },
    indeterminate: {
      type: Boolean,
      default: !1
    },
    buttonMode: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  emits: ["update:modelValue", "updated"],
  setup(t, { attrs: e, emit: n }) {
    const r = W(t.modelValue), o = W(!0), i = W(!1), a = W(""), s = W(e.id || Br(6)), l = W(), c = x(() => !o.value && i.value), u = x(() => ({
      "aria-invalid": !o.value,
      "aria-describedby": `${s}__input__label`,
      ...e,
      class: "o-input__input"
    }));
    async function d() {
      var _;
      if (await Ln(), !l.value)
        return;
      const h = (_ = l.value) == null ? void 0 : _.validity;
      l.value.setCustomValidity(""), o.value = h == null ? void 0 : h.valid, a.value = "Please check this box.";
    }
    function f(h) {
      l.value.setCustomValidity(h), i.value = !0, o.value = !1, a.value = h, l.value.focus();
    }
    return ct(async () => {
      await d(), e.hasOwnProperty("autofocus") && e.autofocus !== !1 && (await Or(1), l.value.focus());
    }), et(
      () => t.modelValue,
      (h, _) => {
        h !== _ && (r.value = h);
      }
    ), et(r, async (h, _) => {
      _ && t.indeterminate || (t.indeterminate ? (n("update:modelValue", !0), n("updated", !0), await d()) : (n("update:modelValue", h), n("updated", h), await d()));
    }), {
      id: s,
      bind: u,
      valid: o,
      dirty: i,
      error: c,
      setError: f,
      inputRef: l,
      localValue: r,
      errorMessage: a
    };
  }
});
const E_e = ["aria-checked"], p_e = ["for"], m_e = ["id", "checked", ".indeterminate"], N_e = {
  key: 0,
  class: "check-icon",
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  xmlns: "http://www.w3.org/2000/svg"
}, v_e = {
  key: 1,
  class: "indeterminate-icon",
  width: "10",
  height: "2",
  viewBox: "0 0 10 2",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, g_e = ["id", "innerHTML"], I_e = ["id"];
function O_e(t, e, n, r, o, i) {
  const a = ee("ErrorMessage");
  return v(), A("div", {
    class: z([
      "o-input",
      "o-input-checkbox",
      {
        "o-input--required": t.$attrs.hasOwnProperty("required"),
        "o-input--invalid": !t.valid,
        "o-input--dirty": t.dirty,
        "o-input--error": t.error
      },
      t.$attrs.class
    ]),
    "aria-checked": t.indeterminate ? "mixed" : t.localValue
  }, [
    g("label", {
      for: `${t.id}__input`,
      class: z([{ "button-mode": t.buttonMode }, "o-input__label", "o-input__checkbox"])
    }, [
      g("input", Tt({
        ref: "inputRef",
        id: `${t.id}__input`,
        checked: t.localValue,
        class: t.indeterminate && !t.$attrs.disabled ? "indeterminate" : t.localValue ? "checked" : ""
      }, t.bind, {
        ".indeterminate": t.indeterminate,
        onChange: e[0] || (e[0] = (s) => {
          var l;
          return t.localValue = (l = s.target) == null ? void 0 : l.checked;
        }),
        onBlurOnce: e[1] || (e[1] = (s) => t.dirty = !0),
        class: "checkbox",
        type: "checkbox"
      }), null, 48, m_e),
      t.localValue && !t.indeterminate ? (v(), A("svg", N_e, [...e[2] || (e[2] = [
        g("polyline", {
          points: "4.5 9 7.5 12 13.5 6",
          transform: "translate(-3 -5)",
          "fill-rule": "nonzero",
          stroke: "#FFFFFF",
          "stroke-width": "2",
          fill: "none",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, -1)
      ])])) : V("", !0),
      t.indeterminate && !t.$attrs.disabled && !t.localValue ? (v(), A("svg", v_e, [...e[3] || (e[3] = [
        g("path", {
          d: "M1 1h8",
          stroke: "#fff",
          "stroke-width": "2",
          "stroke-linecap": "round"
        }, null, -1)
      ])])) : V("", !0),
      t.label && !t.$slots.label ? (v(), A("span", {
        key: 2,
        id: `${t.id}__input__label`,
        class: "o-input__text",
        innerHTML: t.label
      }, null, 8, g_e)) : V("", !0),
      t.$slots.label ? (v(), A("span", {
        key: 3,
        id: `${t.id}__input__label`,
        class: "checkbox-label-slot"
      }, [
        ue(t.$slots, "label", {}, void 0, !0)
      ], 8, I_e)) : V("", !0)
    ], 10, p_e),
    t.error ? (v(), te(a, {
      key: 0,
      content: t.errorMessage,
      style: { "margin-top": "0.875rem" }
    }, null, 8, ["content"])) : V("", !0)
  ], 10, E_e);
}
const hPe = /* @__PURE__ */ Y(__e, [["render", O_e], ["__scopeId", "data-v-6fb8c488"]]);
function A_e(t) {
  if (Array.isArray(t)) {
    for (var e = 0, n = Array(t.length); e < t.length; e++)
      n[e] = t[e];
    return n;
  } else
    return Array.from(t);
}
var Pp = !1;
if (typeof window < "u") {
  var k3 = {
    get passive() {
      Pp = !0;
    }
  };
  window.addEventListener("testPassive", null, k3), window.removeEventListener("testPassive", null, k3);
}
var Z6 = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1), pi = [], Wd = !1, q6 = -1, Ql = void 0, ec = void 0, X6 = function(e) {
  return pi.some(function(n) {
    return !!(n.options.allowTouchMove && n.options.allowTouchMove(e));
  });
}, Yd = function(e) {
  var n = e || window.event;
  return X6(n.target) || n.touches.length > 1 ? !0 : (n.preventDefault && n.preventDefault(), !1);
}, D_e = function(e) {
  if (ec === void 0) {
    var n = !!e && e.reserveScrollBarGap === !0, r = window.innerWidth - document.documentElement.clientWidth;
    n && r > 0 && (ec = document.body.style.paddingRight, document.body.style.paddingRight = r + "px");
  }
  Ql === void 0 && (Ql = document.body.style.overflow, document.body.style.overflow = "hidden");
}, C_e = function() {
  ec !== void 0 && (document.body.style.paddingRight = ec, ec = void 0), Ql !== void 0 && (document.body.style.overflow = Ql, Ql = void 0);
}, S_e = function(e) {
  return e ? e.scrollHeight - e.scrollTop <= e.clientHeight : !1;
}, w_e = function(e, n) {
  var r = e.targetTouches[0].clientY - q6;
  return X6(e.target) ? !1 : n && n.scrollTop === 0 && r > 0 || S_e(n) && r < 0 ? Yd(e) : (e.stopPropagation(), !0);
}, T_e = function(e, n) {
  if (!e) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (!pi.some(function(o) {
    return o.targetElement === e;
  })) {
    var r = {
      targetElement: e,
      options: n || {}
    };
    pi = [].concat(A_e(pi), [r]), Z6 ? (e.ontouchstart = function(o) {
      o.targetTouches.length === 1 && (q6 = o.targetTouches[0].clientY);
    }, e.ontouchmove = function(o) {
      o.targetTouches.length === 1 && w_e(o, e);
    }, Wd || (document.addEventListener("touchmove", Yd, Pp ? { passive: !1 } : void 0), Wd = !0)) : D_e(n);
  }
}, b_e = function(e) {
  if (!e) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  pi = pi.filter(function(n) {
    return n.targetElement !== e;
  }), Z6 ? (e.ontouchstart = null, e.ontouchmove = null, Wd && pi.length === 0 && (document.removeEventListener("touchmove", Yd, Pp ? { passive: !1 } : void 0), Wd = !1)) : pi.length || C_e();
};
let R_e = {};
const M_e = (t, e = R_e) => T_e(t, e), P_e = (t) => b_e(t), y_e = {
  key: 0,
  class: "select-dropdown-empty-state"
}, L_e = ["aria-selected", "onClick", "onKeyup"], x_e = { class: "select-list-option-name" }, U_e = /* @__PURE__ */ Ne({
  __name: "Select",
  props: {
    modelValue: {},
    options: {},
    multiple: { type: Boolean },
    searchable: { type: Boolean },
    disabled: { type: Boolean },
    searchPlaceholder: {}
  },
  emits: ["update:modelValue", "open", "close"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = W(n.modelValue), i = W(!1), a = W(), s = W(), l = W(), c = W(), u = IS();
    function d() {
      i.value ? E() : m();
    }
    const f = x(
      () => {
        var I;
        return (I = n.options) == null ? void 0 : I.map((O) => O ? Object.assign(O, u, {
          label: O.label || O.value,
          name: u.name,
          value: O.value,
          checked: o.value !== void 0 ? O.value === o.value : O.checked,
          disabled: O.disabled
        }) : {});
      }
    ), { activate: h, deactivate: _ } = jE(l, {
      initialFocus: !1,
      allowOutsideClick: !0,
      returnFocusOnDeactivate: !0
    }), { hide: E, show: m } = Ui(a, {
      content: () => s.value,
      interactive: !0,
      touch: !0,
      animateFill: !1,
      animation: "shift-away",
      duration: [200, 120],
      hideOnClick: !1,
      offset: [-2, -4],
      placement: "bottom-start",
      trigger: "manual",
      maxWidth: 352,
      zIndex: 99999999999999,
      appendTo: () => document.body,
      popperOptions: {
        strategy: "fixed"
      },
      onShown: async () => {
        i.value = !0, r("open"), await Ln(), M_e(c.value), h();
      },
      onHide: () => {
        i.value = !1, r("close"), P_e(c.value), _();
      },
      onClickOutside() {
        i.value && E();
      }
    });
    function N(I) {
      o.value = I, r("update:modelValue", I), E();
    }
    return Ir({
      keys: ["esc"],
      onPressCallBack: () => {
        i.value && E();
      }
    }), (I, O) => {
      var C;
      const p = ee("perfect-scrollbar");
      return v(), A(ge, null, [
        g("div", {
          ref_key: "selectButton",
          ref: a
        }, [
          I.$slots.button ? ue(I.$slots, "button ", {
            key: 1,
            api: { localValue: o.value }
          }, void 0, !0) : (v(), te(c_e, {
            key: 0,
            onClick: d,
            disabled: t.disabled,
            "full-width": ""
          }, {
            suffix: q(() => [
              H(nu)
            ]),
            default: q(() => [
              me(Q(t.multiple ? `${o.value.length} Selected` : o.value.label) + " ", 1)
            ]),
            _: 1
          }, 8, ["disabled"]))
        ], 512),
        g("div", {
          ref_key: "selectDropdown",
          ref: s,
          class: "select-dropdown"
        }, [
          (C = f.value) != null && C.length ? (v(), te(p, {
            key: 1,
            ref_key: "scrollRef",
            ref: c,
            class: "listbox-options-container",
            options: {
              suppressScrollX: !0
            }
          }, {
            default: q(() => [
              g("ul", {
                ref_key: "listboxOptions",
                ref: l,
                id: "listbox-options",
                "aria-orientation": "vertical",
                "aria-labelledby": "select-button",
                tabIndex: "0",
                role: "listbox"
              }, [
                (v(!0), A(ge, null, ye(f.value, (D, T) => (v(), A("li", {
                  key: D.value,
                  class: "select-list-option",
                  role: "option",
                  tabindex: "0",
                  "aria-selected": o.value.value === D.value,
                  onClick: (k) => N(D),
                  onKeyup: DO((k) => N(D), ["enter"])
                }, [
                  g("span", x_e, Q(D.label), 1)
                ], 40, L_e))), 128))
              ], 512)
            ]),
            _: 1
          }, 512)) : (v(), A("div", y_e, [
            H(Ye, {
              align: "center",
              size: "f-9"
            }, {
              default: q(() => [...O[0] || (O[0] = [
                me("No options available", -1)
              ])]),
              _: 1
            })
          ]))
        ], 512)
      ], 64);
    };
  }
});
const _Pe = /* @__PURE__ */ Y(U_e, [["__scopeId", "data-v-a2271818"]]), $_e = {
  meta: "⌘",
  shift: "⇧",
  alt: "⌥",
  ctrl: "⌃"
}, k_e = {
  props: {
    keys: {
      type: Array,
      required: !0
    },
    classes: {
      type: String,
      required: !1
    },
    small: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["pressed"],
  setup(t, { emit: e }) {
    const n = W(null), r = x(() => t.keys.length > 1), { pressed: o } = Ir({
      keys: t.keys,
      onPressCallBack: i,
      onReleaseCallBack: i
    });
    function i() {
      o.value && e("pressed");
    }
    function a(l) {
      return $_e[l] ?? l;
    }
    function s(l) {
      return !!["esc", "space", "enter"].includes(l);
    }
    return { pressed: o, group: r, timer: n, mapSymbol: a, isWide: s };
  }
};
const B_e = { class: "keyboard-shortcut" };
function G_e(t, e, n, r, o, i) {
  return v(), A("div", B_e, [
    (v(!0), A(ge, null, ye(n.keys, (a, s) => (v(), A("kbd", {
      key: s,
      class: z([
        { pressed: r.pressed },
        { small: n.small },
        { wide: r.isWide(a) },
        { last: s === n.keys.length - 1 }
      ])
    }, Q(r.mapSymbol(a)), 3))), 128))
  ]);
}
const EPe = /* @__PURE__ */ Y(k_e, [["render", G_e], ["__scopeId", "data-v-5b1e05ad"]]), F_e = {
  name: "ProfileImage",
  components: {
    Skeleton: sa
  },
  props: {
    isAdmin: {
      type: Boolean,
      required: !1,
      default: !1
    },
    width: {
      type: Number,
      required: !1,
      default: 32
    },
    imageUrl: {
      type: String,
      required: !1
    },
    avatarUrl: {
      type: String,
      required: !1
    },
    userId: {
      type: Number,
      required: !1
    },
    hideRole: {
      type: Boolean,
      required: !1
    },
    isActive: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(t) {
    const e = W(!0);
    async function n() {
      e.value === !0 && (await Or(1e3), e.value = !1);
    }
    const r = x(() => {
      if (t.avatarUrl)
        return t.avatarUrl;
      if (t.userId)
        return `https://api.opteo.com/render/avatar.svg?userId=${t.userId}`;
    });
    return {
      skeletonVisible: e,
      hideSkeleton: n,
      boringAvatarUrl: r
    };
  }
};
const V_e = { style: { position: "relative" } }, H_e = ["src"], W_e = ["src"], Y_e = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "active-bubble"
}, K_e = {
  key: 0,
  class: "a-tag"
};
function z_e(t, e, n, r, o, i) {
  const a = ee("Skeleton"), s = ft("tippy");
  return v(), A("div", V_e, [
    g("div", {
      class: "profile-image-wrapper",
      style: Fe({
        width: `${n.width}px`,
        height: `${n.width}px`,
        flex: `0 0 ${n.width}px`
      })
    }, [
      n.imageUrl ? (v(), te(Zt, {
        key: 0,
        name: "fade"
      }, {
        default: q(() => [
          g("img", {
            src: n.imageUrl,
            style: Fe([
              { minWidth: n.width + "px" },
              { minHeight: n.width + "px" },
              { maxWidth: n.width + "px" },
              { position: "absolute" },
              { zIndex: 2 }
            ]),
            onLoad: e[0] || (e[0] = (...l) => r.hideSkeleton && r.hideSkeleton(...l))
          }, null, 44, H_e)
        ]),
        _: 1
      })) : r.boringAvatarUrl ? (v(), te(Zt, {
        key: 1,
        name: "fade"
      }, {
        default: q(() => [
          g("img", {
            src: r.boringAvatarUrl,
            style: Fe([
              { width: n.width + 2 + "px" },
              { height: n.width + 2 + "px" },
              { maxWidth: n.width + 2 + "px" },
              { position: "absolute" },
              { top: "-1px" },
              { left: "-1px" },
              { zIndex: 2 }
            ]),
            onLoad: e[1] || (e[1] = (...l) => r.hideSkeleton && r.hideSkeleton(...l))
          }, null, 44, W_e)
        ]),
        _: 1
      })) : V("", !0),
      r.skeletonVisible ? (v(), te(a, {
        key: 2,
        width: n.width,
        height: n.width
      }, null, 8, ["width", "height"])) : V("", !0)
    ], 4),
    H(Zt, { name: "admin-fade" }, {
      default: q(() => [
        n.isActive && !r.skeletonVisible ? (v(), A("svg", Y_e, [...e[2] || (e[2] = [
          g("circle", {
            cx: "6",
            cy: "6",
            r: "5",
            fill: "#00A861",
            stroke: "white",
            "stroke-width": "2"
          }, null, -1)
        ])])) : V("", !0)
      ]),
      _: 1
    }),
    H(Zt, { name: "admin-fade" }, {
      default: q(() => [
        n.isAdmin && !n.hideRole ? Ze((v(), A("div", K_e, null, 512)), [
          [s, {
            animateFill: "false",
            animation: "shift-away",
            duration: "250",
            placement: "top",
            theme: "circle-icon",
            offset: [0, 4],
            content: "<span class='f7 lh-copy'>Admin</span>",
            trigger: "mouseenter"
          }]
        ]) : V("", !0)
      ]),
      _: 1
    })
  ]);
}
const Z_e = /* @__PURE__ */ Y(F_e, [["render", z_e], ["__scopeId", "data-v-38665ef0"]]);
function q_e(t) {
  return { all: t = t || /* @__PURE__ */ new Map(), on: function(e, n) {
    var r = t.get(e);
    r ? r.push(n) : t.set(e, [n]);
  }, off: function(e, n) {
    var r = t.get(e);
    r && (n ? r.splice(r.indexOf(n) >>> 0, 1) : t.set(e, []));
  }, emit: function(e, n) {
    var r = t.get(e);
    r && r.slice().map(function(o) {
      o(n);
    }), (r = t.get("*")) && r.slice().map(function(o) {
      o(e, n);
    });
  } };
}
const Kd = q_e();
function j6(t) {
  Kd.emit("show-snackbar", t);
}
function pPe() {
  Kd.emit("hide-snackbar");
}
function X_e() {
  const t = W(!1), e = W("No message entered"), n = W(), r = W(null), o = W(), i = W(), a = W(480), s = W(8), l = W(!1), c = W(), u = W(!1), { aboveMobile: d } = Io(), f = W(), h = () => {
    o.value && o.value(), N();
  }, _ = ({ message: C, timeout: D, actionText: T, actionHandler: k }) => {
    if (!C)
      throw new Error("Must enter a message for snackbar");
    if (typeof C != "string")
      throw new Error("message must be a string");
    if (D && typeof D != "number")
      throw new Error("timeout must be a number(in milliseconds)");
    if (T && typeof T != "string")
      throw new Error("actionText must be a string");
    if (k && typeof k != "function")
      throw new Error("actionHandler must be a function");
  }, E = async (C) => {
    if (C === void 0)
      throw new Error("You must pass the appropriate parameters to the Snackbar");
    {
      let {
        message: D,
        timeout: T = 2500,
        actionText: k = null,
        actionHandler: G = null,
        snackbarMaxWidth: b = 480,
        snackbarBottom: P = 8,
        indefiniteTimeout: $ = !1,
        spinner: y = !1
      } = C;
      typeof C == "string" ? D = C : _(C), t.value && (t.value = !1, await new Promise((L) => setTimeout(L, 200))), t.value = !0, O(), e.value = D, r.value = k, o.value = G, a.value = b, s.value = P, u.value = y, l.value = $, n.value = T || (G ? 9e3 : T), I();
    }
  }, m = x(() => `${s.value}px`), N = () => {
    var C;
    (C = f.value) == null || C.destroy(), t.value = !1;
  }, I = () => {
    window.clearTimeout(i.value), !l.value && (i.value = setTimeout(() => {
      N();
    }, n.value));
  }, O = () => {
    f.value = null, f.value = new H6(c.value, (C) => {
      if (d.value === !0)
        return;
      const D = 15;
      C.distance[1] > D && C.delta[1] > 0 && N();
    });
  }, p = () => {
    window.clearTimeout(i.value);
  };
  return ct(() => {
    Kd.on("show-snackbar", (C) => {
      E(C);
    }), Kd.on("hide-snackbar", N);
  }), {
    show: t,
    doActionAndHide: h,
    message: e,
    actionText: r,
    actionHandler: o,
    snackbarMaxWidth: a,
    snackbarBottomPx: m,
    startTimer: I,
    preventHiding: p,
    showSnackbar: j6,
    indefiniteTimeout: l,
    spinner: u,
    snackbar: c
  };
}
const j_e = { class: "snackbar-text-btn-container" }, J_e = { class: "spinner-message-container" }, Q_e = { class: "spinner-container" }, eEe = { class: "snackbar-message" }, tEe = ["innerHTML"], nEe = /* @__PURE__ */ Ne({
  __name: "Snackbar",
  setup(t) {
    Wr((d) => ({
      v33eca1b8: M(u)
    }));
    const {
      show: e,
      actionText: n,
      actionHandler: r,
      doActionAndHide: o,
      preventHiding: i,
      startTimer: a,
      message: s,
      indefiniteTimeout: l,
      spinner: c,
      snackbarBottomPx: u
    } = X_e();
    return (d, f) => (v(), A("div", {
      class: z([[{ active: M(e) }, { "with-button": M(n) && M(r) }], "snackbar-container"]),
      ref: "snackbar",
      onMouseover: f[1] || (f[1] = //@ts-ignore
      (...h) => M(i) && M(i)(...h)),
      onMouseleave: f[2] || (f[2] = //@ts-ignore
      (...h) => M(a) && M(a)(...h))
    }, [
      g("div", j_e, [
        g("div", J_e, [
          Ze(g("div", Q_e, [
            H(M(t5))
          ], 512), [
            [bi, M(l) && M(c) || M(c)]
          ]),
          g("div", eEe, [
            g("span", { innerHTML: M(s) }, null, 8, tEe)
          ])
        ]),
        Ze(g("button", {
          class: "snackbar-button",
          onClick: f[0] || (f[0] = //@ts-ignore
          (...h) => M(o) && M(o)(...h))
        }, Q(M(n)), 513), [
          [bi, M(n) && M(r)]
        ])
      ])
    ], 34));
  }
});
const mPe = /* @__PURE__ */ Y(nEe, [["__scopeId", "data-v-2ca43b90"]]), rEe = {
  name: "Count",
  props: {
    count: {
      type: Number,
      required: !0
    },
    size: {
      type: String,
      required: !1
    }
  }
};
function oEe(t, e, n, r, o, i) {
  return v(), A("div", {
    class: z([
      "count",
      { size: n.size },
      { "digit-3": parseInt(n.count) > 99 },
      { "digit-4": parseInt(n.count) > 999 },
      { "digit-5": parseInt(n.count) > 9999 }
    ])
  }, Q(n.count), 3);
}
const iEe = /* @__PURE__ */ Y(rEe, [["render", oEe], ["__scopeId", "data-v-c39b246d"]]), yp = {
  name: "Tabs",
  components: { Count: iEe },
  props: {
    links: {
      type: Array,
      required: !0
    },
    router: {
      type: Boolean,
      default: !0,
      required: !1
    },
    // active is used to set the active class/state
    active: {
      type: String,
      required: !1
    },
    // https://v3.router.vuejs.org/api/#exact-active-class
    // only applicable when the router prop is true
    exact: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["clicked"],
  setup(t, { emit: e }) {
    return {
      linksLength: x(() => t.links.length),
      tabClicked: (o, i) => {
        i || e("clicked", o);
      }
    };
  }
}, B3 = () => {
  Wr((t) => ({
    v8d0ec6c4: t.linksLength
  }));
}, G3 = yp.setup;
yp.setup = G3 ? (t, e) => (B3(), G3(t, e)) : B3;
const aEe = { class: "tab-wrapper" }, sEe = { class: "tab-link-contents" }, lEe = {
  key: 0,
  class: "tab-text"
}, cEe = {
  key: 1,
  class: "tab-text"
}, uEe = {
  key: 0,
  class: "tab-divider"
};
function dEe(t, e, n, r, o, i) {
  const a = ee("Count");
  return v(), A("div", {
    class: z(["tabs", { "exact-router": n.exact && n.router }]),
    role: "tablist"
  }, [
    (v(!0), A(ge, null, ye(n.links, (s, l) => (v(), A("div", aEe, [
      (v(), te(zo(!s.disabled && n.router ? "router-link" : "div"), {
        key: s.key,
        to: s.to,
        tabindex: 0,
        exact: !!(n.exact && n.router),
        onClick: (c) => n.router ? null : r.tabClicked(s.key, s.disabled),
        class: z([
          "tab-link",
          { "router-link-active": n.active === s.key },
          { last: n.links.length === l + 1 },
          { first: l === 0 },
          { disabled: s.disabled },
          { only: n.links.length === 1 }
        ])
      }, {
        default: q(() => [
          g("div", sEe, [
            s.name ? (v(), A("span", lEe, Q(s.name), 1)) : (v(), A("span", cEe, [
              ue(t.$slots, s.key, {}, void 0, !0)
            ])),
            typeof s.count == "number" ? (v(), te(a, {
              key: 2,
              count: s.count
            }, null, 8, ["count"])) : V("", !0),
            ue(t.$slots, `${s.key}-right`, {}, void 0, !0)
          ])
        ]),
        _: 2
      }, 1032, ["to", "exact", "onClick", "class"])),
      n.links.length != l + 1 ? (v(), A("div", uEe)) : V("", !0)
    ]))), 256))
  ], 2);
}
const NPe = /* @__PURE__ */ Y(yp, [["render", dEe], ["__scopeId", "data-v-f4f3df4b"]]), fEe = {
  name: "ViewToggle",
  props: {
    classes: {
      type: String,
      required: !1
    },
    modelValue: {
      type: String,
      required: !0
    }
  },
  setup(t, { emit: e }) {
    return {
      toggleGridMode: () => {
        e("update:modelValue", "grid");
      },
      toggleListMode: () => {
        e("update:modelValue", "list");
      }
    };
  }
};
function hEe(t, e, n, r, o, i) {
  return v(), A("div", {
    class: z(["o-view-toggle-container", n.classes])
  }, [
    g("div", {
      class: z([{ active: n.modelValue === "list" }, "o-view-toggle list"]),
      onClick: e[0] || (e[0] = (...a) => r.toggleListMode && r.toggleListMode(...a))
    }, [...e[2] || (e[2] = [
      g("svg", {
        width: "16",
        height: "12",
        viewBox: "0 0 16 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        g("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M0 1a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H1Z",
          fill: "#006DFF"
        })
      ], -1)
    ])], 2),
    g("div", {
      class: z([{ active: n.modelValue === "grid" }, "o-view-toggle grid"]),
      onClick: e[1] || (e[1] = (...a) => r.toggleGridMode && r.toggleGridMode(...a))
    }, [...e[3] || (e[3] = [
      g("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        g("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M4.5 0h-2A2.5 2.5 0 0 0 0 2.5v2A2.5 2.5 0 0 0 2.5 7h2A2.5 2.5 0 0 0 7 4.5v-2A2.5 2.5 0 0 0 4.5 0ZM2 2.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2ZM13.5 0h-2A2.5 2.5 0 0 0 9 2.5v2A2.5 2.5 0 0 0 11.5 7h2A2.5 2.5 0 0 0 16 4.5v-2A2.5 2.5 0 0 0 13.5 0ZM11 2.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2ZM2.5 9h2A2.5 2.5 0 0 1 7 11.5v2A2.5 2.5 0 0 1 4.5 16h-2A2.5 2.5 0 0 1 0 13.5v-2A2.5 2.5 0 0 1 2.5 9Zm0 2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2Zm11-2h-2A2.5 2.5 0 0 0 9 11.5v2a2.5 2.5 0 0 0 2.5 2.5h2a2.5 2.5 0 0 0 2.5-2.5v-2A2.5 2.5 0 0 0 13.5 9ZM11 11.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2Z",
          fill: "#E0E0E5"
        })
      ], -1)
    ])], 2)
  ], 2);
}
const vPe = /* @__PURE__ */ Y(fEe, [["render", hEe], ["__scopeId", "data-v-18193b8b"]]);
function Ma(t, e, n) {
  return Math.max(e, Math.min(t, n));
}
function Tn(t, e = 2) {
  return t.toFixed(e).replace(/0+$/, "").replace(/\.$/, "");
}
function F3(t) {
  return t.endsWith(".") ? NaN : (parseFloat(t) % 360 + 360) % 360 / 360;
}
function V3(t) {
  return Tn(t * 360);
}
function Ds(t) {
  if (!t.endsWith("%"))
    return NaN;
  const e = t.substring(0, t.length - 1);
  if (e.endsWith("."))
    return NaN;
  const n = parseFloat(e);
  return Number.isNaN(n) ? NaN : Ma(n, 0, 100) / 100;
}
function Bu(t) {
  return Tn(t * 100) + "%";
}
function j1(t) {
  if (t.endsWith("%"))
    return Ds(t);
  if (t.endsWith("."))
    return NaN;
  const e = parseFloat(t);
  return Number.isNaN(e) ? NaN : Ma(e, 0, 255) / 255;
}
function J1(t) {
  return Tn(t * 255);
}
function Q1(t) {
  return t.endsWith("%") ? Ds(t) : Ma(parseFloat(t), 0, 1);
}
function eh(t) {
  return String(t);
}
const y0 = {
  hsl: {
    h: { to: V3, from: F3 },
    s: { to: Bu, from: Ds },
    l: { to: Bu, from: Ds },
    a: { to: eh, from: Q1 }
  },
  hwb: {
    h: { to: V3, from: F3 },
    w: { to: Bu, from: Ds },
    b: { to: Bu, from: Ds },
    a: { to: eh, from: Q1 }
  },
  rgb: {
    r: { to: J1, from: j1 },
    g: { to: J1, from: j1 },
    b: { to: J1, from: j1 },
    a: { to: eh, from: Q1 }
  }
};
function _Ee(t, e) {
  if (typeof t == "string" || typeof e == "string")
    return t === e;
  for (const n in t)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
function jf(t) {
  const e = t.replace(/^#/, ""), n = [], r = e.length > 4 ? 2 : 1;
  for (let i = 0; i < e.length; i += r) {
    const a = e.slice(i, i + r);
    n.push(a.repeat(r % 2 + 1));
  }
  n.length === 3 && n.push("ff");
  const o = n.map((i) => parseInt(i, 16) / 255);
  return {
    r: o[0],
    g: o[1],
    b: o[2],
    a: o[3]
  };
}
function EEe(t) {
  const e = t.l + t.s * Math.min(t.l, 1 - t.l), n = e === 0 ? 0 : 2 - 2 * t.l / e;
  return {
    h: t.h,
    s: n,
    v: e,
    a: t.a
  };
}
function Lp(t) {
  const e = t.l < 0.5 ? t.l * (1 + t.s) : t.l + t.s - t.l * t.s, n = 2 * t.l - e;
  return {
    r: th(n, e, t.h + 1 / 3),
    g: th(n, e, t.h),
    b: th(n, e, t.h - 1 / 3),
    a: t.a
  };
}
function th(t, e, n) {
  return n < 0 ? n += 1 : n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function pEe(t) {
  const e = t.v - t.v * t.s / 2, n = Math.min(e, 1 - e), r = n === 0 ? 0 : (t.v - e) / n;
  return {
    h: t.h,
    s: r,
    l: e,
    a: t.a
  };
}
function mEe(t) {
  return {
    h: t.h,
    w: (1 - t.s) * t.v,
    b: 1 - t.v,
    a: t.a
  };
}
function xp(t) {
  return {
    r: nh(5, t),
    g: nh(3, t),
    b: nh(1, t),
    a: t.a
  };
}
function nh(t, e) {
  const n = (t + e.h * 6) % 6;
  return e.v - e.v * e.s * Math.max(0, Math.min(n, 4 - n, 1));
}
function Up(t) {
  return {
    h: t.h,
    s: t.b === 1 ? 0 : 1 - t.w / (1 - t.b),
    v: 1 - t.b,
    a: t.a
  };
}
function fu(t) {
  const e = Math.min(t.r, t.g, t.b), n = Math.max(t.r, t.g, t.b);
  let r;
  return n === e ? r = 0 : n === t.r ? r = (0 + (t.g - t.b) / (n - e)) / 6 : n === t.g ? r = (2 + (t.b - t.r) / (n - e)) / 6 : r = (4 + (t.r - t.g) / (n - e)) / 6, r < 0 && (r += 1), {
    h: r,
    w: e,
    b: 1 - n,
    a: t.a
  };
}
function $p(t) {
  const e = fu(t), n = e.w, r = 1 - e.b, o = (r + n) / 2;
  let i;
  return r === 0 || n === 1 ? i = 0 : i = (r - o) / Math.min(o, 1 - o), {
    h: e.h,
    s: i,
    l: o,
    a: t.a
  };
}
function Jf(t) {
  return "#" + Object.values(t).map((n) => {
    const r = n * 255, o = Math.round(r).toString(16);
    return o.length === 1 ? "0" + o : o;
  }).join("");
}
const NEe = {
  hex: [
    ["hsl", vEe],
    ["hsv", gEe],
    ["hwb", IEe],
    ["rgb", jf]
  ],
  hsl: [
    ["hex", OEe],
    ["hsv", EEe],
    ["hwb", AEe],
    ["rgb", Lp]
  ],
  hsv: [
    ["hex", SEe],
    ["hsl", pEe],
    ["hwb", mEe],
    ["rgb", xp]
  ],
  hwb: [
    ["hex", DEe],
    ["hsl", CEe],
    ["hsv", Up],
    ["rgb", kp]
  ],
  rgb: [
    ["hex", Jf],
    ["hsl", $p],
    ["hsv", J6],
    ["hwb", fu]
  ]
};
function vEe(t) {
  return $p(jf(t));
}
function gEe(t) {
  return J6(jf(t));
}
function IEe(t) {
  return fu(jf(t));
}
function OEe(t) {
  return Jf(Lp(t));
}
function AEe(t) {
  return fu(Lp(t));
}
function DEe(t) {
  return Jf(kp(t));
}
function CEe(t) {
  return $p(kp(t));
}
function kp(t) {
  return xp(Up(t));
}
function SEe(t) {
  return Jf(xp(t));
}
function J6(t) {
  return Up(fu(t));
}
function wEe(t) {
  if (!(typeof document.queryCommandSupported == "function" && document.queryCommandSupported("copy")))
    return !1;
  const e = document.createElement("textarea");
  e.textContent = t, e.style.position = "fixed", document.body.appendChild(e), e.select();
  let n;
  try {
    n = document.execCommand("copy");
  } catch {
    n = !1;
  } finally {
    document.body.removeChild(e);
  }
  return n;
}
const TEe = {
  hex(t) {
    return t;
  },
  hsl(t) {
    const e = Tn(t.h * 360), n = Tn(t.s * 100), r = Tn(t.l * 100), o = Tn(t.a);
    return `hsl(${e} ${n}% ${r}% / ${o})`;
  },
  hwb(t) {
    const e = Tn(t.h * 360), n = Tn(t.w * 100), r = Tn(t.b * 100), o = Tn(t.a);
    return `hwb(${e} ${n}% ${r}% / ${o})`;
  },
  rgb(t) {
    const e = Tn(t.r * 255), n = Tn(t.g * 255), r = Tn(t.b * 255), o = Tn(t.a);
    return `rgb(${e} ${n} ${r} / ${o})`;
  }
};
function Q6(t, e) {
  return TEe[e](t);
}
function e7(t) {
  return !t.startsWith("#") || ![3, 4, 6, 8].includes(t.length - 1) ? !1 : /^#[0-9A-Fa-f]+$/.test(t);
}
function bEe(t) {
  return Object.prototype.hasOwnProperty.call(t, "r") ? "rgb" : Object.prototype.hasOwnProperty.call(t, "w") ? "hwb" : Object.prototype.hasOwnProperty.call(t, "v") ? "hsv" : "hsl";
}
function REe(t) {
  if (typeof t != "string")
    return { format: bEe(t), color: t };
  if (e7(t))
    return { format: "hex", color: t };
  if (!t.includes("(")) {
    const s = document.createElement("span");
    if (s.style.display = "none", s.style.color = t, s.style.color === "")
      return null;
    document.body.appendChild(s), t = getComputedStyle(s).color, s.remove();
  }
  const [e, n] = t.split("("), r = e.substring(0, 3), o = n.replace(/[,/)]/g, " ").replace(/\s+/g, " ").trim().split(" ");
  o.length === 3 && o.push("1");
  const i = r.split("").concat("a"), a = Object.fromEntries(i.map((s, l) => [
    s,
    y0[r][s].from(o[l])
  ]));
  return { format: r, color: a };
}
const MEe = 10, rh = ["hex", "hsl", "hwb", "rgb"], PEe = {
  name: "ColorPicker",
  props: {
    color: {
      /** @type {PropType<string | ColorHsl | ColorHsv | ColorHwb | ColorRgb>} */
      type: [String, Object],
      required: !1,
      default: null
    },
    id: {
      type: String,
      required: !1,
      default: "color-picker"
    },
    visibleFormats: {
      /** @type {PropType<VisibleColorFormat[]>} */
      type: Array,
      required: !1,
      default: () => rh,
      validator: (t) => t.length > 0 && t.every((e) => rh.includes(e))
    },
    defaultFormat: {
      type: String,
      required: !1,
      default: "hsl",
      validator: (t) => rh.includes(t)
    }
  },
  emits: ["color-change"],
  setup(t, e) {
    const n = (
      /** @type {Ref<HTMLElement | null>} */
      W(null)
    ), r = (
      /** @type {Ref<HTMLElement | null>} */
      W(null)
    ), o = (
      /** @type {Ref<HTMLElement | null>} */
      W(null)
    ), i = W(!1), a = (
      /** @type {Ref<VisibleColorFormat>} */
      W(t.defaultFormat)
    ), s = (
      /** @type {ColorFormat[]} */
      ["hex", "hsl", "hsv", "hwb", "rgb"]
    ), l = (
      /** @type {UnwrapRef<any>} */
      Oa({
        hex: "#ffffffff",
        hsl: { h: 0, s: 0, l: 1, a: 1 },
        hsv: { h: 0, s: 0, v: 1, a: 1 },
        hwb: { h: 0, w: 1, b: 0, a: 1 },
        rgb: { r: 1, g: 1, b: 1, a: 1 }
      })
    );
    et(() => t.color, (b) => {
      N(b);
    }), ct(() => {
      document.addEventListener("mousemove", h, { passive: !1 }), document.addEventListener("touchmove", _, { passive: !1 }), document.addEventListener("mouseup", f), document.addEventListener("touchend", f), N(t.color);
    }), Li(() => {
      document.removeEventListener("mousemove", h), document.removeEventListener("touchmove", _), document.removeEventListener("mouseup", f), document.removeEventListener("touchend", f);
    });
    function c() {
      const b = t.visibleFormats.findIndex(($) => $ === a.value), P = b === t.visibleFormats.length - 1 ? 0 : b + 1;
      a.value = t.visibleFormats[P];
    }
    function u(b) {
      i.value = !0, h(b);
    }
    function d(b) {
      i.value = !0, _(b);
    }
    function f() {
      i.value = !1;
    }
    function h(b) {
      b.buttons !== 1 || i.value === !1 || !(r.value instanceof HTMLElement) || E(r.value, b.clientX, b.clientY);
    }
    function _(b) {
      i.value === !1 || !(r.value instanceof HTMLElement) || (b.preventDefault(), E(r.value, b.touches[0].clientX, b.touches[0].clientY));
    }
    function E(b, P, $) {
      const y = xEe(b, P, $), L = { ...l.hsv };
      L.s = y.x, L.v = y.y, D("hsv", L);
    }
    function m(b) {
      if (!["ArrowUp", "ArrowRight", "ArrowDown", "ArrowLeft"].includes(b.key))
        return;
      b.preventDefault();
      const P = ["ArrowLeft", "ArrowDown"].includes(b.key) ? -1 : 1, $ = ["ArrowLeft", "ArrowRight"].includes(b.key) ? "s" : "v", y = b.shiftKey ? 10 : 1, L = l.hsv[$] + P * y * 0.01, w = { ...l.hsv };
      w[$] = Ma(L, 0, 1), D("hsv", w);
    }
    function N(b) {
      if (b === null)
        return;
      const P = REe(b);
      P !== null && D(P.format, P.color);
    }
    function I(b) {
      const P = (
        /** @type {HTMLInputElement} */
        b.currentTarget
      ), $ = { ...l.hsv };
      $.h = parseInt(P.value) / 360, D("hsv", $);
    }
    function O(b) {
      const P = (
        /** @type {HTMLInputElement} */
        b.currentTarget
      ), $ = { ...l.hsv };
      $.a = parseInt(P.value) / 100, D("hsv", $);
    }
    function p(b) {
      const P = (
        /** @type {HTMLInputElement} */
        b.target
      );
      e7(P.value) && D("hex", P.value);
    }
    function C(b, P, $) {
      const y = (
        /** @type {HTMLInputElement} */
        b.target
      ), L = { ...l[P] }, w = y0[P][$].from(y.value);
      Number.isNaN(w) || w === void 0 || (L[$] = w, D(P, L));
    }
    function D(b, P) {
      if (!_Ee(l[b], P)) {
        l[b] = P;
        const $ = T(b);
        e.emit("color-change", $);
      }
    }
    function T(b) {
      for (const [P, $] of NEe[b])
        l[P] = $(l[b]);
      return n.value instanceof HTMLElement && r.value instanceof HTMLElement && o.value instanceof HTMLElement && yEe(n.value, r.value, o.value, l), LEe(l, a.value);
    }
    function k() {
      const b = l[a.value], P = Q6(b, a.value);
      wEe(P);
    }
    function G(b, P) {
      return y0[b][P].to(l[b][P]);
    }
    return {
      colorPicker: n,
      colorSpace: r,
      thumb: o,
      activeFormat: a,
      colors: l,
      pointerOriginatedInColorSpace: i,
      supportedFormats: s,
      startMovingThumbWithMouse: u,
      startMovingThumbWithTouch: d,
      moveThumbWithArrows: m,
      changeInputValue: UEe,
      copyColor: k,
      updateHue: I,
      updateAlpha: O,
      updateColorValue: C,
      updateHexColorValue: p,
      switchFormat: c,
      getChannelAsCssValue: G
    };
  }
};
function yEe(t, e, n, r) {
  t.style.setProperty("--vacp-hsl-h", String(r.hsl.h)), t.style.setProperty("--vacp-hsl-s", String(r.hsl.s)), t.style.setProperty("--vacp-hsl-l", String(r.hsl.l)), t.style.setProperty("--vacp-hsl-a", String(r.hsl.a)), e.setAttribute("style", `
    position: relative;
    background-color: hsl(calc(var(--vacp-hsl-h) * 360) 100% 50%);
    background-image:
      linear-gradient(to top, #000, transparent),
      linear-gradient(to right, #fff, transparent)
    ;
  `), n.setAttribute("style", `
    box-sizing: border-box;
    position: absolute;
    left: ${r.hsv.s * 100}%;
    bottom: ${r.hsv.v * 100}%;
  `);
}
function LEe(t, e) {
  return {
    colors: { ...t },
    cssColor: Q6(t[e], e)
  };
}
function xEe(t, e, n) {
  const r = t.getBoundingClientRect(), o = e - r.left, i = n - r.top;
  return {
    x: Ma(o / r.width, 0, 1),
    y: Ma(1 - i / r.height, 0, 1)
  };
}
function UEe(t) {
  if (!["ArrowUp", "ArrowRight", "ArrowDown", "ArrowLeft"].includes(t.key) || !t.shiftKey)
    return;
  const e = (
    /** @type {HTMLInputElement} */
    t.currentTarget
  ), n = parseFloat(e.step), r = ["ArrowLeft", "ArrowDown"].includes(t.key) ? -1 : 1, o = parseFloat(e.value) + r * n * MEe, i = Ma(o, parseInt(e.min), parseInt(e.max));
  e.value = String(i - r * n);
}
const $Ee = {
  ref: "colorPicker",
  class: "vacp-color-picker"
}, kEe = ["for"], BEe = { class: "vacp-range-input-label-text vacp-range-input-label-text--hue" }, GEe = ["id", "value"], FEe = ["for"], VEe = { class: "vacp-range-input-label-text vacp-range-input-label-text--alpha" }, HEe = ["id", "value"], WEe = { class: "vacp-color-inputs" }, YEe = { class: "vacp-color-input-group" }, KEe = ["for"], zEe = ["id", "value"], ZEe = ["id", "for", "onInput"], qEe = { class: "vacp-color-input-label-text" }, XEe = ["id", "value", "onInput"];
function jEe(t, e, n, r, o, i) {
  return v(), A("div", $Ee, [
    g("div", {
      ref: "colorSpace",
      class: "vacp-color-space",
      onMousedown: e[1] || (e[1] = (...a) => r.startMovingThumbWithMouse && r.startMovingThumbWithMouse(...a)),
      onTouchstart: e[2] || (e[2] = (...a) => r.startMovingThumbWithTouch && r.startMovingThumbWithTouch(...a))
    }, [
      g("div", {
        ref: "thumb",
        class: "vacp-color-space-thumb",
        tabindex: "0",
        "aria-label": "Color space thumb",
        onKeydown: e[0] || (e[0] = (...a) => r.moveThumbWithArrows && r.moveThumbWithArrows(...a))
      }, null, 544)
    ], 544),
    g("label", {
      class: "vacp-range-input-label vacp-range-input-label--hue",
      for: `${n.id}-hue-slider`
    }, [
      g("span", BEe, [
        ue(t.$slots, "hue-range-input-label", {}, () => [
          e[10] || (e[10] = me("Hue", -1))
        ])
      ]),
      g("input", {
        id: `${n.id}-hue-slider`,
        class: "vacp-range-input vacp-range-input--hue",
        value: r.colors.hsv.h * 360,
        type: "range",
        min: "0",
        max: "360",
        step: "1",
        onKeydownPassive: e[3] || (e[3] = (...a) => r.changeInputValue && r.changeInputValue(...a)),
        onInput: e[4] || (e[4] = (...a) => r.updateHue && r.updateHue(...a))
      }, null, 40, GEe)
    ], 8, kEe),
    g("label", {
      class: "vacp-range-input-label vacp-range-input-label--alpha",
      for: `${n.id}-alpha-slider`
    }, [
      g("span", VEe, [
        ue(t.$slots, "alpha-range-input-label", {}, () => [
          e[11] || (e[11] = me("Alpha", -1))
        ])
      ]),
      g("input", {
        id: `${n.id}-alpha-slider`,
        class: "vacp-range-input vacp-range-input--alpha",
        value: r.colors.hsv.a * 100,
        type: "range",
        min: "0",
        max: "100",
        step: "1",
        onKeydownPassive: e[5] || (e[5] = (...a) => r.changeInputValue && r.changeInputValue(...a)),
        onInput: e[6] || (e[6] = (...a) => r.updateAlpha && r.updateAlpha(...a))
      }, null, 40, HEe)
    ], 8, FEe),
    g("button", {
      class: "vacp-copy-button",
      type: "button",
      onClick: e[7] || (e[7] = (...a) => r.copyColor && r.copyColor(...a))
    }, [
      ue(t.$slots, "copy-button", {}, () => [
        e[12] || (e[12] = me(" Copy color ", -1))
      ])
    ]),
    g("div", WEe, [
      g("div", YEe, [
        r.activeFormat === "hex" ? (v(), A("label", {
          key: 0,
          class: "vacp-color-input-label",
          for: `${n.id}-color-hex`
        }, [
          e[13] || (e[13] = g("span", { class: "vacp-color-input-label-text" }, " Hex ", -1)),
          g("input", {
            id: `${n.id}-color-hex`,
            class: "vacp-color-input",
            type: "text",
            value: r.colors.hex,
            onInput: e[8] || (e[8] = (a) => r.updateHexColorValue(a))
          }, null, 40, zEe)
        ], 8, KEe)) : (v(!0), A(ge, { key: 1 }, ye(Object.keys(r.colors[r.activeFormat]), (a) => (v(), A("label", {
          id: `${n.id}-color-${r.activeFormat}-${a}`,
          key: `${n.id}-color-${r.activeFormat}-${a}`,
          class: "vacp-color-input-label",
          for: `${n.id}-color-${r.activeFormat}`,
          onInput: (s) => r.updateColorValue(s, r.activeFormat, a)
        }, [
          g("span", qEe, Q(a.toUpperCase()), 1),
          g("input", {
            id: `${n.id}-color-${r.activeFormat}`,
            class: "vacp-color-input",
            type: "text",
            value: r.getChannelAsCssValue(r.activeFormat, a),
            onInput: (s) => r.updateColorValue(s, r.activeFormat, a)
          }, null, 40, XEe)
        ], 40, ZEe))), 128))
      ]),
      n.visibleFormats.length > 1 ? (v(), A("button", {
        key: 0,
        class: "vacp-format-switch-button",
        type: "button",
        onClick: e[9] || (e[9] = (...a) => r.switchFormat && r.switchFormat(...a))
      }, [
        ue(t.$slots, "format-switch-button", {}, () => [
          e[14] || (e[14] = me(" Switch format ", -1))
        ])
      ])) : V("", !0)
    ])
  ], 512);
}
const JEe = /* @__PURE__ */ Y(PEe, [["render", jEe]]), QEe = {
  props: {
    modelValue: {
      type: String,
      required: !0
    },
    readOnly: {
      type: Boolean,
      default: !1
    },
    colorPresets: {
      type: Array
    }
  },
  components: {
    ColorPicker: JEe,
    oInput: Nc,
    Spacer: He,
    oButton: ln,
    Popout: JE
  },
  emits: ["update:modelValue"],
  setup: (t, { emit: e }) => {
    const n = W(t.modelValue), r = W(t.modelValue), o = x(() => r.value + "ff"), i = W(!1);
    et(t, async ({ modelValue: u }) => {
      r.value = u, n.value = u;
    });
    const a = ({ colors: u }) => {
      const d = u.hex.slice(0, 7);
      e("update:modelValue", d), n.value = d;
    }, s = () => {
      c(n.value) || a({ colors: { hex: n.value } });
    }, l = () => {
      i.value === !1 ? i.value = !0 : i.value = !1;
    }, c = (u) => {
      if (!/^#[0-9A-F]{6}$/i.test(u))
        return "Color must be a hex code in the format #xxxxxx";
    };
    return {
      selectedColor: r,
      selectedColorInput: n,
      updateColor: a,
      applyColorInput: s,
      selectedColorWithAlpha: o,
      validator: c,
      pickerOpen: i,
      togglePicker: l
    };
  }
};
const epe = { class: "w-100" }, tpe = { key: 0 }, npe = { class: "color-circle-container" }, rpe = {
  key: 1,
  class: "relative"
}, ope = {
  key: 0,
  class: "colour-circle-container"
}, ipe = ["onClick"], ape = { class: "color-circle-container" };
function spe(t, e, n, r, o, i) {
  const a = ee("oInput"), s = ee("oButton"), l = ee("ColorPicker"), c = ee("Popout");
  return v(), A("div", epe, [
    n.readOnly ? (v(), A("div", tpe, [
      H(a, {
        color: t.selectedColor,
        readonly: "",
        modelValue: t.selectedColorInput,
        "onUpdate:modelValue": e[0] || (e[0] = (u) => t.selectedColorInput = u),
        validator: t.validator
      }, {
        prefix: q(() => [
          g("div", npe, [
            g("div", {
              class: "color-circle",
              style: Fe({ backgroundColor: t.selectedColor })
            }, null, 4)
          ])
        ]),
        _: 1
      }, 8, ["color", "modelValue", "validator"])
    ])) : (v(), A("div", rpe, [
      H(c, {
        modelValue: t.pickerOpen,
        "onUpdate:modelValue": e[2] || (e[2] = (u) => t.pickerOpen = u),
        externalToggleButton: !0,
        trapFocus: !0,
        offset: [0, 44],
        placement: "bottom-end"
      }, {
        content: q(() => [
          g("div", null, [
            H(l, {
              class: "color-picker db",
              color: t.selectedColorWithAlpha,
              "visible-formats": ["rgb"],
              "default-format": "rgb",
              onColorChange: t.updateColor
            }, null, 8, ["color", "onColorChange"]),
            n.colorPresets && n.colorPresets.length ? (v(), A("div", ope, [
              (v(!0), A(ge, null, ye(n.colorPresets, (u) => (v(), A("div", {
                key: u.name,
                style: Fe({ backgroundColor: u }),
                class: "colour-circle",
                onClick: (d) => t.selectedColor = u
              }, null, 12, ipe))), 128))
            ])) : V("", !0)
          ])
        ]),
        default: q(() => [
          H(s, {
            color: "white",
            size: "small",
            class: "color-popout-button",
            onClicked: e[1] || (e[1] = (u) => t.togglePicker())
          }, {
            default: q(() => [...e[4] || (e[4] = [
              me(" Color Picker ", -1)
            ])]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      H(a, {
        color: t.selectedColor,
        modelValue: t.selectedColorInput,
        "onUpdate:modelValue": e[3] || (e[3] = (u) => t.selectedColorInput = u),
        onBlur: t.applyColorInput,
        onKeyup: DO(t.applyColorInput, ["enter"]),
        validator: t.validator
      }, {
        prefix: q(() => [
          g("div", ape, [
            g("div", {
              class: "color-circle",
              style: Fe({ backgroundColor: t.selectedColor })
            }, null, 4)
          ])
        ]),
        _: 1
      }, 8, ["color", "modelValue", "onBlur", "onKeyup", "validator"])
    ]))
  ]);
}
const gPe = /* @__PURE__ */ Y(QEe, [["render", spe], ["__scopeId", "data-v-fe9be355"]]), Bp = {
  props: {
    modelValue: {
      type: Boolean,
      required: !1
    },
    mode: {
      type: String,
      required: !1,
      default: "default"
    },
    position: {
      type: String,
      required: !1,
      default: "relative"
    },
    setBoundingRect: {
      type: Object
    },
    buttonText: {
      type: String,
      required: !1
    },
    fullWidth: {
      type: Boolean,
      required: !1,
      default: !0
    },
    maxWidth: {
      type: String,
      required: !1,
      default: "59.5rem"
    },
    contentMaxWidth: {
      type: String,
      required: !1,
      default: "25rem"
    },
    transition: {
      type: String,
      required: !1
    },
    transitionDelay: {
      // transitionDelay should be given in milliseconds (ms)
      type: Number,
      required: !1,
      default: 0
    },
    column: {
      type: Boolean,
      required: !1,
      default: !1
    },
    gap: {
      type: String,
      required: !1,
      default: "1.5rem"
    },
    expandable: {
      type: Boolean,
      required: !1
    },
    // Minimum: 1
    visibleLines: {
      type: Number,
      required: !1
    }
  },
  components: { oButton: ln, Spacer: He, Text: Ye, SelectArrow: nu },
  emits: ["closed", "update:modelValue"],
  inheritAttrs: !1,
  setup(t, { emit: e, attrs: n }) {
    const { aboveMobile: r } = Io(), o = () => {
      e("update:modelValue", !1), e("closed");
    }, i = x(() => t.mode === "large-modal"), a = x(() => t.mode === "bottom-banner" ? "2.5rem" : "0rem"), s = x(() => {
      const { translateX: _ = 0, translateY: E = 0 } = t.setBoundingRect ?? {};
      return {
        ...t.setBoundingRect,
        ..._ || E ? { transform: `translate(${_}, ${E})` } : {}
      };
    }), l = x(() => n.style), c = x(() => t.mode === "large-modal" || t.mode === "bottom-banner" ? "onboarding-slide-in" : t.transition ? `onboarding-${t.transition}` : "onboarding-no-transition"), u = x(() => `${t.transitionDelay}ms`), d = x(() => !!(t.expandable || t.column)), f = W(!1), h = x(() => f.value ? "Show Less" : "Show More");
    return {
      close: o,
      isLargeModal: i,
      maxWidthOffset: a,
      boundingRect: s,
      styles: l,
      transitionDirection: c,
      verticalSpacer: d,
      aboveMobile: r,
      expanded: f,
      expandedButtonLabel: h,
      transitionDelayMS: u
    };
  }
}, H3 = () => {
  Wr((t) => ({
    v7ca122b6: t.transitionDelayMS
  }));
}, W3 = Bp.setup;
Bp.setup = W3 ? (t, e) => (H3(), W3(t, e)) : H3;
const lpe = { key: 0 }, cpe = { key: 1 };
function upe(t, e, n, r, o, i) {
  const a = ee("Text"), s = ee("Spacer"), l = ee("SelectArrow"), c = ee("oButton");
  return v(), te(Zt, {
    name: r.transitionDirection,
    duration: n.mode === "default" && !n.transition ? 0 : 1e3 + n.transitionDelay,
    mode: "out-in",
    appear: ""
  }, {
    default: q(() => [
      n.modelValue ? (v(), A("div", {
        key: 0,
        class: z(["onboarding-outer-container", n.mode, n.position, { "full-width": n.fullWidth }]),
        style: Fe([
          r.aboveMobile ? n.position === "absolute" ? { width: `calc(${n.maxWidth} + ${r.maxWidthOffset})` } : { maxWidth: `calc(${n.maxWidth} + ${r.maxWidthOffset})` } : { maxWidth: "100%" },
          { ...r.boundingRect }
        ])
      }, [
        g("div", {
          class: z(["onboarding", { "is-column": n.column || n.expandable }]),
          style: Fe(r.styles)
        }, [
          r.isLargeModal ? (v(), A("header", lpe, [
            H(a, {
              as: "h3",
              align: "center",
              color: "dark-blue",
              style: Fe(["line-height: 1.625rem", { maxWidth: n.contentMaxWidth }])
            }, {
              default: q(() => [
                ue(t.$slots, "header", {}, void 0, !0)
              ]),
              _: 3
            }, 8, ["style"]),
            H(s, { height: "1.5rem" })
          ])) : V("", !0),
          H(a, {
            as: "p",
            size: r.isLargeModal ? "f-7" : "f-8",
            align: r.isLargeModal || !r.aboveMobile ? "center" : "left",
            color: "dark-blue",
            style: Fe([
              r.isLargeModal ? { maxWidth: n.contentMaxWidth } : "width: 100%",
              n.expandable ? { height: n.visibleLines * 21 + "px", overflow: "hidden" } : "height: auto",
              r.expanded ? "height: auto" : { height: n.visibleLines * 21 + "px" }
            ])
          }, {
            default: q(() => [
              ue(t.$slots, "copy", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["size", "align", "style"]),
          n.buttonText || r.expandedButtonLabel ? (v(), A("div", cpe, [
            r.verticalSpacer ? (v(), te(s, {
              key: 0,
              height: n.gap
            }, null, 8, ["height"])) : (v(), te(s, {
              key: 1,
              width: n.gap
            }, null, 8, ["width"]))
          ])) : V("", !0),
          t.$slots.button ? ue(t.$slots, "button", { key: 2 }, void 0, !0) : V("", !0),
          (n.buttonText || n.expandable) && !t.$slots.button ? (v(), te(c, {
            key: 3,
            onClicked: e[0] || (e[0] = (u) => n.expandable ? r.expanded = !r.expanded : r.close()),
            color: "dark-blue"
          }, K_({
            default: q(() => [
              me(Q(n.expandable ? r.expandedButtonLabel : n.buttonText) + " ", 1)
            ]),
            _: 2
          }, [
            n.expandable ? {
              name: "icon",
              fn: q(() => [
                H(l, {
                  class: z(["select-arrow", { "rotate-icon": r.expanded }]),
                  hex: "#fff"
                }, null, 8, ["class"])
              ]),
              key: "0"
            } : void 0
          ]), 1024)) : V("", !0)
        ], 6)
      ], 6)) : V("", !0)
    ]),
    _: 3
  }, 8, ["name", "duration"]);
}
const IPe = /* @__PURE__ */ Y(Bp, [["render", upe], ["__scopeId", "data-v-02e9fd38"]]), dpe = Ne({
  name: "Panel",
  components: {
    Spacer: He,
    Text: Ye,
    oButton: ln,
    CloseButton: qE,
    ViewBackground: ru
  },
  props: {
    width: {
      type: Number,
      required: !1,
      default: 932
    },
    title: {
      type: String,
      required: !0
    },
    modelValue: {
      type: Boolean,
      required: !1,
      default: !1
    },
    position: {
      type: String,
      required: !1,
      default: "right"
    },
    noPadding: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["update:modelValue", "close"],
  setup(t, { emit: e }) {
    const n = W(null), r = Ga(t, "modelValue"), { aboveiPadLandscape: o } = Io();
    function i() {
      e("close"), e("update:modelValue", !1);
    }
    return Zf(r, !1), Rf(n, (a) => {
      i();
    }), hf(() => {
      document.body.classList.remove("no-scroll-fixed"), document.body.classList.remove("no-scroll"), document.body.style.removeProperty("top");
    }), { target: n, panelOpen: r, closePanel: i, aboveiPadLandscape: o };
  }
});
const fpe = { class: "title" }, hpe = { class: "left" }, _pe = { class: "title-slot" }, Epe = { class: "content" }, ppe = {
  key: 0,
  class: "footer"
};
function mpe(t, e, n, r, o, i) {
  const a = ee("ViewBackground"), s = ee("Text"), l = ee("CloseButton"), c = ee("perfect-scrollbar");
  return v(), A(ge, null, [
    H(a, {
      active: t.panelOpen,
      zIndex: 2147482999
    }, null, 8, ["active"]),
    H(Zt, { name: "fade-up" }, {
      default: q(() => [
        t.panelOpen ? (v(), A("div", {
          key: 0,
          ref: "target",
          class: z(["o-panel", t.position, t.$slots.footer ? "has-footer" : ""]),
          style: Fe(t.aboveiPadLandscape ? { width: t.width + "px" } : "width: calc(100% - 2rem)")
        }, [
          g("div", fpe, [
            g("div", hpe, [
              H(s, {
                as: "h2",
                size: "f-4",
                weight: "600"
              }, {
                default: q(() => [
                  me(Q(t.title), 1)
                ]),
                _: 1
              }),
              g("div", _pe, [
                ue(t.$slots, "title", {}, void 0, !0)
              ])
            ]),
            H(l, {
              onClicked: e[0] || (e[0] = (u) => t.closePanel()),
              tooltip: !1,
              class: "close-button"
            })
          ]),
          g("div", Epe, [
            H(c, {
              class: z(["scroller", t.noPadding ? "no-padding" : ""])
            }, {
              default: q(() => [
                ue(t.$slots, "content", {}, void 0, !0)
              ]),
              _: 3
            }, 8, ["class"])
          ]),
          t.$slots.footer ? (v(), A("div", ppe, [
            ue(t.$slots, "footer", {}, void 0, !0)
          ])) : V("", !0),
          ue(t.$slots, "batch", {}, void 0, !0)
        ], 6)) : V("", !0)
      ]),
      _: 3
    })
  ], 64);
}
const OPe = /* @__PURE__ */ Y(dpe, [["render", mpe], ["__scopeId", "data-v-9fe4a85a"]]);
function t7(t, e, n) {
  for (var r = -1, o = t.length; ++r < o; ) {
    var i = t[r], a = e(i);
    if (a != null && (s === void 0 ? a === a && !Ra(a) : n(a, s)))
      var s = a, l = i;
  }
  return l;
}
function Npe(t, e) {
  return t > e;
}
function vpe() {
  this.__data__ = [], this.size = 0;
}
function n7(t, e) {
  return t === e || t !== t && e !== e;
}
function Qf(t, e) {
  for (var n = t.length; n--; )
    if (n7(t[n][0], e))
      return n;
  return -1;
}
var gpe = Array.prototype, Ipe = gpe.splice;
function Ope(t) {
  var e = this.__data__, n = Qf(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : Ipe.call(e, n, 1), --this.size, !0;
}
function Ape(t) {
  var e = this.__data__, n = Qf(e, t);
  return n < 0 ? void 0 : e[n][1];
}
function Dpe(t) {
  return Qf(this.__data__, t) > -1;
}
function Cpe(t, e) {
  var n = this.__data__, r = Qf(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
function jo(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
jo.prototype.clear = vpe;
jo.prototype.delete = Ope;
jo.prototype.get = Ape;
jo.prototype.has = Dpe;
jo.prototype.set = Cpe;
function Spe() {
  this.__data__ = new jo(), this.size = 0;
}
function wpe(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
function Tpe(t) {
  return this.__data__.get(t);
}
function bpe(t) {
  return this.__data__.has(t);
}
function Tc(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Rpe = "[object AsyncFunction]", Mpe = "[object Function]", Ppe = "[object GeneratorFunction]", ype = "[object Proxy]";
function r7(t) {
  if (!Tc(t))
    return !1;
  var e = Va(t);
  return e == Mpe || e == Ppe || e == Rpe || e == ype;
}
var Lpe = Zo["__core-js_shared__"];
const oh = Lpe;
var Y3 = function() {
  var t = /[^.]+$/.exec(oh && oh.keys && oh.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function xpe(t) {
  return !!Y3 && Y3 in t;
}
var Upe = Function.prototype, $pe = Upe.toString;
function Ka(t) {
  if (t != null) {
    try {
      return $pe.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var kpe = /[\\^$.*+?()[\]{}|]/g, Bpe = /^\[object .+?Constructor\]$/, Gpe = Function.prototype, Fpe = Object.prototype, Vpe = Gpe.toString, Hpe = Fpe.hasOwnProperty, Wpe = RegExp(
  "^" + Vpe.call(Hpe).replace(kpe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Ype(t) {
  if (!Tc(t) || xpe(t))
    return !1;
  var e = r7(t) ? Wpe : Bpe;
  return e.test(Ka(t));
}
function Kpe(t, e) {
  return t == null ? void 0 : t[e];
}
function za(t, e) {
  var n = Kpe(t, e);
  return Ype(n) ? n : void 0;
}
var zpe = za(Zo, "Map");
const bc = zpe;
var Zpe = za(Object, "create");
const Rc = Zpe;
function qpe() {
  this.__data__ = Rc ? Rc(null) : {}, this.size = 0;
}
function Xpe(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var jpe = "__lodash_hash_undefined__", Jpe = Object.prototype, Qpe = Jpe.hasOwnProperty;
function e2e(t) {
  var e = this.__data__;
  if (Rc) {
    var n = e[t];
    return n === jpe ? void 0 : n;
  }
  return Qpe.call(e, t) ? e[t] : void 0;
}
var t2e = Object.prototype, n2e = t2e.hasOwnProperty;
function r2e(t) {
  var e = this.__data__;
  return Rc ? e[t] !== void 0 : n2e.call(e, t);
}
var o2e = "__lodash_hash_undefined__";
function i2e(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = Rc && e === void 0 ? o2e : e, this;
}
function Pa(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Pa.prototype.clear = qpe;
Pa.prototype.delete = Xpe;
Pa.prototype.get = e2e;
Pa.prototype.has = r2e;
Pa.prototype.set = i2e;
function a2e() {
  this.size = 0, this.__data__ = {
    hash: new Pa(),
    map: new (bc || jo)(),
    string: new Pa()
  };
}
function s2e(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function e1(t, e) {
  var n = t.__data__;
  return s2e(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
function l2e(t) {
  var e = e1(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
function c2e(t) {
  return e1(this, t).get(t);
}
function u2e(t) {
  return e1(this, t).has(t);
}
function d2e(t, e) {
  var n = e1(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
function Jo(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Jo.prototype.clear = a2e;
Jo.prototype.delete = l2e;
Jo.prototype.get = c2e;
Jo.prototype.has = u2e;
Jo.prototype.set = d2e;
var f2e = 200;
function h2e(t, e) {
  var n = this.__data__;
  if (n instanceof jo) {
    var r = n.__data__;
    if (!bc || r.length < f2e - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new Jo(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
function Vo(t) {
  var e = this.__data__ = new jo(t);
  this.size = e.size;
}
Vo.prototype.clear = Spe;
Vo.prototype.delete = wpe;
Vo.prototype.get = Tpe;
Vo.prototype.has = bpe;
Vo.prototype.set = h2e;
var _2e = "__lodash_hash_undefined__";
function E2e(t) {
  return this.__data__.set(t, _2e), this;
}
function p2e(t) {
  return this.__data__.has(t);
}
function Mc(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new Jo(); ++e < n; )
    this.add(t[e]);
}
Mc.prototype.add = Mc.prototype.push = E2e;
Mc.prototype.has = p2e;
function m2e(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r; )
    if (e(t[n], n, t))
      return !0;
  return !1;
}
function o7(t, e) {
  return t.has(e);
}
var N2e = 1, v2e = 2;
function i7(t, e, n, r, o, i) {
  var a = n & N2e, s = t.length, l = e.length;
  if (s != l && !(a && l > s))
    return !1;
  var c = i.get(t), u = i.get(e);
  if (c && u)
    return c == e && u == t;
  var d = -1, f = !0, h = n & v2e ? new Mc() : void 0;
  for (i.set(t, e), i.set(e, t); ++d < s; ) {
    var _ = t[d], E = e[d];
    if (r)
      var m = a ? r(E, _, d, e, t, i) : r(_, E, d, t, e, i);
    if (m !== void 0) {
      if (m)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!m2e(e, function(N, I) {
        if (!o7(h, I) && (_ === N || o(_, N, n, r, i)))
          return h.push(I);
      })) {
        f = !1;
        break;
      }
    } else if (!(_ === E || o(_, E, n, r, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(t), i.delete(e), f;
}
var g2e = Zo.Uint8Array;
const K3 = g2e;
function I2e(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r, o) {
    n[++e] = [o, r];
  }), n;
}
function Gp(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r) {
    n[++e] = r;
  }), n;
}
var O2e = 1, A2e = 2, D2e = "[object Boolean]", C2e = "[object Date]", S2e = "[object Error]", w2e = "[object Map]", T2e = "[object Number]", b2e = "[object RegExp]", R2e = "[object Set]", M2e = "[object String]", P2e = "[object Symbol]", y2e = "[object ArrayBuffer]", L2e = "[object DataView]", z3 = Eo ? Eo.prototype : void 0, ih = z3 ? z3.valueOf : void 0;
function x2e(t, e, n, r, o, i, a) {
  switch (n) {
    case L2e:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case y2e:
      return !(t.byteLength != e.byteLength || !i(new K3(t), new K3(e)));
    case D2e:
    case C2e:
    case T2e:
      return n7(+t, +e);
    case S2e:
      return t.name == e.name && t.message == e.message;
    case b2e:
    case M2e:
      return t == e + "";
    case w2e:
      var s = I2e;
    case R2e:
      var l = r & O2e;
      if (s || (s = Gp), t.size != e.size && !l)
        return !1;
      var c = a.get(t);
      if (c)
        return c == e;
      r |= A2e, a.set(t, e);
      var u = i7(s(t), s(e), r, o, i, a);
      return a.delete(t), u;
    case P2e:
      if (ih)
        return ih.call(t) == ih.call(e);
  }
  return !1;
}
function a7(t, e) {
  for (var n = -1, r = e.length, o = t.length; ++n < r; )
    t[o + n] = e[n];
  return t;
}
function U2e(t, e, n) {
  var r = e(t);
  return xn(t) ? r : a7(r, n(t));
}
function s7(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, o = 0, i = []; ++n < r; ) {
    var a = t[n];
    e(a, n, t) && (i[o++] = a);
  }
  return i;
}
function $2e() {
  return [];
}
var k2e = Object.prototype, B2e = k2e.propertyIsEnumerable, Z3 = Object.getOwnPropertySymbols, G2e = Z3 ? function(t) {
  return t == null ? [] : (t = Object(t), s7(Z3(t), function(e) {
    return B2e.call(t, e);
  }));
} : $2e;
const F2e = G2e;
function V2e(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var H2e = "[object Arguments]";
function q3(t) {
  return Sa(t) && Va(t) == H2e;
}
var l7 = Object.prototype, W2e = l7.hasOwnProperty, Y2e = l7.propertyIsEnumerable, K2e = q3(function() {
  return arguments;
}()) ? q3 : function(t) {
  return Sa(t) && W2e.call(t, "callee") && !Y2e.call(t, "callee");
};
const Fp = K2e;
function z2e() {
  return !1;
}
var c7 = typeof exports == "object" && exports && !exports.nodeType && exports, X3 = c7 && typeof module == "object" && module && !module.nodeType && module, Z2e = X3 && X3.exports === c7, j3 = Z2e ? Zo.Buffer : void 0, q2e = j3 ? j3.isBuffer : void 0, X2e = q2e || z2e;
const L0 = X2e;
var j2e = 9007199254740991, J2e = /^(?:0|[1-9]\d*)$/;
function u7(t, e) {
  var n = typeof t;
  return e = e ?? j2e, !!e && (n == "number" || n != "symbol" && J2e.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var Q2e = 9007199254740991;
function Vp(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= Q2e;
}
var eme = "[object Arguments]", tme = "[object Array]", nme = "[object Boolean]", rme = "[object Date]", ome = "[object Error]", ime = "[object Function]", ame = "[object Map]", sme = "[object Number]", lme = "[object Object]", cme = "[object RegExp]", ume = "[object Set]", dme = "[object String]", fme = "[object WeakMap]", hme = "[object ArrayBuffer]", _me = "[object DataView]", Eme = "[object Float32Array]", pme = "[object Float64Array]", mme = "[object Int8Array]", Nme = "[object Int16Array]", vme = "[object Int32Array]", gme = "[object Uint8Array]", Ime = "[object Uint8ClampedArray]", Ome = "[object Uint16Array]", Ame = "[object Uint32Array]", Dt = {};
Dt[Eme] = Dt[pme] = Dt[mme] = Dt[Nme] = Dt[vme] = Dt[gme] = Dt[Ime] = Dt[Ome] = Dt[Ame] = !0;
Dt[eme] = Dt[tme] = Dt[hme] = Dt[nme] = Dt[_me] = Dt[rme] = Dt[ome] = Dt[ime] = Dt[ame] = Dt[sme] = Dt[lme] = Dt[cme] = Dt[ume] = Dt[dme] = Dt[fme] = !1;
function Dme(t) {
  return Sa(t) && Vp(t.length) && !!Dt[Va(t)];
}
function d7(t) {
  return function(e) {
    return t(e);
  };
}
var f7 = typeof exports == "object" && exports && !exports.nodeType && exports, tc = f7 && typeof module == "object" && module && !module.nodeType && module, Cme = tc && tc.exports === f7, ah = Cme && j4.process, Sme = function() {
  try {
    var t = tc && tc.require && tc.require("util").types;
    return t || ah && ah.binding && ah.binding("util");
  } catch {
  }
}();
const J3 = Sme;
var Q3 = J3 && J3.isTypedArray, wme = Q3 ? d7(Q3) : Dme;
const h7 = wme;
var Tme = Object.prototype, bme = Tme.hasOwnProperty;
function Rme(t, e) {
  var n = xn(t), r = !n && Fp(t), o = !n && !r && L0(t), i = !n && !r && !o && h7(t), a = n || r || o || i, s = a ? V2e(t.length, String) : [], l = s.length;
  for (var c in t)
    (e || bme.call(t, c)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    u7(c, l))) && s.push(c);
  return s;
}
var Mme = Object.prototype;
function Pme(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || Mme;
  return t === n;
}
function yme(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var Lme = yme(Object.keys, Object);
const xme = Lme;
var Ume = Object.prototype, $me = Ume.hasOwnProperty;
function kme(t) {
  if (!Pme(t))
    return xme(t);
  var e = [];
  for (var n in Object(t))
    $me.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
function Hp(t) {
  return t != null && Vp(t.length) && !r7(t);
}
function Wp(t) {
  return Hp(t) ? Rme(t) : kme(t);
}
function eg(t) {
  return U2e(t, Wp, F2e);
}
var Bme = 1, Gme = Object.prototype, Fme = Gme.hasOwnProperty;
function Vme(t, e, n, r, o, i) {
  var a = n & Bme, s = eg(t), l = s.length, c = eg(e), u = c.length;
  if (l != u && !a)
    return !1;
  for (var d = l; d--; ) {
    var f = s[d];
    if (!(a ? f in e : Fme.call(e, f)))
      return !1;
  }
  var h = i.get(t), _ = i.get(e);
  if (h && _)
    return h == e && _ == t;
  var E = !0;
  i.set(t, e), i.set(e, t);
  for (var m = a; ++d < l; ) {
    f = s[d];
    var N = t[f], I = e[f];
    if (r)
      var O = a ? r(I, N, f, e, t, i) : r(N, I, f, t, e, i);
    if (!(O === void 0 ? N === I || o(N, I, n, r, i) : O)) {
      E = !1;
      break;
    }
    m || (m = f == "constructor");
  }
  if (E && !m) {
    var p = t.constructor, C = e.constructor;
    p != C && "constructor" in t && "constructor" in e && !(typeof p == "function" && p instanceof p && typeof C == "function" && C instanceof C) && (E = !1);
  }
  return i.delete(t), i.delete(e), E;
}
var Hme = za(Zo, "DataView");
const x0 = Hme;
var Wme = za(Zo, "Promise");
const U0 = Wme;
var Yme = za(Zo, "Set");
const Ts = Yme;
var Kme = za(Zo, "WeakMap");
const $0 = Kme;
var tg = "[object Map]", zme = "[object Object]", ng = "[object Promise]", rg = "[object Set]", og = "[object WeakMap]", ig = "[object DataView]", Zme = Ka(x0), qme = Ka(bc), Xme = Ka(U0), jme = Ka(Ts), Jme = Ka($0), ta = Va;
(x0 && ta(new x0(new ArrayBuffer(1))) != ig || bc && ta(new bc()) != tg || U0 && ta(U0.resolve()) != ng || Ts && ta(new Ts()) != rg || $0 && ta(new $0()) != og) && (ta = function(t) {
  var e = Va(t), n = e == zme ? t.constructor : void 0, r = n ? Ka(n) : "";
  if (r)
    switch (r) {
      case Zme:
        return ig;
      case qme:
        return tg;
      case Xme:
        return ng;
      case jme:
        return rg;
      case Jme:
        return og;
    }
  return e;
});
const ag = ta;
var Qme = 1, sg = "[object Arguments]", lg = "[object Array]", Gu = "[object Object]", eNe = Object.prototype, cg = eNe.hasOwnProperty;
function tNe(t, e, n, r, o, i) {
  var a = xn(t), s = xn(e), l = a ? lg : ag(t), c = s ? lg : ag(e);
  l = l == sg ? Gu : l, c = c == sg ? Gu : c;
  var u = l == Gu, d = c == Gu, f = l == c;
  if (f && L0(t)) {
    if (!L0(e))
      return !1;
    a = !0, u = !1;
  }
  if (f && !u)
    return i || (i = new Vo()), a || h7(t) ? i7(t, e, n, r, o, i) : x2e(t, e, l, n, r, o, i);
  if (!(n & Qme)) {
    var h = u && cg.call(t, "__wrapped__"), _ = d && cg.call(e, "__wrapped__");
    if (h || _) {
      var E = h ? t.value() : t, m = _ ? e.value() : e;
      return i || (i = new Vo()), o(E, m, n, r, i);
    }
  }
  return f ? (i || (i = new Vo()), Vme(t, e, n, r, o, i)) : !1;
}
function Yp(t, e, n, r, o) {
  return t === e ? !0 : t == null || e == null || !Sa(t) && !Sa(e) ? t !== t && e !== e : tNe(t, e, n, r, Yp, o);
}
var nNe = 1, rNe = 2;
function oNe(t, e, n, r) {
  var o = n.length, i = o, a = !r;
  if (t == null)
    return !i;
  for (t = Object(t); o--; ) {
    var s = n[o];
    if (a && s[2] ? s[1] !== t[s[0]] : !(s[0] in t))
      return !1;
  }
  for (; ++o < i; ) {
    s = n[o];
    var l = s[0], c = t[l], u = s[1];
    if (a && s[2]) {
      if (c === void 0 && !(l in t))
        return !1;
    } else {
      var d = new Vo();
      if (r)
        var f = r(c, u, l, t, e, d);
      if (!(f === void 0 ? Yp(u, c, nNe | rNe, r, d) : f))
        return !1;
    }
  }
  return !0;
}
function _7(t) {
  return t === t && !Tc(t);
}
function iNe(t) {
  for (var e = Wp(t), n = e.length; n--; ) {
    var r = e[n], o = t[r];
    e[n] = [r, o, _7(o)];
  }
  return e;
}
function E7(t, e) {
  return function(n) {
    return n == null ? !1 : n[t] === e && (e !== void 0 || t in Object(n));
  };
}
function aNe(t) {
  var e = iNe(t);
  return e.length == 1 && e[0][2] ? E7(e[0][0], e[0][1]) : function(n) {
    return n === t || oNe(n, t, e);
  };
}
var sNe = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, lNe = /^\w*$/;
function Kp(t, e) {
  if (xn(t))
    return !1;
  var n = typeof t;
  return n == "number" || n == "symbol" || n == "boolean" || t == null || Ra(t) ? !0 : lNe.test(t) || !sNe.test(t) || e != null && t in Object(e);
}
var cNe = "Expected a function";
function zp(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(cNe);
  var n = function() {
    var r = arguments, o = e ? e.apply(this, r) : r[0], i = n.cache;
    if (i.has(o))
      return i.get(o);
    var a = t.apply(this, r);
    return n.cache = i.set(o, a) || i, a;
  };
  return n.cache = new (zp.Cache || Jo)(), n;
}
zp.Cache = Jo;
var uNe = 500;
function dNe(t) {
  var e = zp(t, function(r) {
    return n.size === uNe && n.clear(), r;
  }), n = e.cache;
  return e;
}
var fNe = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, hNe = /\\(\\)?/g, _Ne = dNe(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(fNe, function(n, r, o, i) {
    e.push(o ? i.replace(hNe, "$1") : r || n);
  }), e;
});
const ENe = _Ne;
function p7(t, e) {
  return xn(t) ? t : Kp(t, e) ? [t] : ENe(cu(t));
}
var pNe = 1 / 0;
function t1(t) {
  if (typeof t == "string" || Ra(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -pNe ? "-0" : e;
}
function Zp(t, e) {
  e = p7(e, t);
  for (var n = 0, r = e.length; t != null && n < r; )
    t = t[t1(e[n++])];
  return n && n == r ? t : void 0;
}
function mNe(t, e, n) {
  var r = t == null ? void 0 : Zp(t, e);
  return r === void 0 ? n : r;
}
function NNe(t, e) {
  return t != null && e in Object(t);
}
function vNe(t, e, n) {
  e = p7(e, t);
  for (var r = -1, o = e.length, i = !1; ++r < o; ) {
    var a = t1(e[r]);
    if (!(i = t != null && n(t, a)))
      break;
    t = t[a];
  }
  return i || ++r != o ? i : (o = t == null ? 0 : t.length, !!o && Vp(o) && u7(a, o) && (xn(t) || Fp(t)));
}
function gNe(t, e) {
  return t != null && vNe(t, e, NNe);
}
var INe = 1, ONe = 2;
function ANe(t, e) {
  return Kp(t) && _7(e) ? E7(t1(t), e) : function(n) {
    var r = mNe(n, t);
    return r === void 0 && r === e ? gNe(n, t) : Yp(e, r, INe | ONe);
  };
}
function m7(t) {
  return t;
}
function DNe(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
function CNe(t) {
  return function(e) {
    return Zp(e, t);
  };
}
function SNe(t) {
  return Kp(t) ? DNe(t1(t)) : CNe(t);
}
function Vi(t) {
  return typeof t == "function" ? t : t == null ? m7 : typeof t == "object" ? xn(t) ? ANe(t[0], t[1]) : aNe(t) : SNe(t);
}
function wNe(t, e) {
  return t && t.length ? t7(t, Vi(e), Npe) : void 0;
}
const hs = W([]), TNe = {
  [st.GoogleAds]: "Google",
  [st.MicrosoftAds]: "Microsoft",
  [st.MetaAds]: "Meta",
  [st.LinkedInAds]: "LinkedIn",
  [st.GoogleAnalytics]: "Google Analytics",
  [st.GoogleSearchConsole]: "Google Search Console",
  [st.TikTokAds]: "TikTok",
  [st.ChatGptAds]: "ChatGPT"
};
function APe(t) {
  var i;
  const e = (((i = wNe(hs.value, (a) => a.id)) == null ? void 0 : i.id) ?? 0) + 1, n = {
    id: e,
    platform: t.platform ?? st.GoogleAds,
    platformName: TNe[t.platform ?? st.GoogleAds],
    progress: 0,
    params: t,
    state: "pushing",
    showCloseButton: !1,
    showErrorModal: !1,
    buttons: [],
    remove: () => {
      hs.value = hs.value.filter((a) => a.id !== e), t.onClose && t.onClose();
    }
  };
  hs.value.push(n);
  const r = () => {
    const a = hs.value.find((s) => s.id === e);
    if (!a)
      throw new Error("No toast found for this ID -- does it still exist?");
    return a;
  };
  let o;
  return {
    showSuccessState: (a) => {
      const s = r();
      s.state = "success", s.progress = 1, s.buttons = a == null ? void 0 : a.buttons, s.longErrorMessage = "", t.hideAfterSuccessMs && (o = setTimeout(() => s.remove(), t.hideAfterSuccessMs));
    },
    showErrorState: (a) => {
      clearTimeout(o);
      const s = r();
      s.state = "error", s.progress = 1, s.buttons = a == null ? void 0 : a.buttons, s.longErrorMessage = a == null ? void 0 : a.longErrorMessage;
    },
    showPushingState: () => {
      clearTimeout(o);
      const a = r();
      a.state = "pushing", a.buttons = void 0, a.longErrorMessage = "";
    },
    setProgress: (a) => {
      const s = r();
      s.progress = a;
    },
    close: () => r().remove()
  };
}
function bNe() {
  return { toasts: hs };
}
const RNe = {
  name: "SmallCross",
  props: {
    hex: {
      type: String,
      default: "#000000",
      required: !1
    }
  }
}, MNe = {
  width: "8",
  height: "8",
  viewBox: "0 0 8 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, PNe = ["fill"];
function yNe(t, e, n, r, o, i) {
  return v(), A("svg", MNe, [
    g("path", {
      fill: n.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.70711.292893c-.39053-.3905241-1.023692-.3905241-1.414217 0-.3905241.390525-.3905241 1.023687 0 1.414217L2.58579 4 .292893 6.29289c-.390524.39053-.390524 1.02369 0 1.41422.390524.39052 1.023687.39052 1.414217 0L4 5.41421l2.29289 2.2929c.39053.39052 1.02369.39052 1.41422 0 .39052-.39053.39052-1.02369 0-1.41422L5.41421 4l2.2929-2.29289c.39052-.39053.39052-1.023692 0-1.414217-.39053-.3905241-1.02369-.3905241-1.41422 0L4 2.58579 1.70711.292893Z"
    }, null, 8, PNe)
  ]);
}
const LNe = /* @__PURE__ */ Y(RNe, [["render", yNe]]), xNe = /* @__PURE__ */ Ne({
  __name: "ProgressBar",
  props: {
    progress: {},
    id: {},
    projectedProgress: {},
    microBar: { type: Boolean, default: !1 },
    barColor: { default: null },
    backgroundColor: { default: null },
    transitionSpeedSeconds: { default: 1 }
  },
  setup(t) {
    const e = t, n = {
      "opteo-gray": "rgba(255, 255, 255, 0.1)",
      "opteo-red": "#FF2828",
      "client-gold": "#FF9500",
      "client-green": "#00A861",
      "client-blue": "#006DFF",
      "client-purple": "#6E3AFF",
      "client-pink": "#FF365C"
    }, r = x(() => e.microBar ? "micro-bar-outer" : "regular-bar-outer"), o = x(() => e.microBar ? "micro-bar-inner" : "regular-bar-inner"), i = x(() => {
      const f = a.value ? e.progress - (e.projectedProgress ?? 0) : e.progress;
      return {
        transform: `scaleX(${f > 0 && a.value ? e.progress - f : e.progress})`,
        transition: `transform ${e.transitionSpeedSeconds}s cubic-bezier(0.19, 1, 0.22, 1)`
      };
    }), a = x(() => typeof e.projectedProgress == "number" && e.projectedProgress >= 0), s = x(() => ({
      transform: `scaleX(${e.progress - (e.projectedProgress ?? 0) > 0 ? e.progress : e.projectedProgress}) translateY(-100%)`,
      transition: `transform ${e.transitionSpeedSeconds}s cubic-bezier(0.19, 1, 0.22, 1)`,
      opacity: 0.2
    })), l = x(() => ({
      height: e.microBar ? "3px" : "6px",
      // microbar will actually be 2px high, but it is clipped in the css below
      "border-radius": e.microBar ? "0px" : "999px"
    })), c = x(() => ({
      height: e.microBar ? "3px" : "6px",
      "border-radius": "0px"
    })), u = x(() => e.barColor ? n.hasOwnProperty(e.barColor) ? { "background-color": n[e.barColor] } : { "background-color": e.barColor } : { "background-color": "#006dff" }), d = x(() => e.backgroundColor ? n.hasOwnProperty(e.backgroundColor) ? { "background-color": n[e.backgroundColor] } : { "background-color": e.backgroundColor } : { "background-color": e.microBar ? "transparent" : "#f2f2f6" });
    return (f, h) => (v(), A("div", {
      class: z(r.value),
      style: Fe({ ...l.value, ...d.value })
    }, [
      g("div", {
        class: z(o.value),
        style: Fe({ ...i.value, ...c.value, ...u.value })
      }, null, 6),
      a.value ? (v(), A("div", {
        key: 0,
        class: z(o.value),
        style: Fe({ ...s.value, ...c.value, ...u.value })
      }, null, 6)) : V("", !0)
    ], 6));
  }
});
const UNe = /* @__PURE__ */ Y(xNe, [["__scopeId", "data-v-f0f4c56c"]]), $Ne = {
  name: "AsyncPush",
  components: { SmallCross: LNe, ProgressBar: UNe, Text: Ye, Modal: Hhe, oButton: ln, Spacer: He },
  setup: () => ({
    showCloseButton: W(!1),
    ...bNe()
  })
};
const kNe = { class: "async-push-fixed-container" }, BNe = ["onMouseenter", "onMouseleave"], GNe = ["onClick"], FNe = {
  key: 0,
  class: "buttons"
}, VNe = ["onClick"], HNe = ["onClick"];
function WNe(t, e, n, r, o, i) {
  const a = ee("SmallCross"), s = ee("Text"), l = ee("ProgressBar"), c = ee("oButton"), u = ee("Spacer"), d = ee("Modal");
  return v(), A("div", kNe, [
    H(OS, {
      name: "async-push-fade",
      tag: "div"
    }, {
      default: q(() => [
        (v(!0), A(ge, null, ye(t.toasts, (f) => {
          var h;
          return v(), A("div", {
            key: f.id,
            class: z([(h = f.buttons) != null && h.length || f.longErrorMessage ? "expanded" : "", f.state, "async-push"]),
            onMouseenter: (_) => f.showCloseButton = !0,
            onMouseleave: (_) => f.showCloseButton = !1
          }, [
            H(Zt, { name: "close-button-fade" }, {
              default: q(() => [
                f.state !== "pushing" && f.showCloseButton ? (v(), A("div", {
                  key: 0,
                  onClick: (_) => f.remove(),
                  class: "async-push-close-button"
                }, [
                  H(a, { hex: "#fff" })
                ], 8, GNe)) : V("", !0)
              ]),
              _: 2
            }, 1024),
            H(Zt, {
              name: "async-push-message-fade",
              mode: "out-in"
            }, {
              default: q(() => [
                f.state === "pushing" ? (v(), te(s, {
                  key: 0,
                  as: "span",
                  size: "f-8",
                  class: "async-push-message"
                }, {
                  default: q(() => [
                    me(" Pushing changes to " + Q(f.platformName) + " Ads.. ", 1)
                  ]),
                  _: 2
                }, 1024)) : f.state === "success" ? (v(), te(s, {
                  key: 1,
                  as: "span",
                  size: "f-8",
                  class: "async-push-message"
                }, {
                  default: q(() => [
                    me(" Changes pushed to " + Q(f.platformName) + " Ads ", 1)
                  ]),
                  _: 2
                }, 1024)) : f.state === "error" ? (v(), te(s, {
                  key: 2,
                  as: "span",
                  size: "f-8",
                  class: "async-push-message"
                }, {
                  default: q(() => [
                    me(" Error pushing changes to " + Q(f.platformName) + " Ads ", 1)
                  ]),
                  _: 2
                }, 1024)) : V("", !0)
              ]),
              _: 2
            }, 1024),
            H(l, {
              barColor: "#fff",
              backgroundColor: f.state === "error" ? "#d50007" : "#002bae",
              progress: f.progress
            }, null, 8, ["backgroundColor", "progress"]),
            H(Zt, { name: "async-push-buttons-fade" }, {
              default: q(() => {
                var _;
                return [
                  (_ = f.buttons) != null && _.length || f.longErrorMessage ? (v(), A("div", FNe, [
                    g("button", {
                      class: "button",
                      onClick: (E) => f.showErrorModal = !0
                    }, "Show Error Message", 8, VNe),
                    (v(!0), A(ge, null, ye(f.buttons, (E, m) => (v(), A("button", {
                      key: "button-" + m,
                      class: "button",
                      onClick: (N) => E.handler()
                    }, Q(E.label), 9, HNe))), 128))
                  ])) : V("", !0)
                ];
              }),
              _: 2
            }, 1024),
            H(d, {
              modelValue: f.showErrorModal,
              "onUpdate:modelValue": (_) => f.showErrorModal = _,
              title: "Error Message"
            }, {
              content: q(() => [
                H(s, {
                  as: "p",
                  size: "f-8",
                  innerHTML: f.longErrorMessage
                }, null, 8, ["innerHTML"])
              ]),
              buttons: q(() => [
                H(c, {
                  color: "white",
                  onClicked: (_) => f.showErrorModal = !1
                }, {
                  default: q(() => [...e[0] || (e[0] = [
                    me("Cancel", -1)
                  ])]),
                  _: 1
                }, 8, ["onClicked"]),
                H(u, { width: "0.625rem" }),
                (v(!0), A(ge, null, ye(f.buttons, (_, E) => (v(), te(c, {
                  key: "button-" + E,
                  onClicked: (m) => _.handler(),
                  color: "red"
                }, {
                  default: q(() => [...e[1] || (e[1] = [
                    me(" Dismiss Error Message ", -1)
                  ])]),
                  _: 1
                }, 8, ["onClicked"]))), 128))
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])
          ], 42, BNe);
        }), 128))
      ]),
      _: 1
    })
  ]);
}
const DPe = /* @__PURE__ */ Y($Ne, [["render", WNe], ["__scopeId", "data-v-4d000f80"]]), qp = Ne({
  name: "BatchBar",
  components: { CheckIcon: W5, Text: Ye, oButton: ln },
  props: {
    modelValue: {
      required: !0,
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: "",
      required: !1
    },
    fullScreen: {
      required: !1,
      type: Boolean,
      default: !1
    },
    count: {
      type: Number,
      default: 0,
      required: !1
    },
    zIndex: {
      type: Number,
      default: 9999998,
      required: !1
    }
  },
  emits: ["clear-selected", "update:modelValue"],
  setup(t, { emit: e }) {
    function n() {
      e("update:modelValue", !1), e("clear-selected");
    }
    return { clearSelected: n };
  }
}), ug = () => {
  Wr((t) => ({
    ec767ec8: t.zIndex
  }));
}, dg = qp.setup;
qp.setup = dg ? (t, e) => (ug(), dg(t, e)) : ug;
const YNe = { class: "batch-bar-content" }, KNe = {
  key: 0,
  class: "left-slot"
}, zNe = {
  key: 1,
  class: "left"
}, ZNe = {
  key: 2,
  class: "middle"
}, qNe = { class: "buttons" };
function XNe(t, e, n, r, o, i) {
  const a = ee("CheckIcon"), s = ee("Text"), l = ee("oButton");
  return v(), te(Zt, { name: "batch-bar-fade-up" }, {
    default: q(() => [
      t.modelValue ? (v(), A("div", {
        key: 0,
        ref: "bar",
        class: z([{ "full-screen": t.fullScreen }, "batch-bar"])
      }, [
        g("div", YNe, [
          t.$slots.count ? (v(), A("div", KNe, [
            ue(t.$slots, "count", {}, void 0, !0)
          ])) : (v(), A("div", zNe, [
            H(a, {
              animated: "",
              color: "blue"
            }),
            H(s, {
              as: "span",
              color: "white",
              weight: "300"
            }, {
              default: q(() => [
                me(Q(t.count) + " " + Q(t.title) + " Selected", 1)
              ]),
              _: 1
            })
          ])),
          t.$slots.middle ? (v(), A("div", ZNe, [
            ue(t.$slots, "middle", {}, void 0, !0)
          ])) : V("", !0),
          g("div", qNe, [
            H(l, {
              color: "dark",
              onClicked: t.clearSelected
            }, {
              default: q(() => [...e[0] || (e[0] = [
                me("Clear Selected", -1)
              ])]),
              _: 1
            }, 8, ["onClicked"]),
            ue(t.$slots, "buttons", { class: "buttons" }, void 0, !0)
          ])
        ])
      ], 2)) : V("", !0)
    ]),
    _: 3
  });
}
const CPe = /* @__PURE__ */ Y(qp, [["render", XNe], ["__scopeId", "data-v-13921dcc"]]), jNe = Ne({
  name: "ConnectionStatus",
  components: { Text: Ye },
  props: {},
  setup() {
    return { online: n$() };
  }
});
function JNe(t, e, n, r, o, i) {
  const a = ee("Text");
  return v(), A("div", {
    class: z([{ show: !t.online }, "connection-status"])
  }, [
    H(a, {
      as: "span",
      size: "f-8",
      color: "white"
    }, {
      default: q(() => [...e[0] || (e[0] = [
        me(" Your connection appears to be offline. Please check your network settings. ", -1)
      ])]),
      _: 1
    })
  ], 2);
}
const SPe = /* @__PURE__ */ Y(jNe, [["render", JNe], ["__scopeId", "data-v-ca23d495"]]), QNe = {
  name: "Toggle"
}, eve = /* @__PURE__ */ Ne({
  ...QNe,
  props: {
    modelValue: Boolean,
    disabled: Boolean,
    viewOnly: {
      type: Boolean,
      required: !1,
      default: !1
    },
    color: {
      type: String,
      required: !1,
      default: "#006dff"
    },
    size: {
      type: String,
      required: !1,
      default: "medium"
      // 'medium' || 'large'
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e;
    function o() {
      n.disabled !== !0 && (n.modelValue === !0 ? r("update:modelValue", !1) : n.modelValue === !1 && r("update:modelValue", !0));
    }
    return (i, a) => t.viewOnly ? (v(), A("button", {
      key: 0,
      class: z([{ active: t.modelValue }, { disabled: t.disabled }, t.size, "toggle"]),
      style: Fe({
        backgroundColor: t.modelValue ? t.color : ""
      })
    }, [...a[0] || (a[0] = [
      g("div", { class: "handle" }, null, -1)
    ])], 6)) : (v(), A("button", {
      key: 1,
      onClick: o,
      class: z([{ active: t.modelValue }, { disabled: t.disabled }, t.size, "toggle"]),
      style: Fe({
        backgroundColor: t.modelValue ? t.color : ""
      })
    }, [...a[1] || (a[1] = [
      g("div", { class: "handle" }, null, -1)
    ])], 6));
  }
});
const wPe = /* @__PURE__ */ Y(eve, [["__scopeId", "data-v-037c6f45"]]), tve = Ne({
  name: "CopyableString",
  components: {
    Tooltip: LE,
    Spacer: He
  },
  props: {
    value: {
      type: String,
      required: !0
    },
    maxWidth: {
      type: Number,
      required: !1
    }
  },
  setup() {
    const t = W(""), { copy: e, copied: n } = JU({});
    function r(o) {
      t.value = o, e(t.value), j6("Copied to clipboard successfully.");
    }
    return { valueToCopy: t, handleCopy: r, copied: n };
  }
});
function nve(t, e, n, r, o, i) {
  return v(), A("span", {
    class: z([{ "limit-width": t.maxWidth }, "value"]),
    style: Fe(t.maxWidth ? "max-width: " + t.maxWidth + "px" : ""),
    onClick: e[0] || (e[0] = (a) => t.handleCopy(t.value))
  }, Q(t.value), 7);
}
const TPe = /* @__PURE__ */ Y(tve, [["render", nve], ["__scopeId", "data-v-d9e0d4b6"]]);
function N7(t, e, n, r) {
  for (var o = t.length, i = n + (r ? 1 : -1); r ? i-- : ++i < o; )
    if (e(t[i], i, t))
      return i;
  return -1;
}
var rve = /\s/;
function ove(t) {
  for (var e = t.length; e-- && rve.test(t.charAt(e)); )
    ;
  return e;
}
var ive = /^\s+/;
function ave(t) {
  return t && t.slice(0, ove(t) + 1).replace(ive, "");
}
var fg = 0 / 0, sve = /^[-+]0x[0-9a-f]+$/i, lve = /^0b[01]+$/i, cve = /^0o[0-7]+$/i, uve = parseInt;
function dve(t) {
  if (typeof t == "number")
    return t;
  if (Ra(t))
    return fg;
  if (Tc(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = Tc(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = ave(t);
  var n = lve.test(t);
  return n || cve.test(t) ? uve(t.slice(2), n ? 2 : 8) : sve.test(t) ? fg : +t;
}
var hg = 1 / 0, fve = 17976931348623157e292;
function hve(t) {
  if (!t)
    return t === 0 ? t : 0;
  if (t = dve(t), t === hg || t === -hg) {
    var e = t < 0 ? -1 : 1;
    return e * fve;
  }
  return t === t ? t : 0;
}
function _ve(t) {
  var e = hve(t), n = e % 1;
  return e === e ? n ? e - n : e : 0;
}
var Eve = Math.max;
function pve(t, e, n) {
  var r = t == null ? 0 : t.length;
  if (!r)
    return -1;
  var o = n == null ? 0 : _ve(n);
  return o < 0 && (o = Eve(r + o, 0)), N7(t, Vi(e), o);
}
var _g = Eo ? Eo.isConcatSpreadable : void 0;
function mve(t) {
  return xn(t) || Fp(t) || !!(_g && t && t[_g]);
}
function v7(t, e, n, r, o) {
  var i = -1, a = t.length;
  for (n || (n = mve), o || (o = []); ++i < a; ) {
    var s = t[i];
    e > 0 && n(s) ? e > 1 ? v7(s, e - 1, n, r, o) : a7(o, s) : r || (o[o.length] = s);
  }
  return o;
}
function Nve(t) {
  return function(e, n, r) {
    for (var o = -1, i = Object(e), a = r(e), s = a.length; s--; ) {
      var l = a[t ? s : ++o];
      if (n(i[l], l, i) === !1)
        break;
    }
    return e;
  };
}
var vve = Nve();
const gve = vve;
function g7(t, e) {
  return t && gve(t, e, Wp);
}
function Ive(t, e) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!Hp(n))
      return t(n, r);
    for (var o = n.length, i = e ? o : -1, a = Object(n); (e ? i-- : ++i < o) && r(a[i], i, a) !== !1; )
      ;
    return n;
  };
}
var Ove = Ive(g7);
const I7 = Ove;
function O7(t, e) {
  var n = -1, r = Hp(t) ? Array(t.length) : [];
  return I7(t, function(o, i, a) {
    r[++n] = e(o, i, a);
  }), r;
}
function Ave(t, e) {
  var n = xn(t) ? Jl : O7;
  return n(t, Vi(e));
}
function Eg(t, e) {
  return v7(Ave(t, e), 1);
}
var Dve = function() {
  try {
    var t = za(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}();
const pg = Dve;
function Cve(t, e, n) {
  e == "__proto__" && pg ? pg(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
function Sve(t, e) {
  var n = {};
  return e = Vi(e), g7(t, function(r, o, i) {
    Cve(n, o, e(r, o, i));
  }), n;
}
var mg = globalThis && globalThis.__spreadArray || function(t, e, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = e.length, i; r < o; r++)
      (i || !(r in e)) && (i || (i = Array.prototype.slice.call(e, 0, r)), i[r] = e[r]);
  return t.concat(i || Array.prototype.slice.call(e));
}, wve = (
  /** @class */
  function() {
    function t(e, n, r) {
      this.name = e, this.version = n, this.os = r, this.type = "browser";
    }
    return t;
  }()
), Tve = (
  /** @class */
  function() {
    function t(e) {
      this.version = e, this.type = "node", this.name = "node", this.os = process.platform;
    }
    return t;
  }()
), bve = (
  /** @class */
  function() {
    function t(e, n, r, o) {
      this.name = e, this.version = n, this.os = r, this.bot = o, this.type = "bot-device";
    }
    return t;
  }()
), Rve = (
  /** @class */
  function() {
    function t() {
      this.type = "bot", this.bot = !0, this.name = "bot", this.version = null, this.os = null;
    }
    return t;
  }()
), Mve = (
  /** @class */
  function() {
    function t() {
      this.type = "react-native", this.name = "react-native", this.version = null, this.os = null;
    }
    return t;
  }()
), Pve = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/, yve = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/, Ng = 3, Lve = [
  ["aol", /AOLShield\/([0-9\._]+)/],
  ["edge", /Edge\/([0-9\._]+)/],
  ["edge-ios", /EdgiOS\/([0-9\._]+)/],
  ["yandexbrowser", /YaBrowser\/([0-9\._]+)/],
  ["kakaotalk", /KAKAOTALK\s([0-9\.]+)/],
  ["samsung", /SamsungBrowser\/([0-9\.]+)/],
  ["silk", /\bSilk\/([0-9._-]+)\b/],
  ["miui", /MiuiBrowser\/([0-9\.]+)$/],
  ["beaker", /BeakerBrowser\/([0-9\.]+)/],
  ["edge-chromium", /EdgA?\/([0-9\.]+)/],
  [
    "chromium-webview",
    /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
  ],
  ["chrome", /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
  ["phantomjs", /PhantomJS\/([0-9\.]+)(:?\s|$)/],
  ["crios", /CriOS\/([0-9\.]+)(:?\s|$)/],
  ["firefox", /Firefox\/([0-9\.]+)(?:\s|$)/],
  ["fxios", /FxiOS\/([0-9\.]+)/],
  ["opera-mini", /Opera Mini.*Version\/([0-9\.]+)/],
  ["opera", /Opera\/([0-9\.]+)(?:\s|$)/],
  ["opera", /OPR\/([0-9\.]+)(:?\s|$)/],
  ["pie", /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/],
  ["pie", /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/],
  ["netfront", /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/],
  ["ie", /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
  ["ie", /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
  ["ie", /MSIE\s(7\.0)/],
  ["bb10", /BB10;\sTouch.*Version\/([0-9\.]+)/],
  ["android", /Android\s([0-9\.]+)/],
  ["ios", /Version\/([0-9\._]+).*Mobile.*Safari.*/],
  ["safari", /Version\/([0-9\._]+).*Safari/],
  ["facebook", /FB[AS]V\/([0-9\.]+)/],
  ["instagram", /Instagram\s([0-9\.]+)/],
  ["ios-webview", /AppleWebKit\/([0-9\.]+).*Mobile/],
  ["ios-webview", /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
  ["curl", /^curl\/([0-9\.]+)$/],
  ["searchbot", Pve]
], vg = [
  ["iOS", /iP(hone|od|ad)/],
  ["Android OS", /Android/],
  ["BlackBerry OS", /BlackBerry|BB10/],
  ["Windows Mobile", /IEMobile/],
  ["Amazon OS", /Kindle/],
  ["Windows 3.11", /Win16/],
  ["Windows 95", /(Windows 95)|(Win95)|(Windows_95)/],
  ["Windows 98", /(Windows 98)|(Win98)/],
  ["Windows 2000", /(Windows NT 5.0)|(Windows 2000)/],
  ["Windows XP", /(Windows NT 5.1)|(Windows XP)/],
  ["Windows Server 2003", /(Windows NT 5.2)/],
  ["Windows Vista", /(Windows NT 6.0)/],
  ["Windows 7", /(Windows NT 6.1)/],
  ["Windows 8", /(Windows NT 6.2)/],
  ["Windows 8.1", /(Windows NT 6.3)/],
  ["Windows 10", /(Windows NT 10.0)/],
  ["Windows ME", /Windows ME/],
  ["Windows CE", /Windows CE|WinCE|Microsoft Pocket Internet Explorer/],
  ["Open BSD", /OpenBSD/],
  ["Sun OS", /SunOS/],
  ["Chrome OS", /CrOS/],
  ["Linux", /(Linux)|(X11)/],
  ["Mac OS", /(Mac_PowerPC)|(Macintosh)/],
  ["QNX", /QNX/],
  ["BeOS", /BeOS/],
  ["OS/2", /OS\/2/]
];
function Xp(t) {
  return t ? gg(t) : typeof document > "u" && typeof navigator < "u" && navigator.product === "ReactNative" ? new Mve() : typeof navigator < "u" ? gg(navigator.userAgent) : $ve();
}
function xve(t) {
  return t !== "" && Lve.reduce(function(e, n) {
    var r = n[0], o = n[1];
    if (e)
      return e;
    var i = o.exec(t);
    return !!i && [r, i];
  }, !1);
}
function gg(t) {
  var e = xve(t);
  if (!e)
    return null;
  var n = e[0], r = e[1];
  if (n === "searchbot")
    return new Rve();
  var o = r[1] && r[1].split(".").join("_").split("_").slice(0, 3);
  o ? o.length < Ng && (o = mg(mg([], o, !0), kve(Ng - o.length), !0)) : o = [];
  var i = o.join("."), a = Uve(t), s = yve.exec(t);
  return s && s[1] ? new bve(n, i, a, s[1]) : new wve(n, i, a);
}
function Uve(t) {
  for (var e = 0, n = vg.length; e < n; e++) {
    var r = vg[e], o = r[0], i = r[1], a = i.exec(t);
    if (a)
      return o;
  }
  return null;
}
function $ve() {
  var t = typeof process < "u" && process.version;
  return t ? new Tve(process.version.slice(1)) : null;
}
function kve(t) {
  for (var e = [], n = 0; n < t; n++)
    e.push("0");
  return e;
}
function Do({
  appendTo: t,
  items: e,
  animationMultiplier: n,
  removeInteractivity: r,
  enableMoveTransition: o,
  options: i
}) {
  const a = W(), s = W(), l = e == null ? void 0 : e.findIndex((p) => p.highlighted || p.is_best_bid), c = W(l ?? -1), u = x(() => {
    var p;
    return (p = a.value) == null ? void 0 : p._tippy;
  }), d = W(!1);
  function f(p) {
    var C;
    r || (c.value = p, (C = u.value) != null && C.state.isVisible || m());
  }
  function h() {
    var p;
    r || c.value === -1 || (p = u.value) != null && p.state.isVisible || m();
  }
  e && typeof n < "u" && c.value >= 0 && et(n, async (p) => {
    p && (await Or(750), f(c.value));
  });
  const _ = x(() => {
    var p;
    return ((p = Xp()) == null ? void 0 : p.name) === "safari";
  }), E = {
    content: () => s.value,
    sticky: (i == null ? void 0 : i.sticky) ?? !0,
    popperOptions: {
      modifiers: [
        {
          name: "flip",
          options: {
            fallbackPlacements: ["top"]
          }
        }
      ]
    },
    hideOnClick: !1,
    animateFill: !1,
    trigger: "manual",
    animation: "shift-away",
    placement: "top",
    offset: [0, 8],
    arrow: !1,
    moveTransition: o && !_.value ? "transform 0.2s ease" : void 0,
    onHide: () => {
      d.value = !1;
    },
    onHidden: () => {
      c.value = -1;
    },
    onShow: () => {
      d.value = !0;
    },
    appendTo: () => t != null && t.value ? t.value : document.body
  }, { show: m, hide: N, mount: I, setProps: O } = Ui(a, E);
  return {
    tooltipCircle: a,
    tooltipContent: s,
    hoverItem: f,
    hideTooltip: N,
    showTooltip: h,
    hoveredIndex: c,
    tooltipInstance: u,
    showTooltipMarker: d,
    tooltipOptions: E,
    setProps: O,
    mount: I
  };
}
function yn({
  value: t,
  metric: e,
  compact: n = !1
}) {
  return (e == null ? void 0 : e.dataType) === "percentage" ? Yo({ value: t.valueOf() }) : (e == null ? void 0 : e.dataType) === "roas" ? vc({ value: t.valueOf() }) : (e == null ? void 0 : e.dataType) === "money" ? sn({ value: t.valueOf(), currency: e.currency, compact: n }) : (e == null ? void 0 : e.dataType) === "date" ? { displayValue: x(() => lu(t, e.dateFormat ?? "Do MMM")) } : Gs({ value: t.valueOf(), compact: n });
}
function Hi(t) {
  const e = W(t ? 1 : 0), n = W(!!t);
  return ct(async () => {
    await Or(250), e.value = 1, await Or(750), n.value = !0;
  }), {
    animationMultiplier: e,
    finishedChartAnimation: n
  };
}
function Bve(t, e) {
  var n = t.length;
  for (t.sort(e); n--; )
    t[n] = t[n].value;
  return t;
}
function Gve(t, e) {
  if (t !== e) {
    var n = t !== void 0, r = t === null, o = t === t, i = Ra(t), a = e !== void 0, s = e === null, l = e === e, c = Ra(e);
    if (!s && !c && !i && t > e || i && a && l && !s && !c || r && a && l || !n && l || !o)
      return 1;
    if (!r && !i && !c && t < e || c && n && o && !r && !i || s && n && o || !a && o || !l)
      return -1;
  }
  return 0;
}
function Fve(t, e, n) {
  for (var r = -1, o = t.criteria, i = e.criteria, a = o.length, s = n.length; ++r < a; ) {
    var l = Gve(o[r], i[r]);
    if (l) {
      if (r >= s)
        return l;
      var c = n[r];
      return l * (c == "desc" ? -1 : 1);
    }
  }
  return t.index - e.index;
}
function Vve(t, e, n) {
  e.length ? e = Jl(e, function(i) {
    return xn(i) ? function(a) {
      return Zp(a, i.length === 1 ? i[0] : i);
    } : i;
  }) : e = [m7];
  var r = -1;
  e = Jl(e, d7(Vi));
  var o = O7(t, function(i, a, s) {
    var l = Jl(e, function(c) {
      return c(i);
    });
    return { criteria: l, index: ++r, value: i };
  });
  return Bve(o, function(i, a) {
    return Fve(i, a, n);
  });
}
function Hve(t, e, n, r) {
  return t == null ? [] : (xn(e) || (e = e == null ? [] : [e]), n = r ? void 0 : n, xn(n) || (n = n == null ? [] : [n]), Vve(t, e, n));
}
const Wve = ["Increase Bid", "No Adjustment", "Decrease Bid"];
var nc;
((t) => {
  t.daysOfWeek = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
})(nc || (nc = {}));
const bl = {
  start_hour: 0,
  end_hour: 0,
  start_minute: 0,
  end_minute: 0,
  bid_modifier: 0,
  previous_bid_modifier: 0,
  optimisation_target: "cpa",
  window_value: 0,
  window_target: 0,
  window_difference: 0
};
function Yve(t) {
  const e = W(), n = W(), r = ["Mon.", "Tues.", "Wed.", "Thur.", "Fri.", "Sat.", "Sun."], o = W(300), i = x(() => {
    var b;
    return 600 - (((b = n.value) == null ? void 0 : b.clientWidth) ?? 0);
  }), a = x(
    () => Math.max(
      ...Eg(
        t.adSchedule,
        (b) => b.map((P) => Math.abs(P.previous_bid_modifier - P.bid_modifier))
      )
    )
  ), s = Eg(t.adSchedule).find((b) => b.optimisation_target);
  bl.optimisation_target = (s == null ? void 0 : s.optimisation_target) ?? "cpa", bl.window_target = (s == null ? void 0 : s.window_target) ?? 0;
  const l = x(() => {
    const b = t.adSchedule;
    return nc.daysOfWeek.forEach((P) => {
      let $ = b[P];
      if (!$) {
        const L = {
          ...bl,
          end_hour: 24
        };
        b[P] = $ = [L];
        return;
      }
      let y = 0;
      for (; y < 24; ) {
        const L = $.find((w) => +w.start_hour + w.start_minute / 60 === y);
        if (L)
          y = +L.end_hour + L.end_minute / 60;
        else {
          const w = $.find((U) => +U.start_hour + U.start_minute / 60 > y), R = Math.floor(y), B = (y - R) * 60;
          if (w) {
            const U = {
              ...bl,
              start_hour: R,
              end_hour: w.start_hour,
              start_minute: B,
              end_minute: w.start_minute
            };
            $.push(U), y = +w.start_hour + w.start_minute / 60;
          } else {
            const U = {
              ...bl,
              start_hour: R,
              end_hour: 24,
              start_minute: B
            };
            $.push(U), y = 24;
          }
        }
      }
    }), Sve(b, (P, $) => Hve(P, (y) => +y.start_hour + y.start_minute / 60).map((y) => {
      var ce, Se, se, Ie;
      const L = +y.start_hour + y.start_minute / 60, w = +y.end_hour + y.end_minute / 60, R = L * i.value / 24, B = (w - L) * i.value / 24, U = y.bid_modifier - y.previous_bid_modifier === 0 ? "black" : y.bid_modifier - y.previous_bid_modifier > 0 ? "green" : "red", K = Math.abs(y.previous_bid_modifier - y.bid_modifier), Z = K === 0 ? 0 : Math.ceil(K * 100 * (0.3 / a.value) + 20) / 100, X = M6($), J = `${u(+y.start_hour)}:${u(
        y.start_minute
      )} → ${u(+y.end_hour)}:${u(y.end_minute)}`, { displayValue: ae } = yn({
        value: y.window_value,
        metric: t.metric
      }), { displayValue: re } = yn({
        value: y.window_target,
        metric: t.metric
      }), j = y.window_difference > 0 && !((ce = t.metric) != null && ce.inverted) || y.window_difference < 0 && ((Se = t.metric) != null && Se.inverted) ? "green" : "red", { displayValue: ne } = Yo({
        value: y.window_difference,
        includeSign: !0
      }), Ee = y.bid_modifier > y.previous_bid_modifier ? "green" : "red", { displayValue: fe } = Yo({
        value: y.bid_modifier - y.previous_bid_modifier,
        includeSign: !0
      }), Oe = [
        { label: ((se = t.metric) == null ? void 0 : se.label) ?? "", value: ae.value },
        { label: `Avg. ${(Ie = t.metric) == null ? void 0 : Ie.label}`, value: re.value },
        { label: "Diff.", value: ne.value, textColor: j },
        { label: "Adjust.", value: fe.value, textColor: Ee }
      ];
      return { ...y, x: R, width: B, color: U, opacity: Z, formattedTitle: X, formattedSubtitle: J, metrics: Oe };
    }));
  }), c = W();
  function u(b) {
    const P = b.toString();
    return P.length === 2 ? P : `0${P}`;
  }
  const d = x(() => {
    const b = [];
    for (let P = 0; P <= 24; P += 2)
      b.push(u(P));
    return b;
  }), f = x(() => {
    var b;
    if (c.value)
      return (b = l.value[c.value]) == null ? void 0 : b[O.value];
  });
  function h(b, P) {
    p(P), c.value = b;
  }
  function _() {
    D(), c.value = void 0;
  }
  const E = x(() => f.value ? f.value.x + f.value.width / 2 : -1), m = x(() => pve(nc.daysOfWeek, (P) => P === c.value) * o.value / 7 + o.value / 14), { tooltipCircle: N, tooltipContent: I, hoveredIndex: O, hoverItem: p, showTooltipMarker: C, hideTooltip: D } = Do({
    appendTo: e,
    removeInteractivity: t.removeInteractivity
  }), { animationMultiplier: T } = Hi(t.removeInteractivity), k = x(() => `rounded-corner-mask-${Br(6)}`), G = x(() => `url(#${k.value})`);
  return {
    yAxisLabels: n,
    svgWidth: i,
    svgHeight: o,
    animationMultiplier: T,
    daysOfWeek: nc.daysOfWeek,
    abbreviatedDays: r,
    cells: l,
    hoveredItem: f,
    handelMouseEnterCell: h,
    chartContainer: e,
    handleMouseLeave: _,
    tooltipContent: I,
    tooltipCircle: N,
    showTooltipMarker: C,
    cx: E,
    cy: m,
    formatHour: u,
    graphKeys: Wve,
    hoursOfDays: d,
    roundedMaskId: k,
    roundedMaskurl: G
  };
}
var Ks = /* @__PURE__ */ ((t) => (t[t["opteo-blue"] = 0] = "opteo-blue", t[t["opteo-purple"] = 1] = "opteo-purple", t[t["opteo-teal"] = 2] = "opteo-teal", t[t["opteo-pink"] = 3] = "opteo-pink", t[t["opteo-amber"] = 4] = "opteo-amber", t[t["opteo-orange"] = 5] = "opteo-orange", t[t["opteo-red"] = 6] = "opteo-red", t[t["opteo-green"] = 7] = "opteo-green", t))(Ks || {});
const Kve = Ne({
  name: "ChartTooltip",
  components: { Text: Ye, Spacer: He },
  props: {
    title: {
      type: String,
      required: !1
    },
    subtitle: {
      type: String,
      required: !1
    },
    metrics: {
      type: Array,
      required: !1
    },
    plainText: {
      type: String,
      required: !1
    },
    plotLines: {
      type: Array,
      required: !1
    },
    footer: {
      type: String,
      required: !1
    },
    maxWidth: {
      type: String,
      required: !1,
      default: "none"
    },
    fullWidth: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup() {
    return { ChartColors: Ks };
  }
});
const zve = {
  key: 0,
  class: "titles"
}, Zve = { key: 2 }, qve = { key: 3 }, Xve = { key: 4 }, jve = {
  key: 0,
  cx: "4.5",
  cy: "4.5",
  r: "3.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-dasharray": "3.5,2"
}, Jve = {
  key: 1,
  cx: "4.5",
  cy: "4.5",
  r: "4.5",
  fill: "currentColor"
}, Qve = {
  key: 6,
  class: "footer"
};
function e3e(t, e, n, r, o, i) {
  const a = ee("Text"), s = ee("Spacer");
  return v(), A("div", {
    class: z(["chart-tooltip ", { "w-100": t.fullWidth }]),
    style: Fe({ maxWidth: t.maxWidth })
  }, [
    t.title ? (v(), A("div", zve, [
      H(a, {
        weight: "500",
        color: "white",
        class: "title",
        truncate: !0
      }, {
        default: q(() => [
          me(Q(t.title), 1)
        ]),
        _: 1
      }),
      t.subtitle ? (v(), te(s, {
        key: 0,
        height: "0.25rem"
      })) : V("", !0),
      t.subtitle ? (v(), te(a, {
        key: 1,
        truncate: !0,
        color: "white",
        weight: "400",
        class: "subtitle"
      }, {
        default: q(() => [
          me(Q(t.subtitle), 1)
        ]),
        _: 1
      })) : V("", !0),
      H(s, { height: "0.5rem" })
    ])) : V("", !0),
    t.title ? (v(), te(s, {
      key: 1,
      height: "0.75rem"
    })) : V("", !0),
    t.metrics ? (v(), A("div", Zve, [
      (v(!0), A(ge, null, ye(t.metrics, (l) => (v(), A("div", {
        class: "metrics",
        key: l.label
      }, [
        H(a, {
          color: "white",
          truncate: !0,
          class: "metrics-text"
        }, {
          default: q(() => [
            me(Q(l.label), 1)
          ]),
          _: 2
        }, 1024),
        H(s, { width: "2rem" }),
        H(a, {
          color: l.textColor ?? "white",
          weight: "700",
          align: "right",
          wrap: !1,
          class: "metrics-text"
        }, {
          default: q(() => [
            me(Q(l.value), 1)
          ]),
          _: 2
        }, 1032, ["color"])
      ]))), 128))
    ])) : V("", !0),
    t.plainText ? (v(), A("div", qve, [
      H(a, {
        color: "white",
        truncate: !0,
        class: "plain-text"
      }, {
        default: q(() => [
          me(Q(t.plainText), 1)
        ]),
        _: 1
      })
    ])) : V("", !0),
    t.plotLines ? (v(), A("div", Xve, [
      (v(!0), A(ge, null, ye(t.plotLines, (l, c) => (v(), A("div", {
        class: "metrics",
        key: l.label
      }, [
        (v(), A("svg", {
          width: "9",
          height: "9",
          viewBox: "0 0 9 9",
          class: z([l.color ? l.color : t.ChartColors[c % 6], "flex align-center"]),
          style: { "min-width": "9px" },
          fill: "none"
        }, [
          l.dotted ? (v(), A("circle", jve)) : (v(), A("circle", Jve))
        ], 2)),
        H(s, { width: "0.75rem" }),
        H(a, {
          align: "left",
          color: "white",
          weight: "400",
          truncate: !0,
          class: "metrics-text w-100"
        }, {
          default: q(() => [
            me(Q(l.label), 1)
          ]),
          _: 2
        }, 1024),
        H(s, { width: "0.75rem" }),
        H(a, {
          color: "white",
          weight: "700",
          align: "right",
          wrap: !1,
          class: "metrics-text"
        }, {
          default: q(() => [
            me(Q(l.value), 1)
          ]),
          _: 2
        }, 1024)
      ]))), 128))
    ])) : V("", !0),
    t.footer ? (v(), te(s, {
      key: 5,
      height: "0.75rem"
    })) : V("", !0),
    t.footer ? (v(), A("div", Qve, [
      H(s, { height: "0.5rem" }),
      H(a, {
        color: "white",
        weight: "400",
        class: "subtitle"
      }, {
        default: q(() => [
          me(Q(t.footer), 1)
        ]),
        _: 1
      })
    ])) : V("", !0)
  ], 6);
}
const Co = /* @__PURE__ */ Y(Kve, [["render", e3e], ["__scopeId", "data-v-26a98e60"]]), t3e = { class: "flex-wrapper" }, n3e = /* @__PURE__ */ Ne({
  __name: "GraphKeys",
  props: {
    graphKeys: {},
    inverted: { type: Boolean }
  },
  setup(t) {
    const e = t;
    function n(r) {
      return e.inverted ? `circle-${r + 1}` : `circle-${e.graphKeys.length - r}`;
    }
    return (r, o) => (v(), A("div", t3e, [
      (v(!0), A(ge, null, ye(t.graphKeys, (i, a) => (v(), A("div", {
        class: "flex-center",
        key: i
      }, [
        i ? (v(), A("div", {
          key: 0,
          class: z([n(a), "graph-key-circle"])
        }, null, 2)) : V("", !0),
        H(Ye, { class: "graph-key" }, {
          default: q(() => [
            me(Q(i), 1)
          ]),
          _: 2
        }, 1024)
      ]))), 128))
    ]));
  }
});
const jp = /* @__PURE__ */ Y(n3e, [["__scopeId", "data-v-3c936977"]]), r3e = {
  key: 0,
  class: "axis-title"
}, o3e = { key: 2 }, i3e = /* @__PURE__ */ Ne({
  __name: "VerticalAxisLabels",
  props: {
    chartHeight: {},
    axisTitle: {},
    axisLabels: {},
    centered: { type: Boolean }
  },
  setup(t) {
    Wr((i) => ({
      cf69008c: n.value
    }));
    const e = t, n = x(() => `${e.chartHeight + r.value}px`), r = x(() => e.centered ? 0 : 13), o = so("axisLabelsInsideChart", !1);
    return (i, a) => (v(), A("div", {
      class: z(["flex-wrapper", { performance: M(o) }])
    }, [
      t.axisTitle && !M(o) ? (v(), A("div", r3e, [
        H(Ye, {
          as: "span",
          class: "title-text",
          align: "center",
          size: "f-9",
          weight: "500",
          wrap: !1
        }, {
          default: q(() => [
            me(Q(t.axisTitle), 1)
          ]),
          _: 1
        })
      ])) : V("", !0),
      t.axisTitle || M(o) ? (v(), te(He, {
        key: 1,
        width: M(o) ? "1.5rem" : "1rem",
        height: "100%"
      }, null, 8, ["width"])) : (v(), A("div", o3e)),
      t.axisLabels ? (v(), A("div", {
        key: 3,
        class: z(["axis-labels", { centered: t.centered }])
      }, [
        (v(!0), A(ge, null, ye(t.axisLabels, (s, l) => (v(), A("div", {
          class: "label-box",
          key: s
        }, [
          H(Ye, {
            as: "span",
            align: "right",
            size: "f-10",
            wrap: !1,
            style: { opacity: "0.2" },
            class: z({ "o-0": M(o) && l !== t.axisLabels.length - 1 })
          }, {
            default: q(() => [
              me(Q(s), 1)
            ]),
            _: 2
          }, 1032, ["class"])
        ]))), 128))
      ], 2)) : V("", !0),
      t.axisLabels ? (v(), te(He, {
        key: 4,
        width: "0.5rem",
        height: "100%"
      })) : V("", !0)
    ], 2));
  }
});
const Za = /* @__PURE__ */ Y(i3e, [["__scopeId", "data-v-b69c53cd"]]), a3e = { class: "flex-wrapper" }, s3e = { class: "w-100 inline-flex" }, l3e = {
  key: 0,
  class: "axis-labels w-100"
}, c3e = {
  key: 2,
  class: "flex align-center"
}, u3e = /* @__PURE__ */ Ne({
  __name: "HorizontalAxisLabels",
  props: {
    axisTitle: {},
    axisLabels: {},
    centeredLabels: { type: Boolean },
    offset: {},
    showExtrema: { type: Boolean }
  },
  setup(t) {
    Wr((r) => ({
      b8b67950: n.value
    }));
    const e = t, n = x(() => `${e.offset}px`);
    return (r, o) => (v(), A("div", a3e, [
      t.axisLabels ? (v(), te(He, {
        key: 0,
        height: "0.5rem"
      })) : V("", !0),
      g("div", s3e, [
        t.axisLabels ? (v(), A("div", l3e, [
          (v(!0), A(ge, null, ye(t.axisLabels, (i, a) => (v(), A("div", {
            class: z(["label-box", { centered: t.centeredLabels, "show-extrema": t.axisLabels.length <= 3 }]),
            key: i
          }, [
            t.centeredLabels || t.axisLabels.length <= 3 || t.showExtrema ? (v(), te(Ye, {
              key: 0,
              as: "span",
              align: "center",
              size: "f-10",
              wrap: !1,
              style: { opacity: "0.2" }
            }, {
              default: q(() => [
                me(Q(i), 1)
              ]),
              _: 2
            }, 1024)) : (v(), te(Ye, {
              key: 1,
              as: "span",
              align: "center",
              size: "f-10",
              wrap: !1,
              style: { opacity: "0.2" }
            }, {
              default: q(() => [
                me(Q(a !== 0 && a !== t.axisLabels.length - 1 ? i : ""), 1)
              ]),
              _: 2
            }, 1024))
          ], 2))), 128))
        ])) : V("", !0),
        o[0] || (o[0] = g("div", { class: "offset" }, null, -1))
      ]),
      t.axisTitle && t.axisLabels ? (v(), te(He, {
        key: 1,
        height: "1rem"
      })) : V("", !0),
      t.axisTitle ? (v(), A("div", c3e, [
        H(Ye, {
          class: "w-100",
          as: "span",
          align: "center",
          size: "f-9",
          weight: "500",
          wrap: !1
        }, {
          default: q(() => [
            me(Q(t.axisTitle), 1)
          ]),
          _: 1
        })
      ])) : V("", !0)
    ]));
  }
});
const qa = /* @__PURE__ */ Y(u3e, [["__scopeId", "data-v-ee997c12"]]), d3e = {}, f3e = {
  viewBox: "0 0 278 158",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function h3e(t, e) {
  return v(), A("svg", f3e, [...e[0] || (e[0] = [
    vt('<mask id="mask0_169_4585" style="mask-type:alpha;" maskUnits="userSpaceOnUse" x="0" y="0" width="278" height="158"><rect width="278" height="158" fill="#C4C4C4"></rect></mask><g mask="url(#mask0_169_4585)"><path opacity="0.2" d="M0 0H205.72L0 158V0Z" fill="#FB3535"></path><path opacity="0.1" d="M294.68 0H205.72L0 158L294.68 67.7143V0Z" fill="#FB3535"></path><path opacity="0.2" d="M0 158L294.68 67.7144V158H0Z" fill="#00A861"></path></g><g opacity="0.3"><ellipse cx="25" cy="123.784" rx="3" ry="3.01911" fill="#010105"></ellipse><ellipse cx="40" cy="97.6177" rx="3" ry="3.01911" fill="#010105"></ellipse><ellipse cx="59" cy="129.822" rx="3" ry="3.01911" fill="#010105"></ellipse><ellipse cx="67" cy="113.72" rx="3" ry="3.01911" fill="#010105"></ellipse><ellipse cx="11" cy="56.3568" rx="3" ry="3.01911" fill="#010105"></ellipse><ellipse cx="149" cy="37.2357" rx="3" ry="3.01911" fill="#010105"></ellipse><ellipse cx="233" cy="64.4075" rx="3" ry="3.01911" fill="#010105"></ellipse><ellipse cx="123" cy="132.841" rx="3" ry="3.01911" fill="#010105"></ellipse><ellipse cx="178" cy="110.701" rx="3" ry="3.01911" fill="#010105"></ellipse></g>', 3)
  ])]);
}
const _3e = /* @__PURE__ */ Y(d3e, [["render", h3e]]), E3e = {}, p3e = {
  viewBox: "0 0 278 158",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function m3e(t, e) {
  return v(), A("svg", p3e, [...e[0] || (e[0] = [
    vt('<rect width="278" height="158" rx="8" fill="white"></rect><mask id="mask0_169_4619" style="mask-type:alpha;" maskUnits="userSpaceOnUse" x="0" y="0" width="278" height="158"><rect width="278" height="158" rx="8" fill="#C4C4C4"></rect></mask><g mask="url(#mask0_169_4619)"><path d="M278 159.167H278.5V158.667V42.3562V41.8562H278C275.794 41.8562 274.743 40.4868 273.51 38.8763C272.302 37.2976 270.926 35.504 268.071 35.504C267.256 35.504 266.574 35.8778 266.013 36.4577C265.46 37.0289 265.003 37.8187 264.608 38.7169C263.822 40.5034 263.219 42.8668 262.63 45.1748L262.622 45.206C262.024 47.5508 261.44 49.8369 260.691 51.5395C260.317 52.3899 259.917 53.0571 259.483 53.5059C259.057 53.946 258.62 54.1551 258.143 54.1551C255.89 54.1551 254.937 52.5874 253.779 50.6814L253.761 50.6517C253.197 49.7246 252.58 48.7235 251.727 47.9641C250.852 47.1855 249.74 46.6676 248.214 46.6676C246.709 46.6676 245.639 47.1054 244.806 47.7835C244.019 48.424 243.464 49.2653 242.955 50.0359L242.91 50.1041C242.374 50.9163 241.879 51.6501 241.186 52.1946C240.514 52.723 239.629 53.0914 238.286 53.0914C237.781 53.0914 237.292 52.8098 236.801 52.1502C236.307 51.4875 235.865 50.5089 235.464 49.2812C234.663 46.8297 234.074 43.5439 233.504 40.2114C233.46 39.953 233.416 39.6944 233.372 39.4358C232.851 36.3822 232.333 33.3464 231.669 31.0178C231.31 29.7572 230.896 28.6627 230.393 27.8737C229.895 27.0931 229.233 26.5 228.357 26.5C227.444 26.5 226.78 27.2136 226.289 28.0935C225.783 29.0021 225.358 30.2681 224.983 31.7383C224.263 34.5631 223.695 38.2813 223.127 42.0015L223.054 42.4819C222.458 46.3797 221.854 50.2381 221.068 53.1218C220.675 54.5668 220.245 55.7289 219.768 56.5198C219.28 57.3283 218.829 57.615 218.429 57.615C217.176 57.615 216.316 57.3062 215.64 56.861C214.946 56.4048 214.421 55.7921 213.845 55.1151L213.827 55.0933C213.27 54.4382 212.661 53.7227 211.839 53.1815C210.99 52.6232 209.937 52.263 208.5 52.263C206.901 52.263 205.811 53.2745 205.009 54.5938C204.217 55.8952 203.634 57.6101 203.075 59.2555L203.062 59.292C202.488 60.9805 201.936 62.5949 201.208 63.7926C200.485 64.9821 199.661 65.643 198.571 65.643C197.736 65.643 197.037 66.0109 196.458 66.5917C195.889 67.1633 195.422 67.9543 195.022 68.854C194.221 70.6509 193.623 73.0294 193.044 75.3481L193.017 75.4575C192.441 77.7653 191.882 80.0067 191.16 81.6831C190.794 82.5336 190.401 83.2001 189.973 83.648C189.552 84.0868 189.119 84.2953 188.643 84.2953C187.632 84.2953 186.818 83.5945 186.073 82.2696C185.333 80.9534 184.753 79.1816 184.154 77.3421L184.143 77.3078C183.556 75.5088 182.949 73.6461 182.156 72.2345C181.362 70.8226 180.289 69.6988 178.714 69.6988C177.859 69.6988 177.173 70.1761 176.631 70.8654C176.092 71.5498 175.649 72.4968 175.266 73.5802C174.516 75.7006 173.943 78.4985 173.377 81.2627L173.338 81.4525C172.754 84.3025 172.173 87.1004 171.409 89.187C171.027 90.2312 170.613 91.0574 170.157 91.6147C169.707 92.1656 169.257 92.407 168.786 92.407C167.585 92.407 166.779 91.9805 166.134 91.3348C165.481 90.681 164.994 89.8058 164.458 88.8435L164.413 88.7634C163.876 87.7984 163.285 86.7532 162.437 85.9601C161.566 85.1452 160.436 84.6064 158.857 84.6064C157.59 84.6064 156.7 84.0541 155.975 83.175C155.23 82.2709 154.68 81.0476 154.119 79.7459C154.086 79.6673 154.052 79.5884 154.018 79.5092C153.503 78.3102 152.965 77.0581 152.248 76.0956C151.465 75.0444 150.427 74.2809 148.929 74.2809C147.349 74.2809 146.289 75.4205 145.513 76.8455C144.751 78.2441 144.171 80.082 143.608 81.8662L143.565 82.0027C142.979 83.8598 142.406 85.6484 141.657 86.9763C140.907 88.3083 140.068 89.0256 139 89.0256C138.614 89.0256 138.167 88.7345 137.685 87.88C137.216 87.0488 136.799 85.8286 136.421 84.3139C135.666 81.2911 135.101 77.2487 134.531 73.1668L134.528 73.1439C133.961 69.0884 133.39 64.9957 132.62 61.9158C132.236 60.3762 131.793 59.0511 131.257 58.1006C130.734 57.1735 130.03 56.4464 129.071 56.4464C128.132 56.4464 127.422 57.1147 126.886 57.9924C126.341 58.8846 125.889 60.1267 125.496 61.5658C124.708 64.4502 124.116 68.2829 123.535 72.0746L123.504 72.2787C122.932 76.0203 122.367 79.7065 121.636 82.4751C121.263 83.8877 120.856 85.0225 120.402 85.7942C119.938 86.5853 119.512 86.854 119.143 86.854C118.08 86.854 117.31 86.2804 116.64 85.2783C115.992 84.3086 115.495 83.0199 114.964 81.6436C114.935 81.5694 114.907 81.495 114.878 81.4203C114.326 79.9937 113.729 78.4899 112.884 77.3476C112.021 76.1821 110.865 75.347 109.214 75.347C107.675 75.347 106.576 75.7325 105.717 76.3378C104.875 76.931 104.295 77.7165 103.77 78.4289L103.762 78.4393C103.226 79.1668 102.748 79.8162 102.084 80.3003C101.437 80.7722 100.586 81.1038 99.2857 81.1038C98.1221 81.1038 97.3018 80.477 96.6146 79.3971C95.9203 78.3062 95.4186 76.8385 94.8881 75.2863L94.8721 75.2396C94.3475 73.7048 93.7918 72.0885 92.984 70.8621C92.1608 69.6122 91.0285 68.6988 89.3571 68.6988C87.7537 68.6988 86.6283 69.3308 85.778 70.2653C84.9527 71.1723 84.3865 72.3667 83.8632 73.475L83.8525 73.4976C83.318 74.6295 82.8257 75.6719 82.146 76.4449C81.4875 77.1939 80.662 77.6781 79.4286 77.6781C78.2742 77.6781 77.4263 77.0194 76.7006 75.8665C75.9658 74.6989 75.4213 73.1236 74.8603 71.4724L74.8186 71.3496C74.2817 69.7686 73.7238 68.1257 72.9621 66.8738C72.1735 65.5776 71.0959 64.5884 69.5 64.5884C68.616 64.5884 67.9102 65.0857 67.3542 65.8061C66.802 66.5214 66.3509 67.5121 65.9631 68.6473C65.189 70.9128 64.615 73.9164 64.0503 76.8714L64.0448 76.9002C63.4737 79.8887 62.9113 82.8258 62.1623 85.0175C61.7875 86.1147 61.3788 86.9842 60.9258 87.571C60.4767 88.1528 60.032 88.3997 59.5714 88.3997C58.3672 88.3997 57.5594 87.9813 56.9154 87.3512C56.2632 86.7132 55.7767 85.8592 55.2409 84.9186L55.1966 84.8408C54.6591 83.8977 54.0676 82.875 53.2184 82.099C52.3462 81.3022 51.2183 80.7771 49.6429 80.7771C47.9855 80.7771 46.8171 81.6447 45.9422 82.8452C45.082 84.0254 44.4661 85.5791 43.9012 87.059C43.8588 87.17 43.8168 87.2805 43.7749 87.3904C43.2463 88.7794 42.751 90.0805 42.1236 91.0666C41.4548 92.1178 40.709 92.6976 39.7143 92.6976C38.6449 92.6976 37.8791 92.25 37.2236 91.5304C36.5813 90.8254 36.07 89.8887 35.5137 88.8694C35.4831 88.8133 35.4523 88.757 35.4214 88.7004C34.2796 86.6116 32.9103 84.183 29.7857 84.183C29.2599 84.183 28.814 84.4396 28.4504 84.8174C28.0916 85.1903 27.7834 85.7092 27.511 86.3205C26.9655 87.545 26.511 89.2636 26.1149 91.2812C25.3212 95.324 24.7373 100.704 24.1692 106.053C24.1477 106.255 24.1263 106.457 24.1048 106.659C23.5575 111.817 23.018 116.9 22.313 120.743C21.946 122.744 21.5397 124.375 21.0772 125.496C20.8453 126.059 20.612 126.461 20.386 126.714C20.1632 126.965 19.9887 127.028 19.8571 127.028C19.4492 127.028 19.0319 126.783 18.5965 126.144C18.162 125.507 17.7732 124.563 17.4176 123.376C16.7467 121.137 16.2355 118.183 15.7102 115.147C15.6796 114.97 15.6489 114.793 15.6182 114.616C15.064 111.419 14.4829 108.173 13.6706 105.725C13.265 104.503 12.7891 103.44 12.2032 102.673C11.6132 101.901 10.8649 101.374 9.92857 101.374C8.56528 101.374 7.66825 101.06 6.99423 100.616C6.30519 100.163 5.81424 99.5537 5.27955 98.8754L5.23499 98.8188C4.72556 98.1721 4.16593 97.4617 3.37471 96.9226C2.54243 96.3555 1.48509 95.9953 0 95.9953H-0.5V96.4953V158.667V159.167H0H278Z" fill="url(#paint0_linear_169_4619)" stroke="#006DFF"></path></g><rect opacity="0.1" x="8" y="20" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="8" y="58" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="8" y="96" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="8" y="134" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="35" y="146" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="75" y="146" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="115" y="146" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="155" y="146" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="195" y="146" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="235" y="146" width="16" height="4" rx="2" fill="#010105"></rect><defs><linearGradient id="paint0_linear_169_4619" x1="139" y1="27" x2="139" y2="158.667" gradientUnits="userSpaceOnUse"><stop stop-color="#F0F6FF"></stop><stop offset="1" stop-color="white"></stop></linearGradient></defs>', 14)
  ])]);
}
const N3e = /* @__PURE__ */ Y(E3e, [["render", m3e]]), v3e = {}, g3e = {
  viewBox: "0 0 278 158",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function I3e(t, e) {
  return v(), A("svg", g3e, [...e[0] || (e[0] = [
    vt('<mask id="mask0_169_4642" style="mask-type:alpha;" maskUnits="userSpaceOnUse" x="0" y="0" width="278" height="158"><rect width="278" height="158" fill="white"></rect></mask><g mask="url(#mask0_169_4642)"><rect y="-2" width="69" height="24" fill="#FED7D7"></rect><rect x="138" y="-2" width="35" height="24" fill="#FFEFEF"></rect><rect x="173" y="-2" width="71" height="24" fill="#B3E5D0"></rect><rect x="244" y="-2" width="34" height="24" fill="#FED7D7"></rect><rect x="69" y="-2" width="69" height="24" fill="#BFE9D8"></rect><rect y="44" width="45" height="24" fill="#FED7D7"></rect><rect x="45" y="44" width="24" height="24" fill="#F0F0F5"></rect><rect x="154" y="44" width="49" height="24" fill="#FFE7E7"></rect><rect x="203" y="44" width="34" height="24" fill="#B3E5D0"></rect><rect x="237" y="44" width="41" height="24" fill="#FED7D7"></rect><rect x="69" y="44" width="85" height="24" fill="#99DCC0"></rect><rect y="90" width="73" height="24" fill="#FEB6B6"></rect><rect x="146" y="90" width="43" height="24" fill="#FED7D7"></rect><rect x="189" y="90" width="62" height="24" fill="#B3E5D0"></rect><rect x="251" y="90" width="27" height="24" fill="#CCEEDF"></rect><rect x="73" y="90" width="73" height="24" fill="#99DCC0"></rect><rect y="21" width="79" height="24" fill="#FEE3E3"></rect><rect x="146" y="21" width="33" height="24" fill="#FEDBDB"></rect><rect x="179" y="21" width="77" height="24" fill="#A3E0C6"></rect><rect x="256" y="21" width="22" height="24" fill="#FEE3E3"></rect><rect x="79" y="21" width="67" height="24" fill="#B3E5D0"></rect><rect y="67" width="54" height="24" fill="#FEC2C2"></rect><rect x="54" y="67" width="25" height="24" fill="#D6F1E6"></rect><rect x="135" y="67" width="44" height="24" fill="#FFEFEF"></rect><rect x="179" y="67" width="65" height="24" fill="#D1EFE3"></rect><rect x="244" y="67" width="34" height="24" fill="#FEC2C2"></rect><rect x="79" y="67" width="56" height="24" fill="#A3E0C6"></rect><rect y="113" width="93" height="24" fill="#FEDFDF"></rect><rect x="198" y="113" width="49" height="24" fill="#FEC2C2"></rect><rect x="247" y="113" width="31" height="24" fill="#FECBCB"></rect><rect x="93" y="113" width="105" height="24" fill="#F0F0F5"></rect><rect y="136" width="63" height="24" fill="#FED7D7"></rect><rect x="117" y="136" width="62" height="24" fill="#F0F0F5"></rect><rect x="179" y="136" width="77" height="24" fill="#FEC2C2"></rect><rect x="256" y="136" width="22" height="24" fill="#FED7D7"></rect><rect x="63" y="136" width="54" height="24" fill="#FECCCC"></rect></g>', 2)
  ])]);
}
const O3e = /* @__PURE__ */ Y(v3e, [["render", I3e]]), A3e = {}, D3e = {
  viewBox: "0 0 278 158",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function C3e(t, e) {
  return v(), A("svg", D3e, [...e[0] || (e[0] = [
    vt('<rect width="278" height="158" rx="8" fill="white"></rect><rect opacity="0.1" y="42" width="278" height="32" fill="#00A861"></rect><mask id="mask0_177_4638" style="mask-type:alpha;" maskUnits="userSpaceOnUse" x="0" y="0" width="278" height="158"><rect width="278" height="158" rx="8" fill="#C4C4C4"></rect></mask><g mask="url(#mask0_177_4638)"><rect x="36" y="26" width="17" height="112" rx="4" fill="#CCE2FF"></rect><rect opacity="0.1" x="36" y="146" width="16" height="4" rx="2" fill="#010105"></rect><rect x="77" y="33" width="17" height="105.677" rx="4" fill="#CCE2FF"></rect><rect opacity="0.1" x="77" y="146.226" width="16" height="3.77419" rx="1.8871" fill="#010105"></rect><rect x="118" y="49" width="17" height="89" rx="4" fill="#CCE2FF"></rect><rect opacity="0.1" x="118" y="146" width="16" height="4" rx="2" fill="#010105"></rect><rect x="159" y="29" width="17" height="109" rx="4" fill="#CCE2FF"></rect><rect opacity="0.1" x="159" y="146" width="16" height="4" rx="2" fill="#010105"></rect><rect x="200" y="15" width="17" height="122" rx="4" fill="#CCE2FF"></rect><rect opacity="0.1" x="200" y="145.742" width="16" height="4.25806" rx="2.12903" fill="#010105"></rect><rect x="241" y="46" width="17" height="92" rx="4" fill="#CCE2FF"></rect><rect opacity="0.1" x="241" y="146" width="16" height="4" rx="2" fill="#010105"></rect></g><rect opacity="0.1" x="8" y="20" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="8" y="58" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="8" y="96" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="8" y="134" width="16" height="4" rx="2" fill="#010105"></rect>', 8)
  ])]);
}
const S3e = /* @__PURE__ */ Y(A3e, [["render", C3e]]), w3e = {}, T3e = {
  viewBox: "0 0 278 158",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function b3e(t, e) {
  return v(), A("svg", T3e, [...e[0] || (e[0] = [
    vt('<mask id="mask0_195_1684" style="mask-type:alpha;" maskUnits="userSpaceOnUse" x="0" y="0" width="278" height="158"><rect width="278" height="158" fill="white"></rect></mask><g mask="url(#mask0_195_1684)"><rect width="71" height="158" fill="#FDC2C2"></rect><rect x="71" width="48" height="158" fill="#FDEFEF"></rect><rect x="119" width="48" height="158" fill="#BFF5DE"></rect><rect x="167" width="111" height="158" fill="#B2E4CF"></rect><g opacity="0.3"><ellipse rx="3" ry="3.01911" transform="matrix(-1 0 0 1 230 119.784)" fill="#010105"></ellipse><ellipse rx="3" ry="3.01911" transform="matrix(-1 0 0 1 196 125.822)" fill="#010105"></ellipse><ellipse rx="3" ry="3.01911" transform="matrix(-1 0 0 1 182 104.019)" fill="#010105"></ellipse><ellipse rx="3" ry="3.01911" transform="matrix(-1 0 0 1 249 33.0191)" fill="#010105"></ellipse><ellipse rx="3" ry="3.01911" transform="matrix(-1 0 0 1 107 52.0191)" fill="#010105"></ellipse><ellipse rx="3" ry="3.01911" transform="matrix(-1 0 0 1 161 148.019)" fill="#010105"></ellipse><ellipse rx="3" ry="3.01911" transform="matrix(-1 0 0 1 22 60.4075)" fill="#010105"></ellipse><ellipse rx="3" ry="3.01911" transform="matrix(-1 0 0 1 132 128.841)" fill="#010105"></ellipse><ellipse rx="3" ry="3.01911" transform="matrix(-1 0 0 1 77 106.701)" fill="#010105"></ellipse></g></g>', 2)
  ])]);
}
const R3e = /* @__PURE__ */ Y(w3e, [["render", b3e]]), M3e = {}, P3e = {
  viewBox: "0 0 278 158",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function y3e(t, e) {
  return v(), A("svg", P3e, [...e[0] || (e[0] = [
    vt('<rect width="278" height="158" fill="white"></rect><mask id="mask0_465_1912" style="mask-type:alpha;" maskUnits="userSpaceOnUse" x="0" y="0" width="278" height="158"><rect width="278" height="158" fill="#C4C4C4"></rect></mask><g mask="url(#mask0_465_1912)"><path d="M-4.65638 117.025L-5 117.138V117.5V158V158.5H-4.5H284H284.5V158V22.5V21.8089L283.844 22.0251L-4.65638 117.025Z" fill="url(#paint0_linear_465_1912)" stroke="#006DFF"></path><g opacity="0.3"><ellipse rx="3" ry="3.01911" transform="matrix(-1 0 0 1 229 30.7835)" fill="#010105"></ellipse><ellipse rx="3" ry="3.01911" transform="matrix(-1 0 0 1 205 57.0191)" fill="#010105"></ellipse><ellipse rx="3" ry="3.01911" transform="matrix(-1 0 0 1 262 34.0191)" fill="#010105"></ellipse><ellipse rx="3" ry="3.01911" transform="matrix(-1 0 0 1 119 64.0191)" fill="#010105"></ellipse><ellipse rx="3" ry="3.01911" transform="matrix(-1 0 0 1 166 55.0191)" fill="#010105"></ellipse><ellipse rx="3" ry="3.01911" transform="matrix(-1 0 0 1 34 97.4075)" fill="#010105"></ellipse><ellipse rx="3" ry="3.01911" transform="matrix(-1 0 0 1 77 102.701)" fill="#010105"></ellipse></g></g><rect opacity="0.1" x="8" y="20" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="8" y="58" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="8" y="96" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="8" y="134" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="35" y="146" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="75" y="146" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="115" y="146" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="155" y="146" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="195" y="146" width="16" height="4" rx="2" fill="#010105"></rect><rect opacity="0.1" x="235" y="146" width="16" height="4" rx="2" fill="#010105"></rect><defs><linearGradient id="paint0_linear_465_1912" x1="139.75" y1="52.5" x2="139.75" y2="219" gradientUnits="userSpaceOnUse"><stop stop-color="#F0F6FF"></stop><stop offset="1" stop-color="white"></stop></linearGradient></defs>', 14)
  ])]);
}
const L3e = /* @__PURE__ */ Y(M3e, [["render", y3e]]), x3e = {
  components: {
    Spacer: He,
    Text: Ye,
    ScatterChartPlaceholder: _3e,
    AreaChartPlaceholder: N3e,
    AdScheduleChartPlaceholder: O3e,
    BarChartPlaceholder: S3e,
    SegmentsChartPlaceholder: R3e,
    BidFactoryChartPlaceholder: L3e
  },
  name: "Chart Placeholder",
  props: {
    type: {
      type: String,
      required: !1
    },
    title: {
      type: String,
      required: !1
    },
    screenWidth: {
      type: Number,
      required: !1
    },
    removeContainer: {
      type: Boolean,
      required: !1
    }
  },
  setup(t) {
    const e = {
      scatter: {
        title: "Scatter Point",
        screenWidth: 480
      },
      area: {
        title: "Area and Line",
        screenWidth: 480
      },
      schedule: {
        title: "Ad Schedule",
        screenWidth: 480
      },
      bar: {
        title: "Bar",
        screenWidth: 480
      },
      segment: {
        title: "Segments",
        screenWidth: 480
      },
      bid: {
        title: "Bid Factory",
        screenWidth: 480
      }
    };
    return {
      copyItem: x(() => e[t.type])
    };
  }
};
const U3e = { class: "relative" }, $3e = { class: "overlay-tag" };
function k3e(t, e, n, r, o, i) {
  const a = ee("Text"), s = ee("ScatterChartPlaceholder"), l = ee("AreaChartPlaceholder"), c = ee("AdScheduleChartPlaceholder"), u = ee("BarChartPlaceholder"), d = ee("SegmentsChartPlaceholder"), f = ee("BidFactoryChartPlaceholder"), h = ee("Spacer");
  return v(), A("div", {
    class: z({ container: !n.removeContainer })
  }, [
    g("div", U3e, [
      g("div", $3e, [
        H(a, {
          as: "p",
          size: "f-9"
        }, {
          default: q(() => [...e[0] || (e[0] = [
            me(" Increase window size to view ", -1)
          ])]),
          _: 1
        })
      ]),
      n.type === "scatter" ? (v(), te(s, {
        key: 0,
        class: "sample-chart"
      })) : V("", !0),
      n.type === "area" ? (v(), te(l, {
        key: 1,
        class: "sample-chart shadow"
      })) : V("", !0),
      n.type === "schedule" ? (v(), te(c, {
        key: 2,
        class: "sample-chart"
      })) : V("", !0),
      n.type === "bar" ? (v(), te(u, {
        key: 3,
        class: "sample-chart shadow"
      })) : V("", !0),
      n.type === "segment" ? (v(), te(d, {
        key: 4,
        class: "sample-chart shadow"
      })) : V("", !0),
      n.type === "bid" ? (v(), te(f, {
        key: 5,
        class: "sample-chart shadow"
      })) : V("", !0)
    ]),
    H(h, { height: "24px" }),
    H(a, {
      as: "p",
      size: "f-8"
    }, {
      default: q(() => [
        me(Q(r.copyItem.title) + " Charts are best viewed on screens ", 1),
        g("b", null, Q(r.copyItem.screenWidth) + "px", 1),
        e[1] || (e[1] = me(" or wider, please increase your window size or use another device. ", -1))
      ]),
      _: 1
    })
  ], 2);
}
const Xa = /* @__PURE__ */ Y(x3e, [["render", k3e], ["__scopeId", "data-v-9e5211e5"]]), B3e = {
  components: {
    Money: Dx,
    Percent: l5,
    ChartTooltip: Co,
    Text: Ye,
    Spacer: He,
    GraphKeys: jp,
    VerticalAxisLabels: Za,
    HorizontalAxisLabels: qa,
    ChartPlaceholder: Xa
  },
  name: "AdScheduleChart",
  props: {
    adSchedule: {
      type: Object,
      required: !0
    },
    metric: {
      type: Object,
      required: !1
    },
    axisTitles: {
      type: Object,
      required: !1
    },
    removeInteractivity: {
      type: Boolean,
      required: !1
    },
    disableFallback: {
      type: Boolean,
      required: !1
    },
    removePlaceholderContainer: {
      type: Boolean,
      required: !1
    }
  },
  setup(t) {
    return Yve(t);
  }
};
const G3e = { class: "chart-flex-wrapper" }, F3e = { ref: "yAxisLabels" }, V3e = { class: "chart-grid" }, H3e = ["width", "height"], W3e = ["id", "width", "height"], Y3e = ["width", "height"], K3e = ["mask"], z3e = ["width", "height", "fill-opacity"], Z3e = ["y", "x", "height", "width", "fill-opacity", "onMouseenter"], q3e = ["cx", "cy"], X3e = {
  key: 1,
  ref: "tooltipContent"
};
function j3e(t, e, n, r, o, i) {
  var f, h;
  const a = ee("Spacer"), s = ee("GraphKeys"), l = ee("VerticalAxisLabels"), c = ee("HorizontalAxisLabels"), u = ee("ChartPlaceholder"), d = ee("ChartTooltip");
  return v(), A(ge, null, [
    g("div", {
      ref: "chartContainer",
      class: z({ "desktop-chart": !n.disableFallback })
    }, [
      ue(t.$slots, "header", { hoveredItem: t.hoveredItem }, void 0, !0),
      t.$slots.header ? (v(), te(a, { key: 0 })) : V("", !0),
      t.graphKeys ? (v(), te(s, {
        key: 1,
        "graph-keys": t.graphKeys
      }, null, 8, ["graph-keys"])) : V("", !0),
      H(a, { height: "0.25rem" }),
      g("div", G3e, [
        g("div", F3e, [
          H(l, {
            "chart-height": t.svgHeight,
            "axis-title": (f = n.axisTitles) == null ? void 0 : f.y,
            "axis-labels": t.abbreviatedDays,
            centered: !0
          }, null, 8, ["chart-height", "axis-title", "axis-labels"])
        ], 512),
        g("div", V3e, [
          (v(), A("svg", {
            width: t.svgWidth,
            height: t.svgHeight,
            overflow: "visible",
            onMouseleave: e[0] || (e[0] = (..._) => t.handleMouseLeave && t.handleMouseLeave(..._))
          }, [
            g("mask", {
              id: t.roundedMaskId,
              "mask-type": "alpha",
              maskUnits: "userSpaceOnUse",
              x: 0,
              y: 0,
              width: t.svgWidth,
              height: t.svgHeight
            }, [
              g("rect", {
                x: 0,
                y: 0,
                width: t.svgWidth,
                height: t.svgHeight,
                rx: "8"
              }, null, 8, Y3e)
            ], 8, W3e),
            g("g", { mask: t.roundedMaskurl }, [
              g("rect", {
                class: "chart-background fill-opacity-transition",
                fill: "currentColor",
                x: 0,
                y: 0,
                width: t.svgWidth,
                height: t.svgHeight,
                "fill-opacity": t.animationMultiplier
              }, null, 8, z3e),
              (v(!0), A(ge, null, ye(t.daysOfWeek, (_, E) => (v(), A("g", { key: E }, [
                (v(!0), A(ge, null, ye(t.cells[_], (m, N) => (v(), A("g", { key: N }, [
                  g("rect", {
                    y: E * t.svgHeight / 7,
                    x: m.x,
                    height: t.svgHeight * t.animationMultiplier / 7,
                    width: m.width * t.animationMultiplier,
                    class: z([`opteo-${m.color}`, "fill-opacity-transition"]),
                    fill: "currentColor",
                    "fill-opacity": m.opacity * t.animationMultiplier,
                    onMouseenter: (I) => t.handelMouseEnterCell(_, N)
                  }, null, 42, Z3e)
                ]))), 128))
              ]))), 128))
            ], 8, K3e),
            Ze(g("circle", {
              ref: "tooltipCircle",
              cx: t.cx,
              cy: t.cy,
              r: "4",
              fill: "#000000"
            }, null, 8, q3e), [
              [bi, t.showTooltipMarker]
            ])
          ], 40, H3e)),
          H(c, {
            "chart-width": t.svgWidth,
            "axis-title": (h = n.axisTitles) == null ? void 0 : h.x,
            "axis-labels": t.hoursOfDays,
            "show-extrema": ""
          }, null, 8, ["chart-width", "axis-title", "axis-labels"])
        ])
      ])
    ], 2),
    n.disableFallback ? V("", !0) : (v(), te(u, {
      key: 0,
      type: "schedule",
      "remove-container": n.removePlaceholderContainer,
      class: "mobile-chart"
    }, null, 8, ["remove-container"])),
    n.removeInteractivity ? V("", !0) : (v(), A("div", X3e, [
      t.$slots.tooltip ? ue(t.$slots, "tooltip", {
        key: 0,
        hoveredItem: t.hoveredItem
      }, void 0, !0) : t.hoveredItem ? (v(), te(d, {
        key: 1,
        title: t.hoveredItem.formattedTitle,
        subtitle: t.hoveredItem.formattedSubtitle,
        metrics: t.hoveredItem.metrics
      }, null, 8, ["title", "subtitle", "metrics"])) : V("", !0)
    ], 512))
  ], 64);
}
const J3e = /* @__PURE__ */ Y(B3e, [["render", j3e], ["__scopeId", "data-v-f9b68cb2"]]);
var yt = /* @__PURE__ */ ((t) => (t.Horizontal = "x", t.Vertical = "y", t))(yt || {});
function Mi({
  minItem: t,
  maxItem: e,
  axis: n,
  metric: r
}) {
  const o = x(() => Math.floor(Math.log10(e.value - ((t == null ? void 0 : t.value) ?? 0)))), i = x(() => {
    const O = Math.pow(10, o.value);
    return O <= 0 || Q4(O) ? 1 : O;
  }), a = x(() => Math.floor(((t == null ? void 0 : t.value) ?? 0) / i.value) * i.value), s = x(() => {
    const O = Math.ceil((((t == null ? void 0 : t.value) ?? 0) + (e.value - ((t == null ? void 0 : t.value) ?? 0))) / i.value) * i.value;
    return O || i.value;
  }), l = s.value > 999;
  let c = W(0), u = W(0);
  const d = x(
    () => Math.max(Math.abs(s.value), Math.abs(a.value), i.value)
  ), f = x(() => s.value < 0 || a.value < 0), h = x(() => {
    let O = 3, p = Math.round(d.value / (i.value ?? 1));
    if (!p)
      return {
        n: O,
        divide: 1
      };
    for (; p < O; )
      p *= 10;
    for (; p % O !== 0; )
      O++;
    if (!f.value) {
      const D = d.value / (O + 1);
      return {
        n: O + 1,
        divide: D
      };
    }
    const C = d.value / O;
    return {
      n: Math.ceil(Math.abs(e.value / C)) + Math.ceil(Math.abs(((t == null ? void 0 : t.value) ?? 0) / C)) + 1,
      divide: C
    };
  }), _ = x(() => (r == null ? void 0 : r.dataType) === "percentage" ? (t == null ? void 0 : t.value) ?? 0 : ((t == null ? void 0 : t.value) ?? 0) / h.value.divide), E = x(
    () => e.value > 0 ? e.value / h.value.divide : h.value.n
  ), m = x(() => (r == null ? void 0 : r.dataType) === "percentage" ? Math.floor(_.value) : Math.floor(_.value) * h.value.divide), N = x(() => Math.ceil(E.value) * h.value.divide), I = x(() => {
    let p = (N.value - m.value) / (h.value.n - 1);
    const C = [];
    for (let D = 0; D < h.value.n; D++) {
      const T = D * p + m.value, { displayValue: k } = yn({ value: T, metric: r, compact: l });
      if (C.push(k.value), D == h.value.n - 1) {
        const G = Math.abs(m.value);
        u.value = T, c.value = G / (G + u.value);
      }
    }
    return n === "y" ? C.reverse() : C;
  });
  return { min: m, max: N, formattedAxis: I, zeroLocationPercent: c };
}
function Q3e(t) {
  for (var e = -1, n = t == null ? 0 : t.length, r = 0, o = []; ++e < n; ) {
    var i = t[e];
    i && (o[r++] = i);
  }
  return o;
}
function Jp({
  items: t,
  numberOfPoints: e = x(() => 8)
}) {
  const n = x(() => Q3e(t.map((c) => c.label))), r = x(() => t.length - 1), o = x(() => {
    let l = 0, c = Math.min(e.value, r.value);
    for (; (r.value - l) % c !== 0; )
      c -= 1, c <= 2 && (l += 1, c = Math.min(e.value, r.value));
    return { offset: l, calcNumberOfPoints: c };
  }), i = x(() => o.value.offset), a = x(() => o.value.calcNumberOfPoints);
  return !e || e.value === t.length ? { formattedAxisLabels: n } : { formattedAxisLabels: x(() => {
    const l = [];
    for (let c = 0; c <= a.value; c++) {
      const u = c * (r.value - i.value) / a.value;
      l.push(n.value[u]);
    }
    return l;
  }), offset: i };
}
function n1({
  markers: t,
  svgHeight: e,
  minItemY: n,
  maxItemY: r,
  appendTo: o
}) {
  var d;
  const i = W(), a = W(), s = W(0), l = x(() => {
    var f;
    return (f = c.value) == null ? void 0 : f[s.value];
  }), c = x(() => {
    var f;
    return ((f = t.value) == null ? void 0 : f.map((h) => {
      const _ = Math.abs(r.value - n.value), E = Math.abs(n.value - h.value), m = e.value - e.value * E / _, N = h.color ?? "gray";
      return {
        y: m,
        color: N,
        ...h
      };
    })) ?? [];
  }), u = {
    content: () => a.value,
    sticky: !0,
    hideOnClick: !1,
    animateFill: !1,
    animation: "shift-away",
    placement: ((d = l.value) == null ? void 0 : d.labelPosition) === "end" ? "top-end" : "top-start",
    offset: [8, 8],
    arrow: !1,
    showOnCreate: !0,
    appendTo: () => o != null && o.value ? o.value : document.body
  };
  return Ui(i, u), {
    formattedMarkers: c,
    markerTextAnchor: i,
    markerTextAnchorContent: a,
    hoveredMarker: l,
    hoveredMarkerIndex: s
  };
}
function A7({
  areas: t,
  chartDimensions: e,
  itemExtrema: n
}) {
  return x(
    () => t.map((r) => {
      var h, _, E, m, N, I, O, p;
      const o = r.axis === yt.Horizontal ? Math.abs((((h = n.maxItemX) == null ? void 0 : h.value) ?? 0) - (((_ = n.minItemX) == null ? void 0 : _.value) ?? 0)) : Math.abs((((E = n.maxItemY) == null ? void 0 : E.value) ?? 0) - (((m = n.minItemY) == null ? void 0 : m.value) ?? 0)), i = r.axis === yt.Horizontal ? e.svgWidth.value : e.svgHeight.value, a = (r.axis === yt.Horizontal ? (N = n.minItemX) == null ? void 0 : N.value : (I = n.minItemY) == null ? void 0 : I.value) ?? 0, s = (r.axis === yt.Horizontal ? (O = n.maxItemX) == null ? void 0 : O.value : (p = n.maxItemY) == null ? void 0 : p.value) ?? 0, l = r.axis === yt.Horizontal ? Math.min(r.start.valueOf(), r.end.valueOf()) - a : s - Math.max(r.start.valueOf(), r.end.valueOf()), c = l * i / o, u = (r.axis === yt.Horizontal ? l + Math.abs(
        Math.max(r.start.valueOf(), r.end.valueOf()) - Math.min(r.start.valueOf(), r.end.valueOf())
      ) : l - Math.abs(
        Math.max(r.start.valueOf(), r.end.valueOf()) - Math.min(r.start.valueOf(), r.end.valueOf())
      )) * i / o, d = r.axis === yt.Horizontal ? e.svgHeight.value : Math.abs(u - c), f = r.axis === yt.Horizontal ? Math.abs(u - c) : e.svgWidth.value;
      return {
        [r.axis]: c,
        width: f,
        height: d,
        color: r.color ? `${r.color}-area` : "blue-area"
      };
    })
  );
}
const ege = 36;
function tge(t) {
  const e = so("axisLabelsInsideChart", !1), n = x(() => t.barWidth ?? ege), r = W(), o = W(), { width: i } = go(r), a = x(() => {
    var w;
    return Math.max(240, i.value - (((w = o.value) == null ? void 0 : w.clientWidth) ?? 0));
  }), s = x(() => t.chartHeight ?? 300), l = x(() => {
    var w, R;
    return [
      ...t.items.map((B) => B.y),
      ...((w = t.horizontalMarkers) == null ? void 0 : w.map((B) => B.value)) ?? [],
      ...((R = t.areas) == null ? void 0 : R.map(
        (B) => B.axis === yt.Vertical ? Math.max(B.start.valueOf(), B.start.valueOf()) : 0
      )) ?? []
    ];
  }), c = x(() => Math.min(...l.value, 0)), u = x(() => Math.max(...l.value)), {
    formattedAxis: d,
    min: f,
    max: h
  } = Mi({
    minItem: c,
    maxItem: u,
    axis: yt.Vertical,
    metric: t.metric
  }), _ = x(
    () => (a.value - (e ? 32 : 0) - n.value * t.items.length) / t.items.length
  ), { animationMultiplier: E } = Hi(t.removeInteractivity), { tooltipCircle: m, tooltipContent: N, hoverItem: I, hideTooltip: O, hoveredIndex: p, showTooltipMarker: C } = Do({
    appendTo: r,
    items: t.items,
    animationMultiplier: E,
    removeInteractivity: t.removeInteractivity
  }), { formattedMarkers: D } = n1({
    markers: Ga(t, "horizontalMarkers"),
    svgHeight: s,
    minItemY: f,
    maxItemY: h,
    appendTo: r
  }), T = x(() => t.items.length), { formattedAxisLabels: k } = Jp({ items: t.items, numberOfPoints: T }), G = x(() => {
    var w;
    return (((w = $.value[p.value]) == null ? void 0 : w.x) ?? 0) + n.value / 2;
  }), b = x(() => {
    var w;
    return E ? ((w = $.value[p.value]) == null ? void 0 : w.y) ?? 0 : 0;
  }), P = x(() => $.value[p.value]), $ = x(
    () => t.items.map((w, R) => {
      const { displayValue: B } = yn({
        value: w.y,
        metric: t.metric
      }), U = Math.abs(h.value - f.value), K = E.value * (s.value * Math.abs(w.y)) / U, Z = w.y < 0 ? (h.value * s.value + w.y - w.y * E.value) / U : (h.value - w.y * E.value) * s.value / U;
      return {
        ...w,
        index: R,
        height: K,
        x: n.value * R + _.value * (R + 1 / 2) + (e ? 32 : 0),
        y: Z,
        formattedValue: B.value
      };
    })
  ), y = t.areas ? A7({
    areas: t.areas,
    chartDimensions: { svgHeight: s, svgWidth: a },
    itemExtrema: {
      minItemY: f,
      maxItemY: h
    }
  }) : void 0, L = x(() => {
    var w, R;
    return [
      {
        label: t.metric.label,
        value: (w = P.value) == null ? void 0 : w.formattedValue,
        color: ((R = P.value) == null ? void 0 : R.color) ?? "opteo-blue"
      }
    ];
  });
  return {
    tooltipCircle: m,
    tooltipContent: N,
    yAxis: d,
    bars: $,
    labels: k,
    barGap: _,
    hoveredIndex: p,
    hoverItem: I,
    cx: G,
    cy: b,
    hideTooltip: O,
    showTooltipMarker: C,
    svgWidth: a,
    svgHeight: s,
    barWidth: n,
    formattedMarkers: D,
    plotLines: L,
    hoveredItem: P,
    yAxisContainer: o,
    generatedAreas: y,
    chartContainer: r,
    axisLabelsInsideChart: e
  };
}
const nge = { class: "chart-flex-wrapper" }, rge = { class: "h-100" }, oge = ["width", "height"], ige = { key: 0 }, age = ["x2", "y1", "y2"], sge = ["x", "y"], lge = ["y"], cge = { key: 1 }, uge = ["x", "y", "width", "height"], dge = ["width", "height", "x", "onMouseenter"], fge = ["width", "height", "x", "y"], hge = ["cx", "cy"], _ge = /* @__PURE__ */ Ne({
  __name: "BarChart",
  props: {
    items: {},
    metric: {},
    horizontalMarkers: {},
    axisTitles: {},
    areas: {},
    removeInteractivity: { type: Boolean },
    showVerticalAxis: { type: Boolean, default: !0 },
    barWidth: {},
    chartHeight: {},
    disableFallback: { type: Boolean },
    removePlaceholderContainer: { type: Boolean }
  },
  setup(t) {
    const e = t, {
      tooltipCircle: n,
      tooltipContent: r,
      yAxis: o,
      bars: i,
      labels: a,
      barGap: s,
      hoveredIndex: l,
      hoverItem: c,
      cx: u,
      cy: d,
      hideTooltip: f,
      showTooltipMarker: h,
      svgWidth: _,
      svgHeight: E,
      barWidth: m,
      formattedMarkers: N,
      plotLines: I,
      hoveredItem: O,
      yAxisContainer: p,
      generatedAreas: C,
      chartContainer: D,
      axisLabelsInsideChart: T
    } = tge(e);
    return (k, G) => {
      var b, P;
      return v(), A(ge, null, [
        g("div", {
          ref_key: "chartContainer",
          ref: D,
          class: z(["w-100 h-100", { "desktop-chart": !t.disableFallback }])
        }, [
          ue(k.$slots, "header", {
            class: "w-100",
            hoveredItem: M(O)
          }, void 0, !0),
          k.$slots.header ? (v(), te(He, { key: 0 })) : V("", !0),
          g("div", nge, [
            t.showVerticalAxis ? (v(), A("div", {
              key: 0,
              ref_key: "yAxisContainer",
              ref: p
            }, [
              H(Za, {
                "chart-height": M(E),
                "axis-title": (b = t.axisTitles) == null ? void 0 : b.y,
                "axis-labels": M(o)
              }, null, 8, ["chart-height", "axis-title", "axis-labels"])
            ], 512)) : V("", !0),
            g("div", rge, [
              (v(), A("svg", {
                width: M(_),
                height: M(E),
                overflow: "visible",
                onMouseleave: G[0] || (G[0] = //@ts-ignore
                (...$) => M(f) && M(f)(...$))
              }, [
                M(N) ? (v(), A("g", ige, [
                  (v(!0), A(ge, null, ye(M(N), ($) => (v(), A("g", {
                    key: $.label
                  }, [
                    g("line", {
                      class: "all-transition",
                      x1: 0,
                      x2: M(_),
                      y1: $.y,
                      y2: $.y,
                      style: { stroke: "rgb(218, 218, 218)" },
                      "stroke-dasharray": "5,3"
                    }, null, 8, age),
                    $.labelPosition === "end" ? (v(), A("text", {
                      key: 0,
                      class: "marker-text height-transition",
                      x: M(_),
                      y: $.y,
                      dx: "-3px",
                      dy: "-5px",
                      "text-anchor": "end"
                    }, Q($.label), 9, sge)) : (v(), A("text", {
                      key: 1,
                      class: "marker-text",
                      x: 0,
                      y: $.y,
                      dy: "-5px",
                      "text-anchor": "start"
                    }, Q($.label), 9, lge))
                  ]))), 128))
                ])) : V("", !0),
                M(C) ? (v(), A("g", cge, [
                  (v(!0), A(ge, null, ye(M(C), ($, y) => (v(), A("rect", {
                    key: y,
                    x: $.x,
                    y: $.y,
                    width: $.width,
                    height: $.height,
                    class: z($.color)
                  }, null, 10, uge))), 128))
                ])) : V("", !0),
                (v(!0), A(ge, null, ye(M(i), ($, y) => (v(), A("g", {
                  key: $.index
                }, [
                  g("rect", {
                    width: M(m) + M(s),
                    height: M(E),
                    x: $.x - M(s) / 2,
                    y: 0,
                    fill: "currentColor",
                    "fill-opacity": "0",
                    onMouseenter: (L) => M(c)(y)
                  }, null, 40, dge),
                  g("rect", {
                    width: M(m),
                    height: $.height,
                    x: $.x,
                    y: $.y,
                    fill: "currentColor",
                    class: z([
                      $.color ? `${$.color}` : "opteo-blue",
                      {
                        "o-100": M(l) === y || !M(h),
                        "o-20": M(l) !== y && M(h)
                      },
                      "fill-opacity-transition height-transition"
                    ]),
                    rx: "4"
                  }, null, 10, fge)
                ]))), 128)),
                g("circle", {
                  ref_key: "tooltipCircle",
                  ref: n,
                  class: z(["fill-opacity-transition", { "o-0": !M(i)[M(l)] || !M(h) }]),
                  cx: M(u),
                  cy: M(d),
                  r: "4",
                  fill: "#000"
                }, null, 10, hge)
              ], 40, oge)),
              g("div", {
                class: z([
                  "x-axis-container",
                  {
                    "inside-axis": M(T)
                  }
                ])
              }, [
                H(qa, {
                  "chart-width": M(_),
                  "axis-labels": M(a),
                  "axis-title": (P = t.axisTitles) == null ? void 0 : P.x,
                  "centered-labels": ""
                }, null, 8, ["chart-width", "axis-labels", "axis-title"])
              ], 2)
            ])
          ])
        ], 2),
        t.disableFallback ? V("", !0) : (v(), te(Xa, {
          key: 0,
          type: "bar",
          "remove-container": t.removePlaceholderContainer,
          class: "mobile-chart"
        }, null, 8, ["remove-container"])),
        t.removeInteractivity ? V("", !0) : (v(), A("div", {
          key: 1,
          ref_key: "tooltipContent",
          ref: r
        }, [
          k.$slots.tooltip ? ue(k.$slots, "tooltip", {
            key: 0,
            hoveredItem: M(O)
          }, void 0, !0) : (v(), te(Co, {
            key: 1,
            "plot-lines": M(I)
          }, null, 8, ["plot-lines"]))
        ], 512))
      ], 64);
    };
  }
});
const Ege = /* @__PURE__ */ Y(_ge, [["__scopeId", "data-v-d58ca257"]]);
function pge(t, e) {
  for (var n, r = -1, o = t.length; ++r < o; ) {
    var i = e(t[r]);
    i !== void 0 && (n = n === void 0 ? i : n + i);
  }
  return n;
}
function Pc(t, e) {
  return t && t.length ? pge(t, Vi(e)) : 0;
}
const sh = 150, Ig = 150, as = 100, Og = 10, Ag = 24;
function mge(t) {
  const e = x(() => Pc(t.items, (O) => O.y));
  function n(O, p = as) {
    const C = (O - 90) * Math.PI / 180;
    return {
      x: sh + p * Math.cos(C),
      y: Ig + p * Math.sin(C)
    };
  }
  const r = x(() => {
    const O = (Ag + Og) * 360 / (2 * Math.PI * as), p = 360 - t.items.length * O;
    return t.items.map((C, D) => {
      const G = Pc(
        t.items.filter((re, j) => j < D),
        "y"
      ) / e.value * p, b = (Og * 360 / (4 * Math.PI * as) + (G + D * O)) * _.value, $ = C.y / e.value * p * _.value, y = b + $, L = (y - b) / 2 + b, w = n(L, as + 16), R = `${w.y > Ig ? "bottom" : "top"}-${w.x > sh ? "start" : "end"}`, B = [w.x > sh ? 8 : -8, 8], U = n(y), K = n(b), Z = _.value && y - b <= 180 ? "0" : "1", X = ["M", U.x, U.y, "A", as, as, 0, Z, 0, K.x, K.y].join(" "), { displayValue: J } = yn({
        metric: t.metric,
        value: C.y,
        compact: t.compactKeys
      }), ae = (t.items.length - D) / t.items.length * 0.8 + 0.2;
      return {
        ...C,
        d: X,
        tooltipPoint: w,
        tooltipPosition: R,
        formattedValue: J,
        tooltipOffset: B,
        startAngle: b,
        endAngle: y,
        strokeOpacity: ae
      };
    });
  }), o = x(() => t.items[d.value]), i = W(), { animationMultiplier: a } = Hi(t.removeInteractivity), { tooltipCircle: s, tooltipContent: l, hoverItem: c, hideTooltip: u, hoveredIndex: d, showTooltipMarker: f, setProps: h } = Do({
    appendTo: i,
    items: t.items,
    animationMultiplier: a,
    removeInteractivity: t.removeInteractivity
  }), _ = i$(a, {
    duration: 750,
    transition: [0.19, 1, 0.22, 1],
    onFinished: () => {
      var O, p;
      h({
        // @ts-ignore
        placement: (O = r.value[d == null ? void 0 : d.value]) == null ? void 0 : O.tooltipPosition,
        offset: (p = r.value[d == null ? void 0 : d.value]) == null ? void 0 : p.tooltipOffset
      });
    }
  }), E = x(() => {
    var O;
    return ((O = r.value[d.value]) == null ? void 0 : O.tooltipPoint.x) ?? 0;
  }), m = x(() => {
    var O;
    return ((O = r.value[d.value]) == null ? void 0 : O.tooltipPoint.y) ?? 0;
  }), N = x(() => {
    var O;
    return [
      {
        label: t.metric.label ?? "",
        value: (O = r.value[d.value]) == null ? void 0 : O.formattedValue.value
      }
    ];
  });
  et(d, () => {
    var O, p;
    h({
      // @ts-ignore
      placement: (O = r.value[d == null ? void 0 : d.value]) == null ? void 0 : O.tooltipPosition,
      offset: (p = r.value[d == null ? void 0 : d.value]) == null ? void 0 : p.tooltipOffset
    });
  });
  const I = x(
    () => r.value.map((O) => {
      const p = O.strokeOpacity < 1 ? Math.round(O.strokeOpacity * 100) : "";
      return {
        label: `${O.label} (${O.formattedValue.value})`,
        color: `#006dff${p}`
      };
    })
  );
  return {
    hideTooltip: u,
    arcs: r,
    hoveredIndex: d,
    showTooltipMarker: f,
    hoveredItem: o,
    plotLines: N,
    hoverItem: c,
    cx: E,
    cy: m,
    chartContainer: i,
    tooltipContent: l,
    tooltipCircle: s,
    STROKE_WIDTH: Ag,
    charKeys: I
  };
}
const Nge = /* @__PURE__ */ Ne({
  __name: "ChartKeys",
  props: {
    chartKeys: {}
  },
  setup(t) {
    const e = t, n = x(
      () => e.chartKeys.map((o) => {
        const i = Object.keys(Ks), a = { ...o };
        return i.includes(o.color ?? "") ? a.class = [o.color] : a.style = { color: o.color }, a;
      })
    ), r = so("isPdf", !1);
    return (o, i) => (v(), A("div", {
      class: z(["chart-keys-container", { "pdf-shadow-fix": M(r) }])
    }, [
      (v(!0), A(ge, null, ye(n.value, (a, s) => (v(), A("div", {
        class: z(["chart-key", a.class]),
        style: Fe(a.style),
        key: a.label + "-" + s
      }, [
        i[0] || (i[0] = g("svg", {
          width: "9",
          height: "9",
          viewBox: "0 0 9 9",
          fill: "none"
        }, [
          g("circle", {
            cx: "4.5",
            cy: "4.5",
            r: "4.5",
            fill: "currentColor"
          })
        ], -1)),
        H(He, { width: "0.5rem" }),
        H(Ye, { size: "f-9" }, {
          default: q(() => [
            me(Q(a.label), 1)
          ]),
          _: 2
        }, 1024)
      ], 6))), 128))
    ], 2));
  }
});
const D7 = /* @__PURE__ */ Y(Nge, [["__scopeId", "data-v-3c7d62ca"]]), vge = ["stroke-width", "d", "onMouseenter"], gge = ["d", "onMouseenter"], Ige = ["cx", "cy"], Oge = { class: "chart-keys" }, Age = /* @__PURE__ */ Ne({
  __name: "DonutChart",
  props: {
    items: {},
    metric: {},
    removeInteractivity: { type: Boolean },
    showKeys: { type: Boolean },
    compactKeys: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = t, {
      hideTooltip: n,
      arcs: r,
      hoveredItem: o,
      plotLines: i,
      hoverItem: a,
      cx: s,
      cy: l,
      chartContainer: c,
      tooltipContent: u,
      tooltipCircle: d,
      STROKE_WIDTH: f,
      charKeys: h,
      hoveredIndex: _
    } = mge(e);
    return (E, m) => (v(), A(ge, null, [
      g("div", {
        ref_key: "chartContainer",
        ref: c,
        class: "w-100 flex center-items justify-center"
      }, [
        (v(), A("svg", {
          height: "300",
          width: "300",
          viewBox: "0 0 300 300",
          onMouseleave: m[0] || (m[0] = //@ts-ignore
          (...N) => M(n) && M(n)(...N))
        }, [
          (v(!0), A(ge, null, ye(M(r), (N, I) => (v(), A("g", {
            key: N.label
          }, [
            g("path", {
              style: Fe({
                "stroke-opacity": M(_) === I ? 1 : N.strokeOpacity
              }),
              fill: "none",
              class: z([["stroke-opacity-transition"], "opteo-blue"]),
              stroke: "currentColor",
              "stroke-width": M(f),
              rx: "5",
              d: N.d,
              onMouseenter: (O) => M(a)(I),
              "stroke-linecap": "round"
            }, null, 44, vge),
            g("path", {
              fill: "none",
              stroke: "currentColor",
              "stroke-opacity": "0",
              "stroke-width": "100",
              d: N.d,
              onMouseenter: (O) => M(a)(I)
            }, null, 40, gge)
          ]))), 128)),
          g("circle", {
            ref_key: "tooltipCircle",
            ref: d,
            class: z(["fill-opacity-transition o-0"]),
            cx: M(s),
            cy: M(l),
            r: "4",
            fill: "#000"
          }, null, 8, Ige)
        ], 32))
      ], 512),
      g("div", Oge, [
        t.showKeys ? (v(), te(D7, {
          key: 0,
          "chart-keys": M(h)
        }, null, 8, ["chart-keys"])) : V("", !0)
      ]),
      t.removeInteractivity ? V("", !0) : (v(), A("div", {
        key: 0,
        ref_key: "tooltipContent",
        ref: u
      }, [
        E.$slots.tooltip ? ue(E.$slots, "tooltip", {
          key: 0,
          hoveredItem: M(o)
        }, void 0, !0) : M(o) ? (v(), te(Co, {
          key: 1,
          "plot-lines": M(i),
          footer: M(o).label
        }, null, 8, ["plot-lines", "footer"])) : V("", !0)
      ], 512))
    ], 64));
  }
});
const bPe = /* @__PURE__ */ Y(Age, [["__scopeId", "data-v-7e00b5dc"]]);
function Dge(t) {
  return t !== t;
}
function Cge(t, e, n) {
  for (var r = n - 1, o = t.length; ++r < o; )
    if (t[r] === e)
      return r;
  return -1;
}
function Sge(t, e, n) {
  return e === e ? Cge(t, e, n) : N7(t, Dge, n);
}
function wge(t, e) {
  var n = t == null ? 0 : t.length;
  return !!n && Sge(t, e, 0) > -1;
}
function Tge(t, e, n) {
  for (var r = -1, o = t == null ? 0 : t.length; ++r < o; )
    if (n(e, t[r]))
      return !0;
  return !1;
}
function bge() {
}
var Rge = 1 / 0, Mge = Ts && 1 / Gp(new Ts([, -0]))[1] == Rge ? function(t) {
  return new Ts(t);
} : bge;
const Pge = Mge;
var yge = 200;
function Lge(t, e, n) {
  var r = -1, o = wge, i = t.length, a = !0, s = [], l = s;
  if (n)
    a = !1, o = Tge;
  else if (i >= yge) {
    var c = e ? null : Pge(t);
    if (c)
      return Gp(c);
    a = !1, o = o7, l = new Mc();
  } else
    l = e ? [] : s;
  e:
    for (; ++r < i; ) {
      var u = t[r], d = e ? e(u) : u;
      if (u = n || u !== 0 ? u : 0, a && d === d) {
        for (var f = l.length; f--; )
          if (l[f] === d)
            continue e;
        e && l.push(d), s.push(u);
      } else
        o(l, d, n) || (l !== s && l.push(d), s.push(u));
    }
  return s;
}
function Qp(t) {
  return t && t.length ? Lge(t) : [];
}
var C7 = {};
Object.defineProperty(C7, "__esModule", { value: !0 });
var xge = (
  /** @class */
  function() {
    function t(e, n) {
      this.xs = e, this.ys = n, this.ks = this.getNaturalKs(new Float64Array(this.xs.length));
    }
    return t.prototype.getNaturalKs = function(e) {
      for (var n = this.xs.length - 1, r = $ge(n + 1, n + 2), o = 1; o < n; o++)
        r[o][o - 1] = 1 / (this.xs[o] - this.xs[o - 1]), r[o][o] = 2 * (1 / (this.xs[o] - this.xs[o - 1]) + 1 / (this.xs[o + 1] - this.xs[o])), r[o][o + 1] = 1 / (this.xs[o + 1] - this.xs[o]), r[o][n + 1] = 3 * ((this.ys[o] - this.ys[o - 1]) / ((this.xs[o] - this.xs[o - 1]) * (this.xs[o] - this.xs[o - 1])) + (this.ys[o + 1] - this.ys[o]) / ((this.xs[o + 1] - this.xs[o]) * (this.xs[o + 1] - this.xs[o])));
      return r[0][0] = 2 / (this.xs[1] - this.xs[0]), r[0][1] = 1 / (this.xs[1] - this.xs[0]), r[0][n + 1] = 3 * (this.ys[1] - this.ys[0]) / ((this.xs[1] - this.xs[0]) * (this.xs[1] - this.xs[0])), r[n][n - 1] = 1 / (this.xs[n] - this.xs[n - 1]), r[n][n] = 2 / (this.xs[n] - this.xs[n - 1]), r[n][n + 1] = 3 * (this.ys[n] - this.ys[n - 1]) / ((this.xs[n] - this.xs[n - 1]) * (this.xs[n] - this.xs[n - 1])), Uge(r, e);
    }, t.prototype.getIndexBefore = function(e) {
      for (var n = 0, r = this.xs.length, o = 0; n < r; )
        o = Math.floor((n + r) / 2), this.xs[o] < e && o !== n ? n = o : this.xs[o] >= e && o !== r ? r = o : r = n;
      return n + 1;
    }, t.prototype.at = function(e) {
      var n = this.getIndexBefore(e), r = (e - this.xs[n - 1]) / (this.xs[n] - this.xs[n - 1]), o = this.ks[n - 1] * (this.xs[n] - this.xs[n - 1]) - (this.ys[n] - this.ys[n - 1]), i = -this.ks[n] * (this.xs[n] - this.xs[n - 1]) + (this.ys[n] - this.ys[n - 1]), a = (1 - r) * this.ys[n - 1] + r * this.ys[n] + r * (1 - r) * (o * (1 - r) + i * r);
      return a;
    }, t;
  }()
);
function Uge(t, e) {
  for (var n = t.length, r = 0, o = 0; r < n && o <= n; ) {
    for (var i = 0, a = -1 / 0, s = r; s < n; s++) {
      var l = Math.abs(t[s][o]);
      l > a && (i = s, a = l);
    }
    if (t[i][o] === 0)
      o++;
    else {
      kge(t, r, i);
      for (var s = r + 1; s < n; s++) {
        var c = t[s][o] / t[r][o];
        t[s][o] = 0;
        for (var u = o + 1; u <= n; u++)
          t[s][u] -= t[r][u] * c;
      }
      r++, o++;
    }
  }
  for (var s = n - 1; s >= 0; s--) {
    var d = 0;
    t[s][s] && (d = t[s][n] / t[s][s]), e[s] = d;
    for (var u = s - 1; u >= 0; u--)
      t[u][n] -= t[u][s] * d, t[u][s] = 0;
  }
  return e;
}
function $ge(t, e) {
  for (var n = [], r = 0; r < t; r++)
    n.push(new Float64Array(e));
  return n;
}
function kge(t, e, n) {
  var r = t[e];
  t[e] = t[n], t[n] = r;
}
var Bge = C7.default = xge;
function r1({
  items: t,
  showZero: e,
  maxItem: n,
  numberOfPoints: r = 300
}) {
  if (t.length <= 1)
    throw new Error("Cannot generate a line with one point");
  const o = x(() => {
    const l = Qp(
      t.map((c, u) => {
        var d;
        return !c.x || typeof ((d = c.x) == null ? void 0 : d.valueOf()) == "string" ? u : c.x.valueOf();
      })
    );
    if (l.length !== t.length)
      throw new Error("Multiple items have the same x value");
    return l;
  }), i = x(() => t.map((c) => c.y)), a = x(() => new Bge(o.value, i.value));
  return { splinedItems: x(() => {
    const l = [];
    for (let c = o.value[0]; c <= o.value[o.value.length - 1]; c += (o.value[o.value.length - 1] - o.value[0]) / r) {
      const u = c;
      if (e || n) {
        const f = [], h = [], _ = o.value.map((C) => {
          const D = C - u;
          return C >= u && h.push(D), C < u && f.push(D), D;
        }), E = _.indexOf(Math.max(...f)), m = _.indexOf(Math.min(...h)), N = i.value[E] <= 0 && i.value[m] <= 0, I = n && i.value[E] >= n && i.value[m] >= n, O = n ?? 1 / 0, p = N || a.value.at(u) < 0 ? 0 : I || a.value.at(u) > O ? O : a.value.at(u);
        l.push({ x: u, y: p });
        continue;
      }
      const d = a.value.at(u);
      l.push({ x: u, y: d });
    }
    return l;
  }) };
}
function o1({
  splinedItems: t,
  minItemY: e,
  rangeOfPoints: n,
  svgWidth: r,
  svgHeight: o,
  lastDottedItemX: i,
  firstDottedItemX: a,
  maxItemX: s,
  minItemX: l
}) {
  const c = x(
    () => ((s == null ? void 0 : s.value) ?? Math.max(...t.map((D) => {
      var T;
      return ((T = D.x) == null ? void 0 : T.valueOf()) ?? 0;
    }))) - ((l == null ? void 0 : l.value) ?? 0)
  ), u = x(
    () => t.filter(
      (D) => {
        var T, k;
        return (((T = D.x) == null ? void 0 : T.valueOf()) ?? 0) >= ((i == null ? void 0 : i.valueOf()) ?? 0) && (a ? (((k = D.x) == null ? void 0 : k.valueOf()) ?? 0) <= ((a == null ? void 0 : a.valueOf()) ?? 0) : !0);
      }
    )
  ), d = x(
    () => t.filter(
      (D) => {
        var T;
        return i ? (((T = D.x) == null ? void 0 : T.valueOf()) ?? 0) <= i.valueOf() : !1;
      }
    )
  ), f = x(
    () => a != null && a.valueOf ? t.filter((D) => {
      var T;
      return (((T = D.x) == null ? void 0 : T.valueOf()) ?? 0) >= ((a == null ? void 0 : a.valueOf()) ?? 0);
    }) : []
  );
  function h(D) {
    return D.map((T) => {
      var P;
      const k = Math.min(
        Math.max(
          0,
          ((((P = T.x) == null ? void 0 : P.valueOf()) ?? 0) - ((l == null ? void 0 : l.value) ?? 0)) * r.value / c.value
        ),
        r.value
      ), G = Math.min(
        Math.max(
          0,
          n > 0 ? o.value + e.value * o.value / n - T.y * o.value / n : o.value
        ),
        o.value
      );
      return `${k},${G}`;
    });
  }
  const _ = x(() => h(u.value)), E = x(() => h(d.value)), m = x(() => h(f.value)), N = x(
    () => h([...d.value, ...u.value, ...f.value])
  ), I = x(() => _.value.length > 0 ? `M${_.value.join("L")}` : void 0), O = x(
    () => E.value.length > 0 ? `M${E.value.join("L")}` : void 0
  ), p = x(
    () => m.value.length > 0 ? `M${m.value.join("L")}` : void 0
  ), C = x(
    () => `M0,${o.value + 2}L${N.value.join("L")}L${r.value},${o.value + 2}`
  );
  return { svgPoints: I, svgGradientPoints: C, startDottedSvgPoints: O, endDottedSvgPoints: p };
}
function Gge(t, e) {
  rt(2, arguments);
  var n = wt(t), r = zt(e);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var o = n.getDate(), i = new Date(n.getTime());
  i.setMonth(n.getMonth() + r + 1, 0);
  var a = i.getDate();
  return o >= a ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), o), n);
}
function Fge(t, e) {
  if (rt(2, arguments), !e || ba(e) !== "object")
    return /* @__PURE__ */ new Date(NaN);
  var n = e.years ? zt(e.years) : 0, r = e.months ? zt(e.months) : 0, o = e.weeks ? zt(e.weeks) : 0, i = e.days ? zt(e.days) : 0, a = e.hours ? zt(e.hours) : 0, s = e.minutes ? zt(e.minutes) : 0, l = e.seconds ? zt(e.seconds) : 0, c = wt(t), u = r || n ? Gge(c, r + n * 12) : c, d = i || o ? O6(u, i + o * 7) : u, f = s + a * 60, h = l + f * 60, _ = h * 1e3, E = new Date(d.getTime() + _);
  return E;
}
var Vge = 864e5;
function Hge(t, e) {
  rt(2, arguments);
  var n = Ei(t), r = Ei(e), o = n.getTime() - T0(n), i = r.getTime() - T0(r);
  return Math.round((o - i) / Vge);
}
function Dg(t, e) {
  var n = t.getFullYear() - e.getFullYear() || t.getMonth() - e.getMonth() || t.getDate() - e.getDate() || t.getHours() - e.getHours() || t.getMinutes() - e.getMinutes() || t.getSeconds() - e.getSeconds() || t.getMilliseconds() - e.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function Wge(t, e) {
  rt(2, arguments);
  var n = wt(t), r = wt(e), o = Dg(n, r), i = Math.abs(Hge(n, r));
  n.setDate(n.getDate() - o * i);
  var a = +(Dg(n, r) === -o), s = o * (i - a);
  return s === 0 ? 0 : s;
}
function S7({
  minItem: t,
  maxItem: e,
  numberOfPoints: n = x(() => 8)
}) {
  const r = x(() => Wge(new Date(e.value), new Date(t.value)));
  if (r.value === 0)
    throw new Error("Not using dates");
  const o = x(() => {
    let l = 0, c = Math.min(n.value, r.value);
    for (; (r.value - l) % c !== 0; )
      c -= 1, c <= 2 && (l += 1, c = Math.min(n.value, r.value));
    return { offset: l, calcNumberOfPoints: c };
  }), i = x(() => o.value.offset), a = x(() => o.value.calcNumberOfPoints);
  return {
    formattedAxisLabels: x(() => {
      const l = [];
      for (let c = 0; c <= a.value; c++) {
        const u = c * (r.value - i.value) / a.value, d = Fge(new Date(t.value), { days: u }).valueOf(), { displayValue: f } = yn({
          value: d,
          metric: { dataType: "date", dateFormat: "do MMM", label: "Date" }
        });
        l.push(f.value);
      }
      return l;
    }),
    min: t,
    max: e,
    offset: i
  };
}
function Yge(t) {
  rt(1, arguments);
  var e;
  if (t && typeof t.forEach == "function")
    e = t;
  else if (ba(t) === "object" && t !== null)
    e = Array.prototype.slice.call(t);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return e.forEach(function(r) {
    var o = wt(r);
    (n === void 0 || n > o || isNaN(o.getDate())) && (n = o);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function Kge(t) {
  rt(1, arguments);
  var e;
  if (t && typeof t.forEach == "function")
    e = t;
  else if (ba(t) === "object" && t !== null)
    e = Array.prototype.slice.call(t);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return e.forEach(function(r) {
    var o = wt(r);
    (n === void 0 || n < o || isNaN(Number(o))) && (n = o);
  }), n || /* @__PURE__ */ new Date(NaN);
}
var zge = 36e5;
function Zge(t, e) {
  rt(2, arguments);
  var n = zt(e);
  return Ap(t, n * zge);
}
var qge = 6e4;
function Xge(t, e) {
  rt(2, arguments);
  var n = zt(e);
  return Ap(t, n * qge);
}
function jge(t, e) {
  rt(2, arguments);
  var n = zt(e);
  return Xge(t, -n);
}
function Cg(t) {
  const e = typeof t == "number" ? new Date(t).getTimezoneOffset() : t.getTimezoneOffset();
  return new Date(jge(t, e).setUTCHours(0, 0, 0, 0));
}
function Jge({
  start: t,
  end: e = new Date(Date.now()),
  excludeEnd: n
}) {
  const r = {
    start: Cg(t),
    end: Cg(e)
  };
  let o = r.start;
  const i = [];
  for (; n ? r.end > o : r.end >= o; )
    i.push(o), o = Zge(o, 24);
  return i;
}
function RPe(t, e = {
  defaultPointValue: "zero"
}) {
  if (!t.every((a) => a.x && typeof a.x == "number" && N6(new Date(a.x))))
    throw new Error("All chart items must use { x: number, y: number } where x is a timestamp in milliseconds");
  const r = e.minDate ?? new Date(Yge(t.map((a) => a.x ?? 0))), o = e.maxDate ?? new Date(Kge(t.map((a) => a.x ?? 0)));
  let i = 0;
  return Jge({ start: r, end: o }).map((a) => {
    const s = t.find((l) => +l.x == +a);
    return s ? (i = s.y, s) : {
      x: +a,
      y: e.defaultPointValue === "zero" ? 0 : i
    };
  });
}
const zd = (t) => {
  const e = Ks[t % 6];
  if (!((r) => Object.keys(Ks).filter((i) => isNaN(+i)).some((i) => i === r))(e))
    throw new Error("Invalid chart colour");
  return e;
};
function Qge(t) {
  const e = x(() => {
    var le;
    return ((le = Xp()) == null ? void 0 : le.name) === "safari";
  }), { animationMultiplier: n, finishedChartAnimation: r } = Hi(
    (t.removeInteractivity ?? !1) || e.value
  ), o = x(
    () => t.series.map((le) => {
      const { splinedItems: De } = r1({
        items: le.items,
        showZero: !!t.showZero,
        maxItem: t.maxItem,
        numberOfPoints: Math.round(l.value)
      });
      return {
        ...le,
        splinedItems: De
      };
    })
  ), i = W(), a = W(), { width: s } = go(i), l = x(() => {
    var le;
    return Math.max(0, s.value - (((le = a.value) == null ? void 0 : le.clientWidth) ?? 0));
  }), c = x(() => t.chartHeight ?? 300), u = x(
    () => Qp(o.value.flatMap((le) => le.items.map((De, pe) => {
      var Le;
      return ((Le = De.x) == null ? void 0 : Le.valueOf()) ?? De.label;
    })))
  ), d = x(() => typeof u.value[0] == "string"), f = x(() => o.value.flatMap((le) => le.splinedItems.value.map((De) => De.y))), h = x(() => !!f.value.find((le) => le < 0)), _ = x(() => h.value ? !1 : t.showZero), E = x(() => {
    var le;
    return t.maxItem ? t.maxItem : Math.max(...f.value, 0, ...((le = t.horizontalMarkers) == null ? void 0 : le.map((De) => De.value * 1.1)) ?? []);
  }), m = x(() => _.value ? 0 : Math.min(...f.value, E.value)), N = x(() => d.value ? 0 : Math.min(...u.value)), I = x(() => d.value ? u.value.length - 1 : Math.max(...u.value)), O = x(() => Math.abs(C.value - p.value)), {
    min: p,
    max: C,
    formattedAxis: D
  } = Mi({
    minItem: m,
    maxItem: E,
    axis: yt.Vertical,
    metric: t.metric
  }), T = x(() => Math.min(u.value.length, l.value > 400 ? 8 : 4)), k = x(() => d.value ? Jp({
    items: o.value[0].items,
    numberOfPoints: T
  }) : S7({
    minItem: N,
    maxItem: I,
    numberOfPoints: T
  })), G = x(() => {
    var le;
    return (le = k.value.offset) == null ? void 0 : le.value;
  }), b = x(() => {
    var le;
    return (le = k.value.formattedAxisLabels) == null ? void 0 : le.value;
  }), P = x(() => (G.value ?? 0) * s.value / (u.value.length - 1)), $ = x(
    () => o.value.map((le, De) => {
      var Pr, yr, ht, Gn;
      const pe = le.splinedItems.value, Le = !!le.items[0].dotted, ze = le.items.findIndex((F) => !F.dotted), Xe = Le ? ((yr = (Pr = le.items[ze]) == null ? void 0 : Pr.x) == null ? void 0 : yr.valueOf()) ?? ze : void 0, je = !!le.items[le.items.length - 1].dotted, it = le.items.findIndex((F, oe) => F.dotted && oe > ze), ot = je ? ((Gn = (ht = le.items[it - 1]) == null ? void 0 : ht.x) == null ? void 0 : Gn.valueOf()) ?? it - 1 : void 0, Rt = le.items.filter((F) => !F.dotted).length === 0, Ht = le.dotted || Rt, { svgPoints: Mt, startDottedSvgPoints: pn, endDottedSvgPoints: on } = o1({
        splinedItems: pe,
        svgWidth: l,
        svgHeight: c,
        minItemY: p,
        rangeOfPoints: O.value,
        lastDottedItemX: Xe,
        firstDottedItemX: ot,
        maxItemX: I,
        minItemX: N
      }), Zr = le.color ?? zd(De);
      return {
        ...le,
        dotted: Ht,
        svgPoints: Mt.value,
        startDottedSvgPoints: pn.value,
        endDottedSvgPoints: on.value,
        color: Zr
      };
    })
  ), { tooltipCircle: y, tooltipContent: L, hoveredIndex: w, showTooltip: R, hideTooltip: B, showTooltipMarker: U } = Do({ appendTo: i, enableMoveTransition: !0 });
  function K(le) {
    if (!t.removeInteractivity) {
      if (w.value === -1) {
        w.value = le, R();
        return;
      }
      w.value = le;
    }
  }
  const Z = x(() => $.value.map((le, De) => {
    var Xe;
    const pe = u.value[w.value] ?? 0, Le = (Xe = le.items) == null ? void 0 : Xe.find((je, it) => je.x ? jl(je.x.valueOf(), pe) : it === w.value);
    if (!Le)
      return;
    const { displayValue: ze } = yn({
      value: Le.y ?? 0,
      metric: t.metric
    });
    return {
      ...Le,
      displayYValue: ze,
      seriesName: le.name,
      dotted: le.dotted || (Le == null ? void 0 : Le.dotted),
      color: zd(De)
    };
  })), X = x(
    () => u.value.map((le, De) => {
      const pe = ((d.value ? De : le) - N.value) * l.value / (I.value - N.value);
      let Le = 0;
      t.series.forEach((Xe) => {
        const je = Xe.items.find((it) => {
          var ot;
          return le === ((ot = it.x) == null ? void 0 : ot.valueOf()) || le === it.label;
        });
        Le = Math.max((je == null ? void 0 : je.y) ?? 0, Le);
      });
      const ze = c.value - (Le - p.value) * c.value / (C.value - p.value);
      return { x: pe, y: ze };
    })
  ), J = x(() => {
    var le;
    return w.value < 0 ? -5 : ((le = X.value[w.value]) == null ? void 0 : le.x) ?? -5;
  }), ae = x(() => {
    var le;
    return w.value < 0 ? -5 : ((le = X.value[w.value]) == null ? void 0 : le.y) ?? -5;
  }), re = t.areas ? A7({
    areas: t.areas,
    chartDimensions: { svgHeight: c, svgWidth: l },
    itemExtrema: {
      minItemY: p,
      maxItemY: C,
      minItemX: N,
      maxItemX: I
    }
  }) : void 0, { formattedMarkers: j, markerTextAnchor: ne, markerTextAnchorContent: Ee, hoveredMarker: fe, hoveredMarkerIndex: Oe } = n1({
    markers: Ga(t, "horizontalMarkers"),
    svgHeight: c,
    minItemY: p,
    maxItemY: C,
    appendTo: i
  }), ce = x(() => {
    const le = u.value[w.value];
    if (!le)
      return;
    if (d.value)
      return le;
    const { displayValue: De } = yn({
      value: le,
      metric: {
        dataType: "date",
        dateFormat: "do MMMM yyyy",
        label: "Date"
      }
    });
    return De.value;
  }), Se = x(() => {
    var De;
    const le = [];
    return (De = Z.value) == null || De.forEach((pe) => {
      pe && le.push({ label: pe.seriesName, value: pe.displayYValue.value, dotted: pe.dotted, color: pe.color });
    }), le;
  }), se = x(() => `animation-clip-path-${Br(6)}`), Ie = x(() => `url(#${se.value})`), we = x(
    () => $.value.map((le) => ({
      label: le.name,
      color: le.color
    }))
  );
  return {
    hoverGraph: K,
    hoveredItem: Z,
    tooltipCx: J,
    tooltipCy: ae,
    formattedSeries: $,
    formattedAxisLabels: b,
    tooltipCircle: y,
    tooltipContent: L,
    yAxisLabels: D,
    hideTooltip: B,
    showTooltipMarker: U,
    svgHeight: c,
    svgWidth: l,
    animationMultiplier: n,
    yAxisContainer: a,
    tooltipPlotlines: Se,
    toolTipFooter: ce,
    formattedMarkers: j,
    chartContainer: i,
    allX: u,
    generatedAreas: re,
    hoverAreas: X,
    finishedChartAnimation: r,
    offsetWidth: P,
    clipPathId: se,
    clipPathUrl: Ie,
    charKeys: we,
    markerTextAnchor: ne,
    markerTextAnchorContent: Ee,
    hoveredMarker: fe,
    hoveredMarkerIndex: Oe
  };
}
const eIe = { class: "chart-flex-wrapper" }, tIe = ["width", "height"], nIe = ["id"], rIe = ["x"], oIe = ["clip-path", "stroke-opacity", "d"], iIe = ["clip-path", "stroke-opacity", "d"], aIe = ["clip-path", "stroke-opacity", "d"], sIe = { key: 0 }, lIe = ["x", "y", "width", "height"], cIe = ["cx", "cy"], uIe = ["y2", "x1", "x2"], dIe = ["stroke-width", "onMouseenter", "y2", "x1", "x2"], fIe = { key: 1 }, hIe = ["x2", "y1", "y2"], _Ie = ["x2", "y1", "y2", "onMouseenter"], EIe = { key: 1 }, pIe = ["x", "y"], mIe = ["y"], NIe = ["cx", "cy"], vIe = { key: 1 }, gIe = { class: "chart-keys" }, IIe = /* @__PURE__ */ Ne({
  __name: "LineChart",
  props: {
    series: {},
    metric: {},
    showZero: { type: Boolean },
    horizontalMarkers: {},
    areas: {},
    axisTitles: {},
    chartHeight: {},
    removeInteractivity: { type: Boolean },
    showKeys: { type: Boolean },
    maxItem: {},
    disableFallback: { type: Boolean },
    removePlaceholderContainer: { type: Boolean }
  },
  setup(t) {
    const e = t, {
      hoverGraph: n,
      hoveredItem: r,
      tooltipCx: o,
      tooltipCy: i,
      formattedSeries: a,
      formattedAxisLabels: s,
      tooltipCircle: l,
      tooltipContent: c,
      yAxisLabels: u,
      hideTooltip: d,
      showTooltipMarker: f,
      svgHeight: h,
      svgWidth: _,
      animationMultiplier: E,
      yAxisContainer: m,
      tooltipPlotlines: N,
      toolTipFooter: I,
      formattedMarkers: O,
      chartContainer: p,
      allX: C,
      generatedAreas: D,
      hoverAreas: T,
      finishedChartAnimation: k,
      offsetWidth: G,
      clipPathId: b,
      clipPathUrl: P,
      charKeys: $,
      markerTextAnchor: y,
      markerTextAnchorContent: L,
      hoveredMarker: w,
      hoveredMarkerIndex: R
    } = Qge(e);
    return (B, U) => {
      var K, Z, X, J, ae;
      return v(), A(ge, null, [
        g("div", {
          ref_key: "chartContainer",
          ref: p,
          class: z(["w-100", { "desktop-chart": !t.disableFallback }])
        }, [
          ue(B.$slots, "header", {
            class: "w-100",
            hoveredItem: M(r)
          }, void 0, !0),
          B.$slots.header ? (v(), te(He, { key: 0 })) : V("", !0),
          g("div", eIe, [
            g("div", {
              ref_key: "yAxisContainer",
              ref: m
            }, [
              H(Za, {
                "chart-height": M(h),
                "axis-title": (K = t.axisTitles) == null ? void 0 : K.y,
                "axis-labels": M(u)
              }, null, 8, ["chart-height", "axis-title", "axis-labels"])
            ], 512),
            g("div", null, [
              (v(), A("svg", {
                width: M(_),
                height: M(h),
                overflow: "visible",
                onMouseleave: U[0] || (U[0] = //@ts-ignore
                (...re) => M(d) && M(d)(...re))
              }, [
                g("defs", null, [
                  g("clipPath", { id: M(b) }, [
                    g("rect", {
                      class: "stroke-animation-mask",
                      x: `-${(1 - M(E)) * 100}%`,
                      y: "-2px",
                      width: "100%",
                      height: "200%"
                    }, null, 8, rIe)
                  ], 8, nIe)
                ]),
                (v(!0), A(ge, null, ye(M(a), (re) => (v(), A("g", {
                  key: re.name
                }, [
                  g("path", {
                    "clip-path": M(P),
                    stroke: "currentColor",
                    "stroke-opacity": M(E),
                    class: z([{ "d-transition": M(k) }, re.color, "dotted "]),
                    fill: "none",
                    "stroke-width": "2",
                    d: re.startDottedSvgPoints
                  }, null, 10, oIe),
                  g("path", {
                    "clip-path": M(P),
                    stroke: "currentColor",
                    "stroke-opacity": M(E),
                    class: z([{ "d-transition": M(k), dotted: re.dotted }, re.color]),
                    fill: "none",
                    "stroke-width": "2",
                    d: re.svgPoints
                  }, null, 10, iIe),
                  g("path", {
                    "clip-path": M(P),
                    stroke: "currentColor",
                    "stroke-opacity": M(E),
                    class: z([{ "d-transition": M(k) }, re.color, "dotted"]),
                    fill: "none",
                    "stroke-width": "2",
                    d: re.endDottedSvgPoints
                  }, null, 10, aIe)
                ]))), 128)),
                M(D) ? (v(), A("g", sIe, [
                  (v(!0), A(ge, null, ye(M(D), (re, j) => (v(), A("rect", {
                    key: j,
                    x: re.x,
                    y: re.y,
                    width: re.width,
                    height: re.height,
                    class: z(re.color)
                  }, null, 10, lIe))), 128))
                ])) : V("", !0),
                g("circle", {
                  ref_key: "tooltipCircle",
                  ref: l,
                  stroke: "none",
                  fill: "none",
                  r: "5",
                  "stroke-width": "2",
                  cx: M(o),
                  cy: M(i)
                }, null, 8, cIe),
                g("line", {
                  class: z([{ active: M(f) }, "stroke-tooltip"]),
                  "stroke-width": "2",
                  y1: 0,
                  y2: M(h),
                  x1: M(o),
                  x2: M(o)
                }, null, 10, uIe),
                (v(!0), A(ge, null, ye(M(T), (re, j) => (v(), A("line", {
                  class: "stroke-tooltip",
                  "stroke-width": M(_) / (M(C).length - 1),
                  "stroke-opacity": "1",
                  onMouseenter: (ne) => M(n)(j),
                  key: j,
                  y1: 0,
                  y2: M(h),
                  x1: re.x,
                  x2: re.x
                }, null, 40, dIe))), 128)),
                M(O) ? (v(), A("g", fIe, [
                  (v(!0), A(ge, null, ye(M(O), (re, j) => (v(), A("g", {
                    key: re.label
                  }, [
                    g("line", {
                      class: z(["all-transition", [`opteo-${re.color}`]]),
                      x1: 0,
                      x2: M(_),
                      y1: re.y,
                      y2: re.y,
                      stroke: "currentColor",
                      "stroke-width": "2px",
                      "stroke-dasharray": "5,3"
                    }, null, 10, hIe),
                    M(O).length > 1 ? (v(), A("line", {
                      key: 0,
                      x1: 0,
                      x2: M(_),
                      y1: re.y,
                      y2: re.y,
                      stroke: "currentColor",
                      "stroke-opacity": "0",
                      "stroke-width": "16px",
                      class: z([`opteo-${re.color}`]),
                      onMouseenter: (ne) => R.value = j
                    }, null, 42, _Ie)) : V("", !0),
                    B.$slots.markerText ? V("", !0) : (v(), A("g", EIe, [
                      re.labelPosition === "end" ? (v(), A("text", {
                        key: 0,
                        class: "marker-text height-transition",
                        x: M(_),
                        y: re.y,
                        dx: "-3px",
                        dy: "-5px",
                        "text-anchor": "end"
                      }, Q(re.label), 9, pIe)) : (v(), A("text", {
                        key: 1,
                        class: "marker-text",
                        x: 0,
                        y: re.y,
                        dy: "-5px",
                        "text-anchor": "start"
                      }, Q(re.label), 9, mIe))
                    ]))
                  ]))), 128)),
                  B.$slots.markerText ? (v(), A("circle", {
                    key: 0,
                    ref_key: "markerTextAnchor",
                    ref: y,
                    stroke: "none",
                    fill: "none",
                    r: "5",
                    "stroke-width": "2",
                    cx: ((Z = M(w)) == null ? void 0 : Z.labelPosition) === "end" ? M(_) : 0,
                    cy: (X = M(w)) == null ? void 0 : X.y
                  }, null, 8, NIe)) : V("", !0)
                ])) : V("", !0)
              ], 40, tIe)),
              H(qa, {
                "chart-width": M(_),
                "axis-labels": M(s),
                "axis-title": (J = t.axisTitles) == null ? void 0 : J.x,
                offset: M(G)
              }, null, 8, ["chart-width", "axis-labels", "axis-title", "offset"])
            ])
          ]),
          t.showKeys ? (v(), A("div", vIe, [
            H(He, { height: "1.5rem" }),
            g("div", gIe, [
              H(D7, { "chart-keys": M($) }, null, 8, ["chart-keys"])
            ])
          ])) : V("", !0)
        ], 2),
        t.disableFallback ? V("", !0) : (v(), te(Xa, {
          key: 0,
          type: "area",
          "remove-container": t.removePlaceholderContainer,
          class: "mobile-chart"
        }, null, 8, ["remove-container"])),
        t.removeInteractivity ? V("", !0) : (v(), A("div", {
          key: 1,
          ref_key: "tooltipContent",
          ref: c
        }, [
          B.$slots.tooltip ? ue(B.$slots, "tooltip", {
            key: 0,
            hoveredItem: M(r)
          }, void 0, !0) : (v(), te(Co, {
            key: 1,
            "plot-lines": M(N),
            footer: M(I)
          }, null, 8, ["plot-lines", "footer"]))
        ], 512)),
        B.$slots.markerText ? (v(), A("div", {
          key: 2,
          ref_key: "markerTextAnchorContent",
          ref: L
        }, [
          (ae = M(O)) != null && ae.length ? ue(B.$slots, "markerText", {
            key: 0,
            markerInfo: M(w)
          }, void 0, !0) : V("", !0)
        ], 512)) : V("", !0)
      ], 64);
    };
  }
});
const MPe = /* @__PURE__ */ Y(IIe, [["__scopeId", "data-v-f73edd51"]]);
function OIe(t, e) {
  return t < e;
}
function e2(t, e) {
  return t && t.length ? t7(t, Vi(e), OIe) : void 0;
}
const AIe = Math.pow(10, 9);
var w7 = /* @__PURE__ */ ((t) => (t.DarkGreen = "#97DBBF", t.LightGreen = "#B2E4CF", t.LightRed = "#FDC2C2", t.DarkRed = "#FDADAD", t))(w7 || {});
function DIe(t) {
  const e = W(), n = W(), { width: r } = go(e), o = W(300), i = x(() => {
    var U;
    return Math.max(240, r.value - (((U = n.value) == null ? void 0 : U.clientWidth) ?? 0));
  }), a = x(() => [...t.items.map((U) => U.x)]), s = x(() => Math.max(...a.value) * 1.1), { max: l, formattedAxis: c } = Mi({
    maxItem: s,
    axis: yt.Horizontal,
    metric: t.axis.x
  }), u = x(() => [...t.items.map((U) => U.y)]), d = x(() => Math.max(...u.value) * 1.1), { max: f, formattedAxis: h } = Mi({
    maxItem: d,
    axis: yt.Vertical,
    metric: t.axis.y
  }), _ = {
    [yt.Horizontal]: t.axis.y.label,
    [yt.Vertical]: t.axis.x.label
  };
  function E(U) {
    var Z, X;
    const K = U > t.cutOff;
    return K && ((Z = t.metric) != null && Z.inverted) || !K && !((X = t.metric) != null && X.inverted) ? "red" : "green";
  }
  const { animationMultiplier: m } = Hi(), { tooltipCircle: N, tooltipContent: I, hoverItem: O, hideTooltip: p, showTooltip: C, hoveredIndex: D, showTooltipMarker: T } = Do({
    appendTo: e,
    items: t.items,
    animationMultiplier: m
  }), k = x(() => t.items.map((U) => {
    const K = (U.x ?? 0) * i.value / l.value, Z = o.value - U.y * o.value / f.value, X = U.y / U.x, J = yn({ value: X, metric: t.metric }).displayValue.value, ae = Yo({
      value: (X - t.cutOff) / t.cutOff,
      includeSign: !0
    }).displayValue.value, re = E(X), j = t.items.map((fe) => {
      if ((U == null ? void 0 : U.x) === (fe == null ? void 0 : fe.x) || U.y === fe.y)
        return { x: fe.x, y: fe.y, distance: AIe };
      const Oe = Math.abs((U.x ?? 0) - (fe.x ?? 0)), ce = Math.abs(U.y - fe.y), Se = Oe * i.value / l.value, se = ce * o.value / f.value, Ie = Math.sqrt(Math.pow(Se, 2) + Math.pow(se, 2));
      return { ...fe, distance: Ie };
    }), ne = e2(j, "distance"), Ee = Math.max(Math.min(60, ((ne == null ? void 0 : ne.distance) ?? 0) / 2), 4);
    return {
      ...U,
      formattedRatio: J,
      differenceColor: re,
      formattedDifference: ae,
      hoverRadius: Ee,
      cx: K,
      cy: Z
    };
  })), G = x(() => [
    {
      color: t.metric.inverted ? "#B2E4CF" : "#FDC2C2",
      cutOffMultiplier: 1 / 2
    },
    {
      color: t.metric.inverted ? "#FDC2C2" : "#B2E4CF",
      cutOffMultiplier: 1
    },
    {
      color: t.metric.inverted ? "#FDADAD" : "#97DBBF",
      cutOffMultiplier: 2
    }
  ]), b = x(() => G.value.map((U) => {
    const K = f.value * i.value * m.value / (t.cutOff * l.value * U.cutOffMultiplier), Z = `M0 0V${o.value}H0L${K} 0Z`;
    return {
      ...U,
      d: Z
    };
  }));
  function P() {
    p();
  }
  const $ = x(() => k.value[D.value]), y = x(() => {
    var U;
    return ((U = $.value) == null ? void 0 : U.cx) ?? -1;
  }), L = x(() => {
    var U;
    return ((U = $.value) == null ? void 0 : U.cy) ?? -1;
  }), w = x(() => {
    var ae, re;
    const { displayValue: U } = yn({
      value: $.value.x ?? 0,
      metric: t.axis.x
    }), { displayValue: K } = yn({
      value: $.value.y ?? 0,
      metric: t.axis.y
    }), { displayValue: Z } = yn({
      value: t.cutOff,
      metric: t.metric
    });
    if (!t.axis.y.label || !t.axis.x.label)
      return [];
    const X = t.metric.inverted ? [
      {
        label: t.axis.y.label,
        value: K.value
      },
      {
        label: t.axis.x.label,
        value: U.value
      }
    ] : [
      {
        label: t.axis.x.label,
        value: U.value
      },
      {
        label: t.axis.y.label,
        value: K.value
      }
    ];
    if (!t.metric.label)
      return X;
    const J = [
      {
        label: t.metric.label,
        value: $.value.formattedRatio
      },
      {
        label: `Avg. ${(ae = t.metric) == null ? void 0 : ae.label}`,
        value: Z.value
      },
      {
        label: "Diff.",
        value: $.value.formattedDifference,
        textColor: ((re = $.value) == null ? void 0 : re.differenceColor) ?? "white"
      }
    ];
    return [...X, ...J];
  }), R = x(() => `rounded-corner-mask-${Br(6)}`), B = x(() => `url(#${R.value})`);
  return {
    points: k,
    hoveredIndex: D,
    xAxis: c,
    yAxis: h,
    tooltipContent: I,
    tooltipCircle: N,
    areas: b,
    hideTooltip: p,
    showTooltip: C,
    hoverItem: O,
    svgWidth: i,
    svgHeight: o,
    cx: y,
    cy: L,
    animationMultiplier: m,
    showTooltipMarker: T,
    tooltipMetrics: w,
    handleMouseLeave: P,
    chartContainer: e,
    yAxisLabels: n,
    axisLabels: _,
    hoveredItem: $,
    roundedMaskId: R,
    roundedMaskurl: B
  };
}
const CIe = Ne({
  components: { ChartTooltip: Co, Spacer: He, Text: Ye, GraphKeys: jp, VerticalAxisLabels: Za, HorizontalAxisLabels: qa, ChartPlaceholder: Xa },
  props: {
    items: {
      type: Array,
      required: !0
    },
    metric: {
      type: Object,
      required: !0
    },
    cutOff: {
      type: Number,
      required: !0
    },
    axis: {
      type: Object,
      required: !0
    },
    graphKeys: {
      type: Array,
      required: !1
    },
    disableFallback: {
      type: Boolean,
      required: !1
    },
    chartTooltipMaxWidth: {
      type: String,
      required: !1,
      default: "20rem"
    },
    removePlaceholderContainer: {
      type: Boolean,
      required: !1
    },
    hideAxisLabels: {
      type: Boolean,
      required: !1
    }
  },
  setup(t) {
    return { ScatterPointChartColors: w7, ...DIe(t) };
  }
});
const SIe = { class: "chart-flex-wrapper" }, wIe = { ref: "yAxisLabels" }, TIe = ["width", "height"], bIe = ["id", "width", "height"], RIe = ["width", "height"], MIe = ["mask"], PIe = ["width", "height", "fill"], yIe = ["d", "fill"], LIe = ["cx", "cy", "opacity"], xIe = ["onMouseenter", "cx", "cy", "r"], UIe = ["cx", "cy"], $Ie = {
  ref: "tooltipContent",
  class: "chart-tooltip"
};
function kIe(t, e, n, r, o, i) {
  var f, h;
  const a = ee("Spacer"), s = ee("GraphKeys"), l = ee("VerticalAxisLabels"), c = ee("HorizontalAxisLabels"), u = ee("ChartPlaceholder"), d = ee("ChartTooltip");
  return v(), A(ge, null, [
    g("div", {
      ref: "chartContainer",
      class: z(["w-100", { "desktop-chart": !t.disableFallback }])
    }, [
      ue(t.$slots, "header", { hoveredItem: t.hoveredItem }, void 0, !0),
      t.$slots.header ? (v(), te(a, { key: 0 })) : V("", !0),
      t.graphKeys ? (v(), te(s, {
        key: 1,
        "graph-keys": t.graphKeys,
        inverted: t.metric.inverted
      }, null, 8, ["graph-keys", "inverted"])) : V("", !0),
      H(a, { height: "0.25rem" }),
      g("div", SIe, [
        g("div", wIe, [
          H(l, {
            "chart-height": t.svgHeight,
            "axis-title": (f = t.axis) == null ? void 0 : f.y.label,
            "axis-labels": t.hideAxisLabels ? null : t.yAxis
          }, null, 8, ["chart-height", "axis-title", "axis-labels"])
        ], 512),
        g("div", null, [
          (v(), A("svg", {
            width: t.svgWidth,
            height: t.svgHeight,
            overflow: "visible",
            onMouseleave: e[0] || (e[0] = (..._) => t.handleMouseLeave && t.handleMouseLeave(..._))
          }, [
            g("mask", {
              id: t.roundedMaskId,
              "mask-type": "alpha",
              maskUnits: "userSpaceOnUse",
              x: 0,
              y: 0,
              width: t.svgWidth,
              height: t.svgHeight
            }, [
              g("rect", {
                x: 0,
                y: 0,
                width: t.svgWidth,
                height: t.svgHeight,
                rx: "16",
                fill: "#ffffff"
              }, null, 8, RIe)
            ], 8, bIe),
            g("g", { mask: t.roundedMaskurl }, [
              g("rect", {
                x: 0,
                y: 0,
                width: t.svgWidth,
                height: t.svgHeight,
                rx: "8",
                fill: t.metric.inverted ? t.ScatterPointChartColors.DarkGreen : t.ScatterPointChartColors.DarkRed
              }, null, 8, PIe),
              (v(!0), A(ge, null, ye(t.areas, (_) => (v(), A("path", {
                class: "d-transition",
                key: _.color,
                d: _.d,
                fill: _.color
              }, null, 8, yIe))), 128)),
              (v(!0), A(ge, null, ye(t.points, (_, E) => (v(), A("g", {
                key: _.label
              }, [
                g("circle", {
                  cx: _.cx,
                  cy: _.cy,
                  r: "4",
                  fill: "#000000",
                  opacity: 0.4 * t.animationMultiplier
                }, null, 8, LIe),
                g("circle", {
                  onMouseenter: (m) => t.hoverItem(E),
                  cx: _.cx,
                  cy: _.cy,
                  r: _.hoverRadius,
                  fill: "red",
                  "fill-opacity": "0"
                }, null, 40, xIe)
              ]))), 128)),
              Ze(g("circle", {
                ref: "tooltipCircle",
                cx: t.cx,
                cy: t.cy,
                r: "4",
                fill: "#000000"
              }, null, 8, UIe), [
                [bi, t.showTooltipMarker]
              ])
            ], 8, MIe)
          ], 40, TIe)),
          H(c, {
            "chart-width": t.svgWidth,
            "axis-labels": t.hideAxisLabels ? null : t.xAxis,
            "axis-title": (h = t.axis) == null ? void 0 : h.x.label
          }, null, 8, ["chart-width", "axis-labels", "axis-title"])
        ])
      ])
    ], 2),
    t.disableFallback ? V("", !0) : (v(), te(u, {
      key: 0,
      type: "scatter",
      "remove-container": t.removePlaceholderContainer,
      class: "mobile-chart"
    }, null, 8, ["remove-container"])),
    g("div", $Ie, [
      t.showTooltipMarker ? (v(), te(d, {
        key: 0,
        title: t.hoveredItem.label,
        metrics: t.tooltipMetrics,
        maxWidth: t.chartTooltipMaxWidth
      }, null, 8, ["title", "metrics", "maxWidth"])) : V("", !0)
    ], 512)
  ], 64);
}
const PPe = /* @__PURE__ */ Y(CIe, [["render", kIe], ["__scopeId", "data-v-e82da25d"]]), BIe = Math.pow(10, 9);
function GIe(t) {
  var De;
  const e = t.axis.x.dataType === "percentage", n = x(() => [...t.items.map((pe) => pe.x)]), r = x(() => {
    if (e)
      return -1;
    const pe = Math.min(...n.value, 0), Le = Math.max(...n.value, pe);
    return Math.min(pe, -Le * 0.1);
  }), o = x(() => Math.max(
    ...n.value.filter((pe) => pe < 1 / 0),
    e ? 1.5 : -r.value * 0.1
  )), {
    min: i,
    max: a,
    formattedAxis: s,
    zeroLocationPercent: l
  } = Mi({
    minItem: r,
    maxItem: o,
    axis: yt.Horizontal,
    metric: t.axis.x
  }), c = x(() => [...t.items.map((pe) => pe.y)]), u = x(() => Math.min(...c.value, 0)), d = x(() => Math.max(...c.value)), { max: f, formattedAxis: h } = Mi({
    minItem: u,
    maxItem: d,
    axis: yt.Vertical,
    metric: t.axis.y
  });
  function _(pe) {
    return pe && ae || !pe && !ae ? "red" : "green";
  }
  const E = {
    [yt.Horizontal]: t.axis.y.label,
    [yt.Vertical]: t.axis.x.label
  }, m = W(), N = W(), { width: I } = go(N), O = W(300), p = x(() => {
    var pe;
    return Math.max(I.value - (((pe = m.value) == null ? void 0 : pe.clientWidth) ?? 0), 0);
  }), { animationMultiplier: C } = Hi(), { tooltipCircle: D, tooltipContent: T, hoverItem: k, hideTooltip: G, showTooltip: b, hoveredIndex: P, showTooltipMarker: $ } = Do({
    appendTo: N,
    items: t.items,
    animationMultiplier: C
  }), y = x(() => l.value), L = x(() => 1 - y.value), w = x(() => p.value * l.value), R = x(() => {
    var pe;
    return ((pe = t.metric) == null ? void 0 : pe.label) === "CPA";
  }), B = x(() => {
    var pe;
    return ((pe = t.metric) == null ? void 0 : pe.label) === "ROAS";
  }), U = x(() => t.axis.x.label === "Profit"), K = x(() => e ? w.value : y.value > L.value ? p.value * L.value / 2 : p.value * y.value / 2), Z = x(() => B.value ? w.value / 2 : R.value ? w.value : w.value - K.value / 2), X = x(() => B.value ? w.value / 2 + K.value / 2 : R.value ? w.value + K.value : w.value + K.value / 2), J = x(() => Z.value + (X.value - Z.value) / 2), ae = (De = t.metric) == null ? void 0 : De.inverted, re = x(() => t.items.map((pe) => {
    const Le = pe.x < 1 / 0 ? w.value !== 0 ? w.value - pe.x / i.value * w.value : pe.x * p.value : p.value, ze = O.value - pe.y * O.value / f.value, Xe = t.items.map((ht) => {
      if ((pe == null ? void 0 : pe.x) === (ht == null ? void 0 : ht.x) || pe.y === ht.y)
        return { x: ht.x, y: ht.y, distance: BIe };
      const Gn = Math.abs((pe.x ?? 0) - (ht.x ?? 0)), F = Math.abs(pe.y - ht.y), oe = Gn * p.value / a.value, he = F * O.value / f.value, Re = Math.sqrt(Math.pow(oe, 2) + Math.pow(he, 2));
      return { ...ht, distance: Re };
    }), je = e2(Xe, "distance"), it = Math.max(Math.min(60, ((je == null ? void 0 : je.distance) ?? 0) / 2), 4), ot = _(Le > w.value), Rt = pe.y, Ht = sn({ value: Rt, currency: t.axis.y.currency }).displayValue.value, Mt = t.target ?? 0, pn = Yo({ value: pe.x }).displayValue.value;
    if (R.value) {
      const ht = pe.x * Mt + Mt, Gn = Rt / ht, F = Gs({ value: Gn }).displayValue.value, oe = sn({ value: ht, currency: t.axis.y.currency }).displayValue.value, he = sn({ value: Mt, currency: t.axis.y.currency }).displayValue.value;
      return {
        ...pe,
        formattedCost: Ht,
        formattedConversionMetric: F,
        formattedPerformanceMetric: oe,
        formattedTarget: he,
        formattedDifference: pn,
        hoverRadius: it,
        differenceColor: ot,
        cx: Le,
        cy: ze
      };
    }
    if (B.value) {
      const ht = pe.x * Mt + Mt, Gn = ht * Rt, F = sn({ value: Gn, currency: t.axis.y.currency }).displayValue.value, oe = vc({ value: ht }).displayValue.value, he = vc({ value: Mt }).displayValue.value;
      return {
        ...pe,
        formattedCost: Ht,
        formattedConversionMetric: F,
        formattedPerformanceMetric: oe,
        formattedTarget: he,
        formattedDifference: pn,
        hoverRadius: it,
        differenceColor: ot,
        cx: Le,
        cy: ze
      };
    }
    const on = pe.x, Zr = on + Rt, Pr = sn({ value: Zr, currency: t.axis.y.currency }).displayValue.value, yr = sn({ value: on, currency: t.axis.y.currency }).displayValue.value;
    return {
      ...pe,
      formattedCost: Ht,
      formattedConversionMetric: Pr,
      formattedPerformanceMetric: yr,
      formattedDifference: null,
      formattedTarget: null,
      hoverRadius: it,
      differenceColor: ot,
      cx: Le,
      cy: ze
    };
  })), j = ae ? "#B2E4CF" : "#FDC2C2", ne = ae ? "#FDC2C2" : "#B2E4CF", Ee = e ? "#BFF5DE" : "#FFEFEF", fe = e ? "#FFEFEF" : "#BFF5DE";
  function Oe() {
    G();
  }
  const ce = x(() => re.value[P.value]), Se = x(() => {
    var pe;
    return ((pe = ce.value) == null ? void 0 : pe.cx) ?? -1;
  }), se = x(() => {
    var pe;
    return ((pe = ce.value) == null ? void 0 : pe.cy) ?? -1;
  }), Ie = x(() => {
    var Le, ze, Xe, je, it, ot, Rt, Ht, Mt;
    const pe = [
      {
        label: "Cost",
        value: (Le = ce.value) == null ? void 0 : Le.formattedCost
      },
      {
        label: R.value ? "Conv." : "Value",
        // Conversions for CPA, Conversions Value for ROAS and Profit
        value: (ze = ce.value) == null ? void 0 : ze.formattedConversionMetric
      }
    ];
    return U.value ? [
      ...pe,
      {
        label: "Profit",
        value: (Xe = ce.value) == null ? void 0 : Xe.formattedPerformanceMetric,
        textColor: (je = ce.value) == null ? void 0 : je.differenceColor
      }
    ] : [
      ...pe,
      {
        label: ((it = t.metric) == null ? void 0 : it.label) ?? "",
        value: (ot = ce.value) == null ? void 0 : ot.formattedPerformanceMetric
      },
      {
        label: "Target",
        value: ((Rt = ce.value) == null ? void 0 : Rt.formattedTarget) ?? ""
      },
      {
        label: "Diff.",
        value: ((Ht = ce.value) == null ? void 0 : Ht.formattedDifference) ?? "",
        textColor: (Mt = ce.value) == null ? void 0 : Mt.differenceColor
      }
    ];
  }), we = x(() => `rounded-corner-mask-${Br(6)}`), le = x(() => `url(#${we.value})`);
  return {
    points: re,
    hoveredIndex: P,
    xAxis: s,
    yAxis: h,
    tooltipContent: T,
    tooltipCircle: D,
    hideTooltip: G,
    showTooltip: b,
    hoverItem: k,
    svgWidth: p,
    svgHeight: O,
    cx: Se,
    cy: se,
    animationMultiplier: C,
    showTooltipMarker: $,
    tooltipMetrics: Ie,
    handleMouseLeave: Oe,
    isPercentageDataType: e,
    yAxisLabels: m,
    axisLabels: E,
    hoveredItem: ce,
    firstAreaPercent: y,
    secondAreaPercent: L,
    cutoffWidthFormatted: K,
    zeroPosition: w,
    firstArea: j,
    secondArea: ne,
    lowImpactZone1: Ee,
    lowImpactZone2: fe,
    chartContainer: N,
    firstAreaWidth: Z,
    lowImpactZone2Width: X,
    lowImpactZone1Width: J,
    roundedMaskId: we,
    roundedMaskurl: le
  };
}
const FIe = { class: "chart-flex-wrapper" }, VIe = ["width", "height"], HIe = ["id", "width", "height"], WIe = ["width", "height"], YIe = ["mask"], KIe = ["width", "height", "fill"], zIe = ["width", "height", "fill"], ZIe = ["width", "height", "fill"], qIe = ["width", "height", "fill"], XIe = ["cx", "cy", "opacity"], jIe = ["onMouseenter", "cx", "cy", "r"], JIe = ["cx", "cy"], QIe = /* @__PURE__ */ Ne({
  __name: "SegmentsChart",
  props: {
    items: {},
    metric: {},
    axis: {},
    target: {},
    graphKeys: {},
    disableFallback: { type: Boolean },
    removePlaceholderContainer: { type: Boolean }
  },
  setup(t) {
    const e = t, {
      points: n,
      xAxis: r,
      yAxis: o,
      tooltipContent: i,
      tooltipCircle: a,
      hoverItem: s,
      svgWidth: l,
      svgHeight: c,
      cx: u,
      cy: d,
      animationMultiplier: f,
      showTooltipMarker: h,
      tooltipMetrics: _,
      handleMouseLeave: E,
      isPercentageDataType: m,
      yAxisLabels: N,
      hoveredItem: I,
      firstArea: O,
      secondArea: p,
      lowImpactZone1: C,
      lowImpactZone2: D,
      chartContainer: T,
      firstAreaWidth: k,
      lowImpactZone2Width: G,
      lowImpactZone1Width: b,
      roundedMaskId: P,
      roundedMaskurl: $
    } = GIe(e);
    return (y, L) => {
      var w, R, B;
      return v(), A(ge, null, [
        g("div", {
          ref_key: "chartContainer",
          ref: T,
          class: z(["w-100", { "desktop-chart": !t.disableFallback }])
        }, [
          ue(y.$slots, "header", { hoveredItem: M(I) }, void 0, !0),
          y.$slots.header ? (v(), te(He, { key: 0 })) : V("", !0),
          t.graphKeys ? (v(), te(jp, {
            key: 1,
            "graph-keys": t.graphKeys,
            inverted: !t.target || !t.metric.inverted
          }, null, 8, ["graph-keys", "inverted"])) : V("", !0),
          H(He, { height: "0.25rem" }),
          g("div", FIe, [
            g("div", {
              ref_key: "yAxisLabels",
              ref: N
            }, [
              H(Za, {
                "chart-height": M(c),
                "axis-title": (w = t.axis) == null ? void 0 : w.y.label,
                "axis-labels": M(o)
              }, null, 8, ["chart-height", "axis-title", "axis-labels"])
            ], 512),
            g("div", null, [
              (v(), A("svg", {
                width: M(l),
                height: M(c),
                x: 0,
                y: 0,
                overflow: "visible",
                onMouseleave: L[0] || (L[0] = //@ts-ignore
                (...U) => M(E) && M(E)(...U))
              }, [
                g("mask", {
                  id: M(P),
                  "mask-type": "alpha",
                  maskUnits: "userSpaceOnUse",
                  x: 0,
                  y: 0,
                  width: M(l),
                  height: M(c)
                }, [
                  g("rect", {
                    x: 0,
                    y: 0,
                    width: M(l),
                    height: M(c),
                    rx: "16",
                    fill: "#ffffff"
                  }, null, 8, WIe)
                ], 8, HIe),
                g("g", { mask: M($) }, [
                  g("rect", {
                    class: "width-transition",
                    x: "0",
                    y: "0",
                    rx: "8",
                    width: M(l),
                    height: M(c),
                    fill: M(p)
                  }, null, 8, KIe),
                  g("rect", {
                    class: "width-transition",
                    x: "0",
                    y: "0",
                    width: M(G) * M(f),
                    height: M(c),
                    fill: M(D)
                  }, null, 8, zIe),
                  M(m) ? V("", !0) : (v(), A("rect", {
                    key: 0,
                    class: "width-transition",
                    x: "0",
                    y: "0",
                    width: M(b) * M(f),
                    height: M(c),
                    fill: M(C)
                  }, null, 8, ZIe)),
                  g("rect", {
                    class: "width-transition",
                    x: "0",
                    y: "0",
                    width: M(k) * M(f),
                    height: M(c),
                    fill: M(O)
                  }, null, 8, qIe),
                  (v(!0), A(ge, null, ye(M(n), (U, K) => (v(), A("g", {
                    key: U.label
                  }, [
                    g("circle", {
                      cx: U.cx,
                      cy: U.cy,
                      r: "4",
                      fill: "#000000",
                      opacity: 0.4 * M(f)
                    }, null, 8, XIe),
                    g("circle", {
                      onMouseenter: (Z) => M(s)(K),
                      cx: U.cx,
                      cy: U.cy,
                      r: U.hoverRadius,
                      fill: "red",
                      "fill-opacity": "0"
                    }, null, 40, jIe)
                  ]))), 128)),
                  Ze(g("circle", {
                    ref_key: "tooltipCircle",
                    ref: a,
                    cx: M(u),
                    cy: M(d),
                    r: "4",
                    fill: "#000000"
                  }, null, 8, JIe), [
                    [bi, M(h)]
                  ])
                ], 8, YIe)
              ], 40, VIe)),
              H(qa, {
                "axis-title": (R = t.axis) == null ? void 0 : R.x.label,
                "chart-width": M(l),
                "axis-labels": M(r)
              }, null, 8, ["axis-title", "chart-width", "axis-labels"])
            ])
          ])
        ], 2),
        t.disableFallback ? V("", !0) : (v(), te(Xa, {
          key: 0,
          type: "segment",
          "remove-container": t.removePlaceholderContainer,
          class: "mobile-chart"
        }, null, 8, ["remove-container"])),
        g("div", {
          ref_key: "tooltipContent",
          ref: i,
          class: "chart-tooltip"
        }, [
          M(h) ? (v(), te(Co, {
            key: 0,
            title: (B = M(I)) == null ? void 0 : B.label,
            metrics: M(_)
          }, null, 8, ["title", "metrics"])) : V("", !0)
        ], 512)
      ], 64);
    };
  }
});
const yPe = /* @__PURE__ */ Y(QIe, [["__scopeId", "data-v-e6f14ae9"]]), eOe = { class: "w-100 flex center-items justify-center" }, tOe = ["viewBox"], nOe = ["width", "height"], rOe = ["width", "height"], oOe = { mask: "url(#rounded-corner-mask)" }, iOe = ["d"], aOe = ["d"], LPe = /* @__PURE__ */ Ne({
  __name: "Sparkline",
  props: {
    items: {}
  },
  setup(t) {
    const e = t, n = W(64), r = W(32), { splinedItems: o } = r1({ items: e.items, numberOfPoints: n.value, showZero: !0 }), i = Pc(e.items, "y") / e.items.length, a = x(() => Math.max(Math.max(...e.items.map((_) => _.y)) * 1.1, i * 2)), s = x(() => Math.max(Math.abs(a.value), r.value) * 1.5), l = W(-2), c = x(() => o.value.map((_) => _.x.valueOf())), u = x(() => Math.min(...c.value)), d = x(() => Math.max(...c.value)), { svgPoints: f, svgGradientPoints: h } = o1({
      splinedItems: o.value,
      rangeOfPoints: s.value,
      minItemY: l,
      svgWidth: n,
      svgHeight: r,
      minItemX: u,
      maxItemX: d
    });
    return (_, E) => (v(), A("div", eOe, [
      (v(), A("svg", {
        class: "opteo-blue",
        width: "100%",
        viewBox: `0 0 ${n.value} ${r.value}`
      }, [
        g("mask", {
          id: "rounded-corner-mask",
          "mask-type": "alpha",
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "0",
          width: n.value,
          height: r.value
        }, [
          g("rect", {
            width: n.value,
            x: "0",
            y: "0",
            height: r.value,
            rx: "3",
            fill: "#ffffff"
          }, null, 8, rOe)
        ], 8, nOe),
        g("g", oOe, [
          g("path", {
            stroke: "currentColor",
            class: "d-transition",
            fill: "none",
            "stroke-width": "2",
            d: M(f),
            "stroke-linecap": "round"
          }, null, 8, iOe),
          g("path", {
            class: "fill-lighter-blue",
            d: M(h)
          }, null, 8, aOe)
        ])
      ], 8, tOe))
    ]));
  }
});
function sOe(t) {
  const e = so("axisLabelsInsideChart", !1), n = W(), r = W(), { width: o } = go(n), i = x(() => {
    var se;
    return Math.max(240, o.value - (e ? 0 : ((se = r.value) == null ? void 0 : se.clientWidth) ?? 0));
  }), a = x(() => t.chartHeight ?? 300), s = x(() => {
    var se;
    return ((se = Xp()) == null ? void 0 : se.name) === "safari";
  }), { animationMultiplier: l, finishedChartAnimation: c } = Hi(
    (t.removeInteractivity ?? !1) || s.value
  ), u = x(
    () => t.series.map((se, Ie) => {
      const we = se.items.map((De, pe) => {
        let Le = De.y;
        for (let ze = 0; ze < Ie; ze++)
          Le += t.series[ze].items[pe].y;
        return {
          ...De,
          y: Le
        };
      }), { splinedItems: le } = r1({
        items: we,
        showZero: !!t.showZero,
        maxItem: t.maxItem,
        numberOfPoints: Math.round(i.value)
      });
      return {
        ...se,
        splinedItems: le
      };
    })
  ), d = x(
    () => Qp(u.value.flatMap((se) => se.items.map((Ie, we) => {
      var le;
      return ((le = Ie.x) == null ? void 0 : le.valueOf()) ?? Ie.label;
    })))
  ), f = x(() => typeof d.value[0] == "string"), h = x(
    () => u.value.flatMap((se) => se.splinedItems.value.map((Ie) => Ie.y))
  ), _ = x(() => !!h.value.find((se) => se < 0)), E = x(() => _.value ? !1 : t.showZero), m = x(() => {
    var se;
    return t.maxItem ? t.maxItem : Math.max(...h.value, 0, ...((se = t.horizontalMarkers) == null ? void 0 : se.map((Ie) => Ie.value)) ?? []);
  }), N = x(() => E.value ? 0 : Math.min(...h.value, m.value)), I = x(() => f.value ? 0 : Math.min(...d.value)), O = x(() => f.value ? d.value.length - 1 : Math.max(...d.value)), p = x(() => Math.abs(D.value - C.value)), {
    min: C,
    max: D,
    formattedAxis: T
  } = Mi({
    minItem: N,
    maxItem: m,
    axis: yt.Vertical,
    metric: t.metric
  }), k = x(() => Math.min(d.value.length, i.value > 400 ? 8 : 4)), G = x(() => f.value ? Jp({
    items: u.value[0].items,
    numberOfPoints: k
  }) : S7({
    minItem: I,
    maxItem: O,
    numberOfPoints: k
  })), b = x(() => {
    var se;
    return (se = G.value.offset) == null ? void 0 : se.value;
  }), P = x(() => {
    var se;
    return (se = G.value.formattedAxisLabels) == null ? void 0 : se.value;
  }), $ = x(() => (b.value ?? 0) * o.value / (d.value.length - 1)), y = x(
    () => u.value.map((se, Ie) => {
      var on, Zr, Pr, yr;
      const we = se.splinedItems.value, le = !!se.items[0].dotted, De = se.items.findIndex((ht) => !ht.dotted), pe = le ? ((Zr = (on = se.items[De]) == null ? void 0 : on.x) == null ? void 0 : Zr.valueOf()) ?? De : void 0, Le = !!se.items[se.items.length - 1].dotted, ze = se.items.findIndex(
        (ht, Gn) => ht.dotted && Gn > De
      ), Xe = Le ? ((yr = (Pr = se.items[ze - 1]) == null ? void 0 : Pr.x) == null ? void 0 : yr.valueOf()) ?? ze - 1 : void 0, je = se.items.filter((ht) => !ht.dotted).length === 0, it = se.dotted || je, { svgPoints: ot, svgGradientPoints: Rt, startDottedSvgPoints: Ht, endDottedSvgPoints: Mt } = o1({
        splinedItems: we,
        svgWidth: i,
        svgHeight: a,
        minItemY: C,
        rangeOfPoints: p.value,
        lastDottedItemX: pe,
        firstDottedItemX: Xe,
        maxItemX: O,
        minItemX: I
      }), pn = zd(t.series.length - 1 - Ie);
      return {
        ...se,
        dotted: it,
        svgPoints: ot.value,
        svgGradientPoints: Rt.value,
        startDottedSvgPoints: Ht.value,
        endDottedSvgPoints: Mt.value,
        color: pn
      };
    }).reverse()
  ), L = x(
    () => y.value.map((se) => ({
      color: se.color,
      id: `stop-${se.color}-${Br(6)}`
    }))
  ), { tooltipCircle: w, tooltipContent: R, hoveredIndex: B, showTooltip: U, hideTooltip: K, showTooltipMarker: Z } = Do({ appendTo: n, enableMoveTransition: !0 });
  function X(se) {
    if (!t.removeInteractivity) {
      if (B.value === -1) {
        B.value = se, U();
        return;
      }
      B.value = se;
    }
  }
  const J = x(() => y.value.map((se, Ie) => {
    var pe;
    const we = d.value[B.value] ?? 0, le = (pe = se.items) == null ? void 0 : pe.find((Le, ze) => Le.x ? jl(Le.x.valueOf(), we) : ze === B.value);
    if (!le)
      return;
    const { displayValue: De } = yn({
      value: le.y ?? 0,
      metric: t.metric
    });
    return {
      ...le,
      displayYValue: De,
      seriesName: se.name,
      dotted: se.dotted || (le == null ? void 0 : le.dotted),
      color: zd(Ie)
    };
  })), ae = x(
    () => d.value.map((se, Ie) => {
      const we = ((f.value ? Ie : se) - I.value) * i.value / (O.value - I.value);
      if (t.maxItem === 1)
        return {
          x: we,
          y: a.value / 2
        };
      let le = 0;
      t.series.forEach((pe, Le) => {
        let ze = 0;
        for (let Xe = 0; Xe <= Le; Xe++) {
          const je = t.series[Xe].items.find((it) => {
            var ot;
            return se === ((ot = it.x) == null ? void 0 : ot.valueOf()) || se === it.label;
          });
          ze += (je == null ? void 0 : je.y) ?? 0;
        }
        le = Math.max(ze ?? le, le);
      });
      const De = a.value - (le - C.value) * a.value / (D.value - C.value);
      return { x: we, y: De };
    })
  ), re = x(() => {
    var se;
    return B.value < 0 ? -5 : ((se = ae.value[B.value]) == null ? void 0 : se.x) ?? -5;
  }), j = x(() => {
    var se;
    return B.value < 0 ? -5 : ((se = ae.value[B.value]) == null ? void 0 : se.y) ?? -5;
  }), { formattedMarkers: ne } = n1({
    markers: Ga(t, "horizontalMarkers"),
    svgHeight: a,
    minItemY: C,
    maxItemY: D,
    appendTo: n
  }), Ee = x(() => {
    const se = d.value[B.value];
    if (!se)
      return;
    if (f.value)
      return se;
    const { displayValue: Ie } = yn({
      value: se,
      metric: {
        dataType: "date",
        dateFormat: "do MMMM yyyy",
        label: "Date"
      }
    });
    return Ie.value;
  }), fe = x(() => {
    var Ie;
    const se = [];
    return (Ie = J.value) == null || Ie.forEach((we) => {
      we && se.push({ label: we.seriesName, value: we.displayYValue.value, dotted: we.dotted, color: we.color });
    }), se;
  }), Oe = x(() => Br(6)), ce = x(() => `animation-clip-path-${Br(6)}`), Se = x(() => `url(#${ce.value})`);
  return {
    hoverGraph: X,
    hoveredItem: J,
    tooltipCx: re,
    tooltipCy: j,
    formattedSeries: y,
    formattedAxisLabels: P,
    tooltipCircle: w,
    tooltipContent: R,
    yAxisLabels: T,
    hideTooltip: K,
    showTooltipMarker: Z,
    svgHeight: a,
    svgWidth: i,
    animationMultiplier: l,
    yAxisContainer: r,
    tooltipPlotlines: fe,
    toolTipFooter: Ee,
    formattedMarkers: ne,
    chartContainer: n,
    allX: d,
    seriesColors: L,
    minItemX: I,
    maxItemX: O,
    hoverAreas: ae,
    finishedChartAnimation: c,
    chartUniqueId: Oe,
    hoveredIndex: B,
    offsetWidth: $,
    axisLabelsInsideChart: e,
    clipPathId: ce,
    clipPathUrl: Se
  };
}
const lOe = { class: "chart-flex-wrapper" }, cOe = ["width", "height"], uOe = ["id", "x1", "x2", "y2"], dOe = ["x1", "x2", "y2"], fOe = ["stop-color"], hOe = ["stop-color"], _Oe = ["id"], EOe = ["x"], pOe = ["d"], mOe = ["fill", "d", "fill-opacity"], NOe = ["clip-path", "stroke-opacity", "d"], vOe = ["clip-path", "stroke-opacity", "d"], gOe = ["clip-path", "stroke-opacity", "d"], IOe = { key: 0 }, OOe = ["x2", "y1", "y2"], AOe = ["x", "y"], DOe = ["y"], COe = ["cx", "cy"], SOe = ["y2", "x1", "x2"], wOe = ["stroke-width", "onMouseenter", "y2", "x1", "x2"], TOe = /* @__PURE__ */ Ne({
  __name: "AreaChart",
  props: {
    series: {},
    metric: {},
    showZero: { type: Boolean },
    horizontalMarkers: {},
    axisTitles: {},
    removeInteractivity: { type: Boolean },
    gradientHex: {},
    chartHeight: {},
    maxItem: {},
    disableFallback: { type: Boolean },
    removePlaceholderContainer: { type: Boolean }
  },
  setup(t) {
    const e = t, {
      hoverGraph: n,
      hideTooltip: r,
      hoveredItem: o,
      tooltipCx: i,
      tooltipCy: a,
      formattedSeries: s,
      formattedAxisLabels: l,
      tooltipCircle: c,
      tooltipContent: u,
      yAxisLabels: d,
      showTooltipMarker: f,
      svgHeight: h,
      svgWidth: _,
      animationMultiplier: E,
      yAxisContainer: m,
      tooltipPlotlines: N,
      toolTipFooter: I,
      formattedMarkers: O,
      chartContainer: p,
      allX: C,
      seriesColors: D,
      finishedChartAnimation: T,
      hoverAreas: k,
      offsetWidth: G,
      clipPathId: b,
      clipPathUrl: P
    } = sOe(e);
    return ($, y) => {
      var L, w;
      return v(), A(ge, null, [
        g("div", {
          ref_key: "chartContainer",
          ref: p,
          class: z(["w-100", { "desktop-chart": !t.disableFallback }])
        }, [
          ue($.$slots, "header", {
            class: "w-100",
            hoveredItem: M(o)
          }, void 0, !0),
          $.$slots.header ? (v(), te(He, { key: 0 })) : V("", !0),
          g("div", lOe, [
            g("div", {
              ref_key: "yAxisContainer",
              ref: m
            }, [
              H(Za, {
                "chart-height": M(h),
                "axis-title": (L = t.axisTitles) == null ? void 0 : L.y,
                "axis-labels": M(d)
              }, null, 8, ["chart-height", "axis-title", "axis-labels"])
            ], 512),
            g("div", null, [
              (v(), A("svg", {
                width: M(_),
                height: M(h),
                overflow: "visible",
                onMouseleave: y[0] || (y[0] = //@ts-ignore
                (...R) => M(r) && M(r)(...R))
              }, [
                g("defs", null, [
                  (v(!0), A(ge, null, ye(M(D), (R) => (v(), A("linearGradient", {
                    id: R.id,
                    x1: M(_),
                    y1: "0",
                    x2: M(_),
                    y2: M(h),
                    gradientUnits: "userSpaceOnUse"
                  }, [
                    g("stop", {
                      class: z(`stop-${R.color}`),
                      "stop-opacity": "0.2"
                    }, null, 2),
                    g("stop", {
                      offset: "1",
                      class: z(`stop-${R.color}`),
                      "stop-opacity": "0"
                    }, null, 2)
                  ], 8, uOe))), 256)),
                  g("linearGradient", {
                    id: "stop-custom",
                    x1: M(_),
                    y1: "0",
                    x2: M(_),
                    y2: M(h),
                    gradientUnits: "userSpaceOnUse",
                    fill: "red"
                  }, [
                    g("stop", {
                      "stop-color": t.gradientHex,
                      "stop-opacity": "0.2"
                    }, null, 8, fOe),
                    g("stop", {
                      offset: "1",
                      "stop-color": t.gradientHex,
                      "stop-opacity": "0"
                    }, null, 8, hOe)
                  ], 8, dOe),
                  g("clipPath", { id: M(b) }, [
                    g("rect", {
                      class: "stroke-animation-mask",
                      x: `-${(1 - M(E)) * 100}%`,
                      y: "-2px",
                      width: "100%",
                      height: "200%"
                    }, null, 8, EOe)
                  ], 8, _Oe)
                ]),
                (v(!0), A(ge, null, ye(M(s), (R, B) => (v(), A("g", {
                  key: R.name
                }, [
                  g("path", {
                    class: z([
                      {
                        "d-transition": M(T),
                        "fill-opacity-transition": !M(T)
                      }
                    ]),
                    stroke: "none",
                    fill: "white",
                    d: R.svgGradientPoints
                  }, null, 10, pOe),
                  g("path", {
                    class: z([
                      {
                        "d-transition": M(T),
                        "fill-opacity-transition": !M(T)
                      }
                    ]),
                    fill: t.gradientHex ? "url(#stop-custom)" : `url(#${M(D)[B].id})`,
                    d: R.svgGradientPoints,
                    "fill-opacity": M(E),
                    x: "10",
                    stroke: "none"
                  }, null, 10, mOe),
                  g("path", {
                    "clip-path": M(P),
                    stroke: "currentColor",
                    "stroke-opacity": M(E),
                    class: z([{ "d-transition": M(T) }, R.color, "dotted"]),
                    fill: "none",
                    "stroke-width": "2",
                    d: R.startDottedSvgPoints
                  }, null, 10, NOe),
                  g("path", {
                    "clip-path": M(P),
                    stroke: "currentColor",
                    "stroke-opacity": M(E),
                    class: z([{ "d-transition": M(T), dotted: R.dotted }, R.color]),
                    fill: "none",
                    "stroke-width": "2",
                    d: R.svgPoints
                  }, null, 10, vOe),
                  g("path", {
                    "clip-path": M(P),
                    stroke: "currentColor",
                    "stroke-opacity": M(E),
                    class: z([{ "d-transition": M(T) }, R.color, "dotted"]),
                    fill: "none",
                    "stroke-width": "2",
                    d: R.endDottedSvgPoints
                  }, null, 10, gOe)
                ]))), 128)),
                M(O) ? (v(), A("g", IOe, [
                  (v(!0), A(ge, null, ye(M(O), (R) => (v(), A("g", {
                    key: R.label
                  }, [
                    g("line", {
                      class: "all-transition",
                      x1: 0,
                      x2: M(_),
                      y1: R.y,
                      y2: R.y,
                      style: { stroke: "rgb(218, 218, 218)" },
                      "stroke-dasharray": "5,3"
                    }, null, 8, OOe),
                    R.labelPosition === "end" ? (v(), A("text", {
                      key: 0,
                      class: "marker-text height-transition",
                      x: M(_),
                      y: R.y,
                      dx: "-3px",
                      dy: "-5px",
                      "text-anchor": "end"
                    }, Q(R.label), 9, AOe)) : (v(), A("text", {
                      key: 1,
                      class: "marker-text",
                      x: 0,
                      y: R.y,
                      dy: "-5px",
                      "text-anchor": "start"
                    }, Q(R.label), 9, DOe))
                  ]))), 128))
                ])) : V("", !0),
                g("circle", {
                  ref_key: "tooltipCircle",
                  ref: c,
                  stroke: "none",
                  fill: "none",
                  r: "5",
                  "stroke-width": "2",
                  cx: M(i),
                  cy: M(a)
                }, null, 8, COe),
                g("line", {
                  class: z([{ active: M(f) }, "stroke-tooltip"]),
                  "stroke-width": "2",
                  y1: 0,
                  y2: M(h),
                  x1: M(i),
                  x2: M(i)
                }, null, 10, SOe),
                (v(!0), A(ge, null, ye(M(k), (R, B) => (v(), A("line", {
                  class: "stroke-tooltip",
                  "stroke-width": M(_) / (M(C).length - 1),
                  onMouseenter: (U) => M(n)(B),
                  key: B,
                  y1: 0,
                  y2: M(h),
                  x1: R.x,
                  x2: R.x
                }, null, 40, wOe))), 128))
              ], 40, cOe)),
              H(qa, {
                "chart-width": M(_),
                "axis-labels": M(l),
                "axis-title": (w = t.axisTitles) == null ? void 0 : w.x,
                offset: M(G)
              }, null, 8, ["chart-width", "axis-labels", "axis-title", "offset"])
            ])
          ])
        ], 2),
        t.disableFallback ? V("", !0) : (v(), te(Xa, {
          key: 0,
          type: "area",
          "remove-container": t.removePlaceholderContainer,
          class: "mobile-chart"
        }, null, 8, ["remove-container"])),
        t.removeInteractivity ? V("", !0) : (v(), A("div", {
          key: 1,
          ref_key: "tooltipContent",
          ref: u
        }, [
          $.$slots.tooltip ? ue($.$slots, "tooltip", {
            key: 0,
            hoveredItem: M(o)
          }, void 0, !0) : (v(), te(Co, {
            key: 1,
            "plot-lines": M(N),
            footer: M(I)
          }, null, 8, ["plot-lines", "footer"]))
        ], 512))
      ], 64);
    };
  }
});
const bOe = /* @__PURE__ */ Y(TOe, [["__scopeId", "data-v-814f2bf6"]]), ROe = { class: "chart-container" }, MOe = { class: "chart-header-container" }, POe = { key: 0 }, yOe = { class: "inline-flex items-center" }, LOe = { key: 1 }, xOe = {
  key: 2,
  class: "chart-header"
}, UOe = {
  key: 0,
  class: "inline-flex items-center"
}, $Oe = {
  key: 1,
  class: "nowrap"
}, kOe = {
  key: 3,
  class: "chart-buttons"
}, BOe = { key: 0 }, GOe = {
  key: 0,
  class: "chart-skeleton"
}, FOe = { key: 1 }, VOe = {
  key: 0,
  class: "chart-skeleton"
}, HOe = /* @__PURE__ */ Ne({
  __name: "PerformanceChartContainer",
  props: {
    chartLabel: {},
    skeleton: { type: Boolean },
    noDataAvailable: { type: Boolean },
    total: {},
    delta: {},
    currentValues: {},
    showExpandButton: { type: Boolean },
    skeletonHeight: {}
  },
  emits: ["preview-opened", "download-chart"],
  setup(t, { emit: e }) {
    Wr((c) => ({
      v648114d2: s.value
    }));
    const n = e, r = W(null), { width: o, height: i } = go(r), a = t, s = x(() => `${a.skeletonHeight}px` ?? "350px");
    Ti("axisLabelsInsideChart", !0);
    function l() {
      n("preview-opened");
    }
    return (c, u) => (v(), A("div", ROe, [
      g("div", MOe, [
        t.skeleton ? (v(), A("div", POe, [
          H(M(He), { height: "0.25rem" }),
          H(sa, {
            width: 60,
            height: 10
          }),
          H(M(He), { height: "0.5rem" }),
          g("span", yOe, [
            H(sa, {
              width: 114,
              height: 16
            }),
            H(M(He), { width: "0.75rem" }),
            H(sa, {
              width: 22,
              height: 22,
              style: { opacity: "0.67" }
            }),
            H(M(He), { width: "0.625rem" }),
            H(sa, {
              width: 50,
              height: 12,
              style: { opacity: "0.67" }
            })
          ])
        ])) : t.noDataAvailable ? (v(), A("div", LOe, [
          H(M(Ye), {
            as: "p",
            size: "f-8",
            style: { opacity: "0.2" }
          }, {
            default: q(() => [...u[0] || (u[0] = [
              me("No Data Available", -1)
            ])]),
            _: 1
          }),
          H(M(He), { height: "1.9375rem" })
        ])) : (v(), A("div", xOe, [
          H(M(Ye), {
            as: "p",
            size: "f-8"
          }, {
            default: q(() => [
              me(Q(t.chartLabel), 1)
            ]),
            _: 1
          }),
          t.total ? (v(), A("span", UOe, [
            H(M(Ye), {
              as: "h2",
              size: "f-5",
              weight: "600",
              style: { "letter-spacing": "-0.045rem" }
            }, {
              default: q(() => [
                me(Q(t.total), 1)
              ]),
              _: 1
            }),
            H(M(He), {
              width: "0.75rem",
              height: "0.25rem"
            }),
            t.delta ? (v(), te(M(Dp), Tt({ key: 0 }, t.delta, {
              reverse: t.delta.reverse,
              threshold: 0.05
            }), null, 16, ["reverse"])) : V("", !0)
          ])) : t.currentValues ? (v(), A("span", $Oe, [
            (v(!0), A(ge, null, ye(t.currentValues, (d, f) => (v(), A("div", {
              class: "inline-flex items-center",
              key: f
            }, [
              (v(), A("svg", {
                width: "9",
                height: "9",
                viewBox: "0 0 9 9",
                class: z([M(Ks)[f % 6], "flex align-center"]),
                style: { "min-width": "9px" },
                fill: "none"
              }, [...u[1] || (u[1] = [
                g("circle", {
                  cx: "4.5",
                  cy: "4.5",
                  r: "4.5",
                  fill: "currentColor"
                }, null, -1)
              ])], 2)),
              H(M(He), { width: "0.5rem" }),
              H(M(Ye), {
                as: "h2",
                size: "f-5",
                weight: "600",
                style: { "letter-spacing": "-0.045rem" }
              }, {
                default: q(() => [
                  me(Q(d), 1)
                ]),
                _: 2
              }, 1024),
              H(M(He), { width: "1rem" })
            ]))), 128))
          ])) : V("", !0)
        ])),
        t.noDataAvailable ? V("", !0) : (v(), A("div", kOe, [
          t.showExpandButton ? (v(), te(M(ln), {
            key: 0,
            disabled: t.skeleton,
            color: "white",
            circle: !0,
            size: "medium",
            onClicked: l,
            style: { width: "44px", height: "44px" }
          }, {
            icon: q(() => [...u[2] || (u[2] = [
              g("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                g("mask", {
                  id: "mask0_199_47",
                  style: { "mask-type": "alpha" },
                  maskUnits: "userSpaceOnUse",
                  x: "0",
                  y: "0",
                  width: "16",
                  height: "16"
                }, [
                  g("rect", {
                    width: "16",
                    height: "16",
                    fill: "#C4C4C4"
                  })
                ]),
                g("g", { mask: "url(#mask0_199_47)" }, [
                  g("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M0.0065918 0.997335C0.0065918 0.714492 0.077302 0.50236 0.289434 0.290228C0.501566 0.0780958 0.713698 0.00738525 0.996541 0.00738525H6.06761C6.61434 0.00738525 7.05756 0.4506 7.05756 0.997334C7.05756 1.54407 6.61434 1.98728 6.06761 1.98728L3.4007 1.98728L6.77472 5.3613C7.16524 5.75182 7.16524 6.38499 6.77472 6.77551C6.38419 7.16603 5.75103 7.16603 5.3605 6.77551L1.98649 3.4015L1.98649 6.0684C1.98649 6.61514 1.54328 7.05835 0.996541 7.05835C0.449807 7.05835 0.0065918 6.61514 0.0065918 6.0684V0.997335ZM16.0036 15.0127C16.0036 15.2956 15.9329 15.5077 15.7207 15.7198C15.5086 15.932 15.2965 16.0027 15.0136 16.0027H9.94256C9.39583 16.0027 8.95261 15.5595 8.95261 15.0127C8.95261 14.466 9.39583 14.0228 9.94256 14.0228H12.6095L9.23546 10.6488C8.84493 10.2582 8.84493 9.62507 9.23546 9.23454C9.62598 8.84402 10.2591 8.84402 10.6497 9.23454L14.0237 12.6086L14.0237 9.94165C14.0237 9.39492 14.4669 8.9517 15.0136 8.9517C15.5604 8.9517 16.0036 9.39492 16.0036 9.94165V15.0127Z",
                    fill: "#010105"
                  })
                ])
              ], -1)
            ])]),
            _: 1
          }, 8, ["disabled"])) : V("", !0)
        ]))
      ]),
      g("div", {
        class: "chart",
        ref_key: "chartWidthRef",
        ref: r
      }, [
        M(o) <= 607 ? (v(), A("div", BOe, [
          t.skeleton || t.noDataAvailable ? (v(), A("div", GOe, [...u[3] || (u[3] = [
            vt('<svg viewBox="0 0 607 342" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-33462005><mask id="mask0_1567_1376" style="mask-type:alpha;" maskUnits="userSpaceOnUse" x="0" y="0" width="607" height="342" data-v-33462005><rect width="607" height="342" fill="white" data-v-33462005></rect></mask><g mask="url(#mask0_1567_1376)" data-v-33462005><path d="M607 343H608V342V58.6208V57.6208H607C604.538 57.6208 603.036 56.8134 601.938 55.6498C600.784 54.4285 600.03 52.7777 599.181 50.9206L599.169 50.8947C598.346 49.0955 597.431 47.0998 595.935 45.5825C594.385 44.0095 592.271 43 589.179 43C587.402 43 585.924 43.8517 584.709 45.1658C583.51 46.4635 582.515 48.2626 581.65 50.3204C579.929 54.4183 578.607 59.8457 577.311 65.1657L577.296 65.2279C575.982 70.6204 574.694 75.8989 573.041 79.8342C572.215 81.8011 571.328 83.3558 570.357 84.4058C569.402 85.4394 568.422 85.9292 567.357 85.9292C564.816 85.9292 563.044 84.9839 561.585 83.5284C560.123 82.0699 558.993 80.1214 557.766 78.0071L557.652 77.8103C555.182 73.5538 552.308 68.6953 545.536 68.6953C542.236 68.6953 539.902 69.7002 538.089 71.2444C536.374 72.7058 535.165 74.6259 534.046 76.4026L533.95 76.5549C532.772 78.4232 531.672 80.1311 530.132 81.3987C528.636 82.6306 526.676 83.481 523.714 83.481C521.084 83.481 519.074 81.7269 517.344 78.5959C515.618 75.4702 514.339 71.2606 513.082 66.9179C512.984 66.5792 512.886 66.2396 512.789 65.8998C511.648 61.9436 510.497 57.9499 509.016 54.8779C507.433 51.5941 505.253 48.9106 501.893 48.9106C500.138 48.9106 498.704 49.8289 497.545 51.1969C496.396 52.5517 495.443 54.429 494.61 56.5778C493.015 60.6944 491.76 66.1006 490.515 71.4637L490.349 72.1754C489.037 77.8203 487.719 83.3559 486.01 87.4816C485.155 89.5443 484.232 91.1788 483.218 92.2843C482.22 93.3736 481.19 93.8929 480.071 93.8929C477.311 93.8929 475.408 93.1802 473.905 92.1446C472.366 91.0844 471.201 89.6606 469.937 88.1032L469.899 88.0562C468.673 86.5469 467.346 84.9122 465.551 83.6755C463.701 82.4012 461.4 81.5742 458.25 81.5742C454.763 81.5742 452.396 83.879 450.651 86.884C448.921 89.8637 447.644 93.796 446.411 97.5918L446.388 97.6637C445.127 101.545 443.909 105.281 442.297 108.057C440.69 110.826 438.851 112.371 436.429 112.371C434.609 112.371 433.091 113.21 431.839 114.527C430.604 115.826 429.587 117.627 428.71 119.688C426.959 123.806 425.647 129.264 424.375 134.605L424.312 134.867C423.049 140.171 421.817 145.342 420.225 149.215C419.416 151.182 418.544 152.735 417.585 153.784C416.642 154.815 415.671 155.303 414.607 155.303C412.352 155.303 410.534 153.659 408.882 150.581C407.246 147.533 405.967 143.437 404.651 139.208L404.63 139.139C403.339 134.99 402.009 130.717 400.273 127.483C398.544 124.262 396.214 121.706 392.786 121.706C390.926 121.706 389.443 122.79 388.27 124.352C387.102 125.907 386.136 128.067 385.296 130.553C383.652 135.421 382.394 141.851 381.148 148.22L381.064 148.648C379.781 155.204 378.501 161.659 376.818 166.477C375.976 168.889 375.058 170.811 374.041 172.112C373.032 173.405 372.02 173.974 370.964 173.974C368.313 173.974 366.521 172.987 365.082 171.478C363.633 169.959 362.553 167.928 361.38 165.719L361.277 165.527C360.095 163.304 358.807 160.919 356.96 159.11C355.065 157.255 352.602 156.019 349.143 156.019C346.34 156.019 344.362 154.738 342.747 152.687C341.093 150.587 339.877 147.749 338.646 144.756C338.572 144.576 338.498 144.397 338.424 144.216C337.29 141.452 336.115 138.587 334.551 136.387C332.852 133.997 330.594 132.253 327.321 132.253C323.883 132.253 321.583 134.844 319.892 138.094C318.225 141.298 316.955 145.514 315.716 149.628L315.624 149.933C314.337 154.203 313.072 158.339 311.417 161.414C309.751 164.511 307.878 166.191 305.5 166.191C304.617 166.191 303.608 165.488 302.534 163.494C301.492 161.561 300.571 158.734 299.739 155.242C298.077 148.272 296.833 138.956 295.581 129.565L295.575 129.523C294.329 120.181 293.073 110.768 291.385 103.688C290.542 100.15 289.573 97.1184 288.405 94.9511C287.27 92.8442 285.751 91.2032 283.679 91.2032C281.643 91.2032 280.112 92.7141 278.95 94.7068C277.764 96.7402 276.776 99.5799 275.913 102.887C274.184 109.513 272.884 118.322 271.608 127.053L271.538 127.531C270.281 136.137 269.04 144.63 267.43 151.012C266.608 154.269 265.709 156.9 264.701 158.696C263.664 160.544 262.7 161.193 261.857 161.193C259.498 161.193 257.777 159.854 256.286 157.516C254.852 155.269 253.753 152.286 252.588 149.125C252.524 148.951 252.46 148.778 252.396 148.604C251.183 145.317 249.877 141.877 248.034 139.268C246.16 136.616 243.645 134.707 240.036 134.707C236.66 134.707 234.259 135.592 232.388 136.973C230.555 138.326 229.29 140.117 228.137 141.757L228.115 141.787C226.941 143.457 225.879 144.967 224.405 146.092C222.965 147.192 221.08 147.957 218.214 147.957C215.633 147.957 213.802 146.496 212.271 143.977C210.735 141.449 209.627 138.053 208.464 134.491L208.425 134.371C207.27 130.833 206.055 127.136 204.293 124.334C202.505 121.491 200.044 119.405 196.393 119.405C192.882 119.405 190.431 120.853 188.584 122.978C186.787 125.047 185.552 127.773 184.4 130.327L184.371 130.391C183.201 132.988 182.111 135.405 180.603 137.2C179.134 138.951 177.297 140.072 174.571 140.072C172.009 140.072 170.117 138.536 168.503 135.85C166.876 133.142 165.673 129.495 164.442 125.699L164.353 125.426C163.171 121.78 161.95 118.014 160.285 115.149C158.571 112.198 156.231 109.944 152.75 109.944C150.829 109.944 149.302 111.073 148.099 112.705C146.9 114.332 145.915 116.592 145.066 119.197C143.368 124.399 142.109 131.302 140.866 138.111L140.856 138.167C139.602 145.042 138.363 151.817 136.712 156.877C135.886 159.41 134.981 161.431 133.97 162.802C132.964 164.167 131.962 164.75 130.929 164.75C128.459 164.75 126.683 163.35 125.172 160.918C123.686 158.529 122.581 155.339 121.416 151.975L121.303 151.65C120.12 148.235 118.859 144.663 117.057 141.955C115.226 139.205 112.738 137.205 109.107 137.205C105.485 137.205 102.943 139.188 101.041 141.921C99.1644 144.618 97.8176 148.173 96.575 151.582C96.4814 151.838 96.3884 152.094 96.2958 152.349C95.1359 155.541 94.0416 158.552 92.6536 160.836C91.165 163.287 89.4981 164.643 87.2857 164.643C84.9191 164.643 83.2148 163.604 81.7537 161.924C80.3303 160.288 79.1986 158.116 77.9787 155.776C77.9104 155.645 77.8418 155.513 77.7729 155.381C76.5036 152.949 75.122 150.37 73.2382 148.413C71.3133 146.414 68.8479 145.045 65.4643 145.045C63.3984 145.045 61.8221 146.498 60.6156 148.471C59.3931 150.471 58.3834 153.261 57.5092 156.506C55.7574 163.008 54.4709 171.649 53.2233 180.209C53.1767 180.529 53.1301 180.849 53.0835 181.168C51.879 189.439 50.696 197.562 49.1516 203.696C48.3479 206.888 47.4646 209.463 46.47 211.221C45.4496 213.023 44.4933 213.661 43.6429 213.661C41.329 213.661 39.6051 212.22 38.0928 209.62C36.6518 207.143 35.5481 203.857 34.3851 200.396C34.3207 200.204 34.2561 200.012 34.1913 199.819C32.9778 196.213 31.6775 192.458 29.8435 189.611C27.9887 186.732 25.4738 184.614 21.8214 184.614C18.8179 184.614 16.8333 183.889 15.3356 182.856C13.8047 181.801 12.7146 180.384 11.5395 178.822L11.444 178.695C10.3232 177.206 9.1037 175.584 7.37914 174.354C5.56676 173.061 3.25638 172.233 0 172.233H-1V173.233V342V343H0H607Z" fill="url(#paint0_linear_1567_1376)" stroke="#ececef" stroke-width="2" data-v-33462005></path></g><defs data-v-33462005><linearGradient id="paint0_linear_1567_1376" x1="305.5" y1="44" x2="305.5" y2="352" gradientUnits="userSpaceOnUse" data-v-33462005><stop stop-color="#F8F8FB" data-v-33462005></stop><stop offset="1" stop-color="white" data-v-33462005></stop></linearGradient></defs></svg>', 1)
          ])])) : ue(c.$slots, "default", { key: 1 }, void 0, !0),
          t.skeleton || t.noDataAvailable ? (v(), te(M(He), {
            key: 2,
            height: "0rem"
          })) : (v(), te(M(He), {
            key: 3,
            height: "1.46875rem"
          }))
        ])) : V("", !0),
        M(o) > 607 ? (v(), A("div", FOe, [
          t.skeleton || t.noDataAvailable ? (v(), A("div", VOe, [...u[4] || (u[4] = [
            vt('<svg viewBox="0 0 1248 342" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-33462005><mask id="mask0_1567_1376" style="mask-type:alpha;" maskUnits="userSpaceOnUse" x="0" y="0" width="1248" height="342" data-v-33462005><rect width="1248" height="342" fill="white" data-v-33462005></rect></mask><g mask="url(#mask0_1567_1376)" data-v-33462005><path d="M1248.91 343L1249 342.095L1248 342C1249 342.095 1249 342.094 1249 342.091L1249 342.082L1249 342.045L1249.01 341.896L1249.07 341.309C1249.12 340.791 1249.19 340.023 1249.28 339.021C1249.47 337.018 1249.73 334.08 1250.06 330.341C1250.72 322.863 1251.64 312.182 1252.65 299.364C1254.68 273.728 1257.12 239.545 1258.75 205.358C1260.37 171.179 1261.19 136.967 1259.97 111.289C1259.36 98.4588 1258.24 87.7046 1256.44 80.1363C1255.54 76.3602 1254.46 73.3021 1253.14 71.1652C1251.82 69.0385 1250.13 67.6208 1248 67.6208C1241.86 67.6208 1238.08 65.0236 1235.42 61.0887C1232.7 57.0685 1231.16 51.6605 1229.66 46.0516C1229.57 45.7377 1229.49 45.4232 1229.41 45.1083C1228.01 39.8812 1226.58 34.5437 1224.14 30.4591C1222.84 28.2723 1221.21 26.3967 1219.11 25.0709C1216.99 23.7402 1214.45 23 1211.36 23C1204.9 23 1200.39 28.0543 1196.88 34.942C1193.37 41.861 1190.66 51.0473 1187.99 60.1119L1187.97 60.1818C1185.27 69.3268 1182.61 78.3434 1179.18 85.0808C1175.73 91.8674 1171.72 95.9292 1166.49 95.9292C1161.06 95.9292 1157.18 93.2155 1153.97 88.9479C1150.84 84.7868 1148.44 79.2621 1145.95 73.5416L1145.68 72.9131C1143.12 67.0339 1140.44 60.9999 1136.78 56.4487C1133.08 51.8508 1128.32 48.6953 1121.63 48.6953C1115.22 48.6953 1110.76 49.6347 1107.27 51.0818C1103.86 52.4941 1101.43 54.3707 1099.09 56.1762L1098.94 56.2965C1096.54 58.143 1094.21 59.9128 1090.89 61.2424C1087.58 62.5708 1083.21 63.481 1076.76 63.481C1070.47 63.481 1066.03 61.4164 1062.53 58.3289C1058.98 55.2055 1056.36 51.0161 1053.79 46.6846C1053.59 46.3461 1053.39 46.0065 1053.18 45.6665C1050.84 41.7099 1048.46 37.692 1045.4 34.6082C1042.03 31.2084 1037.81 28.9106 1031.9 28.9106C1025.64 28.9106 1021.31 34.1471 1017.94 41.1954C1014.68 48.0216 1012.11 57.0022 1009.54 65.9595L1009.21 67.1262C1006.51 76.5232 1003.79 85.7954 1000.25 92.7219C996.688 99.6939 992.5 103.893 987.033 103.893C981.126 103.893 976.985 102.541 973.707 100.551C970.399 98.5428 967.919 95.8593 965.336 93.0559L965.297 93.0136C962.751 90.2502 960.099 87.3724 956.532 85.2067C952.917 83.0121 948.412 81.5742 942.168 81.5742C935.848 81.5742 931.3 83.5875 927.68 86.6196C924.123 89.5991 921.485 93.5493 918.943 97.3566L918.903 97.4173C916.317 101.291 913.823 105.013 910.505 107.792C907.232 110.535 903.134 112.371 897.303 112.371C890.874 112.371 886.236 115.233 882.573 119.421C878.951 123.564 876.237 129.057 873.622 134.397L873.499 134.648C870.898 139.959 868.38 145.099 865.125 148.949C861.858 152.814 857.91 155.303 852.438 155.303C841.373 155.303 836.27 147.441 830.847 138.966L830.755 138.822C825.456 130.54 819.804 121.706 807.573 121.706C801.116 121.706 796.659 126.719 793.228 133.549C789.85 140.275 787.264 149.163 784.701 157.974L784.53 158.561C781.893 167.621 779.262 176.551 775.796 183.221C772.315 189.923 768.188 193.974 762.707 193.974C756.946 193.974 752.995 191.745 749.858 188.363C746.775 185.039 744.492 180.623 742.108 176.01L741.864 175.537C739.422 170.815 736.845 165.93 733.185 162.245C729.478 158.512 724.671 156.019 717.842 156.019C711.464 156.019 707.035 154.575 703.602 152.455C700.145 150.32 697.635 147.463 695.122 144.49C694.973 144.315 694.825 144.139 694.676 143.962C692.331 141.183 689.918 138.322 686.73 136.141C683.298 133.793 679.009 132.253 672.977 132.253C660.847 132.253 655.415 141.025 650.283 149.311L650.045 149.695C644.752 158.237 639.644 166.191 628.112 166.191C625.476 166.191 623.135 164.821 620.98 162.169C618.813 159.504 616.917 155.635 615.208 150.885C611.791 141.389 609.235 128.697 606.66 115.898L606.648 115.838C604.086 103.109 601.504 90.2783 598.033 80.6288C596.295 75.798 594.307 71.6832 591.931 68.7603C589.544 65.8233 586.686 64 583.247 64C579.789 64 576.914 65.9217 574.513 68.9894C572.118 72.0478 570.1 76.3552 568.326 81.4182C564.778 91.5495 562.107 105.027 559.482 118.404L559.337 119.145C556.753 132.317 554.2 145.335 550.885 155.123C549.196 160.112 547.334 164.181 545.223 166.985C543.115 169.784 540.865 171.193 538.382 171.193C532.852 171.193 529.015 169.055 525.918 165.802C522.939 162.673 520.666 158.54 518.282 154.204C518.147 153.959 518.012 153.713 517.877 153.467C515.374 148.923 512.707 144.225 508.97 140.682C505.189 137.097 500.331 134.707 493.517 134.707C486.728 134.707 481.991 136.876 478.345 140.159C474.747 143.4 472.249 147.7 469.867 151.833L469.775 151.993C467.395 156.124 465.119 160.073 461.946 163.03C458.784 165.978 454.703 167.957 448.651 167.957C442.741 167.957 438.69 165.147 435.481 160.779C432.275 156.416 429.975 150.588 427.601 144.572L427.5 144.314C425.117 138.276 422.645 132.068 419.085 127.386C415.481 122.647 410.711 119.405 403.786 119.405C396.752 119.405 391.993 121.39 388.424 124.436C384.91 127.434 382.617 131.411 380.426 135.21L380.41 135.239C378.183 139.1 376.059 142.777 372.866 145.522C369.722 148.226 365.476 150.072 358.921 150.072C352.933 150.072 348.856 147.714 345.658 144.136C342.438 140.532 340.123 135.712 337.719 130.708L337.655 130.575C335.26 125.588 332.768 120.429 329.199 116.538C325.581 112.592 320.852 109.944 314.056 109.944C306.045 109.944 300.659 113.567 296.764 118.919C292.916 124.206 290.5 131.209 288.326 138.044C288.076 138.83 287.829 139.613 287.584 140.392C285.672 146.46 283.852 152.239 281.29 156.688C278.434 161.65 274.778 164.75 269.191 164.75C263.333 164.75 259.582 163.101 256.751 160.686C254.145 158.462 252.279 155.568 250.273 152.456C250.055 152.118 249.835 151.777 249.612 151.433C247.373 147.983 244.881 144.392 241.01 141.689C237.114 138.969 231.91 137.205 224.326 137.205C215.744 137.205 210.073 139.98 205.987 144.208C201.954 148.382 199.53 153.914 197.292 159.252C197.166 159.554 197.04 159.855 196.914 160.156C194.789 165.239 192.77 170.068 189.658 173.726C186.428 177.523 181.998 180.072 174.89 180.072C169.6 180.072 166.121 178.031 163.433 174.943C160.84 171.962 158.992 168.023 157.042 163.864C156.928 163.621 156.814 163.377 156.699 163.133C154.65 158.774 152.442 154.241 149.099 150.819C145.705 147.345 141.178 145.045 134.595 145.045C127.733 145.045 122.973 149.741 119.35 156.281C115.724 162.827 113.067 171.515 110.504 180.066C110.41 180.38 110.316 180.693 110.223 181.007C107.741 189.293 105.319 197.381 102.162 203.48C98.8715 209.837 94.9789 213.661 89.7302 213.661C84.1287 213.661 80.265 211.932 77.1835 209.356C74.2191 206.877 71.96 203.606 69.5747 200.153C69.4407 199.959 69.3063 199.764 69.1714 199.569C66.6656 195.947 63.9848 192.187 60.2328 189.355C56.4448 186.495 51.6162 184.614 44.8651 184.614C38.0357 184.614 33.3587 187.087 29.8166 190.802C26.3686 194.419 24.0131 199.201 21.7381 203.82L21.6586 203.982C19.3275 208.715 17.0655 213.267 13.7899 216.661C10.5673 220 6.34307 222.233 -4.1008e-05 222.233C-3.7804 222.233 -6.55169 224.389 -8.48177 227.849C-10.3897 231.27 -11.5472 236.065 -12.1736 241.68C-13.4286 252.929 -12.5894 267.866 -10.9314 282.727C-9.27146 297.606 -6.7825 312.478 -4.70976 323.625C-3.67316 329.2 -2.74017 333.846 -2.06616 337.1C-1.72915 338.726 -1.45685 340.005 -1.2687 340.877C-1.17462 341.313 -1.10158 341.648 -1.05199 341.874L-0.995513 342.13L-0.981037 342.195L-0.97734 342.212L-0.976389 342.216C-0.976165 342.217 -0.976041 342.218 -4.1008e-05 342L-0.976041 342.218L-0.801505 343H-4.1008e-05H1248H1248.91Z" fill="url(#paint0_linear_1567_1376)" stroke="#ececef" stroke-width="2" data-v-33462005></path></g><defs data-v-33462005><linearGradient id="paint0_linear_1567_1376" x1="628.112" y1="44" x2="628.112" y2="333" gradientUnits="userSpaceOnUse" data-v-33462005><stop stop-color="#F8F8FB" data-v-33462005></stop><stop offset="1" stop-color="white" data-v-33462005></stop></linearGradient></defs></svg>', 1)
          ])])) : ue(c.$slots, "default", { key: 1 }, void 0, !0),
          t.skeleton || t.noDataAvailable ? (v(), te(M(He), {
            key: 2,
            height: "0rem"
          })) : (v(), te(M(He), {
            key: 3,
            height: "1.46875rem"
          }))
        ])) : V("", !0)
      ], 512)
    ]));
  }
});
const xPe = /* @__PURE__ */ Y(HOe, [["__scopeId", "data-v-33462005"]]), WOe = Math.pow(10, 9);
function YOe(t) {
  const { animationMultiplier: e, finishedChartAnimation: n } = Hi(), r = W(), o = W(), { width: i } = go(o), a = x(() => {
    var ne;
    return Math.max(0, i.value - (((ne = r.value) == null ? void 0 : ne.clientWidth) ?? 0));
  }), { splinedItems: s } = r1({
    items: t.predictionItems,
    showZero: !1
  }), l = x(() => t.performanceMode === Ec.CPA), c = x(() => t.chartHeight ?? 300), u = x(() => s.value.map((ne) => ne.x)), d = x(() => s.value.map((ne) => ne.y)), {
    min: f,
    max: h,
    formattedAxis: _
  } = Mi({
    minItem: x(() => 0),
    maxItem: x(() => Math.max(...d.value, t.target)),
    axis: yt.Vertical,
    metric: l.value ? {
      dataType: "money",
      currency: t.currencyCode
    } : {
      dataType: "roas"
    }
  }), E = x(() => Math.min(...u.value)), m = x(() => Math.max(...u.value)), N = x(() => [0, 1, 2, 3, 4, 5, 6, 7].map((ne, Ee) => {
    const fe = (m.value - E.value) * Ee / 7 + E.value;
    return sn({ value: fe, currency: t.currencyCode }).displayValue.value;
  })), I = x(() => Math.abs(h.value - f.value)), O = x(() => t.simulationPoints.map((ne) => {
    const Ee = (ne.cpc_bid - E.value) * a.value / (m.value - E.value), fe = l.value ? ne.cpa : ne.roas, Oe = c.value - fe * c.value / h.value;
    let ce = "red";
    ne.is_best_bid && (ce = "green"), (ne.is_current_bid || ne.analysis === r0.BidAnalysis.ABOVE_CAP) && (ce = "amber");
    const Se = t.simulationPoints.map((we) => {
      if ((ne == null ? void 0 : ne.cpc_bid) === (we == null ? void 0 : we.cpc_bid) || ne.cpa === we.cpa || ne.roas === we.roas)
        return {
          x: we.cpc_bid,
          y: l.value ? we.cpa : we.roas,
          distance: WOe
        };
      const le = Math.abs((ne.cpc_bid ?? 0) - (we.cpc_bid ?? 0)), De = l.value ? Math.abs(ne.cpa - we.cpa) : Math.abs(ne.roas - we.roas), pe = le * a.value / m.value, Le = De * c.value / h.value, ze = Math.sqrt(Math.pow(pe, 2) + Math.pow(Le, 2));
      return { ...we, distance: ze };
    }), se = e2(Se, "distance"), Ie = Math.max(Math.min(60, ((se == null ? void 0 : se.distance) ?? 0) / 2), 4);
    return {
      ...ne,
      cx: Ee,
      cy: Oe,
      analysisColor: ce,
      hoverRadius: Ie
    };
  })), { svgPoints: p, svgGradientPoints: C } = o1({
    splinedItems: s.value,
    svgWidth: a,
    svgHeight: c,
    minItemY: f,
    rangeOfPoints: I.value,
    minItemX: E,
    maxItemX: m
  }), { tooltipCircle: D, tooltipContent: T, hoveredIndex: k, showTooltip: G, hideTooltip: b, showTooltipMarker: P } = Do({
    items: t.simulationPoints,
    appendTo: o,
    animationMultiplier: e,
    enableMoveTransition: !0
  });
  function $(ne) {
    if (!t.removeInteractivity) {
      if (k.value === -1) {
        k.value = ne, G();
        return;
      }
      k.value = ne;
    }
  }
  const y = x(() => O.value[k.value]), L = x(() => {
    var ne;
    return (ne = y.value) == null ? void 0 : ne.cx;
  }), w = x(() => {
    var ne;
    return (ne = y.value) == null ? void 0 : ne.cy;
  }), R = x(() => l.value ? "CPA" : "ROAS"), { formattedMarkers: B } = n1({
    markers: x(() => [
      {
        label: t.isAutoTargeting ? `Average ${R.value}` : `Target ${R.value}`,
        value: t.target
      }
    ]),
    svgHeight: c,
    minItemY: f,
    maxItemY: h,
    appendTo: o
  }), U = x(() => [
    {
      label: "Bid",
      value: sn({ value: y.value.cpc_bid, currency: t.currencyCode }).displayValue.value
    },
    l.value ? {
      label: "Pred. CPA",
      value: sn({ value: y.value.cpa, currency: t.currencyCode }).displayValue.value
    } : {
      label: "Pred. ROAS",
      value: vc({ value: y.value.roas }).displayValue.value
    },
    {
      label: t.isAutoTargeting ? `Average ${R.value}` : `Target ${R.value}`,
      value: yn({
        value: t.target,
        metric: l.value ? {
          dataType: "money",
          currency: t.currencyCode
        } : {
          dataType: "roas"
        }
      }).displayValue.value
    },
    l.value ? {
      label: "Pred. Conv.",
      value: Gs({ value: y.value.conversions }).displayValue.value
    } : {
      label: "Pred. Value",
      value: sn({ value: y.value.conversions_value, currency: t.currencyCode }).displayValue.value
    },
    {
      label: "Analysis",
      value: y.value.analysis,
      textColor: y.value.analysisColor
    }
  ]), K = x(() => `animation-clip-path-${Br(6)}`), Z = x(() => `url(#${K.value})`);
  function X() {
    k.value = t.simulationPoints.findIndex((ne) => ne.is_best_bid) ?? -1;
  }
  const J = W(), ae = () => {
    J.value = setTimeout(() => {
      X();
    }, 1e3);
  };
  function re() {
    clearTimeout(J.value);
  }
  const j = x(() => ({ y: l.value ? "Simulated CPA" : "Simulated ROAS", x: "CPC Bid" }));
  return {
    hoverGraph: $,
    hoveredItem: y,
    tooltipCx: L,
    tooltipCy: w,
    svgPoints: p,
    svgGradientPoints: C,
    formattedAxisLabels: N,
    tooltipCircle: D,
    tooltipContent: T,
    yAxisLabels: _,
    showTooltipMarker: P,
    svgHeight: c,
    svgWidth: a,
    animationMultiplier: e,
    yAxisContainer: r,
    toolTipMetrics: U,
    formattedMarkers: B,
    chartContainer: o,
    finishedChartAnimation: n,
    clipPathId: K,
    clipPathUrl: Z,
    points: O,
    handleMouseLeave: ae,
    handleMouseEnter: re,
    axisTitles: j
  };
}
const KOe = { class: "chart-flex-wrapper" }, zOe = ["width", "height"], ZOe = ["x1", "x2", "y2"], qOe = ["id"], XOe = ["x"], jOe = ["clip-path", "stroke-opacity", "d"], JOe = ["d", "fill-opacity"], QOe = { key: 0 }, eAe = ["clip-path", "x2", "y1", "y2"], tAe = ["x", "y"], nAe = ["y"], rAe = ["cx", "cy", "opacity"], oAe = ["onMouseenter", "cx", "cy", "r"], iAe = ["cx", "cy"], aAe = /* @__PURE__ */ Ne({
  __name: "BidFactoryChart",
  props: {
    simulationPoints: {},
    predictionItems: {},
    target: {},
    performanceMode: {},
    currencyCode: {},
    isAutoTargeting: { type: Boolean },
    chartHeight: {},
    removeInteractivity: { type: Boolean },
    disableFallback: { type: Boolean },
    removePlaceholderContainer: { type: Boolean }
  },
  setup(t) {
    const e = t, {
      hoverGraph: n,
      hoveredItem: r,
      tooltipCx: o,
      tooltipCy: i,
      svgPoints: a,
      svgGradientPoints: s,
      formattedAxisLabels: l,
      tooltipCircle: c,
      tooltipContent: u,
      yAxisLabels: d,
      showTooltipMarker: f,
      svgHeight: h,
      svgWidth: _,
      animationMultiplier: E,
      yAxisContainer: m,
      toolTipMetrics: N,
      formattedMarkers: I,
      chartContainer: O,
      finishedChartAnimation: p,
      clipPathId: C,
      clipPathUrl: D,
      points: T,
      handleMouseLeave: k,
      handleMouseEnter: G,
      axisTitles: b
    } = YOe(e);
    return (P, $) => {
      var y, L, w;
      return v(), A(ge, null, [
        g("div", {
          ref_key: "chartContainer",
          ref: O,
          class: z(["w-100", { "desktop-chart": !t.disableFallback }])
        }, [
          ue(P.$slots, "header", {
            class: "w-100",
            hoveredItem: M(r)
          }, void 0, !0),
          P.$slots.header ? (v(), te(He, { key: 0 })) : V("", !0),
          g("div", KOe, [
            g("div", {
              ref_key: "yAxisContainer",
              ref: m
            }, [
              H(Za, {
                "chart-height": M(h),
                "axis-title": (y = M(b)) == null ? void 0 : y.y,
                "axis-labels": M(d)
              }, null, 8, ["chart-height", "axis-title", "axis-labels"])
            ], 512),
            g("div", null, [
              (v(), A("svg", {
                width: M(_),
                height: M(h),
                overflow: "visible",
                onMouseleave: $[0] || ($[0] = //@ts-ignore
                (...R) => M(k) && M(k)(...R)),
                onMouseenter: $[1] || ($[1] = //@ts-ignore
                (...R) => M(G) && M(G)(...R))
              }, [
                g("defs", null, [
                  g("linearGradient", {
                    id: "stop-opteo-blue",
                    x1: M(_),
                    y1: "0",
                    x2: M(_),
                    y2: M(h),
                    gradientUnits: "userSpaceOnUse"
                  }, [...$[2] || ($[2] = [
                    g("stop", {
                      class: "stop-opteo-blue",
                      "stop-opacity": "0.2"
                    }, null, -1),
                    g("stop", {
                      offset: "1",
                      class: "stop-opteo-blue",
                      "stop-opacity": "0"
                    }, null, -1)
                  ])], 8, ZOe),
                  g("clipPath", { id: M(C) }, [
                    g("rect", {
                      class: "stroke-animation-mask",
                      x: `-${(1 - M(E)) * 100}%`,
                      y: "-2px",
                      width: "100%",
                      height: "200%"
                    }, null, 8, XOe)
                  ], 8, qOe)
                ]),
                g("path", {
                  "clip-path": M(D),
                  stroke: "currentColor",
                  "stroke-opacity": M(E),
                  class: z([{ "d-transition": M(p) }, "opteo-blue"]),
                  fill: "none",
                  "stroke-width": "2",
                  d: M(a)
                }, null, 10, jOe),
                g("path", {
                  class: z([
                    {
                      "d-transition": M(p),
                      "fill-opacity-transition": !M(p)
                    }
                  ]),
                  fill: "url(#stop-opteo-blue)",
                  d: M(s),
                  "fill-opacity": M(E),
                  x: "10",
                  stroke: "none"
                }, null, 10, JOe),
                M(I) ? (v(), A("g", QOe, [
                  (v(!0), A(ge, null, ye(M(I), (R) => (v(), A("g", {
                    key: R.label
                  }, [
                    g("line", {
                      "clip-path": M(D),
                      class: "all-transition",
                      x1: 0,
                      x2: M(_),
                      y1: R.y,
                      y2: R.y,
                      style: { stroke: "rgb(218, 218, 218)" },
                      "stroke-dasharray": "5,3"
                    }, null, 8, eAe),
                    R.labelPosition === "end" ? (v(), A("text", {
                      key: 0,
                      class: "marker-text height-transition",
                      x: M(_),
                      y: R.y,
                      dx: "-3px",
                      dy: "-5px",
                      "text-anchor": "end"
                    }, Q(R.label), 9, tAe)) : (v(), A("text", {
                      key: 1,
                      class: "marker-text",
                      x: 0,
                      y: R.y,
                      dy: "-5px",
                      "text-anchor": "start"
                    }, Q(R.label), 9, nAe))
                  ]))), 128))
                ])) : V("", !0),
                (v(!0), A(ge, null, ye(M(T), (R, B) => (v(), A("g", {
                  key: R.cpc_bid
                }, [
                  g("circle", {
                    class: z({ "opteo-blue": R.is_best_bid }),
                    cx: R.cx,
                    cy: R.cy,
                    r: "4",
                    fill: "currentColor",
                    opacity: 0.4 * M(E)
                  }, null, 10, rAe),
                  g("circle", {
                    onMouseenter: (U) => M(n)(B),
                    cx: R.cx,
                    cy: R.cy,
                    r: R.hoverRadius,
                    fill: "red",
                    "fill-opacity": "0"
                  }, null, 40, oAe)
                ]))), 128)),
                Ze(g("circle", {
                  ref_key: "tooltipCircle",
                  ref: c,
                  class: z({ "opteo-blue": (L = M(r)) == null ? void 0 : L.is_best_bid }),
                  cx: M(o),
                  cy: M(i),
                  r: "4",
                  fill: "currentColor"
                }, null, 10, iAe), [
                  [bi, M(f)]
                ])
              ], 40, zOe)),
              H(qa, {
                "chart-width": M(_),
                "axis-labels": M(l),
                "axis-title": (w = M(b)) == null ? void 0 : w.x
              }, null, 8, ["chart-width", "axis-labels", "axis-title"])
            ])
          ])
        ], 2),
        t.disableFallback ? V("", !0) : (v(), te(Xa, {
          key: 0,
          type: "bid",
          "remove-container": t.removePlaceholderContainer,
          class: "mobile-chart"
        }, null, 8, ["remove-container"])),
        t.removeInteractivity ? V("", !0) : (v(), A("div", {
          key: 1,
          ref_key: "tooltipContent",
          ref: u
        }, [
          P.$slots.tooltip ? ue(P.$slots, "tooltip", {
            key: 0,
            hoveredItem: M(r)
          }, void 0, !0) : M(f) ? (v(), te(Co, {
            key: 1,
            metrics: M(N)
          }, null, 8, ["metrics"])) : V("", !0)
        ], 512))
      ], 64);
    };
  }
});
const UPe = /* @__PURE__ */ Y(aAe, [["__scopeId", "data-v-ab710aec"]]), sAe = (t) => t instanceof Date ? t : new Date(new Date(t).valueOf() + (/* @__PURE__ */ new Date()).getTimezoneOffset() * 60 * 1e3), Sg = (t, e) => {
  const n = new Date(t);
  return n.setDate(n.getDate() + e), n;
}, wg = (t) => {
  const e = sAe(t);
  return String(e.getFullYear()) + String(e.getMonth()).padStart(2, "0") + String(e.getDate()).padStart(2, "0");
};
function lAe(t) {
  const r = {
    // Currently hardcoded, could be made customisable with a prop if need be
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
  }, o = /* @__PURE__ */ new Date(), i = Sg(o, -500), a = W(), s = W(null), l = go(s).width, c = x(() => {
    const X = Math.floor((l.value - 40) / 20) * 7, J = t.items.slice(-X);
    return Math.ceil(Math.max(...J.map((ae) => ae.total)));
  }), u = (X) => X[0].date.getDate() < 8, d = W(""), f = W(void 0), {
    tooltipCircle: h,
    tooltipContent: _,
    hoverItem: E,
    hideTooltip: m,
    hoveredIndex: N,
    showTooltipMarker: I,
    showTooltip: O,
    setProps: p,
    mount: C
  } = Do({
    appendTo: a
    //removeInteractivity: props.removeInteractivity,
  }), D = W(), T = W({ x: 0, y: 0 }), k = x(() => {
    let X = /* @__PURE__ */ new Map();
    for (let J = 0, ae = t.items.length; J < ae; J++)
      X.set(wg(t.items[J].date), {
        total: t.items[J].total,
        activities: t.items[J].activities ? t.items[J].activities : [],
        colorIndex: K(t.items[J].total)
      });
    return X;
  }), G = x(() => {
    let X = Sg(i, -L());
    X = new Date(X.getFullYear(), X.getMonth(), X.getDate());
    let J = new Array(B());
    for (let ae = 0, re = J.length; ae < re; ae++) {
      J[ae] = new Array(7);
      for (let j = 0; j < 7; j++) {
        const ne = k.value.get(wg(X));
        J[ae][j] = {
          date: new Date(X.valueOf()),
          activities: ne ? ne.activities : [],
          count: ne ? ne.count : void 0,
          colorIndex: ne ? ne.colorIndex : 0
        }, X.setDate(X.getDate() + 1);
      }
    }
    return J;
  }), b = x(() => {
    const X = Math.floor((l.value - 40) / 20);
    return G.value.slice(-X);
  }), P = (X) => lu(X, "MMMM do y");
  function $(X, J) {
    const { weekIndex: ae, dayIndex: re } = X;
    d.value = P(y({ weekIndex: ae, dayIndex: re }).date), f.value = y({ weekIndex: ae, dayIndex: re }).activities, D.value = ae, E(re), J.target && J.target instanceof HTMLDivElement && (h.value = J.target, p({
      triggerTarget: J.target,
      getReferenceClientRect: () => ({
        width: 100,
        height: 100,
        left: 100,
        right: 200,
        top: 100,
        bottom: 200
      })
    })), C(), O();
  }
  const y = ({ weekIndex: X, dayIndex: J }) => b.value[X][J], L = () => i.getDay(), w = () => 7 - 1 - o.getDay(), R = () => 500 + 1 + L() + w(), B = () => R() / 7, U = W([
    "#cacad333",
    "#0035EC33",
    "#0035EC4D",
    "#0035ec66",
    "#0035EC80",
    "#0035ec99",
    "#0035ECB3",
    "#0035eccc",
    "#0035ECE6",
    "#0035ecff"
  ]), K = (X) => X == null ? 0 : X <= 0 ? 1 : X >= c.value ? U.value.length - 2 : Math.ceil(X * 100 / c.value * 0.08) + 1;
  return {
    // Refs & computed
    getWeekCount: B,
    calendar: G,
    reactiveCalendar: b,
    heatmapContainer: s,
    colorRange: U,
    // util functions
    isFirstFullWeekOfMonth: u,
    getMonthLabel: (X) => r.months[X[0].date.getMonth()],
    showTooltipMarker: I,
    heatmapWrapper: a,
    tooltipContent: _,
    showTooltip: O,
    handleMouseEnter: $,
    hideTooltip: m,
    tooltipAnchorPos: T,
    hoveredWeek: D,
    hoveredIndex: N,
    tooltipDate: d,
    tooltipActivities: f
  };
}
const cAe = { class: "heatmap-wrapper" }, uAe = {
  key: 0,
  class: "heatmap-month-label"
}, dAe = {
  key: 1,
  class: "heatmap-empty-label"
}, fAe = ["data-week-index", "data-day-index", "onMouseenter"], hAe = {
  key: 0,
  class: "heatmap-legend-container"
}, _Ae = { class: "heatmap-legend-left" }, EAe = {
  key: 0,
  class: "heatmap-disclaimer-text"
}, pAe = {
  key: 0,
  class: "heatmap-legend"
}, mAe = { class: "heatmap-legend-wrapper" }, NAe = /* @__PURE__ */ Ne({
  __name: "HeatmapChart",
  props: {
    items: {
      type: Object,
      required: !1,
      // For now, make required once it works with default mock data
      default: [
        { total: 1, date: /* @__PURE__ */ new Date(), activities: [{ label: "Improvements", value: 1 }] },
        {
          total: 2,
          date: new Date(2023, 3, 12),
          activities: [
            { label: "Improvements", value: 1 },
            { label: "Reports", value: 2 }
          ]
        },
        {
          total: 5,
          date: new Date(2023, 6, 12),
          activities: [
            { label: "Improvements", value: 1 },
            { label: "Reports", value: 2 },
            { label: "RSAs", value: 2 }
          ]
        }
      ]
    },
    vertical: {
      // CURRENTLY UNUSED
      type: Boolean,
      required: !1,
      default: !1
    },
    disclaimerText: {
      type: String,
      required: !1
    },
    legend: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  setup(t) {
    const e = t, {
      showTooltipMarker: n,
      isFirstFullWeekOfMonth: r,
      reactiveCalendar: o,
      getMonthLabel: i,
      heatmapWrapper: a,
      tooltipContent: s,
      handleMouseEnter: l,
      hideTooltip: c,
      hoveredWeek: u,
      hoveredIndex: d,
      heatmapContainer: f,
      tooltipDate: h,
      tooltipActivities: _,
      colorRange: E
    } = lAe(e), m = W(/* @__PURE__ */ new Date()), N = x(() => {
      const I = "No activity";
      if (!_)
        return I;
      if (Array.isArray(_.value))
        return _.value.length < 1 ? I : "";
    });
    return (I, O) => (v(), A(ge, null, [
      g("div", {
        class: "heatmap-container",
        ref_key: "heatmapContainer",
        ref: f
      }, [
        g("div", cAe, [
          g("div", {
            class: "heatmap-year-wrapper",
            ref_key: "heatmapWrapper",
            ref: a
          }, [
            O[1] || (O[1] = vt('<div class="heatmap-week-wrapper" data-v-834fe895><div class="heatmap-empty-label" data-v-834fe895></div><div class="heatmap-empty-label" data-v-834fe895></div><div class="heatmap-day-label" data-v-834fe895>Mon</div><div class="heatmap-empty-label" data-v-834fe895></div><div class="heatmap-day-label" data-v-834fe895>Wed</div><div class="heatmap-empty-label" data-v-834fe895></div><div class="heatmap-day-label" data-v-834fe895>Fri</div><div class="heatmap-empty-label" data-v-834fe895></div></div>', 1)),
            (v(!0), A(ge, null, ye(M(o), (p, C) => (v(), A("div", {
              class: "heatmap-week-wrapper",
              key: C
            }, [
              M(r)(p) ? (v(), A("div", uAe, Q(M(i)(p)), 1)) : (v(), A("div", dAe)),
              (v(!0), A(ge, null, ye(p, (D, T) => (v(), A(ge, { key: T }, [
                D.date < m.value ? (v(), A("div", {
                  key: 0,
                  class: "heatmap-day-square",
                  style: Fe({ backgroundColor: M(E)[D.colorIndex] }),
                  "data-week-index": C,
                  "data-day-index": T,
                  onMouseenter: (k) => M(l)({ weekIndex: C, dayIndex: T }, k),
                  onMouseleave: O[0] || (O[0] = (k) => M(c)())
                }, [
                  M(u) === C && M(d) === T && M(n) ? (v(), A("div", {
                    key: 0,
                    ref_for: !0,
                    ref: "tooltipAnchor",
                    class: "tooltip-circle"
                  }, null, 512)) : V("", !0)
                ], 44, fAe)) : V("", !0)
              ], 64))), 128))
            ]))), 128))
          ], 512)
        ]),
        H(M(He), { height: "1rem" }),
        t.disclaimerText || t.legend ? (v(), A("div", hAe, [
          g("div", _Ae, [
            H(M(He), { width: "2.5rem" }),
            t.disclaimerText ? (v(), A("div", EAe, Q(t.disclaimerText), 1)) : V("", !0)
          ]),
          t.legend ? (v(), A("div", pAe, [
            O[2] || (O[2] = g("div", null, "Less", -1)),
            g("div", mAe, [
              (v(!0), A(ge, null, ye(M(E), (p, C) => (v(), A("div", {
                class: "heatmap-day-square",
                key: C,
                style: Fe({ backgroundColor: p })
              }, null, 4))), 128))
            ]),
            O[3] || (O[3] = g("div", null, "More", -1))
          ])) : V("", !0)
        ])) : V("", !0)
      ], 512),
      g("div", {
        ref_key: "tooltipContent",
        ref: s
      }, [
        M(n) ? (v(), te(M(Co), {
          key: 0,
          footer: M(h),
          metrics: M(_),
          plainText: N.value
        }, null, 8, ["footer", "metrics", "plainText"])) : V("", !0)
      ], 512)
    ], 64));
  }
});
const $Pe = /* @__PURE__ */ Y(NAe, [["__scopeId", "data-v-834fe895"]]);
function vAe(t, e, n, r) {
  var o = -1, i = t == null ? 0 : t.length;
  for (r && i && (n = t[++o]); ++o < i; )
    n = e(n, t[o], o, t);
  return n;
}
function gAe(t) {
  return function(e) {
    return t == null ? void 0 : t[e];
  };
}
var IAe = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, OAe = gAe(IAe);
const AAe = OAe;
var DAe = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, CAe = "\\u0300-\\u036f", SAe = "\\ufe20-\\ufe2f", wAe = "\\u20d0-\\u20ff", TAe = CAe + SAe + wAe, bAe = "[" + TAe + "]", RAe = RegExp(bAe, "g");
function MAe(t) {
  return t = cu(t), t && t.replace(DAe, AAe).replace(RAe, "");
}
var PAe = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function yAe(t) {
  return t.match(PAe) || [];
}
var LAe = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function xAe(t) {
  return LAe.test(t);
}
var T7 = "\\ud800-\\udfff", UAe = "\\u0300-\\u036f", $Ae = "\\ufe20-\\ufe2f", kAe = "\\u20d0-\\u20ff", BAe = UAe + $Ae + kAe, b7 = "\\u2700-\\u27bf", R7 = "a-z\\xdf-\\xf6\\xf8-\\xff", GAe = "\\xac\\xb1\\xd7\\xf7", FAe = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", VAe = "\\u2000-\\u206f", HAe = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", M7 = "A-Z\\xc0-\\xd6\\xd8-\\xde", WAe = "\\ufe0e\\ufe0f", P7 = GAe + FAe + VAe + HAe, y7 = "['’]", Tg = "[" + P7 + "]", YAe = "[" + BAe + "]", L7 = "\\d+", KAe = "[" + b7 + "]", x7 = "[" + R7 + "]", U7 = "[^" + T7 + P7 + L7 + b7 + R7 + M7 + "]", zAe = "\\ud83c[\\udffb-\\udfff]", ZAe = "(?:" + YAe + "|" + zAe + ")", qAe = "[^" + T7 + "]", $7 = "(?:\\ud83c[\\udde6-\\uddff]){2}", k7 = "[\\ud800-\\udbff][\\udc00-\\udfff]", _s = "[" + M7 + "]", XAe = "\\u200d", bg = "(?:" + x7 + "|" + U7 + ")", jAe = "(?:" + _s + "|" + U7 + ")", Rg = "(?:" + y7 + "(?:d|ll|m|re|s|t|ve))?", Mg = "(?:" + y7 + "(?:D|LL|M|RE|S|T|VE))?", B7 = ZAe + "?", G7 = "[" + WAe + "]?", JAe = "(?:" + XAe + "(?:" + [qAe, $7, k7].join("|") + ")" + G7 + B7 + ")*", QAe = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", e4e = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", t4e = G7 + B7 + JAe, n4e = "(?:" + [KAe, $7, k7].join("|") + ")" + t4e, r4e = RegExp([
  _s + "?" + x7 + "+" + Rg + "(?=" + [Tg, _s, "$"].join("|") + ")",
  jAe + "+" + Mg + "(?=" + [Tg, _s + bg, "$"].join("|") + ")",
  _s + "?" + bg + "+" + Rg,
  _s + "+" + Mg,
  e4e,
  QAe,
  L7,
  n4e
].join("|"), "g");
function o4e(t) {
  return t.match(r4e) || [];
}
function i4e(t, e, n) {
  return t = cu(t), e = n ? void 0 : e, e === void 0 ? xAe(t) ? o4e(t) : yAe(t) : t.match(e) || [];
}
var a4e = "['’]", s4e = RegExp(a4e, "g");
function l4e(t) {
  return function(e) {
    return vAe(i4e(MAe(e).replace(s4e, "")), t, "");
  };
}
var c4e = l4e(function(t, e, n) {
  return t + (n ? " " : "") + e.toUpperCase();
});
const u4e = c4e, d4e = ["viewbox"], f4e = ["cx"], h4e = ["data-index", "data-ngram", "data-score", "onFocus", "onClick"], _4e = ["cx", "cy", "r"], Rl = 42, E4e = 8, p4e = 0, m4e = /* @__PURE__ */ Ne({
  __name: "MiniSpreadChart",
  props: {
    items: {},
    currencyCode: {},
    performanceMetricType: {},
    loading: { type: Boolean, default: !1 },
    hidden: { type: Boolean, default: !1 },
    divisionsLength: {}
  },
  emits: ["select-item"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = W(), { width: i } = go(o), a = x(() => Math.max(0, i.value)), s = x(() => 4), l = x(() => a.value - s.value * 2), c = x(() => n.divisionsLength + 1), u = x(() => l.value / c.value), d = Rl, f = x(() => n.performanceMetricType === "cpa" || n.performanceMetricType === "roas" ? Math.min(...n.items.map((R) => R.cost)) : Math.min(...n.items.map((R) => R.impressions))), h = x(() => n.performanceMetricType === "cpa" || n.performanceMetricType === "roas" ? Math.max(...n.items.map((R) => R.cost)) : Math.max(...n.items.map((R) => R.impressions)));
    function _(R, B, U, K, Z) {
      return (R - B) * (Z - K) / (U - B) + K;
    }
    function E(R) {
      return R === null ? "#e6e6e6" : R >= 0.7 ? "#FF2828" : R > 0.5 ? "#FF9500" : "#00a861";
    }
    const m = x(
      () => n.items.map((R, B) => {
        const U = n.performanceMetricType === "cpa" || n.performanceMetricType === "roas" ? R.cost : R.impressions, K = _(
          U,
          f.value,
          h.value,
          E4e,
          d
        ), Z = s.value + u.value * (B + 1), X = E(R.nscore);
        return {
          ...R,
          // NaN should only happen when the items.length is 1 in which case the single circle should be full heightnas there are no other relative points
          cx: Z,
          circumference: isNaN(K) ? d : K,
          fillHex: X
        };
      })
    ), { tooltipCircle: N, tooltipContent: I, hoveredIndex: O, showTooltip: p, hideTooltip: C, showTooltipMarker: D } = Do({
      appendTo: o,
      enableMoveTransition: !0,
      options: {
        sticky: "reference"
      }
    }), T = x(() => {
      if (!(O.value < 0))
        return n.items[O == null ? void 0 : O.value];
    }), k = x(() => s.value + u.value * (O.value + 1)), G = x(() => u4e(n.performanceMetricType)), b = x(
      () => T.value ? [
        n.performanceMetricType === "cpa" || n.performanceMetricType === "roas" ? {
          label: "Cost",
          value: sn({ value: T.value.cost, currency: n.currencyCode, compact: !0 }).displayValue.value
        } : {
          label: "Impr.",
          value: Gs({ value: T.value.impressions, compact: !0 }).displayValue.value
        },
        n.performanceMetricType === "roas" ? {
          label: "Conv. Val.",
          value: sn({
            value: T.value.conversionValue,
            currency: n.currencyCode,
            compact: !0
          }).displayValue.value
        } : {
          label: "Conv.",
          value: Gs({ value: T.value.conversions, compact: !0 }).displayValue.value
        },
        n.performanceMetricType === "roas" ? {
          label: G.value,
          value: Yo({ value: T.value.roas }).displayValue.value
        } : n.performanceMetricType === "vpm" ? {
          label: G.value,
          value: sn({ value: T.value.vpm, currency: n.currencyCode, compact: !0 }).displayValue.value
        } : n.performanceMetricType === "cpm" ? {
          label: G.value,
          value: sn({
            value: T.value.cpm,
            currency: n.currencyCode,
            compact: !0
          }).displayValue.value
        } : {
          label: G.value,
          value: sn({
            value: T.value.cpa,
            currency: n.currencyCode,
            compact: !0
          }).displayValue.value
        },
        {
          label: "vs Avg.",
          value: Yo({ value: T.value.vsAvg }).displayValue.value,
          textColor: T.value.vsAverageColor
        }
      ] : []
    ), P = x(() => o.value && o.value.getBoundingClientRect().left), $ = (R) => {
      if (!R || !P.value)
        return;
      const B = R.pageX - P.value, U = Math.round((B - s.value) / u.value) - 1;
      n.items[U] && (O.value = U, p());
    };
    function y(R) {
      !R || n.loading || r("select-item", R);
    }
    function L(R) {
      O.value = R, D.value || p();
    }
    function w(R) {
      uU(R) && D.value && C();
    }
    return (R, B) => (v(), A("div", {
      ref_key: "chartContainer",
      ref: o,
      class: "spread-chart-container",
      onMousemove: $,
      onMouseleave: B[0] || (B[0] = //@ts-ignore
      (...U) => M(C) && M(C)(...U)),
      onFocusout: w
    }, [
      g("div", {
        ref_key: "tooltipContent",
        ref: I
      }, [
        T.value && M(D) && M(O) >= 0 ? (v(), te(M(Co), {
          key: 0,
          title: T.value.ngram,
          metrics: b.value
        }, null, 8, ["title", "metrics"])) : V("", !0)
      ], 512),
      (v(), A("svg", {
        viewbox: `0 0 ${a.value} ${Rl}`,
        height: Rl,
        style: { width: "100%" }
      }, [
        B[1] || (B[1] = g("desc", null, null, -1)),
        g("circle", {
          ref_key: "tooltipCircle",
          ref: N,
          stroke: "none",
          fill: "none",
          r: "5",
          "stroke-width": "2",
          cx: k.value,
          cy: p4e
        }, null, 8, f4e),
        (v(!0), A(ge, null, ye(t.divisionsLength, (U, K) => {
          var Z, X, J;
          return v(), A("a", {
            key: K,
            "data-index": K,
            "data-ngram": (Z = m.value[K]) == null ? void 0 : Z.ngram,
            "data-score": (X = m.value[K]) == null ? void 0 : X.nscore,
            class: z(["ngram-data-point", { active: K === M(O) }, { hidden: t.hidden }]),
            "xlink:href": "#",
            tabindex: "-1",
            onFocus: (ae) => n.loading ? void 0 : () => L(K),
            onClick: (ae) => {
              var re, j;
              return y((j = (re = m.value) == null ? void 0 : re[K]) == null ? void 0 : j.ngram);
            }
          }, [
            g("circle", {
              class: z({ "loading-circle": n.loading }),
              cx: s.value + u.value * (K + 1),
              cy: Rl / 2,
              r: !n.loading && m.value[K] ? m.value[K].circumference / 2 : 3,
              style: Fe({
                fill: n.loading ? "#ECECEF" : (J = m.value[K]) == null ? void 0 : J.fillHex,
                opacity: K === M(O) ? 1 : 0.2,
                transformOrigin: `${s.value + u.value * (K + 1)}px ${Rl / 2}px`
              }),
              "data-tabindex": "0",
              focusable: "false"
            }, null, 14, _4e)
          ], 42, h4e);
        }), 128))
      ], 8, d4e))
    ], 544));
  }
});
const kPe = /* @__PURE__ */ Y(m4e, [["__scopeId", "data-v-00a60dbc"]]), N4e = {
  name: "ImageAd",
  props: {
    img_id: {
      type: [Number, String],
      required: !0
    },
    img_width: {
      type: Number,
      required: !1
    },
    img_height: {
      type: Number,
      required: !1
    },
    img_name: {
      type: String,
      required: !1
    },
    type: {
      type: String,
      required: !1,
      validator(t) {
        return ["current", "new", "win", "lose", "none"].includes(t);
      }
    }
  }
};
const v4e = {
  key: 0,
  class: "mobile-badge"
}, g4e = ["src"];
function I4e(t, e, n, r, o, i) {
  return v(), A("div", {
    class: z([[n.type ? n.type : "shadow"], "ad-container flex items-center justify-center w-100 relative google-image-ad br3 overflow-hidden"]),
    style: { "font-family": "'Helvetica Neue', Helvetica, Arial, sans-serif !important", "font-feature-settings": `'ss01' off,
                'ss02' off,
                'ss04' off,
                'ss05' off,
                'ss08' off` }
  }, [
    n.img_name ? (v(), A("div", v4e, Q(n.img_name) + " (" + Q(n.img_width) + "x" + Q(n.img_height) + ")", 1)) : V("", !0),
    g("img", {
      src: n.img_id.includes("googlesyndication") ? n.img_id : "https://tpc.googlesyndication.com/pageadimg/imgad?id=" + n.img_id,
      class: "podium-image z-1",
      style: Fe({ width: n.img_width, height: n.img_height })
    }, null, 12, g4e)
  ], 2);
}
const O4e = /* @__PURE__ */ Y(N4e, [["render", I4e]]), A4e = {
  props: {
    title: {
      type: String,
      required: !0,
      default: "Default Title"
    },
    classes: {
      type: String,
      required: !1
    }
  }
};
function D4e(t, e, n, r, o, i) {
  return v(), A("div", {
    class: z([n.classes, "flex items-center card-title-tag shadow br-pill"])
  }, Q(n.title), 3);
}
const C4e = /* @__PURE__ */ Y(A4e, [["render", D4e], ["__scopeId", "data-v-c084131c"]]), S4e = {
  name: "TextAd",
  components: { CardTitleTag: C4e, ColorTag: XE, Spacer: He },
  props: {
    ad: {
      type: Object,
      required: !0
    },
    featuredStatistics: {
      type: Array,
      required: !1
    },
    titleTag: {
      type: Object,
      required: !1
    },
    highlight: {
      type: String,
      required: !1
    },
    copyable: {
      type: Boolean,
      default: !1,
      required: !1
    },
    classes: {
      type: String,
      default: "",
      required: !1
    },
    noContainer: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  inject: {
    isPdf: {
      default: !1
    }
  },
  data() {
    return {
      copyHover: !1,
      clickToCopy: "Copy Ad"
    };
  },
  setup(t) {
    return {
      visibleCallouts: x(
        () => t.ad.callouts && t.ad.callouts.filter((n) => n && n.length > 0)
      )
    };
  },
  methods: {
    copyAd() {
      this.$emit(
        "emit-ad",
        this.finalUrl,
        this.headlineOne,
        this.headlineTwo,
        this.headlineThree,
        this.pathOne,
        this.pathTwo,
        this.descriptionOne,
        this.descriptionTwo
      ), this.clickToCopy = "Ad Copied", setTimeout(() => {
        this.clickToCopy = "Copy Ad";
      }, 2e3);
    },
    shouldHighlight(t) {
      var e;
      return !!(t === this.highlight || (e = this.highlight) != null && e.includes(t));
    }
  }
};
const w4e = {
  content: "<span class='f7'>Copy Ad</span>",
  class: "copy-circle br-100 w3 h3 shadow bg-white absolute flex items-center justify-center pointer"
}, T4e = { style: { "margin-bottom": "0.4375rem" } }, b4e = {
  key: 0,
  class: "display-url"
}, R4e = {
  key: 1,
  class: "display-url"
}, M4e = {
  key: 2,
  class: "display-url"
}, P4e = { style: { "margin-bottom": "0.375rem", "min-height": "1.4375rem" } }, y4e = ["innerHTML"], L4e = ["innerHTML"], x4e = ["innerHTML"], U4e = { style: { "min-height": "1.25rem" } }, $4e = ["innerHTML"], k4e = ["innerHTML"], B4e = {
  key: 0,
  class: "snippet-header"
}, G4e = { key: 0 }, F4e = { key: 1 }, V4e = { class: "ad-headline" }, H4e = {
  key: 0,
  class: "description"
}, W4e = {
  key: 3,
  class: "ad-featured-statistics mt3 inline-flex items-center"
};
function Y4e(t, e, n, r, o, i) {
  const a = ee("CardTitleTag"), s = ee("Spacer"), l = ee("ColorTag"), c = ee("perfect-scrollbar"), u = ft("tippy");
  return v(), A("div", {
    class: z(["text-ad", n.classes, { "no-container": n.noContainer }]),
    onMouseover: e[1] || (e[1] = (d) => o.copyHover = !0),
    onMouseleave: e[2] || (e[2] = (d) => o.copyHover = !1)
  }, [
    n.titleTag ? (v(), te(a, {
      key: 0,
      title: n.titleTag.title,
      classes: n.titleTag.classes
    }, null, 8, ["title", "classes"])) : V("", !0),
    n.copyable ? (v(), A("div", {
      key: 1,
      onClick: e[0] || (e[0] = (d) => i.copyAd())
    }, [
      Ze((v(), A("button", w4e, [...e[3] || (e[3] = [
        g("svg", {
          width: "24",
          height: "25",
          viewBox: "0 0 24 25",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          g("g", {
            stroke: "#006dff",
            "stroke-width": "2",
            fill: "none",
            "fill-rule": "evenodd",
            "stroke-linecap": "round"
          }, [
            g("path", { d: "M4 1h10c1.6568542 0 3 1.34314575 3 3v11c0 1.6568542-1.3431458 3-3 3H4c-1.65685425 0-3-1.3431458-3-3V4c0-1.65685425 1.34314575-3 3-3z" }),
            g("path", {
              d: "M19.9090909 7H20c1.6568542 0 3 1.34314575 3 3v11c0 1.6568542-1.3431458 3-3 3H10c-1.65685425 0-3-1.3431458-3-3v-.0909091h0",
              "stroke-linejoin": "round"
            })
          ])
        ], -1)
      ])])), [
        [u, {
          animateFill: "false",
          animation: "shift-away",
          duration: "250",
          placement: "top",
          theme: "circle-icon",
          offset: [0, 8]
        }]
      ])
    ])) : V("", !0),
    H(c, { class: "inner-container" }, {
      default: q(() => [
        g("div", {
          class: z(["ad-width", { "pdf-ad-width": i.isPdf }])
        }, [
          g("div", T4e, [
            e[4] || (e[4] = g("span", { class: "marker" }, " Ad ", -1)),
            e[5] || (e[5] = g("span", {
              class: "display-url",
              style: { "margin-left": "0.125rem", "margin-right": "0.1875rem", "font-weight": "600" }
            }, "·", -1)),
            n.ad.displayUrl ? (v(), A("span", b4e, Q(n.ad.displayUrl), 1)) : V("", !0),
            n.ad.pathOne && n.ad.pathOne !== "--" ? (v(), A("span", R4e, "/" + Q(n.ad.pathOne), 1)) : V("", !0),
            n.ad.pathTwo && n.ad.pathTwo !== "--" ? (v(), A("span", M4e, "/" + Q(n.ad.pathTwo), 1)) : V("", !0)
          ]),
          g("div", P4e, [
            g("span", {
              class: "ad-headline",
              innerHTML: n.ad.headlineOne
            }, null, 8, y4e),
            n.ad.headlineTwo && n.ad.headlineTwo !== "--" ? (v(), A("span", {
              key: 0,
              class: "ad-headline",
              innerHTML: ` | ${n.ad.headlineTwo}`
            }, null, 8, L4e)) : V("", !0),
            n.ad.headlineThree && n.ad.headlineThree !== "--" ? (v(), A("span", {
              key: 1,
              class: "ad-headline",
              innerHTML: ` | ${n.ad.headlineThree}`
            }, null, 8, x4e)) : V("", !0)
          ]),
          g("div", U4e, [
            g("span", {
              class: "description",
              style: { display: "inline-block" },
              innerHTML: n.ad.descriptionOne
            }, null, 8, $4e),
            n.ad.descriptionTwo && n.ad.descriptionTwo !== "--" ? (v(), A("span", {
              key: 0,
              class: "description",
              style: { display: "inline" },
              innerHTML: ` ${n.ad.descriptionTwo}`
            }, null, 8, k4e)) : V("", !0)
          ]),
          n.ad.callouts ? (v(), A("div", {
            key: 0,
            class: z(["callouts", { highlighted: i.shouldHighlight("callouts") }])
          }, [
            (v(!0), A(ge, null, ye(r.visibleCallouts, (d, f) => (v(), A("span", {
              key: "callout-" + f,
              class: "callout"
            }, Q(d), 1))), 128))
          ], 2)) : V("", !0),
          n.ad.structuredSnippets ? (v(), A("div", {
            key: 1,
            class: z(["structured-snippets", { highlighted: i.shouldHighlight("structured-snippets") }])
          }, [
            n.ad.structuredSnippetsHeader ? (v(), A("span", B4e, Q(n.ad.structuredSnippetsHeader) + ": ", 1)) : V("", !0),
            (v(!0), A(ge, null, ye(n.ad.structuredSnippets, (d, f) => (v(), A("span", {
              key: "snippet-" + f,
              class: "snippet"
            }, [
              me(Q(d), 1),
              f != n.ad.structuredSnippets.length - 1 ? (v(), A("span", G4e, ", ")) : V("", !0),
              f === n.ad.structuredSnippets.length - 1 ? (v(), A("span", F4e, ".")) : V("", !0)
            ]))), 128))
          ], 2)) : V("", !0),
          n.ad.sitelinks ? (v(), A("div", {
            key: 2,
            class: z(["sitelinks", { highlighted: i.shouldHighlight("sitelinks") }])
          }, [
            (v(!0), A(ge, null, ye(n.ad.sitelinks, (d, f) => (v(), A("div", {
              key: "sitelink-" + f,
              class: "sitelink-item"
            }, [
              g("span", V4e, Q(d.title), 1),
              H(s, { height: "1px" }),
              d.line1 || d.line2 ? (v(), A("div", H4e, [
                g("div", null, Q(d.line1), 1),
                g("div", null, Q(d.line2), 1)
              ])) : V("", !0)
            ]))), 128))
          ], 2)) : V("", !0),
          n.featuredStatistics ? (v(), A("div", W4e, [
            (v(!0), A(ge, null, ye(n.featuredStatistics, (d, f) => (v(), te(l, {
              key: "statistic-" + f,
              title: d.name,
              content: d.content,
              color: d.color
            }, null, 8, ["title", "content", "color"]))), 128))
          ])) : V("", !0)
        ], 2)
      ]),
      _: 1
    })
  ], 34);
}
const K4e = /* @__PURE__ */ Y(S4e, [["render", Y4e], ["__scopeId", "data-v-aff90955"]]), BPe = /* @__PURE__ */ Ne({
  __name: "EntityPillList",
  props: {
    items: {},
    scrollToRight: { type: Boolean }
  },
  setup(t) {
    const e = t, n = W();
    return ct(async () => {
      e.scrollToRight && (n.value.$el.scrollLeft = 9999, await Or(1), n.value.$el.scrollLeft = 9999);
    }), (r, o) => {
      const i = ee("perfect-scrollbar");
      return v(), te(i, {
        class: "entity-pill-list",
        ref_key: "entityPillList",
        ref: n
      }, {
        default: q(() => [
          (v(!0), A(ge, null, ye(t.items, (a, s) => (v(), te(Cp, Tt({
            key: "entity-" + s
          }, { ref_for: !0 }, a, {
            class: { last: s === t.items.length - 1 }
          }), null, 16, ["class"]))), 128)),
          H(He, { width: "1rem" })
        ]),
        _: 1
      }, 512);
    };
  }
});
const z4e = {
  name: "SlideContainer",
  components: {
    oButton: ln
  },
  props: {
    id: {
      type: [String, Number],
      required: !0
    },
    readOnly: {
      type: Boolean,
      default: !1
    },
    hasEditMode: {
      type: Boolean,
      default: !0
    },
    isDeleted: {
      type: Boolean,
      default: !1
    },
    hasTextContainer: {
      type: [Boolean, String],
      default: !1
    },
    theme: {
      type: Object,
      required: !0
    },
    slideBeingEdited: {
      type: Boolean,
      required: !1
    },
    previewMode: {
      type: Boolean,
      required: !1
    },
    noData: {
      type: Number,
      required: !1
    },
    slideType: {
      type: Number,
      required: !1
    }
  },
  data() {
    return {
      timer: null
    };
  },
  methods: {
    setDeleteStatus(t) {
      const e = {
        id: this.id,
        deleting: !0
      };
      this.$emit("set-delete-status", e);
    },
    editWorkSummary() {
      this.slideType === 21 && !this.hasTextContainer && this.$emit("show-work-summary-modal");
    }
  }
};
const Z4e = ["id", "data-theme", "data-type"], q4e = { class: "slide-inner" }, X4e = {
  key: 1,
  class: "absolute z-2",
  style: { top: "-1.125rem", right: "8.5rem" }
}, j4e = {
  key: 2,
  class: "absolute z-2",
  style: { top: "-1.125rem", right: "1rem" }
};
function J4e(t, e, n, r, o, i) {
  const a = ee("oButton");
  return v(), A("div", {
    id: n.id,
    class: z(["slide-container", ["editor-container-border", { "cover-slide": n.slideType === 0 }]]),
    "data-theme": [n.theme.typeface],
    "data-type": n.slideType === 0 ? "cover-slide" : null,
    style: Fe(n.readOnly ? { width: "842px" } : "")
  }, [
    n.theme.typeface === "colourful" && n.slideType === 0 ? (v(), A("div", {
      key: 0,
      style: Fe({ backgroundColor: n.theme.primary_colour }),
      class: "cover-circle"
    }, null, 4)) : V("", !0),
    g("div", q4e, [
      ue(t.$slots, "default", {}, () => [
        e[2] || (e[2] = me("Slide Container cannot be empty", -1))
      ], !0)
    ]),
    !n.previewMode && n.slideType === 21 && !n.hasTextContainer ? (v(), A("div", X4e, [
      n.previewMode ? V("", !0) : (v(), te(a, {
        key: 0,
        id: "edit-icon",
        color: "white",
        size: "small",
        onClick: i.editWorkSummary
      }, {
        default: q(() => [...e[3] || (e[3] = [
          me(" Edit Slide ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"]))
    ])) : V("", !0),
    n.previewMode ? V("", !0) : (v(), A("div", j4e, [
      !n.previewMode && !n.readOnly && !n.noData && n.id != "slide--1" ? Ze((v(), te(a, {
        key: 0,
        id: "delete-icon",
        color: "white",
        size: "small",
        onClick: e[0] || (e[0] = (s) => i.setDeleteStatus(s))
      }, {
        default: q(() => [...e[4] || (e[4] = [
          me(" Remove Slide ", -1)
        ])]),
        _: 1
      }, 512)), [
        [bi, !n.isDeleted]
      ]) : V("", !0),
      !n.previewMode && !n.readOnly ? Ze((v(), te(a, {
        key: 1,
        id: "revert-icon",
        color: "white",
        size: "small",
        onClick: e[1] || (e[1] = (s) => i.setDeleteStatus(s))
      }, {
        default: q(() => [...e[5] || (e[5] = [
          me(" Reactivate Slide ", -1)
        ])]),
        _: 1
      }, 512)), [
        [bi, n.isDeleted]
      ]) : V("", !0)
    ]))
  ], 14, Z4e);
}
const Q4e = /* @__PURE__ */ Y(z4e, [["render", J4e], ["__scopeId", "data-v-fa753b12"]]), e5e = {
  name: "SlideCompanyLogo",
  props: {
    logoSrc: {
      type: String,
      required: !1
    },
    name: {
      type: String,
      required: !1
    },
    primaryColour: {
      type: String,
      required: !1
    },
    theme: {
      type: String,
      required: !0
    }
  }
};
const t5e = { class: "logo-container flex justify-center items-center" }, n5e = { key: 0 }, r5e = ["src"];
function o5e(t, e, n, r, o, i) {
  return v(), A("div", t5e, [
    n.logoSrc ? (v(), A("img", {
      key: 1,
      src: n.logoSrc
    }, null, 8, r5e)) : (v(), A("div", n5e, [
      g("h2", {
        class: z([`theme-${n.theme}-logo`, "logo-font lh-title"]),
        style: Fe({ color: n.primaryColour })
      }, Q(n.name), 7)
    ]))
  ]);
}
const F7 = /* @__PURE__ */ Y(e5e, [["render", o5e], ["__scopeId", "data-v-c1208fb8"]]), i5e = {}, a5e = {
  width: "126px",
  height: "126px",
  viewBox: "0 0 126 126",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
function s5e(t, e) {
  return v(), A("svg", a5e, [...e[0] || (e[0] = [
    vt('<defs><path d="M82.996,126 L82.996,10 C82.996,4.4771525 87.4731525,-1.31963241e-14 92.996,0 L116,0 C121.522847,-1.01453063e-15 126,4.4771525 126,10 L126,116 C126,121.522847 121.522847,126 116,126 L82.996,126 L82.996,126 Z" id="path-1"></path><linearGradient x1="19.5685726%" y1="-67.111419%" x2="52.2668597%" y2="72.250863%" id="linearGradient-3"><stop stop-color="#E96F0B" offset="0%"></stop><stop stop-color="#F37901" offset="100%"></stop></linearGradient><linearGradient x1="0%" y1="50%" x2="1.63882902%" y2="50%" id="linearGradient-4"><stop stop-color="#000000" offset="0%"></stop><stop stop-color="#000000" stop-opacity="0" offset="100%"></stop></linearGradient><path d="M116,126 L83,126 L83,126 L83,40 L126,82.5179583 L126,116 C126,121.522847 121.522847,126 116,126 Z" id="path-5"></path></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Group" transform="translate(0.000000, 0.000000)"><path d="M0,116 L0,92.983 C4.22892021e-15,87.4601525 4.4771525,82.983 10,82.983 L40,82.983 L40,82.983 L40,50 C40,44.4771525 44.4771525,40 50,40 L83,40 L83,40 L83,126 L56.858,126 L10,126 C4.4771525,126 2.45271059e-15,121.522847 0,116 Z" id="yellowBars" fill="#FFC517" fill-rule="nonzero"></path><mask id="mask-2" fill="white"><use xlink:href="#path-1"></use></mask><use id="orangeBar" fill="#F57E02" fill-rule="nonzero" xlink:href="#path-1"></use><g id="shadow" fill-rule="nonzero" mask="url(#mask-2)"><use fill="url(#linearGradient-3)" xlink:href="#path-5"></use><use fill-opacity="0.05" fill="url(#linearGradient-4)" xlink:href="#path-5"></use></g></g></g>', 2)
  ])]);
}
const l5e = /* @__PURE__ */ Y(i5e, [["render", s5e]]), c5e = {
  components: {
    SlideCompanyLogo: F7,
    GoogleAdsLogo: CV,
    GoogleAnalyticsLogo: l5e
  },
  name: "SlideHeader",
  props: {
    headerText: {
      type: String,
      required: !0
    },
    index: {
      type: [String, Number],
      required: !1
    },
    theme: {
      type: Object,
      required: !1
    },
    logoSrc: {
      type: String,
      required: !1
    },
    name: {
      type: String,
      required: !1
    },
    slideType: {
      type: Number,
      required: !1
    },
    reportPeriod: {
      type: Object,
      required: !1
    }
  },
  computed: {
    slideIndex() {
      return this.index === -1 ? "" : this.index;
    },
    isAnalyticsSlide() {
      return this.headerText.toLowerCase().includes("analytics");
    },
    removeInteractivitySummarySlide() {
      return this.headerText.toLowerCase().includes("google ads summary");
    }
  }
};
const u5e = {
  key: 0,
  class: "slide-header flex justify-between items-start"
}, d5e = { class: "tr" }, f5e = { class: "slide-report-period f6 fw4 o-70" }, h5e = {
  key: 1,
  class: "slide-header w-100 db flex justify-between items-center"
};
function _5e(t, e, n, r, o, i) {
  const a = ee("SlideCompanyLogo");
  return n.slideType === 0 ? (v(), A("div", u5e, [
    H(a, {
      "logo-src": n.logoSrc,
      name: n.name,
      "primary-colour": n.theme.primary_colour,
      "accent-colour": n.theme.accent_colour,
      theme: n.theme.typeface
    }, null, 8, ["logo-src", "name", "primary-colour", "accent-colour", "theme"]),
    g("div", d5e, [
      g("h2", {
        class: z(["f3 fw5 opteo-gray lh-title", `theme-${this.theme.typeface}-header`])
      }, Q(n.headerText), 3),
      g("h4", f5e, Q(n.reportPeriod.from) + "  →  " + Q(n.reportPeriod.to), 1)
    ])
  ])) : (v(), A("div", h5e, [
    g("h2", {
      class: z(["f4 f4-ns fw5 opteo-gray lh-title", `theme-${this.theme.typeface}-header`])
    }, Q(n.headerText), 3)
  ]));
}
const E5e = /* @__PURE__ */ Y(c5e, [["render", _5e]]), p5e = {
  name: "SlideFooter",
  components: { Text: Ye, ProfileImage: Z_e },
  props: {
    isCoverPage: {
      type: Boolean,
      required: !1,
      default: !1
    },
    // this preview refers to the Footer Preview in <ReportSenderProfile />
    isFooterPreview: {
      type: Boolean,
      required: !1,
      default: !1
    },
    sender: {
      type: Object,
      required: !0
    },
    date: {
      type: String,
      required: !1
    },
    theme: {
      type: String,
      // TODO: add type
      required: !1
    }
  },
  data() {
    return { logo_errored: !1 };
  },
  setup(t) {
    return {
      footerColor: x(() => t.theme === "colourful" && t.isCoverPage ? "white" : "black")
    };
  }
};
const m5e = { class: "slide-footer-contact" }, N5e = { key: 0 }, v5e = ["src"], g5e = {
  class: "sender-info",
  style: { "max-width": "30rem" }
}, I5e = { key: 0 }, O5e = { class: "slide-footer-sender" }, A5e = { class: "pl3" };
function D5e(t, e, n, r, o, i) {
  const a = ee("Text"), s = ee("ProfileImage");
  return v(), A("div", {
    class: z([`theme-${n.theme}-footer`, "slide-footer", { "footer-preview-mode": n.isFooterPreview }])
  }, [
    g("div", m5e, [
      n.sender.logo && n.sender.logo.length > 0 && !o.logo_errored ? (v(), A("div", N5e, [
        g("img", {
          class: "company-logo",
          onError: e[0] || (e[0] = (l) => o.logo_errored = !0),
          src: n.sender.logo
        }, null, 40, v5e)
      ])) : V("", !0),
      g("div", g5e, [
        n.sender.address_line1 ? (v(), te(a, {
          key: 0,
          size: "f-10"
        }, {
          default: q(() => [
            me(Q(n.sender.address_line1) + ",", 1)
          ]),
          _: 1
        })) : V("", !0),
        n.sender.address_line2 ? (v(), te(a, {
          key: 1,
          size: "f-10"
        }, {
          default: q(() => [
            me(Q(n.sender.address_line2) + ", ", 1)
          ]),
          _: 1
        })) : V("", !0),
        n.sender.post_code || n.sender.city ? (v(), te(a, {
          key: 2,
          size: "f-10"
        }, {
          default: q(() => [
            n.sender.city ? (v(), A("span", I5e, Q(n.sender.city) + ",", 1)) : V("", !0),
            me(" " + Q(n.sender.post_code) + ". ", 1)
          ]),
          _: 1
        })) : V("", !0)
      ])
    ]),
    g("div", O5e, [
      g("div", null, [
        H(s, {
          imageUrl: n.sender.avatar_url,
          userId: n.sender.user_id ?? 1,
          width: 32
        }, null, 8, ["imageUrl", "userId"])
      ]),
      g("div", A5e, [
        H(a, {
          size: "f-10",
          color: r.footerColor
        }, {
          default: q(() => [
            me(Q(n.sender.name), 1)
          ]),
          _: 1
        }, 8, ["color"]),
        H(a, {
          size: "f-10",
          color: r.footerColor
        }, {
          default: q(() => [
            me(Q(n.sender.email), 1)
          ]),
          _: 1
        }, 8, ["color"]),
        H(a, {
          size: "f-10",
          color: r.footerColor
        }, {
          default: q(() => [
            me(Q(n.date), 1)
          ]),
          _: 1
        }, 8, ["color"])
      ])
    ])
  ], 2);
}
const C5e = /* @__PURE__ */ Y(p5e, [["render", D5e], ["__scopeId", "data-v-0f827852"]]), S5e = Ne({
  name: "SlideTable",
  components: { oTable: $E },
  props: {
    table: {
      type: Object,
      required: !0
      // default: {
      //     columns: [
      //         {
      //             name: 'Impressions',
      //             key: 'impressions',
      //         },
      //         {
      //             name: 'Cost',
      //             key: 'cost',
      //         },
      //         {
      //             name: 'Segment',
      //             key: 'segment',
      //             accent: 'in Devices',
      //         },
      //     ],
      //     data: [
      //         { impressions: 10, cost: 10, segment: 'Computer' },
      //         { impressions: 10, cost: 10, segment: 'Mobile' },
      //         { impressions: 10, cost: 10, segment: 'TV' },
      //         { impressions: 10, cost: 10, segment: 'Tablet' },
      //     ],
      // },
    },
    theme: {
      type: Object,
      required: !1
    },
    readOnly: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = x(() => t.table.columns.map(({ name: r, ...o }) => ({
      text: r,
      vHeaderPadding: "1.125rem",
      vPadding: "0.9375rem",
      ...o
    }))), n = x(() => t.table.data.map((r) => {
      for (const o of t.table.columns)
        for (const i in r)
          i === o.key && (r[o.key + "_color"] = r[o.key + "_color"] ?? o.color);
      return r;
    }));
    return { formattedHeaders: e, formattedBody: n };
  }
});
function w5e(t, e, n, r, o, i) {
  const a = ee("oTable");
  return v(), te(a, {
    headers: t.formattedHeaders,
    items: t.formattedBody,
    noShadow: t.readOnly,
    "order-by": "conversion_rate",
    order: "DESC",
    class: z([t.readOnly ? "pdf-shadow-fix" : "shadow"])
  }, {
    "column.bid_change": q((s) => [
      g("span", {
        class: z([s.row.bid_change_color, "bold-diff"])
      }, Q(s.value), 3)
    ]),
    "column.difference": q((s) => [
      g("span", {
        class: z([s.row.difference_color, "bold-diff"])
      }, Q(s.value), 3)
    ]),
    "column.bid": q((s) => [
      g("span", {
        class: z([s.row.bid_color, "bold-diff"])
      }, Q(s.value), 3)
    ]),
    _: 1
  }, 8, ["headers", "items", "noShadow", "class"]);
}
const T5e = /* @__PURE__ */ Y(S5e, [["render", w5e], ["__scopeId", "data-v-b0f53966"]]), b5e = {
  name: "SlideReportSummaryMetrics",
  functional: !0,
  props: {
    metrics: {
      type: Array,
      required: !0
    },
    theme: {
      type: String,
      required: !0
    },
    readOnly: {
      type: Boolean,
      default: !1
    }
  }
};
const R5e = { class: "flex" }, M5e = { class: "flex" }, P5e = {
  key: 0,
  class: "pr1 flex items-center justify-center"
}, y5e = {
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, L5e = {
  key: 1,
  class: "pr1 flex items-center justify-center f7"
}, x5e = { key: 2 }, U5e = { key: 3 }, $5e = { key: 4 }, k5e = { style: { "max-width": "90px" } };
function B5e(t, e, n, r, o, i) {
  return v(), A("div", R5e, [
    (v(!0), A(ge, null, ye(n.metrics, (a) => (v(), A("div", {
      key: a.title,
      class: z([n.readOnly ? "pdf-shadow-fix" : "shadow", "metric-container br3 mh2"])
    }, [
      g("div", {
        class: z([`theme-${n.theme}-metric`, "metric-number-cnt fw5 flex justify-center items-center"])
      }, [
        g("div", M5e, [
          a.increase ? (v(), A("div", P5e, [
            (v(), A("svg", {
              style: Fe([a.increase ? { transform: "rotate(0deg)" } : { transform: "rotate(180deg)" }]),
              id: "chart-ticker-arrow",
              width: "10px",
              height: "6px",
              viewBox: "0 0 8 5",
              version: "1.1",
              xmlns: "http://www.w3.org/2000/svg",
              "xmlns:xlink": "http://www.w3.org/1999/xlink"
            }, [
              g("g", y5e, [
                g("polygon", {
                  style: Fe([a.increase ? { fill: "#00A861" } : ""]),
                  points: "4 0 8 5 0 5"
                }, null, 4)
              ])
            ], 4))
          ])) : V("", !0),
          a.currency ? (v(), A("div", L5e, Q(a.currency), 1)) : V("", !0),
          a.number ? (v(), A("div", x5e, Q(a.number), 1)) : V("", !0),
          a.text ? (v(), A("div", U5e, Q(a.text), 1)) : V("", !0),
          a.percentage ? (v(), A("div", $5e, "%")) : V("", !0)
        ])
      ], 2),
      g("div", {
        class: z([`theme-${n.theme}-numbers`, "small-caps tc pb2 flex justify-center items-center"]),
        style: { height: "46px" }
      }, [
        g("div", k5e, Q(a.title), 1)
      ], 2)
    ], 2))), 128))
  ]);
}
const G5e = /* @__PURE__ */ Y(b5e, [["render", B5e], ["__scopeId", "data-v-aee3c5c9"]]), F5e = {
  name: "SlideKeywordTable",
  components: {
    ColorTag: XE,
    EntityPill: Cp,
    Text: Ye,
    Spacer: He,
    CircleKeywordIcon: ZE
  },
  props: {
    keyword: {
      type: String,
      required: !0
    },
    metrics: {
      type: Array,
      required: !0
    },
    bid: {
      type: Object,
      required: !0
    },
    readOnly: {
      type: Boolean,
      default: !1
    }
  }
};
const V5e = { class: "metrics-bar top-bar" }, H5e = { class: "keyword-container" }, W5e = { class: "metrics-bar bottom-bar" };
function Y5e(t, e, n, r, o, i) {
  const a = ee("ColorTag"), s = ee("CircleKeywordIcon"), l = ee("Spacer"), c = ee("Text");
  return v(), A("div", {
    class: z([n.readOnly ? "pdf-shadow-fix" : "shadow", "slide-keyword-table"])
  }, [
    g("div", V5e, [
      H(a, {
        title: "Original Bid",
        content: n.bid.original_bid,
        class: "mh1"
      }, null, 8, ["content"]),
      H(a, {
        color: "green",
        title: "New Bid",
        content: n.bid.new_bid,
        class: "mh1"
      }, null, 8, ["content"]),
      H(a, {
        color: "green",
        title: "Difference",
        content: n.bid.bid_adjustment,
        class: "mh1"
      }, null, 8, ["content"])
    ]),
    g("div", H5e, [
      H(s),
      H(l, { width: "0.75rem" }),
      H(c, {
        as: "h5",
        size: "f-5",
        weight: "600",
        style: { "letter-spacing": "-0.04rem" }
      }, {
        default: q(() => [
          me(Q(n.keyword), 1)
        ]),
        _: 1
      })
    ]),
    g("div", W5e, [
      (v(!0), A(ge, null, ye(n.metrics, (u) => (v(), A("div", {
        key: u.title,
        class: "mh1"
      }, [
        H(a, {
          title: u.title,
          color: ["CPA", "Difference"].includes(u.title) ? "green" : "blue",
          content: u.value
        }, null, 8, ["title", "color", "content"])
      ]))), 128))
    ])
  ], 2);
}
const K5e = /* @__PURE__ */ Y(F5e, [["render", Y5e], ["__scopeId", "data-v-2e6f108e"]]);
function an(t) {
  this.content = t;
}
an.prototype = {
  constructor: an,
  find: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === t)
        return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(t) {
    var e = this.find(t);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(t, e, n) {
    var r = n && n != t ? this.remove(n) : this, o = r.find(t), i = r.content.slice();
    return o == -1 ? i.push(n || t, e) : (i[o + 1] = e, n && (i[o] = n)), new an(i);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(t) {
    var e = this.find(t);
    if (e == -1)
      return this;
    var n = this.content.slice();
    return n.splice(e, 2), new an(n);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(t, e) {
    return new an([t, e].concat(this.remove(t).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(t, e) {
    var n = this.remove(t).content.slice();
    return n.push(t, e), new an(n);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(t, e, n) {
    var r = this.remove(e), o = r.content.slice(), i = r.find(t);
    return o.splice(i == -1 ? o.length : i, 0, e, n), new an(o);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      t(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(t) {
    return t = an.from(t), t.size ? new an(t.content.concat(this.subtract(t).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(t) {
    return t = an.from(t), t.size ? new an(this.subtract(t).content.concat(t.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(t) {
    var e = this;
    t = an.from(t);
    for (var n = 0; n < t.content.length; n += 2)
      e = e.remove(t.content[n]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var t = {};
    return this.forEach(function(e, n) {
      t[e] = n;
    }), t;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
an.from = function(t) {
  if (t instanceof an)
    return t;
  var e = [];
  if (t)
    for (var n in t)
      e.push(n, t[n]);
  return new an(e);
};
function V7(t, e, n) {
  for (let r = 0; ; r++) {
    if (r == t.childCount || r == e.childCount)
      return t.childCount == e.childCount ? null : n;
    let o = t.child(r), i = e.child(r);
    if (o == i) {
      n += o.nodeSize;
      continue;
    }
    if (!o.sameMarkup(i))
      return n;
    if (o.isText && o.text != i.text) {
      for (let a = 0; o.text[a] == i.text[a]; a++)
        n++;
      return n;
    }
    if (o.content.size || i.content.size) {
      let a = V7(o.content, i.content, n + 1);
      if (a != null)
        return a;
    }
    n += o.nodeSize;
  }
}
function H7(t, e, n, r) {
  for (let o = t.childCount, i = e.childCount; ; ) {
    if (o == 0 || i == 0)
      return o == i ? null : { a: n, b: r };
    let a = t.child(--o), s = e.child(--i), l = a.nodeSize;
    if (a == s) {
      n -= l, r -= l;
      continue;
    }
    if (!a.sameMarkup(s))
      return { a: n, b: r };
    if (a.isText && a.text != s.text) {
      let c = 0, u = Math.min(a.text.length, s.text.length);
      for (; c < u && a.text[a.text.length - c - 1] == s.text[s.text.length - c - 1]; )
        c++, n--, r--;
      return { a: n, b: r };
    }
    if (a.content.size || s.content.size) {
      let c = H7(a.content, s.content, n - 1, r - 1);
      if (c)
        return c;
    }
    n -= l, r -= l;
  }
}
class _e {
  /**
  @internal
  */
  constructor(e, n) {
    if (this.content = e, this.size = n || 0, n == null)
      for (let r = 0; r < e.length; r++)
        this.size += e[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, n, r, o = 0, i) {
    for (let a = 0, s = 0; s < n; a++) {
      let l = this.content[a], c = s + l.nodeSize;
      if (c > e && r(l, o + s, i || null, a) !== !1 && l.content.size) {
        let u = s + 1;
        l.nodesBetween(Math.max(0, e - u), Math.min(l.content.size, n - u), r, o + u);
      }
      s = c;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, n, r, o) {
    let i = "", a = !0;
    return this.nodesBetween(e, n, (s, l) => {
      let c = s.isText ? s.text.slice(Math.max(e, l) - l, n - l) : s.isLeaf ? o ? typeof o == "function" ? o(s) : o : s.type.spec.leafText ? s.type.spec.leafText(s) : "" : "";
      s.isBlock && (s.isLeaf && c || s.isTextblock) && r && (a ? a = !1 : i += r), i += c;
    }, 0), i;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let n = this.lastChild, r = e.firstChild, o = this.content.slice(), i = 0;
    for (n.isText && n.sameMarkup(r) && (o[o.length - 1] = n.withText(n.text + r.text), i = 1); i < e.content.length; i++)
      o.push(e.content[i]);
    return new _e(o, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, n = this.size) {
    if (e == 0 && n == this.size)
      return this;
    let r = [], o = 0;
    if (n > e)
      for (let i = 0, a = 0; a < n; i++) {
        let s = this.content[i], l = a + s.nodeSize;
        l > e && ((a < e || l > n) && (s.isText ? s = s.cut(Math.max(0, e - a), Math.min(s.text.length, n - a)) : s = s.cut(Math.max(0, e - a - 1), Math.min(s.content.size, n - a - 1))), r.push(s), o += s.nodeSize), a = l;
      }
    return new _e(r, o);
  }
  /**
  @internal
  */
  cutByIndex(e, n) {
    return e == n ? _e.empty : e == 0 && n == this.content.length ? this : new _e(this.content.slice(e, n));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, n) {
    let r = this.content[e];
    if (r == n)
      return this;
    let o = this.content.slice(), i = this.size + n.nodeSize - r.nodeSize;
    return o[e] = n, new _e(o, i);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new _e([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new _e(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let n = 0; n < this.content.length; n++)
      if (!this.content[n].eq(e.content[n]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let n = this.content[e];
    if (!n)
      throw new RangeError("Index " + e + " out of range for " + this);
    return n;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let n = 0, r = 0; n < this.content.length; n++) {
      let o = this.content[n];
      e(o, r, n), r += o.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, n = 0) {
    return V7(this, e, n);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, n = this.size, r = e.size) {
    return H7(this, e, n, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e) {
    if (e == 0)
      return Fu(0, e);
    if (e == this.size)
      return Fu(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let n = 0, r = 0; ; n++) {
      let o = this.child(n), i = r + o.nodeSize;
      if (i >= e)
        return i == e ? Fu(n + 1, i) : Fu(n, r);
      r = i;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      return _e.empty;
    if (!Array.isArray(n))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new _e(n.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return _e.empty;
    let n, r = 0;
    for (let o = 0; o < e.length; o++) {
      let i = e[o];
      r += i.nodeSize, o && i.isText && e[o - 1].sameMarkup(i) ? (n || (n = e.slice(0, o)), n[n.length - 1] = i.withText(n[n.length - 1].text + i.text)) : n && n.push(i);
    }
    return new _e(n || e, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return _e.empty;
    if (e instanceof _e)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new _e([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
_e.empty = new _e([], 0);
const lh = { index: 0, offset: 0 };
function Fu(t, e) {
  return lh.index = t, lh.offset = e, lh;
}
function Zd(t, e) {
  if (t === e)
    return !0;
  if (!(t && typeof t == "object") || !(e && typeof e == "object"))
    return !1;
  let n = Array.isArray(t);
  if (Array.isArray(e) != n)
    return !1;
  if (n) {
    if (t.length != e.length)
      return !1;
    for (let r = 0; r < t.length; r++)
      if (!Zd(t[r], e[r]))
        return !1;
  } else {
    for (let r in t)
      if (!(r in e) || !Zd(t[r], e[r]))
        return !1;
    for (let r in e)
      if (!(r in t))
        return !1;
  }
  return !0;
}
let pt = class k0 {
  /**
  @internal
  */
  constructor(e, n) {
    this.type = e, this.attrs = n;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let n, r = !1;
    for (let o = 0; o < e.length; o++) {
      let i = e[o];
      if (this.eq(i))
        return e;
      if (this.type.excludes(i.type))
        n || (n = e.slice(0, o));
      else {
        if (i.type.excludes(this.type))
          return e;
        !r && i.type.rank > this.type.rank && (n || (n = e.slice(0, o)), n.push(this), r = !0), n && n.push(i);
      }
    }
    return n || (n = e.slice()), r || n.push(this), n;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let n = 0; n < e.length; n++)
      if (this.eq(e[n]))
        return e.slice(0, n).concat(e.slice(n + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let n = 0; n < e.length; n++)
      if (this.eq(e[n]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && Zd(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let n in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, n) {
    if (!n)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = e.marks[n.type];
    if (!r)
      throw new RangeError(`There is no mark type ${n.type} in this schema`);
    let o = r.create(n.attrs);
    return r.checkAttrs(o.attrs), o;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, n) {
    if (e == n)
      return !0;
    if (e.length != n.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!e[r].eq(n[r]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return k0.none;
    if (e instanceof k0)
      return [e];
    let n = e.slice();
    return n.sort((r, o) => r.type.rank - o.type.rank), n;
  }
};
pt.none = [];
class qd extends Error {
}
class Ae {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, n, r) {
    this.content = e, this.openStart = n, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, n) {
    let r = Y7(this.content, e + this.openStart, n);
    return r && new Ae(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, n) {
    return new Ae(W7(this.content, e + this.openStart, n + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      return Ae.empty;
    let r = n.openStart || 0, o = n.openEnd || 0;
    if (typeof r != "number" || typeof o != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new Ae(_e.fromJSON(e, n.content), r, o);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, n = !0) {
    let r = 0, o = 0;
    for (let i = e.firstChild; i && !i.isLeaf && (n || !i.type.spec.isolating); i = i.firstChild)
      r++;
    for (let i = e.lastChild; i && !i.isLeaf && (n || !i.type.spec.isolating); i = i.lastChild)
      o++;
    return new Ae(e, r, o);
  }
}
Ae.empty = new Ae(_e.empty, 0, 0);
function W7(t, e, n) {
  let { index: r, offset: o } = t.findIndex(e), i = t.maybeChild(r), { index: a, offset: s } = t.findIndex(n);
  if (o == e || i.isText) {
    if (s != n && !t.child(a).isText)
      throw new RangeError("Removing non-flat range");
    return t.cut(0, e).append(t.cut(n));
  }
  if (r != a)
    throw new RangeError("Removing non-flat range");
  return t.replaceChild(r, i.copy(W7(i.content, e - o - 1, n - o - 1)));
}
function Y7(t, e, n, r) {
  let { index: o, offset: i } = t.findIndex(e), a = t.maybeChild(o);
  if (i == e || a.isText)
    return r && !r.canReplace(o, o, n) ? null : t.cut(0, e).append(n).append(t.cut(e));
  let s = Y7(a.content, e - i - 1, n, a);
  return s && t.replaceChild(o, a.copy(s));
}
function z5e(t, e, n) {
  if (n.openStart > t.depth)
    throw new qd("Inserted content deeper than insertion position");
  if (t.depth - n.openStart != e.depth - n.openEnd)
    throw new qd("Inconsistent open depths");
  return K7(t, e, n, 0);
}
function K7(t, e, n, r) {
  let o = t.index(r), i = t.node(r);
  if (o == e.index(r) && r < t.depth - n.openStart) {
    let a = K7(t, e, n, r + 1);
    return i.copy(i.content.replaceChild(o, a));
  } else if (n.content.size)
    if (!n.openStart && !n.openEnd && t.depth == r && e.depth == r) {
      let a = t.parent, s = a.content;
      return ma(a, s.cut(0, t.parentOffset).append(n.content).append(s.cut(e.parentOffset)));
    } else {
      let { start: a, end: s } = Z5e(n, t);
      return ma(i, Z7(t, a, s, e, r));
    }
  else
    return ma(i, Xd(t, e, r));
}
function z7(t, e) {
  if (!e.type.compatibleContent(t.type))
    throw new qd("Cannot join " + e.type.name + " onto " + t.type.name);
}
function B0(t, e, n) {
  let r = t.node(n);
  return z7(r, e.node(n)), r;
}
function pa(t, e) {
  let n = e.length - 1;
  n >= 0 && t.isText && t.sameMarkup(e[n]) ? e[n] = t.withText(e[n].text + t.text) : e.push(t);
}
function rc(t, e, n, r) {
  let o = (e || t).node(n), i = 0, a = e ? e.index(n) : o.childCount;
  t && (i = t.index(n), t.depth > n ? i++ : t.textOffset && (pa(t.nodeAfter, r), i++));
  for (let s = i; s < a; s++)
    pa(o.child(s), r);
  e && e.depth == n && e.textOffset && pa(e.nodeBefore, r);
}
function ma(t, e) {
  return t.type.checkContent(e), t.copy(e);
}
function Z7(t, e, n, r, o) {
  let i = t.depth > o && B0(t, e, o + 1), a = r.depth > o && B0(n, r, o + 1), s = [];
  return rc(null, t, o, s), i && a && e.index(o) == n.index(o) ? (z7(i, a), pa(ma(i, Z7(t, e, n, r, o + 1)), s)) : (i && pa(ma(i, Xd(t, e, o + 1)), s), rc(e, n, o, s), a && pa(ma(a, Xd(n, r, o + 1)), s)), rc(r, null, o, s), new _e(s);
}
function Xd(t, e, n) {
  let r = [];
  if (rc(null, t, n, r), t.depth > n) {
    let o = B0(t, e, n + 1);
    pa(ma(o, Xd(t, e, n + 1)), r);
  }
  return rc(e, null, n, r), new _e(r);
}
function Z5e(t, e) {
  let n = e.depth - t.openStart, o = e.node(n).copy(t.content);
  for (let i = n - 1; i >= 0; i--)
    o = e.node(i).copy(_e.from(o));
  return {
    start: o.resolveNoCache(t.openStart + n),
    end: o.resolveNoCache(o.content.size - t.openEnd - n)
  };
}
class yc {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.pos = e, this.path = n, this.parentOffset = r, this.depth = n.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, n = this.index(this.depth);
    if (n == e.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], o = e.child(n);
    return r ? e.child(n).cut(r) : o;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), n = this.pos - this.path[this.path.length - 1];
    return n ? this.parent.child(e).cut(0, n) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, n) {
    n = this.resolveDepth(n);
    let r = this.path[n * 3], o = n == 0 ? 0 : this.path[n * 3 - 1] + 1;
    for (let i = 0; i < e; i++)
      o += r.child(i).nodeSize;
    return o;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, n = this.index();
    if (e.content.size == 0)
      return pt.none;
    if (this.textOffset)
      return e.child(n).marks;
    let r = e.maybeChild(n - 1), o = e.maybeChild(n);
    if (!r) {
      let s = r;
      r = o, o = s;
    }
    let i = r.marks;
    for (var a = 0; a < i.length; a++)
      i[a].type.spec.inclusive === !1 && (!o || !i[a].isInSet(o.marks)) && (i = i[a--].removeFromSet(i));
    return i;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let n = this.parent.maybeChild(this.index());
    if (!n || !n.isInline)
      return null;
    let r = n.marks, o = e.parent.maybeChild(e.index());
    for (var i = 0; i < r.length; i++)
      r[i].type.spec.inclusive === !1 && (!o || !r[i].isInSet(o.marks)) && (r = r[i--].removeFromSet(r));
    return r;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let n = this.depth; n > 0; n--)
      if (this.start(n) <= e && this.end(n) >= e)
        return n;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, n) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); r >= 0; r--)
      if (e.pos <= this.end(r) && (!n || n(this.node(r))))
        return new jd(this, e, r);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let n = 1; n <= this.depth; n++)
      e += (e ? "/" : "") + this.node(n).type.name + "_" + this.index(n - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, n) {
    if (!(n >= 0 && n <= e.content.size))
      throw new RangeError("Position " + n + " out of range");
    let r = [], o = 0, i = n;
    for (let a = e; ; ) {
      let { index: s, offset: l } = a.content.findIndex(i), c = i - l;
      if (r.push(a, s, o + l), !c || (a = a.child(s), a.isText))
        break;
      i = c - 1, o += l + 1;
    }
    return new yc(n, r, i);
  }
  /**
  @internal
  */
  static resolveCached(e, n) {
    let r = Pg.get(e);
    if (r)
      for (let i = 0; i < r.elts.length; i++) {
        let a = r.elts[i];
        if (a.pos == n)
          return a;
      }
    else
      Pg.set(e, r = new q5e());
    let o = r.elts[r.i] = yc.resolve(e, n);
    return r.i = (r.i + 1) % X5e, o;
  }
}
class q5e {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const X5e = 12, Pg = /* @__PURE__ */ new WeakMap();
class jd {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, n, r) {
    this.$from = e, this.$to = n, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const j5e = /* @__PURE__ */ Object.create(null);
let Ai = class G0 {
  /**
  @internal
  */
  constructor(e, n, r, o = pt.none) {
    this.type = e, this.attrs = n, this.marks = o, this.content = r || _e.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, n, r, o = 0) {
    this.content.nodesBetween(e, n, r, o, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
  */
  textBetween(e, n, r, o) {
    return this.content.textBetween(e, n, r, o);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, n, r) {
    return this.type == e && Zd(this.attrs, n || e.defaultAttrs || j5e) && pt.sameSet(this.marks, r || pt.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new G0(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new G0(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, n = this.content.size) {
    return e == 0 && n == this.content.size ? this : this.copy(this.content.cut(e, n));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, n = this.content.size, r = !1) {
    if (e == n)
      return Ae.empty;
    let o = this.resolve(e), i = this.resolve(n), a = r ? 0 : o.sharedDepth(n), s = o.start(a), c = o.node(a).content.cut(o.pos - s, i.pos - s);
    return new Ae(c, o.depth - a, i.depth - a);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, n, r) {
    return z5e(this.resolve(e), this.resolve(n), r);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let n = this; ; ) {
      let { index: r, offset: o } = n.content.findIndex(e);
      if (n = n.maybeChild(r), !n)
        return null;
      if (o == e || n.isText)
        return n;
      e -= o + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: n, offset: r } = this.content.findIndex(e);
    return { node: this.content.maybeChild(n), index: n, offset: r };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: n, offset: r } = this.content.findIndex(e);
    if (r < e)
      return { node: this.content.child(n), index: n, offset: r };
    let o = this.content.child(n - 1);
    return { node: o, index: n - 1, offset: r - o.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return yc.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return yc.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, n, r) {
    let o = !1;
    return n > e && this.nodesBetween(e, n, (i) => (r.isInSet(i.marks) && (o = !0), !o)), o;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), q7(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let n = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!n)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return n;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, n, r = _e.empty, o = 0, i = r.childCount) {
    let a = this.contentMatchAt(e).matchFragment(r, o, i), s = a && a.matchFragment(this.content, n);
    if (!s || !s.validEnd)
      return !1;
    for (let l = o; l < i; l++)
      if (!this.type.allowsMarks(r.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, n, r, o) {
    if (o && !this.type.allowsMarks(o))
      return !1;
    let i = this.contentMatchAt(e).matchType(r), a = i && i.matchFragment(this.content, n);
    return a ? a.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = pt.none;
    for (let n = 0; n < this.marks.length; n++) {
      let r = this.marks[n];
      r.type.checkAttrs(r.attrs), e = r.addToSet(e);
    }
    if (!pt.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((n) => n.type.name)}`);
    this.content.forEach((n) => n.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let n in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((n) => n.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r;
    if (n.marks) {
      if (!Array.isArray(n.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = n.marks.map(e.markFromJSON);
    }
    if (n.type == "text") {
      if (typeof n.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(n.text, r);
    }
    let o = _e.fromJSON(e, n.content), i = e.nodeType(n.type).create(n.attrs, o, r);
    return i.type.checkAttrs(i.attrs), i;
  }
};
Ai.prototype.text = void 0;
class Jd extends Ai {
  /**
  @internal
  */
  constructor(e, n, r, o) {
    if (super(e, n, null, o), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : q7(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, n) {
    return this.text.slice(e, n);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new Jd(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new Jd(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, n = this.text.length) {
    return e == 0 && n == this.text.length ? this : this.withText(this.text.slice(e, n));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function q7(t, e) {
  for (let n = t.length - 1; n >= 0; n--)
    e = t[n].type.name + "(" + e + ")";
  return e;
}
class ya {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, n) {
    let r = new J5e(e, n);
    if (r.next == null)
      return ya.empty;
    let o = X7(r);
    r.next && r.err("Unexpected trailing text");
    let i = iDe(oDe(o));
    return aDe(i, r), i;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let n = 0; n < this.next.length; n++)
      if (this.next[n].type == e)
        return this.next[n].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, n = 0, r = e.childCount) {
    let o = this;
    for (let i = n; o && i < r; i++)
      o = o.matchType(e.child(i).type);
    return o;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: n } = this.next[e];
      if (!(n.isText || n.hasRequiredAttrs()))
        return n;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let n = 0; n < this.next.length; n++)
      for (let r = 0; r < e.next.length; r++)
        if (this.next[n].type == e.next[r].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, n = !1, r = 0) {
    let o = [this];
    function i(a, s) {
      let l = a.matchFragment(e, r);
      if (l && (!n || l.validEnd))
        return _e.from(s.map((c) => c.createAndFill()));
      for (let c = 0; c < a.next.length; c++) {
        let { type: u, next: d } = a.next[c];
        if (!(u.isText || u.hasRequiredAttrs()) && o.indexOf(d) == -1) {
          o.push(d);
          let f = i(d, s.concat(u));
          if (f)
            return f;
        }
      }
      return null;
    }
    return i(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == e)
        return this.wrapCache[r + 1];
    let n = this.computeWrapping(e);
    return this.wrapCache.push(e, n), n;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let n = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let o = r.shift(), i = o.match;
      if (i.matchType(e)) {
        let a = [];
        for (let s = o; s.type; s = s.via)
          a.push(s.type);
        return a.reverse();
      }
      for (let a = 0; a < i.next.length; a++) {
        let { type: s, next: l } = i.next[a];
        !s.isLeaf && !s.hasRequiredAttrs() && !(s.name in n) && (!o.type || l.validEnd) && (r.push({ match: s.contentMatch, type: s, via: o }), n[s.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function n(r) {
      e.push(r);
      for (let o = 0; o < r.next.length; o++)
        e.indexOf(r.next[o].next) == -1 && n(r.next[o].next);
    }
    return n(this), e.map((r, o) => {
      let i = o + (r.validEnd ? "*" : " ") + " ";
      for (let a = 0; a < r.next.length; a++)
        i += (a ? ", " : "") + r.next[a].type.name + "->" + e.indexOf(r.next[a].next);
      return i;
    }).join(`
`);
  }
}
ya.empty = new ya(!0);
class J5e {
  constructor(e, n) {
    this.string = e, this.nodeTypes = n, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function X7(t) {
  let e = [];
  do
    e.push(Q5e(t));
  while (t.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function Q5e(t) {
  let e = [];
  do
    e.push(eDe(t));
  while (t.next && t.next != ")" && t.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function eDe(t) {
  let e = rDe(t);
  for (; ; )
    if (t.eat("+"))
      e = { type: "plus", expr: e };
    else if (t.eat("*"))
      e = { type: "star", expr: e };
    else if (t.eat("?"))
      e = { type: "opt", expr: e };
    else if (t.eat("{"))
      e = tDe(t, e);
    else
      break;
  return e;
}
function yg(t) {
  /\D/.test(t.next) && t.err("Expected number, got '" + t.next + "'");
  let e = Number(t.next);
  return t.pos++, e;
}
function tDe(t, e) {
  let n = yg(t), r = n;
  return t.eat(",") && (t.next != "}" ? r = yg(t) : r = -1), t.eat("}") || t.err("Unclosed braced range"), { type: "range", min: n, max: r, expr: e };
}
function nDe(t, e) {
  let n = t.nodeTypes, r = n[e];
  if (r)
    return [r];
  let o = [];
  for (let i in n) {
    let a = n[i];
    a.isInGroup(e) && o.push(a);
  }
  return o.length == 0 && t.err("No node type or group '" + e + "' found"), o;
}
function rDe(t) {
  if (t.eat("(")) {
    let e = X7(t);
    return t.eat(")") || t.err("Missing closing paren"), e;
  } else if (/\W/.test(t.next))
    t.err("Unexpected token '" + t.next + "'");
  else {
    let e = nDe(t, t.next).map((n) => (t.inline == null ? t.inline = n.isInline : t.inline != n.isInline && t.err("Mixing inline and block content"), { type: "name", value: n }));
    return t.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function oDe(t) {
  let e = [[]];
  return o(i(t, 0), n()), e;
  function n() {
    return e.push([]) - 1;
  }
  function r(a, s, l) {
    let c = { term: l, to: s };
    return e[a].push(c), c;
  }
  function o(a, s) {
    a.forEach((l) => l.to = s);
  }
  function i(a, s) {
    if (a.type == "choice")
      return a.exprs.reduce((l, c) => l.concat(i(c, s)), []);
    if (a.type == "seq")
      for (let l = 0; ; l++) {
        let c = i(a.exprs[l], s);
        if (l == a.exprs.length - 1)
          return c;
        o(c, s = n());
      }
    else if (a.type == "star") {
      let l = n();
      return r(s, l), o(i(a.expr, l), l), [r(l)];
    } else if (a.type == "plus") {
      let l = n();
      return o(i(a.expr, s), l), o(i(a.expr, l), l), [r(l)];
    } else {
      if (a.type == "opt")
        return [r(s)].concat(i(a.expr, s));
      if (a.type == "range") {
        let l = s;
        for (let c = 0; c < a.min; c++) {
          let u = n();
          o(i(a.expr, l), u), l = u;
        }
        if (a.max == -1)
          o(i(a.expr, l), l);
        else
          for (let c = a.min; c < a.max; c++) {
            let u = n();
            r(l, u), o(i(a.expr, l), u), l = u;
          }
        return [r(l)];
      } else {
        if (a.type == "name")
          return [r(s, void 0, a.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function j7(t, e) {
  return e - t;
}
function Lg(t, e) {
  let n = [];
  return r(e), n.sort(j7);
  function r(o) {
    let i = t[o];
    if (i.length == 1 && !i[0].term)
      return r(i[0].to);
    n.push(o);
    for (let a = 0; a < i.length; a++) {
      let { term: s, to: l } = i[a];
      !s && n.indexOf(l) == -1 && r(l);
    }
  }
}
function iDe(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return n(Lg(t, 0));
  function n(r) {
    let o = [];
    r.forEach((a) => {
      t[a].forEach(({ term: s, to: l }) => {
        if (!s)
          return;
        let c;
        for (let u = 0; u < o.length; u++)
          o[u][0] == s && (c = o[u][1]);
        Lg(t, l).forEach((u) => {
          c || o.push([s, c = []]), c.indexOf(u) == -1 && c.push(u);
        });
      });
    });
    let i = e[r.join(",")] = new ya(r.indexOf(t.length - 1) > -1);
    for (let a = 0; a < o.length; a++) {
      let s = o[a][1].sort(j7);
      i.next.push({ type: o[a][0], next: e[s.join(",")] || n(s) });
    }
    return i;
  }
}
function aDe(t, e) {
  for (let n = 0, r = [t]; n < r.length; n++) {
    let o = r[n], i = !o.validEnd, a = [];
    for (let s = 0; s < o.next.length; s++) {
      let { type: l, next: c } = o.next[s];
      a.push(l.name), i && !(l.isText || l.hasRequiredAttrs()) && (i = !1), r.indexOf(c) == -1 && r.push(c);
    }
    i && e.err("Only non-generatable nodes (" + a.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function J7(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t) {
    let r = t[n];
    if (!r.hasDefault)
      return null;
    e[n] = r.default;
  }
  return e;
}
function Q7(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let r in t) {
    let o = e && e[r];
    if (o === void 0) {
      let i = t[r];
      if (i.hasDefault)
        o = i.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    n[r] = o;
  }
  return n;
}
function eC(t, e, n, r) {
  for (let o in e)
    if (!(o in t))
      throw new RangeError(`Unsupported attribute ${o} for ${n} of type ${o}`);
  for (let o in t) {
    let i = t[o];
    i.validate && i.validate(e[o]);
  }
}
function tC(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let r in e)
      n[r] = new lDe(t, r, e[r]);
  return n;
}
let xg = class nC {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.name = e, this.schema = n, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = tC(e, r.attrs), this.defaultAttrs = J7(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == ya.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : Q7(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, n, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new Ai(this, this.computeAttrs(e), _e.from(n), pt.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, n, r) {
    return n = _e.from(n), this.checkContent(n), new Ai(this, this.computeAttrs(e), n, pt.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, n, r) {
    if (e = this.computeAttrs(e), n = _e.from(n), n.size) {
      let a = this.contentMatch.fillBefore(n);
      if (!a)
        return null;
      n = a.append(n);
    }
    let o = this.contentMatch.matchFragment(n), i = o && o.fillBefore(_e.empty, !0);
    return i ? new Ai(this, e, n.append(i), pt.setFrom(r)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let n = this.contentMatch.matchFragment(e);
    if (!n || !n.validEnd)
      return !1;
    for (let r = 0; r < e.childCount; r++)
      if (!this.allowsMarks(e.child(r).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    eC(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let n = 0; n < e.length; n++)
      if (!this.allowsMarkType(e[n].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let n;
    for (let r = 0; r < e.length; r++)
      this.allowsMarkType(e[r].type) ? n && n.push(e[r]) : n || (n = e.slice(0, r));
    return n ? n.length ? n : pt.none : e;
  }
  /**
  @internal
  */
  static compile(e, n) {
    let r = /* @__PURE__ */ Object.create(null);
    e.forEach((i, a) => r[i] = new nC(i, n, a));
    let o = n.spec.topNode || "doc";
    if (!r[o])
      throw new RangeError("Schema is missing its top node type ('" + o + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let i in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
};
function sDe(t, e, n) {
  let r = n.split("|");
  return (o) => {
    let i = o === null ? "null" : typeof o;
    if (r.indexOf(i) < 0)
      throw new RangeError(`Expected value of type ${r} for attribute ${e} on type ${t}, got ${i}`);
  };
}
class lDe {
  constructor(e, n, r) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(r, "default"), this.default = r.default, this.validate = typeof r.validate == "string" ? sDe(e, n, r.validate) : r.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class i1 {
  /**
  @internal
  */
  constructor(e, n, r, o) {
    this.name = e, this.rank = n, this.schema = r, this.spec = o, this.attrs = tC(e, o.attrs), this.excluded = null;
    let i = J7(this.attrs);
    this.instance = i ? new pt(this, i) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new pt(this, Q7(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, n) {
    let r = /* @__PURE__ */ Object.create(null), o = 0;
    return e.forEach((i, a) => r[i] = new i1(i, o++, n, a)), r;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var n = 0; n < e.length; n++)
      e[n].type == this && (e = e.slice(0, n).concat(e.slice(n + 1)), n--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let n = 0; n < e.length; n++)
      if (e[n].type == this)
        return e[n];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    eC(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class rC {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let n = this.spec = {};
    for (let o in e)
      n[o] = e[o];
    n.nodes = an.from(e.nodes), n.marks = an.from(e.marks || {}), this.nodes = xg.compile(this.spec.nodes, this), this.marks = i1.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let o in this.nodes) {
      if (o in this.marks)
        throw new RangeError(o + " can not be both a node and a mark");
      let i = this.nodes[o], a = i.spec.content || "", s = i.spec.marks;
      if (i.contentMatch = r[a] || (r[a] = ya.parse(a, this.nodes)), i.inlineContent = i.contentMatch.inlineContent, i.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!i.isInline || !i.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = i;
      }
      i.markSet = s == "_" ? null : s ? Ug(this, s.split(" ")) : s == "" || !i.inlineContent ? [] : null;
    }
    for (let o in this.marks) {
      let i = this.marks[o], a = i.spec.excludes;
      i.excluded = a == null ? [i] : a == "" ? [] : Ug(this, a.split(" "));
    }
    this.nodeFromJSON = (o) => Ai.fromJSON(this, o), this.markFromJSON = (o) => pt.fromJSON(this, o), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, n = null, r, o) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof xg) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else
      throw new RangeError("Invalid node type: " + e);
    return e.createChecked(n, r, o);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, n) {
    let r = this.nodes.text;
    return new Jd(r, r.defaultAttrs, e, pt.setFrom(n));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, n) {
    return typeof e == "string" && (e = this.marks[e]), e.create(n);
  }
  /**
  @internal
  */
  nodeType(e) {
    let n = this.nodes[e];
    if (!n)
      throw new RangeError("Unknown node type: " + e);
    return n;
  }
}
function Ug(t, e) {
  let n = [];
  for (let r = 0; r < e.length; r++) {
    let o = e[r], i = t.marks[o], a = i;
    if (i)
      n.push(i);
    else
      for (let s in t.marks) {
        let l = t.marks[s];
        (o == "_" || l.spec.group && l.spec.group.split(" ").indexOf(o) > -1) && n.push(a = l);
      }
    if (!a)
      throw new SyntaxError("Unknown mark type: '" + e[r] + "'");
  }
  return n;
}
function cDe(t) {
  return t.tag != null;
}
function uDe(t) {
  return t.style != null;
}
class Di {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, n) {
    this.schema = e, this.rules = n, this.tags = [], this.styles = [];
    let r = this.matchedStyles = [];
    n.forEach((o) => {
      if (cDe(o))
        this.tags.push(o);
      else if (uDe(o)) {
        let i = /[^=]*/.exec(o.style)[0];
        r.indexOf(i) < 0 && r.push(i), this.styles.push(o);
      }
    }), this.normalizeLists = !this.tags.some((o) => {
      if (!/^(ul|ol)\b/.test(o.tag) || !o.node)
        return !1;
      let i = e.nodes[o.node];
      return i.contentMatch.matchType(i);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, n = {}) {
    let r = new kg(this, n, !1);
    return r.addAll(e, pt.none, n.from, n.to), r.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, n = {}) {
    let r = new kg(this, n, !0);
    return r.addAll(e, pt.none, n.from, n.to), Ae.maxOpen(r.finish());
  }
  /**
  @internal
  */
  matchTag(e, n, r) {
    for (let o = r ? this.tags.indexOf(r) + 1 : 0; o < this.tags.length; o++) {
      let i = this.tags[o];
      if (hDe(e, i.tag) && (i.namespace === void 0 || e.namespaceURI == i.namespace) && (!i.context || n.matchesContext(i.context))) {
        if (i.getAttrs) {
          let a = i.getAttrs(e);
          if (a === !1)
            continue;
          i.attrs = a || void 0;
        }
        return i;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, n, r, o) {
    for (let i = o ? this.styles.indexOf(o) + 1 : 0; i < this.styles.length; i++) {
      let a = this.styles[i], s = a.style;
      if (!(s.indexOf(e) != 0 || a.context && !r.matchesContext(a.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      s.length > e.length && (s.charCodeAt(e.length) != 61 || s.slice(e.length + 1) != n))) {
        if (a.getAttrs) {
          let l = a.getAttrs(n);
          if (l === !1)
            continue;
          a.attrs = l || void 0;
        }
        return a;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let n = [];
    function r(o) {
      let i = o.priority == null ? 50 : o.priority, a = 0;
      for (; a < n.length; a++) {
        let s = n[a];
        if ((s.priority == null ? 50 : s.priority) < i)
          break;
      }
      n.splice(a, 0, o);
    }
    for (let o in e.marks) {
      let i = e.marks[o].spec.parseDOM;
      i && i.forEach((a) => {
        r(a = Bg(a)), a.mark || a.ignore || a.clearMark || (a.mark = o);
      });
    }
    for (let o in e.nodes) {
      let i = e.nodes[o].spec.parseDOM;
      i && i.forEach((a) => {
        r(a = Bg(a)), a.node || a.ignore || a.mark || (a.node = o);
      });
    }
    return n;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new Di(e, Di.schemaRules(e)));
  }
}
const oC = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, dDe = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, iC = { ol: !0, ul: !0 }, Lc = 1, F0 = 2, oc = 4;
function $g(t, e, n) {
  return e != null ? (e ? Lc : 0) | (e === "full" ? F0 : 0) : t && t.whitespace == "pre" ? Lc | F0 : n & ~oc;
}
class Vu {
  constructor(e, n, r, o, i, a) {
    this.type = e, this.attrs = n, this.marks = r, this.solid = o, this.options = a, this.content = [], this.activeMarks = pt.none, this.match = i || (a & oc ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let n = this.type.contentMatch.fillBefore(_e.from(e));
      if (n)
        this.match = this.type.contentMatch.matchFragment(n);
      else {
        let r = this.type.contentMatch, o;
        return (o = r.findWrapping(e.type)) ? (this.match = r, o) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & Lc)) {
      let r = this.content[this.content.length - 1], o;
      if (r && r.isText && (o = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let i = r;
        r.text.length == o[0].length ? this.content.pop() : this.content[this.content.length - 1] = i.withText(i.text.slice(0, i.text.length - o[0].length));
      }
    }
    let n = _e.from(this.content);
    return !e && this.match && (n = n.append(this.match.fillBefore(_e.empty, !0))), this.type ? this.type.create(this.attrs, n, this.marks) : n;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !oC.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class kg {
  constructor(e, n, r) {
    this.parser = e, this.options = n, this.isOpen = r, this.open = 0, this.localPreserveWS = !1;
    let o = n.topNode, i, a = $g(null, n.preserveWhitespace, 0) | (r ? oc : 0);
    o ? i = new Vu(o.type, o.attrs, pt.none, !0, n.topMatch || o.type.contentMatch, a) : r ? i = new Vu(null, null, pt.none, !0, null, a) : i = new Vu(e.schema.topNodeType, null, pt.none, !0, null, a), this.nodes = [i], this.find = n.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, n) {
    e.nodeType == 3 ? this.addTextNode(e, n) : e.nodeType == 1 && this.addElement(e, n);
  }
  addTextNode(e, n) {
    let r = e.nodeValue, o = this.top, i = o.options & F0 ? "full" : this.localPreserveWS || (o.options & Lc) > 0, { schema: a } = this.parser;
    if (i === "full" || o.inlineContext(e) || /[^ \t\r\n\u000c]/.test(r)) {
      if (i)
        if (i === "full")
          r = r.replace(/\r\n?/g, `
`);
        else if (a.linebreakReplacement && /[\r\n]/.test(r) && this.top.findWrapping(a.linebreakReplacement.create())) {
          let s = r.split(/\r?\n|\r/);
          for (let l = 0; l < s.length; l++)
            l && this.insertNode(a.linebreakReplacement.create(), n, !0), s[l] && this.insertNode(a.text(s[l]), n, !/\S/.test(s[l]));
          r = "";
        } else
          r = r.replace(/\r?\n|\r/g, " ");
      else if (r = r.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(r) && this.open == this.nodes.length - 1) {
        let s = o.content[o.content.length - 1], l = e.previousSibling;
        (!s || l && l.nodeName == "BR" || s.isText && /[ \t\r\n\u000c]$/.test(s.text)) && (r = r.slice(1));
      }
      r && this.insertNode(a.text(r), n, !/\S/.test(r)), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, n, r) {
    let o = this.localPreserveWS, i = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let a = e.nodeName.toLowerCase(), s;
    iC.hasOwnProperty(a) && this.parser.normalizeLists && fDe(e);
    let l = this.options.ruleFromNode && this.options.ruleFromNode(e) || (s = this.parser.matchTag(e, this, r));
    e:
      if (l ? l.ignore : dDe.hasOwnProperty(a))
        this.findInside(e), this.ignoreFallback(e, n);
      else if (!l || l.skip || l.closeParent) {
        l && l.closeParent ? this.open = Math.max(0, this.open - 1) : l && l.skip.nodeType && (e = l.skip);
        let c, u = this.needsBlock;
        if (oC.hasOwnProperty(a))
          i.content.length && i.content[0].isInline && this.open && (this.open--, i = this.top), c = !0, i.type || (this.needsBlock = !0);
        else if (!e.firstChild) {
          this.leafFallback(e, n);
          break e;
        }
        let d = l && l.skip ? n : this.readStyles(e, n);
        d && this.addAll(e, d), c && this.sync(i), this.needsBlock = u;
      } else {
        let c = this.readStyles(e, n);
        c && this.addElementByRule(e, l, c, l.consuming === !1 ? s : void 0);
      }
    this.localPreserveWS = o;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, n) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), n);
  }
  // Called for ignored nodes
  ignoreFallback(e, n) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), n, !0);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, n) {
    let r = e.style;
    if (r && r.length)
      for (let o = 0; o < this.parser.matchedStyles.length; o++) {
        let i = this.parser.matchedStyles[o], a = r.getPropertyValue(i);
        if (a)
          for (let s = void 0; ; ) {
            let l = this.parser.matchStyle(i, a, this, s);
            if (!l)
              break;
            if (l.ignore)
              return null;
            if (l.clearMark ? n = n.filter((c) => !l.clearMark(c)) : n = n.concat(this.parser.schema.marks[l.mark].create(l.attrs)), l.consuming === !1)
              s = l;
            else
              break;
          }
      }
    return n;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, n, r, o) {
    let i, a;
    if (n.node)
      if (a = this.parser.schema.nodes[n.node], a.isLeaf)
        this.insertNode(a.create(n.attrs), r, e.nodeName == "BR") || this.leafFallback(e, r);
      else {
        let l = this.enter(a, n.attrs || null, r, n.preserveWhitespace);
        l && (i = !0, r = l);
      }
    else {
      let l = this.parser.schema.marks[n.mark];
      r = r.concat(l.create(n.attrs));
    }
    let s = this.top;
    if (a && a.isLeaf)
      this.findInside(e);
    else if (o)
      this.addElement(e, r, o);
    else if (n.getContent)
      this.findInside(e), n.getContent(e, this.parser.schema).forEach((l) => this.insertNode(l, r, !1));
    else {
      let l = e;
      typeof n.contentElement == "string" ? l = e.querySelector(n.contentElement) : typeof n.contentElement == "function" ? l = n.contentElement(e) : n.contentElement && (l = n.contentElement), this.findAround(e, l, !0), this.addAll(l, r), this.findAround(e, l, !1);
    }
    i && this.sync(s) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, n, r, o) {
    let i = r || 0;
    for (let a = r ? e.childNodes[r] : e.firstChild, s = o == null ? null : e.childNodes[o]; a != s; a = a.nextSibling, ++i)
      this.findAtPoint(e, i), this.addDOM(a, n);
    this.findAtPoint(e, i);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, n, r) {
    let o, i;
    for (let a = this.open, s = 0; a >= 0; a--) {
      let l = this.nodes[a], c = l.findWrapping(e);
      if (c && (!o || o.length > c.length + s) && (o = c, i = l, !c.length))
        break;
      if (l.solid) {
        if (r)
          break;
        s += 2;
      }
    }
    if (!o)
      return null;
    this.sync(i);
    for (let a = 0; a < o.length; a++)
      n = this.enterInner(o[a], null, n, !1);
    return n;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, n, r) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let i = this.textblockFromContext();
      i && (n = this.enterInner(i, null, n));
    }
    let o = this.findPlace(e, n, r);
    if (o) {
      this.closeExtra();
      let i = this.top;
      i.match && (i.match = i.match.matchType(e.type));
      let a = pt.none;
      for (let s of o.concat(e.marks))
        (i.type ? i.type.allowsMarkType(s.type) : Gg(s.type, e.type)) && (a = s.addToSet(a));
      return i.content.push(e.mark(a)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, n, r, o) {
    let i = this.findPlace(e.create(n), r, !1);
    return i && (i = this.enterInner(e, n, r, !0, o)), i;
  }
  // Open a node of the given type
  enterInner(e, n, r, o = !1, i) {
    this.closeExtra();
    let a = this.top;
    a.match = a.match && a.match.matchType(e);
    let s = $g(e, i, a.options);
    a.options & oc && a.content.length == 0 && (s |= oc);
    let l = pt.none;
    return r = r.filter((c) => (a.type ? a.type.allowsMarkType(c.type) : Gg(c.type, e)) ? (l = c.addToSet(l), !1) : !0), this.nodes.push(new Vu(e, n, l, o, null, s)), this.open++, r;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let n = this.nodes.length - 1;
    if (n > this.open) {
      for (; n > this.open; n--)
        this.nodes[n - 1].content.push(this.nodes[n].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let n = this.open; n >= 0; n--) {
      if (this.nodes[n] == e)
        return this.open = n, !0;
      this.localPreserveWS && (this.nodes[n].options |= Lc);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let n = this.open; n >= 0; n--) {
      let r = this.nodes[n].content;
      for (let o = r.length - 1; o >= 0; o--)
        e += r[o].nodeSize;
      n && e++;
    }
    return e;
  }
  findAtPoint(e, n) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == e && this.find[r].offset == n && (this.find[r].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].pos == null && e.nodeType == 1 && e.contains(this.find[n].node) && (this.find[n].pos = this.currentPos);
  }
  findAround(e, n, r) {
    if (e != n && this.find)
      for (let o = 0; o < this.find.length; o++)
        this.find[o].pos == null && e.nodeType == 1 && e.contains(this.find[o].node) && n.compareDocumentPosition(this.find[o].node) & (r ? 2 : 4) && (this.find[o].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == e && (this.find[n].pos = this.currentPos - (e.nodeValue.length - this.find[n].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let n = e.split("/"), r = this.options.context, o = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), i = -(r ? r.depth + 1 : 0) + (o ? 0 : 1), a = (s, l) => {
      for (; s >= 0; s--) {
        let c = n[s];
        if (c == "") {
          if (s == n.length - 1 || s == 0)
            continue;
          for (; l >= i; l--)
            if (a(s - 1, l))
              return !0;
          return !1;
        } else {
          let u = l > 0 || l == 0 && o ? this.nodes[l].type : r && l >= i ? r.node(l - i).type : null;
          if (!u || u.name != c && !u.isInGroup(c))
            return !1;
          l--;
        }
      }
      return !0;
    };
    return a(n.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let n = e.depth; n >= 0; n--) {
        let r = e.node(n).contentMatchAt(e.indexAfter(n)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let n in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[n];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
}
function fDe(t) {
  for (let e = t.firstChild, n = null; e; e = e.nextSibling) {
    let r = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    r && iC.hasOwnProperty(r) && n ? (n.appendChild(e), e = n) : r == "li" ? n = e : r && (n = null);
  }
}
function hDe(t, e) {
  return (t.matches || t.msMatchesSelector || t.webkitMatchesSelector || t.mozMatchesSelector).call(t, e);
}
function Bg(t) {
  let e = {};
  for (let n in t)
    e[n] = t[n];
  return e;
}
function Gg(t, e) {
  let n = e.schema.nodes;
  for (let r in n) {
    let o = n[r];
    if (!o.allowsMarkType(t))
      continue;
    let i = [], a = (s) => {
      i.push(s);
      for (let l = 0; l < s.edgeCount; l++) {
        let { type: c, next: u } = s.edge(l);
        if (c == e || i.indexOf(u) < 0 && a(u))
          return !0;
      }
    };
    if (a(o.contentMatch))
      return !0;
  }
}
class ja {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, n) {
    this.nodes = e, this.marks = n;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, n = {}, r) {
    r || (r = ch(n).createDocumentFragment());
    let o = r, i = [];
    return e.forEach((a) => {
      if (i.length || a.marks.length) {
        let s = 0, l = 0;
        for (; s < i.length && l < a.marks.length; ) {
          let c = a.marks[l];
          if (!this.marks[c.type.name]) {
            l++;
            continue;
          }
          if (!c.eq(i[s][0]) || c.type.spec.spanning === !1)
            break;
          s++, l++;
        }
        for (; s < i.length; )
          o = i.pop()[1];
        for (; l < a.marks.length; ) {
          let c = a.marks[l++], u = this.serializeMark(c, a.isInline, n);
          u && (i.push([c, o]), o.appendChild(u.dom), o = u.contentDOM || u.dom);
        }
      }
      o.appendChild(this.serializeNodeInner(a, n));
    }), r;
  }
  /**
  @internal
  */
  serializeNodeInner(e, n) {
    let { dom: r, contentDOM: o } = ld(ch(n), this.nodes[e.type.name](e), null, e.attrs);
    if (o) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, n, o);
    }
    return r;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, n = {}) {
    let r = this.serializeNodeInner(e, n);
    for (let o = e.marks.length - 1; o >= 0; o--) {
      let i = this.serializeMark(e.marks[o], e.isInline, n);
      i && ((i.contentDOM || i.dom).appendChild(r), r = i.dom);
    }
    return r;
  }
  /**
  @internal
  */
  serializeMark(e, n, r = {}) {
    let o = this.marks[e.type.name];
    return o && ld(ch(r), o(e, n), null, e.attrs);
  }
  static renderSpec(e, n, r = null, o) {
    return ld(e, n, r, o);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new ja(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let n = Fg(e.nodes);
    return n.text || (n.text = (r) => r.text), n;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return Fg(e.marks);
  }
}
function Fg(t) {
  let e = {};
  for (let n in t) {
    let r = t[n].spec.toDOM;
    r && (e[n] = r);
  }
  return e;
}
function ch(t) {
  return t.document || window.document;
}
const Vg = /* @__PURE__ */ new WeakMap();
function _De(t) {
  let e = Vg.get(t);
  return e === void 0 && Vg.set(t, e = EDe(t)), e;
}
function EDe(t) {
  let e = null;
  function n(r) {
    if (r && typeof r == "object")
      if (Array.isArray(r))
        if (typeof r[0] == "string")
          e || (e = []), e.push(r);
        else
          for (let o = 0; o < r.length; o++)
            n(r[o]);
      else
        for (let o in r)
          n(r[o]);
  }
  return n(t), e;
}
function ld(t, e, n, r) {
  if (typeof e == "string")
    return { dom: t.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let o = e[0], i;
  if (typeof o != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (r && (i = _De(r)) && i.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let a = o.indexOf(" ");
  a > 0 && (n = o.slice(0, a), o = o.slice(a + 1));
  let s, l = n ? t.createElementNS(n, o) : t.createElement(o), c = e[1], u = 1;
  if (c && typeof c == "object" && c.nodeType == null && !Array.isArray(c)) {
    u = 2;
    for (let d in c)
      if (c[d] != null) {
        let f = d.indexOf(" ");
        f > 0 ? l.setAttributeNS(d.slice(0, f), d.slice(f + 1), c[d]) : d == "style" && l.style ? l.style.cssText = c[d] : l.setAttribute(d, c[d]);
      }
  }
  for (let d = u; d < e.length; d++) {
    let f = e[d];
    if (f === 0) {
      if (d < e.length - 1 || d > u)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: l, contentDOM: l };
    } else {
      let { dom: h, contentDOM: _ } = ld(t, f, n, r);
      if (l.appendChild(h), _) {
        if (s)
          throw new RangeError("Multiple content holes");
        s = _;
      }
    }
  }
  return { dom: l, contentDOM: s };
}
const aC = 65535, sC = Math.pow(2, 16);
function pDe(t, e) {
  return t + e * sC;
}
function Hg(t) {
  return t & aC;
}
function mDe(t) {
  return (t - (t & aC)) / sC;
}
const lC = 1, cC = 2, cd = 4, uC = 8;
class V0 {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.pos = e, this.delInfo = n, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & uC) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (lC | cd)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (cC | cd)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & cd) > 0;
  }
}
class tr {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, n = !1) {
    if (this.ranges = e, this.inverted = n, !e.length && tr.empty)
      return tr.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let n = 0, r = Hg(e);
    if (!this.inverted)
      for (let o = 0; o < r; o++)
        n += this.ranges[o * 3 + 2] - this.ranges[o * 3 + 1];
    return this.ranges[r * 3] + n + mDe(e);
  }
  mapResult(e, n = 1) {
    return this._map(e, n, !1);
  }
  map(e, n = 1) {
    return this._map(e, n, !0);
  }
  /**
  @internal
  */
  _map(e, n, r) {
    let o = 0, i = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? o : 0);
      if (l > e)
        break;
      let c = this.ranges[s + i], u = this.ranges[s + a], d = l + c;
      if (e <= d) {
        let f = c ? e == l ? -1 : e == d ? 1 : n : n, h = l + o + (f < 0 ? 0 : u);
        if (r)
          return h;
        let _ = e == (n < 0 ? l : d) ? null : pDe(s / 3, e - l), E = e == l ? cC : e == d ? lC : cd;
        return (n < 0 ? e != l : e != d) && (E |= uC), new V0(h, E, _);
      }
      o += u - c;
    }
    return r ? e + o : new V0(e + o, 0, null);
  }
  /**
  @internal
  */
  touches(e, n) {
    let r = 0, o = Hg(n), i = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? r : 0);
      if (l > e)
        break;
      let c = this.ranges[s + i], u = l + c;
      if (e <= u && s == o * 3)
        return !0;
      r += this.ranges[s + a] - c;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let n = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let o = 0, i = 0; o < this.ranges.length; o += 3) {
      let a = this.ranges[o], s = a - (this.inverted ? i : 0), l = a + (this.inverted ? 0 : i), c = this.ranges[o + n], u = this.ranges[o + r];
      e(s, s + c, l, l + u), i += u - c;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new tr(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? tr.empty : new tr(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
tr.empty = new tr([]);
class xc {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e, n, r = 0, o = e ? e.length : 0) {
    this.mirror = n, this.from = r, this.to = o, this._maps = e || [], this.ownData = !(e || n);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, n = this.maps.length) {
    return new xc(this._maps, this.mirror, e, n);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, n) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(e), n != null && this.setMirror(this._maps.length - 1, n);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let n = 0, r = this._maps.length; n < e._maps.length; n++) {
      let o = e.getMirror(n);
      this.appendMap(e._maps[n], o != null && o < n ? r + o : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let n = 0; n < this.mirror.length; n++)
        if (this.mirror[n] == e)
          return this.mirror[n + (n % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, n) {
    this.mirror || (this.mirror = []), this.mirror.push(e, n);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let n = e.maps.length - 1, r = this._maps.length + e._maps.length; n >= 0; n--) {
      let o = e.getMirror(n);
      this.appendMap(e._maps[n].invert(), o != null && o > n ? r - o - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new xc();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, n = 1) {
    if (this.mirror)
      return this._map(e, n, !0);
    for (let r = this.from; r < this.to; r++)
      e = this._maps[r].map(e, n);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, n = 1) {
    return this._map(e, n, !1);
  }
  /**
  @internal
  */
  _map(e, n, r) {
    let o = 0;
    for (let i = this.from; i < this.to; i++) {
      let a = this._maps[i], s = a.mapResult(e, n);
      if (s.recover != null) {
        let l = this.getMirror(i);
        if (l != null && l > i && l < this.to) {
          i = l, e = this._maps[l].recover(s.recover);
          continue;
        }
      }
      o |= s.delInfo, e = s.pos;
    }
    return r ? e : new V0(e, o, null);
  }
}
const uh = /* @__PURE__ */ Object.create(null);
class An {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return tr.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, n) {
    if (!n || !n.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = uh[n.stepType];
    if (!r)
      throw new RangeError(`No step type ${n.stepType} defined`);
    return r.fromJSON(e, n);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, n) {
    if (e in uh)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return uh[e] = n, n.prototype.jsonID = e, n;
  }
}
class qt {
  /**
  @internal
  */
  constructor(e, n) {
    this.doc = e, this.failed = n;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new qt(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new qt(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, n, r, o) {
    try {
      return qt.ok(e.replace(n, r, o));
    } catch (i) {
      if (i instanceof qd)
        return qt.fail(i.message);
      throw i;
    }
  }
}
function t2(t, e, n) {
  let r = [];
  for (let o = 0; o < t.childCount; o++) {
    let i = t.child(o);
    i.content.size && (i = i.copy(t2(i.content, e, i))), i.isInline && (i = e(i, n, o)), r.push(i);
  }
  return _e.fromArray(r);
}
class mi extends An {
  /**
  Create a mark step.
  */
  constructor(e, n, r) {
    super(), this.from = e, this.to = n, this.mark = r;
  }
  apply(e) {
    let n = e.slice(this.from, this.to), r = e.resolve(this.from), o = r.node(r.sharedDepth(this.to)), i = new Ae(t2(n.content, (a, s) => !a.isAtom || !s.type.allowsMarkType(this.mark.type) ? a : a.mark(this.mark.addToSet(a.marks)), o), n.openStart, n.openEnd);
    return qt.fromReplace(e, this.from, this.to, i);
  }
  invert() {
    return new ao(this.from, this.to, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new mi(n.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof mi && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new mi(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new mi(n.from, n.to, e.markFromJSON(n.mark));
  }
}
An.jsonID("addMark", mi);
class ao extends An {
  /**
  Create a mark-removing step.
  */
  constructor(e, n, r) {
    super(), this.from = e, this.to = n, this.mark = r;
  }
  apply(e) {
    let n = e.slice(this.from, this.to), r = new Ae(t2(n.content, (o) => o.mark(this.mark.removeFromSet(o.marks)), e), n.openStart, n.openEnd);
    return qt.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new mi(this.from, this.to, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new ao(n.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof ao && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new ao(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new ao(n.from, n.to, e.markFromJSON(n.mark));
  }
}
An.jsonID("removeMark", ao);
class Ni extends An {
  /**
  Create a node mark step.
  */
  constructor(e, n) {
    super(), this.pos = e, this.mark = n;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return qt.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.addToSet(n.marks));
    return qt.fromReplace(e, this.pos, this.pos + 1, new Ae(_e.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(e) {
    let n = e.nodeAt(this.pos);
    if (n) {
      let r = this.mark.addToSet(n.marks);
      if (r.length == n.marks.length) {
        for (let o = 0; o < n.marks.length; o++)
          if (!n.marks[o].isInSet(r))
            return new Ni(this.pos, n.marks[o]);
        return new Ni(this.pos, this.mark);
      }
    }
    return new La(this.pos, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Ni(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Ni(n.pos, e.markFromJSON(n.mark));
  }
}
An.jsonID("addNodeMark", Ni);
class La extends An {
  /**
  Create a mark-removing step.
  */
  constructor(e, n) {
    super(), this.pos = e, this.mark = n;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return qt.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.removeFromSet(n.marks));
    return qt.fromReplace(e, this.pos, this.pos + 1, new Ae(_e.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(e) {
    let n = e.nodeAt(this.pos);
    return !n || !this.mark.isInSet(n.marks) ? this : new Ni(this.pos, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new La(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new La(n.pos, e.markFromJSON(n.mark));
  }
}
An.jsonID("removeNodeMark", La);
class Qt extends An {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, n, r, o = !1) {
    super(), this.from = e, this.to = n, this.slice = r, this.structure = o;
  }
  apply(e) {
    return this.structure && H0(e, this.from, this.to) ? qt.fail("Structure replace would overwrite content") : qt.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new tr([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new Qt(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deletedAcross && r.deletedAcross ? null : new Qt(n.pos, Math.max(n.pos, r.pos), this.slice, this.structure);
  }
  merge(e) {
    if (!(e instanceof Qt) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let n = this.slice.size + e.slice.size == 0 ? Ae.empty : new Ae(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new Qt(this.from, this.to + (e.to - e.from), n, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let n = this.slice.size + e.slice.size == 0 ? Ae.empty : new Ae(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new Qt(e.from, this.to, n, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new Qt(n.from, n.to, Ae.fromJSON(e, n.slice), !!n.structure);
  }
}
An.jsonID("replace", Qt);
class tn extends An {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, n, r, o, i, a, s = !1) {
    super(), this.from = e, this.to = n, this.gapFrom = r, this.gapTo = o, this.slice = i, this.insert = a, this.structure = s;
  }
  apply(e) {
    if (this.structure && (H0(e, this.from, this.gapFrom) || H0(e, this.gapTo, this.to)))
      return qt.fail("Structure gap-replace would overwrite content");
    let n = e.slice(this.gapFrom, this.gapTo);
    if (n.openStart || n.openEnd)
      return qt.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, n.content);
    return r ? qt.fromReplace(e, this.from, this.to, r) : qt.fail("Content does not fit in gap");
  }
  getMap() {
    return new tr([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let n = this.gapTo - this.gapFrom;
    return new tn(this.from, this.from + this.slice.size + n, this.from + this.insert, this.from + this.insert + n, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1), o = this.from == this.gapFrom ? n.pos : e.map(this.gapFrom, -1), i = this.to == this.gapTo ? r.pos : e.map(this.gapTo, 1);
    return n.deletedAcross && r.deletedAcross || o < n.pos || i > r.pos ? null : new tn(n.pos, r.pos, o, i, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number" || typeof n.gapFrom != "number" || typeof n.gapTo != "number" || typeof n.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new tn(n.from, n.to, n.gapFrom, n.gapTo, Ae.fromJSON(e, n.slice), n.insert, !!n.structure);
  }
}
An.jsonID("replaceAround", tn);
function H0(t, e, n) {
  let r = t.resolve(e), o = n - e, i = r.depth;
  for (; o > 0 && i > 0 && r.indexAfter(i) == r.node(i).childCount; )
    i--, o--;
  if (o > 0) {
    let a = r.node(i).maybeChild(r.indexAfter(i));
    for (; o > 0; ) {
      if (!a || a.isLeaf)
        return !0;
      a = a.firstChild, o--;
    }
  }
  return !1;
}
function NDe(t, e, n, r) {
  let o = [], i = [], a, s;
  t.doc.nodesBetween(e, n, (l, c, u) => {
    if (!l.isInline)
      return;
    let d = l.marks;
    if (!r.isInSet(d) && u.type.allowsMarkType(r.type)) {
      let f = Math.max(c, e), h = Math.min(c + l.nodeSize, n), _ = r.addToSet(d);
      for (let E = 0; E < d.length; E++)
        d[E].isInSet(_) || (a && a.to == f && a.mark.eq(d[E]) ? a.to = h : o.push(a = new ao(f, h, d[E])));
      s && s.to == f ? s.to = h : i.push(s = new mi(f, h, r));
    }
  }), o.forEach((l) => t.step(l)), i.forEach((l) => t.step(l));
}
function vDe(t, e, n, r) {
  let o = [], i = 0;
  t.doc.nodesBetween(e, n, (a, s) => {
    if (!a.isInline)
      return;
    i++;
    let l = null;
    if (r instanceof i1) {
      let c = a.marks, u;
      for (; u = r.isInSet(c); )
        (l || (l = [])).push(u), c = u.removeFromSet(c);
    } else
      r ? r.isInSet(a.marks) && (l = [r]) : l = a.marks;
    if (l && l.length) {
      let c = Math.min(s + a.nodeSize, n);
      for (let u = 0; u < l.length; u++) {
        let d = l[u], f;
        for (let h = 0; h < o.length; h++) {
          let _ = o[h];
          _.step == i - 1 && d.eq(o[h].style) && (f = _);
        }
        f ? (f.to = c, f.step = i) : o.push({ style: d, from: Math.max(s, e), to: c, step: i });
      }
    }
  }), o.forEach((a) => t.step(new ao(a.from, a.to, a.style)));
}
function n2(t, e, n, r = n.contentMatch, o = !0) {
  let i = t.doc.nodeAt(e), a = [], s = e + 1;
  for (let l = 0; l < i.childCount; l++) {
    let c = i.child(l), u = s + c.nodeSize, d = r.matchType(c.type);
    if (!d)
      a.push(new Qt(s, u, Ae.empty));
    else {
      r = d;
      for (let f = 0; f < c.marks.length; f++)
        n.allowsMarkType(c.marks[f].type) || t.step(new ao(s, u, c.marks[f]));
      if (o && c.isText && n.whitespace != "pre") {
        let f, h = /\r?\n|\r/g, _;
        for (; f = h.exec(c.text); )
          _ || (_ = new Ae(_e.from(n.schema.text(" ", n.allowedMarks(c.marks))), 0, 0)), a.push(new Qt(s + f.index, s + f.index + f[0].length, _));
      }
    }
    s = u;
  }
  if (!r.validEnd) {
    let l = r.fillBefore(_e.empty, !0);
    t.replace(s, s, new Ae(l, 0, 0));
  }
  for (let l = a.length - 1; l >= 0; l--)
    t.step(a[l]);
}
function gDe(t, e, n) {
  return (e == 0 || t.canReplace(e, t.childCount)) && (n == t.childCount || t.canReplace(0, n));
}
function Nl(t) {
  let n = t.parent.content.cutByIndex(t.startIndex, t.endIndex);
  for (let r = t.depth, o = 0, i = 0; ; --r) {
    let a = t.$from.node(r), s = t.$from.index(r) + o, l = t.$to.indexAfter(r) - i;
    if (r < t.depth && a.canReplace(s, l, n))
      return r;
    if (r == 0 || a.type.spec.isolating || !gDe(a, s, l))
      break;
    s && (o = 1), l < a.childCount && (i = 1);
  }
  return null;
}
function IDe(t, e, n) {
  let { $from: r, $to: o, depth: i } = e, a = r.before(i + 1), s = o.after(i + 1), l = a, c = s, u = _e.empty, d = 0;
  for (let _ = i, E = !1; _ > n; _--)
    E || r.index(_) > 0 ? (E = !0, u = _e.from(r.node(_).copy(u)), d++) : l--;
  let f = _e.empty, h = 0;
  for (let _ = i, E = !1; _ > n; _--)
    E || o.after(_ + 1) < o.end(_) ? (E = !0, f = _e.from(o.node(_).copy(f)), h++) : c++;
  t.step(new tn(l, c, a, s, new Ae(u.append(f), d, h), u.size - d, !0));
}
function r2(t, e, n = null, r = t) {
  let o = ODe(t, e), i = o && ADe(r, e);
  return i ? o.map(Wg).concat({ type: e, attrs: n }).concat(i.map(Wg)) : null;
}
function Wg(t) {
  return { type: t, attrs: null };
}
function ODe(t, e) {
  let { parent: n, startIndex: r, endIndex: o } = t, i = n.contentMatchAt(r).findWrapping(e);
  if (!i)
    return null;
  let a = i.length ? i[0] : e;
  return n.canReplaceWith(r, o, a) ? i : null;
}
function ADe(t, e) {
  let { parent: n, startIndex: r, endIndex: o } = t, i = n.child(r), a = e.contentMatch.findWrapping(i.type);
  if (!a)
    return null;
  let l = (a.length ? a[a.length - 1] : e).contentMatch;
  for (let c = r; l && c < o; c++)
    l = l.matchType(n.child(c).type);
  return !l || !l.validEnd ? null : a;
}
function DDe(t, e, n) {
  let r = _e.empty;
  for (let a = n.length - 1; a >= 0; a--) {
    if (r.size) {
      let s = n[a].type.contentMatch.matchFragment(r);
      if (!s || !s.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = _e.from(n[a].type.create(n[a].attrs, r));
  }
  let o = e.start, i = e.end;
  t.step(new tn(o, i, o, i, new Ae(r, 0, 0), n.length, !0));
}
function CDe(t, e, n, r, o) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let i = t.steps.length;
  t.doc.nodesBetween(e, n, (a, s) => {
    let l = typeof o == "function" ? o(a) : o;
    if (a.isTextblock && !a.hasMarkup(r, l) && SDe(t.doc, t.mapping.slice(i).map(s), r)) {
      let c = null;
      if (r.schema.linebreakReplacement) {
        let h = r.whitespace == "pre", _ = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
        h && !_ ? c = !1 : !h && _ && (c = !0);
      }
      c === !1 && fC(t, a, s, i), n2(t, t.mapping.slice(i).map(s, 1), r, void 0, c === null);
      let u = t.mapping.slice(i), d = u.map(s, 1), f = u.map(s + a.nodeSize, 1);
      return t.step(new tn(d, f, d + 1, f - 1, new Ae(_e.from(r.create(l, null, a.marks)), 0, 0), 1, !0)), c === !0 && dC(t, a, s, i), !1;
    }
  });
}
function dC(t, e, n, r) {
  e.forEach((o, i) => {
    if (o.isText) {
      let a, s = /\r?\n|\r/g;
      for (; a = s.exec(o.text); ) {
        let l = t.mapping.slice(r).map(n + 1 + i + a.index);
        t.replaceWith(l, l + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function fC(t, e, n, r) {
  e.forEach((o, i) => {
    if (o.type == o.type.schema.linebreakReplacement) {
      let a = t.mapping.slice(r).map(n + 1 + i);
      t.replaceWith(a, a + 1, e.type.schema.text(`
`));
    }
  });
}
function SDe(t, e, n) {
  let r = t.resolve(e), o = r.index();
  return r.parent.canReplaceWith(o, o + 1, n);
}
function wDe(t, e, n, r, o) {
  let i = t.doc.nodeAt(e);
  if (!i)
    throw new RangeError("No node at given position");
  n || (n = i.type);
  let a = n.create(r, null, o || i.marks);
  if (i.isLeaf)
    return t.replaceWith(e, e + i.nodeSize, a);
  if (!n.validContent(i.content))
    throw new RangeError("Invalid content for node type " + n.name);
  t.step(new tn(e, e + i.nodeSize, e + 1, e + i.nodeSize - 1, new Ae(_e.from(a), 0, 0), 1, !0));
}
function bs(t, e, n = 1, r) {
  let o = t.resolve(e), i = o.depth - n, a = r && r[r.length - 1] || o.parent;
  if (i < 0 || o.parent.type.spec.isolating || !o.parent.canReplace(o.index(), o.parent.childCount) || !a.type.validContent(o.parent.content.cutByIndex(o.index(), o.parent.childCount)))
    return !1;
  for (let c = o.depth - 1, u = n - 2; c > i; c--, u--) {
    let d = o.node(c), f = o.index(c);
    if (d.type.spec.isolating)
      return !1;
    let h = d.content.cutByIndex(f, d.childCount), _ = r && r[u + 1];
    _ && (h = h.replaceChild(0, _.type.create(_.attrs)));
    let E = r && r[u] || d;
    if (!d.canReplace(f + 1, d.childCount) || !E.type.validContent(h))
      return !1;
  }
  let s = o.indexAfter(i), l = r && r[0];
  return o.node(i).canReplaceWith(s, s, l ? l.type : o.node(i + 1).type);
}
function TDe(t, e, n = 1, r) {
  let o = t.doc.resolve(e), i = _e.empty, a = _e.empty;
  for (let s = o.depth, l = o.depth - n, c = n - 1; s > l; s--, c--) {
    i = _e.from(o.node(s).copy(i));
    let u = r && r[c];
    a = _e.from(u ? u.type.create(u.attrs, a) : o.node(s).copy(a));
  }
  t.step(new Qt(e, e, new Ae(i.append(a), n, n), !0));
}
function Wi(t, e) {
  let n = t.resolve(e), r = n.index();
  return hC(n.nodeBefore, n.nodeAfter) && n.parent.canReplace(r, r + 1);
}
function bDe(t, e) {
  e.content.size || t.type.compatibleContent(e.type);
  let n = t.contentMatchAt(t.childCount), { linebreakReplacement: r } = t.type.schema;
  for (let o = 0; o < e.childCount; o++) {
    let i = e.child(o), a = i.type == r ? t.type.schema.nodes.text : i.type;
    if (n = n.matchType(a), !n || !t.type.allowsMarks(i.marks))
      return !1;
  }
  return n.validEnd;
}
function hC(t, e) {
  return !!(t && e && !t.isLeaf && bDe(t, e));
}
function a1(t, e, n = -1) {
  let r = t.resolve(e);
  for (let o = r.depth; ; o--) {
    let i, a, s = r.index(o);
    if (o == r.depth ? (i = r.nodeBefore, a = r.nodeAfter) : n > 0 ? (i = r.node(o + 1), s++, a = r.node(o).maybeChild(s)) : (i = r.node(o).maybeChild(s - 1), a = r.node(o + 1)), i && !i.isTextblock && hC(i, a) && r.node(o).canReplace(s, s + 1))
      return e;
    if (o == 0)
      break;
    e = n < 0 ? r.before(o) : r.after(o);
  }
}
function RDe(t, e, n) {
  let r = null, { linebreakReplacement: o } = t.doc.type.schema, i = t.doc.resolve(e - n), a = i.node().type;
  if (o && a.inlineContent) {
    let u = a.whitespace == "pre", d = !!a.contentMatch.matchType(o);
    u && !d ? r = !1 : !u && d && (r = !0);
  }
  let s = t.steps.length;
  if (r === !1) {
    let u = t.doc.resolve(e + n);
    fC(t, u.node(), u.before(), s);
  }
  a.inlineContent && n2(t, e + n - 1, a, i.node().contentMatchAt(i.index()), r == null);
  let l = t.mapping.slice(s), c = l.map(e - n);
  if (t.step(new Qt(c, l.map(e + n, -1), Ae.empty, !0)), r === !0) {
    let u = t.doc.resolve(c);
    dC(t, u.node(), u.before(), t.steps.length);
  }
  return t;
}
function MDe(t, e, n) {
  let r = t.resolve(e);
  if (r.parent.canReplaceWith(r.index(), r.index(), n))
    return e;
  if (r.parentOffset == 0)
    for (let o = r.depth - 1; o >= 0; o--) {
      let i = r.index(o);
      if (r.node(o).canReplaceWith(i, i, n))
        return r.before(o + 1);
      if (i > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let o = r.depth - 1; o >= 0; o--) {
      let i = r.indexAfter(o);
      if (r.node(o).canReplaceWith(i, i, n))
        return r.after(o + 1);
      if (i < r.node(o).childCount)
        return null;
    }
  return null;
}
function _C(t, e, n) {
  let r = t.resolve(e);
  if (!n.content.size)
    return e;
  let o = n.content;
  for (let i = 0; i < n.openStart; i++)
    o = o.firstChild.content;
  for (let i = 1; i <= (n.openStart == 0 && n.size ? 2 : 1); i++)
    for (let a = r.depth; a >= 0; a--) {
      let s = a == r.depth ? 0 : r.pos <= (r.start(a + 1) + r.end(a + 1)) / 2 ? -1 : 1, l = r.index(a) + (s > 0 ? 1 : 0), c = r.node(a), u = !1;
      if (i == 1)
        u = c.canReplace(l, l, o);
      else {
        let d = c.contentMatchAt(l).findWrapping(o.firstChild.type);
        u = d && c.canReplaceWith(l, l, d[0]);
      }
      if (u)
        return s == 0 ? r.pos : s < 0 ? r.before(a + 1) : r.after(a + 1);
    }
  return null;
}
function s1(t, e, n = e, r = Ae.empty) {
  if (e == n && !r.size)
    return null;
  let o = t.resolve(e), i = t.resolve(n);
  return EC(o, i, r) ? new Qt(e, n, r) : new PDe(o, i, r).fit();
}
function EC(t, e, n) {
  return !n.openStart && !n.openEnd && t.start() == e.start() && t.parent.canReplace(t.index(), e.index(), n.content);
}
class PDe {
  constructor(e, n, r) {
    this.$from = e, this.$to = n, this.unplaced = r, this.frontier = [], this.placed = _e.empty;
    for (let o = 0; o <= e.depth; o++) {
      let i = e.node(o);
      this.frontier.push({
        type: i.type,
        match: i.contentMatchAt(e.indexAfter(o))
      });
    }
    for (let o = e.depth; o > 0; o--)
      this.placed = _e.from(e.node(o).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let c = this.findFittable();
      c ? this.placeNodes(c) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), n = this.placed.size - this.depth - this.$from.depth, r = this.$from, o = this.close(e < 0 ? this.$to : r.doc.resolve(e));
    if (!o)
      return null;
    let i = this.placed, a = r.depth, s = o.depth;
    for (; a && s && i.childCount == 1; )
      i = i.firstChild.content, a--, s--;
    let l = new Ae(i, a, s);
    return e > -1 ? new tn(r.pos, e, this.$to.pos, this.$to.end(), l, n) : l.size || r.pos != this.$to.pos ? new Qt(r.pos, o.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let n = this.unplaced.content, r = 0, o = this.unplaced.openEnd; r < e; r++) {
      let i = n.firstChild;
      if (n.childCount > 1 && (o = 0), i.type.spec.isolating && o <= r) {
        e = r;
        break;
      }
      n = i.content;
    }
    for (let n = 1; n <= 2; n++)
      for (let r = n == 1 ? e : this.unplaced.openStart; r >= 0; r--) {
        let o, i = null;
        r ? (i = dh(this.unplaced.content, r - 1).firstChild, o = i.content) : o = this.unplaced.content;
        let a = o.firstChild;
        for (let s = this.depth; s >= 0; s--) {
          let { type: l, match: c } = this.frontier[s], u, d = null;
          if (n == 1 && (a ? c.matchType(a.type) || (d = c.fillBefore(_e.from(a), !1)) : i && l.compatibleContent(i.type)))
            return { sliceDepth: r, frontierDepth: s, parent: i, inject: d };
          if (n == 2 && a && (u = c.findWrapping(a.type)))
            return { sliceDepth: r, frontierDepth: s, parent: i, wrap: u };
          if (i && c.matchType(i.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: n, openEnd: r } = this.unplaced, o = dh(e, n);
    return !o.childCount || o.firstChild.isLeaf ? !1 : (this.unplaced = new Ae(e, n + 1, Math.max(r, o.size + n >= e.size - r ? n + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: n, openEnd: r } = this.unplaced, o = dh(e, n);
    if (o.childCount <= 1 && n > 0) {
      let i = e.size - n <= n + o.size;
      this.unplaced = new Ae(kl(e, n - 1, 1), n - 1, i ? n - 1 : r);
    } else
      this.unplaced = new Ae(kl(e, n, 1), n, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: n, parent: r, inject: o, wrap: i }) {
    for (; this.depth > n; )
      this.closeFrontierNode();
    if (i)
      for (let E = 0; E < i.length; E++)
        this.openFrontierNode(i[E]);
    let a = this.unplaced, s = r ? r.content : a.content, l = a.openStart - e, c = 0, u = [], { match: d, type: f } = this.frontier[n];
    if (o) {
      for (let E = 0; E < o.childCount; E++)
        u.push(o.child(E));
      d = d.matchFragment(o);
    }
    let h = s.size + e - (a.content.size - a.openEnd);
    for (; c < s.childCount; ) {
      let E = s.child(c), m = d.matchType(E.type);
      if (!m)
        break;
      c++, (c > 1 || l == 0 || E.content.size) && (d = m, u.push(pC(E.mark(f.allowedMarks(E.marks)), c == 1 ? l : 0, c == s.childCount ? h : -1)));
    }
    let _ = c == s.childCount;
    _ || (h = -1), this.placed = Bl(this.placed, n, _e.from(u)), this.frontier[n].match = d, _ && h < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let E = 0, m = s; E < h; E++) {
      let N = m.lastChild;
      this.frontier.push({ type: N.type, match: N.contentMatchAt(N.childCount) }), m = N.content;
    }
    this.unplaced = _ ? e == 0 ? Ae.empty : new Ae(kl(a.content, e - 1, 1), e - 1, h < 0 ? a.openEnd : e - 1) : new Ae(kl(a.content, e, c), a.openStart, a.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], n;
    if (!e.type.isTextblock || !fh(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (n = this.findCloseLevel(this.$to)) && n.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, o = this.$to.after(r);
    for (; r > 1 && o == this.$to.end(--r); )
      ++o;
    return o;
  }
  findCloseLevel(e) {
    e:
      for (let n = Math.min(this.depth, e.depth); n >= 0; n--) {
        let { match: r, type: o } = this.frontier[n], i = n < e.depth && e.end(n + 1) == e.pos + (e.depth - (n + 1)), a = fh(e, n, o, r, i);
        if (a) {
          for (let s = n - 1; s >= 0; s--) {
            let { match: l, type: c } = this.frontier[s], u = fh(e, s, c, l, !0);
            if (!u || u.childCount)
              continue e;
          }
          return { depth: n, fit: a, move: i ? e.doc.resolve(e.after(n + 1)) : e };
        }
      }
  }
  close(e) {
    let n = this.findCloseLevel(e);
    if (!n)
      return null;
    for (; this.depth > n.depth; )
      this.closeFrontierNode();
    n.fit.childCount && (this.placed = Bl(this.placed, n.depth, n.fit)), e = n.move;
    for (let r = n.depth + 1; r <= e.depth; r++) {
      let o = e.node(r), i = o.type.contentMatch.fillBefore(o.content, !0, e.index(r));
      this.openFrontierNode(o.type, o.attrs, i);
    }
    return e;
  }
  openFrontierNode(e, n = null, r) {
    let o = this.frontier[this.depth];
    o.match = o.match.matchType(e), this.placed = Bl(this.placed, this.depth, _e.from(e.create(n, r))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let n = this.frontier.pop().match.fillBefore(_e.empty, !0);
    n.childCount && (this.placed = Bl(this.placed, this.frontier.length, n));
  }
}
function kl(t, e, n) {
  return e == 0 ? t.cutByIndex(n, t.childCount) : t.replaceChild(0, t.firstChild.copy(kl(t.firstChild.content, e - 1, n)));
}
function Bl(t, e, n) {
  return e == 0 ? t.append(n) : t.replaceChild(t.childCount - 1, t.lastChild.copy(Bl(t.lastChild.content, e - 1, n)));
}
function dh(t, e) {
  for (let n = 0; n < e; n++)
    t = t.firstChild.content;
  return t;
}
function pC(t, e, n) {
  if (e <= 0)
    return t;
  let r = t.content;
  return e > 1 && (r = r.replaceChild(0, pC(r.firstChild, e - 1, r.childCount == 1 ? n - 1 : 0))), e > 0 && (r = t.type.contentMatch.fillBefore(r).append(r), n <= 0 && (r = r.append(t.type.contentMatch.matchFragment(r).fillBefore(_e.empty, !0)))), t.copy(r);
}
function fh(t, e, n, r, o) {
  let i = t.node(e), a = o ? t.indexAfter(e) : t.index(e);
  if (a == i.childCount && !n.compatibleContent(i.type))
    return null;
  let s = r.fillBefore(i.content, !0, a);
  return s && !yDe(n, i.content, a) ? s : null;
}
function yDe(t, e, n) {
  for (let r = n; r < e.childCount; r++)
    if (!t.allowsMarks(e.child(r).marks))
      return !0;
  return !1;
}
function LDe(t) {
  return t.spec.defining || t.spec.definingForContent;
}
function xDe(t, e, n, r) {
  if (!r.size)
    return t.deleteRange(e, n);
  let o = t.doc.resolve(e), i = t.doc.resolve(n);
  if (EC(o, i, r))
    return t.step(new Qt(e, n, r));
  let a = NC(o, i);
  a[a.length - 1] == 0 && a.pop();
  let s = -(o.depth + 1);
  a.unshift(s);
  for (let f = o.depth, h = o.pos - 1; f > 0; f--, h--) {
    let _ = o.node(f).type.spec;
    if (_.defining || _.definingAsContext || _.isolating)
      break;
    a.indexOf(f) > -1 ? s = f : o.before(f) == h && a.splice(1, 0, -f);
  }
  let l = a.indexOf(s), c = [], u = r.openStart;
  for (let f = r.content, h = 0; ; h++) {
    let _ = f.firstChild;
    if (c.push(_), h == r.openStart)
      break;
    f = _.content;
  }
  for (let f = u - 1; f >= 0; f--) {
    let h = c[f], _ = LDe(h.type);
    if (_ && !h.sameMarkup(o.node(Math.abs(s) - 1)))
      u = f;
    else if (_ || !h.type.isTextblock)
      break;
  }
  for (let f = r.openStart; f >= 0; f--) {
    let h = (f + u + 1) % (r.openStart + 1), _ = c[h];
    if (_)
      for (let E = 0; E < a.length; E++) {
        let m = a[(E + l) % a.length], N = !0;
        m < 0 && (N = !1, m = -m);
        let I = o.node(m - 1), O = o.index(m - 1);
        if (I.canReplaceWith(O, O, _.type, _.marks))
          return t.replace(o.before(m), N ? i.after(m) : n, new Ae(mC(r.content, 0, r.openStart, h), h, r.openEnd));
      }
  }
  let d = t.steps.length;
  for (let f = a.length - 1; f >= 0 && (t.replace(e, n, r), !(t.steps.length > d)); f--) {
    let h = a[f];
    h < 0 || (e = o.before(h), n = i.after(h));
  }
}
function mC(t, e, n, r, o) {
  if (e < n) {
    let i = t.firstChild;
    t = t.replaceChild(0, i.copy(mC(i.content, e + 1, n, r, i)));
  }
  if (e > r) {
    let i = o.contentMatchAt(0), a = i.fillBefore(t).append(t);
    t = a.append(i.matchFragment(a).fillBefore(_e.empty, !0));
  }
  return t;
}
function UDe(t, e, n, r) {
  if (!r.isInline && e == n && t.doc.resolve(e).parent.content.size) {
    let o = MDe(t.doc, e, r.type);
    o != null && (e = n = o);
  }
  t.replaceRange(e, n, new Ae(_e.from(r), 0, 0));
}
function $De(t, e, n) {
  let r = t.doc.resolve(e), o = t.doc.resolve(n), i = NC(r, o);
  for (let a = 0; a < i.length; a++) {
    let s = i[a], l = a == i.length - 1;
    if (l && s == 0 || r.node(s).type.contentMatch.validEnd)
      return t.delete(r.start(s), o.end(s));
    if (s > 0 && (l || r.node(s - 1).canReplace(r.index(s - 1), o.indexAfter(s - 1))))
      return t.delete(r.before(s), o.after(s));
  }
  for (let a = 1; a <= r.depth && a <= o.depth; a++)
    if (e - r.start(a) == r.depth - a && n > r.end(a) && o.end(a) - n != o.depth - a && r.start(a - 1) == o.start(a - 1) && r.node(a - 1).canReplace(r.index(a - 1), o.index(a - 1)))
      return t.delete(r.before(a), n);
  t.delete(e, n);
}
function NC(t, e) {
  let n = [], r = Math.min(t.depth, e.depth);
  for (let o = r; o >= 0; o--) {
    let i = t.start(o);
    if (i < t.pos - (t.depth - o) || e.end(o) > e.pos + (e.depth - o) || t.node(o).type.spec.isolating || e.node(o).type.spec.isolating)
      break;
    (i == e.start(o) || o == t.depth && o == e.depth && t.parent.inlineContent && e.parent.inlineContent && o && e.start(o - 1) == i - 1) && n.push(o);
  }
  return n;
}
class Rs extends An {
  /**
  Construct an attribute step.
  */
  constructor(e, n, r) {
    super(), this.pos = e, this.attr = n, this.value = r;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return qt.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let i in n.attrs)
      r[i] = n.attrs[i];
    r[this.attr] = this.value;
    let o = n.type.create(r, null, n.marks);
    return qt.fromReplace(e, this.pos, this.pos + 1, new Ae(_e.from(o), 0, n.isLeaf ? 0 : 1));
  }
  getMap() {
    return tr.empty;
  }
  invert(e) {
    return new Rs(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Rs(n.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, n) {
    if (typeof n.pos != "number" || typeof n.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new Rs(n.pos, n.attr, n.value);
  }
}
An.jsonID("attr", Rs);
class Uc extends An {
  /**
  Construct an attribute step.
  */
  constructor(e, n) {
    super(), this.attr = e, this.value = n;
  }
  apply(e) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let o in e.attrs)
      n[o] = e.attrs[o];
    n[this.attr] = this.value;
    let r = e.type.create(n, e.content, e.marks);
    return qt.ok(r);
  }
  getMap() {
    return tr.empty;
  }
  invert(e) {
    return new Uc(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, n) {
    if (typeof n.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new Uc(n.attr, n.value);
  }
}
An.jsonID("docAttr", Uc);
let zs = class extends Error {
};
zs = function t(e) {
  let n = Error.call(this, e);
  return n.__proto__ = t.prototype, n;
};
zs.prototype = Object.create(Error.prototype);
zs.prototype.constructor = zs;
zs.prototype.name = "TransformError";
class kDe {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new xc();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let n = this.maybeStep(e);
    if (n.failed)
      throw new zs(n.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let n = e.apply(this.doc);
    return n.failed || this.addStep(e, n.doc), n;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  Return a single range, in post-transform document positions,
  that covers all content changed by this transform. Returns null
  if no replacements are made. Note that this will ignore changes
  that add/remove marks without replacing the underlying content.
  */
  changedRange() {
    let e = 1e9, n = -1e9;
    for (let r = 0; r < this.mapping.maps.length; r++) {
      let o = this.mapping.maps[r];
      r && (e = o.map(e, 1), n = o.map(n, -1)), o.forEach((i, a, s, l) => {
        e = Math.min(e, s), n = Math.max(n, l);
      });
    }
    return e == 1e9 ? null : { from: e, to: n };
  }
  /**
  @internal
  */
  addStep(e, n) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = n;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, n = e, r = Ae.empty) {
    let o = s1(this.doc, e, n, r);
    return o && this.step(o), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, n, r) {
    return this.replace(e, n, new Ae(_e.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, n) {
    return this.replace(e, n, Ae.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, n) {
    return this.replaceWith(e, e, n);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, n, r) {
    return xDe(this, e, n, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, n, r) {
    return UDe(this, e, n, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, n) {
    return $De(this, e, n), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, n) {
    return IDe(this, e, n), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, n = 1) {
    return RDe(this, e, n), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, n) {
    return DDe(this, e, n), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, n = e, r, o = null) {
    return CDe(this, e, n, r, o), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, n, r = null, o) {
    return wDe(this, e, n, r, o), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, n, r) {
    return this.step(new Rs(e, n, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, n) {
    return this.step(new Uc(e, n)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, n) {
    return this.step(new Ni(e, n)), this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, n) {
    let r = this.doc.nodeAt(e);
    if (!r)
      throw new RangeError("No node at position " + e);
    if (n instanceof pt)
      n.isInSet(r.marks) && this.step(new La(e, n));
    else {
      let o = r.marks, i, a = [];
      for (; i = n.isInSet(o); )
        a.push(new La(e, i)), o = i.removeFromSet(o);
      for (let s = a.length - 1; s >= 0; s--)
        this.step(a[s]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(e, n = 1, r) {
    return TDe(this, e, n, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, n, r) {
    return NDe(this, e, n, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, n, r) {
    return vDe(this, e, n, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, n, r) {
    return n2(this, e, n, r), this;
  }
}
const hh = /* @__PURE__ */ Object.create(null);
class qe {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, n, r) {
    this.$anchor = e, this.$head = n, this.ranges = r || [new BDe(e.min(n), e.max(n))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let n = 0; n < e.length; n++)
      if (e[n].$from.pos != e[n].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, n = Ae.empty) {
    let r = n.content.lastChild, o = null;
    for (let s = 0; s < n.openEnd; s++)
      o = r, r = r.lastChild;
    let i = e.steps.length, a = this.ranges;
    for (let s = 0; s < a.length; s++) {
      let { $from: l, $to: c } = a[s], u = e.mapping.slice(i);
      e.replaceRange(u.map(l.pos), u.map(c.pos), s ? Ae.empty : n), s == 0 && zg(e, i, (r ? r.isInline : o && o.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, n) {
    let r = e.steps.length, o = this.ranges;
    for (let i = 0; i < o.length; i++) {
      let { $from: a, $to: s } = o[i], l = e.mapping.slice(r), c = l.map(a.pos), u = l.map(s.pos);
      i ? e.deleteRange(c, u) : (e.replaceRangeWith(c, u, n), zg(e, r, n.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, n, r = !1) {
    let o = e.parent.inlineContent ? new Ke(e) : Es(e.node(0), e.parent, e.pos, e.index(), n, r);
    if (o)
      return o;
    for (let i = e.depth - 1; i >= 0; i--) {
      let a = n < 0 ? Es(e.node(0), e.node(i), e.before(i + 1), e.index(i), n, r) : Es(e.node(0), e.node(i), e.after(i + 1), e.index(i) + 1, n, r);
      if (a)
        return a;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, n = 1) {
    return this.findFrom(e, n) || this.findFrom(e, -n) || new Er(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return Es(e, e, 0, 0, 1) || new Er(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return Es(e, e, e.content.size, e.childCount, -1) || new Er(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, n) {
    if (!n || !n.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = hh[n.type];
    if (!r)
      throw new RangeError(`No selection type ${n.type} defined`);
    return r.fromJSON(e, n);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, n) {
    if (e in hh)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return hh[e] = n, n.prototype.jsonID = e, n;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Ke.between(this.$anchor, this.$head).getBookmark();
  }
}
qe.prototype.visible = !0;
class BDe {
  /**
  Create a range.
  */
  constructor(e, n) {
    this.$from = e, this.$to = n;
  }
}
let Yg = !1;
function Kg(t) {
  !Yg && !t.parent.inlineContent && (Yg = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + t.parent.type.name + ")"));
}
class Ke extends qe {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, n = e) {
    Kg(e), Kg(n), super(e, n);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, n) {
    let r = e.resolve(n.map(this.head));
    if (!r.parent.inlineContent)
      return qe.near(r);
    let o = e.resolve(n.map(this.anchor));
    return new Ke(o.parent.inlineContent ? o : r, r);
  }
  replace(e, n = Ae.empty) {
    if (super.replace(e, n), n == Ae.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && e.ensureMarks(r);
    }
  }
  eq(e) {
    return e instanceof Ke && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new l1(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.anchor != "number" || typeof n.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Ke(e.resolve(n.anchor), e.resolve(n.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, n, r = n) {
    let o = e.resolve(n);
    return new this(o, r == n ? o : e.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, n, r) {
    let o = e.pos - n.pos;
    if ((!r || o) && (r = o >= 0 ? 1 : -1), !n.parent.inlineContent) {
      let i = qe.findFrom(n, r, !0) || qe.findFrom(n, -r, !0);
      if (i)
        n = i.$head;
      else
        return qe.near(n, r);
    }
    return e.parent.inlineContent || (o == 0 ? e = n : (e = (qe.findFrom(e, -r, !0) || qe.findFrom(e, r, !0)).$anchor, e.pos < n.pos != o < 0 && (e = n))), new Ke(e, n);
  }
}
qe.jsonID("text", Ke);
class l1 {
  constructor(e, n) {
    this.anchor = e, this.head = n;
  }
  map(e) {
    return new l1(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return Ke.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class ke extends qe {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let n = e.nodeAfter, r = e.node(0).resolve(e.pos + n.nodeSize);
    super(e, r), this.node = n;
  }
  map(e, n) {
    let { deleted: r, pos: o } = n.mapResult(this.anchor), i = e.resolve(o);
    return r ? qe.near(i) : new ke(i);
  }
  content() {
    return new Ae(_e.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof ke && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new o2(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new ke(e.resolve(n.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, n) {
    return new ke(e.resolve(n));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
ke.prototype.visible = !1;
qe.jsonID("node", ke);
class o2 {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: n, pos: r } = e.mapResult(this.anchor);
    return n ? new l1(r, r) : new o2(r);
  }
  resolve(e) {
    let n = e.resolve(this.anchor), r = n.nodeAfter;
    return r && ke.isSelectable(r) ? new ke(n) : qe.near(n);
  }
}
class Er extends qe {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, n = Ae.empty) {
    if (n == Ae.empty) {
      e.delete(0, e.doc.content.size);
      let r = qe.atStart(e.doc);
      r.eq(e.selection) || e.setSelection(r);
    } else
      super.replace(e, n);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new Er(e);
  }
  map(e) {
    return new Er(e);
  }
  eq(e) {
    return e instanceof Er;
  }
  getBookmark() {
    return GDe;
  }
}
qe.jsonID("all", Er);
const GDe = {
  map() {
    return this;
  },
  resolve(t) {
    return new Er(t);
  }
};
function Es(t, e, n, r, o, i = !1) {
  if (e.inlineContent)
    return Ke.create(t, n);
  for (let a = r - (o > 0 ? 0 : 1); o > 0 ? a < e.childCount : a >= 0; a += o) {
    let s = e.child(a);
    if (s.isAtom) {
      if (!i && ke.isSelectable(s))
        return ke.create(t, n - (o < 0 ? s.nodeSize : 0));
    } else {
      let l = Es(t, s, n + o, o < 0 ? s.childCount : 0, o, i);
      if (l)
        return l;
    }
    n += s.nodeSize * o;
  }
  return null;
}
function zg(t, e, n) {
  let r = t.steps.length - 1;
  if (r < e)
    return;
  let o = t.steps[r];
  if (!(o instanceof Qt || o instanceof tn))
    return;
  let i = t.mapping.maps[r], a;
  i.forEach((s, l, c, u) => {
    a == null && (a = u);
  }), t.setSelection(qe.near(t.doc.resolve(a), n));
}
const Zg = 1, Hu = 2, qg = 4;
class FDe extends kDe {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | Zg) & ~Hu, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & Zg) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= Hu, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return pt.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & Hu) > 0;
  }
  /**
  @internal
  */
  addStep(e, n) {
    super.addStep(e, n), this.updated = this.updated & ~Hu, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, n = !0) {
    let r = this.selection;
    return n && (e = e.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || pt.none))), r.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, n, r) {
    let o = this.doc.type.schema;
    if (n == null)
      return e ? this.replaceSelectionWith(o.text(e), !0) : this.deleteSelection();
    {
      if (r == null && (r = n), !e)
        return this.deleteRange(n, r);
      let i = this.storedMarks;
      if (!i) {
        let a = this.doc.resolve(n);
        i = r == n ? a.marks() : a.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(n, r, o.text(e, i)), !this.selection.empty && this.selection.to == n + e.length && this.setSelection(qe.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, n) {
    return this.meta[typeof e == "string" ? e : e.key] = n, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= qg, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & qg) > 0;
  }
}
function Xg(t, e) {
  return !e || !t ? t : t.bind(e);
}
class Gl {
  constructor(e, n, r) {
    this.name = e, this.init = Xg(n.init, r), this.apply = Xg(n.apply, r);
  }
}
const VDe = [
  new Gl("doc", {
    init(t) {
      return t.doc || t.schema.topNodeType.createAndFill();
    },
    apply(t) {
      return t.doc;
    }
  }),
  new Gl("selection", {
    init(t, e) {
      return t.selection || qe.atStart(e.doc);
    },
    apply(t) {
      return t.selection;
    }
  }),
  new Gl("storedMarks", {
    init(t) {
      return t.storedMarks || null;
    },
    apply(t, e, n, r) {
      return r.selection.$cursor ? t.storedMarks : null;
    }
  }),
  new Gl("scrollToSelection", {
    init() {
      return 0;
    },
    apply(t, e) {
      return t.scrolledIntoView ? e + 1 : e;
    }
  })
];
class _h {
  constructor(e, n) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = VDe.slice(), n && n.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new Gl(r.key, r.spec.state, r));
    });
  }
}
class Cs {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, n = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != n) {
        let o = this.config.plugins[r];
        if (o.spec.filterTransaction && !o.spec.filterTransaction.call(o, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let n = [e], r = this.applyInner(e), o = null;
    for (; ; ) {
      let i = !1;
      for (let a = 0; a < this.config.plugins.length; a++) {
        let s = this.config.plugins[a];
        if (s.spec.appendTransaction) {
          let l = o ? o[a].n : 0, c = o ? o[a].state : this, u = l < n.length && s.spec.appendTransaction.call(s, l ? n.slice(l) : n, c, r);
          if (u && r.filterTransaction(u, a)) {
            if (u.setMeta("appendedTransaction", e), !o) {
              o = [];
              for (let d = 0; d < this.config.plugins.length; d++)
                o.push(d < a ? { state: r, n: n.length } : { state: this, n: 0 });
            }
            n.push(u), r = r.applyInner(u), i = !0;
          }
          o && (o[a] = { state: r, n: n.length });
        }
      }
      if (!i)
        return { state: r, transactions: n };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let n = new Cs(this.config), r = this.config.fields;
    for (let o = 0; o < r.length; o++) {
      let i = r[o];
      n[i.name] = i.apply(e, this[i.name], this, n);
    }
    return n;
  }
  /**
  Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new FDe(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let n = new _h(e.doc ? e.doc.type.schema : e.schema, e.plugins), r = new Cs(n);
    for (let o = 0; o < n.fields.length; o++)
      r[n.fields[o].name] = n.fields[o].init(e, r);
    return r;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let n = new _h(this.schema, e.plugins), r = n.fields, o = new Cs(n);
    for (let i = 0; i < r.length; i++) {
      let a = r[i].name;
      o[a] = this.hasOwnProperty(a) ? this[a] : r[i].init(e, o);
    }
    return o;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let n = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (n.storedMarks = this.storedMarks.map((r) => r.toJSON())), e && typeof e == "object")
      for (let r in e) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let o = e[r], i = o.spec.state;
        i && i.toJSON && (n[r] = i.toJSON.call(o, this[o.key]));
      }
    return n;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, n, r) {
    if (!n)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let o = new _h(e.schema, e.plugins), i = new Cs(o);
    return o.fields.forEach((a) => {
      if (a.name == "doc")
        i.doc = Ai.fromJSON(e.schema, n.doc);
      else if (a.name == "selection")
        i.selection = qe.fromJSON(i.doc, n.selection);
      else if (a.name == "storedMarks")
        n.storedMarks && (i.storedMarks = n.storedMarks.map(e.schema.markFromJSON));
      else {
        if (r)
          for (let s in r) {
            let l = r[s], c = l.spec.state;
            if (l.key == a.name && c && c.fromJSON && Object.prototype.hasOwnProperty.call(n, s)) {
              i[a.name] = c.fromJSON.call(l, e, n[s], i);
              return;
            }
          }
        i[a.name] = a.init(e, i);
      }
    }), i;
  }
}
function vC(t, e, n) {
  for (let r in t) {
    let o = t[r];
    o instanceof Function ? o = o.bind(e) : r == "handleDOMEvents" && (o = vC(o, e, {})), n[r] = o;
  }
  return n;
}
class Dn {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && vC(e.props, this, this.props), this.key = e.key ? e.key.key : gC("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const Eh = /* @__PURE__ */ Object.create(null);
function gC(t) {
  return t in Eh ? t + "$" + ++Eh[t] : (Eh[t] = 0, t + "$");
}
class Mr {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = gC(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const cn = function(t) {
  for (var e = 0; ; e++)
    if (t = t.previousSibling, !t)
      return e;
}, Zs = function(t) {
  let e = t.assignedSlot || t.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let W0 = null;
const Po = function(t, e, n) {
  let r = W0 || (W0 = document.createRange());
  return r.setEnd(t, n ?? t.nodeValue.length), r.setStart(t, e || 0), r;
}, HDe = function() {
  W0 = null;
}, xa = function(t, e, n, r) {
  return n && (jg(t, e, n, r, -1) || jg(t, e, n, r, 1));
}, WDe = /^(img|br|input|textarea|hr)$/i;
function jg(t, e, n, r, o) {
  for (var i; ; ) {
    if (t == n && e == r)
      return !0;
    if (e == (o < 0 ? 0 : dr(t))) {
      let a = t.parentNode;
      if (!a || a.nodeType != 1 || hu(t) || WDe.test(t.nodeName) || t.contentEditable == "false")
        return !1;
      e = cn(t) + (o < 0 ? 0 : 1), t = a;
    } else if (t.nodeType == 1) {
      let a = t.childNodes[e + (o < 0 ? -1 : 0)];
      if (a.nodeType == 1 && a.contentEditable == "false")
        if (!((i = a.pmViewDesc) === null || i === void 0) && i.ignoreForSelection)
          e += o;
        else
          return !1;
      else
        t = a, e = o < 0 ? dr(t) : 0;
    } else
      return !1;
  }
}
function dr(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function YDe(t, e) {
  for (; ; ) {
    if (t.nodeType == 3 && e)
      return t;
    if (t.nodeType == 1 && e > 0) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[e - 1], e = dr(t);
    } else if (t.parentNode && !hu(t))
      e = cn(t), t = t.parentNode;
    else
      return null;
  }
}
function KDe(t, e) {
  for (; ; ) {
    if (t.nodeType == 3 && e < t.nodeValue.length)
      return t;
    if (t.nodeType == 1 && e < t.childNodes.length) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[e], e = 0;
    } else if (t.parentNode && !hu(t))
      e = cn(t) + 1, t = t.parentNode;
    else
      return null;
  }
}
function zDe(t, e, n) {
  for (let r = e == 0, o = e == dr(t); r || o; ) {
    if (t == n)
      return !0;
    let i = cn(t);
    if (t = t.parentNode, !t)
      return !1;
    r = r && i == 0, o = o && i == dr(t);
  }
}
function hu(t) {
  let e;
  for (let n = t; n && !(e = n.pmViewDesc); n = n.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == t || e.contentDOM == t);
}
const c1 = function(t) {
  return t.focusNode && xa(t.focusNode, t.focusOffset, t.anchorNode, t.anchorOffset);
};
function ia(t, e) {
  let n = document.createEvent("Event");
  return n.initEvent("keydown", !0, !0), n.keyCode = t, n.key = n.code = e, n;
}
function ZDe(t) {
  let e = t.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function qDe(t, e, n) {
  if (t.caretPositionFromPoint)
    try {
      let r = t.caretPositionFromPoint(e, n);
      if (r)
        return { node: r.offsetNode, offset: Math.min(dr(r.offsetNode), r.offset) };
    } catch {
    }
  if (t.caretRangeFromPoint) {
    let r = t.caretRangeFromPoint(e, n);
    if (r)
      return { node: r.startContainer, offset: Math.min(dr(r.startContainer), r.startOffset) };
  }
}
const mo = typeof navigator < "u" ? navigator : null, Jg = typeof document < "u" ? document : null, Yi = mo && mo.userAgent || "", Y0 = /Edge\/(\d+)/.exec(Yi), IC = /MSIE \d/.exec(Yi), K0 = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Yi), Yn = !!(IC || K0 || Y0), Ci = IC ? document.documentMode : K0 ? +K0[1] : Y0 ? +Y0[1] : 0, pr = !Yn && /gecko\/(\d+)/i.test(Yi);
pr && +(/Firefox\/(\d+)/.exec(Yi) || [0, 0])[1];
const z0 = !Yn && /Chrome\/(\d+)/.exec(Yi), hn = !!z0, OC = z0 ? +z0[1] : 0, In = !Yn && !!mo && /Apple Computer/.test(mo.vendor), qs = In && (/Mobile\/\w+/.test(Yi) || !!mo && mo.maxTouchPoints > 2), sr = qs || (mo ? /Mac/.test(mo.platform) : !1), AC = mo ? /Win/.test(mo.platform) : !1, $o = /Android \d/.test(Yi), _u = !!Jg && "webkitFontSmoothing" in Jg.documentElement.style, XDe = _u ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function jDe(t) {
  let e = t.defaultView && t.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: t.documentElement.clientWidth,
    top: 0,
    bottom: t.documentElement.clientHeight
  };
}
function Ro(t, e) {
  return typeof t == "number" ? t : t[e];
}
function JDe(t) {
  let e = t.getBoundingClientRect(), n = e.width / t.offsetWidth || 1, r = e.height / t.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + t.clientWidth * n,
    top: e.top,
    bottom: e.top + t.clientHeight * r
  };
}
function Qg(t, e, n) {
  let r = t.someProp("scrollThreshold") || 0, o = t.someProp("scrollMargin") || 5, i = t.dom.ownerDocument;
  for (let a = n || t.dom; a; ) {
    if (a.nodeType != 1) {
      a = Zs(a);
      continue;
    }
    let s = a, l = s == i.body, c = l ? jDe(i) : JDe(s), u = 0, d = 0;
    if (e.top < c.top + Ro(r, "top") ? d = -(c.top - e.top + Ro(o, "top")) : e.bottom > c.bottom - Ro(r, "bottom") && (d = e.bottom - e.top > c.bottom - c.top ? e.top + Ro(o, "top") - c.top : e.bottom - c.bottom + Ro(o, "bottom")), e.left < c.left + Ro(r, "left") ? u = -(c.left - e.left + Ro(o, "left")) : e.right > c.right - Ro(r, "right") && (u = e.right - c.right + Ro(o, "right")), u || d)
      if (l)
        i.defaultView.scrollBy(u, d);
      else {
        let h = s.scrollLeft, _ = s.scrollTop;
        d && (s.scrollTop += d), u && (s.scrollLeft += u);
        let E = s.scrollLeft - h, m = s.scrollTop - _;
        e = { left: e.left - E, top: e.top - m, right: e.right - E, bottom: e.bottom - m };
      }
    let f = l ? "fixed" : getComputedStyle(a).position;
    if (/^(fixed|sticky)$/.test(f))
      break;
    a = f == "absolute" ? a.offsetParent : Zs(a);
  }
}
function QDe(t) {
  let e = t.dom.getBoundingClientRect(), n = Math.max(0, e.top), r, o;
  for (let i = (e.left + e.right) / 2, a = n + 1; a < Math.min(innerHeight, e.bottom); a += 5) {
    let s = t.root.elementFromPoint(i, a);
    if (!s || s == t.dom || !t.dom.contains(s))
      continue;
    let l = s.getBoundingClientRect();
    if (l.top >= n - 20) {
      r = s, o = l.top;
      break;
    }
  }
  return { refDOM: r, refTop: o, stack: DC(t.dom) };
}
function DC(t) {
  let e = [], n = t.ownerDocument;
  for (let r = t; r && (e.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), t != n); r = Zs(r))
    ;
  return e;
}
function e6e({ refDOM: t, refTop: e, stack: n }) {
  let r = t ? t.getBoundingClientRect().top : 0;
  CC(n, r == 0 ? 0 : r - e);
}
function CC(t, e) {
  for (let n = 0; n < t.length; n++) {
    let { dom: r, top: o, left: i } = t[n];
    r.scrollTop != o + e && (r.scrollTop = o + e), r.scrollLeft != i && (r.scrollLeft = i);
  }
}
let ss = null;
function t6e(t) {
  if (t.setActive)
    return t.setActive();
  if (ss)
    return t.focus(ss);
  let e = DC(t);
  t.focus(ss == null ? {
    get preventScroll() {
      return ss = { preventScroll: !0 }, !0;
    }
  } : void 0), ss || (ss = !1, CC(e, 0));
}
function SC(t, e) {
  let n, r = 2e8, o, i = 0, a = e.top, s = e.top, l, c;
  for (let u = t.firstChild, d = 0; u; u = u.nextSibling, d++) {
    let f;
    if (u.nodeType == 1)
      f = u.getClientRects();
    else if (u.nodeType == 3)
      f = Po(u).getClientRects();
    else
      continue;
    for (let h = 0; h < f.length; h++) {
      let _ = f[h];
      if (_.top <= a && _.bottom >= s) {
        a = Math.max(_.bottom, a), s = Math.min(_.top, s);
        let E = _.left > e.left ? _.left - e.left : _.right < e.left ? e.left - _.right : 0;
        if (E < r) {
          n = u, r = E, o = E && n.nodeType == 3 ? {
            left: _.right < e.left ? _.right : _.left,
            top: e.top
          } : e, u.nodeType == 1 && E && (i = d + (e.left >= (_.left + _.right) / 2 ? 1 : 0));
          continue;
        }
      } else
        _.top > e.top && !l && _.left <= e.left && _.right >= e.left && (l = u, c = { left: Math.max(_.left, Math.min(_.right, e.left)), top: _.top });
      !n && (e.left >= _.right && e.top >= _.top || e.left >= _.left && e.top >= _.bottom) && (i = d + 1);
    }
  }
  return !n && l && (n = l, o = c, r = 0), n && n.nodeType == 3 ? n6e(n, o) : !n || r && n.nodeType == 1 ? { node: t, offset: i } : SC(n, o);
}
function n6e(t, e) {
  let n = t.nodeValue.length, r = document.createRange(), o;
  for (let i = 0; i < n; i++) {
    r.setEnd(t, i + 1), r.setStart(t, i);
    let a = ai(r, 1);
    if (a.top != a.bottom && i2(e, a)) {
      o = { node: t, offset: i + (e.left >= (a.left + a.right) / 2 ? 1 : 0) };
      break;
    }
  }
  return r.detach(), o || { node: t, offset: 0 };
}
function i2(t, e) {
  return t.left >= e.left - 1 && t.left <= e.right + 1 && t.top >= e.top - 1 && t.top <= e.bottom + 1;
}
function r6e(t, e) {
  let n = t.parentNode;
  return n && /^li$/i.test(n.nodeName) && e.left < t.getBoundingClientRect().left ? n : t;
}
function o6e(t, e, n) {
  let { node: r, offset: o } = SC(e, n), i = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let a = r.getBoundingClientRect();
    i = a.left != a.right && n.left > (a.left + a.right) / 2 ? 1 : -1;
  }
  return t.docView.posFromDOM(r, o, i);
}
function i6e(t, e, n, r) {
  let o = -1;
  for (let i = e, a = !1; i != t.dom; ) {
    let s = t.docView.nearestDesc(i, !0), l;
    if (!s)
      return null;
    if (s.dom.nodeType == 1 && (s.node.isBlock && s.parent || !s.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((l = s.dom.getBoundingClientRect()).width || l.height) && (s.node.isBlock && s.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(s.dom.nodeName) && (!a && l.left > r.left || l.top > r.top ? o = s.posBefore : (!a && l.right < r.left || l.bottom < r.top) && (o = s.posAfter), a = !0), !s.contentDOM && o < 0 && !s.node.isText))
      return (s.node.isBlock ? r.top < (l.top + l.bottom) / 2 : r.left < (l.left + l.right) / 2) ? s.posBefore : s.posAfter;
    i = s.dom.parentNode;
  }
  return o > -1 ? o : t.docView.posFromDOM(e, n, -1);
}
function wC(t, e, n) {
  let r = t.childNodes.length;
  if (r && n.top < n.bottom)
    for (let o = Math.max(0, Math.min(r - 1, Math.floor(r * (e.top - n.top) / (n.bottom - n.top)) - 2)), i = o; ; ) {
      let a = t.childNodes[i];
      if (a.nodeType == 1) {
        let s = a.getClientRects();
        for (let l = 0; l < s.length; l++) {
          let c = s[l];
          if (i2(e, c))
            return wC(a, e, c);
        }
      }
      if ((i = (i + 1) % r) == o)
        break;
    }
  return t;
}
function a6e(t, e) {
  let n = t.dom.ownerDocument, r, o = 0, i = qDe(n, e.left, e.top);
  i && ({ node: r, offset: o } = i);
  let a = (t.root.elementFromPoint ? t.root : n).elementFromPoint(e.left, e.top), s;
  if (!a || !t.dom.contains(a.nodeType != 1 ? a.parentNode : a)) {
    let c = t.dom.getBoundingClientRect();
    if (!i2(e, c) || (a = wC(t.dom, e, c), !a))
      return null;
  }
  if (In)
    for (let c = a; r && c; c = Zs(c))
      c.draggable && (r = void 0);
  if (a = r6e(a, e), r) {
    if (pr && r.nodeType == 1 && (o = Math.min(o, r.childNodes.length), o < r.childNodes.length)) {
      let u = r.childNodes[o], d;
      u.nodeName == "IMG" && (d = u.getBoundingClientRect()).right <= e.left && d.bottom > e.top && o++;
    }
    let c;
    _u && o && r.nodeType == 1 && (c = r.childNodes[o - 1]).nodeType == 1 && c.contentEditable == "false" && c.getBoundingClientRect().top >= e.top && o--, r == t.dom && o == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && e.top > r.lastChild.getBoundingClientRect().bottom ? s = t.state.doc.content.size : (o == 0 || r.nodeType != 1 || r.childNodes[o - 1].nodeName != "BR") && (s = i6e(t, r, o, e));
  }
  s == null && (s = o6e(t, a, e));
  let l = t.docView.nearestDesc(a, !0);
  return { pos: s, inside: l ? l.posAtStart - l.border : -1 };
}
function eI(t) {
  return t.top < t.bottom || t.left < t.right;
}
function ai(t, e) {
  let n = t.getClientRects();
  if (n.length) {
    let r = n[e < 0 ? 0 : n.length - 1];
    if (eI(r))
      return r;
  }
  return Array.prototype.find.call(n, eI) || t.getBoundingClientRect();
}
const s6e = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function TC(t, e, n) {
  let { node: r, offset: o, atom: i } = t.docView.domFromPos(e, n < 0 ? -1 : 1), a = _u || pr;
  if (r.nodeType == 3)
    if (a && (s6e.test(r.nodeValue) || (n < 0 ? !o : o == r.nodeValue.length))) {
      let l = ai(Po(r, o, o), n);
      if (pr && o && /\s/.test(r.nodeValue[o - 1]) && o < r.nodeValue.length) {
        let c = ai(Po(r, o - 1, o - 1), -1);
        if (c.top == l.top) {
          let u = ai(Po(r, o, o + 1), -1);
          if (u.top != l.top)
            return Ml(u, u.left < c.left);
        }
      }
      return l;
    } else {
      let l = o, c = o, u = n < 0 ? 1 : -1;
      return n < 0 && !o ? (c++, u = -1) : n >= 0 && o == r.nodeValue.length ? (l--, u = 1) : n < 0 ? l-- : c++, Ml(ai(Po(r, l, c), u), u < 0);
    }
  if (!t.state.doc.resolve(e - (i || 0)).parent.inlineContent) {
    if (i == null && o && (n < 0 || o == dr(r))) {
      let l = r.childNodes[o - 1];
      if (l.nodeType == 1)
        return ph(l.getBoundingClientRect(), !1);
    }
    if (i == null && o < dr(r)) {
      let l = r.childNodes[o];
      if (l.nodeType == 1)
        return ph(l.getBoundingClientRect(), !0);
    }
    return ph(r.getBoundingClientRect(), n >= 0);
  }
  if (i == null && o && (n < 0 || o == dr(r))) {
    let l = r.childNodes[o - 1], c = l.nodeType == 3 ? Po(l, dr(l) - (a ? 0 : 1)) : l.nodeType == 1 && (l.nodeName != "BR" || !l.nextSibling) ? l : null;
    if (c)
      return Ml(ai(c, 1), !1);
  }
  if (i == null && o < dr(r)) {
    let l = r.childNodes[o];
    for (; l.pmViewDesc && l.pmViewDesc.ignoreForCoords; )
      l = l.nextSibling;
    let c = l ? l.nodeType == 3 ? Po(l, 0, a ? 0 : 1) : l.nodeType == 1 ? l : null : null;
    if (c)
      return Ml(ai(c, -1), !0);
  }
  return Ml(ai(r.nodeType == 3 ? Po(r) : r, -n), n >= 0);
}
function Ml(t, e) {
  if (t.width == 0)
    return t;
  let n = e ? t.left : t.right;
  return { top: t.top, bottom: t.bottom, left: n, right: n };
}
function ph(t, e) {
  if (t.height == 0)
    return t;
  let n = e ? t.top : t.bottom;
  return { top: n, bottom: n, left: t.left, right: t.right };
}
function bC(t, e, n) {
  let r = t.state, o = t.root.activeElement;
  r != e && t.updateState(e), o != t.dom && t.focus();
  try {
    return n();
  } finally {
    r != e && t.updateState(r), o != t.dom && o && o.focus();
  }
}
function l6e(t, e, n) {
  let r = e.selection, o = n == "up" ? r.$from : r.$to;
  return bC(t, e, () => {
    let { node: i } = t.docView.domFromPos(o.pos, n == "up" ? -1 : 1);
    for (; ; ) {
      let s = t.docView.nearestDesc(i, !0);
      if (!s)
        break;
      if (s.node.isBlock) {
        i = s.contentDOM || s.dom;
        break;
      }
      i = s.dom.parentNode;
    }
    let a = TC(t, o.pos, 1);
    for (let s = i.firstChild; s; s = s.nextSibling) {
      let l;
      if (s.nodeType == 1)
        l = s.getClientRects();
      else if (s.nodeType == 3)
        l = Po(s, 0, s.nodeValue.length).getClientRects();
      else
        continue;
      for (let c = 0; c < l.length; c++) {
        let u = l[c];
        if (u.bottom > u.top + 1 && (n == "up" ? a.top - u.top > (u.bottom - a.top) * 2 : u.bottom - a.bottom > (a.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const c6e = /[\u0590-\u08ac]/;
function u6e(t, e, n) {
  let { $head: r } = e.selection;
  if (!r.parent.isTextblock)
    return !1;
  let o = r.parentOffset, i = !o, a = o == r.parent.content.size, s = t.domSelection();
  return s ? !c6e.test(r.parent.textContent) || !s.modify ? n == "left" || n == "backward" ? i : a : bC(t, e, () => {
    let { focusNode: l, focusOffset: c, anchorNode: u, anchorOffset: d } = t.domSelectionRange(), f = s.caretBidiLevel;
    s.modify("move", n, "character");
    let h = r.depth ? t.docView.domAfterPos(r.before()) : t.dom, { focusNode: _, focusOffset: E } = t.domSelectionRange(), m = _ && !h.contains(_.nodeType == 1 ? _ : _.parentNode) || l == _ && c == E;
    try {
      s.collapse(u, d), l && (l != u || c != d) && s.extend && s.extend(l, c);
    } catch {
    }
    return f != null && (s.caretBidiLevel = f), m;
  }) : r.pos == r.start() || r.pos == r.end();
}
let tI = null, nI = null, rI = !1;
function d6e(t, e, n) {
  return tI == e && nI == n ? rI : (tI = e, nI = n, rI = n == "up" || n == "down" ? l6e(t, e, n) : u6e(t, e, n));
}
const mr = 0, oI = 1, la = 2, No = 3;
class Eu {
  constructor(e, n, r, o) {
    this.parent = e, this.children = n, this.dom = r, this.contentDOM = o, this.dirty = mr, r.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, n, r) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let n = 0; n < this.children.length; n++)
      e += this.children[n].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let n = 0, r = this.posAtStart; ; n++) {
      let o = this.children[n];
      if (o == e)
        return r;
      r += o.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, n, r) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (r < 0) {
        let i, a;
        if (e == this.contentDOM)
          i = e.childNodes[n - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          i = e.previousSibling;
        }
        for (; i && !((a = i.pmViewDesc) && a.parent == this); )
          i = i.previousSibling;
        return i ? this.posBeforeChild(a) + a.size : this.posAtStart;
      } else {
        let i, a;
        if (e == this.contentDOM)
          i = e.childNodes[n];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          i = e.nextSibling;
        }
        for (; i && !((a = i.pmViewDesc) && a.parent == this); )
          i = i.nextSibling;
        return i ? this.posBeforeChild(a) : this.posAtEnd;
      }
    let o;
    if (e == this.dom && this.contentDOM)
      o = n > cn(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      o = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (n == 0)
        for (let i = e; ; i = i.parentNode) {
          if (i == this.dom) {
            o = !1;
            break;
          }
          if (i.previousSibling)
            break;
        }
      if (o == null && n == e.childNodes.length)
        for (let i = e; ; i = i.parentNode) {
          if (i == this.dom) {
            o = !0;
            break;
          }
          if (i.nextSibling)
            break;
        }
    }
    return o ?? r > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, n = !1) {
    for (let r = !0, o = e; o; o = o.parentNode) {
      let i = this.getDesc(o), a;
      if (i && (!n || i.node))
        if (r && (a = i.nodeDOM) && !(a.nodeType == 1 ? a.contains(e.nodeType == 1 ? e : e.parentNode) : a == e))
          r = !1;
        else
          return i;
    }
  }
  getDesc(e) {
    let n = e.pmViewDesc;
    for (let r = n; r; r = r.parent)
      if (r == this)
        return n;
  }
  posFromDOM(e, n, r) {
    for (let o = e; o; o = o.parentNode) {
      let i = this.getDesc(o);
      if (i)
        return i.localPosFromDOM(e, n, r);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let n = 0, r = 0; n < this.children.length; n++) {
      let o = this.children[n], i = r + o.size;
      if (r == e && i != r) {
        for (; !o.border && o.children.length; )
          for (let a = 0; a < o.children.length; a++) {
            let s = o.children[a];
            if (s.size) {
              o = s;
              break;
            }
          }
        return o;
      }
      if (e < i)
        return o.descAt(e - r - o.border);
      r = i;
    }
  }
  domFromPos(e, n) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let r = 0, o = 0;
    for (let i = 0; r < this.children.length; r++) {
      let a = this.children[r], s = i + a.size;
      if (s > e || a instanceof MC) {
        o = e - i;
        break;
      }
      i = s;
    }
    if (o)
      return this.children[r].domFromPos(o - this.children[r].border, n);
    for (let i; r && !(i = this.children[r - 1]).size && i instanceof RC && i.side >= 0; r--)
      ;
    if (n <= 0) {
      let i, a = !0;
      for (; i = r ? this.children[r - 1] : null, !(!i || i.dom.parentNode == this.contentDOM); r--, a = !1)
        ;
      return i && n && a && !i.border && !i.domAtom ? i.domFromPos(i.size, n) : { node: this.contentDOM, offset: i ? cn(i.dom) + 1 : 0 };
    } else {
      let i, a = !0;
      for (; i = r < this.children.length ? this.children[r] : null, !(!i || i.dom.parentNode == this.contentDOM); r++, a = !1)
        ;
      return i && a && !i.border && !i.domAtom ? i.domFromPos(0, n) : { node: this.contentDOM, offset: i ? cn(i.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, n, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: n, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let o = -1, i = -1;
    for (let a = r, s = 0; ; s++) {
      let l = this.children[s], c = a + l.size;
      if (o == -1 && e <= c) {
        let u = a + l.border;
        if (e >= u && n <= c - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
          return l.parseRange(e, n, u);
        e = a;
        for (let d = s; d > 0; d--) {
          let f = this.children[d - 1];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(1)) {
            o = cn(f.dom) + 1;
            break;
          }
          e -= f.size;
        }
        o == -1 && (o = 0);
      }
      if (o > -1 && (c > n || s == this.children.length - 1)) {
        n = c;
        for (let u = s + 1; u < this.children.length; u++) {
          let d = this.children[u];
          if (d.size && d.dom.parentNode == this.contentDOM && !d.emptyChildAt(-1)) {
            i = cn(d.dom);
            break;
          }
          n += d.size;
        }
        i == -1 && (i = this.contentDOM.childNodes.length);
        break;
      }
      a = c;
    }
    return { node: this.contentDOM, from: e, to: n, fromOffset: o, toOffset: i };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let n = this.children[e < 0 ? 0 : this.children.length - 1];
    return n.size == 0 || n.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: n, offset: r } = this.domFromPos(e, 0);
    if (n.nodeType != 1 || r == n.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return n.childNodes[r];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, n, r, o = !1) {
    let i = Math.min(e, n), a = Math.max(e, n);
    for (let h = 0, _ = 0; h < this.children.length; h++) {
      let E = this.children[h], m = _ + E.size;
      if (i > _ && a < m)
        return E.setSelection(e - _ - E.border, n - _ - E.border, r, o);
      _ = m;
    }
    let s = this.domFromPos(e, e ? -1 : 1), l = n == e ? s : this.domFromPos(n, n ? -1 : 1), c = r.root.getSelection(), u = r.domSelectionRange(), d = !1;
    if ((pr || In) && e == n) {
      let { node: h, offset: _ } = s;
      if (h.nodeType == 3) {
        if (d = !!(_ && h.nodeValue[_ - 1] == `
`), d && _ == h.nodeValue.length)
          for (let E = h, m; E; E = E.parentNode) {
            if (m = E.nextSibling) {
              m.nodeName == "BR" && (s = l = { node: m.parentNode, offset: cn(m) + 1 });
              break;
            }
            let N = E.pmViewDesc;
            if (N && N.node && N.node.isBlock)
              break;
          }
      } else {
        let E = h.childNodes[_ - 1];
        d = E && (E.nodeName == "BR" || E.contentEditable == "false");
      }
    }
    if (pr && u.focusNode && u.focusNode != l.node && u.focusNode.nodeType == 1) {
      let h = u.focusNode.childNodes[u.focusOffset];
      h && h.contentEditable == "false" && (o = !0);
    }
    if (!(o || d && In) && xa(s.node, s.offset, u.anchorNode, u.anchorOffset) && xa(l.node, l.offset, u.focusNode, u.focusOffset))
      return;
    let f = !1;
    if ((c.extend || e == n) && !(d && pr)) {
      c.collapse(s.node, s.offset);
      try {
        e != n && c.extend(l.node, l.offset), f = !0;
      } catch {
      }
    }
    if (!f) {
      if (e > n) {
        let _ = s;
        s = l, l = _;
      }
      let h = document.createRange();
      h.setEnd(l.node, l.offset), h.setStart(s.node, s.offset), c.removeAllRanges(), c.addRange(h);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, n) {
    for (let r = 0, o = 0; o < this.children.length; o++) {
      let i = this.children[o], a = r + i.size;
      if (r == a ? e <= a && n >= r : e < a && n > r) {
        let s = r + i.border, l = a - i.border;
        if (e >= s && n <= l) {
          this.dirty = e == r || n == a ? la : oI, e == s && n == l && (i.contentLost || i.dom.parentNode != this.contentDOM) ? i.dirty = No : i.markDirty(e - s, n - s);
          return;
        } else
          i.dirty = i.dom == i.contentDOM && i.dom.parentNode == this.contentDOM && !i.children.length ? la : No;
      }
      r = a;
    }
    this.dirty = la;
  }
  markParentsDirty() {
    let e = 1;
    for (let n = this.parent; n; n = n.parent, e++) {
      let r = e == 1 ? la : oI;
      n.dirty < r && (n.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  get ignoreForSelection() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class RC extends Eu {
  constructor(e, n, r, o) {
    let i, a = n.type.toDOM;
    if (typeof a == "function" && (a = a(r, () => {
      if (!i)
        return o;
      if (i.parent)
        return i.parent.posBeforeChild(i);
    })), !n.type.spec.raw) {
      if (a.nodeType != 1) {
        let s = document.createElement("span");
        s.appendChild(a), a = s;
      }
      a.contentEditable = "false", a.classList.add("ProseMirror-widget");
    }
    super(e, [], a, null), this.widget = n, this.widget = n, i = this;
  }
  matchesWidget(e) {
    return this.dirty == mr && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let n = this.widget.spec.stopEvent;
    return n ? n(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
}
class f6e extends Eu {
  constructor(e, n, r, o) {
    super(e, [], n, null), this.textDOM = r, this.text = o;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, n) {
    return e != this.textDOM ? this.posAtStart + (n ? this.size : 0) : this.posAtStart + n;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class Ua extends Eu {
  constructor(e, n, r, o, i) {
    super(e, [], r, o), this.mark = n, this.spec = i;
  }
  static create(e, n, r, o) {
    let i = o.nodeViews[n.type.name], a = i && i(n, o, r);
    return (!a || !a.dom) && (a = ja.renderSpec(document, n.type.spec.toDOM(n, r), null, n.attrs)), new Ua(e, n, a.dom, a.contentDOM || a.dom, a);
  }
  parseRule() {
    return this.dirty & No || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != No && this.mark.eq(e);
  }
  markDirty(e, n) {
    if (super.markDirty(e, n), this.dirty != mr) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = mr;
    }
  }
  slice(e, n, r) {
    let o = Ua.create(this.parent, this.mark, !0, r), i = this.children, a = this.size;
    n < a && (i = q0(i, n, a, r)), e > 0 && (i = q0(i, 0, e, r));
    for (let s = 0; s < i.length; s++)
      i[s].parent = o;
    return o.children = i, o;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class Si extends Eu {
  constructor(e, n, r, o, i, a, s, l, c) {
    super(e, [], i, a), this.node = n, this.outerDeco = r, this.innerDeco = o, this.nodeDOM = s;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, n, r, o, i, a) {
    let s = i.nodeViews[n.type.name], l, c = s && s(n, i, () => {
      if (!l)
        return a;
      if (l.parent)
        return l.parent.posBeforeChild(l);
    }, r, o), u = c && c.dom, d = c && c.contentDOM;
    if (n.isText) {
      if (!u)
        u = document.createTextNode(n.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else
      u || ({ dom: u, contentDOM: d } = ja.renderSpec(document, n.type.spec.toDOM(n), null, n.attrs));
    !d && !n.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), n.type.spec.draggable && (u.draggable = !0));
    let f = u;
    return u = LC(u, r, n), c ? l = new h6e(e, n, r, o, u, d || null, f, c, i, a + 1) : n.isText ? new u1(e, n, r, o, u, f, i) : new Si(e, n, r, o, u, d || null, f, i, a + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let n = this.children.length - 1; n >= 0; n--) {
        let r = this.children[n];
        if (this.dom.contains(r.dom.parentNode)) {
          e.contentElement = r.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => _e.empty);
    }
    return e;
  }
  matchesNode(e, n, r) {
    return this.dirty == mr && e.eq(this.node) && Qd(n, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, n) {
    let r = this.node.inlineContent, o = n, i = e.composing ? this.localCompositionInfo(e, n) : null, a = i && i.pos > -1 ? i : null, s = i && i.pos < 0, l = new E6e(this, a && a.node, e);
    N6e(this.node, this.innerDeco, (c, u, d) => {
      c.spec.marks ? l.syncToMarks(c.spec.marks, r, e, u) : c.type.side >= 0 && !d && l.syncToMarks(u == this.node.childCount ? pt.none : this.node.child(u).marks, r, e, u), l.placeWidget(c, e, o);
    }, (c, u, d, f) => {
      l.syncToMarks(c.marks, r, e, f);
      let h;
      l.findNodeMatch(c, u, d, f) || s && e.state.selection.from > o && e.state.selection.to < o + c.nodeSize && (h = l.findIndexWithChild(i.node)) > -1 && l.updateNodeAt(c, u, d, h, e) || l.updateNextNode(c, u, d, e, f, o) || l.addNode(c, u, d, e, o), o += c.nodeSize;
    }), l.syncToMarks([], r, e, 0), this.node.isTextblock && l.addTextblockHacks(), l.destroyRest(), (l.changed || this.dirty == la) && (a && this.protectLocalComposition(e, a), PC(this.contentDOM, this.children, e), qs && v6e(this.dom));
  }
  localCompositionInfo(e, n) {
    let { from: r, to: o } = e.state.selection;
    if (!(e.state.selection instanceof Ke) || r < n || o > n + this.node.content.size)
      return null;
    let i = e.input.compositionNode;
    if (!i || !this.dom.contains(i.parentNode))
      return null;
    if (this.node.inlineContent) {
      let a = i.nodeValue, s = g6e(this.node.content, a, r - n, o - n);
      return s < 0 ? null : { node: i, pos: s, text: a };
    } else
      return { node: i, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: n, pos: r, text: o }) {
    if (this.getDesc(n))
      return;
    let i = n;
    for (; i.parentNode != this.contentDOM; i = i.parentNode) {
      for (; i.previousSibling; )
        i.parentNode.removeChild(i.previousSibling);
      for (; i.nextSibling; )
        i.parentNode.removeChild(i.nextSibling);
      i.pmViewDesc && (i.pmViewDesc = void 0);
    }
    let a = new f6e(this, i, n, o);
    e.input.compositionNodes.push(a), this.children = q0(this.children, r, r + o.length, e, a);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, n, r, o) {
    return this.dirty == No || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, n, r, o), !0);
  }
  updateInner(e, n, r, o) {
    this.updateOuterDeco(n), this.node = e, this.innerDeco = r, this.contentDOM && this.updateChildren(o, this.posAtStart), this.dirty = mr;
  }
  updateOuterDeco(e) {
    if (Qd(e, this.outerDeco))
      return;
    let n = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = yC(this.dom, this.nodeDOM, Z0(this.outerDeco, this.node, n), Z0(e, this.node, n)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.nodeDOM.draggable = !0));
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.nodeDOM.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function iI(t, e, n, r, o) {
  LC(r, e, t);
  let i = new Si(void 0, t, e, n, r, r, r, o, 0);
  return i.contentDOM && i.updateChildren(o, 0), i;
}
class u1 extends Si {
  constructor(e, n, r, o, i, a, s) {
    super(e, n, r, o, i, null, a, s, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, n, r, o) {
    return this.dirty == No || this.dirty != mr && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(n), (this.dirty != mr || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, o.trackWrites == this.nodeDOM && (o.trackWrites = null)), this.node = e, this.dirty = mr, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let n = this.nodeDOM; n; n = n.parentNode)
      if (n == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, n, r) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(n, this.node.text.length) : super.localPosFromDOM(e, n, r);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, n, r) {
    let o = this.node.cut(e, n), i = document.createTextNode(o.text);
    return new u1(this.parent, o, this.outerDeco, this.innerDeco, i, i, r);
  }
  markDirty(e, n) {
    super.markDirty(e, n), this.dom != this.nodeDOM && (e == 0 || n == this.nodeDOM.nodeValue.length) && (this.dirty = No);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class MC extends Eu {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == mr && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class h6e extends Si {
  constructor(e, n, r, o, i, a, s, l, c, u) {
    super(e, n, r, o, i, a, s, c, u), this.spec = l;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, n, r, o) {
    if (this.dirty == No)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let i = this.spec.update(e, n, r);
      return i && this.updateInner(e, n, r, o), i;
    } else
      return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, n, r, o);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, n, r, o) {
    this.spec.setSelection ? this.spec.setSelection(e, n, r.root) : super.setSelection(e, n, r, o);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function PC(t, e, n) {
  let r = t.firstChild, o = !1;
  for (let i = 0; i < e.length; i++) {
    let a = e[i], s = a.dom;
    if (s.parentNode == t) {
      for (; s != r; )
        r = aI(r), o = !0;
      r = r.nextSibling;
    } else
      o = !0, t.insertBefore(s, r);
    if (a instanceof Ua) {
      let l = r ? r.previousSibling : t.lastChild;
      PC(a.contentDOM, a.children, n), r = l ? l.nextSibling : t.firstChild;
    }
  }
  for (; r; )
    r = aI(r), o = !0;
  o && n.trackWrites == t && (n.trackWrites = null);
}
const ic = function(t) {
  t && (this.nodeName = t);
};
ic.prototype = /* @__PURE__ */ Object.create(null);
const ca = [new ic()];
function Z0(t, e, n) {
  if (t.length == 0)
    return ca;
  let r = n ? ca[0] : new ic(), o = [r];
  for (let i = 0; i < t.length; i++) {
    let a = t[i].type.attrs;
    if (a) {
      a.nodeName && o.push(r = new ic(a.nodeName));
      for (let s in a) {
        let l = a[s];
        l != null && (n && o.length == 1 && o.push(r = new ic(e.isInline ? "span" : "div")), s == "class" ? r.class = (r.class ? r.class + " " : "") + l : s == "style" ? r.style = (r.style ? r.style + ";" : "") + l : s != "nodeName" && (r[s] = l));
      }
    }
  }
  return o;
}
function yC(t, e, n, r) {
  if (n == ca && r == ca)
    return e;
  let o = e;
  for (let i = 0; i < r.length; i++) {
    let a = r[i], s = n[i];
    if (i) {
      let l;
      s && s.nodeName == a.nodeName && o != t && (l = o.parentNode) && l.nodeName.toLowerCase() == a.nodeName || (l = document.createElement(a.nodeName), l.pmIsDeco = !0, l.appendChild(o), s = ca[0]), o = l;
    }
    _6e(o, s || ca[0], a);
  }
  return o;
}
function _6e(t, e, n) {
  for (let r in e)
    r != "class" && r != "style" && r != "nodeName" && !(r in n) && t.removeAttribute(r);
  for (let r in n)
    r != "class" && r != "style" && r != "nodeName" && n[r] != e[r] && t.setAttribute(r, n[r]);
  if (e.class != n.class) {
    let r = e.class ? e.class.split(" ").filter(Boolean) : [], o = n.class ? n.class.split(" ").filter(Boolean) : [];
    for (let i = 0; i < r.length; i++)
      o.indexOf(r[i]) == -1 && t.classList.remove(r[i]);
    for (let i = 0; i < o.length; i++)
      r.indexOf(o[i]) == -1 && t.classList.add(o[i]);
    t.classList.length == 0 && t.removeAttribute("class");
  }
  if (e.style != n.style) {
    if (e.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, o;
      for (; o = r.exec(e.style); )
        t.style.removeProperty(o[1]);
    }
    n.style && (t.style.cssText += n.style);
  }
}
function LC(t, e, n) {
  return yC(t, t, ca, Z0(e, n, t.nodeType != 1));
}
function Qd(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (!t[n].type.eq(e[n].type))
      return !1;
  return !0;
}
function aI(t) {
  let e = t.nextSibling;
  return t.parentNode.removeChild(t), e;
}
class E6e {
  constructor(e, n, r) {
    this.lock = n, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = p6e(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, n) {
    if (e != n) {
      for (let r = e; r < n; r++)
        this.top.children[r].destroy();
      this.top.children.splice(e, n - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, n, r, o) {
    let i = 0, a = this.stack.length >> 1, s = Math.min(a, e.length);
    for (; i < s && (i == a - 1 ? this.top : this.stack[i + 1 << 1]).matchesMark(e[i]) && e[i].type.spec.spanning !== !1; )
      i++;
    for (; i < a; )
      this.destroyRest(), this.top.dirty = mr, this.index = this.stack.pop(), this.top = this.stack.pop(), a--;
    for (; a < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let l = -1, c = this.top.children.length;
      o < this.preMatch.index && (c = Math.min(this.index + 3, c));
      for (let u = this.index; u < c; u++) {
        let d = this.top.children[u];
        if (d.matchesMark(e[a]) && !this.isLocked(d.dom)) {
          l = u;
          break;
        }
      }
      if (l > -1)
        l > this.index && (this.changed = !0, this.destroyBetween(this.index, l)), this.top = this.top.children[this.index];
      else {
        let u = Ua.create(this.top, e[a], n, r);
        this.top.children.splice(this.index, 0, u), this.top = u, this.changed = !0;
      }
      this.index = 0, a++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, n, r, o) {
    let i = -1, a;
    if (o >= this.preMatch.index && (a = this.preMatch.matches[o - this.preMatch.index]).parent == this.top && a.matchesNode(e, n, r))
      i = this.top.children.indexOf(a, this.index);
    else
      for (let s = this.index, l = Math.min(this.top.children.length, s + 5); s < l; s++) {
        let c = this.top.children[s];
        if (c.matchesNode(e, n, r) && !this.preMatch.matched.has(c)) {
          i = s;
          break;
        }
      }
    return i < 0 ? !1 : (this.destroyBetween(this.index, i), this.index++, !0);
  }
  updateNodeAt(e, n, r, o, i) {
    let a = this.top.children[o];
    return a.dirty == No && a.dom == a.contentDOM && (a.dirty = la), a.update(e, n, r, i) ? (this.destroyBetween(this.index, o), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let n = e.parentNode;
      if (!n)
        return -1;
      if (n == this.top.contentDOM) {
        let r = e.pmViewDesc;
        if (r) {
          for (let o = this.index; o < this.top.children.length; o++)
            if (this.top.children[o] == r)
              return o;
        }
        return -1;
      }
      e = n;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, n, r, o, i, a) {
    for (let s = this.index; s < this.top.children.length; s++) {
      let l = this.top.children[s];
      if (l instanceof Si) {
        let c = this.preMatch.matched.get(l);
        if (c != null && c != i)
          return !1;
        let u = l.dom, d, f = this.isLocked(u) && !(e.isText && l.node && l.node.isText && l.nodeDOM.nodeValue == e.text && l.dirty != No && Qd(n, l.outerDeco));
        if (!f && l.update(e, n, r, o))
          return this.destroyBetween(this.index, s), l.dom != u && (this.changed = !0), this.index++, !0;
        if (!f && (d = this.recreateWrapper(l, e, n, r, o, a)))
          return this.destroyBetween(this.index, s), this.top.children[this.index] = d, d.contentDOM && (d.dirty = la, d.updateChildren(o, a + 1), d.dirty = mr), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, n, r, o, i, a) {
    if (e.dirty || n.isAtom || !e.children.length || !e.node.content.eq(n.content) || !Qd(r, e.outerDeco) || !o.eq(e.innerDeco))
      return null;
    let s = Si.create(this.top, n, r, o, i, a);
    if (s.contentDOM) {
      s.children = e.children, e.children = [];
      for (let l of s.children)
        l.parent = s;
    }
    return e.destroy(), s;
  }
  // Insert the node as a newly created node desc.
  addNode(e, n, r, o, i) {
    let a = Si.create(this.top, e, n, r, o, i);
    a.contentDOM && a.updateChildren(o, i + 1), this.top.children.splice(this.index++, 0, a), this.changed = !0;
  }
  placeWidget(e, n, r) {
    let o = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (o && o.matchesWidget(e) && (e == o.widget || !o.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let i = new RC(this.top, e, n, r);
      this.top.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], n = this.top;
    for (; e instanceof Ua; )
      n = e, e = n.children[n.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof u1) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((In || hn) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", n), this.addHackNode("BR", this.top));
  }
  addHackNode(e, n) {
    if (n == this.top && this.index < n.children.length && n.children[this.index].matchesHack(e))
      this.index++;
    else {
      let r = document.createElement(e);
      e == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), e == "BR" && (r.className = "ProseMirror-trailingBreak");
      let o = new MC(this.top, [], r, null);
      n != this.top ? n.children.push(o) : n.children.splice(this.index++, 0, o), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function p6e(t, e) {
  let n = e, r = n.children.length, o = t.childCount, i = /* @__PURE__ */ new Map(), a = [];
  e:
    for (; o > 0; ) {
      let s;
      for (; ; )
        if (r) {
          let c = n.children[r - 1];
          if (c instanceof Ua)
            n = c, r = c.children.length;
          else {
            s = c, r--;
            break;
          }
        } else {
          if (n == e)
            break e;
          r = n.parent.children.indexOf(n), n = n.parent;
        }
      let l = s.node;
      if (l) {
        if (l != t.child(o - 1))
          break;
        --o, i.set(s, o), a.push(s);
      }
    }
  return { index: o, matched: i, matches: a.reverse() };
}
function m6e(t, e) {
  return t.type.side - e.type.side;
}
function N6e(t, e, n, r) {
  let o = e.locals(t), i = 0;
  if (o.length == 0) {
    for (let c = 0; c < t.childCount; c++) {
      let u = t.child(c);
      r(u, o, e.forChild(i, u), c), i += u.nodeSize;
    }
    return;
  }
  let a = 0, s = [], l = null;
  for (let c = 0; ; ) {
    let u, d;
    for (; a < o.length && o[a].to == i; ) {
      let m = o[a++];
      m.widget && (u ? (d || (d = [u])).push(m) : u = m);
    }
    if (u)
      if (d) {
        d.sort(m6e);
        for (let m = 0; m < d.length; m++)
          n(d[m], c, !!l);
      } else
        n(u, c, !!l);
    let f, h;
    if (l)
      h = -1, f = l, l = null;
    else if (c < t.childCount)
      h = c, f = t.child(c++);
    else
      break;
    for (let m = 0; m < s.length; m++)
      s[m].to <= i && s.splice(m--, 1);
    for (; a < o.length && o[a].from <= i && o[a].to > i; )
      s.push(o[a++]);
    let _ = i + f.nodeSize;
    if (f.isText) {
      let m = _;
      a < o.length && o[a].from < m && (m = o[a].from);
      for (let N = 0; N < s.length; N++)
        s[N].to < m && (m = s[N].to);
      m < _ && (l = f.cut(m - i), f = f.cut(0, m - i), _ = m, h = -1);
    } else
      for (; a < o.length && o[a].to < _; )
        a++;
    let E = f.isInline && !f.isLeaf ? s.filter((m) => !m.inline) : s.slice();
    r(f, E, e.forChild(i, f), h), i = _;
  }
}
function v6e(t) {
  if (t.nodeName == "UL" || t.nodeName == "OL") {
    let e = t.style.cssText;
    t.style.cssText = e + "; list-style: square !important", window.getComputedStyle(t).listStyle, t.style.cssText = e;
  }
}
function g6e(t, e, n, r) {
  for (let o = 0, i = 0; o < t.childCount && i <= r; ) {
    let a = t.child(o++), s = i;
    if (i += a.nodeSize, !a.isText)
      continue;
    let l = a.text;
    for (; o < t.childCount; ) {
      let c = t.child(o++);
      if (i += c.nodeSize, !c.isText)
        break;
      l += c.text;
    }
    if (i >= n) {
      if (i >= r && l.slice(r - e.length - s, r - s) == e)
        return r - e.length;
      let c = s < r ? l.lastIndexOf(e, r - s - 1) : -1;
      if (c >= 0 && c + e.length + s >= n)
        return s + c;
      if (n == r && l.length >= r + e.length - s && l.slice(r - s, r - s + e.length) == e)
        return r;
    }
  }
  return -1;
}
function q0(t, e, n, r, o) {
  let i = [];
  for (let a = 0, s = 0; a < t.length; a++) {
    let l = t[a], c = s, u = s += l.size;
    c >= n || u <= e ? i.push(l) : (c < e && i.push(l.slice(0, e - c, r)), o && (i.push(o), o = void 0), u > n && i.push(l.slice(n - c, l.size, r)));
  }
  return i;
}
function a2(t, e = null) {
  let n = t.domSelectionRange(), r = t.state.doc;
  if (!n.focusNode)
    return null;
  let o = t.docView.nearestDesc(n.focusNode), i = o && o.size == 0, a = t.docView.posFromDOM(n.focusNode, n.focusOffset, 1);
  if (a < 0)
    return null;
  let s = r.resolve(a), l, c;
  if (c1(n)) {
    for (l = a; o && !o.node; )
      o = o.parent;
    let d = o.node;
    if (o && d.isAtom && ke.isSelectable(d) && o.parent && !(d.isInline && zDe(n.focusNode, n.focusOffset, o.dom))) {
      let f = o.posBefore;
      c = new ke(a == f ? s : r.resolve(f));
    }
  } else {
    if (n instanceof t.dom.ownerDocument.defaultView.Selection && n.rangeCount > 1) {
      let d = a, f = a;
      for (let h = 0; h < n.rangeCount; h++) {
        let _ = n.getRangeAt(h);
        d = Math.min(d, t.docView.posFromDOM(_.startContainer, _.startOffset, 1)), f = Math.max(f, t.docView.posFromDOM(_.endContainer, _.endOffset, -1));
      }
      if (d < 0)
        return null;
      [l, a] = f == t.state.selection.anchor ? [f, d] : [d, f], s = r.resolve(a);
    } else
      l = t.docView.posFromDOM(n.anchorNode, n.anchorOffset, 1);
    if (l < 0)
      return null;
  }
  let u = r.resolve(l);
  if (!c) {
    let d = e == "pointer" || t.state.selection.head < s.pos && !i ? 1 : -1;
    c = s2(t, u, s, d);
  }
  return c;
}
function xC(t) {
  return t.editable ? t.hasFocus() : $C(t) && document.activeElement && document.activeElement.contains(t.dom);
}
function Ho(t, e = !1) {
  let n = t.state.selection;
  if (UC(t, n), !!xC(t)) {
    if (!e && t.input.mouseDown && t.input.mouseDown.allowDefault && hn) {
      let r = t.domSelectionRange(), o = t.domObserver.currentSelection;
      if (r.anchorNode && o.anchorNode && xa(r.anchorNode, r.anchorOffset, o.anchorNode, o.anchorOffset)) {
        t.input.mouseDown.delayedSelectionSync = !0, t.domObserver.setCurSelection();
        return;
      }
    }
    if (t.domObserver.disconnectSelection(), t.cursorWrapper)
      O6e(t);
    else {
      let { anchor: r, head: o } = n, i, a;
      sI && !(n instanceof Ke) && (n.$from.parent.inlineContent || (i = lI(t, n.from)), !n.empty && !n.$from.parent.inlineContent && (a = lI(t, n.to))), t.docView.setSelection(r, o, t, e), sI && (i && cI(i), a && cI(a)), n.visible ? t.dom.classList.remove("ProseMirror-hideselection") : (t.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && I6e(t));
    }
    t.domObserver.setCurSelection(), t.domObserver.connectSelection();
  }
}
const sI = In || hn && OC < 63;
function lI(t, e) {
  let { node: n, offset: r } = t.docView.domFromPos(e, 0), o = r < n.childNodes.length ? n.childNodes[r] : null, i = r ? n.childNodes[r - 1] : null;
  if (In && o && o.contentEditable == "false")
    return mh(o);
  if ((!o || o.contentEditable == "false") && (!i || i.contentEditable == "false")) {
    if (o)
      return mh(o);
    if (i)
      return mh(i);
  }
}
function mh(t) {
  return t.contentEditable = "true", In && t.draggable && (t.draggable = !1, t.wasDraggable = !0), t;
}
function cI(t) {
  t.contentEditable = "false", t.wasDraggable && (t.draggable = !0, t.wasDraggable = null);
}
function I6e(t) {
  let e = t.dom.ownerDocument;
  e.removeEventListener("selectionchange", t.input.hideSelectionGuard);
  let n = t.domSelectionRange(), r = n.anchorNode, o = n.anchorOffset;
  e.addEventListener("selectionchange", t.input.hideSelectionGuard = () => {
    (n.anchorNode != r || n.anchorOffset != o) && (e.removeEventListener("selectionchange", t.input.hideSelectionGuard), setTimeout(() => {
      (!xC(t) || t.state.selection.visible) && t.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function O6e(t) {
  let e = t.domSelection();
  if (!e)
    return;
  let n = t.cursorWrapper.dom, r = n.nodeName == "IMG";
  r ? e.collapse(n.parentNode, cn(n) + 1) : e.collapse(n, 0), !r && !t.state.selection.visible && Yn && Ci <= 11 && (n.disabled = !0, n.disabled = !1);
}
function UC(t, e) {
  if (e instanceof ke) {
    let n = t.docView.descAt(e.from);
    n != t.lastSelectedViewDesc && (uI(t), n && n.selectNode(), t.lastSelectedViewDesc = n);
  } else
    uI(t);
}
function uI(t) {
  t.lastSelectedViewDesc && (t.lastSelectedViewDesc.parent && t.lastSelectedViewDesc.deselectNode(), t.lastSelectedViewDesc = void 0);
}
function s2(t, e, n, r) {
  return t.someProp("createSelectionBetween", (o) => o(t, e, n)) || Ke.between(e, n, r);
}
function dI(t) {
  return t.editable && !t.hasFocus() ? !1 : $C(t);
}
function $C(t) {
  let e = t.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return t.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (t.editable || t.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function A6e(t) {
  let e = t.docView.domFromPos(t.state.selection.anchor, 0), n = t.domSelectionRange();
  return xa(e.node, e.offset, n.anchorNode, n.anchorOffset);
}
function X0(t, e) {
  let { $anchor: n, $head: r } = t.selection, o = e > 0 ? n.max(r) : n.min(r), i = o.parent.inlineContent ? o.depth ? t.doc.resolve(e > 0 ? o.after() : o.before()) : null : o;
  return i && qe.findFrom(i, e);
}
function li(t, e) {
  return t.dispatch(t.state.tr.setSelection(e).scrollIntoView()), !0;
}
function fI(t, e, n) {
  let r = t.state.selection;
  if (r instanceof Ke)
    if (n.indexOf("s") > -1) {
      let { $head: o } = r, i = o.textOffset ? null : e < 0 ? o.nodeBefore : o.nodeAfter;
      if (!i || i.isText || !i.isLeaf)
        return !1;
      let a = t.state.doc.resolve(o.pos + i.nodeSize * (e < 0 ? -1 : 1));
      return li(t, new Ke(r.$anchor, a));
    } else if (r.empty) {
      if (t.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let o = X0(t.state, e);
        return o && o instanceof ke ? li(t, o) : !1;
      } else if (!(sr && n.indexOf("m") > -1)) {
        let o = r.$head, i = o.textOffset ? null : e < 0 ? o.nodeBefore : o.nodeAfter, a;
        if (!i || i.isText)
          return !1;
        let s = e < 0 ? o.pos - i.nodeSize : o.pos;
        return i.isAtom || (a = t.docView.descAt(s)) && !a.contentDOM ? ke.isSelectable(i) ? li(t, new ke(e < 0 ? t.state.doc.resolve(o.pos - i.nodeSize) : o)) : _u ? li(t, new Ke(t.state.doc.resolve(e < 0 ? s : s + i.nodeSize))) : !1 : !1;
      }
    } else
      return !1;
  else {
    if (r instanceof ke && r.node.isInline)
      return li(t, new Ke(e > 0 ? r.$to : r.$from));
    {
      let o = X0(t.state, e);
      return o ? li(t, o) : !1;
    }
  }
}
function ef(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function ac(t, e) {
  let n = t.pmViewDesc;
  return n && n.size == 0 && (e < 0 || t.nextSibling || t.nodeName != "BR");
}
function ls(t, e) {
  return e < 0 ? D6e(t) : C6e(t);
}
function D6e(t) {
  let e = t.domSelectionRange(), n = e.focusNode, r = e.focusOffset;
  if (!n)
    return;
  let o, i, a = !1;
  for (pr && n.nodeType == 1 && r < ef(n) && ac(n.childNodes[r], -1) && (a = !0); ; )
    if (r > 0) {
      if (n.nodeType != 1)
        break;
      {
        let s = n.childNodes[r - 1];
        if (ac(s, -1))
          o = n, i = --r;
        else if (s.nodeType == 3)
          n = s, r = n.nodeValue.length;
        else
          break;
      }
    } else {
      if (kC(n))
        break;
      {
        let s = n.previousSibling;
        for (; s && ac(s, -1); )
          o = n.parentNode, i = cn(s), s = s.previousSibling;
        if (s)
          n = s, r = ef(n);
        else {
          if (n = n.parentNode, n == t.dom)
            break;
          r = 0;
        }
      }
    }
  a ? j0(t, n, r) : o && j0(t, o, i);
}
function C6e(t) {
  let e = t.domSelectionRange(), n = e.focusNode, r = e.focusOffset;
  if (!n)
    return;
  let o = ef(n), i, a;
  for (; ; )
    if (r < o) {
      if (n.nodeType != 1)
        break;
      let s = n.childNodes[r];
      if (ac(s, 1))
        i = n, a = ++r;
      else
        break;
    } else {
      if (kC(n))
        break;
      {
        let s = n.nextSibling;
        for (; s && ac(s, 1); )
          i = s.parentNode, a = cn(s) + 1, s = s.nextSibling;
        if (s)
          n = s, r = 0, o = ef(n);
        else {
          if (n = n.parentNode, n == t.dom)
            break;
          r = o = 0;
        }
      }
    }
  i && j0(t, i, a);
}
function kC(t) {
  let e = t.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function S6e(t, e) {
  for (; t && e == t.childNodes.length && !hu(t); )
    e = cn(t) + 1, t = t.parentNode;
  for (; t && e < t.childNodes.length; ) {
    let n = t.childNodes[e];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    t = n, e = 0;
  }
}
function w6e(t, e) {
  for (; t && !e && !hu(t); )
    e = cn(t), t = t.parentNode;
  for (; t && e; ) {
    let n = t.childNodes[e - 1];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    t = n, e = t.childNodes.length;
  }
}
function j0(t, e, n) {
  if (e.nodeType != 3) {
    let i, a;
    (a = S6e(e, n)) ? (e = a, n = 0) : (i = w6e(e, n)) && (e = i, n = i.nodeValue.length);
  }
  let r = t.domSelection();
  if (!r)
    return;
  if (c1(r)) {
    let i = document.createRange();
    i.setEnd(e, n), i.setStart(e, n), r.removeAllRanges(), r.addRange(i);
  } else
    r.extend && r.extend(e, n);
  t.domObserver.setCurSelection();
  let { state: o } = t;
  setTimeout(() => {
    t.state == o && Ho(t);
  }, 50);
}
function hI(t, e) {
  let n = t.state.doc.resolve(e);
  if (!(hn || AC) && n.parent.inlineContent) {
    let o = t.coordsAtPos(e);
    if (e > n.start()) {
      let i = t.coordsAtPos(e - 1), a = (i.top + i.bottom) / 2;
      if (a > o.top && a < o.bottom && Math.abs(i.left - o.left) > 1)
        return i.left < o.left ? "ltr" : "rtl";
    }
    if (e < n.end()) {
      let i = t.coordsAtPos(e + 1), a = (i.top + i.bottom) / 2;
      if (a > o.top && a < o.bottom && Math.abs(i.left - o.left) > 1)
        return i.left > o.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(t.dom).direction == "rtl" ? "rtl" : "ltr";
}
function _I(t, e, n) {
  let r = t.state.selection;
  if (r instanceof Ke && !r.empty || n.indexOf("s") > -1 || sr && n.indexOf("m") > -1)
    return !1;
  let { $from: o, $to: i } = r;
  if (!o.parent.inlineContent || t.endOfTextblock(e < 0 ? "up" : "down")) {
    let a = X0(t.state, e);
    if (a && a instanceof ke)
      return li(t, a);
  }
  if (!o.parent.inlineContent) {
    let a = e < 0 ? o : i, s = r instanceof Er ? qe.near(a, e) : qe.findFrom(a, e);
    return s ? li(t, s) : !1;
  }
  return !1;
}
function EI(t, e) {
  if (!(t.state.selection instanceof Ke))
    return !0;
  let { $head: n, $anchor: r, empty: o } = t.state.selection;
  if (!n.sameParent(r))
    return !0;
  if (!o)
    return !1;
  if (t.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let i = !n.textOffset && (e < 0 ? n.nodeBefore : n.nodeAfter);
  if (i && !i.isText) {
    let a = t.state.tr;
    return e < 0 ? a.delete(n.pos - i.nodeSize, n.pos) : a.delete(n.pos, n.pos + i.nodeSize), t.dispatch(a), !0;
  }
  return !1;
}
function pI(t, e, n) {
  t.domObserver.stop(), e.contentEditable = n, t.domObserver.start();
}
function T6e(t) {
  if (!In || t.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: n } = t.domSelectionRange();
  if (e && e.nodeType == 1 && n == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let r = e.firstChild;
    pI(t, r, "true"), setTimeout(() => pI(t, r, "false"), 20);
  }
  return !1;
}
function b6e(t) {
  let e = "";
  return t.ctrlKey && (e += "c"), t.metaKey && (e += "m"), t.altKey && (e += "a"), t.shiftKey && (e += "s"), e;
}
function R6e(t, e) {
  let n = e.keyCode, r = b6e(e);
  if (n == 8 || sr && n == 72 && r == "c")
    return EI(t, -1) || ls(t, -1);
  if (n == 46 && !e.shiftKey || sr && n == 68 && r == "c")
    return EI(t, 1) || ls(t, 1);
  if (n == 13 || n == 27)
    return !0;
  if (n == 37 || sr && n == 66 && r == "c") {
    let o = n == 37 ? hI(t, t.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return fI(t, o, r) || ls(t, o);
  } else if (n == 39 || sr && n == 70 && r == "c") {
    let o = n == 39 ? hI(t, t.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return fI(t, o, r) || ls(t, o);
  } else {
    if (n == 38 || sr && n == 80 && r == "c")
      return _I(t, -1, r) || ls(t, -1);
    if (n == 40 || sr && n == 78 && r == "c")
      return T6e(t) || _I(t, 1, r) || ls(t, 1);
    if (r == (sr ? "m" : "c") && (n == 66 || n == 73 || n == 89 || n == 90))
      return !0;
  }
  return !1;
}
function l2(t, e) {
  t.someProp("transformCopied", (h) => {
    e = h(e, t);
  });
  let n = [], { content: r, openStart: o, openEnd: i } = e;
  for (; o > 1 && i > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    o--, i--;
    let h = r.firstChild;
    n.push(h.type.name, h.attrs != h.type.defaultAttrs ? h.attrs : null), r = h.content;
  }
  let a = t.someProp("clipboardSerializer") || ja.fromSchema(t.state.schema), s = WC(), l = s.createElement("div");
  l.appendChild(a.serializeFragment(r, { document: s }));
  let c = l.firstChild, u, d = 0;
  for (; c && c.nodeType == 1 && (u = HC[c.nodeName.toLowerCase()]); ) {
    for (let h = u.length - 1; h >= 0; h--) {
      let _ = s.createElement(u[h]);
      for (; l.firstChild; )
        _.appendChild(l.firstChild);
      l.appendChild(_), d++;
    }
    c = l.firstChild;
  }
  c && c.nodeType == 1 && c.setAttribute("data-pm-slice", `${o} ${i}${d ? ` -${d}` : ""} ${JSON.stringify(n)}`);
  let f = t.someProp("clipboardTextSerializer", (h) => h(e, t)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: l, text: f, slice: e };
}
function BC(t, e, n, r, o) {
  let i = o.parent.type.spec.code, a, s;
  if (!n && !e)
    return null;
  let l = !!e && (r || i || !n);
  if (l) {
    if (t.someProp("transformPastedText", (f) => {
      e = f(e, i || r, t);
    }), i)
      return s = new Ae(_e.from(t.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0), t.someProp("transformPasted", (f) => {
        s = f(s, t, !0);
      }), s;
    let d = t.someProp("clipboardTextParser", (f) => f(e, o, r, t));
    if (d)
      s = d;
    else {
      let f = o.marks(), { schema: h } = t.state, _ = ja.fromSchema(h);
      a = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((E) => {
        let m = a.appendChild(document.createElement("p"));
        E && m.appendChild(_.serializeNode(h.text(E, f)));
      });
    }
  } else
    t.someProp("transformPastedHTML", (d) => {
      n = d(n, t);
    }), a = L6e(n), _u && x6e(a);
  let c = a && a.querySelector("[data-pm-slice]"), u = c && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(c.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let d = +u[3]; d > 0; d--) {
      let f = a.firstChild;
      for (; f && f.nodeType != 1; )
        f = f.nextSibling;
      if (!f)
        break;
      a = f;
    }
  if (s || (s = (t.someProp("clipboardParser") || t.someProp("domParser") || Di.fromSchema(t.state.schema)).parseSlice(a, {
    preserveWhitespace: !!(l || u),
    context: o,
    ruleFromNode(f) {
      return f.nodeName == "BR" && !f.nextSibling && f.parentNode && !M6e.test(f.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    s = U6e(mI(s, +u[1], +u[2]), u[4]);
  else if (s = Ae.maxOpen(P6e(s.content, o), !0), s.openStart || s.openEnd) {
    let d = 0, f = 0;
    for (let h = s.content.firstChild; d < s.openStart && !h.type.spec.isolating; d++, h = h.firstChild)
      ;
    for (let h = s.content.lastChild; f < s.openEnd && !h.type.spec.isolating; f++, h = h.lastChild)
      ;
    s = mI(s, d, f);
  }
  return t.someProp("transformPasted", (d) => {
    s = d(s, t, l);
  }), s;
}
const M6e = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function P6e(t, e) {
  if (t.childCount < 2)
    return t;
  for (let n = e.depth; n >= 0; n--) {
    let o = e.node(n).contentMatchAt(e.index(n)), i, a = [];
    if (t.forEach((s) => {
      if (!a)
        return;
      let l = o.findWrapping(s.type), c;
      if (!l)
        return a = null;
      if (c = a.length && i.length && FC(l, i, s, a[a.length - 1], 0))
        a[a.length - 1] = c;
      else {
        a.length && (a[a.length - 1] = VC(a[a.length - 1], i.length));
        let u = GC(s, l);
        a.push(u), o = o.matchType(u.type), i = l;
      }
    }), a)
      return _e.from(a);
  }
  return t;
}
function GC(t, e, n = 0) {
  for (let r = e.length - 1; r >= n; r--)
    t = e[r].create(null, _e.from(t));
  return t;
}
function FC(t, e, n, r, o) {
  if (o < t.length && o < e.length && t[o] == e[o]) {
    let i = FC(t, e, n, r.lastChild, o + 1);
    if (i)
      return r.copy(r.content.replaceChild(r.childCount - 1, i));
    if (r.contentMatchAt(r.childCount).matchType(o == t.length - 1 ? n.type : t[o + 1]))
      return r.copy(r.content.append(_e.from(GC(n, t, o + 1))));
  }
}
function VC(t, e) {
  if (e == 0)
    return t;
  let n = t.content.replaceChild(t.childCount - 1, VC(t.lastChild, e - 1)), r = t.contentMatchAt(t.childCount).fillBefore(_e.empty, !0);
  return t.copy(n.append(r));
}
function J0(t, e, n, r, o, i) {
  let a = e < 0 ? t.firstChild : t.lastChild, s = a.content;
  return t.childCount > 1 && (i = 0), o < r - 1 && (s = J0(s, e, n, r, o + 1, i)), o >= n && (s = e < 0 ? a.contentMatchAt(0).fillBefore(s, i <= o).append(s) : s.append(a.contentMatchAt(a.childCount).fillBefore(_e.empty, !0))), t.replaceChild(e < 0 ? 0 : t.childCount - 1, a.copy(s));
}
function mI(t, e, n) {
  return e < t.openStart && (t = new Ae(J0(t.content, -1, e, t.openStart, 0, t.openEnd), e, t.openEnd)), n < t.openEnd && (t = new Ae(J0(t.content, 1, n, t.openEnd, 0, 0), t.openStart, n)), t;
}
const HC = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let NI = null;
function WC() {
  return NI || (NI = document.implementation.createHTMLDocument("title"));
}
let Nh = null;
function y6e(t) {
  let e = window.trustedTypes;
  return e ? (Nh || (Nh = e.defaultPolicy || e.createPolicy("ProseMirrorClipboard", { createHTML: (n) => n })), Nh.createHTML(t)) : t;
}
function L6e(t) {
  let e = /^(\s*<meta [^>]*>)*/.exec(t);
  e && (t = t.slice(e[0].length));
  let n = WC().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(t), o;
  if ((o = r && HC[r[1].toLowerCase()]) && (t = o.map((i) => "<" + i + ">").join("") + t + o.map((i) => "</" + i + ">").reverse().join("")), n.innerHTML = y6e(t), o)
    for (let i = 0; i < o.length; i++)
      n = n.querySelector(o[i]) || n;
  return n;
}
function x6e(t) {
  let e = t.querySelectorAll(hn ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let n = 0; n < e.length; n++) {
    let r = e[n];
    r.childNodes.length == 1 && r.textContent == " " && r.parentNode && r.parentNode.replaceChild(t.ownerDocument.createTextNode(" "), r);
  }
}
function U6e(t, e) {
  if (!t.size)
    return t;
  let n = t.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(e);
  } catch {
    return t;
  }
  let { content: o, openStart: i, openEnd: a } = t;
  for (let s = r.length - 2; s >= 0; s -= 2) {
    let l = n.nodes[r[s]];
    if (!l || l.hasRequiredAttrs())
      break;
    o = _e.from(l.create(r[s + 1], o)), i++, a++;
  }
  return new Ae(o, i, a);
}
const Un = {}, $n = {}, $6e = { touchstart: !0, touchmove: !0 };
class k6e {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.badSafariComposition = !1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function B6e(t) {
  for (let e in Un) {
    let n = Un[e];
    t.dom.addEventListener(e, t.input.eventHandlers[e] = (r) => {
      F6e(t, r) && !c2(t, r) && (t.editable || !(r.type in $n)) && n(t, r);
    }, $6e[e] ? { passive: !0 } : void 0);
  }
  In && t.dom.addEventListener("input", () => null), Q0(t);
}
function vi(t, e) {
  t.input.lastSelectionOrigin = e, t.input.lastSelectionTime = Date.now();
}
function G6e(t) {
  t.domObserver.stop();
  for (let e in t.input.eventHandlers)
    t.dom.removeEventListener(e, t.input.eventHandlers[e]);
  clearTimeout(t.input.composingTimeout), clearTimeout(t.input.lastIOSEnterFallbackTimeout);
}
function Q0(t) {
  t.someProp("handleDOMEvents", (e) => {
    for (let n in e)
      t.input.eventHandlers[n] || t.dom.addEventListener(n, t.input.eventHandlers[n] = (r) => c2(t, r));
  });
}
function c2(t, e) {
  return t.someProp("handleDOMEvents", (n) => {
    let r = n[e.type];
    return r ? r(t, e) || e.defaultPrevented : !1;
  });
}
function F6e(t, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let n = e.target; n != t.dom; n = n.parentNode)
    if (!n || n.nodeType == 11 || n.pmViewDesc && n.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function V6e(t, e) {
  !c2(t, e) && Un[e.type] && (t.editable || !(e.type in $n)) && Un[e.type](t, e);
}
$n.keydown = (t, e) => {
  let n = e;
  if (t.input.shiftKey = n.keyCode == 16 || n.shiftKey, !KC(t, n) && (t.input.lastKeyCode = n.keyCode, t.input.lastKeyCodeTime = Date.now(), !($o && hn && n.keyCode == 13)))
    if (n.keyCode != 229 && t.domObserver.forceFlush(), qs && n.keyCode == 13 && !n.ctrlKey && !n.altKey && !n.metaKey) {
      let r = Date.now();
      t.input.lastIOSEnter = r, t.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        t.input.lastIOSEnter == r && (t.someProp("handleKeyDown", (o) => o(t, ia(13, "Enter"))), t.input.lastIOSEnter = 0);
      }, 200);
    } else
      t.someProp("handleKeyDown", (r) => r(t, n)) || R6e(t, n) ? n.preventDefault() : vi(t, "key");
};
$n.keyup = (t, e) => {
  e.keyCode == 16 && (t.input.shiftKey = !1);
};
$n.keypress = (t, e) => {
  let n = e;
  if (KC(t, n) || !n.charCode || n.ctrlKey && !n.altKey || sr && n.metaKey)
    return;
  if (t.someProp("handleKeyPress", (o) => o(t, n))) {
    n.preventDefault();
    return;
  }
  let r = t.state.selection;
  if (!(r instanceof Ke) || !r.$from.sameParent(r.$to)) {
    let o = String.fromCharCode(n.charCode), i = () => t.state.tr.insertText(o).scrollIntoView();
    !/[\r\n]/.test(o) && !t.someProp("handleTextInput", (a) => a(t, r.$from.pos, r.$to.pos, o, i)) && t.dispatch(i()), n.preventDefault();
  }
};
function d1(t) {
  return { left: t.clientX, top: t.clientY };
}
function H6e(t, e) {
  let n = e.x - t.clientX, r = e.y - t.clientY;
  return n * n + r * r < 100;
}
function u2(t, e, n, r, o) {
  if (r == -1)
    return !1;
  let i = t.state.doc.resolve(r);
  for (let a = i.depth + 1; a > 0; a--)
    if (t.someProp(e, (s) => a > i.depth ? s(t, n, i.nodeAfter, i.before(a), o, !0) : s(t, n, i.node(a), i.before(a), o, !1)))
      return !0;
  return !1;
}
function Ms(t, e, n) {
  if (t.focused || t.focus(), t.state.selection.eq(e))
    return;
  let r = t.state.tr.setSelection(e);
  n == "pointer" && r.setMeta("pointer", !0), t.dispatch(r);
}
function W6e(t, e) {
  if (e == -1)
    return !1;
  let n = t.state.doc.resolve(e), r = n.nodeAfter;
  return r && r.isAtom && ke.isSelectable(r) ? (Ms(t, new ke(n), "pointer"), !0) : !1;
}
function Y6e(t, e) {
  if (e == -1)
    return !1;
  let n = t.state.selection, r, o;
  n instanceof ke && (r = n.node);
  let i = t.state.doc.resolve(e);
  for (let a = i.depth + 1; a > 0; a--) {
    let s = a > i.depth ? i.nodeAfter : i.node(a);
    if (ke.isSelectable(s)) {
      r && n.$from.depth > 0 && a >= n.$from.depth && i.before(n.$from.depth + 1) == n.$from.pos ? o = i.before(n.$from.depth) : o = i.before(a);
      break;
    }
  }
  return o != null ? (Ms(t, ke.create(t.state.doc, o), "pointer"), !0) : !1;
}
function K6e(t, e, n, r, o) {
  return u2(t, "handleClickOn", e, n, r) || t.someProp("handleClick", (i) => i(t, e, r)) || (o ? Y6e(t, n) : W6e(t, n));
}
function z6e(t, e, n, r) {
  return u2(t, "handleDoubleClickOn", e, n, r) || t.someProp("handleDoubleClick", (o) => o(t, e, r));
}
function Z6e(t, e, n, r) {
  return u2(t, "handleTripleClickOn", e, n, r) || t.someProp("handleTripleClick", (o) => o(t, e, r)) || q6e(t, n, r);
}
function q6e(t, e, n) {
  if (n.button != 0)
    return !1;
  let r = t.state.doc;
  if (e == -1)
    return r.inlineContent ? (Ms(t, Ke.create(r, 0, r.content.size), "pointer"), !0) : !1;
  let o = r.resolve(e);
  for (let i = o.depth + 1; i > 0; i--) {
    let a = i > o.depth ? o.nodeAfter : o.node(i), s = o.before(i);
    if (a.inlineContent)
      Ms(t, Ke.create(r, s + 1, s + 1 + a.content.size), "pointer");
    else if (ke.isSelectable(a))
      Ms(t, ke.create(r, s), "pointer");
    else
      continue;
    return !0;
  }
}
function d2(t) {
  return tf(t);
}
const YC = sr ? "metaKey" : "ctrlKey";
Un.mousedown = (t, e) => {
  let n = e;
  t.input.shiftKey = n.shiftKey;
  let r = d2(t), o = Date.now(), i = "singleClick";
  o - t.input.lastClick.time < 500 && H6e(n, t.input.lastClick) && !n[YC] && t.input.lastClick.button == n.button && (t.input.lastClick.type == "singleClick" ? i = "doubleClick" : t.input.lastClick.type == "doubleClick" && (i = "tripleClick")), t.input.lastClick = { time: o, x: n.clientX, y: n.clientY, type: i, button: n.button };
  let a = t.posAtCoords(d1(n));
  a && (i == "singleClick" ? (t.input.mouseDown && t.input.mouseDown.done(), t.input.mouseDown = new X6e(t, a, n, !!r)) : (i == "doubleClick" ? z6e : Z6e)(t, a.pos, a.inside, n) ? n.preventDefault() : vi(t, "pointer"));
};
class X6e {
  constructor(e, n, r, o) {
    this.view = e, this.pos = n, this.event = r, this.flushed = o, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!r[YC], this.allowDefault = r.shiftKey;
    let i, a;
    if (n.inside > -1)
      i = e.state.doc.nodeAt(n.inside), a = n.inside;
    else {
      let u = e.state.doc.resolve(n.pos);
      i = u.parent, a = u.depth ? u.before() : 0;
    }
    const s = o ? null : r.target, l = s ? e.docView.nearestDesc(s, !0) : null;
    this.target = l && l.nodeDOM.nodeType == 1 ? l.nodeDOM : null;
    let { selection: c } = e.state;
    (r.button == 0 && i.type.spec.draggable && i.type.spec.selectable !== !1 || c instanceof ke && c.from <= a && c.to > a) && (this.mightDrag = {
      node: i,
      pos: a,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && pr && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), vi(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => Ho(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let n = this.pos;
    this.view.state.doc != this.startDoc && (n = this.view.posAtCoords(d1(e))), this.updateAllowDefault(e), this.allowDefault || !n ? vi(this.view, "pointer") : K6e(this.view, n.pos, n.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    In && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    hn && !this.view.state.selection.visible && Math.min(Math.abs(n.pos - this.view.state.selection.from), Math.abs(n.pos - this.view.state.selection.to)) <= 2) ? (Ms(this.view, qe.near(this.view.state.doc.resolve(n.pos)), "pointer"), e.preventDefault()) : vi(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), vi(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
Un.touchstart = (t) => {
  t.input.lastTouch = Date.now(), d2(t), vi(t, "pointer");
};
Un.touchmove = (t) => {
  t.input.lastTouch = Date.now(), vi(t, "pointer");
};
Un.contextmenu = (t) => d2(t);
function KC(t, e) {
  return t.composing ? !0 : In && Math.abs(e.timeStamp - t.input.compositionEndedAt) < 500 ? (t.input.compositionEndedAt = -2e8, !0) : !1;
}
const j6e = $o ? 5e3 : -1;
$n.compositionstart = $n.compositionupdate = (t) => {
  if (!t.composing) {
    t.domObserver.flush();
    let { state: e } = t, n = e.selection.$to;
    if (e.selection instanceof Ke && (e.storedMarks || !n.textOffset && n.parentOffset && n.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1) || hn && AC && J6e(t)))
      t.markCursor = t.state.storedMarks || n.marks(), tf(t, !0), t.markCursor = null;
    else if (tf(t, !e.selection.empty), pr && e.selection.empty && n.parentOffset && !n.textOffset && n.nodeBefore.marks.length) {
      let r = t.domSelectionRange();
      for (let o = r.focusNode, i = r.focusOffset; o && o.nodeType == 1 && i != 0; ) {
        let a = i < 0 ? o.lastChild : o.childNodes[i - 1];
        if (!a)
          break;
        if (a.nodeType == 3) {
          let s = t.domSelection();
          s && s.collapse(a, a.nodeValue.length);
          break;
        } else
          o = a, i = -1;
      }
    }
    t.input.composing = !0;
  }
  zC(t, j6e);
};
function J6e(t) {
  let { focusNode: e, focusOffset: n } = t.domSelectionRange();
  if (!e || e.nodeType != 1 || n >= e.childNodes.length)
    return !1;
  let r = e.childNodes[n];
  return r.nodeType == 1 && r.contentEditable == "false";
}
$n.compositionend = (t, e) => {
  t.composing && (t.input.composing = !1, t.input.compositionEndedAt = e.timeStamp, t.input.compositionPendingChanges = t.domObserver.pendingRecords().length ? t.input.compositionID : 0, t.input.compositionNode = null, t.input.badSafariComposition ? t.domObserver.forceFlush() : t.input.compositionPendingChanges && Promise.resolve().then(() => t.domObserver.flush()), t.input.compositionID++, zC(t, 20));
};
function zC(t, e) {
  clearTimeout(t.input.composingTimeout), e > -1 && (t.input.composingTimeout = setTimeout(() => tf(t), e));
}
function ZC(t) {
  for (t.composing && (t.input.composing = !1, t.input.compositionEndedAt = e7e()); t.input.compositionNodes.length > 0; )
    t.input.compositionNodes.pop().markParentsDirty();
}
function Q6e(t) {
  let e = t.domSelectionRange();
  if (!e.focusNode)
    return null;
  let n = YDe(e.focusNode, e.focusOffset), r = KDe(e.focusNode, e.focusOffset);
  if (n && r && n != r) {
    let o = r.pmViewDesc, i = t.domObserver.lastChangedTextNode;
    if (n == i || r == i)
      return i;
    if (!o || !o.isText(r.nodeValue))
      return r;
    if (t.input.compositionNode == r) {
      let a = n.pmViewDesc;
      if (!(!a || !a.isText(n.nodeValue)))
        return r;
    }
  }
  return n || r;
}
function e7e() {
  let t = document.createEvent("Event");
  return t.initEvent("event", !0, !0), t.timeStamp;
}
function tf(t, e = !1) {
  if (!($o && t.domObserver.flushingSoon >= 0)) {
    if (t.domObserver.forceFlush(), ZC(t), e || t.docView && t.docView.dirty) {
      let n = a2(t), r = t.state.selection;
      return n && !n.eq(r) ? t.dispatch(t.state.tr.setSelection(n)) : (t.markCursor || e) && !r.$from.node(r.$from.sharedDepth(r.to)).inlineContent ? t.dispatch(t.state.tr.deleteSelection()) : t.updateState(t.state), !0;
    }
    return !1;
  }
}
function t7e(t, e) {
  if (!t.dom.parentNode)
    return;
  let n = t.dom.parentNode.appendChild(document.createElement("div"));
  n.appendChild(e), n.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), o = document.createRange();
  o.selectNodeContents(e), t.dom.blur(), r.removeAllRanges(), r.addRange(o), setTimeout(() => {
    n.parentNode && n.parentNode.removeChild(n), t.focus();
  }, 50);
}
const $c = Yn && Ci < 15 || qs && XDe < 604;
Un.copy = $n.cut = (t, e) => {
  let n = e, r = t.state.selection, o = n.type == "cut";
  if (r.empty)
    return;
  let i = $c ? null : n.clipboardData, a = r.content(), { dom: s, text: l } = l2(t, a);
  i ? (n.preventDefault(), i.clearData(), i.setData("text/html", s.innerHTML), i.setData("text/plain", l)) : t7e(t, s), o && t.dispatch(t.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function n7e(t) {
  return t.openStart == 0 && t.openEnd == 0 && t.content.childCount == 1 ? t.content.firstChild : null;
}
function r7e(t, e) {
  if (!t.dom.parentNode)
    return;
  let n = t.input.shiftKey || t.state.selection.$from.parent.type.spec.code, r = t.dom.parentNode.appendChild(document.createElement(n ? "textarea" : "div"));
  n || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let o = t.input.shiftKey && t.input.lastKeyCode != 45;
  setTimeout(() => {
    t.focus(), r.parentNode && r.parentNode.removeChild(r), n ? kc(t, r.value, null, o, e) : kc(t, r.textContent, r.innerHTML, o, e);
  }, 50);
}
function kc(t, e, n, r, o) {
  let i = BC(t, e, n, r, t.state.selection.$from);
  if (t.someProp("handlePaste", (l) => l(t, o, i || Ae.empty)))
    return !0;
  if (!i)
    return !1;
  let a = n7e(i), s = a ? t.state.tr.replaceSelectionWith(a, r) : t.state.tr.replaceSelection(i);
  return t.dispatch(s.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function qC(t) {
  let e = t.getData("text/plain") || t.getData("Text");
  if (e)
    return e;
  let n = t.getData("text/uri-list");
  return n ? n.replace(/\r?\n/g, " ") : "";
}
$n.paste = (t, e) => {
  let n = e;
  if (t.composing && !$o)
    return;
  let r = $c ? null : n.clipboardData, o = t.input.shiftKey && t.input.lastKeyCode != 45;
  r && kc(t, qC(r), r.getData("text/html"), o, n) ? n.preventDefault() : r7e(t, n);
};
class XC {
  constructor(e, n, r) {
    this.slice = e, this.move = n, this.node = r;
  }
}
const o7e = sr ? "altKey" : "ctrlKey";
function jC(t, e) {
  let n = t.someProp("dragCopies", (r) => !r(e));
  return n ?? !e[o7e];
}
Un.dragstart = (t, e) => {
  let n = e, r = t.input.mouseDown;
  if (r && r.done(), !n.dataTransfer)
    return;
  let o = t.state.selection, i = o.empty ? null : t.posAtCoords(d1(n)), a;
  if (!(i && i.pos >= o.from && i.pos <= (o instanceof ke ? o.to - 1 : o.to))) {
    if (r && r.mightDrag)
      a = ke.create(t.state.doc, r.mightDrag.pos);
    else if (n.target && n.target.nodeType == 1) {
      let d = t.docView.nearestDesc(n.target, !0);
      d && d.node.type.spec.draggable && d != t.docView && (a = ke.create(t.state.doc, d.posBefore));
    }
  }
  let s = (a || t.state.selection).content(), { dom: l, text: c, slice: u } = l2(t, s);
  (!n.dataTransfer.files.length || !hn || OC > 120) && n.dataTransfer.clearData(), n.dataTransfer.setData($c ? "Text" : "text/html", l.innerHTML), n.dataTransfer.effectAllowed = "copyMove", $c || n.dataTransfer.setData("text/plain", c), t.dragging = new XC(u, jC(t, n), a);
};
Un.dragend = (t) => {
  let e = t.dragging;
  window.setTimeout(() => {
    t.dragging == e && (t.dragging = null);
  }, 50);
};
$n.dragover = $n.dragenter = (t, e) => e.preventDefault();
$n.drop = (t, e) => {
  try {
    i7e(t, e, t.dragging);
  } finally {
    t.dragging = null;
  }
};
function i7e(t, e, n) {
  if (!e.dataTransfer)
    return;
  let r = t.posAtCoords(d1(e));
  if (!r)
    return;
  let o = t.state.doc.resolve(r.pos), i = n && n.slice;
  i ? t.someProp("transformPasted", (h) => {
    i = h(i, t, !1);
  }) : i = BC(t, qC(e.dataTransfer), $c ? null : e.dataTransfer.getData("text/html"), !1, o);
  let a = !!(n && jC(t, e));
  if (t.someProp("handleDrop", (h) => h(t, e, i || Ae.empty, a))) {
    e.preventDefault();
    return;
  }
  if (!i)
    return;
  e.preventDefault();
  let s = i ? _C(t.state.doc, o.pos, i) : o.pos;
  s == null && (s = o.pos);
  let l = t.state.tr;
  if (a) {
    let { node: h } = n;
    h ? h.replace(l) : l.deleteSelection();
  }
  let c = l.mapping.map(s), u = i.openStart == 0 && i.openEnd == 0 && i.content.childCount == 1, d = l.doc;
  if (u ? l.replaceRangeWith(c, c, i.content.firstChild) : l.replaceRange(c, c, i), l.doc.eq(d))
    return;
  let f = l.doc.resolve(c);
  if (u && ke.isSelectable(i.content.firstChild) && f.nodeAfter && f.nodeAfter.sameMarkup(i.content.firstChild))
    l.setSelection(new ke(f));
  else {
    let h = l.mapping.map(s);
    l.mapping.maps[l.mapping.maps.length - 1].forEach((_, E, m, N) => h = N), l.setSelection(s2(t, f, l.doc.resolve(h)));
  }
  t.focus(), t.dispatch(l.setMeta("uiEvent", "drop"));
}
Un.focus = (t) => {
  t.input.lastFocus = Date.now(), t.focused || (t.domObserver.stop(), t.dom.classList.add("ProseMirror-focused"), t.domObserver.start(), t.focused = !0, setTimeout(() => {
    t.docView && t.hasFocus() && !t.domObserver.currentSelection.eq(t.domSelectionRange()) && Ho(t);
  }, 20));
};
Un.blur = (t, e) => {
  let n = e;
  t.focused && (t.domObserver.stop(), t.dom.classList.remove("ProseMirror-focused"), t.domObserver.start(), n.relatedTarget && t.dom.contains(n.relatedTarget) && t.domObserver.currentSelection.clear(), t.focused = !1);
};
Un.beforeinput = (t, e) => {
  if (hn && $o && e.inputType == "deleteContentBackward") {
    t.domObserver.flushSoon();
    let { domChangeCount: r } = t.input;
    setTimeout(() => {
      if (t.input.domChangeCount != r || (t.dom.blur(), t.focus(), t.someProp("handleKeyDown", (i) => i(t, ia(8, "Backspace")))))
        return;
      let { $cursor: o } = t.state.selection;
      o && o.pos > 0 && t.dispatch(t.state.tr.delete(o.pos - 1, o.pos).scrollIntoView());
    }, 50);
  }
};
for (let t in $n)
  Un[t] = $n[t];
function Bc(t, e) {
  if (t == e)
    return !0;
  for (let n in t)
    if (t[n] !== e[n])
      return !1;
  for (let n in e)
    if (!(n in t))
      return !1;
  return !0;
}
class nf {
  constructor(e, n) {
    this.toDOM = e, this.spec = n || Na, this.side = this.spec.side || 0;
  }
  map(e, n, r, o) {
    let { pos: i, deleted: a } = e.mapResult(n.from + o, this.side < 0 ? -1 : 1);
    return a ? null : new fr(i - r, i - r, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof nf && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && Bc(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class wi {
  constructor(e, n) {
    this.attrs = e, this.spec = n || Na;
  }
  map(e, n, r, o) {
    let i = e.map(n.from + o, this.spec.inclusiveStart ? -1 : 1) - r, a = e.map(n.to + o, this.spec.inclusiveEnd ? 1 : -1) - r;
    return i >= a ? null : new fr(i, a, this);
  }
  valid(e, n) {
    return n.from < n.to;
  }
  eq(e) {
    return this == e || e instanceof wi && Bc(this.attrs, e.attrs) && Bc(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof wi;
  }
  destroy() {
  }
}
class f2 {
  constructor(e, n) {
    this.attrs = e, this.spec = n || Na;
  }
  map(e, n, r, o) {
    let i = e.mapResult(n.from + o, 1);
    if (i.deleted)
      return null;
    let a = e.mapResult(n.to + o, -1);
    return a.deleted || a.pos <= i.pos ? null : new fr(i.pos - r, a.pos - r, this);
  }
  valid(e, n) {
    let { index: r, offset: o } = e.content.findIndex(n.from), i;
    return o == n.from && !(i = e.child(r)).isText && o + i.nodeSize == n.to;
  }
  eq(e) {
    return this == e || e instanceof f2 && Bc(this.attrs, e.attrs) && Bc(this.spec, e.spec);
  }
  destroy() {
  }
}
class fr {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.from = e, this.to = n, this.type = r;
  }
  /**
  @internal
  */
  copy(e, n) {
    return new fr(e, n, this.type);
  }
  /**
  @internal
  */
  eq(e, n = 0) {
    return this.type.eq(e.type) && this.from + n == e.from && this.to + n == e.to;
  }
  /**
  @internal
  */
  map(e, n, r) {
    return this.type.map(e, this, n, r);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, n, r) {
    return new fr(e, e, new nf(n, r));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, n, r, o) {
    return new fr(e, n, new wi(r, o));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, n, r, o) {
    return new fr(e, n, new f2(r, o));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof wi;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof nf;
  }
}
const ps = [], Na = {};
class jt {
  /**
  @internal
  */
  constructor(e, n) {
    this.local = e.length ? e : ps, this.children = n.length ? n : ps;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, n) {
    return n.length ? rf(n, e, 0, Na) : mn;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, n, r) {
    let o = [];
    return this.findInner(e ?? 0, n ?? 1e9, o, 0, r), o;
  }
  findInner(e, n, r, o, i) {
    for (let a = 0; a < this.local.length; a++) {
      let s = this.local[a];
      s.from <= n && s.to >= e && (!i || i(s.spec)) && r.push(s.copy(s.from + o, s.to + o));
    }
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] < n && this.children[a + 1] > e) {
        let s = this.children[a] + 1;
        this.children[a + 2].findInner(e - s, n - s, r, o + s, i);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, n, r) {
    return this == mn || e.maps.length == 0 ? this : this.mapInner(e, n, 0, 0, r || Na);
  }
  /**
  @internal
  */
  mapInner(e, n, r, o, i) {
    let a;
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s].map(e, r, o);
      l && l.type.valid(n, l) ? (a || (a = [])).push(l) : i.onRemove && i.onRemove(this.local[s].spec);
    }
    return this.children.length ? a7e(this.children, a || [], e, n, r, o, i) : a ? new jt(a.sort(va), ps) : mn;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, n) {
    return n.length ? this == mn ? jt.create(e, n) : this.addInner(e, n, 0) : this;
  }
  addInner(e, n, r) {
    let o, i = 0;
    e.forEach((s, l) => {
      let c = l + r, u;
      if (u = QC(n, s, c)) {
        for (o || (o = this.children.slice()); i < o.length && o[i] < l; )
          i += 3;
        o[i] == l ? o[i + 2] = o[i + 2].addInner(s, u, c + 1) : o.splice(i, 0, l, l + s.nodeSize, rf(u, s, c + 1, Na)), i += 3;
      }
    });
    let a = JC(i ? e8(n) : n, -r);
    for (let s = 0; s < a.length; s++)
      a[s].type.valid(e, a[s]) || a.splice(s--, 1);
    return new jt(a.length ? this.local.concat(a).sort(va) : this.local, o || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == mn ? this : this.removeInner(e, 0);
  }
  removeInner(e, n) {
    let r = this.children, o = this.local;
    for (let i = 0; i < r.length; i += 3) {
      let a, s = r[i] + n, l = r[i + 1] + n;
      for (let u = 0, d; u < e.length; u++)
        (d = e[u]) && d.from > s && d.to < l && (e[u] = null, (a || (a = [])).push(d));
      if (!a)
        continue;
      r == this.children && (r = this.children.slice());
      let c = r[i + 2].removeInner(a, s + 1);
      c != mn ? r[i + 2] = c : (r.splice(i, 3), i -= 3);
    }
    if (o.length) {
      for (let i = 0, a; i < e.length; i++)
        if (a = e[i])
          for (let s = 0; s < o.length; s++)
            o[s].eq(a, n) && (o == this.local && (o = this.local.slice()), o.splice(s--, 1));
    }
    return r == this.children && o == this.local ? this : o.length || r.length ? new jt(o, r) : mn;
  }
  forChild(e, n) {
    if (this == mn)
      return this;
    if (n.isLeaf)
      return jt.empty;
    let r, o;
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] >= e) {
        this.children[s] == e && (r = this.children[s + 2]);
        break;
      }
    let i = e + 1, a = i + n.content.size;
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s];
      if (l.from < a && l.to > i && l.type instanceof wi) {
        let c = Math.max(i, l.from) - i, u = Math.min(a, l.to) - i;
        c < u && (o || (o = [])).push(l.copy(c, u));
      }
    }
    if (o) {
      let s = new jt(o.sort(va), ps);
      return r ? new di([s, r]) : s;
    }
    return r || mn;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof jt) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let n = 0; n < this.local.length; n++)
      if (!this.local[n].eq(e.local[n]))
        return !1;
    for (let n = 0; n < this.children.length; n += 3)
      if (this.children[n] != e.children[n] || this.children[n + 1] != e.children[n + 1] || !this.children[n + 2].eq(e.children[n + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return h2(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == mn)
      return ps;
    if (e.inlineContent || !this.local.some(wi.is))
      return this.local;
    let n = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof wi || n.push(this.local[r]);
    return n;
  }
  forEachSet(e) {
    e(this);
  }
}
jt.empty = new jt([], []);
jt.removeOverlap = h2;
const mn = jt.empty;
class di {
  constructor(e) {
    this.members = e;
  }
  map(e, n) {
    const r = this.members.map((o) => o.map(e, n, Na));
    return di.from(r);
  }
  forChild(e, n) {
    if (n.isLeaf)
      return jt.empty;
    let r = [];
    for (let o = 0; o < this.members.length; o++) {
      let i = this.members[o].forChild(e, n);
      i != mn && (i instanceof di ? r = r.concat(i.members) : r.push(i));
    }
    return di.from(r);
  }
  eq(e) {
    if (!(e instanceof di) || e.members.length != this.members.length)
      return !1;
    for (let n = 0; n < this.members.length; n++)
      if (!this.members[n].eq(e.members[n]))
        return !1;
    return !0;
  }
  locals(e) {
    let n, r = !0;
    for (let o = 0; o < this.members.length; o++) {
      let i = this.members[o].localsInner(e);
      if (i.length)
        if (!n)
          n = i;
        else {
          r && (n = n.slice(), r = !1);
          for (let a = 0; a < i.length; a++)
            n.push(i[a]);
        }
    }
    return n ? h2(r ? n : n.sort(va)) : ps;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return mn;
      case 1:
        return e[0];
      default:
        return new di(e.every((n) => n instanceof jt) ? e : e.reduce((n, r) => n.concat(r instanceof jt ? r : r.members), []));
    }
  }
  forEachSet(e) {
    for (let n = 0; n < this.members.length; n++)
      this.members[n].forEachSet(e);
  }
}
function a7e(t, e, n, r, o, i, a) {
  let s = t.slice();
  for (let c = 0, u = i; c < n.maps.length; c++) {
    let d = 0;
    n.maps[c].forEach((f, h, _, E) => {
      let m = E - _ - (h - f);
      for (let N = 0; N < s.length; N += 3) {
        let I = s[N + 1];
        if (I < 0 || f > I + u - d)
          continue;
        let O = s[N] + u - d;
        h >= O ? s[N + 1] = f <= O ? -2 : -1 : f >= u && m && (s[N] += m, s[N + 1] += m);
      }
      d += m;
    }), u = n.maps[c].map(u, -1);
  }
  let l = !1;
  for (let c = 0; c < s.length; c += 3)
    if (s[c + 1] < 0) {
      if (s[c + 1] == -2) {
        l = !0, s[c + 1] = -1;
        continue;
      }
      let u = n.map(t[c] + i), d = u - o;
      if (d < 0 || d >= r.content.size) {
        l = !0;
        continue;
      }
      let f = n.map(t[c + 1] + i, -1), h = f - o, { index: _, offset: E } = r.content.findIndex(d), m = r.maybeChild(_);
      if (m && E == d && E + m.nodeSize == h) {
        let N = s[c + 2].mapInner(n, m, u + 1, t[c] + i + 1, a);
        N != mn ? (s[c] = d, s[c + 1] = h, s[c + 2] = N) : (s[c + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let c = s7e(s, t, e, n, o, i, a), u = rf(c, r, 0, a);
    e = u.local;
    for (let d = 0; d < s.length; d += 3)
      s[d + 1] < 0 && (s.splice(d, 3), d -= 3);
    for (let d = 0, f = 0; d < u.children.length; d += 3) {
      let h = u.children[d];
      for (; f < s.length && s[f] < h; )
        f += 3;
      s.splice(f, 0, u.children[d], u.children[d + 1], u.children[d + 2]);
    }
  }
  return new jt(e.sort(va), s);
}
function JC(t, e) {
  if (!e || !t.length)
    return t;
  let n = [];
  for (let r = 0; r < t.length; r++) {
    let o = t[r];
    n.push(new fr(o.from + e, o.to + e, o.type));
  }
  return n;
}
function s7e(t, e, n, r, o, i, a) {
  function s(l, c) {
    for (let u = 0; u < l.local.length; u++) {
      let d = l.local[u].map(r, o, c);
      d ? n.push(d) : a.onRemove && a.onRemove(l.local[u].spec);
    }
    for (let u = 0; u < l.children.length; u += 3)
      s(l.children[u + 2], l.children[u] + c + 1);
  }
  for (let l = 0; l < t.length; l += 3)
    t[l + 1] == -1 && s(t[l + 2], e[l] + i + 1);
  return n;
}
function QC(t, e, n) {
  if (e.isLeaf)
    return null;
  let r = n + e.nodeSize, o = null;
  for (let i = 0, a; i < t.length; i++)
    (a = t[i]) && a.from > n && a.to < r && ((o || (o = [])).push(a), t[i] = null);
  return o;
}
function e8(t) {
  let e = [];
  for (let n = 0; n < t.length; n++)
    t[n] != null && e.push(t[n]);
  return e;
}
function rf(t, e, n, r) {
  let o = [], i = !1;
  e.forEach((s, l) => {
    let c = QC(t, s, l + n);
    if (c) {
      i = !0;
      let u = rf(c, s, n + l + 1, r);
      u != mn && o.push(l, l + s.nodeSize, u);
    }
  });
  let a = JC(i ? e8(t) : t, -n).sort(va);
  for (let s = 0; s < a.length; s++)
    a[s].type.valid(e, a[s]) || (r.onRemove && r.onRemove(a[s].spec), a.splice(s--, 1));
  return a.length || o.length ? new jt(a, o) : mn;
}
function va(t, e) {
  return t.from - e.from || t.to - e.to;
}
function h2(t) {
  let e = t;
  for (let n = 0; n < e.length - 1; n++) {
    let r = e[n];
    if (r.from != r.to)
      for (let o = n + 1; o < e.length; o++) {
        let i = e[o];
        if (i.from == r.from) {
          i.to != r.to && (e == t && (e = t.slice()), e[o] = i.copy(i.from, r.to), vI(e, o + 1, i.copy(r.to, i.to)));
          continue;
        } else {
          i.from < r.to && (e == t && (e = t.slice()), e[n] = r.copy(r.from, i.from), vI(e, o, r.copy(i.from, r.to)));
          break;
        }
      }
  }
  return e;
}
function vI(t, e, n) {
  for (; e < t.length && va(n, t[e]) > 0; )
    e++;
  t.splice(e, 0, n);
}
function vh(t) {
  let e = [];
  return t.someProp("decorations", (n) => {
    let r = n(t.state);
    r && r != mn && e.push(r);
  }), t.cursorWrapper && e.push(jt.create(t.state.doc, [t.cursorWrapper.deco])), di.from(e);
}
const l7e = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, c7e = Yn && Ci <= 11;
class u7e {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class d7e {
  constructor(e, n) {
    this.view = e, this.handleDOMChange = n, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new u7e(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let o = 0; o < r.length; o++)
        this.queue.push(r[o]);
      Yn && Ci <= 11 && r.some((o) => o.type == "childList" && o.removedNodes.length || o.type == "characterData" && o.oldValue.length > o.target.nodeValue.length) ? this.flushSoon() : In && e.composing && r.some((o) => o.type == "childList" && o.target.nodeName == "TR") ? (e.input.badSafariComposition = !0, this.flushSoon()) : this.flush();
    }), c7e && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, l7e)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let n = 0; n < e.length; n++)
          this.queue.push(e[n]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (dI(this.view)) {
      if (this.suppressingSelectionUpdates)
        return Ho(this.view);
      if (Yn && Ci <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && xa(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let n = /* @__PURE__ */ new Set(), r;
    for (let i = e.focusNode; i; i = Zs(i))
      n.add(i);
    for (let i = e.anchorNode; i; i = Zs(i))
      if (n.has(i)) {
        r = i;
        break;
      }
    let o = r && this.view.docView.nearestDesc(r);
    if (o && o.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let n = this.pendingRecords();
    n.length && (this.queue = []);
    let r = e.domSelectionRange(), o = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && dI(e) && !this.ignoreSelectionChange(r), i = -1, a = -1, s = !1, l = [];
    if (e.editable)
      for (let u = 0; u < n.length; u++) {
        let d = this.registerMutation(n[u], l);
        d && (i = i < 0 ? d.from : Math.min(d.from, i), a = a < 0 ? d.to : Math.max(d.to, a), d.typeOver && (s = !0));
      }
    if (l.some((u) => u.nodeName == "BR") && (e.input.lastKeyCode == 8 || e.input.lastKeyCode == 46)) {
      for (let u of l)
        if (u.nodeName == "BR" && u.parentNode) {
          let d = u.nextSibling;
          for (; d && d.nodeType == 1; ) {
            if (d.contentEditable == "false") {
              u.parentNode.removeChild(u);
              break;
            }
            d = d.firstChild;
          }
        }
    } else if (pr && l.length) {
      let u = l.filter((d) => d.nodeName == "BR");
      if (u.length == 2) {
        let [d, f] = u;
        d.parentNode && d.parentNode.parentNode == f.parentNode ? f.remove() : d.remove();
      } else {
        let { focusNode: d } = this.currentSelection;
        for (let f of u) {
          let h = f.parentNode;
          h && h.nodeName == "LI" && (!d || _7e(e, d) != h) && f.remove();
        }
      }
    }
    let c = null;
    i < 0 && o && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && c1(r) && (c = a2(e)) && c.eq(qe.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, Ho(e), this.currentSelection.set(r), e.scrollToSelection()) : (i > -1 || o) && (i > -1 && (e.docView.markDirty(i, a), f7e(e)), e.input.badSafariComposition && (e.input.badSafariComposition = !1, E7e(e, l)), this.handleDOMChange(i, a, s, l), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(r) || Ho(e), this.currentSelection.set(r));
  }
  registerMutation(e, n) {
    if (n.indexOf(e.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (r == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !r || r.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let u = 0; u < e.addedNodes.length; u++) {
        let d = e.addedNodes[u];
        n.push(d), d.nodeType == 3 && (this.lastChangedTextNode = d);
      }
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(e.target))
        return { from: r.posBefore, to: r.posAfter };
      let o = e.previousSibling, i = e.nextSibling;
      if (Yn && Ci <= 11 && e.addedNodes.length)
        for (let u = 0; u < e.addedNodes.length; u++) {
          let { previousSibling: d, nextSibling: f } = e.addedNodes[u];
          (!d || Array.prototype.indexOf.call(e.addedNodes, d) < 0) && (o = d), (!f || Array.prototype.indexOf.call(e.addedNodes, f) < 0) && (i = f);
        }
      let a = o && o.parentNode == e.target ? cn(o) + 1 : 0, s = r.localPosFromDOM(e.target, a, -1), l = i && i.parentNode == e.target ? cn(i) : e.target.childNodes.length, c = r.localPosFromDOM(e.target, l, 1);
      return { from: s, to: c };
    } else
      return e.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : (this.lastChangedTextNode = e.target, {
        from: r.posAtStart,
        to: r.posAtEnd,
        // An event was generated for a text change that didn't change
        // any text. Mark the dom change to fall back to assuming the
        // selection was typed over with an identical value if it can't
        // find another change.
        typeOver: e.target.nodeValue == e.oldValue
      });
  }
}
let gI = /* @__PURE__ */ new WeakMap(), II = !1;
function f7e(t) {
  if (!gI.has(t) && (gI.set(t, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(t.dom).whiteSpace) !== -1)) {
    if (t.requiresGeckoHackNode = pr, II)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), II = !0;
  }
}
function OI(t, e) {
  let n = e.startContainer, r = e.startOffset, o = e.endContainer, i = e.endOffset, a = t.domAtPos(t.state.selection.anchor);
  return xa(a.node, a.offset, o, i) && ([n, r, o, i] = [o, i, n, r]), { anchorNode: n, anchorOffset: r, focusNode: o, focusOffset: i };
}
function h7e(t, e) {
  if (e.getComposedRanges) {
    let o = e.getComposedRanges(t.root)[0];
    if (o)
      return OI(t, o);
  }
  let n;
  function r(o) {
    o.preventDefault(), o.stopImmediatePropagation(), n = o.getTargetRanges()[0];
  }
  return t.dom.addEventListener("beforeinput", r, !0), document.execCommand("indent"), t.dom.removeEventListener("beforeinput", r, !0), n ? OI(t, n) : null;
}
function _7e(t, e) {
  for (let n = e.parentNode; n && n != t.dom; n = n.parentNode) {
    let r = t.docView.nearestDesc(n, !0);
    if (r && r.node.isBlock)
      return n;
  }
  return null;
}
function E7e(t, e) {
  var n;
  let { focusNode: r, focusOffset: o } = t.domSelectionRange();
  for (let i of e)
    if (((n = i.parentNode) === null || n === void 0 ? void 0 : n.nodeName) == "TR") {
      let a = i.nextSibling;
      for (; a && a.nodeName != "TD" && a.nodeName != "TH"; )
        a = a.nextSibling;
      if (a) {
        let s = a;
        for (; ; ) {
          let l = s.firstChild;
          if (!l || l.nodeType != 1 || l.contentEditable == "false" || /^(BR|IMG)$/.test(l.nodeName))
            break;
          s = l;
        }
        s.insertBefore(i, s.firstChild), r == i && t.domSelection().collapse(i, o);
      } else
        i.parentNode.removeChild(i);
    }
}
function p7e(t, e, n) {
  let { node: r, fromOffset: o, toOffset: i, from: a, to: s } = t.docView.parseRange(e, n), l = t.domSelectionRange(), c, u = l.anchorNode;
  if (u && t.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (c = [{ node: u, offset: l.anchorOffset }], c1(l) || c.push({ node: l.focusNode, offset: l.focusOffset })), hn && t.input.lastKeyCode === 8)
    for (let m = i; m > o; m--) {
      let N = r.childNodes[m - 1], I = N.pmViewDesc;
      if (N.nodeName == "BR" && !I) {
        i = m;
        break;
      }
      if (!I || I.size)
        break;
    }
  let d = t.state.doc, f = t.someProp("domParser") || Di.fromSchema(t.state.schema), h = d.resolve(a), _ = null, E = f.parse(r, {
    topNode: h.parent,
    topMatch: h.parent.contentMatchAt(h.index()),
    topOpen: !0,
    from: o,
    to: i,
    preserveWhitespace: h.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: c,
    ruleFromNode: m7e,
    context: h
  });
  if (c && c[0].pos != null) {
    let m = c[0].pos, N = c[1] && c[1].pos;
    N == null && (N = m), _ = { anchor: m + a, head: N + a };
  }
  return { doc: E, sel: _, from: a, to: s };
}
function m7e(t) {
  let e = t.pmViewDesc;
  if (e)
    return e.parseRule();
  if (t.nodeName == "BR" && t.parentNode) {
    if (In && /^(ul|ol)$/i.test(t.parentNode.nodeName)) {
      let n = document.createElement("div");
      return n.appendChild(document.createElement("li")), { skip: n };
    } else if (t.parentNode.lastChild == t || In && /^(tr|table)$/i.test(t.parentNode.nodeName))
      return { ignore: !0 };
  } else if (t.nodeName == "IMG" && t.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const N7e = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function v7e(t, e, n, r, o) {
  let i = t.input.compositionPendingChanges || (t.composing ? t.input.compositionID : 0);
  if (t.input.compositionPendingChanges = 0, e < 0) {
    let T = t.input.lastSelectionTime > Date.now() - 50 ? t.input.lastSelectionOrigin : null, k = a2(t, T);
    if (k && !t.state.selection.eq(k)) {
      if (hn && $o && t.input.lastKeyCode === 13 && Date.now() - 100 < t.input.lastKeyCodeTime && t.someProp("handleKeyDown", (b) => b(t, ia(13, "Enter"))))
        return;
      let G = t.state.tr.setSelection(k);
      T == "pointer" ? G.setMeta("pointer", !0) : T == "key" && G.scrollIntoView(), i && G.setMeta("composition", i), t.dispatch(G);
    }
    return;
  }
  let a = t.state.doc.resolve(e), s = a.sharedDepth(n);
  e = a.before(s + 1), n = t.state.doc.resolve(n).after(s + 1);
  let l = t.state.selection, c = p7e(t, e, n), u = t.state.doc, d = u.slice(c.from, c.to), f, h;
  t.input.lastKeyCode === 8 && Date.now() - 100 < t.input.lastKeyCodeTime ? (f = t.state.selection.to, h = "end") : (f = t.state.selection.from, h = "start"), t.input.lastKeyCode = null;
  let _ = O7e(d.content, c.doc.content, c.from, f, h);
  if (_ && t.input.domChangeCount++, (qs && t.input.lastIOSEnter > Date.now() - 225 || $o) && o.some((T) => T.nodeType == 1 && !N7e.test(T.nodeName)) && (!_ || _.endA >= _.endB) && t.someProp("handleKeyDown", (T) => T(t, ia(13, "Enter")))) {
    t.input.lastIOSEnter = 0;
    return;
  }
  if (!_)
    if (r && l instanceof Ke && !l.empty && l.$head.sameParent(l.$anchor) && !t.composing && !(c.sel && c.sel.anchor != c.sel.head))
      _ = { start: l.from, endA: l.to, endB: l.to };
    else {
      if (c.sel) {
        let T = AI(t, t.state.doc, c.sel);
        if (T && !T.eq(t.state.selection)) {
          let k = t.state.tr.setSelection(T);
          i && k.setMeta("composition", i), t.dispatch(k);
        }
      }
      return;
    }
  t.state.selection.from < t.state.selection.to && _.start == _.endB && t.state.selection instanceof Ke && (_.start > t.state.selection.from && _.start <= t.state.selection.from + 2 && t.state.selection.from >= c.from ? _.start = t.state.selection.from : _.endA < t.state.selection.to && _.endA >= t.state.selection.to - 2 && t.state.selection.to <= c.to && (_.endB += t.state.selection.to - _.endA, _.endA = t.state.selection.to)), Yn && Ci <= 11 && _.endB == _.start + 1 && _.endA == _.start && _.start > c.from && c.doc.textBetween(_.start - c.from - 1, _.start - c.from + 1) == "  " && (_.start--, _.endA--, _.endB--);
  let E = c.doc.resolveNoCache(_.start - c.from), m = c.doc.resolveNoCache(_.endB - c.from), N = u.resolve(_.start), I = E.sameParent(m) && E.parent.inlineContent && N.end() >= _.endA;
  if ((qs && t.input.lastIOSEnter > Date.now() - 225 && (!I || o.some((T) => T.nodeName == "DIV" || T.nodeName == "P")) || !I && E.pos < c.doc.content.size && (!E.sameParent(m) || !E.parent.inlineContent) && E.pos < m.pos && !/\S/.test(c.doc.textBetween(E.pos, m.pos, "", ""))) && t.someProp("handleKeyDown", (T) => T(t, ia(13, "Enter")))) {
    t.input.lastIOSEnter = 0;
    return;
  }
  if (t.state.selection.anchor > _.start && I7e(u, _.start, _.endA, E, m) && t.someProp("handleKeyDown", (T) => T(t, ia(8, "Backspace")))) {
    $o && hn && t.domObserver.suppressSelectionUpdates();
    return;
  }
  hn && _.endB == _.start && (t.input.lastChromeDelete = Date.now()), $o && !I && E.start() != m.start() && m.parentOffset == 0 && E.depth == m.depth && c.sel && c.sel.anchor == c.sel.head && c.sel.head == _.endA && (_.endB -= 2, m = c.doc.resolveNoCache(_.endB - c.from), setTimeout(() => {
    t.someProp("handleKeyDown", function(T) {
      return T(t, ia(13, "Enter"));
    });
  }, 20));
  let O = _.start, p = _.endA, C = (T) => {
    let k = T || t.state.tr.replace(O, p, c.doc.slice(_.start - c.from, _.endB - c.from));
    if (c.sel) {
      let G = AI(t, k.doc, c.sel);
      G && !(hn && t.composing && G.empty && (_.start != _.endB || t.input.lastChromeDelete < Date.now() - 100) && (G.head == O || G.head == k.mapping.map(p) - 1) || Yn && G.empty && G.head == O) && k.setSelection(G);
    }
    return i && k.setMeta("composition", i), k.scrollIntoView();
  }, D;
  if (I)
    if (E.pos == m.pos) {
      Yn && Ci <= 11 && E.parentOffset == 0 && (t.domObserver.suppressSelectionUpdates(), setTimeout(() => Ho(t), 20));
      let T = C(t.state.tr.delete(O, p)), k = u.resolve(_.start).marksAcross(u.resolve(_.endA));
      k && T.ensureMarks(k), t.dispatch(T);
    } else if (
      // Adding or removing a mark
      _.endA == _.endB && (D = g7e(E.parent.content.cut(E.parentOffset, m.parentOffset), N.parent.content.cut(N.parentOffset, _.endA - N.start())))
    ) {
      let T = C(t.state.tr);
      D.type == "add" ? T.addMark(O, p, D.mark) : T.removeMark(O, p, D.mark), t.dispatch(T);
    } else if (E.parent.child(E.index()).isText && E.index() == m.index() - (m.textOffset ? 0 : 1)) {
      let T = E.parent.textBetween(E.parentOffset, m.parentOffset), k = () => C(t.state.tr.insertText(T, O, p));
      t.someProp("handleTextInput", (G) => G(t, O, p, T, k)) || t.dispatch(k());
    } else
      t.dispatch(C());
  else
    t.dispatch(C());
}
function AI(t, e, n) {
  return Math.max(n.anchor, n.head) > e.content.size ? null : s2(t, e.resolve(n.anchor), e.resolve(n.head));
}
function g7e(t, e) {
  let n = t.firstChild.marks, r = e.firstChild.marks, o = n, i = r, a, s, l;
  for (let u = 0; u < r.length; u++)
    o = r[u].removeFromSet(o);
  for (let u = 0; u < n.length; u++)
    i = n[u].removeFromSet(i);
  if (o.length == 1 && i.length == 0)
    s = o[0], a = "add", l = (u) => u.mark(s.addToSet(u.marks));
  else if (o.length == 0 && i.length == 1)
    s = i[0], a = "remove", l = (u) => u.mark(s.removeFromSet(u.marks));
  else
    return null;
  let c = [];
  for (let u = 0; u < e.childCount; u++)
    c.push(l(e.child(u)));
  if (_e.from(c).eq(t))
    return { mark: s, type: a };
}
function I7e(t, e, n, r, o) {
  if (
    // The content must have shrunk
    n - e <= o.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
    gh(r, !0, !1) < o.pos
  )
    return !1;
  let i = t.resolve(e);
  if (!r.parent.isTextblock) {
    let s = i.nodeAfter;
    return s != null && n == e + s.nodeSize;
  }
  if (i.parentOffset < i.parent.content.size || !i.parent.isTextblock)
    return !1;
  let a = t.resolve(gh(i, !0, !0));
  return !a.parent.isTextblock || a.pos > n || gh(a, !0, !1) < n ? !1 : r.parent.content.cut(r.parentOffset).eq(a.parent.content);
}
function gh(t, e, n) {
  let r = t.depth, o = e ? t.end() : t.pos;
  for (; r > 0 && (e || t.indexAfter(r) == t.node(r).childCount); )
    r--, o++, e = !1;
  if (n) {
    let i = t.node(r).maybeChild(t.indexAfter(r));
    for (; i && !i.isLeaf; )
      i = i.firstChild, o++;
  }
  return o;
}
function O7e(t, e, n, r, o) {
  let i = t.findDiffStart(e, n);
  if (i == null)
    return null;
  let { a, b: s } = t.findDiffEnd(e, n + t.size, n + e.size);
  if (o == "end") {
    let l = Math.max(0, i - Math.min(a, s));
    r -= a + l - i;
  }
  if (a < i && t.size < e.size) {
    let l = r <= i && r >= a ? i - r : 0;
    i -= l, i && i < e.size && DI(e.textBetween(i - 1, i + 1)) && (i += l ? 1 : -1), s = i + (s - a), a = i;
  } else if (s < i) {
    let l = r <= i && r >= s ? i - r : 0;
    i -= l, i && i < t.size && DI(t.textBetween(i - 1, i + 1)) && (i += l ? 1 : -1), a = i + (a - s), s = i;
  }
  return { start: i, endA: a, endB: s };
}
function DI(t) {
  if (t.length != 2)
    return !1;
  let e = t.charCodeAt(0), n = t.charCodeAt(1);
  return e >= 56320 && e <= 57343 && n >= 55296 && n <= 56319;
}
class t8 {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, n) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new k6e(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = n, this.state = n.state, this.directPlugins = n.plugins || [], this.directPlugins.forEach(bI), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = wI(this), SI(this), this.nodeViews = TI(this), this.docView = iI(this.state.doc, CI(this), vh(this), this.dom, this), this.domObserver = new d7e(this, (r, o, i, a) => v7e(this, r, o, i, a)), this.domObserver.start(), B6e(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let n in e)
        this._props[n] = e[n];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && Q0(this);
    let n = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(bI), this.directPlugins = e.plugins), this.updateStateInner(e.state, n);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let n = {};
    for (let r in this._props)
      n[r] = this._props[r];
    n.state = this.state;
    for (let r in e)
      n[r] = e[r];
    this.update(n);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, n) {
    var r;
    let o = this.state, i = !1, a = !1;
    e.storedMarks && this.composing && (ZC(this), a = !0), this.state = e;
    let s = o.plugins != e.plugins || this._props.plugins != n.plugins;
    if (s || this._props.plugins != n.plugins || this._props.nodeViews != n.nodeViews) {
      let h = TI(this);
      D7e(h, this.nodeViews) && (this.nodeViews = h, i = !0);
    }
    (s || n.handleDOMEvents != this._props.handleDOMEvents) && Q0(this), this.editable = wI(this), SI(this);
    let l = vh(this), c = CI(this), u = o.plugins != e.plugins && !o.doc.eq(e.doc) ? "reset" : e.scrollToSelection > o.scrollToSelection ? "to selection" : "preserve", d = i || !this.docView.matchesNode(e.doc, c, l);
    (d || !e.selection.eq(o.selection)) && (a = !0);
    let f = u == "preserve" && a && this.dom.style.overflowAnchor == null && QDe(this);
    if (a) {
      this.domObserver.stop();
      let h = d && (Yn || hn) && !this.composing && !o.selection.empty && !e.selection.empty && A7e(o.selection, e.selection);
      if (d) {
        let _ = hn ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = Q6e(this)), (i || !this.docView.update(e.doc, c, l, this)) && (this.docView.updateOuterDeco(c), this.docView.destroy(), this.docView = iI(e.doc, c, l, this.dom, this)), _ && (!this.trackWrites || !this.dom.contains(this.trackWrites)) && (h = !0);
      }
      h || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && A6e(this)) ? Ho(this, h) : (UC(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(o), !((r = this.dragging) === null || r === void 0) && r.node && !o.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, o), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : f && e6e(f);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (n) => n(this)))
        if (this.state.selection instanceof ke) {
          let n = this.docView.domAfterPos(this.state.selection.from);
          n.nodeType == 1 && Qg(this, n.getBoundingClientRect(), e);
        } else
          Qg(this, this.coordsAtPos(this.state.selection.head, 1), e);
    }
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let n = 0; n < this.directPlugins.length; n++) {
        let r = this.directPlugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let n = 0; n < this.state.plugins.length; n++) {
        let r = this.state.plugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let n = 0; n < this.pluginViews.length; n++) {
        let r = this.pluginViews[n];
        r.update && r.update(this, e);
      }
  }
  updateDraggedNode(e, n) {
    let r = e.node, o = -1;
    if (r.from < this.state.doc.content.size && this.state.doc.nodeAt(r.from) == r.node)
      o = r.from;
    else {
      let i = r.from + (this.state.doc.content.size - n.doc.content.size);
      (i > 0 && i < this.state.doc.content.size && this.state.doc.nodeAt(i)) == r.node && (o = i);
    }
    this.dragging = new XC(e.slice, e.move, o < 0 ? void 0 : ke.create(this.state.doc, o));
  }
  someProp(e, n) {
    let r = this._props && this._props[e], o;
    if (r != null && (o = n ? n(r) : r))
      return o;
    for (let a = 0; a < this.directPlugins.length; a++) {
      let s = this.directPlugins[a].props[e];
      if (s != null && (o = n ? n(s) : s))
        return o;
    }
    let i = this.state.plugins;
    if (i)
      for (let a = 0; a < i.length; a++) {
        let s = i[a].props[e];
        if (s != null && (o = n ? n(s) : s))
          return o;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (Yn) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && t6e(this.dom), Ho(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let n = this.dom.parentNode; n; n = n.parentNode)
        if (n.nodeType == 9 || n.nodeType == 11 && n.host)
          return n.getSelection || (Object.getPrototypeOf(n).getSelection = () => n.ownerDocument.getSelection()), this._root = n;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return a6e(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, n = 1) {
    return TC(this, e, n);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, n = 0) {
    return this.docView.domFromPos(e, n);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let n = this.docView.descAt(e);
    return n ? n.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, n, r = -1) {
    let o = this.docView.posFromDOM(e, n, r);
    if (o == null)
      throw new RangeError("DOM position not inside the editor");
    return o;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, n) {
    return d6e(this, n || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, n) {
    return kc(this, "", e, !1, n || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, n) {
    return kc(this, e, null, !0, n || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(e) {
    return l2(this, e);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (G6e(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], vh(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, HDe());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return V6e(this, e);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? In && this.root.nodeType === 11 && ZDe(this.dom.ownerDocument) == this.dom && h7e(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
t8.prototype.dispatch = function(t) {
  let e = this._props.dispatchTransaction;
  e ? e.call(this, t) : this.updateState(this.state.apply(t));
};
function CI(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(t.editable), t.someProp("attributes", (n) => {
    if (typeof n == "function" && (n = n(t.state)), n)
      for (let r in n)
        r == "class" ? e.class += " " + n[r] : r == "style" ? e.style = (e.style ? e.style + ";" : "") + n[r] : !e[r] && r != "contenteditable" && r != "nodeName" && (e[r] = String(n[r]));
  }), e.translate || (e.translate = "no"), [fr.node(0, t.state.doc.content.size, e)];
}
function SI(t) {
  if (t.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), t.cursorWrapper = { dom: e, deco: fr.widget(t.state.selection.from, e, { raw: !0, marks: t.markCursor }) };
  } else
    t.cursorWrapper = null;
}
function wI(t) {
  return !t.someProp("editable", (e) => e(t.state) === !1);
}
function A7e(t, e) {
  let n = Math.min(t.$anchor.sharedDepth(t.head), e.$anchor.sharedDepth(e.head));
  return t.$anchor.start(n) != e.$anchor.start(n);
}
function TI(t) {
  let e = /* @__PURE__ */ Object.create(null);
  function n(r) {
    for (let o in r)
      Object.prototype.hasOwnProperty.call(e, o) || (e[o] = r[o]);
  }
  return t.someProp("nodeViews", n), t.someProp("markViews", n), e;
}
function D7e(t, e) {
  let n = 0, r = 0;
  for (let o in t) {
    if (t[o] != e[o])
      return !0;
    n++;
  }
  for (let o in e)
    r++;
  return n != r;
}
function bI(t) {
  if (t.spec.state || t.spec.filterTransaction || t.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var Pi = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, of = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, C7e = typeof navigator < "u" && /Mac/.test(navigator.platform), S7e = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var un = 0; un < 10; un++)
  Pi[48 + un] = Pi[96 + un] = String(un);
for (var un = 1; un <= 24; un++)
  Pi[un + 111] = "F" + un;
for (var un = 65; un <= 90; un++)
  Pi[un] = String.fromCharCode(un + 32), of[un] = String.fromCharCode(un);
for (var Ih in Pi)
  of.hasOwnProperty(Ih) || (of[Ih] = Pi[Ih]);
function w7e(t) {
  var e = C7e && t.metaKey && t.shiftKey && !t.ctrlKey && !t.altKey || S7e && t.shiftKey && t.key && t.key.length == 1 || t.key == "Unidentified", n = !e && t.key || (t.shiftKey ? of : Pi)[t.keyCode] || t.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
const T7e = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), b7e = typeof navigator < "u" && /Win/.test(navigator.platform);
function R7e(t) {
  let e = t.split(/-(?!$)/), n = e[e.length - 1];
  n == "Space" && (n = " ");
  let r, o, i, a;
  for (let s = 0; s < e.length - 1; s++) {
    let l = e[s];
    if (/^(cmd|meta|m)$/i.test(l))
      a = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      o = !0;
    else if (/^s(hift)?$/i.test(l))
      i = !0;
    else if (/^mod$/i.test(l))
      T7e ? a = !0 : o = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return r && (n = "Alt-" + n), o && (n = "Ctrl-" + n), a && (n = "Meta-" + n), i && (n = "Shift-" + n), n;
}
function M7e(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t)
    e[R7e(n)] = t[n];
  return e;
}
function Oh(t, e, n = !0) {
  return e.altKey && (t = "Alt-" + t), e.ctrlKey && (t = "Ctrl-" + t), e.metaKey && (t = "Meta-" + t), n && e.shiftKey && (t = "Shift-" + t), t;
}
function P7e(t) {
  return new Dn({ props: { handleKeyDown: n8(t) } });
}
function n8(t) {
  let e = M7e(t);
  return function(n, r) {
    let o = w7e(r), i, a = e[Oh(o, r)];
    if (a && a(n.state, n.dispatch, n))
      return !0;
    if (o.length == 1 && o != " ") {
      if (r.shiftKey) {
        let s = e[Oh(o, r, !1)];
        if (s && s(n.state, n.dispatch, n))
          return !0;
      }
      if ((r.altKey || r.metaKey || r.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(b7e && r.ctrlKey && r.altKey) && (i = Pi[r.keyCode]) && i != o) {
        let s = e[Oh(i, r)];
        if (s && s(n.state, n.dispatch, n))
          return !0;
      }
    }
    return !1;
  };
}
const y7e = (t, e) => t.selection.empty ? !1 : (e && e(t.tr.deleteSelection().scrollIntoView()), !0);
function r8(t, e) {
  let { $cursor: n } = t.selection;
  return !n || (e ? !e.endOfTextblock("backward", t) : n.parentOffset > 0) ? null : n;
}
const L7e = (t, e, n) => {
  let r = r8(t, n);
  if (!r)
    return !1;
  let o = _2(r);
  if (!o) {
    let a = r.blockRange(), s = a && Nl(a);
    return s == null ? !1 : (e && e(t.tr.lift(a, s).scrollIntoView()), !0);
  }
  let i = o.nodeBefore;
  if (s8(t, o, e, -1))
    return !0;
  if (r.parent.content.size == 0 && (Xs(i, "end") || ke.isSelectable(i)))
    for (let a = r.depth; ; a--) {
      let s = s1(t.doc, r.before(a), r.after(a), Ae.empty);
      if (s && s.slice.size < s.to - s.from) {
        if (e) {
          let l = t.tr.step(s);
          l.setSelection(Xs(i, "end") ? qe.findFrom(l.doc.resolve(l.mapping.map(o.pos, -1)), -1) : ke.create(l.doc, o.pos - i.nodeSize)), e(l.scrollIntoView());
        }
        return !0;
      }
      if (a == 1 || r.node(a - 1).childCount > 1)
        break;
    }
  return i.isAtom && o.depth == r.depth - 1 ? (e && e(t.tr.delete(o.pos - i.nodeSize, o.pos).scrollIntoView()), !0) : !1;
}, x7e = (t, e, n) => {
  let r = r8(t, n);
  if (!r)
    return !1;
  let o = _2(r);
  return o ? o8(t, o, e) : !1;
}, U7e = (t, e, n) => {
  let r = i8(t, n);
  if (!r)
    return !1;
  let o = E2(r);
  return o ? o8(t, o, e) : !1;
};
function o8(t, e, n) {
  let r = e.nodeBefore, o = r, i = e.pos - 1;
  for (; !o.isTextblock; i--) {
    if (o.type.spec.isolating)
      return !1;
    let u = o.lastChild;
    if (!u)
      return !1;
    o = u;
  }
  let a = e.nodeAfter, s = a, l = e.pos + 1;
  for (; !s.isTextblock; l++) {
    if (s.type.spec.isolating)
      return !1;
    let u = s.firstChild;
    if (!u)
      return !1;
    s = u;
  }
  let c = s1(t.doc, i, l, Ae.empty);
  if (!c || c.from != i || c instanceof Qt && c.slice.size >= l - i)
    return !1;
  if (n) {
    let u = t.tr.step(c);
    u.setSelection(Ke.create(u.doc, i)), n(u.scrollIntoView());
  }
  return !0;
}
function Xs(t, e, n = !1) {
  for (let r = t; r; r = e == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (n && r.childCount != 1)
      return !1;
  }
  return !1;
}
const $7e = (t, e, n) => {
  let { $head: r, empty: o } = t.selection, i = r;
  if (!o)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("backward", t) : r.parentOffset > 0)
      return !1;
    i = _2(r);
  }
  let a = i && i.nodeBefore;
  return !a || !ke.isSelectable(a) ? !1 : (e && e(t.tr.setSelection(ke.create(t.doc, i.pos - a.nodeSize)).scrollIntoView()), !0);
};
function _2(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      if (t.index(e) > 0)
        return t.doc.resolve(t.before(e + 1));
      if (t.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function i8(t, e) {
  let { $cursor: n } = t.selection;
  return !n || (e ? !e.endOfTextblock("forward", t) : n.parentOffset < n.parent.content.size) ? null : n;
}
const k7e = (t, e, n) => {
  let r = i8(t, n);
  if (!r)
    return !1;
  let o = E2(r);
  if (!o)
    return !1;
  let i = o.nodeAfter;
  if (s8(t, o, e, 1))
    return !0;
  if (r.parent.content.size == 0 && (Xs(i, "start") || ke.isSelectable(i))) {
    let a = s1(t.doc, r.before(), r.after(), Ae.empty);
    if (a && a.slice.size < a.to - a.from) {
      if (e) {
        let s = t.tr.step(a);
        s.setSelection(Xs(i, "start") ? qe.findFrom(s.doc.resolve(s.mapping.map(o.pos)), 1) : ke.create(s.doc, s.mapping.map(o.pos))), e(s.scrollIntoView());
      }
      return !0;
    }
  }
  return i.isAtom && o.depth == r.depth - 1 ? (e && e(t.tr.delete(o.pos, o.pos + i.nodeSize).scrollIntoView()), !0) : !1;
}, B7e = (t, e, n) => {
  let { $head: r, empty: o } = t.selection, i = r;
  if (!o)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("forward", t) : r.parentOffset < r.parent.content.size)
      return !1;
    i = E2(r);
  }
  let a = i && i.nodeAfter;
  return !a || !ke.isSelectable(a) ? !1 : (e && e(t.tr.setSelection(ke.create(t.doc, i.pos)).scrollIntoView()), !0);
};
function E2(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      let n = t.node(e);
      if (t.index(e) + 1 < n.childCount)
        return t.doc.resolve(t.after(e + 1));
      if (n.type.spec.isolating)
        break;
    }
  return null;
}
const G7e = (t, e) => {
  let n = t.selection, r = n instanceof ke, o;
  if (r) {
    if (n.node.isTextblock || !Wi(t.doc, n.from))
      return !1;
    o = n.from;
  } else if (o = a1(t.doc, n.from, -1), o == null)
    return !1;
  if (e) {
    let i = t.tr.join(o);
    r && i.setSelection(ke.create(i.doc, o - t.doc.resolve(o).nodeBefore.nodeSize)), e(i.scrollIntoView());
  }
  return !0;
}, F7e = (t, e) => {
  let n = t.selection, r;
  if (n instanceof ke) {
    if (n.node.isTextblock || !Wi(t.doc, n.to))
      return !1;
    r = n.to;
  } else if (r = a1(t.doc, n.to, 1), r == null)
    return !1;
  return e && e(t.tr.join(r).scrollIntoView()), !0;
}, V7e = (t, e) => {
  let { $from: n, $to: r } = t.selection, o = n.blockRange(r), i = o && Nl(o);
  return i == null ? !1 : (e && e(t.tr.lift(o, i).scrollIntoView()), !0);
}, H7e = (t, e) => {
  let { $head: n, $anchor: r } = t.selection;
  return !n.parent.type.spec.code || !n.sameParent(r) ? !1 : (e && e(t.tr.insertText(`
`).scrollIntoView()), !0);
};
function a8(t) {
  for (let e = 0; e < t.edgeCount; e++) {
    let { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
const W7e = (t, e) => {
  let { $head: n, $anchor: r } = t.selection;
  if (!n.parent.type.spec.code || !n.sameParent(r))
    return !1;
  let o = n.node(-1), i = n.indexAfter(-1), a = a8(o.contentMatchAt(i));
  if (!a || !o.canReplaceWith(i, i, a))
    return !1;
  if (e) {
    let s = n.after(), l = t.tr.replaceWith(s, s, a.createAndFill());
    l.setSelection(qe.near(l.doc.resolve(s), 1)), e(l.scrollIntoView());
  }
  return !0;
}, Y7e = (t, e) => {
  let n = t.selection, { $from: r, $to: o } = n;
  if (n instanceof Er || r.parent.inlineContent || o.parent.inlineContent)
    return !1;
  let i = a8(o.parent.contentMatchAt(o.indexAfter()));
  if (!i || !i.isTextblock)
    return !1;
  if (e) {
    let a = (!r.parentOffset && o.index() < o.parent.childCount ? r : o).pos, s = t.tr.insert(a, i.createAndFill());
    s.setSelection(Ke.create(s.doc, a + 1)), e(s.scrollIntoView());
  }
  return !0;
}, K7e = (t, e) => {
  let { $cursor: n } = t.selection;
  if (!n || n.parent.content.size)
    return !1;
  if (n.depth > 1 && n.after() != n.end(-1)) {
    let i = n.before();
    if (bs(t.doc, i))
      return e && e(t.tr.split(i).scrollIntoView()), !0;
  }
  let r = n.blockRange(), o = r && Nl(r);
  return o == null ? !1 : (e && e(t.tr.lift(r, o).scrollIntoView()), !0);
}, z7e = (t, e) => {
  let { $from: n, to: r } = t.selection, o, i = n.sharedDepth(r);
  return i == 0 ? !1 : (o = n.before(i), e && e(t.tr.setSelection(ke.create(t.doc, o))), !0);
};
function Z7e(t, e, n) {
  let r = e.nodeBefore, o = e.nodeAfter, i = e.index();
  return !r || !o || !r.type.compatibleContent(o.type) ? !1 : !r.content.size && e.parent.canReplace(i - 1, i) ? (n && n(t.tr.delete(e.pos - r.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(i, i + 1) || !(o.isTextblock || Wi(t.doc, e.pos)) ? !1 : (n && n(t.tr.join(e.pos).scrollIntoView()), !0);
}
function s8(t, e, n, r) {
  let o = e.nodeBefore, i = e.nodeAfter, a, s, l = o.type.spec.isolating || i.type.spec.isolating;
  if (!l && Z7e(t, e, n))
    return !0;
  let c = !l && e.parent.canReplace(e.index(), e.index() + 1);
  if (c && (a = (s = o.contentMatchAt(o.childCount)).findWrapping(i.type)) && s.matchType(a[0] || i.type).validEnd) {
    if (n) {
      let h = e.pos + i.nodeSize, _ = _e.empty;
      for (let N = a.length - 1; N >= 0; N--)
        _ = _e.from(a[N].create(null, _));
      _ = _e.from(o.copy(_));
      let E = t.tr.step(new tn(e.pos - 1, h, e.pos, h, new Ae(_, 1, 0), a.length, !0)), m = E.doc.resolve(h + 2 * a.length);
      m.nodeAfter && m.nodeAfter.type == o.type && Wi(E.doc, m.pos) && E.join(m.pos), n(E.scrollIntoView());
    }
    return !0;
  }
  let u = i.type.spec.isolating || r > 0 && l ? null : qe.findFrom(e, 1), d = u && u.$from.blockRange(u.$to), f = d && Nl(d);
  if (f != null && f >= e.depth)
    return n && n(t.tr.lift(d, f).scrollIntoView()), !0;
  if (c && Xs(i, "start", !0) && Xs(o, "end")) {
    let h = o, _ = [];
    for (; _.push(h), !h.isTextblock; )
      h = h.lastChild;
    let E = i, m = 1;
    for (; !E.isTextblock; E = E.firstChild)
      m++;
    if (h.canReplace(h.childCount, h.childCount, E.content)) {
      if (n) {
        let N = _e.empty;
        for (let O = _.length - 1; O >= 0; O--)
          N = _e.from(_[O].copy(N));
        let I = t.tr.step(new tn(e.pos - _.length, e.pos + i.nodeSize, e.pos + m, e.pos + i.nodeSize - m, new Ae(N, _.length, 0), 0, !0));
        n(I.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function l8(t) {
  return function(e, n) {
    let r = e.selection, o = t < 0 ? r.$from : r.$to, i = o.depth;
    for (; o.node(i).isInline; ) {
      if (!i)
        return !1;
      i--;
    }
    return o.node(i).isTextblock ? (n && n(e.tr.setSelection(Ke.create(e.doc, t < 0 ? o.start(i) : o.end(i)))), !0) : !1;
  };
}
const q7e = l8(-1), X7e = l8(1);
function j7e(t, e = null) {
  return function(n, r) {
    let { $from: o, $to: i } = n.selection, a = o.blockRange(i), s = a && r2(a, t, e);
    return s ? (r && r(n.tr.wrap(a, s).scrollIntoView()), !0) : !1;
  };
}
function RI(t, e = null) {
  return function(n, r) {
    let o = !1;
    for (let i = 0; i < n.selection.ranges.length && !o; i++) {
      let { $from: { pos: a }, $to: { pos: s } } = n.selection.ranges[i];
      n.doc.nodesBetween(a, s, (l, c) => {
        if (o)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(t, e)))
          if (l.type == t)
            o = !0;
          else {
            let u = n.doc.resolve(c), d = u.index();
            o = u.parent.canReplaceWith(d, d + 1, t);
          }
      });
    }
    if (!o)
      return !1;
    if (r) {
      let i = n.tr;
      for (let a = 0; a < n.selection.ranges.length; a++) {
        let { $from: { pos: s }, $to: { pos: l } } = n.selection.ranges[a];
        i.setBlockType(s, l, t, e);
      }
      r(i.scrollIntoView());
    }
    return !0;
  };
}
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function J7e(t, e = null) {
  return function(n, r) {
    let { $from: o, $to: i } = n.selection, a = o.blockRange(i);
    if (!a)
      return !1;
    let s = r ? n.tr : null;
    return Q7e(s, a, t, e) ? (r && r(s.scrollIntoView()), !0) : !1;
  };
}
function Q7e(t, e, n, r = null) {
  let o = !1, i = e, a = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(n) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let l = a.resolve(e.start - 2);
    i = new jd(l, l, e.depth), e.endIndex < e.parent.childCount && (e = new jd(e.$from, a.resolve(e.$to.end(e.depth)), e.depth)), o = !0;
  }
  let s = r2(i, n, r, e);
  return s ? (t && eCe(t, e, s, o, n), !0) : !1;
}
function eCe(t, e, n, r, o) {
  let i = _e.empty;
  for (let u = n.length - 1; u >= 0; u--)
    i = _e.from(n[u].type.create(n[u].attrs, i));
  t.step(new tn(e.start - (r ? 2 : 0), e.end, e.start, e.end, new Ae(i, 0, 0), n.length, !0));
  let a = 0;
  for (let u = 0; u < n.length; u++)
    n[u].type == o && (a = u + 1);
  let s = n.length - a, l = e.start + n.length - (r ? 2 : 0), c = e.parent;
  for (let u = e.startIndex, d = e.endIndex, f = !0; u < d; u++, f = !1)
    !f && bs(t.doc, l, s) && (t.split(l, s), l += 2 * s), l += c.child(u).nodeSize;
  return t;
}
function tCe(t) {
  return function(e, n) {
    let { $from: r, $to: o } = e.selection, i = r.blockRange(o, (a) => a.childCount > 0 && a.firstChild.type == t);
    return i ? n ? r.node(i.depth - 1).type == t ? nCe(e, n, t, i) : rCe(e, n, i) : !0 : !1;
  };
}
function nCe(t, e, n, r) {
  let o = t.tr, i = r.end, a = r.$to.end(r.depth);
  i < a && (o.step(new tn(i - 1, a, i, a, new Ae(_e.from(n.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new jd(o.doc.resolve(r.$from.pos), o.doc.resolve(a), r.depth));
  const s = Nl(r);
  if (s == null)
    return !1;
  o.lift(r, s);
  let l = o.doc.resolve(o.mapping.map(i, -1) - 1);
  return Wi(o.doc, l.pos) && l.nodeBefore.type == l.nodeAfter.type && o.join(l.pos), e(o.scrollIntoView()), !0;
}
function rCe(t, e, n) {
  let r = t.tr, o = n.parent;
  for (let h = n.end, _ = n.endIndex - 1, E = n.startIndex; _ > E; _--)
    h -= o.child(_).nodeSize, r.delete(h - 1, h + 1);
  let i = r.doc.resolve(n.start), a = i.nodeAfter;
  if (r.mapping.map(n.end) != n.start + i.nodeAfter.nodeSize)
    return !1;
  let s = n.startIndex == 0, l = n.endIndex == o.childCount, c = i.node(-1), u = i.index(-1);
  if (!c.canReplace(u + (s ? 0 : 1), u + 1, a.content.append(l ? _e.empty : _e.from(o))))
    return !1;
  let d = i.pos, f = d + a.nodeSize;
  return r.step(new tn(d - (s ? 1 : 0), f + (l ? 1 : 0), d + 1, f - 1, new Ae((s ? _e.empty : _e.from(o.copy(_e.empty))).append(l ? _e.empty : _e.from(o.copy(_e.empty))), s ? 0 : 1, l ? 0 : 1), s ? 0 : 1)), e(r.scrollIntoView()), !0;
}
function oCe(t) {
  return function(e, n) {
    let { $from: r, $to: o } = e.selection, i = r.blockRange(o, (c) => c.childCount > 0 && c.firstChild.type == t);
    if (!i)
      return !1;
    let a = i.startIndex;
    if (a == 0)
      return !1;
    let s = i.parent, l = s.child(a - 1);
    if (l.type != t)
      return !1;
    if (n) {
      let c = l.lastChild && l.lastChild.type == s.type, u = _e.from(c ? t.create() : null), d = new Ae(_e.from(t.create(null, _e.from(s.type.create(null, u)))), c ? 3 : 1, 0), f = i.start, h = i.end;
      n(e.tr.step(new tn(f - (c ? 3 : 1), h, f, h, d, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function f1(t) {
  const { state: e, transaction: n } = t;
  let { selection: r } = n, { doc: o } = n, { storedMarks: i } = n;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return i;
    },
    get selection() {
      return r;
    },
    get doc() {
      return o;
    },
    get tr() {
      return r = n.selection, o = n.doc, i = n.storedMarks, n;
    }
  };
}
class h1 {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: n, state: r } = this, { view: o } = n, { tr: i } = r, a = this.buildProps(i);
    return Object.fromEntries(Object.entries(e).map(([s, l]) => [s, (...u) => {
      const d = l(...u)(a);
      return !i.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(i), d;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, n = !0) {
    const { rawCommands: r, editor: o, state: i } = this, { view: a } = o, s = [], l = !!e, c = e || i.tr, u = () => (!l && n && !c.getMeta("preventDispatch") && !this.hasCustomState && a.dispatch(c), s.every((f) => f === !0)), d = {
      ...Object.fromEntries(Object.entries(r).map(([f, h]) => [f, (...E) => {
        const m = this.buildProps(c, n), N = h(...E)(m);
        return s.push(N), d;
      }])),
      run: u
    };
    return d;
  }
  createCan(e) {
    const { rawCommands: n, state: r } = this, o = !1, i = e || r.tr, a = this.buildProps(i, o);
    return {
      ...Object.fromEntries(Object.entries(n).map(([l, c]) => [l, (...u) => c(...u)({ ...a, dispatch: void 0 })])),
      chain: () => this.createChain(i, o)
    };
  }
  buildProps(e, n = !0) {
    const { rawCommands: r, editor: o, state: i } = this, { view: a } = o, s = {
      tr: e,
      editor: o,
      view: a,
      state: f1({
        state: i,
        transaction: e
      }),
      dispatch: n ? () => {
      } : void 0,
      chain: () => this.createChain(e, n),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(r).map(([l, c]) => [l, (...u) => c(...u)(s)]));
      }
    };
    return s;
  }
}
class iCe {
  constructor() {
    this.callbacks = {};
  }
  on(e, n) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(n), this;
  }
  emit(e, ...n) {
    const r = this.callbacks[e];
    return r && r.forEach((o) => o.apply(this, n)), this;
  }
  off(e, n) {
    const r = this.callbacks[e];
    return r && (n ? this.callbacks[e] = r.filter((o) => o !== n) : delete this.callbacks[e]), this;
  }
  once(e, n) {
    const r = (...o) => {
      this.off(e, r), n.apply(this, o);
    };
    return this.on(e, r);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function Te(t, e, n) {
  return t.config[e] === void 0 && t.parent ? Te(t.parent, e, n) : typeof t.config[e] == "function" ? t.config[e].bind({
    ...n,
    parent: t.parent ? Te(t.parent, e, n) : null
  }) : t.config[e];
}
function _1(t) {
  const e = t.filter((o) => o.type === "extension"), n = t.filter((o) => o.type === "node"), r = t.filter((o) => o.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: n,
    markExtensions: r
  };
}
function c8(t) {
  const e = [], { nodeExtensions: n, markExtensions: r } = _1(t), o = [...n, ...r], i = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return t.forEach((a) => {
    const s = {
      name: a.name,
      options: a.options,
      storage: a.storage,
      extensions: o
    }, l = Te(a, "addGlobalAttributes", s);
    if (!l)
      return;
    l().forEach((u) => {
      u.types.forEach((d) => {
        Object.entries(u.attributes).forEach(([f, h]) => {
          e.push({
            type: d,
            name: f,
            attribute: {
              ...i,
              ...h
            }
          });
        });
      });
    });
  }), o.forEach((a) => {
    const s = {
      name: a.name,
      options: a.options,
      storage: a.storage
    }, l = Te(a, "addAttributes", s);
    if (!l)
      return;
    const c = l();
    Object.entries(c).forEach(([u, d]) => {
      const f = {
        ...i,
        ...d
      };
      typeof (f == null ? void 0 : f.default) == "function" && (f.default = f.default()), f != null && f.isRequired && (f == null ? void 0 : f.default) === void 0 && delete f.default, e.push({
        type: a.name,
        name: u,
        attribute: f
      });
    });
  }), e;
}
function rn(t, e) {
  if (typeof t == "string") {
    if (!e.nodes[t])
      throw Error(`There is no node type named '${t}'. Maybe you forgot to add the extension?`);
    return e.nodes[t];
  }
  return t;
}
function kn(...t) {
  return t.filter((e) => !!e).reduce((e, n) => {
    const r = { ...e };
    return Object.entries(n).forEach(([o, i]) => {
      if (!r[o]) {
        r[o] = i;
        return;
      }
      if (o === "class") {
        const s = i ? String(i).split(" ") : [], l = r[o] ? r[o].split(" ") : [], c = s.filter((u) => !l.includes(u));
        r[o] = [...l, ...c].join(" ");
      } else if (o === "style") {
        const s = i ? i.split(";").map((u) => u.trim()).filter(Boolean) : [], l = r[o] ? r[o].split(";").map((u) => u.trim()).filter(Boolean) : [], c = /* @__PURE__ */ new Map();
        l.forEach((u) => {
          const [d, f] = u.split(":").map((h) => h.trim());
          c.set(d, f);
        }), s.forEach((u) => {
          const [d, f] = u.split(":").map((h) => h.trim());
          c.set(d, f);
        }), r[o] = Array.from(c.entries()).map(([u, d]) => `${u}: ${d}`).join("; ");
      } else
        r[o] = i;
    }), r;
  }, {});
}
function e_(t, e) {
  return e.filter((n) => n.type === t.type.name).filter((n) => n.attribute.rendered).map((n) => n.attribute.renderHTML ? n.attribute.renderHTML(t.attrs) || {} : {
    [n.name]: t.attrs[n.name]
  }).reduce((n, r) => kn(n, r), {});
}
function u8(t) {
  return typeof t == "function";
}
function Qe(t, e = void 0, ...n) {
  return u8(t) ? e ? t.bind(e)(...n) : t(...n) : t;
}
function aCe(t = {}) {
  return Object.keys(t).length === 0 && t.constructor === Object;
}
function sCe(t) {
  return typeof t != "string" ? t : t.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(t) : t === "true" ? !0 : t === "false" ? !1 : t;
}
function MI(t, e) {
  return "style" in t ? t : {
    ...t,
    getAttrs: (n) => {
      const r = t.getAttrs ? t.getAttrs(n) : t.attrs;
      if (r === !1)
        return !1;
      const o = e.reduce((i, a) => {
        const s = a.attribute.parseHTML ? a.attribute.parseHTML(n) : sCe(n.getAttribute(a.name));
        return s == null ? i : {
          ...i,
          [a.name]: s
        };
      }, {});
      return { ...r, ...o };
    }
  };
}
function PI(t) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(t).filter(([e, n]) => e === "attrs" && aCe(n) ? !1 : n != null)
  );
}
function lCe(t, e) {
  var n;
  const r = c8(t), { nodeExtensions: o, markExtensions: i } = _1(t), a = (n = o.find((c) => Te(c, "topNode"))) === null || n === void 0 ? void 0 : n.name, s = Object.fromEntries(o.map((c) => {
    const u = r.filter((N) => N.type === c.name), d = {
      name: c.name,
      options: c.options,
      storage: c.storage,
      editor: e
    }, f = t.reduce((N, I) => {
      const O = Te(I, "extendNodeSchema", d);
      return {
        ...N,
        ...O ? O(c) : {}
      };
    }, {}), h = PI({
      ...f,
      content: Qe(Te(c, "content", d)),
      marks: Qe(Te(c, "marks", d)),
      group: Qe(Te(c, "group", d)),
      inline: Qe(Te(c, "inline", d)),
      atom: Qe(Te(c, "atom", d)),
      selectable: Qe(Te(c, "selectable", d)),
      draggable: Qe(Te(c, "draggable", d)),
      code: Qe(Te(c, "code", d)),
      whitespace: Qe(Te(c, "whitespace", d)),
      linebreakReplacement: Qe(Te(c, "linebreakReplacement", d)),
      defining: Qe(Te(c, "defining", d)),
      isolating: Qe(Te(c, "isolating", d)),
      attrs: Object.fromEntries(u.map((N) => {
        var I;
        return [N.name, { default: (I = N == null ? void 0 : N.attribute) === null || I === void 0 ? void 0 : I.default }];
      }))
    }), _ = Qe(Te(c, "parseHTML", d));
    _ && (h.parseDOM = _.map((N) => MI(N, u)));
    const E = Te(c, "renderHTML", d);
    E && (h.toDOM = (N) => E({
      node: N,
      HTMLAttributes: e_(N, u)
    }));
    const m = Te(c, "renderText", d);
    return m && (h.toText = m), [c.name, h];
  })), l = Object.fromEntries(i.map((c) => {
    const u = r.filter((m) => m.type === c.name), d = {
      name: c.name,
      options: c.options,
      storage: c.storage,
      editor: e
    }, f = t.reduce((m, N) => {
      const I = Te(N, "extendMarkSchema", d);
      return {
        ...m,
        ...I ? I(c) : {}
      };
    }, {}), h = PI({
      ...f,
      inclusive: Qe(Te(c, "inclusive", d)),
      excludes: Qe(Te(c, "excludes", d)),
      group: Qe(Te(c, "group", d)),
      spanning: Qe(Te(c, "spanning", d)),
      code: Qe(Te(c, "code", d)),
      attrs: Object.fromEntries(u.map((m) => {
        var N;
        return [m.name, { default: (N = m == null ? void 0 : m.attribute) === null || N === void 0 ? void 0 : N.default }];
      }))
    }), _ = Qe(Te(c, "parseHTML", d));
    _ && (h.parseDOM = _.map((m) => MI(m, u)));
    const E = Te(c, "renderHTML", d);
    return E && (h.toDOM = (m) => E({
      mark: m,
      HTMLAttributes: e_(m, u)
    })), [c.name, h];
  }));
  return new rC({
    topNode: a,
    nodes: s,
    marks: l
  });
}
function Ah(t, e) {
  return e.nodes[t] || e.marks[t] || null;
}
function yI(t, e) {
  return Array.isArray(e) ? e.some((n) => (typeof n == "string" ? n : n.name) === t.name) : e;
}
function p2(t, e) {
  const n = ja.fromSchema(e).serializeFragment(t), o = document.implementation.createHTMLDocument().createElement("div");
  return o.appendChild(n), o.innerHTML;
}
const cCe = (t, e = 500) => {
  let n = "";
  const r = t.parentOffset;
  return t.parent.nodesBetween(Math.max(0, r - e), r, (o, i, a, s) => {
    var l, c;
    const u = ((c = (l = o.type.spec).toText) === null || c === void 0 ? void 0 : c.call(l, {
      node: o,
      pos: i,
      parent: a,
      index: s
    })) || o.textContent || "%leaf%";
    n += o.isAtom && !o.isText ? u : u.slice(0, Math.max(0, r - i));
  }), n;
};
function m2(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}
class E1 {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const uCe = (t, e) => {
  if (m2(e))
    return e.exec(t);
  const n = e(t);
  if (!n)
    return null;
  const r = [n.text];
  return r.index = n.index, r.input = t, r.data = n.data, n.replaceWith && (n.text.includes(n.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(n.replaceWith)), r;
};
function Wu(t) {
  var e;
  const { editor: n, from: r, to: o, text: i, rules: a, plugin: s } = t, { view: l } = n;
  if (l.composing)
    return !1;
  const c = l.state.doc.resolve(r);
  if (
    // check for code node
    c.parent.type.spec.code || !((e = c.nodeBefore || c.nodeAfter) === null || e === void 0) && e.marks.find((f) => f.type.spec.code)
  )
    return !1;
  let u = !1;
  const d = cCe(c) + i;
  return a.forEach((f) => {
    if (u)
      return;
    const h = uCe(d, f.find);
    if (!h)
      return;
    const _ = l.state.tr, E = f1({
      state: l.state,
      transaction: _
    }), m = {
      from: r - (h[0].length - i.length),
      to: o
    }, { commands: N, chain: I, can: O } = new h1({
      editor: n,
      state: E
    });
    f.handler({
      state: E,
      range: m,
      match: h,
      commands: N,
      chain: I,
      can: O
    }) === null || !_.steps.length || (_.setMeta(s, {
      transform: _,
      from: r,
      to: o,
      text: i
    }), l.dispatch(_), u = !0);
  }), u;
}
function dCe(t) {
  const { editor: e, rules: n } = t, r = new Dn({
    state: {
      init() {
        return null;
      },
      apply(o, i, a) {
        const s = o.getMeta(r);
        if (s)
          return s;
        const l = o.getMeta("applyInputRules");
        return !!l && setTimeout(() => {
          let { text: u } = l;
          typeof u == "string" ? u = u : u = p2(_e.from(u), a.schema);
          const { from: d } = l, f = d + u.length;
          Wu({
            editor: e,
            from: d,
            to: f,
            text: u,
            rules: n,
            plugin: r
          });
        }), o.selectionSet || o.docChanged ? null : i;
      }
    },
    props: {
      handleTextInput(o, i, a, s) {
        return Wu({
          editor: e,
          from: i,
          to: a,
          text: s,
          rules: n,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (o) => (setTimeout(() => {
          const { $cursor: i } = o.state.selection;
          i && Wu({
            editor: e,
            from: i.pos,
            to: i.pos,
            text: "",
            rules: n,
            plugin: r
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(o, i) {
        if (i.key !== "Enter")
          return !1;
        const { $cursor: a } = o.state.selection;
        return a ? Wu({
          editor: e,
          from: a.pos,
          to: a.pos,
          text: `
`,
          rules: n,
          plugin: r
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return r;
}
function fCe(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function Yu(t) {
  return fCe(t) !== "Object" ? !1 : t.constructor === Object && Object.getPrototypeOf(t) === Object.prototype;
}
function p1(t, e) {
  const n = { ...t };
  return Yu(t) && Yu(e) && Object.keys(e).forEach((r) => {
    Yu(e[r]) && Yu(t[r]) ? n[r] = p1(t[r], e[r]) : n[r] = e[r];
  }), n;
}
class yi {
  constructor(e = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Qe(Te(this, "addOptions", {
      name: this.name
    }))), this.storage = Qe(Te(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new yi(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => p1(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new yi(e);
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Qe(Te(n, "addOptions", {
      name: n.name
    })), n.storage = Qe(Te(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  static handleExit({ editor: e, mark: n }) {
    const { tr: r } = e.state, o = e.state.selection.$from;
    if (o.pos === o.end()) {
      const a = o.marks();
      if (!!!a.find((c) => (c == null ? void 0 : c.type.name) === n.name))
        return !1;
      const l = a.find((c) => (c == null ? void 0 : c.type.name) === n.name);
      return l && r.removeStoredMark(l), r.insertText(" ", o.pos), e.view.dispatch(r), !0;
    }
    return !1;
  }
}
function hCe(t) {
  return typeof t == "number";
}
class _Ce {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const ECe = (t, e, n) => {
  if (m2(e))
    return [...t.matchAll(e)];
  const r = e(t, n);
  return r ? r.map((o) => {
    const i = [o.text];
    return i.index = o.index, i.input = t, i.data = o.data, o.replaceWith && (o.text.includes(o.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), i.push(o.replaceWith)), i;
  }) : [];
};
function pCe(t) {
  const { editor: e, state: n, from: r, to: o, rule: i, pasteEvent: a, dropEvent: s } = t, { commands: l, chain: c, can: u } = new h1({
    editor: e,
    state: n
  }), d = [];
  return n.doc.nodesBetween(r, o, (h, _) => {
    if (!h.isTextblock || h.type.spec.code)
      return;
    const E = Math.max(r, _), m = Math.min(o, _ + h.content.size), N = h.textBetween(E - _, m - _, void 0, "￼");
    ECe(N, i.find, a).forEach((O) => {
      if (O.index === void 0)
        return;
      const p = E + O.index + 1, C = p + O[0].length, D = {
        from: n.tr.mapping.map(p),
        to: n.tr.mapping.map(C)
      }, T = i.handler({
        state: n,
        range: D,
        match: O,
        commands: l,
        chain: c,
        can: u,
        pasteEvent: a,
        dropEvent: s
      });
      d.push(T);
    });
  }), d.every((h) => h !== null);
}
let Ku = null;
const mCe = (t) => {
  var e;
  const n = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = n.clipboardData) === null || e === void 0 || e.setData("text/html", t), n;
};
function NCe(t) {
  const { editor: e, rules: n } = t;
  let r = null, o = !1, i = !1, a = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, s;
  try {
    s = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    s = null;
  }
  const l = ({ state: u, from: d, to: f, rule: h, pasteEvt: _ }) => {
    const E = u.tr, m = f1({
      state: u,
      transaction: E
    });
    if (!(!pCe({
      editor: e,
      state: m,
      from: Math.max(d - 1, 0),
      to: f.b - 1,
      rule: h,
      pasteEvent: _,
      dropEvent: s
    }) || !E.steps.length)) {
      try {
        s = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        s = null;
      }
      return a = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, E;
    }
  };
  return n.map((u) => new Dn({
    // we register a global drag handler to track the current drag source element
    view(d) {
      const f = (_) => {
        var E;
        r = !((E = d.dom.parentElement) === null || E === void 0) && E.contains(_.target) ? d.dom.parentElement : null, r && (Ku = e);
      }, h = () => {
        Ku && (Ku = null);
      };
      return window.addEventListener("dragstart", f), window.addEventListener("dragend", h), {
        destroy() {
          window.removeEventListener("dragstart", f), window.removeEventListener("dragend", h);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (d, f) => {
          if (i = r === d.dom.parentElement, s = f, !i) {
            const h = Ku;
            h != null && h.isEditable && setTimeout(() => {
              const _ = h.state.selection;
              _ && h.commands.deleteRange({ from: _.from, to: _.to });
            }, 10);
          }
          return !1;
        },
        paste: (d, f) => {
          var h;
          const _ = (h = f.clipboardData) === null || h === void 0 ? void 0 : h.getData("text/html");
          return a = f, o = !!(_ != null && _.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (d, f, h) => {
      const _ = d[0], E = _.getMeta("uiEvent") === "paste" && !o, m = _.getMeta("uiEvent") === "drop" && !i, N = _.getMeta("applyPasteRules"), I = !!N;
      if (!E && !m && !I)
        return;
      if (I) {
        let { text: C } = N;
        typeof C == "string" ? C = C : C = p2(_e.from(C), h.schema);
        const { from: D } = N, T = D + C.length, k = mCe(C);
        return l({
          rule: u,
          state: h,
          from: D,
          to: { b: T },
          pasteEvt: k
        });
      }
      const O = f.doc.content.findDiffStart(h.doc.content), p = f.doc.content.findDiffEnd(h.doc.content);
      if (!(!hCe(O) || !p || O === p.b))
        return l({
          rule: u,
          state: h,
          from: O,
          to: p,
          pasteEvt: a
        });
    }
  }));
}
function vCe(t) {
  const e = t.filter((n, r) => t.indexOf(n) !== r);
  return Array.from(new Set(e));
}
class Ss {
  constructor(e, n) {
    this.splittableMarks = [], this.editor = n, this.extensions = Ss.resolve(e), this.schema = lCe(this.extensions, n), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(e) {
    const n = Ss.sort(Ss.flatten(e)), r = vCe(n.map((o) => o.name));
    return r.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${r.map((o) => `'${o}'`).join(", ")}]. This can lead to issues.`), n;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(e) {
    return e.map((n) => {
      const r = {
        name: n.name,
        options: n.options,
        storage: n.storage
      }, o = Te(n, "addExtensions", r);
      return o ? [n, ...this.flatten(o())] : n;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(e) {
    return e.sort((r, o) => {
      const i = Te(r, "priority") || 100, a = Te(o, "priority") || 100;
      return i > a ? -1 : i < a ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, n) => {
      const r = {
        name: n.name,
        options: n.options,
        storage: n.storage,
        editor: this.editor,
        type: Ah(n.name, this.schema)
      }, o = Te(n, "addCommands", r);
      return o ? {
        ...e,
        ...o()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this, n = Ss.sort([...this.extensions].reverse()), r = [], o = [], i = n.map((a) => {
      const s = {
        name: a.name,
        options: a.options,
        storage: a.storage,
        editor: e,
        type: Ah(a.name, this.schema)
      }, l = [], c = Te(a, "addKeyboardShortcuts", s);
      let u = {};
      if (a.type === "mark" && Te(a, "exitable", s) && (u.ArrowRight = () => yi.handleExit({ editor: e, mark: a })), c) {
        const E = Object.fromEntries(Object.entries(c()).map(([m, N]) => [m, () => N({ editor: e })]));
        u = { ...u, ...E };
      }
      const d = P7e(u);
      l.push(d);
      const f = Te(a, "addInputRules", s);
      yI(a, e.options.enableInputRules) && f && r.push(...f());
      const h = Te(a, "addPasteRules", s);
      yI(a, e.options.enablePasteRules) && h && o.push(...h());
      const _ = Te(a, "addProseMirrorPlugins", s);
      if (_) {
        const E = _();
        l.push(...E);
      }
      return l;
    }).flat();
    return [
      dCe({
        editor: e,
        rules: r
      }),
      ...NCe({
        editor: e,
        rules: o
      }),
      ...i
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return c8(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: n } = _1(this.extensions);
    return Object.fromEntries(n.filter((r) => !!Te(r, "addNodeView")).map((r) => {
      const o = this.attributes.filter((l) => l.type === r.name), i = {
        name: r.name,
        options: r.options,
        storage: r.storage,
        editor: e,
        type: rn(r.name, this.schema)
      }, a = Te(r, "addNodeView", i);
      if (!a)
        return [];
      const s = (l, c, u, d, f) => {
        const h = e_(l, o);
        return a()({
          // pass-through
          node: l,
          view: c,
          getPos: u,
          decorations: d,
          innerDecorations: f,
          // tiptap-specific
          editor: e,
          extension: r,
          HTMLAttributes: h
        });
      };
      return [r.name, s];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((e) => {
      var n;
      this.editor.extensionStorage[e.name] = e.storage;
      const r = {
        name: e.name,
        options: e.options,
        storage: e.storage,
        editor: this.editor,
        type: Ah(e.name, this.schema)
      };
      e.type === "mark" && (!((n = Qe(Te(e, "keepOnSplit", r))) !== null && n !== void 0) || n) && this.splittableMarks.push(e.name);
      const o = Te(e, "onBeforeCreate", r), i = Te(e, "onCreate", r), a = Te(e, "onUpdate", r), s = Te(e, "onSelectionUpdate", r), l = Te(e, "onTransaction", r), c = Te(e, "onFocus", r), u = Te(e, "onBlur", r), d = Te(e, "onDestroy", r);
      o && this.editor.on("beforeCreate", o), i && this.editor.on("create", i), a && this.editor.on("update", a), s && this.editor.on("selectionUpdate", s), l && this.editor.on("transaction", l), c && this.editor.on("focus", c), u && this.editor.on("blur", u), d && this.editor.on("destroy", d);
    });
  }
}
class En {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Qe(Te(this, "addOptions", {
      name: this.name
    }))), this.storage = Qe(Te(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new En(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => p1(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new En({ ...this.config, ...e });
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Qe(Te(n, "addOptions", {
      name: n.name
    })), n.storage = Qe(Te(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
}
function d8(t, e, n) {
  const { from: r, to: o } = e, { blockSeparator: i = `

`, textSerializers: a = {} } = n || {};
  let s = "";
  return t.nodesBetween(r, o, (l, c, u, d) => {
    var f;
    l.isBlock && c > r && (s += i);
    const h = a == null ? void 0 : a[l.type.name];
    if (h)
      return u && (s += h({
        node: l,
        pos: c,
        parent: u,
        index: d,
        range: e
      })), !1;
    l.isText && (s += (f = l == null ? void 0 : l.text) === null || f === void 0 ? void 0 : f.slice(Math.max(r, c) - c, o - c));
  }), s;
}
function N2(t) {
  return Object.fromEntries(Object.entries(t.nodes).filter(([, e]) => e.spec.toText).map(([e, n]) => [e, n.spec.toText]));
}
const gCe = En.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Dn({
        key: new Mr("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: t } = this, { state: e, schema: n } = t, { doc: r, selection: o } = e, { ranges: i } = o, a = Math.min(...i.map((u) => u.$from.pos)), s = Math.max(...i.map((u) => u.$to.pos)), l = N2(n);
            return d8(r, { from: a, to: s }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
}), ICe = () => ({ editor: t, view: e }) => (requestAnimationFrame(() => {
  var n;
  t.isDestroyed || (e.dom.blur(), (n = window == null ? void 0 : window.getSelection()) === null || n === void 0 || n.removeAllRanges());
}), !0), OCe = (t = !1) => ({ commands: e }) => e.setContent("", t), ACe = () => ({ state: t, tr: e, dispatch: n }) => {
  const { selection: r } = e, { ranges: o } = r;
  return n && o.forEach(({ $from: i, $to: a }) => {
    t.doc.nodesBetween(i.pos, a.pos, (s, l) => {
      if (s.type.isText)
        return;
      const { doc: c, mapping: u } = e, d = c.resolve(u.map(l)), f = c.resolve(u.map(l + s.nodeSize)), h = d.blockRange(f);
      if (!h)
        return;
      const _ = Nl(h);
      if (s.type.isTextblock) {
        const { defaultType: E } = d.parent.contentMatchAt(d.index());
        e.setNodeMarkup(h.start, E);
      }
      (_ || _ === 0) && e.lift(h, _);
    });
  }), !0;
}, DCe = (t) => (e) => t(e), CCe = () => ({ state: t, dispatch: e }) => Y7e(t, e), SCe = (t, e) => ({ editor: n, tr: r }) => {
  const { state: o } = n, i = o.doc.slice(t.from, t.to);
  r.deleteRange(t.from, t.to);
  const a = r.mapping.map(e);
  return r.insert(a, i.content), r.setSelection(new Ke(r.doc.resolve(Math.max(a - 1, 0)))), !0;
}, wCe = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, r = n.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const o = t.selection.$anchor;
  for (let i = o.depth; i > 0; i -= 1)
    if (o.node(i).type === r.type) {
      if (e) {
        const s = o.before(i), l = o.after(i);
        t.delete(s, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, TCe = (t) => ({ tr: e, state: n, dispatch: r }) => {
  const o = rn(t, n.schema), i = e.selection.$anchor;
  for (let a = i.depth; a > 0; a -= 1)
    if (i.node(a).type === o) {
      if (r) {
        const l = i.before(a), c = i.after(a);
        e.delete(l, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, bCe = (t) => ({ tr: e, dispatch: n }) => {
  const { from: r, to: o } = t;
  return n && e.delete(r, o), !0;
}, RCe = () => ({ state: t, dispatch: e }) => y7e(t, e), MCe = () => ({ commands: t }) => t.keyboardShortcut("Enter"), PCe = () => ({ state: t, dispatch: e }) => W7e(t, e);
function af(t, e, n = { strict: !0 }) {
  const r = Object.keys(e);
  return r.length ? r.every((o) => n.strict ? e[o] === t[o] : m2(e[o]) ? e[o].test(t[o]) : e[o] === t[o]) : !0;
}
function f8(t, e, n = {}) {
  return t.find((r) => r.type === e && af(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(n).map((o) => [o, r.attrs[o]])),
    n
  ));
}
function LI(t, e, n = {}) {
  return !!f8(t, e, n);
}
function v2(t, e, n) {
  var r;
  if (!t || !e)
    return;
  let o = t.parent.childAfter(t.parentOffset);
  if ((!o.node || !o.node.marks.some((u) => u.type === e)) && (o = t.parent.childBefore(t.parentOffset)), !o.node || !o.node.marks.some((u) => u.type === e) || (n = n || ((r = o.node.marks[0]) === null || r === void 0 ? void 0 : r.attrs), !f8([...o.node.marks], e, n)))
    return;
  let a = o.index, s = t.start() + o.offset, l = a + 1, c = s + o.node.nodeSize;
  for (; a > 0 && LI([...t.parent.child(a - 1).marks], e, n); )
    a -= 1, s -= t.parent.child(a).nodeSize;
  for (; l < t.parent.childCount && LI([...t.parent.child(l).marks], e, n); )
    c += t.parent.child(l).nodeSize, l += 1;
  return {
    from: s,
    to: c
  };
}
function Ki(t, e) {
  if (typeof t == "string") {
    if (!e.marks[t])
      throw Error(`There is no mark type named '${t}'. Maybe you forgot to add the extension?`);
    return e.marks[t];
  }
  return t;
}
const yCe = (t, e = {}) => ({ tr: n, state: r, dispatch: o }) => {
  const i = Ki(t, r.schema), { doc: a, selection: s } = n, { $from: l, from: c, to: u } = s;
  if (o) {
    const d = v2(l, i, e);
    if (d && d.from <= c && d.to >= u) {
      const f = Ke.create(a, d.from, d.to);
      n.setSelection(f);
    }
  }
  return !0;
}, LCe = (t) => (e) => {
  const n = typeof t == "function" ? t(e) : t;
  for (let r = 0; r < n.length; r += 1)
    if (n[r](e))
      return !0;
  return !1;
};
function g2(t) {
  return t instanceof Ke;
}
function ko(t = 0, e = 0, n = 0) {
  return Math.min(Math.max(t, e), n);
}
function h8(t, e = null) {
  if (!e)
    return null;
  const n = qe.atStart(t), r = qe.atEnd(t);
  if (e === "start" || e === !0)
    return n;
  if (e === "end")
    return r;
  const o = n.from, i = r.to;
  return e === "all" ? Ke.create(t, ko(0, o, i), ko(t.content.size, o, i)) : Ke.create(t, ko(e, o, i), ko(e, o, i));
}
function xI() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function sf() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function xCe() {
  return typeof navigator < "u" ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : !1;
}
const UCe = (t = null, e = {}) => ({ editor: n, view: r, tr: o, dispatch: i }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const a = () => {
    (sf() || xI()) && r.dom.focus(), requestAnimationFrame(() => {
      n.isDestroyed || (r.focus(), xCe() && !sf() && !xI() && r.dom.focus({ preventScroll: !0 }));
    });
  };
  if (r.hasFocus() && t === null || t === !1)
    return !0;
  if (i && t === null && !g2(n.state.selection))
    return a(), !0;
  const s = h8(o.doc, t) || n.state.selection, l = n.state.selection.eq(s);
  return i && (l || o.setSelection(s), l && o.storedMarks && o.setStoredMarks(o.storedMarks), a()), !0;
}, $Ce = (t, e) => (n) => t.every((r, o) => e(r, { ...n, index: o })), kCe = (t, e) => ({ tr: n, commands: r }) => r.insertContentAt({ from: n.selection.from, to: n.selection.to }, t, e), _8 = (t) => {
  const e = t.childNodes;
  for (let n = e.length - 1; n >= 0; n -= 1) {
    const r = e[n];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? t.removeChild(r) : r.nodeType === 1 && _8(r);
  }
  return t;
};
function zu(t) {
  const e = `<body>${t}</body>`, n = new window.DOMParser().parseFromString(e, "text/html").body;
  return _8(n);
}
function Gc(t, e, n) {
  if (t instanceof Ai || t instanceof _e)
    return t;
  n = {
    slice: !0,
    parseOptions: {},
    ...n
  };
  const r = typeof t == "object" && t !== null, o = typeof t == "string";
  if (r)
    try {
      if (Array.isArray(t) && t.length > 0)
        return _e.fromArray(t.map((s) => e.nodeFromJSON(s)));
      const a = e.nodeFromJSON(t);
      return n.errorOnInvalidContent && a.check(), a;
    } catch (i) {
      if (n.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: i });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", t, "Error:", i), Gc("", e, n);
    }
  if (o) {
    if (n.errorOnInvalidContent) {
      let a = !1, s = "";
      const l = new rC({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (c) => (a = !0, s = typeof c == "string" ? c : c.outerHTML, null)
              }
            ]
          }
        })
      });
      if (n.slice ? Di.fromSchema(l).parseSlice(zu(t), n.parseOptions) : Di.fromSchema(l).parse(zu(t), n.parseOptions), n.errorOnInvalidContent && a)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${s}`) });
    }
    const i = Di.fromSchema(e);
    return n.slice ? i.parseSlice(zu(t), n.parseOptions).content : i.parse(zu(t), n.parseOptions);
  }
  return Gc("", e, n);
}
function BCe(t, e, n) {
  const r = t.steps.length - 1;
  if (r < e)
    return;
  const o = t.steps[r];
  if (!(o instanceof Qt || o instanceof tn))
    return;
  const i = t.mapping.maps[r];
  let a = 0;
  i.forEach((s, l, c, u) => {
    a === 0 && (a = u);
  }), t.setSelection(qe.near(t.doc.resolve(a), n));
}
const GCe = (t) => !("type" in t), FCe = (t, e, n) => ({ tr: r, dispatch: o, editor: i }) => {
  var a;
  if (o) {
    n = {
      parseOptions: i.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...n
    };
    let s;
    const l = (m) => {
      i.emit("contentError", {
        editor: i,
        error: m,
        disableCollaboration: () => {
          i.storage.collaboration && (i.storage.collaboration.isDisabled = !0);
        }
      });
    }, c = {
      preserveWhitespace: "full",
      ...n.parseOptions
    };
    if (!n.errorOnInvalidContent && !i.options.enableContentCheck && i.options.emitContentError)
      try {
        Gc(e, i.schema, {
          parseOptions: c,
          errorOnInvalidContent: !0
        });
      } catch (m) {
        l(m);
      }
    try {
      s = Gc(e, i.schema, {
        parseOptions: c,
        errorOnInvalidContent: (a = n.errorOnInvalidContent) !== null && a !== void 0 ? a : i.options.enableContentCheck
      });
    } catch (m) {
      return l(m), !1;
    }
    let { from: u, to: d } = typeof t == "number" ? { from: t, to: t } : { from: t.from, to: t.to }, f = !0, h = !0;
    if ((GCe(s) ? s : [s]).forEach((m) => {
      m.check(), f = f ? m.isText && m.marks.length === 0 : !1, h = h ? m.isBlock : !1;
    }), u === d && h) {
      const { parent: m } = r.doc.resolve(u);
      m.isTextblock && !m.type.spec.code && !m.childCount && (u -= 1, d += 1);
    }
    let E;
    if (f) {
      if (Array.isArray(e))
        E = e.map((m) => m.text || "").join("");
      else if (e instanceof _e) {
        let m = "";
        e.forEach((N) => {
          N.text && (m += N.text);
        }), E = m;
      } else
        typeof e == "object" && e && e.text ? E = e.text : E = e;
      r.insertText(E, u, d);
    } else
      E = s, r.replaceWith(u, d, E);
    n.updateSelection && BCe(r, r.steps.length - 1, -1), n.applyInputRules && r.setMeta("applyInputRules", { from: u, text: E }), n.applyPasteRules && r.setMeta("applyPasteRules", { from: u, text: E });
  }
  return !0;
}, VCe = () => ({ state: t, dispatch: e }) => G7e(t, e), HCe = () => ({ state: t, dispatch: e }) => F7e(t, e), WCe = () => ({ state: t, dispatch: e }) => L7e(t, e), YCe = () => ({ state: t, dispatch: e }) => k7e(t, e), KCe = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const r = a1(t.doc, t.selection.$from.pos, -1);
    return r == null ? !1 : (n.join(r, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, zCe = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const r = a1(t.doc, t.selection.$from.pos, 1);
    return r == null ? !1 : (n.join(r, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, ZCe = () => ({ state: t, dispatch: e }) => x7e(t, e), qCe = () => ({ state: t, dispatch: e }) => U7e(t, e);
function E8() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function XCe(t) {
  const e = t.split(/-(?!$)/);
  let n = e[e.length - 1];
  n === "Space" && (n = " ");
  let r, o, i, a;
  for (let s = 0; s < e.length - 1; s += 1) {
    const l = e[s];
    if (/^(cmd|meta|m)$/i.test(l))
      a = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      o = !0;
    else if (/^s(hift)?$/i.test(l))
      i = !0;
    else if (/^mod$/i.test(l))
      sf() || E8() ? a = !0 : o = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return r && (n = `Alt-${n}`), o && (n = `Ctrl-${n}`), a && (n = `Meta-${n}`), i && (n = `Shift-${n}`), n;
}
const jCe = (t) => ({ editor: e, view: n, tr: r, dispatch: o }) => {
  const i = XCe(t).split(/-(?!$)/), a = i.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), s = new KeyboardEvent("keydown", {
    key: a === "Space" ? " " : a,
    altKey: i.includes("Alt"),
    ctrlKey: i.includes("Ctrl"),
    metaKey: i.includes("Meta"),
    shiftKey: i.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    n.someProp("handleKeyDown", (c) => c(n, s));
  });
  return l == null || l.steps.forEach((c) => {
    const u = c.map(r.mapping);
    u && o && r.maybeStep(u);
  }), !0;
};
function Fc(t, e, n = {}) {
  const { from: r, to: o, empty: i } = t.selection, a = e ? rn(e, t.schema) : null, s = [];
  t.doc.nodesBetween(r, o, (d, f) => {
    if (d.isText)
      return;
    const h = Math.max(r, f), _ = Math.min(o, f + d.nodeSize);
    s.push({
      node: d,
      from: h,
      to: _
    });
  });
  const l = o - r, c = s.filter((d) => a ? a.name === d.node.type.name : !0).filter((d) => af(d.node.attrs, n, { strict: !1 }));
  return i ? !!c.length : c.reduce((d, f) => d + f.to - f.from, 0) >= l;
}
const JCe = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const o = rn(t, n.schema);
  return Fc(n, o, e) ? V7e(n, r) : !1;
}, QCe = () => ({ state: t, dispatch: e }) => K7e(t, e), e8e = (t) => ({ state: e, dispatch: n }) => {
  const r = rn(t, e.schema);
  return tCe(r)(e, n);
}, t8e = () => ({ state: t, dispatch: e }) => H7e(t, e);
function m1(t, e) {
  return e.nodes[t] ? "node" : e.marks[t] ? "mark" : null;
}
function UI(t, e) {
  const n = typeof e == "string" ? [e] : e;
  return Object.keys(t).reduce((r, o) => (n.includes(o) || (r[o] = t[o]), r), {});
}
const n8e = (t, e) => ({ tr: n, state: r, dispatch: o }) => {
  let i = null, a = null;
  const s = m1(typeof t == "string" ? t : t.name, r.schema);
  return s ? (s === "node" && (i = rn(t, r.schema)), s === "mark" && (a = Ki(t, r.schema)), o && n.selection.ranges.forEach((l) => {
    r.doc.nodesBetween(l.$from.pos, l.$to.pos, (c, u) => {
      i && i === c.type && n.setNodeMarkup(u, void 0, UI(c.attrs, e)), a && c.marks.length && c.marks.forEach((d) => {
        a === d.type && n.addMark(u, u + c.nodeSize, a.create(UI(d.attrs, e)));
      });
    });
  }), !0) : !1;
}, r8e = () => ({ tr: t, dispatch: e }) => (e && t.scrollIntoView(), !0), o8e = () => ({ tr: t, dispatch: e }) => {
  if (e) {
    const n = new Er(t.doc);
    t.setSelection(n);
  }
  return !0;
}, i8e = () => ({ state: t, dispatch: e }) => $7e(t, e), a8e = () => ({ state: t, dispatch: e }) => B7e(t, e), s8e = () => ({ state: t, dispatch: e }) => z7e(t, e), l8e = () => ({ state: t, dispatch: e }) => X7e(t, e), c8e = () => ({ state: t, dispatch: e }) => q7e(t, e);
function t_(t, e, n = {}, r = {}) {
  return Gc(t, e, {
    slice: !1,
    parseOptions: n,
    errorOnInvalidContent: r.errorOnInvalidContent
  });
}
const u8e = (t, e = !1, n = {}, r = {}) => ({ editor: o, tr: i, dispatch: a, commands: s }) => {
  var l, c;
  const { doc: u } = i;
  if (n.preserveWhitespace !== "full") {
    const d = t_(t, o.schema, n, {
      errorOnInvalidContent: (l = r.errorOnInvalidContent) !== null && l !== void 0 ? l : o.options.enableContentCheck
    });
    return a && i.replaceWith(0, u.content.size, d).setMeta("preventUpdate", !e), !0;
  }
  return a && i.setMeta("preventUpdate", !e), s.insertContentAt({ from: 0, to: u.content.size }, t, {
    parseOptions: n,
    errorOnInvalidContent: (c = r.errorOnInvalidContent) !== null && c !== void 0 ? c : o.options.enableContentCheck
  });
};
function p8(t, e) {
  const n = Ki(e, t.schema), { from: r, to: o, empty: i } = t.selection, a = [];
  i ? (t.storedMarks && a.push(...t.storedMarks), a.push(...t.selection.$head.marks())) : t.doc.nodesBetween(r, o, (l) => {
    a.push(...l.marks);
  });
  const s = a.find((l) => l.type.name === n.name);
  return s ? { ...s.attrs } : {};
}
function d8e(t) {
  for (let e = 0; e < t.edgeCount; e += 1) {
    const { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
function f8e(t, e) {
  for (let n = t.depth; n > 0; n -= 1) {
    const r = t.node(n);
    if (e(r))
      return {
        pos: n > 0 ? t.before(n) : 0,
        start: t.start(n),
        depth: n,
        node: r
      };
  }
}
function I2(t) {
  return (e) => f8e(e.$from, t);
}
function m8(t, e) {
  const n = {
    from: 0,
    to: t.content.size
  };
  return d8(t, n, e);
}
function h8e(t, e) {
  const n = rn(e, t.schema), { from: r, to: o } = t.selection, i = [];
  t.doc.nodesBetween(r, o, (s) => {
    i.push(s);
  });
  const a = i.reverse().find((s) => s.type.name === n.name);
  return a ? { ...a.attrs } : {};
}
function _8e(t, e) {
  const n = m1(typeof e == "string" ? e : e.name, t.schema);
  return n === "node" ? h8e(t, e) : n === "mark" ? p8(t, e) : {};
}
function N8(t, e, n) {
  const r = [];
  return t === e ? n.resolve(t).marks().forEach((o) => {
    const i = n.resolve(t), a = v2(i, o.type);
    a && r.push({
      mark: o,
      ...a
    });
  }) : n.nodesBetween(t, e, (o, i) => {
    !o || (o == null ? void 0 : o.nodeSize) === void 0 || r.push(...o.marks.map((a) => ({
      from: i,
      to: i + o.nodeSize,
      mark: a
    })));
  }), r;
}
function ud(t, e, n) {
  return Object.fromEntries(Object.entries(n).filter(([r]) => {
    const o = t.find((i) => i.type === e && i.name === r);
    return o ? o.attribute.keepOnSplit : !1;
  }));
}
function n_(t, e, n = {}) {
  const { empty: r, ranges: o } = t.selection, i = e ? Ki(e, t.schema) : null;
  if (r)
    return !!(t.storedMarks || t.selection.$from.marks()).filter((d) => i ? i.name === d.type.name : !0).find((d) => af(d.attrs, n, { strict: !1 }));
  let a = 0;
  const s = [];
  if (o.forEach(({ $from: d, $to: f }) => {
    const h = d.pos, _ = f.pos;
    t.doc.nodesBetween(h, _, (E, m) => {
      if (!E.isText && !E.marks.length)
        return;
      const N = Math.max(h, m), I = Math.min(_, m + E.nodeSize), O = I - N;
      a += O, s.push(...E.marks.map((p) => ({
        mark: p,
        from: N,
        to: I
      })));
    });
  }), a === 0)
    return !1;
  const l = s.filter((d) => i ? i.name === d.mark.type.name : !0).filter((d) => af(d.mark.attrs, n, { strict: !1 })).reduce((d, f) => d + f.to - f.from, 0), c = s.filter((d) => i ? d.mark.type !== i && d.mark.type.excludes(i) : !0).reduce((d, f) => d + f.to - f.from, 0);
  return (l > 0 ? l + c : l) >= a;
}
function E8e(t, e, n = {}) {
  if (!e)
    return Fc(t, null, n) || n_(t, null, n);
  const r = m1(e, t.schema);
  return r === "node" ? Fc(t, e, n) : r === "mark" ? n_(t, e, n) : !1;
}
function $I(t, e) {
  const { nodeExtensions: n } = _1(e), r = n.find((a) => a.name === t);
  if (!r)
    return !1;
  const o = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, i = Qe(Te(r, "group", o));
  return typeof i != "string" ? !1 : i.split(" ").includes("list");
}
function O2(t, { checkChildren: e = !0, ignoreWhitespace: n = !1 } = {}) {
  var r;
  if (n) {
    if (t.type.name === "hardBreak")
      return !0;
    if (t.isText)
      return /^\s*$/m.test((r = t.text) !== null && r !== void 0 ? r : "");
  }
  if (t.isText)
    return !t.text;
  if (t.isAtom || t.isLeaf)
    return !1;
  if (t.content.childCount === 0)
    return !0;
  if (e) {
    let o = !0;
    return t.content.forEach((i) => {
      o !== !1 && (O2(i, { ignoreWhitespace: n, checkChildren: e }) || (o = !1));
    }), o;
  }
  return !1;
}
function v8(t) {
  return t instanceof ke;
}
function g8(t, e, n) {
  const o = t.state.doc.content.size, i = ko(e, 0, o), a = ko(n, 0, o), s = t.coordsAtPos(i), l = t.coordsAtPos(a, -1), c = Math.min(s.top, l.top), u = Math.max(s.bottom, l.bottom), d = Math.min(s.left, l.left), f = Math.max(s.right, l.right), h = f - d, _ = u - c, N = {
    top: c,
    bottom: u,
    left: d,
    right: f,
    width: h,
    height: _,
    x: d,
    y: c
  };
  return {
    ...N,
    toJSON: () => N
  };
}
function p8e(t, e, n) {
  var r;
  const { selection: o } = e;
  let i = null;
  if (g2(o) && (i = o.$cursor), i) {
    const s = (r = t.storedMarks) !== null && r !== void 0 ? r : i.marks();
    return !!n.isInSet(s) || !s.some((l) => l.type.excludes(n));
  }
  const { ranges: a } = o;
  return a.some(({ $from: s, $to: l }) => {
    let c = s.depth === 0 ? t.doc.inlineContent && t.doc.type.allowsMarkType(n) : !1;
    return t.doc.nodesBetween(s.pos, l.pos, (u, d, f) => {
      if (c)
        return !1;
      if (u.isInline) {
        const h = !f || f.type.allowsMarkType(n), _ = !!n.isInSet(u.marks) || !u.marks.some((E) => E.type.excludes(n));
        c = h && _;
      }
      return !c;
    }), c;
  });
}
const m8e = (t, e = {}) => ({ tr: n, state: r, dispatch: o }) => {
  const { selection: i } = n, { empty: a, ranges: s } = i, l = Ki(t, r.schema);
  if (o)
    if (a) {
      const c = p8(r, l);
      n.addStoredMark(l.create({
        ...c,
        ...e
      }));
    } else
      s.forEach((c) => {
        const u = c.$from.pos, d = c.$to.pos;
        r.doc.nodesBetween(u, d, (f, h) => {
          const _ = Math.max(h, u), E = Math.min(h + f.nodeSize, d);
          f.marks.find((N) => N.type === l) ? f.marks.forEach((N) => {
            l === N.type && n.addMark(_, E, l.create({
              ...N.attrs,
              ...e
            }));
          }) : n.addMark(_, E, l.create(e));
        });
      });
  return p8e(r, n, l);
}, N8e = (t, e) => ({ tr: n }) => (n.setMeta(t, e), !0), v8e = (t, e = {}) => ({ state: n, dispatch: r, chain: o }) => {
  const i = rn(t, n.schema);
  let a;
  return n.selection.$anchor.sameParent(n.selection.$head) && (a = n.selection.$anchor.parent.attrs), i.isTextblock ? o().command(({ commands: s }) => RI(i, { ...a, ...e })(n) ? !0 : s.clearNodes()).command(({ state: s }) => RI(i, { ...a, ...e })(s, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, g8e = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: r } = e, o = ko(t, 0, r.content.size), i = ke.create(r, o);
    e.setSelection(i);
  }
  return !0;
}, I8e = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: r } = e, { from: o, to: i } = typeof t == "number" ? { from: t, to: t } : t, a = Ke.atStart(r).from, s = Ke.atEnd(r).to, l = ko(o, a, s), c = ko(i, a, s), u = Ke.create(r, l, c);
    e.setSelection(u);
  }
  return !0;
}, O8e = (t) => ({ state: e, dispatch: n }) => {
  const r = rn(t, e.schema);
  return oCe(r)(e, n);
};
function kI(t, e) {
  const n = t.storedMarks || t.selection.$to.parentOffset && t.selection.$from.marks();
  if (n) {
    const r = n.filter((o) => e == null ? void 0 : e.includes(o.type.name));
    t.tr.ensureMarks(r);
  }
}
const A8e = ({ keepMarks: t = !0 } = {}) => ({ tr: e, state: n, dispatch: r, editor: o }) => {
  const { selection: i, doc: a } = e, { $from: s, $to: l } = i, c = o.extensionManager.attributes, u = ud(c, s.node().type.name, s.node().attrs);
  if (i instanceof ke && i.node.isBlock)
    return !s.parentOffset || !bs(a, s.pos) ? !1 : (r && (t && kI(n, o.extensionManager.splittableMarks), e.split(s.pos).scrollIntoView()), !0);
  if (!s.parent.isBlock)
    return !1;
  const d = l.parentOffset === l.parent.content.size, f = s.depth === 0 ? void 0 : d8e(s.node(-1).contentMatchAt(s.indexAfter(-1)));
  let h = d && f ? [
    {
      type: f,
      attrs: u
    }
  ] : void 0, _ = bs(e.doc, e.mapping.map(s.pos), 1, h);
  if (!h && !_ && bs(e.doc, e.mapping.map(s.pos), 1, f ? [{ type: f }] : void 0) && (_ = !0, h = f ? [
    {
      type: f,
      attrs: u
    }
  ] : void 0), r) {
    if (_ && (i instanceof Ke && e.deleteSelection(), e.split(e.mapping.map(s.pos), 1, h), f && !d && !s.parentOffset && s.parent.type !== f)) {
      const E = e.mapping.map(s.before()), m = e.doc.resolve(E);
      s.node(-1).canReplaceWith(m.index(), m.index() + 1, f) && e.setNodeMarkup(e.mapping.map(s.before()), f);
    }
    t && kI(n, o.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return _;
}, D8e = (t, e = {}) => ({ tr: n, state: r, dispatch: o, editor: i }) => {
  var a;
  const s = rn(t, r.schema), { $from: l, $to: c } = r.selection, u = r.selection.node;
  if (u && u.isBlock || l.depth < 2 || !l.sameParent(c))
    return !1;
  const d = l.node(-1);
  if (d.type !== s)
    return !1;
  const f = i.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== s || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (o) {
      let N = _e.empty;
      const I = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let k = l.depth - I; k >= l.depth - 3; k -= 1)
        N = _e.from(l.node(k).copy(N));
      const O = l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3, p = {
        ...ud(f, l.node().type.name, l.node().attrs),
        ...e
      }, C = ((a = s.contentMatch.defaultType) === null || a === void 0 ? void 0 : a.createAndFill(p)) || void 0;
      N = N.append(_e.from(s.createAndFill(null, C) || void 0));
      const D = l.before(l.depth - (I - 1));
      n.replace(D, l.after(-O), new Ae(N, 4 - I, 0));
      let T = -1;
      n.doc.nodesBetween(D, n.doc.content.size, (k, G) => {
        if (T > -1)
          return !1;
        k.isTextblock && k.content.size === 0 && (T = G + 1);
      }), T > -1 && n.setSelection(Ke.near(n.doc.resolve(T))), n.scrollIntoView();
    }
    return !0;
  }
  const h = c.pos === l.end() ? d.contentMatchAt(0).defaultType : null, _ = {
    ...ud(f, d.type.name, d.attrs),
    ...e
  }, E = {
    ...ud(f, l.node().type.name, l.node().attrs),
    ...e
  };
  n.delete(l.pos, c.pos);
  const m = h ? [
    { type: s, attrs: _ },
    { type: h, attrs: E }
  ] : [{ type: s, attrs: _ }];
  if (!bs(n.doc, l.pos, 2))
    return !1;
  if (o) {
    const { selection: N, storedMarks: I } = r, { splittableMarks: O } = i.extensionManager, p = I || N.$to.parentOffset && N.$from.marks();
    if (n.split(l.pos, 2, m).scrollIntoView(), !p || !o)
      return !0;
    const C = p.filter((D) => O.includes(D.type.name));
    n.ensureMarks(C);
  }
  return !0;
}, Dh = (t, e) => {
  const n = I2((a) => a.type === e)(t.selection);
  if (!n)
    return !0;
  const r = t.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
  if (r === void 0)
    return !0;
  const o = t.doc.nodeAt(r);
  return n.node.type === (o == null ? void 0 : o.type) && Wi(t.doc, n.pos) && t.join(n.pos), !0;
}, Ch = (t, e) => {
  const n = I2((a) => a.type === e)(t.selection);
  if (!n)
    return !0;
  const r = t.doc.resolve(n.start).after(n.depth);
  if (r === void 0)
    return !0;
  const o = t.doc.nodeAt(r);
  return n.node.type === (o == null ? void 0 : o.type) && Wi(t.doc, r) && t.join(r), !0;
}, C8e = (t, e, n, r = {}) => ({ editor: o, tr: i, state: a, dispatch: s, chain: l, commands: c, can: u }) => {
  const { extensions: d, splittableMarks: f } = o.extensionManager, h = rn(t, a.schema), _ = rn(e, a.schema), { selection: E, storedMarks: m } = a, { $from: N, $to: I } = E, O = N.blockRange(I), p = m || E.$to.parentOffset && E.$from.marks();
  if (!O)
    return !1;
  const C = I2((D) => $I(D.type.name, d))(E);
  if (O.depth >= 1 && C && O.depth - C.depth <= 1) {
    if (C.node.type === h)
      return c.liftListItem(_);
    if ($I(C.node.type.name, d) && h.validContent(C.node.content) && s)
      return l().command(() => (i.setNodeMarkup(C.pos, h), !0)).command(() => Dh(i, h)).command(() => Ch(i, h)).run();
  }
  return !n || !p || !s ? l().command(() => u().wrapInList(h, r) ? !0 : c.clearNodes()).wrapInList(h, r).command(() => Dh(i, h)).command(() => Ch(i, h)).run() : l().command(() => {
    const D = u().wrapInList(h, r), T = p.filter((k) => f.includes(k.type.name));
    return i.ensureMarks(T), D ? !0 : c.clearNodes();
  }).wrapInList(h, r).command(() => Dh(i, h)).command(() => Ch(i, h)).run();
}, S8e = (t, e = {}, n = {}) => ({ state: r, commands: o }) => {
  const { extendEmptyMarkRange: i = !1 } = n, a = Ki(t, r.schema);
  return n_(r, a, e) ? o.unsetMark(a, { extendEmptyMarkRange: i }) : o.setMark(a, e);
}, w8e = (t, e, n = {}) => ({ state: r, commands: o }) => {
  const i = rn(t, r.schema), a = rn(e, r.schema), s = Fc(r, i, n);
  let l;
  return r.selection.$anchor.sameParent(r.selection.$head) && (l = r.selection.$anchor.parent.attrs), s ? o.setNode(a, l) : o.setNode(i, { ...l, ...n });
}, T8e = (t, e = {}) => ({ state: n, commands: r }) => {
  const o = rn(t, n.schema);
  return Fc(n, o, e) ? r.lift(o) : r.wrapIn(o, e);
}, b8e = () => ({ state: t, dispatch: e }) => {
  const n = t.plugins;
  for (let r = 0; r < n.length; r += 1) {
    const o = n[r];
    let i;
    if (o.spec.isInputRules && (i = o.getState(t))) {
      if (e) {
        const a = t.tr, s = i.transform;
        for (let l = s.steps.length - 1; l >= 0; l -= 1)
          a.step(s.steps[l].invert(s.docs[l]));
        if (i.text) {
          const l = a.doc.resolve(i.from).marks();
          a.replaceWith(i.from, i.to, t.schema.text(i.text, l));
        } else
          a.delete(i.from, i.to);
      }
      return !0;
    }
  }
  return !1;
}, R8e = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, { empty: r, ranges: o } = n;
  return r || e && o.forEach((i) => {
    t.removeMark(i.$from.pos, i.$to.pos);
  }), !0;
}, M8e = (t, e = {}) => ({ tr: n, state: r, dispatch: o }) => {
  var i;
  const { extendEmptyMarkRange: a = !1 } = e, { selection: s } = n, l = Ki(t, r.schema), { $from: c, empty: u, ranges: d } = s;
  if (!o)
    return !0;
  if (u && a) {
    let { from: f, to: h } = s;
    const _ = (i = c.marks().find((m) => m.type === l)) === null || i === void 0 ? void 0 : i.attrs, E = v2(c, l, _);
    E && (f = E.from, h = E.to), n.removeMark(f, h, l);
  } else
    d.forEach((f) => {
      n.removeMark(f.$from.pos, f.$to.pos, l);
    });
  return n.removeStoredMark(l), !0;
}, P8e = (t, e = {}) => ({ tr: n, state: r, dispatch: o }) => {
  let i = null, a = null;
  const s = m1(typeof t == "string" ? t : t.name, r.schema);
  return s ? (s === "node" && (i = rn(t, r.schema)), s === "mark" && (a = Ki(t, r.schema)), o && n.selection.ranges.forEach((l) => {
    const c = l.$from.pos, u = l.$to.pos;
    let d, f, h, _;
    n.selection.empty ? r.doc.nodesBetween(c, u, (E, m) => {
      i && i === E.type && (h = Math.max(m, c), _ = Math.min(m + E.nodeSize, u), d = m, f = E);
    }) : r.doc.nodesBetween(c, u, (E, m) => {
      m < c && i && i === E.type && (h = Math.max(m, c), _ = Math.min(m + E.nodeSize, u), d = m, f = E), m >= c && m <= u && (i && i === E.type && n.setNodeMarkup(m, void 0, {
        ...E.attrs,
        ...e
      }), a && E.marks.length && E.marks.forEach((N) => {
        if (a === N.type) {
          const I = Math.max(m, c), O = Math.min(m + E.nodeSize, u);
          n.addMark(I, O, a.create({
            ...N.attrs,
            ...e
          }));
        }
      }));
    }), f && (d !== void 0 && n.setNodeMarkup(d, void 0, {
      ...f.attrs,
      ...e
    }), a && f.marks.length && f.marks.forEach((E) => {
      a === E.type && n.addMark(h, _, a.create({
        ...E.attrs,
        ...e
      }));
    }));
  }), !0) : !1;
}, y8e = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const o = rn(t, n.schema);
  return j7e(o, e)(n, r);
}, L8e = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const o = rn(t, n.schema);
  return J7e(o, e)(n, r);
};
var x8e = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: ICe,
  clearContent: OCe,
  clearNodes: ACe,
  command: DCe,
  createParagraphNear: CCe,
  cut: SCe,
  deleteCurrentNode: wCe,
  deleteNode: TCe,
  deleteRange: bCe,
  deleteSelection: RCe,
  enter: MCe,
  exitCode: PCe,
  extendMarkRange: yCe,
  first: LCe,
  focus: UCe,
  forEach: $Ce,
  insertContent: kCe,
  insertContentAt: FCe,
  joinBackward: WCe,
  joinDown: HCe,
  joinForward: YCe,
  joinItemBackward: KCe,
  joinItemForward: zCe,
  joinTextblockBackward: ZCe,
  joinTextblockForward: qCe,
  joinUp: VCe,
  keyboardShortcut: jCe,
  lift: JCe,
  liftEmptyBlock: QCe,
  liftListItem: e8e,
  newlineInCode: t8e,
  resetAttributes: n8e,
  scrollIntoView: r8e,
  selectAll: o8e,
  selectNodeBackward: i8e,
  selectNodeForward: a8e,
  selectParentNode: s8e,
  selectTextblockEnd: l8e,
  selectTextblockStart: c8e,
  setContent: u8e,
  setMark: m8e,
  setMeta: N8e,
  setNode: v8e,
  setNodeSelection: g8e,
  setTextSelection: I8e,
  sinkListItem: O8e,
  splitBlock: A8e,
  splitListItem: D8e,
  toggleList: C8e,
  toggleMark: S8e,
  toggleNode: w8e,
  toggleWrap: T8e,
  undoInputRule: b8e,
  unsetAllMarks: R8e,
  unsetMark: M8e,
  updateAttributes: P8e,
  wrapIn: y8e,
  wrapInList: L8e
});
const U8e = En.create({
  name: "commands",
  addCommands() {
    return {
      ...x8e
    };
  }
}), $8e = En.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Dn({
        key: new Mr("tiptapDrop"),
        props: {
          handleDrop: (t, e, n, r) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: n,
              moved: r
            });
          }
        }
      })
    ];
  }
}), k8e = En.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Dn({
        key: new Mr("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), B8e = new Mr("focusEvents"), G8e = En.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: t } = this;
    return [
      new Dn({
        key: B8e,
        props: {
          handleDOMEvents: {
            focus: (e, n) => {
              t.isFocused = !0;
              const r = t.state.tr.setMeta("focus", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            },
            blur: (e, n) => {
              t.isFocused = !1;
              const r = t.state.tr.setMeta("blur", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), F8e = En.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const t = () => this.editor.commands.first(({ commands: a }) => [
      () => a.undoInputRule(),
      // maybe convert first text block node to default node
      () => a.command(({ tr: s }) => {
        const { selection: l, doc: c } = s, { empty: u, $anchor: d } = l, { pos: f, parent: h } = d, _ = d.parent.isTextblock && f > 0 ? s.doc.resolve(f - 1) : d, E = _.parent.type.spec.isolating, m = d.pos - d.parentOffset, N = E && _.parent.childCount === 1 ? m === d.pos : qe.atStart(c).from === f;
        return !u || !h.type.isTextblock || h.textContent.length || !N || N && d.parent.type.name === "paragraph" ? !1 : a.clearNodes();
      }),
      () => a.deleteSelection(),
      () => a.joinBackward(),
      () => a.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: a }) => [
      () => a.deleteSelection(),
      () => a.deleteCurrentNode(),
      () => a.joinForward(),
      () => a.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: a }) => [
        () => a.newlineInCode(),
        () => a.createParagraphNear(),
        () => a.liftEmptyBlock(),
        () => a.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: t,
      "Mod-Backspace": t,
      "Shift-Backspace": t,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, o = {
      ...r
    }, i = {
      ...r,
      "Ctrl-h": t,
      "Alt-Backspace": t,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return sf() || E8() ? i : o;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Dn({
        key: new Mr("clearDocument"),
        appendTransaction: (t, e, n) => {
          if (t.some((E) => E.getMeta("composition")))
            return;
          const r = t.some((E) => E.docChanged) && !e.doc.eq(n.doc), o = t.some((E) => E.getMeta("preventClearDocument"));
          if (!r || o)
            return;
          const { empty: i, from: a, to: s } = e.selection, l = qe.atStart(e.doc).from, c = qe.atEnd(e.doc).to;
          if (i || !(a === l && s === c) || !O2(n.doc))
            return;
          const f = n.tr, h = f1({
            state: n,
            transaction: f
          }), { commands: _ } = new h1({
            editor: this.editor,
            state: h
          });
          if (_.clearNodes(), !!f.steps.length)
            return f;
        }
      })
    ];
  }
}), V8e = En.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Dn({
        key: new Mr("tiptapPaste"),
        props: {
          handlePaste: (t, e, n) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: n
            });
          }
        }
      })
    ];
  }
}), H8e = En.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new Dn({
        key: new Mr("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
class aa {
  get name() {
    return this.node.type.name;
  }
  constructor(e, n, r = !1, o = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = r, this.resolvedPos = e, this.editor = n, this.currentNode = o;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) !== null && e !== void 0 ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let n = this.from, r = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      n = this.from + 1, r = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: n, to: r }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), n = this.resolvedPos.doc.resolve(e);
    return new aa(n, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new aa(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new aa(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((n, r) => {
      const o = n.isBlock && !n.isTextblock, i = n.isAtom && !n.isText, a = this.pos + r + (i ? 0 : 1);
      if (a < 0 || a > this.resolvedPos.doc.nodeSize - 2)
        return;
      const s = this.resolvedPos.doc.resolve(a);
      if (!o && s.depth <= this.depth)
        return;
      const l = new aa(s, this.editor, o, o ? n : null);
      o && (l.actualDepth = this.depth + 1), e.push(new aa(s, this.editor, o, o ? n : null));
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, n = {}) {
    let r = null, o = this.parent;
    for (; o && !r; ) {
      if (o.node.type.name === e)
        if (Object.keys(n).length > 0) {
          const i = o.node.attrs, a = Object.keys(n);
          for (let s = 0; s < a.length; s += 1) {
            const l = a[s];
            if (i[l] !== n[l])
              break;
          }
        } else
          r = o;
      o = o.parent;
    }
    return r;
  }
  querySelector(e, n = {}) {
    return this.querySelectorAll(e, n, !0)[0] || null;
  }
  querySelectorAll(e, n = {}, r = !1) {
    let o = [];
    if (!this.children || this.children.length === 0)
      return o;
    const i = Object.keys(n);
    return this.children.forEach((a) => {
      r && o.length > 0 || (a.node.type.name === e && i.every((l) => n[l] === a.node.attrs[l]) && o.push(a), !(r && o.length > 0) && (o = o.concat(a.querySelectorAll(e, n, r))));
    }), o;
  }
  setAttribute(e) {
    const { tr: n } = this.editor.state;
    n.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(n);
  }
}
const W8e = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function Y8e(t, e, n) {
  const r = document.querySelector(`style[data-tiptap-style${n ? `-${n}` : ""}]`);
  if (r !== null)
    return r;
  const o = document.createElement("style");
  return e && o.setAttribute("nonce", e), o.setAttribute(`data-tiptap-style${n ? `-${n}` : ""}`, ""), o.innerHTML = t, document.getElementsByTagName("head")[0].appendChild(o), o;
}
let K8e = class extends iCe {
  constructor(e = {}) {
    super(), this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      emitContentError: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: n }) => {
        throw n;
      },
      onPaste: () => null,
      onDrop: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("contentError", this.options.onContentError), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: n, slice: r, moved: o }) => this.options.onDrop(n, r, o)), this.on("paste", ({ event: n, slice: r }) => this.options.onPaste(n, r)), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = Y8e(W8e, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(e, n = !0) {
    this.setOptions({ editable: e }), n && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(e, n) {
    const r = u8(n) ? n(e, [...this.state.plugins]) : [...this.state.plugins, e], o = this.state.reconfigure({ plugins: r });
    return this.view.updateState(o), o;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const n = this.state.plugins;
    let r = n;
    if ([].concat(e).forEach((i) => {
      const a = typeof i == "string" ? `${i}$` : i.key;
      r = r.filter((s) => !s.key.startsWith(a));
    }), n.length === r.length)
      return;
    const o = this.state.reconfigure({
      plugins: r
    });
    return this.view.updateState(o), o;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var e, n;
    const o = [...this.options.enableCoreExtensions ? [
      k8e,
      gCe.configure({
        blockSeparator: (n = (e = this.options.coreExtensionOptions) === null || e === void 0 ? void 0 : e.clipboardTextSerializer) === null || n === void 0 ? void 0 : n.blockSeparator
      }),
      U8e,
      G8e,
      F8e,
      H8e,
      $8e,
      V8e
    ].filter((i) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[i.name] !== !1 : !0) : [], ...this.options.extensions].filter((i) => ["extension", "node", "mark"].includes(i == null ? void 0 : i.type));
    this.extensionManager = new Ss(o, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new h1({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    var e;
    let n;
    try {
      n = t_(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
    } catch (a) {
      if (!(a instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(a.message))
        throw a;
      this.emit("contentError", {
        editor: this,
        error: a,
        disableCollaboration: () => {
          this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((s) => s.name !== "collaboration"), this.createExtensionManager();
        }
      }), n = t_(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: !1 });
    }
    const r = h8(n, this.options.autofocus);
    this.view = new t8(this.options.element, {
      ...this.options.editorProps,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...(e = this.options.editorProps) === null || e === void 0 ? void 0 : e.attributes
      },
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: Cs.create({
        doc: n,
        selection: r || void 0
      })
    });
    const o = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(o), this.createNodeViews(), this.prependClass();
    const i = this.view.dom;
    i.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const n = this.capturedTransaction;
    return this.capturedTransaction = null, n;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((a) => {
        var s;
        return (s = this.capturedTransaction) === null || s === void 0 ? void 0 : s.step(a);
      });
      return;
    }
    const n = this.state.apply(e), r = !this.state.selection.eq(n.selection);
    this.emit("beforeTransaction", {
      editor: this,
      transaction: e,
      nextState: n
    }), this.view.updateState(n), this.emit("transaction", {
      editor: this,
      transaction: e
    }), r && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const o = e.getMeta("focus"), i = e.getMeta("blur");
    o && this.emit("focus", {
      editor: this,
      event: o.event,
      transaction: e
    }), i && this.emit("blur", {
      editor: this,
      event: i.event,
      transaction: e
    }), !(!e.docChanged || e.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: e
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(e) {
    return _8e(this.state, e);
  }
  isActive(e, n) {
    const r = typeof e == "string" ? e : null, o = typeof e == "string" ? n : e;
    return E8e(this.state, r, o);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return p2(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(e) {
    const { blockSeparator: n = `

`, textSerializers: r = {} } = e || {};
    return m8(this.state.doc, {
      blockSeparator: n,
      textSerializers: {
        ...N2(this.schema),
        ...r
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return O2(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    if (this.emit("destroy"), this.view) {
      const e = this.view.dom;
      e && e.editor && delete e.editor, this.view.destroy();
    }
    this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var e;
    return !(!((e = this.view) === null || e === void 0) && e.docView);
  }
  $node(e, n) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelector(e, n)) || null;
  }
  $nodes(e, n) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelectorAll(e, n)) || null;
  }
  $pos(e) {
    const n = this.state.doc.resolve(e);
    return new aa(n, this);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function $a(t) {
  return new E1({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const o = Qe(t.getAttributes, void 0, r);
      if (o === !1 || o === null)
        return null;
      const { tr: i } = e, a = r[r.length - 1], s = r[0];
      if (a) {
        const l = s.search(/\S/), c = n.from + s.indexOf(a), u = c + a.length;
        if (N8(n.from, n.to, e.doc).filter((h) => h.mark.type.excluded.find((E) => E === t.type && E !== h.mark.type)).filter((h) => h.to > c).length)
          return null;
        u < n.to && i.delete(u, n.to), c > n.from && i.delete(n.from + l, c);
        const f = n.from + l + a.length;
        i.addMark(n.from + l, f, t.type.create(o || {})), i.removeStoredMark(t.type);
      }
    }
  });
}
function z8e(t) {
  return new E1({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const o = Qe(t.getAttributes, void 0, r) || {}, { tr: i } = e, a = n.from;
      let s = n.to;
      const l = t.type.create(o);
      if (r[1]) {
        const c = r[0].lastIndexOf(r[1]);
        let u = a + c;
        u > s ? u = s : s = u + r[1].length;
        const d = r[0][r[0].length - 1];
        i.insertText(d, a + r[0].length - 1), i.replaceWith(u, s, l);
      } else if (r[0]) {
        const c = t.type.isInline ? a : a - 1;
        i.insert(c, t.type.create(o)).delete(i.mapping.map(a), i.mapping.map(s));
      }
      i.scrollIntoView();
    }
  });
}
function r_(t) {
  return new E1({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const o = e.doc.resolve(n.from), i = Qe(t.getAttributes, void 0, r) || {};
      if (!o.node(-1).canReplaceWith(o.index(-1), o.indexAfter(-1), t.type))
        return null;
      e.tr.delete(n.from, n.to).setBlockType(n.from, n.from, t.type, i);
    }
  });
}
function Vc(t) {
  return new E1({
    find: t.find,
    handler: ({ state: e, range: n, match: r, chain: o }) => {
      const i = Qe(t.getAttributes, void 0, r) || {}, a = e.tr.delete(n.from, n.to), l = a.doc.resolve(n.from).blockRange(), c = l && r2(l, t.type, i);
      if (!c)
        return null;
      if (a.wrap(l, c), t.keepMarks && t.editor) {
        const { selection: d, storedMarks: f } = e, { splittableMarks: h } = t.editor.extensionManager, _ = f || d.$to.parentOffset && d.$from.marks();
        if (_) {
          const E = _.filter((m) => h.includes(m.type.name));
          a.ensureMarks(E);
        }
      }
      if (t.keepAttributes) {
        const d = t.type.name === "bulletList" || t.type.name === "orderedList" ? "listItem" : "taskList";
        o().updateAttributes(d, i).run();
      }
      const u = a.doc.resolve(n.from - 1).nodeBefore;
      u && u.type === t.type && Wi(a.doc, n.from - 1) && (!t.joinPredicate || t.joinPredicate(r, u)) && a.join(n.from - 1);
    }
  });
}
let zr = class o_ {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Qe(Te(this, "addOptions", {
      name: this.name
    }))), this.storage = Qe(Te(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new o_(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => p1(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new o_(e);
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Qe(Te(n, "addOptions", {
      name: n.name
    })), n.storage = Qe(Te(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
};
function ka(t) {
  return new _Ce({
    find: t.find,
    handler: ({ state: e, range: n, match: r, pasteEvent: o }) => {
      const i = Qe(t.getAttributes, void 0, r, o);
      if (i === !1 || i === null)
        return null;
      const { tr: a } = e, s = r[r.length - 1], l = r[0];
      let c = n.to;
      if (s) {
        const u = l.search(/\S/), d = n.from + l.indexOf(s), f = d + s.length;
        if (N8(n.from, n.to, e.doc).filter((_) => _.mark.type.excluded.find((m) => m === t.type && m !== _.mark.type)).filter((_) => _.to > d).length)
          return null;
        f < n.to && a.delete(f, n.to), d > n.from && a.delete(n.from + u, d), c = n.from + u + s.length, a.addMark(n.from + u, c, t.type.create(i || {})), a.removeStoredMark(t.type);
      }
    }
  });
}
function Z8e(t, e) {
  const { selection: n } = t, { $from: r } = n;
  if (n instanceof ke) {
    const i = r.index();
    return r.parent.canReplaceWith(i, i + 1, e);
  }
  let o = r.depth;
  for (; o >= 0; ) {
    const i = r.index(o);
    if (r.node(o).contentMatchAt(i).matchType(e))
      return !0;
    o -= 1;
  }
  return !1;
}
var Kn = "top", Sr = "bottom", wr = "right", zn = "left", A2 = "auto", pu = [Kn, Sr, wr, zn], js = "start", Hc = "end", q8e = "clippingParents", I8 = "viewport", Pl = "popper", X8e = "reference", BI = /* @__PURE__ */ pu.reduce(function(t, e) {
  return t.concat([e + "-" + js, e + "-" + Hc]);
}, []), O8 = /* @__PURE__ */ [].concat(pu, [A2]).reduce(function(t, e) {
  return t.concat([e, e + "-" + js, e + "-" + Hc]);
}, []), j8e = "beforeRead", J8e = "read", Q8e = "afterRead", eSe = "beforeMain", tSe = "main", nSe = "afterMain", rSe = "beforeWrite", oSe = "write", iSe = "afterWrite", aSe = [j8e, J8e, Q8e, eSe, tSe, nSe, rSe, oSe, iSe];
function vo(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function or(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function Ba(t) {
  var e = or(t).Element;
  return t instanceof e || t instanceof Element;
}
function Nr(t) {
  var e = or(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function D2(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = or(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function sSe(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var r = e.styles[n] || {}, o = e.attributes[n] || {}, i = e.elements[n];
    !Nr(i) || !vo(i) || (Object.assign(i.style, r), Object.keys(o).forEach(function(a) {
      var s = o[a];
      s === !1 ? i.removeAttribute(a) : i.setAttribute(a, s === !0 ? "" : s);
    }));
  });
}
function lSe(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var o = e.elements[r], i = e.attributes[r] || {}, a = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : n[r]), s = a.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Nr(o) || !vo(o) || (Object.assign(o.style, s), Object.keys(i).forEach(function(l) {
        o.removeAttribute(l);
      }));
    });
  };
}
const A8 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: sSe,
  effect: lSe,
  requires: ["computeStyles"]
};
function uo(t) {
  return t.split("-")[0];
}
var ga = Math.max, lf = Math.min, Js = Math.round;
function i_() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function D8() {
  return !/^((?!chrome|android).)*safari/i.test(i_());
}
function Qs(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var r = t.getBoundingClientRect(), o = 1, i = 1;
  e && Nr(t) && (o = t.offsetWidth > 0 && Js(r.width) / t.offsetWidth || 1, i = t.offsetHeight > 0 && Js(r.height) / t.offsetHeight || 1);
  var a = Ba(t) ? or(t) : window, s = a.visualViewport, l = !D8() && n, c = (r.left + (l && s ? s.offsetLeft : 0)) / o, u = (r.top + (l && s ? s.offsetTop : 0)) / i, d = r.width / o, f = r.height / i;
  return {
    width: d,
    height: f,
    top: u,
    right: c + d,
    bottom: u + f,
    left: c,
    x: c,
    y: u
  };
}
function C2(t) {
  var e = Qs(t), n = t.offsetWidth, r = t.offsetHeight;
  return Math.abs(e.width - n) <= 1 && (n = e.width), Math.abs(e.height - r) <= 1 && (r = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: r
  };
}
function C8(t, e) {
  var n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && D2(n)) {
    var r = e;
    do {
      if (r && t.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Ko(t) {
  return or(t).getComputedStyle(t);
}
function cSe(t) {
  return ["table", "td", "th"].indexOf(vo(t)) >= 0;
}
function zi(t) {
  return ((Ba(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function N1(t) {
  return vo(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (D2(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    zi(t)
  );
}
function GI(t) {
  return !Nr(t) || // https://github.com/popperjs/popper-core/issues/837
  Ko(t).position === "fixed" ? null : t.offsetParent;
}
function uSe(t) {
  var e = /firefox/i.test(i_()), n = /Trident/i.test(i_());
  if (n && Nr(t)) {
    var r = Ko(t);
    if (r.position === "fixed")
      return null;
  }
  var o = N1(t);
  for (D2(o) && (o = o.host); Nr(o) && ["html", "body"].indexOf(vo(o)) < 0; ) {
    var i = Ko(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || e && i.willChange === "filter" || e && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function mu(t) {
  for (var e = or(t), n = GI(t); n && cSe(n) && Ko(n).position === "static"; )
    n = GI(n);
  return n && (vo(n) === "html" || vo(n) === "body" && Ko(n).position === "static") ? e : n || uSe(t) || e;
}
function S2(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function sc(t, e, n) {
  return ga(t, lf(e, n));
}
function dSe(t, e, n) {
  var r = sc(t, e, n);
  return r > n ? n : r;
}
function S8() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function w8(t) {
  return Object.assign({}, S8(), t);
}
function T8(t, e) {
  return e.reduce(function(n, r) {
    return n[r] = t, n;
  }, {});
}
var fSe = function(e, n) {
  return e = typeof e == "function" ? e(Object.assign({}, n.rects, {
    placement: n.placement
  })) : e, w8(typeof e != "number" ? e : T8(e, pu));
};
function hSe(t) {
  var e, n = t.state, r = t.name, o = t.options, i = n.elements.arrow, a = n.modifiersData.popperOffsets, s = uo(n.placement), l = S2(s), c = [zn, wr].indexOf(s) >= 0, u = c ? "height" : "width";
  if (!(!i || !a)) {
    var d = fSe(o.padding, n), f = C2(i), h = l === "y" ? Kn : zn, _ = l === "y" ? Sr : wr, E = n.rects.reference[u] + n.rects.reference[l] - a[l] - n.rects.popper[u], m = a[l] - n.rects.reference[l], N = mu(i), I = N ? l === "y" ? N.clientHeight || 0 : N.clientWidth || 0 : 0, O = E / 2 - m / 2, p = d[h], C = I - f[u] - d[_], D = I / 2 - f[u] / 2 + O, T = sc(p, D, C), k = l;
    n.modifiersData[r] = (e = {}, e[k] = T, e.centerOffset = T - D, e);
  }
}
function _Se(t) {
  var e = t.state, n = t.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = e.elements.popper.querySelector(o), !o) || C8(e.elements.popper, o) && (e.elements.arrow = o));
}
const ESe = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: hSe,
  effect: _Se,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function el(t) {
  return t.split("-")[1];
}
var pSe = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function mSe(t, e) {
  var n = t.x, r = t.y, o = e.devicePixelRatio || 1;
  return {
    x: Js(n * o) / o || 0,
    y: Js(r * o) / o || 0
  };
}
function FI(t) {
  var e, n = t.popper, r = t.popperRect, o = t.placement, i = t.variation, a = t.offsets, s = t.position, l = t.gpuAcceleration, c = t.adaptive, u = t.roundOffsets, d = t.isFixed, f = a.x, h = f === void 0 ? 0 : f, _ = a.y, E = _ === void 0 ? 0 : _, m = typeof u == "function" ? u({
    x: h,
    y: E
  }) : {
    x: h,
    y: E
  };
  h = m.x, E = m.y;
  var N = a.hasOwnProperty("x"), I = a.hasOwnProperty("y"), O = zn, p = Kn, C = window;
  if (c) {
    var D = mu(n), T = "clientHeight", k = "clientWidth";
    if (D === or(n) && (D = zi(n), Ko(D).position !== "static" && s === "absolute" && (T = "scrollHeight", k = "scrollWidth")), D = D, o === Kn || (o === zn || o === wr) && i === Hc) {
      p = Sr;
      var G = d && D === C && C.visualViewport ? C.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        D[T]
      );
      E -= G - r.height, E *= l ? 1 : -1;
    }
    if (o === zn || (o === Kn || o === Sr) && i === Hc) {
      O = wr;
      var b = d && D === C && C.visualViewport ? C.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        D[k]
      );
      h -= b - r.width, h *= l ? 1 : -1;
    }
  }
  var P = Object.assign({
    position: s
  }, c && pSe), $ = u === !0 ? mSe({
    x: h,
    y: E
  }, or(n)) : {
    x: h,
    y: E
  };
  if (h = $.x, E = $.y, l) {
    var y;
    return Object.assign({}, P, (y = {}, y[p] = I ? "0" : "", y[O] = N ? "0" : "", y.transform = (C.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + E + "px)" : "translate3d(" + h + "px, " + E + "px, 0)", y));
  }
  return Object.assign({}, P, (e = {}, e[p] = I ? E + "px" : "", e[O] = N ? h + "px" : "", e.transform = "", e));
}
function NSe(t) {
  var e = t.state, n = t.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, i = n.adaptive, a = i === void 0 ? !0 : i, s = n.roundOffsets, l = s === void 0 ? !0 : s, c = {
    placement: uo(e.placement),
    variation: el(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: o,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, FI(Object.assign({}, c, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: a,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, FI(Object.assign({}, c, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const vSe = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: NSe,
  data: {}
};
var Zu = {
  passive: !0
};
function gSe(t) {
  var e = t.state, n = t.instance, r = t.options, o = r.scroll, i = o === void 0 ? !0 : o, a = r.resize, s = a === void 0 ? !0 : a, l = or(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return i && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, Zu);
  }), s && l.addEventListener("resize", n.update, Zu), function() {
    i && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, Zu);
    }), s && l.removeEventListener("resize", n.update, Zu);
  };
}
const ISe = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: gSe,
  data: {}
};
var OSe = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function dd(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return OSe[e];
  });
}
var ASe = {
  start: "end",
  end: "start"
};
function VI(t) {
  return t.replace(/start|end/g, function(e) {
    return ASe[e];
  });
}
function w2(t) {
  var e = or(t), n = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function T2(t) {
  return Qs(zi(t)).left + w2(t).scrollLeft;
}
function DSe(t, e) {
  var n = or(t), r = zi(t), o = n.visualViewport, i = r.clientWidth, a = r.clientHeight, s = 0, l = 0;
  if (o) {
    i = o.width, a = o.height;
    var c = D8();
    (c || !c && e === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: s + T2(t),
    y: l
  };
}
function CSe(t) {
  var e, n = zi(t), r = w2(t), o = (e = t.ownerDocument) == null ? void 0 : e.body, i = ga(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), a = ga(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), s = -r.scrollLeft + T2(t), l = -r.scrollTop;
  return Ko(o || n).direction === "rtl" && (s += ga(n.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: a,
    x: s,
    y: l
  };
}
function b2(t) {
  var e = Ko(t), n = e.overflow, r = e.overflowX, o = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function b8(t) {
  return ["html", "body", "#document"].indexOf(vo(t)) >= 0 ? t.ownerDocument.body : Nr(t) && b2(t) ? t : b8(N1(t));
}
function lc(t, e) {
  var n;
  e === void 0 && (e = []);
  var r = b8(t), o = r === ((n = t.ownerDocument) == null ? void 0 : n.body), i = or(r), a = o ? [i].concat(i.visualViewport || [], b2(r) ? r : []) : r, s = e.concat(a);
  return o ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(lc(N1(a)))
  );
}
function a_(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function SSe(t, e) {
  var n = Qs(t, !1, e === "fixed");
  return n.top = n.top + t.clientTop, n.left = n.left + t.clientLeft, n.bottom = n.top + t.clientHeight, n.right = n.left + t.clientWidth, n.width = t.clientWidth, n.height = t.clientHeight, n.x = n.left, n.y = n.top, n;
}
function HI(t, e, n) {
  return e === I8 ? a_(DSe(t, n)) : Ba(e) ? SSe(e, n) : a_(CSe(zi(t)));
}
function wSe(t) {
  var e = lc(N1(t)), n = ["absolute", "fixed"].indexOf(Ko(t).position) >= 0, r = n && Nr(t) ? mu(t) : t;
  return Ba(r) ? e.filter(function(o) {
    return Ba(o) && C8(o, r) && vo(o) !== "body";
  }) : [];
}
function TSe(t, e, n, r) {
  var o = e === "clippingParents" ? wSe(t) : [].concat(e), i = [].concat(o, [n]), a = i[0], s = i.reduce(function(l, c) {
    var u = HI(t, c, r);
    return l.top = ga(u.top, l.top), l.right = lf(u.right, l.right), l.bottom = lf(u.bottom, l.bottom), l.left = ga(u.left, l.left), l;
  }, HI(t, a, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function R8(t) {
  var e = t.reference, n = t.element, r = t.placement, o = r ? uo(r) : null, i = r ? el(r) : null, a = e.x + e.width / 2 - n.width / 2, s = e.y + e.height / 2 - n.height / 2, l;
  switch (o) {
    case Kn:
      l = {
        x: a,
        y: e.y - n.height
      };
      break;
    case Sr:
      l = {
        x: a,
        y: e.y + e.height
      };
      break;
    case wr:
      l = {
        x: e.x + e.width,
        y: s
      };
      break;
    case zn:
      l = {
        x: e.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var c = o ? S2(o) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (i) {
      case js:
        l[c] = l[c] - (e[u] / 2 - n[u] / 2);
        break;
      case Hc:
        l[c] = l[c] + (e[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function Wc(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, o = r === void 0 ? t.placement : r, i = n.strategy, a = i === void 0 ? t.strategy : i, s = n.boundary, l = s === void 0 ? q8e : s, c = n.rootBoundary, u = c === void 0 ? I8 : c, d = n.elementContext, f = d === void 0 ? Pl : d, h = n.altBoundary, _ = h === void 0 ? !1 : h, E = n.padding, m = E === void 0 ? 0 : E, N = w8(typeof m != "number" ? m : T8(m, pu)), I = f === Pl ? X8e : Pl, O = t.rects.popper, p = t.elements[_ ? I : f], C = TSe(Ba(p) ? p : p.contextElement || zi(t.elements.popper), l, u, a), D = Qs(t.elements.reference), T = R8({
    reference: D,
    element: O,
    strategy: "absolute",
    placement: o
  }), k = a_(Object.assign({}, O, T)), G = f === Pl ? k : D, b = {
    top: C.top - G.top + N.top,
    bottom: G.bottom - C.bottom + N.bottom,
    left: C.left - G.left + N.left,
    right: G.right - C.right + N.right
  }, P = t.modifiersData.offset;
  if (f === Pl && P) {
    var $ = P[o];
    Object.keys(b).forEach(function(y) {
      var L = [wr, Sr].indexOf(y) >= 0 ? 1 : -1, w = [Kn, Sr].indexOf(y) >= 0 ? "y" : "x";
      b[y] += $[w] * L;
    });
  }
  return b;
}
function bSe(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, o = n.boundary, i = n.rootBoundary, a = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? O8 : l, u = el(r), d = u ? s ? BI : BI.filter(function(_) {
    return el(_) === u;
  }) : pu, f = d.filter(function(_) {
    return c.indexOf(_) >= 0;
  });
  f.length === 0 && (f = d);
  var h = f.reduce(function(_, E) {
    return _[E] = Wc(t, {
      placement: E,
      boundary: o,
      rootBoundary: i,
      padding: a
    })[uo(E)], _;
  }, {});
  return Object.keys(h).sort(function(_, E) {
    return h[_] - h[E];
  });
}
function RSe(t) {
  if (uo(t) === A2)
    return [];
  var e = dd(t);
  return [VI(t), e, VI(e)];
}
function MSe(t) {
  var e = t.state, n = t.options, r = t.name;
  if (!e.modifiersData[r]._skip) {
    for (var o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, s = a === void 0 ? !0 : a, l = n.fallbackPlacements, c = n.padding, u = n.boundary, d = n.rootBoundary, f = n.altBoundary, h = n.flipVariations, _ = h === void 0 ? !0 : h, E = n.allowedAutoPlacements, m = e.options.placement, N = uo(m), I = N === m, O = l || (I || !_ ? [dd(m)] : RSe(m)), p = [m].concat(O).reduce(function(re, j) {
      return re.concat(uo(j) === A2 ? bSe(e, {
        placement: j,
        boundary: u,
        rootBoundary: d,
        padding: c,
        flipVariations: _,
        allowedAutoPlacements: E
      }) : j);
    }, []), C = e.rects.reference, D = e.rects.popper, T = /* @__PURE__ */ new Map(), k = !0, G = p[0], b = 0; b < p.length; b++) {
      var P = p[b], $ = uo(P), y = el(P) === js, L = [Kn, Sr].indexOf($) >= 0, w = L ? "width" : "height", R = Wc(e, {
        placement: P,
        boundary: u,
        rootBoundary: d,
        altBoundary: f,
        padding: c
      }), B = L ? y ? wr : zn : y ? Sr : Kn;
      C[w] > D[w] && (B = dd(B));
      var U = dd(B), K = [];
      if (i && K.push(R[$] <= 0), s && K.push(R[B] <= 0, R[U] <= 0), K.every(function(re) {
        return re;
      })) {
        G = P, k = !1;
        break;
      }
      T.set(P, K);
    }
    if (k)
      for (var Z = _ ? 3 : 1, X = function(j) {
        var ne = p.find(function(Ee) {
          var fe = T.get(Ee);
          if (fe)
            return fe.slice(0, j).every(function(Oe) {
              return Oe;
            });
        });
        if (ne)
          return G = ne, "break";
      }, J = Z; J > 0; J--) {
        var ae = X(J);
        if (ae === "break")
          break;
      }
    e.placement !== G && (e.modifiersData[r]._skip = !0, e.placement = G, e.reset = !0);
  }
}
const PSe = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: MSe,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function WI(t, e, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - n.y,
    right: t.right - e.width + n.x,
    bottom: t.bottom - e.height + n.y,
    left: t.left - e.width - n.x
  };
}
function YI(t) {
  return [Kn, wr, Sr, zn].some(function(e) {
    return t[e] >= 0;
  });
}
function ySe(t) {
  var e = t.state, n = t.name, r = e.rects.reference, o = e.rects.popper, i = e.modifiersData.preventOverflow, a = Wc(e, {
    elementContext: "reference"
  }), s = Wc(e, {
    altBoundary: !0
  }), l = WI(a, r), c = WI(s, o, i), u = YI(l), d = YI(c);
  e.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: d
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": d
  });
}
const LSe = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: ySe
};
function xSe(t, e, n) {
  var r = uo(t), o = [zn, Kn].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, a = i[0], s = i[1];
  return a = a || 0, s = (s || 0) * o, [zn, wr].indexOf(r) >= 0 ? {
    x: s,
    y: a
  } : {
    x: a,
    y: s
  };
}
function USe(t) {
  var e = t.state, n = t.options, r = t.name, o = n.offset, i = o === void 0 ? [0, 0] : o, a = O8.reduce(function(u, d) {
    return u[d] = xSe(d, e.rects, i), u;
  }, {}), s = a[e.placement], l = s.x, c = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += c), e.modifiersData[r] = a;
}
const $Se = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: USe
};
function kSe(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = R8({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const BSe = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: kSe,
  data: {}
};
function GSe(t) {
  return t === "x" ? "y" : "x";
}
function FSe(t) {
  var e = t.state, n = t.options, r = t.name, o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, s = a === void 0 ? !1 : a, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, d = n.padding, f = n.tether, h = f === void 0 ? !0 : f, _ = n.tetherOffset, E = _ === void 0 ? 0 : _, m = Wc(e, {
    boundary: l,
    rootBoundary: c,
    padding: d,
    altBoundary: u
  }), N = uo(e.placement), I = el(e.placement), O = !I, p = S2(N), C = GSe(p), D = e.modifiersData.popperOffsets, T = e.rects.reference, k = e.rects.popper, G = typeof E == "function" ? E(Object.assign({}, e.rects, {
    placement: e.placement
  })) : E, b = typeof G == "number" ? {
    mainAxis: G,
    altAxis: G
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, G), P = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, $ = {
    x: 0,
    y: 0
  };
  if (D) {
    if (i) {
      var y, L = p === "y" ? Kn : zn, w = p === "y" ? Sr : wr, R = p === "y" ? "height" : "width", B = D[p], U = B + m[L], K = B - m[w], Z = h ? -k[R] / 2 : 0, X = I === js ? T[R] : k[R], J = I === js ? -k[R] : -T[R], ae = e.elements.arrow, re = h && ae ? C2(ae) : {
        width: 0,
        height: 0
      }, j = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : S8(), ne = j[L], Ee = j[w], fe = sc(0, T[R], re[R]), Oe = O ? T[R] / 2 - Z - fe - ne - b.mainAxis : X - fe - ne - b.mainAxis, ce = O ? -T[R] / 2 + Z + fe + Ee + b.mainAxis : J + fe + Ee + b.mainAxis, Se = e.elements.arrow && mu(e.elements.arrow), se = Se ? p === "y" ? Se.clientTop || 0 : Se.clientLeft || 0 : 0, Ie = (y = P == null ? void 0 : P[p]) != null ? y : 0, we = B + Oe - Ie - se, le = B + ce - Ie, De = sc(h ? lf(U, we) : U, B, h ? ga(K, le) : K);
      D[p] = De, $[p] = De - B;
    }
    if (s) {
      var pe, Le = p === "x" ? Kn : zn, ze = p === "x" ? Sr : wr, Xe = D[C], je = C === "y" ? "height" : "width", it = Xe + m[Le], ot = Xe - m[ze], Rt = [Kn, zn].indexOf(N) !== -1, Ht = (pe = P == null ? void 0 : P[C]) != null ? pe : 0, Mt = Rt ? it : Xe - T[je] - k[je] - Ht + b.altAxis, pn = Rt ? Xe + T[je] + k[je] - Ht - b.altAxis : ot, on = h && Rt ? dSe(Mt, Xe, pn) : sc(h ? Mt : it, Xe, h ? pn : ot);
      D[C] = on, $[C] = on - Xe;
    }
    e.modifiersData[r] = $;
  }
}
const VSe = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: FSe,
  requiresIfExists: ["offset"]
};
function HSe(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function WSe(t) {
  return t === or(t) || !Nr(t) ? w2(t) : HSe(t);
}
function YSe(t) {
  var e = t.getBoundingClientRect(), n = Js(e.width) / t.offsetWidth || 1, r = Js(e.height) / t.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function KSe(t, e, n) {
  n === void 0 && (n = !1);
  var r = Nr(e), o = Nr(e) && YSe(e), i = zi(e), a = Qs(t, o, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((vo(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  b2(i)) && (s = WSe(e)), Nr(e) ? (l = Qs(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : i && (l.x = T2(i))), {
    x: a.left + s.scrollLeft - l.x,
    y: a.top + s.scrollTop - l.y,
    width: a.width,
    height: a.height
  };
}
function zSe(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  t.forEach(function(i) {
    e.set(i.name, i);
  });
  function o(i) {
    n.add(i.name);
    var a = [].concat(i.requires || [], i.requiresIfExists || []);
    a.forEach(function(s) {
      if (!n.has(s)) {
        var l = e.get(s);
        l && o(l);
      }
    }), r.push(i);
  }
  return t.forEach(function(i) {
    n.has(i.name) || o(i);
  }), r;
}
function ZSe(t) {
  var e = zSe(t);
  return aSe.reduce(function(n, r) {
    return n.concat(e.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function qSe(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function XSe(t) {
  var e = t.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var KI = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function zI() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function jSe(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, r = n === void 0 ? [] : n, o = e.defaultOptions, i = o === void 0 ? KI : o;
  return function(s, l, c) {
    c === void 0 && (c = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, KI, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, h = {
      state: u,
      setOptions: function(N) {
        var I = typeof N == "function" ? N(u.options) : N;
        E(), u.options = Object.assign({}, i, u.options, I), u.scrollParents = {
          reference: Ba(s) ? lc(s) : s.contextElement ? lc(s.contextElement) : [],
          popper: lc(l)
        };
        var O = ZSe(XSe([].concat(r, u.options.modifiers)));
        return u.orderedModifiers = O.filter(function(p) {
          return p.enabled;
        }), _(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var N = u.elements, I = N.reference, O = N.popper;
          if (zI(I, O)) {
            u.rects = {
              reference: KSe(I, mu(O), u.options.strategy === "fixed"),
              popper: C2(O)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(b) {
              return u.modifiersData[b.name] = Object.assign({}, b.data);
            });
            for (var p = 0; p < u.orderedModifiers.length; p++) {
              if (u.reset === !0) {
                u.reset = !1, p = -1;
                continue;
              }
              var C = u.orderedModifiers[p], D = C.fn, T = C.options, k = T === void 0 ? {} : T, G = C.name;
              typeof D == "function" && (u = D({
                state: u,
                options: k,
                name: G,
                instance: h
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: qSe(function() {
        return new Promise(function(m) {
          h.forceUpdate(), m(u);
        });
      }),
      destroy: function() {
        E(), f = !0;
      }
    };
    if (!zI(s, l))
      return h;
    h.setOptions(c).then(function(m) {
      !f && c.onFirstUpdate && c.onFirstUpdate(m);
    });
    function _() {
      u.orderedModifiers.forEach(function(m) {
        var N = m.name, I = m.options, O = I === void 0 ? {} : I, p = m.effect;
        if (typeof p == "function") {
          var C = p({
            state: u,
            name: N,
            instance: h,
            options: O
          }), D = function() {
          };
          d.push(C || D);
        }
      });
    }
    function E() {
      d.forEach(function(m) {
        return m();
      }), d = [];
    }
    return h;
  };
}
var JSe = [ISe, BSe, vSe, A8, $Se, PSe, VSe, ESe, LSe], QSe = /* @__PURE__ */ jSe({
  defaultModifiers: JSe
}), ewe = "tippy-box", M8 = "tippy-content", twe = "tippy-backdrop", P8 = "tippy-arrow", y8 = "tippy-svg-arrow", na = {
  passive: !0,
  capture: !0
}, L8 = function() {
  return document.body;
};
function nwe(t, e) {
  return {}.hasOwnProperty.call(t, e);
}
function Sh(t, e, n) {
  if (Array.isArray(t)) {
    var r = t[e];
    return r ?? (Array.isArray(n) ? n[e] : n);
  }
  return t;
}
function R2(t, e) {
  var n = {}.toString.call(t);
  return n.indexOf("[object") === 0 && n.indexOf(e + "]") > -1;
}
function x8(t, e) {
  return typeof t == "function" ? t.apply(void 0, e) : t;
}
function ZI(t, e) {
  if (e === 0)
    return t;
  var n;
  return function(r) {
    clearTimeout(n), n = setTimeout(function() {
      t(r);
    }, e);
  };
}
function rwe(t, e) {
  var n = Object.assign({}, t);
  return e.forEach(function(r) {
    delete n[r];
  }), n;
}
function owe(t) {
  return t.split(/\s+/).filter(Boolean);
}
function ms(t) {
  return [].concat(t);
}
function qI(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function iwe(t) {
  return t.filter(function(e, n) {
    return t.indexOf(e) === n;
  });
}
function awe(t) {
  return t.split("-")[0];
}
function cf(t) {
  return [].slice.call(t);
}
function XI(t) {
  return Object.keys(t).reduce(function(e, n) {
    return t[n] !== void 0 && (e[n] = t[n]), e;
  }, {});
}
function cc() {
  return document.createElement("div");
}
function Yc(t) {
  return ["Element", "Fragment"].some(function(e) {
    return R2(t, e);
  });
}
function swe(t) {
  return R2(t, "NodeList");
}
function lwe(t) {
  return R2(t, "MouseEvent");
}
function cwe(t) {
  return !!(t && t._tippy && t._tippy.reference === t);
}
function uwe(t) {
  return Yc(t) ? [t] : swe(t) ? cf(t) : Array.isArray(t) ? t : cf(document.querySelectorAll(t));
}
function wh(t, e) {
  t.forEach(function(n) {
    n && (n.style.transitionDuration = e + "ms");
  });
}
function jI(t, e) {
  t.forEach(function(n) {
    n && n.setAttribute("data-state", e);
  });
}
function dwe(t) {
  var e, n = ms(t), r = n[0];
  return r != null && (e = r.ownerDocument) != null && e.body ? r.ownerDocument : document;
}
function fwe(t, e) {
  var n = e.clientX, r = e.clientY;
  return t.every(function(o) {
    var i = o.popperRect, a = o.popperState, s = o.props, l = s.interactiveBorder, c = awe(a.placement), u = a.modifiersData.offset;
    if (!u)
      return !0;
    var d = c === "bottom" ? u.top.y : 0, f = c === "top" ? u.bottom.y : 0, h = c === "right" ? u.left.x : 0, _ = c === "left" ? u.right.x : 0, E = i.top - r + d > l, m = r - i.bottom - f > l, N = i.left - n + h > l, I = n - i.right - _ > l;
    return E || m || N || I;
  });
}
function Th(t, e, n) {
  var r = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(o) {
    t[r](o, n);
  });
}
function JI(t, e) {
  for (var n = e; n; ) {
    var r;
    if (t.contains(n))
      return !0;
    n = n.getRootNode == null || (r = n.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var to = {
  isTouch: !1
}, QI = 0;
function hwe() {
  to.isTouch || (to.isTouch = !0, window.performance && document.addEventListener("mousemove", U8));
}
function U8() {
  var t = performance.now();
  t - QI < 20 && (to.isTouch = !1, document.removeEventListener("mousemove", U8)), QI = t;
}
function _we() {
  var t = document.activeElement;
  if (cwe(t)) {
    var e = t._tippy;
    t.blur && !e.state.isVisible && t.blur();
  }
}
function Ewe() {
  document.addEventListener("touchstart", hwe, na), window.addEventListener("blur", _we);
}
var pwe = typeof window < "u" && typeof document < "u", mwe = pwe ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function cs(t) {
  var e = t === "destroy" ? "n already-" : " ";
  return [t + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function eO(t) {
  var e = /[ \t]{2,}/g, n = /^[ \t]*/gm;
  return t.replace(e, " ").replace(n, "").trim();
}
function Nwe(t) {
  return eO(`
  %ctippy.js

  %c` + eO(t) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function $8(t) {
  return [
    Nwe(t),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var Kc;
process.env.NODE_ENV !== "production" && vwe();
function vwe() {
  Kc = /* @__PURE__ */ new Set();
}
function yo(t, e) {
  if (t && !Kc.has(e)) {
    var n;
    Kc.add(e), (n = console).warn.apply(n, $8(e));
  }
}
function s_(t, e) {
  if (t && !Kc.has(e)) {
    var n;
    Kc.add(e), (n = console).error.apply(n, $8(e));
  }
}
function gwe(t) {
  var e = !t, n = Object.prototype.toString.call(t) === "[object Object]" && !t.addEventListener;
  s_(e, ["tippy() was passed", "`" + String(t) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), s_(n, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var k8 = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, Iwe = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, nr = Object.assign({
  appendTo: L8,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, k8, Iwe), Owe = Object.keys(nr), Awe = function(e) {
  process.env.NODE_ENV !== "production" && G8(e, []);
  var n = Object.keys(e);
  n.forEach(function(r) {
    nr[r] = e[r];
  });
};
function B8(t) {
  var e = t.plugins || [], n = e.reduce(function(r, o) {
    var i = o.name, a = o.defaultValue;
    if (i) {
      var s;
      r[i] = t[i] !== void 0 ? t[i] : (s = nr[i]) != null ? s : a;
    }
    return r;
  }, {});
  return Object.assign({}, t, n);
}
function Dwe(t, e) {
  var n = e ? Object.keys(B8(Object.assign({}, nr, {
    plugins: e
  }))) : Owe, r = n.reduce(function(o, i) {
    var a = (t.getAttribute("data-tippy-" + i) || "").trim();
    if (!a)
      return o;
    if (i === "content")
      o[i] = a;
    else
      try {
        o[i] = JSON.parse(a);
      } catch {
        o[i] = a;
      }
    return o;
  }, {});
  return r;
}
function tO(t, e) {
  var n = Object.assign({}, e, {
    content: x8(e.content, [t])
  }, e.ignoreAttributes ? {} : Dwe(t, e.plugins));
  return n.aria = Object.assign({}, nr.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? e.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? e.interactive ? null : "describedby" : n.aria.content
  }, n;
}
function G8(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = []);
  var n = Object.keys(t);
  n.forEach(function(r) {
    var o = rwe(nr, Object.keys(k8)), i = !nwe(o, r);
    i && (i = e.filter(function(a) {
      return a.name === r;
    }).length === 0), yo(i, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var Cwe = function() {
  return "innerHTML";
};
function l_(t, e) {
  t[Cwe()] = e;
}
function nO(t) {
  var e = cc();
  return t === !0 ? e.className = P8 : (e.className = y8, Yc(t) ? e.appendChild(t) : l_(e, t)), e;
}
function rO(t, e) {
  Yc(e.content) ? (l_(t, ""), t.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? l_(t, e.content) : t.textContent = e.content);
}
function c_(t) {
  var e = t.firstElementChild, n = cf(e.children);
  return {
    box: e,
    content: n.find(function(r) {
      return r.classList.contains(M8);
    }),
    arrow: n.find(function(r) {
      return r.classList.contains(P8) || r.classList.contains(y8);
    }),
    backdrop: n.find(function(r) {
      return r.classList.contains(twe);
    })
  };
}
function F8(t) {
  var e = cc(), n = cc();
  n.className = ewe, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var r = cc();
  r.className = M8, r.setAttribute("data-state", "hidden"), rO(r, t.props), e.appendChild(n), n.appendChild(r), o(t.props, t.props);
  function o(i, a) {
    var s = c_(e), l = s.box, c = s.content, u = s.arrow;
    a.theme ? l.setAttribute("data-theme", a.theme) : l.removeAttribute("data-theme"), typeof a.animation == "string" ? l.setAttribute("data-animation", a.animation) : l.removeAttribute("data-animation"), a.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof a.maxWidth == "number" ? a.maxWidth + "px" : a.maxWidth, a.role ? l.setAttribute("role", a.role) : l.removeAttribute("role"), (i.content !== a.content || i.allowHTML !== a.allowHTML) && rO(c, t.props), a.arrow ? u ? i.arrow !== a.arrow && (l.removeChild(u), l.appendChild(nO(a.arrow))) : l.appendChild(nO(a.arrow)) : u && l.removeChild(u);
  }
  return {
    popper: e,
    onUpdate: o
  };
}
F8.$$tippy = !0;
var Swe = 1, qu = [], bh = [];
function wwe(t, e) {
  var n = tO(t, Object.assign({}, nr, B8(XI(e)))), r, o, i, a = !1, s = !1, l = !1, c = !1, u, d, f, h = [], _ = ZI(we, n.interactiveDebounce), E, m = Swe++, N = null, I = iwe(n.plugins), O = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, p = {
    // properties
    id: m,
    reference: t,
    popper: cc(),
    popperInstance: N,
    props: n,
    state: O,
    plugins: I,
    // methods
    clearDelayTimeouts: Mt,
    setProps: pn,
    setContent: on,
    show: Zr,
    hide: Pr,
    hideWithInteractivity: yr,
    enable: Rt,
    disable: Ht,
    unmount: ht,
    destroy: Gn
  };
  if (!n.render)
    return process.env.NODE_ENV !== "production" && s_(!0, "render() function has not been supplied."), p;
  var C = n.render(p), D = C.popper, T = C.onUpdate;
  D.setAttribute("data-tippy-root", ""), D.id = "tippy-" + p.id, p.popper = D, t._tippy = p, D._tippy = p;
  var k = I.map(function(F) {
    return F.fn(p);
  }), G = t.hasAttribute("aria-expanded");
  return Se(), Z(), B(), U("onCreate", [p]), n.showOnCreate && it(), D.addEventListener("mouseenter", function() {
    p.props.interactive && p.state.isVisible && p.clearDelayTimeouts();
  }), D.addEventListener("mouseleave", function() {
    p.props.interactive && p.props.trigger.indexOf("mouseenter") >= 0 && L().addEventListener("mousemove", _);
  }), p;
  function b() {
    var F = p.props.touch;
    return Array.isArray(F) ? F : [F, 0];
  }
  function P() {
    return b()[0] === "hold";
  }
  function $() {
    var F;
    return !!((F = p.props.render) != null && F.$$tippy);
  }
  function y() {
    return E || t;
  }
  function L() {
    var F = y().parentNode;
    return F ? dwe(F) : document;
  }
  function w() {
    return c_(D);
  }
  function R(F) {
    return p.state.isMounted && !p.state.isVisible || to.isTouch || u && u.type === "focus" ? 0 : Sh(p.props.delay, F ? 0 : 1, nr.delay);
  }
  function B(F) {
    F === void 0 && (F = !1), D.style.pointerEvents = p.props.interactive && !F ? "" : "none", D.style.zIndex = "" + p.props.zIndex;
  }
  function U(F, oe, he) {
    if (he === void 0 && (he = !0), k.forEach(function(Ce) {
      Ce[F] && Ce[F].apply(Ce, oe);
    }), he) {
      var Re;
      (Re = p.props)[F].apply(Re, oe);
    }
  }
  function K() {
    var F = p.props.aria;
    if (F.content) {
      var oe = "aria-" + F.content, he = D.id, Re = ms(p.props.triggerTarget || t);
      Re.forEach(function(Ce) {
        var at = Ce.getAttribute(oe);
        if (p.state.isVisible)
          Ce.setAttribute(oe, at ? at + " " + he : he);
        else {
          var Ot = at && at.replace(he, "").trim();
          Ot ? Ce.setAttribute(oe, Ot) : Ce.removeAttribute(oe);
        }
      });
    }
  }
  function Z() {
    if (!(G || !p.props.aria.expanded)) {
      var F = ms(p.props.triggerTarget || t);
      F.forEach(function(oe) {
        p.props.interactive ? oe.setAttribute("aria-expanded", p.state.isVisible && oe === y() ? "true" : "false") : oe.removeAttribute("aria-expanded");
      });
    }
  }
  function X() {
    L().removeEventListener("mousemove", _), qu = qu.filter(function(F) {
      return F !== _;
    });
  }
  function J(F) {
    if (!(to.isTouch && (l || F.type === "mousedown"))) {
      var oe = F.composedPath && F.composedPath()[0] || F.target;
      if (!(p.props.interactive && JI(D, oe))) {
        if (ms(p.props.triggerTarget || t).some(function(he) {
          return JI(he, oe);
        })) {
          if (to.isTouch || p.state.isVisible && p.props.trigger.indexOf("click") >= 0)
            return;
        } else
          U("onClickOutside", [p, F]);
        p.props.hideOnClick === !0 && (p.clearDelayTimeouts(), p.hide(), s = !0, setTimeout(function() {
          s = !1;
        }), p.state.isMounted || ne());
      }
    }
  }
  function ae() {
    l = !0;
  }
  function re() {
    l = !1;
  }
  function j() {
    var F = L();
    F.addEventListener("mousedown", J, !0), F.addEventListener("touchend", J, na), F.addEventListener("touchstart", re, na), F.addEventListener("touchmove", ae, na);
  }
  function ne() {
    var F = L();
    F.removeEventListener("mousedown", J, !0), F.removeEventListener("touchend", J, na), F.removeEventListener("touchstart", re, na), F.removeEventListener("touchmove", ae, na);
  }
  function Ee(F, oe) {
    Oe(F, function() {
      !p.state.isVisible && D.parentNode && D.parentNode.contains(D) && oe();
    });
  }
  function fe(F, oe) {
    Oe(F, oe);
  }
  function Oe(F, oe) {
    var he = w().box;
    function Re(Ce) {
      Ce.target === he && (Th(he, "remove", Re), oe());
    }
    if (F === 0)
      return oe();
    Th(he, "remove", d), Th(he, "add", Re), d = Re;
  }
  function ce(F, oe, he) {
    he === void 0 && (he = !1);
    var Re = ms(p.props.triggerTarget || t);
    Re.forEach(function(Ce) {
      Ce.addEventListener(F, oe, he), h.push({
        node: Ce,
        eventType: F,
        handler: oe,
        options: he
      });
    });
  }
  function Se() {
    P() && (ce("touchstart", Ie, {
      passive: !0
    }), ce("touchend", le, {
      passive: !0
    })), owe(p.props.trigger).forEach(function(F) {
      if (F !== "manual")
        switch (ce(F, Ie), F) {
          case "mouseenter":
            ce("mouseleave", le);
            break;
          case "focus":
            ce(mwe ? "focusout" : "blur", De);
            break;
          case "focusin":
            ce("focusout", De);
            break;
        }
    });
  }
  function se() {
    h.forEach(function(F) {
      var oe = F.node, he = F.eventType, Re = F.handler, Ce = F.options;
      oe.removeEventListener(he, Re, Ce);
    }), h = [];
  }
  function Ie(F) {
    var oe, he = !1;
    if (!(!p.state.isEnabled || pe(F) || s)) {
      var Re = ((oe = u) == null ? void 0 : oe.type) === "focus";
      u = F, E = F.currentTarget, Z(), !p.state.isVisible && lwe(F) && qu.forEach(function(Ce) {
        return Ce(F);
      }), F.type === "click" && (p.props.trigger.indexOf("mouseenter") < 0 || a) && p.props.hideOnClick !== !1 && p.state.isVisible ? he = !0 : it(F), F.type === "click" && (a = !he), he && !Re && ot(F);
    }
  }
  function we(F) {
    var oe = F.target, he = y().contains(oe) || D.contains(oe);
    if (!(F.type === "mousemove" && he)) {
      var Re = je().concat(D).map(function(Ce) {
        var at, Ot = Ce._tippy, Xn = (at = Ot.popperInstance) == null ? void 0 : at.state;
        return Xn ? {
          popperRect: Ce.getBoundingClientRect(),
          popperState: Xn,
          props: n
        } : null;
      }).filter(Boolean);
      fwe(Re, F) && (X(), ot(F));
    }
  }
  function le(F) {
    var oe = pe(F) || p.props.trigger.indexOf("click") >= 0 && a;
    if (!oe) {
      if (p.props.interactive) {
        p.hideWithInteractivity(F);
        return;
      }
      ot(F);
    }
  }
  function De(F) {
    p.props.trigger.indexOf("focusin") < 0 && F.target !== y() || p.props.interactive && F.relatedTarget && D.contains(F.relatedTarget) || ot(F);
  }
  function pe(F) {
    return to.isTouch ? P() !== F.type.indexOf("touch") >= 0 : !1;
  }
  function Le() {
    ze();
    var F = p.props, oe = F.popperOptions, he = F.placement, Re = F.offset, Ce = F.getReferenceClientRect, at = F.moveTransition, Ot = $() ? c_(D).arrow : null, Xn = Ce ? {
      getBoundingClientRect: Ce,
      contextElement: Ce.contextElement || y()
    } : t, gl = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(wo) {
        var jn = wo.state;
        if ($()) {
          var v1 = w(), qi = v1.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(To) {
            To === "placement" ? qi.setAttribute("data-placement", jn.placement) : jn.attributes.popper["data-popper-" + To] ? qi.setAttribute("data-" + To, "") : qi.removeAttribute("data-" + To);
          }), jn.attributes.popper = {};
        }
      }
    }, Cn = [{
      name: "offset",
      options: {
        offset: Re
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !at
      }
    }, gl];
    $() && Ot && Cn.push({
      name: "arrow",
      options: {
        element: Ot,
        padding: 3
      }
    }), Cn.push.apply(Cn, (oe == null ? void 0 : oe.modifiers) || []), p.popperInstance = QSe(Xn, D, Object.assign({}, oe, {
      placement: he,
      onFirstUpdate: f,
      modifiers: Cn
    }));
  }
  function ze() {
    p.popperInstance && (p.popperInstance.destroy(), p.popperInstance = null);
  }
  function Xe() {
    var F = p.props.appendTo, oe, he = y();
    p.props.interactive && F === L8 || F === "parent" ? oe = he.parentNode : oe = x8(F, [he]), oe.contains(D) || oe.appendChild(D), p.state.isMounted = !0, Le(), process.env.NODE_ENV !== "production" && yo(p.props.interactive && F === nr.appendTo && he.nextElementSibling !== D, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function je() {
    return cf(D.querySelectorAll("[data-tippy-root]"));
  }
  function it(F) {
    p.clearDelayTimeouts(), F && U("onTrigger", [p, F]), j();
    var oe = R(!0), he = b(), Re = he[0], Ce = he[1];
    to.isTouch && Re === "hold" && Ce && (oe = Ce), oe ? r = setTimeout(function() {
      p.show();
    }, oe) : p.show();
  }
  function ot(F) {
    if (p.clearDelayTimeouts(), U("onUntrigger", [p, F]), !p.state.isVisible) {
      ne();
      return;
    }
    if (!(p.props.trigger.indexOf("mouseenter") >= 0 && p.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(F.type) >= 0 && a)) {
      var oe = R(!1);
      oe ? o = setTimeout(function() {
        p.state.isVisible && p.hide();
      }, oe) : i = requestAnimationFrame(function() {
        p.hide();
      });
    }
  }
  function Rt() {
    p.state.isEnabled = !0;
  }
  function Ht() {
    p.hide(), p.state.isEnabled = !1;
  }
  function Mt() {
    clearTimeout(r), clearTimeout(o), cancelAnimationFrame(i);
  }
  function pn(F) {
    if (process.env.NODE_ENV !== "production" && yo(p.state.isDestroyed, cs("setProps")), !p.state.isDestroyed) {
      U("onBeforeUpdate", [p, F]), se();
      var oe = p.props, he = tO(t, Object.assign({}, oe, XI(F), {
        ignoreAttributes: !0
      }));
      p.props = he, Se(), oe.interactiveDebounce !== he.interactiveDebounce && (X(), _ = ZI(we, he.interactiveDebounce)), oe.triggerTarget && !he.triggerTarget ? ms(oe.triggerTarget).forEach(function(Re) {
        Re.removeAttribute("aria-expanded");
      }) : he.triggerTarget && t.removeAttribute("aria-expanded"), Z(), B(), T && T(oe, he), p.popperInstance && (Le(), je().forEach(function(Re) {
        requestAnimationFrame(Re._tippy.popperInstance.forceUpdate);
      })), U("onAfterUpdate", [p, F]);
    }
  }
  function on(F) {
    p.setProps({
      content: F
    });
  }
  function Zr() {
    process.env.NODE_ENV !== "production" && yo(p.state.isDestroyed, cs("show"));
    var F = p.state.isVisible, oe = p.state.isDestroyed, he = !p.state.isEnabled, Re = to.isTouch && !p.props.touch, Ce = Sh(p.props.duration, 0, nr.duration);
    if (!(F || oe || he || Re) && !y().hasAttribute("disabled") && (U("onShow", [p], !1), p.props.onShow(p) !== !1)) {
      if (p.state.isVisible = !0, $() && (D.style.visibility = "visible"), B(), j(), p.state.isMounted || (D.style.transition = "none"), $()) {
        var at = w(), Ot = at.box, Xn = at.content;
        wh([Ot, Xn], 0);
      }
      f = function() {
        var Cn;
        if (!(!p.state.isVisible || c)) {
          if (c = !0, D.offsetHeight, D.style.transition = p.props.moveTransition, $() && p.props.animation) {
            var Zi = w(), wo = Zi.box, jn = Zi.content;
            wh([wo, jn], Ce), jI([wo, jn], "visible");
          }
          K(), Z(), qI(bh, p), (Cn = p.popperInstance) == null || Cn.forceUpdate(), U("onMount", [p]), p.props.animation && $() && fe(Ce, function() {
            p.state.isShown = !0, U("onShown", [p]);
          });
        }
      }, Xe();
    }
  }
  function Pr() {
    process.env.NODE_ENV !== "production" && yo(p.state.isDestroyed, cs("hide"));
    var F = !p.state.isVisible, oe = p.state.isDestroyed, he = !p.state.isEnabled, Re = Sh(p.props.duration, 1, nr.duration);
    if (!(F || oe || he) && (U("onHide", [p], !1), p.props.onHide(p) !== !1)) {
      if (p.state.isVisible = !1, p.state.isShown = !1, c = !1, a = !1, $() && (D.style.visibility = "hidden"), X(), ne(), B(!0), $()) {
        var Ce = w(), at = Ce.box, Ot = Ce.content;
        p.props.animation && (wh([at, Ot], Re), jI([at, Ot], "hidden"));
      }
      K(), Z(), p.props.animation ? $() && Ee(Re, p.unmount) : p.unmount();
    }
  }
  function yr(F) {
    process.env.NODE_ENV !== "production" && yo(p.state.isDestroyed, cs("hideWithInteractivity")), L().addEventListener("mousemove", _), qI(qu, _), _(F);
  }
  function ht() {
    process.env.NODE_ENV !== "production" && yo(p.state.isDestroyed, cs("unmount")), p.state.isVisible && p.hide(), p.state.isMounted && (ze(), je().forEach(function(F) {
      F._tippy.unmount();
    }), D.parentNode && D.parentNode.removeChild(D), bh = bh.filter(function(F) {
      return F !== p;
    }), p.state.isMounted = !1, U("onHidden", [p]));
  }
  function Gn() {
    process.env.NODE_ENV !== "production" && yo(p.state.isDestroyed, cs("destroy")), !p.state.isDestroyed && (p.clearDelayTimeouts(), p.unmount(), se(), delete t._tippy, p.state.isDestroyed = !0, U("onDestroy", [p]));
  }
}
function vl(t, e) {
  e === void 0 && (e = {});
  var n = nr.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (gwe(t), G8(e, n)), Ewe();
  var r = Object.assign({}, e, {
    plugins: n
  }), o = uwe(t);
  if (process.env.NODE_ENV !== "production") {
    var i = Yc(r.content), a = o.length > 1;
    yo(i && a, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var s = o.reduce(function(l, c) {
    var u = c && wwe(c, r);
    return u && l.push(u), l;
  }, []);
  return Yc(t) ? s[0] : s;
}
vl.defaultProps = nr;
vl.setDefaultProps = Awe;
vl.currentInput = to;
Object.assign({}, A8, {
  effect: function(e) {
    var n = e.state, r = {
      popper: {
        position: n.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(n.elements.popper.style, r.popper), n.styles = r, n.elements.arrow && Object.assign(n.elements.arrow.style, r.arrow);
  }
});
vl.setDefaultProps({
  render: F8
});
class Twe {
  constructor({ editor: e, element: n, view: r, tippyOptions: o = {}, updateDelay: i = 250, shouldShow: a }) {
    this.preventHide = !1, this.shouldShow = ({ view: s, state: l, from: c, to: u }) => {
      const { doc: d, selection: f } = l, { empty: h } = f, _ = !d.textBetween(c, u).length && g2(l.selection), E = this.element.contains(document.activeElement);
      return !(!(s.hasFocus() || E) || h || _ || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: s }) => {
      var l;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      s != null && s.relatedTarget && (!((l = this.element.parentNode) === null || l === void 0) && l.contains(s.relatedTarget)) || (s == null ? void 0 : s.relatedTarget) !== this.editor.view.dom && this.hide();
    }, this.tippyBlurHandler = (s) => {
      this.blurHandler({ event: s });
    }, this.handleDebouncedUpdate = (s, l) => {
      const c = !(l != null && l.selection.eq(s.state.selection)), u = !(l != null && l.doc.eq(s.state.doc));
      !c && !u || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(s, c, u, l);
      }, this.updateDelay));
    }, this.updateHandler = (s, l, c, u) => {
      var d, f, h;
      const { state: _, composing: E } = s, { selection: m } = _;
      if (E || !l && !c)
        return;
      this.createTooltip();
      const { ranges: I } = m, O = Math.min(...I.map((D) => D.$from.pos)), p = Math.max(...I.map((D) => D.$to.pos));
      if (!((d = this.shouldShow) === null || d === void 0 ? void 0 : d.call(this, {
        editor: this.editor,
        element: this.element,
        view: s,
        state: _,
        oldState: u,
        from: O,
        to: p
      }))) {
        this.hide();
        return;
      }
      (f = this.tippy) === null || f === void 0 || f.setProps({
        getReferenceClientRect: ((h = this.tippyOptions) === null || h === void 0 ? void 0 : h.getReferenceClientRect) || (() => {
          if (v8(_.selection)) {
            let D = s.nodeDOM(O);
            if (D) {
              const T = D.dataset.nodeViewWrapper ? D : D.querySelector("[data-node-view-wrapper]");
              if (T && (D = T.firstChild), D)
                return D.getBoundingClientRect();
            }
          }
          return g8(s, O, p);
        })
      }), this.show();
    }, this.editor = e, this.element = n, this.view = r, this.updateDelay = i, a && (this.shouldShow = a), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = o, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: e } = this.editor.options, n = !!e.parentElement;
    this.element.tabIndex = 0, !(this.tippy || !n) && (this.tippy = vl(e, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "top",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(e, n) {
    const { state: r } = e, o = r.selection.from !== r.selection.to;
    if (this.updateDelay > 0 && o) {
      this.handleDebouncedUpdate(e, n);
      return;
    }
    const i = !(n != null && n.selection.eq(e.state.selection)), a = !(n != null && n.doc.eq(e.state.doc));
    this.updateHandler(e, i, a, n);
  }
  show() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.show();
  }
  hide() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.hide();
  }
  destroy() {
    var e, n;
    !((e = this.tippy) === null || e === void 0) && e.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (n = this.tippy) === null || n === void 0 || n.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const V8 = (t) => new Dn({
  key: typeof t.pluginKey == "string" ? new Mr(t.pluginKey) : t.pluginKey,
  view: (e) => new Twe({ view: e, ...t })
});
En.create({
  name: "bubbleMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "bubbleMenu",
      updateDelay: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      V8({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        updateDelay: this.options.updateDelay,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
class bwe {
  getTextContent(e) {
    return m8(e, { textSerializers: N2(this.editor.schema) });
  }
  constructor({ editor: e, element: n, view: r, tippyOptions: o = {}, shouldShow: i }) {
    this.preventHide = !1, this.shouldShow = ({ view: a, state: s }) => {
      const { selection: l } = s, { $anchor: c, empty: u } = l, d = c.depth === 1, f = c.parent.isTextblock && !c.parent.type.spec.code && !c.parent.textContent && c.parent.childCount === 0 && !this.getTextContent(c.parent);
      return !(!a.hasFocus() || !u || !d || !f || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: a }) => {
      var s;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      a != null && a.relatedTarget && (!((s = this.element.parentNode) === null || s === void 0) && s.contains(a.relatedTarget)) || (a == null ? void 0 : a.relatedTarget) !== this.editor.view.dom && this.hide();
    }, this.tippyBlurHandler = (a) => {
      this.blurHandler({ event: a });
    }, this.editor = e, this.element = n, this.view = r, i && (this.shouldShow = i), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = o, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: e } = this.editor.options, n = !!e.parentElement;
    this.element.tabIndex = 0, !(this.tippy || !n) && (this.tippy = vl(e, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "right",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(e, n) {
    var r, o, i;
    const { state: a } = e, { doc: s, selection: l } = a, { from: c, to: u } = l;
    if (n && n.doc.eq(s) && n.selection.eq(l))
      return;
    if (this.createTooltip(), !((r = this.shouldShow) === null || r === void 0 ? void 0 : r.call(this, {
      editor: this.editor,
      view: e,
      state: a,
      oldState: n
    }))) {
      this.hide();
      return;
    }
    (o = this.tippy) === null || o === void 0 || o.setProps({
      getReferenceClientRect: ((i = this.tippyOptions) === null || i === void 0 ? void 0 : i.getReferenceClientRect) || (() => g8(e, c, u))
    }), this.show();
  }
  show() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.show();
  }
  hide() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.hide();
  }
  destroy() {
    var e, n;
    !((e = this.tippy) === null || e === void 0) && e.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (n = this.tippy) === null || n === void 0 || n.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const H8 = (t) => new Dn({
  key: typeof t.pluginKey == "string" ? new Mr(t.pluginKey) : t.pluginKey,
  view: (e) => new bwe({ view: e, ...t })
});
En.create({
  name: "floatingMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "floatingMenu",
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      H8({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
Ne({
  name: "BubbleMenu",
  props: {
    pluginKey: {
      type: [String, Object],
      default: "bubbleMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    updateDelay: {
      type: Number,
      default: void 0
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(t, { slots: e }) {
    const n = W(null);
    return ct(() => {
      const { updateDelay: r, editor: o, pluginKey: i, shouldShow: a, tippyOptions: s } = t;
      o.registerPlugin(V8({
        updateDelay: r,
        editor: o,
        element: n.value,
        pluginKey: i,
        shouldShow: a,
        tippyOptions: s
      }));
    }), Li(() => {
      const { pluginKey: r, editor: o } = t;
      o.unregisterPlugin(r);
    }), () => {
      var r;
      return Me("div", { ref: n }, (r = e.default) === null || r === void 0 ? void 0 : r.call(e));
    };
  }
});
function oO(t) {
  return CS((e, n) => ({
    get() {
      return e(), t;
    },
    set(r) {
      t = r, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          n();
        });
      });
    }
  }));
}
class Rwe extends K8e {
  constructor(e = {}) {
    return super(e), this.contentComponent = null, this.appContext = null, this.reactiveState = oO(this.view.state), this.reactiveExtensionStorage = oO(this.extensionStorage), this.on("beforeTransaction", ({ nextState: n }) => {
      this.reactiveState.value = n, this.reactiveExtensionStorage.value = this.extensionStorage;
    }), DS(this);
  }
  get state() {
    return this.reactiveState ? this.reactiveState.value : this.view.state;
  }
  get storage() {
    return this.reactiveExtensionStorage ? this.reactiveExtensionStorage.value : super.storage;
  }
  /**
   * Register a ProseMirror plugin.
   */
  registerPlugin(e, n) {
    const r = super.registerPlugin(e, n);
    return this.reactiveState && (this.reactiveState.value = r), r;
  }
  /**
   * Unregister a ProseMirror plugin.
   */
  unregisterPlugin(e) {
    const n = super.unregisterPlugin(e);
    return this.reactiveState && n && (this.reactiveState.value = n), n;
  }
}
const Mwe = Ne({
  name: "EditorContent",
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  setup(t) {
    const e = W(), n = ff();
    return Y_(() => {
      const r = t.editor;
      r && r.options.element && e.value && Ln(() => {
        if (!e.value || !r.options.element.firstChild)
          return;
        const o = M(e.value);
        e.value.append(...r.options.element.childNodes), r.contentComponent = n.ctx._, n && (r.appContext = {
          ...n.appContext,
          // Vue internally uses prototype chain to forward/shadow injects across the entire component chain
          // so don't use object spread operator or 'Object.assign' and just set `provides` as is on editor's appContext
          // @ts-expect-error forward instance's 'provides' into appContext
          provides: n.provides
        }), r.setOptions({
          element: o
        }), r.createNodeViews();
      });
    }), Li(() => {
      const r = t.editor;
      r && (r.contentComponent = null, r.appContext = null);
    }), { rootEl: e };
  },
  render() {
    return Me("div", {
      ref: (t) => {
        this.rootEl = t;
      }
    });
  }
}), Pwe = Ne({
  name: "FloatingMenu",
  props: {
    pluginKey: {
      // TODO: TypeScript breaks :(
      // type: [String, Object as PropType<Exclude<FloatingMenuPluginProps['pluginKey'], string>>],
      type: null,
      default: "floatingMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(t, { slots: e }) {
    const n = W(null);
    return ct(() => {
      const { pluginKey: r, editor: o, tippyOptions: i, shouldShow: a } = t;
      o.registerPlugin(H8({
        pluginKey: r,
        editor: o,
        element: n.value,
        tippyOptions: i,
        shouldShow: a
      }));
    }), Li(() => {
      const { pluginKey: r, editor: o } = t;
      o.unregisterPlugin(r);
    }), () => {
      var r;
      return Me("div", { ref: n }, (r = e.default) === null || r === void 0 ? void 0 : r.call(e));
    };
  }
});
Ne({
  name: "NodeViewContent",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  render() {
    return Me(this.as, {
      style: {
        whiteSpace: "pre-wrap"
      },
      "data-node-view-content": ""
    });
  }
});
Ne({
  name: "NodeViewWrapper",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  inject: ["onDragStart", "decorationClasses"],
  render() {
    var t, e;
    return Me(this.as, {
      // @ts-ignore
      class: this.decorationClasses,
      style: {
        whiteSpace: "normal"
      },
      "data-node-view-wrapper": "",
      // @ts-ignore (https://github.com/vuejs/vue-next/issues/3031)
      onDragstart: this.onDragStart
    }, (e = (t = this.$slots).default) === null || e === void 0 ? void 0 : e.call(t));
  }
});
const ywe = (t = {}) => {
  const e = AS();
  return ct(() => {
    e.value = new Rwe(t);
  }), Li(() => {
    var n, r, o;
    const i = (n = e.value) === null || n === void 0 ? void 0 : n.options.element, a = i == null ? void 0 : i.cloneNode(!0);
    (r = i == null ? void 0 : i.parentNode) === null || r === void 0 || r.replaceChild(a, i), (o = e.value) === null || o === void 0 || o.destroy();
  }), e;
}, Lwe = /^\s*>\s$/, xwe = zr.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["blockquote", kn(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: t }) => t.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: t }) => t.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: t }) => t.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      Vc({
        find: Lwe,
        type: this.type
      })
    ];
  }
}), Uwe = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, $we = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, kwe = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, Bwe = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, W8 = yi.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (t) => t.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (t) => t.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (t) => /^(bold(er)?|[5-9]\d{2,})$/.test(t) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["strong", kn(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: t }) => t.setMark(this.name),
      toggleBold: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetBold: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      $a({
        find: Uwe,
        type: this.type
      }),
      $a({
        find: kwe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ka({
        find: $we,
        type: this.type
      }),
      ka({
        find: Bwe,
        type: this.type
      })
    ];
  }
}), Gwe = "listItem", iO = "textStyle", aO = /^\s*([-+*])\s$/, Fwe = zr.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["ul", kn(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(Gwe, this.editor.getAttributes(iO)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let t = Vc({
      find: aO,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = Vc({
      find: aO,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(iO),
      editor: this.editor
    })), [
      t
    ];
  }
}), Vwe = /(^|[^`])`([^`]+)`(?!`)/, Hwe = /(^|[^`])`([^`]+)`(?!`)/g, Wwe = yi.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["code", kn(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: t }) => t.setMark(this.name),
      toggleCode: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetCode: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      $a({
        find: Vwe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ka({
        find: Hwe,
        type: this.type
      })
    ];
  }
}), Ywe = /^```([a-z]+)?[\s\n]$/, Kwe = /^~~~([a-z]+)?[\s\n]$/, zwe = zr.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (t) => {
          var e;
          const { languageClassPrefix: n } = this.options, i = [...((e = t.firstElementChild) === null || e === void 0 ? void 0 : e.classList) || []].filter((a) => a.startsWith(n)).map((a) => a.replace(n, ""))[0];
          return i || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [
      "pre",
      kn(this.options.HTMLAttributes, e),
      [
        "code",
        {
          class: t.attrs.language ? this.options.languageClassPrefix + t.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (t) => ({ commands: e }) => e.setNode(this.name, t),
      toggleCodeBlock: (t) => ({ commands: e }) => e.toggleNode(this.name, "paragraph", t)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: t, $anchor: e } = this.editor.state.selection, n = e.pos === 1;
        return !t || e.parent.type.name !== this.name ? !1 : n || !e.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: t }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: e } = t, { selection: n } = e, { $from: r, empty: o } = n;
        if (!o || r.parent.type !== this.type)
          return !1;
        const i = r.parentOffset === r.parent.nodeSize - 2, a = r.parent.textContent.endsWith(`

`);
        return !i || !a ? !1 : t.chain().command(({ tr: s }) => (s.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: t }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: e } = t, { selection: n, doc: r } = e, { $from: o, empty: i } = n;
        if (!i || o.parent.type !== this.type || !(o.parentOffset === o.parent.nodeSize - 2))
          return !1;
        const s = o.after();
        return s === void 0 ? !1 : r.nodeAt(s) ? t.commands.command(({ tr: c }) => (c.setSelection(qe.near(r.resolve(s))), !0)) : t.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      r_({
        find: Ywe,
        type: this.type,
        getAttributes: (t) => ({
          language: t[1]
        })
      }),
      r_({
        find: Kwe,
        type: this.type,
        getAttributes: (t) => ({
          language: t[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new Dn({
        key: new Mr("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (t, e) => {
            if (!e.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const n = e.clipboardData.getData("text/plain"), r = e.clipboardData.getData("vscode-editor-data"), o = r ? JSON.parse(r) : void 0, i = o == null ? void 0 : o.mode;
            if (!n || !i)
              return !1;
            const { tr: a, schema: s } = t.state, l = s.text(n.replace(/\r\n?/g, `
`));
            return a.replaceSelectionWith(this.type.create({ language: i }, l)), a.selection.$from.parent.type !== this.type && a.setSelection(Ke.near(a.doc.resolve(Math.max(0, a.selection.from - 2)))), a.setMeta("paste", !0), t.dispatch(a), !0;
          }
        }
      })
    ];
  }
}), Zwe = zr.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function qwe(t = {}) {
  return new Dn({
    view(e) {
      return new Xwe(e, t);
    }
  });
}
class Xwe {
  constructor(e, n) {
    var r;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = n.width) !== null && r !== void 0 ? r : 1, this.color = n.color === !1 ? void 0 : n.color || "black", this.class = n.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((o) => {
      let i = (a) => {
        this[o](a);
      };
      return e.dom.addEventListener(o, i), { name: o, handler: i };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: n }) => this.editorView.dom.removeEventListener(e, n));
  }
  update(e, n) {
    this.cursorPos != null && n.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), n = !e.parent.inlineContent, r, o = this.editorView.dom, i = o.getBoundingClientRect(), a = i.width / o.offsetWidth, s = i.height / o.offsetHeight;
    if (n) {
      let d = e.nodeBefore, f = e.nodeAfter;
      if (d || f) {
        let h = this.editorView.nodeDOM(this.cursorPos - (d ? d.nodeSize : 0));
        if (h) {
          let _ = h.getBoundingClientRect(), E = d ? _.bottom : _.top;
          d && f && (E = (E + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
          let m = this.width / 2 * s;
          r = { left: _.left, right: _.right, top: E - m, bottom: E + m };
        }
      }
    }
    if (!r) {
      let d = this.editorView.coordsAtPos(this.cursorPos), f = this.width / 2 * a;
      r = { left: d.left - f, right: d.left + f, top: d.top, bottom: d.bottom };
    }
    let l = this.editorView.dom.offsetParent;
    this.element || (this.element = l.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", n), this.element.classList.toggle("prosemirror-dropcursor-inline", !n);
    let c, u;
    if (!l || l == document.body && getComputedStyle(l).position == "static")
      c = -pageXOffset, u = -pageYOffset;
    else {
      let d = l.getBoundingClientRect(), f = d.width / l.offsetWidth, h = d.height / l.offsetHeight;
      c = d.left - l.scrollLeft * f, u = d.top - l.scrollTop * h;
    }
    this.element.style.left = (r.left - c) / a + "px", this.element.style.top = (r.top - u) / s + "px", this.element.style.width = (r.right - r.left) / a + "px", this.element.style.height = (r.bottom - r.top) / s + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let n = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), r = n && n.inside >= 0 && this.editorView.state.doc.nodeAt(n.inside), o = r && r.type.spec.disableDropCursor, i = typeof o == "function" ? o(this.editorView, n, e) : o;
    if (n && !i) {
      let a = n.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let s = _C(this.editorView.state.doc, a, this.editorView.dragging.slice);
        s != null && (a = s);
      }
      this.setCursor(a), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    this.editorView.dom.contains(e.relatedTarget) || this.setCursor(null);
  }
}
const jwe = En.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      qwe(this.options)
    ];
  }
});
class Ut extends qe {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, n) {
    let r = e.resolve(n.map(this.head));
    return Ut.valid(r) ? new Ut(r) : qe.near(r);
  }
  content() {
    return Ae.empty;
  }
  eq(e) {
    return e instanceof Ut && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new Ut(e.resolve(n.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new M2(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let n = e.parent;
    if (n.inlineContent || !Jwe(e) || !Qwe(e))
      return !1;
    let r = n.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let o = n.contentMatchAt(e.index()).defaultType;
    return o && o.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, n, r = !1) {
    e:
      for (; ; ) {
        if (!r && Ut.valid(e))
          return e;
        let o = e.pos, i = null;
        for (let a = e.depth; ; a--) {
          let s = e.node(a);
          if (n > 0 ? e.indexAfter(a) < s.childCount : e.index(a) > 0) {
            i = s.child(n > 0 ? e.indexAfter(a) : e.index(a) - 1);
            break;
          } else if (a == 0)
            return null;
          o += n;
          let l = e.doc.resolve(o);
          if (Ut.valid(l))
            return l;
        }
        for (; ; ) {
          let a = n > 0 ? i.firstChild : i.lastChild;
          if (!a) {
            if (i.isAtom && !i.isText && !ke.isSelectable(i)) {
              e = e.doc.resolve(o + i.nodeSize * n), r = !1;
              continue e;
            }
            break;
          }
          i = a, o += n;
          let s = e.doc.resolve(o);
          if (Ut.valid(s))
            return s;
        }
        return null;
      }
  }
}
Ut.prototype.visible = !1;
Ut.findFrom = Ut.findGapCursorFrom;
qe.jsonID("gapcursor", Ut);
class M2 {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new M2(e.map(this.pos));
  }
  resolve(e) {
    let n = e.resolve(this.pos);
    return Ut.valid(n) ? new Ut(n) : qe.near(n);
  }
}
function Y8(t) {
  return t.isAtom || t.spec.isolating || t.spec.createGapCursor;
}
function Jwe(t) {
  for (let e = t.depth; e >= 0; e--) {
    let n = t.index(e), r = t.node(e);
    if (n == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let o = r.child(n - 1); ; o = o.lastChild) {
      if (o.childCount == 0 && !o.inlineContent || Y8(o.type))
        return !0;
      if (o.inlineContent)
        return !1;
    }
  }
  return !0;
}
function Qwe(t) {
  for (let e = t.depth; e >= 0; e--) {
    let n = t.indexAfter(e), r = t.node(e);
    if (n == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let o = r.child(n); ; o = o.firstChild) {
      if (o.childCount == 0 && !o.inlineContent || Y8(o.type))
        return !0;
      if (o.inlineContent)
        return !1;
    }
  }
  return !0;
}
function eTe() {
  return new Dn({
    props: {
      decorations: oTe,
      createSelectionBetween(t, e, n) {
        return e.pos == n.pos && Ut.valid(n) ? new Ut(n) : null;
      },
      handleClick: nTe,
      handleKeyDown: tTe,
      handleDOMEvents: { beforeinput: rTe }
    }
  });
}
const tTe = n8({
  ArrowLeft: Xu("horiz", -1),
  ArrowRight: Xu("horiz", 1),
  ArrowUp: Xu("vert", -1),
  ArrowDown: Xu("vert", 1)
});
function Xu(t, e) {
  const n = t == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(r, o, i) {
    let a = r.selection, s = e > 0 ? a.$to : a.$from, l = a.empty;
    if (a instanceof Ke) {
      if (!i.endOfTextblock(n) || s.depth == 0)
        return !1;
      l = !1, s = r.doc.resolve(e > 0 ? s.after() : s.before());
    }
    let c = Ut.findGapCursorFrom(s, e, l);
    return c ? (o && o(r.tr.setSelection(new Ut(c))), !0) : !1;
  };
}
function nTe(t, e, n) {
  if (!t || !t.editable)
    return !1;
  let r = t.state.doc.resolve(e);
  if (!Ut.valid(r))
    return !1;
  let o = t.posAtCoords({ left: n.clientX, top: n.clientY });
  return o && o.inside > -1 && ke.isSelectable(t.state.doc.nodeAt(o.inside)) ? !1 : (t.dispatch(t.state.tr.setSelection(new Ut(r))), !0);
}
function rTe(t, e) {
  if (e.inputType != "insertCompositionText" || !(t.state.selection instanceof Ut))
    return !1;
  let { $from: n } = t.state.selection, r = n.parent.contentMatchAt(n.index()).findWrapping(t.state.schema.nodes.text);
  if (!r)
    return !1;
  let o = _e.empty;
  for (let a = r.length - 1; a >= 0; a--)
    o = _e.from(r[a].createAndFill(null, o));
  let i = t.state.tr.replace(n.pos, n.pos, new Ae(o, 0, 0));
  return i.setSelection(Ke.near(i.doc.resolve(n.pos + 1))), t.dispatch(i), !1;
}
function oTe(t) {
  if (!(t.selection instanceof Ut))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", jt.create(t.doc, [fr.widget(t.selection.head, e, { key: "gapcursor" })]);
}
const iTe = En.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      eTe()
    ];
  },
  extendNodeSchema(t) {
    var e;
    const n = {
      name: t.name,
      options: t.options,
      storage: t.storage
    };
    return {
      allowGapCursor: (e = Qe(Te(t, "allowGapCursor", n))) !== null && e !== void 0 ? e : null
    };
  }
}), aTe = zr.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["br", kn(this.options.HTMLAttributes, t)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: t, chain: e, state: n, editor: r }) => t.first([
        () => t.exitCode(),
        () => t.command(() => {
          const { selection: o, storedMarks: i } = n;
          if (o.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: a } = this.options, { splittableMarks: s } = r.extensionManager, l = i || o.$to.parentOffset && o.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: c, dispatch: u }) => {
            if (u && l && a) {
              const d = l.filter((f) => s.includes(f.type.name));
              c.ensureMarks(d);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), sTe = zr.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((t) => ({
      tag: `h${t}`,
      attrs: { level: t }
    }));
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(t.attrs.level) ? t.attrs.level : this.options.levels[0]}`, kn(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setHeading: (t) => ({ commands: e }) => this.options.levels.includes(t.level) ? e.setNode(this.name, t) : !1,
      toggleHeading: (t) => ({ commands: e }) => this.options.levels.includes(t.level) ? e.toggleNode(this.name, "paragraph", t) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((t, e) => ({
      ...t,
      [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((t) => r_({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${t}})\\s$`),
      type: this.type,
      getAttributes: {
        level: t
      }
    }));
  }
});
var uf = 200, nn = function() {
};
nn.prototype.append = function(e) {
  return e.length ? (e = nn.from(e), !this.length && e || e.length < uf && this.leafAppend(e) || this.length < uf && e.leafPrepend(this) || this.appendInner(e)) : this;
};
nn.prototype.prepend = function(e) {
  return e.length ? nn.from(e).append(this) : this;
};
nn.prototype.appendInner = function(e) {
  return new lTe(this, e);
};
nn.prototype.slice = function(e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = this.length), e >= n ? nn.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, n));
};
nn.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
nn.prototype.forEach = function(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length), n <= r ? this.forEachInner(e, n, r, 0) : this.forEachInvertedInner(e, n, r, 0);
};
nn.prototype.map = function(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length);
  var o = [];
  return this.forEach(function(i, a) {
    return o.push(e(i, a));
  }, n, r), o;
};
nn.from = function(e) {
  return e instanceof nn ? e : e && e.length ? new K8(e) : nn.empty;
};
var K8 = /* @__PURE__ */ function(t) {
  function e(r) {
    t.call(this), this.values = r;
  }
  t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
  var n = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(o, i) {
    return o == 0 && i == this.length ? this : new e(this.values.slice(o, i));
  }, e.prototype.getInner = function(o) {
    return this.values[o];
  }, e.prototype.forEachInner = function(o, i, a, s) {
    for (var l = i; l < a; l++)
      if (o(this.values[l], s + l) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(o, i, a, s) {
    for (var l = i - 1; l >= a; l--)
      if (o(this.values[l], s + l) === !1)
        return !1;
  }, e.prototype.leafAppend = function(o) {
    if (this.length + o.length <= uf)
      return new e(this.values.concat(o.flatten()));
  }, e.prototype.leafPrepend = function(o) {
    if (this.length + o.length <= uf)
      return new e(o.flatten().concat(this.values));
  }, n.length.get = function() {
    return this.values.length;
  }, n.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, n), e;
}(nn);
nn.empty = new K8([]);
var lTe = /* @__PURE__ */ function(t) {
  function e(n, r) {
    t.call(this), this.left = n, this.right = r, this.length = n.length + r.length, this.depth = Math.max(n.depth, r.depth) + 1;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, e.prototype.forEachInner = function(r, o, i, a) {
    var s = this.left.length;
    if (o < s && this.left.forEachInner(r, o, Math.min(i, s), a) === !1 || i > s && this.right.forEachInner(r, Math.max(o - s, 0), Math.min(this.length, i) - s, a + s) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(r, o, i, a) {
    var s = this.left.length;
    if (o > s && this.right.forEachInvertedInner(r, o - s, Math.max(i, s) - s, a + s) === !1 || i < s && this.left.forEachInvertedInner(r, Math.min(o, s), i, a) === !1)
      return !1;
  }, e.prototype.sliceInner = function(r, o) {
    if (r == 0 && o == this.length)
      return this;
    var i = this.left.length;
    return o <= i ? this.left.slice(r, o) : r >= i ? this.right.slice(r - i, o - i) : this.left.slice(r, i).append(this.right.slice(0, o - i));
  }, e.prototype.leafAppend = function(r) {
    var o = this.right.leafAppend(r);
    if (o)
      return new e(this.left, o);
  }, e.prototype.leafPrepend = function(r) {
    var o = this.left.leafPrepend(r);
    if (o)
      return new e(o, this.right);
  }, e.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new e(this.left, new e(this.right, r)) : new e(this, r);
  }, e;
}(nn);
const cTe = 500;
class Ur {
  constructor(e, n) {
    this.items = e, this.eventCount = n;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, n) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let o, i;
    n && (o = this.remapping(r, this.items.length), i = o.maps.length);
    let a = e.tr, s, l, c = [], u = [];
    return this.items.forEach((d, f) => {
      if (!d.step) {
        o || (o = this.remapping(r, f + 1), i = o.maps.length), i--, u.push(d);
        return;
      }
      if (o) {
        u.push(new Jr(d.map));
        let h = d.step.map(o.slice(i)), _;
        h && a.maybeStep(h).doc && (_ = a.mapping.maps[a.mapping.maps.length - 1], c.push(new Jr(_, void 0, void 0, c.length + u.length))), i--, _ && o.appendMap(_, i);
      } else
        a.maybeStep(d.step);
      if (d.selection)
        return s = o ? d.selection.map(o.slice(i)) : d.selection, l = new Ur(this.items.slice(0, r).append(u.reverse().concat(c)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: a, selection: s };
  }
  // Create a new branch with the given transform added.
  addTransform(e, n, r, o) {
    let i = [], a = this.eventCount, s = this.items, l = !o && s.length ? s.get(s.length - 1) : null;
    for (let u = 0; u < e.steps.length; u++) {
      let d = e.steps[u].invert(e.docs[u]), f = new Jr(e.mapping.maps[u], d, n), h;
      (h = l && l.merge(f)) && (f = h, u ? i.pop() : s = s.slice(0, s.length - 1)), i.push(f), n && (a++, n = void 0), o || (l = f);
    }
    let c = a - r.depth;
    return c > dTe && (s = uTe(s, c), a -= c), new Ur(s.append(i), a);
  }
  remapping(e, n) {
    let r = new xc();
    return this.items.forEach((o, i) => {
      let a = o.mirrorOffset != null && i - o.mirrorOffset >= e ? r.maps.length - o.mirrorOffset : void 0;
      r.appendMap(o.map, a);
    }, e, n), r;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new Ur(this.items.append(e.map((n) => new Jr(n))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, n) {
    if (!this.eventCount)
      return this;
    let r = [], o = Math.max(0, this.items.length - n), i = e.mapping, a = e.steps.length, s = this.eventCount;
    this.items.forEach((f) => {
      f.selection && s--;
    }, o);
    let l = n;
    this.items.forEach((f) => {
      let h = i.getMirror(--l);
      if (h == null)
        return;
      a = Math.min(a, h);
      let _ = i.maps[h];
      if (f.step) {
        let E = e.steps[h].invert(e.docs[h]), m = f.selection && f.selection.map(i.slice(l + 1, h));
        m && s++, r.push(new Jr(_, E, m));
      } else
        r.push(new Jr(_));
    }, o);
    let c = [];
    for (let f = n; f < a; f++)
      c.push(new Jr(i.maps[f]));
    let u = this.items.slice(0, o).append(c).append(r), d = new Ur(u, s);
    return d.emptyItemCount() > cTe && (d = d.compress(this.items.length - r.length)), d;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((n) => {
      n.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let n = this.remapping(0, e), r = n.maps.length, o = [], i = 0;
    return this.items.forEach((a, s) => {
      if (s >= e)
        o.push(a), a.selection && i++;
      else if (a.step) {
        let l = a.step.map(n.slice(r)), c = l && l.getMap();
        if (r--, c && n.appendMap(c, r), l) {
          let u = a.selection && a.selection.map(n.slice(r));
          u && i++;
          let d = new Jr(c.invert(), l, u), f, h = o.length - 1;
          (f = o.length && o[h].merge(d)) ? o[h] = f : o.push(d);
        }
      } else
        a.map && r--;
    }, this.items.length, 0), new Ur(nn.from(o.reverse()), i);
  }
}
Ur.empty = new Ur(nn.empty, 0);
function uTe(t, e) {
  let n;
  return t.forEach((r, o) => {
    if (r.selection && e-- == 0)
      return n = o, !1;
  }), t.slice(n);
}
class Jr {
  constructor(e, n, r, o) {
    this.map = e, this.step = n, this.selection = r, this.mirrorOffset = o;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let n = e.step.merge(this.step);
      if (n)
        return new Jr(n.getMap().invert(), n, this.selection);
    }
  }
}
class ci {
  constructor(e, n, r, o, i) {
    this.done = e, this.undone = n, this.prevRanges = r, this.prevTime = o, this.prevComposition = i;
  }
}
const dTe = 20;
function fTe(t, e, n, r) {
  let o = n.getMeta(Ia), i;
  if (o)
    return o.historyState;
  n.getMeta(ETe) && (t = new ci(t.done, t.undone, null, 0, -1));
  let a = n.getMeta("appendedTransaction");
  if (n.steps.length == 0)
    return t;
  if (a && a.getMeta(Ia))
    return a.getMeta(Ia).redo ? new ci(t.done.addTransform(n, void 0, r, fd(e)), t.undone, sO(n.mapping.maps), t.prevTime, t.prevComposition) : new ci(t.done, t.undone.addTransform(n, void 0, r, fd(e)), null, t.prevTime, t.prevComposition);
  if (n.getMeta("addToHistory") !== !1 && !(a && a.getMeta("addToHistory") === !1)) {
    let s = n.getMeta("composition"), l = t.prevTime == 0 || !a && t.prevComposition != s && (t.prevTime < (n.time || 0) - r.newGroupDelay || !hTe(n, t.prevRanges)), c = a ? Rh(t.prevRanges, n.mapping) : sO(n.mapping.maps);
    return new ci(t.done.addTransform(n, l ? e.selection.getBookmark() : void 0, r, fd(e)), Ur.empty, c, n.time, s ?? t.prevComposition);
  } else
    return (i = n.getMeta("rebased")) ? new ci(t.done.rebased(n, i), t.undone.rebased(n, i), Rh(t.prevRanges, n.mapping), t.prevTime, t.prevComposition) : new ci(t.done.addMaps(n.mapping.maps), t.undone.addMaps(n.mapping.maps), Rh(t.prevRanges, n.mapping), t.prevTime, t.prevComposition);
}
function hTe(t, e) {
  if (!e)
    return !1;
  if (!t.docChanged)
    return !0;
  let n = !1;
  return t.mapping.maps[0].forEach((r, o) => {
    for (let i = 0; i < e.length; i += 2)
      r <= e[i + 1] && o >= e[i] && (n = !0);
  }), n;
}
function sO(t) {
  let e = [];
  for (let n = t.length - 1; n >= 0 && e.length == 0; n--)
    t[n].forEach((r, o, i, a) => e.push(i, a));
  return e;
}
function Rh(t, e) {
  if (!t)
    return null;
  let n = [];
  for (let r = 0; r < t.length; r += 2) {
    let o = e.map(t[r], 1), i = e.map(t[r + 1], -1);
    o <= i && n.push(o, i);
  }
  return n;
}
function _Te(t, e, n) {
  let r = fd(e), o = Ia.get(e).spec.config, i = (n ? t.undone : t.done).popEvent(e, r);
  if (!i)
    return null;
  let a = i.selection.resolve(i.transform.doc), s = (n ? t.done : t.undone).addTransform(i.transform, e.selection.getBookmark(), o, r), l = new ci(n ? s : i.remaining, n ? i.remaining : s, null, 0, -1);
  return i.transform.setSelection(a).setMeta(Ia, { redo: n, historyState: l });
}
let Mh = !1, lO = null;
function fd(t) {
  let e = t.plugins;
  if (lO != e) {
    Mh = !1, lO = e;
    for (let n = 0; n < e.length; n++)
      if (e[n].spec.historyPreserveItems) {
        Mh = !0;
        break;
      }
  }
  return Mh;
}
const Ia = new Mr("history"), ETe = new Mr("closeHistory");
function pTe(t = {}) {
  return t = {
    depth: t.depth || 100,
    newGroupDelay: t.newGroupDelay || 500
  }, new Dn({
    key: Ia,
    state: {
      init() {
        return new ci(Ur.empty, Ur.empty, null, 0, -1);
      },
      apply(e, n, r) {
        return fTe(n, r, e, t);
      }
    },
    config: t,
    props: {
      handleDOMEvents: {
        beforeinput(e, n) {
          let r = n.inputType, o = r == "historyUndo" ? Z8 : r == "historyRedo" ? q8 : null;
          return !o || !e.editable ? !1 : (n.preventDefault(), o(e.state, e.dispatch));
        }
      }
    }
  });
}
function z8(t, e) {
  return (n, r) => {
    let o = Ia.getState(n);
    if (!o || (t ? o.undone : o.done).eventCount == 0)
      return !1;
    if (r) {
      let i = _Te(o, n, t);
      i && r(e ? i.scrollIntoView() : i);
    }
    return !0;
  };
}
const Z8 = z8(!1, !0), q8 = z8(!0, !0), mTe = En.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: t, dispatch: e }) => Z8(t, e),
      redo: () => ({ state: t, dispatch: e }) => q8(t, e)
    };
  },
  addProseMirrorPlugins() {
    return [
      pTe(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), NTe = zr.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["hr", kn(this.options.HTMLAttributes, t)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: t, state: e }) => {
        if (!Z8e(e, e.schema.nodes[this.name]))
          return !1;
        const { selection: n } = e, { $from: r, $to: o } = n, i = t();
        return r.parentOffset === 0 ? i.insertContentAt({
          from: Math.max(r.pos - 1, 0),
          to: o.pos
        }, {
          type: this.name
        }) : v8(n) ? i.insertContentAt(o.pos, {
          type: this.name
        }) : i.insertContent({ type: this.name }), i.command(({ tr: a, dispatch: s }) => {
          var l;
          if (s) {
            const { $to: c } = a.selection, u = c.end();
            if (c.nodeAfter)
              c.nodeAfter.isTextblock ? a.setSelection(Ke.create(a.doc, c.pos + 1)) : c.nodeAfter.isBlock ? a.setSelection(ke.create(a.doc, c.pos)) : a.setSelection(Ke.create(a.doc, c.pos));
            else {
              const d = (l = c.parent.type.contentMatch.defaultType) === null || l === void 0 ? void 0 : l.create();
              d && (a.insert(u, d), a.setSelection(Ke.create(a.doc, u + 1)));
            }
            a.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      z8e({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), vTe = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, gTe = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, ITe = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, OTe = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, ATe = yi.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (t) => t.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (t) => t.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["em", kn(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: t }) => t.setMark(this.name),
      toggleItalic: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetItalic: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      $a({
        find: vTe,
        type: this.type
      }),
      $a({
        find: ITe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ka({
        find: gTe,
        type: this.type
      }),
      ka({
        find: OTe,
        type: this.type
      })
    ];
  }
}), DTe = zr.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["li", kn(this.options.HTMLAttributes, t), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), CTe = "listItem", cO = "textStyle", uO = /^(\d+)\.\s$/, STe = zr.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (t) => t.hasAttribute("start") ? parseInt(t.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (t) => t.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    const { start: e, ...n } = t;
    return e === 1 ? ["ol", kn(this.options.HTMLAttributes, n), 0] : ["ol", kn(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(CTe, this.editor.getAttributes(cO)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let t = Vc({
      find: uO,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, n) => n.childCount + n.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = Vc({
      find: uO,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(cO) }),
      joinPredicate: (e, n) => n.childCount + n.attrs.start === +e[1],
      editor: this.editor
    })), [
      t
    ];
  }
}), wTe = zr.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["p", kn(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: t }) => t.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), TTe = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, bTe = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, RTe = yi.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (t) => t.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["s", kn(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: t }) => t.setMark(this.name),
      toggleStrike: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetStrike: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      $a({
        find: TTe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ka({
        find: bTe,
        type: this.type
      })
    ];
  }
}), MTe = zr.create({
  name: "text",
  group: "inline"
}), PTe = En.create({
  name: "starterKit",
  addExtensions() {
    const t = [];
    return this.options.bold !== !1 && t.push(W8.configure(this.options.bold)), this.options.blockquote !== !1 && t.push(xwe.configure(this.options.blockquote)), this.options.bulletList !== !1 && t.push(Fwe.configure(this.options.bulletList)), this.options.code !== !1 && t.push(Wwe.configure(this.options.code)), this.options.codeBlock !== !1 && t.push(zwe.configure(this.options.codeBlock)), this.options.document !== !1 && t.push(Zwe.configure(this.options.document)), this.options.dropcursor !== !1 && t.push(jwe.configure(this.options.dropcursor)), this.options.gapcursor !== !1 && t.push(iTe.configure(this.options.gapcursor)), this.options.hardBreak !== !1 && t.push(aTe.configure(this.options.hardBreak)), this.options.heading !== !1 && t.push(sTe.configure(this.options.heading)), this.options.history !== !1 && t.push(mTe.configure(this.options.history)), this.options.horizontalRule !== !1 && t.push(NTe.configure(this.options.horizontalRule)), this.options.italic !== !1 && t.push(ATe.configure(this.options.italic)), this.options.listItem !== !1 && t.push(DTe.configure(this.options.listItem)), this.options.orderedList !== !1 && t.push(STe.configure(this.options.orderedList)), this.options.paragraph !== !1 && t.push(wTe.configure(this.options.paragraph)), this.options.strike !== !1 && t.push(RTe.configure(this.options.strike)), this.options.text !== !1 && t.push(MTe.configure(this.options.text)), t;
  }
}), yTe = /* @__PURE__ */ Ne({
  __name: "SlideTextEditorButton",
  props: {
    active: { type: Boolean }
  },
  setup(t) {
    return (e, n) => (v(), A("button", {
      class: z(["text-editor-button", { "is-active": t.active }])
    }, [
      ue(e.$slots, "default", {}, void 0, !0)
    ], 2));
  }
});
const LTe = /* @__PURE__ */ Y(yTe, [["__scopeId", "data-v-265831a0"]]), P2 = {
  name: "SlideTextEditor",
  components: { EditorContent: Mwe, FloatingMenu: Pwe, Tooltip: LE, EditorButton: LTe, Text: Ye },
  props: {
    id: {
      type: [String, Number],
      required: !0
    },
    content: {
      type: String,
      required: !1,
      default: 'This component is better with some <b>"content"</b> passed in.'
    },
    defaultText: {
      type: String,
      required: !0
    },
    layoutType: {
      type: String,
      required: !0
    },
    theme: {
      type: Object,
      required: !1
    },
    readOnly: {
      type: Boolean,
      required: !1,
      default: !1
    },
    discardEdits: {
      type: Boolean,
      required: !1
    },
    previewMode: {
      type: Boolean,
      required: !1
    },
    maxWidth: {
      type: Number,
      default: 464,
      required: !1
    }
  },
  emits: ["content-updated", "content-reset"],
  setup(t, { emit: e }) {
    const n = W8.extend({
      name: "bold",
      parseHTML() {
        return [
          {
            tag: "strong"
          },
          {
            tag: "b",
            getAttrs: (U) => U.style.fontWeight !== "normal" && null
          },
          {
            style: "font-weight",
            getAttrs: (U) => /^(bold(er)?|[5-9]\d{2,})$/.test(U) && null
          },
          {
            tag: 'span[class="copy-var"]'
          }
        ];
      },
      renderHTML() {
        return ["span", { class: "copy-var" }, 0];
      },
      addKeyboardShortcuts() {
        return {
          "Mod-b": () => this.editor.commands.toggleMark("bold")
        };
      },
      commands() {
        return [this.editor.commands.toggleMark("bold")];
      },
      inputRules() {
        return [$a(/(?:\*\*|__)([^*_]+)(?:\*\*|__)$/)];
      },
      pasteRules() {
        return [ka(/(?:\*\*|__)([^*_]+)(?:\*\*|__)/g)];
      }
    });
    function r() {
      t.readOnly || t.previewMode || (I.value && (I.value = ""), _.value = D(O.value.scrollHeight), T());
    }
    function o() {
      t.readOnly || t.previewMode || (s.value = !0, _.value = D(O.value.scrollHeight));
    }
    function i() {
      t.readOnly || t.previewMode || Ln(() => {
        var U;
        c.value && u(!1), s.value = !1, f.value.$el.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        }), h.value = (((U = a.value) == null ? void 0 : U.state.doc.content.size) ?? 0) - 2;
      });
    }
    const a = ywe({
      content: t.content,
      extensions: [PTe, n],
      onFocus: o,
      onUpdate: r,
      onBlur: i,
      editable: !t.readOnly && !t.previewMode
    }), s = W(!1), l = W(!1), c = W(!1), u = (U) => {
      c.value = U;
    }, d = (U) => {
      U.stopPropagation(), c.value = !c.value;
    }, f = W(), h = W(), _ = W(), E = W(), m = W(), N = W("remaining"), I = W(""), O = W(), p = x(() => {
      var U;
      return `theme-${(U = t.theme) == null ? void 0 : U.typeface}-body editor__content`;
    }), C = x(() => `${t.maxWidth}px`);
    function D(U) {
      let Z = 0, X = 0;
      do
        X = 21 * Z, Z = Z + 1;
      while (X < U);
      return Z - 1;
    }
    function T() {
      var K;
      const U = (K = a.value) == null ? void 0 : K.getHTML().replace("<p>", "").replace("</p>", "");
      !U || U === m.value || (e("content-updated", U), m.value = U);
    }
    function k() {
      var U, K;
      I.value ? (U = a.value) == null || U.commands.setContent(I.value) : (K = a.value) == null || K.commands.undo();
    }
    const G = x(() => 1), b = x(() => G.value === t.id), P = x(
      () => t.layoutType === "two-columns" ? 14 : t.layoutType === "two-rows" ? 10 : 12
    ), $ = x(() => {
      const U = _.value ?? 0;
      return P.value < U ? (N.value = "hidden", U - P.value) : (N.value = "remaining", P.value - U);
    }), y = x(() => h.value === 0 && !b.value || t.content.length === 0), L = x(() => t.discardEdits);
    function w() {
      var Z, X;
      const U = ((Z = a.value) == null ? void 0 : Z.getHTML()) ?? "";
      R(U) ? (e("content-reset"), Ln(() => {
        var J, ae, re, j;
        I.value = ((J = a.value) == null ? void 0 : J.getHTML()) ?? "", O.value = (ae = a.value) == null ? void 0 : ae.view.dom, (re = a.value) == null || re.commands.setContent(t.defaultText), (j = a.value) == null || j.commands.focus("end"), _.value = D(O.value.offsetHeight);
      })) : (X = a.value) == null || X.commands.focus("end");
    }
    function R(U) {
      return t.defaultText !== U.replace("<p>", "").replace("</p>", "");
    }
    const B = (U) => {
      var Z;
      U.target.className === "editor-container" && ((Z = a.value) == null || Z.commands.focus("end"));
    };
    return ct(() => {
      E.value = t.layoutType === "two-columns" ? "292px" : "266px", m.value = t.content, Ln(() => {
        var U;
        O.value = (U = a.value) == null ? void 0 : U.view.dom, _.value = D(O.value.scrollHeight), P.value < _.value ? N.value = "hidden" : N.value = "remaining";
      });
    }), et(b, (U) => {
      var K, Z;
      U ? (K = a.value) == null || K.commands.focus("end") : (Z = a.value) == null || Z.commands.blur();
    }), et(L, (U) => {
      var K, Z;
      U && ((K = a.value) == null || K.commands.undoInputRule()), (Z = a.value) == null || Z.commands.blur();
    }), et(
      () => t.previewMode,
      (U) => {
        var K, Z;
        U ? (K = a.value) == null || K.setOptions({ editable: !1 }) : (Z = a.value) == null || Z.setOptions({ editable: !0 });
      }
    ), et(l, (U) => {
      !U && s.value || u(!!U);
    }), {
      editor: a,
      hasOpacity: c,
      setOpacity: u,
      toggleOpacity: d,
      scrollbar: f,
      lineStatusText: N,
      slideBeingEdited: G,
      inEditMode: b,
      editorHovered: l,
      focusEditor: B,
      linesAvailable: P,
      lineStatus: $,
      showEmptyState: y,
      lineCount: _,
      editorClasses: p,
      maxWidth: C,
      maxHeight: E,
      resetToDefault: w,
      undo: k
    };
  }
}, dO = () => {
  Wr((t) => ({
    v5e6bf804: t.maxWidth,
    v55440ea9: t.maxHeight
  }));
}, fO = P2.setup;
P2.setup = fO ? (t, e) => (dO(), fO(t, e)) : dO;
const xTe = ["data-mode", "data-layout"], UTe = {
  key: 0,
  class: "editor-menubar"
}, $Te = { class: "formatting-buttons" }, kTe = { class: "state-buttons" }, BTe = {
  key: 1,
  class: "editor-line-count"
}, GTe = {
  key: 0,
  class: "eye-open",
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "16",
  viewBox: "0 0 23 16",
  fill: "none"
}, FTe = {
  key: 1,
  class: "eye-closed",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "10",
  viewBox: "0 0 20 10",
  fill: "none"
};
function VTe(t, e, n, r, o, i) {
  const a = ee("EditorButton"), s = ee("Tooltip"), l = ee("editor-content"), c = ee("perfect-scrollbar"), u = ee("Text");
  return r.editor ? (v(), A("div", {
    key: 0,
    class: z(["editor", { visible: r.hasOpacity }]),
    "data-mode": n.previewMode ? "preview" : "edit",
    "data-layout": n.layoutType,
    onMouseenter: e[6] || (e[6] = ua((d) => n.layoutType === "two-rows" ? r.editorHovered = !0 : null, ["self"])),
    onMouseleave: e[7] || (e[7] = ua((d) => n.layoutType === "two-rows" ? r.editorHovered = !1 : null, ["self"]))
  }, [
    r.editor && !n.readOnly && !n.previewMode ? (v(), A("div", UTe, [
      g("div", $Te, [
        H(s, { content: "Heading" }, {
          default: q(() => [
            H(a, {
              active: r.editor.isActive("heading", { level: 3 }),
              onClick: e[0] || (e[0] = (d) => {
                var f;
                return (f = r.editor) == null ? void 0 : f.chain().focus().toggleHeading({ level: 3 }).run();
              }),
              style: { "margin-right": "0.5rem" }
            }, {
              default: q(() => [...e[8] || (e[8] = [
                g("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "8",
                  height: "10",
                  viewBox: "0 0 8 10",
                  fill: "none"
                }, [
                  g("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M0 1C0 0.447715 0.447715 0 1 0C1.55228 0 2 0.447715 2 1V4H6V1C6 0.447715 6.44772 0 7 0C7.55228 0 8 0.447715 8 1V9C8 9.55228 7.55228 10 7 10C6.44772 10 6 9.55229 6 9V6H2V9C2 9.55228 1.55228 10 1 10C0.447715 10 0 9.55229 0 9V1Z",
                    fill: "#010105"
                  })
                ], -1)
              ])]),
              _: 1
            }, 8, ["active"])
          ]),
          _: 1
        }),
        H(s, { content: "Bold" }, {
          default: q(() => [
            H(a, {
              active: r.editor.isActive("bold"),
              onClick: e[1] || (e[1] = (d) => r.editor.chain().focus().toggleBold().run()),
              style: { "margin-right": "0.5rem" }
            }, {
              default: q(() => [...e[9] || (e[9] = [
                g("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "8",
                  height: "10",
                  viewBox: "0 0 8 10",
                  fill: "none"
                }, [
                  g("path", {
                    d: "M1 0C0.447716 0 0 0.447715 0 1V8.99997C0 9.55226 0.447715 9.99998 1 9.99998H4.004C5.88 9.99998 7.00244 8.80997 7.00244 7.18598C7.00244 5.89797 6.244 5.07197 5.348 4.86197C6.16 4.59597 6.804 3.722 6.804 2.7C6.804 1.174 5.67 0 3.71 0H1ZM2.156 4.04998V1.90798H3.332C4.2 1.90798 4.634 2.32797 4.634 2.97197C4.634 3.64398 4.13 4.04998 3.36 4.04998H2.156ZM2.156 8.19398V5.86998H3.542C4.41 5.86998 4.914 6.34597 4.914 7.03197C4.914 7.74597 4.396 8.19398 3.542 8.19398H2.156Z",
                    fill: "black"
                  })
                ], -1)
              ])]),
              _: 1
            }, 8, ["active"])
          ]),
          _: 1
        }),
        H(s, { content: "Italic" }, {
          default: q(() => [
            H(a, {
              active: r.editor.isActive("italic"),
              onClick: e[2] || (e[2] = (d) => r.editor.chain().focus().toggleItalic().run()),
              style: { "margin-right": "0.5rem" }
            }, {
              default: q(() => [...e[10] || (e[10] = [
                g("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "8",
                  height: "10",
                  viewBox: "0 0 8 10",
                  fill: "none"
                }, [
                  g("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M6.2 2L3.8 8H4C4.55228 8 5 8.44771 5 9C5 9.55229 4.55228 10 4 10H3H1C0.447715 10 0 9.55229 0 9C0 8.44771 0.447715 8 1 8H1.8L4.2 2H4C3.44772 2 3 1.55228 3 1C3 0.447715 3.44772 0 4 0H5H7C7.55228 0 8 0.447715 8 1C8 1.55228 7.55228 2 7 2H6.2Z",
                    fill: "#010105"
                  })
                ], -1)
              ])]),
              _: 1
            }, 8, ["active"])
          ]),
          _: 1
        }),
        H(s, { content: "List" }, {
          default: q(() => [
            H(a, {
              active: r.editor.isActive("bulletList"),
              onClick: e[3] || (e[3] = (d) => r.editor.chain().focus().toggleBulletList().run())
            }, {
              default: q(() => [...e[11] || (e[11] = [
                g("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "16",
                  height: "12",
                  viewBox: "0 0 16 12",
                  fill: "none"
                }, [
                  g("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M2 3.5C2.82843 3.5 3.5 2.82843 3.5 2C3.5 1.17157 2.82843 0.5 2 0.5C1.17157 0.5 0.5 1.17157 0.5 2C0.5 2.82843 1.17157 3.5 2 3.5ZM5 2C5 1.44772 5.44772 1 6 1H14.5C15.0523 1 15.5 1.44772 15.5 2C15.5 2.55228 15.0523 3 14.5 3H6C5.44772 3 5 2.55228 5 2ZM6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7H14.5C15.0523 7 15.5 6.55228 15.5 6C15.5 5.44772 15.0523 5 14.5 5H6ZM6 9C5.44772 9 5 9.44771 5 10C5 10.5523 5.44772 11 6 11H14.5C15.0523 11 15.5 10.5523 15.5 10C15.5 9.44771 15.0523 9 14.5 9H6ZM3.5 6C3.5 6.82843 2.82843 7.5 2 7.5C1.17157 7.5 0.5 6.82843 0.5 6C0.5 5.17157 1.17157 4.5 2 4.5C2.82843 4.5 3.5 5.17157 3.5 6ZM2 11.5C2.82843 11.5 3.5 10.8284 3.5 10C3.5 9.17157 2.82843 8.5 2 8.5C1.17157 8.5 0.5 9.17157 0.5 10C0.5 10.8284 1.17157 11.5 2 11.5Z",
                    fill: "#010105"
                  })
                ], -1)
              ])]),
              _: 1
            }, 8, ["active"])
          ]),
          _: 1
        })
      ]),
      g("div", kTe, [
        H(s, { content: "Revert to original text" }, {
          default: q(() => [
            H(a, {
              onClick: r.resetToDefault,
              style: { "margin-left": "0.25rem" }
            }, {
              default: q(() => [...e[12] || (e[12] = [
                g("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "13",
                  height: "16",
                  viewBox: "0 0 13 16",
                  fill: "none"
                }, [
                  g("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M5.28209 1.07112L8.89079 3.23834C9.27259 3.46764 9.37163 3.97718 9.10353 4.3328L6.56946 7.69405C6.17857 8.21254 5.35826 8.02307 5.23437 7.38567L4.89664 5.64823C2.89407 6.22138 1.64898 8.25609 2.08864 10.3245C2.54795 12.4854 4.67201 13.8648 6.83288 13.4055C8.99374 12.9462 10.3731 10.8221 9.91382 8.66122C9.799 8.12101 10.1438 7.58999 10.6841 7.47516C11.2243 7.36034 11.7553 7.70518 11.8701 8.2454C12.5591 11.4867 10.49 14.6728 7.2487 15.3618C4.00741 16.0507 0.821305 13.9816 0.132346 10.7403C-0.539473 7.57968 1.41123 4.4715 4.51406 3.68L4.15974 1.85719C4.03584 1.21979 4.72544 0.736813 5.28209 1.07112Z",
                    fill: "black"
                  })
                ], -1)
              ])]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ])
    ])) : V("", !0),
    g("div", {
      class: "editor-container",
      onClick: e[4] || (e[4] = (d) => r.focusEditor(d))
    }, [
      H(c, {
        ref: "scrollbar",
        class: "editor-scroll-area"
      }, {
        default: q(() => [
          H(l, {
            class: z([r.editorClasses]),
            editor: r.editor
          }, null, 8, ["class", "editor"])
        ]),
        _: 1
      }, 512)
    ]),
    !n.readOnly && !n.previewMode ? (v(), A("div", BTe, [
      H(Zt, { name: "fade-fast" }, {
        default: q(() => [
          H(u, {
            color: r.linesAvailable <= (r.lineCount ?? 0) ? "red" : "gray",
            size: "f-9",
            weight: "400"
          }, {
            default: q(() => [
              me(Q(r.lineStatus) + " lines " + Q(r.lineStatusText), 1)
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        _: 1
      })
    ])) : V("", !0),
    !n.readOnly && !n.previewMode ? (v(), A("div", {
      key: 2,
      class: "editor-opacity-toggle",
      onClick: e[5] || (e[5] = ua((d) => r.toggleOpacity(d), ["stop"]))
    }, [
      r.hasOpacity ? (v(), A("svg", GTe, [...e[13] || (e[13] = [
        g("path", {
          d: "M11.5 1.25C4 1.25 1 8 1 8C1 8 4 14.75 11.5 14.75C19 14.75 22 8 22 8C22 8 19 1.25 11.5 1.25Z",
          stroke: "black",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, -1),
        g("path", {
          d: "M11.5 11.75C13.5711 11.75 15.25 10.0711 15.25 8C15.25 5.92893 13.5711 4.25 11.5 4.25C9.42893 4.25 7.75 5.92893 7.75 8C7.75 10.0711 9.42893 11.75 11.5 11.75Z",
          stroke: "black",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, -1)
      ])])) : (v(), A("svg", FTe, [...e[14] || (e[14] = [
        vt('<path d="M16.8623 2.93457L19.0092 6.6377" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.4658 4.99707L13.1314 8.7752" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.54355 4.9873L6.87793 8.77481" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.14687 2.93457L1 6.65645" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M1.00928 0.834473C2.58428 2.78447 5.47178 5.2501 10.0093 5.2501C14.5468 5.2501 17.4343 2.78447 19.0093 0.834473" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
      ])]))
    ])) : V("", !0)
  ], 42, xTe)) : V("", !0);
}
const HTe = /* @__PURE__ */ Y(P2, [["render", VTe]]);
const WTe = {}, YTe = {
  class: "google-logo",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 272 92",
  width: "92",
  height: "30"
};
function KTe(t, e) {
  return v(), A("svg", YTe, [...e[0] || (e[0] = [
    vt('<path fill="#EA4335" d="M115.75 47.18c0 12.77-9.99 22.18-22.25 22.18s-22.25-9.41-22.25-22.18C71.25 34.32 81.24 25 93.5 25s22.25 9.32 22.25 22.18zm-9.74 0c0-7.98-5.79-13.44-12.51-13.44S80.99 39.2 80.99 47.18c0 7.9 5.79 13.44 12.51 13.44s12.51-5.55 12.51-13.44z"></path><path fill="#FBBC05" d="M163.75 47.18c0 12.77-9.99 22.18-22.25 22.18s-22.25-9.41-22.25-22.18c0-12.85 9.99-22.18 22.25-22.18s22.25 9.32 22.25 22.18zm-9.74 0c0-7.98-5.79-13.44-12.51-13.44s-12.51 5.46-12.51 13.44c0 7.9 5.79 13.44 12.51 13.44s12.51-5.55 12.51-13.44z"></path><path fill="#4285F4" d="M209.75 26.34v39.82c0 16.38-9.66 23.07-21.08 23.07-10.75 0-17.22-7.19-19.66-13.07l8.48-3.53c1.51 3.61 5.21 7.87 11.17 7.87 7.31 0 11.84-4.51 11.84-13v-3.19h-.34c-2.18 2.69-6.38 5.04-11.68 5.04-11.09 0-21.25-9.66-21.25-22.09 0-12.52 10.16-22.26 21.25-22.26 5.29 0 9.49 2.35 11.68 4.96h.34v-3.61h9.25zm-8.56 20.92c0-7.81-5.21-13.52-11.84-13.52-6.72 0-12.35 5.71-12.35 13.52 0 7.73 5.63 13.36 12.35 13.36 6.63 0 11.84-5.63 11.84-13.36z"></path><path fill="#34A853" d="M225 3v65h-9.5V3h9.5z"></path><path fill="#EA4335" d="M262.02 54.48l7.56 5.04c-2.44 3.61-8.32 9.83-18.48 9.83-12.6 0-22.01-9.74-22.01-22.18 0-13.19 9.49-22.18 20.92-22.18 11.51 0 17.14 9.16 18.98 14.11l1.01 2.52-29.65 12.28c2.27 4.45 5.8 6.72 10.75 6.72 4.96 0 8.4-2.44 10.92-6.14zm-23.27-7.98l19.82-8.23c-1.09-2.77-4.37-4.7-8.23-4.7-4.95 0-11.84 4.37-11.59 12.93z"></path><path fill="#4285F4" d="M35.29 41.41V32H67c.31 1.64.47 3.58.47 5.68 0 7.06-1.93 15.79-8.15 22.01-6.05 6.3-13.78 9.66-24.02 9.66C16.32 69.35.36 53.89.36 34.91.36 15.93 16.32.47 35.3.47c10.5 0 17.98 4.12 23.6 9.49l-6.64 6.64c-4.03-3.78-9.49-6.72-16.97-6.72-13.86 0-24.7 11.17-24.7 25.03 0 13.86 10.84 25.03 24.7 25.03 8.99 0 14.11-3.61 17.39-6.89 2.66-2.66 4.41-6.46 5.1-11.65l-22.49.01z"></path>', 6)
  ])]);
}
const zTe = /* @__PURE__ */ Y(WTe, [["render", KTe]]), ZTe = {
  props: {
    hex: {
      type: String,
      required: !1,
      default: "#9aa0a6"
    }
  }
}, qTe = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, XTe = ["fill"];
function jTe(t, e, n, r, o, i) {
  return v(), A("svg", qTe, [
    e[1] || (e[1] = g("title", null, "Search icon", -1)),
    g("g", {
      fill: n.hex,
      class: "nc-icon-wrapper"
    }, [...e[0] || (e[0] = [
      g("path", { d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" }, null, -1)
    ])], 8, XTe)
  ]);
}
const JTe = /* @__PURE__ */ Y(ZTe, [["render", jTe]]), QTe = {}, ebe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "16",
  height: "16"
};
function tbe(t, e) {
  return v(), A("svg", ebe, [...e[0] || (e[0] = [
    vt('<title>Google all results</title><path fill="none" d="M0 0h24v24H0z"></path><path fill="#34A853" d="M10 2v2a6 6 0 0 1 6 6h2a8 8 0 0 0-8-8z"></path><path fill="#EA4335" d="M10 4V2a8 8 0 0 0-8 8h2c0-3.3 2.7-6 6-6z"></path><path fill="#FBBC04" d="M4 10H2a8 8 0 0 0 8 8v-2c-3.3 0-6-2.69-6-6z"></path><path fill="#4285F4" d="M22 20.59l-5.69-5.69A7.96 7.96 0 0 0 18 10h-2a6 6 0 0 1-6 6v2c1.85 0 3.52-.64 4.88-1.68l5.69 5.69L22 20.59z"></path>', 6)
  ])]);
}
const nbe = /* @__PURE__ */ Y(QTe, [["render", tbe]]), rbe = {}, obe = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function ibe(t, e) {
  return v(), A("svg", obe, [...e[0] || (e[0] = [
    g("path", {
      d: "M9.33334 8.66665L12 12H4L6.66667 9.33331L7.86 10.52L9.33334 8.66665ZM5.32667 6.67331C5.68118 6.6742 6.02151 6.53422 6.27281 6.28417C6.52411 6.03412 6.66579 5.69449 6.66667 5.33998C6.66755 4.98547 6.52757 4.64514 6.27753 4.39384C6.02748 4.14254 5.68784 4.00086 5.33334 3.99998C4.97883 3.9991 4.63849 4.13907 4.38719 4.38912C4.13589 4.63917 3.99422 4.97881 3.99334 5.33331C3.99245 5.68782 4.13243 6.02816 4.38248 6.27946C4.63253 6.53075 4.97216 6.67243 5.32667 6.67331V6.67331ZM14.6667 3.33331V12.6666C14.6649 13.1959 14.4534 13.7029 14.0785 14.0766C13.7036 14.4502 13.1959 14.66 12.6667 14.66H3.33334C2.24 14.66 1.33334 13.7533 1.33334 12.66V3.33331C1.33334 2.23998 2.24 1.33331 3.33334 1.33331H12.6667C13.7667 1.33331 14.6667 2.23998 14.6667 3.33331ZM13.3267 3.33331C13.3267 3.1565 13.2564 2.98693 13.1314 2.86191C13.0064 2.73688 12.8368 2.66665 12.66 2.66665H3.33334C3.15652 2.66665 2.98696 2.73688 2.86193 2.86191C2.73691 2.98693 2.66667 3.1565 2.66667 3.33331V12.6666C2.66667 12.8435 2.73691 13.013 2.86193 13.1381C2.98696 13.2631 3.15652 13.3333 3.33334 13.3333H8V13.3266H12.6667C12.8435 13.3266 13.0131 13.2564 13.1381 13.1314C13.2631 13.0064 13.3333 12.8368 13.3333 12.66V3.33331",
      fill: "#5F6368"
    }, null, -1)
  ])]);
}
const abe = /* @__PURE__ */ Y(rbe, [["render", ibe]]), sbe = {}, lbe = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function cbe(t, e) {
  return v(), A("svg", lbe, [...e[0] || (e[0] = [
    g("path", {
      d: "M7.503 0C10.593 0 13.005 2.487 13.005 5.427C13.005 7.764 11.875 9.121 10.745 10.477C10.291 11.005 9.839 11.607 9.387 12.211C8.935 12.814 8.633 13.719 8.407 14.171C8.181 14.623 8.03 15 7.503 15C6.975 15 6.825 14.623 6.598 14.17C6.372 13.719 6.071 12.814 5.618 12.211C5.166 11.608 4.714 11.005 4.262 10.477C3.132 9.121 2 7.764 2 5.427C2 2.487 4.412 0 7.503 0ZM7.503 1.364C5.22 1.364 3.363 3.186 3.363 5.427C3.363 7.27 4.223 8.3 5.309 9.604C5.777 10.151 6.251 10.782 6.709 11.394C7.049 11.846 7.305 12.384 7.503 12.838C7.701 12.383 7.956 11.846 8.296 11.393C8.755 10.783 9.227 10.151 9.709 9.59C10.783 8.3 11.642 7.27 11.642 5.427C11.642 3.187 9.784 1.364 7.503 1.364V1.364ZM7.503 4.098C7.68187 4.09113 7.86028 4.12043 8.02755 4.18416C8.19482 4.24788 8.34751 4.34472 8.47647 4.46886C8.60542 4.593 8.70799 4.74189 8.77803 4.90662C8.84806 5.07135 8.88413 5.24852 8.88406 5.42752C8.884 5.60652 8.8478 5.78366 8.77763 5.94834C8.70747 6.11301 8.60479 6.26183 8.47574 6.38588C8.3467 6.50992 8.19394 6.60664 8.02662 6.67024C7.8593 6.73384 7.68086 6.76301 7.502 6.756C7.15845 6.74267 6.83341 6.59682 6.59506 6.34904C6.3567 6.10126 6.22357 5.77081 6.22357 5.427C6.22357 5.08319 6.3567 4.75274 6.59506 4.50496C6.83341 4.25718 7.15845 4.11133 7.502 4.098",
      fill: "#5F6368"
    }, null, -1)
  ])]);
}
const ube = /* @__PURE__ */ Y(sbe, [["render", cbe]]), dbe = {}, fbe = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function hbe(t, e) {
  return v(), A("svg", fbe, [...e[0] || (e[0] = [
    g("path", {
      d: "M8 7.33333H12V8.66667H8V7.33333ZM4 11.3333H12V10H4V11.3333ZM4 8.66667H6.66667V4.66667H4V8.66667ZM14.6667 3.85333V12.1467C14.6667 13.1733 13.7733 14 12.6667 14H3.33333C2.24 14 1.33333 13.1667 1.33333 12.1467V3.85333C1.33333 2.84 2.24 2 3.33333 2H12.6667C13.76 2 14.6667 2.83333 14.6667 3.85333V3.85333ZM13.3267 8V3.85333C13.3267 3.57333 13.02 3.33333 12.66 3.33333H3.33333C2.97333 3.33333 2.66667 3.57333 2.66667 3.85333V12.1467C2.66667 12.4267 2.97333 12.6667 3.33333 12.6667H12.6667C13.0267 12.6667 13.3333 12.4267 13.3333 12.1467V8H13.3267ZM8 6H12V4.66667H8V6Z",
      fill: "#5F6368"
    }, null, -1)
  ])]);
}
const _be = /* @__PURE__ */ Y(dbe, [["render", hbe]]), Ebe = {}, pbe = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function mbe(t, e) {
  return v(), A("svg", pbe, [...e[0] || (e[0] = [
    g("path", {
      d: "M6.66666 11L10.6667 8.00004L6.66666 5.00004V11ZM3.33333 13.3334H12.6667C12.8435 13.3334 13.013 13.2631 13.1381 13.1381C13.2631 13.0131 13.3333 12.8435 13.3333 12.6667V3.33337C13.3333 3.15656 13.2631 2.98699 13.1381 2.86197C13.013 2.73695 12.8435 2.66671 12.6667 2.66671H3.33333C3.15652 2.66671 2.98695 2.73695 2.86192 2.86197C2.7369 2.98699 2.66666 3.15656 2.66666 3.33337V12.6667C2.66666 12.8435 2.7369 13.0131 2.86192 13.1381C2.98695 13.2631 3.15652 13.3334 3.33333 13.3334ZM13 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91911 14.0809C1.54404 13.7058 1.33333 13.1971 1.33333 12.6667V2.93337C1.33333 2.50903 1.5019 2.10206 1.80196 1.802C2.10202 1.50195 2.50898 1.33337 2.93333 1.33337H13.0667C13.491 1.33337 13.898 1.50195 14.198 1.802C14.4981 2.10206 14.6667 2.50903 14.6667 2.93337V13C14.6667 13.4421 14.4911 13.866 14.1785 14.1786C13.8659 14.4911 13.442 14.6667 13 14.6667Z",
      fill: "#5F6368"
    }, null, -1)
  ])]);
}
const Nbe = /* @__PURE__ */ Y(Ebe, [["render", mbe]]), vbe = {}, gbe = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ibe(t, e) {
  return v(), A("svg", gbe, [...e[0] || (e[0] = [
    g("path", {
      d: "M8 5.33335C8.73333 5.33335 9.33333 4.73335 9.33333 4.00002C9.33333 3.26669 8.73333 2.66669 8 2.66669C7.26666 2.66669 6.66666 3.26669 6.66666 4.00002C6.66666 4.73335 7.26666 5.33335 8 5.33335ZM8 6.66669C7.26666 6.66669 6.66666 7.26669 6.66666 8.00002C6.66666 8.73335 7.26666 9.33335 8 9.33335C8.73333 9.33335 9.33333 8.73335 9.33333 8.00002C9.33333 7.26669 8.73333 6.66669 8 6.66669ZM8 10.6667C7.26666 10.6667 6.66666 11.2667 6.66666 12C6.66666 12.7334 7.26666 13.3334 8 13.3334C8.73333 13.3334 9.33333 12.7334 9.33333 12C9.33333 11.2667 8.73333 10.6667 8 10.6667Z",
      fill: "#5F6368"
    }, null, -1)
  ])]);
}
const Obe = /* @__PURE__ */ Y(vbe, [["render", Ibe]]), Abe = {
  name: "GoogleSearchPreview",
  components: {
    GoogleLogo: zTe,
    SearchIcon: JTe,
    AllResultsIcon: nbe,
    ImagesIcon: abe,
    MapsIcon: ube,
    NewsIcon: _be,
    VideoIcon: Nbe,
    MoreIcon: Obe
  },
  props: {
    searchTerm: {
      type: String,
      required: !1
    },
    showResults: {
      type: Boolean,
      required: !1,
      default: !0
    },
    slotContentPadding: {
      type: String,
      required: !1,
      default: "0.5rem 0rem 2rem 180px"
    }
  },
  emit: ["changed"],
  setup(t, { emit: e }) {
    return {
      updateSearchTerm: (r) => {
        e("changed", r);
      },
      slotContentPadding: t.slotContentPadding
    };
  }
};
const Dbe = {
  id: "desktop-preview",
  class: "desktop"
}, Cbe = { class: "flex items-center search-bar-container" }, Sbe = { class: "search-bar" }, wbe = ["value"], Tbe = { class: "tabs flex no-select" }, bbe = { class: "tab selected mr-24" }, Rbe = { class: "tab mr-24" }, Mbe = { class: "tab mr-24" }, Pbe = { class: "tab mr-24" }, ybe = { class: "tab mr-20" }, Lbe = { class: "tab mr-24" }, xbe = {
  key: 0,
  class: "results-number"
}, Ube = {
  key: 1,
  class: "slot-content"
};
function $be(t, e, n, r, o, i) {
  const a = ee("GoogleLogo"), s = ee("SearchIcon"), l = ee("AllResultsIcon"), c = ee("ImagesIcon"), u = ee("MapsIcon"), d = ee("NewsIcon"), f = ee("VideoIcon"), h = ee("MoreIcon");
  return v(), A("div", Dbe, [
    g("div", Cbe, [
      H(a),
      g("div", Sbe, [
        g("input", {
          value: n.searchTerm,
          onChange: e[0] || (e[0] = (..._) => r.updateSearchTerm && r.updateSearchTerm(..._))
        }, null, 40, wbe),
        H(s, { hex: "#4285f4" })
      ])
    ]),
    g("div", Tbe, [
      g("div", bbe, [
        H(l, { style: { "margin-right": "6px" } }),
        e[1] || (e[1] = g("span", null, "All", -1))
      ]),
      g("div", Rbe, [
        H(c, { style: { "margin-right": "6px" } }),
        e[2] || (e[2] = g("span", null, "Images", -1))
      ]),
      g("div", Mbe, [
        H(u, { style: { "margin-right": "4px" } }),
        e[3] || (e[3] = g("span", null, "Maps", -1))
      ]),
      g("div", Pbe, [
        H(d, { style: { "margin-right": "6px" } }),
        e[4] || (e[4] = g("span", null, "News", -1))
      ]),
      g("div", ybe, [
        H(f, { style: { "margin-right": "6px" } }),
        e[5] || (e[5] = g("span", null, "Video", -1))
      ]),
      g("div", Lbe, [
        H(h, { style: { "margin-right": "2px" } }),
        e[6] || (e[6] = g("span", null, "More", -1))
      ])
    ]),
    n.showResults ? (v(), A("p", xbe, "About 368,000,000 results (0.46 seconds)")) : V("", !0),
    t.$slots.default ? (v(), A("div", Ube, [
      ue(t.$slots, "default", {}, void 0, !0)
    ])) : V("", !0)
  ]);
}
const kbe = /* @__PURE__ */ Y(Abe, [["render", $be], ["__scopeId", "data-v-f0e24f36"]]), Bbe = {
  name: "SlideAdContainer",
  props: {
    ad: {
      type: Object,
      required: !0
    },
    type: {
      type: String,
      required: !1,
      default: "none",
      validator(t) {
        return ["win", "lose", "none"].includes(t);
      }
    },
    theme: {
      type: Object,
      required: !0
    },
    readOnly: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    statsPillColor() {
      return this.type === "lose" ? "red" : "green";
    }
  },
  methods: {
    formatCallouts(t) {
      return t && t.CALLOUT ? t.CALLOUT.map((e) => e.callout_feed_item.callout_text).slice(0, 5) : void 0;
    },
    formatSnippets(t) {
      return t && t.STRUCTURED_SNIPPET ? {
        header: t.STRUCTURED_SNIPPET[0].structured_snippet_feed_item.header,
        snippets: t.STRUCTURED_SNIPPET[0].structured_snippet_feed_item.values.slice(0, 5)
      } : void 0;
    },
    formatCall(t) {
      return t && t.CALL ? t.CALL[0].call_feed_item.phone_number.replace(/(\d{2})(\d{4})(\d{4})/g, "$1 $2 $3") : void 0;
    },
    updateSearchTerm(t) {
      this.$emit("search-term-updated", t.target.value);
    }
  },
  components: {
    TextAd: K4e,
    ImageAd: O4e,
    GoogleLogo: $V,
    GoogleSearchPreview: kbe
  }
};
const Gbe = { class: "slide-ad-container" };
function Fbe(t, e, n, r, o, i) {
  const a = ee("TextAd"), s = ee("GoogleSearchPreview");
  return v(), A("div", Gbe, [
    H(s, {
      "search-term": n.ad.search_term,
      "show-results": !1,
      onChange: i.updateSearchTerm
    }, {
      default: q(() => [
        H(a, {
          "no-container": !0,
          ad: {
            headlineOne: n.ad.expanded_text_ad.headline_part1,
            headlineTwo: n.ad.expanded_text_ad.headline_part2,
            headlineTwo: n.ad.expanded_text_ad.headline_part3,
            displayUrl: n.ad.root_domain ? n.ad.root_domain : n.ad.domain,
            pathOne: n.ad.expanded_text_ad.path1,
            pathTwo: n.ad.expanded_text_ad.path2,
            descriptionOne: n.ad.expanded_text_ad.description,
            descriptionTwo: n.ad.expanded_text_ad.description2
          },
          "featured-statistics": [
            { name: "Impressions", content: n.ad.impressions, color: i.statsPillColor },
            { name: "Clicks", content: n.ad.clicks, color: i.statsPillColor },
            { name: "Conversions", content: n.ad.conversions, color: i.statsPillColor },
            { name: "Conversion Rate", content: n.ad.conversion_rate, color: i.statsPillColor }
          ]
        }, null, 8, ["ad", "featured-statistics"])
      ]),
      _: 1
    }, 8, ["search-term", "onChange"])
  ]);
}
const Vbe = /* @__PURE__ */ Y(Bbe, [["render", Fbe], ["__scopeId", "data-v-59c11474"]]), Hbe = { class: "column-overlay" }, Wbe = { key: 0 }, us = "1.25rem", ds = "0.875rem", Ybe = /* @__PURE__ */ Ne({
  __name: "SlideSegmentsTable",
  props: {
    table: {},
    performanceMode: {},
    readOnly: { type: Boolean }
  },
  setup(t) {
    const e = t, n = !e.performanceMode || e.performanceMode === Ec.CPA, r = e.performanceMode === Ec.ROAS;
    function o(s) {
      return s && n || !s && r ? "green" : "red";
    }
    const i = [
      {
        key: "segment",
        text: "Segment",
        vHeaderPadding: us,
        vPadding: ds,
        noPadding: !0
      },
      {
        key: n ? "conversions" : "conversions_value",
        text: n ? "Conv." : "Value",
        vHeaderPadding: us,
        vPadding: ds,
        noPadding: !0,
        width: 86
      },
      {
        key: "cost",
        text: "Cost",
        vHeaderPadding: us,
        vPadding: ds,
        noPadding: !0,
        width: 100
      },
      {
        key: n ? "cpa" : "roas",
        text: n ? "CPA" : "ROAS",
        vHeaderPadding: us,
        vPadding: ds,
        noPadding: !0,
        width: 100
      },
      {
        key: n ? "cpa_target" : "roas_target",
        text: "Target",
        vHeaderPadding: us,
        vPadding: ds,
        noPadding: !0,
        width: 100
      },
      {
        key: "difference",
        text: "Diff.",
        vHeaderPadding: us,
        vPadding: ds,
        noPadding: !0,
        width: 94
      }
    ], a = x(
      () => e.table.data.map((s, l) => {
        const c = e.table.labels[l];
        return {
          id: c.name + l.toString(),
          segment: { name: c.name, segment: c.segment },
          ...s
        };
      })
    );
    return (s, l) => (v(), te($E, {
      headers: i,
      items: a.value,
      noShadow: t.readOnly,
      "order-by": "difference",
      order: t.performanceMode === M(NR).PerformanceMode.CPA ? "DESC" : "ASC",
      class: z([t.readOnly ? "pdf-shadow-fix" : "shadow"])
    }, {
      "header.segment": q(() => [...l[0] || (l[0] = [
        g("div", { class: "pl-24" }, "Segment", -1)
      ])]),
      "column.segment": q((c) => [
        g("div", Hbe, [
          H(Ye, { size: "f-8" }, {
            default: q(() => [
              me(Q(c.value.name) + " ", 1),
              H(Ye, {
                as: "span",
                size: "f-8",
                color: "gray"
              }, {
                default: q(() => [
                  me("in " + Q(c.value.segment), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ])
      ]),
      "column.difference": q((c) => [
        c.value != "N/A" ? (v(), te(Ye, {
          key: 0,
          size: "f-8",
          color: o(c.row.is_below_cpa),
          weight: "500"
        }, {
          default: q(() => [
            c.row.is_below_cpa ? (v(), A("span", Wbe, "-")) : V("", !0),
            me(Q(c.value), 1)
          ]),
          _: 2
        }, 1032, ["color"])) : (v(), te(Ye, {
          key: 1,
          size: "f-8",
          color: "gray",
          weight: "500"
        }, {
          default: q(() => [...l[1] || (l[1] = [
            me("N/A", -1)
          ])]),
          _: 1
        }))
      ]),
      _: 1
    }, 8, ["items", "noShadow", "order", "class"]));
  }
});
const Kbe = /* @__PURE__ */ Y(Ybe, [["__scopeId", "data-v-0988e0cc"]]);
function zbe(t, e) {
  var n = [];
  return I7(t, function(r, o, i) {
    e(r, o, i) && n.push(r);
  }), n;
}
function Zbe(t, e) {
  var n = xn(t) ? s7 : zbe;
  return n(t, Vi(e));
}
const hO = 6, qbe = {
  name: "SlideWorkSummaryTable",
  components: { oTable: $E, Text: Ye, CheckIcon: W5 },
  props: {
    readOnly: {
      type: Boolean,
      require: !1
    },
    table: {
      type: Array,
      require: !0
    },
    slideNumber: {
      type: Number,
      require: !1
    }
  },
  data() {
    const t = "1.125rem", e = "0.9375rem";
    return {
      columns: [
        { key: "task_completed", text: "Task Completed", vHeaderPadding: t, vPadding: e },
        { key: "number", text: "#", vHeaderPadding: t, vPadding: e },
        // number of tasks
        { key: "time_per_task", text: "Time Per Task", vHeaderPadding: t, vPadding: e },
        { key: "total_time", text: "Total Time", vHeaderPadding: t, vPadding: e }
      ]
    };
  },
  computed: {
    activeRows() {
      return this.table.filter((t) => t.active);
    },
    filteredTable() {
      const t = this.activeRows.length % hO === 0 ? Math.abs(this.activeRows.length / this.numberOfSlides) : hO, e = (this.slideNumber - 1) * t, n = this.slideNumber * t;
      return Zbe(this.activeRows, (r, o) => o >= e && o < n);
    },
    // TODO: this should probably be done server side?
    formattedItems() {
      return this.filteredTable.map((t, e) => ({
        id: t.name + e.toString(),
        task_completed: t.name,
        number: t.number,
        time_per_task: t.time,
        total_time: t.number * t.time,
        active: t.active
      }));
    },
    numberOfSlides() {
      return Math.ceil((this.activeRows.length + 1) / 6);
    },
    showSummaryBar() {
      return this.slideNumber === this.numberOfSlides;
    },
    totalTasks() {
      return Pc(this.activeRows, (t) => t.number);
    },
    totalTime() {
      return Pc(this.activeRows, (t) => t.time * t.number);
    }
  },
  methods: {
    convertTime(t) {
      const e = Math.floor(t / 60), n = t % 60;
      return `${this.addComas(e)} hours ${this.addComas(n)} minutes`;
    },
    addComas(t) {
      Math.abs(+t) > 1e4 ? t = Math.round(+t) + "" : t = Math.round(+t * 100) / 100 + "";
      const e = t.split(".");
      let n = e[0];
      const r = e.length > 1 ? "." + e[1] : "", o = /(\d+)(\d{3})/;
      for (; o.test(n); )
        n = n.replace(o, "$1,$2");
      return n + r;
    }
  }
};
const Xbe = {
  key: 0,
  class: "work-summary-bar"
}, jbe = { style: { "margin-right": "0.75rem" } };
function Jbe(t, e, n, r, o, i) {
  const a = ee("Text"), s = ee("CheckIcon"), l = ee("oTable");
  return v(), te(l, {
    headers: o.columns,
    items: i.formattedItems,
    "order-by": "total_time",
    order: "DESC",
    noShadow: n.readOnly,
    class: z([n.readOnly ? "pdf-shadow-fix" : "shadow"])
  }, {
    "column.time_per_task": q((c) => [
      H(a, { size: "f-8" }, {
        default: q(() => [
          me(Q(c.value) + " minutes", 1)
        ]),
        _: 2
      }, 1024)
    ]),
    "column.total_time": q((c) => [
      H(a, { size: "f-8" }, {
        default: q(() => [
          me(Q(i.convertTime(c.value)), 1)
        ]),
        _: 2
      }, 1024)
    ]),
    footer: q(() => [
      i.showSummaryBar ? (v(), A("div", Xbe, [
        g("div", jbe, [
          H(s)
        ]),
        H(a, { size: "f-8" }, {
          default: q(() => [
            g("b", null, Q(i.addComas(i.totalTasks)), 1),
            e[0] || (e[0] = me(" tasks completed in ", -1)),
            g("b", null, Q(i.convertTime(i.totalTime)), 1)
          ]),
          _: 1
        })
      ])) : V("", !0)
    ]),
    _: 1
  }, 8, ["headers", "items", "noShadow", "class"]);
}
const Qbe = /* @__PURE__ */ Y(qbe, [["render", Jbe], ["__scopeId", "data-v-1b01c994"]]), e9e = {
  name: "SlideStatisticsGrid",
  props: {
    theme: {
      type: Object,
      required: !0
    },
    statistics: {
      type: Array,
      required: !1
    },
    readOnly: {
      type: Boolean,
      default: !1
    }
  },
  setup() {
    return {
      parseDeltaString: e5
    };
  },
  components: {
    Text: Ye,
    Delta: Dp,
    Spacer: He
  }
};
const t9e = {
  class: "statistic-value",
  style: { color: "#000" }
};
function n9e(t, e, n, r, o, i) {
  const a = ee("Spacer"), s = ee("Text"), l = ee("Delta");
  return v(), A("div", {
    class: z([[n.readOnly ? "pdf-shadow-fix" : "editor-container-border"], "slide-statistics-grid"])
  }, [
    (v(!0), A(ge, null, ye(n.statistics, (c, u) => (v(), A("div", {
      class: "statistics-block",
      key: u
    }, [
      g("h1", t9e, Q(c.value), 1),
      H(a, { height: "0.625rem" }),
      H(s, {
        as: "h5",
        size: "f-9",
        color: "gray",
        weight: "400",
        align: "center"
      }, {
        default: q(() => [
          me(Q(c.name), 1)
        ]),
        _: 2
      }, 1024),
      H(a, { height: "0.625rem" }),
      c.delta === "N/A" ? (v(), te(l, {
        key: 0,
        reverse: c.down && c.color === "green" || !c.down && c.color === "red",
        delta: 1 / 0,
        style: { display: "block" }
      }, null, 8, ["reverse"])) : (v(), te(l, {
        key: 1,
        delta: r.parseDeltaString(c.delta, c.down),
        reverse: c.down && c.color === "green" || !c.down && c.color === "red",
        decimalPlaces: 2,
        threshold: 0,
        style: { display: "block" }
      }, null, 8, ["delta", "reverse"]))
    ]))), 128))
  ], 2);
}
const r9e = /* @__PURE__ */ Y(e9e, [["render", n9e], ["__scopeId", "data-v-10f7d317"]]), o9e = {
  name: "SlideMap",
  props: {
    imgUrl: {
      type: String,
      required: !0
    },
    readOnly: {
      type: Boolean,
      default: !1
    }
  }
};
const i9e = ["src"];
function a9e(t, e, n, r, o, i) {
  return v(), A("div", {
    class: z([n.readOnly ? "pdf-shadow-fix" : "", "map"])
  }, [
    g("img", { src: n.imgUrl }, null, 8, i9e)
  ], 2);
}
const s9e = /* @__PURE__ */ Y(o9e, [["render", a9e], ["__scopeId", "data-v-5cb12480"]]);
const l9e = {}, c9e = { class: "logo-container" };
function u9e(t, e) {
  return v(), A("div", c9e, [...e[0] || (e[0] = [
    vt('<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" data-v-f1a0d6a6><path d="M6.126 2.733c.174-.456.413-.877.768-1.217 1.42-1.385 3.77-1.037 4.734.703.725 1.32 1.493 2.61 2.24 3.914 1.246 2.168 2.508 4.335 3.74 6.51 1.037 1.82-.087 4.117-2.146 4.43-1.26.188-2.442-.392-3.095-1.523-1.095-1.907-2.196-3.813-3.291-5.712-.022-.044-.05-.08-.08-.116-.116-.095-.166-.232-.239-.356-.486-.855-.986-1.703-1.472-2.551-.311-.551-.637-1.095-.95-1.646a3.002 3.002 0 0 1-.398-1.595c.022-.29.058-.58.189-.84Z" fill="#3C8BD9" data-v-f1a0d6a6></path><path d="M6.125 2.733a4.17 4.17 0 0 0-.138.798c-.021.609.131 1.174.435 1.703.798 1.37 1.595 2.748 2.385 4.125.073.123.13.247.203.363-.435.754-.87 1.5-1.312 2.254-.609 1.051-1.218 2.11-1.834 3.16-.029 0-.036-.014-.043-.036-.007-.058.014-.108.029-.166.297-1.088.05-2.052-.696-2.878-.457-.5-1.037-.783-1.704-.877-.87-.124-1.638.101-2.327.645-.123.094-.203.232-.348.304-.029 0-.043-.014-.05-.036.348-.602.688-1.203 1.036-1.805C3.197 7.793 4.631 5.3 6.074 2.813c.015-.029.037-.05.051-.08Z" fill="#FABC04" data-v-f1a0d6a6></path><path d="M.754 12.114c.137-.123.268-.254.413-.37 1.761-1.392 4.407-.384 4.792 1.82.094.529.043 1.036-.116 1.544a.759.759 0 0 1-.03.123c-.065.116-.123.24-.195.355-.645 1.066-1.595 1.595-2.842 1.515C1.348 17 .225 15.927.03 14.506a2.9 2.9 0 0 1 .399-1.928c.072-.13.159-.247.239-.377.036-.03.022-.087.087-.087Z" fill="#34A852" data-v-f1a0d6a6></path><path d="M.754 12.114c-.03.029-.03.08-.08.087-.007-.05.022-.08.05-.116l.03.029Z" fill="#FABC04" data-v-f1a0d6a6></path><path d="M5.814 15.231c-.03-.05 0-.087.029-.123l.029.029-.058.094Z" fill="#E1C025" data-v-f1a0d6a6></path></svg>', 1)
  ])]);
}
const d9e = /* @__PURE__ */ Y(l9e, [["render", u9e], ["__scopeId", "data-v-f1a0d6a6"]]), f9e = { class: "chart-info" }, h9e = /* @__PURE__ */ Ne({
  __name: "SlideChartHeader",
  props: {
    title: {},
    total: {},
    theme: {},
    readOnly: { type: Boolean }
  },
  setup(t) {
    return (e, n) => (v(), A("div", {
      class: z([`theme-${t.theme.typeface}-numbers`, "chart-header"])
    }, [
      H(Ye, { size: "f-8" }, {
        default: q(() => [
          me(Q(t.title), 1)
        ]),
        _: 1
      }),
      H(He, { height: "0.1875rem" }),
      g("div", f9e, [
        H(Ye, {
          as: "h2",
          size: "f-5",
          weight: "600",
          style: { "letter-spacing": "-0.045rem" }
        }, {
          default: q(() => [
            me(Q(t.total), 1)
          ]),
          _: 1
        }),
        H(He, {
          width: "0.75rem",
          height: "0.25rem"
        }),
        ue(e.$slots, "default", {}, void 0, !0),
        H(d9e, { style: { position: "absolute", top: "1.25rem", right: "1.25rem" } })
      ])
    ], 2));
  }
});
const X8 = /* @__PURE__ */ Y(h9e, [["__scopeId", "data-v-494ce94b"]]);
var u_ = { exports: {} }, j8 = { exports: {} };
(function(t) {
  function e(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(j8);
var Gt = j8.exports, d_ = { exports: {} }, f_ = { exports: {} }, J8 = { exports: {} };
(function(t) {
  function e(n) {
    "@babel/helpers - typeof";
    return t.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, e(n);
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(J8);
var Q8 = J8.exports, h_ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r, o) {
    if (o.length < r)
      throw new TypeError(r + " argument" + (r > 1 ? "s" : "") + " required, but only " + o.length + " present");
  }
  t.exports = e.default;
})(h_, h_.exports);
var Bn = h_.exports;
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var r = n(Q8), o = n(Bn);
  function i(a) {
    return (0, o.default)(1, arguments), a instanceof Date || (0, r.default)(a) === "object" && Object.prototype.toString.call(a) === "[object Date]";
  }
  t.exports = e.default;
})(f_, f_.exports);
var _9e = f_.exports, __ = { exports: {} };
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var r = n(Q8), o = n(Bn);
  function i(a) {
    (0, o.default)(1, arguments);
    var s = Object.prototype.toString.call(a);
    return a instanceof Date || (0, r.default)(a) === "object" && s === "[object Date]" ? new Date(a.getTime()) : typeof a == "number" || s === "[object Number]" ? new Date(a) : ((typeof a == "string" || s === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
  }
  t.exports = e.default;
})(__, __.exports);
var So = __.exports;
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  var r = n(_9e), o = n(So), i = n(Bn);
  function a(s) {
    if ((0, i.default)(1, arguments), !(0, r.default)(s) && typeof s != "number")
      return !1;
    var l = (0, o.default)(s);
    return !isNaN(Number(l));
  }
  t.exports = e.default;
})(d_, d_.exports);
var E9e = d_.exports, E_ = { exports: {} }, p_ = { exports: {} }, m_ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    if (r === null || r === !0 || r === !1)
      return NaN;
    var o = Number(r);
    return isNaN(o) ? o : o < 0 ? Math.ceil(o) : Math.floor(o);
  }
  t.exports = e.default;
})(m_, m_.exports);
var Ja = m_.exports;
const p9e = /* @__PURE__ */ mf(Ja);
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  var r = n(Ja), o = n(So), i = n(Bn);
  function a(s, l) {
    (0, i.default)(2, arguments);
    var c = (0, o.default)(s).getTime(), u = (0, r.default)(l);
    return new Date(c + u);
  }
  t.exports = e.default;
})(p_, p_.exports);
var m9e = p_.exports;
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  var r = n(m9e), o = n(Bn), i = n(Ja);
  function a(s, l) {
    (0, o.default)(2, arguments);
    var c = (0, i.default)(l);
    return (0, r.default)(s, -c);
  }
  t.exports = e.default;
})(E_, E_.exports);
var N9e = E_.exports, N_ = { exports: {} }, v_ = { exports: {} };
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  var r = n(So), o = n(Bn), i = 864e5;
  function a(s) {
    (0, o.default)(1, arguments);
    var l = (0, r.default)(s), c = l.getTime();
    l.setUTCMonth(0, 1), l.setUTCHours(0, 0, 0, 0);
    var u = l.getTime(), d = c - u;
    return Math.floor(d / i) + 1;
  }
  t.exports = e.default;
})(v_, v_.exports);
var v9e = v_.exports, g_ = { exports: {} }, I_ = { exports: {} };
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var r = n(So), o = n(Bn);
  function i(a) {
    (0, o.default)(1, arguments);
    var s = 1, l = (0, r.default)(a), c = l.getUTCDay(), u = (c < s ? 7 : 0) + c - s;
    return l.setUTCDate(l.getUTCDate() - u), l.setUTCHours(0, 0, 0, 0), l;
  }
  t.exports = e.default;
})(I_, I_.exports);
var y2 = I_.exports, O_ = { exports: {} }, A_ = { exports: {} };
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  var r = n(So), o = n(Bn), i = n(y2);
  function a(s) {
    (0, o.default)(1, arguments);
    var l = (0, r.default)(s), c = l.getUTCFullYear(), u = /* @__PURE__ */ new Date(0);
    u.setUTCFullYear(c + 1, 0, 4), u.setUTCHours(0, 0, 0, 0);
    var d = (0, i.default)(u), f = /* @__PURE__ */ new Date(0);
    f.setUTCFullYear(c, 0, 4), f.setUTCHours(0, 0, 0, 0);
    var h = (0, i.default)(f);
    return l.getTime() >= d.getTime() ? c + 1 : l.getTime() >= h.getTime() ? c : c - 1;
  }
  t.exports = e.default;
})(A_, A_.exports);
var eS = A_.exports;
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  var r = n(eS), o = n(y2), i = n(Bn);
  function a(s) {
    (0, i.default)(1, arguments);
    var l = (0, r.default)(s), c = /* @__PURE__ */ new Date(0);
    c.setUTCFullYear(l, 0, 4), c.setUTCHours(0, 0, 0, 0);
    var u = (0, o.default)(c);
    return u;
  }
  t.exports = e.default;
})(O_, O_.exports);
var g9e = O_.exports;
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = l;
  var r = n(So), o = n(y2), i = n(g9e), a = n(Bn), s = 6048e5;
  function l(c) {
    (0, a.default)(1, arguments);
    var u = (0, r.default)(c), d = (0, o.default)(u).getTime() - (0, i.default)(u).getTime();
    return Math.round(d / s) + 1;
  }
  t.exports = e.default;
})(g_, g_.exports);
var I9e = g_.exports, D_ = { exports: {} }, C_ = { exports: {} }, Qa = {};
Object.defineProperty(Qa, "__esModule", {
  value: !0
});
Qa.getDefaultOptions = O9e;
Qa.setDefaultOptions = A9e;
var tS = {};
function O9e() {
  return tS;
}
function A9e(t) {
  tS = t;
}
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = s;
  var r = n(So), o = n(Bn), i = n(Ja), a = Qa;
  function s(l, c) {
    var u, d, f, h, _, E, m, N;
    (0, o.default)(1, arguments);
    var I = (0, a.getDefaultOptions)(), O = (0, i.default)((u = (d = (f = (h = c == null ? void 0 : c.weekStartsOn) !== null && h !== void 0 ? h : c == null || (_ = c.locale) === null || _ === void 0 || (E = _.options) === null || E === void 0 ? void 0 : E.weekStartsOn) !== null && f !== void 0 ? f : I.weekStartsOn) !== null && d !== void 0 ? d : (m = I.locale) === null || m === void 0 || (N = m.options) === null || N === void 0 ? void 0 : N.weekStartsOn) !== null && u !== void 0 ? u : 0);
    if (!(O >= 0 && O <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var p = (0, r.default)(l), C = p.getUTCDay(), D = (C < O ? 7 : 0) + C - O;
    return p.setUTCDate(p.getUTCDate() - D), p.setUTCHours(0, 0, 0, 0), p;
  }
  t.exports = e.default;
})(C_, C_.exports);
var L2 = C_.exports, S_ = { exports: {} }, w_ = { exports: {} };
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = l;
  var r = n(So), o = n(Bn), i = n(L2), a = n(Ja), s = Qa;
  function l(c, u) {
    var d, f, h, _, E, m, N, I;
    (0, o.default)(1, arguments);
    var O = (0, r.default)(c), p = O.getUTCFullYear(), C = (0, s.getDefaultOptions)(), D = (0, a.default)((d = (f = (h = (_ = u == null ? void 0 : u.firstWeekContainsDate) !== null && _ !== void 0 ? _ : u == null || (E = u.locale) === null || E === void 0 || (m = E.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && h !== void 0 ? h : C.firstWeekContainsDate) !== null && f !== void 0 ? f : (N = C.locale) === null || N === void 0 || (I = N.options) === null || I === void 0 ? void 0 : I.firstWeekContainsDate) !== null && d !== void 0 ? d : 1);
    if (!(D >= 1 && D <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var T = /* @__PURE__ */ new Date(0);
    T.setUTCFullYear(p + 1, 0, D), T.setUTCHours(0, 0, 0, 0);
    var k = (0, i.default)(T, u), G = /* @__PURE__ */ new Date(0);
    G.setUTCFullYear(p, 0, D), G.setUTCHours(0, 0, 0, 0);
    var b = (0, i.default)(G, u);
    return O.getTime() >= k.getTime() ? p + 1 : O.getTime() >= b.getTime() ? p : p - 1;
  }
  t.exports = e.default;
})(w_, w_.exports);
var nS = w_.exports;
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = l;
  var r = n(nS), o = n(Bn), i = n(L2), a = n(Ja), s = Qa;
  function l(c, u) {
    var d, f, h, _, E, m, N, I;
    (0, o.default)(1, arguments);
    var O = (0, s.getDefaultOptions)(), p = (0, a.default)((d = (f = (h = (_ = u == null ? void 0 : u.firstWeekContainsDate) !== null && _ !== void 0 ? _ : u == null || (E = u.locale) === null || E === void 0 || (m = E.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && h !== void 0 ? h : O.firstWeekContainsDate) !== null && f !== void 0 ? f : (N = O.locale) === null || N === void 0 || (I = N.options) === null || I === void 0 ? void 0 : I.firstWeekContainsDate) !== null && d !== void 0 ? d : 1), C = (0, r.default)(c, u), D = /* @__PURE__ */ new Date(0);
    D.setUTCFullYear(C, 0, p), D.setUTCHours(0, 0, 0, 0);
    var T = (0, i.default)(D, u);
    return T;
  }
  t.exports = e.default;
})(S_, S_.exports);
var D9e = S_.exports;
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = l;
  var r = n(So), o = n(L2), i = n(D9e), a = n(Bn), s = 6048e5;
  function l(c, u) {
    (0, a.default)(1, arguments);
    var d = (0, r.default)(c), f = (0, o.default)(d, u).getTime() - (0, i.default)(d, u).getTime();
    return Math.round(f / s) + 1;
  }
  t.exports = e.default;
})(D_, D_.exports);
var C9e = D_.exports, T_ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r, o) {
    for (var i = r < 0 ? "-" : "", a = Math.abs(r).toString(); a.length < o; )
      a = "0" + a;
    return i + a;
  }
  t.exports = e.default;
})(T_, T_.exports);
var rS = T_.exports, b_ = { exports: {} };
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = n(rS), o = {
    // Year
    y: function(s, l) {
      var c = s.getUTCFullYear(), u = c > 0 ? c : 1 - c;
      return (0, r.default)(l === "yy" ? u % 100 : u, l.length);
    },
    // Month
    M: function(s, l) {
      var c = s.getUTCMonth();
      return l === "M" ? String(c + 1) : (0, r.default)(c + 1, 2);
    },
    // Day of the month
    d: function(s, l) {
      return (0, r.default)(s.getUTCDate(), l.length);
    },
    // AM or PM
    a: function(s, l) {
      var c = s.getUTCHours() / 12 >= 1 ? "pm" : "am";
      switch (l) {
        case "a":
        case "aa":
          return c.toUpperCase();
        case "aaa":
          return c;
        case "aaaaa":
          return c[0];
        case "aaaa":
        default:
          return c === "am" ? "a.m." : "p.m.";
      }
    },
    // Hour [1-12]
    h: function(s, l) {
      return (0, r.default)(s.getUTCHours() % 12 || 12, l.length);
    },
    // Hour [0-23]
    H: function(s, l) {
      return (0, r.default)(s.getUTCHours(), l.length);
    },
    // Minute
    m: function(s, l) {
      return (0, r.default)(s.getUTCMinutes(), l.length);
    },
    // Second
    s: function(s, l) {
      return (0, r.default)(s.getUTCSeconds(), l.length);
    },
    // Fraction of second
    S: function(s, l) {
      var c = l.length, u = s.getUTCMilliseconds(), d = Math.floor(u * Math.pow(10, c - 3));
      return (0, r.default)(d, l.length);
    }
  }, i = o;
  e.default = i, t.exports = e.default;
})(b_, b_.exports);
var S9e = b_.exports;
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = n(v9e), o = n(I9e), i = n(eS), a = n(C9e), s = n(nS), l = n(rS), c = n(S9e), u = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }, d = {
    // Era
    G: function(N, I, O) {
      var p = N.getUTCFullYear() > 0 ? 1 : 0;
      switch (I) {
        case "G":
        case "GG":
        case "GGG":
          return O.era(p, {
            width: "abbreviated"
          });
        case "GGGGG":
          return O.era(p, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return O.era(p, {
            width: "wide"
          });
      }
    },
    // Year
    y: function(N, I, O) {
      if (I === "yo") {
        var p = N.getUTCFullYear(), C = p > 0 ? p : 1 - p;
        return O.ordinalNumber(C, {
          unit: "year"
        });
      }
      return c.default.y(N, I);
    },
    // Local week-numbering year
    Y: function(N, I, O, p) {
      var C = (0, s.default)(N, p), D = C > 0 ? C : 1 - C;
      if (I === "YY") {
        var T = D % 100;
        return (0, l.default)(T, 2);
      }
      return I === "Yo" ? O.ordinalNumber(D, {
        unit: "year"
      }) : (0, l.default)(D, I.length);
    },
    // ISO week-numbering year
    R: function(N, I) {
      var O = (0, i.default)(N);
      return (0, l.default)(O, I.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(N, I) {
      var O = N.getUTCFullYear();
      return (0, l.default)(O, I.length);
    },
    // Quarter
    Q: function(N, I, O) {
      var p = Math.ceil((N.getUTCMonth() + 1) / 3);
      switch (I) {
        case "Q":
          return String(p);
        case "QQ":
          return (0, l.default)(p, 2);
        case "Qo":
          return O.ordinalNumber(p, {
            unit: "quarter"
          });
        case "QQQ":
          return O.quarter(p, {
            width: "abbreviated",
            context: "formatting"
          });
        case "QQQQQ":
          return O.quarter(p, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return O.quarter(p, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone quarter
    q: function(N, I, O) {
      var p = Math.ceil((N.getUTCMonth() + 1) / 3);
      switch (I) {
        case "q":
          return String(p);
        case "qq":
          return (0, l.default)(p, 2);
        case "qo":
          return O.ordinalNumber(p, {
            unit: "quarter"
          });
        case "qqq":
          return O.quarter(p, {
            width: "abbreviated",
            context: "standalone"
          });
        case "qqqqq":
          return O.quarter(p, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return O.quarter(p, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Month
    M: function(N, I, O) {
      var p = N.getUTCMonth();
      switch (I) {
        case "M":
        case "MM":
          return c.default.M(N, I);
        case "Mo":
          return O.ordinalNumber(p + 1, {
            unit: "month"
          });
        case "MMM":
          return O.month(p, {
            width: "abbreviated",
            context: "formatting"
          });
        case "MMMMM":
          return O.month(p, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return O.month(p, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone month
    L: function(N, I, O) {
      var p = N.getUTCMonth();
      switch (I) {
        case "L":
          return String(p + 1);
        case "LL":
          return (0, l.default)(p + 1, 2);
        case "Lo":
          return O.ordinalNumber(p + 1, {
            unit: "month"
          });
        case "LLL":
          return O.month(p, {
            width: "abbreviated",
            context: "standalone"
          });
        case "LLLLL":
          return O.month(p, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return O.month(p, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Local week of year
    w: function(N, I, O, p) {
      var C = (0, a.default)(N, p);
      return I === "wo" ? O.ordinalNumber(C, {
        unit: "week"
      }) : (0, l.default)(C, I.length);
    },
    // ISO week of year
    I: function(N, I, O) {
      var p = (0, o.default)(N);
      return I === "Io" ? O.ordinalNumber(p, {
        unit: "week"
      }) : (0, l.default)(p, I.length);
    },
    // Day of the month
    d: function(N, I, O) {
      return I === "do" ? O.ordinalNumber(N.getUTCDate(), {
        unit: "date"
      }) : c.default.d(N, I);
    },
    // Day of year
    D: function(N, I, O) {
      var p = (0, r.default)(N);
      return I === "Do" ? O.ordinalNumber(p, {
        unit: "dayOfYear"
      }) : (0, l.default)(p, I.length);
    },
    // Day of week
    E: function(N, I, O) {
      var p = N.getUTCDay();
      switch (I) {
        case "E":
        case "EE":
        case "EEE":
          return O.day(p, {
            width: "abbreviated",
            context: "formatting"
          });
        case "EEEEE":
          return O.day(p, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return O.day(p, {
            width: "short",
            context: "formatting"
          });
        case "EEEE":
        default:
          return O.day(p, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Local day of week
    e: function(N, I, O, p) {
      var C = N.getUTCDay(), D = (C - p.weekStartsOn + 8) % 7 || 7;
      switch (I) {
        case "e":
          return String(D);
        case "ee":
          return (0, l.default)(D, 2);
        case "eo":
          return O.ordinalNumber(D, {
            unit: "day"
          });
        case "eee":
          return O.day(C, {
            width: "abbreviated",
            context: "formatting"
          });
        case "eeeee":
          return O.day(C, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return O.day(C, {
            width: "short",
            context: "formatting"
          });
        case "eeee":
        default:
          return O.day(C, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone local day of week
    c: function(N, I, O, p) {
      var C = N.getUTCDay(), D = (C - p.weekStartsOn + 8) % 7 || 7;
      switch (I) {
        case "c":
          return String(D);
        case "cc":
          return (0, l.default)(D, I.length);
        case "co":
          return O.ordinalNumber(D, {
            unit: "day"
          });
        case "ccc":
          return O.day(C, {
            width: "abbreviated",
            context: "standalone"
          });
        case "ccccc":
          return O.day(C, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return O.day(C, {
            width: "short",
            context: "standalone"
          });
        case "cccc":
        default:
          return O.day(C, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // ISO day of week
    i: function(N, I, O) {
      var p = N.getUTCDay(), C = p === 0 ? 7 : p;
      switch (I) {
        case "i":
          return String(C);
        case "ii":
          return (0, l.default)(C, I.length);
        case "io":
          return O.ordinalNumber(C, {
            unit: "day"
          });
        case "iii":
          return O.day(p, {
            width: "abbreviated",
            context: "formatting"
          });
        case "iiiii":
          return O.day(p, {
            width: "narrow",
            context: "formatting"
          });
        case "iiiiii":
          return O.day(p, {
            width: "short",
            context: "formatting"
          });
        case "iiii":
        default:
          return O.day(p, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM or PM
    a: function(N, I, O) {
      var p = N.getUTCHours(), C = p / 12 >= 1 ? "pm" : "am";
      switch (I) {
        case "a":
        case "aa":
          return O.dayPeriod(C, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return O.dayPeriod(C, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return O.dayPeriod(C, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return O.dayPeriod(C, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM, PM, midnight, noon
    b: function(N, I, O) {
      var p = N.getUTCHours(), C;
      switch (p === 12 ? C = u.noon : p === 0 ? C = u.midnight : C = p / 12 >= 1 ? "pm" : "am", I) {
        case "b":
        case "bb":
          return O.dayPeriod(C, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return O.dayPeriod(C, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return O.dayPeriod(C, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return O.dayPeriod(C, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(N, I, O) {
      var p = N.getUTCHours(), C;
      switch (p >= 17 ? C = u.evening : p >= 12 ? C = u.afternoon : p >= 4 ? C = u.morning : C = u.night, I) {
        case "B":
        case "BB":
        case "BBB":
          return O.dayPeriod(C, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return O.dayPeriod(C, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return O.dayPeriod(C, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Hour [1-12]
    h: function(N, I, O) {
      if (I === "ho") {
        var p = N.getUTCHours() % 12;
        return p === 0 && (p = 12), O.ordinalNumber(p, {
          unit: "hour"
        });
      }
      return c.default.h(N, I);
    },
    // Hour [0-23]
    H: function(N, I, O) {
      return I === "Ho" ? O.ordinalNumber(N.getUTCHours(), {
        unit: "hour"
      }) : c.default.H(N, I);
    },
    // Hour [0-11]
    K: function(N, I, O) {
      var p = N.getUTCHours() % 12;
      return I === "Ko" ? O.ordinalNumber(p, {
        unit: "hour"
      }) : (0, l.default)(p, I.length);
    },
    // Hour [1-24]
    k: function(N, I, O) {
      var p = N.getUTCHours();
      return p === 0 && (p = 24), I === "ko" ? O.ordinalNumber(p, {
        unit: "hour"
      }) : (0, l.default)(p, I.length);
    },
    // Minute
    m: function(N, I, O) {
      return I === "mo" ? O.ordinalNumber(N.getUTCMinutes(), {
        unit: "minute"
      }) : c.default.m(N, I);
    },
    // Second
    s: function(N, I, O) {
      return I === "so" ? O.ordinalNumber(N.getUTCSeconds(), {
        unit: "second"
      }) : c.default.s(N, I);
    },
    // Fraction of second
    S: function(N, I) {
      return c.default.S(N, I);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(N, I, O, p) {
      var C = p._originalDate || N, D = C.getTimezoneOffset();
      if (D === 0)
        return "Z";
      switch (I) {
        case "X":
          return h(D);
        case "XXXX":
        case "XX":
          return _(D);
        case "XXXXX":
        case "XXX":
        default:
          return _(D, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(N, I, O, p) {
      var C = p._originalDate || N, D = C.getTimezoneOffset();
      switch (I) {
        case "x":
          return h(D);
        case "xxxx":
        case "xx":
          return _(D);
        case "xxxxx":
        case "xxx":
        default:
          return _(D, ":");
      }
    },
    // Timezone (GMT)
    O: function(N, I, O, p) {
      var C = p._originalDate || N, D = C.getTimezoneOffset();
      switch (I) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + f(D, ":");
        case "OOOO":
        default:
          return "GMT" + _(D, ":");
      }
    },
    // Timezone (specific non-location)
    z: function(N, I, O, p) {
      var C = p._originalDate || N, D = C.getTimezoneOffset();
      switch (I) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + f(D, ":");
        case "zzzz":
        default:
          return "GMT" + _(D, ":");
      }
    },
    // Seconds timestamp
    t: function(N, I, O, p) {
      var C = p._originalDate || N, D = Math.floor(C.getTime() / 1e3);
      return (0, l.default)(D, I.length);
    },
    // Milliseconds timestamp
    T: function(N, I, O, p) {
      var C = p._originalDate || N, D = C.getTime();
      return (0, l.default)(D, I.length);
    }
  };
  function f(m, N) {
    var I = m > 0 ? "-" : "+", O = Math.abs(m), p = Math.floor(O / 60), C = O % 60;
    if (C === 0)
      return I + String(p);
    var D = N || "";
    return I + String(p) + D + (0, l.default)(C, 2);
  }
  function h(m, N) {
    if (m % 60 === 0) {
      var I = m > 0 ? "-" : "+";
      return I + (0, l.default)(Math.abs(m) / 60, 2);
    }
    return _(m, N);
  }
  function _(m, N) {
    var I = N || "", O = m > 0 ? "-" : "+", p = Math.abs(m), C = (0, l.default)(Math.floor(p / 60), 2), D = (0, l.default)(p % 60, 2);
    return O + C + I + D;
  }
  var E = d;
  e.default = E, t.exports = e.default;
})(N_, N_.exports);
var w9e = N_.exports, R_ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = function(l, c) {
    switch (l) {
      case "P":
        return c.date({
          width: "short"
        });
      case "PP":
        return c.date({
          width: "medium"
        });
      case "PPP":
        return c.date({
          width: "long"
        });
      case "PPPP":
      default:
        return c.date({
          width: "full"
        });
    }
  }, r = function(l, c) {
    switch (l) {
      case "p":
        return c.time({
          width: "short"
        });
      case "pp":
        return c.time({
          width: "medium"
        });
      case "ppp":
        return c.time({
          width: "long"
        });
      case "pppp":
      default:
        return c.time({
          width: "full"
        });
    }
  }, o = function(l, c) {
    var u = l.match(/(P+)(p+)?/) || [], d = u[1], f = u[2];
    if (!f)
      return n(l, c);
    var h;
    switch (d) {
      case "P":
        h = c.dateTime({
          width: "short"
        });
        break;
      case "PP":
        h = c.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        h = c.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        h = c.dateTime({
          width: "full"
        });
        break;
    }
    return h.replace("{{date}}", n(d, c)).replace("{{time}}", r(f, c));
  }, i = {
    p: r,
    P: o
  }, a = i;
  e.default = a, t.exports = e.default;
})(R_, R_.exports);
var T9e = R_.exports, M_ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    var o = new Date(Date.UTC(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()));
    return o.setUTCFullYear(r.getFullYear()), r.getTime() - o.getTime();
  }
  t.exports = e.default;
})(M_, M_.exports);
var oS = M_.exports;
const _O = /* @__PURE__ */ mf(oS);
var Nu = {};
Object.defineProperty(Nu, "__esModule", {
  value: !0
});
Nu.isProtectedDayOfYearToken = M9e;
Nu.isProtectedWeekYearToken = P9e;
Nu.throwProtectedError = y9e;
var b9e = ["D", "DD"], R9e = ["YY", "YYYY"];
function M9e(t) {
  return b9e.indexOf(t) !== -1;
}
function P9e(t) {
  return R9e.indexOf(t) !== -1;
}
function y9e(t, e, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var P_ = { exports: {} }, y_ = { exports: {} }, L_ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, r = function(a, s, l) {
    var c, u = n[a];
    return typeof u == "string" ? c = u : s === 1 ? c = u.one : c = u.other.replace("{{count}}", s.toString()), l != null && l.addSuffix ? l.comparison && l.comparison > 0 ? "in " + c : c + " ago" : c;
  }, o = r;
  e.default = o, t.exports = e.default;
})(L_, L_.exports);
var L9e = L_.exports, x_ = { exports: {} }, U_ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    return function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = o.width ? String(o.width) : r.defaultWidth, a = r.formats[i] || r.formats[r.defaultWidth];
      return a;
    };
  }
  t.exports = e.default;
})(U_, U_.exports);
var x9e = U_.exports;
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = n(x9e), o = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, i = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, a = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: a,
      defaultWidth: "full"
    })
  }, l = s;
  e.default = l, t.exports = e.default;
})(x_, x_.exports);
var U9e = x_.exports, $_ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, r = function(a, s, l, c) {
    return n[a];
  }, o = r;
  e.default = o, t.exports = e.default;
})($_, $_.exports);
var $9e = $_.exports, k_ = { exports: {} }, B_ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    return function(o, i) {
      var a = i != null && i.context ? String(i.context) : "standalone", s;
      if (a === "formatting" && r.formattingValues) {
        var l = r.defaultFormattingWidth || r.defaultWidth, c = i != null && i.width ? String(i.width) : l;
        s = r.formattingValues[c] || r.formattingValues[l];
      } else {
        var u = r.defaultWidth, d = i != null && i.width ? String(i.width) : r.defaultWidth;
        s = r.values[d] || r.values[u];
      }
      var f = r.argumentCallback ? r.argumentCallback(o) : o;
      return s[f];
    };
  }
  t.exports = e.default;
})(B_, B_.exports);
var k9e = B_.exports;
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = n(k9e), o = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, i = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, a = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }, s = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, c = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, u = function(_, E) {
    var m = Number(_), N = m % 100;
    if (N > 20 || N < 10)
      switch (N % 10) {
        case 1:
          return m + "st";
        case 2:
          return m + "nd";
        case 3:
          return m + "rd";
      }
    return m + "th";
  }, d = {
    ordinalNumber: u,
    era: (0, r.default)({
      values: o,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: i,
      defaultWidth: "wide",
      argumentCallback: function(_) {
        return _ - 1;
      }
    }),
    month: (0, r.default)({
      values: a,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: l,
      defaultWidth: "wide",
      formattingValues: c,
      defaultFormattingWidth: "wide"
    })
  }, f = d;
  e.default = f, t.exports = e.default;
})(k_, k_.exports);
var B9e = k_.exports, G_ = { exports: {} }, F_ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(i) {
    return function(a) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = s.width, c = l && i.matchPatterns[l] || i.matchPatterns[i.defaultMatchWidth], u = a.match(c);
      if (!u)
        return null;
      var d = u[0], f = l && i.parsePatterns[l] || i.parsePatterns[i.defaultParseWidth], h = Array.isArray(f) ? o(f, function(m) {
        return m.test(d);
      }) : r(f, function(m) {
        return m.test(d);
      }), _;
      _ = i.valueCallback ? i.valueCallback(h) : h, _ = s.valueCallback ? s.valueCallback(_) : _;
      var E = a.slice(d.length);
      return {
        value: _,
        rest: E
      };
    };
  }
  function r(i, a) {
    for (var s in i)
      if (i.hasOwnProperty(s) && a(i[s]))
        return s;
  }
  function o(i, a) {
    for (var s = 0; s < i.length; s++)
      if (a(i[s]))
        return s;
  }
  t.exports = e.default;
})(F_, F_.exports);
var G9e = F_.exports, V_ = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  function n(r) {
    return function(o) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = o.match(r.matchPattern);
      if (!a)
        return null;
      var s = a[0], l = o.match(r.parsePattern);
      if (!l)
        return null;
      var c = r.valueCallback ? r.valueCallback(l[0]) : l[0];
      c = i.valueCallback ? i.valueCallback(c) : c;
      var u = o.slice(s.length);
      return {
        value: c,
        rest: u
      };
    };
  }
  t.exports = e.default;
})(V_, V_.exports);
var F9e = V_.exports;
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = n(G9e), o = n(F9e), i = /^(\d+)(th|st|nd|rd)?/i, a = /\d+/i, s = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, l = {
    any: [/^b/i, /^(a|c)/i]
  }, c = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, d = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, f = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, h = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, _ = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, E = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, m = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, N = {
    ordinalNumber: (0, o.default)({
      matchPattern: i,
      parsePattern: a,
      valueCallback: function(p) {
        return parseInt(p, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: l,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(p) {
        return p + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: d,
      defaultMatchWidth: "wide",
      parsePatterns: f,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: h,
      defaultMatchWidth: "wide",
      parsePatterns: _,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: E,
      defaultMatchWidth: "any",
      parsePatterns: m,
      defaultParseWidth: "any"
    })
  }, I = N;
  e.default = I, t.exports = e.default;
})(G_, G_.exports);
var V9e = G_.exports;
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = n(L9e), o = n(U9e), i = n($9e), a = n(B9e), s = n(V9e), l = {
    code: "en-US",
    formatDistance: r.default,
    formatLong: o.default,
    formatRelative: i.default,
    localize: a.default,
    match: s.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, c = l;
  e.default = c, t.exports = e.default;
})(y_, y_.exports);
var H9e = y_.exports;
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = n(H9e), o = r.default;
  e.default = o, t.exports = e.default;
})(P_, P_.exports);
var W9e = P_.exports;
(function(t, e) {
  var n = Gt.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = O;
  var r = n(E9e), o = n(N9e), i = n(So), a = n(w9e), s = n(T9e), l = n(oS), c = Nu, u = n(Ja), d = n(Bn), f = Qa, h = n(W9e), _ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, E = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, m = /^'([^]*?)'?$/, N = /''/g, I = /[a-zA-Z]/;
  function O(C, D, T) {
    var k, G, b, P, $, y, L, w, R, B, U, K, Z, X, J, ae, re, j;
    (0, d.default)(2, arguments);
    var ne = String(D), Ee = (0, f.getDefaultOptions)(), fe = (k = (G = T == null ? void 0 : T.locale) !== null && G !== void 0 ? G : Ee.locale) !== null && k !== void 0 ? k : h.default, Oe = (0, u.default)((b = (P = ($ = (y = T == null ? void 0 : T.firstWeekContainsDate) !== null && y !== void 0 ? y : T == null || (L = T.locale) === null || L === void 0 || (w = L.options) === null || w === void 0 ? void 0 : w.firstWeekContainsDate) !== null && $ !== void 0 ? $ : Ee.firstWeekContainsDate) !== null && P !== void 0 ? P : (R = Ee.locale) === null || R === void 0 || (B = R.options) === null || B === void 0 ? void 0 : B.firstWeekContainsDate) !== null && b !== void 0 ? b : 1);
    if (!(Oe >= 1 && Oe <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var ce = (0, u.default)((U = (K = (Z = (X = T == null ? void 0 : T.weekStartsOn) !== null && X !== void 0 ? X : T == null || (J = T.locale) === null || J === void 0 || (ae = J.options) === null || ae === void 0 ? void 0 : ae.weekStartsOn) !== null && Z !== void 0 ? Z : Ee.weekStartsOn) !== null && K !== void 0 ? K : (re = Ee.locale) === null || re === void 0 || (j = re.options) === null || j === void 0 ? void 0 : j.weekStartsOn) !== null && U !== void 0 ? U : 0);
    if (!(ce >= 0 && ce <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!fe.localize)
      throw new RangeError("locale must contain localize property");
    if (!fe.formatLong)
      throw new RangeError("locale must contain formatLong property");
    var Se = (0, i.default)(C);
    if (!(0, r.default)(Se))
      throw new RangeError("Invalid time value");
    var se = (0, l.default)(Se), Ie = (0, o.default)(Se, se), we = {
      firstWeekContainsDate: Oe,
      weekStartsOn: ce,
      locale: fe,
      _originalDate: Se
    }, le = ne.match(E).map(function(De) {
      var pe = De[0];
      if (pe === "p" || pe === "P") {
        var Le = s.default[pe];
        return Le(De, fe.formatLong);
      }
      return De;
    }).join("").match(_).map(function(De) {
      if (De === "''")
        return "'";
      var pe = De[0];
      if (pe === "'")
        return p(De);
      var Le = a.default[pe];
      if (Le)
        return !(T != null && T.useAdditionalWeekYearTokens) && (0, c.isProtectedWeekYearToken)(De) && (0, c.throwProtectedError)(De, D, String(C)), !(T != null && T.useAdditionalDayOfYearTokens) && (0, c.isProtectedDayOfYearToken)(De) && (0, c.throwProtectedError)(De, D, String(C)), Le(Ie, De, fe.localize, we);
      if (pe.match(I))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + pe + "`");
      return De;
    }).join("");
    return le;
  }
  function p(C) {
    var D = C.match(m);
    return D ? D[1].replace(N, "'") : C;
  }
  t.exports = e.default;
})(u_, u_.exports);
var Y9e = u_.exports;
const K9e = /* @__PURE__ */ mf(Y9e);
function EO(t, e, n) {
  var r = q9e(t, n.timeZone, n.locale);
  return r.formatToParts ? z9e(r, e) : Z9e(r, e);
}
function z9e(t, e) {
  for (var n = t.formatToParts(e), r = n.length - 1; r >= 0; --r)
    if (n[r].type === "timeZoneName")
      return n[r].value;
}
function Z9e(t, e) {
  var n = t.format(e).replace(/\u200E/g, ""), r = / [\w-+ ]+$/.exec(n);
  return r ? r[0].substr(1) : "";
}
function q9e(t, e, n) {
  if (n && !n.code)
    throw new Error(
      "date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`"
    );
  return new Intl.DateTimeFormat(n ? [n.code, "en-US"] : void 0, {
    timeZone: e,
    timeZoneName: t
  });
}
function X9e(t, e) {
  var n = eRe(e);
  return n.formatToParts ? J9e(n, t) : Q9e(n, t);
}
var j9e = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function J9e(t, e) {
  try {
    for (var n = t.formatToParts(e), r = [], o = 0; o < n.length; o++) {
      var i = j9e[n[o].type];
      i >= 0 && (r[i] = parseInt(n[o].value, 10));
    }
    return r;
  } catch (a) {
    if (a instanceof RangeError)
      return [NaN];
    throw a;
  }
}
function Q9e(t, e) {
  var n = t.format(e), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [r[3], r[1], r[2], r[4], r[5], r[6]];
}
var Ph = {};
function eRe(t) {
  if (!Ph[t]) {
    var e = new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), n = e === "06/25/2014, 00:00:00" || e === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    Ph[t] = n ? new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return Ph[t];
}
function iS(t, e, n, r, o, i, a) {
  var s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(t, e, n), s.setUTCHours(r, o, i, a), s;
}
var pO = 36e5, tRe = 6e4, yh = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function x2(t, e, n) {
  var r, o;
  if (!t || (r = yh.timezoneZ.exec(t), r))
    return 0;
  var i;
  if (r = yh.timezoneHH.exec(t), r)
    return i = parseInt(r[1], 10), mO(i) ? -(i * pO) : NaN;
  if (r = yh.timezoneHHMM.exec(t), r) {
    i = parseInt(r[2], 10);
    var a = parseInt(r[3], 10);
    return mO(i, a) ? (o = Math.abs(i) * pO + a * tRe, r[1] === "+" ? -o : o) : NaN;
  }
  if (oRe(t)) {
    e = new Date(e || Date.now());
    var s = n ? e : nRe(e), l = H_(s, t), c = n ? l : rRe(e, l, t);
    return -c;
  }
  return NaN;
}
function nRe(t) {
  return iS(
    t.getFullYear(),
    t.getMonth(),
    t.getDate(),
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  );
}
function H_(t, e) {
  var n = X9e(t, e), r = iS(
    n[0],
    n[1] - 1,
    n[2],
    n[3] % 24,
    n[4],
    n[5],
    0
  ).getTime(), o = t.getTime(), i = o % 1e3;
  return o -= i >= 0 ? i : 1e3 + i, r - o;
}
function rRe(t, e, n) {
  var r = t.getTime(), o = r - e, i = H_(new Date(o), n);
  if (e === i)
    return e;
  o -= i - e;
  var a = H_(new Date(o), n);
  return i === a ? i : Math.max(i, a);
}
function mO(t, e) {
  return -23 <= t && t <= 23 && (e == null || 0 <= e && e <= 59);
}
var NO = {};
function oRe(t) {
  if (NO[t])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: t }), NO[t] = !0, !0;
  } catch {
    return !1;
  }
}
var iRe = 60 * 1e3, aRe = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n, r) {
    var o = Lh(r.timeZone, t);
    if (o === 0)
      return "Z";
    switch (e) {
      case "X":
        return vO(o);
      case "XXXX":
      case "XX":
        return Ns(o);
      case "XXXXX":
      case "XXX":
      default:
        return Ns(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n, r) {
    var o = Lh(r.timeZone, t);
    switch (e) {
      case "x":
        return vO(o);
      case "xxxx":
      case "xx":
        return Ns(o);
      case "xxxxx":
      case "xxx":
      default:
        return Ns(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n, r) {
    var o = Lh(r.timeZone, t);
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + sRe(o, ":");
      case "OOOO":
      default:
        return "GMT" + Ns(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n, r) {
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return EO("short", t, r);
      case "zzzz":
      default:
        return EO("long", t, r);
    }
  }
};
function Lh(t, e) {
  var n = t ? x2(t, e, !0) / iRe : e.getTimezoneOffset();
  if (Number.isNaN(n))
    throw new RangeError("Invalid time zone specified: " + t);
  return n;
}
function df(t, e) {
  for (var n = t < 0 ? "-" : "", r = Math.abs(t).toString(); r.length < e; )
    r = "0" + r;
  return n + r;
}
function Ns(t, e) {
  var n = e || "", r = t > 0 ? "-" : "+", o = Math.abs(t), i = df(Math.floor(o / 60), 2), a = df(Math.floor(o % 60), 2);
  return r + i + n + a;
}
function vO(t, e) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + df(Math.abs(t) / 60, 2);
  }
  return Ns(t, e);
}
function sRe(t, e) {
  var n = t > 0 ? "-" : "+", r = Math.abs(t), o = Math.floor(r / 60), i = r % 60;
  if (i === 0)
    return n + String(o);
  var a = e || "";
  return n + String(o) + a + df(i, 2);
}
const lRe = aRe;
var cRe = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, xh = 36e5, gO = 6e4, uRe = 2, Pn = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: cRe
};
function aS(t, e) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = e || {}, r = n.additionalDigits == null ? uRe : p9e(n.additionalDigits);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]")
    return new Date(t.getTime());
  if (typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]")
    return new Date(t);
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var o = dRe(t), i = fRe(o.date, r), a = i.year, s = i.restDateString, l = hRe(s, a);
  if (isNaN(l))
    return /* @__PURE__ */ new Date(NaN);
  if (l) {
    var c = l.getTime(), u = 0, d;
    if (o.time && (u = _Re(o.time), isNaN(u)))
      return /* @__PURE__ */ new Date(NaN);
    if (o.timeZone || n.timeZone) {
      if (d = x2(o.timeZone || n.timeZone, new Date(c + u)), isNaN(d))
        return /* @__PURE__ */ new Date(NaN);
    } else
      d = _O(new Date(c + u)), d = _O(new Date(c + u + d));
    return new Date(c + u + d);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function dRe(t) {
  var e = {}, n = Pn.dateTimePattern.exec(t), r;
  if (n ? (e.date = n[1], r = n[3]) : (n = Pn.datePattern.exec(t), n ? (e.date = n[1], r = n[2]) : (e.date = null, r = t)), r) {
    var o = Pn.timeZone.exec(r);
    o ? (e.time = r.replace(o[1], ""), e.timeZone = o[1].trim()) : e.time = r;
  }
  return e;
}
function fRe(t, e) {
  var n = Pn.YYY[e], r = Pn.YYYYY[e], o;
  if (o = Pn.YYYY.exec(t) || r.exec(t), o) {
    var i = o[1];
    return {
      year: parseInt(i, 10),
      restDateString: t.slice(i.length)
    };
  }
  if (o = Pn.YY.exec(t) || n.exec(t), o) {
    var a = o[1];
    return {
      year: parseInt(a, 10) * 100,
      restDateString: t.slice(a.length)
    };
  }
  return {
    year: null
  };
}
function hRe(t, e) {
  if (e === null)
    return null;
  var n, r, o, i;
  if (t.length === 0)
    return r = /* @__PURE__ */ new Date(0), r.setUTCFullYear(e), r;
  if (n = Pn.MM.exec(t), n)
    return r = /* @__PURE__ */ new Date(0), o = parseInt(n[1], 10) - 1, OO(e, o) ? (r.setUTCFullYear(e, o), r) : /* @__PURE__ */ new Date(NaN);
  if (n = Pn.DDD.exec(t), n) {
    r = /* @__PURE__ */ new Date(0);
    var a = parseInt(n[1], 10);
    return mRe(e, a) ? (r.setUTCFullYear(e, 0, a), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = Pn.MMDD.exec(t), n) {
    r = /* @__PURE__ */ new Date(0), o = parseInt(n[1], 10) - 1;
    var s = parseInt(n[2], 10);
    return OO(e, o, s) ? (r.setUTCFullYear(e, o, s), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = Pn.Www.exec(t), n)
    return i = parseInt(n[1], 10) - 1, AO(e, i) ? IO(e, i) : /* @__PURE__ */ new Date(NaN);
  if (n = Pn.WwwD.exec(t), n) {
    i = parseInt(n[1], 10) - 1;
    var l = parseInt(n[2], 10) - 1;
    return AO(e, i, l) ? IO(e, i, l) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function _Re(t) {
  var e, n, r;
  if (e = Pn.HH.exec(t), e)
    return n = parseFloat(e[1].replace(",", ".")), Uh(n) ? n % 24 * xh : NaN;
  if (e = Pn.HHMM.exec(t), e)
    return n = parseInt(e[1], 10), r = parseFloat(e[2].replace(",", ".")), Uh(n, r) ? n % 24 * xh + r * gO : NaN;
  if (e = Pn.HHMMSS.exec(t), e) {
    n = parseInt(e[1], 10), r = parseInt(e[2], 10);
    var o = parseFloat(e[3].replace(",", "."));
    return Uh(n, r, o) ? n % 24 * xh + r * gO + o * 1e3 : NaN;
  }
  return null;
}
function IO(t, e, n) {
  e = e || 0, n = n || 0;
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  var o = r.getUTCDay() || 7, i = e * 7 + n + 1 - o;
  return r.setUTCDate(r.getUTCDate() + i), r;
}
var ERe = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], pRe = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function sS(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function OO(t, e, n) {
  if (e < 0 || e > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    var r = sS(t);
    if (r && n > pRe[e] || !r && n > ERe[e])
      return !1;
  }
  return !0;
}
function mRe(t, e) {
  if (e < 1)
    return !1;
  var n = sS(t);
  return !(n && e > 366 || !n && e > 365);
}
function AO(t, e, n) {
  return !(e < 0 || e > 52 || n != null && (n < 0 || n > 6));
}
function Uh(t, e, n) {
  return !(t != null && (t < 0 || t >= 25) || e != null && (e < 0 || e >= 60) || n != null && (n < 0 || n >= 60));
}
var NRe = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function vRe(t, e, n) {
  var r = String(e), o = n || {}, i = r.match(NRe);
  if (i) {
    var a = aS(o.originalDate || t, o);
    r = i.reduce(function(s, l) {
      if (l[0] === "'")
        return s;
      var c = s.indexOf(l), u = s[c - 1] === "'", d = s.replace(
        l,
        "'" + lRe[l[0]](a, l, null, o) + "'"
      );
      return u ? d.substring(0, c - 1) + d.substring(c + 1) : d;
    }, r);
  }
  return K9e(t, r, o);
}
function lS(t, e, n) {
  var r = aS(t, n), o = x2(e, r, !0), i = new Date(r.getTime() - o), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), a.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), a;
}
const gRe = {
  name: "SlideSummaryChart"
}, IRe = /* @__PURE__ */ Ne({
  ...gRe,
  props: {
    chart: {},
    metric: {},
    theme: {},
    slideType: {},
    readOnly: { type: Boolean }
  },
  setup(t) {
    const e = t, n = e.chart, r = {
      name: n.title ?? "Couldn't generate title",
      items: n.points.map((l) => ({ x: lS(l.x * 1e3, "UTC"), y: l.y }))
    }, o = n.data_type ?? "number", i = n.currency_code, a = e5(n.delta ?? 0, !n.increase), s = [2, 4, 7].includes(e.slideType);
    return (l, c) => (v(), A(ge, null, [
      H(X8, {
        theme: t.theme,
        title: M(n).title,
        total: M(n).total
      }, {
        default: q(() => [
          H(M(Dp), {
            delta: M(a),
            reverse: M(s),
            decimalPlaces: 2,
            threshold: 0
          }, null, 8, ["delta", "reverse"])
        ]),
        _: 1
      }, 8, ["theme", "title", "total"]),
      H(M(bOe), {
        series: [r],
        metric: { dataType: M(o), currency: M(i) },
        "chart-height": 188,
        "show-zero": "",
        "remove-interactivity": ""
      }, null, 8, ["series", "metric"])
    ], 64));
  }
});
const ORe = /* @__PURE__ */ Y(IRe, [["__scopeId", "data-v-e6d11171"]]), ARe = {}, DRe = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none"
};
function CRe(t, e) {
  return v(), A("svg", DRe, [...e[0] || (e[0] = [
    g("circle", {
      cx: "11",
      cy: "11",
      r: "11",
      fill: "#E6F7F0"
    }, null, -1),
    g("path", {
      d: "m14.5 9-5 5-2-2",
      stroke: "#00A861",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const SRe = /* @__PURE__ */ Y(ARe, [["render", CRe]]), wRe = {}, TRe = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none"
};
function bRe(t, e) {
  return v(), A("svg", TRe, [...e[0] || (e[0] = [
    g("circle", {
      cx: "11",
      cy: "11",
      r: "11",
      fill: "#FFEBEB"
    }, null, -1),
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11 6C10.4477 6 10 6.44772 10 7V11C10 11.5523 10.4477 12 11 12C11.5523 12 12 11.5523 12 11V7C12 6.44772 11.5523 6 11 6ZM11 16.5C11.8284 16.5 12.5 15.8284 12.5 15C12.5 14.1716 11.8284 13.5 11 13.5C10.1716 13.5 9.5 14.1716 9.5 15C9.5 15.8284 10.1716 16.5 11 16.5Z",
      fill: "#FF2828"
    }, null, -1)
  ])]);
}
const RRe = /* @__PURE__ */ Y(wRe, [["render", bRe]]), MRe = { class: "status-target" }, PRe = /* @__PURE__ */ Ne({
  __name: "StatusTarget",
  props: {
    showWarningIcon: { type: Boolean },
    status: {}
  },
  setup(t) {
    return (e, n) => (v(), A("div", MRe, [
      t.showWarningIcon ? (v(), te(RRe, { key: 0 })) : (v(), te(SRe, { key: 1 })),
      H(He, { width: "0.625rem" }),
      H(Ye, {
        as: "h5",
        weight: "600",
        size: "f-7",
        color: t.showWarningIcon ? "red" : "green"
      }, {
        default: q(() => [
          me(Q(t.status), 1)
        ]),
        _: 1
      }, 8, ["color"])
    ]));
  }
});
const yRe = /* @__PURE__ */ Y(PRe, [["__scopeId", "data-v-1afe238f"]]), LRe = {
  name: "SlideTargetChart"
}, xRe = /* @__PURE__ */ Ne({
  ...LRe,
  props: {
    chart: {},
    theme: {},
    slideType: {},
    readOnly: { type: Boolean }
  },
  setup(t) {
    const e = t, n = e.chart, r = n.points.map((l) => {
      const c = vRe(lS(l.x * 1e3, "UTC"), "do LLL");
      return {
        y: l.y,
        label: c
      };
    }), o = {
      axis: yt.Vertical,
      start: n.target.top,
      end: n.target.bottom,
      color: "green"
    }, i = x(() => e.chart.status === "On Target" ? !1 : e.chart.chart_type === "roas" && e.chart.status === "Below Target" || e.chart.chart_type === "cpa" && e.chart.status === "Over Target" || e.chart.chart_type === "spend" && e.chart.status === "Above Target"), a = n.data_type ?? "number", s = n.currency_code;
    return (l, c) => (v(), A(ge, null, [
      H(X8, {
        theme: t.theme,
        title: M(n).title,
        total: M(n).total
      }, {
        default: q(() => [
          H(yRe, {
            "show-warning-icon": i.value,
            status: M(n).status
          }, null, 8, ["show-warning-icon", "status"])
        ]),
        _: 1
      }, 8, ["theme", "title", "total"]),
      H(M(Ege), {
        items: M(r),
        metric: { dataType: M(a), currency: M(s) },
        areas: [o],
        "bar-width": 28,
        "chart-height": 180,
        "remove-interactivity": ""
      }, null, 8, ["items", "metric", "areas"])
    ], 64));
  }
});
const URe = /* @__PURE__ */ Y(xRe, [["__scopeId", "data-v-cc9d3c8b"]]), $Re = { class: "chart-width overflow-hidden" }, kRe = /* @__PURE__ */ Ne({
  __name: "SlideChartContainer",
  props: {
    chart: {},
    theme: {},
    readOnly: { type: Boolean },
    slideType: {}
  },
  setup(t) {
    const e = t, n = x(() => e.chart.type === "summary");
    return Ti("axisLabelsInsideChart", !0), (r, o) => (v(), A("div", {
      class: z(["slide-chart-container", t.readOnly ? "pdf-shadow-fix" : ""])
    }, [
      g("div", $Re, [
        (v(), te(zo(n.value ? ORe : URe), {
          chart: t.chart,
          theme: t.theme,
          "read-only": t.readOnly,
          "slide-type": t.slideType
        }, null, 8, ["chart", "theme", "read-only", "slide-type"]))
      ])
    ], 2));
  }
});
const BRe = /* @__PURE__ */ Y(kRe, [["__scopeId", "data-v-13aacb9e"]]);
var W_ = /* @__PURE__ */ ((t) => (t[t.ZERO = 0] = "ZERO", t[t.FIFTEEN = 15] = "FIFTEEN", t[t.THIRTY = 30] = "THIRTY", t[t.FORTY_FIVE = 45] = "FORTY_FIVE", t))(W_ || {});
const GRe = /* @__PURE__ */ Ne({
  __name: "SlideAdSchedule",
  props: {
    schedule: {},
    readOnly: { type: Boolean }
  },
  setup(t) {
    const e = t, n = x(() => {
      const r = {};
      return e.schedule.forEach((o) => {
        const i = typeof o.start_minute == "string" ? W_[o.start_minute] : o.start_minute, a = typeof o.end_minute == "string" ? W_[o.end_minute] : o.end_minute, s = {
          ...o,
          optimisation_target: "cpa",
          window_value: o.cpa,
          window_target: o.average_cpa,
          window_difference: o.cpa_ratio,
          start_hour: +o.start_hour,
          end_hour: +o.end_hour,
          start_minute: i,
          end_minute: a
        };
        if (r[o.day_of_week]) {
          r[o.day_of_week].push(s);
          return;
        }
        r[o.day_of_week] = [s];
      }), r;
    });
    return (r, o) => (v(), A("div", null, [
      H(J3e, {
        "ad-schedule": n.value,
        "remove-interactivity": ""
      }, null, 8, ["ad-schedule"])
    ]));
  }
}), FRe = {
  name: "ReportSlide",
  components: {
    SlideContainer: Q4e,
    SlideHeader: E5e,
    SlideFooter: C5e,
    SlideTable: T5e,
    SlideMetricSquares: G5e,
    SlideKeywordTable: K5e,
    // SlideTextContainer,
    SlideTextEditor: HTe,
    SlideCompanyLogo: F7,
    SlideAdContainer: Vbe,
    SlideChartContainer: BRe,
    SlideSegmentsTable: Kbe,
    SlideWorkSummaryTable: Qbe,
    SlideStatisticsGrid: r9e,
    SlideAdSchedule: GRe,
    SlideMap: s9e
  },
  props: {
    mock: {
      type: Boolean,
      required: !1
    },
    id: {
      type: String,
      required: !0
    },
    slideNum: {
      type: Number,
      required: !0
    },
    details: {
      type: Object,
      required: !0
    },
    user: {
      type: Object,
      required: !0
    },
    recipient: {
      type: Object,
      required: !0
    },
    date: {
      type: String,
      required: !0
    },
    /* For available properties, check out luckymetrics/src/common/reports/types#ReportSlide */
    slide: {
      type: Object,
      required: !0
    },
    /* Set the slides to read-only mode, used for rendering as a PDF */
    readOnly: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /* Report colours & typeface */
    theme: {
      type: Object,
      required: !0,
      default: {
        primary_colour: "#048bfb",
        accent_colour: "#71dafc",
        domain_colour: "#048bfb",
        typeface: "professional"
      }
    },
    slideBeingEdited: {
      type: String,
      required: !1
    },
    previewMode: {
      type: Boolean,
      required: !1
    },
    reportPeriod: {
      type: Object,
      required: !0
    }
  },
  emits: [
    "slide-text-reset",
    "slide-text-updated",
    "slide-deleted",
    "search-term-updated",
    "work-summary-button-clicked"
  ],
  setup(t, { emit: e }) {
    const n = W(!1), r = W(!1), o = x(() => !t.readOnly), i = x(() => !t.readOnly), a = x(() => {
      const h = t.slide.chart && t.slide.text, _ = t.slide.table && t.slide.text;
      return h || t.slide.chart && !t.slide.text && !t.slide.default || t.slide.type === 1 || t.slide.type === 24 ? "two-columns" : _ || t.slide.table && !t.slide.text && !t.slide.default || t.slide.category === 7 && t.slide.custom && t.slide.text ? "two-rows" : t.slide.text && !t.slide.table && !t.slide.custom && !t.slide.chart && !t.slide.ad ? "centered" : "top-centered";
    });
    function s(h) {
      e("slide-text-updated", h);
    }
    function l() {
      e("slide-text-reset");
    }
    function c({ id: h, deleting: _ }) {
      e("slide-deleted", _ ? 0 : 1), n.value = _;
    }
    function u() {
      r.value = !0, setTimeout(() => {
        r.value = !1;
      }, 200);
    }
    function d(h) {
      e("search-term-updated", h);
    }
    function f() {
      e("work-summary-button-clicked");
    }
    return {
      enableDelete: o,
      enableEdit: i,
      layoutType: a,
      // configureLayout,
      slideTextUpdated: s,
      slideTextReset: l,
      setDeleteStatus: c,
      discardTextEdit: u,
      searchTermUpdated: d,
      discardEdits: r,
      showWorkSummaryModal: f
    };
  }
};
const VRe = ["data-layout"];
function HRe(t, e, n, r, o, i) {
  const a = ee("SlideHeader"), s = ee("SlideTable"), l = ee("SlideChartContainer"), c = ee("SlideTextEditor"), u = ee("SlideAdContainer"), d = ee("SlideFooter"), f = ee("SlideContainer");
  return v(), te(f, {
    id: n.id,
    readOnly: n.readOnly,
    isDeleted: !n.slide.active,
    hasTextContainer: n.slide.text || !n.slide.text && !n.slide.default,
    slideBeingEdited: n.slideBeingEdited,
    previewMode: n.previewMode,
    onSetDeleteStatus: r.setDeleteStatus,
    onDiscardEdits: r.discardTextEdit,
    onShowWorkSummaryModal: r.showWorkSummaryModal,
    theme: n.theme,
    noData: n.slide.invalid,
    "slide-type": n.slide.type
  }, {
    default: q(() => [
      H(a, {
        headerText: n.slide.title,
        index: n.slideNum,
        theme: n.theme,
        "logo-src": n.slide.image,
        "report-period": n.reportPeriod,
        name: n.recipient.name,
        "slide-type": n.slide.type
      }, null, 8, ["headerText", "index", "theme", "logo-src", "report-period", "name", "slide-type"]),
      g("div", {
        class: z(["slide-content", r.layoutType]),
        "data-layout": r.layoutType
      }, [
        n.slide.table ? (v(), te(s, {
          key: 0,
          table: n.slide.table,
          theme: n.theme,
          readOnly: n.readOnly
        }, null, 8, ["table", "theme", "readOnly"])) : V("", !0),
        n.slide.chart ? (v(), te(l, {
          key: 1,
          chart: n.slide.chart,
          slideType: n.slide.type,
          theme: n.theme,
          readOnly: n.readOnly
        }, null, 8, ["chart", "slideType", "theme", "readOnly"])) : V("", !0),
        n.slide.custom ? (v(), te(zo(n.slide.custom.component), Tt({
          key: 2,
          ref: "custom_component"
        }, n.slide.custom.props, {
          theme: n.theme,
          previewMode: n.previewMode,
          readOnly: n.readOnly
        }), null, 16, ["theme", "previewMode", "readOnly"])) : V("", !0),
        n.slide.text || n.slide.text === "" && !n.slide.default ? (v(), te(c, {
          key: 3,
          id: n.id,
          content: n.slide.text,
          "default-text": n.slide.default_text,
          layoutType: r.layoutType,
          "discard-edits": r.discardEdits,
          onContentUpdated: r.slideTextUpdated,
          onContentReset: r.slideTextReset,
          theme: n.theme,
          "read-only": n.readOnly,
          "preview-mode": n.previewMode
        }, null, 8, ["id", "content", "default-text", "layoutType", "discard-edits", "onContentUpdated", "onContentReset", "theme", "read-only", "preview-mode"])) : V("", !0),
        n.slide.ad ? (v(), te(u, {
          key: 4,
          ad: n.slide.ad,
          theme: n.theme,
          readOnly: n.readOnly,
          onSearchTermUpdated: r.searchTermUpdated
        }, null, 8, ["ad", "theme", "readOnly", "onSearchTermUpdated"])) : V("", !0)
      ], 10, VRe),
      H(d, {
        "is-cover-page": n.slide.type === 0,
        sender: n.details,
        user: n.user,
        date: n.date,
        theme: n.theme.typeface
      }, null, 8, ["is-cover-page", "sender", "user", "date", "theme"])
    ]),
    _: 1
  }, 8, ["id", "readOnly", "isDeleted", "hasTextContainer", "slideBeingEdited", "previewMode", "onSetDeleteStatus", "onDiscardEdits", "onShowWorkSummaryModal", "theme", "noData", "slide-type"]);
}
const FPe = /* @__PURE__ */ Y(FRe, [["render", HRe], ["__scopeId", "data-v-b5d213c3"]]), VPe = {
  install(t) {
    t.use(NT, {
      defaultProps: {
        theme: "opteo-website",
        offset: [0, 8],
        touch: !1,
        allowHTML: !0
      }
    }), t.use(MT, {
      options: {
        // Required for scroll propagation issues with body/ps
        useBothWheelAxes: !0,
        // Prevents scrollbars being created when contents are
        // slightly too tall for the container. See link for more:
        // https://perfectscrollbar.com/#section-options
        scrollYMarginOffset: 8
      }
    }), t.use(LT);
  }
};
export {
  J3e as AdScheduleChart,
  rMe as AmexLogo,
  YMe as AnywordIcon,
  zRe as ArchiveIcon,
  bOe as AreaChart,
  DPe as AsyncPush,
  zMe as Avatar,
  ZMe as BackButton,
  Ege as BarChart,
  CPe as BatchBar,
  UPe as BidFactoryChart,
  ZRe as BinIcon,
  hMe as CalendarIcon,
  dPe as Carousel,
  Co as ChartTooltip,
  W5 as CheckIcon,
  hPe as Checkbox,
  S5 as CircleAccountLevelIcon,
  sG as CircleAdIcon,
  w5 as CircleAdgroupIcon,
  uG as CircleAssetGroupIcon,
  T5 as CircleCampaignGroupIcon,
  b5 as CircleCampaignIcon,
  R5 as CircleConversionActionIcon,
  SG as CircleDemographicIcon,
  RG as CircleDeviceIcon,
  M5 as CircleExperimentIcon,
  $G as CircleExtensionIcon,
  ZE as CircleKeywordIcon,
  P5 as CircleLocationIcon,
  x5 as CircleNGramIcon,
  y5 as CircleNegativeKeywordIcon,
  L5 as CircleNegativeListIcon,
  U5 as CirclePauseIcon,
  $5 as CirclePlacementExclusionListIcon,
  k5 as CirclePlacementIcon,
  B5 as CircleProductGroupIcon,
  vF as CircleProductIcon,
  G5 as CircleReplacementKeywordIcon,
  F5 as CircleSearchTermIcon,
  V5 as CircleUrlIcon,
  H5 as CircleWordIcon,
  qE as CloseButton,
  gPe as ColorPicker,
  XE as ColorTag,
  SPe as ConnectionStatus,
  TPe as CopyableString,
  iEe as Count,
  gU as CrossIcon,
  JMe as DatePicker,
  QMe as DateRange,
  XMe as DeleteButton,
  Dp as Delta,
  uMe as DismissIcon,
  bPe as DonutChart,
  qRe as DownloadIcon,
  Ghe as Drawer,
  XRe as DuplicateIcon,
  ePe as Ent,
  Cp as EntityPill,
  BPe as EntityPillList,
  tPe as EntityTransform,
  r5 as ErrorMessage,
  jRe as ExpandIcon,
  nPe as ExpandableSidebar,
  rPe as ExpandableSidebarButton,
  CV as GoogleAdsLogo,
  LMe as GoogleAllResultsIcon,
  FMe as GoogleAppsIcon,
  WMe as GoogleCloseIcon,
  HMe as GoogleGIcon,
  xMe as GoogleImagesIcon,
  $V as GoogleLogo,
  UMe as GoogleMapsIcon,
  VMe as GoogleMenuIcon,
  pMe as GoogleMicIcon,
  $Me as GoogleMoreIcon,
  kMe as GoogleNewsIcon,
  GMe as GoogleSearchIcon,
  kbe as GoogleSearchPreview,
  BMe as GoogleVideoIcon,
  $Pe as HeatmapChart,
  WV as HelpIcon,
  oPe as HelpLink,
  O4e as ImageAd,
  fMe as InProgressIcon,
  gMe as IndustryIcon,
  sMe as InfoIcon,
  PU as InputErrorIcon,
  EPe as KeyboardShortcut,
  Zx as Label,
  MPe as LineChart,
  iPe as Link,
  wV as LinkedInLogo,
  sPe as ListItem,
  oMe as MaestroLogo,
  iMe as MastercardLogo,
  EMe as MetaAdsLogo,
  _Me as MicrosoftAdsLogo,
  kPe as MiniSpreadChart,
  mMe as MobileAppIcon,
  Hhe as Modal,
  Dx as Money,
  qMe as MoreButton,
  YRe as Number,
  IPe as OnboardingModal,
  NMe as OpteoLogo,
  OPe as Panel,
  l5 as Percent,
  xPe as PerformanceChartContainer,
  eMe as PlusIcon,
  JE as Popout,
  Z_e as ProfileImage,
  UNe as ProgressBar,
  nMe as RegenerateIcon,
  FPe as ReportSlide,
  JRe as RestoreIcon,
  d0 as RightArrowIcon,
  KRe as Roas,
  tMe as RoundedPlusIcon,
  PPe as ScatterPointChart,
  dMe as ScheduledIcon,
  QRe as SearchIcon,
  uPe as Section,
  yPe as SegmentsChart,
  _Pe as Select,
  nu as SelectArrowIcon,
  aPe as SelectableList,
  sa as Skeleton,
  cMe as SkipIcon,
  C5e as SlideFooter,
  mPe as Snackbar,
  He as Spacer,
  LPe as Sparkline,
  t5 as Spinner,
  c_e as SquareButton,
  n5 as TableEdit,
  xx as TableSortArrowDown,
  Bx as TableSortArrowUp,
  Mx as TableSortableArrows,
  NPe as Tabs,
  Ye as Text,
  K4e as TextAd,
  OMe as TimezoneIcon,
  wPe as Toggle,
  LE as Tooltip,
  vMe as TopRightArrow,
  Hx as UpArrow,
  ru as ViewBackground,
  vPe as ViewToggle,
  aMe as VisaLogo,
  zhe as VisibilityWrapper,
  lMe as WarnIcon,
  IMe as WebsiteUrlIcon,
  KMe as WritesonicIcon,
  VPe as default,
  RPe as fillMissingDates,
  pPe as hideSnackbar,
  ln as oButton,
  xE as oForm,
  fPe as oImage,
  Nc as oInput,
  $E as oTable,
  SMe as rsaBinIcon,
  AMe as rsaCopyIcon,
  wMe as rsaDesktopIcon,
  DMe as rsaLeftArrowIcon,
  TMe as rsaMobileIcon,
  bMe as rsaPinIcon,
  RMe as rsaPinOneIcon,
  PMe as rsaPinThreeIcon,
  MMe as rsaPinTwoIcon,
  yMe as rsaRefreshIcon,
  CMe as rsaRightArrowIcon,
  APe as showAsyncPush,
  j6 as showSnackbar,
  cU as sortTable,
  Zf as useBodyLock,
  sn as useMoney,
  Gs as useNumber,
  Yo as usePercent,
  vc as useRoas,
  Ir as useShortKey
};
//# sourceMappingURL=components-next.js.map
